(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('rxjs'), require('rxjs/operators'), require('@angular/common')) :
    typeof define === 'function' && define.amd ? define('angular-library-4testing', ['exports', '@angular/core', 'rxjs', 'rxjs/operators', '@angular/common'], factory) :
    (factory((global.ng = global.ng || {}, global.ng.angularLibraryStarter = {}),global.ng.core,global.rxjs,global.rxjs.operators,global.ng.common));
}(this, (function (exports,core,rxjs,operators,common) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    function __values(o) {
        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
        if (m) return m.call(o);
        return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    /**
     * @license Angular v6.0.0
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
     * `HttpResponse`.
     *
     * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
     * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
     * `HttpBackend`.
     *
     * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
     *
     *
     */
    var HttpHandler = /** @class */ (function () {
        function HttpHandler() {
        }
        return HttpHandler;
    }());
    /**
     * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
     *
     * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
     *
     * When injected, `HttpBackend` dispatches requests directly to the backend, without going
     * through the interceptor chain.
     *
     *
     */
    var HttpBackend = /** @class */ (function () {
        function HttpBackend() {
        }
        return HttpBackend;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Immutable set of Http headers, with lazy parsing.
     *
     */
    var HttpHeaders = /** @class */ (function () {
        function HttpHeaders(headers) {
            var _this = this;
            /**
               * Internal map of lowercased header names to the normalized
               * form of the name (the form seen first).
               */
            this.normalizedNames = new Map();
            /**
               * Queued updates to be materialized the next initialization.
               */
            this.lazyUpdate = null;
            if (!headers) {
                this.headers = new Map();
            }
            else if (typeof headers === 'string') {
                this.lazyInit = function () {
                    _this.headers = new Map();
                    headers.split('\n').forEach(function (line) {
                        var index = line.indexOf(':');
                        if (index > 0) {
                            var name_1 = line.slice(0, index);
                            var key = name_1.toLowerCase();
                            var value = line.slice(index + 1).trim();
                            _this.maybeSetNormalizedName(name_1, key);
                            if (_this.headers.has(key)) {
                                _this.headers.get(key).push(value);
                            }
                            else {
                                _this.headers.set(key, [value]);
                            }
                        }
                    });
                };
            }
            else {
                this.lazyInit = function () {
                    _this.headers = new Map();
                    Object.keys(headers).forEach(function (name) {
                        var values = headers[name];
                        var key = name.toLowerCase();
                        if (typeof values === 'string') {
                            values = [values];
                        }
                        if (values.length > 0) {
                            _this.headers.set(key, values);
                            _this.maybeSetNormalizedName(name, key);
                        }
                    });
                };
            }
        }
        /**
         * Checks for existence of header by given name.
         */
        /**
           * Checks for existence of header by given name.
           */
        HttpHeaders.prototype.has = /**
           * Checks for existence of header by given name.
           */
        function (name) {
            this.init();
            return this.headers.has(name.toLowerCase());
        };
        /**
         * Returns first header that matches given name.
         */
        /**
           * Returns first header that matches given name.
           */
        HttpHeaders.prototype.get = /**
           * Returns first header that matches given name.
           */
        function (name) {
            this.init();
            var values = this.headers.get(name.toLowerCase());
            return values && values.length > 0 ? values[0] : null;
        };
        /**
         * Returns the names of the headers
         */
        /**
           * Returns the names of the headers
           */
        HttpHeaders.prototype.keys = /**
           * Returns the names of the headers
           */
        function () {
            this.init();
            return Array.from(this.normalizedNames.values());
        };
        /**
         * Returns list of header values for a given name.
         */
        /**
           * Returns list of header values for a given name.
           */
        HttpHeaders.prototype.getAll = /**
           * Returns list of header values for a given name.
           */
        function (name) {
            this.init();
            return this.headers.get(name.toLowerCase()) || null;
        };
        HttpHeaders.prototype.append = function (name, value) {
            return this.clone({ name: name, value: value, op: 'a' });
        };
        HttpHeaders.prototype.set = function (name, value) {
            return this.clone({ name: name, value: value, op: 's' });
        };
        HttpHeaders.prototype.delete = function (name, value) {
            return this.clone({ name: name, value: value, op: 'd' });
        };
        HttpHeaders.prototype.maybeSetNormalizedName = function (name, lcName) {
            if (!this.normalizedNames.has(lcName)) {
                this.normalizedNames.set(lcName, name);
            }
        };
        HttpHeaders.prototype.init = function () {
            var _this = this;
            if (!!this.lazyInit) {
                if (this.lazyInit instanceof HttpHeaders) {
                    this.copyFrom(this.lazyInit);
                }
                else {
                    this.lazyInit();
                }
                this.lazyInit = null;
                if (!!this.lazyUpdate) {
                    this.lazyUpdate.forEach(function (update) { return _this.applyUpdate(update); });
                    this.lazyUpdate = null;
                }
            }
        };
        HttpHeaders.prototype.copyFrom = function (other) {
            var _this = this;
            other.init();
            Array.from(other.headers.keys()).forEach(function (key) {
                _this.headers.set(key, (other.headers.get(key)));
                _this.normalizedNames.set(key, (other.normalizedNames.get(key)));
            });
        };
        HttpHeaders.prototype.clone = function (update) {
            var clone = new HttpHeaders();
            clone.lazyInit =
                (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
            clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
            return clone;
        };
        HttpHeaders.prototype.applyUpdate = function (update) {
            var key = update.name.toLowerCase();
            switch (update.op) {
                case 'a':
                case 's':
                    var value = (update.value);
                    if (typeof value === 'string') {
                        value = [value];
                    }
                    if (value.length === 0) {
                        return;
                    }
                    this.maybeSetNormalizedName(update.name, key);
                    var base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                    base.push.apply(base, __spread(value));
                    this.headers.set(key, base);
                    break;
                case 'd':
                    var toDelete_1 = update.value;
                    if (!toDelete_1) {
                        this.headers.delete(key);
                        this.normalizedNames.delete(key);
                    }
                    else {
                        var existing = this.headers.get(key);
                        if (!existing) {
                            return;
                        }
                        existing = existing.filter(function (value) { return toDelete_1.indexOf(value) === -1; });
                        if (existing.length === 0) {
                            this.headers.delete(key);
                            this.normalizedNames.delete(key);
                        }
                        else {
                            this.headers.set(key, existing);
                        }
                    }
                    break;
            }
        };
        /**
         * @internal
         */
        /**
           * @internal
           */
        HttpHeaders.prototype.forEach = /**
           * @internal
           */
        function (fn) {
            var _this = this;
            this.init();
            Array.from(this.normalizedNames.keys())
                .forEach(function (key) { return fn((_this.normalizedNames.get(key)), (_this.headers.get(key))); });
        };
        return HttpHeaders;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * A `HttpParameterCodec` that uses `encodeURIComponent` and `decodeURIComponent` to
     * serialize and parse URL parameter keys and values.
     *
     *
     */
    var HttpUrlEncodingCodec = /** @class */ (function () {
        function HttpUrlEncodingCodec() {
        }
        HttpUrlEncodingCodec.prototype.encodeKey = function (k) { return standardEncoding(k); };
        HttpUrlEncodingCodec.prototype.encodeValue = function (v) { return standardEncoding(v); };
        HttpUrlEncodingCodec.prototype.decodeKey = function (k) { return decodeURIComponent(k); };
        HttpUrlEncodingCodec.prototype.decodeValue = function (v) { return decodeURIComponent(v); };
        return HttpUrlEncodingCodec;
    }());
    function paramParser(rawParams, codec) {
        var map$$1 = new Map();
        if (rawParams.length > 0) {
            var params = rawParams.split('&');
            params.forEach(function (param) {
                var eqIdx = param.indexOf('=');
                var _a = __read(eqIdx == -1 ?
                    [codec.decodeKey(param), ''] :
                    [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], 2), key = _a[0], val = _a[1];
                var list = map$$1.get(key) || [];
                list.push(val);
                map$$1.set(key, list);
            });
        }
        return map$$1;
    }
    function standardEncoding(v) {
        return encodeURIComponent(v)
            .replace(/%40/gi, '@')
            .replace(/%3A/gi, ':')
            .replace(/%24/gi, '$')
            .replace(/%2C/gi, ',')
            .replace(/%3B/gi, ';')
            .replace(/%2B/gi, '+')
            .replace(/%3D/gi, '=')
            .replace(/%3F/gi, '?')
            .replace(/%2F/gi, '/');
    }
    /**
     * An HTTP request/response body that represents serialized parameters,
     * per the MIME type `application/x-www-form-urlencoded`.
     *
     * This class is immutable - all mutation operations return a new instance.
     *
     *
     */
    var HttpParams = /** @class */ (function () {
        function HttpParams(options) {
            if (options === void 0) { options = {}; }
            var _this = this;
            this.updates = null;
            this.cloneFrom = null;
            this.encoder = options.encoder || new HttpUrlEncodingCodec();
            if (!!options.fromString) {
                if (!!options.fromObject) {
                    throw new Error("Cannot specify both fromString and fromObject.");
                }
                this.map = paramParser(options.fromString, this.encoder);
            }
            else if (!!options.fromObject) {
                this.map = new Map();
                Object.keys(options.fromObject).forEach(function (key) {
                    var value = options.fromObject[key];
                    _this.map.set(key, Array.isArray(value) ? value : [value]);
                });
            }
            else {
                this.map = null;
            }
        }
        /**
         * Check whether the body has one or more values for the given parameter name.
         */
        /**
           * Check whether the body has one or more values for the given parameter name.
           */
        HttpParams.prototype.has = /**
           * Check whether the body has one or more values for the given parameter name.
           */
        function (param) {
            this.init();
            return this.map.has(param);
        };
        /**
         * Get the first value for the given parameter name, or `null` if it's not present.
         */
        /**
           * Get the first value for the given parameter name, or `null` if it's not present.
           */
        HttpParams.prototype.get = /**
           * Get the first value for the given parameter name, or `null` if it's not present.
           */
        function (param) {
            this.init();
            var res = this.map.get(param);
            return !!res ? res[0] : null;
        };
        /**
         * Get all values for the given parameter name, or `null` if it's not present.
         */
        /**
           * Get all values for the given parameter name, or `null` if it's not present.
           */
        HttpParams.prototype.getAll = /**
           * Get all values for the given parameter name, or `null` if it's not present.
           */
        function (param) {
            this.init();
            return this.map.get(param) || null;
        };
        /**
         * Get all the parameter names for this body.
         */
        /**
           * Get all the parameter names for this body.
           */
        HttpParams.prototype.keys = /**
           * Get all the parameter names for this body.
           */
        function () {
            this.init();
            return Array.from(this.map.keys());
        };
        /**
         * Construct a new body with an appended value for the given parameter name.
         */
        /**
           * Construct a new body with an appended value for the given parameter name.
           */
        HttpParams.prototype.append = /**
           * Construct a new body with an appended value for the given parameter name.
           */
        function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
        /**
         * Construct a new body with a new value for the given parameter name.
         */
        /**
           * Construct a new body with a new value for the given parameter name.
           */
        HttpParams.prototype.set = /**
           * Construct a new body with a new value for the given parameter name.
           */
        function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
        /**
         * Construct a new body with either the given value for the given parameter
         * removed, if a value is given, or all values for the given parameter removed
         * if not.
         */
        /**
           * Construct a new body with either the given value for the given parameter
           * removed, if a value is given, or all values for the given parameter removed
           * if not.
           */
        HttpParams.prototype.delete = /**
           * Construct a new body with either the given value for the given parameter
           * removed, if a value is given, or all values for the given parameter removed
           * if not.
           */
        function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
        /**
         * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
         * separated by `&`s.
         */
        /**
           * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
           * separated by `&`s.
           */
        HttpParams.prototype.toString = /**
           * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
           * separated by `&`s.
           */
        function () {
            var _this = this;
            this.init();
            return this.keys()
                .map(function (key) {
                var eKey = _this.encoder.encodeKey(key);
                return _this.map.get(key).map(function (value) { return eKey + '=' + _this.encoder.encodeValue(value); })
                    .join('&');
            })
                .join('&');
        };
        HttpParams.prototype.clone = function (update) {
            var clone = new HttpParams({ encoder: this.encoder });
            clone.cloneFrom = this.cloneFrom || this;
            clone.updates = (this.updates || []).concat([update]);
            return clone;
        };
        HttpParams.prototype.init = function () {
            var _this = this;
            if (this.map === null) {
                this.map = new Map();
            }
            if (this.cloneFrom !== null) {
                this.cloneFrom.init();
                this.cloneFrom.keys().forEach(function (key) { return _this.map.set(key, (_this.cloneFrom.map.get(key))); });
                this.updates.forEach(function (update) {
                    switch (update.op) {
                        case 'a':
                        case 's':
                            var base = (update.op === 'a' ? _this.map.get(update.param) : undefined) || [];
                            base.push((update.value));
                            _this.map.set(update.param, base);
                            break;
                        case 'd':
                            if (update.value !== undefined) {
                                var base_1 = _this.map.get(update.param) || [];
                                var idx = base_1.indexOf(update.value);
                                if (idx !== -1) {
                                    base_1.splice(idx, 1);
                                }
                                if (base_1.length > 0) {
                                    _this.map.set(update.param, base_1);
                                }
                                else {
                                    _this.map.delete(update.param);
                                }
                            }
                            else {
                                _this.map.delete(update.param);
                                break;
                            }
                    }
                });
                this.cloneFrom = null;
            }
        };
        return HttpParams;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Determine whether the given HTTP method may include a body.
     */
    function mightHaveBody(method) {
        switch (method) {
            case 'DELETE':
            case 'GET':
            case 'HEAD':
            case 'OPTIONS':
            case 'JSONP':
                return false;
            default:
                return true;
        }
    }
    /**
     * Safely assert whether the given value is an ArrayBuffer.
     *
     * In some execution environments ArrayBuffer is not defined.
     */
    function isArrayBuffer(value) {
        return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
    }
    /**
     * Safely assert whether the given value is a Blob.
     *
     * In some execution environments Blob is not defined.
     */
    function isBlob(value) {
        return typeof Blob !== 'undefined' && value instanceof Blob;
    }
    /**
     * Safely assert whether the given value is a FormData instance.
     *
     * In some execution environments FormData is not defined.
     */
    function isFormData(value) {
        return typeof FormData !== 'undefined' && value instanceof FormData;
    }
    /**
     * An outgoing HTTP request with an optional typed body.
     *
     * `HttpRequest` represents an outgoing request, including URL, method,
     * headers, body, and other request configuration options. Instances should be
     * assumed to be immutable. To modify a `HttpRequest`, the `clone`
     * method should be used.
     *
     *
     */
    var HttpRequest = /** @class */ (function () {
        function HttpRequest(method, url, third, fourth) {
            this.url = url;
            /**
               * The request body, or `null` if one isn't set.
               *
               * Bodies are not enforced to be immutable, as they can include a reference to any
               * user-defined data type. However, interceptors should take care to preserve
               * idempotence by treating them as such.
               */
            this.body = null;
            /**
               * Whether this request should be made in a way that exposes progress events.
               *
               * Progress events are expensive (change detection runs on each event) and so
               * they should only be requested if the consumer intends to monitor them.
               */
            this.reportProgress = false;
            /**
               * Whether this request should be sent with outgoing credentials (cookies).
               */
            this.withCredentials = false;
            /**
               * The expected response type of the server.
               *
               * This is used to parse the response appropriately before returning it to
               * the requestee.
               */
            this.responseType = 'json';
            this.method = method.toUpperCase();
            // Next, need to figure out which argument holds the HttpRequestInit
            // options, if any.
            var options;
            // Check whether a body argument is expected. The only valid way to omit
            // the body argument is to use a known no-body method like GET.
            if (mightHaveBody(this.method) || !!fourth) {
                // Body is the third argument, options are the fourth.
                this.body = (third !== undefined) ? third : null;
                options = fourth;
            }
            else {
                // No body required, options are the third argument. The body stays null.
                options = third;
            }
            // If options have been passed, interpret them.
            if (options) {
                // Normalize reportProgress and withCredentials.
                this.reportProgress = !!options.reportProgress;
                this.withCredentials = !!options.withCredentials;
                // Override default response type of 'json' if one is provided.
                if (!!options.responseType) {
                    this.responseType = options.responseType;
                }
                // Override headers if they're provided.
                if (!!options.headers) {
                    this.headers = options.headers;
                }
                if (!!options.params) {
                    this.params = options.params;
                }
            }
            // If no headers have been passed in, construct a new HttpHeaders instance.
            if (!this.headers) {
                this.headers = new HttpHeaders();
            }
            // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
            if (!this.params) {
                this.params = new HttpParams();
                this.urlWithParams = url;
            }
            else {
                // Encode the parameters to a string in preparation for inclusion in the URL.
                var params = this.params.toString();
                if (params.length === 0) {
                    // No parameters, the visible URL is just the URL given at creation time.
                    this.urlWithParams = url;
                }
                else {
                    // Does the URL already have query parameters? Look for '?'.
                    var qIdx = url.indexOf('?');
                    // There are 3 cases to handle:
                    // 1) No existing parameters -> append '?' followed by params.
                    // 2) '?' exists and is followed by existing query string ->
                    //    append '&' followed by params.
                    // 3) '?' exists at the end of the url -> append params directly.
                    // This basically amounts to determining the character, if any, with
                    // which to join the URL and parameters.
                    var sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
                    this.urlWithParams = url + sep + params;
                }
            }
        }
        /**
         * Transform the free-form body into a serialized format suitable for
         * transmission to the server.
         */
        /**
           * Transform the free-form body into a serialized format suitable for
           * transmission to the server.
           */
        HttpRequest.prototype.serializeBody = /**
           * Transform the free-form body into a serialized format suitable for
           * transmission to the server.
           */
        function () {
            // If no body is present, no need to serialize it.
            if (this.body === null) {
                return null;
            }
            // Check whether the body is already in a serialized form. If so,
            // it can just be returned directly.
            if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
                typeof this.body === 'string') {
                return this.body;
            }
            // Check whether the body is an instance of HttpUrlEncodedParams.
            if (this.body instanceof HttpParams) {
                return this.body.toString();
            }
            // Check whether the body is an object or array, and serialize with JSON if so.
            if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
                Array.isArray(this.body)) {
                return JSON.stringify(this.body);
            }
            // Fall back on toString() for everything else.
            return this.body.toString();
        };
        /**
         * Examine the body and attempt to infer an appropriate MIME type
         * for it.
         *
         * If no such type can be inferred, this method will return `null`.
         */
        /**
           * Examine the body and attempt to infer an appropriate MIME type
           * for it.
           *
           * If no such type can be inferred, this method will return `null`.
           */
        HttpRequest.prototype.detectContentTypeHeader = /**
           * Examine the body and attempt to infer an appropriate MIME type
           * for it.
           *
           * If no such type can be inferred, this method will return `null`.
           */
        function () {
            // An empty body has no content type.
            if (this.body === null) {
                return null;
            }
            // FormData bodies rely on the browser's content type assignment.
            if (isFormData(this.body)) {
                return null;
            }
            // Blobs usually have their own content type. If it doesn't, then
            // no type can be inferred.
            if (isBlob(this.body)) {
                return this.body.type || null;
            }
            // Array buffers have unknown contents and thus no type can be inferred.
            if (isArrayBuffer(this.body)) {
                return null;
            }
            // Technically, strings could be a form of JSON data, but it's safe enough
            // to assume they're plain strings.
            if (typeof this.body === 'string') {
                return 'text/plain';
            }
            // `HttpUrlEncodedParams` has its own content-type.
            if (this.body instanceof HttpParams) {
                return 'application/x-www-form-urlencoded;charset=UTF-8';
            }
            // Arrays, objects, and numbers will be encoded as JSON.
            if (typeof this.body === 'object' || typeof this.body === 'number' ||
                Array.isArray(this.body)) {
                return 'application/json';
            }
            // No type could be inferred.
            return null;
        };
        HttpRequest.prototype.clone = function (update) {
            if (update === void 0) { update = {}; }
            // For method, url, and responseType, take the current value unless
            // it is overridden in the update hash.
            var method = update.method || this.method;
            var url = update.url || this.url;
            var responseType = update.responseType || this.responseType;
            // The body is somewhat special - a `null` value in update.body means
            // whatever current body is present is being overridden with an empty
            // body, whereas an `undefined` value in update.body implies no
            // override.
            var body = (update.body !== undefined) ? update.body : this.body;
            // Carefully handle the boolean options to differentiate between
            // `false` and `undefined` in the update args.
            var withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
            var reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
            // Headers and params may be appended to if `setHeaders` or
            // `setParams` are used.
            var headers = update.headers || this.headers;
            var params = update.params || this.params;
            // Check whether the caller has asked to add headers.
            if (update.setHeaders !== undefined) {
                // Set every requested header.
                headers =
                    Object.keys(update.setHeaders)
                        .reduce(function (headers, name) { return headers.set(name, update.setHeaders[name]); }, headers);
            }
            // Check whether the caller has asked to set params.
            if (update.setParams) {
                // Set every requested param.
                params = Object.keys(update.setParams)
                    .reduce(function (params, param) { return params.set(param, update.setParams[param]); }, params);
            }
            // Finally, construct the new HttpRequest using the pieces from above.
            return new HttpRequest(method, url, body, {
                params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
            });
        };
        return HttpRequest;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Type enumeration for the different kinds of `HttpEvent`.
     *
     *
     */
    /**
     * Type enumeration for the different kinds of `HttpEvent`.
     *
     *
     */
    var HttpEventType;
    /**
     * Type enumeration for the different kinds of `HttpEvent`.
     *
     *
     */
    (function (HttpEventType) {
        /**
         * The request was sent out over the wire.
         */
        HttpEventType[HttpEventType["Sent"] = 0] = "Sent";
        /**
         * An upload progress event was received.
         */
        HttpEventType[HttpEventType["UploadProgress"] = 1] = "UploadProgress";
        /**
         * The response status code and headers were received.
         */
        HttpEventType[HttpEventType["ResponseHeader"] = 2] = "ResponseHeader";
        /**
         * A download progress event was received.
         */
        HttpEventType[HttpEventType["DownloadProgress"] = 3] = "DownloadProgress";
        /**
         * The full response including the body was received.
         */
        HttpEventType[HttpEventType["Response"] = 4] = "Response";
        /**
         * A custom event from an interceptor or a backend.
         */
        HttpEventType[HttpEventType["User"] = 5] = "User";
    })(HttpEventType || (HttpEventType = {}));
    /**
     * Base class for both `HttpResponse` and `HttpHeaderResponse`.
     *
     *
     */
    var HttpResponseBase = /** @class */ (function () {
        /**
         * Super-constructor for all responses.
         *
         * The single parameter accepted is an initialization hash. Any properties
         * of the response passed there will override the default values.
         */
        function HttpResponseBase(init, defaultStatus, defaultStatusText) {
            if (defaultStatus === void 0) { defaultStatus = 200; }
            if (defaultStatusText === void 0) { defaultStatusText = 'OK'; }
            // If the hash has values passed, use them to initialize the response.
            // Otherwise use the default values.
            this.headers = init.headers || new HttpHeaders();
            this.status = init.status !== undefined ? init.status : defaultStatus;
            this.statusText = init.statusText || defaultStatusText;
            this.url = init.url || null;
            // Cache the ok value to avoid defining a getter.
            this.ok = this.status >= 200 && this.status < 300;
        }
        return HttpResponseBase;
    }());
    /**
     * A partial HTTP response which only includes the status and header data,
     * but no response body.
     *
     * `HttpHeaderResponse` is a `HttpEvent` available on the response
     * event stream, only when progress events are requested.
     *
     *
     */
    var HttpHeaderResponse = /** @class */ (function (_super) {
        __extends(HttpHeaderResponse, _super);
        /**
         * Create a new `HttpHeaderResponse` with the given parameters.
         */
        function HttpHeaderResponse(init) {
            if (init === void 0) { init = {}; }
            var _this = _super.call(this, init) || this;
            _this.type = HttpEventType.ResponseHeader;
            return _this;
        }
        /**
         * Copy this `HttpHeaderResponse`, overriding its contents with the
         * given parameter hash.
         */
        /**
           * Copy this `HttpHeaderResponse`, overriding its contents with the
           * given parameter hash.
           */
        HttpHeaderResponse.prototype.clone = /**
           * Copy this `HttpHeaderResponse`, overriding its contents with the
           * given parameter hash.
           */
        function (update) {
            if (update === void 0) { update = {}; }
            // Perform a straightforward initialization of the new HttpHeaderResponse,
            // overriding the current parameters with new ones if given.
            return new HttpHeaderResponse({
                headers: update.headers || this.headers,
                status: update.status !== undefined ? update.status : this.status,
                statusText: update.statusText || this.statusText,
                url: update.url || this.url || undefined,
            });
        };
        return HttpHeaderResponse;
    }(HttpResponseBase));
    /**
     * A full HTTP response, including a typed response body (which may be `null`
     * if one was not returned).
     *
     * `HttpResponse` is a `HttpEvent` available on the response event
     * stream.
     *
     *
     */
    var HttpResponse = /** @class */ (function (_super) {
        __extends(HttpResponse, _super);
        /**
         * Construct a new `HttpResponse`.
         */
        function HttpResponse(init) {
            if (init === void 0) { init = {}; }
            var _this = _super.call(this, init) || this;
            _this.type = HttpEventType.Response;
            _this.body = init.body !== undefined ? init.body : null;
            return _this;
        }
        HttpResponse.prototype.clone = function (update) {
            if (update === void 0) { update = {}; }
            return new HttpResponse({
                body: (update.body !== undefined) ? update.body : this.body,
                headers: update.headers || this.headers,
                status: (update.status !== undefined) ? update.status : this.status,
                statusText: update.statusText || this.statusText,
                url: update.url || this.url || undefined,
            });
        };
        return HttpResponse;
    }(HttpResponseBase));
    /**
     * A response that represents an error or failure, either from a
     * non-successful HTTP status, an error while executing the request,
     * or some other failure which occurred during the parsing of the response.
     *
     * Any error returned on the `Observable` response stream will be
     * wrapped in an `HttpErrorResponse` to provide additional context about
     * the state of the HTTP layer when the error occurred. The error property
     * will contain either a wrapped Error object or the error response returned
     * from the server.
     *
     *
     */
    var HttpErrorResponse = /** @class */ (function (_super) {
        __extends(HttpErrorResponse, _super);
        function HttpErrorResponse(init) {
            var _this = 
            // Initialize with a default status of 0 / Unknown Error.
            _super.call(this, init, 0, 'Unknown Error') || this;
            _this.name = 'HttpErrorResponse';
            /**
               * Errors are never okay, even when the status code is in the 2xx success range.
               */
            _this.ok = false;
            // If the response was successful, then this was a parse error. Otherwise, it was
            // a protocol-level failure of some sort. Either the request failed in transit
            // or the server returned an unsuccessful status code.
            if (_this.status >= 200 && _this.status < 300) {
                _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
            }
            else {
                _this.message =
                    "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
            }
            _this.error = init.error || null;
            return _this;
        }
        return HttpErrorResponse;
    }(HttpResponseBase));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Construct an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
     * the given `body`. Basically, this clones the object and adds the body.
     */
    function addBody(options, body) {
        return {
            body: body,
            headers: options.headers,
            observe: options.observe,
            params: options.params,
            reportProgress: options.reportProgress,
            responseType: options.responseType,
            withCredentials: options.withCredentials,
        };
    }
    /**
     * Perform HTTP requests.
     *
     * `HttpClient` is available as an injectable class, with methods to perform HTTP requests.
     * Each request method has multiple signatures, and the return type varies according to which
     * signature is called (mainly the values of `observe` and `responseType`).
     *
     *
     */
    var HttpClient = /** @class */ (function () {
        function HttpClient(handler) {
            this.handler = handler;
        }
        /**
         * Constructs an `Observable` for a particular HTTP request that, when subscribed,
         * fires the request through the chain of registered interceptors and on to the
         * server.
         *
         * This method can be called in one of two ways. Either an `HttpRequest`
         * instance can be passed directly as the only parameter, or a method can be
         * passed as the first parameter, a string URL as the second, and an
         * options hash as the third.
         *
         * If a `HttpRequest` object is passed directly, an `Observable` of the
         * raw `HttpEvent` stream will be returned.
         *
         * If a request is instead built by providing a URL, the options object
         * determines the return type of `request()`. In addition to configuring
         * request parameters such as the outgoing headers and/or the body, the options
         * hash specifies two key pieces of information about the request: the
         * `responseType` and what to `observe`.
         *
         * The `responseType` value determines how a successful response body will be
         * parsed. If `responseType` is the default `json`, a type interface for the
         * resulting object may be passed as a type parameter to `request()`.
         *
         * The `observe` value determines the return type of `request()`, based on what
         * the consumer is interested in observing. A value of `events` will return an
         * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
         * including progress events by default. A value of `response` will return an
         * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
         * depends on the `responseType` and any optionally provided type parameter.
         * A value of `body` will return an `Observable<T>` with the same `T` body type.
         */
        /**
           * Constructs an `Observable` for a particular HTTP request that, when subscribed,
           * fires the request through the chain of registered interceptors and on to the
           * server.
           *
           * This method can be called in one of two ways. Either an `HttpRequest`
           * instance can be passed directly as the only parameter, or a method can be
           * passed as the first parameter, a string URL as the second, and an
           * options hash as the third.
           *
           * If a `HttpRequest` object is passed directly, an `Observable` of the
           * raw `HttpEvent` stream will be returned.
           *
           * If a request is instead built by providing a URL, the options object
           * determines the return type of `request()`. In addition to configuring
           * request parameters such as the outgoing headers and/or the body, the options
           * hash specifies two key pieces of information about the request: the
           * `responseType` and what to `observe`.
           *
           * The `responseType` value determines how a successful response body will be
           * parsed. If `responseType` is the default `json`, a type interface for the
           * resulting object may be passed as a type parameter to `request()`.
           *
           * The `observe` value determines the return type of `request()`, based on what
           * the consumer is interested in observing. A value of `events` will return an
           * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
           * including progress events by default. A value of `response` will return an
           * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
           * depends on the `responseType` and any optionally provided type parameter.
           * A value of `body` will return an `Observable<T>` with the same `T` body type.
           */
        HttpClient.prototype.request = /**
           * Constructs an `Observable` for a particular HTTP request that, when subscribed,
           * fires the request through the chain of registered interceptors and on to the
           * server.
           *
           * This method can be called in one of two ways. Either an `HttpRequest`
           * instance can be passed directly as the only parameter, or a method can be
           * passed as the first parameter, a string URL as the second, and an
           * options hash as the third.
           *
           * If a `HttpRequest` object is passed directly, an `Observable` of the
           * raw `HttpEvent` stream will be returned.
           *
           * If a request is instead built by providing a URL, the options object
           * determines the return type of `request()`. In addition to configuring
           * request parameters such as the outgoing headers and/or the body, the options
           * hash specifies two key pieces of information about the request: the
           * `responseType` and what to `observe`.
           *
           * The `responseType` value determines how a successful response body will be
           * parsed. If `responseType` is the default `json`, a type interface for the
           * resulting object may be passed as a type parameter to `request()`.
           *
           * The `observe` value determines the return type of `request()`, based on what
           * the consumer is interested in observing. A value of `events` will return an
           * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
           * including progress events by default. A value of `response` will return an
           * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
           * depends on the `responseType` and any optionally provided type parameter.
           * A value of `body` will return an `Observable<T>` with the same `T` body type.
           */
        function (first, url, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            var req;
            // Firstly, check whether the primary argument is an instance of `HttpRequest`.
            if (first instanceof HttpRequest) {
                // It is. The other arguments must be undefined (per the signatures) and can be
                // ignored.
                req = first;
            }
            else {
                // It's a string, so it represents a URL. Construct a request based on it,
                // and incorporate the remaining arguments (assuming GET unless a method is
                // provided.
                // Figure out the headers.
                var headers = undefined;
                if (options.headers instanceof HttpHeaders) {
                    headers = options.headers;
                }
                else {
                    headers = new HttpHeaders(options.headers);
                }
                // Sort out parameters.
                var params = undefined;
                if (!!options.params) {
                    if (options.params instanceof HttpParams) {
                        params = options.params;
                    }
                    else {
                        params = new HttpParams({ fromObject: options.params });
                    }
                }
                // Construct the request.
                req = new HttpRequest(first, (url), (options.body !== undefined ? options.body : null), {
                    headers: headers,
                    params: params,
                    reportProgress: options.reportProgress,
                    // By default, JSON is assumed to be returned for all calls.
                    responseType: options.responseType || 'json',
                    withCredentials: options.withCredentials,
                });
            }
            // Start with an Observable.of() the initial request, and run the handler (which
            // includes all interceptors) inside a concatMap(). This way, the handler runs
            // inside an Observable chain, which causes interceptors to be re-run on every
            // subscription (this also makes retries re-run the handler, including interceptors).
            var events$ = rxjs.of(req).pipe(operators.concatMap(function (req) { return _this.handler.handle(req); }));
            // If coming via the API signature which accepts a previously constructed HttpRequest,
            // the only option is to get the event stream. Otherwise, return the event stream if
            // that is what was requested.
            if (first instanceof HttpRequest || options.observe === 'events') {
                return events$;
            }
            // The requested stream contains either the full response or the body. In either
            // case, the first step is to filter the event stream to extract a stream of
            // responses(s).
            var res$ = events$.pipe(operators.filter(function (event) { return event instanceof HttpResponse; }));
            // Decide which stream to return.
            switch (options.observe || 'body') {
                case 'body':
                    // The requested stream is the body. Map the response stream to the response
                    // body. This could be done more simply, but a misbehaving interceptor might
                    // transform the response body into a different format and ignore the requested
                    // responseType. Guard against this by validating that the response is of the
                    // requested type.
                    switch (req.responseType) {
                        case 'arraybuffer':
                            return res$.pipe(operators.map(function (res) {
                                // Validate that the body is an ArrayBuffer.
                                if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                                    throw new Error('Response is not an ArrayBuffer.');
                                }
                                return res.body;
                            }));
                        case 'blob':
                            return res$.pipe(operators.map(function (res) {
                                // Validate that the body is a Blob.
                                if (res.body !== null && !(res.body instanceof Blob)) {
                                    throw new Error('Response is not a Blob.');
                                }
                                return res.body;
                            }));
                        case 'text':
                            return res$.pipe(operators.map(function (res) {
                                // Validate that the body is a string.
                                if (res.body !== null && typeof res.body !== 'string') {
                                    throw new Error('Response is not a string.');
                                }
                                return res.body;
                            }));
                        case 'json':
                        default:
                            // No validation needed for JSON responses, as they can be of any type.
                            return res$.pipe(operators.map(function (res) { return res.body; }));
                    }
                case 'response':
                    // The response stream was requested directly, so return it.
                    return res$;
                default:
                    // Guard against new future observe types being added.
                    throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
            }
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * DELETE request to be executed on the server. See the individual overloads for
         * details of `delete()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * DELETE request to be executed on the server. See the individual overloads for
           * details of `delete()`'s return type based on the provided options.
           */
        HttpClient.prototype.delete = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * DELETE request to be executed on the server. See the individual overloads for
           * details of `delete()`'s return type based on the provided options.
           */
        function (url, options) {
            if (options === void 0) { options = {}; }
            return this.request('DELETE', url, options);
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * GET request to be executed on the server. See the individual overloads for
         * details of `get()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * GET request to be executed on the server. See the individual overloads for
           * details of `get()`'s return type based on the provided options.
           */
        HttpClient.prototype.get = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * GET request to be executed on the server. See the individual overloads for
           * details of `get()`'s return type based on the provided options.
           */
        function (url, options) {
            if (options === void 0) { options = {}; }
            return this.request('GET', url, options);
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * HEAD request to be executed on the server. See the individual overloads for
         * details of `head()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * HEAD request to be executed on the server. See the individual overloads for
           * details of `head()`'s return type based on the provided options.
           */
        HttpClient.prototype.head = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * HEAD request to be executed on the server. See the individual overloads for
           * details of `head()`'s return type based on the provided options.
           */
        function (url, options) {
            if (options === void 0) { options = {}; }
            return this.request('HEAD', url, options);
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause a request
         * with the special method `JSONP` to be dispatched via the interceptor pipeline.
         *
         * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
         * If no such interceptor is reached, then the `JSONP` request will likely be
         * rejected by the configured backend.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause a request
           * with the special method `JSONP` to be dispatched via the interceptor pipeline.
           *
           * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
           * If no such interceptor is reached, then the `JSONP` request will likely be
           * rejected by the configured backend.
           */
        HttpClient.prototype.jsonp = /**
           * Constructs an `Observable` which, when subscribed, will cause a request
           * with the special method `JSONP` to be dispatched via the interceptor pipeline.
           *
           * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
           * If no such interceptor is reached, then the `JSONP` request will likely be
           * rejected by the configured backend.
           */
        function (url, callbackParam) {
            return this.request('JSONP', url, {
                params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
                observe: 'body',
                responseType: 'json',
            });
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * OPTIONS request to be executed on the server. See the individual overloads for
         * details of `options()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * OPTIONS request to be executed on the server. See the individual overloads for
           * details of `options()`'s return type based on the provided options.
           */
        HttpClient.prototype.options = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * OPTIONS request to be executed on the server. See the individual overloads for
           * details of `options()`'s return type based on the provided options.
           */
        function (url, options) {
            if (options === void 0) { options = {}; }
            return this.request('OPTIONS', url, options);
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * PATCH request to be executed on the server. See the individual overloads for
         * details of `patch()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * PATCH request to be executed on the server. See the individual overloads for
           * details of `patch()`'s return type based on the provided options.
           */
        HttpClient.prototype.patch = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * PATCH request to be executed on the server. See the individual overloads for
           * details of `patch()`'s return type based on the provided options.
           */
        function (url, body, options) {
            if (options === void 0) { options = {}; }
            return this.request('PATCH', url, addBody(options, body));
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * POST request to be executed on the server. See the individual overloads for
         * details of `post()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * POST request to be executed on the server. See the individual overloads for
           * details of `post()`'s return type based on the provided options.
           */
        HttpClient.prototype.post = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * POST request to be executed on the server. See the individual overloads for
           * details of `post()`'s return type based on the provided options.
           */
        function (url, body, options) {
            if (options === void 0) { options = {}; }
            return this.request('POST', url, addBody(options, body));
        };
        /**
         * Constructs an `Observable` which, when subscribed, will cause the configured
         * POST request to be executed on the server. See the individual overloads for
         * details of `post()`'s return type based on the provided options.
         */
        /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * POST request to be executed on the server. See the individual overloads for
           * details of `post()`'s return type based on the provided options.
           */
        HttpClient.prototype.put = /**
           * Constructs an `Observable` which, when subscribed, will cause the configured
           * POST request to be executed on the server. See the individual overloads for
           * details of `post()`'s return type based on the provided options.
           */
        function (url, body, options) {
            if (options === void 0) { options = {}; }
            return this.request('PUT', url, addBody(options, body));
        };
        HttpClient.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HttpClient.ctorParameters = function () { return [
            { type: HttpHandler, },
        ]; };
        return HttpClient;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
     *
     *
     */
    var HttpInterceptorHandler = /** @class */ (function () {
        function HttpInterceptorHandler(next, interceptor) {
            this.next = next;
            this.interceptor = interceptor;
        }
        HttpInterceptorHandler.prototype.handle = function (req) {
            return this.interceptor.intercept(req, this.next);
        };
        return HttpInterceptorHandler;
    }());
    /**
     * A multi-provider token which represents the array of `HttpInterceptor`s that
     * are registered.
     *
     *
     */
    var HTTP_INTERCEPTORS = new core.InjectionToken('HTTP_INTERCEPTORS');
    var NoopInterceptor = /** @class */ (function () {
        function NoopInterceptor() {
        }
        NoopInterceptor.prototype.intercept = function (req, next) {
            return next.handle(req);
        };
        NoopInterceptor.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        NoopInterceptor.ctorParameters = function () { return []; };
        return NoopInterceptor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var XSSI_PREFIX = /^\)\]\}',?\n/;
    /**
     * Determine an appropriate URL for the response, by checking either
     * XMLHttpRequest.responseURL or the X-Request-URL header.
     */
    function getResponseUrl(xhr) {
        if ('responseURL' in xhr && xhr.responseURL) {
            return xhr.responseURL;
        }
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
            return xhr.getResponseHeader('X-Request-URL');
        }
        return null;
    }
    /**
     * A wrapper around the `XMLHttpRequest` constructor.
     *
     *
     */
    var XhrFactory = /** @class */ (function () {
        function XhrFactory() {
        }
        return XhrFactory;
    }());
    /**
     * A factory for @{link HttpXhrBackend} that uses the `XMLHttpRequest` browser API.
     *
     *
     */
    var BrowserXhr = /** @class */ (function () {
        function BrowserXhr() {
        }
        BrowserXhr.prototype.build = function () { return (new XMLHttpRequest()); };
        BrowserXhr.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        BrowserXhr.ctorParameters = function () { return []; };
        return BrowserXhr;
    }());
    /**
     * An `HttpBackend` which uses the XMLHttpRequest API to send
     * requests to a backend server.
     *
     *
     */
    var HttpXhrBackend = /** @class */ (function () {
        function HttpXhrBackend(xhrFactory) {
            this.xhrFactory = xhrFactory;
        }
        /**
         * Process a request and return a stream of response events.
         */
        /**
           * Process a request and return a stream of response events.
           */
        HttpXhrBackend.prototype.handle = /**
           * Process a request and return a stream of response events.
           */
        function (req) {
            var _this = this;
            // Quick check to give a better error message when a user attempts to use
            // HttpClient.jsonp() without installing the JsonpClientModule
            if (req.method === 'JSONP') {
                throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
            }
            // Everything happens on Observable subscription.
            return new rxjs.Observable(function (observer) {
                // Start by setting up the XHR object with request method, URL, and withCredentials flag.
                var xhr = _this.xhrFactory.build();
                xhr.open(req.method, req.urlWithParams);
                if (!!req.withCredentials) {
                    xhr.withCredentials = true;
                }
                // Add all the requested headers.
                req.headers.forEach(function (name, values) { return xhr.setRequestHeader(name, values.join(',')); });
                // Add an Accept header if one isn't present already.
                if (!req.headers.has('Accept')) {
                    xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
                }
                // Auto-detect the Content-Type header if one isn't present already.
                if (!req.headers.has('Content-Type')) {
                    var detectedType = req.detectContentTypeHeader();
                    // Sometimes Content-Type detection fails.
                    if (detectedType !== null) {
                        xhr.setRequestHeader('Content-Type', detectedType);
                    }
                }
                // Set the responseType if one was requested.
                if (req.responseType) {
                    var responseType = req.responseType.toLowerCase();
                    // JSON responses need to be processed as text. This is because if the server
                    // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                    // xhr.response will be null, and xhr.responseText cannot be accessed to
                    // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                    // is parsed by first requesting text and then applying JSON.parse.
                    xhr.responseType = ((responseType !== 'json') ? responseType : 'text');
                }
                // Serialize the request body if one is present. If not, this will be set to null.
                var reqBody = req.serializeBody();
                // If progress events are enabled, response headers will be delivered
                // in two events - the HttpHeaderResponse event and the full HttpResponse
                // event. However, since response headers don't change in between these
                // two events, it doesn't make sense to parse them twice. So headerResponse
                // caches the data extracted from the response whenever it's first parsed,
                // to ensure parsing isn't duplicated.
                var headerResponse = null;
                // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
                // state, and memoizes it into headerResponse.
                var partialFromXhr = function () {
                    if (headerResponse !== null) {
                        return headerResponse;
                    }
                    // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                    var status = xhr.status === 1223 ? 204 : xhr.status;
                    var statusText = xhr.statusText || 'OK';
                    // Parse headers from XMLHttpRequest - this step is lazy.
                    var headers = new HttpHeaders(xhr.getAllResponseHeaders());
                    // Read the response URL from the XMLHttpResponse instance and fall back on the
                    // request URL.
                    var url = getResponseUrl(xhr) || req.url;
                    // Construct the HttpHeaderResponse and memoize it.
                    headerResponse = new HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
                    return headerResponse;
                };
                // Next, a few closures are defined for the various events which XMLHttpRequest can
                // emit. This allows them to be unregistered as event listeners later.
                // First up is the load event, which represents a response being fully available.
                var onLoad = function () {
                    // Read response state from the memoized partial data.
                    var _a = partialFromXhr(), headers = _a.headers, status = _a.status, statusText = _a.statusText, url = _a.url;
                    // The body will be read out if present.
                    var body = null;
                    if (status !== 204) {
                        // Use XMLHttpRequest.response if set, responseText otherwise.
                        body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
                    }
                    // Normalize another potential bug (this one comes from CORS).
                    if (status === 0) {
                        status = !!body ? 200 : 0;
                    }
                    // ok determines whether the response will be transmitted on the event or
                    // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                    // but a successful status code can still result in an error if the user
                    // asked for JSON data and the body cannot be parsed as such.
                    var ok = status >= 200 && status < 300;
                    // Check whether the body needs to be parsed as JSON (in many cases the browser
                    // will have done that already).
                    if (req.responseType === 'json' && typeof body === 'string') {
                        // Save the original body, before attempting XSSI prefix stripping.
                        var originalBody = body;
                        body = body.replace(XSSI_PREFIX, '');
                        try {
                            // Attempt the parse. If it fails, a parse error should be delivered to the user.
                            body = body !== '' ? JSON.parse(body) : null;
                        }
                        catch (error) {
                            // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                            // JSON response. Restore the original body (including any XSSI prefix) to deliver
                            // a better error response.
                            body = originalBody;
                            // If this was an error request to begin with, leave it as a string, it probably
                            // just isn't JSON. Otherwise, deliver the parsing error to the user.
                            if (ok) {
                                // Even though the response status was 2xx, this is still an error.
                                ok = false;
                                // The parse error contains the text of the body that failed to parse.
                                body = { error: error, text: body };
                            }
                        }
                    }
                    if (ok) {
                        // A successful response is delivered on the event stream.
                        observer.next(new HttpResponse({
                            body: body,
                            headers: headers,
                            status: status,
                            statusText: statusText,
                            url: url || undefined,
                        }));
                        // The full body has been received and delivered, no further events
                        // are possible. This request is complete.
                        observer.complete();
                    }
                    else {
                        // An unsuccessful request is delivered on the error channel.
                        observer.error(new HttpErrorResponse({
                            // The error in this case is the response body (error from the server).
                            error: body,
                            headers: headers,
                            status: status,
                            statusText: statusText,
                            url: url || undefined,
                        }));
                    }
                };
                // The onError callback is called when something goes wrong at the network level.
                // Connection timeout, DNS error, offline, etc. These are actual errors, and are
                // transmitted on the error channel.
                var onError = function (error) {
                    var res = new HttpErrorResponse({
                        error: error,
                        status: xhr.status || 0,
                        statusText: xhr.statusText || 'Unknown Error',
                    });
                    observer.error(res);
                };
                // The sentHeaders flag tracks whether the HttpResponseHeaders event
                // has been sent on the stream. This is necessary to track if progress
                // is enabled since the event will be sent on only the first download
                // progerss event.
                var sentHeaders = false;
                // The download progress event handler, which is only registered if
                // progress events are enabled.
                var onDownProgress = function (event) {
                    // Send the HttpResponseHeaders event if it hasn't been sent already.
                    if (!sentHeaders) {
                        observer.next(partialFromXhr());
                        sentHeaders = true;
                    }
                    // Start building the download progress event to deliver on the response
                    // event stream.
                    var progressEvent = {
                        type: HttpEventType.DownloadProgress,
                        loaded: event.loaded,
                    };
                    // Set the total number of bytes in the event if it's available.
                    if (event.lengthComputable) {
                        progressEvent.total = event.total;
                    }
                    // If the request was for text content and a partial response is
                    // available on XMLHttpRequest, include it in the progress event
                    // to allow for streaming reads.
                    if (req.responseType === 'text' && !!xhr.responseText) {
                        progressEvent.partialText = xhr.responseText;
                    }
                    // Finally, fire the event.
                    observer.next(progressEvent);
                };
                // The upload progress event handler, which is only registered if
                // progress events are enabled.
                var onUpProgress = function (event) {
                    // Upload progress events are simpler. Begin building the progress
                    // event.
                    var progress = {
                        type: HttpEventType.UploadProgress,
                        loaded: event.loaded,
                    };
                    // If the total number of bytes being uploaded is available, include
                    // it.
                    if (event.lengthComputable) {
                        progress.total = event.total;
                    }
                    // Send the event.
                    observer.next(progress);
                };
                // By default, register for load and error events.
                xhr.addEventListener('load', onLoad);
                xhr.addEventListener('error', onError);
                // Progress events are only enabled if requested.
                if (req.reportProgress) {
                    // Download progress is always enabled if requested.
                    xhr.addEventListener('progress', onDownProgress);
                    // Upload progress depends on whether there is a body to upload.
                    if (reqBody !== null && xhr.upload) {
                        xhr.upload.addEventListener('progress', onUpProgress);
                    }
                }
                // Fire the request, and notify the event stream that it was fired.
                xhr.send(reqBody);
                observer.next({ type: HttpEventType.Sent });
                // This is the return from the Observable function, which is the
                // request cancellation handler.
                return function () {
                    // On a cancellation, remove all registered event listeners.
                    xhr.removeEventListener('error', onError);
                    xhr.removeEventListener('load', onLoad);
                    if (req.reportProgress) {
                        xhr.removeEventListener('progress', onDownProgress);
                        if (reqBody !== null && xhr.upload) {
                            xhr.upload.removeEventListener('progress', onUpProgress);
                        }
                    }
                    // Finally, abort the in-flight request.
                    xhr.abort();
                };
            });
        };
        HttpXhrBackend.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HttpXhrBackend.ctorParameters = function () { return [
            { type: XhrFactory, },
        ]; };
        return HttpXhrBackend;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var XSRF_COOKIE_NAME = new core.InjectionToken('XSRF_COOKIE_NAME');
    var XSRF_HEADER_NAME = new core.InjectionToken('XSRF_HEADER_NAME');
    /**
     * Retrieves the current XSRF token to use with the next outgoing request.
     *
     *
     */
    var HttpXsrfTokenExtractor = /** @class */ (function () {
        function HttpXsrfTokenExtractor() {
        }
        return HttpXsrfTokenExtractor;
    }());
    /**
     * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
     */
    var HttpXsrfCookieExtractor = /** @class */ (function () {
        function HttpXsrfCookieExtractor(doc, platform, cookieName) {
            this.doc = doc;
            this.platform = platform;
            this.cookieName = cookieName;
            this.lastCookieString = '';
            this.lastToken = null;
            /**
               * @internal for testing
               */
            this.parseCount = 0;
        }
        HttpXsrfCookieExtractor.prototype.getToken = function () {
            if (this.platform === 'server') {
                return null;
            }
            var cookieString = this.doc.cookie || '';
            if (cookieString !== this.lastCookieString) {
                this.parseCount++;
                this.lastToken = common.ɵparseCookieValue(cookieString, this.cookieName);
                this.lastCookieString = cookieString;
            }
            return this.lastToken;
        };
        HttpXsrfCookieExtractor.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HttpXsrfCookieExtractor.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [core.PLATFORM_ID,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [XSRF_COOKIE_NAME,] },] },
        ]; };
        return HttpXsrfCookieExtractor;
    }());
    /**
     * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
     */
    var HttpXsrfInterceptor = /** @class */ (function () {
        function HttpXsrfInterceptor(tokenService, headerName) {
            this.tokenService = tokenService;
            this.headerName = headerName;
        }
        HttpXsrfInterceptor.prototype.intercept = function (req, next) {
            var lcUrl = req.url.toLowerCase();
            // Skip both non-mutating requests and absolute URLs.
            // Non-mutating requests don't require a token, and absolute URLs require special handling
            // anyway as the cookie set
            // on our origin is not the same as the token expected by another origin.
            if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
                lcUrl.startsWith('https://')) {
                return next.handle(req);
            }
            var token = this.tokenService.getToken();
            // Be careful not to overwrite an existing header of the same name.
            if (token !== null && !req.headers.has(this.headerName)) {
                req = req.clone({ headers: req.headers.set(this.headerName, token) });
            }
            return next.handle(req);
        };
        HttpXsrfInterceptor.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HttpXsrfInterceptor.ctorParameters = function () { return [
            { type: HttpXsrfTokenExtractor, },
            { type: undefined, decorators: [{ type: core.Inject, args: [XSRF_HEADER_NAME,] },] },
        ]; };
        return HttpXsrfInterceptor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * An `HttpHandler` that applies a bunch of `HttpInterceptor`s
     * to a request before passing it to the given `HttpBackend`.
     *
     * The interceptors are loaded lazily from the injector, to allow
     * interceptors to themselves inject classes depending indirectly
     * on `HttpInterceptingHandler` itself.
     */
    var HttpInterceptingHandler = /** @class */ (function () {
        function HttpInterceptingHandler(backend, injector) {
            this.backend = backend;
            this.injector = injector;
            this.chain = null;
        }
        HttpInterceptingHandler.prototype.handle = function (req) {
            if (this.chain === null) {
                var interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
                this.chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, this.backend);
            }
            return this.chain.handle(req);
        };
        HttpInterceptingHandler.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HttpInterceptingHandler.ctorParameters = function () { return [
            { type: HttpBackend, },
            { type: core.Injector, },
        ]; };
        return HttpInterceptingHandler;
    }());
    /**
     * `NgModule` which adds XSRF protection support to outgoing requests.
     *
     * Provided the server supports a cookie-based XSRF protection system, this
     * module can be used directly to configure XSRF protection with the correct
     * cookie and header names.
     *
     * If no such names are provided, the default is to use `X-XSRF-TOKEN` for
     * the header name and `XSRF-TOKEN` for the cookie name.
     *
     *
     */
    var HttpClientXsrfModule = /** @class */ (function () {
        function HttpClientXsrfModule() {
        }
        /**
         * Disable the default XSRF protection.
         */
        /**
           * Disable the default XSRF protection.
           */
        HttpClientXsrfModule.disable = /**
           * Disable the default XSRF protection.
           */
        function () {
            return {
                ngModule: HttpClientXsrfModule,
                providers: [
                    { provide: HttpXsrfInterceptor, useClass: NoopInterceptor },
                ],
            };
        };
        /**
         * Configure XSRF protection to use the given cookie name or header name,
         * or the default names (as described above) if not provided.
         */
        /**
           * Configure XSRF protection to use the given cookie name or header name,
           * or the default names (as described above) if not provided.
           */
        HttpClientXsrfModule.withOptions = /**
           * Configure XSRF protection to use the given cookie name or header name,
           * or the default names (as described above) if not provided.
           */
        function (options) {
            if (options === void 0) { options = {}; }
            return {
                ngModule: HttpClientXsrfModule,
                providers: [
                    options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
                    options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
                ],
            };
        };
        HttpClientXsrfModule.decorators = [
            { type: core.NgModule, args: [{
                        providers: [
                            HttpXsrfInterceptor,
                            { provide: HTTP_INTERCEPTORS, useExisting: HttpXsrfInterceptor, multi: true },
                            { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfCookieExtractor },
                            { provide: XSRF_COOKIE_NAME, useValue: 'XSRF-TOKEN' },
                            { provide: XSRF_HEADER_NAME, useValue: 'X-XSRF-TOKEN' },
                        ],
                    },] }
        ];
        /** @nocollapse */
        HttpClientXsrfModule.ctorParameters = function () { return []; };
        return HttpClientXsrfModule;
    }());
    /**
     * `NgModule` which provides the `HttpClient` and associated services.
     *
     * Interceptors can be added to the chain behind `HttpClient` by binding them
     * to the multiprovider for `HTTP_INTERCEPTORS`.
     *
     *
     */
    var HttpClientModule = /** @class */ (function () {
        function HttpClientModule() {
        }
        HttpClientModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            HttpClientXsrfModule.withOptions({
                                cookieName: 'XSRF-TOKEN',
                                headerName: 'X-XSRF-TOKEN',
                            }),
                        ],
                        providers: [
                            HttpClient,
                            { provide: HttpHandler, useClass: HttpInterceptingHandler },
                            HttpXhrBackend,
                            { provide: HttpBackend, useExisting: HttpXhrBackend },
                            BrowserXhr,
                            { provide: XhrFactory, useExisting: BrowserXhr },
                        ],
                    },] }
        ];
        /** @nocollapse */
        HttpClientModule.ctorParameters = function () { return []; };
        return HttpClientModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token used to inject the document into Directionality.
     * This is used so that the value can be faked in tests.
     *
     * We can't use the real document in tests because changing the real `dir` causes geometry-based
     * tests in Safari to fail.
     *
     * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
     * themselves use things like `querySelector` in test code.
     *
     * This token is defined in a separate file from Directionality as a workaround for
     * https://github.com/angular/angular/issues/22559
     *
     * \@docs-private
     */
    var /** @type {?} */ DIR_DOCUMENT = new core.InjectionToken('cdk-dir-doc', {
        providedIn: 'root',
        factory: DIR_DOCUMENT_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function DIR_DOCUMENT_FACTORY() {
        return core.inject(common.DOCUMENT);
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The directionality (LTR / RTL) context for the application (or a subtree of it).
     * Exposes the current direction and a stream of direction changes.
     */
    var Directionality = /** @class */ (function () {
        function Directionality(_document) {
            /**
             * The current 'ltr' or 'rtl' value.
             */
            this.value = 'ltr';
            /**
             * Stream that emits whenever the 'ltr' / 'rtl' state changes.
             */
            this.change = new core.EventEmitter();
            if (_document) {
                // TODO: handle 'auto' value -
                // We still need to account for dir="auto".
                // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
                // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
                var /** @type {?} */ bodyDir = _document.body ? _document.body.dir : null;
                var /** @type {?} */ htmlDir = _document.documentElement ? _document.documentElement.dir : null;
                this.value = /** @type {?} */ ((bodyDir || htmlDir || 'ltr'));
            }
        }
        /**
         * @return {?}
         */
        Directionality.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.change.complete();
        };
        Directionality.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        Directionality.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [DIR_DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ Directionality.ngInjectableDef = core.defineInjectable({ factory: function Directionality_Factory() { return new Directionality(core.inject(DIR_DOCUMENT, 8)); }, token: Directionality, providedIn: "root" });
        return Directionality;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Directive to listen for changes of direction of part of the DOM.
     *
     * Provides itself as Directionality such that descendant directives only need to ever inject
     * Directionality to get the closest direction.
     */
    var Dir = /** @class */ (function () {
        function Dir() {
            this._dir = 'ltr';
            /**
             * Whether the `value` has been set to its initial value.
             */
            this._isInitialized = false;
            /**
             * Event emitted when the direction changes.
             */
            this.change = new core.EventEmitter();
        }
        Object.defineProperty(Dir.prototype, "dir", {
            get: /**
             * \@docs-private
             * @return {?}
             */
            function () { return this._dir; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                var /** @type {?} */ old = this._dir;
                this._dir = v;
                if (old !== this._dir && this._isInitialized) {
                    this.change.emit(this._dir);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Dir.prototype, "value", {
            /** Current layout direction of the element. */
            get: /**
             * Current layout direction of the element.
             * @return {?}
             */
            function () { return this.dir; },
            enumerable: true,
            configurable: true
        });
        /** Initialize once default value has been set. */
        /**
         * Initialize once default value has been set.
         * @return {?}
         */
        Dir.prototype.ngAfterContentInit = /**
         * Initialize once default value has been set.
         * @return {?}
         */
        function () {
            this._isInitialized = true;
        };
        /**
         * @return {?}
         */
        Dir.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.change.complete();
        };
        Dir.decorators = [
            { type: core.Directive, args: [{
                        selector: '[dir]',
                        providers: [{ provide: Directionality, useExisting: Dir }],
                        host: { '[dir]': 'dir' },
                        exportAs: 'dir',
                    },] },
        ];
        /** @nocollapse */
        Dir.propDecorators = {
            "change": [{ type: core.Output, args: ['dirChange',] },],
            "dir": [{ type: core.Input },],
        };
        return Dir;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var BidiModule = /** @class */ (function () {
        function BidiModule() {
        }
        BidiModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [Dir],
                        declarations: [Dir],
                    },] },
        ];
        return BidiModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Coerces a data-bound value (typically a string) to a boolean.
     * @param {?} value
     * @return {?}
     */
    function coerceBooleanProperty(value) {
        return value != null && "" + value !== 'false';
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * @param {?} value
     * @param {?=} fallbackValue
     * @return {?}
     */
    function coerceNumberProperty(value, fallbackValue) {
        if (fallbackValue === void 0) { fallbackValue = 0; }
        return _isNumberValue(value) ? Number(value) : fallbackValue;
    }
    /**
     * Whether the provided value is considered a number.
     * \@docs-private
     * @param {?} value
     * @return {?}
     */
    function _isNumberValue(value) {
        // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
        // and other non-number values as NaN, where Number just uses 0) but it considers the string
        // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
        return !isNaN(parseFloat(/** @type {?} */ (value))) && !isNaN(Number(value));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Wraps the provided value in an array, unless the provided value is an array.
     * @template T
     * @param {?} value
     * @return {?}
     */
    function coerceArray(value) {
        return Array.isArray(value) ? value : [value];
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Coerces a value to a CSS pixel value.
     * @param {?} value
     * @return {?}
     */
    function coerceCssPixelValue(value) {
        if (value == null) {
            return '';
        }
        return typeof value === 'string' ? value : value + "px";
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Whether the current platform supports the V8 Break Iterator. The V8 check
    // is necessary to detect all Blink based browsers.
    var /** @type {?} */ hasV8BreakIterator = (typeof Intl !== 'undefined' && (/** @type {?} */ (Intl)).v8BreakIterator);
    /**
     * Service to detect the current platform by comparing the userAgent strings and
     * checking browser-specific global properties.
     */
    var Platform = /** @class */ (function () {
        /**
         * @deletion-target v7.0.0 remove optional decorator
         */
        function Platform(_platformId) {
            this._platformId = _platformId;
            /**
             * Whether the Angular application is being rendered in the browser.
             * We want to use the Angular platform check because if the Document is shimmed
             * without the navigator, the following checks will fail. This is preferred because
             * sometimes the Document may be shimmed without the user's knowledge or intention
             */
            this.isBrowser = this._platformId ?
                common.isPlatformBrowser(this._platformId) : typeof document === 'object' && !!document;
            /**
             * Whether the current browser is Microsoft Edge.
             */
            this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
            /**
             * Whether the current rendering engine is Microsoft Trident.
             */
            this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
            /**
             * Whether the current rendering engine is Blink.
             */
            this.BLINK = this.isBrowser && (!!((/** @type {?} */ (window)).chrome || hasV8BreakIterator) &&
                typeof CSS !== 'undefined' && !this.EDGE && !this.TRIDENT);
            /**
             * Whether the current rendering engine is WebKit.
             */
            this.WEBKIT = this.isBrowser &&
                /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
            /**
             * Whether the current platform is Apple iOS.
             */
            this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                !(/** @type {?} */ (window)).MSStream;
            /**
             * Whether the current browser is Firefox.
             */
            this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
            /**
             * Whether the current platform is Android.
             */
            this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
            /**
             * Whether the current browser is Safari.
             */
            this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
        }
        Platform.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        Platform.ctorParameters = function () { return [
            { type: Object, decorators: [{ type: core.Optional }, { type: core.Inject, args: [core.PLATFORM_ID,] },] },
        ]; };
        /** @nocollapse */ Platform.ngInjectableDef = core.defineInjectable({ factory: function Platform_Factory() { return new Platform(core.inject(core.PLATFORM_ID, 8)); }, token: Platform, providedIn: "root" });
        return Platform;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Cached result of whether the user's browser supports passive event listeners.
     */
    var /** @type {?} */ supportsPassiveEvents;
    /**
     * Checks whether the user's browser supports passive event listeners.
     * See: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
     * @return {?}
     */
    function supportsPassiveEventListeners() {
        if (supportsPassiveEvents == null && typeof window !== 'undefined') {
            try {
                window.addEventListener('test', /** @type {?} */ ((null)), Object.defineProperty({}, 'passive', {
                    get: function () { return supportsPassiveEvents = true; }
                }));
            }
            finally {
                supportsPassiveEvents = supportsPassiveEvents || false;
            }
        }
        return supportsPassiveEvents;
    }
    /**
     * Cached result Set of input types support by the current browser.
     */
    var /** @type {?} */ supportedInputTypes;
    /**
     * Types of `<input>` that *might* be supported.
     */
    var /** @type {?} */ candidateInputTypes = [
        'color',
        'button',
        'checkbox',
        'date',
        'datetime-local',
        'email',
        'file',
        'hidden',
        'image',
        'month',
        'number',
        'password',
        'radio',
        'range',
        'reset',
        'search',
        'submit',
        'tel',
        'text',
        'time',
        'url',
        'week',
    ];
    /**
     * @return {?} The input types supported by this browser.
     */
    function getSupportedInputTypes() {
        // Result is cached.
        if (supportedInputTypes) {
            return supportedInputTypes;
        }
        // We can't check if an input type is not supported until we're on the browser, so say that
        // everything is supported when not on the browser. We don't use `Platform` here since it's
        // just a helper function and can't inject it.
        if (typeof document !== 'object' || !document) {
            supportedInputTypes = new Set(candidateInputTypes);
            return supportedInputTypes;
        }
        var /** @type {?} */ featureTestInput = document.createElement('input');
        supportedInputTypes = new Set(candidateInputTypes.filter(function (value) {
            featureTestInput.setAttribute('type', value);
            return featureTestInput.type === value;
        }));
        return supportedInputTypes;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var PlatformModule = /** @class */ (function () {
        function PlatformModule() {
        }
        PlatformModule.decorators = [
            { type: core.NgModule },
        ];
        return PlatformModule;
    }());

    /**
     * @license Angular v6.0.0
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var _DOM = (null);
    function getDOM() {
        return _DOM;
    }

    function setRootDomAdapter(adapter) {
        if (!_DOM) {
            _DOM = adapter;
        }
    }
    /* tslint:disable:requireParameterType */
    /**
     * Provides DOM operations in an environment-agnostic way.
     *
     * @security Tread carefully! Interacting with the DOM directly is dangerous and
     * can introduce XSS risks.
     */
    var DomAdapter = /** @class */ (function () {
        function DomAdapter() {
            this.resourceLoaderType = null;
        }
        Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
            /**
             * Maps attribute names to their corresponding property names for cases
             * where attribute name doesn't match property name.
             */
            get: /**
               * Maps attribute names to their corresponding property names for cases
               * where attribute name doesn't match property name.
               */
            function () { return this._attrToPropMap; },
            set: function (value) { this._attrToPropMap = value; },
            enumerable: true,
            configurable: true
        });
        return DomAdapter;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Provides DOM operations in any browser environment.
     *
     * @security Tread carefully! Interacting with the DOM directly is dangerous and
     * can introduce XSS risks.
     */
    var GenericBrowserDomAdapter = /** @class */ (function (_super) {
        __extends(GenericBrowserDomAdapter, _super);
        function GenericBrowserDomAdapter() {
            var _this = _super.call(this) || this;
            _this._animationPrefix = null;
            _this._transitionEnd = null;
            try {
                var element_1 = _this.createElement('div', document);
                if (_this.getStyle(element_1, 'animationName') != null) {
                    _this._animationPrefix = '';
                }
                else {
                    var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                    for (var i = 0; i < domPrefixes.length; i++) {
                        if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
                            _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                            break;
                        }
                    }
                }
                var transEndEventNames_1 = {
                    WebkitTransition: 'webkitTransitionEnd',
                    MozTransition: 'transitionend',
                    OTransition: 'oTransitionEnd otransitionend',
                    transition: 'transitionend'
                };
                Object.keys(transEndEventNames_1).forEach(function (key) {
                    if (_this.getStyle(element_1, key) != null) {
                        _this._transitionEnd = transEndEventNames_1[key];
                    }
                });
            }
            catch (e) {
                _this._animationPrefix = null;
                _this._transitionEnd = null;
            }
            return _this;
        }
        GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) { return el.getDistributedNodes(); };
        GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
            el.href = href == null ? baseUrl : baseUrl + '/../' + href;
        };
        GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () { return true; };
        GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
            return typeof document.body.createShadowRoot === 'function';
        };
        GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () { return this._animationPrefix ? this._animationPrefix : ''; };
        GenericBrowserDomAdapter.prototype.getTransitionEnd = function () { return this._transitionEnd ? this._transitionEnd : ''; };
        GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
            return this._animationPrefix != null && this._transitionEnd != null;
        };
        return GenericBrowserDomAdapter;
    }(DomAdapter));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var _attrToPropMap = {
        'class': 'className',
        'innerHtml': 'innerHTML',
        'readonly': 'readOnly',
        'tabindex': 'tabIndex',
    };
    var DOM_KEY_LOCATION_NUMPAD = 3;
    // Map to convert some key or keyIdentifier values to what will be returned by getEventKey
    var _keyMap = {
        // The following values are here for cross-browser compatibility and to match the W3C standard
        // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
        '\b': 'Backspace',
        '\t': 'Tab',
        '\x7F': 'Delete',
        '\x1B': 'Escape',
        'Del': 'Delete',
        'Esc': 'Escape',
        'Left': 'ArrowLeft',
        'Right': 'ArrowRight',
        'Up': 'ArrowUp',
        'Down': 'ArrowDown',
        'Menu': 'ContextMenu',
        'Scroll': 'ScrollLock',
        'Win': 'OS'
    };
    // There is a bug in Chrome for numeric keypad keys:
    // https://code.google.com/p/chromium/issues/detail?id=155654
    // 1, 2, 3 ... are reported as A, B, C ...
    var _chromeNumKeyPadMap = {
        'A': '1',
        'B': '2',
        'C': '3',
        'D': '4',
        'E': '5',
        'F': '6',
        'G': '7',
        'H': '8',
        'I': '9',
        'J': '*',
        'K': '+',
        'M': '-',
        'N': '.',
        'O': '/',
        '\x60': '0',
        '\x90': 'NumLock'
    };
    var nodeContains;
    if (core.ɵglobal['Node']) {
        nodeContains = core.ɵglobal['Node'].prototype.contains || function (node) {
            return !!(this.compareDocumentPosition(node) & 16);
        };
    }
    /**
     * A `DomAdapter` powered by full browser DOM APIs.
     *
     * @security Tread carefully! Interacting with the DOM directly is dangerous and
     * can introduce XSS risks.
     */
    /* tslint:disable:requireParameterType no-console */
    var BrowserDomAdapter = /** @class */ (function (_super) {
        __extends(BrowserDomAdapter, _super);
        function BrowserDomAdapter() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        BrowserDomAdapter.prototype.parse = function (templateHtml) { throw new Error('parse not implemented'); };
        BrowserDomAdapter.makeCurrent = function () { setRootDomAdapter(new BrowserDomAdapter()); };
        BrowserDomAdapter.prototype.hasProperty = function (element, name) { return name in element; };
        BrowserDomAdapter.prototype.setProperty = function (el, name, value) { el[name] = value; };
        BrowserDomAdapter.prototype.getProperty = function (el, name) { return el[name]; };
        BrowserDomAdapter.prototype.invoke = function (el, methodName, args) {
            (_a = el)[methodName].apply(_a, __spread(args));
            var _a;
        };
        // TODO(tbosch): move this into a separate environment class once we have it
        // TODO(tbosch): move this into a separate environment class once we have it
        BrowserDomAdapter.prototype.logError = 
        // TODO(tbosch): move this into a separate environment class once we have it
        function (error) {
            if (window.console) {
                if (console.error) {
                    console.error(error);
                }
                else {
                    console.log(error);
                }
            }
        };
        BrowserDomAdapter.prototype.log = function (error) {
            if (window.console) {
                window.console.log && window.console.log(error);
            }
        };
        BrowserDomAdapter.prototype.logGroup = function (error) {
            if (window.console) {
                window.console.group && window.console.group(error);
            }
        };
        BrowserDomAdapter.prototype.logGroupEnd = function () {
            if (window.console) {
                window.console.groupEnd && window.console.groupEnd();
            }
        };
        Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
            get: function () { return _attrToPropMap; },
            enumerable: true,
            configurable: true
        });
        BrowserDomAdapter.prototype.contains = function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
        BrowserDomAdapter.prototype.querySelector = function (el, selector) { return el.querySelector(selector); };
        BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) { return el.querySelectorAll(selector); };
        BrowserDomAdapter.prototype.on = function (el, evt, listener) { el.addEventListener(evt, listener, false); };
        BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
            el.addEventListener(evt, listener, false);
            // Needed to follow Dart's subscription semantic, until fix of
            // https://code.google.com/p/dart/issues/detail?id=17406
            return function () { el.removeEventListener(evt, listener, false); };
        };
        BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) { el.dispatchEvent(evt); };
        BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
            var evt = this.getDefaultDocument().createEvent('MouseEvent');
            evt.initEvent(eventType, true, true);
            return evt;
        };
        BrowserDomAdapter.prototype.createEvent = function (eventType) {
            var evt = this.getDefaultDocument().createEvent('Event');
            evt.initEvent(eventType, true, true);
            return evt;
        };
        BrowserDomAdapter.prototype.preventDefault = function (evt) {
            evt.preventDefault();
            evt.returnValue = false;
        };
        BrowserDomAdapter.prototype.isPrevented = function (evt) {
            return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
        };
        BrowserDomAdapter.prototype.getInnerHTML = function (el) { return el.innerHTML; };
        BrowserDomAdapter.prototype.getTemplateContent = function (el) {
            return 'content' in el && this.isTemplateElement(el) ? el.content : null;
        };
        BrowserDomAdapter.prototype.getOuterHTML = function (el) { return el.outerHTML; };
        BrowserDomAdapter.prototype.nodeName = function (node) { return node.nodeName; };
        BrowserDomAdapter.prototype.nodeValue = function (node) { return node.nodeValue; };
        BrowserDomAdapter.prototype.type = function (node) { return node.type; };
        BrowserDomAdapter.prototype.content = function (node) {
            if (this.hasProperty(node, 'content')) {
                return node.content;
            }
            else {
                return node;
            }
        };
        BrowserDomAdapter.prototype.firstChild = function (el) { return el.firstChild; };
        BrowserDomAdapter.prototype.nextSibling = function (el) { return el.nextSibling; };
        BrowserDomAdapter.prototype.parentElement = function (el) { return el.parentNode; };
        BrowserDomAdapter.prototype.childNodes = function (el) { return el.childNodes; };
        BrowserDomAdapter.prototype.childNodesAsList = function (el) {
            var childNodes = el.childNodes;
            var res = new Array(childNodes.length);
            for (var i = 0; i < childNodes.length; i++) {
                res[i] = childNodes[i];
            }
            return res;
        };
        BrowserDomAdapter.prototype.clearNodes = function (el) {
            while (el.firstChild) {
                el.removeChild(el.firstChild);
            }
        };
        BrowserDomAdapter.prototype.appendChild = function (el, node) { el.appendChild(node); };
        BrowserDomAdapter.prototype.removeChild = function (el, node) { el.removeChild(node); };
        BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
        BrowserDomAdapter.prototype.remove = function (node) {
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            return node;
        };
        BrowserDomAdapter.prototype.insertBefore = function (parent, ref, node) { parent.insertBefore(node, ref); };
        BrowserDomAdapter.prototype.insertAllBefore = function (parent, ref, nodes) {
            nodes.forEach(function (n) { return parent.insertBefore(n, ref); });
        };
        BrowserDomAdapter.prototype.insertAfter = function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
        BrowserDomAdapter.prototype.setInnerHTML = function (el, value) { el.innerHTML = value; };
        BrowserDomAdapter.prototype.getText = function (el) { return el.textContent; };
        BrowserDomAdapter.prototype.setText = function (el, value) { el.textContent = value; };
        BrowserDomAdapter.prototype.getValue = function (el) { return el.value; };
        BrowserDomAdapter.prototype.setValue = function (el, value) { el.value = value; };
        BrowserDomAdapter.prototype.getChecked = function (el) { return el.checked; };
        BrowserDomAdapter.prototype.setChecked = function (el, value) { el.checked = value; };
        BrowserDomAdapter.prototype.createComment = function (text) { return this.getDefaultDocument().createComment(text); };
        BrowserDomAdapter.prototype.createTemplate = function (html) {
            var t = this.getDefaultDocument().createElement('template');
            t.innerHTML = html;
            return t;
        };
        BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
            doc = doc || this.getDefaultDocument();
            return doc.createElement(tagName);
        };
        BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
            doc = doc || this.getDefaultDocument();
            return doc.createElementNS(ns, tagName);
        };
        BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
            doc = doc || this.getDefaultDocument();
            return doc.createTextNode(text);
        };
        BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
            doc = doc || this.getDefaultDocument();
            var el = doc.createElement('SCRIPT');
            el.setAttribute(attrName, attrValue);
            return el;
        };
        BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
            doc = doc || this.getDefaultDocument();
            var style = doc.createElement('style');
            this.appendChild(style, this.createTextNode(css, doc));
            return style;
        };
        BrowserDomAdapter.prototype.createShadowRoot = function (el) { return el.createShadowRoot(); };
        BrowserDomAdapter.prototype.getShadowRoot = function (el) { return el.shadowRoot; };
        BrowserDomAdapter.prototype.getHost = function (el) { return el.host; };
        BrowserDomAdapter.prototype.clone = function (node) { return node.cloneNode(true); };
        BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
            return element.getElementsByClassName(name);
        };
        BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
            return element.getElementsByTagName(name);
        };
        BrowserDomAdapter.prototype.classList = function (element) { return Array.prototype.slice.call(element.classList, 0); };
        BrowserDomAdapter.prototype.addClass = function (element, className) { element.classList.add(className); };
        BrowserDomAdapter.prototype.removeClass = function (element, className) { element.classList.remove(className); };
        BrowserDomAdapter.prototype.hasClass = function (element, className) {
            return element.classList.contains(className);
        };
        BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
            element.style[styleName] = styleValue;
        };
        BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
            // IE requires '' instead of null
            // see https://github.com/angular/angular/issues/7916
            element.style[stylename] = '';
        };
        BrowserDomAdapter.prototype.getStyle = function (element, stylename) { return element.style[stylename]; };
        BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
            var value = this.getStyle(element, styleName) || '';
            return styleValue ? value == styleValue : value.length > 0;
        };
        BrowserDomAdapter.prototype.tagName = function (element) { return element.tagName; };
        BrowserDomAdapter.prototype.attributeMap = function (element) {
            var res = new Map();
            var elAttrs = element.attributes;
            for (var i = 0; i < elAttrs.length; i++) {
                var attrib = elAttrs.item(i);
                res.set(attrib.name, attrib.value);
            }
            return res;
        };
        BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
            return element.hasAttribute(attribute);
        };
        BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
            return element.hasAttributeNS(ns, attribute);
        };
        BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
            return element.getAttribute(attribute);
        };
        BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
            return element.getAttributeNS(ns, name);
        };
        BrowserDomAdapter.prototype.setAttribute = function (element, name, value) { element.setAttribute(name, value); };
        BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
            element.setAttributeNS(ns, name, value);
        };
        BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) { element.removeAttribute(attribute); };
        BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
            element.removeAttributeNS(ns, name);
        };
        BrowserDomAdapter.prototype.templateAwareRoot = function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
        BrowserDomAdapter.prototype.createHtmlDocument = function () {
            return document.implementation.createHTMLDocument('fakeTitle');
        };
        BrowserDomAdapter.prototype.getDefaultDocument = function () { return document; };
        BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
            try {
                return el.getBoundingClientRect();
            }
            catch (e) {
                return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
            }
        };
        BrowserDomAdapter.prototype.getTitle = function (doc) { return doc.title; };
        BrowserDomAdapter.prototype.setTitle = function (doc, newTitle) { doc.title = newTitle || ''; };
        BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
            if (this.isElementNode(n)) {
                return n.matches && n.matches(selector) ||
                    n.msMatchesSelector && n.msMatchesSelector(selector) ||
                    n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
            }
            return false;
        };
        BrowserDomAdapter.prototype.isTemplateElement = function (el) {
            return this.isElementNode(el) && el.nodeName === 'TEMPLATE';
        };
        BrowserDomAdapter.prototype.isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
        BrowserDomAdapter.prototype.isCommentNode = function (node) { return node.nodeType === Node.COMMENT_NODE; };
        BrowserDomAdapter.prototype.isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
        BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
            return node.shadowRoot != null && node instanceof HTMLElement;
        };
        BrowserDomAdapter.prototype.isShadowRoot = function (node) { return node instanceof DocumentFragment; };
        BrowserDomAdapter.prototype.importIntoDoc = function (node) { return document.importNode(this.templateAwareRoot(node), true); };
        BrowserDomAdapter.prototype.adoptNode = function (node) { return document.adoptNode(node); };
        BrowserDomAdapter.prototype.getHref = function (el) { return el.getAttribute('href'); };
        BrowserDomAdapter.prototype.getEventKey = function (event) {
            var key = event.key;
            if (key == null) {
                key = event.keyIdentifier;
                // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
                // Safari cf
                // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
                if (key == null) {
                    return 'Unidentified';
                }
                if (key.startsWith('U+')) {
                    key = String.fromCharCode(parseInt(key.substring(2), 16));
                    if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                        // There is a bug in Chrome for numeric keypad keys:
                        // https://code.google.com/p/chromium/issues/detail?id=155654
                        // 1, 2, 3 ... are reported as A, B, C ...
                        key = _chromeNumKeyPadMap[key];
                    }
                }
            }
            return _keyMap[key] || key;
        };
        BrowserDomAdapter.prototype.getGlobalEventTarget = function (doc, target) {
            if (target === 'window') {
                return window;
            }
            if (target === 'document') {
                return doc;
            }
            if (target === 'body') {
                return doc.body;
            }
            return null;
        };
        BrowserDomAdapter.prototype.getHistory = function () { return window.history; };
        BrowserDomAdapter.prototype.getLocation = function () { return window.location; };
        BrowserDomAdapter.prototype.getBaseHref = function (doc) {
            var href = getBaseElementHref();
            return href == null ? null : relativePath(href);
        };
        BrowserDomAdapter.prototype.resetBaseElement = function () { baseElement = null; };
        BrowserDomAdapter.prototype.getUserAgent = function () { return window.navigator.userAgent; };
        BrowserDomAdapter.prototype.setData = function (element, name, value) {
            this.setAttribute(element, 'data-' + name, value);
        };
        BrowserDomAdapter.prototype.getData = function (element, name) {
            return this.getAttribute(element, 'data-' + name);
        };
        BrowserDomAdapter.prototype.getComputedStyle = function (element) { return getComputedStyle(element); };
        // TODO(tbosch): move this into a separate environment class once we have it
        // TODO(tbosch): move this into a separate environment class once we have it
        BrowserDomAdapter.prototype.supportsWebAnimation = 
        // TODO(tbosch): move this into a separate environment class once we have it
        function () {
            return typeof Element.prototype['animate'] === 'function';
        };
        BrowserDomAdapter.prototype.performanceNow = function () {
            // performance.now() is not available in all browsers, see
            // http://caniuse.com/#search=performance.now
            return window.performance && window.performance.now ? window.performance.now() :
                new Date().getTime();
        };
        BrowserDomAdapter.prototype.supportsCookies = function () { return true; };
        BrowserDomAdapter.prototype.getCookie = function (name) { return common.ɵparseCookieValue(document.cookie, name); };
        BrowserDomAdapter.prototype.setCookie = function (name, value) {
            // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
            // not clear other cookies.
            document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        };
        return BrowserDomAdapter;
    }(GenericBrowserDomAdapter));
    var baseElement = null;
    function getBaseElementHref() {
        if (!baseElement) {
            baseElement = (document.querySelector('base'));
            if (!baseElement) {
                return null;
            }
        }
        return baseElement.getAttribute('href');
    }
    // based on urlUtils.js in AngularJS 1
    var urlParsingNode;
    function relativePath(url) {
        if (!urlParsingNode) {
            urlParsingNode = document.createElement('a');
        }
        urlParsingNode.setAttribute('href', url);
        return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
            '/' + urlParsingNode.pathname;
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * A DI Token representing the main rendering context. In a browser this is the DOM Document.
     *
     * Note: Document might not be available in the Application Context when Application and Rendering
     * Contexts are not the same (e.g. when running the application into a Web Worker).
     *
     * @deprecated import from `@angular/common` instead.
     */
    var DOCUMENT$1 = common.DOCUMENT;

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function supportsState() {
        return !!window.history.pushState;
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
     * This class should not be used directly by an application developer. Instead, use
     * {@link Location}.
     */
    var BrowserPlatformLocation = /** @class */ (function (_super) {
        __extends(BrowserPlatformLocation, _super);
        function BrowserPlatformLocation(_doc) {
            var _this = _super.call(this) || this;
            _this._doc = _doc;
            _this._init();
            return _this;
        }
        // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
        /** @internal */
        // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
        /** @internal */
        BrowserPlatformLocation.prototype._init = 
        // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
        /** @internal */
        function () {
            this.location = getDOM().getLocation();
            this._history = getDOM().getHistory();
        };
        BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () { return getDOM().getBaseHref(this._doc); };
        BrowserPlatformLocation.prototype.onPopState = function (fn) {
            getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
        };
        BrowserPlatformLocation.prototype.onHashChange = function (fn) {
            getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
        };
        Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
            get: function () { return this.location.pathname; },
            set: function (newPath) { this.location.pathname = newPath; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
            get: function () { return this.location.search; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
            get: function () { return this.location.hash; },
            enumerable: true,
            configurable: true
        });
        BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
            if (supportsState()) {
                this._history.pushState(state, title, url);
            }
            else {
                this.location.hash = url;
            }
        };
        BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
            if (supportsState()) {
                this._history.replaceState(state, title, url);
            }
            else {
                this.location.hash = url;
            }
        };
        BrowserPlatformLocation.prototype.forward = function () { this._history.forward(); };
        BrowserPlatformLocation.prototype.back = function () { this._history.back(); };
        BrowserPlatformLocation.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        BrowserPlatformLocation.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        ]; };
        return BrowserPlatformLocation;
    }(common.PlatformLocation));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * An id that identifies a particular application being bootstrapped, that should
     * match across the client/server boundary.
     */
    var TRANSITION_ID = new core.InjectionToken('TRANSITION_ID');

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var BrowserGetTestability = /** @class */ (function () {
        function BrowserGetTestability() {
        }
        BrowserGetTestability.init = function () { core.setTestabilityGetter(new BrowserGetTestability()); };
        BrowserGetTestability.prototype.addToWindow = function (registry) {
            core.ɵglobal['getAngularTestability'] = function (elem, findInAncestors) {
                if (findInAncestors === void 0) { findInAncestors = true; }
                var testability = registry.findTestabilityInTree(elem, findInAncestors);
                if (testability == null) {
                    throw new Error('Could not find testability for element.');
                }
                return testability;
            };
            core.ɵglobal['getAllAngularTestabilities'] = function () { return registry.getAllTestabilities(); };
            core.ɵglobal['getAllAngularRootElements'] = function () { return registry.getAllRootElements(); };
            var whenAllStable = function (callback /** TODO #9100 */) {
                var testabilities = core.ɵglobal['getAllAngularTestabilities']();
                var count = testabilities.length;
                var didWork = false;
                var decrement = function (didWork_ /** TODO #9100 */) {
                    didWork = didWork || didWork_;
                    count--;
                    if (count == 0) {
                        callback(didWork);
                    }
                };
                testabilities.forEach(function (testability /** TODO #9100 */) {
                    testability.whenStable(decrement);
                });
            };
            if (!core.ɵglobal['frameworkStabilizers']) {
                core.ɵglobal['frameworkStabilizers'] = [];
            }
            core.ɵglobal['frameworkStabilizers'].push(whenAllStable);
        };
        BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
            if (elem == null) {
                return null;
            }
            var t = registry.getTestability(elem);
            if (t != null) {
                return t;
            }
            else if (!findInAncestors) {
                return null;
            }
            if (getDOM().isShadowRoot(elem)) {
                return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
            }
            return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
        };
        return BrowserGetTestability;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */


    /**
     * Exports the value under a given `name` in the global property `ng`. For example `ng.probe` if
     * `name` is `'probe'`.
     * @param name Name under which it will be exported. Keep in mind this will be a property of the
     * global `ng` object.
     * @param value The value to export.
     */
    function exportNgVar(name, value) {
        if (typeof COMPILED === 'undefined' || !COMPILED) {
            // Note: we can't export `ng` when using closure enhanced optimization as:
            // - closure declares globals itself for minified names, which sometimes clobber our `ng` global
            // - we can't declare a closure extern as the namespace `ng` is already used within Google
            //   for typings for angularJS (via `goog.provide('ng....')`).
            var ng = core.ɵglobal['ng'] = core.ɵglobal['ng'] || {};
            ng[name] = value;
        }
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var CORE_TOKENS = {
        'ApplicationRef': core.ApplicationRef,
        'NgZone': core.NgZone,
    };
    var INSPECT_GLOBAL_NAME = 'probe';
    var CORE_TOKENS_GLOBAL_NAME = 'coreTokens';
    /**
     * Returns a {@link DebugElement} for the given native DOM element, or
     * null if the given native element does not have an Angular view associated
     * with it.
     */
    function inspectNativeElement(element) {
        return core.getDebugNode(element);
    }
    function _createNgProbe(coreTokens) {
        exportNgVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
        exportNgVar(CORE_TOKENS_GLOBAL_NAME, __assign({}, CORE_TOKENS, _ngProbeTokensToMap(coreTokens || [])));
        return function () { return inspectNativeElement; };
    }
    function _ngProbeTokensToMap(tokens) {
        return tokens.reduce(function (prev, t) { return (prev[t.name] = t.token, prev); }, {});
    }
    /**
     * Providers which support debugging Angular applications (e.g. via `ng.probe`).
     */
    var ELEMENT_PROBE_PROVIDERS = [
        {
            provide: core.APP_INITIALIZER,
            useFactory: _createNgProbe,
            deps: [
                [core.NgProbeToken, new core.Optional()],
            ],
            multi: true,
        },
    ];

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     *
     */
    var EVENT_MANAGER_PLUGINS = new core.InjectionToken('EventManagerPlugins');
    /**
     *
     */
    var EventManager = /** @class */ (function () {
        function EventManager(plugins, _zone) {
            var _this = this;
            this._zone = _zone;
            this._eventNameToPlugin = new Map();
            plugins.forEach(function (p) { return p.manager = _this; });
            this._plugins = plugins.slice().reverse();
        }
        EventManager.prototype.addEventListener = function (element, eventName, handler) {
            var plugin = this._findPluginFor(eventName);
            return plugin.addEventListener(element, eventName, handler);
        };
        EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
            var plugin = this._findPluginFor(eventName);
            return plugin.addGlobalEventListener(target, eventName, handler);
        };
        EventManager.prototype.getZone = function () { return this._zone; };
        /** @internal */
        /** @internal */
        EventManager.prototype._findPluginFor = /** @internal */
        function (eventName) {
            var plugin = this._eventNameToPlugin.get(eventName);
            if (plugin) {
                return plugin;
            }
            var plugins = this._plugins;
            for (var i = 0; i < plugins.length; i++) {
                var plugin_1 = plugins[i];
                if (plugin_1.supports(eventName)) {
                    this._eventNameToPlugin.set(eventName, plugin_1);
                    return plugin_1;
                }
            }
            throw new Error("No event manager plugin found for event " + eventName);
        };
        EventManager.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        EventManager.ctorParameters = function () { return [
            { type: Array, decorators: [{ type: core.Inject, args: [EVENT_MANAGER_PLUGINS,] },] },
            { type: core.NgZone, },
        ]; };
        return EventManager;
    }());
    var EventManagerPlugin = /** @class */ (function () {
        function EventManagerPlugin(_doc) {
            this._doc = _doc;
        }
        EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
            var target = getDOM().getGlobalEventTarget(this._doc, element);
            if (!target) {
                throw new Error("Unsupported event target " + target + " for event " + eventName);
            }
            return this.addEventListener(target, eventName, handler);
        };
        return EventManagerPlugin;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var SharedStylesHost = /** @class */ (function () {
        function SharedStylesHost() {
            /** @internal */
            this._stylesSet = new Set();
        }
        SharedStylesHost.prototype.addStyles = function (styles) {
            var _this = this;
            var additions = new Set();
            styles.forEach(function (style) {
                if (!_this._stylesSet.has(style)) {
                    _this._stylesSet.add(style);
                    additions.add(style);
                }
            });
            this.onStylesAdded(additions);
        };
        SharedStylesHost.prototype.onStylesAdded = function (additions) { };
        SharedStylesHost.prototype.getAllStyles = function () { return Array.from(this._stylesSet); };
        SharedStylesHost.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        SharedStylesHost.ctorParameters = function () { return []; };
        return SharedStylesHost;
    }());
    var DomSharedStylesHost = /** @class */ (function (_super) {
        __extends(DomSharedStylesHost, _super);
        function DomSharedStylesHost(_doc) {
            var _this = _super.call(this) || this;
            _this._doc = _doc;
            _this._hostNodes = new Set();
            _this._styleNodes = new Set();
            _this._hostNodes.add(_doc.head);
            return _this;
        }
        DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
            var _this = this;
            styles.forEach(function (style) {
                var styleEl = _this._doc.createElement('style');
                styleEl.textContent = style;
                _this._styleNodes.add(host.appendChild(styleEl));
            });
        };
        DomSharedStylesHost.prototype.addHost = function (hostNode) {
            this._addStylesToHost(this._stylesSet, hostNode);
            this._hostNodes.add(hostNode);
        };
        DomSharedStylesHost.prototype.removeHost = function (hostNode) { this._hostNodes.delete(hostNode); };
        DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
            var _this = this;
            this._hostNodes.forEach(function (hostNode) { return _this._addStylesToHost(additions, hostNode); });
        };
        DomSharedStylesHost.prototype.ngOnDestroy = function () { this._styleNodes.forEach(function (styleNode) { return getDOM().remove(styleNode); }); };
        DomSharedStylesHost.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        DomSharedStylesHost.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        ]; };
        return DomSharedStylesHost;
    }(SharedStylesHost));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var NAMESPACE_URIS = {
        'svg': 'http://www.w3.org/2000/svg',
        'xhtml': 'http://www.w3.org/1999/xhtml',
        'xlink': 'http://www.w3.org/1999/xlink',
        'xml': 'http://www.w3.org/XML/1998/namespace',
        'xmlns': 'http://www.w3.org/2000/xmlns/',
    };
    var COMPONENT_REGEX = /%COMP%/g;
    var COMPONENT_VARIABLE = '%COMP%';
    var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
    var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
    function shimContentAttribute(componentShortId) {
        return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
    }
    function shimHostAttribute(componentShortId) {
        return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
    }
    function flattenStyles(compId, styles, target) {
        for (var i = 0; i < styles.length; i++) {
            var style = styles[i];
            if (Array.isArray(style)) {
                flattenStyles(compId, style, target);
            }
            else {
                style = style.replace(COMPONENT_REGEX, compId);
                target.push(style);
            }
        }
        return target;
    }
    function decoratePreventDefault(eventHandler) {
        return function (event) {
            var allowDefaultBehavior = eventHandler(event);
            if (allowDefaultBehavior === false) {
                // TODO(tbosch): move preventDefault into event plugins...
                event.preventDefault();
                event.returnValue = false;
            }
        };
    }
    var DomRendererFactory2 = /** @class */ (function () {
        function DomRendererFactory2(eventManager, sharedStylesHost) {
            this.eventManager = eventManager;
            this.sharedStylesHost = sharedStylesHost;
            this.rendererByCompId = new Map();
            this.defaultRenderer = new DefaultDomRenderer2(eventManager);
        }
        DomRendererFactory2.prototype.createRenderer = function (element, type) {
            if (!element || !type) {
                return this.defaultRenderer;
            }
            switch (type.encapsulation) {
                case core.ViewEncapsulation.Emulated: {
                    var renderer = this.rendererByCompId.get(type.id);
                    if (!renderer) {
                        renderer =
                            new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type);
                        this.rendererByCompId.set(type.id, renderer);
                    }
                    renderer.applyToHost(element);
                    return renderer;
                }
                case core.ViewEncapsulation.Native:
                    return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
                default: {
                    if (!this.rendererByCompId.has(type.id)) {
                        var styles = flattenStyles(type.id, type.styles, []);
                        this.sharedStylesHost.addStyles(styles);
                        this.rendererByCompId.set(type.id, this.defaultRenderer);
                    }
                    return this.defaultRenderer;
                }
            }
        };
        DomRendererFactory2.prototype.begin = function () { };
        DomRendererFactory2.prototype.end = function () { };
        DomRendererFactory2.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        DomRendererFactory2.ctorParameters = function () { return [
            { type: EventManager, },
            { type: DomSharedStylesHost, },
        ]; };
        return DomRendererFactory2;
    }());
    var DefaultDomRenderer2 = /** @class */ (function () {
        function DefaultDomRenderer2(eventManager) {
            this.eventManager = eventManager;
            this.data = Object.create(null);
        }
        DefaultDomRenderer2.prototype.destroy = function () { };
        DefaultDomRenderer2.prototype.createElement = function (name, namespace) {
            if (namespace) {
                return document.createElementNS(NAMESPACE_URIS[namespace], name);
            }
            return document.createElement(name);
        };
        DefaultDomRenderer2.prototype.createComment = function (value) { return document.createComment(value); };
        DefaultDomRenderer2.prototype.createText = function (value) { return document.createTextNode(value); };
        DefaultDomRenderer2.prototype.appendChild = function (parent, newChild) { parent.appendChild(newChild); };
        DefaultDomRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
            if (parent) {
                parent.insertBefore(newChild, refChild);
            }
        };
        DefaultDomRenderer2.prototype.removeChild = function (parent, oldChild) {
            if (parent) {
                parent.removeChild(oldChild);
            }
        };
        DefaultDomRenderer2.prototype.selectRootElement = function (selectorOrNode) {
            var el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
                selectorOrNode;
            if (!el) {
                throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
            }
            el.textContent = '';
            return el;
        };
        DefaultDomRenderer2.prototype.parentNode = function (node) { return node.parentNode; };
        DefaultDomRenderer2.prototype.nextSibling = function (node) { return node.nextSibling; };
        DefaultDomRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
            if (namespace) {
                name = namespace + ":" + name;
                var namespaceUri = NAMESPACE_URIS[namespace];
                if (namespaceUri) {
                    el.setAttributeNS(namespaceUri, name, value);
                }
                else {
                    el.setAttribute(name, value);
                }
            }
            else {
                el.setAttribute(name, value);
            }
        };
        DefaultDomRenderer2.prototype.removeAttribute = function (el, name, namespace) {
            if (namespace) {
                var namespaceUri = NAMESPACE_URIS[namespace];
                if (namespaceUri) {
                    el.removeAttributeNS(namespaceUri, name);
                }
                else {
                    el.removeAttribute(namespace + ":" + name);
                }
            }
            else {
                el.removeAttribute(name);
            }
        };
        DefaultDomRenderer2.prototype.addClass = function (el, name) { el.classList.add(name); };
        DefaultDomRenderer2.prototype.removeClass = function (el, name) { el.classList.remove(name); };
        DefaultDomRenderer2.prototype.setStyle = function (el, style, value, flags) {
            if (flags & core.RendererStyleFlags2.DashCase) {
                el.style.setProperty(style, value, !!(flags & core.RendererStyleFlags2.Important) ? 'important' : '');
            }
            else {
                el.style[style] = value;
            }
        };
        DefaultDomRenderer2.prototype.removeStyle = function (el, style, flags) {
            if (flags & core.RendererStyleFlags2.DashCase) {
                el.style.removeProperty(style);
            }
            else {
                // IE requires '' instead of null
                // see https://github.com/angular/angular/issues/7916
                el.style[style] = '';
            }
        };
        DefaultDomRenderer2.prototype.setProperty = function (el, name, value) {
            checkNoSyntheticProp(name, 'property');
            el[name] = value;
        };
        DefaultDomRenderer2.prototype.setValue = function (node, value) { node.nodeValue = value; };
        DefaultDomRenderer2.prototype.listen = function (target, event, callback) {
            checkNoSyntheticProp(event, 'listener');
            if (typeof target === 'string') {
                return this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback));
            }
            return this.eventManager.addEventListener(target, event, decoratePreventDefault(callback));
        };
        return DefaultDomRenderer2;
    }());
    var AT_CHARCODE = '@'.charCodeAt(0);
    function checkNoSyntheticProp(name, nameKind) {
        if (name.charCodeAt(0) === AT_CHARCODE) {
            throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
        }
    }
    var EmulatedEncapsulationDomRenderer2 = /** @class */ (function (_super) {
        __extends(EmulatedEncapsulationDomRenderer2, _super);
        function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component) {
            var _this = _super.call(this, eventManager) || this;
            _this.component = component;
            var styles = flattenStyles(component.id, component.styles, []);
            sharedStylesHost.addStyles(styles);
            _this.contentAttr = shimContentAttribute(component.id);
            _this.hostAttr = shimHostAttribute(component.id);
            return _this;
        }
        EmulatedEncapsulationDomRenderer2.prototype.applyToHost = function (element) { _super.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
        EmulatedEncapsulationDomRenderer2.prototype.createElement = function (parent, name) {
            var el = _super.prototype.createElement.call(this, parent, name);
            _super.prototype.setAttribute.call(this, el, this.contentAttr, '');
            return el;
        };
        return EmulatedEncapsulationDomRenderer2;
    }(DefaultDomRenderer2));
    var ShadowDomRenderer = /** @class */ (function (_super) {
        __extends(ShadowDomRenderer, _super);
        function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
            var _this = _super.call(this, eventManager) || this;
            _this.sharedStylesHost = sharedStylesHost;
            _this.hostEl = hostEl;
            _this.component = component;
            _this.shadowRoot = hostEl.createShadowRoot();
            _this.sharedStylesHost.addHost(_this.shadowRoot);
            var styles = flattenStyles(component.id, component.styles, []);
            for (var i = 0; i < styles.length; i++) {
                var styleEl = document.createElement('style');
                styleEl.textContent = styles[i];
                _this.shadowRoot.appendChild(styleEl);
            }
            return _this;
        }
        ShadowDomRenderer.prototype.nodeOrShadowRoot = function (node) { return node === this.hostEl ? this.shadowRoot : node; };
        ShadowDomRenderer.prototype.destroy = function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
        ShadowDomRenderer.prototype.appendChild = function (parent, newChild) {
            return _super.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
        };
        ShadowDomRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
            return _super.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
        };
        ShadowDomRenderer.prototype.removeChild = function (parent, oldChild) {
            return _super.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
        };
        ShadowDomRenderer.prototype.parentNode = function (node) {
            return this.nodeOrShadowRoot(_super.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
        };
        return ShadowDomRenderer;
    }(DefaultDomRenderer2));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var ɵ0 = function (v) {
        return '__zone_symbol__' + v;
    };
    /**
     * Detect if Zone is present. If it is then use simple zone aware 'addEventListener'
     * since Angular can do much more
     * efficient bookkeeping than Zone can, because we have additional information. This speeds up
     * addEventListener by 3x.
     */
    var __symbol__ = (typeof Zone !== 'undefined') && Zone['__symbol__'] || ɵ0;
    var ADD_EVENT_LISTENER = __symbol__('addEventListener');
    var REMOVE_EVENT_LISTENER = __symbol__('removeEventListener');
    var symbolNames = {};
    var FALSE = 'FALSE';
    var ANGULAR = 'ANGULAR';
    var NATIVE_ADD_LISTENER = 'addEventListener';
    var NATIVE_REMOVE_LISTENER = 'removeEventListener';
    // use the same symbol string which is used in zone.js
    var stopSymbol = '__zone_symbol__propagationStopped';
    var stopMethodSymbol = '__zone_symbol__stopImmediatePropagation';
    var blackListedEvents = (typeof Zone !== 'undefined') && Zone[__symbol__('BLACK_LISTED_EVENTS')];
    var blackListedMap;
    if (blackListedEvents) {
        blackListedMap = {};
        blackListedEvents.forEach(function (eventName) { blackListedMap[eventName] = eventName; });
    }
    var isBlackListedEvent = function (eventName) {
        if (!blackListedMap) {
            return false;
        }
        return blackListedMap.hasOwnProperty(eventName);
    };
    // a global listener to handle all dom event,
    // so we do not need to create a closure every time
    var globalListener = function (event) {
        var symbolName = symbolNames[event.type];
        if (!symbolName) {
            return;
        }
        var taskDatas = this[symbolName];
        if (!taskDatas) {
            return;
        }
        var args = [event];
        if (taskDatas.length === 1) {
            // if taskDatas only have one element, just invoke it
            var taskData = taskDatas[0];
            if (taskData.zone !== Zone.current) {
                // only use Zone.run when Zone.current not equals to stored zone
                return taskData.zone.run(taskData.handler, this, args);
            }
            else {
                return taskData.handler.apply(this, args);
            }
        }
        else {
            // copy tasks as a snapshot to avoid event handlers remove
            // itself or others
            var copiedTasks = taskDatas.slice();
            for (var i = 0; i < copiedTasks.length; i++) {
                // if other listener call event.stopImmediatePropagation
                // just break
                if (event[stopSymbol] === true) {
                    break;
                }
                var taskData = copiedTasks[i];
                if (taskData.zone !== Zone.current) {
                    // only use Zone.run when Zone.current not equals to stored zone
                    taskData.zone.run(taskData.handler, this, args);
                }
                else {
                    taskData.handler.apply(this, args);
                }
            }
        }
    };
    var DomEventsPlugin = /** @class */ (function (_super) {
        __extends(DomEventsPlugin, _super);
        function DomEventsPlugin(doc, ngZone) {
            var _this = _super.call(this, doc) || this;
            _this.ngZone = ngZone;
            _this.patchEvent();
            return _this;
        }
        DomEventsPlugin.prototype.patchEvent = function () {
            if (!Event || !Event.prototype) {
                return;
            }
            if (Event.prototype[stopMethodSymbol]) {
                // already patched by zone.js
                return;
            }
            var delegate = Event.prototype[stopMethodSymbol] =
                Event.prototype.stopImmediatePropagation;
            Event.prototype.stopImmediatePropagation = function () {
                if (this) {
                    this[stopSymbol] = true;
                }
                // should call native delegate in case
                // in some environment part of the application
                // will not use the patched Event
                delegate && delegate.apply(this, arguments);
            };
        };
        // This plugin should come last in the list of plugins, because it accepts all
        // events.
        // This plugin should come last in the list of plugins, because it accepts all
        // events.
        DomEventsPlugin.prototype.supports = 
        // This plugin should come last in the list of plugins, because it accepts all
        // events.
        function (eventName) { return true; };
        DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var _this = this;
            /**
                 * This code is about to add a listener to the DOM. If Zone.js is present, than
                 * `addEventListener` has been patched. The patched code adds overhead in both
                 * memory and speed (3x slower) than native. For this reason if we detect that
                 * Zone.js is present we use a simple version of zone aware addEventListener instead.
                 * The result is faster registration and the zone will be restored.
                 * But ZoneSpec.onScheduleTask, ZoneSpec.onInvokeTask, ZoneSpec.onCancelTask
                 * will not be invoked
                 * We also do manual zone restoration in element.ts renderEventHandlerClosure method.
                 *
                 * NOTE: it is possible that the element is from different iframe, and so we
                 * have to check before we execute the method.
                 */
            var zoneJsLoaded = element[ADD_EVENT_LISTENER];
            var callback = handler;
            // if zonejs is loaded and current zone is not ngZone
            // we keep Zone.current on target for later restoration.
            if (zoneJsLoaded && (!core.NgZone.isInAngularZone() || isBlackListedEvent(eventName))) {
                var symbolName = symbolNames[eventName];
                if (!symbolName) {
                    symbolName = symbolNames[eventName] = __symbol__(ANGULAR + eventName + FALSE);
                }
                var taskDatas = element[symbolName];
                var globalListenerRegistered = taskDatas && taskDatas.length > 0;
                if (!taskDatas) {
                    taskDatas = element[symbolName] = [];
                }
                var zone = isBlackListedEvent(eventName) ? Zone.root : Zone.current;
                if (taskDatas.length === 0) {
                    taskDatas.push({ zone: zone, handler: callback });
                }
                else {
                    var callbackRegistered = false;
                    for (var i = 0; i < taskDatas.length; i++) {
                        if (taskDatas[i].handler === callback) {
                            callbackRegistered = true;
                            break;
                        }
                    }
                    if (!callbackRegistered) {
                        taskDatas.push({ zone: zone, handler: callback });
                    }
                }
                if (!globalListenerRegistered) {
                    element[ADD_EVENT_LISTENER](eventName, globalListener, false);
                }
            }
            else {
                element[NATIVE_ADD_LISTENER](eventName, callback, false);
            }
            return function () { return _this.removeEventListener(element, eventName, callback); };
        };
        DomEventsPlugin.prototype.removeEventListener = function (target, eventName, callback) {
            var underlyingRemove = target[REMOVE_EVENT_LISTENER];
            // zone.js not loaded, use native removeEventListener
            if (!underlyingRemove) {
                return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
            }
            var symbolName = symbolNames[eventName];
            var taskDatas = symbolName && target[symbolName];
            if (!taskDatas) {
                // addEventListener not using patched version
                // just call native removeEventListener
                return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
            }
            // fix issue 20532, should be able to remove
            // listener which was added inside of ngZone
            var found = false;
            for (var i = 0; i < taskDatas.length; i++) {
                // remove listener from taskDatas if the callback equals
                if (taskDatas[i].handler === callback) {
                    found = true;
                    taskDatas.splice(i, 1);
                    break;
                }
            }
            if (found) {
                if (taskDatas.length === 0) {
                    // all listeners are removed, we can remove the globalListener from target
                    underlyingRemove.apply(target, [eventName, globalListener, false]);
                }
            }
            else {
                // not found in taskDatas, the callback may be added inside of ngZone
                // use native remove listener to remove the callback
                target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
            }
        };
        DomEventsPlugin.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        DomEventsPlugin.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
            { type: core.NgZone, },
        ]; };
        return DomEventsPlugin;
    }(EventManagerPlugin));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var EVENT_NAMES = {
        // pan
        'pan': true,
        'panstart': true,
        'panmove': true,
        'panend': true,
        'pancancel': true,
        'panleft': true,
        'panright': true,
        'panup': true,
        'pandown': true,
        // pinch
        'pinch': true,
        'pinchstart': true,
        'pinchmove': true,
        'pinchend': true,
        'pinchcancel': true,
        'pinchin': true,
        'pinchout': true,
        // press
        'press': true,
        'pressup': true,
        // rotate
        'rotate': true,
        'rotatestart': true,
        'rotatemove': true,
        'rotateend': true,
        'rotatecancel': true,
        // swipe
        'swipe': true,
        'swipeleft': true,
        'swiperight': true,
        'swipeup': true,
        'swipedown': true,
        // tap
        'tap': true,
    };
    /**
     * A DI token that you can use to provide{@link HammerGestureConfig} to Angular. Use it to configure
     * Hammer gestures.
     *
     * @experimental
     */
    var HAMMER_GESTURE_CONFIG = new core.InjectionToken('HammerGestureConfig');
    /**
     * @experimental
     */
    var HammerGestureConfig = /** @class */ (function () {
        function HammerGestureConfig() {
            this.events = [];
            this.overrides = {};
        }
        HammerGestureConfig.prototype.buildHammer = function (element) {
            var mc = new Hammer(element, this.options);
            mc.get('pinch').set({ enable: true });
            mc.get('rotate').set({ enable: true });
            for (var eventName in this.overrides) {
                mc.get(eventName).set(this.overrides[eventName]);
            }
            return mc;
        };
        HammerGestureConfig.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HammerGestureConfig.ctorParameters = function () { return []; };
        return HammerGestureConfig;
    }());
    var HammerGesturesPlugin = /** @class */ (function (_super) {
        __extends(HammerGesturesPlugin, _super);
        function HammerGesturesPlugin(doc, _config, console) {
            var _this = _super.call(this, doc) || this;
            _this._config = _config;
            _this.console = console;
            return _this;
        }
        HammerGesturesPlugin.prototype.supports = function (eventName) {
            if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
                return false;
            }
            if (!window.Hammer) {
                this.console.warn("Hammer.js is not loaded, can not bind '" + eventName + "' event.");
                return false;
            }
            return true;
        };
        HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var _this = this;
            var zone = this.manager.getZone();
            eventName = eventName.toLowerCase();
            return zone.runOutsideAngular(function () {
                // Creating the manager bind events, must be done outside of angular
                var mc = _this._config.buildHammer(element);
                var callback = function (eventObj) {
                    zone.runGuarded(function () { handler(eventObj); });
                };
                mc.on(eventName, callback);
                return function () { return mc.off(eventName, callback); };
            });
        };
        HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) { return this._config.events.indexOf(eventName) > -1; };
        HammerGesturesPlugin.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        HammerGesturesPlugin.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
            { type: HammerGestureConfig, decorators: [{ type: core.Inject, args: [HAMMER_GESTURE_CONFIG,] },] },
            { type: core.ɵConsole, },
        ]; };
        return HammerGesturesPlugin;
    }(EventManagerPlugin));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
    var ɵ0$1 = function (event) { return event.altKey; };
    var ɵ1$1 = function (event) { return event.ctrlKey; };
    var ɵ2$1 = function (event) { return event.metaKey; };
    var ɵ3 = function (event) { return event.shiftKey; };
    var MODIFIER_KEY_GETTERS = {
        'alt': ɵ0$1,
        'control': ɵ1$1,
        'meta': ɵ2$1,
        'shift': ɵ3
    };
    /**
     * @experimental
     */
    var KeyEventsPlugin = /** @class */ (function (_super) {
        __extends(KeyEventsPlugin, _super);
        function KeyEventsPlugin(doc) {
            return _super.call(this, doc) || this;
        }
        KeyEventsPlugin.prototype.supports = function (eventName) { return KeyEventsPlugin.parseEventName(eventName) != null; };
        KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var parsedEvent = (KeyEventsPlugin.parseEventName(eventName));
            var outsideHandler = KeyEventsPlugin.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
            return this.manager.getZone().runOutsideAngular(function () {
                return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
            });
        };
        KeyEventsPlugin.parseEventName = function (eventName) {
            var parts = eventName.toLowerCase().split('.');
            var domEventName = parts.shift();
            if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
                return null;
            }
            var key = KeyEventsPlugin._normalizeKey((parts.pop()));
            var fullKey = '';
            MODIFIER_KEYS.forEach(function (modifierName) {
                var index = parts.indexOf(modifierName);
                if (index > -1) {
                    parts.splice(index, 1);
                    fullKey += modifierName + '.';
                }
            });
            fullKey += key;
            if (parts.length != 0 || key.length === 0) {
                // returning null instead of throwing to let another plugin process the event
                return null;
            }
            var result = {};
            result['domEventName'] = domEventName;
            result['fullKey'] = fullKey;
            return result;
        };
        KeyEventsPlugin.getEventFullKey = function (event) {
            var fullKey = '';
            var key = getDOM().getEventKey(event);
            key = key.toLowerCase();
            if (key === ' ') {
                key = 'space'; // for readability
            }
            else if (key === '.') {
                key = 'dot'; // because '.' is used as a separator in event names
            }
            MODIFIER_KEYS.forEach(function (modifierName) {
                if (modifierName != key) {
                    var modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
                    if (modifierGetter(event)) {
                        fullKey += modifierName + '.';
                    }
                }
            });
            fullKey += key;
            return fullKey;
        };
        KeyEventsPlugin.eventCallback = function (fullKey, handler, zone) {
            return function (event /** TODO #9100 */) {
                if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
                    zone.runGuarded(function () { return handler(event); });
                }
            };
        };
        /** @internal */
        /** @internal */
        KeyEventsPlugin._normalizeKey = /** @internal */
        function (keyName) {
            // TODO: switch to a Map if the mapping grows too much
            switch (keyName) {
                case 'esc':
                    return 'escape';
                default:
                    return keyName;
            }
        };
        KeyEventsPlugin.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        KeyEventsPlugin.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        ]; };
        return KeyEventsPlugin;
    }(EventManagerPlugin));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
     * values to be safe to use in the different DOM contexts.
     *
     * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
     * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
     * the website.
     *
     * In specific situations, it might be necessary to disable sanitization, for example if the
     * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
     * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
     * methods, and then binding to that value from the template.
     *
     * These situations should be very rare, and extraordinary care must be taken to avoid creating a
     * Cross Site Scripting (XSS) security bug!
     *
     * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
     * close as possible to the source of the value, to make it easy to verify no security bug is
     * created by its use.
     *
     * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
     * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
     * code. The sanitizer leaves safe values intact.
     *
     * @security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
     * sanitization for the value passed in. Carefully check and audit all values and code paths going
     * into this call. Make sure any user data is appropriately escaped for this security context.
     * For more detail, see the [Security Guide](http://g.co/ng/security).
     *
     *
     */
    var DomSanitizer = /** @class */ (function () {
        function DomSanitizer() {
        }
        return DomSanitizer;
    }());
    var DomSanitizerImpl = /** @class */ (function (_super) {
        __extends(DomSanitizerImpl, _super);
        function DomSanitizerImpl(_doc) {
            var _this = _super.call(this) || this;
            _this._doc = _doc;
            return _this;
        }
        DomSanitizerImpl.prototype.sanitize = function (ctx, value) {
            if (value == null)
                return null;
            switch (ctx) {
                case core.SecurityContext.NONE:
                    return value;
                case core.SecurityContext.HTML:
                    if (value instanceof SafeHtmlImpl)
                        return value.changingThisBreaksApplicationSecurity;
                    this.checkNotSafeValue(value, 'HTML');
                    return core.ɵ_sanitizeHtml(this._doc, String(value));
                case core.SecurityContext.STYLE:
                    if (value instanceof SafeStyleImpl)
                        return value.changingThisBreaksApplicationSecurity;
                    this.checkNotSafeValue(value, 'Style');
                    return core.ɵ_sanitizeStyle(value);
                case core.SecurityContext.SCRIPT:
                    if (value instanceof SafeScriptImpl)
                        return value.changingThisBreaksApplicationSecurity;
                    this.checkNotSafeValue(value, 'Script');
                    throw new Error('unsafe value used in a script context');
                case core.SecurityContext.URL:
                    if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                        // Allow resource URLs in URL contexts, they are strictly more trusted.
                        return value.changingThisBreaksApplicationSecurity;
                    }
                    this.checkNotSafeValue(value, 'URL');
                    return core.ɵ_sanitizeUrl(String(value));
                case core.SecurityContext.RESOURCE_URL:
                    if (value instanceof SafeResourceUrlImpl) {
                        return value.changingThisBreaksApplicationSecurity;
                    }
                    this.checkNotSafeValue(value, 'ResourceURL');
                    throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
                default:
                    throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
            }
        };
        DomSanitizerImpl.prototype.checkNotSafeValue = function (value, expectedType) {
            if (value instanceof SafeValueImpl) {
                throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
                    "(see http://g.co/ng/security#xss)");
            }
        };
        DomSanitizerImpl.prototype.bypassSecurityTrustHtml = function (value) { return new SafeHtmlImpl(value); };
        DomSanitizerImpl.prototype.bypassSecurityTrustStyle = function (value) { return new SafeStyleImpl(value); };
        DomSanitizerImpl.prototype.bypassSecurityTrustScript = function (value) { return new SafeScriptImpl(value); };
        DomSanitizerImpl.prototype.bypassSecurityTrustUrl = function (value) { return new SafeUrlImpl(value); };
        DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = function (value) {
            return new SafeResourceUrlImpl(value);
        };
        DomSanitizerImpl.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        DomSanitizerImpl.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        ]; };
        return DomSanitizerImpl;
    }(DomSanitizer));
    var SafeValueImpl = /** @class */ (function () {
        function SafeValueImpl(changingThisBreaksApplicationSecurity) {
            // empty
            this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
        }
        SafeValueImpl.prototype.toString = function () {
            return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
                " (see http://g.co/ng/security#xss)";
        };
        return SafeValueImpl;
    }());
    var SafeHtmlImpl = /** @class */ (function (_super) {
        __extends(SafeHtmlImpl, _super);
        function SafeHtmlImpl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SafeHtmlImpl.prototype.getTypeName = function () { return 'HTML'; };
        return SafeHtmlImpl;
    }(SafeValueImpl));
    var SafeStyleImpl = /** @class */ (function (_super) {
        __extends(SafeStyleImpl, _super);
        function SafeStyleImpl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SafeStyleImpl.prototype.getTypeName = function () { return 'Style'; };
        return SafeStyleImpl;
    }(SafeValueImpl));
    var SafeScriptImpl = /** @class */ (function (_super) {
        __extends(SafeScriptImpl, _super);
        function SafeScriptImpl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SafeScriptImpl.prototype.getTypeName = function () { return 'Script'; };
        return SafeScriptImpl;
    }(SafeValueImpl));
    var SafeUrlImpl = /** @class */ (function (_super) {
        __extends(SafeUrlImpl, _super);
        function SafeUrlImpl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SafeUrlImpl.prototype.getTypeName = function () { return 'URL'; };
        return SafeUrlImpl;
    }(SafeValueImpl));
    var SafeResourceUrlImpl = /** @class */ (function (_super) {
        __extends(SafeResourceUrlImpl, _super);
        function SafeResourceUrlImpl() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SafeResourceUrlImpl.prototype.getTypeName = function () { return 'ResourceURL'; };
        return SafeResourceUrlImpl;
    }(SafeValueImpl));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
        { provide: core.PLATFORM_ID, useValue: common.ɵPLATFORM_BROWSER_ID },
        { provide: core.PLATFORM_INITIALIZER, useValue: initDomAdapter, multi: true },
        { provide: common.PlatformLocation, useClass: BrowserPlatformLocation, deps: [DOCUMENT$1] },
        { provide: DOCUMENT$1, useFactory: _document, deps: [] },
    ];
    /**
     *
     */
    var platformBrowser = core.createPlatformFactory(core.platformCore, 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
    function initDomAdapter() {
        BrowserDomAdapter.makeCurrent();
        BrowserGetTestability.init();
    }
    function _document() {
        return document;
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     *
     */
    var VERSION = new core.Version('6.0.0');

    /**
     * @license Angular v6.0.0
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    /**
     * AnimationBuilder is an injectable service that is available when the {@link
     * BrowserAnimationsModule BrowserAnimationsModule} or {@link NoopAnimationsModule
     * NoopAnimationsModule} modules are used within an application.
     *
     * The purpose if this service is to produce an animation sequence programmatically within an
     * angular component or directive.
     *
     * Programmatic animations are first built and then a player is created when the build animation is
     * attached to an element.
     *
     * ```ts
     * // remember to include the BrowserAnimationsModule module for this to work...
     * import {AnimationBuilder} from '@angular/animations';
     *
     * class MyCmp {
     *   constructor(private _builder: AnimationBuilder) {}
     *
     *   makeAnimation(element: any) {
     *     // first build the animation
     *     const myAnimation = this._builder.build([
     *       style({ width: 0 }),
     *       animate(1000, style({ width: '100px' }))
     *     ]);
     *
     *     // then create a player from it
     *     const player = myAnimation.create(element);
     *
     *     player.play();
     *   }
     * }
     * ```
     *
     * When an animation is built an instance of {@link AnimationFactory AnimationFactory} will be
     * returned. Using that an {@link AnimationPlayer AnimationPlayer} can be created which can then be
     * used to start the animation.
     *
     * @experimental Animation support is experimental.
     */
    var AnimationBuilder = /** @class */ (function () {
        function AnimationBuilder() {
        }
        return AnimationBuilder;
    }());
    /**
     * An instance of `AnimationFactory` is returned from {@link AnimationBuilder#build
     * AnimationBuilder.build}.
     *
     * @experimental Animation support is experimental.
     */
    var AnimationFactory = /** @class */ (function () {
        function AnimationFactory() {
        }
        return AnimationFactory;
    }());

    /**
     * @experimental Animation support is experimental.
     */
    var AUTO_STYLE = '*';
    /**
     * `trigger` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the
     * {@link Component#animations component animations metadata page} to gain a better
     * understanding of how animations in Angular are used.
     *
     * `trigger` Creates an animation trigger which will a list of {@link state state} and
     * {@link transition transition} entries that will be evaluated when the expression
     * bound to the trigger changes.
     *
     * Triggers are registered within the component annotation data under the
     * {@link Component#animations animations section}. An animation trigger can be placed on an element
     * within a template by referencing the name of the trigger followed by the expression value that
     the
     * trigger is bound to (in the form of `[@triggerName]="expression"`.
     *
     * Animation trigger bindings strigify values and then match the previous and current values against
     * any linked transitions. If a boolean value is provided into the trigger binding then it will both
     * be represented as `1` or `true` and `0` or `false` for a true and false boolean values
     * respectively.
     *
     * ### Usage
     *
     * `trigger` will create an animation trigger reference based on the provided `name` value. The
     * provided `animation` value is expected to be an array consisting of {@link state state} and
     * {@link transition transition} declarations.
     *
     * ```typescript
     * @Component({
     *   selector: 'my-component',
     *   templateUrl: 'my-component-tpl.html',
     *   animations: [
     *     trigger("myAnimationTrigger", [
     *       state(...),
     *       state(...),
     *       transition(...),
     *       transition(...)
     *     ])
     *   ]
     * })
     * class MyComponent {
     *   myStatusExp = "something";
     * }
     * ```
     *
     * The template associated with this component will make use of the `myAnimationTrigger` animation
     trigger by binding to an element within its template code.
     *
     * ```html
     * <!-- somewhere inside of my-component-tpl.html -->
     * <div [@myAnimationTrigger]="myStatusExp">...</div>
     * ```
     *
     * ### Using an inline function
     * The `transition` animation method also supports reading an inline function which can decide
     * if its associated animation should be run.
     *
     * ```
     * // this method will be run each time the `myAnimationTrigger`
     * // trigger value changes...
     * function myInlineMatcherFn(fromState: string, toState: string, element: any, params: {[key:
     string]: any}): boolean {
     *   // notice that `element` and `params` are also available here
     *   return toState == 'yes-please-animate';
     * }
     *
     * @Component({
     *   selector: 'my-component',
     *   templateUrl: 'my-component-tpl.html',
     *   animations: [
     *     trigger('myAnimationTrigger', [
     *       transition(myInlineMatcherFn, [
     *         // the animation sequence code
     *       ]),
     *     ])
     *   ]
     * })
     * class MyComponent {
     *   myStatusExp = "yes-please-animate";
     * }
     * ```
     *
     * The inline method will be run each time the trigger
     * value changes
     *
     * ## Disable Animations
     * A special animation control binding called `@.disabled` can be placed on an element which will
     then disable animations for any inner animation triggers situated within the element as well as
     any animations on the element itself.
     *
     * When true, the `@.disabled` binding will prevent all animations from rendering. The example
     below shows how to use this feature:
     *
     * ```ts
     * @Component({
     *   selector: 'my-component',
     *   template: `
     *     <div [@.disabled]="isDisabled">
     *       <div [@childAnimation]="exp"></div>
     *     </div>
     *   `,
     *   animations: [
     *     trigger("childAnimation", [
     *       // ...
     *     ])
     *   ]
     * })
     * class MyComponent {
     *   isDisabled = true;
     *   exp = '...';
     * }
     * ```
     *
     * The `@childAnimation` trigger will not animate because `@.disabled` prevents it from happening
     (when true).
     *
     * Note that `@.disabled` will only disable all animations (this means any animations running on
     * the same element will also be disabled).
     *
     * ### Disabling Animations Application-wide
     * When an area of the template is set to have animations disabled, **all** inner components will
     also have their animations disabled as well. This means that all animations for an angular
     application can be disabled by placing a host binding set on `@.disabled` on the topmost Angular
     component.
     *
     * ```ts
     * import {Component, HostBinding} from '@angular/core';
     *
     * @Component({
     *   selector: 'app-component',
     *   templateUrl: 'app.component.html',
     * })
     * class AppComponent {
     *   @HostBinding('@.disabled')
     *   public animationsDisabled = true;
     * }
     * ```
     *
     * ### What about animations that us `query()` and `animateChild()`?
     * Despite inner animations being disabled, a parent animation can {@link query query} for inner
     elements located in disabled areas of the template and still animate them as it sees fit. This is
     also the case for when a sub animation is queried by a parent and then later animated using {@link
     animateChild animateChild}.

     * ### Detecting when an animation is disabled
     * If a region of the DOM (or the entire application) has its animations disabled, then animation
     * trigger callbacks will still fire just as normal (only for zero seconds).
     *
     * When a trigger callback fires it will provide an instance of an {@link AnimationEvent}. If
     animations
     * are disabled then the `.disabled` flag on the event will be true.
     *
     * @experimental Animation support is experimental.
     */
    function trigger(name, definitions) {
        return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
    }
    /**
     * `animate` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `animate` specifies an animation step that will apply the provided `styles` data for a given
     * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
     * to be used within {@link sequence an animation sequence}, {@link group group}, or {@link
     * transition transition}.
     *
     * ### Usage
     *
     * The `animate` function accepts two input parameters: `timing` and `styles`:
     *
     * - `timing` is a string based value that can be a combination of a duration with optional delay
     * and easing values. The format for the expression breaks down to `duration delay easing`
     * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
     * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
     * `duration` value in millisecond form.
     * - `styles` is the style input data which can either be a call to {@link style style} or {@link
     * keyframes keyframes}. If left empty then the styles from the destination state will be collected
     * and used (this is useful when describing an animation step that will complete an animation by
     * {@link transition#the-final-animate-call animating to the final state}).
     *
     * ```typescript
     * // various functions for specifying timing data
     * animate(500, style(...))
     * animate("1s", style(...))
     * animate("100ms 0.5s", style(...))
     * animate("5s ease", style(...))
     * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
     *
     * // either style() of keyframes() can be used
     * animate(500, style({ background: "red" }))
     * animate(500, keyframes([
     *   style({ background: "blue" })),
     *   style({ background: "red" }))
     * ])
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function animate(timings, styles) {
        if (styles === void 0) { styles = null; }
        return { type: 4 /* Animate */, styles: styles, timings: timings };
    }
    /**
     * `group` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
     * useful when a series of styles must be animated/closed off at different starting/ending times.
     *
     * The `group` function can either be used within a {@link sequence sequence} or a {@link transition
     * transition} and it will only continue to the next instruction once all of the inner animation
     * steps have completed.
     *
     * ### Usage
     *
     * The `steps` data that is passed into the `group` animation function can either consist of {@link
     * style style} or {@link animate animate} function calls. Each call to `style()` or `animate()`
     * within a group will be executed instantly (use {@link keyframes keyframes} or a {@link
     * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
     *
     * ```typescript
     * group([
     *   animate("1s", { background: "black" }))
     *   animate("2s", { color: "white" }))
     * ])
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function group(steps, options) {
        if (options === void 0) { options = null; }
        return { type: 3 /* Group */, steps: steps, options: options };
    }
    /**
     * `sequence` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
     * default when an array is passed as animation data into {@link transition transition}.)
     *
     * The `sequence` function can either be used within a {@link group group} or a {@link transition
     * transition} and it will only continue to the next instruction once each of the inner animation
     * steps have completed.
     *
     * To perform animation styling in parallel with other animation steps then have a look at the
     * {@link group group} animation function.
     *
     * ### Usage
     *
     * The `steps` data that is passed into the `sequence` animation function can either consist of
     * {@link style style} or {@link animate animate} function calls. A call to `style()` will apply the
     * provided styling data immediately while a call to `animate()` will apply its styling data over a
     * given time depending on its timing data.
     *
     * ```typescript
     * sequence([
     *   style({ opacity: 0 })),
     *   animate("1s", { opacity: 1 }))
     * ])
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function sequence(steps, options) {
        if (options === void 0) { options = null; }
        return { type: 2 /* Sequence */, steps: steps, options: options };
    }
    /**
     * `style` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `style` declares a key/value object containing CSS properties/styles that can then be used for
     * {@link state animation states}, within an {@link sequence animation sequence}, or as styling data
     * for both {@link animate animate} and {@link keyframes keyframes}.
     *
     * ### Usage
     *
     * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
     * to be defined.
     *
     * ```typescript
     * // string values are used for css properties
     * style({ background: "red", color: "blue" })
     *
     * // numerical (pixel) values are also supported
     * style({ width: 100, height: 0 })
     * ```
     *
     * #### Auto-styles (using `*`)
     *
     * When an asterix (`*`) character is used as a value then it will be detected from the element
     * being animated and applied as animation data when the animation starts.
     *
     * This feature proves useful for a state depending on layout and/or environment factors; in such
     * cases the styles are calculated just before the animation starts.
     *
     * ```typescript
     * // the steps below will animate from 0 to the
     * // actual height of the element
     * style({ height: 0 }),
     * animate("1s", style({ height: "*" }))
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function style(tokens) {
        return { type: 6 /* Style */, styles: tokens, offset: null };
    }
    /**
     * `state` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `state` declares an animation state within the given trigger. When a state is active within a
     * component then its associated styles will persist on the element that the trigger is attached to
     * (even when the animation ends).
     *
     * To animate between states, have a look at the animation {@link transition transition} DSL
     * function. To register states to an animation trigger please have a look at the {@link trigger
     * trigger} function.
     *
     * #### The `void` state
     *
     * The `void` state value is a reserved word that angular uses to determine when the element is not
     * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
     * associated element is void).
     *
     * #### The `*` (default) state
     *
     * The `*` state (when styled) is a fallback state that will be used if the state that is being
     * animated is not declared within the trigger.
     *
     * ### Usage
     *
     * `state` will declare an animation state with its associated styles
     * within the given trigger.
     *
     * - `stateNameExpr` can be one or more state names separated by commas.
     * - `styles` refers to the {@link style styling data} that will be persisted on the element once
     * the state has been reached.
     *
     * ```typescript
     * // "void" is a reserved name for a state and is used to represent
     * // the state in which an element is detached from from the application.
     * state("void", style({ height: 0 }))
     *
     * // user-defined states
     * state("closed", style({ height: 0 }))
     * state("open, visible", style({ height: "*" }))
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function state(name, styles, options) {
        return { type: 0 /* State */, name: name, styles: styles, options: options };
    }
    /**
     * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `keyframes` specifies a collection of {@link style style} entries each optionally characterized
     * by an `offset` value.
     *
     * ### Usage
     *
     * The `keyframes` animation function is designed to be used alongside the {@link animate animate}
     * animation function. Instead of applying animations from where they are currently to their
     * destination, keyframes can describe how each style entry is applied and at what point within the
     * animation arc (much like CSS Keyframe Animations do).
     *
     * For each `style()` entry an `offset` value can be set. Doing so allows to specify at what
     * percentage of the animate time the styles will be applied.
     *
     * ```typescript
     * // the provided offset values describe when each backgroundColor value is applied.
     * animate("5s", keyframes([
     *   style({ backgroundColor: "red", offset: 0 }),
     *   style({ backgroundColor: "blue", offset: 0.2 }),
     *   style({ backgroundColor: "orange", offset: 0.3 }),
     *   style({ backgroundColor: "black", offset: 1 })
     * ]))
     * ```
     *
     * Alternatively, if there are no `offset` values used within the style entries then the offsets
     * will be calculated automatically.
     *
     * ```typescript
     * animate("5s", keyframes([
     *   style({ backgroundColor: "red" }) // offset = 0
     *   style({ backgroundColor: "blue" }) // offset = 0.33
     *   style({ backgroundColor: "orange" }) // offset = 0.66
     *   style({ backgroundColor: "black" }) // offset = 1
     * ]))
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function keyframes(steps) {
        return { type: 5 /* Keyframes */, steps: steps };
    }
    /**
     * `transition` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. If this information is new, please navigate to the {@link
     * Component#animations component animations metadata page} to gain a better understanding of
     * how animations in Angular are used.
     *
     * `transition` declares the {@link sequence sequence of animation steps} that will be run when the
     * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
     * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
     * and/or ending state).
     *
     * A function can also be provided as the `stateChangeExpr` argument for a transition and this
     * function will be executed each time a state change occurs. If the value returned within the
     * function is true then the associated animation will be run.
     *
     * Animation transitions are placed within an {@link trigger animation trigger}. For an transition
     * to animate to a state value and persist its styles then one or more {@link state animation
     * states} is expected to be defined.
     *
     * ### Usage
     *
     * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
     * what the previous state is and what the current state has become. In other words, if a transition
     * is defined that matches the old/current state criteria then the associated animation will be
     * triggered.
     *
     * ```typescript
     * // all transition/state changes are defined within an animation trigger
     * trigger("myAnimationTrigger", [
     *   // if a state is defined then its styles will be persisted when the
     *   // animation has fully completed itself
     *   state("on", style({ background: "green" })),
     *   state("off", style({ background: "grey" })),
     *
     *   // a transition animation that will be kicked off when the state value
     *   // bound to "myAnimationTrigger" changes from "on" to "off"
     *   transition("on => off", animate(500)),
     *
     *   // it is also possible to do run the same animation for both directions
     *   transition("on <=> off", animate(500)),
     *
     *   // or to define multiple states pairs separated by commas
     *   transition("on => off, off => void", animate(500)),
     *
     *   // this is a catch-all state change for when an element is inserted into
     *   // the page and the destination state is unknown
     *   transition("void => *", [
     *     style({ opacity: 0 }),
     *     animate(500)
     *   ]),
     *
     *   // this will capture a state change between any states
     *   transition("* => *", animate("1s 0s")),
     *
     *   // you can also go full out and include a function
     *   transition((fromState, toState) => {
     *     // when `true` then it will allow the animation below to be invoked
     *     return fromState == "off" && toState == "on";
     *   }, animate("1s 0s"))
     * ])
     * ```
     *
     * The template associated with this component will make use of the `myAnimationTrigger` animation
     * trigger by binding to an element within its template code.
     *
     * ```html
     * <!-- somewhere inside of my-component-tpl.html -->
     * <div [@myAnimationTrigger]="myStatusExp">...</div>
     * ```
     *
     * #### The final `animate` call
     *
     * If the final step within the transition steps is a call to `animate()` that **only** uses a
     * timing value with **no style data** then it will be automatically used as the final animation arc
     * for the element to animate itself to the final state. This involves an automatic mix of
     * adding/removing CSS styles so that the element will be in the exact state it should be for the
     * applied state to be presented correctly.
     *
     * ```
     * // start off by hiding the element, but make sure that it animates properly to whatever state
     * // is currently active for "myAnimationTrigger"
     * transition("void => *", [
     *   style({ opacity: 0 }),
     *   animate(500)
     * ])
     * ```
     *
     * ### Using :enter and :leave
     *
     * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
     * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
     * => void` state changes.
     *
     * ```
     * transition(":enter", [
     *   style({ opacity: 0 }),
     *   animate(500, style({ opacity: 1 }))
     * ]),
     * transition(":leave", [
     *   animate(500, style({ opacity: 0 }))
     * ])
     * ```
     *
     * ### Boolean values
     * if a trigger binding value is a boolean value then it can be matched using a transition
     * expression that compares `true` and `false` or `1` and `0`.
     *
     * ```
     * // in the template
     * <div [@openClose]="open ? true : false">...</div>
     *
     * // in the component metadata
     * trigger('openClose', [
     *   state('true', style({ height: '*' })),
     *   state('false', style({ height: '0px' })),
     *   transition('false <=> true', animate(500))
     * ])
     * ```
     *
     * ### Using :increment and :decrement
     * In addition to the :enter and :leave transition aliases, the :increment and :decrement aliases
     * can be used to kick off a transition when a numeric value has increased or decreased in value.
     *
     * ```
     * import {group, animate, query, transition, style, trigger} from '@angular/animations';
     * import {Component} from '@angular/core';
     *
     * @Component({
     *   selector: 'banner-carousel-component',
     *   styles: [`
     *     .banner-container {
     *        position:relative;
     *        height:500px;
     *        overflow:hidden;
     *      }
     *     .banner-container > .banner {
     *        position:absolute;
     *        left:0;
     *        top:0;
     *        font-size:200px;
     *        line-height:500px;
     *        font-weight:bold;
     *        text-align:center;
     *        width:100%;
     *      }
     *   `],
     *   template: `
     *     <button (click)="previous()">Previous</button>
     *     <button (click)="next()">Next</button>
     *     <hr>
     *     <div [@bannerAnimation]="selectedIndex" class="banner-container">
     *       <div class="banner" *ngFor="let banner of banners"> {{ banner }} </div>
     *     </div>
     *   `,
     *   animations: [
     *     trigger('bannerAnimation', [
     *       transition(":increment", group([
     *         query(':enter', [
     *           style({ left: '100%' }),
     *           animate('0.5s ease-out', style('*'))
     *         ]),
     *         query(':leave', [
     *           animate('0.5s ease-out', style({ left: '-100%' }))
     *         ])
     *       ])),
     *       transition(":decrement", group([
     *         query(':enter', [
     *           style({ left: '-100%' }),
     *           animate('0.5s ease-out', style('*'))
     *         ]),
     *         query(':leave', [
     *           animate('0.5s ease-out', style({ left: '100%' }))
     *         ])
     *       ]))
     *     ])
     *   ]
     * })
     * class BannerCarouselComponent {
     *   allBanners: string[] = ['1', '2', '3', '4'];
     *   selectedIndex: number = 0;
     *
     *   get banners() {
     *      return [this.allBanners[this.selectedIndex]];
     *   }
     *
     *   previous() {
     *     this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
     *   }
     *
     *   next() {
     *     this.selectedIndex = Math.min(this.selectedIndex + 1, this.allBanners.length - 1);
     *   }
     * }
     * ```
     *
     * {@example core/animation/ts/dsl/animation_example.ts region='Component'}
     *
     * @experimental Animation support is experimental.
     */
    function transition(stateChangeExpr, steps, options) {
        if (options === void 0) { options = null; }
        return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
    }
    /**
     * `animateChild` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language. It works by allowing a queried element to execute its own
     * animation within the animation sequence.
     *
     * Each time an animation is triggered in angular, the parent animation
     * will always get priority and any child animations will be blocked. In order
     * for a child animation to run, the parent animation must query each of the elements
     * containing child animations and then allow the animations to run using `animateChild`.
     *
     * The example HTML code below shows both parent and child elements that have animation
     * triggers that will execute at the same time.
     *
     * ```html
     * <!-- parent-child.component.html -->
     * <button (click)="exp =! exp">Toggle</button>
     * <hr>
     *
     * <div [@parentAnimation]="exp">
     *   <header>Hello</header>
     *   <div [@childAnimation]="exp">
     *       one
     *   </div>
     *   <div [@childAnimation]="exp">
     *       two
     *   </div>
     *   <div [@childAnimation]="exp">
     *       three
     *   </div>
     * </div>
     * ```
     *
     * Now when the `exp` value changes to true, only the `parentAnimation` animation will animate
     * because it has priority. However, using `query` and `animateChild` each of the inner animations
     * can also fire:
     *
     * ```ts
     * // parent-child.component.ts
     * import {trigger, transition, animate, style, query, animateChild} from '@angular/animations';
     * @Component({
     *   selector: 'parent-child-component',
     *   animations: [
     *     trigger('parentAnimation', [
     *       transition('false => true', [
     *         query('header', [
     *           style({ opacity: 0 }),
     *           animate(500, style({ opacity: 1 }))
     *         ]),
     *         query('@childAnimation', [
     *           animateChild()
     *         ])
     *       ])
     *     ]),
     *     trigger('childAnimation', [
     *       transition('false => true', [
     *         style({ opacity: 0 }),
     *         animate(500, style({ opacity: 1 }))
     *       ])
     *     ])
     *   ]
     * })
     * class ParentChildCmp {
     *   exp: boolean = false;
     * }
     * ```
     *
     * In the animation code above, when the `parentAnimation` transition kicks off it first queries to
     * find the header element and fades it in. It then finds each of the sub elements that contain the
     * `@childAnimation` trigger and then allows for their animations to fire.
     *
     * This example can be further extended by using stagger:
     *
     * ```ts
     * query('@childAnimation', stagger(100, [
     *   animateChild()
     * ]))
     * ```
     *
     * Now each of the sub animations start off with respect to the `100ms` staggering step.
     *
     * ## The first frame of child animations
     * When sub animations are executed using `animateChild` the animation engine will always apply the
     * first frame of every sub animation immediately at the start of the animation sequence. This way
     * the parent animation does not need to set any initial styling data on the sub elements before the
     * sub animations kick off.
     *
     * In the example above the first frame of the `childAnimation`'s `false => true` transition
     * consists of a style of `opacity: 0`. This is applied immediately when the `parentAnimation`
     * animation transition sequence starts. Only then when the `@childAnimation` is queried and called
     * with `animateChild` will it then animate to its destination of `opacity: 1`.
     *
     * Note that this feature designed to be used alongside {@link query query()} and it will only work
     * with animations that are assigned using the Angular animation DSL (this means that CSS keyframes
     * and transitions are not handled by this API).
     *
     * @experimental Animation support is experimental.
     */
    function animateChild(options) {
        if (options === void 0) { options = null; }
        return { type: 9 /* AnimateChild */, options: options };
    }
    /**
     * `query` is an animation-specific function that is designed to be used inside of Angular's
     * animation DSL language.
     *
     * query() is used to find one or more inner elements within the current element that is
     * being animated within the sequence. The provided animation steps are applied
     * to the queried element (by default, an array is provided, then this will be
     * treated as an animation sequence).
     *
     * ### Usage
     *
     * query() is designed to collect multiple elements and works internally by using
     * `element.querySelectorAll`. An additional options object can be provided which
     * can be used to limit the total amount of items to be collected.
     *
     * ```js
     * query('div', [
     *   animate(...),
     *   animate(...)
     * ], { limit: 1 })
     * ```
     *
     * query(), by default, will throw an error when zero items are found. If a query
     * has the `optional` flag set to true then this error will be ignored.
     *
     * ```js
     * query('.some-element-that-may-not-be-there', [
     *   animate(...),
     *   animate(...)
     * ], { optional: true })
     * ```
     *
     * ### Special Selector Values
     *
     * The selector value within a query can collect elements that contain angular-specific
     * characteristics
     * using special pseudo-selectors tokens.
     *
     * These include:
     *
     *  - Querying for newly inserted/removed elements using `query(":enter")`/`query(":leave")`
     *  - Querying all currently animating elements using `query(":animating")`
     *  - Querying elements that contain an animation trigger using `query("@triggerName")`
     *  - Querying all elements that contain an animation triggers using `query("@*")`
     *  - Including the current element into the animation sequence using `query(":self")`
     *
     *
     *  Each of these pseudo-selector tokens can be merged together into a combined query selector
     * string:
     *
     *  ```
     *  query(':self, .record:enter, .record:leave, @subTrigger', [...])
     *  ```
     *
     * ### Demo
     *
     * ```
     * @Component({
     *   selector: 'inner',
     *   template: `
     *     <div [@queryAnimation]="exp">
     *       <h1>Title</h1>
     *       <div class="content">
     *         Blah blah blah
     *       </div>
     *     </div>
     *   `,
     *   animations: [
     *    trigger('queryAnimation', [
     *      transition('* => goAnimate', [
     *        // hide the inner elements
     *        query('h1', style({ opacity: 0 })),
     *        query('.content', style({ opacity: 0 })),
     *
     *        // animate the inner elements in, one by one
     *        query('h1', animate(1000, style({ opacity: 1 })),
     *        query('.content', animate(1000, style({ opacity: 1 })),
     *      ])
     *    ])
     *  ]
     * })
     * class Cmp {
     *   exp = '';
     *
     *   goAnimate() {
     *     this.exp = 'goAnimate';
     *   }
     * }
     * ```
     *
     * @experimental Animation support is experimental.
     */
    function query(selector, animation, options) {
        if (options === void 0) { options = null; }
        return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function scheduleMicroTask(cb) {
        Promise.resolve(null).then(cb);
    }

    /**
     * @experimental Animation support is experimental.
     */
    var NoopAnimationPlayer = /** @class */ (function () {
        function NoopAnimationPlayer(duration, delay) {
            if (duration === void 0) { duration = 0; }
            if (delay === void 0) { delay = 0; }
            this._onDoneFns = [];
            this._onStartFns = [];
            this._onDestroyFns = [];
            this._started = false;
            this._destroyed = false;
            this._finished = false;
            this.parentPlayer = null;
            this.totalTime = duration + delay;
        }
        NoopAnimationPlayer.prototype._onFinish = function () {
            if (!this._finished) {
                this._finished = true;
                this._onDoneFns.forEach(function (fn) { return fn(); });
                this._onDoneFns = [];
            }
        };
        NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
        NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
        NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
        NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
        NoopAnimationPlayer.prototype.init = function () { };
        NoopAnimationPlayer.prototype.play = function () {
            if (!this.hasStarted()) {
                this._onStart();
                this.triggerMicrotask();
            }
            this._started = true;
        };
        /* @internal */
        /* @internal */
        NoopAnimationPlayer.prototype.triggerMicrotask = /* @internal */
        function () {
            var _this = this;
            scheduleMicroTask(function () { return _this._onFinish(); });
        };
        NoopAnimationPlayer.prototype._onStart = function () {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
        };
        NoopAnimationPlayer.prototype.pause = function () { };
        NoopAnimationPlayer.prototype.restart = function () { };
        NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
        NoopAnimationPlayer.prototype.destroy = function () {
            if (!this._destroyed) {
                this._destroyed = true;
                if (!this.hasStarted()) {
                    this._onStart();
                }
                this.finish();
                this._onDestroyFns.forEach(function (fn) { return fn(); });
                this._onDestroyFns = [];
            }
        };
        NoopAnimationPlayer.prototype.reset = function () { };
        NoopAnimationPlayer.prototype.setPosition = function (p) { };
        NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
        /* @internal */
        /* @internal */
        NoopAnimationPlayer.prototype.triggerCallback = /* @internal */
        function (phaseName) {
            var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
            methods.forEach(function (fn) { return fn(); });
            methods.length = 0;
        };
        return NoopAnimationPlayer;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var AnimationGroupPlayer = /** @class */ (function () {
        function AnimationGroupPlayer(_players) {
            var _this = this;
            this._onDoneFns = [];
            this._onStartFns = [];
            this._finished = false;
            this._started = false;
            this._destroyed = false;
            this._onDestroyFns = [];
            this.parentPlayer = null;
            this.totalTime = 0;
            this.players = _players;
            var doneCount = 0;
            var destroyCount = 0;
            var startCount = 0;
            var total = this.players.length;
            if (total == 0) {
                scheduleMicroTask(function () { return _this._onFinish(); });
            }
            else {
                this.players.forEach(function (player) {
                    player.onDone(function () {
                        if (++doneCount == total) {
                            _this._onFinish();
                        }
                    });
                    player.onDestroy(function () {
                        if (++destroyCount == total) {
                            _this._onDestroy();
                        }
                    });
                    player.onStart(function () {
                        if (++startCount == total) {
                            _this._onStart();
                        }
                    });
                });
            }
            this.totalTime = this.players.reduce(function (time, player) { return Math.max(time, player.totalTime); }, 0);
        }
        AnimationGroupPlayer.prototype._onFinish = function () {
            if (!this._finished) {
                this._finished = true;
                this._onDoneFns.forEach(function (fn) { return fn(); });
                this._onDoneFns = [];
            }
        };
        AnimationGroupPlayer.prototype.init = function () { this.players.forEach(function (player) { return player.init(); }); };
        AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
        AnimationGroupPlayer.prototype._onStart = function () {
            if (!this.hasStarted()) {
                this._started = true;
                this._onStartFns.forEach(function (fn) { return fn(); });
                this._onStartFns = [];
            }
        };
        AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
        AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
        AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
        AnimationGroupPlayer.prototype.play = function () {
            if (!this.parentPlayer) {
                this.init();
            }
            this._onStart();
            this.players.forEach(function (player) { return player.play(); });
        };
        AnimationGroupPlayer.prototype.pause = function () { this.players.forEach(function (player) { return player.pause(); }); };
        AnimationGroupPlayer.prototype.restart = function () { this.players.forEach(function (player) { return player.restart(); }); };
        AnimationGroupPlayer.prototype.finish = function () {
            this._onFinish();
            this.players.forEach(function (player) { return player.finish(); });
        };
        AnimationGroupPlayer.prototype.destroy = function () { this._onDestroy(); };
        AnimationGroupPlayer.prototype._onDestroy = function () {
            if (!this._destroyed) {
                this._destroyed = true;
                this._onFinish();
                this.players.forEach(function (player) { return player.destroy(); });
                this._onDestroyFns.forEach(function (fn) { return fn(); });
                this._onDestroyFns = [];
            }
        };
        AnimationGroupPlayer.prototype.reset = function () {
            this.players.forEach(function (player) { return player.reset(); });
            this._destroyed = false;
            this._finished = false;
            this._started = false;
        };
        AnimationGroupPlayer.prototype.setPosition = function (p) {
            var timeAtPosition = p * this.totalTime;
            this.players.forEach(function (player) {
                var position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
                player.setPosition(position);
            });
        };
        AnimationGroupPlayer.prototype.getPosition = function () {
            var min = 0;
            this.players.forEach(function (player) {
                var p = player.getPosition();
                min = Math.min(p, min);
            });
            return min;
        };
        AnimationGroupPlayer.prototype.beforeDestroy = function () {
            this.players.forEach(function (player) {
                if (player.beforeDestroy) {
                    player.beforeDestroy();
                }
            });
        };
        /* @internal */
        /* @internal */
        AnimationGroupPlayer.prototype.triggerCallback = /* @internal */
        function (phaseName) {
            var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
            methods.forEach(function (fn) { return fn(); });
            methods.length = 0;
        };
        return AnimationGroupPlayer;
    }());

    var ɵPRE_STYLE = '!';

    /**
     * @license Angular v6.0.0
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    function optimizeGroupPlayer(players) {
        switch (players.length) {
            case 0:
                return new NoopAnimationPlayer();
            case 1:
                return players[0];
            default:
                return new AnimationGroupPlayer(players);
        }
    }
    function normalizeKeyframes(driver, normalizer, element, keyframes$$1, preStyles, postStyles) {
        if (preStyles === void 0) { preStyles = {}; }
        if (postStyles === void 0) { postStyles = {}; }
        var errors = [];
        var normalizedKeyframes = [];
        var previousOffset = -1;
        var previousKeyframe = null;
        keyframes$$1.forEach(function (kf) {
            var offset = kf['offset'];
            var isSameOffset = offset == previousOffset;
            var normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
            Object.keys(kf).forEach(function (prop) {
                var normalizedProp = prop;
                var normalizedValue = kf[prop];
                if (prop !== 'offset') {
                    normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
                    switch (normalizedValue) {
                        case ɵPRE_STYLE:
                            normalizedValue = preStyles[prop];
                            break;
                        case AUTO_STYLE:
                            normalizedValue = postStyles[prop];
                            break;
                        default:
                            normalizedValue =
                                normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
                            break;
                    }
                }
                normalizedKeyframe[normalizedProp] = normalizedValue;
            });
            if (!isSameOffset) {
                normalizedKeyframes.push(normalizedKeyframe);
            }
            previousKeyframe = normalizedKeyframe;
            previousOffset = offset;
        });
        if (errors.length) {
            var LINE_START = '\n - ';
            throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
        }
        return normalizedKeyframes;
    }
    function listenOnPlayer(player, eventName, event, callback) {
        switch (eventName) {
            case 'start':
                player.onStart(function () { return callback(event && copyAnimationEvent(event, 'start', player)); });
                break;
            case 'done':
                player.onDone(function () { return callback(event && copyAnimationEvent(event, 'done', player)); });
                break;
            case 'destroy':
                player.onDestroy(function () { return callback(event && copyAnimationEvent(event, 'destroy', player)); });
                break;
        }
    }
    function copyAnimationEvent(e, phaseName, player) {
        var totalTime = player.totalTime;
        var disabled = player.disabled ? true : false;
        var event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime, disabled);
        var data = e['_data'];
        if (data != null) {
            event['_data'] = data;
        }
        return event;
    }
    function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime, disabled) {
        if (phaseName === void 0) { phaseName = ''; }
        if (totalTime === void 0) { totalTime = 0; }
        return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime, disabled: !!disabled };
    }
    function getOrSetAsInMap(map, key, defaultValue) {
        var value;
        if (map instanceof Map) {
            value = map.get(key);
            if (!value) {
                map.set(key, value = defaultValue);
            }
        }
        else {
            value = map[key];
            if (!value) {
                value = map[key] = defaultValue;
            }
        }
        return value;
    }
    function parseTimelineCommand(command) {
        var separatorPos = command.indexOf(':');
        var id = command.substring(1, separatorPos);
        var action = command.substr(separatorPos + 1);
        return [id, action];
    }
    var _contains = function (elm1, elm2) { return false; };
    var _matches = function (element, selector) {
        return false;
    };
    var _query = function (element, selector, multi) {
        return [];
    };
    if (typeof Element != 'undefined') {
        // this is well supported in all browsers
        _contains = function (elm1, elm2) { return elm1.contains(elm2); };
        if (Element.prototype.matches) {
            _matches = function (element, selector) { return element.matches(selector); };
        }
        else {
            var proto = Element.prototype;
            var fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
                proto.oMatchesSelector || proto.webkitMatchesSelector;
            if (fn_1) {
                _matches = function (element, selector) { return fn_1.apply(element, [selector]); };
            }
        }
        _query = function (element, selector, multi) {
            var results = [];
            if (multi) {
                results.push.apply(results, __spread(element.querySelectorAll(selector)));
            }
            else {
                var elm = element.querySelector(selector);
                if (elm) {
                    results.push(elm);
                }
            }
            return results;
        };
    }
    function containsVendorPrefix(prop) {
        // Webkit is the only real popular vendor prefix nowadays
        // cc: http://shouldiprefix.com/
        return prop.substring(1, 6) == 'ebkit'; // webkit or Webkit
    }
    var _CACHED_BODY = null;
    var _IS_WEBKIT = false;
    function validateStyleProperty(prop) {
        if (!_CACHED_BODY) {
            _CACHED_BODY = getBodyNode() || {};
            _IS_WEBKIT = _CACHED_BODY.style ? ('WebkitAppearance' in _CACHED_BODY.style) : false;
        }
        var result = true;
        if (_CACHED_BODY.style && !containsVendorPrefix(prop)) {
            result = prop in _CACHED_BODY.style;
            if (!result && _IS_WEBKIT) {
                var camelProp = 'Webkit' + prop.charAt(0).toUpperCase() + prop.substr(1);
                result = camelProp in _CACHED_BODY.style;
            }
        }
        return result;
    }
    function getBodyNode() {
        if (typeof document != 'undefined') {
            return document.body;
        }
        return null;
    }
    var matchesElement = _matches;
    var containsElement = _contains;
    var invokeQuery = _query;

    /**
     * @experimental
     */
    var NoopAnimationDriver = /** @class */ (function () {
        function NoopAnimationDriver() {
        }
        NoopAnimationDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
        NoopAnimationDriver.prototype.matchesElement = function (element, selector) {
            return matchesElement(element, selector);
        };
        NoopAnimationDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
        NoopAnimationDriver.prototype.query = function (element, selector, multi) {
            return invokeQuery(element, selector, multi);
        };
        NoopAnimationDriver.prototype.computeStyle = function (element, prop, defaultValue) {
            return defaultValue || '';
        };
        NoopAnimationDriver.prototype.animate = function (element, keyframes$$1, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
            if (previousPlayers === void 0) { previousPlayers = []; }
            return new NoopAnimationPlayer(duration, delay);
        };
        NoopAnimationDriver.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        NoopAnimationDriver.ctorParameters = function () { return []; };
        return NoopAnimationDriver;
    }());
    /**
     * @experimental
     */
    var AnimationDriver = /** @class */ (function () {
        function AnimationDriver() {
        }
        AnimationDriver.NOOP = new NoopAnimationDriver();
        return AnimationDriver;
    }());

    var ONE_SECOND = 1000;
    var SUBSTITUTION_EXPR_START = '{{';
    var SUBSTITUTION_EXPR_END = '}}';
    var ENTER_CLASSNAME = 'ng-enter';
    var LEAVE_CLASSNAME = 'ng-leave';


    var NG_TRIGGER_CLASSNAME = 'ng-trigger';
    var NG_TRIGGER_SELECTOR = '.ng-trigger';
    var NG_ANIMATING_CLASSNAME = 'ng-animating';
    var NG_ANIMATING_SELECTOR = '.ng-animating';
    function resolveTimingValue(value) {
        if (typeof value == 'number')
            return value;
        var matches = value.match(/^(-?[\.\d]+)(m?s)/);
        if (!matches || matches.length < 2)
            return 0;
        return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
    }
    function _convertTimeValueToMS(value, unit) {
        switch (unit) {
            case 's':
                return value * ONE_SECOND;
            default:
                // ms or something else
                return value;
        }
    }
    function resolveTiming(timings, errors, allowNegativeValues) {
        return timings.hasOwnProperty('duration') ?
            timings :
            parseTimeExpression(timings, errors, allowNegativeValues);
    }
    function parseTimeExpression(exp, errors, allowNegativeValues) {
        var regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
        var duration;
        var delay = 0;
        var easing = '';
        if (typeof exp === 'string') {
            var matches = exp.match(regex);
            if (matches === null) {
                errors.push("The provided timing value \"" + exp + "\" is invalid.");
                return { duration: 0, delay: 0, easing: '' };
            }
            duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
            var delayMatch = matches[3];
            if (delayMatch != null) {
                delay = _convertTimeValueToMS(Math.floor(parseFloat(delayMatch)), matches[4]);
            }
            var easingVal = matches[5];
            if (easingVal) {
                easing = easingVal;
            }
        }
        else {
            duration = exp;
        }
        if (!allowNegativeValues) {
            var containsErrors = false;
            var startIndex = errors.length;
            if (duration < 0) {
                errors.push("Duration values below 0 are not allowed for this animation step.");
                containsErrors = true;
            }
            if (delay < 0) {
                errors.push("Delay values below 0 are not allowed for this animation step.");
                containsErrors = true;
            }
            if (containsErrors) {
                errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
            }
        }
        return { duration: duration, delay: delay, easing: easing };
    }
    function copyObj(obj, destination) {
        if (destination === void 0) { destination = {}; }
        Object.keys(obj).forEach(function (prop) { destination[prop] = obj[prop]; });
        return destination;
    }
    function copyStyles(styles, readPrototype, destination) {
        if (destination === void 0) { destination = {}; }
        if (readPrototype) {
            // we make use of a for-in loop so that the
            // prototypically inherited properties are
            // revealed from the backFill map
            for (var prop in styles) {
                destination[prop] = styles[prop];
            }
        }
        else {
            copyObj(styles, destination);
        }
        return destination;
    }
    function setStyles(element, styles) {
        if (element['style']) {
            Object.keys(styles).forEach(function (prop) {
                var camelProp = dashCaseToCamelCase(prop);
                element.style[camelProp] = styles[prop];
            });
        }
    }
    function eraseStyles(element, styles) {
        if (element['style']) {
            Object.keys(styles).forEach(function (prop) {
                var camelProp = dashCaseToCamelCase(prop);
                element.style[camelProp] = '';
            });
        }
    }
    function normalizeAnimationEntry(steps) {
        if (Array.isArray(steps)) {
            if (steps.length == 1)
                return steps[0];
            return sequence(steps);
        }
        return steps;
    }
    function validateStyleParams(value, options, errors) {
        var params = options.params || {};
        var matches = extractStyleParams(value);
        if (matches.length) {
            matches.forEach(function (varName) {
                if (!params.hasOwnProperty(varName)) {
                    errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
                }
            });
        }
    }
    var PARAM_REGEX = new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
    function extractStyleParams(value) {
        var params = [];
        if (typeof value === 'string') {
            var val = value.toString();
            var match = void 0;
            while (match = PARAM_REGEX.exec(val)) {
                params.push(match[1]);
            }
            PARAM_REGEX.lastIndex = 0;
        }
        return params;
    }
    function interpolateParams(value, params, errors) {
        var original = value.toString();
        var str = original.replace(PARAM_REGEX, function (_, varName) {
            var localVal = params[varName];
            // this means that the value was never overridden by the data passed in by the user
            if (!params.hasOwnProperty(varName)) {
                errors.push("Please provide a value for the animation param " + varName);
                localVal = '';
            }
            return localVal.toString();
        });
        // we do this to assert that numeric values stay as they are
        return str == original ? value : str;
    }
    function iteratorToArray(iterator) {
        var arr = [];
        var item = iterator.next();
        while (!item.done) {
            arr.push(item.value);
            item = iterator.next();
        }
        return arr;
    }

    var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
    function dashCaseToCamelCase(input) {
        return input.replace(DASH_CASE_REGEXP, function () {
            var m = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                m[_i] = arguments[_i];
            }
            return m[1].toUpperCase();
        });
    }
    function allowPreviousPlayerStylesMerge(duration, delay) {
        return duration === 0 || delay === 0;
    }
    function balancePreviousStylesIntoKeyframes(element, keyframes$$1, previousStyles) {
        var previousStyleProps = Object.keys(previousStyles);
        if (previousStyleProps.length && keyframes$$1.length) {
            var startingKeyframe_1 = keyframes$$1[0];
            var missingStyleProps_1 = [];
            previousStyleProps.forEach(function (prop) {
                if (!startingKeyframe_1.hasOwnProperty(prop)) {
                    missingStyleProps_1.push(prop);
                }
                startingKeyframe_1[prop] = previousStyles[prop];
            });
            if (missingStyleProps_1.length) {
                var _loop_1 = function () {
                    var kf = keyframes$$1[i];
                    missingStyleProps_1.forEach(function (prop) { kf[prop] = computeStyle(element, prop); });
                };
                // tslint:disable-next-line
                for (var i = 1; i < keyframes$$1.length; i++) {
                    _loop_1();
                }
            }
        }
        return keyframes$$1;
    }
    function visitDslNode(visitor, node, context) {
        switch (node.type) {
            case 7 /* Trigger */:
                return visitor.visitTrigger(node, context);
            case 0 /* State */:
                return visitor.visitState(node, context);
            case 1 /* Transition */:
                return visitor.visitTransition(node, context);
            case 2 /* Sequence */:
                return visitor.visitSequence(node, context);
            case 3 /* Group */:
                return visitor.visitGroup(node, context);
            case 4 /* Animate */:
                return visitor.visitAnimate(node, context);
            case 5 /* Keyframes */:
                return visitor.visitKeyframes(node, context);
            case 6 /* Style */:
                return visitor.visitStyle(node, context);
            case 8 /* Reference */:
                return visitor.visitReference(node, context);
            case 9 /* AnimateChild */:
                return visitor.visitAnimateChild(node, context);
            case 10 /* AnimateRef */:
                return visitor.visitAnimateRef(node, context);
            case 11 /* Query */:
                return visitor.visitQuery(node, context);
            case 12 /* Stagger */:
                return visitor.visitStagger(node, context);
            default:
                throw new Error("Unable to resolve animation metadata node #" + node.type);
        }
    }
    function computeStyle(element, prop) {
        return window.getComputedStyle(element)[prop];
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var ANY_STATE = '*';
    function parseTransitionExpr(transitionValue, errors) {
        var expressions = [];
        if (typeof transitionValue == 'string') {
            transitionValue
                .split(/\s*,\s*/)
                .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
        }
        else {
            expressions.push(transitionValue);
        }
        return expressions;
    }
    function parseInnerTransitionStr(eventStr, expressions, errors) {
        if (eventStr[0] == ':') {
            var result = parseAnimationAlias(eventStr, errors);
            if (typeof result == 'function') {
                expressions.push(result);
                return;
            }
            eventStr = result;
        }
        var match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
        if (match == null || match.length < 4) {
            errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
            return expressions;
        }
        var fromState = match[1];
        var separator = match[2];
        var toState = match[3];
        expressions.push(makeLambdaFromStates(fromState, toState));
        var isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
        if (separator[0] == '<' && !isFullAnyStateExpr) {
            expressions.push(makeLambdaFromStates(toState, fromState));
        }
    }
    function parseAnimationAlias(alias, errors) {
        switch (alias) {
            case ':enter':
                return 'void => *';
            case ':leave':
                return '* => void';
            case ':increment':
                return function (fromState, toState) { return parseFloat(toState) > parseFloat(fromState); };
            case ':decrement':
                return function (fromState, toState) { return parseFloat(toState) < parseFloat(fromState); };
            default:
                errors.push("The transition alias value \"" + alias + "\" is not supported");
                return '* => *';
        }
    }
    // DO NOT REFACTOR ... keep the follow set instantiations
    // with the values intact (closure compiler for some reason
    // removes follow-up lines that add the values outside of
    // the constructor...
    var TRUE_BOOLEAN_VALUES = new Set(['true', '1']);
    var FALSE_BOOLEAN_VALUES = new Set(['false', '0']);
    function makeLambdaFromStates(lhs, rhs) {
        var LHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(lhs) || FALSE_BOOLEAN_VALUES.has(lhs);
        var RHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(rhs) || FALSE_BOOLEAN_VALUES.has(rhs);
        return function (fromState, toState) {
            var lhsMatch = lhs == ANY_STATE || lhs == fromState;
            var rhsMatch = rhs == ANY_STATE || rhs == toState;
            if (!lhsMatch && LHS_MATCH_BOOLEAN && typeof fromState === 'boolean') {
                lhsMatch = fromState ? TRUE_BOOLEAN_VALUES.has(lhs) : FALSE_BOOLEAN_VALUES.has(lhs);
            }
            if (!rhsMatch && RHS_MATCH_BOOLEAN && typeof toState === 'boolean') {
                rhsMatch = toState ? TRUE_BOOLEAN_VALUES.has(rhs) : FALSE_BOOLEAN_VALUES.has(rhs);
            }
            return lhsMatch && rhsMatch;
        };
    }

    var SELF_TOKEN = ':self';
    var SELF_TOKEN_REGEX = new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
    /*
     * [Validation]
     * The visitor code below will traverse the animation AST generated by the animation verb functions
     * (the output is a tree of objects) and attempt to perform a series of validations on the data. The
     * following corner-cases will be validated:
     *
     * 1. Overlap of animations
     * Given that a CSS property cannot be animated in more than one place at the same time, it's
     * important that this behaviour is detected and validated. The way in which this occurs is that
     * each time a style property is examined, a string-map containing the property will be updated with
     * the start and end times for when the property is used within an animation step.
     *
     * If there are two or more parallel animations that are currently running (these are invoked by the
     * group()) on the same element then the validator will throw an error. Since the start/end timing
     * values are collected for each property then if the current animation step is animating the same
     * property and its timing values fall anywhere into the window of time that the property is
     * currently being animated within then this is what causes an error.
     *
     * 2. Timing values
     * The validator will validate to see if a timing value of `duration delay easing` or
     * `durationNumber` is valid or not.
     *
     * (note that upon validation the code below will replace the timing data with an object containing
     * {duration,delay,easing}.
     *
     * 3. Offset Validation
     * Each of the style() calls are allowed to have an offset value when placed inside of keyframes().
     * Offsets within keyframes() are considered valid when:
     *
     *   - No offsets are used at all
     *   - Each style() entry contains an offset value
     *   - Each offset is between 0 and 1
     *   - Each offset is greater to or equal than the previous one
     *
     * Otherwise an error will be thrown.
     */
    function buildAnimationAst(driver, metadata, errors) {
        return new AnimationAstBuilderVisitor(driver).build(metadata, errors);
    }
    var ROOT_SELECTOR = '';
    var AnimationAstBuilderVisitor = /** @class */ (function () {
        function AnimationAstBuilderVisitor(_driver) {
            this._driver = _driver;
        }
        AnimationAstBuilderVisitor.prototype.build = function (metadata, errors) {
            var context = new AnimationAstBuilderContext(errors);
            this._resetContextStyleTimingState(context);
            return visitDslNode(this, normalizeAnimationEntry(metadata), context);
        };
        AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = function (context) {
            context.currentQuerySelector = ROOT_SELECTOR;
            context.collectedStyles = {};
            context.collectedStyles[ROOT_SELECTOR] = {};
            context.currentTime = 0;
        };
        AnimationAstBuilderVisitor.prototype.visitTrigger = function (metadata, context) {
            var _this = this;
            var queryCount = context.queryCount = 0;
            var depCount = context.depCount = 0;
            var states = [];
            var transitions = [];
            if (metadata.name.charAt(0) == '@') {
                context.errors.push('animation triggers cannot be prefixed with an `@` sign (e.g. trigger(\'@foo\', [...]))');
            }
            metadata.definitions.forEach(function (def) {
                _this._resetContextStyleTimingState(context);
                if (def.type == 0 /* State */) {
                    var stateDef_1 = def;
                    var name_1 = stateDef_1.name;
                    name_1.toString().split(/\s*,\s*/).forEach(function (n) {
                        stateDef_1.name = n;
                        states.push(_this.visitState(stateDef_1, context));
                    });
                    stateDef_1.name = name_1;
                }
                else if (def.type == 1 /* Transition */) {
                    var transition$$1 = _this.visitTransition(def, context);
                    queryCount += transition$$1.queryCount;
                    depCount += transition$$1.depCount;
                    transitions.push(transition$$1);
                }
                else {
                    context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
                }
            });
            return {
                type: 7 /* Trigger */,
                name: metadata.name, states: states, transitions: transitions, queryCount: queryCount, depCount: depCount,
                options: null
            };
        };
        AnimationAstBuilderVisitor.prototype.visitState = function (metadata, context) {
            var styleAst = this.visitStyle(metadata.styles, context);
            var astParams = (metadata.options && metadata.options.params) || null;
            if (styleAst.containsDynamicStyles) {
                var missingSubs_1 = new Set();
                var params_1 = astParams || {};
                styleAst.styles.forEach(function (value) {
                    if (isObject(value)) {
                        var stylesObj_1 = value;
                        Object.keys(stylesObj_1).forEach(function (prop) {
                            extractStyleParams(stylesObj_1[prop]).forEach(function (sub) {
                                if (!params_1.hasOwnProperty(sub)) {
                                    missingSubs_1.add(sub);
                                }
                            });
                        });
                    }
                });
                if (missingSubs_1.size) {
                    var missingSubsArr = iteratorToArray(missingSubs_1.values());
                    context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
                }
            }
            return {
                type: 0 /* State */,
                name: metadata.name,
                style: styleAst,
                options: astParams ? { params: astParams } : null
            };
        };
        AnimationAstBuilderVisitor.prototype.visitTransition = function (metadata, context) {
            context.queryCount = 0;
            context.depCount = 0;
            var animation$$1 = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
            var matchers = parseTransitionExpr(metadata.expr, context.errors);
            return {
                type: 1 /* Transition */,
                matchers: matchers,
                animation: animation$$1,
                queryCount: context.queryCount,
                depCount: context.depCount,
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitSequence = function (metadata, context) {
            var _this = this;
            return {
                type: 2 /* Sequence */,
                steps: metadata.steps.map(function (s) { return visitDslNode(_this, s, context); }),
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitGroup = function (metadata, context) {
            var _this = this;
            var currentTime = context.currentTime;
            var furthestTime = 0;
            var steps = metadata.steps.map(function (step) {
                context.currentTime = currentTime;
                var innerAst = visitDslNode(_this, step, context);
                furthestTime = Math.max(furthestTime, context.currentTime);
                return innerAst;
            });
            context.currentTime = furthestTime;
            return {
                type: 3 /* Group */,
                steps: steps,
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitAnimate = function (metadata, context) {
            var timingAst = constructTimingAst(metadata.timings, context.errors);
            context.currentAnimateTimings = timingAst;
            var styleAst;
            var styleMetadata = metadata.styles ? metadata.styles : style({});
            if (styleMetadata.type == 5 /* Keyframes */) {
                styleAst = this.visitKeyframes(styleMetadata, context);
            }
            else {
                var styleMetadata_1 = metadata.styles;
                var isEmpty = false;
                if (!styleMetadata_1) {
                    isEmpty = true;
                    var newStyleData = {};
                    if (timingAst.easing) {
                        newStyleData['easing'] = timingAst.easing;
                    }
                    styleMetadata_1 = style(newStyleData);
                }
                context.currentTime += timingAst.duration + timingAst.delay;
                var _styleAst = this.visitStyle(styleMetadata_1, context);
                _styleAst.isEmptyStep = isEmpty;
                styleAst = _styleAst;
            }
            context.currentAnimateTimings = null;
            return {
                type: 4 /* Animate */,
                timings: timingAst,
                style: styleAst,
                options: null
            };
        };
        AnimationAstBuilderVisitor.prototype.visitStyle = function (metadata, context) {
            var ast = this._makeStyleAst(metadata, context);
            this._validateStyleAst(ast, context);
            return ast;
        };
        AnimationAstBuilderVisitor.prototype._makeStyleAst = function (metadata, context) {
            var styles = [];
            if (Array.isArray(metadata.styles)) {
                metadata.styles.forEach(function (styleTuple) {
                    if (typeof styleTuple == 'string') {
                        if (styleTuple == AUTO_STYLE) {
                            styles.push(styleTuple);
                        }
                        else {
                            context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
                        }
                    }
                    else {
                        styles.push(styleTuple);
                    }
                });
            }
            else {
                styles.push(metadata.styles);
            }
            var containsDynamicStyles = false;
            var collectedEasing = null;
            styles.forEach(function (styleData) {
                if (isObject(styleData)) {
                    var styleMap = styleData;
                    var easing = styleMap['easing'];
                    if (easing) {
                        collectedEasing = easing;
                        delete styleMap['easing'];
                    }
                    if (!containsDynamicStyles) {
                        for (var prop in styleMap) {
                            var value = styleMap[prop];
                            if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
                                containsDynamicStyles = true;
                                break;
                            }
                        }
                    }
                }
            });
            return {
                type: 6 /* Style */,
                styles: styles,
                easing: collectedEasing,
                offset: metadata.offset, containsDynamicStyles: containsDynamicStyles,
                options: null
            };
        };
        AnimationAstBuilderVisitor.prototype._validateStyleAst = function (ast, context) {
            var _this = this;
            var timings = context.currentAnimateTimings;
            var endTime = context.currentTime;
            var startTime = context.currentTime;
            if (timings && startTime > 0) {
                startTime -= timings.duration + timings.delay;
            }
            ast.styles.forEach(function (tuple) {
                if (typeof tuple == 'string')
                    return;
                Object.keys(tuple).forEach(function (prop) {
                    if (!_this._driver.validateStyleProperty(prop)) {
                        context.errors.push("The provided animation property \"" + prop + "\" is not a supported CSS property for animations");
                        return;
                    }
                    var collectedStyles = context.collectedStyles[context.currentQuerySelector];
                    var collectedEntry = collectedStyles[prop];
                    var updateCollectedStyle = true;
                    if (collectedEntry) {
                        if (startTime != endTime && startTime >= collectedEntry.startTime &&
                            endTime <= collectedEntry.endTime) {
                            context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                            updateCollectedStyle = false;
                        }
                        // we always choose the smaller start time value since we
                        // want to have a record of the entire animation window where
                        // the style property is being animated in between
                        startTime = collectedEntry.startTime;
                    }
                    if (updateCollectedStyle) {
                        collectedStyles[prop] = { startTime: startTime, endTime: endTime };
                    }
                    if (context.options) {
                        validateStyleParams(tuple[prop], context.options, context.errors);
                    }
                });
            });
        };
        AnimationAstBuilderVisitor.prototype.visitKeyframes = function (metadata, context) {
            var _this = this;
            var ast = { type: 5 /* Keyframes */, styles: [], options: null };
            if (!context.currentAnimateTimings) {
                context.errors.push("keyframes() must be placed inside of a call to animate()");
                return ast;
            }
            var MAX_KEYFRAME_OFFSET = 1;
            var totalKeyframesWithOffsets = 0;
            var offsets = [];
            var offsetsOutOfOrder = false;
            var keyframesOutOfRange = false;
            var previousOffset = 0;
            var keyframes$$1 = metadata.steps.map(function (styles) {
                var style$$1 = _this._makeStyleAst(styles, context);
                var offsetVal = style$$1.offset != null ? style$$1.offset : consumeOffset(style$$1.styles);
                var offset = 0;
                if (offsetVal != null) {
                    totalKeyframesWithOffsets++;
                    offset = style$$1.offset = offsetVal;
                }
                keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
                offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
                previousOffset = offset;
                offsets.push(offset);
                return style$$1;
            });
            if (keyframesOutOfRange) {
                context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
            }
            if (offsetsOutOfOrder) {
                context.errors.push("Please ensure that all keyframe offsets are in order");
            }
            var length = metadata.steps.length;
            var generatedOffset = 0;
            if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
                context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
            }
            else if (totalKeyframesWithOffsets == 0) {
                generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
            }
            var limit = length - 1;
            var currentTime = context.currentTime;
            var currentAnimateTimings = (context.currentAnimateTimings);
            var animateDuration = currentAnimateTimings.duration;
            keyframes$$1.forEach(function (kf, i) {
                var offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
                var durationUpToThisFrame = offset * animateDuration;
                context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
                currentAnimateTimings.duration = durationUpToThisFrame;
                _this._validateStyleAst(kf, context);
                kf.offset = offset;
                ast.styles.push(kf);
            });
            return ast;
        };
        AnimationAstBuilderVisitor.prototype.visitReference = function (metadata, context) {
            return {
                type: 8 /* Reference */,
                animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context),
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitAnimateChild = function (metadata, context) {
            context.depCount++;
            return {
                type: 9 /* AnimateChild */,
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitAnimateRef = function (metadata, context) {
            return {
                type: 10 /* AnimateRef */,
                animation: this.visitReference(metadata.animation, context),
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitQuery = function (metadata, context) {
            var parentSelector = (context.currentQuerySelector);
            var options = (metadata.options || {});
            context.queryCount++;
            context.currentQuery = metadata;
            var _a = __read(normalizeSelector(metadata.selector), 2), selector = _a[0], includeSelf = _a[1];
            context.currentQuerySelector =
                parentSelector.length ? (parentSelector + ' ' + selector) : selector;
            getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
            var animation$$1 = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
            context.currentQuery = null;
            context.currentQuerySelector = parentSelector;
            return {
                type: 11 /* Query */,
                selector: selector,
                limit: options.limit || 0,
                optional: !!options.optional, includeSelf: includeSelf, animation: animation$$1,
                originalSelector: metadata.selector,
                options: normalizeAnimationOptions(metadata.options)
            };
        };
        AnimationAstBuilderVisitor.prototype.visitStagger = function (metadata, context) {
            if (!context.currentQuery) {
                context.errors.push("stagger() can only be used inside of query()");
            }
            var timings = metadata.timings === 'full' ?
                { duration: 0, delay: 0, easing: 'full' } :
                resolveTiming(metadata.timings, context.errors, true);
            return {
                type: 12 /* Stagger */,
                animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context), timings: timings,
                options: null
            };
        };
        return AnimationAstBuilderVisitor;
    }());
    function normalizeSelector(selector) {
        var hasAmpersand = selector.split(/\s*,\s*/).find(function (token) { return token == SELF_TOKEN; }) ? true : false;
        if (hasAmpersand) {
            selector = selector.replace(SELF_TOKEN_REGEX, '');
        }
        // the :enter and :leave selectors are filled in at runtime during timeline building
        selector = selector.replace(/@\*/g, NG_TRIGGER_SELECTOR)
            .replace(/@\w+/g, function (match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); })
            .replace(/:animating/g, NG_ANIMATING_SELECTOR);
        return [selector, hasAmpersand];
    }
    function normalizeParams(obj) {
        return obj ? copyObj(obj) : null;
    }
    var AnimationAstBuilderContext = /** @class */ (function () {
        function AnimationAstBuilderContext(errors) {
            this.errors = errors;
            this.queryCount = 0;
            this.depCount = 0;
            this.currentTransition = null;
            this.currentQuery = null;
            this.currentQuerySelector = null;
            this.currentAnimateTimings = null;
            this.currentTime = 0;
            this.collectedStyles = {};
            this.options = null;
        }
        return AnimationAstBuilderContext;
    }());
    function consumeOffset(styles) {
        if (typeof styles == 'string')
            return null;
        var offset = null;
        if (Array.isArray(styles)) {
            styles.forEach(function (styleTuple) {
                if (isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
                    var obj = styleTuple;
                    offset = parseFloat(obj['offset']);
                    delete obj['offset'];
                }
            });
        }
        else if (isObject(styles) && styles.hasOwnProperty('offset')) {
            var obj = styles;
            offset = parseFloat(obj['offset']);
            delete obj['offset'];
        }
        return offset;
    }
    function isObject(value) {
        return !Array.isArray(value) && typeof value == 'object';
    }
    function constructTimingAst(value, errors) {
        var timings = null;
        if (value.hasOwnProperty('duration')) {
            timings = value;
        }
        else if (typeof value == 'number') {
            var duration = resolveTiming(value, errors).duration;
            return makeTimingAst(duration, 0, '');
        }
        var strValue = value;
        var isDynamic = strValue.split(/\s+/).some(function (v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; });
        if (isDynamic) {
            var ast = makeTimingAst(0, 0, '');
            ast.dynamic = true;
            ast.strValue = strValue;
            return ast;
        }
        timings = timings || resolveTiming(strValue, errors);
        return makeTimingAst(timings.duration, timings.delay, timings.easing);
    }
    function normalizeAnimationOptions(options) {
        if (options) {
            options = copyObj(options);
            if (options['params']) {
                options['params'] = (normalizeParams(options['params']));
            }
        }
        else {
            options = {};
        }
        return options;
    }
    function makeTimingAst(duration, delay, easing) {
        return { duration: duration, delay: delay, easing: easing };
    }

    function createTimelineInstruction(element, keyframes$$1, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
        if (easing === void 0) { easing = null; }
        if (subTimeline === void 0) { subTimeline = false; }
        return {
            type: 1 /* TimelineAnimation */,
            element: element,
            keyframes: keyframes$$1,
            preStyleProps: preStyleProps,
            postStyleProps: postStyleProps,
            duration: duration,
            delay: delay,
            totalTime: duration + delay, easing: easing, subTimeline: subTimeline
        };
    }

    var ElementInstructionMap = /** @class */ (function () {
        function ElementInstructionMap() {
            this._map = new Map();
        }
        ElementInstructionMap.prototype.consume = function (element) {
            var instructions = this._map.get(element);
            if (instructions) {
                this._map.delete(element);
            }
            else {
                instructions = [];
            }
            return instructions;
        };
        ElementInstructionMap.prototype.append = function (element, instructions) {
            var existingInstructions = this._map.get(element);
            if (!existingInstructions) {
                this._map.set(element, existingInstructions = []);
            }
            existingInstructions.push.apply(existingInstructions, __spread(instructions));
        };
        ElementInstructionMap.prototype.has = function (element) { return this._map.has(element); };
        ElementInstructionMap.prototype.clear = function () { this._map.clear(); };
        return ElementInstructionMap;
    }());

    var ONE_FRAME_IN_MILLISECONDS = 1;
    var ENTER_TOKEN = ':enter';
    var ENTER_TOKEN_REGEX = new RegExp(ENTER_TOKEN, 'g');
    var LEAVE_TOKEN = ':leave';
    var LEAVE_TOKEN_REGEX = new RegExp(LEAVE_TOKEN, 'g');
    /*
     * The code within this file aims to generate web-animations-compatible keyframes from Angular's
     * animation DSL code.
     *
     * The code below will be converted from:
     *
     * ```
     * sequence([
     *   style({ opacity: 0 }),
     *   animate(1000, style({ opacity: 0 }))
     * ])
     * ```
     *
     * To:
     * ```
     * keyframes = [{ opacity: 0, offset: 0 }, { opacity: 1, offset: 1 }]
     * duration = 1000
     * delay = 0
     * easing = ''
     * ```
     *
     * For this operation to cover the combination of animation verbs (style, animate, group, etc...) a
     * combination of prototypical inheritance, AST traversal and merge-sort-like algorithms are used.
     *
     * [AST Traversal]
     * Each of the animation verbs, when executed, will return an string-map object representing what
     * type of action it is (style, animate, group, etc...) and the data associated with it. This means
     * that when functional composition mix of these functions is evaluated (like in the example above)
     * then it will end up producing a tree of objects representing the animation itself.
     *
     * When this animation object tree is processed by the visitor code below it will visit each of the
     * verb statements within the visitor. And during each visit it will build the context of the
     * animation keyframes by interacting with the `TimelineBuilder`.
     *
     * [TimelineBuilder]
     * This class is responsible for tracking the styles and building a series of keyframe objects for a
     * timeline between a start and end time. The builder starts off with an initial timeline and each
     * time the AST comes across a `group()`, `keyframes()` or a combination of the two wihtin a
     * `sequence()` then it will generate a sub timeline for each step as well as a new one after
     * they are complete.
     *
     * As the AST is traversed, the timing state on each of the timelines will be incremented. If a sub
     * timeline was created (based on one of the cases above) then the parent timeline will attempt to
     * merge the styles used within the sub timelines into itself (only with group() this will happen).
     * This happens with a merge operation (much like how the merge works in mergesort) and it will only
     * copy the most recently used styles from the sub timelines into the parent timeline. This ensures
     * that if the styles are used later on in another phase of the animation then they will be the most
     * up-to-date values.
     *
     * [How Missing Styles Are Updated]
     * Each timeline has a `backFill` property which is responsible for filling in new styles into
     * already processed keyframes if a new style shows up later within the animation sequence.
     *
     * ```
     * sequence([
     *   style({ width: 0 }),
     *   animate(1000, style({ width: 100 })),
     *   animate(1000, style({ width: 200 })),
     *   animate(1000, style({ width: 300 }))
     *   animate(1000, style({ width: 400, height: 400 })) // notice how `height` doesn't exist anywhere
     * else
     * ])
     * ```
     *
     * What is happening here is that the `height` value is added later in the sequence, but is missing
     * from all previous animation steps. Therefore when a keyframe is created it would also be missing
     * from all previous keyframes up until where it is first used. For the timeline keyframe generation
     * to properly fill in the style it will place the previous value (the value from the parent
     * timeline) or a default value of `*` into the backFill object. Given that each of the keyframe
     * styles are objects that prototypically inhert from the backFill object, this means that if a
     * value is added into the backFill then it will automatically propagate any missing values to all
     * keyframes. Therefore the missing `height` value will be properly filled into the already
     * processed keyframes.
     *
     * When a sub-timeline is created it will have its own backFill property. This is done so that
     * styles present within the sub-timeline do not accidentally seep into the previous/future timeline
     * keyframes
     *
     * (For prototypically-inherited contents to be detected a `for(i in obj)` loop must be used.)
     *
     * [Validation]
     * The code in this file is not responsible for validation. That functionality happens with within
     * the `AnimationValidatorVisitor` code.
     */
    function buildAnimationTimelines(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
        if (startingStyles === void 0) { startingStyles = {}; }
        if (finalStyles === void 0) { finalStyles = {}; }
        if (errors === void 0) { errors = []; }
        return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors);
    }
    var AnimationTimelineBuilderVisitor = /** @class */ (function () {
        function AnimationTimelineBuilderVisitor() {
        }
        AnimationTimelineBuilderVisitor.prototype.buildKeyframes = function (driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
            if (errors === void 0) { errors = []; }
            subInstructions = subInstructions || new ElementInstructionMap();
            var context = new AnimationTimelineContext(driver, rootElement, subInstructions, enterClassName, leaveClassName, errors, []);
            context.options = options;
            context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
            visitDslNode(this, ast, context);
            // this checks to see if an actual animation happened
            var timelines = context.timelines.filter(function (timeline) { return timeline.containsAnimation(); });
            if (timelines.length && Object.keys(finalStyles).length) {
                var tl = timelines[timelines.length - 1];
                if (!tl.allowOnlyTimelineStyles()) {
                    tl.setStyles([finalStyles], null, context.errors, options);
                }
            }
            return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
                [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
        };
        AnimationTimelineBuilderVisitor.prototype.visitTrigger = function (ast, context) {
            // these values are not visited in this AST
        };
        AnimationTimelineBuilderVisitor.prototype.visitState = function (ast, context) {
            // these values are not visited in this AST
        };
        AnimationTimelineBuilderVisitor.prototype.visitTransition = function (ast, context) {
            // these values are not visited in this AST
        };
        AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = function (ast, context) {
            var elementInstructions = context.subInstructions.consume(context.element);
            if (elementInstructions) {
                var innerContext = context.createSubContext(ast.options);
                var startTime = context.currentTimeline.currentTime;
                var endTime = this._visitSubInstructions(elementInstructions, innerContext, innerContext.options);
                if (startTime != endTime) {
                    // we do this on the upper context because we created a sub context for
                    // the sub child animations
                    context.transformIntoNewTimeline(endTime);
                }
            }
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = function (ast, context) {
            var innerContext = context.createSubContext(ast.options);
            innerContext.transformIntoNewTimeline();
            this.visitReference(ast.animation, innerContext);
            context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = function (instructions, context, options) {
            var startTime = context.currentTimeline.currentTime;
            var furthestTime = startTime;
            // this is a special-case for when a user wants to skip a sub
            // animation from being fired entirely.
            var duration = options.duration != null ? resolveTimingValue(options.duration) : null;
            var delay = options.delay != null ? resolveTimingValue(options.delay) : null;
            if (duration !== 0) {
                instructions.forEach(function (instruction) {
                    var instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
                    furthestTime =
                        Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
                });
            }
            return furthestTime;
        };
        AnimationTimelineBuilderVisitor.prototype.visitReference = function (ast, context) {
            context.updateOptions(ast.options, true);
            visitDslNode(this, ast.animation, context);
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitSequence = function (ast, context) {
            var _this = this;
            var subContextCount = context.subContextCount;
            var ctx = context;
            var options = ast.options;
            if (options && (options.params || options.delay)) {
                ctx = context.createSubContext(options);
                ctx.transformIntoNewTimeline();
                if (options.delay != null) {
                    if (ctx.previousNode.type == 6 /* Style */) {
                        ctx.currentTimeline.snapshotCurrentStyles();
                        ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                    }
                    var delay = resolveTimingValue(options.delay);
                    ctx.delayNextStep(delay);
                }
            }
            if (ast.steps.length) {
                ast.steps.forEach(function (s) { return visitDslNode(_this, s, ctx); });
                // this is here just incase the inner steps only contain or end with a style() call
                ctx.currentTimeline.applyStylesToKeyframe();
                // this means that some animation function within the sequence
                // ended up creating a sub timeline (which means the current
                // timeline cannot overlap with the contents of the sequence)
                if (ctx.subContextCount > subContextCount) {
                    ctx.transformIntoNewTimeline();
                }
            }
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitGroup = function (ast, context) {
            var _this = this;
            var innerTimelines = [];
            var furthestTime = context.currentTimeline.currentTime;
            var delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
            ast.steps.forEach(function (s) {
                var innerContext = context.createSubContext(ast.options);
                if (delay) {
                    innerContext.delayNextStep(delay);
                }
                visitDslNode(_this, s, innerContext);
                furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
                innerTimelines.push(innerContext.currentTimeline);
            });
            // this operation is run after the AST loop because otherwise
            // if the parent timeline's collected styles were updated then
            // it would pass in invalid data into the new-to-be forked items
            innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
            context.transformIntoNewTimeline(furthestTime);
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype._visitTiming = function (ast, context) {
            if (ast.dynamic) {
                var strValue = ast.strValue;
                var timingValue = context.params ? interpolateParams(strValue, context.params, context.errors) : strValue;
                return resolveTiming(timingValue, context.errors);
            }
            else {
                return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
            }
        };
        AnimationTimelineBuilderVisitor.prototype.visitAnimate = function (ast, context) {
            var timings = context.currentAnimateTimings = this._visitTiming(ast.timings, context);
            var timeline = context.currentTimeline;
            if (timings.delay) {
                context.incrementTime(timings.delay);
                timeline.snapshotCurrentStyles();
            }
            var style$$1 = ast.style;
            if (style$$1.type == 5 /* Keyframes */) {
                this.visitKeyframes(style$$1, context);
            }
            else {
                context.incrementTime(timings.duration);
                this.visitStyle(style$$1, context);
                timeline.applyStylesToKeyframe();
            }
            context.currentAnimateTimings = null;
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitStyle = function (ast, context) {
            var timeline = context.currentTimeline;
            var timings = (context.currentAnimateTimings);
            // this is a special case for when a style() call
            // directly follows  an animate() call (but not inside of an animate() call)
            if (!timings && timeline.getCurrentStyleProperties().length) {
                timeline.forwardFrame();
            }
            var easing = (timings && timings.easing) || ast.easing;
            if (ast.isEmptyStep) {
                timeline.applyEmptyStep(easing);
            }
            else {
                timeline.setStyles(ast.styles, easing, context.errors, context.options);
            }
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitKeyframes = function (ast, context) {
            var currentAnimateTimings = (context.currentAnimateTimings);
            var startTime = (context.currentTimeline).duration;
            var duration = currentAnimateTimings.duration;
            var innerContext = context.createSubContext();
            var innerTimeline = innerContext.currentTimeline;
            innerTimeline.easing = currentAnimateTimings.easing;
            ast.styles.forEach(function (step) {
                var offset = step.offset || 0;
                innerTimeline.forwardTime(offset * duration);
                innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
                innerTimeline.applyStylesToKeyframe();
            });
            // this will ensure that the parent timeline gets all the styles from
            // the child even if the new timeline below is not used
            context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
            // we do this because the window between this timeline and the sub timeline
            // should ensure that the styles within are exactly the same as they were before
            context.transformIntoNewTimeline(startTime + duration);
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitQuery = function (ast, context) {
            var _this = this;
            // in the event that the first step before this is a style step we need
            // to ensure the styles are applied before the children are animated
            var startTime = context.currentTimeline.currentTime;
            var options = (ast.options || {});
            var delay = options.delay ? resolveTimingValue(options.delay) : 0;
            if (delay && (context.previousNode.type === 6 /* Style */ ||
                (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
                context.currentTimeline.snapshotCurrentStyles();
                context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
            }
            var furthestTime = startTime;
            var elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
            context.currentQueryTotal = elms.length;
            var sameElementTimeline = null;
            elms.forEach(function (element, i) {
                context.currentQueryIndex = i;
                var innerContext = context.createSubContext(ast.options, element);
                if (delay) {
                    innerContext.delayNextStep(delay);
                }
                if (element === context.element) {
                    sameElementTimeline = innerContext.currentTimeline;
                }
                visitDslNode(_this, ast.animation, innerContext);
                // this is here just incase the inner steps only contain or end
                // with a style() call (which is here to signal that this is a preparatory
                // call to style an element before it is animated again)
                innerContext.currentTimeline.applyStylesToKeyframe();
                var endTime = innerContext.currentTimeline.currentTime;
                furthestTime = Math.max(furthestTime, endTime);
            });
            context.currentQueryIndex = 0;
            context.currentQueryTotal = 0;
            context.transformIntoNewTimeline(furthestTime);
            if (sameElementTimeline) {
                context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
                context.currentTimeline.snapshotCurrentStyles();
            }
            context.previousNode = ast;
        };
        AnimationTimelineBuilderVisitor.prototype.visitStagger = function (ast, context) {
            var parentContext = (context.parentContext);
            var tl = context.currentTimeline;
            var timings = ast.timings;
            var duration = Math.abs(timings.duration);
            var maxTime = duration * (context.currentQueryTotal - 1);
            var delay = duration * context.currentQueryIndex;
            var staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
            switch (staggerTransformer) {
                case 'reverse':
                    delay = maxTime - delay;
                    break;
                case 'full':
                    delay = parentContext.currentStaggerTime;
                    break;
            }
            var timeline = context.currentTimeline;
            if (delay) {
                timeline.delayNextStep(delay);
            }
            var startingTime = timeline.currentTime;
            visitDslNode(this, ast.animation, context);
            context.previousNode = ast;
            // time = duration + delay
            // the reason why this computation is so complex is because
            // the inner timeline may either have a delay value or a stretched
            // keyframe depending on if a subtimeline is not used or is used.
            parentContext.currentStaggerTime =
                (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
        };
        return AnimationTimelineBuilderVisitor;
    }());
    var DEFAULT_NOOP_PREVIOUS_NODE = {};
    var AnimationTimelineContext = /** @class */ (function () {
        function AnimationTimelineContext(_driver, element, subInstructions, _enterClassName, _leaveClassName, errors, timelines, initialTimeline) {
            this._driver = _driver;
            this.element = element;
            this.subInstructions = subInstructions;
            this._enterClassName = _enterClassName;
            this._leaveClassName = _leaveClassName;
            this.errors = errors;
            this.timelines = timelines;
            this.parentContext = null;
            this.currentAnimateTimings = null;
            this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
            this.subContextCount = 0;
            this.options = {};
            this.currentQueryIndex = 0;
            this.currentQueryTotal = 0;
            this.currentStaggerTime = 0;
            this.currentTimeline = initialTimeline || new TimelineBuilder(this._driver, element, 0);
            timelines.push(this.currentTimeline);
        }
        Object.defineProperty(AnimationTimelineContext.prototype, "params", {
            get: function () { return this.options.params; },
            enumerable: true,
            configurable: true
        });
        AnimationTimelineContext.prototype.updateOptions = function (options, skipIfExists) {
            var _this = this;
            if (!options)
                return;
            var newOptions = options;
            var optionsToUpdate = this.options;
            // NOTE: this will get patched up when other animation methods support duration overrides
            if (newOptions.duration != null) {
                optionsToUpdate.duration = resolveTimingValue(newOptions.duration);
            }
            if (newOptions.delay != null) {
                optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
            }
            var newParams = newOptions.params;
            if (newParams) {
                var paramsToUpdate_1 = (optionsToUpdate.params);
                if (!paramsToUpdate_1) {
                    paramsToUpdate_1 = this.options.params = {};
                }
                Object.keys(newParams).forEach(function (name) {
                    if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
                        paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
                    }
                });
            }
        };
        AnimationTimelineContext.prototype._copyOptions = function () {
            var options = {};
            if (this.options) {
                var oldParams_1 = this.options.params;
                if (oldParams_1) {
                    var params_1 = options['params'] = {};
                    Object.keys(oldParams_1).forEach(function (name) { params_1[name] = oldParams_1[name]; });
                }
            }
            return options;
        };
        AnimationTimelineContext.prototype.createSubContext = function (options, element, newTime) {
            if (options === void 0) { options = null; }
            var target = element || this.element;
            var context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
            context.previousNode = this.previousNode;
            context.currentAnimateTimings = this.currentAnimateTimings;
            context.options = this._copyOptions();
            context.updateOptions(options);
            context.currentQueryIndex = this.currentQueryIndex;
            context.currentQueryTotal = this.currentQueryTotal;
            context.parentContext = this;
            this.subContextCount++;
            return context;
        };
        AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
            this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
            this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
            this.timelines.push(this.currentTimeline);
            return this.currentTimeline;
        };
        AnimationTimelineContext.prototype.appendInstructionToTimeline = function (instruction, duration, delay) {
            var updatedTimings = {
                duration: duration != null ? duration : instruction.duration,
                delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
                easing: ''
            };
            var builder = new SubTimelineBuilder(this._driver, instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
            this.timelines.push(builder);
            return updatedTimings;
        };
        AnimationTimelineContext.prototype.incrementTime = function (time) {
            this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
        };
        AnimationTimelineContext.prototype.delayNextStep = function (delay) {
            // negative delays are not yet supported
            if (delay > 0) {
                this.currentTimeline.delayNextStep(delay);
            }
        };
        AnimationTimelineContext.prototype.invokeQuery = function (selector, originalSelector, limit, includeSelf, optional, errors) {
            var results = [];
            if (includeSelf) {
                results.push(this.element);
            }
            if (selector.length > 0) {
                // if :self is only used then the selector is empty
                selector = selector.replace(ENTER_TOKEN_REGEX, '.' + this._enterClassName);
                selector = selector.replace(LEAVE_TOKEN_REGEX, '.' + this._leaveClassName);
                var multi = limit != 1;
                var elements = this._driver.query(this.element, selector, multi);
                if (limit !== 0) {
                    elements = limit < 0 ? elements.slice(elements.length + limit, elements.length) :
                        elements.slice(0, limit);
                }
                results.push.apply(results, __spread(elements));
            }
            if (!optional && results.length == 0) {
                errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
            }
            return results;
        };
        return AnimationTimelineContext;
    }());
    var TimelineBuilder = /** @class */ (function () {
        function TimelineBuilder(_driver, element, startTime, _elementTimelineStylesLookup) {
            this._driver = _driver;
            this.element = element;
            this.startTime = startTime;
            this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
            this.duration = 0;
            this._previousKeyframe = {};
            this._currentKeyframe = {};
            this._keyframes = new Map();
            this._styleSummary = {};
            this._pendingStyles = {};
            this._backFill = {};
            this._currentEmptyStepKeyframe = null;
            if (!this._elementTimelineStylesLookup) {
                this._elementTimelineStylesLookup = new Map();
            }
            this._localTimelineStyles = Object.create(this._backFill, {});
            this._globalTimelineStyles = (this._elementTimelineStylesLookup.get(element));
            if (!this._globalTimelineStyles) {
                this._globalTimelineStyles = this._localTimelineStyles;
                this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
            }
            this._loadKeyframe();
        }
        TimelineBuilder.prototype.containsAnimation = function () {
            switch (this._keyframes.size) {
                case 0:
                    return false;
                case 1:
                    return this.getCurrentStyleProperties().length > 0;
                default:
                    return true;
            }
        };
        TimelineBuilder.prototype.getCurrentStyleProperties = function () { return Object.keys(this._currentKeyframe); };
        Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
            get: function () { return this.startTime + this.duration; },
            enumerable: true,
            configurable: true
        });
        TimelineBuilder.prototype.delayNextStep = function (delay) {
            // in the event that a style() step is placed right before a stagger()
            // and that style() step is the very first style() value in the animation
            // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
            // properly applies the style() values to work with the stagger...
            var hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
            if (this.duration || hasPreStyleStep) {
                this.forwardTime(this.currentTime + delay);
                if (hasPreStyleStep) {
                    this.snapshotCurrentStyles();
                }
            }
            else {
                this.startTime += delay;
            }
        };
        TimelineBuilder.prototype.fork = function (element, currentTime) {
            this.applyStylesToKeyframe();
            return new TimelineBuilder(this._driver, element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
        };
        TimelineBuilder.prototype._loadKeyframe = function () {
            if (this._currentKeyframe) {
                this._previousKeyframe = this._currentKeyframe;
            }
            this._currentKeyframe = (this._keyframes.get(this.duration));
            if (!this._currentKeyframe) {
                this._currentKeyframe = Object.create(this._backFill, {});
                this._keyframes.set(this.duration, this._currentKeyframe);
            }
        };
        TimelineBuilder.prototype.forwardFrame = function () {
            this.duration += ONE_FRAME_IN_MILLISECONDS;
            this._loadKeyframe();
        };
        TimelineBuilder.prototype.forwardTime = function (time) {
            this.applyStylesToKeyframe();
            this.duration = time;
            this._loadKeyframe();
        };
        TimelineBuilder.prototype._updateStyle = function (prop, value) {
            this._localTimelineStyles[prop] = value;
            this._globalTimelineStyles[prop] = value;
            this._styleSummary[prop] = { time: this.currentTime, value: value };
        };
        TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
        TimelineBuilder.prototype.applyEmptyStep = function (easing) {
            var _this = this;
            if (easing) {
                this._previousKeyframe['easing'] = easing;
            }
            // special case for animate(duration):
            // all missing styles are filled with a `*` value then
            // if any destination styles are filled in later on the same
            // keyframe then they will override the overridden styles
            // We use `_globalTimelineStyles` here because there may be
            // styles in previous keyframes that are not present in this timeline
            Object.keys(this._globalTimelineStyles).forEach(function (prop) {
                _this._backFill[prop] = _this._globalTimelineStyles[prop] || AUTO_STYLE;
                _this._currentKeyframe[prop] = AUTO_STYLE;
            });
            this._currentEmptyStepKeyframe = this._currentKeyframe;
        };
        TimelineBuilder.prototype.setStyles = function (input, easing, errors, options) {
            var _this = this;
            if (easing) {
                this._previousKeyframe['easing'] = easing;
            }
            var params = (options && options.params) || {};
            var styles = flattenStyles$1(input, this._globalTimelineStyles);
            Object.keys(styles).forEach(function (prop) {
                var val = interpolateParams(styles[prop], params, errors);
                _this._pendingStyles[prop] = val;
                if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
                    _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
                        _this._globalTimelineStyles[prop] :
                        AUTO_STYLE;
                }
                _this._updateStyle(prop, val);
            });
        };
        TimelineBuilder.prototype.applyStylesToKeyframe = function () {
            var _this = this;
            var styles = this._pendingStyles;
            var props = Object.keys(styles);
            if (props.length == 0)
                return;
            this._pendingStyles = {};
            props.forEach(function (prop) {
                var val = styles[prop];
                _this._currentKeyframe[prop] = val;
            });
            Object.keys(this._localTimelineStyles).forEach(function (prop) {
                if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                    _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
                }
            });
        };
        TimelineBuilder.prototype.snapshotCurrentStyles = function () {
            var _this = this;
            Object.keys(this._localTimelineStyles).forEach(function (prop) {
                var val = _this._localTimelineStyles[prop];
                _this._pendingStyles[prop] = val;
                _this._updateStyle(prop, val);
            });
        };
        TimelineBuilder.prototype.getFinalKeyframe = function () { return this._keyframes.get(this.duration); };
        Object.defineProperty(TimelineBuilder.prototype, "properties", {
            get: function () {
                var properties = [];
                for (var prop in this._currentKeyframe) {
                    properties.push(prop);
                }
                return properties;
            },
            enumerable: true,
            configurable: true
        });
        TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
            var _this = this;
            Object.keys(timeline._styleSummary).forEach(function (prop) {
                var details0 = _this._styleSummary[prop];
                var details1 = timeline._styleSummary[prop];
                if (!details0 || details1.time > details0.time) {
                    _this._updateStyle(prop, details1.value);
                }
            });
        };
        TimelineBuilder.prototype.buildKeyframes = function () {
            var _this = this;
            this.applyStylesToKeyframe();
            var preStyleProps = new Set();
            var postStyleProps = new Set();
            var isEmpty = this._keyframes.size === 1 && this.duration === 0;
            var finalKeyframes = [];
            this._keyframes.forEach(function (keyframe, time) {
                var finalKeyframe = copyStyles(keyframe, true);
                Object.keys(finalKeyframe).forEach(function (prop) {
                    var value = finalKeyframe[prop];
                    if (value == ɵPRE_STYLE) {
                        preStyleProps.add(prop);
                    }
                    else if (value == AUTO_STYLE) {
                        postStyleProps.add(prop);
                    }
                });
                if (!isEmpty) {
                    finalKeyframe['offset'] = time / _this.duration;
                }
                finalKeyframes.push(finalKeyframe);
            });
            var preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
            var postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
            // special case for a 0-second animation (which is designed just to place styles onscreen)
            if (isEmpty) {
                var kf0 = finalKeyframes[0];
                var kf1 = copyObj(kf0);
                kf0['offset'] = 0;
                kf1['offset'] = 1;
                finalKeyframes = [kf0, kf1];
            }
            return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
        };
        return TimelineBuilder;
    }());
    var SubTimelineBuilder = /** @class */ (function (_super) {
        __extends(SubTimelineBuilder, _super);
        function SubTimelineBuilder(driver, element, keyframes$$1, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
            if (_stretchStartingKeyframe === void 0) { _stretchStartingKeyframe = false; }
            var _this = _super.call(this, driver, element, timings.delay) || this;
            _this.element = element;
            _this.keyframes = keyframes$$1;
            _this.preStyleProps = preStyleProps;
            _this.postStyleProps = postStyleProps;
            _this._stretchStartingKeyframe = _stretchStartingKeyframe;
            _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
            return _this;
        }
        SubTimelineBuilder.prototype.containsAnimation = function () { return this.keyframes.length > 1; };
        SubTimelineBuilder.prototype.buildKeyframes = function () {
            var keyframes$$1 = this.keyframes;
            var _a = this.timings, delay = _a.delay, duration = _a.duration, easing = _a.easing;
            if (this._stretchStartingKeyframe && delay) {
                var newKeyframes = [];
                var totalTime = duration + delay;
                var startingGap = delay / totalTime;
                // the original starting keyframe now starts once the delay is done
                var newFirstKeyframe = copyStyles(keyframes$$1[0], false);
                newFirstKeyframe['offset'] = 0;
                newKeyframes.push(newFirstKeyframe);
                var oldFirstKeyframe = copyStyles(keyframes$$1[0], false);
                oldFirstKeyframe['offset'] = roundOffset(startingGap);
                newKeyframes.push(oldFirstKeyframe);
                /*
                        When the keyframe is stretched then it means that the delay before the animation
                        starts is gone. Instead the first keyframe is placed at the start of the animation
                        and it is then copied to where it starts when the original delay is over. This basically
                        means nothing animates during that delay, but the styles are still renderered. For this
                        to work the original offset values that exist in the original keyframes must be "warped"
                        so that they can take the new keyframe + delay into account.
                
                        delay=1000, duration=1000, keyframes = 0 .5 1
                
                        turns into
                
                        delay=0, duration=2000, keyframes = 0 .33 .66 1
                       */
                // offsets between 1 ... n -1 are all warped by the keyframe stretch
                var limit = keyframes$$1.length - 1;
                for (var i = 1; i <= limit; i++) {
                    var kf = copyStyles(keyframes$$1[i], false);
                    var oldOffset = kf['offset'];
                    var timeAtKeyframe = delay + oldOffset * duration;
                    kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
                    newKeyframes.push(kf);
                }
                // the new starting keyframe should be added at the start
                duration = totalTime;
                delay = 0;
                easing = '';
                keyframes$$1 = newKeyframes;
            }
            return createTimelineInstruction(this.element, keyframes$$1, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
        };
        return SubTimelineBuilder;
    }(TimelineBuilder));
    function roundOffset(offset, decimalPoints) {
        if (decimalPoints === void 0) { decimalPoints = 3; }
        var mult = Math.pow(10, decimalPoints - 1);
        return Math.round(offset * mult) / mult;
    }
    function flattenStyles$1(input, allStyles) {
        var styles = {};
        var allProperties;
        input.forEach(function (token) {
            if (token === '*') {
                allProperties = allProperties || Object.keys(allStyles);
                allProperties.forEach(function (prop) { styles[prop] = AUTO_STYLE; });
            }
            else {
                copyStyles(token, false, styles);
            }
        });
        return styles;
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @experimental Animation support is experimental.
     */
    var AnimationStyleNormalizer = /** @class */ (function () {
        function AnimationStyleNormalizer() {
        }
        return AnimationStyleNormalizer;
    }());

    var WebAnimationsStyleNormalizer = /** @class */ (function (_super) {
        __extends(WebAnimationsStyleNormalizer, _super);
        function WebAnimationsStyleNormalizer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
            return dashCaseToCamelCase(propertyName);
        };
        WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
            var unit = '';
            var strVal = value.toString().trim();
            if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
                if (typeof value === 'number') {
                    unit = 'px';
                }
                else {
                    var valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                    if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                        errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                    }
                }
            }
            return strVal + unit;
        };
        return WebAnimationsStyleNormalizer;
    }(AnimationStyleNormalizer));
    var DIMENSIONAL_PROP_MAP = makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
        .split(','));
    function makeBooleanMap(keys) {
        var map = {};
        keys.forEach(function (key) { return map[key] = true; });
        return map;
    }

    function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, totalTime, errors) {
        return {
            type: 0 /* TransitionAnimation */,
            element: element,
            triggerName: triggerName,
            isRemovalTransition: isRemovalTransition,
            fromState: fromState,
            fromStyles: fromStyles,
            toState: toState,
            toStyles: toStyles,
            timelines: timelines,
            queriedElements: queriedElements,
            preStyleProps: preStyleProps,
            postStyleProps: postStyleProps,
            totalTime: totalTime,
            errors: errors
        };
    }

    var EMPTY_OBJECT = {};
    var AnimationTransitionFactory = /** @class */ (function () {
        function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
            this._triggerName = _triggerName;
            this.ast = ast;
            this._stateStyles = _stateStyles;
        }
        AnimationTransitionFactory.prototype.match = function (currentState, nextState, element, params) {
            return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState, element, params);
        };
        AnimationTransitionFactory.prototype.buildStyles = function (stateName, params, errors) {
            var backupStateStyler = this._stateStyles['*'];
            var stateStyler = this._stateStyles[stateName];
            var backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
            return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
        };
        AnimationTransitionFactory.prototype.build = function (driver, element, currentState, nextState, enterClassName, leaveClassName, currentOptions, nextOptions, subInstructions) {
            var errors = [];
            var transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
            var currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
            var currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
            var nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
            var nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
            var queriedElements = new Set();
            var preStyleMap = new Map();
            var postStyleMap = new Map();
            var isRemoval = nextState === 'void';
            var animationOptions = { params: __assign({}, transitionAnimationParams, nextAnimationParams) };
            var timelines = buildAnimationTimelines(driver, element, this.ast.animation, enterClassName, leaveClassName, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
            var totalTime = 0;
            timelines.forEach(function (tl) { totalTime = Math.max(tl.duration + tl.delay, totalTime); });
            if (errors.length) {
                return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, totalTime, errors);
            }
            timelines.forEach(function (tl) {
                var elm = tl.element;
                var preProps = getOrSetAsInMap(preStyleMap, elm, {});
                tl.preStyleProps.forEach(function (prop) { return preProps[prop] = true; });
                var postProps = getOrSetAsInMap(postStyleMap, elm, {});
                tl.postStyleProps.forEach(function (prop) { return postProps[prop] = true; });
                if (elm !== element) {
                    queriedElements.add(elm);
                }
            });
            var queriedElementsList = iteratorToArray(queriedElements.values());
            return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap, totalTime);
        };
        return AnimationTransitionFactory;
    }());
    function oneOrMoreTransitionsMatch(matchFns, currentState, nextState, element, params) {
        return matchFns.some(function (fn) { return fn(currentState, nextState, element, params); });
    }
    var AnimationStateStyles = /** @class */ (function () {
        function AnimationStateStyles(styles, defaultParams) {
            this.styles = styles;
            this.defaultParams = defaultParams;
        }
        AnimationStateStyles.prototype.buildStyles = function (params, errors) {
            var finalStyles = {};
            var combinedParams = copyObj(this.defaultParams);
            Object.keys(params).forEach(function (key) {
                var value = params[key];
                if (value != null) {
                    combinedParams[key] = value;
                }
            });
            this.styles.styles.forEach(function (value) {
                if (typeof value !== 'string') {
                    var styleObj_1 = value;
                    Object.keys(styleObj_1).forEach(function (prop) {
                        var val = styleObj_1[prop];
                        if (val.length > 1) {
                            val = interpolateParams(val, combinedParams, errors);
                        }
                        finalStyles[prop] = val;
                    });
                }
            });
            return finalStyles;
        };
        return AnimationStateStyles;
    }());

    /**
     * @experimental Animation support is experimental.
     */
    function buildTrigger(name, ast) {
        return new AnimationTrigger(name, ast);
    }
    /**
    * @experimental Animation support is experimental.
    */
    var AnimationTrigger = /** @class */ (function () {
        function AnimationTrigger(name, ast) {
            var _this = this;
            this.name = name;
            this.ast = ast;
            this.transitionFactories = [];
            this.states = {};
            ast.states.forEach(function (ast) {
                var defaultParams = (ast.options && ast.options.params) || {};
                _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
            });
            balanceProperties(this.states, 'true', '1');
            balanceProperties(this.states, 'false', '0');
            ast.transitions.forEach(function (ast) {
                _this.transitionFactories.push(new AnimationTransitionFactory(name, ast, _this.states));
            });
            this.fallbackTransition = createFallbackTransition(name, this.states);
        }
        Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
            get: function () { return this.ast.queryCount > 0; },
            enumerable: true,
            configurable: true
        });
        AnimationTrigger.prototype.matchTransition = function (currentState, nextState, element, params) {
            var entry = this.transitionFactories.find(function (f) { return f.match(currentState, nextState, element, params); });
            return entry || null;
        };
        AnimationTrigger.prototype.matchStyles = function (currentState, params, errors) {
            return this.fallbackTransition.buildStyles(currentState, params, errors);
        };
        return AnimationTrigger;
    }());
    function createFallbackTransition(triggerName, states) {
        var matchers = [function (fromState, toState) { return true; }];
        var animation$$1 = { type: 2 /* Sequence */, steps: [], options: null };
        var transition$$1 = {
            type: 1 /* Transition */,
            animation: animation$$1,
            matchers: matchers,
            options: null,
            queryCount: 0,
            depCount: 0
        };
        return new AnimationTransitionFactory(triggerName, transition$$1, states);
    }
    function balanceProperties(obj, key1, key2) {
        if (obj.hasOwnProperty(key1)) {
            if (!obj.hasOwnProperty(key2)) {
                obj[key2] = obj[key1];
            }
        }
        else if (obj.hasOwnProperty(key2)) {
            obj[key1] = obj[key2];
        }
    }

    var EMPTY_INSTRUCTION_MAP = new ElementInstructionMap();
    var TimelineAnimationEngine = /** @class */ (function () {
        function TimelineAnimationEngine(_driver, _normalizer) {
            this._driver = _driver;
            this._normalizer = _normalizer;
            this._animations = {};
            this._playersById = {};
            this.players = [];
        }
        TimelineAnimationEngine.prototype.register = function (id, metadata) {
            var errors = [];
            var ast = buildAnimationAst(this._driver, metadata, errors);
            if (errors.length) {
                throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
            }
            else {
                this._animations[id] = ast;
            }
        };
        TimelineAnimationEngine.prototype._buildPlayer = function (i, preStyles, postStyles) {
            var element = i.element;
            var keyframes$$1 = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
            return this._driver.animate(element, keyframes$$1, i.duration, i.delay, i.easing, [], true);
        };
        TimelineAnimationEngine.prototype.create = function (id, element, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            var errors = [];
            var ast = this._animations[id];
            var instructions;
            var autoStylesMap = new Map();
            if (ast) {
                instructions = buildAnimationTimelines(this._driver, element, ast, ENTER_CLASSNAME, LEAVE_CLASSNAME, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
                instructions.forEach(function (inst) {
                    var styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
                    inst.postStyleProps.forEach(function (prop) { return styles[prop] = null; });
                });
            }
            else {
                errors.push('The requested animation doesn\'t exist or has already been destroyed');
                instructions = [];
            }
            if (errors.length) {
                throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
            }
            autoStylesMap.forEach(function (styles, element) {
                Object.keys(styles).forEach(function (prop) { styles[prop] = _this._driver.computeStyle(element, prop, AUTO_STYLE); });
            });
            var players = instructions.map(function (i) {
                var styles = autoStylesMap.get(i.element);
                return _this._buildPlayer(i, {}, styles);
            });
            var player = optimizeGroupPlayer(players);
            this._playersById[id] = player;
            player.onDestroy(function () { return _this.destroy(id); });
            this.players.push(player);
            return player;
        };
        TimelineAnimationEngine.prototype.destroy = function (id) {
            var player = this._getPlayer(id);
            player.destroy();
            delete this._playersById[id];
            var index = this.players.indexOf(player);
            if (index >= 0) {
                this.players.splice(index, 1);
            }
        };
        TimelineAnimationEngine.prototype._getPlayer = function (id) {
            var player = this._playersById[id];
            if (!player) {
                throw new Error("Unable to find the timeline player referenced by " + id);
            }
            return player;
        };
        TimelineAnimationEngine.prototype.listen = function (id, element, eventName, callback) {
            // triggerName, fromState, toState are all ignored for timeline animations
            var baseEvent = makeAnimationEvent(element, '', '', '');
            listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
            return function () { };
        };
        TimelineAnimationEngine.prototype.command = function (id, element, command, args) {
            if (command == 'register') {
                this.register(id, args[0]);
                return;
            }
            if (command == 'create') {
                var options = (args[0] || {});
                this.create(id, element, options);
                return;
            }
            var player = this._getPlayer(id);
            switch (command) {
                case 'play':
                    player.play();
                    break;
                case 'pause':
                    player.pause();
                    break;
                case 'reset':
                    player.reset();
                    break;
                case 'restart':
                    player.restart();
                    break;
                case 'finish':
                    player.finish();
                    break;
                case 'init':
                    player.init();
                    break;
                case 'setPosition':
                    player.setPosition(parseFloat(args[0]));
                    break;
                case 'destroy':
                    this.destroy(id);
                    break;
            }
        };
        return TimelineAnimationEngine;
    }());

    var QUEUED_CLASSNAME = 'ng-animate-queued';
    var QUEUED_SELECTOR = '.ng-animate-queued';
    var DISABLED_CLASSNAME = 'ng-animate-disabled';
    var DISABLED_SELECTOR = '.ng-animate-disabled';
    var STAR_CLASSNAME = 'ng-star-inserted';
    var STAR_SELECTOR = '.ng-star-inserted';
    var EMPTY_PLAYER_ARRAY = [];
    var NULL_REMOVAL_STATE = {
        namespaceId: '',
        setForRemoval: null,
        hasAnimation: false,
        removedBeforeQueried: false
    };
    var NULL_REMOVED_QUERIED_STATE = {
        namespaceId: '',
        setForRemoval: null,
        hasAnimation: false,
        removedBeforeQueried: true
    };
    var REMOVAL_FLAG = '__ng_removed';
    var StateValue = /** @class */ (function () {
        function StateValue(input, namespaceId) {
            if (namespaceId === void 0) { namespaceId = ''; }
            this.namespaceId = namespaceId;
            var isObj = input && input.hasOwnProperty('value');
            var value = isObj ? input['value'] : input;
            this.value = normalizeTriggerValue(value);
            if (isObj) {
                var options = copyObj(input);
                delete options['value'];
                this.options = options;
            }
            else {
                this.options = {};
            }
            if (!this.options.params) {
                this.options.params = {};
            }
        }
        Object.defineProperty(StateValue.prototype, "params", {
            get: function () { return this.options.params; },
            enumerable: true,
            configurable: true
        });
        StateValue.prototype.absorbOptions = function (options) {
            var newParams = options.params;
            if (newParams) {
                var oldParams_1 = (this.options.params);
                Object.keys(newParams).forEach(function (prop) {
                    if (oldParams_1[prop] == null) {
                        oldParams_1[prop] = newParams[prop];
                    }
                });
            }
        };
        return StateValue;
    }());
    var VOID_VALUE = 'void';
    var DEFAULT_STATE_VALUE = new StateValue(VOID_VALUE);
    var DELETED_STATE_VALUE = new StateValue('DELETED');
    var AnimationTransitionNamespace = /** @class */ (function () {
        function AnimationTransitionNamespace(id, hostElement, _engine) {
            this.id = id;
            this.hostElement = hostElement;
            this._engine = _engine;
            this.players = [];
            this._triggers = {};
            this._queue = [];
            this._elementListeners = new Map();
            this._hostClassName = 'ng-tns-' + id;
            addClass(hostElement, this._hostClassName);
        }
        AnimationTransitionNamespace.prototype.listen = function (element, name, phase, callback) {
            var _this = this;
            if (!this._triggers.hasOwnProperty(name)) {
                throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
            }
            if (phase == null || phase.length == 0) {
                throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
            }
            if (!isTriggerEventValid(phase)) {
                throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
            }
            var listeners = getOrSetAsInMap(this._elementListeners, element, []);
            var data = { name: name, phase: phase, callback: callback };
            listeners.push(data);
            var triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
            if (!triggersWithStates.hasOwnProperty(name)) {
                addClass(element, NG_TRIGGER_CLASSNAME);
                addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
                triggersWithStates[name] = DEFAULT_STATE_VALUE;
            }
            return function () {
                // the event listener is removed AFTER the flush has occurred such
                // that leave animations callbacks can fire (otherwise if the node
                // is removed in between then the listeners would be deregistered)
                // the event listener is removed AFTER the flush has occurred such
                // that leave animations callbacks can fire (otherwise if the node
                // is removed in between then the listeners would be deregistered)
                _this._engine.afterFlush(function () {
                    var index = listeners.indexOf(data);
                    if (index >= 0) {
                        listeners.splice(index, 1);
                    }
                    if (!_this._triggers[name]) {
                        delete triggersWithStates[name];
                    }
                });
            };
        };
        AnimationTransitionNamespace.prototype.register = function (name, ast) {
            if (this._triggers[name]) {
                // throw
                return false;
            }
            else {
                this._triggers[name] = ast;
                return true;
            }
        };
        AnimationTransitionNamespace.prototype._getTrigger = function (name) {
            var trigger$$1 = this._triggers[name];
            if (!trigger$$1) {
                throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
            }
            return trigger$$1;
        };
        AnimationTransitionNamespace.prototype.trigger = function (element, triggerName, value, defaultToFallback) {
            var _this = this;
            if (defaultToFallback === void 0) { defaultToFallback = true; }
            var trigger$$1 = this._getTrigger(triggerName);
            var player = new TransitionAnimationPlayer(this.id, triggerName, element);
            var triggersWithStates = this._engine.statesByElement.get(element);
            if (!triggersWithStates) {
                addClass(element, NG_TRIGGER_CLASSNAME);
                addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
                this._engine.statesByElement.set(element, triggersWithStates = {});
            }
            var fromState = triggersWithStates[triggerName];
            var toState = new StateValue(value, this.id);
            var isObj = value && value.hasOwnProperty('value');
            if (!isObj && fromState) {
                toState.absorbOptions(fromState.options);
            }
            triggersWithStates[triggerName] = toState;
            if (!fromState) {
                fromState = DEFAULT_STATE_VALUE;
            }
            else if (fromState === DELETED_STATE_VALUE) {
                return player;
            }
            var isRemoval = toState.value === VOID_VALUE;
            // normally this isn't reached by here, however, if an object expression
            // is passed in then it may be a new object each time. Comparing the value
            // is important since that will stay the same despite there being a new object.
            // The removal arc here is special cased because the same element is triggered
            // twice in the event that it contains animations on the outer/inner portions
            // of the host container
            if (!isRemoval && fromState.value === toState.value) {
                // this means that despite the value not changing, some inner params
                // have changed which means that the animation final styles need to be applied
                if (!objEquals(fromState.params, toState.params)) {
                    var errors = [];
                    var fromStyles_1 = trigger$$1.matchStyles(fromState.value, fromState.params, errors);
                    var toStyles_1 = trigger$$1.matchStyles(toState.value, toState.params, errors);
                    if (errors.length) {
                        this._engine.reportError(errors);
                    }
                    else {
                        this._engine.afterFlush(function () {
                            eraseStyles(element, fromStyles_1);
                            setStyles(element, toStyles_1);
                        });
                    }
                }
                return;
            }
            var playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
            playersOnElement.forEach(function (player) {
                // only remove the player if it is queued on the EXACT same trigger/namespace
                // we only also deal with queued players here because if the animation has
                // started then we want to keep the player alive until the flush happens
                // (which is where the previousPlayers are passed into the new palyer)
                if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
                    player.destroy();
                }
            });
            var transition$$1 = trigger$$1.matchTransition(fromState.value, toState.value, element, toState.params);
            var isFallbackTransition = false;
            if (!transition$$1) {
                if (!defaultToFallback)
                    return;
                transition$$1 = trigger$$1.fallbackTransition;
                isFallbackTransition = true;
            }
            this._engine.totalQueuedPlayers++;
            this._queue.push({ element: element, triggerName: triggerName, transition: transition$$1, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
            if (!isFallbackTransition) {
                addClass(element, QUEUED_CLASSNAME);
                player.onStart(function () { removeClass(element, QUEUED_CLASSNAME); });
            }
            player.onDone(function () {
                var index = _this.players.indexOf(player);
                if (index >= 0) {
                    _this.players.splice(index, 1);
                }
                var players = _this._engine.playersByElement.get(element);
                if (players) {
                    var index_1 = players.indexOf(player);
                    if (index_1 >= 0) {
                        players.splice(index_1, 1);
                    }
                }
            });
            this.players.push(player);
            playersOnElement.push(player);
            return player;
        };
        AnimationTransitionNamespace.prototype.deregister = function (name) {
            var _this = this;
            delete this._triggers[name];
            this._engine.statesByElement.forEach(function (stateMap, element) { delete stateMap[name]; });
            this._elementListeners.forEach(function (listeners, element) {
                _this._elementListeners.set(element, listeners.filter(function (entry) { return entry.name != name; }));
            });
        };
        AnimationTransitionNamespace.prototype.clearElementCache = function (element) {
            this._engine.statesByElement.delete(element);
            this._elementListeners.delete(element);
            var elementPlayers = this._engine.playersByElement.get(element);
            if (elementPlayers) {
                elementPlayers.forEach(function (player) { return player.destroy(); });
                this._engine.playersByElement.delete(element);
            }
        };
        AnimationTransitionNamespace.prototype._signalRemovalForInnerTriggers = function (rootElement, context, animate$$1) {
            var _this = this;
            if (animate$$1 === void 0) { animate$$1 = false; }
            // emulate a leave animation for all inner nodes within this node.
            // If there are no animations found for any of the nodes then clear the cache
            // for the element.
            this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(function (elm) {
                // this means that an inner remove() operation has already kicked off
                // the animation on this element...
                if (elm[REMOVAL_FLAG])
                    return;
                var namespaces = _this._engine.fetchNamespacesByElement(elm);
                if (namespaces.size) {
                    namespaces.forEach(function (ns) { return ns.triggerLeaveAnimation(elm, context, false, true); });
                }
                else {
                    _this.clearElementCache(elm);
                }
            });
        };
        AnimationTransitionNamespace.prototype.triggerLeaveAnimation = function (element, context, destroyAfterComplete, defaultToFallback) {
            var _this = this;
            var triggerStates = this._engine.statesByElement.get(element);
            if (triggerStates) {
                var players_1 = [];
                Object.keys(triggerStates).forEach(function (triggerName) {
                    // this check is here in the event that an element is removed
                    // twice (both on the host level and the component level)
                    if (_this._triggers[triggerName]) {
                        var player = _this.trigger(element, triggerName, VOID_VALUE, defaultToFallback);
                        if (player) {
                            players_1.push(player);
                        }
                    }
                });
                if (players_1.length) {
                    this._engine.markElementAsRemoved(this.id, element, true, context);
                    if (destroyAfterComplete) {
                        optimizeGroupPlayer(players_1).onDone(function () { return _this._engine.processLeaveNode(element); });
                    }
                    return true;
                }
            }
            return false;
        };
        AnimationTransitionNamespace.prototype.prepareLeaveAnimationListeners = function (element) {
            var _this = this;
            var listeners = this._elementListeners.get(element);
            if (listeners) {
                var visitedTriggers_1 = new Set();
                listeners.forEach(function (listener) {
                    var triggerName = listener.name;
                    if (visitedTriggers_1.has(triggerName))
                        return;
                    visitedTriggers_1.add(triggerName);
                    var trigger$$1 = _this._triggers[triggerName];
                    var transition$$1 = trigger$$1.fallbackTransition;
                    var elementStates = (_this._engine.statesByElement.get(element));
                    var fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
                    var toState = new StateValue(VOID_VALUE);
                    var player = new TransitionAnimationPlayer(_this.id, triggerName, element);
                    _this._engine.totalQueuedPlayers++;
                    _this._queue.push({
                        element: element,
                        triggerName: triggerName,
                        transition: transition$$1,
                        fromState: fromState,
                        toState: toState,
                        player: player,
                        isFallbackTransition: true
                    });
                });
            }
        };
        AnimationTransitionNamespace.prototype.removeNode = function (element, context) {
            var _this = this;
            var engine = this._engine;
            if (element.childElementCount) {
                this._signalRemovalForInnerTriggers(element, context, true);
            }
            // this means that a * => VOID animation was detected and kicked off
            if (this.triggerLeaveAnimation(element, context, true))
                return;
            // find the player that is animating and make sure that the
            // removal is delayed until that player has completed
            var containsPotentialParentTransition = false;
            if (engine.totalAnimations) {
                var currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
                // when this `if statement` does not continue forward it means that
                // a previous animation query has selected the current element and
                // is animating it. In this situation want to continue forwards and
                // allow the element to be queued up for animation later.
                if (currentPlayers && currentPlayers.length) {
                    containsPotentialParentTransition = true;
                }
                else {
                    var parent_1 = element;
                    while (parent_1 = parent_1.parentNode) {
                        var triggers = engine.statesByElement.get(parent_1);
                        if (triggers) {
                            containsPotentialParentTransition = true;
                            break;
                        }
                    }
                }
            }
            // at this stage we know that the element will either get removed
            // during flush or will be picked up by a parent query. Either way
            // we need to fire the listeners for this element when it DOES get
            // removed (once the query parent animation is done or after flush)
            this.prepareLeaveAnimationListeners(element);
            // whether or not a parent has an animation we need to delay the deferral of the leave
            // operation until we have more information (which we do after flush() has been called)
            if (containsPotentialParentTransition) {
                engine.markElementAsRemoved(this.id, element, false, context);
            }
            else {
                // we do this after the flush has occurred such
                // that the callbacks can be fired
                engine.afterFlush(function () { return _this.clearElementCache(element); });
                engine.destroyInnerAnimations(element);
                engine._onRemovalComplete(element, context);
            }
        };
        AnimationTransitionNamespace.prototype.insertNode = function (element, parent) { addClass(element, this._hostClassName); };
        AnimationTransitionNamespace.prototype.drainQueuedTransitions = function (microtaskId) {
            var _this = this;
            var instructions = [];
            this._queue.forEach(function (entry) {
                var player = entry.player;
                if (player.destroyed)
                    return;
                var element = entry.element;
                var listeners = _this._elementListeners.get(element);
                if (listeners) {
                    listeners.forEach(function (listener) {
                        if (listener.name == entry.triggerName) {
                            var baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
                            baseEvent['_data'] = microtaskId;
                            listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
                        }
                    });
                }
                if (player.markedForDestroy) {
                    _this._engine.afterFlush(function () {
                        // now we can destroy the element properly since the event listeners have
                        // been bound to the player
                        player.destroy();
                    });
                }
                else {
                    instructions.push(entry);
                }
            });
            this._queue = [];
            return instructions.sort(function (a, b) {
                // if depCount == 0 them move to front
                // otherwise if a contains b then move back
                var d0 = a.transition.ast.depCount;
                var d1 = b.transition.ast.depCount;
                if (d0 == 0 || d1 == 0) {
                    return d0 - d1;
                }
                return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
            });
        };
        AnimationTransitionNamespace.prototype.destroy = function (context) {
            this.players.forEach(function (p) { return p.destroy(); });
            this._signalRemovalForInnerTriggers(this.hostElement, context);
        };
        AnimationTransitionNamespace.prototype.elementContainsData = function (element) {
            var containsData = false;
            if (this._elementListeners.has(element))
                containsData = true;
            containsData =
                (this._queue.find(function (entry) { return entry.element === element; }) ? true : false) || containsData;
            return containsData;
        };
        return AnimationTransitionNamespace;
    }());
    var TransitionAnimationEngine = /** @class */ (function () {
        function TransitionAnimationEngine(driver, _normalizer) {
            this.driver = driver;
            this._normalizer = _normalizer;
            this.players = [];
            this.newHostElements = new Map();
            this.playersByElement = new Map();
            this.playersByQueriedElement = new Map();
            this.statesByElement = new Map();
            this.disabledNodes = new Set();
            this.totalAnimations = 0;
            this.totalQueuedPlayers = 0;
            this._namespaceLookup = {};
            this._namespaceList = [];
            this._flushFns = [];
            this._whenQuietFns = [];
            this.namespacesByHostElement = new Map();
            this.collectedEnterElements = [];
            this.collectedLeaveElements = [];
            // this method is designed to be overridden by the code that uses this engine
            this.onRemovalComplete = function (element, context) { };
        }
        /** @internal */
        /** @internal */
        TransitionAnimationEngine.prototype._onRemovalComplete = /** @internal */
        function (element, context) { this.onRemovalComplete(element, context); };
        Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
            get: function () {
                var players = [];
                this._namespaceList.forEach(function (ns) {
                    ns.players.forEach(function (player) {
                        if (player.queued) {
                            players.push(player);
                        }
                    });
                });
                return players;
            },
            enumerable: true,
            configurable: true
        });
        TransitionAnimationEngine.prototype.createNamespace = function (namespaceId, hostElement) {
            var ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
            if (hostElement.parentNode) {
                this._balanceNamespaceList(ns, hostElement);
            }
            else {
                // defer this later until flush during when the host element has
                // been inserted so that we know exactly where to place it in
                // the namespace list
                this.newHostElements.set(hostElement, ns);
                // given that this host element is apart of the animation code, it
                // may or may not be inserted by a parent node that is an of an
                // animation renderer type. If this happens then we can still have
                // access to this item when we query for :enter nodes. If the parent
                // is a renderer then the set data-structure will normalize the entry
                this.collectEnterElement(hostElement);
            }
            return this._namespaceLookup[namespaceId] = ns;
        };
        TransitionAnimationEngine.prototype._balanceNamespaceList = function (ns, hostElement) {
            var limit = this._namespaceList.length - 1;
            if (limit >= 0) {
                var found = false;
                for (var i = limit; i >= 0; i--) {
                    var nextNamespace = this._namespaceList[i];
                    if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
                        this._namespaceList.splice(i + 1, 0, ns);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this._namespaceList.splice(0, 0, ns);
                }
            }
            else {
                this._namespaceList.push(ns);
            }
            this.namespacesByHostElement.set(hostElement, ns);
            return ns;
        };
        TransitionAnimationEngine.prototype.register = function (namespaceId, hostElement) {
            var ns = this._namespaceLookup[namespaceId];
            if (!ns) {
                ns = this.createNamespace(namespaceId, hostElement);
            }
            return ns;
        };
        TransitionAnimationEngine.prototype.registerTrigger = function (namespaceId, name, trigger$$1) {
            var ns = this._namespaceLookup[namespaceId];
            if (ns && ns.register(name, trigger$$1)) {
                this.totalAnimations++;
            }
        };
        TransitionAnimationEngine.prototype.destroy = function (namespaceId, context) {
            var _this = this;
            if (!namespaceId)
                return;
            var ns = this._fetchNamespace(namespaceId);
            this.afterFlush(function () {
                _this.namespacesByHostElement.delete(ns.hostElement);
                delete _this._namespaceLookup[namespaceId];
                var index = _this._namespaceList.indexOf(ns);
                if (index >= 0) {
                    _this._namespaceList.splice(index, 1);
                }
            });
            this.afterFlushAnimationsDone(function () { return ns.destroy(context); });
        };
        TransitionAnimationEngine.prototype._fetchNamespace = function (id) { return this._namespaceLookup[id]; };
        TransitionAnimationEngine.prototype.fetchNamespacesByElement = function (element) {
            // normally there should only be one namespace per element, however
            // if @triggers are placed on both the component element and then
            // its host element (within the component code) then there will be
            // two namespaces returned. We use a set here to simply the dedupe
            // of namespaces incase there are multiple triggers both the elm and host
            var namespaces = new Set();
            var elementStates = this.statesByElement.get(element);
            if (elementStates) {
                var keys = Object.keys(elementStates);
                for (var i = 0; i < keys.length; i++) {
                    var nsId = elementStates[keys[i]].namespaceId;
                    if (nsId) {
                        var ns = this._fetchNamespace(nsId);
                        if (ns) {
                            namespaces.add(ns);
                        }
                    }
                }
            }
            return namespaces;
        };
        TransitionAnimationEngine.prototype.trigger = function (namespaceId, element, name, value) {
            if (isElementNode(element)) {
                this._fetchNamespace(namespaceId).trigger(element, name, value);
                return true;
            }
            return false;
        };
        TransitionAnimationEngine.prototype.insertNode = function (namespaceId, element, parent, insertBefore) {
            if (!isElementNode(element))
                return;
            // special case for when an element is removed and reinserted (move operation)
            // when this occurs we do not want to use the element for deletion later
            var details = element[REMOVAL_FLAG];
            if (details && details.setForRemoval) {
                details.setForRemoval = false;
            }
            // in the event that the namespaceId is blank then the caller
            // code does not contain any animation code in it, but it is
            // just being called so that the node is marked as being inserted
            if (namespaceId) {
                var ns = this._fetchNamespace(namespaceId);
                // This if-statement is a workaround for router issue #21947.
                // The router sometimes hits a race condition where while a route
                // is being instantiated a new navigation arrives, triggering leave
                // animation of DOM that has not been fully initialized, until this
                // is resolved, we need to handle the scenario when DOM is not in a
                // consistent state during the animation.
                if (ns) {
                    ns.insertNode(element, parent);
                }
            }
            // only *directives and host elements are inserted before
            if (insertBefore) {
                this.collectEnterElement(element);
            }
        };
        TransitionAnimationEngine.prototype.collectEnterElement = function (element) { this.collectedEnterElements.push(element); };
        TransitionAnimationEngine.prototype.markElementAsDisabled = function (element, value) {
            if (value) {
                if (!this.disabledNodes.has(element)) {
                    this.disabledNodes.add(element);
                    addClass(element, DISABLED_CLASSNAME);
                }
            }
            else if (this.disabledNodes.has(element)) {
                this.disabledNodes.delete(element);
                removeClass(element, DISABLED_CLASSNAME);
            }
        };
        TransitionAnimationEngine.prototype.removeNode = function (namespaceId, element, context) {
            if (!isElementNode(element)) {
                this._onRemovalComplete(element, context);
                return;
            }
            var ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
            if (ns) {
                ns.removeNode(element, context);
            }
            else {
                this.markElementAsRemoved(namespaceId, element, false, context);
            }
        };
        TransitionAnimationEngine.prototype.markElementAsRemoved = function (namespaceId, element, hasAnimation, context) {
            this.collectedLeaveElements.push(element);
            element[REMOVAL_FLAG] = {
                namespaceId: namespaceId,
                setForRemoval: context, hasAnimation: hasAnimation,
                removedBeforeQueried: false
            };
        };
        TransitionAnimationEngine.prototype.listen = function (namespaceId, element, name, phase, callback) {
            if (isElementNode(element)) {
                return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
            }
            return function () { };
        };
        TransitionAnimationEngine.prototype._buildInstruction = function (entry, subTimelines, enterClassName, leaveClassName) {
            return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, enterClassName, leaveClassName, entry.fromState.options, entry.toState.options, subTimelines);
        };
        TransitionAnimationEngine.prototype.destroyInnerAnimations = function (containerElement) {
            var _this = this;
            var elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
            elements.forEach(function (element) { return _this.destroyActiveAnimationsForElement(element); });
            if (this.playersByQueriedElement.size == 0)
                return;
            elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
            elements.forEach(function (element) { return _this.finishActiveQueriedAnimationOnElement(element); });
        };
        TransitionAnimationEngine.prototype.destroyActiveAnimationsForElement = function (element) {
            var players = this.playersByElement.get(element);
            if (players) {
                players.forEach(function (player) {
                    // special case for when an element is set for destruction, but hasn't started.
                    // in this situation we want to delay the destruction until the flush occurs
                    // so that any event listeners attached to the player are triggered.
                    if (player.queued) {
                        player.markedForDestroy = true;
                    }
                    else {
                        player.destroy();
                    }
                });
            }
            var stateMap = this.statesByElement.get(element);
            if (stateMap) {
                Object.keys(stateMap).forEach(function (triggerName) { return stateMap[triggerName] = DELETED_STATE_VALUE; });
            }
        };
        TransitionAnimationEngine.prototype.finishActiveQueriedAnimationOnElement = function (element) {
            var players = this.playersByQueriedElement.get(element);
            if (players) {
                players.forEach(function (player) { return player.finish(); });
            }
        };
        TransitionAnimationEngine.prototype.whenRenderingDone = function () {
            var _this = this;
            return new Promise(function (resolve) {
                if (_this.players.length) {
                    return optimizeGroupPlayer(_this.players).onDone(function () { return resolve(); });
                }
                else {
                    resolve();
                }
            });
        };
        TransitionAnimationEngine.prototype.processLeaveNode = function (element) {
            var _this = this;
            var details = element[REMOVAL_FLAG];
            if (details && details.setForRemoval) {
                // this will prevent it from removing it twice
                element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
                if (details.namespaceId) {
                    this.destroyInnerAnimations(element);
                    var ns = this._fetchNamespace(details.namespaceId);
                    if (ns) {
                        ns.clearElementCache(element);
                    }
                }
                this._onRemovalComplete(element, details.setForRemoval);
            }
            if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
                this.markElementAsDisabled(element, false);
            }
            this.driver.query(element, DISABLED_SELECTOR, true).forEach(function (node) {
                _this.markElementAsDisabled(element, false);
            });
        };
        TransitionAnimationEngine.prototype.flush = function (microtaskId) {
            var _this = this;
            if (microtaskId === void 0) { microtaskId = -1; }
            var players = [];
            if (this.newHostElements.size) {
                this.newHostElements.forEach(function (ns, element) { return _this._balanceNamespaceList(ns, element); });
                this.newHostElements.clear();
            }
            if (this.totalAnimations && this.collectedEnterElements.length) {
                for (var i = 0; i < this.collectedEnterElements.length; i++) {
                    var elm = this.collectedEnterElements[i];
                    addClass(elm, STAR_CLASSNAME);
                }
            }
            if (this._namespaceList.length &&
                (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
                var cleanupFns = [];
                try {
                    players = this._flushAnimations(cleanupFns, microtaskId);
                }
                finally {
                    for (var i = 0; i < cleanupFns.length; i++) {
                        cleanupFns[i]();
                    }
                }
            }
            else {
                for (var i = 0; i < this.collectedLeaveElements.length; i++) {
                    var element = this.collectedLeaveElements[i];
                    this.processLeaveNode(element);
                }
            }
            this.totalQueuedPlayers = 0;
            this.collectedEnterElements.length = 0;
            this.collectedLeaveElements.length = 0;
            this._flushFns.forEach(function (fn) { return fn(); });
            this._flushFns = [];
            if (this._whenQuietFns.length) {
                // we move these over to a variable so that
                // if any new callbacks are registered in another
                // flush they do not populate the existing set
                var quietFns_1 = this._whenQuietFns;
                this._whenQuietFns = [];
                if (players.length) {
                    optimizeGroupPlayer(players).onDone(function () { quietFns_1.forEach(function (fn) { return fn(); }); });
                }
                else {
                    quietFns_1.forEach(function (fn) { return fn(); });
                }
            }
        };
        TransitionAnimationEngine.prototype.reportError = function (errors) {
            throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join('\n'));
        };
        TransitionAnimationEngine.prototype._flushAnimations = function (cleanupFns, microtaskId) {
            var _this = this;
            var subTimelines = new ElementInstructionMap();
            var skippedPlayers = [];
            var skippedPlayersMap = new Map();
            var queuedInstructions = [];
            var queriedElements = new Map();
            var allPreStyleElements = new Map();
            var allPostStyleElements = new Map();
            var disabledElementsSet = new Set();
            this.disabledNodes.forEach(function (node) {
                disabledElementsSet.add(node);
                var nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
                for (var i_1 = 0; i_1 < nodesThatAreDisabled.length; i_1++) {
                    disabledElementsSet.add(nodesThatAreDisabled[i_1]);
                }
            });
            var bodyNode = getBodyNode();
            var allTriggerElements = Array.from(this.statesByElement.keys());
            var enterNodeMap = buildRootMap(allTriggerElements, this.collectedEnterElements);
            // this must occur before the instructions are built below such that
            // the :enter queries match the elements (since the timeline queries
            // are fired during instruction building).
            var enterNodeMapIds = new Map();
            var i = 0;
            enterNodeMap.forEach(function (nodes, root) {
                var className = ENTER_CLASSNAME + i++;
                enterNodeMapIds.set(root, className);
                nodes.forEach(function (node) { return addClass(node, className); });
            });
            var allLeaveNodes = [];
            var mergedLeaveNodes = new Set();
            var leaveNodesWithoutAnimations = new Set();
            for (var i_2 = 0; i_2 < this.collectedLeaveElements.length; i_2++) {
                var element = this.collectedLeaveElements[i_2];
                var details = element[REMOVAL_FLAG];
                if (details && details.setForRemoval) {
                    allLeaveNodes.push(element);
                    mergedLeaveNodes.add(element);
                    if (details.hasAnimation) {
                        this.driver.query(element, STAR_SELECTOR, true).forEach(function (elm) { return mergedLeaveNodes.add(elm); });
                    }
                    else {
                        leaveNodesWithoutAnimations.add(element);
                    }
                }
            }
            var leaveNodeMapIds = new Map();
            var leaveNodeMap = buildRootMap(allTriggerElements, Array.from(mergedLeaveNodes));
            leaveNodeMap.forEach(function (nodes, root) {
                var className = LEAVE_CLASSNAME + i++;
                leaveNodeMapIds.set(root, className);
                nodes.forEach(function (node) { return addClass(node, className); });
            });
            cleanupFns.push(function () {
                enterNodeMap.forEach(function (nodes, root) {
                    var className = (enterNodeMapIds.get(root));
                    nodes.forEach(function (node) { return removeClass(node, className); });
                });
                leaveNodeMap.forEach(function (nodes, root) {
                    var className = (leaveNodeMapIds.get(root));
                    nodes.forEach(function (node) { return removeClass(node, className); });
                });
                allLeaveNodes.forEach(function (element) { _this.processLeaveNode(element); });
            });
            var allPlayers = [];
            var erroneousTransitions = [];
            for (var i_3 = this._namespaceList.length - 1; i_3 >= 0; i_3--) {
                var ns = this._namespaceList[i_3];
                ns.drainQueuedTransitions(microtaskId).forEach(function (entry) {
                    var player = entry.player;
                    allPlayers.push(player);
                    var element = entry.element;
                    if (!bodyNode || !_this.driver.containsElement(bodyNode, element)) {
                        player.destroy();
                        return;
                    }
                    var leaveClassName = (leaveNodeMapIds.get(element));
                    var enterClassName = (enterNodeMapIds.get(element));
                    var instruction = (_this._buildInstruction(entry, subTimelines, enterClassName, leaveClassName));
                    if (instruction.errors && instruction.errors.length) {
                        erroneousTransitions.push(instruction);
                        return;
                    }
                    // if a unmatched transition is queued to go then it SHOULD NOT render
                    // an animation and cancel the previously running animations.
                    if (entry.isFallbackTransition) {
                        player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                        player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                        skippedPlayers.push(player);
                        return;
                    }
                    // this means that if a parent animation uses this animation as a sub trigger
                    // then it will instruct the timeline builder to not add a player delay, but
                    // instead stretch the first keyframe gap up until the animation starts. The
                    // reason this is important is to prevent extra initialization styles from being
                    // required by the user in the animation.
                    instruction.timelines.forEach(function (tl) { return tl.stretchStartingKeyframe = true; });
                    subTimelines.append(element, instruction.timelines);
                    var tuple = { instruction: instruction, player: player, element: element };
                    queuedInstructions.push(tuple);
                    instruction.queriedElements.forEach(function (element) { return getOrSetAsInMap(queriedElements, element, []).push(player); });
                    instruction.preStyleProps.forEach(function (stringMap, element) {
                        var props = Object.keys(stringMap);
                        if (props.length) {
                            var setVal_1 = (allPreStyleElements.get(element));
                            if (!setVal_1) {
                                allPreStyleElements.set(element, setVal_1 = new Set());
                            }
                            props.forEach(function (prop) { return setVal_1.add(prop); });
                        }
                    });
                    instruction.postStyleProps.forEach(function (stringMap, element) {
                        var props = Object.keys(stringMap);
                        var setVal = (allPostStyleElements.get(element));
                        if (!setVal) {
                            allPostStyleElements.set(element, setVal = new Set());
                        }
                        props.forEach(function (prop) { return setVal.add(prop); });
                    });
                });
            }
            if (erroneousTransitions.length) {
                var errors_1 = [];
                erroneousTransitions.forEach(function (instruction) {
                    errors_1.push("@" + instruction.triggerName + " has failed due to:\n");
                    instruction.errors.forEach(function (error) { return errors_1.push("- " + error + "\n"); });
                });
                allPlayers.forEach(function (player) { return player.destroy(); });
                this.reportError(errors_1);
            }
            var allPreviousPlayersMap = new Map();
            // this map works to tell which element in the DOM tree is contained by
            // which animation. Further down below this map will get populated once
            // the players are built and in doing so it can efficiently figure out
            // if a sub player is skipped due to a parent player having priority.
            var animationElementMap = new Map();
            queuedInstructions.forEach(function (entry) {
                var element = entry.element;
                if (subTimelines.has(element)) {
                    animationElementMap.set(element, element);
                    _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
                }
            });
            skippedPlayers.forEach(function (player) {
                var element = player.element;
                var previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
                previousPlayers.forEach(function (prevPlayer) {
                    getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
                    prevPlayer.destroy();
                });
            });
            // this is a special case for nodes that will be removed (either by)
            // having their own leave animations or by being queried in a container
            // that will be removed once a parent animation is complete. The idea
            // here is that * styles must be identical to ! styles because of
            // backwards compatibility (* is also filled in by default in many places).
            // Otherwise * styles will return an empty value or auto since the element
            // that is being getComputedStyle'd will not be visible (since * = destination)
            var replaceNodes = allLeaveNodes.filter(function (node) {
                return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
            });
            // POST STAGE: fill the * styles
            var postStylesMap = new Map();
            var allLeaveQueriedNodes = cloakAndComputeStyles(postStylesMap, this.driver, leaveNodesWithoutAnimations, allPostStyleElements, AUTO_STYLE);
            allLeaveQueriedNodes.forEach(function (node) {
                if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
                    replaceNodes.push(node);
                }
            });
            // PRE STAGE: fill the ! styles
            var preStylesMap = new Map();
            enterNodeMap.forEach(function (nodes, root) {
                cloakAndComputeStyles(preStylesMap, _this.driver, new Set(nodes), allPreStyleElements, ɵPRE_STYLE);
            });
            replaceNodes.forEach(function (node) {
                var post = postStylesMap.get(node);
                var pre = preStylesMap.get(node);
                postStylesMap.set(node, __assign({}, post, pre));
            });
            var rootPlayers = [];
            var subPlayers = [];
            var NO_PARENT_ANIMATION_ELEMENT_DETECTED = {};
            queuedInstructions.forEach(function (entry) {
                var element = entry.element, player = entry.player, instruction = entry.instruction;
                // this means that it was never consumed by a parent animation which
                // means that it is independent and therefore should be set for animation
                if (subTimelines.has(element)) {
                    if (disabledElementsSet.has(element)) {
                        player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                        player.disabled = true;
                        player.overrideTotalTime(instruction.totalTime);
                        skippedPlayers.push(player);
                        return;
                    }
                    // this will flow up the DOM and query the map to figure out
                    // if a parent animation has priority over it. In the situation
                    // that a parent is detected then it will cancel the loop. If
                    // nothing is detected, or it takes a few hops to find a parent,
                    // then it will fill in the missing nodes and signal them as having
                    // a detected parent (or a NO_PARENT value via a special constant).
                    var parentWithAnimation_1 = NO_PARENT_ANIMATION_ELEMENT_DETECTED;
                    if (animationElementMap.size > 1) {
                        var elm = element;
                        var parentsToAdd = [];
                        while (elm = elm.parentNode) {
                            var detectedParent = animationElementMap.get(elm);
                            if (detectedParent) {
                                parentWithAnimation_1 = detectedParent;
                                break;
                            }
                            parentsToAdd.push(elm);
                        }
                        parentsToAdd.forEach(function (parent) { return animationElementMap.set(parent, parentWithAnimation_1); });
                    }
                    var innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
                    player.setRealPlayer(innerPlayer);
                    if (parentWithAnimation_1 === NO_PARENT_ANIMATION_ELEMENT_DETECTED) {
                        rootPlayers.push(player);
                    }
                    else {
                        var parentPlayers = _this.playersByElement.get(parentWithAnimation_1);
                        if (parentPlayers && parentPlayers.length) {
                            player.parentPlayer = optimizeGroupPlayer(parentPlayers);
                        }
                        skippedPlayers.push(player);
                    }
                }
                else {
                    eraseStyles(element, instruction.fromStyles);
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    // there still might be a ancestor player animating this
                    // element therefore we will still add it as a sub player
                    // even if its animation may be disabled
                    subPlayers.push(player);
                    if (disabledElementsSet.has(element)) {
                        skippedPlayers.push(player);
                    }
                }
            });
            // find all of the sub players' corresponding inner animation player
            subPlayers.forEach(function (player) {
                // even if any players are not found for a sub animation then it
                // will still complete itself after the next tick since it's Noop
                var playersForElement = skippedPlayersMap.get(player.element);
                if (playersForElement && playersForElement.length) {
                    var innerPlayer = optimizeGroupPlayer(playersForElement);
                    player.setRealPlayer(innerPlayer);
                }
            });
            // the reason why we don't actually play the animation is
            // because all that a skipped player is designed to do is to
            // fire the start/done transition callback events
            skippedPlayers.forEach(function (player) {
                if (player.parentPlayer) {
                    player.syncPlayerEvents(player.parentPlayer);
                }
                else {
                    player.destroy();
                }
            });
            // run through all of the queued removals and see if they
            // were picked up by a query. If not then perform the removal
            // operation right away unless a parent animation is ongoing.
            for (var i_4 = 0; i_4 < allLeaveNodes.length; i_4++) {
                var element = allLeaveNodes[i_4];
                var details = element[REMOVAL_FLAG];
                removeClass(element, LEAVE_CLASSNAME);
                // this means the element has a removal animation that is being
                // taken care of and therefore the inner elements will hang around
                // until that animation is over (or the parent queried animation)
                if (details && details.hasAnimation)
                    continue;
                var players = [];
                // if this element is queried or if it contains queried children
                // then we want for the element not to be removed from the page
                // until the queried animations have finished
                if (queriedElements.size) {
                    var queriedPlayerResults = queriedElements.get(element);
                    if (queriedPlayerResults && queriedPlayerResults.length) {
                        players.push.apply(players, __spread(queriedPlayerResults));
                    }
                    var queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
                    for (var j = 0; j < queriedInnerElements.length; j++) {
                        var queriedPlayers = queriedElements.get(queriedInnerElements[j]);
                        if (queriedPlayers && queriedPlayers.length) {
                            players.push.apply(players, __spread(queriedPlayers));
                        }
                    }
                }
                var activePlayers = players.filter(function (p) { return !p.destroyed; });
                if (activePlayers.length) {
                    removeNodesAfterAnimationDone(this, element, activePlayers);
                }
                else {
                    this.processLeaveNode(element);
                }
            }
            // this is required so the cleanup method doesn't remove them
            allLeaveNodes.length = 0;
            rootPlayers.forEach(function (player) {
                _this.players.push(player);
                player.onDone(function () {
                    player.destroy();
                    var index = _this.players.indexOf(player);
                    _this.players.splice(index, 1);
                });
                player.play();
            });
            return rootPlayers;
        };
        TransitionAnimationEngine.prototype.elementContainsData = function (namespaceId, element) {
            var containsData = false;
            var details = element[REMOVAL_FLAG];
            if (details && details.setForRemoval)
                containsData = true;
            if (this.playersByElement.has(element))
                containsData = true;
            if (this.playersByQueriedElement.has(element))
                containsData = true;
            if (this.statesByElement.has(element))
                containsData = true;
            return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
        };
        TransitionAnimationEngine.prototype.afterFlush = function (callback) { this._flushFns.push(callback); };
        TransitionAnimationEngine.prototype.afterFlushAnimationsDone = function (callback) { this._whenQuietFns.push(callback); };
        TransitionAnimationEngine.prototype._getPreviousPlayers = function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
            var players = [];
            if (isQueriedElement) {
                var queriedElementPlayers = this.playersByQueriedElement.get(element);
                if (queriedElementPlayers) {
                    players = queriedElementPlayers;
                }
            }
            else {
                var elementPlayers = this.playersByElement.get(element);
                if (elementPlayers) {
                    var isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
                    elementPlayers.forEach(function (player) {
                        if (player.queued)
                            return;
                        if (!isRemovalAnimation_1 && player.triggerName != triggerName)
                            return;
                        players.push(player);
                    });
                }
            }
            if (namespaceId || triggerName) {
                players = players.filter(function (player) {
                    if (namespaceId && namespaceId != player.namespaceId)
                        return false;
                    if (triggerName && triggerName != player.triggerName)
                        return false;
                    return true;
                });
            }
            return players;
        };
        TransitionAnimationEngine.prototype._beforeAnimationBuild = function (namespaceId, instruction, allPreviousPlayersMap) {
            var triggerName = instruction.triggerName;
            var rootElement = instruction.element;
            // when a removal animation occurs, ALL previous players are collected
            // and destroyed (even if they are outside of the current namespace)
            var targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
            var targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
            var _loop_1 = function (timelineInstruction) {
                var element = timelineInstruction.element;
                var isQueriedElement = element !== rootElement;
                var players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
                var previousPlayers = this_1._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
                previousPlayers.forEach(function (player) {
                    var realPlayer = player.getRealPlayer();
                    if (realPlayer.beforeDestroy) {
                        realPlayer.beforeDestroy();
                    }
                    player.destroy();
                    players.push(player);
                });
            };
            var this_1 = this;
            try {
                for (var _a = __values(instruction.timelines), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var timelineInstruction = _b.value;
                    _loop_1(timelineInstruction);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // this needs to be done so that the PRE/POST styles can be
            // computed properly without interfering with the previous animation
            eraseStyles(rootElement, instruction.fromStyles);
            var e_1, _c;
        };
        TransitionAnimationEngine.prototype._buildAnimation = function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
            var _this = this;
            var triggerName = instruction.triggerName;
            var rootElement = instruction.element;
            // we first run this so that the previous animation player
            // data can be passed into the successive animation players
            var allQueriedPlayers = [];
            var allConsumedElements = new Set();
            var allSubElements = new Set();
            var allNewPlayers = instruction.timelines.map(function (timelineInstruction) {
                var element = timelineInstruction.element;
                allConsumedElements.add(element);
                // FIXME (matsko): make sure to-be-removed animations are removed properly
                var details = element[REMOVAL_FLAG];
                if (details && details.removedBeforeQueried)
                    return new NoopAnimationPlayer(timelineInstruction.duration, timelineInstruction.delay);
                var isQueriedElement = element !== rootElement;
                var previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
                    .map(function (p) { return p.getRealPlayer(); }))
                    .filter(function (p) {
                    // the `element` is not apart of the AnimationPlayer definition, but
                    // Mock/WebAnimations
                    // use the element within their implementation. This will be added in Angular5 to
                    // AnimationPlayer
                    var pp = p;
                    return pp.element ? pp.element === element : false;
                });
                var preStyles = preStylesMap.get(element);
                var postStyles = postStylesMap.get(element);
                var keyframes$$1 = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
                var player = _this._buildPlayer(timelineInstruction, keyframes$$1, previousPlayers);
                // this means that this particular player belongs to a sub trigger. It is
                // important that we match this player up with the corresponding (@trigger.listener)
                if (timelineInstruction.subTimeline && skippedPlayersMap) {
                    allSubElements.add(element);
                }
                if (isQueriedElement) {
                    var wrappedPlayer = new TransitionAnimationPlayer(namespaceId, triggerName, element);
                    wrappedPlayer.setRealPlayer(player);
                    allQueriedPlayers.push(wrappedPlayer);
                }
                return player;
            });
            allQueriedPlayers.forEach(function (player) {
                getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
                player.onDone(function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); });
            });
            allConsumedElements.forEach(function (element) { return addClass(element, NG_ANIMATING_CLASSNAME); });
            var player = optimizeGroupPlayer(allNewPlayers);
            player.onDestroy(function () {
                allConsumedElements.forEach(function (element) { return removeClass(element, NG_ANIMATING_CLASSNAME); });
                setStyles(rootElement, instruction.toStyles);
            });
            // this basically makes all of the callbacks for sub element animations
            // be dependent on the upper players for when they finish
            allSubElements.forEach(function (element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); });
            return player;
        };
        TransitionAnimationEngine.prototype._buildPlayer = function (instruction, keyframes$$1, previousPlayers) {
            if (keyframes$$1.length > 0) {
                return this.driver.animate(instruction.element, keyframes$$1, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
            }
            // special case for when an empty transition|definition is provided
            // ... there is no point in rendering an empty animation
            return new NoopAnimationPlayer(instruction.duration, instruction.delay);
        };
        return TransitionAnimationEngine;
    }());
    var TransitionAnimationPlayer = /** @class */ (function () {
        function TransitionAnimationPlayer(namespaceId, triggerName, element) {
            this.namespaceId = namespaceId;
            this.triggerName = triggerName;
            this.element = element;
            this._player = new NoopAnimationPlayer();
            this._containsRealPlayer = false;
            this._queuedCallbacks = {};
            this.destroyed = false;
            this.markedForDestroy = false;
            this.disabled = false;
            this.queued = true;
            this.totalTime = 0;
        }
        TransitionAnimationPlayer.prototype.setRealPlayer = function (player) {
            var _this = this;
            if (this._containsRealPlayer)
                return;
            this._player = player;
            Object.keys(this._queuedCallbacks).forEach(function (phase) {
                _this._queuedCallbacks[phase].forEach(function (callback) { return listenOnPlayer(player, phase, undefined, callback); });
            });
            this._queuedCallbacks = {};
            this._containsRealPlayer = true;
            this.overrideTotalTime(player.totalTime);
            this.queued = false;
        };
        TransitionAnimationPlayer.prototype.getRealPlayer = function () { return this._player; };
        TransitionAnimationPlayer.prototype.overrideTotalTime = function (totalTime) { this.totalTime = totalTime; };
        TransitionAnimationPlayer.prototype.syncPlayerEvents = function (player) {
            var _this = this;
            var p = this._player;
            if (p.triggerCallback) {
                player.onStart(function () { return p.triggerCallback('start'); });
            }
            player.onDone(function () { return _this.finish(); });
            player.onDestroy(function () { return _this.destroy(); });
        };
        TransitionAnimationPlayer.prototype._queueEvent = function (name, callback) {
            getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
        };
        TransitionAnimationPlayer.prototype.onDone = function (fn) {
            if (this.queued) {
                this._queueEvent('done', fn);
            }
            this._player.onDone(fn);
        };
        TransitionAnimationPlayer.prototype.onStart = function (fn) {
            if (this.queued) {
                this._queueEvent('start', fn);
            }
            this._player.onStart(fn);
        };
        TransitionAnimationPlayer.prototype.onDestroy = function (fn) {
            if (this.queued) {
                this._queueEvent('destroy', fn);
            }
            this._player.onDestroy(fn);
        };
        TransitionAnimationPlayer.prototype.init = function () { this._player.init(); };
        TransitionAnimationPlayer.prototype.hasStarted = function () { return this.queued ? false : this._player.hasStarted(); };
        TransitionAnimationPlayer.prototype.play = function () { !this.queued && this._player.play(); };
        TransitionAnimationPlayer.prototype.pause = function () { !this.queued && this._player.pause(); };
        TransitionAnimationPlayer.prototype.restart = function () { !this.queued && this._player.restart(); };
        TransitionAnimationPlayer.prototype.finish = function () { this._player.finish(); };
        TransitionAnimationPlayer.prototype.destroy = function () {
            this.destroyed = true;
            this._player.destroy();
        };
        TransitionAnimationPlayer.prototype.reset = function () { !this.queued && this._player.reset(); };
        TransitionAnimationPlayer.prototype.setPosition = function (p) {
            if (!this.queued) {
                this._player.setPosition(p);
            }
        };
        TransitionAnimationPlayer.prototype.getPosition = function () { return this.queued ? 0 : this._player.getPosition(); };
        /* @internal */
        /* @internal */
        TransitionAnimationPlayer.prototype.triggerCallback = /* @internal */
        function (phaseName) {
            var p = this._player;
            if (p.triggerCallback) {
                p.triggerCallback(phaseName);
            }
        };
        return TransitionAnimationPlayer;
    }());
    function deleteOrUnsetInMap(map, key, value) {
        var currentValues;
        if (map instanceof Map) {
            currentValues = map.get(key);
            if (currentValues) {
                if (currentValues.length) {
                    var index = currentValues.indexOf(value);
                    currentValues.splice(index, 1);
                }
                if (currentValues.length == 0) {
                    map.delete(key);
                }
            }
        }
        else {
            currentValues = map[key];
            if (currentValues) {
                if (currentValues.length) {
                    var index = currentValues.indexOf(value);
                    currentValues.splice(index, 1);
                }
                if (currentValues.length == 0) {
                    delete map[key];
                }
            }
        }
        return currentValues;
    }
    function normalizeTriggerValue(value) {
        // we use `!= null` here because it's the most simple
        // way to test against a "falsy" value without mixing
        // in empty strings or a zero value. DO NOT OPTIMIZE.
        return value != null ? value : null;
    }
    function isElementNode(node) {
        return node && node['nodeType'] === 1;
    }
    function isTriggerEventValid(eventName) {
        return eventName == 'start' || eventName == 'done';
    }
    function cloakElement(element, value) {
        var oldValue = element.style.display;
        element.style.display = value != null ? value : 'none';
        return oldValue;
    }
    function cloakAndComputeStyles(valuesMap, driver, elements, elementPropsMap, defaultStyle) {
        var cloakVals = [];
        elements.forEach(function (element) { return cloakVals.push(cloakElement(element)); });
        var failedElements = [];
        elementPropsMap.forEach(function (props, element) {
            var styles = {};
            props.forEach(function (prop) {
                var value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
                // there is no easy way to detect this because a sub element could be removed
                // by a parent animation element being detached.
                if (!value || value.length == 0) {
                    element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
                    failedElements.push(element);
                }
            });
            valuesMap.set(element, styles);
        });
        // we use a index variable here since Set.forEach(a, i) does not return
        // an index value for the closure (but instead just the value)
        var i = 0;
        elements.forEach(function (element) { return cloakElement(element, cloakVals[i++]); });
        return failedElements;
    }
    /*
    Since the Angular renderer code will return a collection of inserted
    nodes in all areas of a DOM tree, it's up to this algorithm to figure
    out which nodes are roots for each animation @trigger.

    By placing each inserted node into a Set and traversing upwards, it
    is possible to find the @trigger elements and well any direct *star
    insertion nodes, if a @trigger root is found then the enter element
    is placed into the Map[@trigger] spot.
     */
    function buildRootMap(roots, nodes) {
        var rootMap = new Map();
        roots.forEach(function (root) { return rootMap.set(root, []); });
        if (nodes.length == 0)
            return rootMap;
        var NULL_NODE = 1;
        var nodeSet = new Set(nodes);
        var localRootMap = new Map();
        function getRoot(node) {
            if (!node)
                return NULL_NODE;
            var root = localRootMap.get(node);
            if (root)
                return root;
            var parent = node.parentNode;
            if (rootMap.has(parent)) {
                // ngIf inside @trigger
                root = parent;
            }
            else if (nodeSet.has(parent)) {
                // ngIf inside ngIf
                root = NULL_NODE;
            }
            else {
                // recurse upwards
                root = getRoot(parent);
            }
            localRootMap.set(node, root);
            return root;
        }
        nodes.forEach(function (node) {
            var root = getRoot(node);
            if (root !== NULL_NODE) {
                rootMap.get(root).push(node);
            }
        });
        return rootMap;
    }
    var CLASSES_CACHE_KEY = '$$classes';
    function addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            var classes = element[CLASSES_CACHE_KEY];
            if (!classes) {
                classes = element[CLASSES_CACHE_KEY] = {};
            }
            classes[className] = true;
        }
    }
    function removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            var classes = element[CLASSES_CACHE_KEY];
            if (classes) {
                delete classes[className];
            }
        }
    }
    function removeNodesAfterAnimationDone(engine, element, players) {
        optimizeGroupPlayer(players).onDone(function () { return engine.processLeaveNode(element); });
    }
    function flattenGroupPlayers(players) {
        var finalPlayers = [];
        _flattenGroupPlayersRecur(players, finalPlayers);
        return finalPlayers;
    }
    function _flattenGroupPlayersRecur(players, finalPlayers) {
        for (var i = 0; i < players.length; i++) {
            var player = players[i];
            if (player instanceof AnimationGroupPlayer) {
                _flattenGroupPlayersRecur(player.players, finalPlayers);
            }
            else {
                finalPlayers.push(player);
            }
        }
    }
    function objEquals(a, b) {
        var k1 = Object.keys(a);
        var k2 = Object.keys(b);
        if (k1.length != k2.length)
            return false;
        for (var i = 0; i < k1.length; i++) {
            var prop = k1[i];
            if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
                return false;
        }
        return true;
    }
    function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
        var postEntry = allPostStyleElements.get(element);
        if (!postEntry)
            return false;
        var preEntry = allPreStyleElements.get(element);
        if (preEntry) {
            postEntry.forEach(function (data) { return preEntry.add(data); });
        }
        else {
            allPreStyleElements.set(element, postEntry);
        }
        allPostStyleElements.delete(element);
        return true;
    }

    var AnimationEngine = /** @class */ (function () {
        function AnimationEngine(_driver, normalizer) {
            var _this = this;
            this._driver = _driver;
            this._triggerCache = {};
            // this method is designed to be overridden by the code that uses this engine
            this.onRemovalComplete = function (element, context) { };
            this._transitionEngine = new TransitionAnimationEngine(_driver, normalizer);
            this._timelineEngine = new TimelineAnimationEngine(_driver, normalizer);
            this._transitionEngine.onRemovalComplete = function (element, context) {
                return _this.onRemovalComplete(element, context);
            };
        }
        AnimationEngine.prototype.registerTrigger = function (componentId, namespaceId, hostElement, name, metadata) {
            var cacheKey = componentId + '-' + name;
            var trigger$$1 = this._triggerCache[cacheKey];
            if (!trigger$$1) {
                var errors = [];
                var ast = buildAnimationAst(this._driver, metadata, errors);
                if (errors.length) {
                    throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
                }
                trigger$$1 = buildTrigger(name, ast);
                this._triggerCache[cacheKey] = trigger$$1;
            }
            this._transitionEngine.registerTrigger(namespaceId, name, trigger$$1);
        };
        AnimationEngine.prototype.register = function (namespaceId, hostElement) {
            this._transitionEngine.register(namespaceId, hostElement);
        };
        AnimationEngine.prototype.destroy = function (namespaceId, context) {
            this._transitionEngine.destroy(namespaceId, context);
        };
        AnimationEngine.prototype.onInsert = function (namespaceId, element, parent, insertBefore) {
            this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
        };
        AnimationEngine.prototype.onRemove = function (namespaceId, element, context) {
            this._transitionEngine.removeNode(namespaceId, element, context);
        };
        AnimationEngine.prototype.disableAnimations = function (element, disable) {
            this._transitionEngine.markElementAsDisabled(element, disable);
        };
        AnimationEngine.prototype.process = function (namespaceId, element, property, value) {
            if (property.charAt(0) == '@') {
                var _a = __read(parseTimelineCommand(property), 2), id = _a[0], action = _a[1];
                var args = value;
                this._timelineEngine.command(id, element, action, args);
            }
            else {
                this._transitionEngine.trigger(namespaceId, element, property, value);
            }
        };
        AnimationEngine.prototype.listen = function (namespaceId, element, eventName, eventPhase, callback) {
            // @@listen
            if (eventName.charAt(0) == '@') {
                var _a = __read(parseTimelineCommand(eventName), 2), id = _a[0], action = _a[1];
                return this._timelineEngine.listen(id, element, action, callback);
            }
            return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
        };
        AnimationEngine.prototype.flush = function (microtaskId) {
            if (microtaskId === void 0) { microtaskId = -1; }
            this._transitionEngine.flush(microtaskId);
        };
        Object.defineProperty(AnimationEngine.prototype, "players", {
            get: function () {
                return this._transitionEngine.players
                    .concat(this._timelineEngine.players);
            },
            enumerable: true,
            configurable: true
        });
        AnimationEngine.prototype.whenRenderingDone = function () { return this._transitionEngine.whenRenderingDone(); };
        return AnimationEngine;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
    var ANIMATION_PROP = 'animation';
    var ANIMATIONEND_EVENT = 'animationend';
    var ONE_SECOND$1 = 1000;
    var ElementAnimationStyleHandler = /** @class */ (function () {
        function ElementAnimationStyleHandler(_element, _name, _duration, _delay, _easing, _fillMode, _onDoneFn) {
            var _this = this;
            this._element = _element;
            this._name = _name;
            this._duration = _duration;
            this._delay = _delay;
            this._easing = _easing;
            this._fillMode = _fillMode;
            this._onDoneFn = _onDoneFn;
            this._finished = false;
            this._destroyed = false;
            this._startTime = 0;
            this._position = 0;
            this._eventFn = function (e) { return _this._handleCallback(e); };
        }
        ElementAnimationStyleHandler.prototype.apply = function () {
            applyKeyframeAnimation(this._element, this._duration + "ms " + this._easing + " " + this._delay + "ms 1 normal " + this._fillMode + " " + this._name);
            addRemoveAnimationEvent(this._element, this._eventFn, false);
            this._startTime = Date.now();
        };
        ElementAnimationStyleHandler.prototype.pause = function () { playPauseAnimation(this._element, this._name, 'paused'); };
        ElementAnimationStyleHandler.prototype.resume = function () { playPauseAnimation(this._element, this._name, 'running'); };
        ElementAnimationStyleHandler.prototype.setPosition = function (position) {
            var index = findIndexForAnimation(this._element, this._name);
            this._position = position * this._duration;
            setAnimationStyle(this._element, 'Delay', "-" + this._position + "ms", index);
        };
        ElementAnimationStyleHandler.prototype.getPosition = function () { return this._position; };
        ElementAnimationStyleHandler.prototype._handleCallback = function (event) {
            var timestamp = event._ngTestManualTimestamp || Date.now();
            var elapsedTime = parseFloat(event.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES)) * ONE_SECOND$1;
            if (event.animationName == this._name &&
                Math.max(timestamp - this._startTime, 0) >= this._delay && elapsedTime >= this._duration) {
                this.finish();
            }
        };
        ElementAnimationStyleHandler.prototype.finish = function () {
            if (this._finished)
                return;
            this._finished = true;
            this._onDoneFn();
            addRemoveAnimationEvent(this._element, this._eventFn, true);
        };
        ElementAnimationStyleHandler.prototype.destroy = function () {
            if (this._destroyed)
                return;
            this._destroyed = true;
            this.finish();
            removeKeyframeAnimation(this._element, this._name);
        };
        return ElementAnimationStyleHandler;
    }());
    function playPauseAnimation(element, name, status) {
        var index = findIndexForAnimation(element, name);
        setAnimationStyle(element, 'PlayState', status, index);
    }
    function applyKeyframeAnimation(element, value) {
        var anim = getAnimationStyle(element, '').trim();
        var index = 0;
        if (anim.length) {
            index = countChars(anim, ',') + 1;
            value = anim + ", " + value;
        }
        setAnimationStyle(element, '', value);
        return index;
    }
    function removeKeyframeAnimation(element, name) {
        var anim = getAnimationStyle(element, '');
        var tokens = anim.split(',');
        var index = findMatchingTokenIndex(tokens, name);
        if (index >= 0) {
            tokens.splice(index, 1);
            var newValue = tokens.join(',');
            setAnimationStyle(element, '', newValue);
        }
    }
    function findIndexForAnimation(element, value) {
        var anim = getAnimationStyle(element, '');
        if (anim.indexOf(',') > 0) {
            var tokens = anim.split(',');
            return findMatchingTokenIndex(tokens, value);
        }
        return findMatchingTokenIndex([anim], value);
    }
    function findMatchingTokenIndex(tokens, searchToken) {
        for (var i = 0; i < tokens.length; i++) {
            if (tokens[i].indexOf(searchToken) >= 0) {
                return i;
            }
        }
        return -1;
    }
    function addRemoveAnimationEvent(element, fn, doRemove) {
        doRemove ? element.removeEventListener(ANIMATIONEND_EVENT, fn) :
            element.addEventListener(ANIMATIONEND_EVENT, fn);
    }
    function setAnimationStyle(element, name, value, index) {
        var prop = ANIMATION_PROP + name;
        if (index != null) {
            var oldValue = element.style[prop];
            if (oldValue.length) {
                var tokens = oldValue.split(',');
                tokens[index] = value;
                value = tokens.join(',');
            }
        }
        element.style[prop] = value;
    }
    function getAnimationStyle(element, name) {
        return element.style[ANIMATION_PROP + name];
    }
    function countChars(value, char) {
        var count = 0;
        for (var i = 0; i < value.length; i++) {
            var c = value.charAt(i);
            if (c === char)
                count++;
        }
        return count;
    }

    var DEFAULT_FILL_MODE = 'forwards';
    var DEFAULT_EASING = 'linear';
    var AnimatorControlState;
    (function (AnimatorControlState) {
        AnimatorControlState[AnimatorControlState["INITIALIZED"] = 1] = "INITIALIZED";
        AnimatorControlState[AnimatorControlState["STARTED"] = 2] = "STARTED";
        AnimatorControlState[AnimatorControlState["FINISHED"] = 3] = "FINISHED";
        AnimatorControlState[AnimatorControlState["DESTROYED"] = 4] = "DESTROYED";
    })(AnimatorControlState || (AnimatorControlState = {}));
    var CssKeyframesPlayer = /** @class */ (function () {
        function CssKeyframesPlayer(element, keyframes$$1, animationName, _duration, _delay, easing, _finalStyles) {
            this.element = element;
            this.keyframes = keyframes$$1;
            this.animationName = animationName;
            this._duration = _duration;
            this._delay = _delay;
            this._finalStyles = _finalStyles;
            this._onDoneFns = [];
            this._onStartFns = [];
            this._onDestroyFns = [];
            this._started = false;
            this.currentSnapshot = {};
            this.state = 0;
            this.easing = easing || DEFAULT_EASING;
            this.totalTime = _duration + _delay;
            this._buildStyler();
        }
        CssKeyframesPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
        CssKeyframesPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
        CssKeyframesPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
        CssKeyframesPlayer.prototype.destroy = function () {
            this.init();
            if (this.state >= AnimatorControlState.DESTROYED)
                return;
            this.state = AnimatorControlState.DESTROYED;
            this._styler.destroy();
            this._flushStartFns();
            this._flushDoneFns();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        };
        CssKeyframesPlayer.prototype._flushDoneFns = function () {
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        };
        CssKeyframesPlayer.prototype._flushStartFns = function () {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
        };
        CssKeyframesPlayer.prototype.finish = function () {
            this.init();
            if (this.state >= AnimatorControlState.FINISHED)
                return;
            this.state = AnimatorControlState.FINISHED;
            this._styler.finish();
            this._flushStartFns();
            this._flushDoneFns();
        };
        CssKeyframesPlayer.prototype.setPosition = function (value) { this._styler.setPosition(value); };
        CssKeyframesPlayer.prototype.getPosition = function () { return this._styler.getPosition(); };
        CssKeyframesPlayer.prototype.hasStarted = function () { return this.state >= AnimatorControlState.STARTED; };
        CssKeyframesPlayer.prototype.init = function () {
            if (this.state >= AnimatorControlState.INITIALIZED)
                return;
            this.state = AnimatorControlState.INITIALIZED;
            var elm = this.element;
            this._styler.apply();
            if (this._delay) {
                this._styler.pause();
            }
        };
        CssKeyframesPlayer.prototype.play = function () {
            this.init();
            if (!this.hasStarted()) {
                this._flushStartFns();
                this.state = AnimatorControlState.STARTED;
            }
            this._styler.resume();
        };
        CssKeyframesPlayer.prototype.pause = function () {
            this.init();
            this._styler.pause();
        };
        CssKeyframesPlayer.prototype.restart = function () {
            this.reset();
            this.play();
        };
        CssKeyframesPlayer.prototype.reset = function () {
            this._styler.destroy();
            this._buildStyler();
            this._styler.apply();
        };
        CssKeyframesPlayer.prototype._buildStyler = function () {
            var _this = this;
            this._styler = new ElementAnimationStyleHandler(this.element, this.animationName, this._duration, this._delay, this.easing, DEFAULT_FILL_MODE, function () { return _this.finish(); });
        };
        /* @internal */
        /* @internal */
        CssKeyframesPlayer.prototype.triggerCallback = /* @internal */
        function (phaseName) {
            var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
            methods.forEach(function (fn) { return fn(); });
            methods.length = 0;
        };
        CssKeyframesPlayer.prototype.beforeDestroy = function () {
            var _this = this;
            this.init();
            var styles = {};
            if (this.hasStarted()) {
                var finished_1 = this.state >= AnimatorControlState.FINISHED;
                Object.keys(this._finalStyles).forEach(function (prop) {
                    if (prop != 'offset') {
                        styles[prop] = finished_1 ? _this._finalStyles[prop] : computeStyle(_this.element, prop);
                    }
                });
            }
            this.currentSnapshot = styles;
        };
        return CssKeyframesPlayer;
    }());

    var DirectStylePlayer = /** @class */ (function (_super) {
        __extends(DirectStylePlayer, _super);
        function DirectStylePlayer(element, _styles) {
            var _this = _super.call(this) || this;
            _this.element = element;
            _this._styles = _styles;
            _this._startingStyles = {};
            _this.__initialized = false;
            return _this;
        }
        DirectStylePlayer.prototype.init = function () {
            var _this = this;
            if (this.__initialized || !this._startingStyles)
                return;
            this.__initialized = true;
            Object.keys(this._styles).forEach(function (prop) {
                _this._startingStyles[prop] = _this.element.style[prop];
            });
            _super.prototype.init.call(this);
        };
        DirectStylePlayer.prototype.play = function () {
            var _this = this;
            if (!this._startingStyles)
                return;
            this.init();
            Object.keys(this._styles).forEach(function (prop) { _this.element.style[prop] = _this._styles[prop]; });
            _super.prototype.play.call(this);
        };
        DirectStylePlayer.prototype.destroy = function () {
            var _this = this;
            if (!this._startingStyles)
                return;
            Object.keys(this._startingStyles).forEach(function (prop) {
                var value = _this._startingStyles[prop];
                if (value) {
                    _this.element.style[prop] = value;
                }
                else {
                    _this.element.style.removeProperty(prop);
                }
            });
            this._startingStyles = null;
            _super.prototype.destroy.call(this);
        };
        return DirectStylePlayer;
    }(NoopAnimationPlayer));

    var KEYFRAMES_NAME_PREFIX = 'gen_css_kf_';
    var TAB_SPACE = ' ';
    var CssKeyframesDriver = /** @class */ (function () {
        function CssKeyframesDriver() {
            this._count = 0;
            this._head = document.querySelector('head');
            this._warningIssued = false;
        }
        CssKeyframesDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
        CssKeyframesDriver.prototype.matchesElement = function (element, selector) {
            return matchesElement(element, selector);
        };
        CssKeyframesDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
        CssKeyframesDriver.prototype.query = function (element, selector, multi) {
            return invokeQuery(element, selector, multi);
        };
        CssKeyframesDriver.prototype.computeStyle = function (element, prop, defaultValue) {
            return window.getComputedStyle(element)[prop];
        };
        CssKeyframesDriver.prototype.buildKeyframeElement = function (element, name, keyframes$$1) {
            keyframes$$1 = keyframes$$1.map(function (kf) { return hypenatePropsObject(kf); });
            var keyframeStr = "@keyframes " + name + " {\n";
            var tab = '';
            keyframes$$1.forEach(function (kf) {
                tab = TAB_SPACE;
                var offset = parseFloat(kf.offset);
                keyframeStr += "" + tab + offset * 100 + "% {\n";
                tab += TAB_SPACE;
                Object.keys(kf).forEach(function (prop) {
                    var value = kf[prop];
                    switch (prop) {
                        case 'offset':
                            return;
                        case 'easing':
                            if (value) {
                                keyframeStr += tab + "animation-timing-function: " + value + ";\n";
                            }
                            return;
                        default:
                            keyframeStr += "" + tab + prop + ": " + value + ";\n";
                            return;
                    }
                });
                keyframeStr += tab + "}\n";
            });
            keyframeStr += "}\n";
            var kfElm = document.createElement('style');
            kfElm.innerHTML = keyframeStr;
            return kfElm;
        };
        CssKeyframesDriver.prototype.animate = function (element, keyframes$$1, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
            if (previousPlayers === void 0) { previousPlayers = []; }
            if (scrubberAccessRequested) {
                this._notifyFaultyScrubber();
            }
            var previousCssKeyframePlayers = previousPlayers.filter(function (player) { return player instanceof CssKeyframesPlayer; });
            var previousStyles = {};
            if (allowPreviousPlayerStylesMerge(duration, delay)) {
                previousCssKeyframePlayers.forEach(function (player) {
                    var styles = player.currentSnapshot;
                    Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
                });
            }
            keyframes$$1 = balancePreviousStylesIntoKeyframes(element, keyframes$$1, previousStyles);
            var finalStyles = flattenKeyframesIntoStyles(keyframes$$1);
            // if there is no animation then there is no point in applying
            // styles and waiting for an event to get fired. This causes lag.
            // It's better to just directly apply the styles to the element
            // via the direct styling animation player.
            if (duration == 0) {
                return new DirectStylePlayer(element, finalStyles);
            }
            var animationName = "" + KEYFRAMES_NAME_PREFIX + this._count++;
            var kfElm = this.buildKeyframeElement(element, animationName, keyframes$$1);
            document.querySelector('head').appendChild(kfElm);
            var player = new CssKeyframesPlayer(element, keyframes$$1, animationName, duration, delay, easing, finalStyles);
            player.onDestroy(function () { return removeElement(kfElm); });
            return player;
        };
        CssKeyframesDriver.prototype._notifyFaultyScrubber = function () {
            if (!this._warningIssued) {
                console.warn('@angular/animations: please load the web-animations.js polyfill to allow programmatic access...\n', '  visit http://bit.ly/IWukam to learn more about using the web-animation-js polyfill.');
                this._warningIssued = true;
            }
        };
        return CssKeyframesDriver;
    }());
    function flattenKeyframesIntoStyles(keyframes$$1) {
        var flatKeyframes = {};
        if (keyframes$$1) {
            var kfs = Array.isArray(keyframes$$1) ? keyframes$$1 : [keyframes$$1];
            kfs.forEach(function (kf) {
                Object.keys(kf).forEach(function (prop) {
                    if (prop == 'offset' || prop == 'easing')
                        return;
                    flatKeyframes[prop] = kf[prop];
                });
            });
        }
        return flatKeyframes;
    }
    function hypenatePropsObject(object) {
        var newObj = {};
        Object.keys(object).forEach(function (prop) {
            var newProp = prop.replace(/([a-z])([A-Z])/g, '$1-$2');
            newObj[newProp] = object[prop];
        });
        return newObj;
    }
    function removeElement(node) {
        node.parentNode.removeChild(node);
    }

    var WebAnimationsPlayer = /** @class */ (function () {
        function WebAnimationsPlayer(element, keyframes$$1, options) {
            this.element = element;
            this.keyframes = keyframes$$1;
            this.options = options;
            this._onDoneFns = [];
            this._onStartFns = [];
            this._onDestroyFns = [];
            this._initialized = false;
            this._finished = false;
            this._started = false;
            this._destroyed = false;
            this.time = 0;
            this.parentPlayer = null;
            this.currentSnapshot = {};
            this._duration = options['duration'];
            this._delay = options['delay'] || 0;
            this.time = this._duration + this._delay;
        }
        WebAnimationsPlayer.prototype._onFinish = function () {
            if (!this._finished) {
                this._finished = true;
                this._onDoneFns.forEach(function (fn) { return fn(); });
                this._onDoneFns = [];
            }
        };
        WebAnimationsPlayer.prototype.init = function () {
            this._buildPlayer();
            this._preparePlayerBeforeStart();
        };
        WebAnimationsPlayer.prototype._buildPlayer = function () {
            var _this = this;
            if (this._initialized)
                return;
            this._initialized = true;
            var keyframes$$1 = this.keyframes;
            this.domPlayer =
                this._triggerWebAnimation(this.element, keyframes$$1, this.options);
            this._finalKeyframe = keyframes$$1.length ? keyframes$$1[keyframes$$1.length - 1] : {};
            this.domPlayer.addEventListener('finish', function () { return _this._onFinish(); });
        };
        WebAnimationsPlayer.prototype._preparePlayerBeforeStart = function () {
            // this is required so that the player doesn't start to animate right away
            if (this._delay) {
                this._resetDomPlayerState();
            }
            else {
                this.domPlayer.pause();
            }
        };
        /** @internal */
        /** @internal */
        WebAnimationsPlayer.prototype._triggerWebAnimation = /** @internal */
        function (element, keyframes$$1, options) {
            // jscompiler doesn't seem to know animate is a native property because it's not fully
            // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
            return element['animate'](keyframes$$1, options);
        };
        WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
        WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
        WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
        WebAnimationsPlayer.prototype.play = function () {
            this._buildPlayer();
            if (!this.hasStarted()) {
                this._onStartFns.forEach(function (fn) { return fn(); });
                this._onStartFns = [];
                this._started = true;
            }
            this.domPlayer.play();
        };
        WebAnimationsPlayer.prototype.pause = function () {
            this.init();
            this.domPlayer.pause();
        };
        WebAnimationsPlayer.prototype.finish = function () {
            this.init();
            this._onFinish();
            this.domPlayer.finish();
        };
        WebAnimationsPlayer.prototype.reset = function () {
            this._resetDomPlayerState();
            this._destroyed = false;
            this._finished = false;
            this._started = false;
        };
        WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
            if (this.domPlayer) {
                this.domPlayer.cancel();
            }
        };
        WebAnimationsPlayer.prototype.restart = function () {
            this.reset();
            this.play();
        };
        WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
        WebAnimationsPlayer.prototype.destroy = function () {
            if (!this._destroyed) {
                this._destroyed = true;
                this._resetDomPlayerState();
                this._onFinish();
                this._onDestroyFns.forEach(function (fn) { return fn(); });
                this._onDestroyFns = [];
            }
        };
        WebAnimationsPlayer.prototype.setPosition = function (p) { this.domPlayer.currentTime = p * this.time; };
        WebAnimationsPlayer.prototype.getPosition = function () { return this.domPlayer.currentTime / this.time; };
        Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
            get: function () { return this._delay + this._duration; },
            enumerable: true,
            configurable: true
        });
        WebAnimationsPlayer.prototype.beforeDestroy = function () {
            var _this = this;
            var styles = {};
            if (this.hasStarted()) {
                Object.keys(this._finalKeyframe).forEach(function (prop) {
                    if (prop != 'offset') {
                        styles[prop] =
                            _this._finished ? _this._finalKeyframe[prop] : computeStyle(_this.element, prop);
                    }
                });
            }
            this.currentSnapshot = styles;
        };
        /* @internal */
        /* @internal */
        WebAnimationsPlayer.prototype.triggerCallback = /* @internal */
        function (phaseName) {
            var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
            methods.forEach(function (fn) { return fn(); });
            methods.length = 0;
        };
        return WebAnimationsPlayer;
    }());

    var WebAnimationsDriver = /** @class */ (function () {
        function WebAnimationsDriver() {
            this._isNativeImpl = /\{\s*\[native\s+code\]\s*\}/.test(getElementAnimateFn().toString());
            this._cssKeyframesDriver = new CssKeyframesDriver();
        }
        WebAnimationsDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
        WebAnimationsDriver.prototype.matchesElement = function (element, selector) {
            return matchesElement(element, selector);
        };
        WebAnimationsDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
        WebAnimationsDriver.prototype.query = function (element, selector, multi) {
            return invokeQuery(element, selector, multi);
        };
        WebAnimationsDriver.prototype.computeStyle = function (element, prop, defaultValue) {
            return window.getComputedStyle(element)[prop];
        };
        WebAnimationsDriver.prototype.overrideWebAnimationsSupport = function (supported) { this._isNativeImpl = supported; };
        WebAnimationsDriver.prototype.animate = function (element, keyframes$$1, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
            if (previousPlayers === void 0) { previousPlayers = []; }
            var useKeyframes = !scrubberAccessRequested && !this._isNativeImpl;
            if (useKeyframes) {
                return this._cssKeyframesDriver.animate(element, keyframes$$1, duration, delay, easing, previousPlayers);
            }
            var fill = delay == 0 ? 'both' : 'forwards';
            var playerOptions = { duration: duration, delay: delay, fill: fill };
            // we check for this to avoid having a null|undefined value be present
            // for the easing (which results in an error for certain browsers #9752)
            if (easing) {
                playerOptions['easing'] = easing;
            }
            var previousStyles = {};
            var previousWebAnimationPlayers = previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; });
            if (allowPreviousPlayerStylesMerge(duration, delay)) {
                previousWebAnimationPlayers.forEach(function (player) {
                    var styles = player.currentSnapshot;
                    Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
                });
            }
            keyframes$$1 = keyframes$$1.map(function (styles) { return copyStyles(styles, false); });
            keyframes$$1 = balancePreviousStylesIntoKeyframes(element, keyframes$$1, previousStyles);
            return new WebAnimationsPlayer(element, keyframes$$1, playerOptions);
        };
        return WebAnimationsDriver;
    }());
    function supportsWebAnimations() {
        return typeof getElementAnimateFn() === 'function';
    }
    function getElementAnimateFn() {
        return (typeof Element !== 'undefined' && Element.prototype['animate']) || {};
    }

    /**
     * @license Angular v6.0.0
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    var BrowserAnimationBuilder = /** @class */ (function (_super) {
        __extends(BrowserAnimationBuilder, _super);
        function BrowserAnimationBuilder(rootRenderer, doc) {
            var _this = _super.call(this) || this;
            _this._nextAnimationId = 0;
            var typeData = {
                id: '0',
                encapsulation: core.ViewEncapsulation.None,
                styles: [],
                data: { animation: [] }
            };
            _this._renderer = rootRenderer.createRenderer(doc.body, typeData);
            return _this;
        }
        BrowserAnimationBuilder.prototype.build = function (animation$$1) {
            var id = this._nextAnimationId.toString();
            this._nextAnimationId++;
            var entry = Array.isArray(animation$$1) ? sequence(animation$$1) : animation$$1;
            issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
            return new BrowserAnimationFactory(id, this._renderer);
        };
        BrowserAnimationBuilder.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        BrowserAnimationBuilder.ctorParameters = function () { return [
            { type: core.RendererFactory2, },
            { type: undefined, decorators: [{ type: core.Inject, args: [DOCUMENT$1,] },] },
        ]; };
        return BrowserAnimationBuilder;
    }(AnimationBuilder));
    var BrowserAnimationFactory = /** @class */ (function (_super) {
        __extends(BrowserAnimationFactory, _super);
        function BrowserAnimationFactory(_id, _renderer) {
            var _this = _super.call(this) || this;
            _this._id = _id;
            _this._renderer = _renderer;
            return _this;
        }
        BrowserAnimationFactory.prototype.create = function (element, options) {
            return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
        };
        return BrowserAnimationFactory;
    }(AnimationFactory));
    var RendererAnimationPlayer = /** @class */ (function () {
        function RendererAnimationPlayer(id, element, options, _renderer) {
            this.id = id;
            this.element = element;
            this._renderer = _renderer;
            this.parentPlayer = null;
            this._started = false;
            this.totalTime = 0;
            this._command('create', options);
        }
        RendererAnimationPlayer.prototype._listen = function (eventName, callback) {
            return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
        };
        RendererAnimationPlayer.prototype._command = function (command) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
        };
        RendererAnimationPlayer.prototype.onDone = function (fn) { this._listen('done', fn); };
        RendererAnimationPlayer.prototype.onStart = function (fn) { this._listen('start', fn); };
        RendererAnimationPlayer.prototype.onDestroy = function (fn) { this._listen('destroy', fn); };
        RendererAnimationPlayer.prototype.init = function () { this._command('init'); };
        RendererAnimationPlayer.prototype.hasStarted = function () { return this._started; };
        RendererAnimationPlayer.prototype.play = function () {
            this._command('play');
            this._started = true;
        };
        RendererAnimationPlayer.prototype.pause = function () { this._command('pause'); };
        RendererAnimationPlayer.prototype.restart = function () { this._command('restart'); };
        RendererAnimationPlayer.prototype.finish = function () { this._command('finish'); };
        RendererAnimationPlayer.prototype.destroy = function () { this._command('destroy'); };
        RendererAnimationPlayer.prototype.reset = function () { this._command('reset'); };
        RendererAnimationPlayer.prototype.setPosition = function (p) { this._command('setPosition', p); };
        RendererAnimationPlayer.prototype.getPosition = function () { return 0; };
        return RendererAnimationPlayer;
    }());
    function issueAnimationCommand(renderer, element, id, command, args) {
        return renderer.setProperty(element, "@@" + id + ":" + command, args);
    }

    var ANIMATION_PREFIX = '@';
    var DISABLE_ANIMATIONS_FLAG = '@.disabled';
    var AnimationRendererFactory = /** @class */ (function () {
        function AnimationRendererFactory(delegate, engine, _zone) {
            this.delegate = delegate;
            this.engine = engine;
            this._zone = _zone;
            this._currentId = 0;
            this._microtaskId = 1;
            this._animationCallbacksBuffer = [];
            this._rendererCache = new Map();
            this._cdRecurDepth = 0;
            this.promise = Promise.resolve(0);
            engine.onRemovalComplete = function (element, delegate) {
                // Note: if an component element has a leave animation, and the component
                // a host leave animation, the view engine will call `removeChild` for the parent
                // component renderer as well as for the child component renderer.
                // Therefore, we need to check if we already removed the element.
                if (delegate && delegate.parentNode(element)) {
                    delegate.removeChild(element.parentNode, element);
                }
            };
        }
        AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
            var _this = this;
            var EMPTY_NAMESPACE_ID = '';
            // cache the delegates to find out which cached delegate can
            // be used by which cached renderer
            var delegate = this.delegate.createRenderer(hostElement, type);
            if (!hostElement || !type || !type.data || !type.data['animation']) {
                var renderer = this._rendererCache.get(delegate);
                if (!renderer) {
                    renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
                    // only cache this result when the base renderer is used
                    this._rendererCache.set(delegate, renderer);
                }
                return renderer;
            }
            var componentId = type.id;
            var namespaceId = type.id + '-' + this._currentId;
            this._currentId++;
            this.engine.register(namespaceId, hostElement);
            var animationTriggers = type.data['animation'];
            animationTriggers.forEach(function (trigger$$1) {
                return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger$$1.name, trigger$$1);
            });
            return new AnimationRenderer(this, namespaceId, delegate, this.engine);
        };
        AnimationRendererFactory.prototype.begin = function () {
            this._cdRecurDepth++;
            if (this.delegate.begin) {
                this.delegate.begin();
            }
        };
        AnimationRendererFactory.prototype._scheduleCountTask = function () {
            var _this = this;
            // always use promise to schedule microtask instead of use Zone
            this.promise.then(function () { _this._microtaskId++; });
        };
        /* @internal */
        /* @internal */
        AnimationRendererFactory.prototype.scheduleListenerCallback = /* @internal */
        function (count, fn, data) {
            var _this = this;
            if (count >= 0 && count < this._microtaskId) {
                this._zone.run(function () { return fn(data); });
                return;
            }
            if (this._animationCallbacksBuffer.length == 0) {
                Promise.resolve(null).then(function () {
                    _this._zone.run(function () {
                        _this._animationCallbacksBuffer.forEach(function (tuple) {
                            var _a = __read(tuple, 2), fn = _a[0], data = _a[1];
                            fn(data);
                        });
                        _this._animationCallbacksBuffer = [];
                    });
                });
            }
            this._animationCallbacksBuffer.push([fn, data]);
        };
        AnimationRendererFactory.prototype.end = function () {
            var _this = this;
            this._cdRecurDepth--;
            // this is to prevent animations from running twice when an inner
            // component does CD when a parent component insted has inserted it
            if (this._cdRecurDepth == 0) {
                this._zone.runOutsideAngular(function () {
                    _this._scheduleCountTask();
                    _this.engine.flush(_this._microtaskId);
                });
            }
            if (this.delegate.end) {
                this.delegate.end();
            }
        };
        AnimationRendererFactory.prototype.whenRenderingDone = function () { return this.engine.whenRenderingDone(); };
        AnimationRendererFactory.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        AnimationRendererFactory.ctorParameters = function () { return [
            { type: core.RendererFactory2, },
            { type: AnimationEngine, },
            { type: core.NgZone, },
        ]; };
        return AnimationRendererFactory;
    }());
    var BaseAnimationRenderer = /** @class */ (function () {
        function BaseAnimationRenderer(namespaceId, delegate, engine) {
            this.namespaceId = namespaceId;
            this.delegate = delegate;
            this.engine = engine;
            this.destroyNode = this.delegate.destroyNode ? function (n) { return delegate.destroyNode(n); } : null;
        }
        Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
            get: function () { return this.delegate.data; },
            enumerable: true,
            configurable: true
        });
        BaseAnimationRenderer.prototype.destroy = function () {
            this.engine.destroy(this.namespaceId, this.delegate);
            this.delegate.destroy();
        };
        BaseAnimationRenderer.prototype.createElement = function (name, namespace) {
            return this.delegate.createElement(name, namespace);
        };
        BaseAnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
        BaseAnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
        BaseAnimationRenderer.prototype.appendChild = function (parent, newChild) {
            this.delegate.appendChild(parent, newChild);
            this.engine.onInsert(this.namespaceId, newChild, parent, false);
        };
        BaseAnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
            this.delegate.insertBefore(parent, newChild, refChild);
            this.engine.onInsert(this.namespaceId, newChild, parent, true);
        };
        BaseAnimationRenderer.prototype.removeChild = function (parent, oldChild) {
            this.engine.onRemove(this.namespaceId, oldChild, this.delegate);
        };
        BaseAnimationRenderer.prototype.selectRootElement = function (selectorOrNode) { return this.delegate.selectRootElement(selectorOrNode); };
        BaseAnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
        BaseAnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
        BaseAnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
            this.delegate.setAttribute(el, name, value, namespace);
        };
        BaseAnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
            this.delegate.removeAttribute(el, name, namespace);
        };
        BaseAnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
        BaseAnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
        BaseAnimationRenderer.prototype.setStyle = function (el, style$$1, value, flags) {
            this.delegate.setStyle(el, style$$1, value, flags);
        };
        BaseAnimationRenderer.prototype.removeStyle = function (el, style$$1, flags) {
            this.delegate.removeStyle(el, style$$1, flags);
        };
        BaseAnimationRenderer.prototype.setProperty = function (el, name, value) {
            if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
                this.disableAnimations(el, !!value);
            }
            else {
                this.delegate.setProperty(el, name, value);
            }
        };
        BaseAnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
        BaseAnimationRenderer.prototype.listen = function (target, eventName, callback) {
            return this.delegate.listen(target, eventName, callback);
        };
        BaseAnimationRenderer.prototype.disableAnimations = function (element, value) {
            this.engine.disableAnimations(element, value);
        };
        return BaseAnimationRenderer;
    }());
    var AnimationRenderer = /** @class */ (function (_super) {
        __extends(AnimationRenderer, _super);
        function AnimationRenderer(factory, namespaceId, delegate, engine) {
            var _this = _super.call(this, namespaceId, delegate, engine) || this;
            _this.factory = factory;
            _this.namespaceId = namespaceId;
            return _this;
        }
        AnimationRenderer.prototype.setProperty = function (el, name, value) {
            if (name.charAt(0) == ANIMATION_PREFIX) {
                if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
                    value = value === undefined ? true : !!value;
                    this.disableAnimations(el, value);
                }
                else {
                    this.engine.process(this.namespaceId, el, name.substr(1), value);
                }
            }
            else {
                this.delegate.setProperty(el, name, value);
            }
        };
        AnimationRenderer.prototype.listen = function (target, eventName, callback) {
            var _this = this;
            if (eventName.charAt(0) == ANIMATION_PREFIX) {
                var element = resolveElementFromTarget(target);
                var name_1 = eventName.substr(1);
                var phase = '';
                // @listener.phase is for trigger animation callbacks
                // @@listener is for animation builder callbacks
                if (name_1.charAt(0) != ANIMATION_PREFIX) {
                    _a = __read(parseTriggerCallbackName(name_1), 2), name_1 = _a[0], phase = _a[1];
                }
                return this.engine.listen(this.namespaceId, element, name_1, phase, function (event) {
                    var countId = event['_data'] || -1;
                    _this.factory.scheduleListenerCallback(countId, callback, event);
                });
            }
            return this.delegate.listen(target, eventName, callback);
            var _a;
        };
        return AnimationRenderer;
    }(BaseAnimationRenderer));
    function resolveElementFromTarget(target) {
        switch (target) {
            case 'body':
                return document.body;
            case 'document':
                return document;
            case 'window':
                return window;
            default:
                return target;
        }
    }
    function parseTriggerCallbackName(triggerName) {
        var dotIndex = triggerName.indexOf('.');
        var trigger$$1 = triggerName.substring(0, dotIndex);
        var phase = triggerName.substr(dotIndex + 1);
        return [trigger$$1, phase];
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var InjectableAnimationEngine = /** @class */ (function (_super) {
        __extends(InjectableAnimationEngine, _super);
        function InjectableAnimationEngine(driver, normalizer) {
            return _super.call(this, driver, normalizer) || this;
        }
        InjectableAnimationEngine.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        InjectableAnimationEngine.ctorParameters = function () { return [
            { type: AnimationDriver, },
            { type: AnimationStyleNormalizer, },
        ]; };
        return InjectableAnimationEngine;
    }(AnimationEngine));
    function instantiateSupportedAnimationDriver() {
        return supportsWebAnimations() ? new WebAnimationsDriver() : new CssKeyframesDriver();
    }
    function instantiateDefaultStyleNormalizer() {
        return new WebAnimationsStyleNormalizer();
    }
    function instantiateRendererFactory(renderer, engine, zone) {
        return new AnimationRendererFactory(renderer, engine, zone);
    }
    /**
     * @experimental Animation support is experimental.
     */
    var ANIMATION_MODULE_TYPE = new core.InjectionToken('AnimationModuleType');
    var SHARED_ANIMATION_PROVIDERS = [
        { provide: AnimationBuilder, useClass: BrowserAnimationBuilder },
        { provide: AnimationStyleNormalizer, useFactory: instantiateDefaultStyleNormalizer },
        { provide: AnimationEngine, useClass: InjectableAnimationEngine }, {
            provide: core.RendererFactory2,
            useFactory: instantiateRendererFactory,
            deps: [DomRendererFactory2, AnimationEngine, core.NgZone]
        }
    ];
    /**
     * Separate providers from the actual module so that we can do a local modification in Google3 to
     * include them in the BrowserModule.
     */
    var BROWSER_ANIMATIONS_PROVIDERS = __spread([
        { provide: AnimationDriver, useFactory: instantiateSupportedAnimationDriver },
        { provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }
    ], SHARED_ANIMATION_PROVIDERS);
    /**
     * Separate providers from the actual module so that we can do a local modification in Google3 to
     * include them in the BrowserTestingModule.
     */
    var BROWSER_NOOP_ANIMATIONS_PROVIDERS = __spread([
        { provide: AnimationDriver, useClass: NoopAnimationDriver },
        { provide: ANIMATION_MODULE_TYPE, useValue: 'NoopAnimations' }
    ], SHARED_ANIMATION_PROVIDERS);

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var /** @type {?} */ BACKSPACE = 8;
    var /** @type {?} */ TAB = 9;
    var /** @type {?} */ ENTER = 13;
    var /** @type {?} */ ESCAPE = 27;
    var /** @type {?} */ SPACE = 32;
    var /** @type {?} */ PAGE_UP = 33;
    var /** @type {?} */ PAGE_DOWN = 34;
    var /** @type {?} */ END = 35;
    var /** @type {?} */ HOME = 36;
    var /** @type {?} */ LEFT_ARROW = 37;
    var /** @type {?} */ UP_ARROW = 38;
    var /** @type {?} */ RIGHT_ARROW = 39;
    var /** @type {?} */ DOWN_ARROW = 40;
    var /** @type {?} */ DELETE = 46;
    var /** @type {?} */ ZERO = 48;
    var /** @type {?} */ NINE = 57;
    var /** @type {?} */ A = 65;
    var /** @type {?} */ Z = 90;

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * \@docs-private
     */
    var AnimationCurves = /** @class */ (function () {
        function AnimationCurves() {
        }
        AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
        AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
        AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
        AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
        return AnimationCurves;
    }());
    /**
     * \@docs-private
     */
    var AnimationDurations = /** @class */ (function () {
        function AnimationDurations() {
        }
        AnimationDurations.COMPLEX = '375ms';
        AnimationDurations.ENTERING = '225ms';
        AnimationDurations.EXITING = '195ms';
        return AnimationDurations;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that configures whether the Material sanity checks are enabled.
     */
    var /** @type {?} */ MATERIAL_SANITY_CHECKS = new core.InjectionToken('mat-sanity-checks', {
        providedIn: 'root',
        factory: MATERIAL_SANITY_CHECKS_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MATERIAL_SANITY_CHECKS_FACTORY() {
        return true;
    }
    /**
     * Module that captures anything that should be loaded and/or run for *all* Angular Material
     * components. This includes Bidi, etc.
     *
     * This module should be imported to each top-level component module (e.g., MatTabsModule).
     */
    var MatCommonModule = /** @class */ (function () {
        function MatCommonModule(_sanityChecksEnabled) {
            this._sanityChecksEnabled = _sanityChecksEnabled;
            /**
             * Whether we've done the global sanity checks (e.g. a theme is loaded, there is a doctype).
             */
            this._hasDoneGlobalChecks = false;
            /**
             * Whether we've already checked for HammerJs availability.
             */
            this._hasCheckedHammer = false;
            /**
             * Reference to the global `document` object.
             */
            this._document = typeof document === 'object' && document ? document : null;
            /**
             * Reference to the global 'window' object.
             */
            this._window = typeof window === 'object' && window ? window : null;
            if (this._areChecksEnabled() && !this._hasDoneGlobalChecks) {
                this._checkDoctypeIsDefined();
                this._checkThemeIsPresent();
                this._hasDoneGlobalChecks = true;
            }
        }
        /**
         * Whether any sanity checks are enabled
         * @return {?}
         */
        MatCommonModule.prototype._areChecksEnabled = /**
         * Whether any sanity checks are enabled
         * @return {?}
         */
        function () {
            return this._sanityChecksEnabled && core.isDevMode() && !this._isTestEnv();
        };
        /**
         * Whether the code is running in tests.
         * @return {?}
         */
        MatCommonModule.prototype._isTestEnv = /**
         * Whether the code is running in tests.
         * @return {?}
         */
        function () {
            return this._window && (this._window['__karma__'] || this._window['jasmine']);
        };
        /**
         * @return {?}
         */
        MatCommonModule.prototype._checkDoctypeIsDefined = /**
         * @return {?}
         */
        function () {
            if (this._document && !this._document.doctype) {
                console.warn('Current document does not have a doctype. This may cause ' +
                    'some Angular Material components not to behave as expected.');
            }
        };
        /**
         * @return {?}
         */
        MatCommonModule.prototype._checkThemeIsPresent = /**
         * @return {?}
         */
        function () {
            if (this._document && typeof getComputedStyle === 'function') {
                var /** @type {?} */ testElement = this._document.createElement('div');
                testElement.classList.add('mat-theme-loaded-marker');
                this._document.body.appendChild(testElement);
                var /** @type {?} */ computedStyle = getComputedStyle(testElement);
                // In some situations, the computed style of the test element can be null. For example in
                // Firefox, the computed style is null if an application is running inside of a hidden iframe.
                // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
                if (computedStyle && computedStyle.display !== 'none') {
                    console.warn('Could not find Angular Material core theme. Most Material ' +
                        'components may not work as expected. For more info refer ' +
                        'to the theming guide: https://material.angular.io/guide/theming');
                }
                this._document.body.removeChild(testElement);
            }
        };
        /** Checks whether HammerJS is available. */
        /**
         * Checks whether HammerJS is available.
         * @return {?}
         */
        MatCommonModule.prototype._checkHammerIsAvailable = /**
         * Checks whether HammerJS is available.
         * @return {?}
         */
        function () {
            if (this._hasCheckedHammer || !this._window) {
                return;
            }
            if (this._areChecksEnabled() && !this._window['Hammer']) {
                console.warn('Could not find HammerJS. Certain Angular Material components may not work correctly.');
            }
            this._hasCheckedHammer = true;
        };
        MatCommonModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [BidiModule],
                        exports: [BidiModule],
                    },] },
        ];
        /** @nocollapse */
        MatCommonModule.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MATERIAL_SANITY_CHECKS,] },] },
        ]; };
        return MatCommonModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with a `disabled` property.
     * @template T
     * @param {?} base
     * @return {?}
     */
    function mixinDisabled(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                _this._disabled = false;
                return _this;
            }
            Object.defineProperty(class_1.prototype, "disabled", {
                get: /**
                 * @return {?}
                 */
                function () { return this._disabled; },
                set: /**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) { this._disabled = coerceBooleanProperty(value); },
                enumerable: true,
                configurable: true
            });
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with a `color` property.
     * @template T
     * @param {?} base
     * @param {?=} defaultColor
     * @return {?}
     */
    function mixinColor(base, defaultColor) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                // Set the default color that can be specified from the mixin.
                // Set the default color that can be specified from the mixin.
                _this.color = defaultColor;
                return _this;
            }
            Object.defineProperty(class_1.prototype, "color", {
                get: /**
                 * @return {?}
                 */
                function () { return this._color; },
                set: /**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) {
                    var /** @type {?} */ colorPalette = value || defaultColor;
                    if (colorPalette !== this._color) {
                        if (this._color) {
                            this._elementRef.nativeElement.classList.remove("mat-" + this._color);
                        }
                        if (colorPalette) {
                            this._elementRef.nativeElement.classList.add("mat-" + colorPalette);
                        }
                        this._color = colorPalette;
                    }
                },
                enumerable: true,
                configurable: true
            });
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with a `disableRipple` property.
     * @template T
     * @param {?} base
     * @return {?}
     */
    function mixinDisableRipple(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                _this._disableRipple = false;
                return _this;
            }
            Object.defineProperty(class_1.prototype, "disableRipple", {
                /** Whether the ripple effect is disabled or not. */
                get: /**
                 * Whether the ripple effect is disabled or not.
                 * @return {?}
                 */
                function () { return this._disableRipple; },
                set: /**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) { this._disableRipple = coerceBooleanProperty(value); },
                enumerable: true,
                configurable: true
            });
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with a `tabIndex` property.
     * @template T
     * @param {?} base
     * @param {?=} defaultTabIndex
     * @return {?}
     */
    function mixinTabIndex(base, defaultTabIndex) {
        if (defaultTabIndex === void 0) { defaultTabIndex = 0; }
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                _this._tabIndex = defaultTabIndex;
                return _this;
            }
            Object.defineProperty(class_1.prototype, "tabIndex", {
                get: /**
                 * @return {?}
                 */
                function () { return this.disabled ? -1 : this._tabIndex; },
                set: /**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) {
                    // If the specified tabIndex value is null or undefined, fall back to the default value.
                    this._tabIndex = value != null ? value : defaultTabIndex;
                },
                enumerable: true,
                configurable: true
            });
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with updateErrorState method.
     * For component with `errorState` and need to update `errorState`.
     * @template T
     * @param {?} base
     * @return {?}
     */
    function mixinErrorState(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                /**
                 * Whether the component is in an error state.
                 */
                _this.errorState = false;
                /**
                 * Stream that emits whenever the state of the input changes such that the wrapping
                 * `MatFormField` needs to run change detection.
                 */
                _this.stateChanges = new rxjs.Subject();
                return _this;
            }
            /**
             * @return {?}
             */
            class_1.prototype.updateErrorState = /**
             * @return {?}
             */
            function () {
                var /** @type {?} */ oldState = this.errorState;
                var /** @type {?} */ parent = this._parentFormGroup || this._parentForm;
                var /** @type {?} */ matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
                var /** @type {?} */ control = this.ngControl ? /** @type {?} */ (this.ngControl.control) : null;
                var /** @type {?} */ newState = matcher.isErrorState(control, parent);
                if (newState !== oldState) {
                    this.errorState = newState;
                    this.stateChanges.next();
                }
            };
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to augment a directive with an initialized property that will emits when ngOnInit ends.
     * @template T
     * @param {?} base
     * @return {?}
     */
    function mixinInitialized(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                /**
                 * Whether this directive has been marked as initialized.
                 */
                _this._isInitialized = false;
                /**
                 * List of subscribers that subscribed before the directive was initialized. Should be notified
                 * during _markInitialized. Set to null after pending subscribers are notified, and should
                 * not expect to be populated after.
                 */
                _this._pendingSubscribers = [];
                /**
                 * Observable stream that emits when the directive initializes. If already initialized, the
                 * subscriber is stored to be notified once _markInitialized is called.
                 */
                _this.initialized = new rxjs.Observable(function (subscriber) {
                    // If initialized, immediately notify the subscriber. Otherwise store the subscriber to notify
                    // when _markInitialized is called.
                    if (_this._isInitialized) {
                        _this._notifySubscriber(subscriber);
                    }
                    else {
                        /** @type {?} */ ((_this._pendingSubscribers)).push(subscriber);
                    }
                });
                return _this;
            }
            /**
             * Marks the state as initialized and notifies pending subscribers. Should be called at the end
             * of ngOnInit.
             * @docs-private
             */
            /**
             * Marks the state as initialized and notifies pending subscribers. Should be called at the end
             * of ngOnInit.
             * \@docs-private
             * @return {?}
             */
            class_1.prototype._markInitialized = /**
             * Marks the state as initialized and notifies pending subscribers. Should be called at the end
             * of ngOnInit.
             * \@docs-private
             * @return {?}
             */
            function () {
                if (this._isInitialized) {
                    throw Error('This directive has already been marked as initialized and ' +
                        'should not be called twice.');
                }
                this._isInitialized = true; /** @type {?} */
                ((this._pendingSubscribers)).forEach(this._notifySubscriber);
                this._pendingSubscribers = null;
            };
            /** Emits and completes the subscriber stream (should only emit once). */
            /**
             * Emits and completes the subscriber stream (should only emit once).
             * @param {?} subscriber
             * @return {?}
             */
            class_1.prototype._notifySubscriber = /**
             * Emits and completes the subscriber stream (should only emit once).
             * @param {?} subscriber
             * @return {?}
             */
            function (subscriber) {
                subscriber.next();
                subscriber.complete();
            };
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * InjectionToken for datepicker that can be used to override default locale code.
     */
    var /** @type {?} */ MAT_DATE_LOCALE = new core.InjectionToken('MAT_DATE_LOCALE', {
        providedIn: 'root',
        factory: MAT_DATE_LOCALE_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_DATE_LOCALE_FACTORY() {
        return core.inject(core.LOCALE_ID);
    }
    /**
     * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
     * @abstract
     * @template D
     */
    var  /**
     * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
     * @abstract
     * @template D
     */
    DateAdapter = /** @class */ (function () {
        function DateAdapter() {
            this._localeChanges = new rxjs.Subject();
        }
        Object.defineProperty(DateAdapter.prototype, "localeChanges", {
            /** A stream that emits when the locale changes. */
            get: /**
             * A stream that emits when the locale changes.
             * @return {?}
             */
            function () { return this._localeChanges; },
            enumerable: true,
            configurable: true
        });
        /**
         * Attempts to deserialize a value to a valid date object. This is different from parsing in that
         * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
         * string). The default implementation does not allow any deserialization, it simply checks that
         * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
         * method on all of it's `@Input()` properties that accept dates. It is therefore possible to
         * support passing values from your backend directly to these properties by overriding this method
         * to also deserialize the format used by your backend.
         * @param value The value to be deserialized into a date object.
         * @returns The deserialized date object, either a valid date, null if the value can be
         *     deserialized into a null date (e.g. the empty string), or an invalid date.
         */
        /**
         * Attempts to deserialize a value to a valid date object. This is different from parsing in that
         * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
         * string). The default implementation does not allow any deserialization, it simply checks that
         * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
         * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
         * support passing values from your backend directly to these properties by overriding this method
         * to also deserialize the format used by your backend.
         * @param {?} value The value to be deserialized into a date object.
         * @return {?} The deserialized date object, either a valid date, null if the value can be
         *     deserialized into a null date (e.g. the empty string), or an invalid date.
         */
        DateAdapter.prototype.deserialize = /**
         * Attempts to deserialize a value to a valid date object. This is different from parsing in that
         * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
         * string). The default implementation does not allow any deserialization, it simply checks that
         * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
         * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
         * support passing values from your backend directly to these properties by overriding this method
         * to also deserialize the format used by your backend.
         * @param {?} value The value to be deserialized into a date object.
         * @return {?} The deserialized date object, either a valid date, null if the value can be
         *     deserialized into a null date (e.g. the empty string), or an invalid date.
         */
        function (value) {
            if (value == null || this.isDateInstance(value) && this.isValid(value)) {
                return value;
            }
            return this.invalid();
        };
        /**
         * Sets the locale used for all dates.
         * @param locale The new locale.
         */
        /**
         * Sets the locale used for all dates.
         * @param {?} locale The new locale.
         * @return {?}
         */
        DateAdapter.prototype.setLocale = /**
         * Sets the locale used for all dates.
         * @param {?} locale The new locale.
         * @return {?}
         */
        function (locale) {
            this.locale = locale;
            this._localeChanges.next();
        };
        /**
         * Compares two dates.
         * @param first The first date to compare.
         * @param second The second date to compare.
         * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier,
         *     a number greater than 0 if the first date is later.
         */
        /**
         * Compares two dates.
         * @param {?} first The first date to compare.
         * @param {?} second The second date to compare.
         * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
         *     a number greater than 0 if the first date is later.
         */
        DateAdapter.prototype.compareDate = /**
         * Compares two dates.
         * @param {?} first The first date to compare.
         * @param {?} second The second date to compare.
         * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
         *     a number greater than 0 if the first date is later.
         */
        function (first, second) {
            return this.getYear(first) - this.getYear(second) ||
                this.getMonth(first) - this.getMonth(second) ||
                this.getDate(first) - this.getDate(second);
        };
        /**
         * Checks if two dates are equal.
         * @param first The first date to check.
         * @param second The second date to check.
         * @returns Whether the two dates are equal.
         *     Null dates are considered equal to other null dates.
         */
        /**
         * Checks if two dates are equal.
         * @param {?} first The first date to check.
         * @param {?} second The second date to check.
         * @return {?} Whether the two dates are equal.
         *     Null dates are considered equal to other null dates.
         */
        DateAdapter.prototype.sameDate = /**
         * Checks if two dates are equal.
         * @param {?} first The first date to check.
         * @param {?} second The second date to check.
         * @return {?} Whether the two dates are equal.
         *     Null dates are considered equal to other null dates.
         */
        function (first, second) {
            if (first && second) {
                var /** @type {?} */ firstValid = this.isValid(first);
                var /** @type {?} */ secondValid = this.isValid(second);
                if (firstValid && secondValid) {
                    return !this.compareDate(first, second);
                }
                return firstValid == secondValid;
            }
            return first == second;
        };
        /**
         * Clamp the given date between min and max dates.
         * @param date The date to clamp.
         * @param min The minimum value to allow. If null or omitted no min is enforced.
         * @param max The maximum value to allow. If null or omitted no max is enforced.
         * @returns `min` if `date` is less than `min`, `max` if date is greater than `max`,
         *     otherwise `date`.
         */
        /**
         * Clamp the given date between min and max dates.
         * @param {?} date The date to clamp.
         * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
         * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
         * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
         *     otherwise `date`.
         */
        DateAdapter.prototype.clampDate = /**
         * Clamp the given date between min and max dates.
         * @param {?} date The date to clamp.
         * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
         * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
         * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
         *     otherwise `date`.
         */
        function (date, min, max) {
            if (min && this.compareDate(date, min) < 0) {
                return min;
            }
            if (max && this.compareDate(date, max) > 0) {
                return max;
            }
            return date;
        };
        return DateAdapter;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ MAT_DATE_FORMATS = new core.InjectionToken('mat-date-formats');

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Whether the browser supports the Intl API.
     */
    var /** @type {?} */ SUPPORTS_INTL_API = typeof Intl != 'undefined';
    /**
     * The default month names to use if Intl API is not available.
     */
    var /** @type {?} */ DEFAULT_MONTH_NAMES = {
        'long': [
            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
            'October', 'November', 'December'
        ],
        'short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'narrow': ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
    };
    var ɵ0$2 = function (i) { return String(i + 1); };
    /**
     * The default date names to use if Intl API is not available.
     */
    var /** @type {?} */ DEFAULT_DATE_NAMES = range(31, ɵ0$2);
    /**
     * The default day of the week names to use if Intl API is not available.
     */
    var /** @type {?} */ DEFAULT_DAY_OF_WEEK_NAMES = {
        'long': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        'narrow': ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    };
    /**
     * Matches strings that have the form of a valid RFC 3339 string
     * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
     * because the regex will match strings an with out of bounds month, date, etc.
     */
    var /** @type {?} */ ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
    /**
     * Creates an array and fills it with values.
     * @template T
     * @param {?} length
     * @param {?} valueFunction
     * @return {?}
     */
    function range(length, valueFunction) {
        var /** @type {?} */ valuesArray = Array(length);
        for (var /** @type {?} */ i = 0; i < length; i++) {
            valuesArray[i] = valueFunction(i);
        }
        return valuesArray;
    }
    /**
     * Adapts the native JS Date for use with cdk-based components that work with dates.
     */
    var NativeDateAdapter = /** @class */ (function (_super) {
        __extends(NativeDateAdapter, _super);
        function NativeDateAdapter(matDateLocale, platform) {
            var _this = _super.call(this) || this;
            /**
             * Whether to use `timeZone: 'utc'` with `Intl.DateTimeFormat` when formatting dates.
             * Without this `Intl.DateTimeFormat` sometimes chooses the wrong timeZone, which can throw off
             * the result. (e.g. in the en-US locale `new Date(1800, 7, 14).toLocaleDateString()`
             * will produce `'8/13/1800'`.
             *
             * TODO(mmalerba): drop this variable. It's not being used in the code right now. We're now
             * getting the string representation of a Date object from it's utc representation. We're keeping
             * it here for sometime, just for precaution, in case we decide to revert some of these changes
             * though.
             */
            _this.useUtcForDisplay = true;
            _super.prototype.setLocale.call(_this, matDateLocale);
            // IE does its own time zone correction, so we disable this on IE.
            // IE does its own time zone correction, so we disable this on IE.
            _this.useUtcForDisplay = !platform.TRIDENT;
            _this._clampDate = platform.TRIDENT || platform.EDGE;
            return _this;
        }
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getYear = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date.getFullYear();
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getMonth = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date.getMonth();
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getDate = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date.getDate();
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getDayOfWeek = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date.getDay();
        };
        /**
         * @param {?} style
         * @return {?}
         */
        NativeDateAdapter.prototype.getMonthNames = /**
         * @param {?} style
         * @return {?}
         */
        function (style) {
            var _this = this;
            if (SUPPORTS_INTL_API) {
                var /** @type {?} */ dtf_1 = new Intl.DateTimeFormat(this.locale, { month: style, timeZone: 'utc' });
                return range(12, function (i) {
                    return _this._stripDirectionalityCharacters(_this._format(dtf_1, new Date(2017, i, 1)));
                });
            }
            return DEFAULT_MONTH_NAMES[style];
        };
        /**
         * @return {?}
         */
        NativeDateAdapter.prototype.getDateNames = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (SUPPORTS_INTL_API) {
                var /** @type {?} */ dtf_2 = new Intl.DateTimeFormat(this.locale, { day: 'numeric', timeZone: 'utc' });
                return range(31, function (i) {
                    return _this._stripDirectionalityCharacters(_this._format(dtf_2, new Date(2017, 0, i + 1)));
                });
            }
            return DEFAULT_DATE_NAMES;
        };
        /**
         * @param {?} style
         * @return {?}
         */
        NativeDateAdapter.prototype.getDayOfWeekNames = /**
         * @param {?} style
         * @return {?}
         */
        function (style) {
            var _this = this;
            if (SUPPORTS_INTL_API) {
                var /** @type {?} */ dtf_3 = new Intl.DateTimeFormat(this.locale, { weekday: style, timeZone: 'utc' });
                return range(7, function (i) {
                    return _this._stripDirectionalityCharacters(_this._format(dtf_3, new Date(2017, 0, i + 1)));
                });
            }
            return DEFAULT_DAY_OF_WEEK_NAMES[style];
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getYearName = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            if (SUPPORTS_INTL_API) {
                var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric', timeZone: 'utc' });
                return this._stripDirectionalityCharacters(this._format(dtf, date));
            }
            return String(this.getYear(date));
        };
        /**
         * @return {?}
         */
        NativeDateAdapter.prototype.getFirstDayOfWeek = /**
         * @return {?}
         */
        function () {
            // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
            return 0;
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.getNumDaysInMonth = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.clone = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return this.createDate(this.getYear(date), this.getMonth(date), this.getDate(date));
        };
        /**
         * @param {?} year
         * @param {?} month
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.createDate = /**
         * @param {?} year
         * @param {?} month
         * @param {?} date
         * @return {?}
         */
        function (year, month, date) {
            // Check for invalid month and date (except upper bound on date which we have to check after
            // creating the Date).
            if (month < 0 || month > 11) {
                throw Error("Invalid month index \"" + month + "\". Month index has to be between 0 and 11.");
            }
            if (date < 1) {
                throw Error("Invalid date \"" + date + "\". Date has to be greater than 0.");
            }
            var /** @type {?} */ result = this._createDateWithOverflow(year, month, date);
            // Check that the date wasn't above the upper bound for the month, causing the month to overflow
            if (result.getMonth() != month) {
                throw Error("Invalid date \"" + date + "\" for month with index \"" + month + "\".");
            }
            return result;
        };
        /**
         * @return {?}
         */
        NativeDateAdapter.prototype.today = /**
         * @return {?}
         */
        function () {
            return new Date();
        };
        /**
         * @param {?} value
         * @return {?}
         */
        NativeDateAdapter.prototype.parse = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            // We have no way using the native JS Date to set the parse format or locale, so we ignore these
            // parameters.
            if (typeof value == 'number') {
                return new Date(value);
            }
            return value ? new Date(Date.parse(value)) : null;
        };
        /**
         * @param {?} date
         * @param {?} displayFormat
         * @return {?}
         */
        NativeDateAdapter.prototype.format = /**
         * @param {?} date
         * @param {?} displayFormat
         * @return {?}
         */
        function (date, displayFormat) {
            if (!this.isValid(date)) {
                throw Error('NativeDateAdapter: Cannot format invalid date.');
            }
            if (SUPPORTS_INTL_API) {
                // On IE and Edge the i18n API will throw a hard error that can crash the entire app
                // if we attempt to format a date whose year is less than 1 or greater than 9999.
                if (this._clampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
                    date = this.clone(date);
                    date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
                }
                displayFormat = __assign({}, displayFormat, { timeZone: 'utc' });
                var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
                return this._stripDirectionalityCharacters(this._format(dtf, date));
            }
            return this._stripDirectionalityCharacters(date.toDateString());
        };
        /**
         * @param {?} date
         * @param {?} years
         * @return {?}
         */
        NativeDateAdapter.prototype.addCalendarYears = /**
         * @param {?} date
         * @param {?} years
         * @return {?}
         */
        function (date, years) {
            return this.addCalendarMonths(date, years * 12);
        };
        /**
         * @param {?} date
         * @param {?} months
         * @return {?}
         */
        NativeDateAdapter.prototype.addCalendarMonths = /**
         * @param {?} date
         * @param {?} months
         * @return {?}
         */
        function (date, months) {
            var /** @type {?} */ newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
            // It's possible to wind up in the wrong month if the original month has more days than the new
            // month. In this case we want to go to the last day of the desired month.
            // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
            // guarantee this.
            if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
                newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
            }
            return newDate;
        };
        /**
         * @param {?} date
         * @param {?} days
         * @return {?}
         */
        NativeDateAdapter.prototype.addCalendarDays = /**
         * @param {?} date
         * @param {?} days
         * @return {?}
         */
        function (date, days) {
            return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.toIso8601 = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return [
                date.getUTCFullYear(),
                this._2digit(date.getUTCMonth() + 1),
                this._2digit(date.getUTCDate())
            ].join('-');
        };
        /**
         * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
         * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
         * invalid date for all other values.
         */
        /**
         * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
         * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
         * invalid date for all other values.
         * @param {?} value
         * @return {?}
         */
        NativeDateAdapter.prototype.deserialize = /**
         * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
         * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
         * invalid date for all other values.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (typeof value === 'string') {
                if (!value) {
                    return null;
                }
                // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
                // string is the right format first.
                if (ISO_8601_REGEX.test(value)) {
                    var /** @type {?} */ date = new Date(value);
                    if (this.isValid(date)) {
                        return date;
                    }
                }
            }
            return _super.prototype.deserialize.call(this, value);
        };
        /**
         * @param {?} obj
         * @return {?}
         */
        NativeDateAdapter.prototype.isDateInstance = /**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            return obj instanceof Date;
        };
        /**
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype.isValid = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return !isNaN(date.getTime());
        };
        /**
         * @return {?}
         */
        NativeDateAdapter.prototype.invalid = /**
         * @return {?}
         */
        function () {
            return new Date(NaN);
        };
        /**
         * Creates a date but allows the month and date to overflow.
         * @param {?} year
         * @param {?} month
         * @param {?} date
         * @return {?}
         */
        NativeDateAdapter.prototype._createDateWithOverflow = /**
         * Creates a date but allows the month and date to overflow.
         * @param {?} year
         * @param {?} month
         * @param {?} date
         * @return {?}
         */
        function (year, month, date) {
            var /** @type {?} */ result = new Date(year, month, date);
            // We need to correct for the fact that JS native Date treats years in range [0, 99] as
            // abbreviations for 19xx.
            if (year >= 0 && year < 100) {
                result.setFullYear(this.getYear(result) - 1900);
            }
            return result;
        };
        /**
         * Pads a number to make it two digits.
         * @param {?} n The number to pad.
         * @return {?} The padded number.
         */
        NativeDateAdapter.prototype._2digit = /**
         * Pads a number to make it two digits.
         * @param {?} n The number to pad.
         * @return {?} The padded number.
         */
        function (n) {
            return ('00' + n).slice(-2);
        };
        /**
         * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
         * other browsers do not. We remove them to make output consistent and because they interfere with
         * date parsing.
         * @param {?} str The string to strip direction characters from.
         * @return {?} The stripped string.
         */
        NativeDateAdapter.prototype._stripDirectionalityCharacters = /**
         * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
         * other browsers do not. We remove them to make output consistent and because they interfere with
         * date parsing.
         * @param {?} str The string to strip direction characters from.
         * @return {?} The stripped string.
         */
        function (str) {
            return str.replace(/[\u200e\u200f]/g, '');
        };
        /**
         * When converting Date object to string, javascript built-in functions may return wrong
         * results because it applies its internal DST rules. The DST rules around the world change
         * very frequently, and the current valid rule is not always valid in previous years though.
         * We work around this problem building a new Date object which has its internal UTC
         * representation with the local date and time.
         * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
         *    timeZone set to 'utc' to work fine.
         * @param {?} date Date from which we want to get the string representation according to dtf
         * @return {?} A Date object with its UTC representation based on the passed in date info
         */
        NativeDateAdapter.prototype._format = /**
         * When converting Date object to string, javascript built-in functions may return wrong
         * results because it applies its internal DST rules. The DST rules around the world change
         * very frequently, and the current valid rule is not always valid in previous years though.
         * We work around this problem building a new Date object which has its internal UTC
         * representation with the local date and time.
         * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
         *    timeZone set to 'utc' to work fine.
         * @param {?} date Date from which we want to get the string representation according to dtf
         * @return {?} A Date object with its UTC representation based on the passed in date info
         */
        function (dtf, date) {
            var /** @type {?} */ d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
            return dtf.format(d);
        };
        NativeDateAdapter.decorators = [
            { type: core.Injectable },
        ];
        /** @nocollapse */
        NativeDateAdapter.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_LOCALE,] },] },
            { type: Platform, },
        ]; };
        return NativeDateAdapter;
    }(DateAdapter));
    /**
     * Provider that defines how form controls behave with regards to displaying error messages.
     */
    var ErrorStateMatcher = /** @class */ (function () {
        function ErrorStateMatcher() {
        }
        /**
         * @param {?} control
         * @param {?} form
         * @return {?}
         */
        ErrorStateMatcher.prototype.isErrorState = /**
         * @param {?} control
         * @param {?} form
         * @return {?}
         */
        function (control, form) {
            return !!(control && control.invalid && (control.touched || (form && form.submitted)));
        };
        ErrorStateMatcher.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ ErrorStateMatcher.ngInjectableDef = core.defineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
        return ErrorStateMatcher;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to provide options to the Hammerjs instance.
     * More info at http://hammerjs.github.io/api/.
     */
    var /** @type {?} */ MAT_HAMMER_OPTIONS = new core.InjectionToken('MAT_HAMMER_OPTIONS');
    /**
     * Adjusts configuration of our gesture library, Hammer.
     */
    var GestureConfig = /** @class */ (function (_super) {
        __extends(GestureConfig, _super);
        function GestureConfig(_hammerOptions, commonModule) {
            var _this = _super.call(this) || this;
            _this._hammerOptions = _hammerOptions;
            _this._hammer = typeof window !== 'undefined' ? (/** @type {?} */ (window)).Hammer : null;
            /**
             * List of new event names to add to the gesture support list
             */
            _this.events = _this._hammer ? [
                'longpress',
                'slide',
                'slidestart',
                'slideend',
                'slideright',
                'slideleft'
            ] : [];
            if (commonModule) {
                commonModule._checkHammerIsAvailable();
            }
            return _this;
        }
        /**
         * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
         *
         * Our gesture names come from the Material Design gestures spec:
         * https://material.io/design/#gestures-touch-mechanics
         *
         * More information on default recognizers can be found in Hammer docs:
         * http://hammerjs.github.io/recognizer-pan/
         * http://hammerjs.github.io/recognizer-press/
         *
         * @param element Element to which to assign the new HammerJS gestures.
         * @returns Newly-created HammerJS instance.
         */
        /**
         * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
         *
         * Our gesture names come from the Material Design gestures spec:
         * https://material.io/design/#gestures-touch-mechanics
         *
         * More information on default recognizers can be found in Hammer docs:
         * http://hammerjs.github.io/recognizer-pan/
         * http://hammerjs.github.io/recognizer-press/
         *
         * @param {?} element Element to which to assign the new HammerJS gestures.
         * @return {?} Newly-created HammerJS instance.
         */
        GestureConfig.prototype.buildHammer = /**
         * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
         *
         * Our gesture names come from the Material Design gestures spec:
         * https://material.io/design/#gestures-touch-mechanics
         *
         * More information on default recognizers can be found in Hammer docs:
         * http://hammerjs.github.io/recognizer-pan/
         * http://hammerjs.github.io/recognizer-press/
         *
         * @param {?} element Element to which to assign the new HammerJS gestures.
         * @return {?} Newly-created HammerJS instance.
         */
        function (element) {
            var /** @type {?} */ mc = new this._hammer(element, this._hammerOptions || undefined);
            // Default Hammer Recognizers.
            var /** @type {?} */ pan = new this._hammer.Pan();
            var /** @type {?} */ swipe = new this._hammer.Swipe();
            var /** @type {?} */ press = new this._hammer.Press();
            // Notice that a HammerJS recognizer can only depend on one other recognizer once.
            // Otherwise the previous `recognizeWith` will be dropped.
            // TODO: Confirm threshold numbers with Material Design UX Team
            var /** @type {?} */ slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
            var /** @type {?} */ longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
            // Overwrite the default `pan` event to use the swipe event.
            pan.recognizeWith(swipe);
            // Add customized gestures to Hammer manager
            mc.add([swipe, press, pan, slide, longpress]);
            return /** @type {?} */ (mc);
        };
        /**
         * Creates a new recognizer, without affecting the default recognizers of HammerJS
         * @param {?} base
         * @param {?} options
         * @param {...?} inheritances
         * @return {?}
         */
        GestureConfig.prototype._createRecognizer = /**
         * Creates a new recognizer, without affecting the default recognizers of HammerJS
         * @param {?} base
         * @param {?} options
         * @param {...?} inheritances
         * @return {?}
         */
        function (base, options) {
            var inheritances = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                inheritances[_i - 2] = arguments[_i];
            }
            var /** @type {?} */ recognizer = new (/** @type {?} */ (base.constructor))(options);
            inheritances.push(base);
            inheritances.forEach(function (item) { return recognizer.recognizeWith(item); });
            return recognizer;
        };
        GestureConfig.decorators = [
            { type: core.Injectable },
        ];
        /** @nocollapse */
        GestureConfig.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_HAMMER_OPTIONS,] },] },
            { type: MatCommonModule, decorators: [{ type: core.Optional },] },
        ]; };
        return GestureConfig;
    }(HammerGestureConfig));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Shared directive to count lines inside a text area, such as a list item.
     * Line elements can be extracted with a \@ContentChildren(MatLine) query, then
     * counted by checking the query list's length.
     */
    var MatLine = /** @class */ (function () {
        function MatLine() {
        }
        MatLine.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-line], [matLine]',
                        host: { 'class': 'mat-line' }
                    },] },
        ];
        return MatLine;
    }());
    /**
     * Helper that takes a query list of lines and sets the correct class on the host.
     * \@docs-private
     */
    var  /**
     * Helper that takes a query list of lines and sets the correct class on the host.
     * \@docs-private
     */
    MatLineSetter = /** @class */ (function () {
        function MatLineSetter(_lines, _element) {
            var _this = this;
            this._lines = _lines;
            this._element = _element;
            this._setLineClass(this._lines.length);
            this._lines.changes.subscribe(function () {
                _this._setLineClass(_this._lines.length);
            });
        }
        /**
         * @param {?} count
         * @return {?}
         */
        MatLineSetter.prototype._setLineClass = /**
         * @param {?} count
         * @return {?}
         */
        function (count) {
            this._resetClasses();
            if (count === 2 || count === 3) {
                this._setClass("mat-" + count + "-line", true);
            }
            else if (count > 3) {
                this._setClass("mat-multi-line", true);
            }
        };
        /**
         * @return {?}
         */
        MatLineSetter.prototype._resetClasses = /**
         * @return {?}
         */
        function () {
            this._setClass('mat-2-line', false);
            this._setClass('mat-3-line', false);
            this._setClass('mat-multi-line', false);
        };
        /**
         * @param {?} className
         * @param {?} isAdd
         * @return {?}
         */
        MatLineSetter.prototype._setClass = /**
         * @param {?} className
         * @param {?} isAdd
         * @return {?}
         */
        function (className, isAdd) {
            if (isAdd) {
                this._element.nativeElement.classList.add(className);
            }
            else {
                this._element.nativeElement.classList.remove(className);
            }
        };
        return MatLineSetter;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /** @enum {number} */
    var RippleState = {
        FADING_IN: 0,
        VISIBLE: 1,
        FADING_OUT: 2,
        HIDDEN: 3,
    };
    RippleState[RippleState.FADING_IN] = "FADING_IN";
    RippleState[RippleState.VISIBLE] = "VISIBLE";
    RippleState[RippleState.FADING_OUT] = "FADING_OUT";
    RippleState[RippleState.HIDDEN] = "HIDDEN";
    /**
     * Reference to a previously launched ripple element.
     */
    var  /**
     * Reference to a previously launched ripple element.
     */
    RippleRef = /** @class */ (function () {
        function RippleRef(_renderer, element, config) {
            this._renderer = _renderer;
            this.element = element;
            this.config = config;
            /**
             * Current state of the ripple reference.
             */
            this.state = RippleState.HIDDEN;
        }
        /** Fades out the ripple element. */
        /**
         * Fades out the ripple element.
         * @return {?}
         */
        RippleRef.prototype.fadeOut = /**
         * Fades out the ripple element.
         * @return {?}
         */
        function () {
            this._renderer.fadeOutRipple(this);
        };
        return RippleRef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Default ripple animation configuration for ripples without an explicit
     * animation config specified.
     */
    var /** @type {?} */ defaultRippleAnimationConfig = {
        enterDuration: 450,
        exitDuration: 400
    };
    /**
     * Timeout for ignoring mouse events. Mouse events will be temporary ignored after touch
     * events to avoid synthetic mouse events.
     */
    var /** @type {?} */ ignoreMouseEventsTimeout = 800;
    /**
     * Helper service that performs DOM manipulations. Not intended to be used outside this module.
     * The constructor takes a reference to the ripple directive's host element and a map of DOM
     * event handlers to be installed on the element that triggers ripple animations.
     * This will eventually become a custom renderer once Angular support exists.
     * \@docs-private
     */
    var  /**
     * Helper service that performs DOM manipulations. Not intended to be used outside this module.
     * The constructor takes a reference to the ripple directive's host element and a map of DOM
     * event handlers to be installed on the element that triggers ripple animations.
     * This will eventually become a custom renderer once Angular support exists.
     * \@docs-private
     */
    RippleRenderer = /** @class */ (function () {
        function RippleRenderer(_target, _ngZone, elementRef, platform) {
            var _this = this;
            this._target = _target;
            this._ngZone = _ngZone;
            /**
             * Whether the pointer is currently down or not.
             */
            this._isPointerDown = false;
            /**
             * Events to be registered on the trigger element.
             */
            this._triggerEvents = new Map();
            /**
             * Set of currently active ripple references.
             */
            this._activeRipples = new Set();
            /**
             * Options that apply to all the event listeners that are bound by the renderer.
             */
            this._eventOptions = supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true })) : false;
            /**
             * Function being called whenever the trigger is being pressed using mouse.
             */
            this.onMousedown = function (event) {
                var /** @type {?} */ isSyntheticEvent = _this._lastTouchStartEvent &&
                    Date.now() < _this._lastTouchStartEvent + ignoreMouseEventsTimeout;
                if (!_this._target.rippleDisabled && !isSyntheticEvent) {
                    _this._isPointerDown = true;
                    _this.fadeInRipple(event.clientX, event.clientY, _this._target.rippleConfig);
                }
            };
            /**
             * Function being called whenever the trigger is being pressed using touch.
             */
            this.onTouchStart = function (event) {
                if (!_this._target.rippleDisabled) {
                    // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
                    // events will launch a second ripple if we don't ignore mouse events for a specific
                    // time after a touchstart event.
                    // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
                    // events will launch a second ripple if we don't ignore mouse events for a specific
                    // time after a touchstart event.
                    _this._lastTouchStartEvent = Date.now();
                    _this._isPointerDown = true;
                    _this.fadeInRipple(event.touches[0].clientX, event.touches[0].clientY, _this._target.rippleConfig);
                }
            };
            /**
             * Function being called whenever the trigger is being released.
             */
            this.onPointerUp = function () {
                if (!_this._isPointerDown) {
                    return;
                }
                _this._isPointerDown = false;
                // Fade-out all ripples that are visible and not persistent.
                // Fade-out all ripples that are visible and not persistent.
                _this._activeRipples.forEach(function (ripple) {
                    // By default, only ripples that are completely visible will fade out on pointer release.
                    // If the `terminateOnPointerUp` option is set, ripples that still fade in will also fade out.
                    var /** @type {?} */ isVisible = ripple.state === RippleState.VISIBLE ||
                        ripple.config.terminateOnPointerUp && ripple.state === RippleState.FADING_IN;
                    if (!ripple.config.persistent && isVisible) {
                        ripple.fadeOut();
                    }
                });
            };
            // Only do anything if we're on the browser.
            if (platform.isBrowser) {
                this._containerElement = elementRef.nativeElement;
                // Specify events which need to be registered on the trigger.
                this._triggerEvents.set('mousedown', this.onMousedown);
                this._triggerEvents.set('mouseup', this.onPointerUp);
                this._triggerEvents.set('mouseleave', this.onPointerUp);
                this._triggerEvents.set('touchstart', this.onTouchStart);
                this._triggerEvents.set('touchend', this.onPointerUp);
            }
        }
        /**
         * Fades in a ripple at the given coordinates.
         * @param x Coordinate within the element, along the X axis at which to start the ripple.
         * @param y Coordinate within the element, along the Y axis at which to start the ripple.
         * @param config Extra ripple options.
         */
        /**
         * Fades in a ripple at the given coordinates.
         * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
         * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
         * @param {?=} config Extra ripple options.
         * @return {?}
         */
        RippleRenderer.prototype.fadeInRipple = /**
         * Fades in a ripple at the given coordinates.
         * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
         * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
         * @param {?=} config Extra ripple options.
         * @return {?}
         */
        function (x, y, config) {
            var _this = this;
            if (config === void 0) { config = {}; }
            var /** @type {?} */ containerRect = this._containerRect =
                this._containerRect || this._containerElement.getBoundingClientRect();
            var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, config.animation);
            if (config.centered) {
                x = containerRect.left + containerRect.width / 2;
                y = containerRect.top + containerRect.height / 2;
            }
            var /** @type {?} */ radius = config.radius || distanceToFurthestCorner(x, y, containerRect);
            var /** @type {?} */ offsetX = x - containerRect.left;
            var /** @type {?} */ offsetY = y - containerRect.top;
            var /** @type {?} */ duration = animationConfig.enterDuration / (config.speedFactor || 1);
            var /** @type {?} */ ripple = document.createElement('div');
            ripple.classList.add('mat-ripple-element');
            ripple.style.left = offsetX - radius + "px";
            ripple.style.top = offsetY - radius + "px";
            ripple.style.height = radius * 2 + "px";
            ripple.style.width = radius * 2 + "px";
            // If the color is not set, the default CSS color will be used.
            ripple.style.backgroundColor = config.color || null;
            ripple.style.transitionDuration = duration + "ms";
            this._containerElement.appendChild(ripple);
            // By default the browser does not recalculate the styles of dynamically created
            // ripple elements. This is critical because then the `scale` would not animate properly.
            enforceStyleRecalculation(ripple);
            ripple.style.transform = 'scale(1)';
            // Exposed reference to the ripple that will be returned.
            var /** @type {?} */ rippleRef = new RippleRef(this, ripple, config);
            rippleRef.state = RippleState.FADING_IN;
            // Add the ripple reference to the list of all active ripples.
            this._activeRipples.add(rippleRef);
            if (!config.persistent) {
                this._mostRecentTransientRipple = rippleRef;
            }
            // Wait for the ripple element to be completely faded in.
            // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
            this.runTimeoutOutsideZone(function () {
                var /** @type {?} */ isMostRecentTransientRipple = rippleRef === _this._mostRecentTransientRipple;
                rippleRef.state = RippleState.VISIBLE;
                // When the timer runs out while the user has kept their pointer down, we want to
                // keep only the persistent ripples and the latest transient ripple. We do this,
                // because we don't want stacked transient ripples to appear after their enter
                // animation has finished.
                if (!config.persistent && (!isMostRecentTransientRipple || !_this._isPointerDown)) {
                    rippleRef.fadeOut();
                }
            }, duration);
            return rippleRef;
        };
        /** Fades out a ripple reference. */
        /**
         * Fades out a ripple reference.
         * @param {?} rippleRef
         * @return {?}
         */
        RippleRenderer.prototype.fadeOutRipple = /**
         * Fades out a ripple reference.
         * @param {?} rippleRef
         * @return {?}
         */
        function (rippleRef) {
            var /** @type {?} */ wasActive = this._activeRipples.delete(rippleRef);
            if (rippleRef === this._mostRecentTransientRipple) {
                this._mostRecentTransientRipple = null;
            }
            // Clear out the cached bounding rect if we have no more ripples.
            if (!this._activeRipples.size) {
                this._containerRect = null;
            }
            // For ripples that are not active anymore, don't re-un the fade-out animation.
            if (!wasActive) {
                return;
            }
            var /** @type {?} */ rippleEl = rippleRef.element;
            var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, rippleRef.config.animation);
            rippleEl.style.transitionDuration = animationConfig.exitDuration + "ms";
            rippleEl.style.opacity = '0';
            rippleRef.state = RippleState.FADING_OUT;
            // Once the ripple faded out, the ripple can be safely removed from the DOM.
            this.runTimeoutOutsideZone(function () {
                rippleRef.state = RippleState.HIDDEN; /** @type {?} */
                ((rippleEl.parentNode)).removeChild(rippleEl);
            }, animationConfig.exitDuration);
        };
        /** Fades out all currently active ripples. */
        /**
         * Fades out all currently active ripples.
         * @return {?}
         */
        RippleRenderer.prototype.fadeOutAll = /**
         * Fades out all currently active ripples.
         * @return {?}
         */
        function () {
            this._activeRipples.forEach(function (ripple) { return ripple.fadeOut(); });
        };
        /** Sets up the trigger event listeners */
        /**
         * Sets up the trigger event listeners
         * @param {?} element
         * @return {?}
         */
        RippleRenderer.prototype.setupTriggerEvents = /**
         * Sets up the trigger event listeners
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var _this = this;
            if (!element || element === this._triggerElement) {
                return;
            }
            // Remove all previously registered event listeners from the trigger element.
            this._removeTriggerEvents();
            this._ngZone.runOutsideAngular(function () {
                _this._triggerEvents.forEach(function (fn, type) {
                    return element.addEventListener(type, fn, _this._eventOptions);
                });
            });
            this._triggerElement = element;
        };
        /**
         * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
         * @param {?} fn
         * @param {?=} delay
         * @return {?}
         */
        RippleRenderer.prototype.runTimeoutOutsideZone = /**
         * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
         * @param {?} fn
         * @param {?=} delay
         * @return {?}
         */
        function (fn, delay) {
            if (delay === void 0) { delay = 0; }
            this._ngZone.runOutsideAngular(function () { return setTimeout(fn, delay); });
        };
        /** Removes previously registered event listeners from the trigger element. */
        /**
         * Removes previously registered event listeners from the trigger element.
         * @return {?}
         */
        RippleRenderer.prototype._removeTriggerEvents = /**
         * Removes previously registered event listeners from the trigger element.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._triggerElement) {
                this._triggerEvents.forEach(function (fn, type) {
                    /** @type {?} */ ((_this._triggerElement)).removeEventListener(type, fn, _this._eventOptions);
                });
            }
        };
        return RippleRenderer;
    }());
    /**
     * Enforces a style recalculation of a DOM element by computing its styles.
     * @param {?} element
     * @return {?}
     */
    function enforceStyleRecalculation(element) {
        // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
        // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
        // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
        window.getComputedStyle(element).getPropertyValue('opacity');
    }
    /**
     * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
     * @param {?} x
     * @param {?} y
     * @param {?} rect
     * @return {?}
     */
    function distanceToFurthestCorner(x, y, rect) {
        var /** @type {?} */ distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
        var /** @type {?} */ distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
        return Math.sqrt(distX * distX + distY * distY);
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to specify the global ripple options.
     */
    var /** @type {?} */ MAT_RIPPLE_GLOBAL_OPTIONS = new core.InjectionToken('mat-ripple-global-options');
    var MatRipple = /** @class */ (function () {
        function MatRipple(_elementRef, ngZone, platform, globalOptions, _animationMode) {
            this._elementRef = _elementRef;
            this._animationMode = _animationMode;
            /**
             * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
             * will be the distance from the center of the ripple to the furthest corner of the host element's
             * bounding rectangle.
             */
            this.radius = 0;
            /**
             * If set, the normal duration of ripple animations is divided by this value. For example,
             * setting it to 0.5 will cause the animations to take twice as long.
             * A changed speedFactor will not modify the fade-out duration of the ripples.
             * @deprecated Use the [matRippleAnimation] binding instead.
             * \@deletion-target 7.0.0
             */
            this.speedFactor = 1;
            this._disabled = false;
            /**
             * Whether ripple directive is initialized and the input bindings are set.
             */
            this._isInitialized = false;
            this._globalOptions = globalOptions || {};
            this._rippleRenderer = new RippleRenderer(this, ngZone, _elementRef, platform);
        }
        Object.defineProperty(MatRipple.prototype, "disabled", {
            get: /**
             * Whether click events will not trigger the ripple. Ripples can be still launched manually
             * by using the `launch()` method.
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = value;
                this._setupTriggerEventsIfEnabled();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRipple.prototype, "trigger", {
            get: /**
             * The element that triggers the ripple when click events are received.
             * Defaults to the directive's host element.
             * @return {?}
             */
            function () { return this._trigger || this._elementRef.nativeElement; },
            set: /**
             * @param {?} trigger
             * @return {?}
             */
            function (trigger) {
                this._trigger = trigger;
                this._setupTriggerEventsIfEnabled();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatRipple.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._isInitialized = true;
            this._setupTriggerEventsIfEnabled();
        };
        /**
         * @return {?}
         */
        MatRipple.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._rippleRenderer._removeTriggerEvents();
        };
        /** Fades out all currently showing ripple elements. */
        /**
         * Fades out all currently showing ripple elements.
         * @return {?}
         */
        MatRipple.prototype.fadeOutAll = /**
         * Fades out all currently showing ripple elements.
         * @return {?}
         */
        function () {
            this._rippleRenderer.fadeOutAll();
        };
        Object.defineProperty(MatRipple.prototype, "rippleConfig", {
            /** Ripple configuration from the directive's input values. */
            get: /**
             * Ripple configuration from the directive's input values.
             * @return {?}
             */
            function () {
                return {
                    centered: this.centered,
                    radius: this.radius,
                    color: this.color,
                    animation: this._animationMode === 'NoopAnimations' ?
                        { enterDuration: 0, exitDuration: 0 } : __assign({}, this._globalOptions.animation, this.animation),
                    terminateOnPointerUp: this._globalOptions.terminateOnPointerUp,
                    speedFactor: this.speedFactor * (this._globalOptions.baseSpeedFactor || 1),
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRipple.prototype, "rippleDisabled", {
            /** Whether ripples on pointer-down are disabled or not. */
            get: /**
             * Whether ripples on pointer-down are disabled or not.
             * @return {?}
             */
            function () {
                return this.disabled || !!this._globalOptions.disabled;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets up the the trigger event listeners if ripples are enabled.
         * @return {?}
         */
        MatRipple.prototype._setupTriggerEventsIfEnabled = /**
         * Sets up the the trigger event listeners if ripples are enabled.
         * @return {?}
         */
        function () {
            if (!this.disabled && this._isInitialized) {
                this._rippleRenderer.setupTriggerEvents(this.trigger);
            }
        };
        /** Launches a manual ripple at the specified coordinated or just by the ripple config. */
        /**
         * Launches a manual ripple at the specified coordinated or just by the ripple config.
         * @param {?} configOrX
         * @param {?=} y
         * @param {?=} config
         * @return {?}
         */
        MatRipple.prototype.launch = /**
         * Launches a manual ripple at the specified coordinated or just by the ripple config.
         * @param {?} configOrX
         * @param {?=} y
         * @param {?=} config
         * @return {?}
         */
        function (configOrX, y, config) {
            if (y === void 0) { y = 0; }
            if (typeof configOrX === 'number') {
                return this._rippleRenderer.fadeInRipple(configOrX, y, __assign({}, this.rippleConfig, config));
            }
            else {
                return this._rippleRenderer.fadeInRipple(0, 0, __assign({}, this.rippleConfig, configOrX));
            }
        };
        MatRipple.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-ripple], [matRipple]',
                        exportAs: 'matRipple',
                        host: {
                            'class': 'mat-ripple',
                            '[class.mat-ripple-unbounded]': 'unbounded'
                        }
                    },] },
        ];
        /** @nocollapse */
        MatRipple.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatRipple.propDecorators = {
            "color": [{ type: core.Input, args: ['matRippleColor',] },],
            "unbounded": [{ type: core.Input, args: ['matRippleUnbounded',] },],
            "centered": [{ type: core.Input, args: ['matRippleCentered',] },],
            "radius": [{ type: core.Input, args: ['matRippleRadius',] },],
            "speedFactor": [{ type: core.Input, args: ['matRippleSpeedFactor',] },],
            "animation": [{ type: core.Input, args: ['matRippleAnimation',] },],
            "disabled": [{ type: core.Input, args: ['matRippleDisabled',] },],
            "trigger": [{ type: core.Input, args: ['matRippleTrigger',] },],
        };
        return MatRipple;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatRippleModule = /** @class */ (function () {
        function MatRippleModule() {
        }
        MatRippleModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatCommonModule, PlatformModule],
                        exports: [MatRipple, MatCommonModule],
                        declarations: [MatRipple],
                    },] },
        ];
        return MatRippleModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Component that shows a simplified checkbox without including any kind of "real" checkbox.
     * Meant to be used when the checkbox is purely decorative and a large number of them will be
     * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
     * Note that theming is meant to be handled by the parent element, e.g.
     * `mat-primary .mat-pseudo-checkbox`.
     *
     * Note that this component will be completely invisible to screen-reader users. This is *not*
     * interchangeable with `<mat-checkbox>` and should *not* be used if the user would directly
     * interact with the checkbox. The pseudo-checkbox should only be used as an implementation detail
     * of more complex components that appropriately handle selected / checked state.
     * \@docs-private
     */
    var MatPseudoCheckbox = /** @class */ (function () {
        function MatPseudoCheckbox(_animationMode) {
            this._animationMode = _animationMode;
            /**
             * Display state of the checkbox.
             */
            this.state = 'unchecked';
            /**
             * Whether the checkbox is disabled.
             */
            this.disabled = false;
        }
        MatPseudoCheckbox.decorators = [
            { type: core.Component, args: [{encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        selector: 'mat-pseudo-checkbox',
                        styles: [".mat-pseudo-checkbox{width:20px;height:20px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;flex-shrink:0;transition:border-color 90ms cubic-bezier(0,0,.2,.1),background-color 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:'';border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border-color:transparent}._mat-animation-noopable.mat-pseudo-checkbox{transition:none;animation:none}._mat-animation-noopable.mat-pseudo-checkbox::after{transition:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:7px;left:0;width:16px;opacity:1}.mat-pseudo-checkbox-checked::after{top:3px;left:1px;width:12px;height:5px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1}"],
                        template: '',
                        host: {
                            'class': 'mat-pseudo-checkbox',
                            '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
                            '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
                            '[class.mat-pseudo-checkbox-disabled]': 'disabled',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatPseudoCheckbox.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatPseudoCheckbox.propDecorators = {
            "state": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
        };
        return MatPseudoCheckbox;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatPseudoCheckboxModule = /** @class */ (function () {
        function MatPseudoCheckboxModule() {
        }
        MatPseudoCheckboxModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MatPseudoCheckbox],
                        declarations: [MatPseudoCheckbox]
                    },] },
        ];
        return MatPseudoCheckboxModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatOptgroupBase = /** @class */ (function () {
        function MatOptgroupBase() {
        }
        return MatOptgroupBase;
    }());
    var /** @type {?} */ _MatOptgroupMixinBase = mixinDisabled(MatOptgroupBase);
    // Counter for unique group ids.
    var /** @type {?} */ _uniqueOptgroupIdCounter = 0;
    /**
     * Component that is used to group instances of `mat-option`.
     */
    var MatOptgroup = /** @class */ (function (_super) {
        __extends(MatOptgroup, _super);
        function MatOptgroup() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /**
             * Unique id for the underlying label.
             */
            _this._labelId = "mat-optgroup-label-" + _uniqueOptgroupIdCounter++;
            return _this;
        }
        MatOptgroup.decorators = [
            { type: core.Component, args: [{selector: 'mat-optgroup',
                        exportAs: 'matOptgroup',
                        template: "<label class=\"mat-optgroup-label\" [id]=\"_labelId\">{{ label }}</label><ng-content select=\"mat-option, ng-container\"></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['disabled'],
                        styles: [".mat-optgroup-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup-label[disabled]{cursor:default}[dir=rtl] .mat-optgroup-label{text-align:right}.mat-optgroup-label .mat-icon{margin-right:16px;vertical-align:middle}.mat-optgroup-label .mat-icon svg{vertical-align:top}[dir=rtl] .mat-optgroup-label .mat-icon{margin-left:16px;margin-right:0}"],
                        host: {
                            'class': 'mat-optgroup',
                            'role': 'group',
                            '[class.mat-optgroup-disabled]': 'disabled',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.aria-labelledby]': '_labelId',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatOptgroup.propDecorators = {
            "label": [{ type: core.Input },],
        };
        return MatOptgroup;
    }(_MatOptgroupMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Option IDs need to be unique across components, so this counter exists outside of
     * the component definition.
     */
    var /** @type {?} */ _uniqueIdCounter = 0;
    /**
     * Event object emitted by MatOption when selected or deselected.
     */
    var  /**
     * Event object emitted by MatOption when selected or deselected.
     */
    MatOptionSelectionChange = /** @class */ (function () {
        function MatOptionSelectionChange(source, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this.source = source;
            this.isUserInput = isUserInput;
        }
        return MatOptionSelectionChange;
    }());
    /**
     * Injection token used to provide the parent component to options.
     */
    var /** @type {?} */ MAT_OPTION_PARENT_COMPONENT = new core.InjectionToken('MAT_OPTION_PARENT_COMPONENT');
    /**
     * Single option inside of a `<mat-select>` element.
     */
    var MatOption = /** @class */ (function () {
        function MatOption(_element, _changeDetectorRef, _parent, group) {
            this._element = _element;
            this._changeDetectorRef = _changeDetectorRef;
            this._parent = _parent;
            this.group = group;
            this._selected = false;
            this._active = false;
            this._disabled = false;
            this._id = "mat-option-" + _uniqueIdCounter++;
            this._mostRecentViewValue = '';
            /**
             * Event emitted when the option is selected or deselected.
             */
            this.onSelectionChange = new core.EventEmitter();
            /**
             * Emits when the state of the option changes and any parents have to be notified.
             */
            this._stateChanges = new rxjs.Subject();
        }
        Object.defineProperty(MatOption.prototype, "multiple", {
            /** Whether the wrapping component is in multiple selection mode. */
            get: /**
             * Whether the wrapping component is in multiple selection mode.
             * @return {?}
             */
            function () { return this._parent && this._parent.multiple; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "id", {
            /** The unique ID of the option. */
            get: /**
             * The unique ID of the option.
             * @return {?}
             */
            function () { return this._id; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "selected", {
            /** Whether or not the option is currently selected. */
            get: /**
             * Whether or not the option is currently selected.
             * @return {?}
             */
            function () { return this._selected; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "disabled", {
            get: /**
             * Whether the option is disabled.
             * @return {?}
             */
            function () { return (this.group && this.group.disabled) || this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._disabled = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "disableRipple", {
            /** Whether ripples for the option are disabled. */
            get: /**
             * Whether ripples for the option are disabled.
             * @return {?}
             */
            function () { return this._parent && this._parent.disableRipple; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "active", {
            /**
             * Whether or not the option is currently active and ready to be selected.
             * An active option displays styles as if it is focused, but the
             * focus is actually retained somewhere else. This comes in handy
             * for components like autocomplete where focus must remain on the input.
             */
            get: /**
             * Whether or not the option is currently active and ready to be selected.
             * An active option displays styles as if it is focused, but the
             * focus is actually retained somewhere else. This comes in handy
             * for components like autocomplete where focus must remain on the input.
             * @return {?}
             */
            function () {
                return this._active;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatOption.prototype, "viewValue", {
            /**
             * The displayed value of the option. It is necessary to show the selected option in the
             * select's trigger.
             */
            get: /**
             * The displayed value of the option. It is necessary to show the selected option in the
             * select's trigger.
             * @return {?}
             */
            function () {
                // TODO(kara): Add input property alternative for node envs.
                return (this._getHostElement().textContent || '').trim();
            },
            enumerable: true,
            configurable: true
        });
        /** Selects the option. */
        /**
         * Selects the option.
         * @return {?}
         */
        MatOption.prototype.select = /**
         * Selects the option.
         * @return {?}
         */
        function () {
            if (!this._selected) {
                this._selected = true;
                this._changeDetectorRef.markForCheck();
                this._emitSelectionChangeEvent();
            }
        };
        /** Deselects the option. */
        /**
         * Deselects the option.
         * @return {?}
         */
        MatOption.prototype.deselect = /**
         * Deselects the option.
         * @return {?}
         */
        function () {
            if (this._selected) {
                this._selected = false;
                this._changeDetectorRef.markForCheck();
                this._emitSelectionChangeEvent();
            }
        };
        /** Sets focus onto this option. */
        /**
         * Sets focus onto this option.
         * @return {?}
         */
        MatOption.prototype.focus = /**
         * Sets focus onto this option.
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this._getHostElement();
            if (typeof element.focus === 'function') {
                element.focus();
            }
        };
        /**
         * This method sets display styles on the option to make it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         */
        /**
         * This method sets display styles on the option to make it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         * @return {?}
         */
        MatOption.prototype.setActiveStyles = /**
         * This method sets display styles on the option to make it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         * @return {?}
         */
        function () {
            if (!this._active) {
                this._active = true;
                this._changeDetectorRef.markForCheck();
            }
        };
        /**
         * This method removes display styles on the option that made it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         */
        /**
         * This method removes display styles on the option that made it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         * @return {?}
         */
        MatOption.prototype.setInactiveStyles = /**
         * This method removes display styles on the option that made it appear
         * active. This is used by the ActiveDescendantKeyManager so key
         * events will display the proper options as active on arrow key events.
         * @return {?}
         */
        function () {
            if (this._active) {
                this._active = false;
                this._changeDetectorRef.markForCheck();
            }
        };
        /** Gets the label to be used when determining whether the option should be focused. */
        /**
         * Gets the label to be used when determining whether the option should be focused.
         * @return {?}
         */
        MatOption.prototype.getLabel = /**
         * Gets the label to be used when determining whether the option should be focused.
         * @return {?}
         */
        function () {
            return this.viewValue;
        };
        /** Ensures the option is selected when activated from the keyboard. */
        /**
         * Ensures the option is selected when activated from the keyboard.
         * @param {?} event
         * @return {?}
         */
        MatOption.prototype._handleKeydown = /**
         * Ensures the option is selected when activated from the keyboard.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.keyCode === ENTER || event.keyCode === SPACE) {
                this._selectViaInteraction();
                // Prevent the page from scrolling down and form submits.
                event.preventDefault();
            }
        };
        /**
         * `Selects the option while indicating the selection came from the user. Used to
         * determine if the select's view -> model callback should be invoked.`
         */
        /**
         * `Selects the option while indicating the selection came from the user. Used to
         * determine if the select's view -> model callback should be invoked.`
         * @return {?}
         */
        MatOption.prototype._selectViaInteraction = /**
         * `Selects the option while indicating the selection came from the user. Used to
         * determine if the select's view -> model callback should be invoked.`
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this._selected = this.multiple ? !this._selected : true;
                this._changeDetectorRef.markForCheck();
                this._emitSelectionChangeEvent(true);
            }
        };
        /** Returns the correct tabindex for the option depending on disabled state. */
        /**
         * Returns the correct tabindex for the option depending on disabled state.
         * @return {?}
         */
        MatOption.prototype._getTabIndex = /**
         * Returns the correct tabindex for the option depending on disabled state.
         * @return {?}
         */
        function () {
            return this.disabled ? '-1' : '0';
        };
        /** Gets the host DOM element. */
        /**
         * Gets the host DOM element.
         * @return {?}
         */
        MatOption.prototype._getHostElement = /**
         * Gets the host DOM element.
         * @return {?}
         */
        function () {
            return this._element.nativeElement;
        };
        /**
         * @return {?}
         */
        MatOption.prototype.ngAfterViewChecked = /**
         * @return {?}
         */
        function () {
            // Since parent components could be using the option's label to display the selected values
            // (e.g. `mat-select`) and they don't have a way of knowing if the option's label has changed
            // we have to check for changes in the DOM ourselves and dispatch an event. These checks are
            // relatively cheap, however we still limit them only to selected options in order to avoid
            // hitting the DOM too often.
            if (this._selected) {
                var /** @type {?} */ viewValue = this.viewValue;
                if (viewValue !== this._mostRecentViewValue) {
                    this._mostRecentViewValue = viewValue;
                    this._stateChanges.next();
                }
            }
        };
        /**
         * @return {?}
         */
        MatOption.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._stateChanges.complete();
        };
        /**
         * Emits the selection change event.
         * @param {?=} isUserInput
         * @return {?}
         */
        MatOption.prototype._emitSelectionChangeEvent = /**
         * Emits the selection change event.
         * @param {?=} isUserInput
         * @return {?}
         */
        function (isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this.onSelectionChange.emit(new MatOptionSelectionChange(this, isUserInput));
        };
        MatOption.decorators = [
            { type: core.Component, args: [{selector: 'mat-option',
                        exportAs: 'matOption',
                        host: {
                            'role': 'option',
                            '[attr.tabindex]': '_getTabIndex()',
                            '[class.mat-selected]': 'selected',
                            '[class.mat-option-multiple]': 'multiple',
                            '[class.mat-active]': 'active',
                            '[id]': 'id',
                            '[attr.aria-selected]': 'selected.toString()',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[class.mat-option-disabled]': 'disabled',
                            '(click)': '_selectViaInteraction()',
                            '(keydown)': '_handleKeydown($event)',
                            'class': 'mat-option',
                        },
                        styles: [".mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative;cursor:pointer;outline:0;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}.mat-option .mat-icon svg{vertical-align:top}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}@media screen and (-ms-high-contrast:active){.mat-option{margin:0 1px}.mat-option.mat-active{border:solid 1px currentColor;margin:0}}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-option-ripple{opacity:.5}}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}"],
                        template: "<mat-pseudo-checkbox *ngIf=\"multiple\" class=\"mat-option-pseudo-checkbox\" [state]=\"selected ? 'checked' : ''\" [disabled]=\"disabled\"></mat-pseudo-checkbox><span class=\"mat-option-text\"><ng-content></ng-content></span><div class=\"mat-option-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"disabled || disableRipple\"></div>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatOption.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_OPTION_PARENT_COMPONENT,] },] },
            { type: MatOptgroup, decorators: [{ type: core.Optional },] },
        ]; };
        MatOption.propDecorators = {
            "value": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "onSelectionChange": [{ type: core.Output },],
        };
        return MatOption;
    }());
    /**
     * Counts the amount of option group labels that precede the specified option.
     * \@docs-private
     * @param {?} optionIndex Index of the option at which to start counting.
     * @param {?} options Flat list of all of the options.
     * @param {?} optionGroups Flat list of all of the option groups.
     * @return {?}
     */
    function _countGroupLabelsBeforeOption(optionIndex, options, optionGroups) {
        if (optionGroups.length) {
            var /** @type {?} */ optionsArray = options.toArray();
            var /** @type {?} */ groups = optionGroups.toArray();
            var /** @type {?} */ groupCounter = 0;
            for (var /** @type {?} */ i = 0; i < optionIndex + 1; i++) {
                if (optionsArray[i].group && optionsArray[i].group === groups[groupCounter]) {
                    groupCounter++;
                }
            }
            return groupCounter;
        }
        return 0;
    }
    /**
     * Determines the position to which to scroll a panel in order for an option to be into view.
     * \@docs-private
     * @param {?} optionIndex Index of the option to be scrolled into the view.
     * @param {?} optionHeight Height of the options.
     * @param {?} currentScrollPosition Current scroll position of the panel.
     * @param {?} panelHeight Height of the panel.
     * @return {?}
     */
    function _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, panelHeight) {
        var /** @type {?} */ optionOffset = optionIndex * optionHeight;
        if (optionOffset < currentScrollPosition) {
            return optionOffset;
        }
        if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
            return Math.max(0, optionOffset - panelHeight + optionHeight);
        }
        return currentScrollPosition;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatOptionModule = /** @class */ (function () {
        function MatOptionModule() {
        }
        MatOptionModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatRippleModule, common.CommonModule, MatPseudoCheckboxModule],
                        exports: [MatOption, MatOptgroup],
                        declarations: [MatOption, MatOptgroup]
                    },] },
        ];
        return MatOptionModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * InjectionToken that can be used to specify the global label options.
     */
    var /** @type {?} */ MAT_LABEL_GLOBAL_OPTIONS = new core.InjectionToken('mat-label-global-options');

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Factory that creates a new MutationObserver and allows us to stub it out in unit tests.
     * \@docs-private
     */
    var MutationObserverFactory = /** @class */ (function () {
        function MutationObserverFactory() {
        }
        /**
         * @param {?} callback
         * @return {?}
         */
        MutationObserverFactory.prototype.create = /**
         * @param {?} callback
         * @return {?}
         */
        function (callback) {
            return typeof MutationObserver === 'undefined' ? null : new MutationObserver(callback);
        };
        MutationObserverFactory.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ MutationObserverFactory.ngInjectableDef = core.defineInjectable({ factory: function MutationObserverFactory_Factory() { return new MutationObserverFactory(); }, token: MutationObserverFactory, providedIn: "root" });
        return MutationObserverFactory;
    }());
    /**
     * An injectable service that allows watching elements for changes to their content.
     */
    var ContentObserver = /** @class */ (function () {
        function ContentObserver(_mutationObserverFactory) {
            this._mutationObserverFactory = _mutationObserverFactory;
            /**
             * Keeps track of the existing MutationObservers so they can be reused.
             */
            this._observedElements = new Map();
        }
        /**
         * @return {?}
         */
        ContentObserver.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._observedElements.forEach(function (_, element) { return _this._cleanupObserver(element); });
        };
        /**
         * Observe content changes on an element.
         * @param element The element to observe for content changes.
         */
        /**
         * Observe content changes on an element.
         * @param {?} element The element to observe for content changes.
         * @return {?}
         */
        ContentObserver.prototype.observe = /**
         * Observe content changes on an element.
         * @param {?} element The element to observe for content changes.
         * @return {?}
         */
        function (element) {
            var _this = this;
            return rxjs.Observable.create(function (observer) {
                var /** @type {?} */ stream = _this._observeElement(element);
                var /** @type {?} */ subscription = stream.subscribe(observer);
                return function () {
                    subscription.unsubscribe();
                    _this._unobserveElement(element);
                };
            });
        };
        /**
         * Observes the given element by using the existing MutationObserver if available, or creating a
         * new one if not.
         * @param {?} element
         * @return {?}
         */
        ContentObserver.prototype._observeElement = /**
         * Observes the given element by using the existing MutationObserver if available, or creating a
         * new one if not.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (!this._observedElements.has(element)) {
                var /** @type {?} */ stream_1 = new rxjs.Subject();
                var /** @type {?} */ observer = this._mutationObserverFactory.create(function (mutations) { return stream_1.next(mutations); });
                if (observer) {
                    observer.observe(element, {
                        characterData: true,
                        childList: true,
                        subtree: true
                    });
                }
                this._observedElements.set(element, { observer: observer, stream: stream_1, count: 1 });
            }
            else {
                /** @type {?} */ ((this._observedElements.get(element))).count++;
            }
            return /** @type {?} */ ((this._observedElements.get(element))).stream;
        };
        /**
         * Un-observes the given element and cleans up the underlying MutationObserver if nobody else is
         * observing this element.
         * @param {?} element
         * @return {?}
         */
        ContentObserver.prototype._unobserveElement = /**
         * Un-observes the given element and cleans up the underlying MutationObserver if nobody else is
         * observing this element.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (this._observedElements.has(element)) {
                /** @type {?} */ ((this._observedElements.get(element))).count--;
                if (!/** @type {?} */ ((this._observedElements.get(element))).count) {
                    this._cleanupObserver(element);
                }
            }
        };
        /**
         * Clean up the underlying MutationObserver for the specified element.
         * @param {?} element
         * @return {?}
         */
        ContentObserver.prototype._cleanupObserver = /**
         * Clean up the underlying MutationObserver for the specified element.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (this._observedElements.has(element)) {
                var _a = /** @type {?} */ ((this._observedElements.get(element))), observer = _a.observer, stream = _a.stream;
                if (observer) {
                    observer.disconnect();
                }
                stream.complete();
                this._observedElements.delete(element);
            }
        };
        ContentObserver.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        ContentObserver.ctorParameters = function () { return [
            { type: MutationObserverFactory, },
        ]; };
        /** @nocollapse */ ContentObserver.ngInjectableDef = core.defineInjectable({ factory: function ContentObserver_Factory() { return new ContentObserver(core.inject(MutationObserverFactory)); }, token: ContentObserver, providedIn: "root" });
        return ContentObserver;
    }());
    /**
     * Directive that triggers a callback whenever the content of
     * its associated element has changed.
     */
    var CdkObserveContent = /** @class */ (function () {
        function CdkObserveContent(_contentObserver, _elementRef, _ngZone) {
            this._contentObserver = _contentObserver;
            this._elementRef = _elementRef;
            this._ngZone = _ngZone;
            /**
             * Event emitted for each change in the element's content.
             */
            this.event = new core.EventEmitter();
            this._disabled = false;
            this._currentSubscription = null;
        }
        Object.defineProperty(CdkObserveContent.prototype, "disabled", {
            get: /**
             * Whether observing content is disabled. This option can be used
             * to disconnect the underlying MutationObserver until it is needed.
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
                if (this._disabled) {
                    this._unsubscribe();
                }
                else {
                    this._subscribe();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkObserveContent.prototype, "debounce", {
            get: /**
             * Debounce interval for emitting the changes.
             * @return {?}
             */
            function () { return this._debounce; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._debounce = coerceNumberProperty(value);
                this._subscribe();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkObserveContent.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            if (!this._currentSubscription && !this.disabled) {
                this._subscribe();
            }
        };
        /**
         * @return {?}
         */
        CdkObserveContent.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._unsubscribe();
        };
        /**
         * @return {?}
         */
        CdkObserveContent.prototype._subscribe = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._unsubscribe();
            var /** @type {?} */ stream = this._contentObserver.observe(this._elementRef.nativeElement);
            // TODO(mmalerba): We shouldn't be emitting on this @Output() outside the zone.
            // Consider brining it back inside the zone next time we're making breaking changes.
            // Bringing it back inside can cause things like infinite change detection loops and changed
            // after checked errors if people's code isn't handling it properly.
            this._ngZone.runOutsideAngular(function () {
                _this._currentSubscription =
                    (_this.debounce ? stream.pipe(operators.debounceTime(_this.debounce)) : stream).subscribe(_this.event);
            });
        };
        /**
         * @return {?}
         */
        CdkObserveContent.prototype._unsubscribe = /**
         * @return {?}
         */
        function () {
            if (this._currentSubscription) {
                this._currentSubscription.unsubscribe();
            }
        };
        CdkObserveContent.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkObserveContent]',
                        exportAs: 'cdkObserveContent',
                    },] },
        ];
        /** @nocollapse */
        CdkObserveContent.ctorParameters = function () { return [
            { type: ContentObserver, },
            { type: core.ElementRef, },
            { type: core.NgZone, },
        ]; };
        CdkObserveContent.propDecorators = {
            "event": [{ type: core.Output, args: ['cdkObserveContent',] },],
            "disabled": [{ type: core.Input, args: ['cdkObserveContentDisabled',] },],
            "debounce": [{ type: core.Input },],
        };
        return CdkObserveContent;
    }());
    var ObserversModule = /** @class */ (function () {
        function ObserversModule() {
        }
        ObserversModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [CdkObserveContent],
                        declarations: [CdkObserveContent],
                        providers: [MutationObserverFactory]
                    },] },
        ];
        return ObserversModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * IDs are deliminated by an empty space, as per the spec.
     */
    var /** @type {?} */ ID_DELIMINATOR = ' ';
    /**
     * Adds the given ID to the specified ARIA attribute on an element.
     * Used for attributes such as aria-labelledby, aria-owns, etc.
     * @param {?} el
     * @param {?} attr
     * @param {?} id
     * @return {?}
     */
    function addAriaReferencedId(el, attr, id) {
        var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
        if (ids.some(function (existingId) { return existingId.trim() == id.trim(); })) {
            return;
        }
        ids.push(id.trim());
        el.setAttribute(attr, ids.join(ID_DELIMINATOR));
    }
    /**
     * Removes the given ID from the specified ARIA attribute on an element.
     * Used for attributes such as aria-labelledby, aria-owns, etc.
     * @param {?} el
     * @param {?} attr
     * @param {?} id
     * @return {?}
     */
    function removeAriaReferencedId(el, attr, id) {
        var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
        var /** @type {?} */ filteredIds = ids.filter(function (val) { return val != id.trim(); });
        el.setAttribute(attr, filteredIds.join(ID_DELIMINATOR));
    }
    /**
     * Gets the list of IDs referenced by the given ARIA attribute on an element.
     * Used for attributes such as aria-labelledby, aria-owns, etc.
     * @param {?} el
     * @param {?} attr
     * @return {?}
     */
    function getAriaReferenceIds(el, attr) {
        // Get string array of all individual ids (whitespace deliminated) in the attribute value
        return (el.getAttribute(attr) || '').match(/\S+/g) || [];
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * ID used for the body container where all messages are appended.
     */
    var /** @type {?} */ MESSAGES_CONTAINER_ID = 'cdk-describedby-message-container';
    /**
     * ID prefix used for each created message element.
     */
    var /** @type {?} */ CDK_DESCRIBEDBY_ID_PREFIX = 'cdk-describedby-message';
    /**
     * Attribute given to each host element that is described by a message element.
     */
    var /** @type {?} */ CDK_DESCRIBEDBY_HOST_ATTRIBUTE = 'cdk-describedby-host';
    /**
     * Global incremental identifier for each registered message element.
     */
    var /** @type {?} */ nextId = 0;
    /**
     * Global map of all registered message elements that have been placed into the document.
     */
    var /** @type {?} */ messageRegistry = new Map();
    /**
     * Container for all registered messages.
     */
    var /** @type {?} */ messagesContainer = null;
    /**
     * Utility that creates visually hidden elements with a message content. Useful for elements that
     * want to use aria-describedby to further describe themselves without adding additional visual
     * content.
     * \@docs-private
     */
    var AriaDescriber = /** @class */ (function () {
        function AriaDescriber(_document) {
            this._document = _document;
        }
        /**
         * Adds to the host element an aria-describedby reference to a hidden element that contains
         * the message. If the same message has already been registered, then it will reuse the created
         * message element.
         */
        /**
         * Adds to the host element an aria-describedby reference to a hidden element that contains
         * the message. If the same message has already been registered, then it will reuse the created
         * message element.
         * @param {?} hostElement
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype.describe = /**
         * Adds to the host element an aria-describedby reference to a hidden element that contains
         * the message. If the same message has already been registered, then it will reuse the created
         * message element.
         * @param {?} hostElement
         * @param {?} message
         * @return {?}
         */
        function (hostElement, message) {
            if (!this._canBeDescribed(hostElement, message)) {
                return;
            }
            if (!messageRegistry.has(message)) {
                this._createMessageElement(message);
            }
            if (!this._isElementDescribedByMessage(hostElement, message)) {
                this._addMessageReference(hostElement, message);
            }
        };
        /** Removes the host element's aria-describedby reference to the message element. */
        /**
         * Removes the host element's aria-describedby reference to the message element.
         * @param {?} hostElement
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype.removeDescription = /**
         * Removes the host element's aria-describedby reference to the message element.
         * @param {?} hostElement
         * @param {?} message
         * @return {?}
         */
        function (hostElement, message) {
            if (!this._canBeDescribed(hostElement, message)) {
                return;
            }
            if (this._isElementDescribedByMessage(hostElement, message)) {
                this._removeMessageReference(hostElement, message);
            }
            var /** @type {?} */ registeredMessage = messageRegistry.get(message);
            if (registeredMessage && registeredMessage.referenceCount === 0) {
                this._deleteMessageElement(message);
            }
            if (messagesContainer && messagesContainer.childNodes.length === 0) {
                this._deleteMessagesContainer();
            }
        };
        /** Unregisters all created message elements and removes the message container. */
        /**
         * Unregisters all created message elements and removes the message container.
         * @return {?}
         */
        AriaDescriber.prototype.ngOnDestroy = /**
         * Unregisters all created message elements and removes the message container.
         * @return {?}
         */
        function () {
            var /** @type {?} */ describedElements = this._document.querySelectorAll("[" + CDK_DESCRIBEDBY_HOST_ATTRIBUTE + "]");
            for (var /** @type {?} */ i = 0; i < describedElements.length; i++) {
                this._removeCdkDescribedByReferenceIds(describedElements[i]);
                describedElements[i].removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
            }
            if (messagesContainer) {
                this._deleteMessagesContainer();
            }
            messageRegistry.clear();
        };
        /**
         * Creates a new element in the visually hidden message container element with the message
         * as its content and adds it to the message registry.
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._createMessageElement = /**
         * Creates a new element in the visually hidden message container element with the message
         * as its content and adds it to the message registry.
         * @param {?} message
         * @return {?}
         */
        function (message) {
            var /** @type {?} */ messageElement = this._document.createElement('div');
            messageElement.setAttribute('id', CDK_DESCRIBEDBY_ID_PREFIX + "-" + nextId++);
            messageElement.appendChild(/** @type {?} */ ((this._document.createTextNode(message))));
            if (!messagesContainer) {
                this._createMessagesContainer();
            } /** @type {?} */
            ((messagesContainer)).appendChild(messageElement);
            messageRegistry.set(message, { messageElement: messageElement, referenceCount: 0 });
        };
        /**
         * Deletes the message element from the global messages container.
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._deleteMessageElement = /**
         * Deletes the message element from the global messages container.
         * @param {?} message
         * @return {?}
         */
        function (message) {
            var /** @type {?} */ registeredMessage = messageRegistry.get(message);
            var /** @type {?} */ messageElement = registeredMessage && registeredMessage.messageElement;
            if (messagesContainer && messageElement) {
                messagesContainer.removeChild(messageElement);
            }
            messageRegistry.delete(message);
        };
        /**
         * Creates the global container for all aria-describedby messages.
         * @return {?}
         */
        AriaDescriber.prototype._createMessagesContainer = /**
         * Creates the global container for all aria-describedby messages.
         * @return {?}
         */
        function () {
            messagesContainer = this._document.createElement('div');
            messagesContainer.setAttribute('id', MESSAGES_CONTAINER_ID);
            messagesContainer.setAttribute('aria-hidden', 'true');
            messagesContainer.style.display = 'none';
            this._document.body.appendChild(messagesContainer);
        };
        /**
         * Deletes the global messages container.
         * @return {?}
         */
        AriaDescriber.prototype._deleteMessagesContainer = /**
         * Deletes the global messages container.
         * @return {?}
         */
        function () {
            if (messagesContainer && messagesContainer.parentNode) {
                messagesContainer.parentNode.removeChild(messagesContainer);
                messagesContainer = null;
            }
        };
        /**
         * Removes all cdk-describedby messages that are hosted through the element.
         * @param {?} element
         * @return {?}
         */
        AriaDescriber.prototype._removeCdkDescribedByReferenceIds = /**
         * Removes all cdk-describedby messages that are hosted through the element.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            // Remove all aria-describedby reference IDs that are prefixed by CDK_DESCRIBEDBY_ID_PREFIX
            var /** @type {?} */ originalReferenceIds = getAriaReferenceIds(element, 'aria-describedby')
                .filter(function (id) { return id.indexOf(CDK_DESCRIBEDBY_ID_PREFIX) != 0; });
            element.setAttribute('aria-describedby', originalReferenceIds.join(' '));
        };
        /**
         * Adds a message reference to the element using aria-describedby and increments the registered
         * message's reference count.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._addMessageReference = /**
         * Adds a message reference to the element using aria-describedby and increments the registered
         * message's reference count.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        function (element, message) {
            var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
            // Add the aria-describedby reference and set the
            // describedby_host attribute to mark the element.
            addAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
            element.setAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE, '');
            registeredMessage.referenceCount++;
        };
        /**
         * Removes a message reference from the element using aria-describedby
         * and decrements the registered message's reference count.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._removeMessageReference = /**
         * Removes a message reference from the element using aria-describedby
         * and decrements the registered message's reference count.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        function (element, message) {
            var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
            registeredMessage.referenceCount--;
            removeAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
            element.removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
        };
        /**
         * Returns true if the element has been described by the provided message ID.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._isElementDescribedByMessage = /**
         * Returns true if the element has been described by the provided message ID.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        function (element, message) {
            var /** @type {?} */ referenceIds = getAriaReferenceIds(element, 'aria-describedby');
            var /** @type {?} */ registeredMessage = messageRegistry.get(message);
            var /** @type {?} */ messageId = registeredMessage && registeredMessage.messageElement.id;
            return !!messageId && referenceIds.indexOf(messageId) != -1;
        };
        /**
         * Determines whether a message can be described on a particular element.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        AriaDescriber.prototype._canBeDescribed = /**
         * Determines whether a message can be described on a particular element.
         * @param {?} element
         * @param {?} message
         * @return {?}
         */
        function (element, message) {
            return element.nodeType === this._document.ELEMENT_NODE && message != null &&
                !!("" + message).trim();
        };
        AriaDescriber.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        AriaDescriber.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ AriaDescriber.ngInjectableDef = core.defineInjectable({ factory: function AriaDescriber_Factory() { return new AriaDescriber(core.inject(common.DOCUMENT)); }, token: AriaDescriber, providedIn: "root" });
        return AriaDescriber;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentDispatcher
     * @param {?} _document
     * @return {?}
     */
    function ARIA_DESCRIBER_PROVIDER_FACTORY(parentDispatcher, _document) {
        return parentDispatcher || new AriaDescriber(_document);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ ARIA_DESCRIBER_PROVIDER = {
        // If there is already an AriaDescriber available, use that. Otherwise, provide a new one.
        provide: AriaDescriber,
        deps: [
            [new core.Optional(), new core.SkipSelf(), AriaDescriber],
            /** @type {?} */ (common.DOCUMENT)
        ],
        useFactory: ARIA_DESCRIBER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // unsupported: template constraints.
    /**
     * This class manages keyboard events for selectable lists. If you pass it a query list
     * of items, it will set the active item correctly when arrow events occur.
     * @template T
     */
    var  
    // unsupported: template constraints.
    /**
     * This class manages keyboard events for selectable lists. If you pass it a query list
     * of items, it will set the active item correctly when arrow events occur.
     * @template T
     */
    ListKeyManager = /** @class */ (function () {
        function ListKeyManager(_items) {
            var _this = this;
            this._items = _items;
            this._activeItemIndex = -1;
            this._wrap = false;
            this._letterKeyStream = new rxjs.Subject();
            this._typeaheadSubscription = rxjs.Subscription.EMPTY;
            this._vertical = true;
            /**
             * Predicate function that can be used to check whether an item should be skipped
             * by the key manager. By default, disabled items are skipped.
             */
            this._skipPredicateFn = function (item) { return item.disabled; };
            this._pressedLetters = [];
            /**
             * Stream that emits any time the TAB key is pressed, so components can react
             * when focus is shifted off of the list.
             */
            this.tabOut = new rxjs.Subject();
            /**
             * Stream that emits whenever the active item of the list manager changes.
             */
            this.change = new rxjs.Subject();
            // We allow for the items to be an array because, in some cases, the consumer may
            // not have access to a QueryList of the items they want to manage (e.g. when the
            // items aren't being collected via `ViewChildren` or `ContentChildren`).
            if (_items instanceof core.QueryList) {
                _items.changes.subscribe(function (newItems) {
                    if (_this._activeItem) {
                        var /** @type {?} */ itemArray = newItems.toArray();
                        var /** @type {?} */ newIndex = itemArray.indexOf(_this._activeItem);
                        if (newIndex > -1 && newIndex !== _this._activeItemIndex) {
                            _this._activeItemIndex = newIndex;
                        }
                    }
                });
            }
        }
        /**
         * Sets the predicate function that determines which items should be skipped by the
         * list key manager.
         * @param predicate Function that determines whether the given item should be skipped.
         */
        /**
         * Sets the predicate function that determines which items should be skipped by the
         * list key manager.
         * @param {?} predicate Function that determines whether the given item should be skipped.
         * @return {?}
         */
        ListKeyManager.prototype.skipPredicate = /**
         * Sets the predicate function that determines which items should be skipped by the
         * list key manager.
         * @param {?} predicate Function that determines whether the given item should be skipped.
         * @return {?}
         */
        function (predicate) {
            this._skipPredicateFn = predicate;
            return this;
        };
        /**
         * Turns on wrapping mode, which ensures that the active item will wrap to
         * the other end of list when there are no more items in the given direction.
         */
        /**
         * Turns on wrapping mode, which ensures that the active item will wrap to
         * the other end of list when there are no more items in the given direction.
         * @return {?}
         */
        ListKeyManager.prototype.withWrap = /**
         * Turns on wrapping mode, which ensures that the active item will wrap to
         * the other end of list when there are no more items in the given direction.
         * @return {?}
         */
        function () {
            this._wrap = true;
            return this;
        };
        /**
         * Configures whether the key manager should be able to move the selection vertically.
         * @param enabled Whether vertical selection should be enabled.
         */
        /**
         * Configures whether the key manager should be able to move the selection vertically.
         * @param {?=} enabled Whether vertical selection should be enabled.
         * @return {?}
         */
        ListKeyManager.prototype.withVerticalOrientation = /**
         * Configures whether the key manager should be able to move the selection vertically.
         * @param {?=} enabled Whether vertical selection should be enabled.
         * @return {?}
         */
        function (enabled) {
            if (enabled === void 0) { enabled = true; }
            this._vertical = enabled;
            return this;
        };
        /**
         * Configures the key manager to move the selection horizontally.
         * Passing in `null` will disable horizontal movement.
         * @param direction Direction in which the selection can be moved.
         */
        /**
         * Configures the key manager to move the selection horizontally.
         * Passing in `null` will disable horizontal movement.
         * @param {?} direction Direction in which the selection can be moved.
         * @return {?}
         */
        ListKeyManager.prototype.withHorizontalOrientation = /**
         * Configures the key manager to move the selection horizontally.
         * Passing in `null` will disable horizontal movement.
         * @param {?} direction Direction in which the selection can be moved.
         * @return {?}
         */
        function (direction) {
            this._horizontal = direction;
            return this;
        };
        /**
         * Turns on typeahead mode which allows users to set the active item by typing.
         * @param debounceInterval Time to wait after the last keystroke before setting the active item.
         */
        /**
         * Turns on typeahead mode which allows users to set the active item by typing.
         * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
         * @return {?}
         */
        ListKeyManager.prototype.withTypeAhead = /**
         * Turns on typeahead mode which allows users to set the active item by typing.
         * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
         * @return {?}
         */
        function (debounceInterval) {
            var _this = this;
            if (debounceInterval === void 0) { debounceInterval = 200; }
            if (this._items.length && this._items.some(function (item) { return typeof item.getLabel !== 'function'; })) {
                throw Error('ListKeyManager items in typeahead mode must implement the `getLabel` method.');
            }
            this._typeaheadSubscription.unsubscribe();
            // Debounce the presses of non-navigational keys, collect the ones that correspond to letters
            // and convert those letters back into a string. Afterwards find the first item that starts
            // with that string and select it.
            this._typeaheadSubscription = this._letterKeyStream.pipe(operators.tap(function (keyCode) { return _this._pressedLetters.push(keyCode); }), operators.debounceTime(debounceInterval), operators.filter(function () { return _this._pressedLetters.length > 0; }), operators.map(function () { return _this._pressedLetters.join(''); })).subscribe(function (inputString) {
                var /** @type {?} */ items = _this._getItemsArray();
                // Start at 1 because we want to start searching at the item immediately
                // following the current active item.
                for (var /** @type {?} */ i = 1; i < items.length + 1; i++) {
                    var /** @type {?} */ index = (_this._activeItemIndex + i) % items.length;
                    var /** @type {?} */ item = items[index];
                    if (!_this._skipPredicateFn(item) && /** @type {?} */ ((item.getLabel))().toUpperCase().trim().indexOf(inputString) === 0) {
                        _this.setActiveItem(index);
                        break;
                    }
                }
                _this._pressedLetters = [];
            });
            return this;
        };
        /**
         * @param {?} item
         * @return {?}
         */
        ListKeyManager.prototype.setActiveItem = /**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            var /** @type {?} */ previousIndex = this._activeItemIndex;
            this.updateActiveItem(item);
            if (this._activeItemIndex !== previousIndex) {
                this.change.next(this._activeItemIndex);
            }
        };
        /**
         * Sets the active item depending on the key event passed in.
         * @param event Keyboard event to be used for determining which element should be active.
         */
        /**
         * Sets the active item depending on the key event passed in.
         * @param {?} event Keyboard event to be used for determining which element should be active.
         * @return {?}
         */
        ListKeyManager.prototype.onKeydown = /**
         * Sets the active item depending on the key event passed in.
         * @param {?} event Keyboard event to be used for determining which element should be active.
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            switch (keyCode) {
                case TAB:
                    this.tabOut.next();
                    return;
                case DOWN_ARROW:
                    if (this._vertical) {
                        this.setNextItemActive();
                        break;
                    }
                    else {
                        return;
                    }
                case UP_ARROW:
                    if (this._vertical) {
                        this.setPreviousItemActive();
                        break;
                    }
                    else {
                        return;
                    }
                case RIGHT_ARROW:
                    if (this._horizontal === 'ltr') {
                        this.setNextItemActive();
                        break;
                    }
                    else if (this._horizontal === 'rtl') {
                        this.setPreviousItemActive();
                        break;
                    }
                    else {
                        return;
                    }
                case LEFT_ARROW:
                    if (this._horizontal === 'ltr') {
                        this.setPreviousItemActive();
                        break;
                    }
                    else if (this._horizontal === 'rtl') {
                        this.setNextItemActive();
                        break;
                    }
                    else {
                        return;
                    }
                default:
                    // Attempt to use the `event.key` which also maps it to the user's keyboard language,
                    // otherwise fall back to resolving alphanumeric characters via the keyCode.
                    if (event.key && event.key.length === 1) {
                        this._letterKeyStream.next(event.key.toLocaleUpperCase());
                    }
                    else if ((keyCode >= A && keyCode <= Z) || (keyCode >= ZERO && keyCode <= NINE)) {
                        this._letterKeyStream.next(String.fromCharCode(keyCode));
                    }
                    // Note that we return here, in order to avoid preventing
                    // the default action of non-navigational keys.
                    return;
            }
            this._pressedLetters = [];
            event.preventDefault();
        };
        Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
            /** Index of the currently active item. */
            get: /**
             * Index of the currently active item.
             * @return {?}
             */
            function () {
                return this._activeItemIndex;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ListKeyManager.prototype, "activeItem", {
            /** The active item. */
            get: /**
             * The active item.
             * @return {?}
             */
            function () {
                return this._activeItem;
            },
            enumerable: true,
            configurable: true
        });
        /** Sets the active item to the first enabled item in the list. */
        /**
         * Sets the active item to the first enabled item in the list.
         * @return {?}
         */
        ListKeyManager.prototype.setFirstItemActive = /**
         * Sets the active item to the first enabled item in the list.
         * @return {?}
         */
        function () {
            this._setActiveItemByIndex(0, 1);
        };
        /** Sets the active item to the last enabled item in the list. */
        /**
         * Sets the active item to the last enabled item in the list.
         * @return {?}
         */
        ListKeyManager.prototype.setLastItemActive = /**
         * Sets the active item to the last enabled item in the list.
         * @return {?}
         */
        function () {
            this._setActiveItemByIndex(this._items.length - 1, -1);
        };
        /** Sets the active item to the next enabled item in the list. */
        /**
         * Sets the active item to the next enabled item in the list.
         * @return {?}
         */
        ListKeyManager.prototype.setNextItemActive = /**
         * Sets the active item to the next enabled item in the list.
         * @return {?}
         */
        function () {
            this._activeItemIndex < 0 ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
        };
        /** Sets the active item to a previous enabled item in the list. */
        /**
         * Sets the active item to a previous enabled item in the list.
         * @return {?}
         */
        ListKeyManager.prototype.setPreviousItemActive = /**
         * Sets the active item to a previous enabled item in the list.
         * @return {?}
         */
        function () {
            this._activeItemIndex < 0 && this._wrap ? this.setLastItemActive()
                : this._setActiveItemByDelta(-1);
        };
        /**
         * @param {?} item
         * @return {?}
         */
        ListKeyManager.prototype.updateActiveItem = /**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            var /** @type {?} */ itemArray = this._getItemsArray();
            var /** @type {?} */ index = typeof item === 'number' ? item : itemArray.indexOf(item);
            this._activeItemIndex = index;
            this._activeItem = itemArray[index];
        };
        /**
         * Allows setting of the activeItemIndex without any other effects.
         * @param index The new activeItemIndex.
         * @deprecated Use `updateActiveItem` instead.
         * @deletion-target 7.0.0
         */
        /**
         * Allows setting of the activeItemIndex without any other effects.
         * @deprecated Use `updateActiveItem` instead.
         * \@deletion-target 7.0.0
         * @param {?} index The new activeItemIndex.
         * @return {?}
         */
        ListKeyManager.prototype.updateActiveItemIndex = /**
         * Allows setting of the activeItemIndex without any other effects.
         * @deprecated Use `updateActiveItem` instead.
         * \@deletion-target 7.0.0
         * @param {?} index The new activeItemIndex.
         * @return {?}
         */
        function (index) {
            this.updateActiveItem(index);
        };
        /**
         * This method sets the active item, given a list of items and the delta between the
         * currently active item and the new active item. It will calculate differently
         * depending on whether wrap mode is turned on.
         * @param {?} delta
         * @return {?}
         */
        ListKeyManager.prototype._setActiveItemByDelta = /**
         * This method sets the active item, given a list of items and the delta between the
         * currently active item and the new active item. It will calculate differently
         * depending on whether wrap mode is turned on.
         * @param {?} delta
         * @return {?}
         */
        function (delta) {
            this._wrap ? this._setActiveInWrapMode(delta) : this._setActiveInDefaultMode(delta);
        };
        /**
         * Sets the active item properly given "wrap" mode. In other words, it will continue to move
         * down the list until it finds an item that is not disabled, and it will wrap if it
         * encounters either end of the list.
         * @param {?} delta
         * @return {?}
         */
        ListKeyManager.prototype._setActiveInWrapMode = /**
         * Sets the active item properly given "wrap" mode. In other words, it will continue to move
         * down the list until it finds an item that is not disabled, and it will wrap if it
         * encounters either end of the list.
         * @param {?} delta
         * @return {?}
         */
        function (delta) {
            var /** @type {?} */ items = this._getItemsArray();
            for (var /** @type {?} */ i = 1; i <= items.length; i++) {
                var /** @type {?} */ index = (this._activeItemIndex + (delta * i) + items.length) % items.length;
                var /** @type {?} */ item = items[index];
                if (!this._skipPredicateFn(item)) {
                    this.setActiveItem(index);
                    return;
                }
            }
        };
        /**
         * Sets the active item properly given the default mode. In other words, it will
         * continue to move down the list until it finds an item that is not disabled. If
         * it encounters either end of the list, it will stop and not wrap.
         * @param {?} delta
         * @return {?}
         */
        ListKeyManager.prototype._setActiveInDefaultMode = /**
         * Sets the active item properly given the default mode. In other words, it will
         * continue to move down the list until it finds an item that is not disabled. If
         * it encounters either end of the list, it will stop and not wrap.
         * @param {?} delta
         * @return {?}
         */
        function (delta) {
            this._setActiveItemByIndex(this._activeItemIndex + delta, delta);
        };
        /**
         * Sets the active item to the first enabled item starting at the index specified. If the
         * item is disabled, it will move in the fallbackDelta direction until it either
         * finds an enabled item or encounters the end of the list.
         * @param {?} index
         * @param {?} fallbackDelta
         * @return {?}
         */
        ListKeyManager.prototype._setActiveItemByIndex = /**
         * Sets the active item to the first enabled item starting at the index specified. If the
         * item is disabled, it will move in the fallbackDelta direction until it either
         * finds an enabled item or encounters the end of the list.
         * @param {?} index
         * @param {?} fallbackDelta
         * @return {?}
         */
        function (index, fallbackDelta) {
            var /** @type {?} */ items = this._getItemsArray();
            if (!items[index]) {
                return;
            }
            while (this._skipPredicateFn(items[index])) {
                index += fallbackDelta;
                if (!items[index]) {
                    return;
                }
            }
            this.setActiveItem(index);
        };
        /**
         * Returns the items as an array.
         * @return {?}
         */
        ListKeyManager.prototype._getItemsArray = /**
         * Returns the items as an array.
         * @return {?}
         */
        function () {
            return this._items instanceof core.QueryList ? this._items.toArray() : this._items;
        };
        return ListKeyManager;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * @template T
     */
    var  /**
     * @template T
     */
    ActiveDescendantKeyManager = /** @class */ (function (_super) {
        __extends(ActiveDescendantKeyManager, _super);
        function ActiveDescendantKeyManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * @param {?} index
         * @return {?}
         */
        ActiveDescendantKeyManager.prototype.setActiveItem = /**
         * @param {?} index
         * @return {?}
         */
        function (index) {
            if (this.activeItem) {
                this.activeItem.setInactiveStyles();
            }
            _super.prototype.setActiveItem.call(this, index);
            if (this.activeItem) {
                this.activeItem.setActiveStyles();
            }
        };
        return ActiveDescendantKeyManager;
    }(ListKeyManager));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * @template T
     */
    var  /**
     * @template T
     */
    FocusKeyManager = /** @class */ (function (_super) {
        __extends(FocusKeyManager, _super);
        function FocusKeyManager() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._origin = 'program';
            return _this;
        }
        /**
         * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
         * @param origin Focus origin to be used when focusing items.
         */
        /**
         * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
         * @param {?} origin Focus origin to be used when focusing items.
         * @return {?}
         */
        FocusKeyManager.prototype.setFocusOrigin = /**
         * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
         * @param {?} origin Focus origin to be used when focusing items.
         * @return {?}
         */
        function (origin) {
            this._origin = origin;
            return this;
        };
        /**
         * @param {?} item
         * @return {?}
         */
        FocusKeyManager.prototype.setActiveItem = /**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            _super.prototype.setActiveItem.call(this, item);
            if (this.activeItem) {
                this.activeItem.focus(this._origin);
            }
        };
        return FocusKeyManager;
    }(ListKeyManager));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Utility for checking the interactivity of an element, such as whether is is focusable or
     * tabbable.
     */
    var InteractivityChecker = /** @class */ (function () {
        function InteractivityChecker(_platform) {
            this._platform = _platform;
        }
        /**
         * Gets whether an element is disabled.
         *
         * @param element Element to be checked.
         * @returns Whether the element is disabled.
         */
        /**
         * Gets whether an element is disabled.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is disabled.
         */
        InteractivityChecker.prototype.isDisabled = /**
         * Gets whether an element is disabled.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is disabled.
         */
        function (element) {
            // This does not capture some cases, such as a non-form control with a disabled attribute or
            // a form control inside of a disabled form, but should capture the most common cases.
            return element.hasAttribute('disabled');
        };
        /**
         * Gets whether an element is visible for the purposes of interactivity.
         *
         * This will capture states like `display: none` and `visibility: hidden`, but not things like
         * being clipped by an `overflow: hidden` parent or being outside the viewport.
         *
         * @returns Whether the element is visible.
         */
        /**
         * Gets whether an element is visible for the purposes of interactivity.
         *
         * This will capture states like `display: none` and `visibility: hidden`, but not things like
         * being clipped by an `overflow: hidden` parent or being outside the viewport.
         *
         * @param {?} element
         * @return {?} Whether the element is visible.
         */
        InteractivityChecker.prototype.isVisible = /**
         * Gets whether an element is visible for the purposes of interactivity.
         *
         * This will capture states like `display: none` and `visibility: hidden`, but not things like
         * being clipped by an `overflow: hidden` parent or being outside the viewport.
         *
         * @param {?} element
         * @return {?} Whether the element is visible.
         */
        function (element) {
            return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
        };
        /**
         * Gets whether an element can be reached via Tab key.
         * Assumes that the element has already been checked with isFocusable.
         *
         * @param element Element to be checked.
         * @returns Whether the element is tabbable.
         */
        /**
         * Gets whether an element can be reached via Tab key.
         * Assumes that the element has already been checked with isFocusable.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is tabbable.
         */
        InteractivityChecker.prototype.isTabbable = /**
         * Gets whether an element can be reached via Tab key.
         * Assumes that the element has already been checked with isFocusable.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is tabbable.
         */
        function (element) {
            // Nothing is tabbable on the the server 😎
            if (!this._platform.isBrowser) {
                return false;
            }
            var /** @type {?} */ frameElement = getFrameElement(getWindow(element));
            if (frameElement) {
                var /** @type {?} */ frameType = frameElement && frameElement.nodeName.toLowerCase();
                // Frame elements inherit their tabindex onto all child elements.
                if (getTabIndexValue(frameElement) === -1) {
                    return false;
                }
                // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
                if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
                    return false;
                }
                // Webkit and Blink disable tabbing to an element inside of an invisible frame.
                if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
                    return false;
                }
            }
            var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
            var /** @type {?} */ tabIndexValue = getTabIndexValue(element);
            if (element.hasAttribute('contenteditable')) {
                return tabIndexValue !== -1;
            }
            if (nodeName === 'iframe') {
                // The frames may be tabbable depending on content, but it's not possibly to reliably
                // investigate the content of the frames.
                return false;
            }
            if (nodeName === 'audio') {
                if (!element.hasAttribute('controls')) {
                    // By default an <audio> element without the controls enabled is not tabbable.
                    return false;
                }
                else if (this._platform.BLINK) {
                    // In Blink <audio controls> elements are always tabbable.
                    return true;
                }
            }
            if (nodeName === 'video') {
                if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
                    // In Trident a <video> element without the controls enabled is not tabbable.
                    return false;
                }
                else if (this._platform.BLINK || this._platform.FIREFOX) {
                    // In Chrome and Firefox <video controls> elements are always tabbable.
                    return true;
                }
            }
            if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
                // In all Blink and WebKit based browsers <object> elements are never tabbable.
                return false;
            }
            // In iOS the browser only considers some specific elements as tabbable.
            if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
                return false;
            }
            return element.tabIndex >= 0;
        };
        /**
         * Gets whether an element can be focused by the user.
         *
         * @param element Element to be checked.
         * @returns Whether the element is focusable.
         */
        /**
         * Gets whether an element can be focused by the user.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is focusable.
         */
        InteractivityChecker.prototype.isFocusable = /**
         * Gets whether an element can be focused by the user.
         *
         * @param {?} element Element to be checked.
         * @return {?} Whether the element is focusable.
         */
        function (element) {
            // Perform checks in order of left to most expensive.
            // Again, naive approach that does not capture many edge cases and browser quirks.
            return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
        };
        InteractivityChecker.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        InteractivityChecker.ctorParameters = function () { return [
            { type: Platform, },
        ]; };
        /** @nocollapse */ InteractivityChecker.ngInjectableDef = core.defineInjectable({ factory: function InteractivityChecker_Factory() { return new InteractivityChecker(core.inject(Platform)); }, token: InteractivityChecker, providedIn: "root" });
        return InteractivityChecker;
    }());
    /**
     * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
     * the frameElement property is being accessed from a different host address, this property
     * should be accessed carefully.
     * @param {?} window
     * @return {?}
     */
    function getFrameElement(window) {
        try {
            return /** @type {?} */ (window.frameElement);
        }
        catch (/** @type {?} */ e) {
            return null;
        }
    }
    /**
     * Checks whether the specified element has any geometry / rectangles.
     * @param {?} element
     * @return {?}
     */
    function hasGeometry(element) {
        // Use logic from jQuery to check for an invisible element.
        // See https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js#L12
        return !!(element.offsetWidth || element.offsetHeight ||
            (typeof element.getClientRects === 'function' && element.getClientRects().length));
    }
    /**
     * Gets whether an element's
     * @param {?} element
     * @return {?}
     */
    function isNativeFormElement(element) {
        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
        return nodeName === 'input' ||
            nodeName === 'select' ||
            nodeName === 'button' ||
            nodeName === 'textarea';
    }
    /**
     * Gets whether an element is an `<input type="hidden">`.
     * @param {?} element
     * @return {?}
     */
    function isHiddenInput(element) {
        return isInputElement(element) && element.type == 'hidden';
    }
    /**
     * Gets whether an element is an anchor that has an href attribute.
     * @param {?} element
     * @return {?}
     */
    function isAnchorWithHref(element) {
        return isAnchorElement(element) && element.hasAttribute('href');
    }
    /**
     * Gets whether an element is an input element.
     * @param {?} element
     * @return {?}
     */
    function isInputElement(element) {
        return element.nodeName.toLowerCase() == 'input';
    }
    /**
     * Gets whether an element is an anchor element.
     * @param {?} element
     * @return {?}
     */
    function isAnchorElement(element) {
        return element.nodeName.toLowerCase() == 'a';
    }
    /**
     * Gets whether an element has a valid tabindex.
     * @param {?} element
     * @return {?}
     */
    function hasValidTabIndex(element) {
        if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
            return false;
        }
        var /** @type {?} */ tabIndex = element.getAttribute('tabindex');
        // IE11 parses tabindex="" as the value "-32768"
        if (tabIndex == '-32768') {
            return false;
        }
        return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
    }
    /**
     * Returns the parsed tabindex from the element attributes instead of returning the
     * evaluated tabindex from the browsers defaults.
     * @param {?} element
     * @return {?}
     */
    function getTabIndexValue(element) {
        if (!hasValidTabIndex(element)) {
            return null;
        }
        // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
        var /** @type {?} */ tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);
        return isNaN(tabIndex) ? -1 : tabIndex;
    }
    /**
     * Checks whether the specified element is potentially tabbable on iOS
     * @param {?} element
     * @return {?}
     */
    function isPotentiallyTabbableIOS(element) {
        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
        var /** @type {?} */ inputType = nodeName === 'input' && (/** @type {?} */ (element)).type;
        return inputType === 'text'
            || inputType === 'password'
            || nodeName === 'select'
            || nodeName === 'textarea';
    }
    /**
     * Gets whether an element is potentially focusable without taking current visible/disabled state
     * into account.
     * @param {?} element
     * @return {?}
     */
    function isPotentiallyFocusable(element) {
        // Inputs are potentially focusable *unless* they're type="hidden".
        if (isHiddenInput(element)) {
            return false;
        }
        return isNativeFormElement(element) ||
            isAnchorWithHref(element) ||
            element.hasAttribute('contenteditable') ||
            hasValidTabIndex(element);
    }
    /**
     * Gets the parent window of a DOM node with regards of being inside of an iframe.
     * @param {?} node
     * @return {?}
     */
    function getWindow(node) {
        return node.ownerDocument.defaultView || window;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Class that allows for trapping focus within a DOM element.
     *
     * This class currently uses a relatively simple approach to focus trapping.
     * It assumes that the tab order is the same as DOM order, which is not necessarily true.
     * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
     */
    var  /**
     * Class that allows for trapping focus within a DOM element.
     *
     * This class currently uses a relatively simple approach to focus trapping.
     * It assumes that the tab order is the same as DOM order, which is not necessarily true.
     * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
     */
    FocusTrap = /** @class */ (function () {
        function FocusTrap(_element, _checker, _ngZone, _document, deferAnchors) {
            if (deferAnchors === void 0) { deferAnchors = false; }
            this._element = _element;
            this._checker = _checker;
            this._ngZone = _ngZone;
            this._document = _document;
            this._enabled = true;
            if (!deferAnchors) {
                this.attachAnchors();
            }
        }
        Object.defineProperty(FocusTrap.prototype, "enabled", {
            /** Whether the focus trap is active. */
            get: /**
             * Whether the focus trap is active.
             * @return {?}
             */
            function () { return this._enabled; },
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                this._enabled = val;
                if (this._startAnchor && this._endAnchor) {
                    this._startAnchor.tabIndex = this._endAnchor.tabIndex = this._enabled ? 0 : -1;
                }
            },
            enumerable: true,
            configurable: true
        });
        /** Destroys the focus trap by cleaning up the anchors. */
        /**
         * Destroys the focus trap by cleaning up the anchors.
         * @return {?}
         */
        FocusTrap.prototype.destroy = /**
         * Destroys the focus trap by cleaning up the anchors.
         * @return {?}
         */
        function () {
            if (this._startAnchor && this._startAnchor.parentNode) {
                this._startAnchor.parentNode.removeChild(this._startAnchor);
            }
            if (this._endAnchor && this._endAnchor.parentNode) {
                this._endAnchor.parentNode.removeChild(this._endAnchor);
            }
            this._startAnchor = this._endAnchor = null;
        };
        /**
         * Inserts the anchors into the DOM. This is usually done automatically
         * in the constructor, but can be deferred for cases like directives with `*ngIf`.
         */
        /**
         * Inserts the anchors into the DOM. This is usually done automatically
         * in the constructor, but can be deferred for cases like directives with `*ngIf`.
         * @return {?}
         */
        FocusTrap.prototype.attachAnchors = /**
         * Inserts the anchors into the DOM. This is usually done automatically
         * in the constructor, but can be deferred for cases like directives with `*ngIf`.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._startAnchor) {
                this._startAnchor = this._createAnchor();
            }
            if (!this._endAnchor) {
                this._endAnchor = this._createAnchor();
            }
            this._ngZone.runOutsideAngular(function () {
                /** @type {?} */ ((_this._startAnchor)).addEventListener('focus', function () {
                    _this.focusLastTabbableElement();
                }); /** @type {?} */
                ((_this._endAnchor)).addEventListener('focus', function () {
                    _this.focusFirstTabbableElement();
                });
                if (_this._element.parentNode) {
                    _this._element.parentNode.insertBefore(/** @type {?} */ ((_this._startAnchor)), _this._element);
                    _this._element.parentNode.insertBefore(/** @type {?} */ ((_this._endAnchor)), _this._element.nextSibling);
                }
            });
        };
        /**
         * Waits for the zone to stabilize, then either focuses the first element that the
         * user specified, or the first tabbable element.
         * @returns Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        /**
         * Waits for the zone to stabilize, then either focuses the first element that the
         * user specified, or the first tabbable element.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusInitialElementWhenReady = /**
         * Waits for the zone to stabilize, then either focuses the first element that the
         * user specified, or the first tabbable element.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        function () {
            var _this = this;
            return new Promise(function (resolve) {
                _this._executeOnStable(function () { return resolve(_this.focusInitialElement()); });
            });
        };
        /**
         * Waits for the zone to stabilize, then focuses
         * the first tabbable element within the focus trap region.
         * @returns Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        /**
         * Waits for the zone to stabilize, then focuses
         * the first tabbable element within the focus trap region.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusFirstTabbableElementWhenReady = /**
         * Waits for the zone to stabilize, then focuses
         * the first tabbable element within the focus trap region.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        function () {
            var _this = this;
            return new Promise(function (resolve) {
                _this._executeOnStable(function () { return resolve(_this.focusFirstTabbableElement()); });
            });
        };
        /**
         * Waits for the zone to stabilize, then focuses
         * the last tabbable element within the focus trap region.
         * @returns Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        /**
         * Waits for the zone to stabilize, then focuses
         * the last tabbable element within the focus trap region.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusLastTabbableElementWhenReady = /**
         * Waits for the zone to stabilize, then focuses
         * the last tabbable element within the focus trap region.
         * @return {?} Returns a promise that resolves with a boolean, depending
         * on whether focus was moved successfuly.
         */
        function () {
            var _this = this;
            return new Promise(function (resolve) {
                _this._executeOnStable(function () { return resolve(_this.focusLastTabbableElement()); });
            });
        };
        /**
         * Get the specified boundary element of the trapped region.
         * @param {?} bound The boundary to get (start or end of trapped region).
         * @return {?} The boundary element.
         */
        FocusTrap.prototype._getRegionBoundary = /**
         * Get the specified boundary element of the trapped region.
         * @param {?} bound The boundary to get (start or end of trapped region).
         * @return {?} The boundary element.
         */
        function (bound) {
            // Contains the deprecated version of selector, for temporary backwards comparability.
            var /** @type {?} */ markers = /** @type {?} */ (this._element.querySelectorAll("[cdk-focus-region-" + bound + "], " +
                ("[cdkFocusRegion" + bound + "], ") +
                ("[cdk-focus-" + bound + "]")));
            for (var /** @type {?} */ i = 0; i < markers.length; i++) {
                // @deletion-target 7.0.0
                if (markers[i].hasAttribute("cdk-focus-" + bound)) {
                    console.warn("Found use of deprecated attribute 'cdk-focus-" + bound + "', " +
                        ("use 'cdkFocusRegion" + bound + "' instead. The deprecated ") +
                        "attribute will be removed in 7.0.0.", markers[i]);
                }
                else if (markers[i].hasAttribute("cdk-focus-region-" + bound)) {
                    console.warn("Found use of deprecated attribute 'cdk-focus-region-" + bound + "', " +
                        ("use 'cdkFocusRegion" + bound + "' instead. The deprecated attribute ") +
                        "will be removed in 7.0.0.", markers[i]);
                }
            }
            if (bound == 'start') {
                return markers.length ? markers[0] : this._getFirstTabbableElement(this._element);
            }
            return markers.length ?
                markers[markers.length - 1] : this._getLastTabbableElement(this._element);
        };
        /**
         * Focuses the element that should be focused when the focus trap is initialized.
         * @returns Whether focus was moved successfuly.
         */
        /**
         * Focuses the element that should be focused when the focus trap is initialized.
         * @return {?} Whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusInitialElement = /**
         * Focuses the element that should be focused when the focus trap is initialized.
         * @return {?} Whether focus was moved successfuly.
         */
        function () {
            // Contains the deprecated version of selector, for temporary backwards comparability.
            var /** @type {?} */ redirectToElement = /** @type {?} */ (this._element.querySelector("[cdk-focus-initial], " +
                "[cdkFocusInitial]"));
            if (redirectToElement) {
                // @deletion-target 7.0.0
                if (redirectToElement.hasAttribute("cdk-focus-initial")) {
                    console.warn("Found use of deprecated attribute 'cdk-focus-initial', " +
                        "use 'cdkFocusInitial' instead. The deprecated attribute " +
                        "will be removed in 7.0.0", redirectToElement);
                }
                redirectToElement.focus();
                return true;
            }
            return this.focusFirstTabbableElement();
        };
        /**
         * Focuses the first tabbable element within the focus trap region.
         * @returns Whether focus was moved successfuly.
         */
        /**
         * Focuses the first tabbable element within the focus trap region.
         * @return {?} Whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusFirstTabbableElement = /**
         * Focuses the first tabbable element within the focus trap region.
         * @return {?} Whether focus was moved successfuly.
         */
        function () {
            var /** @type {?} */ redirectToElement = this._getRegionBoundary('start');
            if (redirectToElement) {
                redirectToElement.focus();
            }
            return !!redirectToElement;
        };
        /**
         * Focuses the last tabbable element within the focus trap region.
         * @returns Whether focus was moved successfuly.
         */
        /**
         * Focuses the last tabbable element within the focus trap region.
         * @return {?} Whether focus was moved successfuly.
         */
        FocusTrap.prototype.focusLastTabbableElement = /**
         * Focuses the last tabbable element within the focus trap region.
         * @return {?} Whether focus was moved successfuly.
         */
        function () {
            var /** @type {?} */ redirectToElement = this._getRegionBoundary('end');
            if (redirectToElement) {
                redirectToElement.focus();
            }
            return !!redirectToElement;
        };
        /**
         * Get the first tabbable element from a DOM subtree (inclusive).
         * @param {?} root
         * @return {?}
         */
        FocusTrap.prototype._getFirstTabbableElement = /**
         * Get the first tabbable element from a DOM subtree (inclusive).
         * @param {?} root
         * @return {?}
         */
        function (root) {
            if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
                return root;
            }
            // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
            // back to `childNodes` which includes text nodes, comments etc.
            var /** @type {?} */ children = root.children || root.childNodes;
            for (var /** @type {?} */ i = 0; i < children.length; i++) {
                var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                    this._getFirstTabbableElement(/** @type {?} */ (children[i])) :
                    null;
                if (tabbableChild) {
                    return tabbableChild;
                }
            }
            return null;
        };
        /**
         * Get the last tabbable element from a DOM subtree (inclusive).
         * @param {?} root
         * @return {?}
         */
        FocusTrap.prototype._getLastTabbableElement = /**
         * Get the last tabbable element from a DOM subtree (inclusive).
         * @param {?} root
         * @return {?}
         */
        function (root) {
            if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
                return root;
            }
            // Iterate in reverse DOM order.
            var /** @type {?} */ children = root.children || root.childNodes;
            for (var /** @type {?} */ i = children.length - 1; i >= 0; i--) {
                var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                    this._getLastTabbableElement(/** @type {?} */ (children[i])) :
                    null;
                if (tabbableChild) {
                    return tabbableChild;
                }
            }
            return null;
        };
        /**
         * Creates an anchor element.
         * @return {?}
         */
        FocusTrap.prototype._createAnchor = /**
         * Creates an anchor element.
         * @return {?}
         */
        function () {
            var /** @type {?} */ anchor = this._document.createElement('div');
            anchor.tabIndex = this._enabled ? 0 : -1;
            anchor.classList.add('cdk-visually-hidden');
            anchor.classList.add('cdk-focus-trap-anchor');
            return anchor;
        };
        /**
         * Executes a function when the zone is stable.
         * @param {?} fn
         * @return {?}
         */
        FocusTrap.prototype._executeOnStable = /**
         * Executes a function when the zone is stable.
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (this._ngZone.isStable) {
                fn();
            }
            else {
                this._ngZone.onStable.asObservable().pipe(operators.take(1)).subscribe(fn);
            }
        };
        return FocusTrap;
    }());
    /**
     * Factory that allows easy instantiation of focus traps.
     */
    var FocusTrapFactory = /** @class */ (function () {
        function FocusTrapFactory(_checker, _ngZone, _document) {
            this._checker = _checker;
            this._ngZone = _ngZone;
            this._document = _document;
        }
        /**
         * Creates a focus-trapped region around the given element.
         * @param element The element around which focus will be trapped.
         * @param deferCaptureElements Defers the creation of focus-capturing elements to be done
         *     manually by the user.
         * @returns The created focus trap instance.
         */
        /**
         * Creates a focus-trapped region around the given element.
         * @param {?} element The element around which focus will be trapped.
         * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
         *     manually by the user.
         * @return {?} The created focus trap instance.
         */
        FocusTrapFactory.prototype.create = /**
         * Creates a focus-trapped region around the given element.
         * @param {?} element The element around which focus will be trapped.
         * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
         *     manually by the user.
         * @return {?} The created focus trap instance.
         */
        function (element, deferCaptureElements) {
            if (deferCaptureElements === void 0) { deferCaptureElements = false; }
            return new FocusTrap(element, this._checker, this._ngZone, this._document, deferCaptureElements);
        };
        FocusTrapFactory.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        FocusTrapFactory.ctorParameters = function () { return [
            { type: InteractivityChecker, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ FocusTrapFactory.ngInjectableDef = core.defineInjectable({ factory: function FocusTrapFactory_Factory() { return new FocusTrapFactory(core.inject(InteractivityChecker), core.inject(core.NgZone), core.inject(common.DOCUMENT)); }, token: FocusTrapFactory, providedIn: "root" });
        return FocusTrapFactory;
    }());
    /**
     * Directive for trapping focus within a region.
     */
    var CdkTrapFocus = /** @class */ (function () {
        function CdkTrapFocus(_elementRef, _focusTrapFactory, _document) {
            this._elementRef = _elementRef;
            this._focusTrapFactory = _focusTrapFactory;
            /**
             * Previously focused element to restore focus to upon destroy when using autoCapture.
             */
            this._previouslyFocusedElement = null;
            this._document = _document;
            this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
        }
        Object.defineProperty(CdkTrapFocus.prototype, "enabled", {
            get: /**
             * Whether the focus trap is active.
             * @return {?}
             */
            function () { return this.focusTrap.enabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.focusTrap.enabled = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTrapFocus.prototype, "autoCapture", {
            get: /**
             * Whether the directive should automatially move focus into the trapped region upon
             * initialization and return focus to the previous activeElement upon destruction.
             * @return {?}
             */
            function () { return this._autoCapture; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._autoCapture = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkTrapFocus.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.focusTrap.destroy();
            // If we stored a previously focused element when using autoCapture, return focus to that
            // element now that the trapped region is being destroyed.
            if (this._previouslyFocusedElement) {
                this._previouslyFocusedElement.focus();
                this._previouslyFocusedElement = null;
            }
        };
        /**
         * @return {?}
         */
        CdkTrapFocus.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this.focusTrap.attachAnchors();
            if (this.autoCapture) {
                this._previouslyFocusedElement = /** @type {?} */ (this._document.activeElement);
                this.focusTrap.focusInitialElementWhenReady();
            }
        };
        CdkTrapFocus.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkTrapFocus]',
                        exportAs: 'cdkTrapFocus',
                    },] },
        ];
        /** @nocollapse */
        CdkTrapFocus.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: FocusTrapFactory, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        CdkTrapFocus.propDecorators = {
            "enabled": [{ type: core.Input, args: ['cdkTrapFocus',] },],
            "autoCapture": [{ type: core.Input, args: ['cdkTrapFocusAutoCapture',] },],
        };
        return CdkTrapFocus;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // The token for the live announcer element is defined in a separate file from LiveAnnouncer
    // as a workaround for https://github.com/angular/angular/issues/22559
    var /** @type {?} */ LIVE_ANNOUNCER_ELEMENT_TOKEN = new core.InjectionToken('liveAnnouncerElement', {
        providedIn: 'root',
        factory: LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY() {
        return null;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var LiveAnnouncer = /** @class */ (function () {
        function LiveAnnouncer(elementToken, _document) {
            this._document = _document;
            // We inject the live element as `any` because the constructor signature cannot reference
            // browser globals (HTMLElement) on non-browser environments, since having a class decorator
            // causes TypeScript to preserve the constructor signature types.
            this._liveElement = elementToken || this._createLiveElement();
        }
        /**
         * Announces a message to screenreaders.
         * @param message Message to be announced to the screenreader
         * @param politeness The politeness of the announcer element
         * @returns Promise that will be resolved when the message is added to the DOM.
         */
        /**
         * Announces a message to screenreaders.
         * @param {?} message Message to be announced to the screenreader
         * @param {?=} politeness The politeness of the announcer element
         * @return {?} Promise that will be resolved when the message is added to the DOM.
         */
        LiveAnnouncer.prototype.announce = /**
         * Announces a message to screenreaders.
         * @param {?} message Message to be announced to the screenreader
         * @param {?=} politeness The politeness of the announcer element
         * @return {?} Promise that will be resolved when the message is added to the DOM.
         */
        function (message, politeness) {
            var _this = this;
            if (politeness === void 0) { politeness = 'polite'; }
            this._liveElement.textContent = '';
            // TODO: ensure changing the politeness works on all environments we support.
            this._liveElement.setAttribute('aria-live', politeness);
            // This 100ms timeout is necessary for some browser + screen-reader combinations:
            // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
            // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
            //   second time without clearing and then using a non-zero delay.
            // (using JAWS 17 at time of this writing).
            return new Promise(function (resolve) {
                setTimeout(function () {
                    _this._liveElement.textContent = message;
                    resolve();
                }, 100);
            });
        };
        /**
         * @return {?}
         */
        LiveAnnouncer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._liveElement && this._liveElement.parentNode) {
                this._liveElement.parentNode.removeChild(this._liveElement);
            }
        };
        /**
         * @return {?}
         */
        LiveAnnouncer.prototype._createLiveElement = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ liveEl = this._document.createElement('div');
            liveEl.classList.add('cdk-visually-hidden');
            liveEl.setAttribute('aria-atomic', 'true');
            liveEl.setAttribute('aria-live', 'polite');
            this._document.body.appendChild(liveEl);
            return liveEl;
        };
        LiveAnnouncer.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        LiveAnnouncer.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ LiveAnnouncer.ngInjectableDef = core.defineInjectable({ factory: function LiveAnnouncer_Factory() { return new LiveAnnouncer(core.inject(LIVE_ANNOUNCER_ELEMENT_TOKEN, 8), core.inject(common.DOCUMENT)); }, token: LiveAnnouncer, providedIn: "root" });
        return LiveAnnouncer;
    }());
    /**
     * A directive that works similarly to aria-live, but uses the LiveAnnouncer to ensure compatibility
     * with a wider range of browsers and screen readers.
     */
    var CdkAriaLive = /** @class */ (function () {
        function CdkAriaLive(_elementRef, _liveAnnouncer, _contentObserver, _ngZone) {
            this._elementRef = _elementRef;
            this._liveAnnouncer = _liveAnnouncer;
            this._contentObserver = _contentObserver;
            this._ngZone = _ngZone;
            this._politeness = 'off';
        }
        Object.defineProperty(CdkAriaLive.prototype, "politeness", {
            get: /**
             * The aria-live politeness level to use when announcing messages.
             * @return {?}
             */
            function () { return this._politeness; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var _this = this;
                this._politeness = value === 'polite' || value === 'assertive' ? value : 'off';
                if (this._politeness === 'off') {
                    if (this._subscription) {
                        this._subscription.unsubscribe();
                        this._subscription = null;
                    }
                }
                else {
                    if (!this._subscription) {
                        this._subscription = this._ngZone.runOutsideAngular(function () {
                            return _this._contentObserver.observe(_this._elementRef.nativeElement).subscribe(function () {
                                return _this._liveAnnouncer.announce(_this._elementRef.nativeElement.innerText, _this._politeness);
                            });
                        });
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkAriaLive.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._subscription) {
                this._subscription.unsubscribe();
            }
        };
        CdkAriaLive.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkAriaLive]',
                        exportAs: 'cdkAriaLive',
                    },] },
        ];
        /** @nocollapse */
        CdkAriaLive.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: LiveAnnouncer, },
            { type: ContentObserver, },
            { type: core.NgZone, },
        ]; };
        CdkAriaLive.propDecorators = {
            "politeness": [{ type: core.Input, args: ['cdkAriaLive',] },],
        };
        return CdkAriaLive;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentDispatcher
     * @param {?} liveElement
     * @param {?} _document
     * @return {?}
     */
    function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, _document) {
        return parentDispatcher || new LiveAnnouncer(liveElement, _document);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ LIVE_ANNOUNCER_PROVIDER = {
        // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
        provide: LiveAnnouncer,
        deps: [
            [new core.Optional(), new core.SkipSelf(), LiveAnnouncer],
            [new core.Optional(), new core.Inject(LIVE_ANNOUNCER_ELEMENT_TOKEN)],
            common.DOCUMENT,
        ],
        useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
    // that a value of around 650ms seems appropriate.
    var /** @type {?} */ TOUCH_BUFFER_MS = 650;
    /**
     * Monitors mouse and keyboard events to determine the cause of focus events.
     */
    var FocusMonitor = /** @class */ (function () {
        function FocusMonitor(_ngZone, _platform) {
            this._ngZone = _ngZone;
            this._platform = _platform;
            /**
             * The focus origin that the next focus event is a result of.
             */
            this._origin = null;
            /**
             * Whether the window has just been focused.
             */
            this._windowFocused = false;
            /**
             * Map of elements being monitored to their info.
             */
            this._elementInfo = new Map();
            /**
             * A map of global objects to lists of current listeners.
             */
            this._unregisterGlobalListeners = function () { };
            /**
             * The number of elements currently being monitored.
             */
            this._monitoredElementCount = 0;
        }
        /**
         * Monitors focus on an element and applies appropriate CSS classes.
         * @param element The element to monitor
         * @param checkChildren Whether to count the element as focused when its children are focused.
         * @returns An observable that emits when the focus state of the element changes.
         *     When the element is blurred, null will be emitted.
         */
        /**
         * Monitors focus on an element and applies appropriate CSS classes.
         * @param {?} element The element to monitor
         * @param {?=} checkChildren Whether to count the element as focused when its children are focused.
         * @return {?} An observable that emits when the focus state of the element changes.
         *     When the element is blurred, null will be emitted.
         */
        FocusMonitor.prototype.monitor = /**
         * Monitors focus on an element and applies appropriate CSS classes.
         * @param {?} element The element to monitor
         * @param {?=} checkChildren Whether to count the element as focused when its children are focused.
         * @return {?} An observable that emits when the focus state of the element changes.
         *     When the element is blurred, null will be emitted.
         */
        function (element, checkChildren) {
            var _this = this;
            if (checkChildren === void 0) { checkChildren = false; }
            // Do nothing if we're not on the browser platform.
            if (!this._platform.isBrowser) {
                return rxjs.of(null);
            }
            // Check if we're already monitoring this element.
            if (this._elementInfo.has(element)) {
                var /** @type {?} */ cachedInfo = this._elementInfo.get(element); /** @type {?} */
                ((cachedInfo)).checkChildren = checkChildren;
                return /** @type {?} */ ((cachedInfo)).subject.asObservable();
            }
            // Create monitored element info.
            var /** @type {?} */ info = {
                unlisten: function () { },
                checkChildren: checkChildren,
                subject: new rxjs.Subject()
            };
            this._elementInfo.set(element, info);
            this._incrementMonitoredElementCount();
            // Start listening. We need to listen in capture phase since focus events don't bubble.
            var /** @type {?} */ focusListener = function (event) { return _this._onFocus(event, element); };
            var /** @type {?} */ blurListener = function (event) { return _this._onBlur(event, element); };
            this._ngZone.runOutsideAngular(function () {
                element.addEventListener('focus', focusListener, true);
                element.addEventListener('blur', blurListener, true);
            });
            // Create an unlisten function for later.
            info.unlisten = function () {
                element.removeEventListener('focus', focusListener, true);
                element.removeEventListener('blur', blurListener, true);
            };
            return info.subject.asObservable();
        };
        /**
         * Stops monitoring an element and removes all focus classes.
         * @param element The element to stop monitoring.
         */
        /**
         * Stops monitoring an element and removes all focus classes.
         * @param {?} element The element to stop monitoring.
         * @return {?}
         */
        FocusMonitor.prototype.stopMonitoring = /**
         * Stops monitoring an element and removes all focus classes.
         * @param {?} element The element to stop monitoring.
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ elementInfo = this._elementInfo.get(element);
            if (elementInfo) {
                elementInfo.unlisten();
                elementInfo.subject.complete();
                this._setClasses(element);
                this._elementInfo.delete(element);
                this._decrementMonitoredElementCount();
            }
        };
        /**
         * Focuses the element via the specified focus origin.
         * @param element The element to focus.
         * @param origin The focus origin.
         */
        /**
         * Focuses the element via the specified focus origin.
         * @param {?} element The element to focus.
         * @param {?} origin The focus origin.
         * @return {?}
         */
        FocusMonitor.prototype.focusVia = /**
         * Focuses the element via the specified focus origin.
         * @param {?} element The element to focus.
         * @param {?} origin The focus origin.
         * @return {?}
         */
        function (element, origin) {
            this._setOriginForCurrentEventQueue(origin);
            // `focus` isn't available on the server
            if (typeof element.focus === 'function') {
                element.focus();
            }
        };
        /**
         * @return {?}
         */
        FocusMonitor.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._elementInfo.forEach(function (_info, element) { return _this.stopMonitoring(element); });
        };
        /**
         * Register necessary event listeners on the document and window.
         * @return {?}
         */
        FocusMonitor.prototype._registerGlobalListeners = /**
         * Register necessary event listeners on the document and window.
         * @return {?}
         */
        function () {
            var _this = this;
            // Do nothing if we're not on the browser platform.
            if (!this._platform.isBrowser) {
                return;
            }
            // On keydown record the origin and clear any touch event that may be in progress.
            var /** @type {?} */ documentKeydownListener = function () {
                _this._lastTouchTarget = null;
                _this._setOriginForCurrentEventQueue('keyboard');
            };
            // On mousedown record the origin only if there is not touch target, since a mousedown can
            // happen as a result of a touch event.
            var /** @type {?} */ documentMousedownListener = function () {
                if (!_this._lastTouchTarget) {
                    _this._setOriginForCurrentEventQueue('mouse');
                }
            };
            // When the touchstart event fires the focus event is not yet in the event queue. This means
            // we can't rely on the trick used above (setting timeout of 0ms). Instead we wait 650ms to
            // see if a focus happens.
            var /** @type {?} */ documentTouchstartListener = function (event) {
                if (_this._touchTimeoutId != null) {
                    clearTimeout(_this._touchTimeoutId);
                }
                _this._lastTouchTarget = event.target;
                _this._touchTimeoutId = setTimeout(function () { return _this._lastTouchTarget = null; }, TOUCH_BUFFER_MS);
            };
            // Make a note of when the window regains focus, so we can restore the origin info for the
            // focused element.
            var /** @type {?} */ windowFocusListener = function () {
                _this._windowFocused = true;
                _this._windowFocusTimeoutId = setTimeout(function () { return _this._windowFocused = false; });
            };
            // Note: we listen to events in the capture phase so we can detect them even if the user stops
            // propagation.
            this._ngZone.runOutsideAngular(function () {
                document.addEventListener('keydown', documentKeydownListener, true);
                document.addEventListener('mousedown', documentMousedownListener, true);
                document.addEventListener('touchstart', documentTouchstartListener, supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
                window.addEventListener('focus', windowFocusListener);
            });
            this._unregisterGlobalListeners = function () {
                document.removeEventListener('keydown', documentKeydownListener, true);
                document.removeEventListener('mousedown', documentMousedownListener, true);
                document.removeEventListener('touchstart', documentTouchstartListener, supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
                window.removeEventListener('focus', windowFocusListener);
                // Clear timeouts for all potentially pending timeouts to prevent the leaks.
                clearTimeout(_this._windowFocusTimeoutId);
                clearTimeout(_this._touchTimeoutId);
                clearTimeout(_this._originTimeoutId);
            };
        };
        /**
         * @param {?} element
         * @param {?} className
         * @param {?} shouldSet
         * @return {?}
         */
        FocusMonitor.prototype._toggleClass = /**
         * @param {?} element
         * @param {?} className
         * @param {?} shouldSet
         * @return {?}
         */
        function (element, className, shouldSet) {
            if (shouldSet) {
                element.classList.add(className);
            }
            else {
                element.classList.remove(className);
            }
        };
        /**
         * Sets the focus classes on the element based on the given focus origin.
         * @param {?} element The element to update the classes on.
         * @param {?=} origin The focus origin.
         * @return {?}
         */
        FocusMonitor.prototype._setClasses = /**
         * Sets the focus classes on the element based on the given focus origin.
         * @param {?} element The element to update the classes on.
         * @param {?=} origin The focus origin.
         * @return {?}
         */
        function (element, origin) {
            var /** @type {?} */ elementInfo = this._elementInfo.get(element);
            if (elementInfo) {
                this._toggleClass(element, 'cdk-focused', !!origin);
                this._toggleClass(element, 'cdk-touch-focused', origin === 'touch');
                this._toggleClass(element, 'cdk-keyboard-focused', origin === 'keyboard');
                this._toggleClass(element, 'cdk-mouse-focused', origin === 'mouse');
                this._toggleClass(element, 'cdk-program-focused', origin === 'program');
            }
        };
        /**
         * Sets the origin and schedules an async function to clear it at the end of the event queue.
         * @param {?} origin The origin to set.
         * @return {?}
         */
        FocusMonitor.prototype._setOriginForCurrentEventQueue = /**
         * Sets the origin and schedules an async function to clear it at the end of the event queue.
         * @param {?} origin The origin to set.
         * @return {?}
         */
        function (origin) {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                _this._origin = origin;
                _this._originTimeoutId = setTimeout(function () { return _this._origin = null; });
            });
        };
        /**
         * Checks whether the given focus event was caused by a touchstart event.
         * @param {?} event The focus event to check.
         * @return {?} Whether the event was caused by a touch.
         */
        FocusMonitor.prototype._wasCausedByTouch = /**
         * Checks whether the given focus event was caused by a touchstart event.
         * @param {?} event The focus event to check.
         * @return {?} Whether the event was caused by a touch.
         */
        function (event) {
            // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
            // Consider the following dom structure:
            //
            // <div #parent tabindex="0" cdkFocusClasses>
            //   <div #child (click)="#parent.focus()"></div>
            // </div>
            //
            // If the user touches the #child element and the #parent is programmatically focused as a
            // result, this code will still consider it to have been caused by the touch event and will
            // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
            // relatively small edge-case that can be worked around by using
            // focusVia(parentEl, 'program') to focus the parent element.
            //
            // If we decide that we absolutely must handle this case correctly, we can do so by listening
            // for the first focus event after the touchstart, and then the first blur event after that
            // focus event. When that blur event fires we know that whatever follows is not a result of the
            // touchstart.
            var /** @type {?} */ focusTarget = event.target;
            return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
                (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
        };
        /**
         * Handles focus events on a registered element.
         * @param {?} event The focus event.
         * @param {?} element The monitored element.
         * @return {?}
         */
        FocusMonitor.prototype._onFocus = /**
         * Handles focus events on a registered element.
         * @param {?} event The focus event.
         * @param {?} element The monitored element.
         * @return {?}
         */
        function (event, element) {
            // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
            // focus event affecting the monitored element. If we want to use the origin of the first event
            // instead we should check for the cdk-focused class here and return if the element already has
            // it. (This only matters for elements that have includesChildren = true).
            // If we are not counting child-element-focus as focused, make sure that the event target is the
            // monitored element itself.
            var /** @type {?} */ elementInfo = this._elementInfo.get(element);
            if (!elementInfo || (!elementInfo.checkChildren && element !== event.target)) {
                return;
            }
            // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
            // 1) The window has just regained focus, in which case we want to restore the focused state of
            //    the element from before the window blurred.
            // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
            // 3) The element was programmatically focused, in which case we should mark the origin as
            //    'program'.
            var /** @type {?} */ origin = this._origin;
            if (!origin) {
                if (this._windowFocused && this._lastFocusOrigin) {
                    origin = this._lastFocusOrigin;
                }
                else if (this._wasCausedByTouch(event)) {
                    origin = 'touch';
                }
                else {
                    origin = 'program';
                }
            }
            this._setClasses(element, origin);
            this._emitOrigin(elementInfo.subject, origin);
            this._lastFocusOrigin = origin;
        };
        /**
         * Handles blur events on a registered element.
         * @param event The blur event.
         * @param element The monitored element.
         */
        /**
         * Handles blur events on a registered element.
         * @param {?} event The blur event.
         * @param {?} element The monitored element.
         * @return {?}
         */
        FocusMonitor.prototype._onBlur = /**
         * Handles blur events on a registered element.
         * @param {?} event The blur event.
         * @param {?} element The monitored element.
         * @return {?}
         */
        function (event, element) {
            // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
            // order to focus another child of the monitored element.
            var /** @type {?} */ elementInfo = this._elementInfo.get(element);
            if (!elementInfo || (elementInfo.checkChildren && event.relatedTarget instanceof Node &&
                element.contains(event.relatedTarget))) {
                return;
            }
            this._setClasses(element);
            this._emitOrigin(elementInfo.subject, null);
        };
        /**
         * @param {?} subject
         * @param {?} origin
         * @return {?}
         */
        FocusMonitor.prototype._emitOrigin = /**
         * @param {?} subject
         * @param {?} origin
         * @return {?}
         */
        function (subject, origin) {
            this._ngZone.run(function () { return subject.next(origin); });
        };
        /**
         * @return {?}
         */
        FocusMonitor.prototype._incrementMonitoredElementCount = /**
         * @return {?}
         */
        function () {
            // Register global listeners when first element is monitored.
            if (++this._monitoredElementCount == 1) {
                this._registerGlobalListeners();
            }
        };
        /**
         * @return {?}
         */
        FocusMonitor.prototype._decrementMonitoredElementCount = /**
         * @return {?}
         */
        function () {
            // Unregister global listeners when last element is unmonitored.
            if (!--this._monitoredElementCount) {
                this._unregisterGlobalListeners();
                this._unregisterGlobalListeners = function () { };
            }
        };
        FocusMonitor.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        FocusMonitor.ctorParameters = function () { return [
            { type: core.NgZone, },
            { type: Platform, },
        ]; };
        /** @nocollapse */ FocusMonitor.ngInjectableDef = core.defineInjectable({ factory: function FocusMonitor_Factory() { return new FocusMonitor(core.inject(core.NgZone), core.inject(Platform)); }, token: FocusMonitor, providedIn: "root" });
        return FocusMonitor;
    }());
    /**
     * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
     * programmatically) and adds corresponding classes to the element.
     *
     * There are two variants of this directive:
     * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
     *    focused.
     * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
     */
    var CdkMonitorFocus = /** @class */ (function () {
        function CdkMonitorFocus(_elementRef, _focusMonitor) {
            var _this = this;
            this._elementRef = _elementRef;
            this._focusMonitor = _focusMonitor;
            this.cdkFocusChange = new core.EventEmitter();
            this._monitorSubscription = this._focusMonitor.monitor(this._elementRef.nativeElement, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
                .subscribe(function (origin) { return _this.cdkFocusChange.emit(origin); });
        }
        /**
         * @return {?}
         */
        CdkMonitorFocus.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
            this._monitorSubscription.unsubscribe();
        };
        CdkMonitorFocus.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
                    },] },
        ];
        /** @nocollapse */
        CdkMonitorFocus.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: FocusMonitor, },
        ]; };
        CdkMonitorFocus.propDecorators = {
            "cdkFocusChange": [{ type: core.Output },],
        };
        return CdkMonitorFocus;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentDispatcher
     * @param {?} ngZone
     * @param {?} platform
     * @return {?}
     */
    function FOCUS_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
        return parentDispatcher || new FocusMonitor(ngZone, platform);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ FOCUS_MONITOR_PROVIDER = {
        // If there is already a FocusMonitor available, use that. Otherwise, provide a new one.
        provide: FocusMonitor,
        deps: [[new core.Optional(), new core.SkipSelf(), FocusMonitor], core.NgZone, Platform],
        useFactory: FOCUS_MONITOR_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Screenreaders will often fire fake mousedown events when a focusable element
     * is activated using the keyboard. We can typically distinguish between these faked
     * mousedown events and real mousedown events using the "buttons" property. While
     * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
     * the left mouse button), faked mousedowns will usually set the property value to 0.
     * @param {?} event
     * @return {?}
     */
    function isFakeMousedownFromScreenReader(event) {
        return event.buttons === 0;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var A11yModule = /** @class */ (function () {
        function A11yModule() {
        }
        A11yModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, PlatformModule, ObserversModule],
                        declarations: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                        exports: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                    },] },
        ];
        return A11yModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Time in ms to throttle the scrolling events by default.
     */
    var /** @type {?} */ DEFAULT_SCROLL_TIME = 20;
    /**
     * Service contained all registered Scrollable references and emits an event when any one of the
     * Scrollable references emit a scrolled event.
     */
    var ScrollDispatcher = /** @class */ (function () {
        function ScrollDispatcher(_ngZone, _platform) {
            this._ngZone = _ngZone;
            this._platform = _platform;
            /**
             * Subject for notifying that a registered scrollable reference element has been scrolled.
             */
            this._scrolled = new rxjs.Subject();
            /**
             * Keeps track of the global `scroll` and `resize` subscriptions.
             */
            this._globalSubscription = null;
            /**
             * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
             */
            this._scrolledCount = 0;
            /**
             * Map of all the scrollable references that are registered with the service and their
             * scroll event subscriptions.
             */
            this.scrollContainers = new Map();
        }
        /**
         * Registers a scrollable instance with the service and listens for its scrolled events. When the
         * scrollable is scrolled, the service emits the event to its scrolled observable.
         * @param scrollable Scrollable instance to be registered.
         */
        /**
         * Registers a scrollable instance with the service and listens for its scrolled events. When the
         * scrollable is scrolled, the service emits the event to its scrolled observable.
         * @param {?} scrollable Scrollable instance to be registered.
         * @return {?}
         */
        ScrollDispatcher.prototype.register = /**
         * Registers a scrollable instance with the service and listens for its scrolled events. When the
         * scrollable is scrolled, the service emits the event to its scrolled observable.
         * @param {?} scrollable Scrollable instance to be registered.
         * @return {?}
         */
        function (scrollable) {
            var _this = this;
            var /** @type {?} */ scrollSubscription = scrollable.elementScrolled()
                .subscribe(function () { return _this._scrolled.next(scrollable); });
            this.scrollContainers.set(scrollable, scrollSubscription);
        };
        /**
         * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
         * @param scrollable Scrollable instance to be deregistered.
         */
        /**
         * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
         * @param {?} scrollable Scrollable instance to be deregistered.
         * @return {?}
         */
        ScrollDispatcher.prototype.deregister = /**
         * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
         * @param {?} scrollable Scrollable instance to be deregistered.
         * @return {?}
         */
        function (scrollable) {
            var /** @type {?} */ scrollableReference = this.scrollContainers.get(scrollable);
            if (scrollableReference) {
                scrollableReference.unsubscribe();
                this.scrollContainers.delete(scrollable);
            }
        };
        /**
         * Returns an observable that emits an event whenever any of the registered Scrollable
         * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
         * to override the default "throttle" time.
         *
         * **Note:** in order to avoid hitting change detection for every scroll event,
         * all of the events emitted from this stream will be run outside the Angular zone.
         * If you need to update any data bindings as a result of a scroll event, you have
         * to run the callback using `NgZone.run`.
         */
        /**
         * Returns an observable that emits an event whenever any of the registered Scrollable
         * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
         * to override the default "throttle" time.
         *
         * **Note:** in order to avoid hitting change detection for every scroll event,
         * all of the events emitted from this stream will be run outside the Angular zone.
         * If you need to update any data bindings as a result of a scroll event, you have
         * to run the callback using `NgZone.run`.
         * @param {?=} auditTimeInMs
         * @return {?}
         */
        ScrollDispatcher.prototype.scrolled = /**
         * Returns an observable that emits an event whenever any of the registered Scrollable
         * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
         * to override the default "throttle" time.
         *
         * **Note:** in order to avoid hitting change detection for every scroll event,
         * all of the events emitted from this stream will be run outside the Angular zone.
         * If you need to update any data bindings as a result of a scroll event, you have
         * to run the callback using `NgZone.run`.
         * @param {?=} auditTimeInMs
         * @return {?}
         */
        function (auditTimeInMs) {
            var _this = this;
            if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
            return this._platform.isBrowser ? rxjs.Observable.create(function (observer) {
                if (!_this._globalSubscription) {
                    _this._addGlobalListener();
                }
                // In the case of a 0ms delay, use an observable without auditTime
                // since it does add a perceptible delay in processing overhead.
                var /** @type {?} */ subscription = auditTimeInMs > 0 ?
                    _this._scrolled.pipe(operators.auditTime(auditTimeInMs)).subscribe(observer) :
                    _this._scrolled.subscribe(observer);
                _this._scrolledCount++;
                return function () {
                    subscription.unsubscribe();
                    _this._scrolledCount--;
                    if (!_this._scrolledCount) {
                        _this._removeGlobalListener();
                    }
                };
            }) : rxjs.of();
        };
        /**
         * @return {?}
         */
        ScrollDispatcher.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._removeGlobalListener();
            this.scrollContainers.forEach(function (_, container) { return _this.deregister(container); });
            this._scrolled.complete();
        };
        /**
         * Returns an observable that emits whenever any of the
         * scrollable ancestors of an element are scrolled.
         * @param elementRef Element whose ancestors to listen for.
         * @param auditTimeInMs Time to throttle the scroll events.
         */
        /**
         * Returns an observable that emits whenever any of the
         * scrollable ancestors of an element are scrolled.
         * @param {?} elementRef Element whose ancestors to listen for.
         * @param {?=} auditTimeInMs Time to throttle the scroll events.
         * @return {?}
         */
        ScrollDispatcher.prototype.ancestorScrolled = /**
         * Returns an observable that emits whenever any of the
         * scrollable ancestors of an element are scrolled.
         * @param {?} elementRef Element whose ancestors to listen for.
         * @param {?=} auditTimeInMs Time to throttle the scroll events.
         * @return {?}
         */
        function (elementRef, auditTimeInMs) {
            var /** @type {?} */ ancestors = this.getAncestorScrollContainers(elementRef);
            return this.scrolled(auditTimeInMs).pipe(operators.filter(function (target) {
                return !target || ancestors.indexOf(target) > -1;
            }));
        };
        /** Returns all registered Scrollables that contain the provided element. */
        /**
         * Returns all registered Scrollables that contain the provided element.
         * @param {?} elementRef
         * @return {?}
         */
        ScrollDispatcher.prototype.getAncestorScrollContainers = /**
         * Returns all registered Scrollables that contain the provided element.
         * @param {?} elementRef
         * @return {?}
         */
        function (elementRef) {
            var _this = this;
            var /** @type {?} */ scrollingContainers = [];
            this.scrollContainers.forEach(function (_subscription, scrollable) {
                if (_this._scrollableContainsElement(scrollable, elementRef)) {
                    scrollingContainers.push(scrollable);
                }
            });
            return scrollingContainers;
        };
        /**
         * Returns true if the element is contained within the provided Scrollable.
         * @param {?} scrollable
         * @param {?} elementRef
         * @return {?}
         */
        ScrollDispatcher.prototype._scrollableContainsElement = /**
         * Returns true if the element is contained within the provided Scrollable.
         * @param {?} scrollable
         * @param {?} elementRef
         * @return {?}
         */
        function (scrollable, elementRef) {
            var /** @type {?} */ element = elementRef.nativeElement;
            var /** @type {?} */ scrollableElement = scrollable.getElementRef().nativeElement;
            // Traverse through the element parents until we reach null, checking if any of the elements
            // are the scrollable's element.
            do {
                if (element == scrollableElement) {
                    return true;
                }
            } while (element = element.parentElement);
            return false;
        };
        /**
         * Sets up the global scroll listeners.
         * @return {?}
         */
        ScrollDispatcher.prototype._addGlobalListener = /**
         * Sets up the global scroll listeners.
         * @return {?}
         */
        function () {
            var _this = this;
            this._globalSubscription = this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(window.document, 'scroll').subscribe(function () { return _this._scrolled.next(); });
            });
        };
        /**
         * Cleans up the global scroll listener.
         * @return {?}
         */
        ScrollDispatcher.prototype._removeGlobalListener = /**
         * Cleans up the global scroll listener.
         * @return {?}
         */
        function () {
            if (this._globalSubscription) {
                this._globalSubscription.unsubscribe();
                this._globalSubscription = null;
            }
        };
        ScrollDispatcher.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        ScrollDispatcher.ctorParameters = function () { return [
            { type: core.NgZone, },
            { type: Platform, },
        ]; };
        /** @nocollapse */ ScrollDispatcher.ngInjectableDef = core.defineInjectable({ factory: function ScrollDispatcher_Factory() { return new ScrollDispatcher(core.inject(core.NgZone), core.inject(Platform)); }, token: ScrollDispatcher, providedIn: "root" });
        return ScrollDispatcher;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentDispatcher
     * @param {?} ngZone
     * @param {?} platform
     * @return {?}
     */
    function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
        return parentDispatcher || new ScrollDispatcher(ngZone, platform);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ SCROLL_DISPATCHER_PROVIDER = {
        // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
        provide: ScrollDispatcher,
        deps: [[new core.Optional(), new core.SkipSelf(), ScrollDispatcher], core.NgZone, Platform],
        useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Sends an event when the directive's element is scrolled. Registers itself with the
     * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
     * can be listened to through the service.
     */
    var CdkScrollable = /** @class */ (function () {
        function CdkScrollable(_elementRef, _scroll, _ngZone) {
            var _this = this;
            this._elementRef = _elementRef;
            this._scroll = _scroll;
            this._ngZone = _ngZone;
            this._elementScrolled = new rxjs.Subject();
            this._scrollListener = function (event) { return _this._elementScrolled.next(event); };
        }
        /**
         * @return {?}
         */
        CdkScrollable.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                _this.getElementRef().nativeElement.addEventListener('scroll', _this._scrollListener);
            });
            this._scroll.register(this);
        };
        /**
         * @return {?}
         */
        CdkScrollable.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._scroll.deregister(this);
            if (this._scrollListener) {
                this.getElementRef().nativeElement.removeEventListener('scroll', this._scrollListener);
            }
            this._elementScrolled.complete();
        };
        /**
         * Returns observable that emits when a scroll event is fired on the host element.
         */
        /**
         * Returns observable that emits when a scroll event is fired on the host element.
         * @return {?}
         */
        CdkScrollable.prototype.elementScrolled = /**
         * Returns observable that emits when a scroll event is fired on the host element.
         * @return {?}
         */
        function () {
            return this._elementScrolled.asObservable();
        };
        /**
         * @return {?}
         */
        CdkScrollable.prototype.getElementRef = /**
         * @return {?}
         */
        function () {
            return this._elementRef;
        };
        CdkScrollable.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdk-scrollable], [cdkScrollable]'
                    },] },
        ];
        /** @nocollapse */
        CdkScrollable.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: ScrollDispatcher, },
            { type: core.NgZone, },
        ]; };
        return CdkScrollable;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Time in ms to throttle the resize events by default.
     */
    var /** @type {?} */ DEFAULT_RESIZE_TIME = 20;
    /**
     * Simple utility for getting the bounds of the browser viewport.
     * \@docs-private
     */
    var ViewportRuler = /** @class */ (function () {
        function ViewportRuler(_platform, ngZone) {
            var _this = this;
            this._platform = _platform;
            this._change = _platform.isBrowser ? ngZone.runOutsideAngular(function () {
                return rxjs.merge(rxjs.fromEvent(window, 'resize'), rxjs.fromEvent(window, 'orientationchange'));
            }) : rxjs.of();
            this._invalidateCache = this.change().subscribe(function () { return _this._updateViewportSize(); });
        }
        /**
         * @return {?}
         */
        ViewportRuler.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._invalidateCache.unsubscribe();
        };
        /** Returns the viewport's width and height. */
        /**
         * Returns the viewport's width and height.
         * @return {?}
         */
        ViewportRuler.prototype.getViewportSize = /**
         * Returns the viewport's width and height.
         * @return {?}
         */
        function () {
            if (!this._viewportSize) {
                this._updateViewportSize();
            }
            var /** @type {?} */ output = { width: this._viewportSize.width, height: this._viewportSize.height };
            // If we're not on a browser, don't cache the size since it'll be mocked out anyway.
            if (!this._platform.isBrowser) {
                this._viewportSize = /** @type {?} */ ((null));
            }
            return output;
        };
        /** Gets a ClientRect for the viewport's bounds. */
        /**
         * Gets a ClientRect for the viewport's bounds.
         * @return {?}
         */
        ViewportRuler.prototype.getViewportRect = /**
         * Gets a ClientRect for the viewport's bounds.
         * @return {?}
         */
        function () {
            // Use the document element's bounding rect rather than the window scroll properties
            // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
            // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
            // conceptual viewports. Under most circumstances these viewports are equivalent, but they
            // can disagree when the page is pinch-zoomed (on devices that support touch).
            // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
            // We use the documentElement instead of the body because, by default (without a css reset)
            // browsers typically give the document body an 8px margin, which is not included in
            // getBoundingClientRect().
            var /** @type {?} */ scrollPosition = this.getViewportScrollPosition();
            var _a = this.getViewportSize(), width = _a.width, height = _a.height;
            return {
                top: scrollPosition.top,
                left: scrollPosition.left,
                bottom: scrollPosition.top + height,
                right: scrollPosition.left + width,
                height: height,
                width: width,
            };
        };
        /** Gets the (top, left) scroll position of the viewport. */
        /**
         * Gets the (top, left) scroll position of the viewport.
         * @return {?}
         */
        ViewportRuler.prototype.getViewportScrollPosition = /**
         * Gets the (top, left) scroll position of the viewport.
         * @return {?}
         */
        function () {
            // While we can get a reference to the fake document
            // during SSR, it doesn't have getBoundingClientRect.
            if (!this._platform.isBrowser) {
                return { top: 0, left: 0 };
            }
            // The top-left-corner of the viewport is determined by the scroll position of the document
            // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
            // whether `document.body` or `document.documentElement` is the scrolled element, so reading
            // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
            // `document.documentElement` works consistently, where the `top` and `left` values will
            // equal negative the scroll position.
            var /** @type {?} */ documentRect = document.documentElement.getBoundingClientRect();
            var /** @type {?} */ top = -documentRect.top || document.body.scrollTop || window.scrollY ||
                document.documentElement.scrollTop || 0;
            var /** @type {?} */ left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
                document.documentElement.scrollLeft || 0;
            return { top: top, left: left };
        };
        /**
         * Returns a stream that emits whenever the size of the viewport changes.
         * @param throttleTime Time in milliseconds to throttle the stream.
         */
        /**
         * Returns a stream that emits whenever the size of the viewport changes.
         * @param {?=} throttleTime Time in milliseconds to throttle the stream.
         * @return {?}
         */
        ViewportRuler.prototype.change = /**
         * Returns a stream that emits whenever the size of the viewport changes.
         * @param {?=} throttleTime Time in milliseconds to throttle the stream.
         * @return {?}
         */
        function (throttleTime) {
            if (throttleTime === void 0) { throttleTime = DEFAULT_RESIZE_TIME; }
            return throttleTime > 0 ? this._change.pipe(operators.auditTime(throttleTime)) : this._change;
        };
        /**
         * Updates the cached viewport size.
         * @return {?}
         */
        ViewportRuler.prototype._updateViewportSize = /**
         * Updates the cached viewport size.
         * @return {?}
         */
        function () {
            this._viewportSize = this._platform.isBrowser ?
                { width: window.innerWidth, height: window.innerHeight } :
                { width: 0, height: 0 };
        };
        ViewportRuler.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        ViewportRuler.ctorParameters = function () { return [
            { type: Platform, },
            { type: core.NgZone, },
        ]; };
        /** @nocollapse */ ViewportRuler.ngInjectableDef = core.defineInjectable({ factory: function ViewportRuler_Factory() { return new ViewportRuler(core.inject(Platform), core.inject(core.NgZone)); }, token: ViewportRuler, providedIn: "root" });
        return ViewportRuler;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentRuler
     * @param {?} platform
     * @param {?} ngZone
     * @return {?}
     */
    function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, platform, ngZone) {
        return parentRuler || new ViewportRuler(platform, ngZone);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ VIEWPORT_RULER_PROVIDER = {
        // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
        provide: ViewportRuler,
        deps: [[new core.Optional(), new core.SkipSelf(), ViewportRuler], Platform, core.NgZone],
        useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var ScrollDispatchModule = /** @class */ (function () {
        function ScrollDispatchModule() {
        }
        ScrollDispatchModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [PlatformModule],
                        exports: [CdkScrollable],
                        declarations: [CdkScrollable],
                    },] },
        ];
        return ScrollDispatchModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Throws an exception when attempting to attach a null portal to a host.
     * \@docs-private
     * @return {?}
     */
    function throwNullPortalError() {
        throw Error('Must provide a portal to attach');
    }
    /**
     * Throws an exception when attempting to attach a portal to a host that is already attached.
     * \@docs-private
     * @return {?}
     */
    function throwPortalAlreadyAttachedError() {
        throw Error('Host already has a portal attached');
    }
    /**
     * Throws an exception when attempting to attach a portal to an already-disposed host.
     * \@docs-private
     * @return {?}
     */
    function throwPortalOutletAlreadyDisposedError() {
        throw Error('This PortalOutlet has already been disposed');
    }
    /**
     * Throws an exception when attempting to attach an unknown portal type.
     * \@docs-private
     * @return {?}
     */
    function throwUnknownPortalTypeError() {
        throw Error('Attempting to attach an unknown Portal type. BasePortalOutlet accepts either ' +
            'a ComponentPortal or a TemplatePortal.');
    }
    /**
     * Throws an exception when attempting to attach a portal to a null host.
     * \@docs-private
     * @return {?}
     */
    function throwNullPortalOutletError() {
        throw Error('Attempting to attach a portal to a null PortalOutlet');
    }
    /**
     * Throws an exception when attempting to detach a portal that is not attached.
     * \@docs-private
     * @return {?}
     */
    function throwNoPortalAttachedError() {
        throw Error('Attempting to detach a portal that is not attached to a host');
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * A `Portal` is something that you want to render somewhere else.
     * It can be attach to / detached from a `PortalOutlet`.
     * @abstract
     * @template T
     */
    var  /**
     * A `Portal` is something that you want to render somewhere else.
     * It can be attach to / detached from a `PortalOutlet`.
     * @abstract
     * @template T
     */
    Portal = /** @class */ (function () {
        function Portal() {
        }
        /** Attach this portal to a host. */
        /**
         * Attach this portal to a host.
         * @param {?} host
         * @return {?}
         */
        Portal.prototype.attach = /**
         * Attach this portal to a host.
         * @param {?} host
         * @return {?}
         */
        function (host) {
            if (host == null) {
                throwNullPortalOutletError();
            }
            if (host.hasAttached()) {
                throwPortalAlreadyAttachedError();
            }
            this._attachedHost = host;
            return /** @type {?} */ (host.attach(this));
        };
        /** Detach this portal from its host */
        /**
         * Detach this portal from its host
         * @return {?}
         */
        Portal.prototype.detach = /**
         * Detach this portal from its host
         * @return {?}
         */
        function () {
            var /** @type {?} */ host = this._attachedHost;
            if (host == null) {
                throwNoPortalAttachedError();
            }
            else {
                this._attachedHost = null;
                host.detach();
            }
        };
        Object.defineProperty(Portal.prototype, "isAttached", {
            /** Whether this portal is attached to a host. */
            get: /**
             * Whether this portal is attached to a host.
             * @return {?}
             */
            function () {
                return this._attachedHost != null;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
         * the PortalOutlet when it is performing an `attach()` or `detach()`.
         */
        /**
         * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
         * the PortalOutlet when it is performing an `attach()` or `detach()`.
         * @param {?} host
         * @return {?}
         */
        Portal.prototype.setAttachedHost = /**
         * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
         * the PortalOutlet when it is performing an `attach()` or `detach()`.
         * @param {?} host
         * @return {?}
         */
        function (host) {
            this._attachedHost = host;
        };
        return Portal;
    }());
    /**
     * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
     * @template T
     */
    var  /**
     * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
     * @template T
     */
    ComponentPortal = /** @class */ (function (_super) {
        __extends(ComponentPortal, _super);
        function ComponentPortal(component, viewContainerRef, injector) {
            var _this = _super.call(this) || this;
            _this.component = component;
            _this.viewContainerRef = viewContainerRef;
            _this.injector = injector;
            return _this;
        }
        return ComponentPortal;
    }(Portal));
    /**
     * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
     * @template C
     */
    var  /**
     * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
     * @template C
     */
    TemplatePortal = /** @class */ (function (_super) {
        __extends(TemplatePortal, _super);
        function TemplatePortal(template, viewContainerRef, context) {
            var _this = _super.call(this) || this;
            _this.templateRef = template;
            _this.viewContainerRef = viewContainerRef;
            _this.context = context;
            return _this;
        }
        Object.defineProperty(TemplatePortal.prototype, "origin", {
            get: /**
             * @return {?}
             */
            function () {
                return this.templateRef.elementRef;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Attach the the portal to the provided `PortalOutlet`.
         * When a context is provided it will override the `context` property of the `TemplatePortal`
         * instance.
         */
        /**
         * Attach the the portal to the provided `PortalOutlet`.
         * When a context is provided it will override the `context` property of the `TemplatePortal`
         * instance.
         * @param {?} host
         * @param {?=} context
         * @return {?}
         */
        TemplatePortal.prototype.attach = /**
         * Attach the the portal to the provided `PortalOutlet`.
         * When a context is provided it will override the `context` property of the `TemplatePortal`
         * instance.
         * @param {?} host
         * @param {?=} context
         * @return {?}
         */
        function (host, context) {
            if (context === void 0) { context = this.context; }
            this.context = context;
            return _super.prototype.attach.call(this, host);
        };
        /**
         * @return {?}
         */
        TemplatePortal.prototype.detach = /**
         * @return {?}
         */
        function () {
            this.context = undefined;
            return _super.prototype.detach.call(this);
        };
        return TemplatePortal;
    }(Portal));
    /**
     * Partial implementation of PortalOutlet that handles attaching
     * ComponentPortal and TemplatePortal.
     * @abstract
     */
    var  /**
     * Partial implementation of PortalOutlet that handles attaching
     * ComponentPortal and TemplatePortal.
     * @abstract
     */
    BasePortalOutlet = /** @class */ (function () {
        function BasePortalOutlet() {
            /**
             * Whether this host has already been permanently disposed.
             */
            this._isDisposed = false;
        }
        /** Whether this host has an attached portal. */
        /**
         * Whether this host has an attached portal.
         * @return {?}
         */
        BasePortalOutlet.prototype.hasAttached = /**
         * Whether this host has an attached portal.
         * @return {?}
         */
        function () {
            return !!this._attachedPortal;
        };
        /** Attaches a portal. */
        /**
         * Attaches a portal.
         * @param {?} portal
         * @return {?}
         */
        BasePortalOutlet.prototype.attach = /**
         * Attaches a portal.
         * @param {?} portal
         * @return {?}
         */
        function (portal) {
            if (!portal) {
                throwNullPortalError();
            }
            if (this.hasAttached()) {
                throwPortalAlreadyAttachedError();
            }
            if (this._isDisposed) {
                throwPortalOutletAlreadyDisposedError();
            }
            if (portal instanceof ComponentPortal) {
                this._attachedPortal = portal;
                return this.attachComponentPortal(portal);
            }
            else if (portal instanceof TemplatePortal) {
                this._attachedPortal = portal;
                return this.attachTemplatePortal(portal);
            }
            throwUnknownPortalTypeError();
        };
        /** Detaches a previously attached portal. */
        /**
         * Detaches a previously attached portal.
         * @return {?}
         */
        BasePortalOutlet.prototype.detach = /**
         * Detaches a previously attached portal.
         * @return {?}
         */
        function () {
            if (this._attachedPortal) {
                this._attachedPortal.setAttachedHost(null);
                this._attachedPortal = null;
            }
            this._invokeDisposeFn();
        };
        /** Permanently dispose of this portal host. */
        /**
         * Permanently dispose of this portal host.
         * @return {?}
         */
        BasePortalOutlet.prototype.dispose = /**
         * Permanently dispose of this portal host.
         * @return {?}
         */
        function () {
            if (this.hasAttached()) {
                this.detach();
            }
            this._invokeDisposeFn();
            this._isDisposed = true;
        };
        /** @docs-private */
        /**
         * \@docs-private
         * @param {?} fn
         * @return {?}
         */
        BasePortalOutlet.prototype.setDisposeFn = /**
         * \@docs-private
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._disposeFn = fn;
        };
        /**
         * @return {?}
         */
        BasePortalOutlet.prototype._invokeDisposeFn = /**
         * @return {?}
         */
        function () {
            if (this._disposeFn) {
                this._disposeFn();
                this._disposeFn = null;
            }
        };
        return BasePortalOutlet;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * A PortalOutlet for attaching portals to an arbitrary DOM element outside of the Angular
     * application context.
     */
    var  /**
     * A PortalOutlet for attaching portals to an arbitrary DOM element outside of the Angular
     * application context.
     */
    DomPortalOutlet = /** @class */ (function (_super) {
        __extends(DomPortalOutlet, _super);
        function DomPortalOutlet(outletElement, _componentFactoryResolver, _appRef, _defaultInjector) {
            var _this = _super.call(this) || this;
            _this.outletElement = outletElement;
            _this._componentFactoryResolver = _componentFactoryResolver;
            _this._appRef = _appRef;
            _this._defaultInjector = _defaultInjector;
            return _this;
        }
        /**
         * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
         * @param portal Portal to be attached
         * @returns Reference to the created component.
         */
        /**
         * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
         * @template T
         * @param {?} portal Portal to be attached
         * @return {?} Reference to the created component.
         */
        DomPortalOutlet.prototype.attachComponentPortal = /**
         * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
         * @template T
         * @param {?} portal Portal to be attached
         * @return {?} Reference to the created component.
         */
        function (portal) {
            var _this = this;
            var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
            var /** @type {?} */ componentRef;
            // If the portal specifies a ViewContainerRef, we will use that as the attachment point
            // for the component (in terms of Angular's component tree, not rendering).
            // When the ViewContainerRef is missing, we use the factory to create the component directly
            // and then manually attach the view to the application.
            if (portal.viewContainerRef) {
                componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.parentInjector);
                this.setDisposeFn(function () { return componentRef.destroy(); });
            }
            else {
                componentRef = componentFactory.create(portal.injector || this._defaultInjector);
                this._appRef.attachView(componentRef.hostView);
                this.setDisposeFn(function () {
                    _this._appRef.detachView(componentRef.hostView);
                    componentRef.destroy();
                });
            }
            // At this point the component has been instantiated, so we move it to the location in the DOM
            // where we want it to be rendered.
            this.outletElement.appendChild(this._getComponentRootNode(componentRef));
            return componentRef;
        };
        /**
         * Attaches a template portal to the DOM as an embedded view.
         * @param portal Portal to be attached.
         * @returns Reference to the created embedded view.
         */
        /**
         * Attaches a template portal to the DOM as an embedded view.
         * @template C
         * @param {?} portal Portal to be attached.
         * @return {?} Reference to the created embedded view.
         */
        DomPortalOutlet.prototype.attachTemplatePortal = /**
         * Attaches a template portal to the DOM as an embedded view.
         * @template C
         * @param {?} portal Portal to be attached.
         * @return {?} Reference to the created embedded view.
         */
        function (portal) {
            var _this = this;
            var /** @type {?} */ viewContainer = portal.viewContainerRef;
            var /** @type {?} */ viewRef = viewContainer.createEmbeddedView(portal.templateRef, portal.context);
            viewRef.detectChanges();
            // The method `createEmbeddedView` will add the view as a child of the viewContainer.
            // But for the DomPortalOutlet the view can be added everywhere in the DOM
            // (e.g Overlay Container) To move the view to the specified host element. We just
            // re-append the existing root nodes.
            viewRef.rootNodes.forEach(function (rootNode) { return _this.outletElement.appendChild(rootNode); });
            this.setDisposeFn((function () {
                var /** @type {?} */ index = viewContainer.indexOf(viewRef);
                if (index !== -1) {
                    viewContainer.remove(index);
                }
            }));
            // TODO(jelbourn): Return locals from view.
            return viewRef;
        };
        /**
         * Clears out a portal from the DOM.
         */
        /**
         * Clears out a portal from the DOM.
         * @return {?}
         */
        DomPortalOutlet.prototype.dispose = /**
         * Clears out a portal from the DOM.
         * @return {?}
         */
        function () {
            _super.prototype.dispose.call(this);
            if (this.outletElement.parentNode != null) {
                this.outletElement.parentNode.removeChild(this.outletElement);
            }
        };
        /**
         * Gets the root HTMLElement for an instantiated component.
         * @param {?} componentRef
         * @return {?}
         */
        DomPortalOutlet.prototype._getComponentRootNode = /**
         * Gets the root HTMLElement for an instantiated component.
         * @param {?} componentRef
         * @return {?}
         */
        function (componentRef) {
            return /** @type {?} */ ((/** @type {?} */ (componentRef.hostView)).rootNodes[0]);
        };
        return DomPortalOutlet;
    }(BasePortalOutlet));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Directive version of a `TemplatePortal`. Because the directive *is* a TemplatePortal,
     * the directive instance itself can be attached to a host, enabling declarative use of portals.
     */
    var CdkPortal = /** @class */ (function (_super) {
        __extends(CdkPortal, _super);
        function CdkPortal(templateRef, viewContainerRef) {
            return _super.call(this, templateRef, viewContainerRef) || this;
        }
        CdkPortal.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdk-portal], [cdkPortal], [portal]',
                        exportAs: 'cdkPortal',
                    },] },
        ];
        /** @nocollapse */
        CdkPortal.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.ViewContainerRef, },
        ]; };
        return CdkPortal;
    }(TemplatePortal));
    /**
     * Directive version of a PortalOutlet. Because the directive *is* a PortalOutlet, portals can be
     * directly attached to it, enabling declarative use.
     *
     * Usage:
     * `<ng-template [cdkPortalOutlet]="greeting"></ng-template>`
     */
    var CdkPortalOutlet = /** @class */ (function (_super) {
        __extends(CdkPortalOutlet, _super);
        function CdkPortalOutlet(_componentFactoryResolver, _viewContainerRef) {
            var _this = _super.call(this) || this;
            _this._componentFactoryResolver = _componentFactoryResolver;
            _this._viewContainerRef = _viewContainerRef;
            /**
             * Whether the portal component is initialized.
             */
            _this._isInitialized = false;
            _this.attached = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(CdkPortalOutlet.prototype, "portal", {
            /** Portal associated with the Portal outlet. */
            get: /**
             * Portal associated with the Portal outlet.
             * @return {?}
             */
            function () {
                return this._attachedPortal;
            },
            set: /**
             * @param {?} portal
             * @return {?}
             */
            function (portal) {
                // Ignore the cases where the `portal` is set to a falsy value before the lifecycle hooks have
                // run. This handles the cases where the user might do something like `<div cdkPortalOutlet>`
                // and attach a portal programmatically in the parent component. When Angular does the first CD
                // round, it will fire the setter with empty string, causing the user's content to be cleared.
                if (this.hasAttached() && !portal && !this._isInitialized) {
                    return;
                }
                if (this.hasAttached()) {
                    _super.prototype.detach.call(this);
                }
                if (portal) {
                    _super.prototype.attach.call(this, portal);
                }
                this._attachedPortal = portal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkPortalOutlet.prototype, "attachedRef", {
            /** Component or view reference that is attached to the portal. */
            get: /**
             * Component or view reference that is attached to the portal.
             * @return {?}
             */
            function () {
                return this._attachedRef;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkPortalOutlet.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._isInitialized = true;
        };
        /**
         * @return {?}
         */
        CdkPortalOutlet.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            _super.prototype.dispose.call(this);
            this._attachedPortal = null;
            this._attachedRef = null;
        };
        /**
         * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
         *
         * @param portal Portal to be attached to the portal outlet.
         * @returns Reference to the created component.
         */
        /**
         * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
         *
         * @template T
         * @param {?} portal Portal to be attached to the portal outlet.
         * @return {?} Reference to the created component.
         */
        CdkPortalOutlet.prototype.attachComponentPortal = /**
         * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
         *
         * @template T
         * @param {?} portal Portal to be attached to the portal outlet.
         * @return {?} Reference to the created component.
         */
        function (portal) {
            portal.setAttachedHost(this);
            // If the portal specifies an origin, use that as the logical location of the component
            // in the application tree. Otherwise use the location of this PortalOutlet.
            var /** @type {?} */ viewContainerRef = portal.viewContainerRef != null ?
                portal.viewContainerRef :
                this._viewContainerRef;
            var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
            var /** @type {?} */ ref = viewContainerRef.createComponent(componentFactory, viewContainerRef.length, portal.injector || viewContainerRef.parentInjector);
            _super.prototype.setDisposeFn.call(this, function () { return ref.destroy(); });
            this._attachedPortal = portal;
            this._attachedRef = ref;
            this.attached.emit(ref);
            return ref;
        };
        /**
         * Attach the given TemplatePortal to this PortlHost as an embedded View.
         * @param portal Portal to be attached.
         * @returns Reference to the created embedded view.
         */
        /**
         * Attach the given TemplatePortal to this PortlHost as an embedded View.
         * @template C
         * @param {?} portal Portal to be attached.
         * @return {?} Reference to the created embedded view.
         */
        CdkPortalOutlet.prototype.attachTemplatePortal = /**
         * Attach the given TemplatePortal to this PortlHost as an embedded View.
         * @template C
         * @param {?} portal Portal to be attached.
         * @return {?} Reference to the created embedded view.
         */
        function (portal) {
            var _this = this;
            portal.setAttachedHost(this);
            var /** @type {?} */ viewRef = this._viewContainerRef.createEmbeddedView(portal.templateRef, portal.context);
            _super.prototype.setDisposeFn.call(this, function () { return _this._viewContainerRef.clear(); });
            this._attachedPortal = portal;
            this._attachedRef = viewRef;
            this.attached.emit(viewRef);
            return viewRef;
        };
        CdkPortalOutlet.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkPortalOutlet], [cdkPortalHost], [portalHost]',
                        exportAs: 'cdkPortalOutlet, cdkPortalHost',
                        inputs: ['portal: cdkPortalOutlet']
                    },] },
        ];
        /** @nocollapse */
        CdkPortalOutlet.ctorParameters = function () { return [
            { type: core.ComponentFactoryResolver, },
            { type: core.ViewContainerRef, },
        ]; };
        CdkPortalOutlet.propDecorators = {
            "attached": [{ type: core.Output },],
        };
        return CdkPortalOutlet;
    }(BasePortalOutlet));
    var PortalModule = /** @class */ (function () {
        function PortalModule() {
        }
        PortalModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [CdkPortal, CdkPortalOutlet],
                        declarations: [CdkPortal, CdkPortalOutlet],
                    },] },
        ];
        return PortalModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Custom injector to be used when providing custom
     * injection tokens to components inside a portal.
     * \@docs-private
     */
    var  /**
     * Custom injector to be used when providing custom
     * injection tokens to components inside a portal.
     * \@docs-private
     */
    PortalInjector = /** @class */ (function () {
        function PortalInjector(_parentInjector, _customTokens) {
            this._parentInjector = _parentInjector;
            this._customTokens = _customTokens;
        }
        /**
         * @param {?} token
         * @param {?=} notFoundValue
         * @return {?}
         */
        PortalInjector.prototype.get = /**
         * @param {?} token
         * @param {?=} notFoundValue
         * @return {?}
         */
        function (token, notFoundValue) {
            var /** @type {?} */ value = this._customTokens.get(token);
            if (typeof value !== 'undefined') {
                return value;
            }
            return this._parentInjector.get(token, notFoundValue);
        };
        return PortalInjector;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Scroll strategy that doesn't do anything.
     */
    var  /**
     * Scroll strategy that doesn't do anything.
     */
    NoopScrollStrategy = /** @class */ (function () {
        function NoopScrollStrategy() {
        }
        /** Does nothing, as this scroll strategy is a no-op. */
        /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        NoopScrollStrategy.prototype.enable = /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        function () { };
        /** Does nothing, as this scroll strategy is a no-op. */
        /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        NoopScrollStrategy.prototype.disable = /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        function () { };
        /** Does nothing, as this scroll strategy is a no-op. */
        /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        NoopScrollStrategy.prototype.attach = /**
         * Does nothing, as this scroll strategy is a no-op.
         * @return {?}
         */
        function () { };
        return NoopScrollStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Initial configuration used when creating an overlay.
     */
    var  /**
     * Initial configuration used when creating an overlay.
     */
    OverlayConfig = /** @class */ (function () {
        function OverlayConfig(config) {
            var _this = this;
            /**
             * Strategy to be used when handling scroll events while the overlay is open.
             */
            this.scrollStrategy = new NoopScrollStrategy();
            /**
             * Custom class to add to the overlay pane.
             */
            this.panelClass = '';
            /**
             * Whether the overlay has a backdrop.
             */
            this.hasBackdrop = false;
            /**
             * Custom class to add to the backdrop
             */
            this.backdropClass = 'cdk-overlay-dark-backdrop';
            if (config) {
                Object.keys(config)
                    .filter(function (key) { return typeof config[key] !== 'undefined'; })
                    .forEach(function (key) { return _this[key] = config[key]; });
            }
        }
        return OverlayConfig;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The points of the origin element and the overlay element to connect.
     */
    var  /**
     * The points of the origin element and the overlay element to connect.
     */
    ConnectionPositionPair = /** @class */ (function () {
        function ConnectionPositionPair(origin, overlay, offsetX, offsetY) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.originX = origin.originX;
            this.originY = origin.originY;
            this.overlayX = overlay.overlayX;
            this.overlayY = overlay.overlayY;
        }
        return ConnectionPositionPair;
    }());
    /**
     * Set of properties regarding the position of the origin and overlay relative to the viewport
     * with respect to the containing Scrollable elements.
     *
     * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
     * bounds of any one of the strategy's Scrollable's bounding client rectangle.
     *
     * The overlay and origin are outside view if there is no overlap between their bounding client
     * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
     *
     *       -----------                    -----------
     *       | outside |                    | clipped |
     *       |  view   |              --------------------------
     *       |         |              |     |         |        |
     *       ----------               |     -----------        |
     *  --------------------------    |                        |
     *  |                        |    |      Scrollable        |
     *  |                        |    |                        |
     *  |                        |     --------------------------
     *  |      Scrollable        |
     *  |                        |
     *  --------------------------
     *
     *  \@docs-private
     */
    var  /**
     * Set of properties regarding the position of the origin and overlay relative to the viewport
     * with respect to the containing Scrollable elements.
     *
     * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
     * bounds of any one of the strategy's Scrollable's bounding client rectangle.
     *
     * The overlay and origin are outside view if there is no overlap between their bounding client
     * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
     *
     *       -----------                    -----------
     *       | outside |                    | clipped |
     *       |  view   |              --------------------------
     *       |         |              |     |         |        |
     *       ----------               |     -----------        |
     *  --------------------------    |                        |
     *  |                        |    |      Scrollable        |
     *  |                        |    |                        |
     *  |                        |     --------------------------
     *  |      Scrollable        |
     *  |                        |
     *  --------------------------
     *
     *  \@docs-private
     */
    ScrollingVisibility = /** @class */ (function () {
        function ScrollingVisibility() {
        }
        return ScrollingVisibility;
    }());
    /**
     * The change event emitted by the strategy when a fallback position is used.
     */
    var ConnectedOverlayPositionChange = /** @class */ (function () {
        function ConnectedOverlayPositionChange(connectionPair, /** @docs-private */
        scrollableViewProperties) {
            this.connectionPair = connectionPair;
            this.scrollableViewProperties = scrollableViewProperties;
        }
        /** @nocollapse */
        ConnectedOverlayPositionChange.ctorParameters = function () { return [
            { type: ConnectionPositionPair, },
            { type: ScrollingVisibility, decorators: [{ type: core.Optional },] },
        ]; };
        return ConnectedOverlayPositionChange;
    }());
    /**
     * Validates whether a vertical position property matches the expected values.
     * \@docs-private
     * @param {?} property Name of the property being validated.
     * @param {?} value Value of the property being validated.
     * @return {?}
     */
    function validateVerticalPosition(property, value) {
        if (value !== 'top' && value !== 'bottom' && value !== 'center') {
            throw Error("ConnectedPosition: Invalid " + property + " \"" + value + "\". " +
                "Expected \"top\", \"bottom\" or \"center\".");
        }
    }
    /**
     * Validates whether a horizontal position property matches the expected values.
     * \@docs-private
     * @param {?} property Name of the property being validated.
     * @param {?} value Value of the property being validated.
     * @return {?}
     */
    function validateHorizontalPosition(property, value) {
        if (value !== 'start' && value !== 'end' && value !== 'center') {
            throw Error("ConnectedPosition: Invalid " + property + " \"" + value + "\". " +
                "Expected \"start\", \"end\" or \"center\".");
        }
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Strategy that will prevent the user from scrolling while the overlay is visible.
     */
    var  /**
     * Strategy that will prevent the user from scrolling while the overlay is visible.
     */
    BlockScrollStrategy = /** @class */ (function () {
        function BlockScrollStrategy(_viewportRuler, document) {
            this._viewportRuler = _viewportRuler;
            this._previousHTMLStyles = { top: '', left: '' };
            this._isEnabled = false;
            this._document = document;
        }
        /** Attaches this scroll strategy to an overlay. */
        /**
         * Attaches this scroll strategy to an overlay.
         * @return {?}
         */
        BlockScrollStrategy.prototype.attach = /**
         * Attaches this scroll strategy to an overlay.
         * @return {?}
         */
        function () { };
        /** Blocks page-level scroll while the attached overlay is open. */
        /**
         * Blocks page-level scroll while the attached overlay is open.
         * @return {?}
         */
        BlockScrollStrategy.prototype.enable = /**
         * Blocks page-level scroll while the attached overlay is open.
         * @return {?}
         */
        function () {
            if (this._canBeEnabled()) {
                var /** @type {?} */ root = this._document.documentElement;
                this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition();
                // Cache the previous inline styles in case the user had set them.
                this._previousHTMLStyles.left = root.style.left || '';
                this._previousHTMLStyles.top = root.style.top || '';
                // Note: we're using the `html` node, instead of the `body`, because the `body` may
                // have the user agent margin, whereas the `html` is guaranteed not to have one.
                root.style.left = coerceCssPixelValue(-this._previousScrollPosition.left);
                root.style.top = coerceCssPixelValue(-this._previousScrollPosition.top);
                root.classList.add('cdk-global-scrollblock');
                this._isEnabled = true;
            }
        };
        /** Unblocks page-level scroll while the attached overlay is open. */
        /**
         * Unblocks page-level scroll while the attached overlay is open.
         * @return {?}
         */
        BlockScrollStrategy.prototype.disable = /**
         * Unblocks page-level scroll while the attached overlay is open.
         * @return {?}
         */
        function () {
            if (this._isEnabled) {
                var /** @type {?} */ html = this._document.documentElement;
                var /** @type {?} */ body = this._document.body;
                var /** @type {?} */ previousHtmlScrollBehavior = html.style['scrollBehavior'] || '';
                var /** @type {?} */ previousBodyScrollBehavior = body.style['scrollBehavior'] || '';
                this._isEnabled = false;
                html.style.left = this._previousHTMLStyles.left;
                html.style.top = this._previousHTMLStyles.top;
                html.classList.remove('cdk-global-scrollblock');
                // Disable user-defined smooth scrolling temporarily while we restore the scroll position.
                // See https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
                html.style['scrollBehavior'] = body.style['scrollBehavior'] = 'auto';
                window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top);
                html.style['scrollBehavior'] = previousHtmlScrollBehavior;
                body.style['scrollBehavior'] = previousBodyScrollBehavior;
            }
        };
        /**
         * @return {?}
         */
        BlockScrollStrategy.prototype._canBeEnabled = /**
         * @return {?}
         */
        function () {
            // Since the scroll strategies can't be singletons, we have to use a global CSS class
            // (`cdk-global-scrollblock`) to make sure that we don't try to disable global
            // scrolling multiple times.
            var /** @type {?} */ html = this._document.documentElement;
            if (html.classList.contains('cdk-global-scrollblock') || this._isEnabled) {
                return false;
            }
            var /** @type {?} */ body = this._document.body;
            var /** @type {?} */ viewport = this._viewportRuler.getViewportSize();
            return body.scrollHeight > viewport.height || body.scrollWidth > viewport.width;
        };
        return BlockScrollStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
     * @return {?}
     */
    function getMatScrollStrategyAlreadyAttachedError() {
        return Error("Scroll strategy has already been attached.");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Strategy that will close the overlay as soon as the user starts scrolling.
     */
    var  /**
     * Strategy that will close the overlay as soon as the user starts scrolling.
     */
    CloseScrollStrategy = /** @class */ (function () {
        function CloseScrollStrategy(_scrollDispatcher, _ngZone, _viewportRuler, _config) {
            var _this = this;
            this._scrollDispatcher = _scrollDispatcher;
            this._ngZone = _ngZone;
            this._viewportRuler = _viewportRuler;
            this._config = _config;
            this._scrollSubscription = null;
            /**
             * Detaches the overlay ref and disables the scroll strategy.
             */
            this._detach = function () {
                _this.disable();
                if (_this._overlayRef.hasAttached()) {
                    _this._ngZone.run(function () { return _this._overlayRef.detach(); });
                }
            };
        }
        /** Attaches this scroll strategy to an overlay. */
        /**
         * Attaches this scroll strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        CloseScrollStrategy.prototype.attach = /**
         * Attaches this scroll strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            if (this._overlayRef) {
                throw getMatScrollStrategyAlreadyAttachedError();
            }
            this._overlayRef = overlayRef;
        };
        /** Enables the closing of the attached overlay on scroll. */
        /**
         * Enables the closing of the attached overlay on scroll.
         * @return {?}
         */
        CloseScrollStrategy.prototype.enable = /**
         * Enables the closing of the attached overlay on scroll.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._scrollSubscription) {
                return;
            }
            var /** @type {?} */ stream = this._scrollDispatcher.scrolled(0);
            if (this._config && this._config.threshold && this._config.threshold > 1) {
                this._initialScrollPosition = this._viewportRuler.getViewportScrollPosition().top;
                this._scrollSubscription = stream.subscribe(function () {
                    var /** @type {?} */ scrollPosition = _this._viewportRuler.getViewportScrollPosition().top;
                    if (Math.abs(scrollPosition - _this._initialScrollPosition) > /** @type {?} */ ((/** @type {?} */ ((_this._config)).threshold))) {
                        _this._detach();
                    }
                    else {
                        _this._overlayRef.updatePosition();
                    }
                });
            }
            else {
                this._scrollSubscription = stream.subscribe(this._detach);
            }
        };
        /** Disables the closing the attached overlay on scroll. */
        /**
         * Disables the closing the attached overlay on scroll.
         * @return {?}
         */
        CloseScrollStrategy.prototype.disable = /**
         * Disables the closing the attached overlay on scroll.
         * @return {?}
         */
        function () {
            if (this._scrollSubscription) {
                this._scrollSubscription.unsubscribe();
                this._scrollSubscription = null;
            }
        };
        return CloseScrollStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    // TODO(jelbourn): move this to live with the rest of the scrolling code
    // TODO(jelbourn): someday replace this with IntersectionObservers
    /**
     * Gets whether an element is scrolled outside of view by any of its parent scrolling containers.
     * \@docs-private
     * @param {?} element Dimensions of the element (from getBoundingClientRect)
     * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
     * @return {?} Whether the element is scrolled out of view
     */
    function isElementScrolledOutsideView(element, scrollContainers) {
        return scrollContainers.some(function (containerBounds) {
            var /** @type {?} */ outsideAbove = element.bottom < containerBounds.top;
            var /** @type {?} */ outsideBelow = element.top > containerBounds.bottom;
            var /** @type {?} */ outsideLeft = element.right < containerBounds.left;
            var /** @type {?} */ outsideRight = element.left > containerBounds.right;
            return outsideAbove || outsideBelow || outsideLeft || outsideRight;
        });
    }
    /**
     * Gets whether an element is clipped by any of its scrolling containers.
     * \@docs-private
     * @param {?} element Dimensions of the element (from getBoundingClientRect)
     * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
     * @return {?} Whether the element is clipped
     */
    function isElementClippedByScrolling(element, scrollContainers) {
        return scrollContainers.some(function (scrollContainerRect) {
            var /** @type {?} */ clippedAbove = element.top < scrollContainerRect.top;
            var /** @type {?} */ clippedBelow = element.bottom > scrollContainerRect.bottom;
            var /** @type {?} */ clippedLeft = element.left < scrollContainerRect.left;
            var /** @type {?} */ clippedRight = element.right > scrollContainerRect.right;
            return clippedAbove || clippedBelow || clippedLeft || clippedRight;
        });
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Strategy that will update the element position as the user is scrolling.
     */
    var  /**
     * Strategy that will update the element position as the user is scrolling.
     */
    RepositionScrollStrategy = /** @class */ (function () {
        function RepositionScrollStrategy(_scrollDispatcher, _viewportRuler, _ngZone, _config) {
            this._scrollDispatcher = _scrollDispatcher;
            this._viewportRuler = _viewportRuler;
            this._ngZone = _ngZone;
            this._config = _config;
            this._scrollSubscription = null;
        }
        /** Attaches this scroll strategy to an overlay. */
        /**
         * Attaches this scroll strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        RepositionScrollStrategy.prototype.attach = /**
         * Attaches this scroll strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            if (this._overlayRef) {
                throw getMatScrollStrategyAlreadyAttachedError();
            }
            this._overlayRef = overlayRef;
        };
        /** Enables repositioning of the attached overlay on scroll. */
        /**
         * Enables repositioning of the attached overlay on scroll.
         * @return {?}
         */
        RepositionScrollStrategy.prototype.enable = /**
         * Enables repositioning of the attached overlay on scroll.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._scrollSubscription) {
                var /** @type {?} */ throttle = this._config ? this._config.scrollThrottle : 0;
                this._scrollSubscription = this._scrollDispatcher.scrolled(throttle).subscribe(function () {
                    _this._overlayRef.updatePosition();
                    // TODO(crisbeto): make `close` on by default once all components can handle it.
                    if (_this._config && _this._config.autoClose) {
                        var /** @type {?} */ overlayRect = _this._overlayRef.overlayElement.getBoundingClientRect();
                        var _a = _this._viewportRuler.getViewportSize(), width = _a.width, height = _a.height;
                        // TODO(crisbeto): include all ancestor scroll containers here once
                        // we have a way of exposing the trigger element to the scroll strategy.
                        var /** @type {?} */ parentRects = [{ width: width, height: height, bottom: height, right: width, top: 0, left: 0 }];
                        if (isElementScrolledOutsideView(overlayRect, parentRects)) {
                            _this.disable();
                            _this._ngZone.run(function () { return _this._overlayRef.detach(); });
                        }
                    }
                });
            }
        };
        /** Disables repositioning of the attached overlay on scroll. */
        /**
         * Disables repositioning of the attached overlay on scroll.
         * @return {?}
         */
        RepositionScrollStrategy.prototype.disable = /**
         * Disables repositioning of the attached overlay on scroll.
         * @return {?}
         */
        function () {
            if (this._scrollSubscription) {
                this._scrollSubscription.unsubscribe();
                this._scrollSubscription = null;
            }
        };
        return RepositionScrollStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Options for how an overlay will handle scrolling.
     *
     * Users can provide a custom value for `ScrollStrategyOptions` to replace the default
     * behaviors. This class primarily acts as a factory for ScrollStrategy instances.
     */
    var ScrollStrategyOptions = /** @class */ (function () {
        function ScrollStrategyOptions(_scrollDispatcher, _viewportRuler, _ngZone, document) {
            var _this = this;
            this._scrollDispatcher = _scrollDispatcher;
            this._viewportRuler = _viewportRuler;
            this._ngZone = _ngZone;
            /**
             * Do nothing on scroll.
             */
            this.noop = function () { return new NoopScrollStrategy(); };
            /**
             * Close the overlay as soon as the user scrolls.
             * @param config Configuration to be used inside the scroll strategy.
             */
            this.close = function (config) {
                return new CloseScrollStrategy(_this._scrollDispatcher, _this._ngZone, _this._viewportRuler, config);
            };
            /**
             * Block scrolling.
             */
            this.block = function () { return new BlockScrollStrategy(_this._viewportRuler, _this._document); };
            /**
             * Update the overlay's position on scroll.
             * @param config Configuration to be used inside the scroll strategy.
             * Allows debouncing the reposition calls.
             */
            this.reposition = function (config) {
                return new RepositionScrollStrategy(_this._scrollDispatcher, _this._viewportRuler, _this._ngZone, config);
            };
            this._document = document;
        }
        ScrollStrategyOptions.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        ScrollStrategyOptions.ctorParameters = function () { return [
            { type: ScrollDispatcher, },
            { type: ViewportRuler, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ ScrollStrategyOptions.ngInjectableDef = core.defineInjectable({ factory: function ScrollStrategyOptions_Factory() { return new ScrollStrategyOptions(core.inject(ScrollDispatcher), core.inject(ViewportRuler), core.inject(core.NgZone), core.inject(common.DOCUMENT)); }, token: ScrollStrategyOptions, providedIn: "root" });
        return ScrollStrategyOptions;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Service for dispatching keyboard events that land on the body to appropriate overlay ref,
     * if any. It maintains a list of attached overlays to determine best suited overlay based
     * on event target and order of overlay opens.
     */
    var OverlayKeyboardDispatcher = /** @class */ (function () {
        function OverlayKeyboardDispatcher(document) {
            var _this = this;
            /**
             * Currently attached overlays in the order they were attached.
             */
            this._attachedOverlays = [];
            /**
             * Keyboard event listener that will be attached to the body.
             */
            this._keydownListener = function (event) {
                if (_this._attachedOverlays.length) {
                    // Dispatch the keydown event to the top overlay. We want to target the most recent overlay,
                    // rather than trying to match where the event came from, because some components might open
                    // an overlay, but keep focus on a trigger element (e.g. for select and autocomplete).
                    // Dispatch the keydown event to the top overlay. We want to target the most recent overlay,
                    // rather than trying to match where the event came from, because some components might open
                    // an overlay, but keep focus on a trigger element (e.g. for select and autocomplete).
                    _this._attachedOverlays[_this._attachedOverlays.length - 1]._keydownEvents.next(event);
                }
            };
            this._document = document;
        }
        /**
         * @return {?}
         */
        OverlayKeyboardDispatcher.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._detach();
        };
        /** Add a new overlay to the list of attached overlay refs. */
        /**
         * Add a new overlay to the list of attached overlay refs.
         * @param {?} overlayRef
         * @return {?}
         */
        OverlayKeyboardDispatcher.prototype.add = /**
         * Add a new overlay to the list of attached overlay refs.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            // Lazily start dispatcher once first overlay is added
            if (!this._isAttached) {
                this._document.body.addEventListener('keydown', this._keydownListener, true);
                this._isAttached = true;
            }
            this._attachedOverlays.push(overlayRef);
        };
        /** Remove an overlay from the list of attached overlay refs. */
        /**
         * Remove an overlay from the list of attached overlay refs.
         * @param {?} overlayRef
         * @return {?}
         */
        OverlayKeyboardDispatcher.prototype.remove = /**
         * Remove an overlay from the list of attached overlay refs.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            var /** @type {?} */ index = this._attachedOverlays.indexOf(overlayRef);
            if (index > -1) {
                this._attachedOverlays.splice(index, 1);
            }
            // Remove the global listener once there are no more overlays.
            if (this._attachedOverlays.length === 0) {
                this._detach();
            }
        };
        /**
         * Detaches the global keyboard event listener.
         * @return {?}
         */
        OverlayKeyboardDispatcher.prototype._detach = /**
         * Detaches the global keyboard event listener.
         * @return {?}
         */
        function () {
            if (this._isAttached) {
                this._document.body.removeEventListener('keydown', this._keydownListener, true);
                this._isAttached = false;
            }
        };
        OverlayKeyboardDispatcher.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        OverlayKeyboardDispatcher.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ OverlayKeyboardDispatcher.ngInjectableDef = core.defineInjectable({ factory: function OverlayKeyboardDispatcher_Factory() { return new OverlayKeyboardDispatcher(core.inject(common.DOCUMENT)); }, token: OverlayKeyboardDispatcher, providedIn: "root" });
        return OverlayKeyboardDispatcher;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} dispatcher
     * @param {?} _document
     * @return {?}
     */
    function OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY(dispatcher, _document) {
        return dispatcher || new OverlayKeyboardDispatcher(_document);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ OVERLAY_KEYBOARD_DISPATCHER_PROVIDER = {
        // If there is already an OverlayKeyboardDispatcher available, use that.
        // Otherwise, provide a new one.
        provide: OverlayKeyboardDispatcher,
        deps: [
            [new core.Optional(), new core.SkipSelf(), OverlayKeyboardDispatcher],
            /** @type {?} */ (
            // Coerce to `InjectionToken` so that the `deps` match the "shape"
            // of the type expected by Angular
            common.DOCUMENT)
        ],
        useFactory: OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Container inside which all overlays will render.
     */
    var OverlayContainer = /** @class */ (function () {
        function OverlayContainer(_document) {
            this._document = _document;
        }
        /**
         * @return {?}
         */
        OverlayContainer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._containerElement && this._containerElement.parentNode) {
                this._containerElement.parentNode.removeChild(this._containerElement);
            }
        };
        /**
         * This method returns the overlay container element. It will lazily
         * create the element the first time  it is called to facilitate using
         * the container in non-browser environments.
         * @returns the container element
         */
        /**
         * This method returns the overlay container element. It will lazily
         * create the element the first time  it is called to facilitate using
         * the container in non-browser environments.
         * @return {?} the container element
         */
        OverlayContainer.prototype.getContainerElement = /**
         * This method returns the overlay container element. It will lazily
         * create the element the first time  it is called to facilitate using
         * the container in non-browser environments.
         * @return {?} the container element
         */
        function () {
            if (!this._containerElement) {
                this._createContainer();
            }
            return this._containerElement;
        };
        /**
         * Create the overlay container element, which is simply a div
         * with the 'cdk-overlay-container' class on the document body.
         */
        /**
         * Create the overlay container element, which is simply a div
         * with the 'cdk-overlay-container' class on the document body.
         * @return {?}
         */
        OverlayContainer.prototype._createContainer = /**
         * Create the overlay container element, which is simply a div
         * with the 'cdk-overlay-container' class on the document body.
         * @return {?}
         */
        function () {
            var /** @type {?} */ container = this._document.createElement('div');
            container.classList.add('cdk-overlay-container');
            this._document.body.appendChild(container);
            this._containerElement = container;
        };
        OverlayContainer.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        OverlayContainer.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ OverlayContainer.ngInjectableDef = core.defineInjectable({ factory: function OverlayContainer_Factory() { return new OverlayContainer(core.inject(common.DOCUMENT)); }, token: OverlayContainer, providedIn: "root" });
        return OverlayContainer;
    }());
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     * @param {?} parentContainer
     * @param {?} _document
     * @return {?}
     */
    function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer, _document) {
        return parentContainer || new OverlayContainer(_document);
    }
    /**
     * \@docs-private \@deprecated \@deletion-target 7.0.0
     */
    var /** @type {?} */ OVERLAY_CONTAINER_PROVIDER = {
        // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
        provide: OverlayContainer,
        deps: [
            [new core.Optional(), new core.SkipSelf(), OverlayContainer],
            /** @type {?} */ (common.DOCUMENT // We need to use the InjectionToken somewhere to keep TS happy
            ) // We need to use the InjectionToken somewhere to keep TS happy
        ],
        useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Reference to an overlay that has been created with the Overlay service.
     * Used to manipulate or dispose of said overlay.
     */
    var  /**
     * Reference to an overlay that has been created with the Overlay service.
     * Used to manipulate or dispose of said overlay.
     */
    OverlayRef = /** @class */ (function () {
        function OverlayRef(_portalOutlet, _host, _pane, _config, _ngZone, _keyboardDispatcher, _document) {
            this._portalOutlet = _portalOutlet;
            this._host = _host;
            this._pane = _pane;
            this._config = _config;
            this._ngZone = _ngZone;
            this._keyboardDispatcher = _keyboardDispatcher;
            this._document = _document;
            this._backdropElement = null;
            this._backdropClick = new rxjs.Subject();
            this._attachments = new rxjs.Subject();
            this._detachments = new rxjs.Subject();
            /**
             * Stream of keydown events dispatched to this overlay.
             */
            this._keydownEvents = new rxjs.Subject();
            if (_config.scrollStrategy) {
                _config.scrollStrategy.attach(this);
            }
        }
        Object.defineProperty(OverlayRef.prototype, "overlayElement", {
            /** The overlay's HTML element */
            get: /**
             * The overlay's HTML element
             * @return {?}
             */
            function () {
                return this._pane;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OverlayRef.prototype, "backdropElement", {
            /** The overlay's backdrop HTML element. */
            get: /**
             * The overlay's backdrop HTML element.
             * @return {?}
             */
            function () {
                return this._backdropElement;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(OverlayRef.prototype, "hostElement", {
            /**
             * Wrapper around the panel element. Can be used for advanced
             * positioning where a wrapper with specific styling is
             * required around the overlay pane.
             */
            get: /**
             * Wrapper around the panel element. Can be used for advanced
             * positioning where a wrapper with specific styling is
             * required around the overlay pane.
             * @return {?}
             */
            function () {
                return this._host;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Attaches content, given via a Portal, to the overlay.
         * If the overlay is configured to have a backdrop, it will be created.
         *
         * @param portal Portal instance to which to attach the overlay.
         * @returns The portal attachment result.
         */
        /**
         * Attaches content, given via a Portal, to the overlay.
         * If the overlay is configured to have a backdrop, it will be created.
         *
         * @param {?} portal Portal instance to which to attach the overlay.
         * @return {?} The portal attachment result.
         */
        OverlayRef.prototype.attach = /**
         * Attaches content, given via a Portal, to the overlay.
         * If the overlay is configured to have a backdrop, it will be created.
         *
         * @param {?} portal Portal instance to which to attach the overlay.
         * @return {?} The portal attachment result.
         */
        function (portal) {
            var _this = this;
            var /** @type {?} */ attachResult = this._portalOutlet.attach(portal);
            if (this._config.positionStrategy) {
                this._config.positionStrategy.attach(this);
            }
            // Update the pane element with the given configuration.
            this._updateStackingOrder();
            this._updateElementSize();
            this._updateElementDirection();
            if (this._config.scrollStrategy) {
                this._config.scrollStrategy.enable();
            }
            // Update the position once the zone is stable so that the overlay will be fully rendered
            // before attempting to position it, as the position may depend on the size of the rendered
            // content.
            this._ngZone.onStable
                .asObservable()
                .pipe(operators.take(1))
                .subscribe(function () {
                // The overlay could've been detached before the zone has stabilized.
                if (_this.hasAttached()) {
                    _this.updatePosition();
                }
            });
            // Enable pointer events for the overlay pane element.
            this._togglePointerEvents(true);
            if (this._config.hasBackdrop) {
                this._attachBackdrop();
            }
            if (this._config.panelClass) {
                this._toggleClasses(this._pane, this._config.panelClass, true);
            }
            // Only emit the `attachments` event once all other setup is done.
            this._attachments.next();
            // Track this overlay by the keyboard dispatcher
            this._keyboardDispatcher.add(this);
            return attachResult;
        };
        /**
         * Detaches an overlay from a portal.
         * @returns The portal detachment result.
         */
        /**
         * Detaches an overlay from a portal.
         * @return {?} The portal detachment result.
         */
        OverlayRef.prototype.detach = /**
         * Detaches an overlay from a portal.
         * @return {?} The portal detachment result.
         */
        function () {
            if (!this.hasAttached()) {
                return;
            }
            this.detachBackdrop();
            // When the overlay is detached, the pane element should disable pointer events.
            // This is necessary because otherwise the pane element will cover the page and disable
            // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
            this._togglePointerEvents(false);
            if (this._config.positionStrategy && this._config.positionStrategy.detach) {
                this._config.positionStrategy.detach();
            }
            if (this._config.scrollStrategy) {
                this._config.scrollStrategy.disable();
            }
            var /** @type {?} */ detachmentResult = this._portalOutlet.detach();
            // Only emit after everything is detached.
            this._detachments.next();
            // Remove this overlay from keyboard dispatcher tracking
            this._keyboardDispatcher.remove(this);
            return detachmentResult;
        };
        /** Cleans up the overlay from the DOM. */
        /**
         * Cleans up the overlay from the DOM.
         * @return {?}
         */
        OverlayRef.prototype.dispose = /**
         * Cleans up the overlay from the DOM.
         * @return {?}
         */
        function () {
            var /** @type {?} */ isAttached = this.hasAttached();
            if (this._config.positionStrategy) {
                this._config.positionStrategy.dispose();
            }
            if (this._config.scrollStrategy) {
                this._config.scrollStrategy.disable();
            }
            this.detachBackdrop();
            this._keyboardDispatcher.remove(this);
            this._portalOutlet.dispose();
            this._attachments.complete();
            this._backdropClick.complete();
            this._keydownEvents.complete();
            if (this._host && this._host.parentNode) {
                this._host.parentNode.removeChild(this._host);
                this._host = /** @type {?} */ ((null));
            }
            this._pane = /** @type {?} */ ((null));
            if (isAttached) {
                this._detachments.next();
            }
            this._detachments.complete();
        };
        /** Whether the overlay has attached content. */
        /**
         * Whether the overlay has attached content.
         * @return {?}
         */
        OverlayRef.prototype.hasAttached = /**
         * Whether the overlay has attached content.
         * @return {?}
         */
        function () {
            return this._portalOutlet.hasAttached();
        };
        /** Gets an observable that emits when the backdrop has been clicked. */
        /**
         * Gets an observable that emits when the backdrop has been clicked.
         * @return {?}
         */
        OverlayRef.prototype.backdropClick = /**
         * Gets an observable that emits when the backdrop has been clicked.
         * @return {?}
         */
        function () {
            return this._backdropClick.asObservable();
        };
        /** Gets an observable that emits when the overlay has been attached. */
        /**
         * Gets an observable that emits when the overlay has been attached.
         * @return {?}
         */
        OverlayRef.prototype.attachments = /**
         * Gets an observable that emits when the overlay has been attached.
         * @return {?}
         */
        function () {
            return this._attachments.asObservable();
        };
        /** Gets an observable that emits when the overlay has been detached. */
        /**
         * Gets an observable that emits when the overlay has been detached.
         * @return {?}
         */
        OverlayRef.prototype.detachments = /**
         * Gets an observable that emits when the overlay has been detached.
         * @return {?}
         */
        function () {
            return this._detachments.asObservable();
        };
        /** Gets an observable of keydown events targeted to this overlay. */
        /**
         * Gets an observable of keydown events targeted to this overlay.
         * @return {?}
         */
        OverlayRef.prototype.keydownEvents = /**
         * Gets an observable of keydown events targeted to this overlay.
         * @return {?}
         */
        function () {
            return this._keydownEvents.asObservable();
        };
        /** Gets the the current overlay configuration, which is immutable. */
        /**
         * Gets the the current overlay configuration, which is immutable.
         * @return {?}
         */
        OverlayRef.prototype.getConfig = /**
         * Gets the the current overlay configuration, which is immutable.
         * @return {?}
         */
        function () {
            return this._config;
        };
        /** Updates the position of the overlay based on the position strategy. */
        /**
         * Updates the position of the overlay based on the position strategy.
         * @return {?}
         */
        OverlayRef.prototype.updatePosition = /**
         * Updates the position of the overlay based on the position strategy.
         * @return {?}
         */
        function () {
            if (this._config.positionStrategy) {
                this._config.positionStrategy.apply();
            }
        };
        /** Update the size properties of the overlay. */
        /**
         * Update the size properties of the overlay.
         * @param {?} sizeConfig
         * @return {?}
         */
        OverlayRef.prototype.updateSize = /**
         * Update the size properties of the overlay.
         * @param {?} sizeConfig
         * @return {?}
         */
        function (sizeConfig) {
            this._config = __assign({}, this._config, sizeConfig);
            this._updateElementSize();
        };
        /** Sets the LTR/RTL direction for the overlay. */
        /**
         * Sets the LTR/RTL direction for the overlay.
         * @param {?} dir
         * @return {?}
         */
        OverlayRef.prototype.setDirection = /**
         * Sets the LTR/RTL direction for the overlay.
         * @param {?} dir
         * @return {?}
         */
        function (dir) {
            this._config = __assign({}, this._config, { direction: dir });
            this._updateElementDirection();
        };
        /**
         * Returns the layout direction of the overlay panel.
         */
        /**
         * Returns the layout direction of the overlay panel.
         * @return {?}
         */
        OverlayRef.prototype.getDirection = /**
         * Returns the layout direction of the overlay panel.
         * @return {?}
         */
        function () {
            var /** @type {?} */ direction = this._config.direction;
            if (!direction) {
                return 'ltr';
            }
            return typeof direction === 'string' ? direction : direction.value;
        };
        /**
         * Updates the text direction of the overlay panel.
         * @return {?}
         */
        OverlayRef.prototype._updateElementDirection = /**
         * Updates the text direction of the overlay panel.
         * @return {?}
         */
        function () {
            this._host.setAttribute('dir', this.getDirection());
        };
        /**
         * Updates the size of the overlay element based on the overlay config.
         * @return {?}
         */
        OverlayRef.prototype._updateElementSize = /**
         * Updates the size of the overlay element based on the overlay config.
         * @return {?}
         */
        function () {
            var /** @type {?} */ style = this._pane.style;
            style.width = coerceCssPixelValue(this._config.width);
            style.height = coerceCssPixelValue(this._config.height);
            style.minWidth = coerceCssPixelValue(this._config.minWidth);
            style.minHeight = coerceCssPixelValue(this._config.minHeight);
            style.maxWidth = coerceCssPixelValue(this._config.maxWidth);
            style.maxHeight = coerceCssPixelValue(this._config.maxHeight);
        };
        /**
         * Toggles the pointer events for the overlay pane element.
         * @param {?} enablePointer
         * @return {?}
         */
        OverlayRef.prototype._togglePointerEvents = /**
         * Toggles the pointer events for the overlay pane element.
         * @param {?} enablePointer
         * @return {?}
         */
        function (enablePointer) {
            this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
        };
        /**
         * Attaches a backdrop for this overlay.
         * @return {?}
         */
        OverlayRef.prototype._attachBackdrop = /**
         * Attaches a backdrop for this overlay.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ showingClass = 'cdk-overlay-backdrop-showing';
            this._backdropElement = this._document.createElement('div');
            this._backdropElement.classList.add('cdk-overlay-backdrop');
            if (this._config.backdropClass) {
                this._toggleClasses(this._backdropElement, this._config.backdropClass, true);
            } /** @type {?} */
            ((
            // Insert the backdrop before the pane in the DOM order,
            // in order to handle stacked overlays properly.
            this._host.parentElement)).insertBefore(this._backdropElement, this._host);
            // Forward backdrop clicks such that the consumer of the overlay can perform whatever
            // action desired when such a click occurs (usually closing the overlay).
            this._backdropElement.addEventListener('click', function (event) { return _this._backdropClick.next(event); });
            // Add class to fade-in the backdrop after one frame.
            if (typeof requestAnimationFrame !== 'undefined') {
                this._ngZone.runOutsideAngular(function () {
                    requestAnimationFrame(function () {
                        if (_this._backdropElement) {
                            _this._backdropElement.classList.add(showingClass);
                        }
                    });
                });
            }
            else {
                this._backdropElement.classList.add(showingClass);
            }
        };
        /**
         * Updates the stacking order of the element, moving it to the top if necessary.
         * This is required in cases where one overlay was detached, while another one,
         * that should be behind it, was destroyed. The next time both of them are opened,
         * the stacking will be wrong, because the detached element's pane will still be
         * in its original DOM position.
         * @return {?}
         */
        OverlayRef.prototype._updateStackingOrder = /**
         * Updates the stacking order of the element, moving it to the top if necessary.
         * This is required in cases where one overlay was detached, while another one,
         * that should be behind it, was destroyed. The next time both of them are opened,
         * the stacking will be wrong, because the detached element's pane will still be
         * in its original DOM position.
         * @return {?}
         */
        function () {
            if (this._host.nextSibling) {
                /** @type {?} */ ((this._host.parentNode)).appendChild(this._host);
            }
        };
        /** Detaches the backdrop (if any) associated with the overlay. */
        /**
         * Detaches the backdrop (if any) associated with the overlay.
         * @return {?}
         */
        OverlayRef.prototype.detachBackdrop = /**
         * Detaches the backdrop (if any) associated with the overlay.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ backdropToDetach = this._backdropElement;
            if (backdropToDetach) {
                var /** @type {?} */ finishDetach_1 = function () {
                    // It may not be attached to anything in certain cases (e.g. unit tests).
                    if (backdropToDetach && backdropToDetach.parentNode) {
                        backdropToDetach.parentNode.removeChild(backdropToDetach);
                    }
                    // It is possible that a new portal has been attached to this overlay since we started
                    // removing the backdrop. If that is the case, only clear the backdrop reference if it
                    // is still the same instance that we started to remove.
                    if (_this._backdropElement == backdropToDetach) {
                        _this._backdropElement = null;
                    }
                };
                backdropToDetach.classList.remove('cdk-overlay-backdrop-showing');
                if (this._config.backdropClass) {
                    this._toggleClasses(backdropToDetach, this._config.backdropClass, false);
                }
                backdropToDetach.addEventListener('transitionend', finishDetach_1);
                // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
                // In this case we make it unclickable and we try to remove it after a delay.
                backdropToDetach.style.pointerEvents = 'none';
                // Run this outside the Angular zone because there's nothing that Angular cares about.
                // If it were to run inside the Angular zone, every test that used Overlay would have to be
                // either async or fakeAsync.
                this._ngZone.runOutsideAngular(function () { return setTimeout(finishDetach_1, 500); });
            }
        };
        /**
         * Toggles a single CSS class or an array of classes on an element.
         * @param {?} element
         * @param {?} cssClasses
         * @param {?} isAdd
         * @return {?}
         */
        OverlayRef.prototype._toggleClasses = /**
         * Toggles a single CSS class or an array of classes on an element.
         * @param {?} element
         * @param {?} cssClasses
         * @param {?} isAdd
         * @return {?}
         */
        function (element, cssClasses, isAdd) {
            var /** @type {?} */ classList = element.classList;
            coerceArray(cssClasses).forEach(function (cssClass) {
                // We can't do a spread here, because IE doesn't support setting multiple classes.
                isAdd ? classList.add(cssClass) : classList.remove(cssClass);
            });
        };
        return OverlayRef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * implicit position relative some origin element. The relative position is defined in terms of
     * a point on the origin element that is connected to a point on the overlay element. For example,
     * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
     * of the overlay.
     */
    var  /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * implicit position relative some origin element. The relative position is defined in terms of
     * a point on the origin element that is connected to a point on the overlay element. For example,
     * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
     * of the overlay.
     */
    FlexibleConnectedPositionStrategy = /** @class */ (function () {
        function FlexibleConnectedPositionStrategy(connectedTo, _viewportRuler, _document, _platform) {
            var _this = this;
            this._viewportRuler = _viewportRuler;
            this._document = _document;
            this._platform = _platform;
            /**
             * Whether we're performing the very first positioning of the overlay.
             */
            this._isInitialRender = true;
            /**
             * Last size used for the bounding box. Used to avoid resizing the overlay after open.
             */
            this._lastBoundingBoxSize = { width: 0, height: 0 };
            /**
             * Whether the overlay was pushed in a previous positioning.
             */
            this._isPushed = false;
            /**
             * Whether the overlay can be pushed on-screen on the initial open.
             */
            this._canPush = true;
            /**
             * Whether the overlay can grow via flexible width/height after the initial open.
             */
            this._growAfterOpen = false;
            /**
             * Whether the overlay's width and height can be constrained to fit within the viewport.
             */
            this._hasFlexibleDimensions = true;
            /**
             * Whether the overlay position is locked.
             */
            this._positionLocked = false;
            /**
             * Amount of space that must be maintained between the overlay and the edge of the viewport.
             */
            this._viewportMargin = 0;
            /**
             * The Scrollable containers used to check scrollable view properties on position change.
             */
            this.scrollables = [];
            /**
             * Ordered list of preferred positions, from most to least desirable.
             */
            this._preferredPositions = [];
            /**
             * Subject that emits whenever the position changes.
             */
            this._positionChanges = new rxjs.Subject();
            /**
             * Subscription to viewport size changes.
             */
            this._resizeSubscription = rxjs.Subscription.EMPTY;
            /**
             * Default offset for the overlay along the x axis.
             */
            this._offsetX = 0;
            /**
             * Default offset for the overlay along the y axis.
             */
            this._offsetY = 0;
            /**
             * Amount of subscribers to the `positionChanges` stream.
             */
            this._positionChangeSubscriptions = 0;
            /**
             * Observable sequence of position changes.
             */
            this.positionChanges = rxjs.Observable.create(function (observer) {
                var /** @type {?} */ subscription = _this._positionChanges.subscribe(observer);
                _this._positionChangeSubscriptions++;
                return function () {
                    subscription.unsubscribe();
                    _this._positionChangeSubscriptions--;
                };
            });
            this.setOrigin(connectedTo);
        }
        Object.defineProperty(FlexibleConnectedPositionStrategy.prototype, "positions", {
            /** Ordered list of preferred positions, from most to least desirable. */
            get: /**
             * Ordered list of preferred positions, from most to least desirable.
             * @return {?}
             */
            function () {
                return this._preferredPositions;
            },
            enumerable: true,
            configurable: true
        });
        /** Attaches this position strategy to an overlay. */
        /**
         * Attaches this position strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.attach = /**
         * Attaches this position strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            var _this = this;
            if (this._overlayRef && overlayRef !== this._overlayRef) {
                throw Error('This position strategy is already attached to an overlay');
            }
            this._validatePositions();
            overlayRef.hostElement.classList.add('cdk-overlay-connected-position-bounding-box');
            this._overlayRef = overlayRef;
            this._boundingBox = overlayRef.hostElement;
            this._pane = overlayRef.overlayElement;
            this._resizeSubscription.unsubscribe();
            this._resizeSubscription = this._viewportRuler.change().subscribe(function () { return _this.apply(); });
        };
        /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin best fits on-screen.
         *
         * The selection of a position goes as follows:
         *  - If any positions fit completely within the viewport as-is,
         *      choose the first position that does so.
         *  - If flexible dimensions are enabled and at least one satifies the given minimum width/height,
         *      choose the position with the greatest available size modified by the positions' weight.
         *  - If pushing is enabled, take the position that went off-screen the least and push it
         *      on-screen.
         *  - If none of the previous criteria were met, use the position that goes off-screen the least.
         * @docs-private
         */
        /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin best fits on-screen.
         *
         * The selection of a position goes as follows:
         *  - If any positions fit completely within the viewport as-is,
         *      choose the first position that does so.
         *  - If flexible dimensions are enabled and at least one satifies the given minimum width/height,
         *      choose the position with the greatest available size modified by the positions' weight.
         *  - If pushing is enabled, take the position that went off-screen the least and push it
         *      on-screen.
         *  - If none of the previous criteria were met, use the position that goes off-screen the least.
         * \@docs-private
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.apply = /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin best fits on-screen.
         *
         * The selection of a position goes as follows:
         *  - If any positions fit completely within the viewport as-is,
         *      choose the first position that does so.
         *  - If flexible dimensions are enabled and at least one satifies the given minimum width/height,
         *      choose the position with the greatest available size modified by the positions' weight.
         *  - If pushing is enabled, take the position that went off-screen the least and push it
         *      on-screen.
         *  - If none of the previous criteria were met, use the position that goes off-screen the least.
         * \@docs-private
         * @return {?}
         */
        function () {
            // We shouldn't do anything if the strategy was disposed or we're on the server.
            if (this._isDisposed || (this._platform && !this._platform.isBrowser)) {
                return;
            }
            // If the position has been applied already (e.g. when the overlay was opened) and the
            // consumer opted into locking in the position, re-use the old position, in order to
            // prevent the overlay from jumping around.
            if (!this._isInitialRender && this._positionLocked && this._lastPosition) {
                this.reapplyLastPosition();
                return;
            }
            this._resetOverlayElementStyles();
            this._resetBoundingBoxStyles();
            // We need the bounding rects for the origin and the overlay to determine how to position
            // the overlay relative to the origin.
            // We use the viewport rect to determine whether a position would go off-screen.
            this._viewportRect = this._getNarrowedViewportRect();
            this._originRect = this._origin.getBoundingClientRect();
            this._overlayRect = this._pane.getBoundingClientRect();
            var /** @type {?} */ originRect = this._originRect;
            var /** @type {?} */ overlayRect = this._overlayRect;
            var /** @type {?} */ viewportRect = this._viewportRect;
            // Positions where the overlay will fit with flexible dimensions.
            var /** @type {?} */ flexibleFits = [];
            // Fallback if none of the preferred positions fit within the viewport.
            var /** @type {?} */ fallback;
            // Go through each of the preferred positions looking for a good fit.
            // If a good fit is found, it will be applied immediately.
            for (var _i = 0, _a = this._preferredPositions; _i < _a.length; _i++) {
                var pos = _a[_i];
                // Get the exact (x, y) coordinate for the point-of-origin on the origin element.
                var /** @type {?} */ originPoint = this._getOriginPoint(originRect, pos);
                // From that point-of-origin, get the exact (x, y) coordinate for the top-left corner of the
                // overlay in this position. We use the top-left corner for calculations and later translate
                // this into an appropriate (top, left, bottom, right) style.
                var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, pos);
                // Calculate how well the overlay would fit into the viewport with this point.
                var /** @type {?} */ overlayFit = this._getOverlayFit(overlayPoint, overlayRect, viewportRect, pos);
                // If the overlay, without any further work, fits into the viewport, use this position.
                if (overlayFit.isCompletelyWithinViewport) {
                    this._isPushed = false;
                    this._applyPosition(pos, originPoint);
                    return;
                }
                // If the overlay has flexible dimensions, we can use this position
                // so long as there's enough space for the minimum dimensions.
                if (this._canFitWithFlexibleDimensions(overlayFit, overlayPoint, viewportRect)) {
                    // Save positions where the overlay will fit with flexible dimensions. We will use these
                    // if none of the positions fit *without* flexible dimensions.
                    flexibleFits.push({
                        position: pos,
                        origin: originPoint,
                        overlayRect: overlayRect,
                        boundingBoxRect: this._calculateBoundingBoxRect(originPoint, pos)
                    });
                    continue;
                }
                // If the current preferred position does not fit on the screen, remember the position
                // if it has more visible area on-screen than we've seen and move onto the next preferred
                // position.
                if (!fallback || fallback.overlayFit.visibleArea < overlayFit.visibleArea) {
                    fallback = { overlayFit: overlayFit, overlayPoint: overlayPoint, originPoint: originPoint, position: pos, overlayRect: overlayRect };
                }
            }
            // If there are any positions where the overlay would fit with flexible dimensions, choose the
            // one that has the greatest area available modified by the position's weight
            if (flexibleFits.length) {
                var /** @type {?} */ bestFit = null;
                var /** @type {?} */ bestScore = -1;
                for (var _b = 0, flexibleFits_1 = flexibleFits; _b < flexibleFits_1.length; _b++) {
                    var fit_1 = flexibleFits_1[_b];
                    var /** @type {?} */ score = fit_1.boundingBoxRect.width * fit_1.boundingBoxRect.height * (fit_1.position.weight || 1);
                    if (score > bestScore) {
                        bestScore = score;
                        bestFit = fit_1;
                    }
                }
                this._isPushed = false;
                this._applyPosition(/** @type {?} */ ((bestFit)).position, /** @type {?} */ ((bestFit)).origin);
                return;
            }
            // When none of the preferred positions fit within the viewport, take the position
            // that went off-screen the least and attempt to push it on-screen.
            if (this._canPush) {
                // TODO(jelbourn): after pushing, the opening "direction" of the overlay might not make sense.
                this._isPushed = true;
                this._applyPosition(/** @type {?} */ ((fallback)).position, /** @type {?} */ ((fallback)).originPoint);
                return;
            }
            // All options for getting the overlay within the viewport have been exhausted, so go with the
            // position that went off-screen the least.
            this._applyPosition(/** @type {?} */ ((fallback)).position, /** @type {?} */ ((fallback)).originPoint);
        };
        /**
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.detach = /**
         * @return {?}
         */
        function () {
            this._resizeSubscription.unsubscribe();
        };
        /** Cleanup after the element gets destroyed. */
        /**
         * Cleanup after the element gets destroyed.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.dispose = /**
         * Cleanup after the element gets destroyed.
         * @return {?}
         */
        function () {
            if (!this._isDisposed) {
                this.detach();
                this._boundingBox = null;
                this._positionChanges.complete();
                this._isDisposed = true;
            }
        };
        /**
         * This re-aligns the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         */
        /**
         * This re-aligns the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.reapplyLastPosition = /**
         * This re-aligns the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         * @return {?}
         */
        function () {
            if (!this._isDisposed && (!this._platform || this._platform.isBrowser)) {
                this._originRect = this._origin.getBoundingClientRect();
                this._overlayRect = this._pane.getBoundingClientRect();
                this._viewportRect = this._getNarrowedViewportRect();
                var /** @type {?} */ lastPosition = this._lastPosition || this._preferredPositions[0];
                var /** @type {?} */ originPoint = this._getOriginPoint(this._originRect, lastPosition);
                this._applyPosition(lastPosition, originPoint);
            }
        };
        /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         */
        /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         * @param {?} scrollables
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withScrollableContainers = /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         * @param {?} scrollables
         * @return {?}
         */
        function (scrollables) {
            this.scrollables = scrollables;
        };
        /**
         * Adds new preferred positions.
         * @param positions List of positions options for this overlay.
         */
        /**
         * Adds new preferred positions.
         * @param {?} positions List of positions options for this overlay.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withPositions = /**
         * Adds new preferred positions.
         * @param {?} positions List of positions options for this overlay.
         * @return {?}
         */
        function (positions) {
            this._preferredPositions = positions;
            // If the last calculated position object isn't part of the positions anymore, clear
            // it in order to avoid it being picked up if the consumer tries to re-apply.
            if (positions.indexOf(/** @type {?} */ ((this._lastPosition))) === -1) {
                this._lastPosition = null;
            }
            this._validatePositions();
            return this;
        };
        /**
         * Sets a minimum distance the overlay may be positioned to the edge of the viewport.
         * @param margin Required margin between the overlay and the viewport edge in pixels.
         */
        /**
         * Sets a minimum distance the overlay may be positioned to the edge of the viewport.
         * @param {?} margin Required margin between the overlay and the viewport edge in pixels.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withViewportMargin = /**
         * Sets a minimum distance the overlay may be positioned to the edge of the viewport.
         * @param {?} margin Required margin between the overlay and the viewport edge in pixels.
         * @return {?}
         */
        function (margin) {
            this._viewportMargin = margin;
            return this;
        };
        /** Sets whether the overlay's width and height can be constrained to fit within the viewport. */
        /**
         * Sets whether the overlay's width and height can be constrained to fit within the viewport.
         * @param {?=} flexibleDimensions
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withFlexibleDimensions = /**
         * Sets whether the overlay's width and height can be constrained to fit within the viewport.
         * @param {?=} flexibleDimensions
         * @return {?}
         */
        function (flexibleDimensions) {
            if (flexibleDimensions === void 0) { flexibleDimensions = true; }
            this._hasFlexibleDimensions = flexibleDimensions;
            return this;
        };
        /** Sets whether the overlay can grow after the initial open via flexible width/height. */
        /**
         * Sets whether the overlay can grow after the initial open via flexible width/height.
         * @param {?=} growAfterOpen
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withGrowAfterOpen = /**
         * Sets whether the overlay can grow after the initial open via flexible width/height.
         * @param {?=} growAfterOpen
         * @return {?}
         */
        function (growAfterOpen) {
            if (growAfterOpen === void 0) { growAfterOpen = true; }
            this._growAfterOpen = growAfterOpen;
            return this;
        };
        /** Sets whether the overlay can be pushed on-screen if none of the provided positions fit. */
        /**
         * Sets whether the overlay can be pushed on-screen if none of the provided positions fit.
         * @param {?=} canPush
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withPush = /**
         * Sets whether the overlay can be pushed on-screen if none of the provided positions fit.
         * @param {?=} canPush
         * @return {?}
         */
        function (canPush) {
            if (canPush === void 0) { canPush = true; }
            this._canPush = canPush;
            return this;
        };
        /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param isLocked Whether the overlay should locked in.
         */
        /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param {?=} isLocked Whether the overlay should locked in.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withLockedPosition = /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param {?=} isLocked Whether the overlay should locked in.
         * @return {?}
         */
        function (isLocked) {
            if (isLocked === void 0) { isLocked = true; }
            this._positionLocked = isLocked;
            return this;
        };
        /**
         * Sets the origin element, relative to which to position the overlay.
         * @param origin Reference to the new origin element.
         */
        /**
         * Sets the origin element, relative to which to position the overlay.
         * @param {?} origin Reference to the new origin element.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.setOrigin = /**
         * Sets the origin element, relative to which to position the overlay.
         * @param {?} origin Reference to the new origin element.
         * @return {?}
         */
        function (origin) {
            this._origin = origin instanceof core.ElementRef ? origin.nativeElement : origin;
            return this;
        };
        /**
         * Sets the default offset for the overlay's connection point on the x-axis.
         * @param offset New offset in the X axis.
         */
        /**
         * Sets the default offset for the overlay's connection point on the x-axis.
         * @param {?} offset New offset in the X axis.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withDefaultOffsetX = /**
         * Sets the default offset for the overlay's connection point on the x-axis.
         * @param {?} offset New offset in the X axis.
         * @return {?}
         */
        function (offset) {
            this._offsetX = offset;
            return this;
        };
        /**
         * Sets the default offset for the overlay's connection point on the y-axis.
         * @param offset New offset in the Y axis.
         */
        /**
         * Sets the default offset for the overlay's connection point on the y-axis.
         * @param {?} offset New offset in the Y axis.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withDefaultOffsetY = /**
         * Sets the default offset for the overlay's connection point on the y-axis.
         * @param {?} offset New offset in the Y axis.
         * @return {?}
         */
        function (offset) {
            this._offsetY = offset;
            return this;
        };
        /**
         * Configures that the position strategy should set a `transform-origin` on some elements
         * inside the overlay, depending on the current position that is being applied. This is
         * useful for the cases where the origin of an animation can change depending on the
         * alignment of the overlay.
         * @param selector CSS selector that will be used to find the target
         *    elements onto which to set the transform origin.
         */
        /**
         * Configures that the position strategy should set a `transform-origin` on some elements
         * inside the overlay, depending on the current position that is being applied. This is
         * useful for the cases where the origin of an animation can change depending on the
         * alignment of the overlay.
         * @param {?} selector CSS selector that will be used to find the target
         *    elements onto which to set the transform origin.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype.withTransformOriginOn = /**
         * Configures that the position strategy should set a `transform-origin` on some elements
         * inside the overlay, depending on the current position that is being applied. This is
         * useful for the cases where the origin of an animation can change depending on the
         * alignment of the overlay.
         * @param {?} selector CSS selector that will be used to find the target
         *    elements onto which to set the transform origin.
         * @return {?}
         */
        function (selector) {
            this._transformOriginSelector = selector;
            return this;
        };
        /**
         * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
         * @param {?} originRect
         * @param {?} pos
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getOriginPoint = /**
         * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
         * @param {?} originRect
         * @param {?} pos
         * @return {?}
         */
        function (originRect, pos) {
            var /** @type {?} */ x;
            if (pos.originX == 'center') {
                // Note: when centering we should always use the `left`
                // offset, otherwise the position will be wrong in RTL.
                x = originRect.left + (originRect.width / 2);
            }
            else {
                var /** @type {?} */ startX = this._isRtl() ? originRect.right : originRect.left;
                var /** @type {?} */ endX = this._isRtl() ? originRect.left : originRect.right;
                x = pos.originX == 'start' ? startX : endX;
            }
            var /** @type {?} */ y;
            if (pos.originY == 'center') {
                y = originRect.top + (originRect.height / 2);
            }
            else {
                y = pos.originY == 'top' ? originRect.top : originRect.bottom;
            }
            return { x: x, y: y };
        };
        /**
         * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
         * origin point to which the overlay should be connected.
         * @param {?} originPoint
         * @param {?} overlayRect
         * @param {?} pos
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getOverlayPoint = /**
         * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
         * origin point to which the overlay should be connected.
         * @param {?} originPoint
         * @param {?} overlayRect
         * @param {?} pos
         * @return {?}
         */
        function (originPoint, overlayRect, pos) {
            // Calculate the (overlayStartX, overlayStartY), the start of the
            // potential overlay position relative to the origin point.
            var /** @type {?} */ overlayStartX;
            if (pos.overlayX == 'center') {
                overlayStartX = -overlayRect.width / 2;
            }
            else if (pos.overlayX === 'start') {
                overlayStartX = this._isRtl() ? -overlayRect.width : 0;
            }
            else {
                overlayStartX = this._isRtl() ? 0 : -overlayRect.width;
            }
            var /** @type {?} */ overlayStartY;
            if (pos.overlayY == 'center') {
                overlayStartY = -overlayRect.height / 2;
            }
            else {
                overlayStartY = pos.overlayY == 'top' ? 0 : -overlayRect.height;
            }
            // The (x, y) coordinates of the overlay.
            return {
                x: originPoint.x + overlayStartX,
                y: originPoint.y + overlayStartY,
            };
        };
        /**
         * Gets how well an overlay at the given point will fit within the viewport.
         * @param {?} point
         * @param {?} overlay
         * @param {?} viewport
         * @param {?} position
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getOverlayFit = /**
         * Gets how well an overlay at the given point will fit within the viewport.
         * @param {?} point
         * @param {?} overlay
         * @param {?} viewport
         * @param {?} position
         * @return {?}
         */
        function (point, overlay, viewport, position) {
            var x = point.x, y = point.y;
            var /** @type {?} */ offsetX = this._getOffset(position, 'x');
            var /** @type {?} */ offsetY = this._getOffset(position, 'y');
            // Account for the offsets since they could push the overlay out of the viewport.
            if (offsetX) {
                x += offsetX;
            }
            if (offsetY) {
                y += offsetY;
            }
            // How much the overlay would overflow at this position, on each side.
            var /** @type {?} */ leftOverflow = 0 - x;
            var /** @type {?} */ rightOverflow = (x + overlay.width) - viewport.width;
            var /** @type {?} */ topOverflow = 0 - y;
            var /** @type {?} */ bottomOverflow = (y + overlay.height) - viewport.height;
            // Visible parts of the element on each axis.
            var /** @type {?} */ visibleWidth = this._subtractOverflows(overlay.width, leftOverflow, rightOverflow);
            var /** @type {?} */ visibleHeight = this._subtractOverflows(overlay.height, topOverflow, bottomOverflow);
            var /** @type {?} */ visibleArea = visibleWidth * visibleHeight;
            return {
                visibleArea: visibleArea,
                isCompletelyWithinViewport: (overlay.width * overlay.height) === visibleArea,
                fitsInViewportVertically: visibleHeight === overlay.height,
                fitsInViewportHorizontally: visibleWidth == overlay.width,
            };
        };
        /**
         * Whether the overlay can fit within the viewport when it may resize either its width or height.
         * @param {?} fit How well the overlay fits in the viewport at some position.
         * @param {?} point The (x, y) coordinates of the overlat at some position.
         * @param {?} viewport The geometry of the viewport.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._canFitWithFlexibleDimensions = /**
         * Whether the overlay can fit within the viewport when it may resize either its width or height.
         * @param {?} fit How well the overlay fits in the viewport at some position.
         * @param {?} point The (x, y) coordinates of the overlat at some position.
         * @param {?} viewport The geometry of the viewport.
         * @return {?}
         */
        function (fit, point, viewport) {
            if (this._hasFlexibleDimensions) {
                var /** @type {?} */ availableHeight = viewport.bottom - point.y;
                var /** @type {?} */ availableWidth = viewport.right - point.x;
                var /** @type {?} */ minHeight = this._overlayRef.getConfig().minHeight;
                var /** @type {?} */ minWidth = this._overlayRef.getConfig().minWidth;
                var /** @type {?} */ verticalFit = fit.fitsInViewportVertically ||
                    (minHeight != null && minHeight <= availableHeight);
                var /** @type {?} */ horizontalFit = fit.fitsInViewportHorizontally ||
                    (minWidth != null && minWidth <= availableWidth);
                return verticalFit && horizontalFit;
            }
        };
        /**
         * Gets the point at which the overlay can be "pushed" on-screen. If the overlay is larger than
         * the viewport, the top-left corner will be pushed on-screen (with overflow occuring on the
         * right and bottom).
         *
         * @param {?} start The starting point from which the overlay is pushed.
         * @param {?} overlay The overlay dimensions.
         * @return {?} The point at which to position the overlay after pushing. This is effectively a new
         *     originPoint.
         */
        FlexibleConnectedPositionStrategy.prototype._pushOverlayOnScreen = /**
         * Gets the point at which the overlay can be "pushed" on-screen. If the overlay is larger than
         * the viewport, the top-left corner will be pushed on-screen (with overflow occuring on the
         * right and bottom).
         *
         * @param {?} start The starting point from which the overlay is pushed.
         * @param {?} overlay The overlay dimensions.
         * @return {?} The point at which to position the overlay after pushing. This is effectively a new
         *     originPoint.
         */
        function (start, overlay) {
            var /** @type {?} */ viewport = this._viewportRect;
            // Determine how much the overlay goes outside the viewport on each side, which we'll use to
            // decide which direction to push it.
            var /** @type {?} */ overflowRight = Math.max(start.x + overlay.width - viewport.right, 0);
            var /** @type {?} */ overflowBottom = Math.max(start.y + overlay.height - viewport.bottom, 0);
            var /** @type {?} */ overflowTop = Math.max(viewport.top - start.y, 0);
            var /** @type {?} */ overflowLeft = Math.max(viewport.left - start.x, 0);
            // Amount by which to push the overlay in each direction such that it remains on-screen.
            var /** @type {?} */ pushX, /** @type {?} */ pushY = 0;
            // If the overlay fits completely within the bounds of the viewport, push it from whichever
            // direction is goes off-screen. Otherwise, push the top-left corner such that its in the
            // viewport and allow for the trailing end of the overlay to go out of bounds.
            if (overlay.width <= viewport.width) {
                pushX = overflowLeft || -overflowRight;
            }
            else {
                pushX = viewport.left - start.x;
            }
            if (overlay.height <= viewport.height) {
                pushY = overflowTop || -overflowBottom;
            }
            else {
                pushY = viewport.top - start.y;
            }
            return {
                x: start.x + pushX,
                y: start.y + pushY,
            };
        };
        /**
         * Applies a computed position to the overlay and emits a position change.
         * @param {?} position The position preference
         * @param {?} originPoint The point on the origin element where the overlay is connected.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._applyPosition = /**
         * Applies a computed position to the overlay and emits a position change.
         * @param {?} position The position preference
         * @param {?} originPoint The point on the origin element where the overlay is connected.
         * @return {?}
         */
        function (position, originPoint) {
            this._setTransformOrigin(position);
            this._setOverlayElementStyles(originPoint, position);
            this._setBoundingBoxStyles(originPoint, position);
            // Save the last connected position in case the position needs to be re-calculated.
            this._lastPosition = position;
            // Notify that the position has been changed along with its change properties.
            // We only emit if we've got any subscriptions, because the scroll visibility
            // calculcations can be somewhat expensive.
            if (this._positionChangeSubscriptions > 0) {
                var /** @type {?} */ scrollableViewProperties = this._getScrollVisibility();
                var /** @type {?} */ changeEvent = new ConnectedOverlayPositionChange(position, scrollableViewProperties);
                this._positionChanges.next(changeEvent);
            }
            this._isInitialRender = false;
        };
        /**
         * Sets the transform origin based on the configured selector and the passed-in position.
         * @param {?} position
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._setTransformOrigin = /**
         * Sets the transform origin based on the configured selector and the passed-in position.
         * @param {?} position
         * @return {?}
         */
        function (position) {
            if (!this._transformOriginSelector) {
                return;
            }
            var /** @type {?} */ elements = /** @type {?} */ ((this._boundingBox)).querySelectorAll(this._transformOriginSelector);
            var /** @type {?} */ xOrigin;
            var /** @type {?} */ yOrigin = position.overlayY;
            if (position.overlayX === 'center') {
                xOrigin = 'center';
            }
            else if (this._isRtl()) {
                xOrigin = position.overlayX === 'start' ? 'right' : 'left';
            }
            else {
                xOrigin = position.overlayX === 'start' ? 'left' : 'right';
            }
            for (var /** @type {?} */ i = 0; i < elements.length; i++) {
                elements[i].style.transformOrigin = xOrigin + " " + yOrigin;
            }
        };
        /**
         * Gets the position and size of the overlay's sizing container.
         *
         * This method does no measuring and applies no styles so that we can cheaply compute the
         * bounds for all positions and choose the best fit based on these results.
         * @param {?} origin
         * @param {?} position
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._calculateBoundingBoxRect = /**
         * Gets the position and size of the overlay's sizing container.
         *
         * This method does no measuring and applies no styles so that we can cheaply compute the
         * bounds for all positions and choose the best fit based on these results.
         * @param {?} origin
         * @param {?} position
         * @return {?}
         */
        function (origin, position) {
            var /** @type {?} */ viewport = this._viewportRect;
            var /** @type {?} */ isRtl = this._isRtl();
            var /** @type {?} */ height, /** @type {?} */ top, /** @type {?} */ bottom;
            if (position.overlayY === 'top') {
                // Overlay is opening "downward" and thus is bound by the bottom viewport edge.
                top = origin.y;
                height = viewport.bottom - origin.y;
            }
            else if (position.overlayY === 'bottom') {
                // Overlay is opening "upward" and thus is bound by the top viewport edge. We need to add
                // the viewport margin back in, because the viewport rect is narrowed down to remove the
                // margin, whereas the `origin` position is calculated based on its `ClientRect`.
                bottom = viewport.height - origin.y + this._viewportMargin * 2;
                height = viewport.height - bottom + this._viewportMargin;
            }
            else {
                // If neither top nor bottom, it means that the overlay
                // is vertically centered on the origin point.
                var /** @type {?} */ smallestDistanceToViewportEdge = Math.min(viewport.bottom - origin.y, origin.y - viewport.left);
                var /** @type {?} */ previousHeight = this._lastBoundingBoxSize.height;
                height = smallestDistanceToViewportEdge * 2;
                top = origin.y - smallestDistanceToViewportEdge;
                if (height > previousHeight && !this._isInitialRender && !this._growAfterOpen) {
                    top = origin.y - (previousHeight / 2);
                }
            }
            // The overlay is opening 'right-ward' (the content flows to the right).
            var /** @type {?} */ isBoundedByRightViewportEdge = (position.overlayX === 'start' && !isRtl) ||
                (position.overlayX === 'end' && isRtl);
            // The overlay is opening 'left-ward' (the content flows to the left).
            var /** @type {?} */ isBoundedByLeftViewportEdge = (position.overlayX === 'end' && !isRtl) ||
                (position.overlayX === 'start' && isRtl);
            var /** @type {?} */ width, /** @type {?} */ left, /** @type {?} */ right;
            if (isBoundedByLeftViewportEdge) {
                right = viewport.right - origin.x + this._viewportMargin;
                width = origin.x - viewport.left;
            }
            else if (isBoundedByRightViewportEdge) {
                left = origin.x;
                width = viewport.right - origin.x;
            }
            else {
                // If neither start nor end, it means that the overlay
                // is horizontally centered on the origin point.
                var /** @type {?} */ smallestDistanceToViewportEdge = Math.min(viewport.right - origin.x, origin.x - viewport.top);
                var /** @type {?} */ previousWidth = this._lastBoundingBoxSize.width;
                width = smallestDistanceToViewportEdge * 2;
                left = origin.x - smallestDistanceToViewportEdge;
                if (width > previousWidth && !this._isInitialRender && !this._growAfterOpen) {
                    left = origin.x - (previousWidth / 2);
                }
            }
            return { top: top, left: left, bottom: bottom, right: right, width: width, height: height };
        };
        /**
         * Sets the position and size of the overlay's sizing wrapper. The wrapper is positioned on the
         * origin's connection point and stetches to the bounds of the viewport.
         *
         * @param {?} origin The point on the origin element where the overlay is connected.
         * @param {?} position The position preference
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._setBoundingBoxStyles = /**
         * Sets the position and size of the overlay's sizing wrapper. The wrapper is positioned on the
         * origin's connection point and stetches to the bounds of the viewport.
         *
         * @param {?} origin The point on the origin element where the overlay is connected.
         * @param {?} position The position preference
         * @return {?}
         */
        function (origin, position) {
            var /** @type {?} */ boundingBoxRect = this._calculateBoundingBoxRect(origin, position);
            // It's weird if the overlay *grows* while scrolling, so we take the last size into account
            // when applying a new size.
            if (!this._isInitialRender && !this._growAfterOpen) {
                boundingBoxRect.height = Math.min(boundingBoxRect.height, this._lastBoundingBoxSize.height);
                boundingBoxRect.width = Math.min(boundingBoxRect.width, this._lastBoundingBoxSize.width);
            }
            var /** @type {?} */ styles = /** @type {?} */ ({});
            if (this._hasExactPosition()) {
                styles.top = styles.left = '0';
                styles.bottom = styles.right = '';
                styles.width = styles.height = '100%';
            }
            else {
                var /** @type {?} */ maxHeight = this._overlayRef.getConfig().maxHeight;
                var /** @type {?} */ maxWidth = this._overlayRef.getConfig().maxWidth;
                styles.height = coerceCssPixelValue(boundingBoxRect.height);
                styles.top = coerceCssPixelValue(boundingBoxRect.top);
                styles.bottom = coerceCssPixelValue(boundingBoxRect.bottom);
                styles.width = coerceCssPixelValue(boundingBoxRect.width);
                styles.left = coerceCssPixelValue(boundingBoxRect.left);
                styles.right = coerceCssPixelValue(boundingBoxRect.right);
                // Push the pane content towards the proper direction.
                if (position.overlayX === 'center') {
                    styles.alignItems = 'center';
                }
                else {
                    styles.alignItems = position.overlayX === 'end' ? 'flex-end' : 'flex-start';
                }
                if (position.overlayY === 'center') {
                    styles.justifyContent = 'center';
                }
                else {
                    styles.justifyContent = position.overlayY === 'bottom' ? 'flex-end' : 'flex-start';
                }
                if (maxHeight) {
                    styles.maxHeight = coerceCssPixelValue(maxHeight);
                }
                if (maxWidth) {
                    styles.maxWidth = coerceCssPixelValue(maxWidth);
                }
            }
            this._lastBoundingBoxSize = boundingBoxRect;
            extendStyles(/** @type {?} */ ((this._boundingBox)).style, styles);
        };
        /**
         * Resets the styles for the bounding box so that a new positioning can be computed.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._resetBoundingBoxStyles = /**
         * Resets the styles for the bounding box so that a new positioning can be computed.
         * @return {?}
         */
        function () {
            extendStyles(/** @type {?} */ ((this._boundingBox)).style, /** @type {?} */ ({
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                height: '',
                width: '',
                alignItems: '',
                justifyContent: '',
            }));
        };
        /**
         * Resets the styles for the overlay pane so that a new positioning can be computed.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._resetOverlayElementStyles = /**
         * Resets the styles for the overlay pane so that a new positioning can be computed.
         * @return {?}
         */
        function () {
            extendStyles(this._pane.style, /** @type {?} */ ({
                top: '',
                left: '',
                bottom: '',
                right: '',
                position: '',
            }));
        };
        /**
         * Sets positioning styles to the overlay element.
         * @param {?} originPoint
         * @param {?} position
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._setOverlayElementStyles = /**
         * Sets positioning styles to the overlay element.
         * @param {?} originPoint
         * @param {?} position
         * @return {?}
         */
        function (originPoint, position) {
            var /** @type {?} */ styles = /** @type {?} */ ({});
            if (this._hasExactPosition()) {
                extendStyles(styles, this._getExactOverlayY(position, originPoint));
                extendStyles(styles, this._getExactOverlayX(position, originPoint));
            }
            else {
                styles.position = 'static';
            }
            // Use a transform to apply the offsets. We do this because the `center` positions rely on
            // being in the normal flex flow and setting a `top` / `left` at all will completely throw
            // off the position. We also can't use margins, because they won't have an effect in some
            // cases where the element doesn't have anything to "push off of". Finally, this works
            // better both with flexible and non-flexible positioning.
            var /** @type {?} */ transformString = '';
            var /** @type {?} */ offsetX = this._getOffset(position, 'x');
            var /** @type {?} */ offsetY = this._getOffset(position, 'y');
            if (offsetX) {
                transformString += "translateX(" + offsetX + "px) ";
            }
            if (offsetY) {
                transformString += "translateY(" + offsetY + "px)";
            }
            styles.transform = transformString.trim();
            // If a maxWidth or maxHeight is specified on the overlay, we remove them. We do this because
            // we need these values to both be set to "100%" for the automatic flexible sizing to work.
            // The maxHeight and maxWidth are set on the boundingBox in order to enforce the constraint.
            if (this._hasFlexibleDimensions && this._overlayRef.getConfig().maxHeight) {
                styles.maxHeight = '';
            }
            if (this._hasFlexibleDimensions && this._overlayRef.getConfig().maxWidth) {
                styles.maxWidth = '';
            }
            extendStyles(this._pane.style, styles);
        };
        /**
         * Gets the exact top/bottom for the overlay when not using flexible sizing or when pushing.
         * @param {?} position
         * @param {?} originPoint
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getExactOverlayY = /**
         * Gets the exact top/bottom for the overlay when not using flexible sizing or when pushing.
         * @param {?} position
         * @param {?} originPoint
         * @return {?}
         */
        function (position, originPoint) {
            // Reset any existing styles. This is necessary in case the
            // preferred position has changed since the last `apply`.
            var /** @type {?} */ styles = /** @type {?} */ ({ top: null, bottom: null });
            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, this._overlayRect, position);
            if (this._isPushed) {
                overlayPoint = this._pushOverlayOnScreen(overlayPoint, this._overlayRect);
            }
            // We want to set either `top` or `bottom` based on whether the overlay wants to appear
            // above or below the origin and the direction in which the element will expand.
            if (position.overlayY === 'bottom') {
                // When using `bottom`, we adjust the y position such that it is the distance
                // from the bottom of the viewport rather than the top.
                var /** @type {?} */ documentHeight = this._document.documentElement.clientHeight;
                styles.bottom = documentHeight - (overlayPoint.y + this._overlayRect.height) + "px";
            }
            else {
                styles.top = coerceCssPixelValue(overlayPoint.y);
            }
            return styles;
        };
        /**
         * Gets the exact left/right for the overlay when not using flexible sizing or when pushing.
         * @param {?} position
         * @param {?} originPoint
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getExactOverlayX = /**
         * Gets the exact left/right for the overlay when not using flexible sizing or when pushing.
         * @param {?} position
         * @param {?} originPoint
         * @return {?}
         */
        function (position, originPoint) {
            // Reset any existing styles. This is necessary in case the preferred position has
            // changed since the last `apply`.
            var /** @type {?} */ styles = /** @type {?} */ ({ left: null, right: null });
            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, this._overlayRect, position);
            if (this._isPushed) {
                overlayPoint = this._pushOverlayOnScreen(overlayPoint, this._overlayRect);
            }
            // We want to set either `left` or `right` based on whether the overlay wants to appear "before"
            // or "after" the origin, which determines the direction in which the element will expand.
            // For the horizontal axis, the meaning of "before" and "after" change based on whether the
            // page is in RTL or LTR.
            var /** @type {?} */ horizontalStyleProperty;
            if (this._isRtl()) {
                horizontalStyleProperty = position.overlayX === 'end' ? 'left' : 'right';
            }
            else {
                horizontalStyleProperty = position.overlayX === 'end' ? 'right' : 'left';
            }
            // When we're setting `right`, we adjust the x position such that it is the distance
            // from the right edge of the viewport rather than the left edge.
            if (horizontalStyleProperty === 'right') {
                var /** @type {?} */ documentWidth = this._document.documentElement.clientWidth;
                styles.right = documentWidth - (overlayPoint.x + this._overlayRect.width) + "px";
            }
            else {
                styles.left = coerceCssPixelValue(overlayPoint.x);
            }
            return styles;
        };
        /**
         * Gets the view properties of the trigger and overlay, including whether they are clipped
         * or completely outside the view of any of the strategy's scrollables.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getScrollVisibility = /**
         * Gets the view properties of the trigger and overlay, including whether they are clipped
         * or completely outside the view of any of the strategy's scrollables.
         * @return {?}
         */
        function () {
            // Note: needs fresh rects since the position could've changed.
            var /** @type {?} */ originBounds = this._origin.getBoundingClientRect();
            var /** @type {?} */ overlayBounds = this._pane.getBoundingClientRect();
            // TODO(jelbourn): instead of needing all of the client rects for these scrolling containers
            // every time, we should be able to use the scrollTop of the containers if the size of those
            // containers hasn't changed.
            var /** @type {?} */ scrollContainerBounds = this.scrollables.map(function (scrollable) {
                return scrollable.getElementRef().nativeElement.getBoundingClientRect();
            });
            return {
                isOriginClipped: isElementClippedByScrolling(originBounds, scrollContainerBounds),
                isOriginOutsideView: isElementScrolledOutsideView(originBounds, scrollContainerBounds),
                isOverlayClipped: isElementClippedByScrolling(overlayBounds, scrollContainerBounds),
                isOverlayOutsideView: isElementScrolledOutsideView(overlayBounds, scrollContainerBounds),
            };
        };
        /**
         * Subtracts the amount that an element is overflowing on an axis from it's length.
         * @param {?} length
         * @param {...?} overflows
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._subtractOverflows = /**
         * Subtracts the amount that an element is overflowing on an axis from it's length.
         * @param {?} length
         * @param {...?} overflows
         * @return {?}
         */
        function (length) {
            var overflows = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                overflows[_i - 1] = arguments[_i];
            }
            return overflows.reduce(function (currentValue, currentOverflow) {
                return currentValue - Math.max(currentOverflow, 0);
            }, length);
        };
        /**
         * Narrows the given viewport rect by the current _viewportMargin.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getNarrowedViewportRect = /**
         * Narrows the given viewport rect by the current _viewportMargin.
         * @return {?}
         */
        function () {
            // We recalculate the viewport rect here ourselves, rather than using the ViewportRuler,
            // because we want to use the `clientWidth` and `clientHeight` as the base. The difference
            // being that the client properties don't include the scrollbar, as opposed to `innerWidth`
            // and `innerHeight` that do. This is necessary, because the overlay container uses
            // 100% `width` and `height` which don't include the scrollbar either.
            var /** @type {?} */ width = this._document.documentElement.clientWidth;
            var /** @type {?} */ height = this._document.documentElement.clientHeight;
            var /** @type {?} */ scrollPosition = this._viewportRuler.getViewportScrollPosition();
            return {
                top: scrollPosition.top + this._viewportMargin,
                left: scrollPosition.left + this._viewportMargin,
                right: scrollPosition.left + width - this._viewportMargin,
                bottom: scrollPosition.top + height - this._viewportMargin,
                width: width - (2 * this._viewportMargin),
                height: height - (2 * this._viewportMargin),
            };
        };
        /**
         * Whether the we're dealing with an RTL context
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._isRtl = /**
         * Whether the we're dealing with an RTL context
         * @return {?}
         */
        function () {
            return this._overlayRef.getDirection() === 'rtl';
        };
        /**
         * Determines whether the overlay uses exact or flexible positioning.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._hasExactPosition = /**
         * Determines whether the overlay uses exact or flexible positioning.
         * @return {?}
         */
        function () {
            return !this._hasFlexibleDimensions || this._isPushed;
        };
        /**
         * Retrieves the offset of a position along the x or y axis.
         * @param {?} position
         * @param {?} axis
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._getOffset = /**
         * Retrieves the offset of a position along the x or y axis.
         * @param {?} position
         * @param {?} axis
         * @return {?}
         */
        function (position, axis) {
            if (axis === 'x') {
                // We don't do something like `position['offset' + axis]` in
                // order to avoid breking minifiers that rename properties.
                return position.offsetX == null ? this._offsetX : position.offsetX;
            }
            return position.offsetY == null ? this._offsetY : position.offsetY;
        };
        /**
         * Validates that the current position match the expected values.
         * @return {?}
         */
        FlexibleConnectedPositionStrategy.prototype._validatePositions = /**
         * Validates that the current position match the expected values.
         * @return {?}
         */
        function () {
            if (!this._preferredPositions.length) {
                throw Error('FlexibleConnectedPositionStrategy: At least one position is required.');
            }
            // TODO(crisbeto): remove these once Angular's template type
            // checking is advanced enough to catch these cases.
            this._preferredPositions.forEach(function (pair) {
                validateHorizontalPosition('originX', pair.originX);
                validateVerticalPosition('originY', pair.originY);
                validateHorizontalPosition('overlayX', pair.overlayX);
                validateVerticalPosition('overlayY', pair.overlayY);
            });
        };
        return FlexibleConnectedPositionStrategy;
    }());
    /**
     * Shallow-extends a stylesheet object with another stylesheet object.
     * @param {?} dest
     * @param {?} source
     * @return {?}
     */
    function extendStyles(dest, source) {
        for (var /** @type {?} */ key in source) {
            if (source.hasOwnProperty(key)) {
                dest[key] = source[key];
            }
        }
        return dest;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * implicit position relative to some origin element. The relative position is defined in terms of
     * a point on the origin element that is connected to a point on the overlay element. For example,
     * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
     * of the overlay.
     * @deprecated Use `FlexibleConnectedPositionStrategy` instead.
     * \@deletion-target 7.0.0
     */
    var  /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * implicit position relative to some origin element. The relative position is defined in terms of
     * a point on the origin element that is connected to a point on the overlay element. For example,
     * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
     * of the overlay.
     * @deprecated Use `FlexibleConnectedPositionStrategy` instead.
     * \@deletion-target 7.0.0
     */
    ConnectedPositionStrategy = /** @class */ (function () {
        function ConnectedPositionStrategy(originPos, overlayPos, connectedTo, viewportRuler, document, 
        // @deletion-target 7.0.0 `platform` parameter to be made required.
        // @deletion-target 7.0.0 `platform` parameter to be made required.
        platform) {
            /**
             * Ordered list of preferred positions, from most to least desirable.
             */
            this._preferredPositions = [];
            // Since the `ConnectedPositionStrategy` is deprecated and we don't want to maintain
            // the extra logic, we create an instance of the positioning strategy that has some
            // defaults that make it behave as the old position strategy and to which we'll
            // proxy all of the API calls.
            this._positionStrategy =
                new FlexibleConnectedPositionStrategy(connectedTo, viewportRuler, document, platform)
                    .withFlexibleDimensions(false)
                    .withPush(false)
                    .withViewportMargin(0);
            this.withFallbackPosition(originPos, overlayPos);
        }
        Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
            /** Whether the we're dealing with an RTL context */
            get: /**
             * Whether the we're dealing with an RTL context
             * @return {?}
             */
            function () {
                return this._overlayRef.getDirection() === 'rtl';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
            /** Emits an event when the connection point changes. */
            get: /**
             * Emits an event when the connection point changes.
             * @return {?}
             */
            function () {
                return this._positionStrategy.positionChanges;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
            /** Ordered list of preferred positions, from most to least desirable. */
            get: /**
             * Ordered list of preferred positions, from most to least desirable.
             * @return {?}
             */
            function () {
                return this._preferredPositions;
            },
            enumerable: true,
            configurable: true
        });
        /** Attach this position strategy to an overlay. */
        /**
         * Attach this position strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.attach = /**
         * Attach this position strategy to an overlay.
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            this._overlayRef = overlayRef;
            this._positionStrategy.attach(overlayRef);
            if (this._direction) {
                overlayRef.setDirection(this._direction);
                this._direction = null;
            }
        };
        /** Disposes all resources used by the position strategy. */
        /**
         * Disposes all resources used by the position strategy.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.dispose = /**
         * Disposes all resources used by the position strategy.
         * @return {?}
         */
        function () {
            this._positionStrategy.dispose();
        };
        /** @docs-private */
        /**
         * \@docs-private
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.detach = /**
         * \@docs-private
         * @return {?}
         */
        function () {
            this._positionStrategy.detach();
        };
        /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin fits on-screen.
         * @docs-private
         */
        /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin fits on-screen.
         * \@docs-private
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.apply = /**
         * Updates the position of the overlay element, using whichever preferred position relative
         * to the origin fits on-screen.
         * \@docs-private
         * @return {?}
         */
        function () {
            this._positionStrategy.apply();
        };
        /**
         * Re-positions the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         */
        /**
         * Re-positions the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.recalculateLastPosition = /**
         * Re-positions the overlay element with the trigger in its last calculated position,
         * even if a position higher in the "preferred positions" list would now fit. This
         * allows one to re-align the panel without changing the orientation of the panel.
         * @return {?}
         */
        function () {
            this._positionStrategy.reapplyLastPosition();
        };
        /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         */
        /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         * @param {?} scrollables
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withScrollableContainers = /**
         * Sets the list of Scrollable containers that host the origin element so that
         * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
         * Scrollable must be an ancestor element of the strategy's origin element.
         * @param {?} scrollables
         * @return {?}
         */
        function (scrollables) {
            this._positionStrategy.withScrollableContainers(scrollables);
        };
        /**
         * Adds a new preferred fallback position.
         * @param originPos
         * @param overlayPos
         */
        /**
         * Adds a new preferred fallback position.
         * @param {?} originPos
         * @param {?} overlayPos
         * @param {?=} offsetX
         * @param {?=} offsetY
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withFallbackPosition = /**
         * Adds a new preferred fallback position.
         * @param {?} originPos
         * @param {?} overlayPos
         * @param {?=} offsetX
         * @param {?=} offsetY
         * @return {?}
         */
        function (originPos, overlayPos, offsetX, offsetY) {
            var /** @type {?} */ position = new ConnectionPositionPair(originPos, overlayPos, offsetX, offsetY);
            this._preferredPositions.push(position);
            this._positionStrategy.withPositions(this._preferredPositions);
            return this;
        };
        /**
         * Sets the layout direction so the overlay's position can be adjusted to match.
         * @param dir New layout direction.
         */
        /**
         * Sets the layout direction so the overlay's position can be adjusted to match.
         * @param {?} dir New layout direction.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withDirection = /**
         * Sets the layout direction so the overlay's position can be adjusted to match.
         * @param {?} dir New layout direction.
         * @return {?}
         */
        function (dir) {
            // Since the direction might be declared before the strategy is attached,
            // we save the value in a temporary property and we'll transfer it to the
            // overlay ref on attachment.
            if (this._overlayRef) {
                this._overlayRef.setDirection(dir);
            }
            else {
                this._direction = dir;
            }
            return this;
        };
        /**
         * Sets an offset for the overlay's connection point on the x-axis
         * @param offset New offset in the X axis.
         */
        /**
         * Sets an offset for the overlay's connection point on the x-axis
         * @param {?} offset New offset in the X axis.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withOffsetX = /**
         * Sets an offset for the overlay's connection point on the x-axis
         * @param {?} offset New offset in the X axis.
         * @return {?}
         */
        function (offset) {
            this._positionStrategy.withDefaultOffsetX(offset);
            return this;
        };
        /**
         * Sets an offset for the overlay's connection point on the y-axis
         * @param  offset New offset in the Y axis.
         */
        /**
         * Sets an offset for the overlay's connection point on the y-axis
         * @param {?} offset New offset in the Y axis.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withOffsetY = /**
         * Sets an offset for the overlay's connection point on the y-axis
         * @param {?} offset New offset in the Y axis.
         * @return {?}
         */
        function (offset) {
            this._positionStrategy.withDefaultOffsetY(offset);
            return this;
        };
        /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param isLocked Whether the overlay should locked in.
         */
        /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param {?} isLocked Whether the overlay should locked in.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withLockedPosition = /**
         * Sets whether the overlay's position should be locked in after it is positioned
         * initially. When an overlay is locked in, it won't attempt to reposition itself
         * when the position is re-applied (e.g. when the user scrolls away).
         * @param {?} isLocked Whether the overlay should locked in.
         * @return {?}
         */
        function (isLocked) {
            this._positionStrategy.withLockedPosition(isLocked);
            return this;
        };
        /**
         * Overwrites the current set of positions with an array of new ones.
         * @param positions Position pairs to be set on the strategy.
         */
        /**
         * Overwrites the current set of positions with an array of new ones.
         * @param {?} positions Position pairs to be set on the strategy.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.withPositions = /**
         * Overwrites the current set of positions with an array of new ones.
         * @param {?} positions Position pairs to be set on the strategy.
         * @return {?}
         */
        function (positions) {
            this._preferredPositions = positions.slice();
            this._positionStrategy.withPositions(this._preferredPositions);
            return this;
        };
        /**
         * Sets the origin element, relative to which to position the overlay.
         * @param origin Reference to the new origin element.
         */
        /**
         * Sets the origin element, relative to which to position the overlay.
         * @param {?} origin Reference to the new origin element.
         * @return {?}
         */
        ConnectedPositionStrategy.prototype.setOrigin = /**
         * Sets the origin element, relative to which to position the overlay.
         * @param {?} origin Reference to the new origin element.
         * @return {?}
         */
        function (origin) {
            this._positionStrategy.setOrigin(origin);
            return this;
        };
        return ConnectedPositionStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * explicit position relative to the browser's viewport. We use flexbox, instead of
     * transforms, in order to avoid issues with subpixel rendering which can cause the
     * element to become blurry.
     */
    var  /**
     * A strategy for positioning overlays. Using this strategy, an overlay is given an
     * explicit position relative to the browser's viewport. We use flexbox, instead of
     * transforms, in order to avoid issues with subpixel rendering which can cause the
     * element to become blurry.
     */
    GlobalPositionStrategy = /** @class */ (function () {
        function GlobalPositionStrategy() {
            this._cssPosition = 'static';
            this._topOffset = '';
            this._bottomOffset = '';
            this._leftOffset = '';
            this._rightOffset = '';
            this._alignItems = '';
            this._justifyContent = '';
            this._width = '';
            this._height = '';
        }
        /**
         * @param {?} overlayRef
         * @return {?}
         */
        GlobalPositionStrategy.prototype.attach = /**
         * @param {?} overlayRef
         * @return {?}
         */
        function (overlayRef) {
            var /** @type {?} */ config = overlayRef.getConfig();
            this._overlayRef = overlayRef;
            if (this._width && !config.width) {
                overlayRef.updateSize({ width: this._width });
            }
            if (this._height && !config.height) {
                overlayRef.updateSize({ height: this._height });
            }
            overlayRef.hostElement.classList.add('cdk-global-overlay-wrapper');
        };
        /**
         * Sets the top position of the overlay. Clears any previously set vertical position.
         * @param value New top offset.
         */
        /**
         * Sets the top position of the overlay. Clears any previously set vertical position.
         * @param {?=} value New top offset.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.top = /**
         * Sets the top position of the overlay. Clears any previously set vertical position.
         * @param {?=} value New top offset.
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            this._bottomOffset = '';
            this._topOffset = value;
            this._alignItems = 'flex-start';
            return this;
        };
        /**
         * Sets the left position of the overlay. Clears any previously set horizontal position.
         * @param value New left offset.
         */
        /**
         * Sets the left position of the overlay. Clears any previously set horizontal position.
         * @param {?=} value New left offset.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.left = /**
         * Sets the left position of the overlay. Clears any previously set horizontal position.
         * @param {?=} value New left offset.
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            this._rightOffset = '';
            this._leftOffset = value;
            this._justifyContent = 'flex-start';
            return this;
        };
        /**
         * Sets the bottom position of the overlay. Clears any previously set vertical position.
         * @param value New bottom offset.
         */
        /**
         * Sets the bottom position of the overlay. Clears any previously set vertical position.
         * @param {?=} value New bottom offset.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.bottom = /**
         * Sets the bottom position of the overlay. Clears any previously set vertical position.
         * @param {?=} value New bottom offset.
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            this._topOffset = '';
            this._bottomOffset = value;
            this._alignItems = 'flex-end';
            return this;
        };
        /**
         * Sets the right position of the overlay. Clears any previously set horizontal position.
         * @param value New right offset.
         */
        /**
         * Sets the right position of the overlay. Clears any previously set horizontal position.
         * @param {?=} value New right offset.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.right = /**
         * Sets the right position of the overlay. Clears any previously set horizontal position.
         * @param {?=} value New right offset.
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            this._leftOffset = '';
            this._rightOffset = value;
            this._justifyContent = 'flex-end';
            return this;
        };
        /**
         * Sets the overlay width and clears any previously set width.
         * @param value New width for the overlay
         * @deprecated Pass the `width` through the `OverlayConfig`.
         * @deletion-target 7.0.0
         */
        /**
         * Sets the overlay width and clears any previously set width.
         * @deprecated Pass the `width` through the `OverlayConfig`.
         * \@deletion-target 7.0.0
         * @param {?=} value New width for the overlay
         * @return {?}
         */
        GlobalPositionStrategy.prototype.width = /**
         * Sets the overlay width and clears any previously set width.
         * @deprecated Pass the `width` through the `OverlayConfig`.
         * \@deletion-target 7.0.0
         * @param {?=} value New width for the overlay
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            if (this._overlayRef) {
                this._overlayRef.updateSize({ width: value });
            }
            else {
                this._width = value;
            }
            return this;
        };
        /**
         * Sets the overlay height and clears any previously set height.
         * @param value New height for the overlay
         * @deprecated Pass the `height` through the `OverlayConfig`.
         * @deletion-target 7.0.0
         */
        /**
         * Sets the overlay height and clears any previously set height.
         * @deprecated Pass the `height` through the `OverlayConfig`.
         * \@deletion-target 7.0.0
         * @param {?=} value New height for the overlay
         * @return {?}
         */
        GlobalPositionStrategy.prototype.height = /**
         * Sets the overlay height and clears any previously set height.
         * @deprecated Pass the `height` through the `OverlayConfig`.
         * \@deletion-target 7.0.0
         * @param {?=} value New height for the overlay
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = ''; }
            if (this._overlayRef) {
                this._overlayRef.updateSize({ height: value });
            }
            else {
                this._height = value;
            }
            return this;
        };
        /**
         * Centers the overlay horizontally with an optional offset.
         * Clears any previously set horizontal position.
         *
         * @param offset Overlay offset from the horizontal center.
         */
        /**
         * Centers the overlay horizontally with an optional offset.
         * Clears any previously set horizontal position.
         *
         * @param {?=} offset Overlay offset from the horizontal center.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.centerHorizontally = /**
         * Centers the overlay horizontally with an optional offset.
         * Clears any previously set horizontal position.
         *
         * @param {?=} offset Overlay offset from the horizontal center.
         * @return {?}
         */
        function (offset) {
            if (offset === void 0) { offset = ''; }
            this.left(offset);
            this._justifyContent = 'center';
            return this;
        };
        /**
         * Centers the overlay vertically with an optional offset.
         * Clears any previously set vertical position.
         *
         * @param offset Overlay offset from the vertical center.
         */
        /**
         * Centers the overlay vertically with an optional offset.
         * Clears any previously set vertical position.
         *
         * @param {?=} offset Overlay offset from the vertical center.
         * @return {?}
         */
        GlobalPositionStrategy.prototype.centerVertically = /**
         * Centers the overlay vertically with an optional offset.
         * Clears any previously set vertical position.
         *
         * @param {?=} offset Overlay offset from the vertical center.
         * @return {?}
         */
        function (offset) {
            if (offset === void 0) { offset = ''; }
            this.top(offset);
            this._alignItems = 'center';
            return this;
        };
        /**
         * Apply the position to the element.
         * @docs-private
         */
        /**
         * Apply the position to the element.
         * \@docs-private
         * @return {?}
         */
        GlobalPositionStrategy.prototype.apply = /**
         * Apply the position to the element.
         * \@docs-private
         * @return {?}
         */
        function () {
            // Since the overlay ref applies the strategy asynchronously, it could
            // have been disposed before it ends up being applied. If that is the
            // case, we shouldn't do anything.
            if (!this._overlayRef.hasAttached()) {
                return;
            }
            var /** @type {?} */ styles = this._overlayRef.overlayElement.style;
            var /** @type {?} */ parentStyles = this._overlayRef.hostElement.style;
            var /** @type {?} */ config = this._overlayRef.getConfig();
            styles.position = this._cssPosition;
            styles.marginLeft = config.width === '100%' ? '0' : this._leftOffset;
            styles.marginTop = config.height === '100%' ? '0' : this._topOffset;
            styles.marginBottom = this._bottomOffset;
            styles.marginRight = this._rightOffset;
            if (config.width === '100%') {
                parentStyles.justifyContent = 'flex-start';
            }
            else if (this._overlayRef.getConfig().direction === 'rtl') {
                // In RTL the browser will invert `flex-start` and `flex-end` automatically, but we
                // don't want that because our positioning is explicitly `left` and `right`, hence
                // why we do another inversion to ensure that the overlay stays in the same position.
                // TODO: reconsider this if we add `start` and `end` methods.
                if (this._justifyContent === 'flex-start') {
                    parentStyles.justifyContent = 'flex-end';
                }
                else if (this._justifyContent === 'flex-end') {
                    parentStyles.justifyContent = 'flex-start';
                }
            }
            else {
                parentStyles.justifyContent = this._justifyContent;
            }
            parentStyles.alignItems = config.height === '100%' ? 'flex-start' : this._alignItems;
        };
        /**
         * Noop implemented as a part of the PositionStrategy interface.
         * @docs-private
         */
        /**
         * Noop implemented as a part of the PositionStrategy interface.
         * \@docs-private
         * @return {?}
         */
        GlobalPositionStrategy.prototype.dispose = /**
         * Noop implemented as a part of the PositionStrategy interface.
         * \@docs-private
         * @return {?}
         */
        function () { };
        return GlobalPositionStrategy;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Builder for overlay position strategy.
     */
    var OverlayPositionBuilder = /** @class */ (function () {
        function OverlayPositionBuilder(_viewportRuler, _document, 
        // @deletion-target 7.0.0 `_platform` parameter to be made required.
        _platform) {
            this._viewportRuler = _viewportRuler;
            this._document = _document;
            this._platform = _platform;
        }
        /**
         * Creates a global position strategy.
         */
        /**
         * Creates a global position strategy.
         * @return {?}
         */
        OverlayPositionBuilder.prototype.global = /**
         * Creates a global position strategy.
         * @return {?}
         */
        function () {
            return new GlobalPositionStrategy();
        };
        /**
         * Creates a relative position strategy.
         * @param elementRef
         * @param originPos
         * @param overlayPos
         * @deprecated Use `flexibleConnectedTo` instead.
         * @deletion-target 7.0.0
         */
        /**
         * Creates a relative position strategy.
         * @deprecated Use `flexibleConnectedTo` instead.
         * \@deletion-target 7.0.0
         * @param {?} elementRef
         * @param {?} originPos
         * @param {?} overlayPos
         * @return {?}
         */
        OverlayPositionBuilder.prototype.connectedTo = /**
         * Creates a relative position strategy.
         * @deprecated Use `flexibleConnectedTo` instead.
         * \@deletion-target 7.0.0
         * @param {?} elementRef
         * @param {?} originPos
         * @param {?} overlayPos
         * @return {?}
         */
        function (elementRef, originPos, overlayPos) {
            return new ConnectedPositionStrategy(originPos, overlayPos, elementRef, this._viewportRuler, this._document);
        };
        /**
         * Creates a flexible position strategy.
         * @param elementRef
         */
        /**
         * Creates a flexible position strategy.
         * @param {?} elementRef
         * @return {?}
         */
        OverlayPositionBuilder.prototype.flexibleConnectedTo = /**
         * Creates a flexible position strategy.
         * @param {?} elementRef
         * @return {?}
         */
        function (elementRef) {
            return new FlexibleConnectedPositionStrategy(elementRef, this._viewportRuler, this._document, this._platform);
        };
        OverlayPositionBuilder.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        OverlayPositionBuilder.ctorParameters = function () { return [
            { type: ViewportRuler, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: Platform, decorators: [{ type: core.Optional },] },
        ]; };
        /** @nocollapse */ OverlayPositionBuilder.ngInjectableDef = core.defineInjectable({ factory: function OverlayPositionBuilder_Factory() { return new OverlayPositionBuilder(core.inject(ViewportRuler), core.inject(common.DOCUMENT), core.inject(Platform, 8)); }, token: OverlayPositionBuilder, providedIn: "root" });
        return OverlayPositionBuilder;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Next overlay unique ID.
     */
    var /** @type {?} */ nextUniqueId = 0;
    /**
     * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
     * used as a low-level building block for other components. Dialogs, tooltips, menus,
     * selects, etc. can all be built using overlays. The service should primarily be used by authors
     * of re-usable components rather than developers building end-user applications.
     *
     * An overlay *is* a PortalOutlet, so any kind of Portal can be loaded into one.
     */
    var Overlay = /** @class */ (function () {
        function Overlay(scrollStrategies, _overlayContainer, _componentFactoryResolver, _positionBuilder, _keyboardDispatcher, _injector, _ngZone, _document, _directionality) {
            this.scrollStrategies = scrollStrategies;
            this._overlayContainer = _overlayContainer;
            this._componentFactoryResolver = _componentFactoryResolver;
            this._positionBuilder = _positionBuilder;
            this._keyboardDispatcher = _keyboardDispatcher;
            this._injector = _injector;
            this._ngZone = _ngZone;
            this._document = _document;
            this._directionality = _directionality;
        }
        /**
         * Creates an overlay.
         * @param config Configuration applied to the overlay.
         * @returns Reference to the created overlay.
         */
        /**
         * Creates an overlay.
         * @param {?=} config Configuration applied to the overlay.
         * @return {?} Reference to the created overlay.
         */
        Overlay.prototype.create = /**
         * Creates an overlay.
         * @param {?=} config Configuration applied to the overlay.
         * @return {?} Reference to the created overlay.
         */
        function (config) {
            var /** @type {?} */ host = this._createHostElement();
            var /** @type {?} */ pane = this._createPaneElement(host);
            var /** @type {?} */ portalOutlet = this._createPortalOutlet(pane);
            var /** @type {?} */ overlayConfig = new OverlayConfig(config);
            overlayConfig.direction = overlayConfig.direction || this._directionality.value;
            return new OverlayRef(portalOutlet, host, pane, overlayConfig, this._ngZone, this._keyboardDispatcher, this._document);
        };
        /**
         * Gets a position builder that can be used, via fluent API,
         * to construct and configure a position strategy.
         * @returns An overlay position builder.
         */
        /**
         * Gets a position builder that can be used, via fluent API,
         * to construct and configure a position strategy.
         * @return {?} An overlay position builder.
         */
        Overlay.prototype.position = /**
         * Gets a position builder that can be used, via fluent API,
         * to construct and configure a position strategy.
         * @return {?} An overlay position builder.
         */
        function () {
            return this._positionBuilder;
        };
        /**
         * Creates the DOM element for an overlay and appends it to the overlay container.
         * @param {?} host
         * @return {?} Newly-created pane element
         */
        Overlay.prototype._createPaneElement = /**
         * Creates the DOM element for an overlay and appends it to the overlay container.
         * @param {?} host
         * @return {?} Newly-created pane element
         */
        function (host) {
            var /** @type {?} */ pane = this._document.createElement('div');
            pane.id = "cdk-overlay-" + nextUniqueId++;
            pane.classList.add('cdk-overlay-pane');
            host.appendChild(pane);
            return pane;
        };
        /**
         * Creates the host element that wraps around an overlay
         * and can be used for advanced positioning.
         * @return {?} Newly-create host element.
         */
        Overlay.prototype._createHostElement = /**
         * Creates the host element that wraps around an overlay
         * and can be used for advanced positioning.
         * @return {?} Newly-create host element.
         */
        function () {
            var /** @type {?} */ host = this._document.createElement('div');
            this._overlayContainer.getContainerElement().appendChild(host);
            return host;
        };
        /**
         * Create a DomPortalOutlet into which the overlay content can be loaded.
         * @param {?} pane The DOM element to turn into a portal outlet.
         * @return {?} A portal outlet for the given DOM element.
         */
        Overlay.prototype._createPortalOutlet = /**
         * Create a DomPortalOutlet into which the overlay content can be loaded.
         * @param {?} pane The DOM element to turn into a portal outlet.
         * @return {?} A portal outlet for the given DOM element.
         */
        function (pane) {
            // We have to resolve the ApplicationRef later in order to allow people
            // to use overlay-based providers during app initialization.
            if (!this._appRef) {
                this._appRef = this._injector.get(core.ApplicationRef);
            }
            return new DomPortalOutlet(pane, this._componentFactoryResolver, this._appRef, this._injector);
        };
        Overlay.decorators = [
            { type: core.Injectable },
        ];
        /** @nocollapse */
        Overlay.ctorParameters = function () { return [
            { type: ScrollStrategyOptions, },
            { type: OverlayContainer, },
            { type: core.ComponentFactoryResolver, },
            { type: OverlayPositionBuilder, },
            { type: OverlayKeyboardDispatcher, },
            { type: core.Injector, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: Directionality, },
        ]; };
        return Overlay;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Default set of positions for the overlay. Follows the behavior of a dropdown.
     */
    var /** @type {?} */ defaultPositionList = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
        },
        {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom'
        },
        {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom'
        },
        {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
        }
    ];
    /**
     * Injection token that determines the scroll handling while the connected overlay is open.
     */
    var /** @type {?} */ CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY = new core.InjectionToken('cdk-connected-overlay-scroll-strategy');
    /**
     * Directive applied to an element to make it usable as an origin for an Overlay using a
     * ConnectedPositionStrategy.
     */
    var CdkOverlayOrigin = /** @class */ (function () {
        function CdkOverlayOrigin(elementRef) {
            this.elementRef = elementRef;
        }
        CdkOverlayOrigin.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]',
                        exportAs: 'cdkOverlayOrigin',
                    },] },
        ];
        /** @nocollapse */
        CdkOverlayOrigin.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        return CdkOverlayOrigin;
    }());
    /**
     * Directive to facilitate declarative creation of an
     * Overlay using a FlexibleConnectedPositionStrategy.
     */
    var CdkConnectedOverlay = /** @class */ (function () {
        // TODO(jelbourn): inputs for size, scroll behavior, animation, etc.
        function CdkConnectedOverlay(_overlay, templateRef, viewContainerRef, _scrollStrategy, _dir) {
            this._overlay = _overlay;
            this._scrollStrategy = _scrollStrategy;
            this._dir = _dir;
            this._hasBackdrop = false;
            this._lockPosition = false;
            this._growAfterOpen = false;
            this._flexibleDimensions = false;
            this._push = false;
            this._backdropSubscription = rxjs.Subscription.EMPTY;
            /**
             * Margin between the overlay and the viewport edges.
             */
            this.viewportMargin = 0;
            /**
             * Strategy to be used when handling scroll events while the overlay is open.
             */
            this.scrollStrategy = this._scrollStrategy();
            /**
             * Whether the overlay is open.
             */
            this.open = false;
            /**
             * Event emitted when the backdrop is clicked.
             */
            this.backdropClick = new core.EventEmitter();
            /**
             * Event emitted when the position has changed.
             */
            this.positionChange = new core.EventEmitter();
            /**
             * Event emitted when the overlay has been attached.
             */
            this.attach = new core.EventEmitter();
            /**
             * Event emitted when the overlay has been detached.
             */
            this.detach = new core.EventEmitter();
            this._templatePortal = new TemplatePortal(templateRef, viewContainerRef);
        }
        Object.defineProperty(CdkConnectedOverlay.prototype, "offsetX", {
            get: /**
             * The offset in pixels for the overlay connection point on the x-axis
             * @return {?}
             */
            function () { return this._offsetX; },
            set: /**
             * @param {?} offsetX
             * @return {?}
             */
            function (offsetX) {
                this._offsetX = offsetX;
                if (this._position) {
                    this._setPositions(this._position);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "offsetY", {
            get: /**
             * The offset in pixels for the overlay connection point on the y-axis
             * @return {?}
             */
            function () { return this._offsetY; },
            set: /**
             * @param {?} offsetY
             * @return {?}
             */
            function (offsetY) {
                this._offsetY = offsetY;
                if (this._position) {
                    this._setPositions(this._position);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "hasBackdrop", {
            get: /**
             * Whether or not the overlay should attach a backdrop.
             * @return {?}
             */
            function () { return this._hasBackdrop; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._hasBackdrop = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "lockPosition", {
            get: /**
             * Whether or not the overlay should be locked when scrolling.
             * @return {?}
             */
            function () { return this._lockPosition; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._lockPosition = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "flexibleDiemsions", {
            get: /**
             * Whether the overlay's width and height can be constrained to fit within the viewport.
             * @return {?}
             */
            function () { return this._flexibleDimensions; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._flexibleDimensions = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "growAfterOpen", {
            get: /**
             * Whether the overlay can grow after the initial open when flexible positioning is turned on.
             * @return {?}
             */
            function () { return this._growAfterOpen; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._growAfterOpen = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "push", {
            get: /**
             * Whether the overlay can be pushed on-screen if none of the provided positions fit.
             * @return {?}
             */
            function () { return this._push; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._push = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "overlayRef", {
            /** The associated overlay reference. */
            get: /**
             * The associated overlay reference.
             * @return {?}
             */
            function () {
                return this._overlayRef;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkConnectedOverlay.prototype, "dir", {
            /** The element's layout direction. */
            get: /**
             * The element's layout direction.
             * @return {?}
             */
            function () {
                return this._dir ? this._dir.value : 'ltr';
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkConnectedOverlay.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroyOverlay();
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        CdkConnectedOverlay.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            if (this._position) {
                if (changes['positions']) {
                    this._position.withPositions(this.positions);
                }
                if (changes['lockPosition']) {
                    this._position.withLockedPosition(this.lockPosition);
                }
                if (changes['origin']) {
                    this._position.setOrigin(this.origin.elementRef);
                    if (this.open) {
                        this._position.apply();
                    }
                }
            }
            if (changes['open']) {
                this.open ? this._attachOverlay() : this._detachOverlay();
            }
        };
        /**
         * Creates an overlay
         * @return {?}
         */
        CdkConnectedOverlay.prototype._createOverlay = /**
         * Creates an overlay
         * @return {?}
         */
        function () {
            if (!this.positions || !this.positions.length) {
                this.positions = defaultPositionList;
            }
            this._overlayRef = this._overlay.create(this._buildConfig());
        };
        /**
         * Builds the overlay config based on the directive's inputs
         * @return {?}
         */
        CdkConnectedOverlay.prototype._buildConfig = /**
         * Builds the overlay config based on the directive's inputs
         * @return {?}
         */
        function () {
            var /** @type {?} */ positionStrategy = this._position = this._createPositionStrategy();
            var /** @type {?} */ overlayConfig = new OverlayConfig({
                direction: this._dir,
                positionStrategy: positionStrategy,
                scrollStrategy: this.scrollStrategy,
                hasBackdrop: this.hasBackdrop
            });
            if (this.width || this.width === 0) {
                overlayConfig.width = this.width;
            }
            if (this.height || this.height === 0) {
                overlayConfig.height = this.height;
            }
            if (this.minWidth || this.minWidth === 0) {
                overlayConfig.minWidth = this.minWidth;
            }
            if (this.minHeight || this.minHeight === 0) {
                overlayConfig.minHeight = this.minHeight;
            }
            if (this.backdropClass) {
                overlayConfig.backdropClass = this.backdropClass;
            }
            return overlayConfig;
        };
        /**
         * Returns the position strategy of the overlay to be set on the overlay config
         * @return {?}
         */
        CdkConnectedOverlay.prototype._createPositionStrategy = /**
         * Returns the position strategy of the overlay to be set on the overlay config
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ strategy = this._overlay.position()
                .flexibleConnectedTo(this.origin.elementRef)
                .withFlexibleDimensions(this.flexibleDiemsions)
                .withPush(this.push)
                .withGrowAfterOpen(this.growAfterOpen)
                .withViewportMargin(this.viewportMargin)
                .withLockedPosition(this.lockPosition);
            this._setPositions(strategy);
            strategy.positionChanges.subscribe(function (p) { return _this.positionChange.emit(p); });
            return strategy;
        };
        /**
         * Sets the primary and fallback positions of a positions strategy,
         * based on the current directive inputs.
         * @param {?} positionStrategy
         * @return {?}
         */
        CdkConnectedOverlay.prototype._setPositions = /**
         * Sets the primary and fallback positions of a positions strategy,
         * based on the current directive inputs.
         * @param {?} positionStrategy
         * @return {?}
         */
        function (positionStrategy) {
            var _this = this;
            var /** @type {?} */ positions = this.positions.map(function (pos) {
                return ({
                    originX: pos.originX,
                    originY: pos.originY,
                    overlayX: pos.overlayX,
                    overlayY: pos.overlayY,
                    offsetX: pos.offsetX || _this.offsetX,
                    offsetY: pos.offsetY || _this.offsetY
                });
            });
            positionStrategy.withPositions(positions);
        };
        /**
         * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
         * @return {?}
         */
        CdkConnectedOverlay.prototype._attachOverlay = /**
         * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._overlayRef) {
                this._createOverlay(); /** @type {?} */
                ((this._overlayRef)).keydownEvents().subscribe(function (event) {
                    if (event.keyCode === ESCAPE) {
                        _this._detachOverlay();
                    }
                });
            }
            else {
                // Update the overlay size, in case the directive's inputs have changed
                this._overlayRef.updateSize({
                    width: this.width,
                    minWidth: this.minWidth,
                    height: this.height,
                    minHeight: this.minHeight,
                });
            }
            if (!this._overlayRef.hasAttached()) {
                this._overlayRef.attach(this._templatePortal);
                this.attach.emit();
            }
            if (this.hasBackdrop) {
                this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function (event) {
                    _this.backdropClick.emit(event);
                });
            }
        };
        /**
         * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
         * @return {?}
         */
        CdkConnectedOverlay.prototype._detachOverlay = /**
         * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
         * @return {?}
         */
        function () {
            if (this._overlayRef) {
                this._overlayRef.detach();
                this.detach.emit();
            }
            this._backdropSubscription.unsubscribe();
        };
        /**
         * Destroys the overlay created by this directive.
         * @return {?}
         */
        CdkConnectedOverlay.prototype._destroyOverlay = /**
         * Destroys the overlay created by this directive.
         * @return {?}
         */
        function () {
            if (this._overlayRef) {
                this._overlayRef.dispose();
            }
            this._backdropSubscription.unsubscribe();
        };
        CdkConnectedOverlay.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]',
                        exportAs: 'cdkConnectedOverlay'
                    },] },
        ];
        /** @nocollapse */
        CdkConnectedOverlay.ctorParameters = function () { return [
            { type: Overlay, },
            { type: core.TemplateRef, },
            { type: core.ViewContainerRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        CdkConnectedOverlay.propDecorators = {
            "origin": [{ type: core.Input, args: ['cdkConnectedOverlayOrigin',] },],
            "positions": [{ type: core.Input, args: ['cdkConnectedOverlayPositions',] },],
            "offsetX": [{ type: core.Input, args: ['cdkConnectedOverlayOffsetX',] },],
            "offsetY": [{ type: core.Input, args: ['cdkConnectedOverlayOffsetY',] },],
            "width": [{ type: core.Input, args: ['cdkConnectedOverlayWidth',] },],
            "height": [{ type: core.Input, args: ['cdkConnectedOverlayHeight',] },],
            "minWidth": [{ type: core.Input, args: ['cdkConnectedOverlayMinWidth',] },],
            "minHeight": [{ type: core.Input, args: ['cdkConnectedOverlayMinHeight',] },],
            "backdropClass": [{ type: core.Input, args: ['cdkConnectedOverlayBackdropClass',] },],
            "viewportMargin": [{ type: core.Input, args: ['cdkConnectedOverlayViewportMargin',] },],
            "scrollStrategy": [{ type: core.Input, args: ['cdkConnectedOverlayScrollStrategy',] },],
            "open": [{ type: core.Input, args: ['cdkConnectedOverlayOpen',] },],
            "hasBackdrop": [{ type: core.Input, args: ['cdkConnectedOverlayHasBackdrop',] },],
            "lockPosition": [{ type: core.Input, args: ['cdkConnectedOverlayLockPosition',] },],
            "flexibleDiemsions": [{ type: core.Input, args: ['cdkConnectedOverlayFlexibleDimensions',] },],
            "growAfterOpen": [{ type: core.Input, args: ['cdkConnectedOverlayGrowAfterOpen',] },],
            "push": [{ type: core.Input, args: ['cdkConnectedOverlayPush',] },],
            "backdropClick": [{ type: core.Output },],
            "positionChange": [{ type: core.Output },],
            "attach": [{ type: core.Output },],
            "detach": [{ type: core.Output },],
        };
        return CdkConnectedOverlay;
    }());
    /**
     * \@docs-private
     * @param {?} overlay
     * @return {?}
     */
    function CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
        return function () { return overlay.scrollStrategies.reposition(); };
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER = {
        provide: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,
        deps: [Overlay],
        useFactory: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY,
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var OverlayModule = /** @class */ (function () {
        function OverlayModule() {
        }
        OverlayModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [BidiModule, PortalModule, ScrollDispatchModule],
                        exports: [CdkConnectedOverlay, CdkOverlayOrigin, ScrollDispatchModule],
                        declarations: [CdkConnectedOverlay, CdkOverlayOrigin],
                        providers: [
                            Overlay,
                            CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER,
                        ],
                    },] },
        ];
        return OverlayModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Alternative to OverlayContainer that supports correct displaying of overlay elements in
     * Fullscreen mode
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
     *
     * Should be provided in the root component.
     */
    var FullscreenOverlayContainer = /** @class */ (function (_super) {
        __extends(FullscreenOverlayContainer, _super);
        function FullscreenOverlayContainer(_document) {
            return _super.call(this, _document) || this;
        }
        /**
         * @return {?}
         */
        FullscreenOverlayContainer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            _super.prototype.ngOnDestroy.call(this);
            if (this._fullScreenEventName && this._fullScreenListener) {
                this._document.removeEventListener(this._fullScreenEventName, this._fullScreenListener);
            }
        };
        /**
         * @return {?}
         */
        FullscreenOverlayContainer.prototype._createContainer = /**
         * @return {?}
         */
        function () {
            var _this = this;
            _super.prototype._createContainer.call(this);
            this._adjustParentForFullscreenChange();
            this._addFullscreenChangeListener(function () { return _this._adjustParentForFullscreenChange(); });
        };
        /**
         * @return {?}
         */
        FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = /**
         * @return {?}
         */
        function () {
            if (!this._containerElement) {
                return;
            }
            var /** @type {?} */ fullscreenElement = this.getFullscreenElement();
            var /** @type {?} */ parent = fullscreenElement || this._document.body;
            parent.appendChild(this._containerElement);
        };
        /**
         * @param {?} fn
         * @return {?}
         */
        FullscreenOverlayContainer.prototype._addFullscreenChangeListener = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            var /** @type {?} */ eventName = this._getEventName();
            if (eventName) {
                if (this._fullScreenListener) {
                    this._document.removeEventListener(eventName, this._fullScreenListener);
                }
                this._document.addEventListener(eventName, fn);
                this._fullScreenListener = fn;
            }
        };
        /**
         * @return {?}
         */
        FullscreenOverlayContainer.prototype._getEventName = /**
         * @return {?}
         */
        function () {
            if (!this._fullScreenEventName) {
                if (this._document.fullscreenEnabled) {
                    this._fullScreenEventName = 'fullscreenchange';
                }
                else if (this._document.webkitFullscreenEnabled) {
                    this._fullScreenEventName = 'webkitfullscreenchange';
                }
                else if ((/** @type {?} */ (this._document)).mozFullScreenEnabled) {
                    this._fullScreenEventName = 'mozfullscreenchange';
                }
                else if ((/** @type {?} */ (this._document)).msFullscreenEnabled) {
                    this._fullScreenEventName = 'MSFullscreenChange';
                }
            }
            return this._fullScreenEventName;
        };
        /**
         * When the page is put into fullscreen mode, a specific element is specified.
         * Only that element and its children are visible when in fullscreen mode.
         */
        /**
         * When the page is put into fullscreen mode, a specific element is specified.
         * Only that element and its children are visible when in fullscreen mode.
         * @return {?}
         */
        FullscreenOverlayContainer.prototype.getFullscreenElement = /**
         * When the page is put into fullscreen mode, a specific element is specified.
         * Only that element and its children are visible when in fullscreen mode.
         * @return {?}
         */
        function () {
            return this._document.fullscreenElement ||
                this._document.webkitFullscreenElement ||
                (/** @type {?} */ (this._document)).mozFullScreenElement ||
                (/** @type {?} */ (this._document)).msFullscreenElement ||
                null;
        };
        FullscreenOverlayContainer.decorators = [
            { type: core.Injectable },
        ];
        /** @nocollapse */
        FullscreenOverlayContainer.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        return FullscreenOverlayContainer;
    }(OverlayContainer));

    /**
     * @license Angular v6.0.6
     * (c) 2010-2018 Google, Inc. https://angular.io/
     * License: MIT
     */

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Base class for control directives.
     *
     * Only used internally in the forms module.
     *
     *
     */
    var AbstractControlDirective = /** @class */ (function () {
        function AbstractControlDirective() {
        }
        Object.defineProperty(AbstractControlDirective.prototype, "value", {
            /** The value of the control. */
            get: function () { return this.control ? this.control.value : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "valid", {
            /**
             * A control is `valid` when its `status === VALID`.
             *
             * In order to have this status, the control must have passed all its
             * validation checks.
             */
            get: function () { return this.control ? this.control.valid : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
            /**
             * A control is `invalid` when its `status === INVALID`.
             *
             * In order to have this status, the control must have failed
             * at least one of its validation checks.
             */
            get: function () { return this.control ? this.control.invalid : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "pending", {
            /**
             * A control is `pending` when its `status === PENDING`.
             *
             * In order to have this status, the control must be in the
             * middle of conducting a validation check.
             */
            get: function () { return this.control ? this.control.pending : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
            /**
             * A control is `disabled` when its `status === DISABLED`.
             *
             * Disabled controls are exempt from validation checks and
             * are not included in the aggregate value of their ancestor
             * controls.
             */
            get: function () { return this.control ? this.control.disabled : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
            /**
             * A control is `enabled` as long as its `status !== DISABLED`.
             *
             * In other words, it has a status of `VALID`, `INVALID`, or
             * `PENDING`.
             */
            get: function () { return this.control ? this.control.enabled : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "errors", {
            /**
             * Returns any errors generated by failing validation. If there
             * are no errors, it will return null.
             */
            get: function () { return this.control ? this.control.errors : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
            /**
             * A control is `pristine` if the user has not yet changed
             * the value in the UI.
             *
             * Note that programmatic changes to a control's value will
             * *not* mark it dirty.
             */
            get: function () { return this.control ? this.control.pristine : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
            /**
             * A control is `dirty` if the user has changed the value
             * in the UI.
             *
             * Note that programmatic changes to a control's value will
             * *not* mark it dirty.
             */
            get: function () { return this.control ? this.control.dirty : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "touched", {
            /**
             * A control is marked `touched` once the user has triggered
             * a `blur` event on it.
             */
            get: function () { return this.control ? this.control.touched : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "status", {
            get: function () { return this.control ? this.control.status : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
            /**
             * A control is `untouched` if the user has not yet triggered
             * a `blur` event on it.
             */
            get: function () { return this.control ? this.control.untouched : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
            /**
             * Emits an event every time the validation status of the control
             * is re-calculated.
             */
            get: function () {
                return this.control ? this.control.statusChanges : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
            /**
             * Emits an event every time the value of the control changes, in
             * the UI or programmatically.
             */
            get: function () {
                return this.control ? this.control.valueChanges : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "path", {
            /**
             * Returns an array that represents the path from the top-level form
             * to this control. Each index is the string name of the control on
             * that level.
             */
            get: function () { return null; },
            enumerable: true,
            configurable: true
        });
        /**
         * Resets the form control. This means by default:
         *
         * * it is marked as `pristine`
         * * it is marked as `untouched`
         * * value is set to null
         *
         * For more information, see `AbstractControl`.
         */
        AbstractControlDirective.prototype.reset = function (value) {
            if (value === void 0) { value = undefined; }
            if (this.control)
                this.control.reset(value);
        };
        /**
         * Returns true if the control with the given path has the error specified. Otherwise
         * returns false.
         *
         * If no path is given, it checks for the error on the present control.
         */
        AbstractControlDirective.prototype.hasError = function (errorCode, path) {
            return this.control ? this.control.hasError(errorCode, path) : false;
        };
        /**
         * Returns error data if the control with the given path has the error specified. Otherwise
         * returns null or undefined.
         *
         * If no path is given, it checks for the error on the present control.
         */
        AbstractControlDirective.prototype.getError = function (errorCode, path) {
            return this.control ? this.control.getError(errorCode, path) : null;
        };
        return AbstractControlDirective;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * A directive that contains multiple `NgControl`s.
     *
     * Only used by the forms module.
     *
     *
     */
    var ControlContainer = /** @class */ (function (_super) {
        __extends(ControlContainer, _super);
        function ControlContainer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ControlContainer.prototype, "formDirective", {
            /**
             * Get the form to which this container belongs.
             */
            get: function () { return null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControlContainer.prototype, "path", {
            /**
             * Get the path to this container.
             */
            get: function () { return null; },
            enumerable: true,
            configurable: true
        });
        return ControlContainer;
    }(AbstractControlDirective));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function isEmptyInputValue(value) {
        // we don't check for string here so it also works with arrays
        return value == null || value.length === 0;
    }
    /**
     * Providers for validators to be used for `FormControl`s in a form.
     *
     * Provide this using `multi: true` to add validators.
     *
     * ### Example
     *
     * ```typescript
     * @Directive({
     *   selector: '[custom-validator]',
     *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
     * })
     * class CustomValidatorDirective implements Validator {
     *   validate(control: AbstractControl): ValidationErrors | null {
     *     return {"custom": true};
     *   }
     * }
     * ```
     *
     *
     */
    var NG_VALIDATORS = new core.InjectionToken('NgValidators');
    /**
     * Providers for asynchronous validators to be used for `FormControl`s
     * in a form.
     *
     * Provide this using `multi: true` to add validators.
     *
     * See `NG_VALIDATORS` for more details.
     *
     *
     */
    var NG_ASYNC_VALIDATORS = new core.InjectionToken('NgAsyncValidators');
    var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
    /**
     * Provides a set of validators used by form controls.
     *
     * A validator is a function that processes a `FormControl` or collection of
     * controls and returns a map of errors. A null map means that validation has passed.
     *
     * ### Example
     *
     * ```typescript
     * var loginControl = new FormControl("", Validators.required)
     * ```
     *
     *
     */
    var Validators = /** @class */ (function () {
        function Validators() {
        }
        /**
         * Validator that requires controls to have a value greater than a number.
         *`min()` exists only as a function, not as a directive. For example,
         * `control = new FormControl('', Validators.min(3));`.
         */
        Validators.min = function (min) {
            return function (control) {
                if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                    return null; // don't validate empty values to allow optional controls
                }
                var value = parseFloat(control.value);
                // Controls with NaN values after parsing should be treated as not having a
                // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
                return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
            };
        };
        /**
         * Validator that requires controls to have a value less than a number.
         * `max()` exists only as a function, not as a directive. For example,
         * `control = new FormControl('', Validators.max(15));`.
         */
        Validators.max = function (max) {
            return function (control) {
                if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                    return null; // don't validate empty values to allow optional controls
                }
                var value = parseFloat(control.value);
                // Controls with NaN values after parsing should be treated as not having a
                // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
                return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
            };
        };
        /**
         * Validator that requires controls to have a non-empty value.
         */
        Validators.required = function (control) {
            return isEmptyInputValue(control.value) ? { 'required': true } : null;
        };
        /**
         * Validator that requires control value to be true.
         */
        Validators.requiredTrue = function (control) {
            return control.value === true ? null : { 'required': true };
        };
        /**
         * Validator that performs email validation.
         */
        Validators.email = function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
        };
        /**
         * Validator that requires controls to have a value of a minimum length.
         */
        Validators.minLength = function (minLength) {
            return function (control) {
                if (isEmptyInputValue(control.value)) {
                    return null; // don't validate empty values to allow optional controls
                }
                var length = control.value ? control.value.length : 0;
                return length < minLength ?
                    { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                    null;
            };
        };
        /**
         * Validator that requires controls to have a value of a maximum length.
         */
        Validators.maxLength = function (maxLength) {
            return function (control) {
                var length = control.value ? control.value.length : 0;
                return length > maxLength ?
                    { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                    null;
            };
        };
        /**
         * Validator that requires a control to match a regex to its value.
         */
        Validators.pattern = function (pattern) {
            if (!pattern)
                return Validators.nullValidator;
            var regex;
            var regexStr;
            if (typeof pattern === 'string') {
                regexStr = '';
                if (pattern.charAt(0) !== '^')
                    regexStr += '^';
                regexStr += pattern;
                if (pattern.charAt(pattern.length - 1) !== '$')
                    regexStr += '$';
                regex = new RegExp(regexStr);
            }
            else {
                regexStr = pattern.toString();
                regex = pattern;
            }
            return function (control) {
                if (isEmptyInputValue(control.value)) {
                    return null; // don't validate empty values to allow optional controls
                }
                var value = control.value;
                return regex.test(value) ? null :
                    { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
            };
        };
        /**
         * No-op validator.
         */
        Validators.nullValidator = function (c) { return null; };
        Validators.compose = function (validators) {
            if (!validators)
                return null;
            var presentValidators = validators.filter(isPresent);
            if (presentValidators.length == 0)
                return null;
            return function (control) {
                return _mergeErrors(_executeValidators(control, presentValidators));
            };
        };
        Validators.composeAsync = function (validators) {
            if (!validators)
                return null;
            var presentValidators = validators.filter(isPresent);
            if (presentValidators.length == 0)
                return null;
            return function (control) {
                var observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
                return rxjs.forkJoin(observables).pipe(operators.map(_mergeErrors));
            };
        };
        return Validators;
    }());
    function isPresent(o) {
        return o != null;
    }
    function toObservable(r) {
        var obs = core.ɵisPromise(r) ? rxjs.from(r) : r;
        if (!(core.ɵisObservable(obs))) {
            throw new Error("Expected validator to return Promise or Observable.");
        }
        return obs;
    }
    function _executeValidators(control, validators) {
        return validators.map(function (v) { return v(control); });
    }
    function _executeAsyncValidators(control, validators) {
        return validators.map(function (v) { return v(control); });
    }
    function _mergeErrors(arrayOfErrors) {
        var res = arrayOfErrors.reduce(function (res, errors) {
            return errors != null ? __assign({}, res, errors) : res;
        }, {});
        return Object.keys(res).length === 0 ? null : res;
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Used to provide a `ControlValueAccessor` for form controls.
     *
     * See `DefaultValueAccessor` for how to implement one.
     *
     */
    var NG_VALUE_ACCESSOR = new core.InjectionToken('NgValueAccessor');

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var CHECKBOX_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return CheckboxControlValueAccessor; }),
        multi: true,
    };
    /**
     * The accessor for writing a value and listening to changes on a checkbox input element.
     *
     *  ### Example
     *  ```
     *  <input type="checkbox" name="rememberLogin" ngModel>
     *  ```
     *
     *
     */
    var CheckboxControlValueAccessor = /** @class */ (function () {
        function CheckboxControlValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) { };
            this.onTouched = function () { };
        }
        CheckboxControlValueAccessor.prototype.writeValue = function (value) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
        };
        CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
        CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        CheckboxControlValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                        host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                        providers: [CHECKBOX_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        CheckboxControlValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef }
        ]; };
        return CheckboxControlValueAccessor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var DEFAULT_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return DefaultValueAccessor; }),
        multi: true
    };
    /**
     * We must check whether the agent is Android because composition events
     * behave differently between iOS and Android.
     */
    function _isAndroid() {
        var userAgent = getDOM() ? getDOM().getUserAgent() : '';
        return /android (\d+)/.test(userAgent.toLowerCase());
    }
    /**
     * Turn this mode on if you want form directives to buffer IME input until compositionend
     * @experimental
     */
    var COMPOSITION_BUFFER_MODE = new core.InjectionToken('CompositionEventMode');
    /**
     * The default accessor for writing a value and listening to changes that is used by the
     * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
     *
     *  ### Example
     *  ```
     *  <input type="text" name="searchQuery" ngModel>
     *  ```
     *
     *
     */
    var DefaultValueAccessor = /** @class */ (function () {
        function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this._compositionMode = _compositionMode;
            this.onChange = function (_) { };
            this.onTouched = function () { };
            /** Whether the user is creating a composition string (IME events). */
            this._composing = false;
            if (this._compositionMode == null) {
                this._compositionMode = !_isAndroid();
            }
        }
        DefaultValueAccessor.prototype.writeValue = function (value) {
            var normalizedValue = value == null ? '' : value;
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
        };
        DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
        DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        /** @internal */
        DefaultValueAccessor.prototype._handleInput = function (value) {
            if (!this._compositionMode || (this._compositionMode && !this._composing)) {
                this.onChange(value);
            }
        };
        /** @internal */
        DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
        /** @internal */
        DefaultValueAccessor.prototype._compositionEnd = function (value) {
            this._composing = false;
            this._compositionMode && this.onChange(value);
        };
        DefaultValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                        // TODO: vsavkin replace the above selector with the one below it once
                        // https://github.com/angular/angular/issues/3011 is implemented
                        // selector: '[ngModel],[formControl],[formControlName]',
                        host: {
                            '(input)': '$any(this)._handleInput($event.target.value)',
                            '(blur)': 'onTouched()',
                            '(compositionstart)': '$any(this)._compositionStart()',
                            '(compositionend)': '$any(this)._compositionEnd($event.target.value)'
                        },
                        providers: [DEFAULT_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        DefaultValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef },
            { type: Boolean, decorators: [{ type: core.Optional }, { type: core.Inject, args: [COMPOSITION_BUFFER_MODE,] }] }
        ]; };
        return DefaultValueAccessor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function normalizeValidator(validator) {
        if (validator.validate) {
            return function (c) { return validator.validate(c); };
        }
        else {
            return validator;
        }
    }
    function normalizeAsyncValidator(validator) {
        if (validator.validate) {
            return function (c) { return validator.validate(c); };
        }
        else {
            return validator;
        }
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var NUMBER_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return NumberValueAccessor; }),
        multi: true
    };
    /**
     * The accessor for writing a number value and listening to changes that is used by the
     * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
     *
     *  ### Example
     *  ```
     *  <input type="number" [(ngModel)]="age">
     *  ```
     */
    var NumberValueAccessor = /** @class */ (function () {
        function NumberValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) { };
            this.onTouched = function () { };
        }
        NumberValueAccessor.prototype.writeValue = function (value) {
            // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
            var normalizedValue = value == null ? '' : value;
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
        };
        NumberValueAccessor.prototype.registerOnChange = function (fn) {
            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
        };
        NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        NumberValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                        host: {
                            '(change)': 'onChange($event.target.value)',
                            '(input)': 'onChange($event.target.value)',
                            '(blur)': 'onTouched()'
                        },
                        providers: [NUMBER_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        NumberValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef }
        ]; };
        return NumberValueAccessor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function unimplemented() {
        throw new Error('unimplemented');
    }
    /**
     * A base class that all control directive extend.
     * It binds a `FormControl` object to a DOM element.
     *
     * Used internally by Angular forms.
     *
     *
     */
    var NgControl = /** @class */ (function (_super) {
        __extends(NgControl, _super);
        function NgControl() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** @internal */
            _this._parent = null;
            _this.name = null;
            _this.valueAccessor = null;
            /** @internal */
            _this._rawValidators = [];
            /** @internal */
            _this._rawAsyncValidators = [];
            return _this;
        }
        Object.defineProperty(NgControl.prototype, "validator", {
            get: function () { return unimplemented(); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControl.prototype, "asyncValidator", {
            get: function () { return unimplemented(); },
            enumerable: true,
            configurable: true
        });
        return NgControl;
    }(AbstractControlDirective));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var RADIO_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return RadioControlValueAccessor; }),
        multi: true
    };
    /**
     * Internal class used by Angular to uncheck radio buttons with the matching name.
     */
    var RadioControlRegistry = /** @class */ (function () {
        function RadioControlRegistry() {
            this._accessors = [];
        }
        RadioControlRegistry.prototype.add = function (control, accessor) {
            this._accessors.push([control, accessor]);
        };
        RadioControlRegistry.prototype.remove = function (accessor) {
            for (var i = this._accessors.length - 1; i >= 0; --i) {
                if (this._accessors[i][1] === accessor) {
                    this._accessors.splice(i, 1);
                    return;
                }
            }
        };
        RadioControlRegistry.prototype.select = function (accessor) {
            var _this = this;
            this._accessors.forEach(function (c) {
                if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                    c[1].fireUncheck(accessor.value);
                }
            });
        };
        RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
            if (!controlPair[0].control)
                return false;
            return controlPair[0]._parent === accessor._control._parent &&
                controlPair[1].name === accessor.name;
        };
        RadioControlRegistry.decorators = [
            { type: core.Injectable }
        ];
        return RadioControlRegistry;
    }());
    /**
     * @description
     *
     * Writes radio control values and listens to radio control changes.
     *
     * Used by `NgModel`, `FormControlDirective`, and `FormControlName`
     * to keep the view synced with the `FormControl` model.
     *
     * If you have imported the `FormsModule` or the `ReactiveFormsModule`, this
     * value accessor will be active on any radio control that has a form directive. You do
     * **not** need to add a special selector to activate it.
     *
     * ### How to use radio buttons with form directives
     *
     * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
     * in the same group have the same `name` attribute.  Radio buttons with different `name`
     * attributes do not affect each other.
     *
     * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
     *
     * When using radio buttons in a reactive form, radio buttons in the same group should have the
     * same `formControlName`. You can also add a `name` attribute, but it's optional.
     *
     * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
     *
     *  * **npm package**: `@angular/forms`
     *
     *
     */
    var RadioControlValueAccessor = /** @class */ (function () {
        function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this._registry = _registry;
            this._injector = _injector;
            this.onChange = function () { };
            this.onTouched = function () { };
        }
        RadioControlValueAccessor.prototype.ngOnInit = function () {
            this._control = this._injector.get(NgControl);
            this._checkName();
            this._registry.add(this._control, this);
        };
        RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
        RadioControlValueAccessor.prototype.writeValue = function (value) {
            this._state = value === this.value;
            this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
        };
        RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
            var _this = this;
            this._fn = fn;
            this.onChange = function () {
                fn(_this.value);
                _this._registry.select(_this);
            };
        };
        RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
        RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        RadioControlValueAccessor.prototype._checkName = function () {
            if (this.name && this.formControlName && this.name !== this.formControlName) {
                this._throwNameError();
            }
            if (!this.name && this.formControlName)
                this.name = this.formControlName;
        };
        RadioControlValueAccessor.prototype._throwNameError = function () {
            throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
        };
        RadioControlValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                        host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                        providers: [RADIO_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        RadioControlValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef },
            { type: RadioControlRegistry },
            { type: core.Injector }
        ]; };
        RadioControlValueAccessor.propDecorators = {
            name: [{ type: core.Input }],
            formControlName: [{ type: core.Input }],
            value: [{ type: core.Input }]
        };
        return RadioControlValueAccessor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var RANGE_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return RangeValueAccessor; }),
        multi: true
    };
    /**
     * The accessor for writing a range value and listening to changes that is used by the
     * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
     *
     *  ### Example
     *  ```
     *  <input type="range" [(ngModel)]="age" >
     *  ```
     */
    var RangeValueAccessor = /** @class */ (function () {
        function RangeValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) { };
            this.onTouched = function () { };
        }
        RangeValueAccessor.prototype.writeValue = function (value) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
        };
        RangeValueAccessor.prototype.registerOnChange = function (fn) {
            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
        };
        RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        RangeValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                        host: {
                            '(change)': 'onChange($event.target.value)',
                            '(input)': 'onChange($event.target.value)',
                            '(blur)': 'onTouched()'
                        },
                        providers: [RANGE_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        RangeValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef }
        ]; };
        return RangeValueAccessor;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var FormErrorExamples = {
        formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
        formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
        formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
        ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
        ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
    };

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var ReactiveErrors = /** @class */ (function () {
        function ReactiveErrors() {
        }
        ReactiveErrors.controlParentException = function () {
            throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
        };
        ReactiveErrors.ngModelGroupException = function () {
            throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
        };
        ReactiveErrors.missingFormException = function () {
            throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
        };
        ReactiveErrors.groupParentException = function () {
            throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
        };
        ReactiveErrors.arrayParentException = function () {
            throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
        };
        ReactiveErrors.disabledAttrWarning = function () {
            console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
        };
        ReactiveErrors.ngModelWarning = function (directiveName) {
            console.warn("\n    It looks like you're using ngModel on the same form field as " + directiveName + ". \n    Support for using the ngModel input property and ngModelChange event with \n    reactive form directives has been deprecated in Angular v6 and will be removed \n    in Angular v7.\n    \n    For more information on this, see our API docs here:\n    https://angular.io/api/forms/" + (directiveName === 'formControl' ? 'FormControlDirective'
                : 'FormControlName') + "#use-with-ngmodel\n    ");
        };
        return ReactiveErrors;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var SELECT_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return SelectControlValueAccessor; }),
        multi: true
    };
    function _buildValueString(id, value) {
        if (id == null)
            return "" + value;
        if (value && typeof value === 'object')
            value = 'Object';
        return (id + ": " + value).slice(0, 50);
    }
    function _extractId(valueString) {
        return valueString.split(':')[0];
    }
    /**
     * @description
     *
     * Writes values and listens to changes on a select element.
     *
     * Used by `NgModel`, `FormControlDirective`, and `FormControlName`
     * to keep the view synced with the `FormControl` model.
     *
     * If you have imported the `FormsModule` or the `ReactiveFormsModule`, this
     * value accessor will be active on any select control that has a form directive. You do
     * **not** need to add a special selector to activate it.
     *
     * ### How to use select controls with form directives
     *
     * To use a select in a template-driven form, simply add an `ngModel` and a `name`
     * attribute to the main `<select>` tag.
     *
     * If your option values are simple strings, you can bind to the normal `value` property
     * on the option.  If your option values happen to be objects (and you'd like to save the
     * selection in your form as an object), use `ngValue` instead:
     *
     * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
     *
     * In reactive forms, you'll also want to add your form directive (`formControlName` or
     * `formControl`) on the main `<select>` tag. Like in the former example, you have the
     * choice of binding to the  `value` or `ngValue` property on the select's options.
     *
     * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
     *
     * ### Caveat: Option selection
     *
     * Angular uses object identity to select option. It's possible for the identities of items
     * to change while the data does not. This can happen, for example, if the items are produced
     * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
     * second response will produce objects with different identities.
     *
     * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
     * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
     * If `compareWith` is given, Angular selects option by the return value of the function.
     *
     * #### Syntax
     *
     * ```
     * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
     *     <option *ngFor="let country of countries" [ngValue]="country">
     *         {{country.name}}
     *     </option>
     * </select>
     *
     * compareFn(c1: Country, c2: Country): boolean {
     *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
     * }
     * ```
     *
     * Note: We listen to the 'change' event because 'input' events aren't fired
     * for selects in Firefox and IE:
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
     * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
     *
     * * **npm package**: `@angular/forms`
     *
     *
     */
    var SelectControlValueAccessor = /** @class */ (function () {
        function SelectControlValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            /** @internal */
            this._optionMap = new Map();
            /** @internal */
            this._idCounter = 0;
            this.onChange = function (_) { };
            this.onTouched = function () { };
            this._compareWith = core.ɵlooseIdentical;
        }
        Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
            set: function (fn) {
                if (typeof fn !== 'function') {
                    throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
                }
                this._compareWith = fn;
            },
            enumerable: true,
            configurable: true
        });
        SelectControlValueAccessor.prototype.writeValue = function (value) {
            this.value = value;
            var id = this._getOptionId(value);
            if (id == null) {
                this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
            }
            var valueString = _buildValueString(id, value);
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
        };
        SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
            var _this = this;
            this.onChange = function (valueString) {
                _this.value = _this._getOptionValue(valueString);
                fn(_this.value);
            };
        };
        SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        /** @internal */
        SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
        /** @internal */
        SelectControlValueAccessor.prototype._getOptionId = function (value) {
            try {
                for (var _a = __values(Array.from(this._optionMap.keys())), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var id = _b.value;
                    if (this._compareWith(this._optionMap.get(id), value))
                        return id;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
            var e_1, _c;
        };
        /** @internal */
        SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
            var id = _extractId(valueString);
            return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
        };
        SelectControlValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                        host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                        providers: [SELECT_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        SelectControlValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef }
        ]; };
        SelectControlValueAccessor.propDecorators = {
            compareWith: [{ type: core.Input }]
        };
        return SelectControlValueAccessor;
    }());
    /**
     * @description
     *
     * Marks `<option>` as dynamic, so Angular can be notified when options change.
     *
     * See docs for `SelectControlValueAccessor` for usage examples.
     *
     *
     */
    var NgSelectOption = /** @class */ (function () {
        function NgSelectOption(_element, _renderer, _select) {
            this._element = _element;
            this._renderer = _renderer;
            this._select = _select;
            if (this._select)
                this.id = this._select._registerOption();
        }
        Object.defineProperty(NgSelectOption.prototype, "ngValue", {
            set: function (value) {
                if (this._select == null)
                    return;
                this._select._optionMap.set(this.id, value);
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgSelectOption.prototype, "value", {
            set: function (value) {
                this._setElementValue(value);
                if (this._select)
                    this._select.writeValue(this._select.value);
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        NgSelectOption.prototype._setElementValue = function (value) {
            this._renderer.setProperty(this._element.nativeElement, 'value', value);
        };
        NgSelectOption.prototype.ngOnDestroy = function () {
            if (this._select) {
                this._select._optionMap.delete(this.id);
                this._select.writeValue(this._select.value);
            }
        };
        NgSelectOption.decorators = [
            { type: core.Directive, args: [{ selector: 'option' },] }
        ];
        /** @nocollapse */
        NgSelectOption.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: core.Renderer2 },
            { type: SelectControlValueAccessor, decorators: [{ type: core.Optional }, { type: core.Host }] }
        ]; };
        NgSelectOption.propDecorators = {
            ngValue: [{ type: core.Input, args: ['ngValue',] }],
            value: [{ type: core.Input, args: ['value',] }]
        };
        return NgSelectOption;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var SELECT_MULTIPLE_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
        multi: true
    };
    function _buildValueString$1(id, value) {
        if (id == null)
            return "" + value;
        if (typeof value === 'string')
            value = "'" + value + "'";
        if (value && typeof value === 'object')
            value = 'Object';
        return (id + ": " + value).slice(0, 50);
    }
    function _extractId$1(valueString) {
        return valueString.split(':')[0];
    }
    /**
     * The accessor for writing a value and listening to changes on a select element.
     *
     *  ### Caveat: Options selection
     *
     * Angular uses object identity to select options. It's possible for the identities of items
     * to change while the data does not. This can happen, for example, if the items are produced
     * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
     * second response will produce objects with different identities.
     *
     * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
     * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
     * If `compareWith` is given, Angular selects options by the return value of the function.
     *
     * #### Syntax
     *
     * ```
     * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
     *     <option *ngFor="let country of countries" [ngValue]="country">
     *         {{country.name}}
     *     </option>
     * </select>
     *
     * compareFn(c1: Country, c2: Country): boolean {
     *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
     * }
     * ```
     *
     *
     */
    var SelectMultipleControlValueAccessor = /** @class */ (function () {
        function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            /** @internal */
            this._optionMap = new Map();
            /** @internal */
            this._idCounter = 0;
            this.onChange = function (_) { };
            this.onTouched = function () { };
            this._compareWith = core.ɵlooseIdentical;
        }
        Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
            set: function (fn) {
                if (typeof fn !== 'function') {
                    throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
                }
                this._compareWith = fn;
            },
            enumerable: true,
            configurable: true
        });
        SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
            var _this = this;
            this.value = value;
            var optionSelectedStateSetter;
            if (Array.isArray(value)) {
                // convert values to ids
                var ids_1 = value.map(function (v) { return _this._getOptionId(v); });
                optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
            }
            else {
                optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
            }
            this._optionMap.forEach(optionSelectedStateSetter);
        };
        SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
            var _this = this;
            this.onChange = function (_) {
                var selected = [];
                if (_.hasOwnProperty('selectedOptions')) {
                    var options = _.selectedOptions;
                    for (var i = 0; i < options.length; i++) {
                        var opt = options.item(i);
                        var val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
                else {
                    var options = _.options;
                    for (var i = 0; i < options.length; i++) {
                        var opt = options.item(i);
                        if (opt.selected) {
                            var val = _this._getOptionValue(opt.value);
                            selected.push(val);
                        }
                    }
                }
                _this.value = selected;
                fn(selected);
            };
        };
        SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
        SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
        };
        /** @internal */
        SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
            var id = (this._idCounter++).toString();
            this._optionMap.set(id, value);
            return id;
        };
        /** @internal */
        SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
            try {
                for (var _a = __values(Array.from(this._optionMap.keys())), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var id = _b.value;
                    if (this._compareWith(this._optionMap.get(id)._value, value))
                        return id;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
            var e_1, _c;
        };
        /** @internal */
        SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
            var id = _extractId$1(valueString);
            return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
        };
        SelectMultipleControlValueAccessor.decorators = [
            { type: core.Directive, args: [{
                        selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                        host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                        providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                    },] }
        ];
        /** @nocollapse */
        SelectMultipleControlValueAccessor.ctorParameters = function () { return [
            { type: core.Renderer2 },
            { type: core.ElementRef }
        ]; };
        SelectMultipleControlValueAccessor.propDecorators = {
            compareWith: [{ type: core.Input }]
        };
        return SelectMultipleControlValueAccessor;
    }());
    /**
     * Marks `<option>` as dynamic, so Angular can be notified when options change.
     *
     * ### Example
     *
     * ```
     * <select multiple name="city" ngModel>
     *   <option *ngFor="let c of cities" [value]="c"></option>
     * </select>
     * ```
     */
    var NgSelectMultipleOption = /** @class */ (function () {
        function NgSelectMultipleOption(_element, _renderer, _select) {
            this._element = _element;
            this._renderer = _renderer;
            this._select = _select;
            if (this._select) {
                this.id = this._select._registerOption(this);
            }
        }
        Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
            set: function (value) {
                if (this._select == null)
                    return;
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
            set: function (value) {
                if (this._select) {
                    this._value = value;
                    this._setElementValue(_buildValueString$1(this.id, value));
                    this._select.writeValue(this._select.value);
                }
                else {
                    this._setElementValue(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        NgSelectMultipleOption.prototype._setElementValue = function (value) {
            this._renderer.setProperty(this._element.nativeElement, 'value', value);
        };
        /** @internal */
        NgSelectMultipleOption.prototype._setSelected = function (selected) {
            this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
        };
        NgSelectMultipleOption.prototype.ngOnDestroy = function () {
            if (this._select) {
                this._select._optionMap.delete(this.id);
                this._select.writeValue(this._select.value);
            }
        };
        NgSelectMultipleOption.decorators = [
            { type: core.Directive, args: [{ selector: 'option' },] }
        ];
        /** @nocollapse */
        NgSelectMultipleOption.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: core.Renderer2 },
            { type: SelectMultipleControlValueAccessor, decorators: [{ type: core.Optional }, { type: core.Host }] }
        ]; };
        NgSelectMultipleOption.propDecorators = {
            ngValue: [{ type: core.Input, args: ['ngValue',] }],
            value: [{ type: core.Input, args: ['value',] }]
        };
        return NgSelectMultipleOption;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    function controlPath(name, parent) {
        return __spread(parent.path, [name]);
    }
    function setUpControl(control, dir) {
        if (!control)
            _throwError(dir, 'Cannot find control with');
        if (!dir.valueAccessor)
            _throwError(dir, 'No value accessor for form control with');
        control.validator = Validators.compose([control.validator, dir.validator]);
        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
        dir.valueAccessor.writeValue(control.value);
        setUpViewChangePipeline(control, dir);
        setUpModelChangePipeline(control, dir);
        setUpBlurPipeline(control, dir);
        if (dir.valueAccessor.setDisabledState) {
            control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
        }
        // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
        dir._rawValidators.forEach(function (validator) {
            if (validator.registerOnValidatorChange)
                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
        });
        dir._rawAsyncValidators.forEach(function (validator) {
            if (validator.registerOnValidatorChange)
                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
        });
    }
    function cleanUpControl(control, dir) {
        dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
        dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
        dir._rawValidators.forEach(function (validator) {
            if (validator.registerOnValidatorChange) {
                validator.registerOnValidatorChange(null);
            }
        });
        dir._rawAsyncValidators.forEach(function (validator) {
            if (validator.registerOnValidatorChange) {
                validator.registerOnValidatorChange(null);
            }
        });
        if (control)
            control._clearChangeFns();
    }
    function setUpViewChangePipeline(control, dir) {
        dir.valueAccessor.registerOnChange(function (newValue) {
            control._pendingValue = newValue;
            control._pendingChange = true;
            control._pendingDirty = true;
            if (control.updateOn === 'change')
                updateControl(control, dir);
        });
    }
    function setUpBlurPipeline(control, dir) {
        dir.valueAccessor.registerOnTouched(function () {
            control._pendingTouched = true;
            if (control.updateOn === 'blur' && control._pendingChange)
                updateControl(control, dir);
            if (control.updateOn !== 'submit')
                control.markAsTouched();
        });
    }
    function updateControl(control, dir) {
        if (control._pendingDirty)
            control.markAsDirty();
        control.setValue(control._pendingValue, { emitModelToViewChange: false });
        dir.viewToModelUpdate(control._pendingValue);
        control._pendingChange = false;
    }
    function setUpModelChangePipeline(control, dir) {
        control.registerOnChange(function (newValue, emitModelEvent) {
            // control -> view
            dir.valueAccessor.writeValue(newValue);
            // control -> ngModel
            if (emitModelEvent)
                dir.viewToModelUpdate(newValue);
        });
    }
    function setUpFormContainer(control, dir) {
        if (control == null)
            _throwError(dir, 'Cannot find control with');
        control.validator = Validators.compose([control.validator, dir.validator]);
        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
    }
    function _noControlError(dir) {
        return _throwError(dir, 'There is no FormControl instance attached to form control element with');
    }
    function _throwError(dir, message) {
        var messageEnd;
        if (dir.path.length > 1) {
            messageEnd = "path: '" + dir.path.join(' -> ') + "'";
        }
        else if (dir.path[0]) {
            messageEnd = "name: '" + dir.path + "'";
        }
        else {
            messageEnd = 'unspecified name attribute';
        }
        throw new Error(message + " " + messageEnd);
    }
    function composeValidators(validators) {
        return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
    }
    function composeAsyncValidators(validators) {
        return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
            null;
    }
    function isPropertyUpdated(changes, viewModel) {
        if (!changes.hasOwnProperty('model'))
            return false;
        var change = changes['model'];
        if (change.isFirstChange())
            return true;
        return !core.ɵlooseIdentical(viewModel, change.currentValue);
    }
    var BUILTIN_ACCESSORS = [
        CheckboxControlValueAccessor,
        RangeValueAccessor,
        NumberValueAccessor,
        SelectControlValueAccessor,
        SelectMultipleControlValueAccessor,
        RadioControlValueAccessor,
    ];
    function isBuiltInAccessor(valueAccessor) {
        return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
    }
    function syncPendingControls(form, directives) {
        form._syncPendingControls();
        directives.forEach(function (dir) {
            var control = dir.control;
            if (control.updateOn === 'submit' && control._pendingChange) {
                dir.viewToModelUpdate(control._pendingValue);
                control._pendingChange = false;
            }
        });
    }
    // TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
    function selectValueAccessor(dir, valueAccessors) {
        if (!valueAccessors)
            return null;
        if (!Array.isArray(valueAccessors))
            _throwError(dir, 'Value accessor was not provided as an array for form control with');
        var defaultAccessor = undefined;
        var builtinAccessor = undefined;
        var customAccessor = undefined;
        valueAccessors.forEach(function (v) {
            if (v.constructor === DefaultValueAccessor) {
                defaultAccessor = v;
            }
            else if (isBuiltInAccessor(v)) {
                if (builtinAccessor)
                    _throwError(dir, 'More than one built-in value accessor matches form control with');
                builtinAccessor = v;
            }
            else {
                if (customAccessor)
                    _throwError(dir, 'More than one custom value accessor matches form control with');
                customAccessor = v;
            }
        });
        if (customAccessor)
            return customAccessor;
        if (builtinAccessor)
            return builtinAccessor;
        if (defaultAccessor)
            return defaultAccessor;
        _throwError(dir, 'No valid value accessor for form control with');
        return null;
    }
    function removeDir(list, el) {
        var index = list.indexOf(el);
        if (index > -1)
            list.splice(index, 1);
    }
    // TODO(kara): remove after deprecation period
    function _ngModelWarning(name, type, instance, warningConfig) {
        if (!core.isDevMode() || warningConfig === 'never')
            return;
        if (((warningConfig === null || warningConfig === 'once') && !type._ngModelWarningSentOnce) ||
            (warningConfig === 'always' && !instance._ngModelWarningSent)) {
            ReactiveErrors.ngModelWarning(name);
            type._ngModelWarningSentOnce = true;
            instance._ngModelWarningSent = true;
        }
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * This is a base class for code shared between `NgModelGroup` and `FormGroupName`.
     *
     *
     */
    var AbstractFormGroupDirective = /** @class */ (function (_super) {
        __extends(AbstractFormGroupDirective, _super);
        function AbstractFormGroupDirective() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AbstractFormGroupDirective.prototype.ngOnInit = function () {
            this._checkParentType();
            this.formDirective.addFormGroup(this);
        };
        AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
            if (this.formDirective) {
                this.formDirective.removeFormGroup(this);
            }
        };
        Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
            /**
             * Get the `FormGroup` backing this binding.
             */
            get: function () { return this.formDirective.getFormGroup(this); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
            /**
             * Get the path to this control group.
             */
            get: function () { return controlPath(this.name, this._parent); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
            /**
             * Get the `Form` to which this group belongs.
             */
            get: function () { return this._parent ? this._parent.formDirective : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
            get: function () { return composeValidators(this._validators); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
            get: function () {
                return composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        AbstractFormGroupDirective.prototype._checkParentType = function () { };
        return AbstractFormGroupDirective;
    }(ControlContainer));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var AbstractControlStatus = /** @class */ (function () {
        function AbstractControlStatus(cd) {
            this._cd = cd;
        }
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
            get: function () { return this._cd.control ? this._cd.control.untouched : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
            get: function () { return this._cd.control ? this._cd.control.touched : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
            get: function () { return this._cd.control ? this._cd.control.pristine : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
            get: function () { return this._cd.control ? this._cd.control.dirty : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
            get: function () { return this._cd.control ? this._cd.control.valid : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
            get: function () { return this._cd.control ? this._cd.control.invalid : false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
            get: function () { return this._cd.control ? this._cd.control.pending : false; },
            enumerable: true,
            configurable: true
        });
        return AbstractControlStatus;
    }());
    var ngControlStatusHost = {
        '[class.ng-untouched]': 'ngClassUntouched',
        '[class.ng-touched]': 'ngClassTouched',
        '[class.ng-pristine]': 'ngClassPristine',
        '[class.ng-dirty]': 'ngClassDirty',
        '[class.ng-valid]': 'ngClassValid',
        '[class.ng-invalid]': 'ngClassInvalid',
        '[class.ng-pending]': 'ngClassPending',
    };
    /**
     * Directive automatically applied to Angular form controls that sets CSS classes
     * based on control status. The following classes are applied as the properties
     * become true:
     *
     * * ng-valid
     * * ng-invalid
     * * ng-pending
     * * ng-pristine
     * * ng-dirty
     * * ng-untouched
     * * ng-touched
     *
     *
     */
    var NgControlStatus = /** @class */ (function (_super) {
        __extends(NgControlStatus, _super);
        function NgControlStatus(cd) {
            return _super.call(this, cd) || this;
        }
        NgControlStatus.decorators = [
            { type: core.Directive, args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] }
        ];
        /** @nocollapse */
        NgControlStatus.ctorParameters = function () { return [
            { type: NgControl, decorators: [{ type: core.Self }] }
        ]; };
        return NgControlStatus;
    }(AbstractControlStatus));
    /**
     * Directive automatically applied to Angular form groups that sets CSS classes
     * based on control status (valid/invalid/dirty/etc).
     *
     *
     */
    var NgControlStatusGroup = /** @class */ (function (_super) {
        __extends(NgControlStatusGroup, _super);
        function NgControlStatusGroup(cd) {
            return _super.call(this, cd) || this;
        }
        NgControlStatusGroup.decorators = [
            { type: core.Directive, args: [{
                        selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                        host: ngControlStatusHost
                    },] }
        ];
        /** @nocollapse */
        NgControlStatusGroup.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Self }] }
        ]; };
        return NgControlStatusGroup;
    }(AbstractControlStatus));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Reports that a FormControl is valid, meaning that no errors exist in the input value.
     *
     * @see `status`
     */
    var VALID = 'VALID';
    /**
     * Reports that a FormControl is invalid, meaning that an error exists in the input value.
     *
     * @see `status`
     */
    var INVALID = 'INVALID';
    /**
     * Reports that a FormControl is pending, meaning that that async validation is occurring and
     * errors are not yet available for the input value.
     *
     * @see `markAsPending`
     * @see `status`
     */
    var PENDING = 'PENDING';
    /**
     * Reports that a FormControl is disabled, meaning that the control is exempt from ancestor
     * calculations of validity or value.
     *
     * @see `markAsDisabled`
     * @see `status`
     */
    var DISABLED = 'DISABLED';
    function _find(control, path, delimiter) {
        if (path == null)
            return null;
        if (!(path instanceof Array)) {
            path = path.split(delimiter);
        }
        if (path instanceof Array && (path.length === 0))
            return null;
        return path.reduce(function (v, name) {
            if (v instanceof FormGroup) {
                return v.controls.hasOwnProperty(name) ? v.controls[name] : null;
            }
            if (v instanceof FormArray) {
                return v.at(name) || null;
            }
            return null;
        }, control);
    }
    function coerceToValidator(validatorOrOpts) {
        var validator = (isOptionsObj(validatorOrOpts) ? validatorOrOpts.validators :
            validatorOrOpts);
        return Array.isArray(validator) ? composeValidators(validator) : validator || null;
    }
    function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
        var origAsyncValidator = (isOptionsObj(validatorOrOpts) ? validatorOrOpts.asyncValidators :
            asyncValidator);
        return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
            origAsyncValidator || null;
    }
    function isOptionsObj(validatorOrOpts) {
        return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
            typeof validatorOrOpts === 'object';
    }
    /**
     * This is the base class for `FormControl`, `FormGroup`, and `FormArray`.
     *
     * It provides some of the shared behavior that all controls and groups of controls have, like
     * running validators, calculating status, and resetting state. It also defines the properties
     * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
     * instantiated directly.
     *
     * @see [Forms Guide](/guide/forms)
     * @see [Reactive Forms Guide](/guide/reactive-forms)
     * @see [Dynamic Forms Guide](/guide/dynamic-form)
     *
     */
    var AbstractControl = /** @class */ (function () {
        /**
         * Initialize the AbstractControl instance.
         *
         * @param validator The function that determines the synchronous validity of this control.
         * @param asyncValidator The function that determines the asynchronous validity of this
         * control.
         */
        function AbstractControl(validator, asyncValidator) {
            this.validator = validator;
            this.asyncValidator = asyncValidator;
            /** @internal */
            this._onCollectionChange = function () { };
            /**
             * A control is `pristine` if the user has not yet changed
             * the value in the UI.
             *
             * @returns True if the user has not yet changed the value in the UI; compare `dirty`.
             * Programmatic changes to a control's value do not mark it dirty.
             */
            this.pristine = true;
            /**
             * True if the control is marked as `touched`.
             *
             * A control is marked `touched` once the user has triggered
             * a `blur` event on it.
             */
            this.touched = false;
            /** @internal */
            this._onDisabledChange = [];
        }
        Object.defineProperty(AbstractControl.prototype, "parent", {
            /**
             * The parent control.
             */
            get: function () { return this._parent; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "valid", {
            /**
             * A control is `valid` when its `status` is `VALID`.
             *
             * @see `status`
             *
             * @returns True if the control has passed all of its validation tests,
             * false otherwise.
             */
            get: function () { return this.status === VALID; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "invalid", {
            /**
             * A control is `invalid` when its `status` is `INVALID`.
             *
             * @see `status`
             *
             * @returns True if this control has failed one or more of its validation checks,
             * false otherwise.
             */
            get: function () { return this.status === INVALID; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "pending", {
            /**
             * A control is `pending` when its `status` is `PENDING`.
             *
             * @see `status`
             *
             * @returns True if this control is in the process of conducting a validation check,
             * false otherwise.
             */
            get: function () { return this.status == PENDING; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "disabled", {
            /**
             * A control is `disabled` when its `status` is `DISABLED`.
             *
             * @see `status`
             *
             * Disabled controls are exempt from validation checks and
             * are not included in the aggregate value of their ancestor
             * controls.
             *
             * @returns True if the control is disabled, false otherwise.
             */
            get: function () { return this.status === DISABLED; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "enabled", {
            /**
             * A control is `enabled` as long as its `status` is not `DISABLED`.
             *
             * @see `status`
             *
             * @returns True if the control has any status other than 'DISABLED',
             * false if the status is 'DISABLED'.
             *
             */
            get: function () { return this.status !== DISABLED; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "dirty", {
            /**
             * A control is `dirty` if the user has changed the value
             * in the UI.
             *
             * @returns True if the user has changed the value of this control in the UI; compare `pristine`.
             * Programmatic changes to a control's value do not mark it dirty.
             */
            get: function () { return !this.pristine; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "untouched", {
            /**
             * True if the control has not been marked as touched
             *
             * A control is `untouched` if the user has not yet triggered
             * a `blur` event on it.
             */
            get: function () { return !this.touched; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "updateOn", {
            /**
             * Reports the update strategy of the `AbstractControl` (meaning
             * the event on which the control updates itself).
             * Possible values: `'change'` | `'blur'` | `'submit'`
             * Default value: `'change'`
             */
            get: function () {
                return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets the synchronous validators that are active on this control.  Calling
         * this overwrites any existing sync validators.
         */
        AbstractControl.prototype.setValidators = function (newValidator) {
            this.validator = coerceToValidator(newValidator);
        };
        /**
         * Sets the async validators that are active on this control. Calling this
         * overwrites any existing async validators.
         */
        AbstractControl.prototype.setAsyncValidators = function (newValidator) {
            this.asyncValidator = coerceToAsyncValidator(newValidator);
        };
        /**
         * Empties out the sync validator list.
         */
        AbstractControl.prototype.clearValidators = function () { this.validator = null; };
        /**
         * Empties out the async validator list.
         */
        AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
        /**
         * Marks the control as `touched`. A control is touched by focus and
         * blur events that do not change the value; compare `markAsDirty`;
         *
         *  @param opts Configuration options that determine how the control propagates changes
         * and emits events events after marking is applied.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false.
         */
        AbstractControl.prototype.markAsTouched = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.touched = true;
            if (this._parent && !opts.onlySelf) {
                this._parent.markAsTouched(opts);
            }
        };
        /**
         * Marks the control as `untouched`.
         *
         * If the control has any children, also marks all children as `untouched`
         * and recalculates the `touched` status of all parent controls.
         *
         *  @param opts Configuration options that determine how the control propagates changes
         * and emits events after the marking is applied.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false.
         */
        AbstractControl.prototype.markAsUntouched = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.touched = false;
            this._pendingTouched = false;
            this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
            if (this._parent && !opts.onlySelf) {
                this._parent._updateTouched(opts);
            }
        };
        /**
         * Marks the control as `dirty`. A control becomes dirty when
         * the control's is changed through the UI; compare `markAsTouched`.
         *
         *  @param opts Configuration options that determine how the control propagates changes
         * and emits events after marking is applied.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false.
         */
        AbstractControl.prototype.markAsDirty = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.pristine = false;
            if (this._parent && !opts.onlySelf) {
                this._parent.markAsDirty(opts);
            }
        };
        /**
         * Marks the control as `pristine`.
         *
         * If the control has any children, marks all children as `pristine`,
         * and recalculates the `pristine` status of all parent
         * controls.
         *
         *  @param opts Configuration options that determine how the control emits events after
         * marking is applied.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false..
         */
        AbstractControl.prototype.markAsPristine = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.pristine = true;
            this._pendingDirty = false;
            this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
            if (this._parent && !opts.onlySelf) {
                this._parent._updatePristine(opts);
            }
        };
        /**
         * Marks the control as `pending`.
         *
         * A control is pending while the control performs async validation.
         *
         *  @param opts Configuration options that determine how the control propagates changes and
         * emits events after marking is applied.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false..
         * * `emitEvent`: When true or not supplied (the default), the `statusChanges`
         * observable emits an event with the latest status the control is marked pending.
         * When false, no events are emitted.
         *
         */
        AbstractControl.prototype.markAsPending = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.status = PENDING;
            if (opts.emitEvent !== false) {
                this.statusChanges.emit(this.status);
            }
            if (this._parent && !opts.onlySelf) {
                this._parent.markAsPending(opts);
            }
        };
        /**
         * Disables the control. This means the control is exempt from validation checks and
         * excluded from the aggregate value of any parent. Its status is `DISABLED`.
         *
         * If the control has children, all children are also disabled.
         *
         *  @param opts Configuration options that determine how the control propagates
         * changes and emits events after the control is disabled.
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false..
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is disabled.
         * When false, no events are emitted.
         */
        AbstractControl.prototype.disable = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.status = DISABLED;
            this.errors = null;
            this._forEachChild(function (control) { control.disable(__assign({}, opts, { onlySelf: true })); });
            this._updateValue();
            if (opts.emitEvent !== false) {
                this.valueChanges.emit(this.value);
                this.statusChanges.emit(this.status);
            }
            this._updateAncestors(opts);
            this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
        };
        /**
         * Enables the control. This means the control is included in validation checks and
         * the aggregate value of its parent. Its status recalculates based on its value and
         * its validators.
         *
         * By default, if the control has children, all children are enabled.
         *
         *  @param opts Configure options that control how the control propagates changes and
         * emits events when marked as untouched
         * * `onlySelf`: When true, mark only this control. When false or not supplied,
         * marks all direct ancestors. Default is false..
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is enabled.
         * When false, no events are emitted.
         */
        AbstractControl.prototype.enable = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.status = VALID;
            this._forEachChild(function (control) { control.enable(__assign({}, opts, { onlySelf: true })); });
            this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
            this._updateAncestors(opts);
            this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
        };
        AbstractControl.prototype._updateAncestors = function (opts) {
            if (this._parent && !opts.onlySelf) {
                this._parent.updateValueAndValidity(opts);
                this._parent._updatePristine();
                this._parent._updateTouched();
            }
        };
        /**
         * @param parent Sets the parent of the control
         */
        AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
        /**
         * Recalculates the value and validation status of the control.
         *
         * By default, it also updates the value and validity of its ancestors.
         *
         * @param opts Configuration options determine how the control propagates changes and emits events
         * after updates and validity checks are applied.
         * * `onlySelf`: When true, only update this control. When false or not supplied,
         * update all direct ancestors. Default is false..
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is updated.
         * When false, no events are emitted.
         */
        AbstractControl.prototype.updateValueAndValidity = function (opts) {
            if (opts === void 0) { opts = {}; }
            this._setInitialStatus();
            this._updateValue();
            if (this.enabled) {
                this._cancelExistingSubscription();
                this.errors = this._runValidator();
                this.status = this._calculateStatus();
                if (this.status === VALID || this.status === PENDING) {
                    this._runAsyncValidator(opts.emitEvent);
                }
            }
            if (opts.emitEvent !== false) {
                this.valueChanges.emit(this.value);
                this.statusChanges.emit(this.status);
            }
            if (this._parent && !opts.onlySelf) {
                this._parent.updateValueAndValidity(opts);
            }
        };
        /** @internal */
        AbstractControl.prototype._updateTreeValidity = function (opts) {
            if (opts === void 0) { opts = { emitEvent: true }; }
            this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
            this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
        };
        AbstractControl.prototype._setInitialStatus = function () {
            this.status = this._allControlsDisabled() ? DISABLED : VALID;
        };
        AbstractControl.prototype._runValidator = function () {
            return this.validator ? this.validator(this) : null;
        };
        AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
            var _this = this;
            if (this.asyncValidator) {
                this.status = PENDING;
                var obs = toObservable(this.asyncValidator(this));
                this._asyncValidationSubscription =
                    obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
            }
        };
        AbstractControl.prototype._cancelExistingSubscription = function () {
            if (this._asyncValidationSubscription) {
                this._asyncValidationSubscription.unsubscribe();
            }
        };
        /**
         * Sets errors on a form control when running validations manually, rather than automatically.
         *
         * Calling `setErrors` also updates the validity of the parent control.
         *
         * ### Manually set the errors for a control
         *
         * ```
         * const login = new FormControl('someLogin');
         * login.setErrors({
         *   notUnique: true
         * });
         *
         * expect(login.valid).toEqual(false);
         * expect(login.errors).toEqual({ notUnique: true });
         *
         * login.setValue('someOtherLogin');
         *
         * expect(login.valid).toEqual(true);
         * ```
         */
        AbstractControl.prototype.setErrors = function (errors, opts) {
            if (opts === void 0) { opts = {}; }
            this.errors = errors;
            this._updateControlsErrors(opts.emitEvent !== false);
        };
        /**
         * Retrieves a child control given the control's name or path.
         *
         * @param path A dot-delimited string or array of string/number values that define the path to the
         * control.
         *
         * ### Retrieve a nested control
         *
         * For example, to get a `name` control nested within a `person` sub-group:
         *
         * * `this.form.get('person.name');`
         *
         * -OR-
         *
         * * `this.form.get(['person', 'name']);`
         */
        AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
        /**
         * Reports error data for a specific error occurring in this control or in another control.
         *
         * @param errorCode The error code for which to retrieve data
         * @param path The path to a control to check. If not supplied, checks for the error in this
         * control.
         *
         * @returns The error data if the control with the given path has the given error, otherwise null
         * or undefined.
         */
        AbstractControl.prototype.getError = function (errorCode, path) {
            var control = path ? this.get(path) : this;
            return control && control.errors ? control.errors[errorCode] : null;
        };
        /**
         * Reports whether the control with the given path has the error specified.
         *
         * @param errorCode The error code for which to retrieve data
         * @param path The path to a control to check. If not supplied, checks for the error in this
         * control.
         * @returns True when the control with the given path has the error, otherwise false.
         */
        AbstractControl.prototype.hasError = function (errorCode, path) { return !!this.getError(errorCode, path); };
        Object.defineProperty(AbstractControl.prototype, "root", {
            /**
             * Retrieves the top-level ancestor of this control.
             */
            get: function () {
                var x = this;
                while (x._parent) {
                    x = x._parent;
                }
                return x;
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
            this.status = this._calculateStatus();
            if (emitEvent) {
                this.statusChanges.emit(this.status);
            }
            if (this._parent) {
                this._parent._updateControlsErrors(emitEvent);
            }
        };
        /** @internal */
        AbstractControl.prototype._initObservables = function () {
            this.valueChanges = new core.EventEmitter();
            this.statusChanges = new core.EventEmitter();
        };
        AbstractControl.prototype._calculateStatus = function () {
            if (this._allControlsDisabled())
                return DISABLED;
            if (this.errors)
                return INVALID;
            if (this._anyControlsHaveStatus(PENDING))
                return PENDING;
            if (this._anyControlsHaveStatus(INVALID))
                return INVALID;
            return VALID;
        };
        /** @internal */
        AbstractControl.prototype._anyControlsHaveStatus = function (status) {
            return this._anyControls(function (control) { return control.status === status; });
        };
        /** @internal */
        AbstractControl.prototype._anyControlsDirty = function () {
            return this._anyControls(function (control) { return control.dirty; });
        };
        /** @internal */
        AbstractControl.prototype._anyControlsTouched = function () {
            return this._anyControls(function (control) { return control.touched; });
        };
        /** @internal */
        AbstractControl.prototype._updatePristine = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.pristine = !this._anyControlsDirty();
            if (this._parent && !opts.onlySelf) {
                this._parent._updatePristine(opts);
            }
        };
        /** @internal */
        AbstractControl.prototype._updateTouched = function (opts) {
            if (opts === void 0) { opts = {}; }
            this.touched = this._anyControlsTouched();
            if (this._parent && !opts.onlySelf) {
                this._parent._updateTouched(opts);
            }
        };
        /** @internal */
        AbstractControl.prototype._isBoxedValue = function (formState) {
            return typeof formState === 'object' && formState !== null &&
                Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
        };
        /** @internal */
        AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
        /** @internal */
        AbstractControl.prototype._setUpdateStrategy = function (opts) {
            if (isOptionsObj(opts) && opts.updateOn != null) {
                this._updateOn = opts.updateOn;
            }
        };
        return AbstractControl;
    }());
    /**
     * Tracks the value and validation status of an individual form control.
     *
     * This is one of the three fundamental building blocks of Angular forms, along with
     * `FormGroup` and `FormArray`. It extends the `AbstractControl` class that
     * implements most of the base functionality for accessing the value, validation status,
     * user interactions and events.
     *
     * @see `AbstractControl`
     * @see [Reactive Forms Guide](guide/reactive-forms)
     * @see [Usage Notes](#usage-notes)
     *
     * @usageNotes
     *
     * ### Initializing Form Controls
     *
     * Instantiate a `FormControl`, with an initial value.
     *
     * ```ts
     * const ctrl = new FormControl('some value');
     * console.log(ctrl.value);     // 'some value'
     *```
     *
     * The following example initializes the control with a form state object. The `value`
     * and `disabled` keys are required in this case.
     *
     * ```ts
     * const ctrl = new FormControl({ value: 'n/a', disabled: true });
     * console.log(ctrl.value);     // 'n/a'
     * console.log(ctrl.status);    // 'DISABLED'
     * ```
     *
     * The following example initializes the control with a sync validator.
     *
     * ```ts
     * const ctrl = new FormControl('', Validators.required);
     * console.log(ctrl.value);      // ''
     * console.log(ctrl.status);     // 'INVALID'
     * ```
     *
     * The following example initializes the control using an options object.
     *
     * ```ts
     * const ctrl = new FormControl('', {
     *    validators: Validators.required,
     *    asyncValidators: myAsyncValidator
     * });
     * ```
     *
     * ### Configure the control to update on a blur event
     *
     * Set the `updateOn` option to `'blur'` to update on the blur `event`.
     *
     * ```ts
     * const ctrl = new FormControl('', { updateOn: 'blur' });
     * ```
     *
     * ### Configure the control to update on a submit event
     *
     * Set the `updateOn` option to `'submit'` to update on a submit `event`.
     *
     * ```ts
     * const ctrl = new FormControl('', { updateOn: 'submit' });
     * ```
     *
     * ### Reset the control back to an initial value
     *
     * You reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * ```ts
     * const ctrl = new FormControl('Nancy');
     *
     * console.log(control.value); // 'Nancy'
     *
     * control.reset('Drew');
     *
     * console.log(control.value); // 'Drew'
     * ```
     *
     * ### Reset the control back to an initial value and disabled
     *
     * ```
     * const ctrl = new FormControl('Nancy');
     *
     * console.log(control.value); // 'Nancy'
     * console.log(this.control.status); // 'DISABLED'
     *
     * control.reset({ value: 'Drew', disabled: true });
     *
     * console.log(this.control.value); // 'Drew'
     * console.log(this.control.status); // 'DISABLED'
     *
    */
    var FormControl = /** @class */ (function (_super) {
        __extends(FormControl, _super);
        /**
        * Creates a new `FormControl` instance.
        *
        * @param formState Initializes the control with an initial state value,
        * or with an object that defines the initial value, status, and options
        * for handling updates and validation.
        *
        * @param validatorOrOpts A synchronous validator function, or an array of
        * such functions, or an `AbstractControlOptions` object that contains validation functions
        * and a validation trigger.
        *
        * @param asyncValidator A single async validator or array of async validator functions
        *
        */
        function FormControl(formState, validatorOrOpts, asyncValidator) {
            if (formState === void 0) { formState = null; }
            var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
            /** @internal */
            _this._onChange = [];
            _this._applyFormState(formState);
            _this._setUpdateStrategy(validatorOrOpts);
            _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            _this._initObservables();
            return _this;
        }
        /**
         * Sets a new value for the form control.
         *
         * @param value The new value for the control.
         * @param options Configuration options that determine how the control proopagates changes
         * and emits events when the value changes.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
         * false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control value is updated.
         * When false, no events are emitted.
         * * `emitModelToViewChange`: When true or not supplied  (the default), each change triggers an
         * `onChange` event to
         * update the view.
         * * `emitViewToModelChange`: When true or not supplied (the default), each change triggers an
         * `ngModelChange`
         * event to update the model.
         *
         */
        FormControl.prototype.setValue = function (value, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            this.value = this._pendingValue = value;
            if (this._onChange.length && options.emitModelToViewChange !== false) {
                this._onChange.forEach(function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); });
            }
            this.updateValueAndValidity(options);
        };
        /**
         * Patches the value of a control.
         *
         * This function is functionally the same as {@link FormControl#setValue setValue} at this level.
         * It exists for symmetry with {@link FormGroup#patchValue patchValue} on `FormGroups` and
         * `FormArrays`, where it does behave differently.
         *
         * @see `setValue` for options
         */
        FormControl.prototype.patchValue = function (value, options) {
            if (options === void 0) { options = {}; }
            this.setValue(value, options);
        };
        /**
         * Resets the form control, marking it `pristine` and `untouched`, and setting
         * the value to null.
         *
         * @param formState Initializes the control with an initial state value,
         * or with an object that defines the initial value, status, and options
         * for handling updates and validation.
         *
         * @param options Configuration options that determine how the control propagates changes
         * and emits events after the value changes.
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
         * false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is reset.
         * When false, no events are emitted.
         *
         */
        FormControl.prototype.reset = function (formState, options) {
            if (formState === void 0) { formState = null; }
            if (options === void 0) { options = {}; }
            this._applyFormState(formState);
            this.markAsPristine(options);
            this.markAsUntouched(options);
            this.setValue(this.value, options);
            this._pendingChange = false;
        };
        /**
         * @internal
         */
        FormControl.prototype._updateValue = function () { };
        /**
         * @internal
         */
        FormControl.prototype._anyControls = function (condition) { return false; };
        /**
         * @internal
         */
        FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
        /**
         * Register a listener for change events.
         *
         * @param fn The method that is called when the value changes
         */
        FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
        /**
         * @internal
         */
        FormControl.prototype._clearChangeFns = function () {
            this._onChange = [];
            this._onDisabledChange = [];
            this._onCollectionChange = function () { };
        };
        /**
         * Register a listener for disabled events.
         *
         * @param fn The method that is called when the disabled status changes.
         */
        FormControl.prototype.registerOnDisabledChange = function (fn) {
            this._onDisabledChange.push(fn);
        };
        /**
         * @internal
         */
        FormControl.prototype._forEachChild = function (cb) { };
        /** @internal */
        FormControl.prototype._syncPendingControls = function () {
            if (this.updateOn === 'submit') {
                if (this._pendingDirty)
                    this.markAsDirty();
                if (this._pendingTouched)
                    this.markAsTouched();
                if (this._pendingChange) {
                    this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
                    return true;
                }
            }
            return false;
        };
        FormControl.prototype._applyFormState = function (formState) {
            if (this._isBoxedValue(formState)) {
                this.value = this._pendingValue = formState.value;
                formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                    this.enable({ onlySelf: true, emitEvent: false });
            }
            else {
                this.value = this._pendingValue = formState;
            }
        };
        return FormControl;
    }(AbstractControl));
    /**
     * Tracks the value and validity state of a group of `FormControl` instances.
     *
     * A `FormGroup` aggregates the values of each child `FormControl` into one object,
     * with each control name as the key.  It calculates its status by reducing the status values
     * of its children. For example, if one of the controls in a group is invalid, the entire
     * group becomes invalid.
     *
     * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
     * along with `FormControl` and `FormArray`.
     *
     * When instantiating a `FormGroup`, pass in a collection of child controls as the first
     * argument. The key for each child registers the name for the control.
     *
     * @usageNotes
     *
     * ### Create a form group with 2 controls
     *
     * ```
     * const form = new FormGroup({
     *   first: new FormControl('Nancy', Validators.minLength(2)),
     *   last: new FormControl('Drew'),
     * });
     *
     * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
     * console.log(form.status);  // 'VALID'
     * ```
     *
     * ### Create a form group with a group-level validator
     *
     * You include group-level validators as the second arg, or group-level async
     * validators as the third arg. These come in handy when you want to perform validation
     * that considers the value of more than one child control.
     *
     * ```
     * const form = new FormGroup({
     *   password: new FormControl('', Validators.minLength(2)),
     *   passwordConfirm: new FormControl('', Validators.minLength(2)),
     * }, passwordMatchValidator);
     *
     *
     * function passwordMatchValidator(g: FormGroup) {
     *    return g.get('password').value === g.get('passwordConfirm').value
     *       ? null : {'mismatch': true};
     * }
     * ```
     *
     * Like `FormControl` instances, you choose to pass in
     * validators and async validators as part of an options object.
     *
     * ```
     * const form = new FormGroup({
     *   password: new FormControl('')
     *   passwordConfirm: new FormControl('')
     * }, { validators: passwordMatchValidator, asyncValidators: otherValidator });
     * ```
     *
     * ### Set the updateOn property for all controls in a form group
     *
     * The options object is used to set a default value for each child
     * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
     * group level, all child controls default to 'blur', unless the child
     * has explicitly specified a different `updateOn` value.
     *
     * ```ts
     * const c = new FormGroup({
     *   one: new FormControl()
     * }, { updateOn: 'blur' });
     * ```
     */
    var FormGroup = /** @class */ (function (_super) {
        __extends(FormGroup, _super);
        /**
        * Creates a new `FormGroup` instance.
        *
        * @param controls A collection of child controls. The key for each child is the name
        * under which it is registered.
        *
        * @param validatorOrOpts A synchronous validator function, or an array of
        * such functions, or an `AbstractControlOptions` object that contains validation functions
        * and a validation trigger.
        *
        * @param asyncValidator A single async validator or array of async validator functions
        *
        */
        function FormGroup(controls, validatorOrOpts, asyncValidator) {
            var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
            _this.controls = controls;
            _this._initObservables();
            _this._setUpdateStrategy(validatorOrOpts);
            _this._setUpControls();
            _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            return _this;
        }
        /**
         * Registers a control with the group's list of controls.
         *
         * This method does not update the value or validity of the control.
         * Use {@link FormGroup#addControl addControl} instead.
         *
         * @param name The control name to register in the collection
         * @param control Provides the control for the given name
         */
        FormGroup.prototype.registerControl = function (name, control) {
            if (this.controls[name])
                return this.controls[name];
            this.controls[name] = control;
            control.setParent(this);
            control._registerOnCollectionChange(this._onCollectionChange);
            return control;
        };
        /**
         * Add a control to this group.
         *
         * This method also updates the value and validity of the control.
         *
         * @param name The control name to add to the collection
         * @param control Provides the control for the given name
         */
        FormGroup.prototype.addControl = function (name, control) {
            this.registerControl(name, control);
            this.updateValueAndValidity();
            this._onCollectionChange();
        };
        /**
         * Remove a control from this group.
         *
         * @param name The control name to remove from the collection
         */
        FormGroup.prototype.removeControl = function (name) {
            if (this.controls[name])
                this.controls[name]._registerOnCollectionChange(function () { });
            delete (this.controls[name]);
            this.updateValueAndValidity();
            this._onCollectionChange();
        };
        /**
         * Replace an existing control.
         *
         * @param name The control name to replace in the collection
         * @param control Provides the control for the given name
         */
        FormGroup.prototype.setControl = function (name, control) {
            if (this.controls[name])
                this.controls[name]._registerOnCollectionChange(function () { });
            delete (this.controls[name]);
            if (control)
                this.registerControl(name, control);
            this.updateValueAndValidity();
            this._onCollectionChange();
        };
        /**
         * Check whether there is an enabled control with the given name in the group.
         *
         * Reports false for disabled controls. If you'd like to check for existence in the group
         * only, use {@link AbstractControl#get get} instead.
         *
         * @param name The control name to check for existence in the collection
         *
         * @returns false for disabled controls, true otherwise.
         */
        FormGroup.prototype.contains = function (controlName) {
            return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
        };
        /**
         * Sets the value of the `FormGroup`. It accepts an object that matches
         * the structure of the group, with control names as keys.
         *
         * ### Set the complete value for the form group
         *
         * ```
         * const form = new FormGroup({
         *   first: new FormControl(),
         *   last: new FormControl()
         * });
         *
         * console.log(form.value);   // {first: null, last: null}
         *
         * form.setValue({first: 'Nancy', last: 'Drew'});
         * console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
         *
         * ```
         * @throws When strict checks fail, such as setting the value of a control
         * that doesn't exist or if you excluding the value of a control.
         *
         * @param value The new value for the control that matches the structure of the group.
         * @param options Configuration options that determine how the control propagates changes
         * and emits events after the value changes.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
         * false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control value is updated.
         * When false, no events are emitted.
         */
        FormGroup.prototype.setValue = function (value, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            this._checkAllValuesPresent(value);
            Object.keys(value).forEach(function (name) {
                _this._throwIfControlMissing(name);
                _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            });
            this.updateValueAndValidity(options);
        };
        /**
         * Patches the value of the `FormGroup`. It accepts an object with control
         * names as keys, and does its best to match the values to the correct controls
         * in the group.
         *
         * It accepts both super-sets and sub-sets of the group without throwing an error.
         *
         * ### Patch the value for a form group
         *
         *  ```
         *  const form = new FormGroup({
         *     first: new FormControl(),
         *     last: new FormControl()
         *  });
         *  console.log(form.value);   // {first: null, last: null}
         *
         *  form.patchValue({first: 'Nancy'});
         *  console.log(form.value);   // {first: 'Nancy', last: null}
         *
         *  ```
         *
         * @param value The object that matches the structure of the group
         * @param options Configure options that determines how the control propagates changes and
         * emits events after the value is patched
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
         * true.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control value is updated.
         * When false, no events are emitted.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         */
        FormGroup.prototype.patchValue = function (value, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            Object.keys(value).forEach(function (name) {
                if (_this.controls[name]) {
                    _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
                }
            });
            this.updateValueAndValidity(options);
        };
        /**
         * Resets the `FormGroup`, marks all descendants are marked `pristine` and `untouched`, and
         * the value of all descendants to null.
         *
         * You reset to a specific form state by passing in a map of states
         * that matches the structure of your form, with control names as keys. The state
         * is a standalone value or a form state object with both a value and a disabled
         * status.
         *
         * @param value Initializes the control with an initial state value,
         * or with an object that defines the initial value, status,
         * and options for handling updates and validation.
         *
         * @param options Configuration options that determine how the control propagates changes
         * and emits events when the group is reset.
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
         * false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is reset.
         * When false, no events are emitted.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         *
         * @usageNotes
         *
         * ### Reset the form group values
         *
         * ```ts
         * const form = new FormGroup({
         *   first: new FormControl('first name'),
         *   last: new FormControl('last name')
         * });
         *
         * console.log(form.value);  // {first: 'first name', last: 'last name'}
         *
         * form.reset({ first: 'name', last: 'last name' });
         *
         * console.log(form.value);  // {first: 'name', last: 'last name'}
         * ```
         *
         * ### Reset the form group values and disabled status
         *
         * ```
         * const form = new FormGroup({
         *   first: new FormControl('first name'),
         *   last: new FormControl('last name')
         * });
         *
         * form.reset({
         *   first: {value: 'name', disabled: true},
         *   last: 'last'
         * });
         *
         * console.log(this.form.value);  // {first: 'name', last: 'last name'}
         * console.log(this.form.get('first').status);  // 'DISABLED'
         * ```
         */
        FormGroup.prototype.reset = function (value, options) {
            if (value === void 0) { value = {}; }
            if (options === void 0) { options = {}; }
            this._forEachChild(function (control, name) {
                control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            });
            this.updateValueAndValidity(options);
            this._updatePristine(options);
            this._updateTouched(options);
        };
        /**
         * The aggregate value of the `FormGroup`, including any disabled controls.
         *
         * Retrieves all values regardless of disabled status.
         * The `value` property is the best way to get the value of the group, because
         * it excludes disabled controls in the `FormGroup`.
         */
        FormGroup.prototype.getRawValue = function () {
            return this._reduceChildren({}, function (acc, control, name) {
                acc[name] = control instanceof FormControl ? control.value : control.getRawValue();
                return acc;
            });
        };
        /** @internal */
        FormGroup.prototype._syncPendingControls = function () {
            var subtreeUpdated = this._reduceChildren(false, function (updated, child) {
                return child._syncPendingControls() ? true : updated;
            });
            if (subtreeUpdated)
                this.updateValueAndValidity({ onlySelf: true });
            return subtreeUpdated;
        };
        /** @internal */
        FormGroup.prototype._throwIfControlMissing = function (name) {
            if (!Object.keys(this.controls).length) {
                throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
            }
            if (!this.controls[name]) {
                throw new Error("Cannot find form control with name: " + name + ".");
            }
        };
        /** @internal */
        FormGroup.prototype._forEachChild = function (cb) {
            var _this = this;
            Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
        };
        /** @internal */
        FormGroup.prototype._setUpControls = function () {
            var _this = this;
            this._forEachChild(function (control) {
                control.setParent(_this);
                control._registerOnCollectionChange(_this._onCollectionChange);
            });
        };
        /** @internal */
        FormGroup.prototype._updateValue = function () { this.value = this._reduceValue(); };
        /** @internal */
        FormGroup.prototype._anyControls = function (condition) {
            var _this = this;
            var res = false;
            this._forEachChild(function (control, name) {
                res = res || (_this.contains(name) && condition(control));
            });
            return res;
        };
        /** @internal */
        FormGroup.prototype._reduceValue = function () {
            var _this = this;
            return this._reduceChildren({}, function (acc, control, name) {
                if (control.enabled || _this.disabled) {
                    acc[name] = control.value;
                }
                return acc;
            });
        };
        /** @internal */
        FormGroup.prototype._reduceChildren = function (initValue, fn) {
            var res = initValue;
            this._forEachChild(function (control, name) { res = fn(res, control, name); });
            return res;
        };
        /** @internal */
        FormGroup.prototype._allControlsDisabled = function () {
            try {
                for (var _a = __values(Object.keys(this.controls)), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var controlName = _b.value;
                    if (this.controls[controlName].enabled) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return Object.keys(this.controls).length > 0 || this.disabled;
            var e_1, _c;
        };
        /** @internal */
        FormGroup.prototype._checkAllValuesPresent = function (value) {
            this._forEachChild(function (control, name) {
                if (value[name] === undefined) {
                    throw new Error("Must supply a value for form control with name: '" + name + "'.");
                }
            });
        };
        return FormGroup;
    }(AbstractControl));
    /**
     * Tracks the value and validity state of an array of `FormControl`,
     * `FormGroup` or `FormArray` instances.
     *
     * A `FormArray` aggregates the values of each child `FormControl` into an array.
     * It calculates its status by reducing the status values of its children. For example, if one of
     * the controls in a `FormArray` is invalid, the entire array becomes invalid.
     *
     * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
     * along with `FormControl` and `FormGroup`.
     *
     * @usageNotes
     *
     * ### Create an array of form controls
     *
     * ```
     * const arr = new FormArray([
     *   new FormControl('Nancy', Validators.minLength(2)),
     *   new FormControl('Drew'),
     * ]);
     *
     * console.log(arr.value);   // ['Nancy', 'Drew']
     * console.log(arr.status);  // 'VALID'
     * ```
     *
     * ### Create a form array with array-level validators
     *
     * You include array-level validators and async validators. These come in handy
     * when you want to perform validation that considers the value of more than one child
     * control.
     *
     * The two types of validators are passed in separately as the second and third arg
     * respectively, or together as part of an options object.
     *
     * ```
     * const arr = new FormArray([
     *   new FormControl('Nancy'),
     *   new FormControl('Drew')
     * ], {validators: myValidator, asyncValidators: myAsyncValidator});
     * ```
     *
      * ### Set the updateOn property for all controls in a form array
     *
     * The options object is used to set a default value for each child
     * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
     * array level, all child controls default to 'blur', unless the child
     * has explicitly specified a different `updateOn` value.
     *
     * ```ts
     * const arr = new FormArray([
     *    new FormControl()
     * ], {updateOn: 'blur'});
     * ```
     *
     * ### Adding or removing controls from a form array
     *
     * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
     * in `FormArray` itself. These methods ensure the controls are properly tracked in the
     * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
     * the `FormArray` directly, as that result in strange and unexpected behavior such
     * as broken change detection.
     *
     *
     */
    var FormArray = /** @class */ (function (_super) {
        __extends(FormArray, _super);
        /**
        * Creates a new `FormArray` instance.
        *
        * @param controls An array of child controls. Each child control is given an index
        * wheh it is registered.
        *
        * @param validatorOrOpts A synchronous validator function, or an array of
        * such functions, or an `AbstractControlOptions` object that contains validation functions
        * and a validation trigger.
        *
        * @param asyncValidator A single async validator or array of async validator functions
        *
        */
        function FormArray(controls, validatorOrOpts, asyncValidator) {
            var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
            _this.controls = controls;
            _this._initObservables();
            _this._setUpdateStrategy(validatorOrOpts);
            _this._setUpControls();
            _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            return _this;
        }
        /**
         * Get the `AbstractControl` at the given `index` in the array.
         *
         * @param index Index in the array to retrieve the control
         */
        FormArray.prototype.at = function (index) { return this.controls[index]; };
        /**
         * Insert a new `AbstractControl` at the end of the array.
         *
         * @param control Form control to be inserted
         */
        FormArray.prototype.push = function (control) {
            this.controls.push(control);
            this._registerControl(control);
            this.updateValueAndValidity();
            this._onCollectionChange();
        };
        /**
         * Insert a new `AbstractControl` at the given `index` in the array.
         *
         * @param index Index in the array to insert the control
         * @param control Form control to be inserted
         */
        FormArray.prototype.insert = function (index, control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
            this.updateValueAndValidity();
        };
        /**
         * Remove the control at the given `index` in the array.
         *
         * @param index Index in the array to remove the control
         */
        FormArray.prototype.removeAt = function (index) {
            if (this.controls[index])
                this.controls[index]._registerOnCollectionChange(function () { });
            this.controls.splice(index, 1);
            this.updateValueAndValidity();
        };
        /**
         * Replace an existing control.
         *
         * @param index Index in the array to replace the control
         * @param control The `AbstractControl` control to replace the existing control
         */
        FormArray.prototype.setControl = function (index, control) {
            if (this.controls[index])
                this.controls[index]._registerOnCollectionChange(function () { });
            this.controls.splice(index, 1);
            if (control) {
                this.controls.splice(index, 0, control);
                this._registerControl(control);
            }
            this.updateValueAndValidity();
            this._onCollectionChange();
        };
        Object.defineProperty(FormArray.prototype, "length", {
            /**
             * Length of the control array.
             */
            get: function () { return this.controls.length; },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets the value of the `FormArray`. It accepts an array that matches
         * the structure of the control.
         *
         * This method performs strict checks, and throws an error if you try
         * to set the value of a control that doesn't exist or if you exclude the
         * value of a control.
         *
         * ### Set the values for the controls in the form array
         *
         * ```
         * const arr = new FormArray([
         *   new FormControl(),
         *   new FormControl()
         * ]);
         * console.log(arr.value);   // [null, null]
         *
         * arr.setValue(['Nancy', 'Drew']);
         * console.log(arr.value);   // ['Nancy', 'Drew']
         * ```
         *
         * @param value Array of values for the controls
         * @param options Configure options that determine how the control propagates changes and
         * emits events after the value changes
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
         * is false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control value is updated.
         * When false, no events are emitted.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         */
        FormArray.prototype.setValue = function (value, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            this._checkAllValuesPresent(value);
            value.forEach(function (newValue, index) {
                _this._throwIfControlMissing(index);
                _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
            });
            this.updateValueAndValidity(options);
        };
        /**
         * Patches the value of the `FormArray`. It accepts an array that matches the
         * structure of the control, and does its best to match the values to the correct
         * controls in the group.
         *
         * It accepts both super-sets and sub-sets of the array without throwing an error.
         *
         * ### Patch the values for controls in a form array
         *
         * ```
         * const arr = new FormArray([
         *    new FormControl(),
         *    new FormControl()
         * ]);
         * console.log(arr.value);   // [null, null]
         *
         * arr.patchValue(['Nancy']);
         * console.log(arr.value);   // ['Nancy', null]
         * ```
         *
         * @param value Array of latest values for the controls
         * @param options Configure options that determine how the control propagates changes and
         * emits events after the value changes
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
         * is false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control value is updated.
         * When false, no events are emitted.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         */
        FormArray.prototype.patchValue = function (value, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            value.forEach(function (newValue, index) {
                if (_this.at(index)) {
                    _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
                }
            });
            this.updateValueAndValidity(options);
        };
        /**
         * Resets the `FormArray` and all descendants are marked `pristine` and `untouched`, and the
         * value of all descendants to null or null maps.
         *
         * You reset to a specific form state by passing in an array of states
         * that matches the structure of the control. The state is a standalone value
         * or a form state object with both a value and a disabled status.
         *
         * ### Reset the values in a form array
         *
         * ```ts
         * const arr = new FormArray([
         *    new FormControl(),
         *    new FormControl()
         * ]);
         * arr.reset(['name', 'last name']);
         *
         * console.log(this.arr.value);  // ['name', 'last name']
         * ```
         *
         * ### Reset the values in a form array and the disabled status for the first control
         *
         * ```
         * this.arr.reset([
         *   {value: 'name', disabled: true},
         *   'last'
         * ]);
         *
         * console.log(this.arr.value);  // ['name', 'last name']
         * console.log(this.arr.get(0).status);  // 'DISABLED'
         * ```
         *
         * @param value Array of values for the controls
         * @param options Configure options that determine how the control propagates changes and
         * emits events after the value changes
         *
         * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
         * is false.
         * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
         * `valueChanges`
         * observables emit events with the latest status and value when the control is reset.
         * When false, no events are emitted.
         * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
         * updateValueAndValidity} method.
         */
        FormArray.prototype.reset = function (value, options) {
            if (value === void 0) { value = []; }
            if (options === void 0) { options = {}; }
            this._forEachChild(function (control, index) {
                control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
            });
            this.updateValueAndValidity(options);
            this._updatePristine(options);
            this._updateTouched(options);
        };
        /**
         * The aggregate value of the array, including any disabled controls.
         *
         * Reports all values regardless of disabled status.
         * For enabled controls only, the `value` property is the best way to get the value of the array.
         */
        FormArray.prototype.getRawValue = function () {
            return this.controls.map(function (control) {
                return control instanceof FormControl ? control.value : control.getRawValue();
            });
        };
        /** @internal */
        FormArray.prototype._syncPendingControls = function () {
            var subtreeUpdated = this.controls.reduce(function (updated, child) {
                return child._syncPendingControls() ? true : updated;
            }, false);
            if (subtreeUpdated)
                this.updateValueAndValidity({ onlySelf: true });
            return subtreeUpdated;
        };
        /** @internal */
        FormArray.prototype._throwIfControlMissing = function (index) {
            if (!this.controls.length) {
                throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
            }
            if (!this.at(index)) {
                throw new Error("Cannot find form control at index " + index);
            }
        };
        /** @internal */
        FormArray.prototype._forEachChild = function (cb) {
            this.controls.forEach(function (control, index) { cb(control, index); });
        };
        /** @internal */
        FormArray.prototype._updateValue = function () {
            var _this = this;
            this.value =
                this.controls.filter(function (control) { return control.enabled || _this.disabled; })
                    .map(function (control) { return control.value; });
        };
        /** @internal */
        FormArray.prototype._anyControls = function (condition) {
            return this.controls.some(function (control) { return control.enabled && condition(control); });
        };
        /** @internal */
        FormArray.prototype._setUpControls = function () {
            var _this = this;
            this._forEachChild(function (control) { return _this._registerControl(control); });
        };
        /** @internal */
        FormArray.prototype._checkAllValuesPresent = function (value) {
            this._forEachChild(function (control, i) {
                if (value[i] === undefined) {
                    throw new Error("Must supply a value for form control at index: " + i + ".");
                }
            });
        };
        /** @internal */
        FormArray.prototype._allControlsDisabled = function () {
            try {
                for (var _a = __values(this.controls), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var control = _b.value;
                    if (control.enabled)
                        return false;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return this.controls.length > 0 || this.disabled;
            var e_2, _c;
        };
        FormArray.prototype._registerControl = function (control) {
            control.setParent(this);
            control._registerOnCollectionChange(this._onCollectionChange);
        };
        return FormArray;
    }(AbstractControl));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var formDirectiveProvider = {
        provide: ControlContainer,
        useExisting: core.forwardRef(function () { return NgForm; })
    };
    var resolvedPromise = Promise.resolve(null);
    /**
     * @description
     *
     * Creates a top-level `FormGroup` instance and binds it to a form
     * to track aggregate form value and validation status.
     *
     * As soon as you import the `FormsModule`, this directive becomes active by default on
     * all `<form>` tags.  You don't need to add a special selector.
     *
     * You can export the directive into a local template variable using `ngForm` as the key
     * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
     * `FormGroup` instance are duplicated on the directive itself, so a reference to it
     * will give you access to the aggregate value and validity status of the form, as well as
     * user interaction properties like `dirty` and `touched`.
     *
     * To register child controls with the form, you'll want to use `NgModel` with a
     * `name` attribute.  You can also use `NgModelGroup` if you'd like to create
     * sub-groups within the form.
     *
     * You can listen to the directive's `ngSubmit` event to be notified when the user has
     * triggered a form submission. The `ngSubmit` event will be emitted with the original form
     * submission event.
     *
     * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
     * If you want to import the `FormsModule` but skip its usage in some forms,
     * for example, to use native HTML5 validation, you can add `ngNoForm` and the `<form>`
     * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
     * unnecessary because the `<form>` tags are inert. In that case, you would
     * refrain from using the `formGroup` directive.
     *
     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
     *
     * * **npm package**: `@angular/forms`
     *
     * * **NgModule**: `FormsModule`
     *
     *
     */
    var NgForm = /** @class */ (function (_super) {
        __extends(NgForm, _super);
        function NgForm(validators, asyncValidators) {
            var _this = _super.call(this) || this;
            _this.submitted = false;
            _this._directives = [];
            _this.ngSubmit = new core.EventEmitter();
            _this.form =
                new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
            return _this;
        }
        NgForm.prototype.ngAfterViewInit = function () { this._setUpdateStrategy(); };
        Object.defineProperty(NgForm.prototype, "formDirective", {
            get: function () { return this; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "control", {
            get: function () { return this.form; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "path", {
            get: function () { return []; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "controls", {
            get: function () { return this.form.controls; },
            enumerable: true,
            configurable: true
        });
        NgForm.prototype.addControl = function (dir) {
            var _this = this;
            resolvedPromise.then(function () {
                var container = _this._findContainer(dir.path);
                dir.control =
                    container.registerControl(dir.name, dir.control);
                setUpControl(dir.control, dir);
                dir.control.updateValueAndValidity({ emitEvent: false });
                _this._directives.push(dir);
            });
        };
        NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
        NgForm.prototype.removeControl = function (dir) {
            var _this = this;
            resolvedPromise.then(function () {
                var container = _this._findContainer(dir.path);
                if (container) {
                    container.removeControl(dir.name);
                }
                removeDir(_this._directives, dir);
            });
        };
        NgForm.prototype.addFormGroup = function (dir) {
            var _this = this;
            resolvedPromise.then(function () {
                var container = _this._findContainer(dir.path);
                var group = new FormGroup({});
                setUpFormContainer(group, dir);
                container.registerControl(dir.name, group);
                group.updateValueAndValidity({ emitEvent: false });
            });
        };
        NgForm.prototype.removeFormGroup = function (dir) {
            var _this = this;
            resolvedPromise.then(function () {
                var container = _this._findContainer(dir.path);
                if (container) {
                    container.removeControl(dir.name);
                }
            });
        };
        NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
        NgForm.prototype.updateModel = function (dir, value) {
            var _this = this;
            resolvedPromise.then(function () {
                var ctrl = _this.form.get(dir.path);
                ctrl.setValue(value);
            });
        };
        NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
        NgForm.prototype.onSubmit = function ($event) {
            this.submitted = true;
            syncPendingControls(this.form, this._directives);
            this.ngSubmit.emit($event);
            return false;
        };
        NgForm.prototype.onReset = function () { this.resetForm(); };
        NgForm.prototype.resetForm = function (value) {
            if (value === void 0) { value = undefined; }
            this.form.reset(value);
            this.submitted = false;
        };
        NgForm.prototype._setUpdateStrategy = function () {
            if (this.options && this.options.updateOn != null) {
                this.form._updateOn = this.options.updateOn;
            }
        };
        /** @internal */
        NgForm.prototype._findContainer = function (path) {
            path.pop();
            return path.length ? this.form.get(path) : this.form;
        };
        NgForm.decorators = [
            { type: core.Directive, args: [{
                        selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                        providers: [formDirectiveProvider],
                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                        outputs: ['ngSubmit'],
                        exportAs: 'ngForm'
                    },] }
        ];
        /** @nocollapse */
        NgForm.ctorParameters = function () { return [
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] }
        ]; };
        NgForm.propDecorators = {
            options: [{ type: core.Input, args: ['ngFormOptions',] }]
        };
        return NgForm;
    }(ControlContainer));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var TemplateDrivenErrors = /** @class */ (function () {
        function TemplateDrivenErrors() {
        }
        TemplateDrivenErrors.modelParentException = function () {
            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
        };
        TemplateDrivenErrors.formGroupNameException = function () {
            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
        };
        TemplateDrivenErrors.missingNameException = function () {
            throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
        };
        TemplateDrivenErrors.modelGroupParentException = function () {
            throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
        };
        return TemplateDrivenErrors;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var modelGroupProvider = {
        provide: ControlContainer,
        useExisting: core.forwardRef(function () { return NgModelGroup; })
    };
    /**
     * @description
     *
     * Creates and binds a `FormGroup` instance to a DOM element.
     *
     * This directive can only be used as a child of `NgForm` (or in other words,
     * within `<form>` tags).
     *
     * Use this directive if you'd like to create a sub-group within a form. This can
     * come in handy if you want to validate a sub-group of your form separately from
     * the rest of your form, or if some values in your domain model make more sense to
     * consume together in a nested object.
     *
     * Pass in the name you'd like this sub-group to have and it will become the key
     * for the sub-group in the form's full value. You can also export the directive into
     * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
     *
     * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
     *
     * * **npm package**: `@angular/forms`
     *
     * * **NgModule**: `FormsModule`
     *
     *
     */
    var NgModelGroup = /** @class */ (function (_super) {
        __extends(NgModelGroup, _super);
        function NgModelGroup(parent, validators, asyncValidators) {
            var _this = _super.call(this) || this;
            _this._parent = parent;
            _this._validators = validators;
            _this._asyncValidators = asyncValidators;
            return _this;
        }
        /** @internal */
        NgModelGroup.prototype._checkParentType = function () {
            if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
                TemplateDrivenErrors.modelGroupParentException();
            }
        };
        NgModelGroup.decorators = [
            { type: core.Directive, args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] }
        ];
        /** @nocollapse */
        NgModelGroup.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Host }, { type: core.SkipSelf }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] }
        ]; };
        NgModelGroup.propDecorators = {
            name: [{ type: core.Input, args: ['ngModelGroup',] }]
        };
        return NgModelGroup;
    }(AbstractFormGroupDirective));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var formControlBinding = {
        provide: NgControl,
        useExisting: core.forwardRef(function () { return NgModel; })
    };
    /**
     * `ngModel` forces an additional change detection run when its inputs change:
     * E.g.:
     * ```
     * <div>{{myModel.valid}}</div>
     * <input [(ngModel)]="myValue" #myModel="ngModel">
     * ```
     * I.e. `ngModel` can export itself on the element and then be used in the template.
     * Normally, this would result in expressions before the `input` that use the exported directive
     * to have and old value as they have been
     * dirty checked before. As this is a very common case for `ngModel`, we added this second change
     * detection run.
     *
     * Notes:
     * - this is just one extra run no matter how many `ngModel` have been changed.
     * - this is a general problem when using `exportAs` for directives!
     */
    var resolvedPromise$1 = Promise.resolve(null);
    /**
     * @description
     *
     * Creates a `FormControl` instance from a domain model and binds it
     * to a form control element.
     *
     * The `FormControl` instance will track the value, user interaction, and
     * validation status of the control and keep the view synced with the model. If used
     * within a parent form, the directive will also register itself with the form as a child
     * control.
     *
     * This directive can be used by itself or as part of a larger form. All you need is the
     * `ngModel` selector to activate it.
     *
     * It accepts a domain model as an optional `Input`. If you have a one-way binding
     * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
     * class will set the value in the view. If you have a two-way binding with `[()]` syntax
     * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
     * the domain model in your class as well.
     *
     * If you wish to inspect the properties of the associated `FormControl` (like
     * validity state), you can also export the directive into a local template variable using
     * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
     * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
     * will fall through to the control anyway, so you can access them directly. You can see a
     * full list of properties directly available in `AbstractControlDirective`.
     *
     * The following is an example of a simple standalone control using `ngModel`:
     *
     * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
     *
     * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
     * so that the control can be registered with the parent form under that name.
     *
     * It's worth noting that in the context of a parent form, you often can skip one-way or
     * two-way binding because the parent form will sync the value for you. You can access
     * its properties by exporting it into a local template variable using `ngForm` (ex:
     * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
     *
     * If you do need to populate initial values into your form, using a one-way binding for
     * `ngModel` tends to be sufficient as long as you use the exported form's value rather
     * than the domain model's value on submit.
     *
     * Take a look at an example of using `ngModel` within a form:
     *
     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
     *
     * To see `ngModel` examples with different form control types, see:
     *
     * * Radio buttons: `RadioControlValueAccessor`
     * * Selects: `SelectControlValueAccessor`
     *
     * **npm package**: `@angular/forms`
     *
     * **NgModule**: `FormsModule`
     *
     *
     */
    var NgModel = /** @class */ (function (_super) {
        __extends(NgModel, _super);
        function NgModel(parent, validators, asyncValidators, valueAccessors) {
            var _this = _super.call(this) || this;
            _this.control = new FormControl();
            /** @internal */
            _this._registered = false;
            _this.update = new core.EventEmitter();
            _this._parent = parent;
            _this._rawValidators = validators || [];
            _this._rawAsyncValidators = asyncValidators || [];
            _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
            return _this;
        }
        NgModel.prototype.ngOnChanges = function (changes) {
            this._checkForErrors();
            if (!this._registered)
                this._setUpControl();
            if ('isDisabled' in changes) {
                this._updateDisabled(changes);
            }
            if (isPropertyUpdated(changes, this.viewModel)) {
                this._updateValue(this.model);
                this.viewModel = this.model;
            }
        };
        NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
        Object.defineProperty(NgModel.prototype, "path", {
            get: function () {
                return this._parent ? controlPath(this.name, this._parent) : [this.name];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "formDirective", {
            get: function () { return this._parent ? this._parent.formDirective : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "validator", {
            get: function () { return composeValidators(this._rawValidators); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "asyncValidator", {
            get: function () {
                return composeAsyncValidators(this._rawAsyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        NgModel.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            this.update.emit(newValue);
        };
        NgModel.prototype._setUpControl = function () {
            this._setUpdateStrategy();
            this._isStandalone() ? this._setUpStandalone() :
                this.formDirective.addControl(this);
            this._registered = true;
        };
        NgModel.prototype._setUpdateStrategy = function () {
            if (this.options && this.options.updateOn != null) {
                this.control._updateOn = this.options.updateOn;
            }
        };
        NgModel.prototype._isStandalone = function () {
            return !this._parent || !!(this.options && this.options.standalone);
        };
        NgModel.prototype._setUpStandalone = function () {
            setUpControl(this.control, this);
            this.control.updateValueAndValidity({ emitEvent: false });
        };
        NgModel.prototype._checkForErrors = function () {
            if (!this._isStandalone()) {
                this._checkParentType();
            }
            this._checkName();
        };
        NgModel.prototype._checkParentType = function () {
            if (!(this._parent instanceof NgModelGroup) &&
                this._parent instanceof AbstractFormGroupDirective) {
                TemplateDrivenErrors.formGroupNameException();
            }
            else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
                TemplateDrivenErrors.modelParentException();
            }
        };
        NgModel.prototype._checkName = function () {
            if (this.options && this.options.name)
                this.name = this.options.name;
            if (!this._isStandalone() && !this.name) {
                TemplateDrivenErrors.missingNameException();
            }
        };
        NgModel.prototype._updateValue = function (value) {
            var _this = this;
            resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
        };
        NgModel.prototype._updateDisabled = function (changes) {
            var _this = this;
            var disabledValue = changes['isDisabled'].currentValue;
            var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
            resolvedPromise$1.then(function () {
                if (isDisabled && !_this.control.disabled) {
                    _this.control.disable();
                }
                else if (!isDisabled && _this.control.disabled) {
                    _this.control.enable();
                }
            });
        };
        NgModel.decorators = [
            { type: core.Directive, args: [{
                        selector: '[ngModel]:not([formControlName]):not([formControl])',
                        providers: [formControlBinding],
                        exportAs: 'ngModel'
                    },] }
        ];
        /** @nocollapse */
        NgModel.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Optional }, { type: core.Host }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALUE_ACCESSOR,] }] }
        ]; };
        NgModel.propDecorators = {
            name: [{ type: core.Input }],
            isDisabled: [{ type: core.Input, args: ['disabled',] }],
            model: [{ type: core.Input, args: ['ngModel',] }],
            options: [{ type: core.Input, args: ['ngModelOptions',] }],
            update: [{ type: core.Output, args: ['ngModelChange',] }]
        };
        return NgModel;
    }(NgControl));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * Token to provide to turn off the ngModel warning on formControl and formControlName.
     */
    var NG_MODEL_WITH_FORM_CONTROL_WARNING = new core.InjectionToken('NgModelWithFormControlWarning');
    var formControlBinding$1 = {
        provide: NgControl,
        useExisting: core.forwardRef(function () { return FormControlDirective; })
    };
    /**
     * @description
     *
     * Syncs a standalone `FormControl` instance to a form control element.
     *
     * This directive ensures that any values written to the `FormControl`
     * instance programmatically will be written to the DOM element (model -> view). Conversely,
     * any values written to the DOM element through user input will be reflected in the
     * `FormControl` instance (view -> model).
     *
     * Use this directive if you'd like to create and manage a `FormControl` instance directly.
     * Simply create a `FormControl`, save it to your component class, and pass it into the
     * `FormControlDirective`.
     *
     * This directive is designed to be used as a standalone control.  Unlike `FormControlName`,
     * it does not require that your `FormControl` instance be part of any parent
     * `FormGroup`, and it won't be registered to any `FormGroupDirective` that
     * exists above it.
     *
     * **Get the value**: the `value` property is always synced and available on the
     * `FormControl` instance. See a full list of available properties in
     * `AbstractControl`.
     *
     * **Set the value**: You can pass in an initial value when instantiating the `FormControl`,
     * or you can set it programmatically later using {@link AbstractControl#setValue setValue} or
     * {@link AbstractControl#patchValue patchValue}.
     *
     * **Listen to value**: If you want to listen to changes in the value of the control, you can
     * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
     * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
     * re-calculated.
     *
     * ### Example
     *
     * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
     *
     * * **npm package**: `@angular/forms`
     *
     * * **NgModule**: `ReactiveFormsModule`
     *
     * ### Use with ngModel
     *
     * Support for using the `ngModel` input property and `ngModelChange` event with reactive
     * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
     *
     * Now deprecated:
     * ```html
     * <input [formControl]="control" [(ngModel)]="value">
     * ```
     *
     * ```ts
     * this.value = 'some value';
     * ```
     *
     * This has been deprecated for a few reasons. First, developers have found this pattern
     * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
     * an input/output property named `ngModel` on the reactive form directive that simply
     * approximates (some of) its behavior. Specifically, it allows getting/setting the value
     * and intercepting value events. However, some of `ngModel`'s other features - like
     * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
     * which has understandably caused some confusion.
     *
     * In addition, this pattern mixes template-driven and reactive forms strategies, which
     * we generally don't recommend because it doesn't take advantage of the full benefits of
     * either strategy. Setting the value in the template violates the template-agnostic
     * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
     * the class removes the convenience of defining forms in the template.
     *
     * To update your code before v7, you'll want to decide whether to stick with reactive form
     * directives (and get/set values using reactive forms patterns) or switch over to
     * template-driven directives.
     *
     * After (choice 1 - use reactive forms):
     *
     * ```html
     * <input [formControl]="control">
     * ```
     *
     * ```ts
     * this.control.setValue('some value');
     * ```
     *
     * After (choice 2 - use template-driven forms):
     *
     * ```html
     * <input [(ngModel)]="value">
     * ```
     *
     * ```ts
     * this.value = 'some value';
     * ```
     *
     * By default, when you use this pattern, you will see a deprecation warning once in dev
     * mode. You can choose to silence this warning by providing a config for
     * `ReactiveFormsModule` at import time:
     *
     * ```ts
     * imports: [
     *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'});
     * ]
     * ```
     *
     * Alternatively, you can choose to surface a separate warning for each instance of this
     * pattern with a config value of `"always"`. This may help to track down where in the code
     * the pattern is being used as the code is being updated.
     *
     *
     */
    var FormControlDirective = /** @class */ (function (_super) {
        __extends(FormControlDirective, _super);
        function FormControlDirective(validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
            var _this = _super.call(this) || this;
            _this._ngModelWarningConfig = _ngModelWarningConfig;
            /** @deprecated as of v6 */
            _this.update = new core.EventEmitter();
            /**
             * Instance property used to track whether an ngModel warning has been sent out for this
             * particular FormControlDirective instance. Used to support warning config of "always".
             *
             * @internal
             */
            _this._ngModelWarningSent = false;
            _this._rawValidators = validators || [];
            _this._rawAsyncValidators = asyncValidators || [];
            _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
            return _this;
        }
        Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
            enumerable: true,
            configurable: true
        });
        FormControlDirective.prototype.ngOnChanges = function (changes) {
            if (this._isControlChanged(changes)) {
                setUpControl(this.form, this);
                if (this.control.disabled && this.valueAccessor.setDisabledState) {
                    this.valueAccessor.setDisabledState(true);
                }
                this.form.updateValueAndValidity({ emitEvent: false });
            }
            if (isPropertyUpdated(changes, this.viewModel)) {
                _ngModelWarning('formControl', FormControlDirective, this, this._ngModelWarningConfig);
                this.form.setValue(this.model);
                this.viewModel = this.model;
            }
        };
        Object.defineProperty(FormControlDirective.prototype, "path", {
            get: function () { return []; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlDirective.prototype, "validator", {
            get: function () { return composeValidators(this._rawValidators); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
            get: function () {
                return composeAsyncValidators(this._rawAsyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlDirective.prototype, "control", {
            get: function () { return this.form; },
            enumerable: true,
            configurable: true
        });
        FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            this.update.emit(newValue);
        };
        FormControlDirective.prototype._isControlChanged = function (changes) {
            return changes.hasOwnProperty('form');
        };
        /**
         * Static property used to track whether any ngModel warnings have been sent across
         * all instances of FormControlDirective. Used to support warning config of "once".
         *
         * @internal
         */
        FormControlDirective._ngModelWarningSentOnce = false;
        FormControlDirective.decorators = [
            { type: core.Directive, args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] }
        ];
        /** @nocollapse */
        FormControlDirective.ctorParameters = function () { return [
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALUE_ACCESSOR,] }] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [NG_MODEL_WITH_FORM_CONTROL_WARNING,] }] }
        ]; };
        FormControlDirective.propDecorators = {
            form: [{ type: core.Input, args: ['formControl',] }],
            isDisabled: [{ type: core.Input, args: ['disabled',] }],
            model: [{ type: core.Input, args: ['ngModel',] }],
            update: [{ type: core.Output, args: ['ngModelChange',] }]
        };
        return FormControlDirective;
    }(NgControl));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var formDirectiveProvider$1 = {
        provide: ControlContainer,
        useExisting: core.forwardRef(function () { return FormGroupDirective; })
    };
    /**
     * @description
     *
     * Binds an existing `FormGroup` to a DOM element.
     *
     * This directive accepts an existing `FormGroup` instance. It will then use this
     * `FormGroup` instance to match any child `FormControl`, `FormGroup`,
     * and `FormArray` instances to child `FormControlName`, `FormGroupName`,
     * and `FormArrayName` directives.
     *
     * **Set value**: You can set the form's initial value when instantiating the
     * `FormGroup`, or you can set it programmatically later using the `FormGroup`'s
     * {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}
     * methods.
     *
     * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
     * to the `FormGroup`'s {@link AbstractControl#valueChanges valueChanges} event.  You can also
     * listen to its {@link AbstractControl#statusChanges statusChanges} event to be notified when the
     * validation status is re-calculated.
     *
     * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
     * triggered a form submission. The `ngSubmit` event will be emitted with the original form
     * submission event.
     *
     * ### Example
     *
     * In this example, we create form controls for first name and last name.
     *
     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
     *
     * **npm package**: `@angular/forms`
     *
     * **NgModule**: `ReactiveFormsModule`
     *
     *
     */
    var FormGroupDirective = /** @class */ (function (_super) {
        __extends(FormGroupDirective, _super);
        function FormGroupDirective(_validators, _asyncValidators) {
            var _this = _super.call(this) || this;
            _this._validators = _validators;
            _this._asyncValidators = _asyncValidators;
            _this.submitted = false;
            _this.directives = [];
            _this.form = null;
            _this.ngSubmit = new core.EventEmitter();
            return _this;
        }
        FormGroupDirective.prototype.ngOnChanges = function (changes) {
            this._checkFormPresent();
            if (changes.hasOwnProperty('form')) {
                this._updateValidators();
                this._updateDomValue();
                this._updateRegistrations();
            }
        };
        Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
            get: function () { return this; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormGroupDirective.prototype, "control", {
            get: function () { return this.form; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormGroupDirective.prototype, "path", {
            get: function () { return []; },
            enumerable: true,
            configurable: true
        });
        FormGroupDirective.prototype.addControl = function (dir) {
            var ctrl = this.form.get(dir.path);
            setUpControl(ctrl, dir);
            ctrl.updateValueAndValidity({ emitEvent: false });
            this.directives.push(dir);
            return ctrl;
        };
        FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
        FormGroupDirective.prototype.removeControl = function (dir) { removeDir(this.directives, dir); };
        FormGroupDirective.prototype.addFormGroup = function (dir) {
            var ctrl = this.form.get(dir.path);
            setUpFormContainer(ctrl, dir);
            ctrl.updateValueAndValidity({ emitEvent: false });
        };
        FormGroupDirective.prototype.removeFormGroup = function (dir) { };
        FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
        FormGroupDirective.prototype.addFormArray = function (dir) {
            var ctrl = this.form.get(dir.path);
            setUpFormContainer(ctrl, dir);
            ctrl.updateValueAndValidity({ emitEvent: false });
        };
        FormGroupDirective.prototype.removeFormArray = function (dir) { };
        FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
        FormGroupDirective.prototype.updateModel = function (dir, value) {
            var ctrl = this.form.get(dir.path);
            ctrl.setValue(value);
        };
        FormGroupDirective.prototype.onSubmit = function ($event) {
            this.submitted = true;
            syncPendingControls(this.form, this.directives);
            this.ngSubmit.emit($event);
            return false;
        };
        FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
        FormGroupDirective.prototype.resetForm = function (value) {
            if (value === void 0) { value = undefined; }
            this.form.reset(value);
            this.submitted = false;
        };
        /** @internal */
        FormGroupDirective.prototype._updateDomValue = function () {
            var _this = this;
            this.directives.forEach(function (dir) {
                var newCtrl = _this.form.get(dir.path);
                if (dir.control !== newCtrl) {
                    cleanUpControl(dir.control, dir);
                    if (newCtrl)
                        setUpControl(newCtrl, dir);
                    dir.control = newCtrl;
                }
            });
            this.form._updateTreeValidity({ emitEvent: false });
        };
        FormGroupDirective.prototype._updateRegistrations = function () {
            var _this = this;
            this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
            if (this._oldForm)
                this._oldForm._registerOnCollectionChange(function () { });
            this._oldForm = this.form;
        };
        FormGroupDirective.prototype._updateValidators = function () {
            var sync = composeValidators(this._validators);
            this.form.validator = Validators.compose([this.form.validator, sync]);
            var async = composeAsyncValidators(this._asyncValidators);
            this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
        };
        FormGroupDirective.prototype._checkFormPresent = function () {
            if (!this.form) {
                ReactiveErrors.missingFormException();
            }
        };
        FormGroupDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[formGroup]',
                        providers: [formDirectiveProvider$1],
                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                        exportAs: 'ngForm'
                    },] }
        ];
        /** @nocollapse */
        FormGroupDirective.ctorParameters = function () { return [
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] }
        ]; };
        FormGroupDirective.propDecorators = {
            form: [{ type: core.Input, args: ['formGroup',] }],
            ngSubmit: [{ type: core.Output }]
        };
        return FormGroupDirective;
    }(ControlContainer));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var formGroupNameProvider = {
        provide: ControlContainer,
        useExisting: core.forwardRef(function () { return FormGroupName; })
    };
    /**
     * @description
     *
     * Syncs a nested `FormGroup` to a DOM element.
     *
     * This directive can only be used with a parent `FormGroupDirective` (selector:
     * `[formGroup]`).
     *
     * It accepts the string name of the nested `FormGroup` you want to link, and
     * will look for a `FormGroup` registered with that name in the parent
     * `FormGroup` instance you passed into `FormGroupDirective`.
     *
     * Nested form groups can come in handy when you want to validate a sub-group of a
     * form separately from the rest or when you'd like to group the values of certain
     * controls into their own nested object.
     *
     * **Access the group**: You can access the associated `FormGroup` using the
     * {@link AbstractControl#get get} method. Ex: `this.form.get('name')`.
     *
     * You can also access individual controls within the group using dot syntax.
     * Ex: `this.form.get('name.first')`
     *
     * **Get the value**: the `value` property is always synced and available on the
     * `FormGroup`. See a full list of available properties in `AbstractControl`.
     *
     * **Set the value**: You can set an initial value for each child control when instantiating
     * the `FormGroup`, or you can set it programmatically later using
     * {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}.
     *
     * **Listen to value**: If you want to listen to changes in the value of the group, you can
     * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
     * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
     * re-calculated.
     *
     * ### Example
     *
     * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
     *
     * * **npm package**: `@angular/forms`
     *
     * * **NgModule**: `ReactiveFormsModule`
     *
     *
     */
    var FormGroupName = /** @class */ (function (_super) {
        __extends(FormGroupName, _super);
        function FormGroupName(parent, validators, asyncValidators) {
            var _this = _super.call(this) || this;
            _this._parent = parent;
            _this._validators = validators;
            _this._asyncValidators = asyncValidators;
            return _this;
        }
        /** @internal */
        FormGroupName.prototype._checkParentType = function () {
            if (_hasInvalidParent(this._parent)) {
                ReactiveErrors.groupParentException();
            }
        };
        FormGroupName.decorators = [
            { type: core.Directive, args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] }
        ];
        /** @nocollapse */
        FormGroupName.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Optional }, { type: core.Host }, { type: core.SkipSelf }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] }
        ]; };
        FormGroupName.propDecorators = {
            name: [{ type: core.Input, args: ['formGroupName',] }]
        };
        return FormGroupName;
    }(AbstractFormGroupDirective));
    var formArrayNameProvider = {
        provide: ControlContainer,
        useExisting: core.forwardRef(function () { return FormArrayName; })
    };
    /**
     * @description
     *
     * Syncs a nested `FormArray` to a DOM element.
     *
     * This directive is designed to be used with a parent `FormGroupDirective` (selector:
     * `[formGroup]`).
     *
     * It accepts the string name of the nested `FormArray` you want to link, and
     * will look for a `FormArray` registered with that name in the parent
     * `FormGroup` instance you passed into `FormGroupDirective`.
     *
     * Nested form arrays can come in handy when you have a group of form controls but
     * you're not sure how many there will be. Form arrays allow you to create new
     * form controls dynamically.
     *
     * **Access the array**: You can access the associated `FormArray` using the
     * {@link AbstractControl#get get} method on the parent `FormGroup`.
     * Ex: `this.form.get('cities')`.
     *
     * **Get the value**: the `value` property is always synced and available on the
     * `FormArray`. See a full list of available properties in `AbstractControl`.
     *
     * **Set the value**: You can set an initial value for each child control when instantiating
     * the `FormArray`, or you can set the value programmatically later using the
     * `FormArray`'s {@link AbstractControl#setValue setValue} or
     * {@link AbstractControl#patchValue patchValue} methods.
     *
     * **Listen to value**: If you want to listen to changes in the value of the array, you can
     * subscribe to the `FormArray`'s {@link AbstractControl#valueChanges valueChanges} event.
     * You can also listen to its {@link AbstractControl#statusChanges statusChanges} event to be
     * notified when the validation status is re-calculated.
     *
     * **Add new controls**: You can add new controls to the `FormArray` dynamically by calling
     * its {@link FormArray#push push} method.
     * Ex: `this.form.get('cities').push(new FormControl());`
     *
     * ### Example
     *
     * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
     *
     * * **npm package**: `@angular/forms`
     *
     * * **NgModule**: `ReactiveFormsModule`
     *
     *
     */
    var FormArrayName = /** @class */ (function (_super) {
        __extends(FormArrayName, _super);
        function FormArrayName(parent, validators, asyncValidators) {
            var _this = _super.call(this) || this;
            _this._parent = parent;
            _this._validators = validators;
            _this._asyncValidators = asyncValidators;
            return _this;
        }
        FormArrayName.prototype.ngOnInit = function () {
            this._checkParentType();
            this.formDirective.addFormArray(this);
        };
        FormArrayName.prototype.ngOnDestroy = function () {
            if (this.formDirective) {
                this.formDirective.removeFormArray(this);
            }
        };
        Object.defineProperty(FormArrayName.prototype, "control", {
            get: function () { return this.formDirective.getFormArray(this); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormArrayName.prototype, "formDirective", {
            get: function () {
                return this._parent ? this._parent.formDirective : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormArrayName.prototype, "path", {
            get: function () { return controlPath(this.name, this._parent); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormArrayName.prototype, "validator", {
            get: function () { return composeValidators(this._validators); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
            get: function () {
                return composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        FormArrayName.prototype._checkParentType = function () {
            if (_hasInvalidParent(this._parent)) {
                ReactiveErrors.arrayParentException();
            }
        };
        FormArrayName.decorators = [
            { type: core.Directive, args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] }
        ];
        /** @nocollapse */
        FormArrayName.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Optional }, { type: core.Host }, { type: core.SkipSelf }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] }
        ]; };
        FormArrayName.propDecorators = {
            name: [{ type: core.Input, args: ['formArrayName',] }]
        };
        return FormArrayName;
    }(ControlContainer));
    function _hasInvalidParent(parent) {
        return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
            !(parent instanceof FormArrayName);
    }

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var controlNameBinding = {
        provide: NgControl,
        useExisting: core.forwardRef(function () { return FormControlName; })
    };
    /**
     * @description
     *
     * Syncs a `FormControl` in an existing `FormGroup` to a form control
     * element by name.
     *
     * This directive ensures that any values written to the `FormControl`
     * instance programmatically will be written to the DOM element (model -> view). Conversely,
     * any values written to the DOM element through user input will be reflected in the
     * `FormControl` instance (view -> model).
     *
     * This directive is designed to be used with a parent `FormGroupDirective` (selector:
     * `[formGroup]`).
     *
     * It accepts the string name of the `FormControl` instance you want to
     * link, and will look for a `FormControl` registered with that name in the
     * closest `FormGroup` or `FormArray` above it.
     *
     * **Access the control**: You can access the `FormControl` associated with
     * this directive by using the {@link AbstractControl#get get} method.
     * Ex: `this.form.get('first');`
     *
     * **Get value**: the `value` property is always synced and available on the `FormControl`.
     * See a full list of available properties in `AbstractControl`.
     *
     *  **Set value**: You can set an initial value for the control when instantiating the
     *  `FormControl`, or you can set it programmatically later using
     *  {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}.
     *
     * **Listen to value**: If you want to listen to changes in the value of the control, you can
     * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
     * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
     * re-calculated.
     *
     * ### Example
     *
     * In this example, we create form controls for first name and last name.
     *
     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
     *
     * To see `formControlName` examples with different form control types, see:
     *
     * * Radio buttons: `RadioControlValueAccessor`
     * * Selects: `SelectControlValueAccessor`
     *
     * **npm package**: `@angular/forms`
     *
     * **NgModule**: `ReactiveFormsModule`
     *
     * ### Use with ngModel
     *
     * Support for using the `ngModel` input property and `ngModelChange` event with reactive
     * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
     *
     * Now deprecated:
     * ```html
     * <form [formGroup]="form">
     *   <input formControlName="first" [(ngModel)]="value">
     * </form>
     * ```
     *
     * ```ts
     * this.value = 'some value';
     * ```
     *
     * This has been deprecated for a few reasons. First, developers have found this pattern
     * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
     * an input/output property named `ngModel` on the reactive form directive that simply
     * approximates (some of) its behavior. Specifically, it allows getting/setting the value
     * and intercepting value events. However, some of `ngModel`'s other features - like
     * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
     * which has understandably caused some confusion.
     *
     * In addition, this pattern mixes template-driven and reactive forms strategies, which
     * we generally don't recommend because it doesn't take advantage of the full benefits of
     * either strategy. Setting the value in the template violates the template-agnostic
     * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
     * the class removes the convenience of defining forms in the template.
     *
     * To update your code before v7, you'll want to decide whether to stick with reactive form
     * directives (and get/set values using reactive forms patterns) or switch over to
     * template-driven directives.
     *
     * After (choice 1 - use reactive forms):
     *
     * ```html
     * <form [formGroup]="form">
     *   <input formControlName="first">
     * </form>
     * ```
     *
     * ```ts
     * this.form.get('first').setValue('some value');
     * ```
     *
     * After (choice 2 - use template-driven forms):
     *
     * ```html
     * <input [(ngModel)]="value">
     * ```
     *
     * ```ts
     * this.value = 'some value';
     * ```
     *
     * By default, when you use this pattern, you will see a deprecation warning once in dev
     * mode. You can choose to silence this warning by providing a config for
     * `ReactiveFormsModule` at import time:
     *
     * ```ts
     * imports: [
     *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'});
     * ]
     * ```
     *
     * Alternatively, you can choose to surface a separate warning for each instance of this
     * pattern with a config value of `"always"`. This may help to track down where in the code
     * the pattern is being used as the code is being updated.
     *
     *
     */
    var FormControlName = /** @class */ (function (_super) {
        __extends(FormControlName, _super);
        function FormControlName(parent, validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
            var _this = _super.call(this) || this;
            _this._ngModelWarningConfig = _ngModelWarningConfig;
            _this._added = false;
            /** @deprecated as of v6 */
            _this.update = new core.EventEmitter();
            /**
             * Instance property used to track whether an ngModel warning has been sent out for this
             * particular FormControlName instance. Used to support warning config of "always".
             *
             * @internal
             */
            _this._ngModelWarningSent = false;
            _this._parent = parent;
            _this._rawValidators = validators || [];
            _this._rawAsyncValidators = asyncValidators || [];
            _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
            return _this;
        }
        Object.defineProperty(FormControlName.prototype, "isDisabled", {
            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
            enumerable: true,
            configurable: true
        });
        FormControlName.prototype.ngOnChanges = function (changes) {
            if (!this._added)
                this._setUpControl();
            if (isPropertyUpdated(changes, this.viewModel)) {
                _ngModelWarning('formControlName', FormControlName, this, this._ngModelWarningConfig);
                this.viewModel = this.model;
                this.formDirective.updateModel(this, this.model);
            }
        };
        FormControlName.prototype.ngOnDestroy = function () {
            if (this.formDirective) {
                this.formDirective.removeControl(this);
            }
        };
        FormControlName.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            this.update.emit(newValue);
        };
        Object.defineProperty(FormControlName.prototype, "path", {
            get: function () { return controlPath(this.name, this._parent); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlName.prototype, "formDirective", {
            get: function () { return this._parent ? this._parent.formDirective : null; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlName.prototype, "validator", {
            get: function () { return composeValidators(this._rawValidators); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(FormControlName.prototype, "asyncValidator", {
            get: function () {
                return composeAsyncValidators(this._rawAsyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        FormControlName.prototype._checkParentType = function () {
            if (!(this._parent instanceof FormGroupName) &&
                this._parent instanceof AbstractFormGroupDirective) {
                ReactiveErrors.ngModelGroupException();
            }
            else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
                !(this._parent instanceof FormArrayName)) {
                ReactiveErrors.controlParentException();
            }
        };
        FormControlName.prototype._setUpControl = function () {
            this._checkParentType();
            this.control = this.formDirective.addControl(this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this._added = true;
        };
        /**
         * Static property used to track whether any ngModel warnings have been sent across
         * all instances of FormControlName. Used to support warning config of "once".
         *
         * @internal
         */
        FormControlName._ngModelWarningSentOnce = false;
        FormControlName.decorators = [
            { type: core.Directive, args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] }
        ];
        /** @nocollapse */
        FormControlName.ctorParameters = function () { return [
            { type: ControlContainer, decorators: [{ type: core.Optional }, { type: core.Host }, { type: core.SkipSelf }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_ASYNC_VALIDATORS,] }] },
            { type: Array, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [NG_VALUE_ACCESSOR,] }] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [NG_MODEL_WITH_FORM_CONTROL_WARNING,] }] }
        ]; };
        FormControlName.propDecorators = {
            name: [{ type: core.Input, args: ['formControlName',] }],
            isDisabled: [{ type: core.Input, args: ['disabled',] }],
            model: [{ type: core.Input, args: ['ngModel',] }],
            update: [{ type: core.Output, args: ['ngModelChange',] }]
        };
        return FormControlName;
    }(NgControl));

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var REQUIRED_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return RequiredValidator; }),
        multi: true
    };
    var CHECKBOX_REQUIRED_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return CheckboxRequiredValidator; }),
        multi: true
    };
    /**
     * A Directive that adds the `required` validator to any controls marked with the
     * `required` attribute, via the `NG_VALIDATORS` binding.
     *
     * ### Example
     *
     * ```
     * <input name="fullName" ngModel required>
     * ```
     *
     *
     */
    var RequiredValidator = /** @class */ (function () {
        function RequiredValidator() {
        }
        Object.defineProperty(RequiredValidator.prototype, "required", {
            get: function () { return this._required; },
            set: function (value) {
                this._required = value != null && value !== false && "" + value !== 'false';
                if (this._onChange)
                    this._onChange();
            },
            enumerable: true,
            configurable: true
        });
        RequiredValidator.prototype.validate = function (c) {
            return this.required ? Validators.required(c) : null;
        };
        RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
        RequiredValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                        providers: [REQUIRED_VALIDATOR],
                        host: { '[attr.required]': 'required ? "" : null' }
                    },] }
        ];
        RequiredValidator.propDecorators = {
            required: [{ type: core.Input }]
        };
        return RequiredValidator;
    }());
    /**
     * A Directive that adds the `required` validator to checkbox controls marked with the
     * `required` attribute, via the `NG_VALIDATORS` binding.
     *
     * ### Example
     *
     * ```
     * <input type="checkbox" name="active" ngModel required>
     * ```
     *
     * @experimental
     */
    var CheckboxRequiredValidator = /** @class */ (function (_super) {
        __extends(CheckboxRequiredValidator, _super);
        function CheckboxRequiredValidator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CheckboxRequiredValidator.prototype.validate = function (c) {
            return this.required ? Validators.requiredTrue(c) : null;
        };
        CheckboxRequiredValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                        providers: [CHECKBOX_REQUIRED_VALIDATOR],
                        host: { '[attr.required]': 'required ? "" : null' }
                    },] }
        ];
        return CheckboxRequiredValidator;
    }(RequiredValidator));
    /**
     * Provider which adds `EmailValidator` to `NG_VALIDATORS`.
     */
    var EMAIL_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return EmailValidator; }),
        multi: true
    };
    /**
     * A Directive that adds the `email` validator to controls marked with the
     * `email` attribute, via the `NG_VALIDATORS` binding.
     *
     * ### Example
     *
     * ```
     * <input type="email" name="email" ngModel email>
     * <input type="email" name="email" ngModel email="true">
     * <input type="email" name="email" ngModel [email]="true">
     * ```
     *
     * @experimental
     */
    var EmailValidator = /** @class */ (function () {
        function EmailValidator() {
        }
        Object.defineProperty(EmailValidator.prototype, "email", {
            set: function (value) {
                this._enabled = value === '' || value === true || value === 'true';
                if (this._onChange)
                    this._onChange();
            },
            enumerable: true,
            configurable: true
        });
        EmailValidator.prototype.validate = function (c) {
            return this._enabled ? Validators.email(c) : null;
        };
        EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
        EmailValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                        providers: [EMAIL_VALIDATOR]
                    },] }
        ];
        EmailValidator.propDecorators = {
            email: [{ type: core.Input }]
        };
        return EmailValidator;
    }());
    /**
     * Provider which adds `MinLengthValidator` to `NG_VALIDATORS`.
     *
     * ## Example:
     *
     * {@example common/forms/ts/validators/validators.ts region='min'}
     */
    var MIN_LENGTH_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return MinLengthValidator; }),
        multi: true
    };
    /**
     * A directive which installs the `MinLengthValidator` for any `formControlName`,
     * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
     *
     *
     */
    var MinLengthValidator = /** @class */ (function () {
        function MinLengthValidator() {
        }
        MinLengthValidator.prototype.ngOnChanges = function (changes) {
            if ('minlength' in changes) {
                this._createValidator();
                if (this._onChange)
                    this._onChange();
            }
        };
        MinLengthValidator.prototype.validate = function (c) {
            return this.minlength == null ? null : this._validator(c);
        };
        MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
        MinLengthValidator.prototype._createValidator = function () {
            this._validator = Validators.minLength(parseInt(this.minlength, 10));
        };
        MinLengthValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                        providers: [MIN_LENGTH_VALIDATOR],
                        host: { '[attr.minlength]': 'minlength ? minlength : null' }
                    },] }
        ];
        MinLengthValidator.propDecorators = {
            minlength: [{ type: core.Input }]
        };
        return MinLengthValidator;
    }());
    /**
     * Provider which adds `MaxLengthValidator` to `NG_VALIDATORS`.
     *
     * ## Example:
     *
     * {@example common/forms/ts/validators/validators.ts region='max'}
     */
    var MAX_LENGTH_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return MaxLengthValidator; }),
        multi: true
    };
    /**
     * A directive which installs the `MaxLengthValidator` for any `formControlName,
     * `formControl`,
     * or control with `ngModel` that also has a `maxlength` attribute.
     *
     *
     */
    var MaxLengthValidator = /** @class */ (function () {
        function MaxLengthValidator() {
        }
        MaxLengthValidator.prototype.ngOnChanges = function (changes) {
            if ('maxlength' in changes) {
                this._createValidator();
                if (this._onChange)
                    this._onChange();
            }
        };
        MaxLengthValidator.prototype.validate = function (c) {
            return this.maxlength != null ? this._validator(c) : null;
        };
        MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
        MaxLengthValidator.prototype._createValidator = function () {
            this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
        };
        MaxLengthValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                        providers: [MAX_LENGTH_VALIDATOR],
                        host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                    },] }
        ];
        MaxLengthValidator.propDecorators = {
            maxlength: [{ type: core.Input }]
        };
        return MaxLengthValidator;
    }());
    var PATTERN_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return PatternValidator; }),
        multi: true
    };
    /**
     * A Directive that adds the `pattern` validator to any controls marked with the
     * `pattern` attribute, via the `NG_VALIDATORS` binding. Uses attribute value
     * as the regex to validate Control value against.  Follows pattern attribute
     * semantics; i.e. regex must match entire Control value.
     *
     * ### Example
     *
     * ```
     * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
     * ```
     *
     */
    var PatternValidator = /** @class */ (function () {
        function PatternValidator() {
        }
        PatternValidator.prototype.ngOnChanges = function (changes) {
            if ('pattern' in changes) {
                this._createValidator();
                if (this._onChange)
                    this._onChange();
            }
        };
        PatternValidator.prototype.validate = function (c) { return this._validator(c); };
        PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
        PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
        PatternValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                        providers: [PATTERN_VALIDATOR],
                        host: { '[attr.pattern]': 'pattern ? pattern : null' }
                    },] }
        ];
        PatternValidator.propDecorators = {
            pattern: [{ type: core.Input }]
        };
        return PatternValidator;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @description
     *
     * Creates an `AbstractControl` from a user-specified configuration.
     *
     * This is essentially syntactic sugar that shortens the `new FormGroup()`,
     * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
     * forms.
     *
     * To use, inject `FormBuilder` into your component class. You can then call its methods
     * directly.
     *
     * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
     *
     *  * **npm package**: `@angular/forms`
     *
     *  * **NgModule**: `ReactiveFormsModule`
     *
     *
     */
    var FormBuilder = /** @class */ (function () {
        function FormBuilder() {
        }
        /**
         * Construct a new `FormGroup` with the given map of configuration.
         * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
         *
         * See the `FormGroup` constructor for more details.
         */
        FormBuilder.prototype.group = function (controlsConfig, extra) {
            if (extra === void 0) { extra = null; }
            var controls = this._reduceControls(controlsConfig);
            var validator = extra != null ? extra['validator'] : null;
            var asyncValidator = extra != null ? extra['asyncValidator'] : null;
            return new FormGroup(controls, validator, asyncValidator);
        };
        /**
         * Construct a new `FormControl` with the given `formState`,`validator`, and
         * `asyncValidator`.
         *
         * `formState` can either be a standalone value for the form control or an object
         * that contains both a value and a disabled status.
         *
         */
        FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
            return new FormControl(formState, validator, asyncValidator);
        };
        /**
         * Construct a `FormArray` from the given `controlsConfig` array of
         * configuration, with the given optional `validator` and `asyncValidator`.
         */
        FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
            var _this = this;
            var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
            return new FormArray(controls, validator, asyncValidator);
        };
        /** @internal */
        FormBuilder.prototype._reduceControls = function (controlsConfig) {
            var _this = this;
            var controls = {};
            Object.keys(controlsConfig).forEach(function (controlName) {
                controls[controlName] = _this._createControl(controlsConfig[controlName]);
            });
            return controls;
        };
        /** @internal */
        FormBuilder.prototype._createControl = function (controlConfig) {
            if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
                controlConfig instanceof FormArray) {
                return controlConfig;
            }
            else if (Array.isArray(controlConfig)) {
                var value = controlConfig[0];
                var validator = controlConfig.length > 1 ? controlConfig[1] : null;
                var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
                return this.control(value, validator, asyncValidator);
            }
            else {
                return this.control(controlConfig);
            }
        };
        FormBuilder.decorators = [
            { type: core.Injectable }
        ];
        return FormBuilder;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @module
     * @description
     * Entry point for all public APIs of the common package.
     */
    var VERSION$1 = new core.Version('6.0.6');

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @description
     *
     * Adds `novalidate` attribute to all forms by default.
     *
     * `novalidate` is used to disable browser's native form validation.
     *
     * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
     *
     * ```
     * <form ngNativeValidate></form>
     * ```
     *
     * @experimental
     */
    var NgNoValidate = /** @class */ (function () {
        function NgNoValidate() {
        }
        NgNoValidate.decorators = [
            { type: core.Directive, args: [{
                        selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                        host: { 'novalidate': '' },
                    },] }
        ];
        return NgNoValidate;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var SHARED_FORM_DIRECTIVES = [
        NgNoValidate,
        NgSelectOption,
        NgSelectMultipleOption,
        DefaultValueAccessor,
        NumberValueAccessor,
        RangeValueAccessor,
        CheckboxControlValueAccessor,
        SelectControlValueAccessor,
        SelectMultipleControlValueAccessor,
        RadioControlValueAccessor,
        NgControlStatus,
        NgControlStatusGroup,
        RequiredValidator,
        MinLengthValidator,
        MaxLengthValidator,
        PatternValidator,
        CheckboxRequiredValidator,
        EmailValidator,
    ];
    var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
    var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
    /**
     * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
     */
    var InternalFormsSharedModule = /** @class */ (function () {
        function InternalFormsSharedModule() {
        }
        InternalFormsSharedModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: SHARED_FORM_DIRECTIVES,
                        exports: SHARED_FORM_DIRECTIVES,
                    },] }
        ];
        return InternalFormsSharedModule;
    }());

    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * The ng module for forms.
     *
     */
    var FormsModule = /** @class */ (function () {
        function FormsModule() {
        }
        FormsModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                        providers: [RadioControlRegistry],
                        exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
                    },] }
        ];
        return FormsModule;
    }());
    /**
     * The ng module for reactive forms.
     *
     */
    var ReactiveFormsModule = /** @class */ (function () {
        function ReactiveFormsModule() {
        }
        ReactiveFormsModule.withConfig = function (opts) {
            return {
                ngModule: ReactiveFormsModule,
                providers: [{
                        provide: NG_MODEL_WITH_FORM_CONTROL_WARNING,
                        useValue: opts.warnOnNgModelWithFormControl
                    }]
            };
        };
        ReactiveFormsModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                        providers: [FormBuilder, RadioControlRegistry],
                        exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
                    },] }
        ];
        return ReactiveFormsModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ nextUniqueId$1 = 0;
    /**
     * Single error message to be shown underneath the form field.
     */
    var MatError = /** @class */ (function () {
        function MatError() {
            this.id = "mat-error-" + nextUniqueId$1++;
        }
        MatError.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-error',
                        host: {
                            'class': 'mat-error',
                            'role': 'alert',
                            '[attr.id]': 'id',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatError.propDecorators = {
            "id": [{ type: core.Input },],
        };
        return MatError;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the MatFormField.
     */
    var /** @type {?} */ matFormFieldAnimations = {
        /** Animation that transitions the form field's error and hint messages. */
        transitionMessages: trigger('transitionMessages', [
            // TODO(mmalerba): Use angular animations for label animation as well.
            state('enter', style({ opacity: 1, transform: 'translateY(0%)' })),
            transition('void => enter', [
                style({ opacity: 0, transform: 'translateY(-100%)' }),
                animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
            ]),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * An interface which allows a control to work inside of a `MatFormField`.
     * @abstract
     * @template T
     */
    var  /**
     * An interface which allows a control to work inside of a `MatFormField`.
     * @abstract
     * @template T
     */
    MatFormFieldControl = /** @class */ (function () {
        function MatFormFieldControl() {
        }
        return MatFormFieldControl;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * \@docs-private
     * @return {?}
     */
    function getMatFormFieldPlaceholderConflictError() {
        return Error('Placeholder attribute and child element were both specified.');
    }
    /**
     * \@docs-private
     * @param {?} align
     * @return {?}
     */
    function getMatFormFieldDuplicatedHintError(align) {
        return Error("A hint was already declared for 'align=\"" + align + "\"'.");
    }
    /**
     * \@docs-private
     * @return {?}
     */
    function getMatFormFieldMissingControlError() {
        return Error('mat-form-field must contain a MatFormFieldControl.');
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ nextUniqueId$1$1 = 0;
    /**
     * Hint text to be shown underneath the form field control.
     */
    var MatHint = /** @class */ (function () {
        function MatHint() {
            /**
             * Whether to align the hint label at the start or end of the line.
             */
            this.align = 'start';
            /**
             * Unique ID for the hint. Used for the aria-describedby on the form field control.
             */
            this.id = "mat-hint-" + nextUniqueId$1$1++;
        }
        MatHint.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-hint',
                        host: {
                            'class': 'mat-hint',
                            '[class.mat-right]': 'align == "end"',
                            '[attr.id]': 'id',
                            // Remove align attribute to prevent it from interfering with layout.
                            '[attr.align]': 'null',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatHint.propDecorators = {
            "align": [{ type: core.Input },],
            "id": [{ type: core.Input },],
        };
        return MatHint;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The floating label for a `mat-form-field`.
     */
    var MatLabel = /** @class */ (function () {
        function MatLabel() {
        }
        MatLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-label'
                    },] },
        ];
        return MatLabel;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The placeholder text for an `MatFormField`.
     * @deprecated Use `<mat-label>` to specify the label and the `placeholder` attribute to specify the
     *     placeholder.
     * \@deletion-target 8.0.0
     */
    var MatPlaceholder = /** @class */ (function () {
        function MatPlaceholder() {
        }
        MatPlaceholder.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-placeholder'
                    },] },
        ];
        return MatPlaceholder;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Prefix to be placed the the front of the form field.
     */
    var MatPrefix = /** @class */ (function () {
        function MatPrefix() {
        }
        MatPrefix.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matPrefix]',
                    },] },
        ];
        return MatPrefix;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Suffix to be placed at the end of the form field.
     */
    var MatSuffix = /** @class */ (function () {
        function MatSuffix() {
        }
        MatSuffix.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matSuffix]',
                    },] },
        ];
        return MatSuffix;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ nextUniqueId$2 = 0;
    var /** @type {?} */ floatingLabelScale = 0.75;
    var /** @type {?} */ outlineGapPadding = 5;
    /**
     * Boilerplate for applying mixins to MatFormField.
     * \@docs-private
     */
    var  /**
     * Boilerplate for applying mixins to MatFormField.
     * \@docs-private
     */
    MatFormFieldBase = /** @class */ (function () {
        function MatFormFieldBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatFormFieldBase;
    }());
    /**
     * Base class to which we're applying the form field mixins.
     * \@docs-private
     */
    var /** @type {?} */ _MatFormFieldMixinBase = mixinColor(MatFormFieldBase, 'primary');
    /**
     * Injection token that can be used to configure the
     * default options for all form field within an app.
     */
    var /** @type {?} */ MAT_FORM_FIELD_DEFAULT_OPTIONS = new core.InjectionToken('MAT_FORM_FIELD_DEFAULT_OPTIONS');
    /**
     * Container for form controls that applies Material Design styling and behavior.
     */
    var MatFormField = /** @class */ (function (_super) {
        __extends(MatFormField, _super);
        function MatFormField(_elementRef, _changeDetectorRef, labelOptions, _dir, _defaultOptions, _platform, _ngZone, _animationMode) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._dir = _dir;
            _this._defaultOptions = _defaultOptions;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            /**
             * Override for the logic that disables the label animation in certain cases.
             */
            _this._showAlwaysAnimate = false;
            /**
             * State of the mat-hint and mat-error animations.
             */
            _this._subscriptAnimationState = '';
            _this._hintLabel = '';
            // Unique id for the hint label.
            _this._hintLabelId = "mat-hint-" + nextUniqueId$2++;
            // Unique id for the internal form field label.
            _this._labelId = "mat-form-field-label-" + nextUniqueId$2++;
            _this._outlineGapWidth = 0;
            _this._outlineGapStart = 0;
            _this._initialGapCalculated = false;
            _this._labelOptions = labelOptions ? labelOptions : {};
            _this.floatLabel = _this._labelOptions.float || 'auto';
            _this._animationsEnabled = _animationMode !== 'NoopAnimations';
            return _this;
        }
        Object.defineProperty(MatFormField.prototype, "appearance", {
            get: /**
             * The form-field appearance style.
             * @return {?}
             */
            function () {
                return this._appearance || this._defaultOptions && this._defaultOptions.appearance || 'legacy';
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._appearance = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatFormField.prototype, "hideRequiredMarker", {
            get: /**
             * Whether the required marker should be hidden.
             * @return {?}
             */
            function () { return this._hideRequiredMarker; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._hideRequiredMarker = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatFormField.prototype, "_shouldAlwaysFloat", {
            /** Whether the floating label should always float or not. */
            get: /**
             * Whether the floating label should always float or not.
             * @return {?}
             */
            function () {
                return this.floatLabel === 'always' && !this._showAlwaysAnimate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatFormField.prototype, "_canLabelFloat", {
            /** Whether the label can float or not. */
            get: /**
             * Whether the label can float or not.
             * @return {?}
             */
            function () { return this.floatLabel !== 'never'; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatFormField.prototype, "hintLabel", {
            get: /**
             * Text for the form field hint.
             * @return {?}
             */
            function () { return this._hintLabel; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._hintLabel = value;
                this._processHints();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatFormField.prototype, "floatLabel", {
            get: /**
             * Whether the label should always float, never float or float as the user types.
             *
             * Note: only the legacy appearance supports the `never` option. `never` was originally added as a
             * way to make the floating label emulate the behavior of a standard input placeholder. However
             * the form field now supports both floating labels and placeholders. Therefore in the non-legacy
             * appearances the `never` option has been disabled in favor of just using the placeholder.
             * @return {?}
             */
            function () {
                return this.appearance !== 'legacy' && this._floatLabel === 'never' ? 'auto' : this._floatLabel;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== this._floatLabel) {
                    this._floatLabel = value || this._labelOptions.float || 'auto';
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Gets an ElementRef for the element that a overlay attached to the form-field should be
         * positioned relative to.
         */
        /**
         * Gets an ElementRef for the element that a overlay attached to the form-field should be
         * positioned relative to.
         * @return {?}
         */
        MatFormField.prototype.getConnectedOverlayOrigin = /**
         * Gets an ElementRef for the element that a overlay attached to the form-field should be
         * positioned relative to.
         * @return {?}
         */
        function () {
            return this._connectionContainerRef || this._elementRef;
        };
        /**
         * @return {?}
         */
        MatFormField.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._validateControlChild();
            if (this._control.controlType) {
                this._elementRef.nativeElement.classList
                    .add("mat-form-field-type-" + this._control.controlType);
            }
            // Subscribe to changes in the child control state in order to update the form field UI.
            this._control.stateChanges.pipe(operators.startWith(/** @type {?} */ ((null)))).subscribe(function () {
                _this._validatePlaceholders();
                _this._syncDescribedByIds();
                _this._changeDetectorRef.markForCheck();
            });
            // Run change detection if the value, prefix, or suffix changes.
            var /** @type {?} */ valueChanges = this._control.ngControl && this._control.ngControl.valueChanges || rxjs.EMPTY;
            rxjs.merge(valueChanges, this._prefixChildren.changes, this._suffixChildren.changes)
                .subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
            // Re-validate when the number of hints changes.
            this._hintChildren.changes.pipe(operators.startWith(null)).subscribe(function () {
                _this._processHints();
                _this._changeDetectorRef.markForCheck();
            });
            // Update the aria-described by when the number of errors changes.
            this._errorChildren.changes.pipe(operators.startWith(null)).subscribe(function () {
                _this._syncDescribedByIds();
                _this._changeDetectorRef.markForCheck();
            });
        };
        /**
         * @return {?}
         */
        MatFormField.prototype.ngAfterContentChecked = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._validateControlChild();
            if (!this._initialGapCalculated) {
                // @deletion-target 7.0.0 Remove this check and else block once _ngZone is required.
                if (this._ngZone) {
                    // It's important that we run this outside the `_ngZone`, because the `Promise.resolve`
                    // can kick us into an infinite change detection loop, if the `_initialGapCalculated`
                    // wasn't flipped on for some reason.
                    this._ngZone.runOutsideAngular(function () {
                        Promise.resolve().then(function () { return _this.updateOutlineGap(); });
                    });
                }
                else {
                    Promise.resolve().then(function () { return _this.updateOutlineGap(); });
                }
            }
        };
        /**
         * @return {?}
         */
        MatFormField.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            // Avoid animations on load.
            this._subscriptAnimationState = 'enter';
            this._changeDetectorRef.detectChanges();
        };
        /** Determines whether a class from the NgControl should be forwarded to the host element. */
        /**
         * Determines whether a class from the NgControl should be forwarded to the host element.
         * @param {?} prop
         * @return {?}
         */
        MatFormField.prototype._shouldForward = /**
         * Determines whether a class from the NgControl should be forwarded to the host element.
         * @param {?} prop
         * @return {?}
         */
        function (prop) {
            var /** @type {?} */ ngControl = this._control ? this._control.ngControl : null;
            return ngControl && ngControl[prop];
        };
        /**
         * @return {?}
         */
        MatFormField.prototype._hasPlaceholder = /**
         * @return {?}
         */
        function () {
            return !!(this._control && this._control.placeholder || this._placeholderChild);
        };
        /**
         * @return {?}
         */
        MatFormField.prototype._hasLabel = /**
         * @return {?}
         */
        function () {
            return !!this._labelChild;
        };
        /**
         * @return {?}
         */
        MatFormField.prototype._shouldLabelFloat = /**
         * @return {?}
         */
        function () {
            return this._canLabelFloat && (this._control.shouldLabelFloat || this._shouldAlwaysFloat);
        };
        /**
         * @return {?}
         */
        MatFormField.prototype._hideControlPlaceholder = /**
         * @return {?}
         */
        function () {
            // In the legacy appearance the placeholder is promoted to a label if no label is given.
            return this.appearance === 'legacy' && !this._hasLabel() ||
                this._hasLabel() && !this._shouldLabelFloat();
        };
        /**
         * @return {?}
         */
        MatFormField.prototype._hasFloatingLabel = /**
         * @return {?}
         */
        function () {
            // In the legacy appearance the placeholder is promoted to a label if no label is given.
            return this._hasLabel() || this.appearance === 'legacy' && this._hasPlaceholder();
        };
        /** Determines whether to display hints or errors. */
        /**
         * Determines whether to display hints or errors.
         * @return {?}
         */
        MatFormField.prototype._getDisplayedMessages = /**
         * Determines whether to display hints or errors.
         * @return {?}
         */
        function () {
            return (this._errorChildren && this._errorChildren.length > 0 &&
                this._control.errorState) ? 'error' : 'hint';
        };
        /** Animates the placeholder up and locks it in position. */
        /**
         * Animates the placeholder up and locks it in position.
         * @return {?}
         */
        MatFormField.prototype._animateAndLockLabel = /**
         * Animates the placeholder up and locks it in position.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._hasFloatingLabel() && this._canLabelFloat) {
                // If animations are disabled, we shouldn't go in here,
                // because the `transitionend` will never fire.
                if (this._animationsEnabled) {
                    this._showAlwaysAnimate = true;
                    rxjs.fromEvent(this._label.nativeElement, 'transitionend').pipe(operators.take(1)).subscribe(function () {
                        _this._showAlwaysAnimate = false;
                    });
                }
                this.floatLabel = 'always';
                this._changeDetectorRef.markForCheck();
            }
        };
        /**
         * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
         * or child element with the `mat-placeholder` directive).
         * @return {?}
         */
        MatFormField.prototype._validatePlaceholders = /**
         * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
         * or child element with the `mat-placeholder` directive).
         * @return {?}
         */
        function () {
            if (this._control.placeholder && this._placeholderChild) {
                throw getMatFormFieldPlaceholderConflictError();
            }
        };
        /**
         * Does any extra processing that is required when handling the hints.
         * @return {?}
         */
        MatFormField.prototype._processHints = /**
         * Does any extra processing that is required when handling the hints.
         * @return {?}
         */
        function () {
            this._validateHints();
            this._syncDescribedByIds();
        };
        /**
         * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
         * attribute being considered as `align="start"`.
         * @return {?}
         */
        MatFormField.prototype._validateHints = /**
         * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
         * attribute being considered as `align="start"`.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._hintChildren) {
                var /** @type {?} */ startHint_1;
                var /** @type {?} */ endHint_1;
                this._hintChildren.forEach(function (hint) {
                    if (hint.align === 'start') {
                        if (startHint_1 || _this.hintLabel) {
                            throw getMatFormFieldDuplicatedHintError('start');
                        }
                        startHint_1 = hint;
                    }
                    else if (hint.align === 'end') {
                        if (endHint_1) {
                            throw getMatFormFieldDuplicatedHintError('end');
                        }
                        endHint_1 = hint;
                    }
                });
            }
        };
        /**
         * Sets the list of element IDs that describe the child control. This allows the control to update
         * its `aria-describedby` attribute accordingly.
         * @return {?}
         */
        MatFormField.prototype._syncDescribedByIds = /**
         * Sets the list of element IDs that describe the child control. This allows the control to update
         * its `aria-describedby` attribute accordingly.
         * @return {?}
         */
        function () {
            if (this._control) {
                var /** @type {?} */ ids = [];
                if (this._getDisplayedMessages() === 'hint') {
                    var /** @type {?} */ startHint = this._hintChildren ?
                        this._hintChildren.find(function (hint) { return hint.align === 'start'; }) : null;
                    var /** @type {?} */ endHint = this._hintChildren ?
                        this._hintChildren.find(function (hint) { return hint.align === 'end'; }) : null;
                    if (startHint) {
                        ids.push(startHint.id);
                    }
                    else if (this._hintLabel) {
                        ids.push(this._hintLabelId);
                    }
                    if (endHint) {
                        ids.push(endHint.id);
                    }
                }
                else if (this._errorChildren) {
                    ids = this._errorChildren.map(function (error) { return error.id; });
                }
                this._control.setDescribedByIds(ids);
            }
        };
        /** Throws an error if the form field's control is missing. */
        /**
         * Throws an error if the form field's control is missing.
         * @return {?}
         */
        MatFormField.prototype._validateControlChild = /**
         * Throws an error if the form field's control is missing.
         * @return {?}
         */
        function () {
            if (!this._control) {
                throw getMatFormFieldMissingControlError();
            }
        };
        /**
         * Updates the width and position of the gap in the outline. Only relevant for the outline
         * appearance.
         */
        /**
         * Updates the width and position of the gap in the outline. Only relevant for the outline
         * appearance.
         * @return {?}
         */
        MatFormField.prototype.updateOutlineGap = /**
         * Updates the width and position of the gap in the outline. Only relevant for the outline
         * appearance.
         * @return {?}
         */
        function () {
            if (this.appearance === 'outline' && this._label && this._label.nativeElement.children.length) {
                if (this._platform && !this._platform.isBrowser) {
                    // getBoundingClientRect isn't available on the server.
                    this._initialGapCalculated = true;
                    return;
                }
                if (!document.documentElement.contains(this._elementRef.nativeElement)) {
                    return;
                }
                var /** @type {?} */ containerStart = this._getStartEnd(this._connectionContainerRef.nativeElement.getBoundingClientRect());
                var /** @type {?} */ labelStart = this._getStartEnd(this._label.nativeElement.children[0].getBoundingClientRect());
                var /** @type {?} */ labelWidth = 0;
                for (var _i = 0, _a = this._label.nativeElement.children; _i < _a.length; _i++) {
                    var child = _a[_i];
                    labelWidth += child.offsetWidth;
                }
                this._outlineGapStart = labelStart - containerStart - outlineGapPadding;
                this._outlineGapWidth = labelWidth * floatingLabelScale + outlineGapPadding * 2;
            }
            else {
                this._outlineGapStart = 0;
                this._outlineGapWidth = 0;
            }
            this._initialGapCalculated = true;
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Gets the start end of the rect considering the current directionality.
         * @param {?} rect
         * @return {?}
         */
        MatFormField.prototype._getStartEnd = /**
         * Gets the start end of the rect considering the current directionality.
         * @param {?} rect
         * @return {?}
         */
        function (rect) {
            return this._dir && this._dir.value === 'rtl' ? rect.right : rect.left;
        };
        MatFormField.decorators = [
            { type: core.Component, args: [{selector: 'mat-form-field',
                        exportAs: 'matFormField',
                        template: "<div class=\"mat-form-field-wrapper\"><div class=\"mat-form-field-flex\" #connectionContainer (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"><div class=\"mat-form-field-prefix\" *ngIf=\"_prefixChildren.length\"><ng-content select=\"[matPrefix]\"></ng-content></div><div class=\"mat-form-field-infix\" #inputContainer><ng-content></ng-content><span class=\"mat-form-field-label-wrapper\"><label class=\"mat-form-field-label\" [id]=\"_labelId\" [attr.for]=\"_control.id\" [attr.aria-owns]=\"_control.id\" [class.mat-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-form-field-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" #label *ngIf=\"_hasFloatingLabel()\" [ngSwitch]=\"_hasLabel()\"><ng-container *ngSwitchCase=\"false\"><ng-content select=\"mat-placeholder\"></ng-content>{{_control.placeholder}}</ng-container><ng-content select=\"mat-label\" *ngSwitchCase=\"true\"></ng-content><span class=\"mat-placeholder-required mat-form-field-required-marker\" aria-hidden=\"true\" *ngIf=\"!hideRequiredMarker && _control.required && !_control.disabled\">&nbsp;*</span></label></span></div><div class=\"mat-form-field-suffix\" *ngIf=\"_suffixChildren.length\"><ng-content select=\"[matSuffix]\"></ng-content></div></div><div class=\"mat-form-field-underline\" #underline *ngIf=\"appearance != 'outline'\"><span class=\"mat-form-field-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"></span></div><ng-container *ngIf=\"appearance == 'outline'\"><div class=\"mat-form-field-outline\"><div class=\"mat-form-field-outline-start\" [style.width.px]=\"_outlineGapStart\"></div><div class=\"mat-form-field-outline-gap\" [style.width.px]=\"_outlineGapWidth\"></div><div class=\"mat-form-field-outline-end\"></div></div><div class=\"mat-form-field-outline mat-form-field-outline-thick\"><div class=\"mat-form-field-outline-start\" [style.width.px]=\"_outlineGapStart\"></div><div class=\"mat-form-field-outline-gap\" [style.width.px]=\"_outlineGapWidth\"></div><div class=\"mat-form-field-outline-end\"></div></div></ng-container><div class=\"mat-form-field-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"><div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"><ng-content select=\"mat-error\"></ng-content></div><div class=\"mat-form-field-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"><div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div><ng-content select=\"mat-hint:not([align='end'])\"></ng-content><div class=\"mat-form-field-hint-spacer\"></div><ng-content select=\"mat-hint[align='end']\"></ng-content></div></div></div>",
                        // MatInput is a directive and can't have styles, so we need to include its styles here.
                        // The MatInput styles are fairly minimal so it shouldn't be a big deal for people who
                        // aren't using MatInput.
                        styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;box-sizing:border-box;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none;position:relative}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px}@media screen and (-ms-high-contrast:active){.mat-form-field-infix{border-image:linear-gradient(transparent,transparent)}}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);display:none}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-empty.mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;width:100%;pointer-events:none;transform:scaleY(1.0001)}.mat-form-field-ripple{position:absolute;left:0;width:100%;transform-origin:50%;transform:scaleX(.5);opacity:0;transition:background-color .3s cubic-bezier(.55,0,.55,.2)}.mat-form-field.mat-focused .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple{opacity:1;transform:scaleX(1);transition:transform .3s cubic-bezier(.25,.8,.25,1),opacity .1s cubic-bezier(.25,.8,.25,1),background-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-subscript-wrapper{position:absolute;box-sizing:border-box;width:100%;overflow:hidden}.mat-form-field-label-wrapper .mat-icon,.mat-form-field-subscript-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{display:block}.mat-form-field._mat-animation-noopable .mat-form-field-label,.mat-form-field._mat-animation-noopable .mat-form-field-ripple{transition:none} .mat-form-field-appearance-fill .mat-form-field-flex{border-radius:4px 4px 0 0;padding:.75em .75em 0 .75em}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-fill .mat-form-field-flex{outline:solid 1px}}.mat-form-field-appearance-fill .mat-form-field-underline::before{content:'';display:block;position:absolute;bottom:0;height:1px;width:100%}.mat-form-field-appearance-fill .mat-form-field-ripple{bottom:0;height:2px}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-fill .mat-form-field-ripple{height:0;border-top:solid 2px}}.mat-form-field-appearance-fill:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-fill._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none}.mat-form-field-appearance-fill .mat-form-field-subscript-wrapper{padding:0 1em} .mat-form-field-appearance-legacy .mat-form-field-label{transform:perspective(100px);-ms-transform:none}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-appearance-legacy .mat-form-field-underline{height:1px}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-legacy .mat-form-field-underline{height:0;border-top:solid 1px}}.mat-form-field-appearance-legacy .mat-form-field-ripple{top:0;height:2px}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-legacy .mat-form-field-ripple{height:0;border-top:solid 2px}}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-appearance-legacy.mat-form-field-invalid:not(.mat-focused) .mat-form-field-ripple{height:1px} .mat-form-field-appearance-outline .mat-form-field-wrapper{margin:.25em 0}.mat-form-field-appearance-outline .mat-form-field-flex{padding:0 .75em 0 .75em;margin-top:-.25em}.mat-form-field-appearance-outline .mat-form-field-prefix,.mat-form-field-appearance-outline .mat-form-field-suffix{top:.25em}.mat-form-field-appearance-outline .mat-form-field-outline{display:flex;position:absolute;top:0;left:0;right:0;pointer-events:none}.mat-form-field-appearance-outline .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-start{border:1px solid currentColor;min-width:5px}.mat-form-field-appearance-outline .mat-form-field-outline-start{border-radius:5px 0 0 5px;border-right-style:none}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-start{border-right-style:solid;border-left-style:none;border-radius:0 5px 5px 0}.mat-form-field-appearance-outline .mat-form-field-outline-end{border-radius:0 5px 5px 0;border-left-style:none;flex-grow:1}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-end{border-left-style:solid;border-right-style:none;border-radius:5px 0 0 5px}.mat-form-field-appearance-outline .mat-form-field-outline-gap{border-radius:.000001px;border:1px solid currentColor;border-left-style:none;border-right-style:none}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-outline-gap{border-top-color:transparent}.mat-form-field-appearance-outline .mat-form-field-outline-thick{opacity:0}.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-gap,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-start{border-width:2px;transition:border-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline{opacity:0;transition:opacity .1s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline{opacity:0;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline .mat-form-field-subscript-wrapper{padding:0 1em}.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-end,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-gap,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-start,.mat-form-field-appearance-outline._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline{transition:none} .mat-form-field-appearance-standard .mat-form-field-flex{padding-top:.75em}.mat-form-field-appearance-standard .mat-form-field-underline{height:1px}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-standard .mat-form-field-underline{height:0;border-top:solid 1px}}.mat-form-field-appearance-standard .mat-form-field-ripple{bottom:0;height:2px}@media screen and (-ms-high-contrast:active){.mat-form-field-appearance-standard .mat-form-field-ripple{height:0;border-top:2px}}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-appearance-standard:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-standard._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none} .mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element::-ms-clear,.mat-input-element::-ms-reveal{display:none}.mat-input-element[type=date]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=month]::after,.mat-input-element[type=time]::after,.mat-input-element[type=week]::after{content:' ';white-space:pre;width:1px}.mat-input-element::placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-moz-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-webkit-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element:-ms-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:transparent!important;transition:none}textarea.mat-input-element{resize:vertical;overflow:auto}textarea.mat-input-element.cdk-textarea-autosize{resize:none}textarea.mat-input-element{padding:2px 0;margin:-2px 0}"],
                        animations: [matFormFieldAnimations.transitionMessages],
                        host: {
                            'class': 'mat-form-field',
                            '[class.mat-form-field-appearance-standard]': 'appearance == "standard"',
                            '[class.mat-form-field-appearance-fill]': 'appearance == "fill"',
                            '[class.mat-form-field-appearance-outline]': 'appearance == "outline"',
                            '[class.mat-form-field-appearance-legacy]': 'appearance == "legacy"',
                            '[class.mat-form-field-invalid]': '_control.errorState',
                            '[class.mat-form-field-can-float]': '_canLabelFloat',
                            '[class.mat-form-field-should-float]': '_shouldLabelFloat()',
                            '[class.mat-form-field-hide-placeholder]': '_hideControlPlaceholder()',
                            '[class.mat-form-field-disabled]': '_control.disabled',
                            '[class.mat-form-field-autofilled]': '_control.autofilled',
                            '[class.mat-focused]': '_control.focused',
                            '[class.mat-accent]': 'color == "accent"',
                            '[class.mat-warn]': 'color == "warn"',
                            '[class.ng-untouched]': '_shouldForward("untouched")',
                            '[class.ng-touched]': '_shouldForward("touched")',
                            '[class.ng-pristine]': '_shouldForward("pristine")',
                            '[class.ng-dirty]': '_shouldForward("dirty")',
                            '[class.ng-valid]': '_shouldForward("valid")',
                            '[class.ng-invalid]': '_shouldForward("invalid")',
                            '[class.ng-pending]': '_shouldForward("pending")',
                            '[class._mat-animation-noopable]': '!_animationsEnabled',
                        },
                        inputs: ['color'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatFormField.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_LABEL_GLOBAL_OPTIONS,] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] },] },
            { type: Platform, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatFormField.propDecorators = {
            "appearance": [{ type: core.Input },],
            "hideRequiredMarker": [{ type: core.Input },],
            "hintLabel": [{ type: core.Input },],
            "floatLabel": [{ type: core.Input },],
            "underlineRef": [{ type: core.ViewChild, args: ['underline',] },],
            "_connectionContainerRef": [{ type: core.ViewChild, args: ['connectionContainer',] },],
            "_inputContainerRef": [{ type: core.ViewChild, args: ['inputContainer',] },],
            "_label": [{ type: core.ViewChild, args: ['label',] },],
            "_control": [{ type: core.ContentChild, args: [MatFormFieldControl,] },],
            "_placeholderChild": [{ type: core.ContentChild, args: [MatPlaceholder,] },],
            "_labelChild": [{ type: core.ContentChild, args: [MatLabel,] },],
            "_errorChildren": [{ type: core.ContentChildren, args: [MatError,] },],
            "_hintChildren": [{ type: core.ContentChildren, args: [MatHint,] },],
            "_prefixChildren": [{ type: core.ContentChildren, args: [MatPrefix,] },],
            "_suffixChildren": [{ type: core.ContentChildren, args: [MatSuffix,] },],
        };
        return MatFormField;
    }(_MatFormFieldMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatFormFieldModule = /** @class */ (function () {
        function MatFormFieldModule() {
        }
        MatFormFieldModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: [
                            MatError,
                            MatFormField,
                            MatHint,
                            MatLabel,
                            MatPlaceholder,
                            MatPrefix,
                            MatSuffix,
                        ],
                        imports: [common.CommonModule],
                        exports: [
                            MatError,
                            MatFormField,
                            MatHint,
                            MatLabel,
                            MatPlaceholder,
                            MatPrefix,
                            MatSuffix,
                        ],
                    },] },
        ];
        return MatFormFieldModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Autocomplete IDs need to be unique across components, so this counter exists outside of
     * the component definition.
     */
    var /** @type {?} */ _uniqueAutocompleteIdCounter = 0;
    /**
     * Event object that is emitted when an autocomplete option is selected.
     */
    var  /**
     * Event object that is emitted when an autocomplete option is selected.
     */
    MatAutocompleteSelectedEvent = /** @class */ (function () {
        function MatAutocompleteSelectedEvent(source, option) {
            this.source = source;
            this.option = option;
        }
        return MatAutocompleteSelectedEvent;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatAutocompleteBase = /** @class */ (function () {
        function MatAutocompleteBase() {
        }
        return MatAutocompleteBase;
    }());
    var /** @type {?} */ _MatAutocompleteMixinBase = mixinDisableRipple(MatAutocompleteBase);
    /**
     * Injection token to be used to override the default options for `mat-autocomplete`.
     */
    var /** @type {?} */ MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = new core.InjectionToken('mat-autocomplete-default-options', {
        providedIn: 'root',
        factory: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_AUTOCOMPLETE_DEFAULT_OPTIONS_FACTORY() {
        return { autoActiveFirstOption: false };
    }
    var MatAutocomplete = /** @class */ (function (_super) {
        __extends(MatAutocomplete, _super);
        function MatAutocomplete(_changeDetectorRef, _elementRef, defaults) {
            var _this = _super.call(this) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._elementRef = _elementRef;
            /**
             * Whether the autocomplete panel should be visible, depending on option length.
             */
            _this.showPanel = false;
            _this._isOpen = false;
            /**
             * Function that maps an option's control value to its display value in the trigger.
             */
            _this.displayWith = null;
            /**
             * Event that is emitted whenever an option from the list is selected.
             */
            _this.optionSelected = new core.EventEmitter();
            /**
             * Event that is emitted when the autocomplete panel is opened.
             */
            _this.opened = new core.EventEmitter();
            /**
             * Event that is emitted when the autocomplete panel is closed.
             */
            _this.closed = new core.EventEmitter();
            _this._classList = {};
            /**
             * Unique ID to be used by autocomplete trigger's "aria-owns" property.
             */
            _this.id = "mat-autocomplete-" + _uniqueAutocompleteIdCounter++;
            _this._autoActiveFirstOption = !!defaults.autoActiveFirstOption;
            return _this;
        }
        Object.defineProperty(MatAutocomplete.prototype, "isOpen", {
            /** Whether the autocomplete panel is open. */
            get: /**
             * Whether the autocomplete panel is open.
             * @return {?}
             */
            function () { return this._isOpen && this.showPanel; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatAutocomplete.prototype, "autoActiveFirstOption", {
            get: /**
             * Whether the first option should be highlighted when the autocomplete panel is opened.
             * Can be configured globally through the `MAT_AUTOCOMPLETE_DEFAULT_OPTIONS` token.
             * @return {?}
             */
            function () { return this._autoActiveFirstOption; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._autoActiveFirstOption = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatAutocomplete.prototype, "classList", {
            set: /**
             * Takes classes set on the host mat-autocomplete element and applies them to the panel
             * inside the overlay container to allow for easy styling.
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var _this = this;
                if (value && value.length) {
                    value.split(' ').forEach(function (className) { return _this._classList[className.trim()] = true; });
                    this._elementRef.nativeElement.className = '';
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatAutocomplete.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._keyManager = new ActiveDescendantKeyManager(this.options).withWrap();
            // Set the initial visibility state.
            this._setVisibility();
        };
        /**
         * Sets the panel scrollTop. This allows us to manually scroll to display options
         * above or below the fold, as they are not actually being focused when active.
         */
        /**
         * Sets the panel scrollTop. This allows us to manually scroll to display options
         * above or below the fold, as they are not actually being focused when active.
         * @param {?} scrollTop
         * @return {?}
         */
        MatAutocomplete.prototype._setScrollTop = /**
         * Sets the panel scrollTop. This allows us to manually scroll to display options
         * above or below the fold, as they are not actually being focused when active.
         * @param {?} scrollTop
         * @return {?}
         */
        function (scrollTop) {
            if (this.panel) {
                this.panel.nativeElement.scrollTop = scrollTop;
            }
        };
        /** Returns the panel's scrollTop. */
        /**
         * Returns the panel's scrollTop.
         * @return {?}
         */
        MatAutocomplete.prototype._getScrollTop = /**
         * Returns the panel's scrollTop.
         * @return {?}
         */
        function () {
            return this.panel ? this.panel.nativeElement.scrollTop : 0;
        };
        /** Panel should hide itself when the option list is empty. */
        /**
         * Panel should hide itself when the option list is empty.
         * @return {?}
         */
        MatAutocomplete.prototype._setVisibility = /**
         * Panel should hide itself when the option list is empty.
         * @return {?}
         */
        function () {
            this.showPanel = !!this.options.length;
            this._classList['mat-autocomplete-visible'] = this.showPanel;
            this._classList['mat-autocomplete-hidden'] = !this.showPanel;
            this._changeDetectorRef.markForCheck();
        };
        /** Emits the `select` event. */
        /**
         * Emits the `select` event.
         * @param {?} option
         * @return {?}
         */
        MatAutocomplete.prototype._emitSelectEvent = /**
         * Emits the `select` event.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            var /** @type {?} */ event = new MatAutocompleteSelectedEvent(this, option);
            this.optionSelected.emit(event);
        };
        MatAutocomplete.decorators = [
            { type: core.Component, args: [{selector: 'mat-autocomplete',
                        template: "<ng-template><div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_classList\" #panel><ng-content></ng-content></div></ng-template>",
                        styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative;width:100%}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}@media screen and (-ms-high-contrast:active){.mat-autocomplete-panel{outline:solid 1px}}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        exportAs: 'matAutocomplete',
                        inputs: ['disableRipple'],
                        host: {
                            'class': 'mat-autocomplete'
                        },
                        providers: [
                            { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: MatAutocomplete }
                        ]
                    },] },
        ];
        /** @nocollapse */
        MatAutocomplete.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] },] },
        ]; };
        MatAutocomplete.propDecorators = {
            "template": [{ type: core.ViewChild, args: [core.TemplateRef,] },],
            "panel": [{ type: core.ViewChild, args: ['panel',] },],
            "options": [{ type: core.ContentChildren, args: [MatOption, { descendants: true },] },],
            "optionGroups": [{ type: core.ContentChildren, args: [MatOptgroup,] },],
            "displayWith": [{ type: core.Input },],
            "autoActiveFirstOption": [{ type: core.Input },],
            "optionSelected": [{ type: core.Output },],
            "opened": [{ type: core.Output },],
            "closed": [{ type: core.Output },],
            "classList": [{ type: core.Input, args: ['class',] },],
        };
        return MatAutocomplete;
    }(_MatAutocompleteMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The height of each autocomplete option.
     */
    var /** @type {?} */ AUTOCOMPLETE_OPTION_HEIGHT = 48;
    /**
     * The total height of the autocomplete panel.
     */
    var /** @type {?} */ AUTOCOMPLETE_PANEL_HEIGHT = 256;
    /**
     * Injection token that determines the scroll handling while the autocomplete panel is open.
     */
    var /** @type {?} */ MAT_AUTOCOMPLETE_SCROLL_STRATEGY = new core.InjectionToken('mat-autocomplete-scroll-strategy');
    /**
     * Provider that allows the autocomplete to register as a ControlValueAccessor.
     * \@docs-private
     */
    var /** @type {?} */ MAT_AUTOCOMPLETE_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatAutocompleteTrigger; }),
        multi: true
    };
    /**
     * Creates an error to be thrown when attempting to use an autocomplete trigger without a panel.
     * @return {?}
     */
    function getMatAutocompleteMissingPanelError() {
        return Error('Attempting to open an undefined instance of `mat-autocomplete`. ' +
            'Make sure that the id passed to the `matAutocomplete` is correct and that ' +
            'you\'re attempting to open it after the ngAfterContentInit hook.');
    }
    var MatAutocompleteTrigger = /** @class */ (function () {
        function MatAutocompleteTrigger(_element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, _scrollStrategy, _dir, _formField, _document, _viewportRuler) {
            var _this = this;
            this._element = _element;
            this._overlay = _overlay;
            this._viewContainerRef = _viewContainerRef;
            this._zone = _zone;
            this._changeDetectorRef = _changeDetectorRef;
            this._scrollStrategy = _scrollStrategy;
            this._dir = _dir;
            this._formField = _formField;
            this._document = _document;
            this._viewportRuler = _viewportRuler;
            this._componentDestroyed = false;
            this._autocompleteDisabled = false;
            /**
             * Whether or not the label state is being overridden.
             */
            this._manuallyFloatingLabel = false;
            /**
             * Subscription to viewport size changes.
             */
            this._viewportSubscription = rxjs.Subscription.EMPTY;
            /**
             * Stream of keyboard events that can close the panel.
             */
            this._closeKeyEventStream = new rxjs.Subject();
            /**
             * `View -> model callback called when value changes`
             */
            this._onChange = function () { };
            /**
             * `View -> model callback called when autocomplete has been touched`
             */
            this._onTouched = function () { };
            this._overlayAttached = false;
            /**
             * Stream of autocomplete option selections.
             */
            this.optionSelections = rxjs.defer(function () {
                if (_this.autocomplete && _this.autocomplete.options) {
                    return rxjs.merge.apply(void 0, _this.autocomplete.options.map(function (option) { return option.onSelectionChange; }));
                }
                // If there are any subscribers before `ngAfterViewInit`, the `autocomplete` will be undefined.
                // Return a stream that we'll replace with the real one once everything is in place.
                return _this._zone.onStable
                    .asObservable()
                    .pipe(operators.take(1), operators.switchMap(function () { return _this.optionSelections; }));
            });
        }
        Object.defineProperty(MatAutocompleteTrigger.prototype, "autocompleteDisabled", {
            get: /**
             * Whether the autocomplete is disabled. When disabled, the element will
             * act as a regular input and the user won't be able to open the panel.
             * @return {?}
             */
            function () { return this._autocompleteDisabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._autocompleteDisabled = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._viewportSubscription.unsubscribe();
            this._componentDestroyed = true;
            this._destroyPanel();
            this._closeKeyEventStream.complete();
        };
        Object.defineProperty(MatAutocompleteTrigger.prototype, "panelOpen", {
            /** Whether or not the autocomplete panel is open. */
            get: /**
             * Whether or not the autocomplete panel is open.
             * @return {?}
             */
            function () {
                return this._overlayAttached && this.autocomplete.showPanel;
            },
            enumerable: true,
            configurable: true
        });
        /** Opens the autocomplete suggestion panel. */
        /**
         * Opens the autocomplete suggestion panel.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.openPanel = /**
         * Opens the autocomplete suggestion panel.
         * @return {?}
         */
        function () {
            this._attachOverlay();
            this._floatLabel();
        };
        /** Closes the autocomplete suggestion panel. */
        /**
         * Closes the autocomplete suggestion panel.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.closePanel = /**
         * Closes the autocomplete suggestion panel.
         * @return {?}
         */
        function () {
            this._resetLabel();
            if (!this._overlayAttached) {
                return;
            }
            if (this.panelOpen) {
                // Only emit if the panel was visible.
                this.autocomplete.closed.emit();
            }
            this.autocomplete._isOpen = this._overlayAttached = false;
            if (this._overlayRef && this._overlayRef.hasAttached()) {
                this._overlayRef.detach();
                this._closingActionsSubscription.unsubscribe();
            }
            // Note that in some cases this can end up being called after the component is destroyed.
            // Add a check to ensure that we don't try to run change detection on a destroyed view.
            if (!this._componentDestroyed) {
                // We need to trigger change detection manually, because
                // `fromEvent` doesn't seem to do it at the proper time.
                // This ensures that the label is reset when the
                // user clicks outside.
                this._changeDetectorRef.detectChanges();
            }
        };
        Object.defineProperty(MatAutocompleteTrigger.prototype, "panelClosingActions", {
            /**
             * A stream of actions that should close the autocomplete panel, including
             * when an option is selected, on blur, and when TAB is pressed.
             */
            get: /**
             * A stream of actions that should close the autocomplete panel, including
             * when an option is selected, on blur, and when TAB is pressed.
             * @return {?}
             */
            function () {
                var _this = this;
                return rxjs.merge(this.optionSelections, this.autocomplete._keyManager.tabOut.pipe(operators.filter(function () { return _this._overlayAttached; })), this._closeKeyEventStream, this._outsideClickStream, this._overlayRef ?
                    this._overlayRef.detachments().pipe(operators.filter(function () { return _this._overlayAttached; })) :
                    rxjs.of()).pipe(
                // Normalize the output so we return a consistent type.
                operators.map(function (event) { return event instanceof MatOptionSelectionChange ? event : null; }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatAutocompleteTrigger.prototype, "activeOption", {
            /** The currently active option, coerced to MatOption type. */
            get: /**
             * The currently active option, coerced to MatOption type.
             * @return {?}
             */
            function () {
                if (this.autocomplete && this.autocomplete._keyManager) {
                    return this.autocomplete._keyManager.activeItem;
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatAutocompleteTrigger.prototype, "_outsideClickStream", {
            get: /**
             * Stream of clicks outside of the autocomplete panel.
             * @return {?}
             */
            function () {
                var _this = this;
                if (!this._document) {
                    return rxjs.of(null);
                }
                return rxjs.merge(rxjs.fromEvent(this._document, 'click'), rxjs.fromEvent(this._document, 'touchend'))
                    .pipe(operators.filter(function (event) {
                    var /** @type {?} */ clickTarget = /** @type {?} */ (event.target);
                    var /** @type {?} */ formField = _this._formField ?
                        _this._formField._elementRef.nativeElement : null;
                    return _this._overlayAttached &&
                        clickTarget !== _this._element.nativeElement &&
                        (!formField || !formField.contains(clickTarget)) &&
                        (!!_this._overlayRef && !_this._overlayRef.overlayElement.contains(clickTarget));
                }));
            },
            enumerable: true,
            configurable: true
        });
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} value
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            Promise.resolve(null).then(function () { return _this._setTriggerValue(value); });
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onChange = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        MatAutocompleteTrigger.prototype.setDisabledState = /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this._element.nativeElement.disabled = isDisabled;
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._handleKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            // Prevent the default action on all escape key presses. This is here primarily to bring IE
            // in line with other browsers. By default, pressing escape on IE will cause it to revert
            // the input value to the one that it had on focus, however it won't dispatch any events
            // which means that the model value will be out of sync with the view.
            if (keyCode === ESCAPE) {
                event.preventDefault();
            }
            // Close when pressing ESCAPE or ALT + UP_ARROW, based on the a11y guidelines.
            // See: https://www.w3.org/TR/wai-aria-practices-1.1/#textbox-keyboard-interaction
            if (this.panelOpen && (keyCode === ESCAPE || (keyCode === UP_ARROW && event.altKey))) {
                this._resetActiveItem();
                this._closeKeyEventStream.next();
                event.stopPropagation();
            }
            else if (this.activeOption && keyCode === ENTER && this.panelOpen) {
                this.activeOption._selectViaInteraction();
                this._resetActiveItem();
                event.preventDefault();
            }
            else {
                var /** @type {?} */ prevActiveItem = this.autocomplete._keyManager.activeItem;
                var /** @type {?} */ isArrowKey = keyCode === UP_ARROW || keyCode === DOWN_ARROW;
                if (this.panelOpen || keyCode === TAB) {
                    this.autocomplete._keyManager.onKeydown(event);
                }
                else if (isArrowKey && this._canOpen()) {
                    this.openPanel();
                }
                if (isArrowKey || this.autocomplete._keyManager.activeItem !== prevActiveItem) {
                    this._scrollToOption();
                }
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._handleInput = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ target = /** @type {?} */ (event.target);
            var /** @type {?} */ value = target.value;
            // Based on `NumberValueAccessor` from forms.
            if (target.type === 'number') {
                value = value == '' ? null : parseFloat(value);
            }
            // If the input has a placeholder, IE will fire the `input` event on page load,
            // focus and blur, in addition to when the user actually changed the value. To
            // filter out all of the extra events, we save the value on focus and between
            // `input` events, and we check whether it changed.
            // See: https://connect.microsoft.com/IE/feedback/details/885747/
            if (this._previousValue !== value && document.activeElement === event.target) {
                this._previousValue = value;
                this._onChange(value);
                if (this._canOpen()) {
                    this.openPanel();
                }
            }
        };
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._handleFocus = /**
         * @return {?}
         */
        function () {
            if (this._canOpen()) {
                this._previousValue = this._element.nativeElement.value;
                this._attachOverlay();
                this._floatLabel(true);
            }
        };
        /**
         * In "auto" mode, the label will animate down as soon as focus is lost.
         * This causes the value to jump when selecting an option with the mouse.
         * This method manually floats the label until the panel can be closed.
         * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._floatLabel = /**
         * In "auto" mode, the label will animate down as soon as focus is lost.
         * This causes the value to jump when selecting an option with the mouse.
         * This method manually floats the label until the panel can be closed.
         * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
         * @return {?}
         */
        function (shouldAnimate) {
            if (shouldAnimate === void 0) { shouldAnimate = false; }
            if (this._formField && this._formField.floatLabel === 'auto') {
                if (shouldAnimate) {
                    this._formField._animateAndLockLabel();
                }
                else {
                    this._formField.floatLabel = 'always';
                }
                this._manuallyFloatingLabel = true;
            }
        };
        /**
         * If the label has been manually elevated, return it to its normal state.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._resetLabel = /**
         * If the label has been manually elevated, return it to its normal state.
         * @return {?}
         */
        function () {
            if (this._manuallyFloatingLabel) {
                this._formField.floatLabel = 'auto';
                this._manuallyFloatingLabel = false;
            }
        };
        /**
         * Given that we are not actually focusing active options, we must manually adjust scroll
         * to reveal options below the fold. First, we find the offset of the option from the top
         * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
         * the panel height + the option height, so the active option will be just visible at the
         * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
         * will become the offset. If that offset is visible within the panel already, the scrollTop is
         * not adjusted.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._scrollToOption = /**
         * Given that we are not actually focusing active options, we must manually adjust scroll
         * to reveal options below the fold. First, we find the offset of the option from the top
         * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
         * the panel height + the option height, so the active option will be just visible at the
         * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
         * will become the offset. If that offset is visible within the panel already, the scrollTop is
         * not adjusted.
         * @return {?}
         */
        function () {
            var /** @type {?} */ index = this.autocomplete._keyManager.activeItemIndex || 0;
            var /** @type {?} */ labelCount = _countGroupLabelsBeforeOption(index, this.autocomplete.options, this.autocomplete.optionGroups);
            var /** @type {?} */ newScrollPosition = _getOptionScrollPosition(index + labelCount, AUTOCOMPLETE_OPTION_HEIGHT, this.autocomplete._getScrollTop(), AUTOCOMPLETE_PANEL_HEIGHT);
            this.autocomplete._setScrollTop(newScrollPosition);
        };
        /**
         * This method listens to a stream of panel closing actions and resets the
         * stream every time the option list changes.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._subscribeToClosingActions = /**
         * This method listens to a stream of panel closing actions and resets the
         * stream every time the option list changes.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ firstStable = this._zone.onStable.asObservable().pipe(operators.take(1));
            var /** @type {?} */ optionChanges = this.autocomplete.options.changes.pipe(operators.tap(function () { return _this._positionStrategy.reapplyLastPosition(); }), 
            // Defer emitting to the stream until the next tick, because changing
            // bindings in here will cause "changed after checked" errors.
            operators.delay(0));
            // When the zone is stable initially, and when the option list changes...
            return rxjs.merge(firstStable, optionChanges)
                .pipe(
            // create a new stream of panelClosingActions, replacing any previous streams
            // that were created, and flatten it so our stream only emits closing events...
            operators.switchMap(function () {
                _this._resetActiveItem();
                _this.autocomplete._setVisibility();
                return _this.panelClosingActions;
            }), 
            // when the first closing event occurs...
            operators.take(1))
                .subscribe(function (event) { return _this._setValueAndClose(event); });
        };
        /**
         * Destroys the autocomplete suggestion panel.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._destroyPanel = /**
         * Destroys the autocomplete suggestion panel.
         * @return {?}
         */
        function () {
            if (this._overlayRef) {
                this.closePanel();
                this._overlayRef.dispose();
                this._overlayRef = null;
            }
        };
        /**
         * @param {?} value
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._setTriggerValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ toDisplay = this.autocomplete && this.autocomplete.displayWith ?
                this.autocomplete.displayWith(value) :
                value;
            // Simply falling back to an empty string if the display value is falsy does not work properly.
            // The display value can also be the number zero and shouldn't fall back to an empty string.
            var /** @type {?} */ inputValue = toDisplay != null ? toDisplay : '';
            // If it's used within a `MatFormField`, we should set it through the property so it can go
            // through change detection.
            if (this._formField) {
                this._formField._control.value = inputValue;
            }
            else {
                this._element.nativeElement.value = inputValue;
            }
        };
        /**
         * This method closes the panel, and if a value is specified, also sets the associated
         * control to that value. It will also mark the control as dirty if this interaction
         * stemmed from the user.
         * @param {?} event
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._setValueAndClose = /**
         * This method closes the panel, and if a value is specified, also sets the associated
         * control to that value. It will also mark the control as dirty if this interaction
         * stemmed from the user.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event && event.source) {
                this._clearPreviousSelectedOption(event.source);
                this._setTriggerValue(event.source.value);
                this._onChange(event.source.value);
                this._element.nativeElement.focus();
                this.autocomplete._emitSelectEvent(event.source);
            }
            this.closePanel();
        };
        /**
         * Clear any previous selected option and emit a selection change event for this option
         * @param {?} skip
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._clearPreviousSelectedOption = /**
         * Clear any previous selected option and emit a selection change event for this option
         * @param {?} skip
         * @return {?}
         */
        function (skip) {
            this.autocomplete.options.forEach(function (option) {
                if (option != skip && option.selected) {
                    option.deselect();
                }
            });
        };
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._attachOverlay = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this.autocomplete) {
                throw getMatAutocompleteMissingPanelError();
            }
            if (!this._overlayRef) {
                this._portal = new TemplatePortal(this.autocomplete.template, this._viewContainerRef);
                this._overlayRef = this._overlay.create(this._getOverlayConfig());
                if (this._viewportRuler) {
                    this._viewportSubscription = this._viewportRuler.change().subscribe(function () {
                        if (_this.panelOpen && _this._overlayRef) {
                            _this._overlayRef.updateSize({ width: _this._getHostWidth() });
                        }
                    });
                }
            }
            else {
                // Update the panel width and direction, in case anything has changed.
                this._overlayRef.updateSize({ width: this._getHostWidth() });
            }
            if (this._overlayRef && !this._overlayRef.hasAttached()) {
                this._overlayRef.attach(this._portal);
                this._closingActionsSubscription = this._subscribeToClosingActions();
            }
            var /** @type {?} */ wasOpen = this.panelOpen;
            this.autocomplete._setVisibility();
            this.autocomplete._isOpen = this._overlayAttached = true;
            // We need to do an extra `panelOpen` check in here, because the
            // autocomplete won't be shown if there are no options.
            if (this.panelOpen && wasOpen !== this.panelOpen) {
                this.autocomplete.opened.emit();
            }
        };
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._getOverlayConfig = /**
         * @return {?}
         */
        function () {
            return new OverlayConfig({
                positionStrategy: this._getOverlayPosition(),
                scrollStrategy: this._scrollStrategy(),
                width: this._getHostWidth(),
                direction: this._dir
            });
        };
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._getOverlayPosition = /**
         * @return {?}
         */
        function () {
            this._positionStrategy = this._overlay.position()
                .flexibleConnectedTo(this._getConnectedElement())
                .withFlexibleDimensions(false)
                .withPush(false)
                .withPositions([
                { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
                { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' }
            ]);
            return this._positionStrategy;
        };
        /**
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._getConnectedElement = /**
         * @return {?}
         */
        function () {
            if (this.connectedTo) {
                return this.connectedTo.elementRef;
            }
            return this._formField ? this._formField.getConnectedOverlayOrigin() : this._element;
        };
        /**
         * Returns the width of the input element, so the panel width can match it.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._getHostWidth = /**
         * Returns the width of the input element, so the panel width can match it.
         * @return {?}
         */
        function () {
            return this._getConnectedElement().nativeElement.getBoundingClientRect().width;
        };
        /**
         * Resets the active item to -1 so arrow events will activate the
         * correct options, or to 0 if the consumer opted into it.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._resetActiveItem = /**
         * Resets the active item to -1 so arrow events will activate the
         * correct options, or to 0 if the consumer opted into it.
         * @return {?}
         */
        function () {
            this.autocomplete._keyManager.setActiveItem(this.autocomplete.autoActiveFirstOption ? 0 : -1);
        };
        /**
         * Determines whether the panel can be opened.
         * @return {?}
         */
        MatAutocompleteTrigger.prototype._canOpen = /**
         * Determines whether the panel can be opened.
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this._element.nativeElement;
            return !element.readOnly && !element.disabled && !this._autocompleteDisabled;
        };
        MatAutocompleteTrigger.decorators = [
            { type: core.Directive, args: [{
                        selector: "input[matAutocomplete], textarea[matAutocomplete]",
                        host: {
                            'autocomplete': 'off',
                            '[attr.role]': 'autocompleteDisabled ? null : "combobox"',
                            '[attr.aria-autocomplete]': 'autocompleteDisabled ? null : "list"',
                            '[attr.aria-activedescendant]': 'activeOption?.id',
                            '[attr.aria-expanded]': 'autocompleteDisabled ? null : panelOpen.toString()',
                            '[attr.aria-owns]': 'autocompleteDisabled ? null : autocomplete?.id',
                            // Note: we use `focusin`, as opposed to `focus`, in order to open the panel
                            // a little earlier. This avoids issues where IE delays the focusing of the input.
                            '(focusin)': '_handleFocus()',
                            '(blur)': '_onTouched()',
                            '(input)': '_handleInput($event)',
                            '(keydown)': '_handleKeydown($event)',
                        },
                        exportAs: 'matAutocompleteTrigger',
                        providers: [MAT_AUTOCOMPLETE_VALUE_ACCESSOR]
                    },] },
        ];
        /** @nocollapse */
        MatAutocompleteTrigger.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Overlay, },
            { type: core.ViewContainerRef, },
            { type: core.NgZone, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY,] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: MatFormField, decorators: [{ type: core.Optional }, { type: core.Host },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: ViewportRuler, },
        ]; };
        MatAutocompleteTrigger.propDecorators = {
            "autocomplete": [{ type: core.Input, args: ['matAutocomplete',] },],
            "connectedTo": [{ type: core.Input, args: ['matAutocompleteConnectedTo',] },],
            "autocompleteDisabled": [{ type: core.Input, args: ['matAutocompleteDisabled',] },],
        };
        return MatAutocompleteTrigger;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ nextId$1 = 0;
    /**
     * Directive to display a text badge.
     */
    var MatBadge = /** @class */ (function () {
        function MatBadge(_document, _ngZone, _elementRef, _ariaDescriber) {
            this._document = _document;
            this._ngZone = _ngZone;
            this._elementRef = _elementRef;
            this._ariaDescriber = _ariaDescriber;
            this._color = 'primary';
            this._overlap = true;
            /**
             * Position the badge should reside.
             * Accepts any combination of 'above'|'below' and 'before'|'after'
             */
            this.position = 'above after';
            /**
             * Size of the badge. Can be 'small', 'medium', or 'large'.
             */
            this.size = 'medium';
            /**
             * Unique id for the badge
             */
            this._id = nextId$1++;
        }
        Object.defineProperty(MatBadge.prototype, "color", {
            get: /**
             * The color of the badge. Can be `primary`, `accent`, or `warn`.
             * @return {?}
             */
            function () { return this._color; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._setColor(value);
                this._color = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatBadge.prototype, "overlap", {
            get: /**
             * Whether the badge should overlap its contents or not
             * @return {?}
             */
            function () { return this._overlap; },
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                this._overlap = coerceBooleanProperty(val);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatBadge.prototype, "content", {
            get: /**
             * The content for the badge
             * @return {?}
             */
            function () { return this._content; },
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                this._content = val;
                this._updateTextContent();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatBadge.prototype, "description", {
            get: /**
             * Message used to describe the decorated element via aria-describedby
             * @return {?}
             */
            function () { return this._description; },
            set: /**
             * @param {?} newDescription
             * @return {?}
             */
            function (newDescription) {
                if (newDescription !== this._description) {
                    this._updateHostAriaDescription(newDescription, this._description);
                    this._description = newDescription;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatBadge.prototype, "hidden", {
            get: /**
             * Whether the badge is hidden.
             * @return {?}
             */
            function () { return this._hidden; },
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                this._hidden = coerceBooleanProperty(val);
            },
            enumerable: true,
            configurable: true
        });
        /** Whether the badge is above the host or not */
        /**
         * Whether the badge is above the host or not
         * @return {?}
         */
        MatBadge.prototype.isAbove = /**
         * Whether the badge is above the host or not
         * @return {?}
         */
        function () {
            return this.position.indexOf('below') === -1;
        };
        /** Whether the badge is after the host or not */
        /**
         * Whether the badge is after the host or not
         * @return {?}
         */
        MatBadge.prototype.isAfter = /**
         * Whether the badge is after the host or not
         * @return {?}
         */
        function () {
            return this.position.indexOf('before') === -1;
        };
        /**
         * @return {?}
         */
        MatBadge.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this.description && this._badgeElement) {
                this._ariaDescriber.removeDescription(this._badgeElement, this.description);
            }
        };
        /**
         * Injects a span element into the DOM with the content.
         * @return {?}
         */
        MatBadge.prototype._updateTextContent = /**
         * Injects a span element into the DOM with the content.
         * @return {?}
         */
        function () {
            if (!this._badgeElement) {
                this._badgeElement = this._createBadgeElement();
            }
            else {
                this._badgeElement.textContent = this.content;
            }
            return this._badgeElement;
        };
        /**
         * Creates the badge element
         * @return {?}
         */
        MatBadge.prototype._createBadgeElement = /**
         * Creates the badge element
         * @return {?}
         */
        function () {
            var /** @type {?} */ badgeElement = this._document.createElement('span');
            var /** @type {?} */ activeClass = 'mat-badge-active';
            badgeElement.setAttribute('id', "mat-badge-content-" + this._id);
            badgeElement.classList.add('mat-badge-content');
            badgeElement.textContent = this.content;
            if (this.description) {
                badgeElement.setAttribute('aria-label', this.description);
            }
            this._elementRef.nativeElement.appendChild(badgeElement);
            // animate in after insertion
            if (typeof requestAnimationFrame === 'function') {
                this._ngZone.runOutsideAngular(function () {
                    requestAnimationFrame(function () {
                        badgeElement.classList.add(activeClass);
                    });
                });
            }
            else {
                badgeElement.classList.add(activeClass);
            }
            return badgeElement;
        };
        /**
         * Sets the aria-label property on the element
         * @param {?} newDescription
         * @param {?} oldDescription
         * @return {?}
         */
        MatBadge.prototype._updateHostAriaDescription = /**
         * Sets the aria-label property on the element
         * @param {?} newDescription
         * @param {?} oldDescription
         * @return {?}
         */
        function (newDescription, oldDescription) {
            // ensure content available before setting label
            var /** @type {?} */ content = this._updateTextContent();
            if (oldDescription) {
                this._ariaDescriber.removeDescription(content, oldDescription);
            }
            if (newDescription) {
                this._ariaDescriber.describe(content, newDescription);
            }
        };
        /**
         * Adds css theme class given the color to the component host
         * @param {?} colorPalette
         * @return {?}
         */
        MatBadge.prototype._setColor = /**
         * Adds css theme class given the color to the component host
         * @param {?} colorPalette
         * @return {?}
         */
        function (colorPalette) {
            if (colorPalette !== this._color) {
                if (this._color) {
                    this._elementRef.nativeElement.classList.remove("mat-badge-" + this._color);
                }
                if (colorPalette) {
                    this._elementRef.nativeElement.classList.add("mat-badge-" + colorPalette);
                }
            }
        };
        MatBadge.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matBadge]',
                        host: {
                            'class': 'mat-badge',
                            '[class.mat-badge-overlap]': 'overlap',
                            '[class.mat-badge-above]': 'isAbove()',
                            '[class.mat-badge-below]': '!isAbove()',
                            '[class.mat-badge-before]': '!isAfter()',
                            '[class.mat-badge-after]': 'isAfter()',
                            '[class.mat-badge-small]': 'size === "small"',
                            '[class.mat-badge-medium]': 'size === "medium"',
                            '[class.mat-badge-large]': 'size === "large"',
                            '[class.mat-badge-hidden]': 'hidden',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatBadge.ctorParameters = function () { return [
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: core.NgZone, },
            { type: core.ElementRef, },
            { type: AriaDescriber, },
        ]; };
        MatBadge.propDecorators = {
            "color": [{ type: core.Input, args: ['matBadgeColor',] },],
            "overlap": [{ type: core.Input, args: ['matBadgeOverlap',] },],
            "position": [{ type: core.Input, args: ['matBadgePosition',] },],
            "content": [{ type: core.Input, args: ['matBadge',] },],
            "description": [{ type: core.Input, args: ['matBadgeDescription',] },],
            "size": [{ type: core.Input, args: ['matBadgeSize',] },],
            "hidden": [{ type: core.Input, args: ['matBadgeHidden',] },],
        };
        return MatBadge;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Global registry for all dynamically-created, injected media queries.
     */
    var /** @type {?} */ mediaQueriesForWebkitCompatibility = new Set();
    /**
     * Style tag that holds all of the dynamically-created media queries.
     */
    var /** @type {?} */ mediaQueryStyleNode;
    /**
     * A utility for calling matchMedia queries.
     */
    var MediaMatcher = /** @class */ (function () {
        function MediaMatcher(platform) {
            this.platform = platform;
            this._matchMedia = this.platform.isBrowser && window.matchMedia ?
                // matchMedia is bound to the window scope intentionally as it is an illegal invocation to
                // call it from a different scope.
                window.matchMedia.bind(window) :
                noopMatchMedia;
        }
        /**
         * Evaluates the given media query and returns the native MediaQueryList from which results
         * can be retrieved.
         * Confirms the layout engine will trigger for the selector query provided and returns the
         * MediaQueryList for the query provided.
         */
        /**
         * Evaluates the given media query and returns the native MediaQueryList from which results
         * can be retrieved.
         * Confirms the layout engine will trigger for the selector query provided and returns the
         * MediaQueryList for the query provided.
         * @param {?} query
         * @return {?}
         */
        MediaMatcher.prototype.matchMedia = /**
         * Evaluates the given media query and returns the native MediaQueryList from which results
         * can be retrieved.
         * Confirms the layout engine will trigger for the selector query provided and returns the
         * MediaQueryList for the query provided.
         * @param {?} query
         * @return {?}
         */
        function (query) {
            if (this.platform.WEBKIT) {
                createEmptyStyleRule(query);
            }
            return this._matchMedia(query);
        };
        MediaMatcher.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        MediaMatcher.ctorParameters = function () { return [
            { type: Platform, },
        ]; };
        /** @nocollapse */ MediaMatcher.ngInjectableDef = core.defineInjectable({ factory: function MediaMatcher_Factory() { return new MediaMatcher(core.inject(Platform)); }, token: MediaMatcher, providedIn: "root" });
        return MediaMatcher;
    }());
    /**
     * For Webkit engines that only trigger the MediaQueryListListener when
     * there is at least one CSS selector for the respective media query.
     * @param {?} query
     * @return {?}
     */
    function createEmptyStyleRule(query) {
        if (mediaQueriesForWebkitCompatibility.has(query)) {
            return;
        }
        try {
            if (!mediaQueryStyleNode) {
                mediaQueryStyleNode = document.createElement('style');
                mediaQueryStyleNode.setAttribute('type', 'text/css');
                document.head.appendChild(mediaQueryStyleNode);
            }
            if (mediaQueryStyleNode.sheet) {
                (/** @type {?} */ (mediaQueryStyleNode.sheet))
                    .insertRule("@media " + query + " {.fx-query-test{ }}", 0);
                mediaQueriesForWebkitCompatibility.add(query);
            }
        }
        catch (/** @type {?} */ e) {
            console.error(e);
        }
    }
    /**
     * No-op matchMedia replacement for non-browser platforms.
     * @param {?} query
     * @return {?}
     */
    function noopMatchMedia(query) {
        return {
            matches: query === 'all' || query === '',
            media: query,
            addListener: function () { },
            removeListener: function () { }
        };
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Utility for checking the matching state of \@media queries.
     */
    var BreakpointObserver = /** @class */ (function () {
        function BreakpointObserver(mediaMatcher, zone) {
            this.mediaMatcher = mediaMatcher;
            this.zone = zone;
            /**
             * A map of all media queries currently being listened for.
             */
            this._queries = new Map();
            /**
             * A subject for all other observables to takeUntil based on.
             */
            this._destroySubject = new rxjs.Subject();
        }
        /** Completes the active subject, signalling to all other observables to complete. */
        /**
         * Completes the active subject, signalling to all other observables to complete.
         * @return {?}
         */
        BreakpointObserver.prototype.ngOnDestroy = /**
         * Completes the active subject, signalling to all other observables to complete.
         * @return {?}
         */
        function () {
            this._destroySubject.next();
            this._destroySubject.complete();
        };
        /**
         * Whether one or more media queries match the current viewport size.
         * @param value One or more media queries to check.
         * @returns Whether any of the media queries match.
         */
        /**
         * Whether one or more media queries match the current viewport size.
         * @param {?} value One or more media queries to check.
         * @return {?} Whether any of the media queries match.
         */
        BreakpointObserver.prototype.isMatched = /**
         * Whether one or more media queries match the current viewport size.
         * @param {?} value One or more media queries to check.
         * @return {?} Whether any of the media queries match.
         */
        function (value) {
            var _this = this;
            var /** @type {?} */ queries = splitQueries(coerceArray(value));
            return queries.some(function (mediaQuery) { return _this._registerQuery(mediaQuery).mql.matches; });
        };
        /**
         * Gets an observable of results for the given queries that will emit new results for any changes
         * in matching of the given queries.
         * @param value One or more media queries to check.
         * @returns A stream of matches for the given queries.
         */
        /**
         * Gets an observable of results for the given queries that will emit new results for any changes
         * in matching of the given queries.
         * @param {?} value One or more media queries to check.
         * @return {?} A stream of matches for the given queries.
         */
        BreakpointObserver.prototype.observe = /**
         * Gets an observable of results for the given queries that will emit new results for any changes
         * in matching of the given queries.
         * @param {?} value One or more media queries to check.
         * @return {?} A stream of matches for the given queries.
         */
        function (value) {
            var _this = this;
            var /** @type {?} */ queries = splitQueries(coerceArray(value));
            var /** @type {?} */ observables = queries.map(function (query) { return _this._registerQuery(query).observable; });
            return rxjs.combineLatest(observables).pipe(operators.map(function (breakpointStates) {
                return {
                    matches: breakpointStates.some(function (state) { return state && state.matches; })
                };
            }));
        };
        /**
         * Registers a specific query to be listened for.
         * @param {?} query
         * @return {?}
         */
        BreakpointObserver.prototype._registerQuery = /**
         * Registers a specific query to be listened for.
         * @param {?} query
         * @return {?}
         */
        function (query) {
            var _this = this;
            // Only set up a new MediaQueryList if it is not already being listened for.
            if (this._queries.has(query)) {
                return /** @type {?} */ ((this._queries.get(query)));
            }
            var /** @type {?} */ mql = this.mediaMatcher.matchMedia(query);
            // Create callback for match changes and add it is as a listener.
            var /** @type {?} */ queryObservable = rxjs.fromEventPattern(
            // Listener callback methods are wrapped to be placed back in ngZone. Callbacks must be placed
            // back into the zone because matchMedia is only included in Zone.js by loading the
            // webapis-media-query.js file alongside the zone.js file.  Additionally, some browsers do not
            // have MediaQueryList inherit from EventTarget, which causes inconsistencies in how Zone.js
            // patches it.
            // Listener callback methods are wrapped to be placed back in ngZone. Callbacks must be placed
            // back into the zone because matchMedia is only included in Zone.js by loading the
            // webapis-media-query.js file alongside the zone.js file.  Additionally, some browsers do not
            // have MediaQueryList inherit from EventTarget, which causes inconsistencies in how Zone.js
            // patches it.
            function (listener) {
                mql.addListener(function (e) { return _this.zone.run(function () { return listener(e); }); });
            }, function (listener) {
                mql.removeListener(function (e) { return _this.zone.run(function () { return listener(e); }); });
            })
                .pipe(operators.takeUntil(this._destroySubject), operators.startWith(mql), operators.map(function (nextMql) { return ({ matches: nextMql.matches }); }));
            // Add the MediaQueryList to the set of queries.
            var /** @type {?} */ output = { observable: queryObservable, mql: mql };
            this._queries.set(query, output);
            return output;
        };
        BreakpointObserver.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        BreakpointObserver.ctorParameters = function () { return [
            { type: MediaMatcher, },
            { type: core.NgZone, },
        ]; };
        /** @nocollapse */ BreakpointObserver.ngInjectableDef = core.defineInjectable({ factory: function BreakpointObserver_Factory() { return new BreakpointObserver(core.inject(MediaMatcher), core.inject(core.NgZone)); }, token: BreakpointObserver, providedIn: "root" });
        return BreakpointObserver;
    }());
    /**
     * Split each query string into separate query strings if two queries are provided as comma
     * separated.
     * @param {?} queries
     * @return {?}
     */
    function splitQueries(queries) {
        return queries.map(function (query) { return query.split(','); })
            .reduce(function (a1, a2) { return a1.concat(a2); })
            .map(function (query) { return query.trim(); });
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    var /** @type {?} */ Breakpoints = {
        XSmall: '(max-width: 599px)',
        Small: '(min-width: 600px) and (max-width: 959px)',
        Medium: '(min-width: 960px) and (max-width: 1279px)',
        Large: '(min-width: 1280px) and (max-width: 1919px)',
        XLarge: '(min-width: 1920px)',
        Handset: '(max-width: 599px) and (orientation: portrait), ' +
            '(max-width: 959px) and (orientation: landscape)',
        Tablet: '(min-width: 600px) and (max-width: 839px) and (orientation: portrait), ' +
            '(min-width: 960px) and (max-width: 1279px) and (orientation: landscape)',
        Web: '(min-width: 840px) and (orientation: portrait), ' +
            '(min-width: 1280px) and (orientation: landscape)',
        HandsetPortrait: '(max-width: 599px) and (orientation: portrait)',
        TabletPortrait: '(min-width: 600px) and (max-width: 839px) and (orientation: portrait)',
        WebPortrait: '(min-width: 840px) and (orientation: portrait)',
        HandsetLandscape: '(max-width: 959px) and (orientation: landscape)',
        TabletLandscape: '(min-width: 960px) and (max-width: 1279px) and (orientation: landscape)',
        WebLandscape: '(min-width: 1280px) and (orientation: landscape)',
    };

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to access the data that was passed in to a bottom sheet.
     */
    var /** @type {?} */ MAT_BOTTOM_SHEET_DATA = new core.InjectionToken('MatBottomSheetData');
    /**
     * Configuration used when opening a bottom sheet.
     * @template D
     */
    var  /**
     * Configuration used when opening a bottom sheet.
     * @template D
     */
    MatBottomSheetConfig = /** @class */ (function () {
        function MatBottomSheetConfig() {
            /**
             * Data being injected into the child component.
             */
            this.data = null;
            /**
             * Whether the bottom sheet has a backdrop.
             */
            this.hasBackdrop = true;
            /**
             * Whether the user can use escape or clicking outside to close the bottom sheet.
             */
            this.disableClose = false;
            /**
             * Aria label to assign to the bottom sheet element.
             */
            this.ariaLabel = null;
        }
        return MatBottomSheetConfig;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material bottom sheet.
     */
    var /** @type {?} */ matBottomSheetAnimations = {
        /** Animation that shows and hides a bottom sheet. */
        bottomSheetState: trigger('state', [
            state('void, hidden', style({ transform: 'translateY(100%)' })),
            state('visible', style({ transform: 'translateY(0%)' })),
            transition('visible => void, visible => hidden', animate(AnimationDurations.COMPLEX + " " + AnimationCurves.ACCELERATION_CURVE)),
            transition('void => visible', animate(AnimationDurations.EXITING + " " + AnimationCurves.DECELERATION_CURVE)),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Internal component that wraps user-provided bottom sheet content.
     * \@docs-private
     */
    var MatBottomSheetContainer = /** @class */ (function (_super) {
        __extends(MatBottomSheetContainer, _super);
        function MatBottomSheetContainer(_elementRef, _changeDetectorRef, _focusTrapFactory, breakpointObserver, document, bottomSheetConfig) {
            var _this = _super.call(this) || this;
            _this._elementRef = _elementRef;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._focusTrapFactory = _focusTrapFactory;
            _this.bottomSheetConfig = bottomSheetConfig;
            /**
             * The state of the bottom sheet animations.
             */
            _this._animationState = 'void';
            /**
             * Emits whenever the state of the animation changes.
             */
            _this._animationStateChanged = new core.EventEmitter();
            /**
             * Element that was focused before the bottom sheet was opened.
             */
            _this._elementFocusedBeforeOpened = null;
            _this._document = document;
            _this._breakpointSubscription = breakpointObserver
                .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
                .subscribe(function () {
                _this._toggleClass('mat-bottom-sheet-container-medium', breakpointObserver.isMatched(Breakpoints.Medium));
                _this._toggleClass('mat-bottom-sheet-container-large', breakpointObserver.isMatched(Breakpoints.Large));
                _this._toggleClass('mat-bottom-sheet-container-xlarge', breakpointObserver.isMatched(Breakpoints.XLarge));
            });
            return _this;
        }
        /** Attach a component portal as content to this bottom sheet container. */
        /**
         * Attach a component portal as content to this bottom sheet container.
         * @template T
         * @param {?} portal
         * @return {?}
         */
        MatBottomSheetContainer.prototype.attachComponentPortal = /**
         * Attach a component portal as content to this bottom sheet container.
         * @template T
         * @param {?} portal
         * @return {?}
         */
        function (portal) {
            this._validatePortalAttached();
            this._setPanelClass();
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachComponentPortal(portal);
        };
        /** Attach a template portal as content to this bottom sheet container. */
        /**
         * Attach a template portal as content to this bottom sheet container.
         * @template C
         * @param {?} portal
         * @return {?}
         */
        MatBottomSheetContainer.prototype.attachTemplatePortal = /**
         * Attach a template portal as content to this bottom sheet container.
         * @template C
         * @param {?} portal
         * @return {?}
         */
        function (portal) {
            this._validatePortalAttached();
            this._setPanelClass();
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachTemplatePortal(portal);
        };
        /** Begin animation of bottom sheet entrance into view. */
        /**
         * Begin animation of bottom sheet entrance into view.
         * @return {?}
         */
        MatBottomSheetContainer.prototype.enter = /**
         * Begin animation of bottom sheet entrance into view.
         * @return {?}
         */
        function () {
            if (!this._destroyed) {
                this._animationState = 'visible';
                this._changeDetectorRef.detectChanges();
            }
        };
        /** Begin animation of the bottom sheet exiting from view. */
        /**
         * Begin animation of the bottom sheet exiting from view.
         * @return {?}
         */
        MatBottomSheetContainer.prototype.exit = /**
         * Begin animation of the bottom sheet exiting from view.
         * @return {?}
         */
        function () {
            if (!this._destroyed) {
                this._animationState = 'hidden';
                this._changeDetectorRef.markForCheck();
            }
        };
        /**
         * @return {?}
         */
        MatBottomSheetContainer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._breakpointSubscription.unsubscribe();
            this._destroyed = true;
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatBottomSheetContainer.prototype._onAnimationDone = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.toState === 'visible') {
                this._trapFocus();
            }
            else if (event.toState === 'hidden') {
                this._restoreFocus();
            }
            this._animationStateChanged.emit(event);
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatBottomSheetContainer.prototype._onAnimationStart = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this._animationStateChanged.emit(event);
        };
        /**
         * @param {?} cssClass
         * @param {?} add
         * @return {?}
         */
        MatBottomSheetContainer.prototype._toggleClass = /**
         * @param {?} cssClass
         * @param {?} add
         * @return {?}
         */
        function (cssClass, add) {
            var /** @type {?} */ classList = this._elementRef.nativeElement.classList;
            add ? classList.add(cssClass) : classList.remove(cssClass);
        };
        /**
         * @return {?}
         */
        MatBottomSheetContainer.prototype._validatePortalAttached = /**
         * @return {?}
         */
        function () {
            if (this._portalOutlet.hasAttached()) {
                throw Error('Attempting to attach bottom sheet content after content is already attached');
            }
        };
        /**
         * @return {?}
         */
        MatBottomSheetContainer.prototype._setPanelClass = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this._elementRef.nativeElement;
            var /** @type {?} */ panelClass = this.bottomSheetConfig.panelClass;
            if (Array.isArray(panelClass)) {
                // Note that we can't use a spread here, because IE doesn't support multiple arguments.
                panelClass.forEach(function (cssClass) { return element.classList.add(cssClass); });
            }
            else if (panelClass) {
                element.classList.add(panelClass);
            }
        };
        /**
         * Moves the focus inside the focus trap.
         * @return {?}
         */
        MatBottomSheetContainer.prototype._trapFocus = /**
         * Moves the focus inside the focus trap.
         * @return {?}
         */
        function () {
            if (!this._focusTrap) {
                this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
            }
            this._focusTrap.focusInitialElementWhenReady();
        };
        /**
         * Restores focus to the element that was focused before the bottom sheet opened.
         * @return {?}
         */
        MatBottomSheetContainer.prototype._restoreFocus = /**
         * Restores focus to the element that was focused before the bottom sheet opened.
         * @return {?}
         */
        function () {
            var /** @type {?} */ toFocus = this._elementFocusedBeforeOpened;
            // We need the extra check, because IE can set the `activeElement` to null in some cases.
            if (toFocus && typeof toFocus.focus === 'function') {
                toFocus.focus();
            }
            if (this._focusTrap) {
                this._focusTrap.destroy();
            }
        };
        /**
         * Saves a reference to the element that was focused before the bottom sheet was opened.
         * @return {?}
         */
        MatBottomSheetContainer.prototype._savePreviouslyFocusedElement = /**
         * Saves a reference to the element that was focused before the bottom sheet was opened.
         * @return {?}
         */
        function () {
            var _this = this;
            this._elementFocusedBeforeOpened = /** @type {?} */ (this._document.activeElement);
            // The `focus` method isn't available during server-side rendering.
            if (this._elementRef.nativeElement.focus) {
                Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
            }
        };
        MatBottomSheetContainer.decorators = [
            { type: core.Component, args: [{selector: 'mat-bottom-sheet-container',
                        template: "<ng-template cdkPortalOutlet></ng-template>",
                        styles: [".mat-bottom-sheet-container{box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12);padding:8px 16px;min-width:100vw;box-sizing:border-box;display:block;outline:0;max-height:80vh;overflow:auto}@media screen and (-ms-high-contrast:active){.mat-bottom-sheet-container{outline:1px solid}}.mat-bottom-sheet-container-medium{min-width:384px;max-width:calc(100vw - 128px)}.mat-bottom-sheet-container-large{min-width:512px;max-width:calc(100vw - 256px)}.mat-bottom-sheet-container-xlarge{min-width:576px;max-width:calc(100vw - 384px)}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        animations: [matBottomSheetAnimations.bottomSheetState],
                        host: {
                            'class': 'mat-bottom-sheet-container',
                            'tabindex': '-1',
                            'role': 'dialog',
                            'aria-modal': 'true',
                            '[attr.aria-label]': 'bottomSheetConfig?.ariaLabel',
                            '[@state]': '_animationState',
                            '(@state.start)': '_onAnimationStart($event)',
                            '(@state.done)': '_onAnimationDone($event)'
                        },
                    },] },
        ];
        /** @nocollapse */
        MatBottomSheetContainer.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: FocusTrapFactory, },
            { type: BreakpointObserver, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: MatBottomSheetConfig, },
        ]; };
        MatBottomSheetContainer.propDecorators = {
            "_portalOutlet": [{ type: core.ViewChild, args: [CdkPortalOutlet,] },],
        };
        return MatBottomSheetContainer;
    }(BasePortalOutlet));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatBottomSheetModule = /** @class */ (function () {
        function MatBottomSheetModule() {
        }
        MatBottomSheetModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            OverlayModule,
                            MatCommonModule,
                            PortalModule,
                        ],
                        exports: [MatBottomSheetContainer, MatCommonModule],
                        declarations: [MatBottomSheetContainer],
                        entryComponents: [MatBottomSheetContainer],
                    },] },
        ];
        return MatBottomSheetModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Reference to a bottom sheet dispatched from the bottom sheet service.
     * @template T, R
     */
    var  /**
     * Reference to a bottom sheet dispatched from the bottom sheet service.
     * @template T, R
     */
    MatBottomSheetRef = /** @class */ (function () {
        function MatBottomSheetRef(containerInstance, _overlayRef) {
            var _this = this;
            this._overlayRef = _overlayRef;
            /**
             * Subject for notifying the user that the bottom sheet has been dismissed.
             */
            this._afterDismissed = new rxjs.Subject();
            /**
             * Subject for notifying the user that the bottom sheet has opened and appeared.
             */
            this._afterOpened = new rxjs.Subject();
            this.containerInstance = containerInstance;
            // Emit when opening animation completes
            containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'done' && event.toState === 'visible'; }), operators.take(1))
                .subscribe(function () {
                _this._afterOpened.next();
                _this._afterOpened.complete();
            });
            // Dispose overlay when closing animation is complete
            containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'done' && event.toState === 'hidden'; }), operators.take(1))
                .subscribe(function () {
                _this._overlayRef.dispose();
                _this._afterDismissed.next(_this._result);
                _this._afterDismissed.complete();
            });
            if (!containerInstance.bottomSheetConfig.disableClose) {
                rxjs.merge(_overlayRef.backdropClick(), _overlayRef._keydownEvents.pipe(operators.filter(function (event) { return event.keyCode === ESCAPE; }))).subscribe(function () { return _this.dismiss(); });
            }
        }
        /**
         * Dismisses the bottom sheet.
         * @param result Data to be passed back to the bottom sheet opener.
         */
        /**
         * Dismisses the bottom sheet.
         * @param {?=} result Data to be passed back to the bottom sheet opener.
         * @return {?}
         */
        MatBottomSheetRef.prototype.dismiss = /**
         * Dismisses the bottom sheet.
         * @param {?=} result Data to be passed back to the bottom sheet opener.
         * @return {?}
         */
        function (result) {
            var _this = this;
            if (!this._afterDismissed.closed) {
                // Transition the backdrop in parallel to the bottom sheet.
                this.containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'start'; }), operators.take(1)).subscribe(function () { return _this._overlayRef.detachBackdrop(); });
                this._result = result;
                this.containerInstance.exit();
            }
        };
        /** Gets an observable that is notified when the bottom sheet is finished closing. */
        /**
         * Gets an observable that is notified when the bottom sheet is finished closing.
         * @return {?}
         */
        MatBottomSheetRef.prototype.afterDismissed = /**
         * Gets an observable that is notified when the bottom sheet is finished closing.
         * @return {?}
         */
        function () {
            return this._afterDismissed.asObservable();
        };
        /** Gets an observable that is notified when the bottom sheet has opened and appeared. */
        /**
         * Gets an observable that is notified when the bottom sheet has opened and appeared.
         * @return {?}
         */
        MatBottomSheetRef.prototype.afterOpened = /**
         * Gets an observable that is notified when the bottom sheet has opened and appeared.
         * @return {?}
         */
        function () {
            return this._afterOpened.asObservable();
        };
        /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         */
        /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         * @return {?}
         */
        MatBottomSheetRef.prototype.backdropClick = /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         * @return {?}
         */
        function () {
            return this._overlayRef.backdropClick();
        };
        /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         */
        /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         * @return {?}
         */
        MatBottomSheetRef.prototype.keydownEvents = /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         * @return {?}
         */
        function () {
            return this._overlayRef.keydownEvents();
        };
        return MatBottomSheetRef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Service to trigger Material Design bottom sheets.
     */
    var MatBottomSheet = /** @class */ (function () {
        function MatBottomSheet(_overlay, _injector, _parentBottomSheet) {
            this._overlay = _overlay;
            this._injector = _injector;
            this._parentBottomSheet = _parentBottomSheet;
            this._bottomSheetRefAtThisLevel = null;
        }
        Object.defineProperty(MatBottomSheet.prototype, "_openedBottomSheetRef", {
            /** Reference to the currently opened bottom sheet. */
            get: /**
             * Reference to the currently opened bottom sheet.
             * @return {?}
             */
            function () {
                var /** @type {?} */ parent = this._parentBottomSheet;
                return parent ? parent._openedBottomSheetRef : this._bottomSheetRefAtThisLevel;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this._parentBottomSheet) {
                    this._parentBottomSheet._openedBottomSheetRef = value;
                }
                else {
                    this._bottomSheetRefAtThisLevel = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @template T, D, R
         * @param {?} componentOrTemplateRef
         * @param {?=} config
         * @return {?}
         */
        MatBottomSheet.prototype.open = /**
         * @template T, D, R
         * @param {?} componentOrTemplateRef
         * @param {?=} config
         * @return {?}
         */
        function (componentOrTemplateRef, config) {
            var _this = this;
            var /** @type {?} */ _config = _applyConfigDefaults(config);
            var /** @type {?} */ overlayRef = this._createOverlay(_config);
            var /** @type {?} */ container = this._attachContainer(overlayRef, _config);
            var /** @type {?} */ ref = new MatBottomSheetRef(container, overlayRef);
            if (componentOrTemplateRef instanceof core.TemplateRef) {
                container.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, /** @type {?} */ ((null)), /** @type {?} */ ({
                    $implicit: _config.data,
                    bottomSheetRef: ref
                })));
            }
            else {
                var /** @type {?} */ portal = new ComponentPortal(componentOrTemplateRef, undefined, this._createInjector(_config, ref));
                var /** @type {?} */ contentRef = container.attachComponentPortal(portal);
                ref.instance = contentRef.instance;
            }
            // When the bottom sheet is dismissed, clear the reference to it.
            ref.afterDismissed().subscribe(function () {
                // Clear the bottom sheet ref if it hasn't already been replaced by a newer one.
                if (_this._openedBottomSheetRef == ref) {
                    _this._openedBottomSheetRef = null;
                }
            });
            if (this._openedBottomSheetRef) {
                // If a bottom sheet is already in view, dismiss it and enter the
                // new bottom sheet after exit animation is complete.
                this._openedBottomSheetRef.afterDismissed().subscribe(function () { return ref.containerInstance.enter(); });
                this._openedBottomSheetRef.dismiss();
            }
            else {
                // If no bottom sheet is in view, enter the new bottom sheet.
                ref.containerInstance.enter();
            }
            this._openedBottomSheetRef = ref;
            return ref;
        };
        /**
         * Dismisses the currently-visible bottom sheet.
         */
        /**
         * Dismisses the currently-visible bottom sheet.
         * @return {?}
         */
        MatBottomSheet.prototype.dismiss = /**
         * Dismisses the currently-visible bottom sheet.
         * @return {?}
         */
        function () {
            if (this._openedBottomSheetRef) {
                this._openedBottomSheetRef.dismiss();
            }
        };
        /**
         * Attaches the bottom sheet container component to the overlay.
         * @param {?} overlayRef
         * @param {?} config
         * @return {?}
         */
        MatBottomSheet.prototype._attachContainer = /**
         * Attaches the bottom sheet container component to the overlay.
         * @param {?} overlayRef
         * @param {?} config
         * @return {?}
         */
        function (overlayRef, config) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var /** @type {?} */ injector = new PortalInjector(userInjector || this._injector, new WeakMap([
                [MatBottomSheetConfig, config]
            ]));
            var /** @type {?} */ containerPortal = new ComponentPortal(MatBottomSheetContainer, config.viewContainerRef, injector);
            var /** @type {?} */ containerRef = overlayRef.attach(containerPortal);
            return containerRef.instance;
        };
        /**
         * Creates a new overlay and places it in the correct location.
         * @param {?} config The user-specified bottom sheet config.
         * @return {?}
         */
        MatBottomSheet.prototype._createOverlay = /**
         * Creates a new overlay and places it in the correct location.
         * @param {?} config The user-specified bottom sheet config.
         * @return {?}
         */
        function (config) {
            var /** @type {?} */ overlayConfig = new OverlayConfig({
                direction: config.direction,
                hasBackdrop: config.hasBackdrop,
                maxWidth: '100%',
                scrollStrategy: this._overlay.scrollStrategies.block(),
                positionStrategy: this._overlay.position()
                    .global()
                    .centerHorizontally()
                    .bottom('0')
            });
            if (config.backdropClass) {
                overlayConfig.backdropClass = config.backdropClass;
            }
            return this._overlay.create(overlayConfig);
        };
        /**
         * Creates an injector to be used inside of a bottom sheet component.
         * @template T
         * @param {?} config Config that was used to create the bottom sheet.
         * @param {?} bottomSheetRef Reference to the bottom sheet.
         * @return {?}
         */
        MatBottomSheet.prototype._createInjector = /**
         * Creates an injector to be used inside of a bottom sheet component.
         * @template T
         * @param {?} config Config that was used to create the bottom sheet.
         * @param {?} bottomSheetRef Reference to the bottom sheet.
         * @return {?}
         */
        function (config, bottomSheetRef) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var /** @type {?} */ injectionTokens = new WeakMap([
                [MatBottomSheetRef, bottomSheetRef],
                [MAT_BOTTOM_SHEET_DATA, config.data]
            ]);
            if (config.direction &&
                (!userInjector || !userInjector.get(Directionality, null))) {
                injectionTokens.set(Directionality, {
                    value: config.direction,
                    change: rxjs.of()
                });
            }
            return new PortalInjector(userInjector || this._injector, injectionTokens);
        };
        MatBottomSheet.decorators = [
            { type: core.Injectable, args: [{ providedIn: MatBottomSheetModule },] },
        ];
        /** @nocollapse */
        MatBottomSheet.ctorParameters = function () { return [
            { type: Overlay, },
            { type: core.Injector, },
            { type: MatBottomSheet, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
        ]; };
        /** @nocollapse */ MatBottomSheet.ngInjectableDef = core.defineInjectable({ factory: function MatBottomSheet_Factory() { return new MatBottomSheet(core.inject(Overlay), core.inject(core.INJECTOR), core.inject(MatBottomSheet, 12)); }, token: MatBottomSheet, providedIn: MatBottomSheetModule });
        return MatBottomSheet;
    }());
    /**
     * Applies default options to the bottom sheet config.
     * @param {?=} config The configuration to which the defaults will be applied.
     * @return {?} The new configuration object with defaults applied.
     */
    function _applyConfigDefaults(config) {
        return __assign({}, new MatBottomSheetConfig(), config);
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Default color palette for round buttons (mat-fab and mat-mini-fab)
     */
    var /** @type {?} */ DEFAULT_ROUND_BUTTON_COLOR = 'accent';
    /**
     * Default color palette for flat buttons (mat-flat-button)
     */
    var /** @type {?} */ DEFAULT_FLAT_BUTTON_COLOR = 'primary';
    /**
     * List of classes to add to MatButton instances based on host attributes to
     * style as different variants.
     */
    var /** @type {?} */ BUTTON_HOST_ATTRIBUTES = [
        'mat-button',
        'mat-flat-button',
        'mat-icon-button',
        'mat-raised-button',
        'mat-stroked-button',
        'mat-mini-fab',
        'mat-fab',
    ];
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatButtonBase = /** @class */ (function () {
        function MatButtonBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatButtonBase;
    }());
    var /** @type {?} */ _MatButtonMixinBase = mixinColor(mixinDisabled(mixinDisableRipple(MatButtonBase)));
    /**
     * Material design button.
     */
    var MatButton = /** @class */ (function (_super) {
        __extends(MatButton, _super);
        function MatButton(elementRef, _platform, _focusMonitor, 
        // @deletion-target 7.0.0 `_animationMode` parameter to be made required.
        _animationMode) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._focusMonitor = _focusMonitor;
            _this._animationMode = _animationMode;
            /**
             * Whether the button is round.
             */
            _this.isRoundButton = _this._hasHostAttributes('mat-fab', 'mat-mini-fab');
            /**
             * Whether the button is icon button.
             */
            _this.isIconButton = _this._hasHostAttributes('mat-icon-button');
            // For each of the variant selectors that is prevent in the button's host
            // attributes, add the correct corresponding class.
            for (var _i = 0, BUTTON_HOST_ATTRIBUTES_1 = BUTTON_HOST_ATTRIBUTES; _i < BUTTON_HOST_ATTRIBUTES_1.length; _i++) {
                var attr = BUTTON_HOST_ATTRIBUTES_1[_i];
                if (_this._hasHostAttributes(attr)) {
                    (/** @type {?} */ (elementRef.nativeElement)).classList.add(attr);
                }
            }
            _this._focusMonitor.monitor(_this._elementRef.nativeElement, true);
            if (_this.isRoundButton) {
                _this.color = DEFAULT_ROUND_BUTTON_COLOR;
            }
            else if (_this._hasHostAttributes('mat-flat-button')) {
                _this.color = DEFAULT_FLAT_BUTTON_COLOR;
            }
            return _this;
        }
        /**
         * @return {?}
         */
        MatButton.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
        };
        /** Focuses the button. */
        /**
         * Focuses the button.
         * @return {?}
         */
        MatButton.prototype.focus = /**
         * Focuses the button.
         * @return {?}
         */
        function () {
            this._getHostElement().focus();
        };
        /**
         * @return {?}
         */
        MatButton.prototype._getHostElement = /**
         * @return {?}
         */
        function () {
            return this._elementRef.nativeElement;
        };
        /**
         * @return {?}
         */
        MatButton.prototype._isRippleDisabled = /**
         * @return {?}
         */
        function () {
            return this.disableRipple || this.disabled;
        };
        /** Gets whether the button has one of the given attributes. */
        /**
         * Gets whether the button has one of the given attributes.
         * @param {...?} attributes
         * @return {?}
         */
        MatButton.prototype._hasHostAttributes = /**
         * Gets whether the button has one of the given attributes.
         * @param {...?} attributes
         * @return {?}
         */
        function () {
            var _this = this;
            var attributes = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                attributes[_i] = arguments[_i];
            }
            return attributes.some(function (attribute) { return _this._getHostElement().hasAttribute(attribute); });
        };
        MatButton.decorators = [
            { type: core.Component, args: [{selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],\n             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],\n             button[mat-flat-button]",
                        exportAs: 'matButton',
                        host: {
                            '[disabled]': 'disabled || null',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        },
                        template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
                        styles: [".mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:1}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-raised-button{transition:none;animation:none}.mat-raised-button:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-raised-button[disabled]{box-shadow:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-fab{transition:none;animation:none}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-fab[disabled]{box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-mini-fab{transition:none;animation:none}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable .mat-button-focus-overlay{transition:none}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
                        inputs: ['disabled', 'disableRipple', 'color'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatButton.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: FocusMonitor, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatButton.propDecorators = {
            "ripple": [{ type: core.ViewChild, args: [MatRipple,] },],
        };
        return MatButton;
    }(_MatButtonMixinBase));
    /**
     * Raised Material design button.
     */
    var MatAnchor = /** @class */ (function (_super) {
        __extends(MatAnchor, _super);
        function MatAnchor(platform, focusMonitor, elementRef, 
        // @deletion-target 7.0.0 `animationMode` parameter to be made required.
        animationMode) {
            return _super.call(this, elementRef, platform, focusMonitor, animationMode) || this;
        }
        /**
         * @param {?} event
         * @return {?}
         */
        MatAnchor.prototype._haltDisabledEvents = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // A disabled button shouldn't apply any actions
            if (this.disabled) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        MatAnchor.decorators = [
            { type: core.Component, args: [{selector: "a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab],\n             a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]",
                        exportAs: 'matButton, matAnchor',
                        host: {
                            '[attr.tabindex]': 'disabled ? -1 : 0',
                            '[attr.disabled]': 'disabled || null',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '(click)': '_haltDisabledEvents($event)',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        },
                        inputs: ['disabled', 'disableRipple', 'color'],
                        template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
                        styles: [".mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:1}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-raised-button{transition:none;animation:none}.mat-raised-button:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-raised-button[disabled]{box-shadow:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-fab{transition:none;animation:none}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-fab[disabled]{box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}._mat-animation-noopable.mat-mini-fab{transition:none;animation:none}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}._mat-animation-noopable .mat-button-focus-overlay{transition:none}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatAnchor.ctorParameters = function () { return [
            { type: Platform, },
            { type: FocusMonitor, },
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        return MatAnchor;
    }(MatButton));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatButtonModule = /** @class */ (function () {
        function MatButtonModule() {
        }
        MatButtonModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            MatRippleModule,
                            MatCommonModule,
                        ],
                        exports: [
                            MatButton,
                            MatAnchor,
                            MatCommonModule,
                        ],
                        declarations: [
                            MatButton,
                            MatAnchor,
                        ],
                    },] },
        ];
        return MatButtonModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * @abstract
     * @template T
     */
    var  /**
     * @abstract
     * @template T
     */
    DataSource = /** @class */ (function () {
        function DataSource() {
        }
        return DataSource;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * DataSource wrapper for a native array.
     * @template T
     */
    var  /**
     * DataSource wrapper for a native array.
     * @template T
     */
    ArrayDataSource = /** @class */ (function (_super) {
        __extends(ArrayDataSource, _super);
        function ArrayDataSource(_data) {
            var _this = _super.call(this) || this;
            _this._data = _data;
            return _this;
        }
        /**
         * @return {?}
         */
        ArrayDataSource.prototype.connect = /**
         * @return {?}
         */
        function () {
            return this._data instanceof rxjs.Observable ? this._data : rxjs.of(this._data);
        };
        /**
         * @return {?}
         */
        ArrayDataSource.prototype.disconnect = /**
         * @return {?}
         */
        function () { };
        return ArrayDataSource;
    }(DataSource));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Class to be used to power selecting one or more options from a list.
     * @template T
     */
    var  /**
     * Class to be used to power selecting one or more options from a list.
     * @template T
     */
    SelectionModel = /** @class */ (function () {
        function SelectionModel(_multiple, initiallySelectedValues, _emitChanges) {
            if (_multiple === void 0) { _multiple = false; }
            if (_emitChanges === void 0) { _emitChanges = true; }
            var _this = this;
            this._multiple = _multiple;
            this._emitChanges = _emitChanges;
            /**
             * Currently-selected values.
             */
            this._selection = new Set();
            /**
             * Keeps track of the deselected options that haven't been emitted by the change event.
             */
            this._deselectedToEmit = [];
            /**
             * Keeps track of the selected options that haven't been emitted by the change event.
             */
            this._selectedToEmit = [];
            /**
             * Event emitted when the value has changed.
             */
            this.onChange = this._emitChanges ? new rxjs.Subject() : null;
            if (initiallySelectedValues && initiallySelectedValues.length) {
                if (_multiple) {
                    initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
                }
                else {
                    this._markSelected(initiallySelectedValues[0]);
                }
                // Clear the array in order to avoid firing the change event for preselected values.
                this._selectedToEmit.length = 0;
            }
        }
        Object.defineProperty(SelectionModel.prototype, "selected", {
            /** Selected values. */
            get: /**
             * Selected values.
             * @return {?}
             */
            function () {
                if (!this._selected) {
                    this._selected = Array.from(this._selection.values());
                }
                return this._selected;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Selects a value or an array of values.
         */
        /**
         * Selects a value or an array of values.
         * @param {...?} values
         * @return {?}
         */
        SelectionModel.prototype.select = /**
         * Selects a value or an array of values.
         * @param {...?} values
         * @return {?}
         */
        function () {
            var _this = this;
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            this._verifyValueAssignment(values);
            values.forEach(function (value) { return _this._markSelected(value); });
            this._emitChangeEvent();
        };
        /**
         * Deselects a value or an array of values.
         */
        /**
         * Deselects a value or an array of values.
         * @param {...?} values
         * @return {?}
         */
        SelectionModel.prototype.deselect = /**
         * Deselects a value or an array of values.
         * @param {...?} values
         * @return {?}
         */
        function () {
            var _this = this;
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            this._verifyValueAssignment(values);
            values.forEach(function (value) { return _this._unmarkSelected(value); });
            this._emitChangeEvent();
        };
        /**
         * Toggles a value between selected and deselected.
         */
        /**
         * Toggles a value between selected and deselected.
         * @param {?} value
         * @return {?}
         */
        SelectionModel.prototype.toggle = /**
         * Toggles a value between selected and deselected.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.isSelected(value) ? this.deselect(value) : this.select(value);
        };
        /**
         * Clears all of the selected values.
         */
        /**
         * Clears all of the selected values.
         * @return {?}
         */
        SelectionModel.prototype.clear = /**
         * Clears all of the selected values.
         * @return {?}
         */
        function () {
            this._unmarkAll();
            this._emitChangeEvent();
        };
        /**
         * Determines whether a value is selected.
         */
        /**
         * Determines whether a value is selected.
         * @param {?} value
         * @return {?}
         */
        SelectionModel.prototype.isSelected = /**
         * Determines whether a value is selected.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            return this._selection.has(value);
        };
        /**
         * Determines whether the model does not have a value.
         */
        /**
         * Determines whether the model does not have a value.
         * @return {?}
         */
        SelectionModel.prototype.isEmpty = /**
         * Determines whether the model does not have a value.
         * @return {?}
         */
        function () {
            return this._selection.size === 0;
        };
        /**
         * Determines whether the model has a value.
         */
        /**
         * Determines whether the model has a value.
         * @return {?}
         */
        SelectionModel.prototype.hasValue = /**
         * Determines whether the model has a value.
         * @return {?}
         */
        function () {
            return !this.isEmpty();
        };
        /**
         * Sorts the selected values based on a predicate function.
         */
        /**
         * Sorts the selected values based on a predicate function.
         * @param {?=} predicate
         * @return {?}
         */
        SelectionModel.prototype.sort = /**
         * Sorts the selected values based on a predicate function.
         * @param {?=} predicate
         * @return {?}
         */
        function (predicate) {
            if (this._multiple && this.selected) {
                /** @type {?} */ ((this._selected)).sort(predicate);
            }
        };
        /**
         * Gets whether multiple values can be selected.
         */
        /**
         * Gets whether multiple values can be selected.
         * @return {?}
         */
        SelectionModel.prototype.isMultipleSelection = /**
         * Gets whether multiple values can be selected.
         * @return {?}
         */
        function () {
            return this._multiple;
        };
        /**
         * Emits a change event and clears the records of selected and deselected values.
         * @return {?}
         */
        SelectionModel.prototype._emitChangeEvent = /**
         * Emits a change event and clears the records of selected and deselected values.
         * @return {?}
         */
        function () {
            // Clear the selected values so they can be re-cached.
            this._selected = null;
            if (this._selectedToEmit.length || this._deselectedToEmit.length) {
                if (this.onChange) {
                    this.onChange.next({
                        source: this,
                        added: this._selectedToEmit,
                        removed: this._deselectedToEmit
                    });
                }
                this._deselectedToEmit = [];
                this._selectedToEmit = [];
            }
        };
        /**
         * Selects a value.
         * @param {?} value
         * @return {?}
         */
        SelectionModel.prototype._markSelected = /**
         * Selects a value.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (!this.isSelected(value)) {
                if (!this._multiple) {
                    this._unmarkAll();
                }
                this._selection.add(value);
                if (this._emitChanges) {
                    this._selectedToEmit.push(value);
                }
            }
        };
        /**
         * Deselects a value.
         * @param {?} value
         * @return {?}
         */
        SelectionModel.prototype._unmarkSelected = /**
         * Deselects a value.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.isSelected(value)) {
                this._selection.delete(value);
                if (this._emitChanges) {
                    this._deselectedToEmit.push(value);
                }
            }
        };
        /**
         * Clears out the selected values.
         * @return {?}
         */
        SelectionModel.prototype._unmarkAll = /**
         * Clears out the selected values.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this.isEmpty()) {
                this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
            }
        };
        /**
         * Verifies the value assignment and throws an error if the specified value array is
         * including multiple values while the selection model is not supporting multiple values.
         * @param {?} values
         * @return {?}
         */
        SelectionModel.prototype._verifyValueAssignment = /**
         * Verifies the value assignment and throws an error if the specified value array is
         * including multiple values while the selection model is not supporting multiple values.
         * @param {?} values
         * @return {?}
         */
        function (values) {
            if (values.length > 1 && !this._multiple) {
                throw getMultipleValuesInSingleSelectionError();
            }
        };
        return SelectionModel;
    }());
    /**
     * Returns an error that reports that multiple values are passed into a selection model
     * with a single value.
     * @return {?}
     */
    function getMultipleValuesInSingleSelectionError() {
        return Error('Cannot pass multiple values into SelectionModel with single-value mode.');
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Class to coordinate unique selection based on name.
     * Intended to be consumed as an Angular service.
     * This service is needed because native radio change events are only fired on the item currently
     * being selected, and we still need to uncheck the previous selection.
     *
     * This service does not *store* any IDs and names because they may change at any time, so it is
     * less error-prone if they are simply passed through when the events occur.
     */
    var UniqueSelectionDispatcher = /** @class */ (function () {
        function UniqueSelectionDispatcher() {
            this._listeners = [];
        }
        /**
         * Notify other items that selection for the given name has been set.
         * @param id ID of the item.
         * @param name Name of the item.
         */
        /**
         * Notify other items that selection for the given name has been set.
         * @param {?} id ID of the item.
         * @param {?} name Name of the item.
         * @return {?}
         */
        UniqueSelectionDispatcher.prototype.notify = /**
         * Notify other items that selection for the given name has been set.
         * @param {?} id ID of the item.
         * @param {?} name Name of the item.
         * @return {?}
         */
        function (id, name) {
            for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener(id, name);
            }
        };
        /**
         * Listen for future changes to item selection.
         * @return Function used to deregister listener
         */
        /**
         * Listen for future changes to item selection.
         * @param {?} listener
         * @return {?} Function used to deregister listener
         */
        UniqueSelectionDispatcher.prototype.listen = /**
         * Listen for future changes to item selection.
         * @param {?} listener
         * @return {?} Function used to deregister listener
         */
        function (listener) {
            var _this = this;
            this._listeners.push(listener);
            return function () {
                _this._listeners = _this._listeners.filter(function (registered) {
                    return listener !== registered;
                });
            };
        };
        /**
         * @return {?}
         */
        UniqueSelectionDispatcher.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._listeners = [];
        };
        UniqueSelectionDispatcher.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ UniqueSelectionDispatcher.ngInjectableDef = core.defineInjectable({ factory: function UniqueSelectionDispatcher_Factory() { return new UniqueSelectionDispatcher(); }, token: UniqueSelectionDispatcher, providedIn: "root" });
        return UniqueSelectionDispatcher;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatButtonToggleGroupBase = /** @class */ (function () {
        function MatButtonToggleGroupBase() {
        }
        return MatButtonToggleGroupBase;
    }());
    var /** @type {?} */ _MatButtonToggleGroupMixinBase = mixinDisabled(MatButtonToggleGroupBase);
    /**
     * Provider Expression that allows mat-button-toggle-group to register as a ControlValueAccessor.
     * This allows it to support [(ngModel)].
     * \@docs-private
     */
    var /** @type {?} */ MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatButtonToggleGroup; }),
        multi: true
    };
    /**
     * @deprecated Use `MatButtonToggleGroup` instead.
     * \@deletion-target 7.0.0
     */
    var  /**
     * @deprecated Use `MatButtonToggleGroup` instead.
     * \@deletion-target 7.0.0
     */
    MatButtonToggleGroupMultiple = /** @class */ (function () {
        function MatButtonToggleGroupMultiple() {
        }
        return MatButtonToggleGroupMultiple;
    }());
    var /** @type {?} */ _uniqueIdCounter$1 = 0;
    /**
     * Change event object emitted by MatButtonToggle.
     */
    var  /**
     * Change event object emitted by MatButtonToggle.
     */
    MatButtonToggleChange = /** @class */ (function () {
        function MatButtonToggleChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MatButtonToggleChange;
    }());
    /**
     * Exclusive selection button toggle group that behaves like a radio-button group.
     */
    var MatButtonToggleGroup = /** @class */ (function (_super) {
        __extends(MatButtonToggleGroup, _super);
        function MatButtonToggleGroup(_changeDetector) {
            var _this = _super.call(this) || this;
            _this._changeDetector = _changeDetector;
            _this._vertical = false;
            _this._multiple = false;
            /**
             * The method to be called in order to update ngModel.
             * Now `ngModel` binding is not supported in multiple selection mode.
             */
            _this._controlValueAccessorChangeFn = function () { };
            /**
             * onTouch function registered via registerOnTouch (ControlValueAccessor).
             */
            _this._onTouched = function () { };
            _this._name = "mat-button-toggle-group-" + _uniqueIdCounter$1++;
            /**
             * Event that emits whenever the value of the group changes.
             * Used to facilitate two-way data binding.
             * \@docs-private
             */
            _this.valueChange = new core.EventEmitter();
            /**
             * Event emitted when the group's value changes.
             */
            _this.change = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(MatButtonToggleGroup.prototype, "name", {
            get: /**
             * `name` attribute for the underlying `input` element.
             * @return {?}
             */
            function () { return this._name; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var _this = this;
                this._name = value;
                if (this._buttonToggles) {
                    this._buttonToggles.forEach(function (toggle) { return toggle.name = _this._name; });
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggleGroup.prototype, "vertical", {
            get: /**
             * Whether the toggle group is vertical.
             * @return {?}
             */
            function () { return this._vertical; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._vertical = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggleGroup.prototype, "value", {
            get: /**
             * Value of the toggle group.
             * @return {?}
             */
            function () {
                var /** @type {?} */ selected = this._selectionModel ? this._selectionModel.selected : [];
                if (this.multiple) {
                    return selected.map(function (toggle) { return toggle.value; });
                }
                return selected[0] ? selected[0].value : undefined;
            },
            set: /**
             * @param {?} newValue
             * @return {?}
             */
            function (newValue) {
                this._setSelectionByValue(newValue);
                this.valueChange.emit(this.value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggleGroup.prototype, "selected", {
            /** Selected button toggles in the group. */
            get: /**
             * Selected button toggles in the group.
             * @return {?}
             */
            function () {
                var /** @type {?} */ selected = this._selectionModel.selected;
                return this.multiple ? selected : (selected[0] || null);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggleGroup.prototype, "multiple", {
            get: /**
             * Whether multiple button toggles can be selected.
             * @return {?}
             */
            function () { return this._multiple; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._multiple = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatButtonToggleGroup.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._selectionModel = new SelectionModel(this.multiple, undefined, false);
        };
        /**
         * @return {?}
         */
        MatButtonToggleGroup.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            (_a = this._selectionModel).select.apply(_a, this._buttonToggles.filter(function (toggle) { return toggle.checked; }));
            var _a;
        };
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param value Value to be set to the model.
         */
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value Value to be set to the model.
         * @return {?}
         */
        MatButtonToggleGroup.prototype.writeValue = /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value Value to be set to the model.
         * @return {?}
         */
        function (value) {
            this.value = value;
            this._changeDetector.markForCheck();
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatButtonToggleGroup.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatButtonToggleGroup.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        MatButtonToggleGroup.prototype.setDisabledState = /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
            if (this._buttonToggles) {
                this._buttonToggles.forEach(function (toggle) { return toggle._markForCheck(); });
            }
        };
        /** Dispatch change event with current selection and group value. */
        /**
         * Dispatch change event with current selection and group value.
         * @return {?}
         */
        MatButtonToggleGroup.prototype._emitChangeEvent = /**
         * Dispatch change event with current selection and group value.
         * @return {?}
         */
        function () {
            var /** @type {?} */ selected = this.selected;
            var /** @type {?} */ source = Array.isArray(selected) ? selected[selected.length - 1] : selected;
            var /** @type {?} */ event = new MatButtonToggleChange(/** @type {?} */ ((source)), this.value);
            this._controlValueAccessorChangeFn(event.value);
            this.change.emit(event);
        };
        /**
         * Syncs a button toggle's selected state with the model value.
         * @param toggle Toggle to be synced.
         * @param select Whether the toggle should be selected.
         * @param isUserInput Whether the change was a result of a user interaction.
         */
        /**
         * Syncs a button toggle's selected state with the model value.
         * @param {?} toggle Toggle to be synced.
         * @param {?} select Whether the toggle should be selected.
         * @param {?=} isUserInput Whether the change was a result of a user interaction.
         * @return {?}
         */
        MatButtonToggleGroup.prototype._syncButtonToggle = /**
         * Syncs a button toggle's selected state with the model value.
         * @param {?} toggle Toggle to be synced.
         * @param {?} select Whether the toggle should be selected.
         * @param {?=} isUserInput Whether the change was a result of a user interaction.
         * @return {?}
         */
        function (toggle, select, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            // Deselect the currently-selected toggle, if we're in single-selection
            // mode and the button being toggled isn't selected at the moment.
            if (!this.multiple && this.selected && !toggle.checked) {
                (/** @type {?} */ (this.selected)).checked = false;
            }
            if (select) {
                this._selectionModel.select(toggle);
            }
            else {
                this._selectionModel.deselect(toggle);
            }
            // Only emit the change event for user input.
            if (isUserInput) {
                this._emitChangeEvent();
            }
            // Note: we emit this one no matter whether it was a user interaction, because
            // it is used by Angular to sync up the two-way data binding.
            this.valueChange.emit(this.value);
        };
        /** Checks whether a button toggle is selected. */
        /**
         * Checks whether a button toggle is selected.
         * @param {?} toggle
         * @return {?}
         */
        MatButtonToggleGroup.prototype._isSelected = /**
         * Checks whether a button toggle is selected.
         * @param {?} toggle
         * @return {?}
         */
        function (toggle) {
            return this._selectionModel.isSelected(toggle);
        };
        /** Determines whether a button toggle should be checked on init. */
        /**
         * Determines whether a button toggle should be checked on init.
         * @param {?} toggle
         * @return {?}
         */
        MatButtonToggleGroup.prototype._isPrechecked = /**
         * Determines whether a button toggle should be checked on init.
         * @param {?} toggle
         * @return {?}
         */
        function (toggle) {
            if (typeof this._rawValue === 'undefined') {
                return false;
            }
            if (this.multiple && Array.isArray(this._rawValue)) {
                return this._rawValue.some(function (value) { return toggle.value != null && value === toggle.value; });
            }
            return toggle.value === this._rawValue;
        };
        /**
         * Updates the selection state of the toggles in the group based on a value.
         * @param {?} value
         * @return {?}
         */
        MatButtonToggleGroup.prototype._setSelectionByValue = /**
         * Updates the selection state of the toggles in the group based on a value.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            this._rawValue = value;
            if (!this._buttonToggles) {
                return;
            }
            if (this.multiple && value) {
                if (!Array.isArray(value)) {
                    throw Error('Value must be an array in multiple-selection mode.');
                }
                this._clearSelection();
                value.forEach(function (currentValue) { return _this._selectValue(currentValue); });
            }
            else {
                this._clearSelection();
                this._selectValue(value);
            }
        };
        /**
         * Clears the selected toggles.
         * @return {?}
         */
        MatButtonToggleGroup.prototype._clearSelection = /**
         * Clears the selected toggles.
         * @return {?}
         */
        function () {
            this._selectionModel.clear();
            this._buttonToggles.forEach(function (toggle) { return toggle.checked = false; });
        };
        /**
         * Selects a value if there's a toggle that corresponds to it.
         * @param {?} value
         * @return {?}
         */
        MatButtonToggleGroup.prototype._selectValue = /**
         * Selects a value if there's a toggle that corresponds to it.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ correspondingOption = this._buttonToggles.find(function (toggle) {
                return toggle.value != null && toggle.value === value;
            });
            if (correspondingOption) {
                correspondingOption.checked = true;
                this._selectionModel.select(correspondingOption);
            }
        };
        MatButtonToggleGroup.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-button-toggle-group',
                        providers: [
                            MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR,
                            { provide: MatButtonToggleGroupMultiple, useExisting: MatButtonToggleGroup },
                        ],
                        inputs: ['disabled'],
                        host: {
                            '[attr.role]': 'multiple ? "group" : "radiogroup"',
                            'class': 'mat-button-toggle-group',
                            '[class.mat-button-toggle-vertical]': 'vertical'
                        },
                        exportAs: 'matButtonToggleGroup',
                    },] },
        ];
        /** @nocollapse */
        MatButtonToggleGroup.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
        ]; };
        MatButtonToggleGroup.propDecorators = {
            "_buttonToggles": [{ type: core.ContentChildren, args: [core.forwardRef(function () { return MatButtonToggle; }),] },],
            "name": [{ type: core.Input },],
            "vertical": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "valueChange": [{ type: core.Output },],
            "multiple": [{ type: core.Input },],
            "change": [{ type: core.Output },],
        };
        return MatButtonToggleGroup;
    }(_MatButtonToggleGroupMixinBase));
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatButtonToggleBase = /** @class */ (function () {
        function MatButtonToggleBase() {
        }
        return MatButtonToggleBase;
    }());
    var /** @type {?} */ _MatButtonToggleMixinBase = mixinDisableRipple(MatButtonToggleBase);
    /**
     * Single button inside of a toggle group.
     */
    var MatButtonToggle = /** @class */ (function (_super) {
        __extends(MatButtonToggle, _super);
        function MatButtonToggle(toggleGroup, _changeDetectorRef, _elementRef, _focusMonitor) {
            var _this = _super.call(this) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._elementRef = _elementRef;
            _this._focusMonitor = _focusMonitor;
            _this._isSingleSelector = false;
            _this._checked = false;
            /**
             * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
             */
            _this.ariaLabelledby = null;
            _this._disabled = false;
            /**
             * Event emitted when the group value changes.
             */
            _this.change = new core.EventEmitter();
            _this.buttonToggleGroup = toggleGroup;
            return _this;
        }
        Object.defineProperty(MatButtonToggle.prototype, "inputId", {
            /** Unique ID for the underlying `input` element. */
            get: /**
             * Unique ID for the underlying `input` element.
             * @return {?}
             */
            function () { return this.id + "-input"; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggle.prototype, "checked", {
            get: /**
             * Whether the button is checked.
             * @return {?}
             */
            function () {
                return this.buttonToggleGroup ? this.buttonToggleGroup._isSelected(this) : this._checked;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newValue = coerceBooleanProperty(value);
                if (newValue !== this._checked) {
                    this._checked = newValue;
                    if (this.buttonToggleGroup) {
                        this.buttonToggleGroup._syncButtonToggle(this, this._checked);
                    }
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatButtonToggle.prototype, "disabled", {
            get: /**
             * Whether the button is disabled.
             * @return {?}
             */
            function () {
                return this._disabled || (this.buttonToggleGroup && this.buttonToggleGroup.disabled);
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._disabled = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatButtonToggle.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._isSingleSelector = this.buttonToggleGroup && !this.buttonToggleGroup.multiple;
            this._type = this._isSingleSelector ? 'radio' : 'checkbox';
            this.id = this.id || "mat-button-toggle-" + _uniqueIdCounter$1++;
            if (this._isSingleSelector) {
                this.name = this.buttonToggleGroup.name;
            }
            if (this.buttonToggleGroup && this.buttonToggleGroup._isPrechecked(this)) {
                this.checked = true;
            }
            this._focusMonitor.monitor(this._elementRef.nativeElement, true);
        };
        /**
         * @return {?}
         */
        MatButtonToggle.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
        };
        /** Focuses the button. */
        /**
         * Focuses the button.
         * @return {?}
         */
        MatButtonToggle.prototype.focus = /**
         * Focuses the button.
         * @return {?}
         */
        function () {
            this._inputElement.nativeElement.focus();
        };
        /** Checks the button toggle due to an interaction with the underlying native input. */
        /**
         * Checks the button toggle due to an interaction with the underlying native input.
         * @param {?} event
         * @return {?}
         */
        MatButtonToggle.prototype._onInputChange = /**
         * Checks the button toggle due to an interaction with the underlying native input.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            event.stopPropagation();
            this._checked = this._isSingleSelector ? true : !this._checked;
            if (this.buttonToggleGroup) {
                this.buttonToggleGroup._syncButtonToggle(this, this._checked, true);
                this.buttonToggleGroup._onTouched();
            }
            // Emit a change event when the native input does.
            this.change.emit(new MatButtonToggleChange(this, this.value));
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatButtonToggle.prototype._onInputClick = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We have to stop propagation for click events on the visual hidden input element.
            // By default, when a user clicks on a label element, a generated click event will be
            // dispatched on the associated input element. Since we are using a label element as our
            // root container, the click event on the `slide-toggle` will be executed twice.
            // The real click event will bubble up, and the generated click event also tries to bubble up.
            // This will lead to multiple click events.
            // Preventing bubbling for the second event will solve that issue.
            event.stopPropagation();
        };
        /**
         * Marks the button toggle as needing checking for change detection.
         * This method is exposed because the parent button toggle group will directly
         * update bound properties of the radio button.
         */
        /**
         * Marks the button toggle as needing checking for change detection.
         * This method is exposed because the parent button toggle group will directly
         * update bound properties of the radio button.
         * @return {?}
         */
        MatButtonToggle.prototype._markForCheck = /**
         * Marks the button toggle as needing checking for change detection.
         * This method is exposed because the parent button toggle group will directly
         * update bound properties of the radio button.
         * @return {?}
         */
        function () {
            // When the group value changes, the button will not be notified.
            // Use `markForCheck` to explicit update button toggle's status.
            this._changeDetectorRef.markForCheck();
        };
        MatButtonToggle.decorators = [
            { type: core.Component, args: [{selector: 'mat-button-toggle',
                        template: "<label [attr.for]=\"inputId\" class=\"mat-button-toggle-label\" #label><input #input class=\"mat-button-toggle-input cdk-visually-hidden\" [type]=\"_type\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled || null\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-button-toggle-label-content\"><ng-content></ng-content></div></label><div class=\"mat-button-toggle-focus-overlay\"></div><div class=\"mat-button-toggle-ripple\" matRipple [matRippleTrigger]=\"label\" [matRippleDisabled]=\"this.disableRipple || this.disabled\"></div>",
                        styles: [".mat-button-toggle-group,.mat-button-toggle-standalone{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);position:relative;display:inline-flex;flex-direction:row;border-radius:2px;cursor:pointer;white-space:nowrap;overflow:hidden}@media screen and (-ms-high-contrast:active){.mat-button-toggle-group,.mat-button-toggle-standalone{outline:solid 1px}}.mat-button-toggle-vertical{flex-direction:column}.mat-button-toggle-vertical .mat-button-toggle-label-content{display:block}.mat-button-toggle-disabled .mat-button-toggle-label-content{cursor:default}.mat-button-toggle{white-space:nowrap;position:relative}.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay{opacity:1}@media screen and (-ms-high-contrast:active){.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay{opacity:.5}}.mat-button-toggle-label-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;line-height:36px;padding:0 16px;cursor:pointer}.mat-button-toggle-label-content>*{vertical-align:middle}.mat-button-toggle-focus-overlay{border-radius:inherit;pointer-events:none;opacity:0;top:0;left:0;right:0;bottom:0;position:absolute}@media screen and (-ms-high-contrast:active){.mat-button-toggle-checked .mat-button-toggle-focus-overlay{opacity:.5;height:0;border-bottom:solid 36px}}.mat-button-toggle-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matButtonToggle',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['disableRipple'],
                        host: {
                            '[class.mat-button-toggle-standalone]': '!buttonToggleGroup',
                            '[class.mat-button-toggle-checked]': 'checked',
                            '[class.mat-button-toggle-disabled]': 'disabled',
                            'class': 'mat-button-toggle',
                            '[attr.id]': 'id',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatButtonToggle.ctorParameters = function () { return [
            { type: MatButtonToggleGroup, decorators: [{ type: core.Optional },] },
            { type: core.ChangeDetectorRef, },
            { type: core.ElementRef, },
            { type: FocusMonitor, },
        ]; };
        MatButtonToggle.propDecorators = {
            "ariaLabel": [{ type: core.Input, args: ['aria-label',] },],
            "ariaLabelledby": [{ type: core.Input, args: ['aria-labelledby',] },],
            "_inputElement": [{ type: core.ViewChild, args: ['input',] },],
            "id": [{ type: core.Input },],
            "name": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "checked": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "change": [{ type: core.Output },],
        };
        return MatButtonToggle;
    }(_MatButtonToggleMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Content of a card, needed as it's used as a selector in the API.
     * \@docs-private
     */
    var MatCardContent = /** @class */ (function () {
        function MatCardContent() {
        }
        MatCardContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-card-content',
                        host: { 'class': 'mat-card-content' }
                    },] },
        ];
        return MatCardContent;
    }());
    /**
     * Title of a card, needed as it's used as a selector in the API.
     * \@docs-private
     */
    var MatCardTitle = /** @class */ (function () {
        function MatCardTitle() {
        }
        MatCardTitle.decorators = [
            { type: core.Directive, args: [{
                        selector: "mat-card-title, [mat-card-title], [matCardTitle]",
                        host: {
                            'class': 'mat-card-title'
                        }
                    },] },
        ];
        return MatCardTitle;
    }());
    /**
     * Sub-title of a card, needed as it's used as a selector in the API.
     * \@docs-private
     */
    var MatCardSubtitle = /** @class */ (function () {
        function MatCardSubtitle() {
        }
        MatCardSubtitle.decorators = [
            { type: core.Directive, args: [{
                        selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]",
                        host: {
                            'class': 'mat-card-subtitle'
                        }
                    },] },
        ];
        return MatCardSubtitle;
    }());
    /**
     * Action section of a card, needed as it's used as a selector in the API.
     * \@docs-private
     */
    var MatCardActions = /** @class */ (function () {
        function MatCardActions() {
            /**
             * Position of the actions inside the card.
             */
            this.align = 'start';
        }
        MatCardActions.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-card-actions',
                        exportAs: 'matCardActions',
                        host: {
                            'class': 'mat-card-actions',
                            '[class.mat-card-actions-align-end]': 'align === "end"',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatCardActions.propDecorators = {
            "align": [{ type: core.Input },],
        };
        return MatCardActions;
    }());
    /**
     * Footer of a card, needed as it's used as a selector in the API.
     * \@docs-private
     */
    var MatCardFooter = /** @class */ (function () {
        function MatCardFooter() {
        }
        MatCardFooter.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-card-footer',
                        host: { 'class': 'mat-card-footer' }
                    },] },
        ];
        return MatCardFooter;
    }());
    /**
     * Image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardImage = /** @class */ (function () {
        function MatCardImage() {
        }
        MatCardImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-image], [matCardImage]',
                        host: { 'class': 'mat-card-image' }
                    },] },
        ];
        return MatCardImage;
    }());
    /**
     * Image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardSmImage = /** @class */ (function () {
        function MatCardSmImage() {
        }
        MatCardSmImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-sm-image], [matCardImageSmall]',
                        host: { 'class': 'mat-card-sm-image' }
                    },] },
        ];
        return MatCardSmImage;
    }());
    /**
     * Image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardMdImage = /** @class */ (function () {
        function MatCardMdImage() {
        }
        MatCardMdImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-md-image], [matCardImageMedium]',
                        host: { 'class': 'mat-card-md-image' }
                    },] },
        ];
        return MatCardMdImage;
    }());
    /**
     * Image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardLgImage = /** @class */ (function () {
        function MatCardLgImage() {
        }
        MatCardLgImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-lg-image], [matCardImageLarge]',
                        host: { 'class': 'mat-card-lg-image' }
                    },] },
        ];
        return MatCardLgImage;
    }());
    /**
     * Large image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardXlImage = /** @class */ (function () {
        function MatCardXlImage() {
        }
        MatCardXlImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-xl-image], [matCardImageXLarge]',
                        host: { 'class': 'mat-card-xl-image' }
                    },] },
        ];
        return MatCardXlImage;
    }());
    /**
     * Avatar image used in a card, needed to add the mat- CSS styling.
     * \@docs-private
     */
    var MatCardAvatar = /** @class */ (function () {
        function MatCardAvatar() {
        }
        MatCardAvatar.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-card-avatar], [matCardAvatar]',
                        host: { 'class': 'mat-card-avatar' }
                    },] },
        ];
        return MatCardAvatar;
    }());
    /**
     * A basic content container component that adds the styles of a Material design card.
     *
     * While this component can be used alone, it also provides a number
     * of preset styles for common card sections, including:
     * - mat-card-title
     * - mat-card-subtitle
     * - mat-card-content
     * - mat-card-actions
     * - mat-card-footer
     */
    var MatCard = /** @class */ (function () {
        function MatCard() {
        }
        MatCard.decorators = [
            { type: core.Component, args: [{selector: 'mat-card',
                        exportAs: 'matCard',
                        template: "<ng-content></ng-content><ng-content select=\"mat-card-footer\"></ng-content>",
                        styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:block;position:relative;padding:24px;border-radius:2px}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-card .mat-divider{position:absolute;left:0;width:100%}[dir=rtl] .mat-card .mat-divider{left:auto;right:0}.mat-card .mat-divider.mat-divider-inset{position:static;margin:0}.mat-card.mat-card-flat{box-shadow:none}@media screen and (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-actions,.mat-card-content,.mat-card-subtitle,.mat-card-title{display:block;margin-bottom:16px}.mat-card-actions{margin-left:-16px;margin-right:-16px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 48px);margin:0 -24px 16px -24px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-footer{display:block;margin:0 -24px -24px -24px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button{margin:0 4px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header-text{margin:0 8px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0}.mat-card-lg-image,.mat-card-md-image,.mat-card-sm-image{margin:-8px 0}.mat-card-title-group{display:flex;justify-content:space-between;margin:0 -8px}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}@media (max-width:599px){.mat-card{padding:24px 16px}.mat-card-actions{margin-left:-8px;margin-right:-8px}.mat-card-image{width:calc(100% + 32px);margin:16px -16px}.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}.mat-card-header{margin:-8px 0 0 0}.mat-card-footer{margin-left:-16px;margin-right:-16px}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child:not(.mat-card-footer),.mat-card>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-24px}.mat-card>.mat-card-actions:last-child{margin-bottom:-16px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        host: { 'class': 'mat-card' }
                    },] },
        ];
        return MatCard;
    }());
    /**
     * Component intended to be used within the `<mat-card>` component. It adds styles for a
     * preset header section (i.e. a title, subtitle, and avatar layout).
     * \@docs-private
     */
    var MatCardHeader = /** @class */ (function () {
        function MatCardHeader() {
        }
        MatCardHeader.decorators = [
            { type: core.Component, args: [{selector: 'mat-card-header',
                        template: "<ng-content select=\"[mat-card-avatar], [matCardAvatar]\"></ng-content><div class=\"mat-card-header-text\"><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        host: { 'class': 'mat-card-header' }
                    },] },
        ];
        return MatCardHeader;
    }());
    /**
     * Component intended to be used within the `<mat-card>` component. It adds styles for a preset
     * layout that groups an image with a title section.
     * \@docs-private
     */
    var MatCardTitleGroup = /** @class */ (function () {
        function MatCardTitleGroup() {
        }
        MatCardTitleGroup.decorators = [
            { type: core.Component, args: [{selector: 'mat-card-title-group',
                        template: "<div><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content select=\"img\"></ng-content><ng-content></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        host: { 'class': 'mat-card-title-group' }
                    },] },
        ];
        return MatCardTitleGroup;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatCardModule = /** @class */ (function () {
        function MatCardModule() {
        }
        MatCardModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatCommonModule],
                        exports: [
                            MatCard,
                            MatCardHeader,
                            MatCardTitleGroup,
                            MatCardContent,
                            MatCardTitle,
                            MatCardSubtitle,
                            MatCardActions,
                            MatCardFooter,
                            MatCardSmImage,
                            MatCardMdImage,
                            MatCardLgImage,
                            MatCardImage,
                            MatCardXlImage,
                            MatCardAvatar,
                            MatCommonModule,
                        ],
                        declarations: [
                            MatCard, MatCardHeader, MatCardTitleGroup, MatCardContent, MatCardTitle, MatCardSubtitle,
                            MatCardActions, MatCardFooter, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardImage,
                            MatCardXlImage, MatCardAvatar,
                        ],
                    },] },
        ];
        return MatCardModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to specify the checkbox click behavior.
     */
    var /** @type {?} */ MAT_CHECKBOX_CLICK_ACTION = new core.InjectionToken('mat-checkbox-click-action');

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Increasing integer for generating unique ids for checkbox components.
    var /** @type {?} */ nextUniqueId$3 = 0;
    /**
     * Provider Expression that allows mat-checkbox to register as a ControlValueAccessor.
     * This allows it to support [(ngModel)].
     * \@docs-private
     */
    var /** @type {?} */ MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatCheckbox; }),
        multi: true
    };
    /** @enum {number} */
    var TransitionCheckState = {
        /** The initial state of the component before any user interaction. */
        Init: 0,
        /** The state representing the component when it's becoming checked. */
        Checked: 1,
        /** The state representing the component when it's becoming unchecked. */
        Unchecked: 2,
        /** The state representing the component when it's becoming indeterminate. */
        Indeterminate: 3,
    };
    TransitionCheckState[TransitionCheckState.Init] = "Init";
    TransitionCheckState[TransitionCheckState.Checked] = "Checked";
    TransitionCheckState[TransitionCheckState.Unchecked] = "Unchecked";
    TransitionCheckState[TransitionCheckState.Indeterminate] = "Indeterminate";
    /**
     * Change event object emitted by MatCheckbox.
     */
    var  /**
     * Change event object emitted by MatCheckbox.
     */
    MatCheckboxChange = /** @class */ (function () {
        function MatCheckboxChange() {
        }
        return MatCheckboxChange;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatCheckboxBase = /** @class */ (function () {
        function MatCheckboxBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatCheckboxBase;
    }());
    var /** @type {?} */ _MatCheckboxMixinBase = mixinTabIndex(mixinColor(mixinDisableRipple(mixinDisabled(MatCheckboxBase)), 'accent'));
    /**
     * A material design checkbox component. Supports all of the functionality of an HTML5 checkbox,
     * and exposes a similar API. A MatCheckbox can be either checked, unchecked, indeterminate, or
     * disabled. Note that all additional accessibility attributes are taken care of by the component,
     * so there is no need to provide them yourself. However, if you want to omit a label and still
     * have the checkbox be accessible, you may supply an [aria-label] input.
     * See: https://material.io/design/components/selection-controls.html
     */
    var MatCheckbox = /** @class */ (function (_super) {
        __extends(MatCheckbox, _super);
        function MatCheckbox(elementRef, _changeDetectorRef, _focusMonitor, tabIndex, _clickAction, _animationMode) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._focusMonitor = _focusMonitor;
            _this._clickAction = _clickAction;
            _this._animationMode = _animationMode;
            /**
             * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
             * take precedence so this may be omitted.
             */
            _this.ariaLabel = '';
            /**
             * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
             */
            _this.ariaLabelledby = null;
            _this._uniqueId = "mat-checkbox-" + ++nextUniqueId$3;
            /**
             * A unique id for the checkbox input. If none is supplied, it will be auto-generated.
             */
            _this.id = _this._uniqueId;
            /**
             * Whether the label should appear after or before the checkbox. Defaults to 'after'
             */
            _this.labelPosition = 'after';
            /**
             * Name value will be applied to the input element if present
             */
            _this.name = null;
            /**
             * Event emitted when the checkbox's `checked` value changes.
             */
            _this.change = new core.EventEmitter();
            /**
             * Event emitted when the checkbox's `indeterminate` value changes.
             */
            _this.indeterminateChange = new core.EventEmitter();
            /**
             * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
             * \@docs-private
             */
            _this._onTouched = function () { };
            _this._currentAnimationClass = '';
            _this._currentCheckState = TransitionCheckState.Init;
            _this._controlValueAccessorChangeFn = function () { };
            _this._checked = false;
            _this._disabled = false;
            _this._indeterminate = false;
            _this.tabIndex = parseInt(tabIndex) || 0;
            return _this;
        }
        Object.defineProperty(MatCheckbox.prototype, "inputId", {
            /** Returns the unique id for the visual hidden input. */
            get: /**
             * Returns the unique id for the visual hidden input.
             * @return {?}
             */
            function () { return (this.id || this._uniqueId) + "-input"; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCheckbox.prototype, "required", {
            get: /**
             * Whether the checkbox is required.
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._required = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatCheckbox.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._focusMonitor
                .monitor(this._inputElement.nativeElement)
                .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
        };
        /**
         * @return {?}
         */
        MatCheckbox.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
        };
        Object.defineProperty(MatCheckbox.prototype, "checked", {
            get: /**
             * Whether the checkbox is checked.
             * @return {?}
             */
            function () { return this._checked; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value != this.checked) {
                    this._checked = value;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCheckbox.prototype, "disabled", {
            get: /**
             * Whether the checkbox is disabled. This fully overrides the implementation provided by
             * mixinDisabled, but the mixin is still required because mixinTabIndex requires it.
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value != this.disabled) {
                    this._disabled = value;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCheckbox.prototype, "indeterminate", {
            get: /**
             * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
             * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
             * checkable items. Note that whenever checkbox is manually clicked, indeterminate is immediately
             * set to false.
             * @return {?}
             */
            function () { return this._indeterminate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ changed = value != this._indeterminate;
                this._indeterminate = value;
                if (changed) {
                    if (this._indeterminate) {
                        this._transitionCheckState(TransitionCheckState.Indeterminate);
                    }
                    else {
                        this._transitionCheckState(this.checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                    }
                    this.indeterminateChange.emit(this._indeterminate);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatCheckbox.prototype._isRippleDisabled = /**
         * @return {?}
         */
        function () {
            return this.disableRipple || this.disabled;
        };
        /** Method being called whenever the label text changes. */
        /**
         * Method being called whenever the label text changes.
         * @return {?}
         */
        MatCheckbox.prototype._onLabelTextChange = /**
         * Method being called whenever the label text changes.
         * @return {?}
         */
        function () {
            // This method is getting called whenever the label of the checkbox changes.
            // Since the checkbox uses the OnPush strategy we need to notify it about the change
            // that has been recognized by the cdkObserveContent directive.
            this._changeDetectorRef.markForCheck();
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} value
         * @return {?}
         */
        MatCheckbox.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.checked = !!value;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatCheckbox.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatCheckbox.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        MatCheckbox.prototype.setDisabledState = /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
        };
        /**
         * @return {?}
         */
        MatCheckbox.prototype._getAriaChecked = /**
         * @return {?}
         */
        function () {
            return this.checked ? 'true' : (this.indeterminate ? 'mixed' : 'false');
        };
        /**
         * @param {?} newState
         * @return {?}
         */
        MatCheckbox.prototype._transitionCheckState = /**
         * @param {?} newState
         * @return {?}
         */
        function (newState) {
            var /** @type {?} */ oldState = this._currentCheckState;
            var /** @type {?} */ element = this._elementRef.nativeElement;
            if (oldState === newState) {
                return;
            }
            if (this._currentAnimationClass.length > 0) {
                element.classList.remove(this._currentAnimationClass);
            }
            this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(oldState, newState);
            this._currentCheckState = newState;
            if (this._currentAnimationClass.length > 0) {
                element.classList.add(this._currentAnimationClass);
            }
        };
        /**
         * @return {?}
         */
        MatCheckbox.prototype._emitChangeEvent = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ event = new MatCheckboxChange();
            event.source = this;
            event.checked = this.checked;
            this._controlValueAccessorChangeFn(this.checked);
            this.change.emit(event);
        };
        /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        MatCheckbox.prototype._onInputFocusChange = /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        function (focusOrigin) {
            // TODO(paul): support `program`. See https://github.com/angular/material2/issues/9889
            if (!this._focusRipple && focusOrigin === 'keyboard') {
                this._focusRipple = this.ripple.launch(0, 0, { persistent: true });
            }
            else if (!focusOrigin) {
                if (this._focusRipple) {
                    this._focusRipple.fadeOut();
                    this._focusRipple = null;
                }
                this._onTouched();
            }
        };
        /** Toggles the `checked` state of the checkbox. */
        /**
         * Toggles the `checked` state of the checkbox.
         * @return {?}
         */
        MatCheckbox.prototype.toggle = /**
         * Toggles the `checked` state of the checkbox.
         * @return {?}
         */
        function () {
            this.checked = !this.checked;
        };
        /**
         * Event handler for checkbox input element.
         * Toggles checked state if element is not disabled.
         * Do not toggle on (change) event since IE doesn't fire change event when
         *   indeterminate checkbox is clicked.
         * @param event
         */
        /**
         * Event handler for checkbox input element.
         * Toggles checked state if element is not disabled.
         * Do not toggle on (change) event since IE doesn't fire change event when
         *   indeterminate checkbox is clicked.
         * @param {?} event
         * @return {?}
         */
        MatCheckbox.prototype._onInputClick = /**
         * Event handler for checkbox input element.
         * Toggles checked state if element is not disabled.
         * Do not toggle on (change) event since IE doesn't fire change event when
         *   indeterminate checkbox is clicked.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var _this = this;
            // We have to stop propagation for click events on the visual hidden input element.
            // By default, when a user clicks on a label element, a generated click event will be
            // dispatched on the associated input element. Since we are using a label element as our
            // root container, the click event on the `checkbox` will be executed twice.
            // The real click event will bubble up, and the generated click event also tries to bubble up.
            // This will lead to multiple click events.
            // Preventing bubbling for the second event will solve that issue.
            event.stopPropagation();
            // If resetIndeterminate is false, and the current state is indeterminate, do nothing on click
            if (!this.disabled && this._clickAction !== 'noop') {
                // When user manually click on the checkbox, `indeterminate` is set to false.
                if (this.indeterminate && this._clickAction !== 'check') {
                    Promise.resolve().then(function () {
                        _this._indeterminate = false;
                        _this.indeterminateChange.emit(_this._indeterminate);
                    });
                }
                this.toggle();
                this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                // Emit our custom change event if the native input emitted one.
                // It is important to only emit it, if the native input triggered one, because
                // we don't want to trigger a change event, when the `checked` variable changes for example.
                this._emitChangeEvent();
            }
            else if (!this.disabled && this._clickAction === 'noop') {
                // Reset native input when clicked with noop. The native checkbox becomes checked after
                // click, reset it to be align with `checked` value of `mat-checkbox`.
                this._inputElement.nativeElement.checked = this.checked;
                this._inputElement.nativeElement.indeterminate = this.indeterminate;
            }
        };
        /** Focuses the checkbox. */
        /**
         * Focuses the checkbox.
         * @return {?}
         */
        MatCheckbox.prototype.focus = /**
         * Focuses the checkbox.
         * @return {?}
         */
        function () {
            this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatCheckbox.prototype._onInteractionEvent = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We always have to stop propagation on the change event.
            // Otherwise the change event, from the input element, will bubble up and
            // emit its event object to the `change` output.
            event.stopPropagation();
        };
        /**
         * @param {?} oldState
         * @param {?} newState
         * @return {?}
         */
        MatCheckbox.prototype._getAnimationClassForCheckStateTransition = /**
         * @param {?} oldState
         * @param {?} newState
         * @return {?}
         */
        function (oldState, newState) {
            // Don't transition if animations are disabled.
            if (this._animationMode === 'NoopAnimations') {
                return '';
            }
            var /** @type {?} */ animSuffix = '';
            switch (oldState) {
                case TransitionCheckState.Init:
                    // Handle edge case where user interacts with checkbox that does not have [(ngModel)] or
                    // [checked] bound to it.
                    if (newState === TransitionCheckState.Checked) {
                        animSuffix = 'unchecked-checked';
                    }
                    else if (newState == TransitionCheckState.Indeterminate) {
                        animSuffix = 'unchecked-indeterminate';
                    }
                    else {
                        return '';
                    }
                    break;
                case TransitionCheckState.Unchecked:
                    animSuffix = newState === TransitionCheckState.Checked ?
                        'unchecked-checked' : 'unchecked-indeterminate';
                    break;
                case TransitionCheckState.Checked:
                    animSuffix = newState === TransitionCheckState.Unchecked ?
                        'checked-unchecked' : 'checked-indeterminate';
                    break;
                case TransitionCheckState.Indeterminate:
                    animSuffix = newState === TransitionCheckState.Checked ?
                        'indeterminate-checked' : 'indeterminate-unchecked';
                    break;
            }
            return "mat-checkbox-anim-" + animSuffix;
        };
        MatCheckbox.decorators = [
            { type: core.Component, args: [{selector: 'mat-checkbox',
                        template: "<label [attr.for]=\"inputId\" class=\"mat-checkbox-layout\" #label><div class=\"mat-checkbox-inner-container\" [class.mat-checkbox-inner-container-no-side-margin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\"><input #input class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [attr.value]=\"value\" [disabled]=\"disabled\" [attr.name]=\"name\" [tabIndex]=\"tabIndex\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel || null\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-checked]=\"_getAriaChecked()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"><div matRipple class=\"mat-checkbox-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleRadius]=\"25\" [matRippleCentered]=\"true\" [matRippleAnimation]=\"{enterDuration: 150}\"></div><div class=\"mat-checkbox-frame\"></div><div class=\"mat-checkbox-background\"><svg version=\"1.1\" focusable=\"false\" class=\"mat-checkbox-checkmark\" viewBox=\"0 0 24 24\" xml:space=\"preserve\"><path class=\"mat-checkbox-checkmark-path\" fill=\"none\" stroke=\"white\" d=\"M4.1,12.7 9,17.6 20.3,6.3\"/></svg><div class=\"mat-checkbox-mixedmark\"></div></div></div><span class=\"mat-checkbox-label\" #checkboxLabel (cdkObserveContent)=\"_onLabelTextChange()\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></span></label>",
                        styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-checkmark,.mat-checkbox-mixedmark{width:calc(100% - 4px)}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);cursor:pointer;-webkit-tap-highlight-color:transparent}._mat-animation-noopable.mat-checkbox{transition:none;animation:none}.mat-checkbox-layout{cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-inner-container{display:inline-block;height:20px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:20px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}._mat-animation-noopable .mat-checkbox-frame{transition:none}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}._mat-animation-noopable .mat-checkbox-background{transition:none}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.66667px}.mat-checkbox-mixedmark{height:2px;opacity:0;transform:scaleX(0) rotate(0)}@media screen and (-ms-high-contrast:active){.mat-checkbox-mixedmark{height:0;border-top:solid 2px;margin-top:2px}}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"],
                        exportAs: 'matCheckbox',
                        host: {
                            'class': 'mat-checkbox',
                            '[id]': 'id',
                            '[class.mat-checkbox-indeterminate]': 'indeterminate',
                            '[class.mat-checkbox-checked]': 'checked',
                            '[class.mat-checkbox-disabled]': 'disabled',
                            '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
                            '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                        },
                        providers: [MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                        inputs: ['disableRipple', 'color', 'tabIndex'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatCheckbox.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: FocusMonitor, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_CHECKBOX_CLICK_ACTION,] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatCheckbox.propDecorators = {
            "ariaLabel": [{ type: core.Input, args: ['aria-label',] },],
            "ariaLabelledby": [{ type: core.Input, args: ['aria-labelledby',] },],
            "id": [{ type: core.Input },],
            "required": [{ type: core.Input },],
            "labelPosition": [{ type: core.Input },],
            "name": [{ type: core.Input },],
            "change": [{ type: core.Output },],
            "indeterminateChange": [{ type: core.Output },],
            "value": [{ type: core.Input },],
            "_inputElement": [{ type: core.ViewChild, args: ['input',] },],
            "ripple": [{ type: core.ViewChild, args: [MatRipple,] },],
            "checked": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "indeterminate": [{ type: core.Input },],
        };
        return MatCheckbox;
    }(_MatCheckboxMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ MAT_CHECKBOX_REQUIRED_VALIDATOR = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return MatCheckboxRequiredValidator; }),
        multi: true
    };
    /**
     * Validator for Material checkbox's required attribute in template-driven checkbox.
     * Current CheckboxRequiredValidator only work with `input type=checkbox` and does not
     * work with `mat-checkbox`.
     */
    var MatCheckboxRequiredValidator = /** @class */ (function (_super) {
        __extends(MatCheckboxRequiredValidator, _super);
        function MatCheckboxRequiredValidator() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatCheckboxRequiredValidator.decorators = [
            { type: core.Directive, args: [{
                        selector: "mat-checkbox[required][formControlName],\n             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]",
                        providers: [MAT_CHECKBOX_REQUIRED_VALIDATOR],
                        host: { '[attr.required]': 'required ? "" : null' }
                    },] },
        ];
        return MatCheckboxRequiredValidator;
    }(CheckboxRequiredValidator));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatChipBase = /** @class */ (function () {
        function MatChipBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatChipBase;
    }());
    var /** @type {?} */ _MatChipMixinBase = mixinColor(mixinDisableRipple(mixinDisabled(MatChipBase)), 'primary');
    var /** @type {?} */ CHIP_ATTRIBUTE_NAMES = ['mat-basic-chip'];
    /**
     * Dummy directive to add CSS class to chip avatar.
     * \@docs-private
     */
    var MatChipAvatar = /** @class */ (function () {
        function MatChipAvatar() {
        }
        MatChipAvatar.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-chip-avatar, [matChipAvatar]',
                        host: { 'class': 'mat-chip-avatar' }
                    },] },
        ];
        return MatChipAvatar;
    }());
    /**
     * Dummy directive to add CSS class to chip trailing icon.
     * \@docs-private
     */
    var MatChipTrailingIcon = /** @class */ (function () {
        function MatChipTrailingIcon() {
        }
        MatChipTrailingIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-chip-trailing-icon, [matChipTrailingIcon]',
                        host: { 'class': 'mat-chip-trailing-icon' }
                    },] },
        ];
        return MatChipTrailingIcon;
    }());
    /**
     * Material design styled Chip component. Used inside the MatChipList component.
     */
    var MatChip = /** @class */ (function (_super) {
        __extends(MatChip, _super);
        function MatChip(_elementRef, ngZone, platform, globalOptions) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            /**
             * Ripple configuration for ripples that are launched on pointer down.
             * \@docs-private
             */
            _this.rippleConfig = {};
            /**
             * Whether the chip has focus.
             */
            _this._hasFocus = false;
            /**
             * Whether the chip list is selectable
             */
            _this.chipListSelectable = true;
            _this._selected = false;
            _this._selectable = true;
            _this._removable = true;
            /**
             * Emits when the chip is focused.
             */
            _this._onFocus = new rxjs.Subject();
            /**
             * Emits when the chip is blured.
             */
            _this._onBlur = new rxjs.Subject();
            /**
             * Emitted when the chip is selected or deselected.
             */
            _this.selectionChange = new core.EventEmitter();
            /**
             * Emitted when the chip is destroyed.
             */
            _this.destroyed = new core.EventEmitter();
            /**
             * Emitted when a chip is to be removed.
             */
            _this.removed = new core.EventEmitter();
            _this._addHostClassName();
            _this._chipRipple = new RippleRenderer(_this, ngZone, _elementRef, platform);
            _this._chipRipple.setupTriggerEvents(_elementRef.nativeElement);
            if (globalOptions) {
                _this.rippleConfig = {
                    speedFactor: globalOptions.baseSpeedFactor,
                    animation: globalOptions.animation,
                    terminateOnPointerUp: globalOptions.terminateOnPointerUp,
                };
            }
            return _this;
        }
        Object.defineProperty(MatChip.prototype, "rippleDisabled", {
            /**
             * Whether ripples are disabled on interaction
             * @docs-private
             */
            get: /**
             * Whether ripples are disabled on interaction
             * \@docs-private
             * @return {?}
             */
            function () {
                return this.disabled || this.disableRipple;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChip.prototype, "selected", {
            get: /**
             * Whether the chip is selected.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selected = coerceBooleanProperty(value);
                this.selectionChange.emit({
                    source: this,
                    isUserInput: false,
                    selected: value
                });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChip.prototype, "value", {
            get: /**
             * The value of the chip. Defaults to the content inside `<mat-chip>` tags.
             * @return {?}
             */
            function () {
                return this._value != undefined
                    ? this._value
                    : this._elementRef.nativeElement.textContent;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._value = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChip.prototype, "selectable", {
            get: /**
             * Whether or not the chip is selectable. When a chip is not selectable,
             * changes to it's selected state are always ignored. By default a chip is
             * selectable, and it becomes non-selectable if it's parent chip list is
             * not selectable.
             * @return {?}
             */
            function () { return this._selectable && this.chipListSelectable; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selectable = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChip.prototype, "removable", {
            get: /**
             * Determines whether or not the chip displays the remove styling and emits (removed) events.
             * @return {?}
             */
            function () { return this._removable; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._removable = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChip.prototype, "ariaSelected", {
            /** The ARIA selected applied to the chip. */
            get: /**
             * The ARIA selected applied to the chip.
             * @return {?}
             */
            function () {
                return this.selectable ? this.selected.toString() : null;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatChip.prototype._addHostClassName = /**
         * @return {?}
         */
        function () {
            // Add class for the different chips
            for (var _i = 0, CHIP_ATTRIBUTE_NAMES_1 = CHIP_ATTRIBUTE_NAMES; _i < CHIP_ATTRIBUTE_NAMES_1.length; _i++) {
                var attr = CHIP_ATTRIBUTE_NAMES_1[_i];
                if (this._elementRef.nativeElement.hasAttribute(attr) ||
                    this._elementRef.nativeElement.tagName.toLowerCase() === attr) {
                    (/** @type {?} */ (this._elementRef.nativeElement)).classList.add(attr);
                    return;
                }
            }
            (/** @type {?} */ (this._elementRef.nativeElement)).classList.add('mat-standard-chip');
        };
        /**
         * @return {?}
         */
        MatChip.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.destroyed.emit({ chip: this });
            this._chipRipple._removeTriggerEvents();
        };
        /** Selects the chip. */
        /**
         * Selects the chip.
         * @return {?}
         */
        MatChip.prototype.select = /**
         * Selects the chip.
         * @return {?}
         */
        function () {
            this._selected = true;
            this.selectionChange.emit({
                source: this,
                isUserInput: false,
                selected: true
            });
        };
        /** Deselects the chip. */
        /**
         * Deselects the chip.
         * @return {?}
         */
        MatChip.prototype.deselect = /**
         * Deselects the chip.
         * @return {?}
         */
        function () {
            this._selected = false;
            this.selectionChange.emit({
                source: this,
                isUserInput: false,
                selected: false
            });
        };
        /** Select this chip and emit selected event */
        /**
         * Select this chip and emit selected event
         * @return {?}
         */
        MatChip.prototype.selectViaInteraction = /**
         * Select this chip and emit selected event
         * @return {?}
         */
        function () {
            this._selected = true;
            // Emit select event when selected changes.
            this.selectionChange.emit({
                source: this,
                isUserInput: true,
                selected: true
            });
        };
        /** Toggles the current selected state of this chip. */
        /**
         * Toggles the current selected state of this chip.
         * @param {?=} isUserInput
         * @return {?}
         */
        MatChip.prototype.toggleSelected = /**
         * Toggles the current selected state of this chip.
         * @param {?=} isUserInput
         * @return {?}
         */
        function (isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._selected = !this.selected;
            this.selectionChange.emit({
                source: this,
                isUserInput: isUserInput,
                selected: this._selected
            });
            return this.selected;
        };
        /** Allows for programmatic focusing of the chip. */
        /**
         * Allows for programmatic focusing of the chip.
         * @return {?}
         */
        MatChip.prototype.focus = /**
         * Allows for programmatic focusing of the chip.
         * @return {?}
         */
        function () {
            if (!this._hasFocus) {
                this._elementRef.nativeElement.focus();
                this._onFocus.next({ chip: this });
            }
            this._hasFocus = true;
        };
        /**
         * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
         * BACKSPACE keys are pressed.
         *
         * Informs any listeners of the removal request. Does not remove the chip from the DOM.
         */
        /**
         * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
         * BACKSPACE keys are pressed.
         *
         * Informs any listeners of the removal request. Does not remove the chip from the DOM.
         * @return {?}
         */
        MatChip.prototype.remove = /**
         * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
         * BACKSPACE keys are pressed.
         *
         * Informs any listeners of the removal request. Does not remove the chip from the DOM.
         * @return {?}
         */
        function () {
            if (this.removable) {
                this.removed.emit({ chip: this });
            }
        };
        /** Ensures events fire properly upon click. */
        /**
         * Ensures events fire properly upon click.
         * @param {?} event
         * @return {?}
         */
        MatChip.prototype._handleClick = /**
         * Ensures events fire properly upon click.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // Check disabled
            if (this.disabled) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        };
        /** Handle custom key presses. */
        /**
         * Handle custom key presses.
         * @param {?} event
         * @return {?}
         */
        MatChip.prototype._handleKeydown = /**
         * Handle custom key presses.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                return;
            }
            switch (event.keyCode) {
                case DELETE:
                case BACKSPACE:
                    // If we are removable, remove the focused chip
                    this.remove();
                    // Always prevent so page navigation does not occur
                    event.preventDefault();
                    break;
                case SPACE:
                    // If we are selectable, toggle the focused chip
                    if (this.selectable) {
                        this.toggleSelected(true);
                    }
                    // Always prevent space from scrolling the page since the list has focus
                    event.preventDefault();
                    break;
            }
        };
        /**
         * @return {?}
         */
        MatChip.prototype._blur = /**
         * @return {?}
         */
        function () {
            this._hasFocus = false;
            this._onBlur.next({ chip: this });
        };
        MatChip.decorators = [
            { type: core.Directive, args: [{
                        selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]",
                        inputs: ['color', 'disabled', 'disableRipple'],
                        exportAs: 'matChip',
                        host: {
                            'class': 'mat-chip',
                            '[attr.tabindex]': 'disabled ? null : -1',
                            'role': 'option',
                            '[class.mat-chip-selected]': 'selected',
                            '[class.mat-chip-with-avatar]': 'avatar',
                            '[class.mat-chip-with-trailing-icon]': 'trailingIcon || removeIcon',
                            '[class.mat-chip-disabled]': 'disabled',
                            '[attr.disabled]': 'disabled || null',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.aria-selected]': 'ariaSelected',
                            '(click)': '_handleClick($event)',
                            '(keydown)': '_handleKeydown($event)',
                            '(focus)': 'focus()',
                            '(blur)': '_blur()',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatChip.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
        ]; };
        MatChip.propDecorators = {
            "avatar": [{ type: core.ContentChild, args: [MatChipAvatar,] },],
            "trailingIcon": [{ type: core.ContentChild, args: [MatChipTrailingIcon,] },],
            "removeIcon": [{ type: core.ContentChild, args: [core.forwardRef(function () { return MatChipRemove; }),] },],
            "selected": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "selectable": [{ type: core.Input },],
            "removable": [{ type: core.Input },],
            "selectionChange": [{ type: core.Output },],
            "destroyed": [{ type: core.Output },],
            "removed": [{ type: core.Output },],
        };
        return MatChip;
    }(_MatChipMixinBase));
    /**
     * Applies proper (click) support and adds styling for use with the Material Design "cancel" icon
     * available at https://material.io/icons/#ic_cancel.
     *
     * Example:
     *
     *     `<mat-chip>
     *       <mat-icon matChipRemove>cancel</mat-icon>
     *     </mat-chip>`
     *
     * You *may* use a custom icon, but you may need to override the `mat-chip-remove` positioning
     * styles to properly center the icon within the chip.
     */
    var MatChipRemove = /** @class */ (function () {
        function MatChipRemove(_parentChip) {
            this._parentChip = _parentChip;
        }
        /** Calls the parent chip's public `remove()` method if applicable. */
        /**
         * Calls the parent chip's public `remove()` method if applicable.
         * @return {?}
         */
        MatChipRemove.prototype._handleClick = /**
         * Calls the parent chip's public `remove()` method if applicable.
         * @return {?}
         */
        function () {
            if (this._parentChip.removable) {
                this._parentChip.remove();
            }
        };
        MatChipRemove.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matChipRemove]',
                        host: {
                            'class': 'mat-chip-remove mat-chip-trailing-icon',
                            '(click)': '_handleClick()',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatChipRemove.ctorParameters = function () { return [
            { type: MatChip, },
        ]; };
        return MatChipRemove;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token to be used to override the default options for the chips module.
     */
    var /** @type {?} */ MAT_CHIPS_DEFAULT_OPTIONS = new core.InjectionToken('mat-chips-default-options');

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatChipListBase = /** @class */ (function () {
        function MatChipListBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            this._parentForm = _parentForm;
            this._parentFormGroup = _parentFormGroup;
            this.ngControl = ngControl;
        }
        return MatChipListBase;
    }());
    var /** @type {?} */ _MatChipListMixinBase = mixinErrorState(MatChipListBase);
    // Increasing integer for generating unique ids for chip-list components.
    var /** @type {?} */ nextUniqueId$4 = 0;
    /**
     * Change event object that is emitted when the chip list value has changed.
     */
    var  /**
     * Change event object that is emitted when the chip list value has changed.
     */
    MatChipListChange = /** @class */ (function () {
        function MatChipListChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MatChipListChange;
    }());
    /**
     * A material design chips component (named ChipList for it's similarity to the List component).
     */
    var MatChipList = /** @class */ (function (_super) {
        __extends(MatChipList, _super);
        function MatChipList(_elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, /** @docs-private */
        ngControl) {
            var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._elementRef = _elementRef;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._dir = _dir;
            _this.ngControl = ngControl;
            /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             */
            _this.controlType = 'mat-chip-list';
            /**
             * When a chip is destroyed, we track the index so we can focus the appropriate next chip.
             */
            _this._lastDestroyedIndex = null;
            /**
             * Track which chips we're listening to for focus/destruction.
             */
            _this._chipSet = new WeakMap();
            /**
             * Subscription to tabbing out from the chip list.
             */
            _this._tabOutSubscription = rxjs.Subscription.EMPTY;
            /**
             * Uid of the chip list
             */
            _this._uid = "mat-chip-list-" + nextUniqueId$4++;
            /**
             * Tab index for the chip list.
             */
            _this._tabIndex = 0;
            /**
             * User defined tab index.
             * When it is not null, use user defined tab index. Otherwise use _tabIndex
             */
            _this._userTabIndex = null;
            /**
             * Function when touched
             */
            _this._onTouched = function () { };
            /**
             * Function when changed
             */
            _this._onChange = function () { };
            _this._multiple = false;
            _this._compareWith = function (o1, o2) { return o1 === o2; };
            _this._required = false;
            _this._disabled = false;
            /**
             * Orientation of the chip list.
             */
            _this.ariaOrientation = 'horizontal';
            _this._selectable = true;
            /**
             * Event emitted when the selected chip list value has been changed by the user.
             */
            _this.change = new core.EventEmitter();
            /**
             * Event that emits whenever the raw value of the chip-list changes. This is here primarily
             * to facilitate the two-way binding for the `value` input.
             * \@docs-private
             */
            _this.valueChange = new core.EventEmitter();
            if (_this.ngControl) {
                _this.ngControl.valueAccessor = _this;
            }
            return _this;
        }
        Object.defineProperty(MatChipList.prototype, "selected", {
            /** The array of selected chips inside chip list. */
            get: /**
             * The array of selected chips inside chip list.
             * @return {?}
             */
            function () {
                return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "role", {
            /** The ARIA role applied to the chip list. */
            get: /**
             * The ARIA role applied to the chip list.
             * @return {?}
             */
            function () { return this.empty ? null : 'listbox'; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "multiple", {
            get: /**
             * Whether the user should be allowed to select multiple chips.
             * @return {?}
             */
            function () { return this._multiple; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._multiple = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "compareWith", {
            get: /**
             * A function to compare the option values with the selected values. The first argument
             * is a value from an option. The second is a value from the selection. A boolean
             * should be returned.
             * @return {?}
             */
            function () { return this._compareWith; },
            set: /**
             * @param {?} fn
             * @return {?}
             */
            function (fn) {
                this._compareWith = fn;
                if (this._selectionModel) {
                    // A different comparator means the selection could change.
                    this._initializeSelection();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "value", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this.writeValue(value);
                this._value = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "id", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                return this._chipInput ? this._chipInput.id : this._uid;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "required", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._required = coerceBooleanProperty(value);
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "placeholder", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                return this._chipInput ? this._chipInput.placeholder : this._placeholder;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._placeholder = value;
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "focused", {
            /** Whether any chips or the matChipInput inside of this chip-list has focus. */
            get: /**
             * Whether any chips or the matChipInput inside of this chip-list has focus.
             * @return {?}
             */
            function () {
                return this.chips.some(function (chip) { return chip._hasFocus; }) ||
                    (this._chipInput && this._chipInput.focused);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "empty", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                return (!this._chipInput || this._chipInput.empty) && this.chips.length === 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "shouldLabelFloat", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return !this.empty || this.focused; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "disabled", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this.ngControl ? !!this.ngControl.disabled : this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._disabled = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "selectable", {
            get: /**
             * Whether or not this chip list is selectable. When a chip list is not selectable,
             * the selected states for all the chips inside the chip list are always ignored.
             * @return {?}
             */
            function () { return this._selectable; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var _this = this;
                this._selectable = coerceBooleanProperty(value);
                if (this.chips) {
                    this.chips.forEach(function (chip) { return chip.chipListSelectable = _this._selectable; });
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "tabIndex", {
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._userTabIndex = value;
                this._tabIndex = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "chipSelectionChanges", {
            /** Combined stream of all of the child chips' selection change events. */
            get: /**
             * Combined stream of all of the child chips' selection change events.
             * @return {?}
             */
            function () {
                return rxjs.merge.apply(void 0, this.chips.map(function (chip) { return chip.selectionChange; }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "chipFocusChanges", {
            /** Combined stream of all of the child chips' focus change events. */
            get: /**
             * Combined stream of all of the child chips' focus change events.
             * @return {?}
             */
            function () {
                return rxjs.merge.apply(void 0, this.chips.map(function (chip) { return chip._onFocus; }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "chipBlurChanges", {
            /** Combined stream of all of the child chips' blur change events. */
            get: /**
             * Combined stream of all of the child chips' blur change events.
             * @return {?}
             */
            function () {
                return rxjs.merge.apply(void 0, this.chips.map(function (chip) { return chip._onBlur; }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipList.prototype, "chipRemoveChanges", {
            /** Combined stream of all of the child chips' remove change events. */
            get: /**
             * Combined stream of all of the child chips' remove change events.
             * @return {?}
             */
            function () {
                return rxjs.merge.apply(void 0, this.chips.map(function (chip) { return chip.destroyed; }));
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatChipList.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._keyManager = new FocusKeyManager(this.chips)
                .withWrap()
                .withVerticalOrientation()
                .withHorizontalOrientation(this._dir ? this._dir.value : 'ltr');
            // Prevents the chip list from capturing focus and redirecting
            // it back to the first chip when the user tabs out.
            this._tabOutSubscription = this._keyManager.tabOut.subscribe(function () {
                _this._tabIndex = -1;
                setTimeout(function () { return _this._tabIndex = _this._userTabIndex || 0; });
            });
            // When the list changes, re-subscribe
            this._changeSubscription = this.chips.changes.pipe(operators.startWith(null)).subscribe(function () {
                _this._resetChips();
                // Reset chips selected/deselected status
                // Reset chips selected/deselected status
                _this._initializeSelection();
                // Check to see if we need to update our tab index
                // Check to see if we need to update our tab index
                _this._updateTabIndex();
                // Check to see if we have a destroyed chip and need to refocus
                // Check to see if we have a destroyed chip and need to refocus
                _this._updateFocusForDestroyedChips();
                _this.stateChanges.next();
            });
        };
        /**
         * @return {?}
         */
        MatChipList.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._selectionModel = new SelectionModel(this.multiple, undefined, false);
            this.stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatChipList.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
        };
        /**
         * @return {?}
         */
        MatChipList.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._tabOutSubscription.unsubscribe();
            if (this._changeSubscription) {
                this._changeSubscription.unsubscribe();
            }
            if (this._chipRemoveSubscription) {
                this._chipRemoveSubscription.unsubscribe();
            }
            this._dropSubscriptions();
            this.stateChanges.complete();
        };
        /** Associates an HTML input element with this chip list. */
        /**
         * Associates an HTML input element with this chip list.
         * @param {?} inputElement
         * @return {?}
         */
        MatChipList.prototype.registerInput = /**
         * Associates an HTML input element with this chip list.
         * @param {?} inputElement
         * @return {?}
         */
        function (inputElement) {
            this._chipInput = inputElement;
        };
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        MatChipList.prototype.setDescribedByIds = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        function (ids) { this._ariaDescribedby = ids.join(' '); };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} value
         * @return {?}
         */
        MatChipList.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this.chips) {
                this._setSelectionByValue(value, false);
            }
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatChipList.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onChange = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatChipList.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        MatChipList.prototype.setDisabledState = /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
            this._elementRef.nativeElement.disabled = isDisabled;
            this.stateChanges.next();
        };
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        MatChipList.prototype.onContainerClick = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        function () { this.focus(); };
        /**
         * Focuses the the first non-disabled chip in this chip list, or the associated input when there
         * are no eligible chips.
         */
        /**
         * Focuses the the first non-disabled chip in this chip list, or the associated input when there
         * are no eligible chips.
         * @return {?}
         */
        MatChipList.prototype.focus = /**
         * Focuses the the first non-disabled chip in this chip list, or the associated input when there
         * are no eligible chips.
         * @return {?}
         */
        function () {
            // TODO: ARIA says this should focus the first `selected` chip if any are selected.
            // Focus on first element if there's no chipInput inside chip-list
            if (this._chipInput && this._chipInput.focused) ;
            else if (this.chips.length > 0) {
                this._keyManager.setFirstItemActive();
                this.stateChanges.next();
            }
            else {
                this._focusInput();
                this.stateChanges.next();
            }
        };
        /** Attempt to focus an input if we have one. */
        /**
         * Attempt to focus an input if we have one.
         * @return {?}
         */
        MatChipList.prototype._focusInput = /**
         * Attempt to focus an input if we have one.
         * @return {?}
         */
        function () {
            if (this._chipInput) {
                this._chipInput.focus();
            }
        };
        /**
         * Pass events to the keyboard manager. Available here for tests.
         */
        /**
         * Pass events to the keyboard manager. Available here for tests.
         * @param {?} event
         * @return {?}
         */
        MatChipList.prototype._keydown = /**
         * Pass events to the keyboard manager. Available here for tests.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ target = /** @type {?} */ (event.target);
            // If they are on an empty input and hit backspace, focus the last chip
            if (event.keyCode === BACKSPACE && this._isInputEmpty(target)) {
                this._keyManager.setLastItemActive();
                event.preventDefault();
            }
            else if (target && target.classList.contains('mat-chip')) {
                this._keyManager.onKeydown(event);
                this.stateChanges.next();
            }
        };
        /**
         * Check the tab index as you should not be allowed to focus an empty list.
         */
        /**
         * Check the tab index as you should not be allowed to focus an empty list.
         * @return {?}
         */
        MatChipList.prototype._updateTabIndex = /**
         * Check the tab index as you should not be allowed to focus an empty list.
         * @return {?}
         */
        function () {
            // If we have 0 chips, we should not allow keyboard focus
            this._tabIndex = this._userTabIndex || (this.chips.length === 0 ? -1 : 0);
        };
        /**
         * Update key manager's active item when chip is deleted.
         * If the deleted chip is the last chip in chip list, focus the new last chip.
         * Otherwise focus the next chip in the list.
         * Save `_lastDestroyedIndex` so we can set the correct focus.
         */
        /**
         * Update key manager's active item when chip is deleted.
         * If the deleted chip is the last chip in chip list, focus the new last chip.
         * Otherwise focus the next chip in the list.
         * Save `_lastDestroyedIndex` so we can set the correct focus.
         * @param {?} chip
         * @return {?}
         */
        MatChipList.prototype._updateKeyManager = /**
         * Update key manager's active item when chip is deleted.
         * If the deleted chip is the last chip in chip list, focus the new last chip.
         * Otherwise focus the next chip in the list.
         * Save `_lastDestroyedIndex` so we can set the correct focus.
         * @param {?} chip
         * @return {?}
         */
        function (chip) {
            var /** @type {?} */ chipIndex = this.chips.toArray().indexOf(chip);
            if (this._isValidIndex(chipIndex)) {
                if (chip._hasFocus) {
                    // Check whether the chip is not the last item
                    if (chipIndex < this.chips.length - 1) {
                        this._keyManager.setActiveItem(chipIndex);
                    }
                    else if (chipIndex - 1 >= 0) {
                        this._keyManager.setActiveItem(chipIndex - 1);
                    }
                }
                if (this._keyManager.activeItemIndex === chipIndex) {
                    this._lastDestroyedIndex = chipIndex;
                }
            }
        };
        /**
         * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
         * one.
         */
        /**
         * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
         * one.
         * @return {?}
         */
        MatChipList.prototype._updateFocusForDestroyedChips = /**
         * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
         * one.
         * @return {?}
         */
        function () {
            var /** @type {?} */ chipsArray = this.chips;
            if (this._lastDestroyedIndex != null && chipsArray.length > 0 && this.focused) {
                // Check whether the destroyed chip was the last item
                var /** @type {?} */ newFocusIndex = Math.min(this._lastDestroyedIndex, chipsArray.length - 1);
                this._keyManager.setActiveItem(newFocusIndex);
                var /** @type {?} */ focusChip = this._keyManager.activeItem;
                // Focus the chip
                if (focusChip) {
                    focusChip.focus();
                }
            }
            // Reset our destroyed index
            this._lastDestroyedIndex = null;
        };
        /**
         * Utility to ensure all indexes are valid.
         *
         * @param {?} index The index to be checked.
         * @return {?} True if the index is valid for our list of chips.
         */
        MatChipList.prototype._isValidIndex = /**
         * Utility to ensure all indexes are valid.
         *
         * @param {?} index The index to be checked.
         * @return {?} True if the index is valid for our list of chips.
         */
        function (index) {
            return index >= 0 && index < this.chips.length;
        };
        /**
         * @param {?} element
         * @return {?}
         */
        MatChipList.prototype._isInputEmpty = /**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (element && element.nodeName.toLowerCase() === 'input') {
                var /** @type {?} */ input = /** @type {?} */ (element);
                return !input.value;
            }
            return false;
        };
        /**
         * @param {?} value
         * @param {?=} isUserInput
         * @return {?}
         */
        MatChipList.prototype._setSelectionByValue = /**
         * @param {?} value
         * @param {?=} isUserInput
         * @return {?}
         */
        function (value, isUserInput) {
            var _this = this;
            if (isUserInput === void 0) { isUserInput = true; }
            this._clearSelection();
            this.chips.forEach(function (chip) { return chip.deselect(); });
            if (Array.isArray(value)) {
                value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
                this._sortValues();
            }
            else {
                var /** @type {?} */ correspondingChip = this._selectValue(value, isUserInput);
                // Shift focus to the active item. Note that we shouldn't do this in multiple
                // mode, because we don't know what chip the user interacted with last.
                if (correspondingChip) {
                    if (isUserInput) {
                        this._keyManager.setActiveItem(correspondingChip);
                    }
                }
            }
        };
        /**
         * Finds and selects the chip based on its value.
         * @param {?} value
         * @param {?=} isUserInput
         * @return {?} Chip that has the corresponding value.
         */
        MatChipList.prototype._selectValue = /**
         * Finds and selects the chip based on its value.
         * @param {?} value
         * @param {?=} isUserInput
         * @return {?} Chip that has the corresponding value.
         */
        function (value, isUserInput) {
            var _this = this;
            if (isUserInput === void 0) { isUserInput = true; }
            var /** @type {?} */ correspondingChip = this.chips.find(function (chip) {
                return chip.value != null && _this._compareWith(chip.value, value);
            });
            if (correspondingChip) {
                isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
                this._selectionModel.select(correspondingChip);
            }
            return correspondingChip;
        };
        /**
         * @return {?}
         */
        MatChipList.prototype._initializeSelection = /**
         * @return {?}
         */
        function () {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                if (_this.ngControl || _this._value) {
                    _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value, false);
                    _this.stateChanges.next();
                }
            });
        };
        /**
         * Deselects every chip in the list.
         * @param {?=} skip Chip that should not be deselected.
         * @return {?}
         */
        MatChipList.prototype._clearSelection = /**
         * Deselects every chip in the list.
         * @param {?=} skip Chip that should not be deselected.
         * @return {?}
         */
        function (skip) {
            this._selectionModel.clear();
            this.chips.forEach(function (chip) {
                if (chip !== skip) {
                    chip.deselect();
                }
            });
            this.stateChanges.next();
        };
        /**
         * Sorts the model values, ensuring that they keep the same
         * order that they have in the panel.
         * @return {?}
         */
        MatChipList.prototype._sortValues = /**
         * Sorts the model values, ensuring that they keep the same
         * order that they have in the panel.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._multiple) {
                this._selectionModel.clear();
                this.chips.forEach(function (chip) {
                    if (chip.selected) {
                        _this._selectionModel.select(chip);
                    }
                });
                this.stateChanges.next();
            }
        };
        /**
         * Emits change event to set the model value.
         * @param {?=} fallbackValue
         * @return {?}
         */
        MatChipList.prototype._propagateChanges = /**
         * Emits change event to set the model value.
         * @param {?=} fallbackValue
         * @return {?}
         */
        function (fallbackValue) {
            var /** @type {?} */ valueToEmit = null;
            if (Array.isArray(this.selected)) {
                valueToEmit = this.selected.map(function (chip) { return chip.value; });
            }
            else {
                valueToEmit = this.selected ? this.selected.value : fallbackValue;
            }
            this._value = valueToEmit;
            this.change.emit(new MatChipListChange(this, valueToEmit));
            this.valueChange.emit(valueToEmit);
            this._onChange(valueToEmit);
            this._changeDetectorRef.markForCheck();
        };
        /** When blurred, mark the field as touched when focus moved outside the chip list. */
        /**
         * When blurred, mark the field as touched when focus moved outside the chip list.
         * @return {?}
         */
        MatChipList.prototype._blur = /**
         * When blurred, mark the field as touched when focus moved outside the chip list.
         * @return {?}
         */
        function () {
            var _this = this;
            this._keyManager.setActiveItem(-1);
            if (!this.disabled) {
                if (this._chipInput) {
                    // If there's a chip input, we should check whether the focus moved to chip input.
                    // If the focus is not moved to chip input, mark the field as touched. If the focus moved
                    // to chip input, do nothing.
                    // Timeout is needed to wait for the focus() event trigger on chip input.
                    setTimeout(function () {
                        if (!_this.focused) {
                            _this._markAsTouched();
                        }
                    });
                }
                else {
                    // If there's no chip input, then mark the field as touched.
                    this._markAsTouched();
                }
            }
        };
        /** Mark the field as touched */
        /**
         * Mark the field as touched
         * @return {?}
         */
        MatChipList.prototype._markAsTouched = /**
         * Mark the field as touched
         * @return {?}
         */
        function () {
            this._onTouched();
            this._changeDetectorRef.markForCheck();
            this.stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatChipList.prototype._resetChips = /**
         * @return {?}
         */
        function () {
            this._dropSubscriptions();
            this._listenToChipsFocus();
            this._listenToChipsSelection();
            this._listenToChipsRemoved();
        };
        /**
         * @return {?}
         */
        MatChipList.prototype._dropSubscriptions = /**
         * @return {?}
         */
        function () {
            if (this._chipFocusSubscription) {
                this._chipFocusSubscription.unsubscribe();
                this._chipFocusSubscription = null;
            }
            if (this._chipBlurSubscription) {
                this._chipBlurSubscription.unsubscribe();
                this._chipBlurSubscription = null;
            }
            if (this._chipSelectionSubscription) {
                this._chipSelectionSubscription.unsubscribe();
                this._chipSelectionSubscription = null;
            }
        };
        /**
         * Listens to user-generated selection events on each chip.
         * @return {?}
         */
        MatChipList.prototype._listenToChipsSelection = /**
         * Listens to user-generated selection events on each chip.
         * @return {?}
         */
        function () {
            var _this = this;
            this._chipSelectionSubscription = this.chipSelectionChanges.subscribe(function (event) {
                event.source.selected
                    ? _this._selectionModel.select(event.source)
                    : _this._selectionModel.deselect(event.source);
                // For single selection chip list, make sure the deselected value is unselected.
                if (!_this.multiple) {
                    _this.chips.forEach(function (chip) {
                        if (!_this._selectionModel.isSelected(chip) && chip.selected) {
                            chip.deselect();
                        }
                    });
                }
                if (event.isUserInput) {
                    _this._propagateChanges();
                }
            });
        };
        /**
         * Listens to user-generated selection events on each chip.
         * @return {?}
         */
        MatChipList.prototype._listenToChipsFocus = /**
         * Listens to user-generated selection events on each chip.
         * @return {?}
         */
        function () {
            var _this = this;
            this._chipFocusSubscription = this.chipFocusChanges.subscribe(function (event) {
                var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(event.chip);
                if (_this._isValidIndex(chipIndex)) {
                    _this._keyManager.updateActiveItemIndex(chipIndex);
                }
                _this.stateChanges.next();
            });
            this._chipBlurSubscription = this.chipBlurChanges.subscribe(function () {
                _this._blur();
                _this.stateChanges.next();
            });
        };
        /**
         * @return {?}
         */
        MatChipList.prototype._listenToChipsRemoved = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._chipRemoveSubscription = this.chipRemoveChanges.subscribe(function (event) {
                _this._updateKeyManager(event.chip);
            });
        };
        MatChipList.decorators = [
            { type: core.Component, args: [{selector: 'mat-chip-list',
                        template: "<div class=\"mat-chip-list-wrapper\"><ng-content></ng-content></div>",
                        exportAs: 'matChipList',
                        host: {
                            '[attr.tabindex]': '_tabIndex',
                            '[attr.aria-describedby]': '_ariaDescribedby || null',
                            '[attr.aria-required]': 'required.toString()',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.aria-invalid]': 'errorState',
                            '[attr.aria-multiselectable]': 'multiple',
                            '[attr.role]': 'role',
                            '[class.mat-chip-list-disabled]': 'disabled',
                            '[class.mat-chip-list-invalid]': 'errorState',
                            '[class.mat-chip-list-required]': 'required',
                            '[attr.aria-orientation]': 'ariaOrientation',
                            'class': 'mat-chip-list',
                            '(focus)': 'focus()',
                            '(blur)': '_blur()',
                            '(keydown)': '_keydown($event)',
                            '[id]': '_uid',
                        },
                        providers: [{ provide: MatFormFieldControl, useExisting: MatChipList }],
                        styles: [".mat-chip{position:relative;overflow:hidden;box-sizing:border-box}.mat-standard-chip{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:inline-flex;padding:7px 12px;border-radius:24px;align-items:center;cursor:default}.mat-standard-chip .mat-chip-remove.mat-icon{width:18px;height:18px}.mat-standard-chip:focus{box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);outline:0}@media screen and (-ms-high-contrast:active){.mat-standard-chip{outline:solid 1px}}.mat-standard-chip.mat-chip-with-avatar,.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-top:0;padding-bottom:0}.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-right:7px;padding-left:0}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-left:7px;padding-right:0}.mat-standard-chip.mat-chip-with-trailing-icon{padding-top:7px;padding-bottom:7px;padding-right:7px;padding-left:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon{padding-left:7px;padding-right:12px}.mat-standard-chip.mat-chip-with-avatar{padding-left:0;padding-right:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-avatar{padding-right:0;padding-left:12px}.mat-standard-chip .mat-chip-avatar{width:32px;height:32px;margin-right:8px;margin-left:0}[dir=rtl] .mat-standard-chip .mat-chip-avatar{margin-left:8px;margin-right:0}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{width:18px;height:18px;cursor:pointer}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{margin-left:7px;margin-right:0}[dir=rtl] .mat-standard-chip .mat-chip-remove,[dir=rtl] .mat-standard-chip .mat-chip-trailing-icon{margin-right:7px;margin-left:0}.mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:-4px}.mat-chip-list-wrapper .mat-standard-chip,.mat-chip-list-wrapper input.mat-input-element{margin:4px}.mat-chip-list-stacked .mat-chip-list-wrapper{flex-direction:column;align-items:flex-start}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-standard-chip{width:100%}.mat-chip-avatar{border-radius:50%;justify-content:center;align-items:center;display:flex;overflow:hidden}input.mat-chip-input{width:150px;margin:3px;flex:1 0 150px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatChipList.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: NgForm, decorators: [{ type: core.Optional },] },
            { type: FormGroupDirective, decorators: [{ type: core.Optional },] },
            { type: ErrorStateMatcher, },
            { type: NgControl, decorators: [{ type: core.Optional }, { type: core.Self },] },
        ]; };
        MatChipList.propDecorators = {
            "errorStateMatcher": [{ type: core.Input },],
            "multiple": [{ type: core.Input },],
            "compareWith": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "required": [{ type: core.Input },],
            "placeholder": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "ariaOrientation": [{ type: core.Input, args: ['aria-orientation',] },],
            "selectable": [{ type: core.Input },],
            "tabIndex": [{ type: core.Input },],
            "change": [{ type: core.Output },],
            "valueChange": [{ type: core.Output },],
            "chips": [{ type: core.ContentChildren, args: [MatChip,] },],
        };
        return MatChipList;
    }(_MatChipListMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Increasing integer for generating unique ids.
    var /** @type {?} */ nextUniqueId$1$2 = 0;
    /**
     * Directive that adds chip-specific behaviors to an input element inside `<mat-form-field>`.
     * May be placed inside or outside of an `<mat-chip-list>`.
     */
    var MatChipInput = /** @class */ (function () {
        function MatChipInput(_elementRef, _defaultOptions) {
            this._elementRef = _elementRef;
            this._defaultOptions = _defaultOptions;
            /**
             * Whether the control is focused.
             */
            this.focused = false;
            this._addOnBlur = false;
            /**
             * The list of key codes that will trigger a chipEnd event.
             *
             * Defaults to `[ENTER]`.
             */
            this.separatorKeyCodes = this._defaultOptions.separatorKeyCodes;
            /**
             * Emitted when a chip is to be added.
             */
            this.chipEnd = new core.EventEmitter();
            /**
             * The input's placeholder text.
             * @deprecated Bind to the `placeholder` attribute directly.
             * \@deletion-target 7.0.0
             */
            this.placeholder = '';
            /**
             * Unique id for the input.
             */
            this.id = "mat-chip-list-input-" + nextUniqueId$1$2++;
            this._inputElement = /** @type {?} */ (this._elementRef.nativeElement);
        }
        Object.defineProperty(MatChipInput.prototype, "chipList", {
            set: /**
             * Register input for chip list
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value) {
                    this._chipList = value;
                    this._chipList.registerInput(this);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipInput.prototype, "addOnBlur", {
            get: /**
             * Whether or not the chipEnd event will be emitted when the input is blurred.
             * @return {?}
             */
            function () { return this._addOnBlur; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._addOnBlur = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatChipInput.prototype, "empty", {
            /** Whether the input is empty. */
            get: /**
             * Whether the input is empty.
             * @return {?}
             */
            function () { return !this._inputElement.value; },
            enumerable: true,
            configurable: true
        });
        /** Utility method to make host definition/tests more clear. */
        /**
         * Utility method to make host definition/tests more clear.
         * @param {?=} event
         * @return {?}
         */
        MatChipInput.prototype._keydown = /**
         * Utility method to make host definition/tests more clear.
         * @param {?=} event
         * @return {?}
         */
        function (event) {
            this._emitChipEnd(event);
        };
        /** Checks to see if the blur should emit the (chipEnd) event. */
        /**
         * Checks to see if the blur should emit the (chipEnd) event.
         * @return {?}
         */
        MatChipInput.prototype._blur = /**
         * Checks to see if the blur should emit the (chipEnd) event.
         * @return {?}
         */
        function () {
            if (this.addOnBlur) {
                this._emitChipEnd();
            }
            this.focused = false;
            // Blur the chip list if it is not focused
            if (!this._chipList.focused) {
                this._chipList._blur();
            }
            this._chipList.stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatChipInput.prototype._focus = /**
         * @return {?}
         */
        function () {
            this.focused = true;
            this._chipList.stateChanges.next();
        };
        /** Checks to see if the (chipEnd) event needs to be emitted. */
        /**
         * Checks to see if the (chipEnd) event needs to be emitted.
         * @param {?=} event
         * @return {?}
         */
        MatChipInput.prototype._emitChipEnd = /**
         * Checks to see if the (chipEnd) event needs to be emitted.
         * @param {?=} event
         * @return {?}
         */
        function (event) {
            if (!this._inputElement.value && !!event) {
                this._chipList._keydown(event);
            }
            if (!event || this.separatorKeyCodes.indexOf(event.keyCode) > -1) {
                this.chipEnd.emit({ input: this._inputElement, value: this._inputElement.value });
                if (event) {
                    event.preventDefault();
                }
            }
        };
        /**
         * @return {?}
         */
        MatChipInput.prototype._onInput = /**
         * @return {?}
         */
        function () {
            // Let chip list know whenever the value changes.
            this._chipList.stateChanges.next();
        };
        /** Focuses the input. */
        /**
         * Focuses the input.
         * @return {?}
         */
        MatChipInput.prototype.focus = /**
         * Focuses the input.
         * @return {?}
         */
        function () { this._inputElement.focus(); };
        MatChipInput.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[matChipInputFor]',
                        exportAs: 'matChipInput, matChipInputFor',
                        host: {
                            'class': 'mat-chip-input mat-input-element',
                            '(keydown)': '_keydown($event)',
                            '(blur)': '_blur()',
                            '(focus)': '_focus()',
                            '(input)': '_onInput()',
                            '[id]': 'id',
                            '[attr.placeholder]': 'placeholder || null',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatChipInput.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_CHIPS_DEFAULT_OPTIONS,] },] },
        ]; };
        MatChipInput.propDecorators = {
            "chipList": [{ type: core.Input, args: ['matChipInputFor',] },],
            "addOnBlur": [{ type: core.Input, args: ['matChipInputAddOnBlur',] },],
            "separatorKeyCodes": [{ type: core.Input, args: ['matChipInputSeparatorKeyCodes',] },],
            "chipEnd": [{ type: core.Output, args: ['matChipInputTokenEnd',] },],
            "placeholder": [{ type: core.Input },],
            "id": [{ type: core.Input },],
        };
        return MatChipInput;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Configuration for opening a modal dialog with the MatDialog service.
     * @template D
     */
    var  /**
     * Configuration for opening a modal dialog with the MatDialog service.
     * @template D
     */
    MatDialogConfig = /** @class */ (function () {
        function MatDialogConfig() {
            /**
             * The ARIA role of the dialog element.
             */
            this.role = 'dialog';
            /**
             * Custom class for the overlay pane.
             */
            this.panelClass = '';
            /**
             * Whether the dialog has a backdrop.
             */
            this.hasBackdrop = true;
            /**
             * Custom class for the backdrop,
             */
            this.backdropClass = '';
            /**
             * Whether the user can use escape or clicking on the backdrop to close the modal.
             */
            this.disableClose = false;
            /**
             * Width of the dialog.
             */
            this.width = '';
            /**
             * Height of the dialog.
             */
            this.height = '';
            /**
             * Max-width of the dialog. If a number is provided, pixel units are assumed. Defaults to 80vw
             */
            this.maxWidth = '80vw';
            /**
             * Data being injected into the child component.
             */
            this.data = null;
            /**
             * ID of the element that describes the dialog.
             */
            this.ariaDescribedBy = null;
            /**
             * Aria label to assign to the dialog element
             */
            this.ariaLabel = null;
            /**
             * Whether the dialog should focus the first focusable element on open.
             */
            this.autoFocus = true;
            /**
             * Whether the dialog should close when the user goes backwards/forwards in history.
             */
            this.closeOnNavigation = true;
        }
        return MatDialogConfig;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by MatDialog.
     */
    var /** @type {?} */ matDialogAnimations = {
        /** Animation that slides the dialog in and out of view and fades the opacity. */
        slideDialog: trigger('slideDialog', [
            // Note: The `enter` animation doesn't transition to something like `translate3d(0, 0, 0)
            // scale(1)`, because for some reason specifying the transform explicitly, causes IE both
            // to blur the dialog content and decimate the animation performance. Leaving it as `none`
            // solves both issues.
            state('enter', style({ transform: 'none', opacity: 1 })),
            state('void', style({ transform: 'translate3d(0, 25%, 0) scale(0.9)', opacity: 0 })),
            state('exit', style({ transform: 'translate3d(0, 25%, 0)', opacity: 0 })),
            transition('* => *', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Throws an exception for the case when a ComponentPortal is
     * attached to a DomPortalOutlet without an origin.
     * \@docs-private
     * @return {?}
     */
    function throwMatDialogContentAlreadyAttachedError() {
        throw Error('Attempting to attach dialog content after content is already attached');
    }
    /**
     * Internal component that wraps user-provided dialog content.
     * Animation is based on https://material.io/guidelines/motion/choreography.html.
     * \@docs-private
     */
    var MatDialogContainer = /** @class */ (function (_super) {
        __extends(MatDialogContainer, _super);
        function MatDialogContainer(_elementRef, _focusTrapFactory, _changeDetectorRef, _document, _config) {
            var _this = _super.call(this) || this;
            _this._elementRef = _elementRef;
            _this._focusTrapFactory = _focusTrapFactory;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._document = _document;
            _this._config = _config;
            /**
             * Element that was focused before the dialog was opened. Save this to restore upon close.
             */
            _this._elementFocusedBeforeDialogWasOpened = null;
            /**
             * State of the dialog animation.
             */
            _this._state = 'enter';
            /**
             * Emits when an animation state changes.
             */
            _this._animationStateChanged = new core.EventEmitter();
            /**
             * ID of the element that should be considered as the dialog's label.
             */
            _this._ariaLabelledBy = null;
            return _this;
        }
        /**
         * Attach a ComponentPortal as content to this dialog container.
         * @param portal Portal to be attached as the dialog content.
         */
        /**
         * Attach a ComponentPortal as content to this dialog container.
         * @template T
         * @param {?} portal Portal to be attached as the dialog content.
         * @return {?}
         */
        MatDialogContainer.prototype.attachComponentPortal = /**
         * Attach a ComponentPortal as content to this dialog container.
         * @template T
         * @param {?} portal Portal to be attached as the dialog content.
         * @return {?}
         */
        function (portal) {
            if (this._portalOutlet.hasAttached()) {
                throwMatDialogContentAlreadyAttachedError();
            }
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachComponentPortal(portal);
        };
        /**
         * Attach a TemplatePortal as content to this dialog container.
         * @param portal Portal to be attached as the dialog content.
         */
        /**
         * Attach a TemplatePortal as content to this dialog container.
         * @template C
         * @param {?} portal Portal to be attached as the dialog content.
         * @return {?}
         */
        MatDialogContainer.prototype.attachTemplatePortal = /**
         * Attach a TemplatePortal as content to this dialog container.
         * @template C
         * @param {?} portal Portal to be attached as the dialog content.
         * @return {?}
         */
        function (portal) {
            if (this._portalOutlet.hasAttached()) {
                throwMatDialogContentAlreadyAttachedError();
            }
            this._savePreviouslyFocusedElement();
            return this._portalOutlet.attachTemplatePortal(portal);
        };
        /**
         * Moves the focus inside the focus trap.
         * @return {?}
         */
        MatDialogContainer.prototype._trapFocus = /**
         * Moves the focus inside the focus trap.
         * @return {?}
         */
        function () {
            if (!this._focusTrap) {
                this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
            }
            // If were to attempt to focus immediately, then the content of the dialog would not yet be
            // ready in instances where change detection has to run first. To deal with this, we simply
            // wait for the microtask queue to be empty.
            if (this._config.autoFocus) {
                this._focusTrap.focusInitialElementWhenReady();
            }
        };
        /**
         * Restores focus to the element that was focused before the dialog opened.
         * @return {?}
         */
        MatDialogContainer.prototype._restoreFocus = /**
         * Restores focus to the element that was focused before the dialog opened.
         * @return {?}
         */
        function () {
            var /** @type {?} */ toFocus = this._elementFocusedBeforeDialogWasOpened;
            // We need the extra check, because IE can set the `activeElement` to null in some cases.
            if (toFocus && typeof toFocus.focus === 'function') {
                toFocus.focus();
            }
            if (this._focusTrap) {
                this._focusTrap.destroy();
            }
        };
        /**
         * Saves a reference to the element that was focused before the dialog was opened.
         * @return {?}
         */
        MatDialogContainer.prototype._savePreviouslyFocusedElement = /**
         * Saves a reference to the element that was focused before the dialog was opened.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._document) {
                this._elementFocusedBeforeDialogWasOpened = /** @type {?} */ (this._document.activeElement);
                // Note that there is no focus method when rendering on the server.
                if (this._elementRef.nativeElement.focus) {
                    // Move focus onto the dialog immediately in order to prevent the user from accidentally
                    // opening multiple dialogs at the same time. Needs to be async, because the element
                    // may not be focusable immediately.
                    Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
                }
            }
        };
        /** Callback, invoked whenever an animation on the host completes. */
        /**
         * Callback, invoked whenever an animation on the host completes.
         * @param {?} event
         * @return {?}
         */
        MatDialogContainer.prototype._onAnimationDone = /**
         * Callback, invoked whenever an animation on the host completes.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.toState === 'enter') {
                this._trapFocus();
            }
            else if (event.toState === 'exit') {
                this._restoreFocus();
            }
            this._animationStateChanged.emit(event);
        };
        /** Callback, invoked when an animation on the host starts. */
        /**
         * Callback, invoked when an animation on the host starts.
         * @param {?} event
         * @return {?}
         */
        MatDialogContainer.prototype._onAnimationStart = /**
         * Callback, invoked when an animation on the host starts.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this._animationStateChanged.emit(event);
        };
        /** Starts the dialog exit animation. */
        /**
         * Starts the dialog exit animation.
         * @return {?}
         */
        MatDialogContainer.prototype._startExitAnimation = /**
         * Starts the dialog exit animation.
         * @return {?}
         */
        function () {
            this._state = 'exit';
            // Mark the container for check so it can react if the
            // view container is using OnPush change detection.
            this._changeDetectorRef.markForCheck();
        };
        MatDialogContainer.decorators = [
            { type: core.Component, args: [{selector: 'mat-dialog-container',
                        template: "<ng-template cdkPortalOutlet></ng-template>",
                        styles: [".mat-dialog-container{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);display:block;padding:24px;border-radius:2px;box-sizing:border-box;overflow:auto;outline:0;width:100%;height:100%;min-height:inherit;max-height:inherit}@media screen and (-ms-high-contrast:active){.mat-dialog-container{outline:solid 1px}}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto;-webkit-overflow-scrolling:touch}.mat-dialog-title{margin:0 0 20px;display:block}.mat-dialog-actions{padding:12px 0;display:flex;flex-wrap:wrap;margin-bottom:-24px}.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions[align=center]{justify-content:center}.mat-dialog-actions .mat-button+.mat-button,.mat-dialog-actions .mat-button+.mat-raised-button,.mat-dialog-actions .mat-raised-button+.mat-button,.mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:8px}[dir=rtl] .mat-dialog-actions .mat-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-button+.mat-raised-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:0;margin-right:8px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        // Using OnPush for dialogs caused some G3 sync issues. Disabled until we can track them down.
                        // tslint:disable-next-line:validate-decorators
                        changeDetection: core.ChangeDetectionStrategy.Default,
                        animations: [matDialogAnimations.slideDialog],
                        host: {
                            'class': 'mat-dialog-container',
                            'tabindex': '-1',
                            'aria-modal': 'true',
                            '[attr.id]': '_id',
                            '[attr.role]': '_config.role',
                            '[attr.aria-labelledby]': '_config.ariaLabel ? null : _ariaLabelledBy',
                            '[attr.aria-label]': '_config.ariaLabel',
                            '[attr.aria-describedby]': '_config.ariaDescribedBy || null',
                            '[@slideDialog]': '_state',
                            '(@slideDialog.start)': '_onAnimationStart($event)',
                            '(@slideDialog.done)': '_onAnimationDone($event)',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatDialogContainer.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: FocusTrapFactory, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: MatDialogConfig, },
        ]; };
        MatDialogContainer.propDecorators = {
            "_portalOutlet": [{ type: core.ViewChild, args: [CdkPortalOutlet,] },],
        };
        return MatDialogContainer;
    }(BasePortalOutlet));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // TODO(jelbourn): resizing
    // Counter for unique dialog ids.
    var /** @type {?} */ uniqueId = 0;
    /**
     * Reference to a dialog opened via the MatDialog service.
     * @template T, R
     */
    var  /**
     * Reference to a dialog opened via the MatDialog service.
     * @template T, R
     */
    MatDialogRef = /** @class */ (function () {
        function MatDialogRef(_overlayRef, _containerInstance, location, id) {
            if (id === void 0) { id = "mat-dialog-" + uniqueId++; }
            var _this = this;
            this._overlayRef = _overlayRef;
            this._containerInstance = _containerInstance;
            this.id = id;
            /**
             * Whether the user is allowed to close the dialog.
             */
            this.disableClose = this._containerInstance._config.disableClose;
            /**
             * Subject for notifying the user that the dialog has finished opening.
             */
            this._afterOpen = new rxjs.Subject();
            /**
             * Subject for notifying the user that the dialog has finished closing.
             */
            this._afterClosed = new rxjs.Subject();
            /**
             * Subject for notifying the user that the dialog has started closing.
             */
            this._beforeClose = new rxjs.Subject();
            /**
             * Subscription to changes in the user's location.
             */
            this._locationChanges = rxjs.Subscription.EMPTY;
            // Pass the id along to the container.
            _containerInstance._id = id;
            // Emit when opening animation completes
            _containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'done' && event.toState === 'enter'; }), operators.take(1))
                .subscribe(function () {
                _this._afterOpen.next();
                _this._afterOpen.complete();
            });
            // Dispose overlay when closing animation is complete
            _containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'done' && event.toState === 'exit'; }), operators.take(1)).subscribe(function () { return _this._overlayRef.dispose(); });
            _overlayRef.detachments().subscribe(function () {
                _this._beforeClose.next(_this._result);
                _this._beforeClose.complete();
                _this._locationChanges.unsubscribe();
                _this._afterClosed.next(_this._result);
                _this._afterClosed.complete();
                _this.componentInstance = /** @type {?} */ ((null));
                _this._overlayRef.dispose();
            });
            _overlayRef.keydownEvents()
                .pipe(operators.filter(function (event) { return event.keyCode === ESCAPE && !_this.disableClose; }))
                .subscribe(function () { return _this.close(); });
            if (location) {
                // Close the dialog when the user goes forwards/backwards in history or when the location
                // hash changes. Note that this usually doesn't include clicking on links (unless the user
                // is using the `HashLocationStrategy`).
                this._locationChanges = location.subscribe(function () {
                    if (_this._containerInstance._config.closeOnNavigation) {
                        _this.close();
                    }
                });
            }
        }
        /**
         * Close the dialog.
         * @param dialogResult Optional result to return to the dialog opener.
         */
        /**
         * Close the dialog.
         * @param {?=} dialogResult Optional result to return to the dialog opener.
         * @return {?}
         */
        MatDialogRef.prototype.close = /**
         * Close the dialog.
         * @param {?=} dialogResult Optional result to return to the dialog opener.
         * @return {?}
         */
        function (dialogResult) {
            var _this = this;
            this._result = dialogResult;
            // Transition the backdrop in parallel to the dialog.
            this._containerInstance._animationStateChanged.pipe(operators.filter(function (event) { return event.phaseName === 'start'; }), operators.take(1))
                .subscribe(function () {
                _this._beforeClose.next(dialogResult);
                _this._beforeClose.complete();
                _this._overlayRef.detachBackdrop();
            });
            this._containerInstance._startExitAnimation();
        };
        /**
         * Gets an observable that is notified when the dialog is finished opening.
         */
        /**
         * Gets an observable that is notified when the dialog is finished opening.
         * @return {?}
         */
        MatDialogRef.prototype.afterOpen = /**
         * Gets an observable that is notified when the dialog is finished opening.
         * @return {?}
         */
        function () {
            return this._afterOpen.asObservable();
        };
        /**
         * Gets an observable that is notified when the dialog is finished closing.
         */
        /**
         * Gets an observable that is notified when the dialog is finished closing.
         * @return {?}
         */
        MatDialogRef.prototype.afterClosed = /**
         * Gets an observable that is notified when the dialog is finished closing.
         * @return {?}
         */
        function () {
            return this._afterClosed.asObservable();
        };
        /**
         * Gets an observable that is notified when the dialog has started closing.
         */
        /**
         * Gets an observable that is notified when the dialog has started closing.
         * @return {?}
         */
        MatDialogRef.prototype.beforeClose = /**
         * Gets an observable that is notified when the dialog has started closing.
         * @return {?}
         */
        function () {
            return this._beforeClose.asObservable();
        };
        /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         */
        /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         * @return {?}
         */
        MatDialogRef.prototype.backdropClick = /**
         * Gets an observable that emits when the overlay's backdrop has been clicked.
         * @return {?}
         */
        function () {
            return this._overlayRef.backdropClick();
        };
        /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         */
        /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         * @return {?}
         */
        MatDialogRef.prototype.keydownEvents = /**
         * Gets an observable that emits when keydown events are targeted on the overlay.
         * @return {?}
         */
        function () {
            return this._overlayRef.keydownEvents();
        };
        /**
         * Updates the dialog's position.
         * @param position New dialog position.
         */
        /**
         * Updates the dialog's position.
         * @param {?=} position New dialog position.
         * @return {?}
         */
        MatDialogRef.prototype.updatePosition = /**
         * Updates the dialog's position.
         * @param {?=} position New dialog position.
         * @return {?}
         */
        function (position) {
            var /** @type {?} */ strategy = this._getPositionStrategy();
            if (position && (position.left || position.right)) {
                position.left ? strategy.left(position.left) : strategy.right(position.right);
            }
            else {
                strategy.centerHorizontally();
            }
            if (position && (position.top || position.bottom)) {
                position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
            }
            else {
                strategy.centerVertically();
            }
            this._overlayRef.updatePosition();
            return this;
        };
        /**
         * Updates the dialog's width and height.
         * @param width New width of the dialog.
         * @param height New height of the dialog.
         */
        /**
         * Updates the dialog's width and height.
         * @param {?=} width New width of the dialog.
         * @param {?=} height New height of the dialog.
         * @return {?}
         */
        MatDialogRef.prototype.updateSize = /**
         * Updates the dialog's width and height.
         * @param {?=} width New width of the dialog.
         * @param {?=} height New height of the dialog.
         * @return {?}
         */
        function (width, height) {
            if (width === void 0) { width = ''; }
            if (height === void 0) { height = ''; }
            this._getPositionStrategy().width(width).height(height);
            this._overlayRef.updatePosition();
            return this;
        };
        /**
         * Fetches the position strategy object from the overlay ref.
         * @return {?}
         */
        MatDialogRef.prototype._getPositionStrategy = /**
         * Fetches the position strategy object from the overlay ref.
         * @return {?}
         */
        function () {
            return /** @type {?} */ (this._overlayRef.getConfig().positionStrategy);
        };
        return MatDialogRef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to access the data that was passed in to a dialog.
     */
    var /** @type {?} */ MAT_DIALOG_DATA = new core.InjectionToken('MatDialogData');
    /**
     * Injection token that can be used to specify default dialog options.
     */
    var /** @type {?} */ MAT_DIALOG_DEFAULT_OPTIONS = new core.InjectionToken('mat-dialog-default-options');
    /**
     * Injection token that determines the scroll handling while the dialog is open.
     */
    var /** @type {?} */ MAT_DIALOG_SCROLL_STRATEGY = new core.InjectionToken('mat-dialog-scroll-strategy');
    /**
     * Service to open Material Design modal dialogs.
     */
    var MatDialog = /** @class */ (function () {
        function MatDialog(_overlay, _injector, _location, _defaultOptions, _scrollStrategy, _parentDialog, _overlayContainer) {
            var _this = this;
            this._overlay = _overlay;
            this._injector = _injector;
            this._location = _location;
            this._defaultOptions = _defaultOptions;
            this._scrollStrategy = _scrollStrategy;
            this._parentDialog = _parentDialog;
            this._overlayContainer = _overlayContainer;
            this._openDialogsAtThisLevel = [];
            this._afterAllClosedAtThisLevel = new rxjs.Subject();
            this._afterOpenAtThisLevel = new rxjs.Subject();
            this._ariaHiddenElements = new Map();
            /**
             * Stream that emits when all open dialog have finished closing.
             * Will emit on subscribe if there are no open dialogs to begin with.
             */
            this.afterAllClosed = rxjs.defer(function () {
                return _this.openDialogs.length ?
                    _this._afterAllClosed :
                    _this._afterAllClosed.pipe(operators.startWith(undefined));
            });
        }
        Object.defineProperty(MatDialog.prototype, "openDialogs", {
            /** Keeps track of the currently-open dialogs. */
            get: /**
             * Keeps track of the currently-open dialogs.
             * @return {?}
             */
            function () {
                return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDialog.prototype, "afterOpen", {
            /** Stream that emits when a dialog has been opened. */
            get: /**
             * Stream that emits when a dialog has been opened.
             * @return {?}
             */
            function () {
                return this._parentDialog ? this._parentDialog.afterOpen : this._afterOpenAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDialog.prototype, "_afterAllClosed", {
            get: /**
             * @return {?}
             */
            function () {
                var /** @type {?} */ parent = this._parentDialog;
                return parent ? parent._afterAllClosed : this._afterAllClosedAtThisLevel;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Opens a modal dialog containing the given component.
         * @param componentOrTemplateRef Type of the component to load into the dialog,
         *     or a TemplateRef to instantiate as the dialog content.
         * @param config Extra configuration options.
         * @returns Reference to the newly-opened dialog.
         */
        /**
         * Opens a modal dialog containing the given component.
         * @template T, D, R
         * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
         *     or a TemplateRef to instantiate as the dialog content.
         * @param {?=} config Extra configuration options.
         * @return {?} Reference to the newly-opened dialog.
         */
        MatDialog.prototype.open = /**
         * Opens a modal dialog containing the given component.
         * @template T, D, R
         * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
         *     or a TemplateRef to instantiate as the dialog content.
         * @param {?=} config Extra configuration options.
         * @return {?} Reference to the newly-opened dialog.
         */
        function (componentOrTemplateRef, config) {
            var _this = this;
            config = _applyConfigDefaults$1(config, this._defaultOptions || new MatDialogConfig());
            if (config.id && this.getDialogById(config.id)) {
                throw Error("Dialog with id \"" + config.id + "\" exists already. The dialog id must be unique.");
            }
            var /** @type {?} */ overlayRef = this._createOverlay(config);
            var /** @type {?} */ dialogContainer = this._attachDialogContainer(overlayRef, config);
            var /** @type {?} */ dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
            // If this is the first dialog that we're opening, hide all the non-overlay content.
            if (!this.openDialogs.length) {
                this._hideNonDialogContentFromAssistiveTechnology();
            }
            this.openDialogs.push(dialogRef);
            dialogRef.afterClosed().subscribe(function () { return _this._removeOpenDialog(dialogRef); });
            this.afterOpen.next(dialogRef);
            return dialogRef;
        };
        /**
         * Closes all of the currently-open dialogs.
         */
        /**
         * Closes all of the currently-open dialogs.
         * @return {?}
         */
        MatDialog.prototype.closeAll = /**
         * Closes all of the currently-open dialogs.
         * @return {?}
         */
        function () {
            var /** @type {?} */ i = this.openDialogs.length;
            while (i--) {
                // The `_openDialogs` property isn't updated after close until the rxjs subscription
                // runs on the next microtask, in addition to modifying the array as we're going
                // through it. We loop through all of them and call close without assuming that
                // they'll be removed from the list instantaneously.
                this.openDialogs[i].close();
            }
        };
        /**
         * Finds an open dialog by its id.
         * @param id ID to use when looking up the dialog.
         */
        /**
         * Finds an open dialog by its id.
         * @param {?} id ID to use when looking up the dialog.
         * @return {?}
         */
        MatDialog.prototype.getDialogById = /**
         * Finds an open dialog by its id.
         * @param {?} id ID to use when looking up the dialog.
         * @return {?}
         */
        function (id) {
            return this.openDialogs.find(function (dialog) { return dialog.id === id; });
        };
        /**
         * Creates the overlay into which the dialog will be loaded.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to the OverlayRef for the created overlay.
         */
        MatDialog.prototype._createOverlay = /**
         * Creates the overlay into which the dialog will be loaded.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to the OverlayRef for the created overlay.
         */
        function (config) {
            var /** @type {?} */ overlayConfig = this._getOverlayConfig(config);
            return this._overlay.create(overlayConfig);
        };
        /**
         * Creates an overlay config from a dialog config.
         * @param {?} dialogConfig The dialog configuration.
         * @return {?} The overlay configuration.
         */
        MatDialog.prototype._getOverlayConfig = /**
         * Creates an overlay config from a dialog config.
         * @param {?} dialogConfig The dialog configuration.
         * @return {?} The overlay configuration.
         */
        function (dialogConfig) {
            var /** @type {?} */ state$$1 = new OverlayConfig({
                positionStrategy: this._overlay.position().global(),
                scrollStrategy: dialogConfig.scrollStrategy || this._scrollStrategy(),
                panelClass: dialogConfig.panelClass,
                hasBackdrop: dialogConfig.hasBackdrop,
                direction: dialogConfig.direction,
                minWidth: dialogConfig.minWidth,
                minHeight: dialogConfig.minHeight,
                maxWidth: dialogConfig.maxWidth,
                maxHeight: dialogConfig.maxHeight
            });
            if (dialogConfig.backdropClass) {
                state$$1.backdropClass = dialogConfig.backdropClass;
            }
            return state$$1;
        };
        /**
         * Attaches an MatDialogContainer to a dialog's already-created overlay.
         * @param {?} overlay Reference to the dialog's underlying overlay.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to a ComponentRef for the attached container.
         */
        MatDialog.prototype._attachDialogContainer = /**
         * Attaches an MatDialogContainer to a dialog's already-created overlay.
         * @param {?} overlay Reference to the dialog's underlying overlay.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to a ComponentRef for the attached container.
         */
        function (overlay, config) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var /** @type {?} */ injector = new PortalInjector(userInjector || this._injector, new WeakMap([
                [MatDialogConfig, config]
            ]));
            var /** @type {?} */ containerPortal = new ComponentPortal(MatDialogContainer, config.viewContainerRef, injector);
            var /** @type {?} */ containerRef = overlay.attach(containerPortal);
            return containerRef.instance;
        };
        /**
         * Attaches the user-provided component to the already-created MatDialogContainer.
         * @template T, R
         * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
         *     or a TemplateRef to instantiate as the content.
         * @param {?} dialogContainer Reference to the wrapping MatDialogContainer.
         * @param {?} overlayRef Reference to the overlay in which the dialog resides.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to the MatDialogRef that should be returned to the user.
         */
        MatDialog.prototype._attachDialogContent = /**
         * Attaches the user-provided component to the already-created MatDialogContainer.
         * @template T, R
         * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
         *     or a TemplateRef to instantiate as the content.
         * @param {?} dialogContainer Reference to the wrapping MatDialogContainer.
         * @param {?} overlayRef Reference to the overlay in which the dialog resides.
         * @param {?} config The dialog configuration.
         * @return {?} A promise resolving to the MatDialogRef that should be returned to the user.
         */
        function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
            // Create a reference to the dialog we're creating in order to give the user a handle
            // to modify and close it.
            var /** @type {?} */ dialogRef = new MatDialogRef(overlayRef, dialogContainer, this._location, config.id);
            // When the dialog backdrop is clicked, we want to close it.
            if (config.hasBackdrop) {
                overlayRef.backdropClick().subscribe(function () {
                    if (!dialogRef.disableClose) {
                        dialogRef.close();
                    }
                });
            }
            if (componentOrTemplateRef instanceof core.TemplateRef) {
                dialogContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, /** @type {?} */ ((null)), /** @type {?} */ ({ $implicit: config.data, dialogRef: dialogRef })));
            }
            else {
                var /** @type {?} */ injector = this._createInjector(config, dialogRef, dialogContainer);
                var /** @type {?} */ contentRef = dialogContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, undefined, injector));
                dialogRef.componentInstance = contentRef.instance;
            }
            dialogRef
                .updateSize(config.width, config.height)
                .updatePosition(config.position);
            return dialogRef;
        };
        /**
         * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
         * of a dialog to close itself and, optionally, to return a value.
         * @template T
         * @param {?} config Config object that is used to construct the dialog.
         * @param {?} dialogRef Reference to the dialog.
         * @param {?} dialogContainer
         * @return {?} The custom injector that can be used inside the dialog.
         */
        MatDialog.prototype._createInjector = /**
         * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
         * of a dialog to close itself and, optionally, to return a value.
         * @template T
         * @param {?} config Config object that is used to construct the dialog.
         * @param {?} dialogRef Reference to the dialog.
         * @param {?} dialogContainer
         * @return {?} The custom injector that can be used inside the dialog.
         */
        function (config, dialogRef, dialogContainer) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            // The MatDialogContainer is injected in the portal as the MatDialogContainer and the dialog's
            // content are created out of the same ViewContainerRef and as such, are siblings for injector
            // purposes. To allow the hierarchy that is expected, the MatDialogContainer is explicitly
            // added to the injection tokens.
            var /** @type {?} */ injectionTokens = new WeakMap([
                [MatDialogContainer, dialogContainer],
                [MAT_DIALOG_DATA, config.data],
                [MatDialogRef, dialogRef]
            ]);
            if (config.direction &&
                (!userInjector || !userInjector.get(Directionality, null))) {
                injectionTokens.set(Directionality, {
                    value: config.direction,
                    change: rxjs.of()
                });
            }
            return new PortalInjector(userInjector || this._injector, injectionTokens);
        };
        /**
         * Removes a dialog from the array of open dialogs.
         * @param {?} dialogRef Dialog to be removed.
         * @return {?}
         */
        MatDialog.prototype._removeOpenDialog = /**
         * Removes a dialog from the array of open dialogs.
         * @param {?} dialogRef Dialog to be removed.
         * @return {?}
         */
        function (dialogRef) {
            var /** @type {?} */ index = this.openDialogs.indexOf(dialogRef);
            if (index > -1) {
                this.openDialogs.splice(index, 1);
                // If all the dialogs were closed, remove/restore the `aria-hidden`
                // to a the siblings and emit to the `afterAllClosed` stream.
                if (!this.openDialogs.length) {
                    this._ariaHiddenElements.forEach(function (previousValue, element) {
                        if (previousValue) {
                            element.setAttribute('aria-hidden', previousValue);
                        }
                        else {
                            element.removeAttribute('aria-hidden');
                        }
                    });
                    this._ariaHiddenElements.clear();
                    this._afterAllClosed.next();
                }
            }
        };
        /**
         * Hides all of the content that isn't an overlay from assistive technology.
         * @return {?}
         */
        MatDialog.prototype._hideNonDialogContentFromAssistiveTechnology = /**
         * Hides all of the content that isn't an overlay from assistive technology.
         * @return {?}
         */
        function () {
            var /** @type {?} */ overlayContainer = this._overlayContainer.getContainerElement();
            // Ensure that the overlay container is attached to the DOM.
            if (overlayContainer.parentElement) {
                var /** @type {?} */ siblings = overlayContainer.parentElement.children;
                for (var /** @type {?} */ i = siblings.length - 1; i > -1; i--) {
                    var /** @type {?} */ sibling = siblings[i];
                    if (sibling !== overlayContainer &&
                        sibling.nodeName !== 'SCRIPT' &&
                        sibling.nodeName !== 'STYLE' &&
                        !sibling.hasAttribute('aria-live')) {
                        this._ariaHiddenElements.set(sibling, sibling.getAttribute('aria-hidden'));
                        sibling.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        };
        MatDialog.decorators = [
            { type: core.Injectable },
        ];
        /** @nocollapse */
        MatDialog.ctorParameters = function () { return [
            { type: Overlay, },
            { type: core.Injector, },
            { type: common.Location, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DIALOG_DEFAULT_OPTIONS,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_DIALOG_SCROLL_STRATEGY,] },] },
            { type: MatDialog, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
            { type: OverlayContainer, },
        ]; };
        return MatDialog;
    }());
    /**
     * Applies default options to the dialog config.
     * @param {?=} config Config to be modified.
     * @param {?=} defaultOptions Default options provided.
     * @return {?} The new configuration object.
     */
    function _applyConfigDefaults$1(config, defaultOptions) {
        return __assign({}, defaultOptions, config);
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Options to pass to the animationstart listener.
     */
    var /** @type {?} */ listenerOptions = supportsPassiveEventListeners() ? { passive: true } : false;
    /**
     * An injectable service that can be used to monitor the autofill state of an input.
     * Based on the following blog post:
     * https://medium.com/\@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7
     */
    var AutofillMonitor = /** @class */ (function () {
        function AutofillMonitor(_platform, _ngZone) {
            this._platform = _platform;
            this._ngZone = _ngZone;
            this._monitoredElements = new Map();
        }
        /**
         * Monitor for changes in the autofill state of the given input element.
         * @param element The element to monitor.
         * @return A stream of autofill state changes.
         */
        /**
         * Monitor for changes in the autofill state of the given input element.
         * @param {?} element The element to monitor.
         * @return {?} A stream of autofill state changes.
         */
        AutofillMonitor.prototype.monitor = /**
         * Monitor for changes in the autofill state of the given input element.
         * @param {?} element The element to monitor.
         * @return {?} A stream of autofill state changes.
         */
        function (element) {
            var _this = this;
            if (!this._platform.isBrowser) {
                return rxjs.EMPTY;
            }
            var /** @type {?} */ info = this._monitoredElements.get(element);
            if (info) {
                return info.subject.asObservable();
            }
            var /** @type {?} */ result = new rxjs.Subject();
            var /** @type {?} */ listener = function (event) {
                if (event.animationName === 'cdk-text-field-autofill-start') {
                    element.classList.add('cdk-text-field-autofilled');
                    _this._ngZone.run(function () { return result.next({ target: /** @type {?} */ (event.target), isAutofilled: true }); });
                }
                else if (event.animationName === 'cdk-text-field-autofill-end') {
                    element.classList.remove('cdk-text-field-autofilled');
                    _this._ngZone.run(function () { return result.next({ target: /** @type {?} */ (event.target), isAutofilled: false }); });
                }
            };
            this._ngZone.runOutsideAngular(function () {
                element.addEventListener('animationstart', listener, listenerOptions);
                element.classList.add('cdk-text-field-autofill-monitored');
            });
            this._monitoredElements.set(element, {
                subject: result,
                unlisten: function () {
                    element.removeEventListener('animationstart', listener, listenerOptions);
                }
            });
            return result.asObservable();
        };
        /**
         * Stop monitoring the autofill state of the given input element.
         * @param element The element to stop monitoring.
         */
        /**
         * Stop monitoring the autofill state of the given input element.
         * @param {?} element The element to stop monitoring.
         * @return {?}
         */
        AutofillMonitor.prototype.stopMonitoring = /**
         * Stop monitoring the autofill state of the given input element.
         * @param {?} element The element to stop monitoring.
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ info = this._monitoredElements.get(element);
            if (info) {
                info.unlisten();
                info.subject.complete();
                element.classList.remove('cdk-text-field-autofill-monitored');
                element.classList.remove('cdk-text-field-autofilled');
                this._monitoredElements.delete(element);
            }
        };
        /**
         * @return {?}
         */
        AutofillMonitor.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._monitoredElements.forEach(function (_info, element) { return _this.stopMonitoring(element); });
        };
        AutofillMonitor.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        AutofillMonitor.ctorParameters = function () { return [
            { type: Platform, },
            { type: core.NgZone, },
        ]; };
        /** @nocollapse */ AutofillMonitor.ngInjectableDef = core.defineInjectable({ factory: function AutofillMonitor_Factory() { return new AutofillMonitor(core.inject(Platform), core.inject(core.NgZone)); }, token: AutofillMonitor, providedIn: "root" });
        return AutofillMonitor;
    }());
    /**
     * A directive that can be used to monitor the autofill state of an input.
     */
    var CdkAutofill = /** @class */ (function () {
        function CdkAutofill(_elementRef, _autofillMonitor) {
            this._elementRef = _elementRef;
            this._autofillMonitor = _autofillMonitor;
            /**
             * Emits when the autofill state of the element changes.
             */
            this.cdkAutofill = new core.EventEmitter();
        }
        /**
         * @return {?}
         */
        CdkAutofill.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._autofillMonitor
                .monitor(this._elementRef.nativeElement)
                .subscribe(function (event) { return _this.cdkAutofill.emit(event); });
        };
        /**
         * @return {?}
         */
        CdkAutofill.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._autofillMonitor.stopMonitoring(this._elementRef.nativeElement);
        };
        CdkAutofill.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkAutofill]',
                    },] },
        ];
        /** @nocollapse */
        CdkAutofill.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: AutofillMonitor, },
        ]; };
        CdkAutofill.propDecorators = {
            "cdkAutofill": [{ type: core.Output },],
        };
        return CdkAutofill;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Directive to automatically resize a textarea to fit its content.
     */
    var CdkTextareaAutosize = /** @class */ (function () {
        function CdkTextareaAutosize(_elementRef, _platform, _ngZone) {
            this._elementRef = _elementRef;
            this._platform = _platform;
            this._ngZone = _ngZone;
            this._destroyed = new rxjs.Subject();
            this._enabled = true;
            this._textareaElement = /** @type {?} */ (this._elementRef.nativeElement);
        }
        Object.defineProperty(CdkTextareaAutosize.prototype, "minRows", {
            get: /**
             * Minimum amount of rows in the textarea.
             * @return {?}
             */
            function () { return this._minRows; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._minRows = value;
                this._setMinHeight();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTextareaAutosize.prototype, "maxRows", {
            get: /**
             * Maximum amount of rows in the textarea.
             * @return {?}
             */
            function () { return this._maxRows; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._maxRows = value;
                this._setMaxHeight();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTextareaAutosize.prototype, "enabled", {
            get: /**
             * Whether autosizing is enabled or not
             * @return {?}
             */
            function () { return this._enabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                value = coerceBooleanProperty(value);
                // Only act if the actual value changed. This specifically helps to not run
                // resizeToFitContent too early (i.e. before ngAfterViewInit)
                if (this._enabled !== value) {
                    (this._enabled = value) ? this.resizeToFitContent(true) : this.reset();
                }
            },
            enumerable: true,
            configurable: true
        });
        /** Sets the minimum height of the textarea as determined by minRows. */
        /**
         * Sets the minimum height of the textarea as determined by minRows.
         * @return {?}
         */
        CdkTextareaAutosize.prototype._setMinHeight = /**
         * Sets the minimum height of the textarea as determined by minRows.
         * @return {?}
         */
        function () {
            var /** @type {?} */ minHeight = this.minRows && this._cachedLineHeight ?
                this.minRows * this._cachedLineHeight + "px" : null;
            if (minHeight) {
                this._setTextareaStyle('minHeight', minHeight);
            }
        };
        /** Sets the maximum height of the textarea as determined by maxRows. */
        /**
         * Sets the maximum height of the textarea as determined by maxRows.
         * @return {?}
         */
        CdkTextareaAutosize.prototype._setMaxHeight = /**
         * Sets the maximum height of the textarea as determined by maxRows.
         * @return {?}
         */
        function () {
            var /** @type {?} */ maxHeight = this.maxRows && this._cachedLineHeight ?
                this.maxRows * this._cachedLineHeight + "px" : null;
            if (maxHeight) {
                this._setTextareaStyle('maxHeight', maxHeight);
            }
        };
        /**
         * @return {?}
         */
        CdkTextareaAutosize.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._platform.isBrowser) {
                // Remember the height which we started with in case autosizing is disabled
                this._initialHeight = this._textareaElement.style.height;
                this.resizeToFitContent();
                this._ngZone.runOutsideAngular(function () {
                    rxjs.fromEvent(window, 'resize')
                        .pipe(operators.auditTime(16), operators.takeUntil(_this._destroyed))
                        .subscribe(function () { return _this.resizeToFitContent(true); });
                });
            }
        };
        /**
         * @return {?}
         */
        CdkTextareaAutosize.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroyed.next();
            this._destroyed.complete();
        };
        /**
         * Sets a style property on the textarea element.
         * @param {?} property
         * @param {?} value
         * @return {?}
         */
        CdkTextareaAutosize.prototype._setTextareaStyle = /**
         * Sets a style property on the textarea element.
         * @param {?} property
         * @param {?} value
         * @return {?}
         */
        function (property, value) {
            this._textareaElement.style[property] = value;
        };
        /**
         * Cache the height of a single-row textarea if it has not already been cached.
         *
         * We need to know how large a single "row" of a textarea is in order to apply minRows and
         * maxRows. For the initial version, we will assume that the height of a single line in the
         * textarea does not ever change.
         * @return {?}
         */
        CdkTextareaAutosize.prototype._cacheTextareaLineHeight = /**
         * Cache the height of a single-row textarea if it has not already been cached.
         *
         * We need to know how large a single "row" of a textarea is in order to apply minRows and
         * maxRows. For the initial version, we will assume that the height of a single line in the
         * textarea does not ever change.
         * @return {?}
         */
        function () {
            if (this._cachedLineHeight) {
                return;
            }
            // Use a clone element because we have to override some styles.
            var /** @type {?} */ textareaClone = /** @type {?} */ (this._textareaElement.cloneNode(false));
            textareaClone.rows = 1;
            // Use `position: absolute` so that this doesn't cause a browser layout and use
            // `visibility: hidden` so that nothing is rendered. Clear any other styles that
            // would affect the height.
            textareaClone.style.position = 'absolute';
            textareaClone.style.visibility = 'hidden';
            textareaClone.style.border = 'none';
            textareaClone.style.padding = '0';
            textareaClone.style.height = '';
            textareaClone.style.minHeight = '';
            textareaClone.style.maxHeight = '';
            // In Firefox it happens that textarea elements are always bigger than the specified amount
            // of rows. This is because Firefox tries to add extra space for the horizontal scrollbar.
            // As a workaround that removes the extra space for the scrollbar, we can just set overflow
            // to hidden. This ensures that there is no invalid calculation of the line height.
            // See Firefox bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=33654
            textareaClone.style.overflow = 'hidden'; /** @type {?} */
            ((this._textareaElement.parentNode)).appendChild(textareaClone);
            this._cachedLineHeight = textareaClone.clientHeight; /** @type {?} */
            ((this._textareaElement.parentNode)).removeChild(textareaClone);
            // Min and max heights have to be re-calculated if the cached line height changes
            this._setMinHeight();
            this._setMaxHeight();
        };
        /**
         * @return {?}
         */
        CdkTextareaAutosize.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            if (this._platform.isBrowser) {
                this.resizeToFitContent();
            }
        };
        /**
         * Resize the textarea to fit its content.
         * @param force Whether to force a height recalculation. By default the height will be
         *    recalculated only if the value changed since the last call.
         */
        /**
         * Resize the textarea to fit its content.
         * @param {?=} force Whether to force a height recalculation. By default the height will be
         *    recalculated only if the value changed since the last call.
         * @return {?}
         */
        CdkTextareaAutosize.prototype.resizeToFitContent = /**
         * Resize the textarea to fit its content.
         * @param {?=} force Whether to force a height recalculation. By default the height will be
         *    recalculated only if the value changed since the last call.
         * @return {?}
         */
        function (force) {
            var _this = this;
            if (force === void 0) { force = false; }
            // If autosizing is disabled, just skip everything else
            if (!this._enabled) {
                return;
            }
            this._cacheTextareaLineHeight();
            // If we haven't determined the line-height yet, we know we're still hidden and there's no point
            // in checking the height of the textarea.
            if (!this._cachedLineHeight) {
                return;
            }
            var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
            var /** @type {?} */ value = textarea.value;
            // Only resize of the value changed since these calculations can be expensive.
            if (value === this._previousValue && !force) {
                return;
            }
            var /** @type {?} */ placeholderText = textarea.placeholder;
            // Reset the textarea height to auto in order to shrink back to its default size.
            // Also temporarily force overflow:hidden, so scroll bars do not interfere with calculations.
            // Long placeholders that are wider than the textarea width may lead to a bigger scrollHeight
            // value. To ensure that the scrollHeight is not bigger than the content, the placeholders
            // need to be removed temporarily.
            textarea.classList.add('cdk-textarea-autosize-measuring');
            textarea.placeholder = '';
            // The cdk-textarea-autosize-measuring class includes a 2px padding to workaround an issue with
            // Chrome, so we account for that extra space here by subtracting 4 (2px top + 2px bottom).
            var /** @type {?} */ height = textarea.scrollHeight - 4;
            // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
            textarea.style.height = height + "px";
            textarea.classList.remove('cdk-textarea-autosize-measuring');
            textarea.placeholder = placeholderText;
            // On Firefox resizing the textarea will prevent it from scrolling to the caret position.
            // We need to re-set the selection in order for it to scroll to the proper position.
            if (typeof requestAnimationFrame !== 'undefined') {
                this._ngZone.runOutsideAngular(function () {
                    return requestAnimationFrame(function () {
                        var selectionStart = textarea.selectionStart, selectionEnd = textarea.selectionEnd;
                        // IE will throw an "Unspecified error" if we try to set the selection range after the
                        // element has been removed from the DOM. Assert that the directive hasn't been destroyed
                        // between the time we requested the animation frame and when it was executed.
                        // Also note that we have to assert that the textarea is focused before we set the
                        // selection range. Setting the selection range on a non-focused textarea will cause
                        // it to receive focus on IE and Edge.
                        if (!_this._destroyed.isStopped && document.activeElement === textarea) {
                            textarea.setSelectionRange(selectionStart, selectionEnd);
                        }
                    });
                });
            }
            this._previousValue = value;
        };
        /**
         * Resets the textarea to it's original size
         */
        /**
         * Resets the textarea to it's original size
         * @return {?}
         */
        CdkTextareaAutosize.prototype.reset = /**
         * Resets the textarea to it's original size
         * @return {?}
         */
        function () {
            // Do not try to change the textarea, if the initialHeight has not been determined yet
            // This might potentially remove styles when reset() is called before ngAfterViewInit
            if (this._initialHeight === undefined) {
                return;
            }
            this._textareaElement.style.height = this._initialHeight;
        };
        /**
         * @return {?}
         */
        CdkTextareaAutosize.prototype._noopInputHandler = /**
         * @return {?}
         */
        function () {
            // no-op handler that ensures we're running change detection on input events.
        };
        CdkTextareaAutosize.decorators = [
            { type: core.Directive, args: [{
                        selector: 'textarea[cdkTextareaAutosize]',
                        exportAs: 'cdkTextareaAutosize',
                        host: {
                            'class': 'cdk-textarea-autosize',
                            // Textarea elements that have the directive applied should have a single row by default.
                            // Browsers normally show two rows by default and therefore this limits the minRows binding.
                            'rows': '1',
                            '(input)': '_noopInputHandler()',
                        },
                    },] },
        ];
        /** @nocollapse */
        CdkTextareaAutosize.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: core.NgZone, },
        ]; };
        CdkTextareaAutosize.propDecorators = {
            "minRows": [{ type: core.Input, args: ['cdkAutosizeMinRows',] },],
            "maxRows": [{ type: core.Input, args: ['cdkAutosizeMaxRows',] },],
            "enabled": [{ type: core.Input, args: ['cdkTextareaAutosize',] },],
        };
        return CdkTextareaAutosize;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var TextFieldModule = /** @class */ (function () {
        function TextFieldModule() {
        }
        TextFieldModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: [CdkAutofill, CdkTextareaAutosize],
                        imports: [PlatformModule],
                        exports: [CdkAutofill, CdkTextareaAutosize],
                    },] },
        ];
        return TextFieldModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Directive to automatically resize a textarea to fit its content.
     * \@deletion-target 7.0.0 deprecate in favor of `cdkTextareaAutosize`.
     */
    var MatTextareaAutosize = /** @class */ (function (_super) {
        __extends(MatTextareaAutosize, _super);
        function MatTextareaAutosize() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(MatTextareaAutosize.prototype, "matAutosizeMinRows", {
            get: /**
             * @return {?}
             */
            function () { return this.minRows; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.minRows = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTextareaAutosize.prototype, "matAutosizeMaxRows", {
            get: /**
             * @return {?}
             */
            function () { return this.maxRows; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.maxRows = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTextareaAutosize.prototype, "matAutosize", {
            get: /**
             * @return {?}
             */
            function () { return this.enabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.enabled = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTextareaAutosize.prototype, "matTextareaAutosize", {
            get: /**
             * @return {?}
             */
            function () { return this.enabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.enabled = value; },
            enumerable: true,
            configurable: true
        });
        MatTextareaAutosize.decorators = [
            { type: core.Directive, args: [{
                        selector: 'textarea[mat-autosize], textarea[matTextareaAutosize]',
                        exportAs: 'matTextareaAutosize',
                        inputs: ['cdkAutosizeMinRows', 'cdkAutosizeMaxRows'],
                        host: {
                            'class': 'cdk-textarea-autosize mat-autosize',
                            // Textarea elements that have the directive applied should have a single row by default.
                            // Browsers normally show two rows by default and therefore this limits the minRows binding.
                            'rows': '1',
                            '(input)': '_noopInputHandler()',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatTextareaAutosize.propDecorators = {
            "matAutosizeMinRows": [{ type: core.Input },],
            "matAutosizeMaxRows": [{ type: core.Input },],
            "matAutosize": [{ type: core.Input, args: ['mat-autosize',] },],
            "matTextareaAutosize": [{ type: core.Input },],
        };
        return MatTextareaAutosize;
    }(CdkTextareaAutosize));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * \@docs-private
     * @param {?} type
     * @return {?}
     */
    function getMatInputUnsupportedTypeError(type) {
        return Error("Input type \"" + type + "\" isn't supported by matInput.");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * This token is used to inject the object whose value should be set into `MatInput`. If none is
     * provided, the native `HTMLInputElement` is used. Directives like `MatDatepickerInput` can provide
     * themselves for this token, in order to make `MatInput` delegate the getting and setting of the
     * value to them.
     */
    var /** @type {?} */ MAT_INPUT_VALUE_ACCESSOR = new core.InjectionToken('MAT_INPUT_VALUE_ACCESSOR');

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Invalid input type. Using one of these will throw an MatInputUnsupportedTypeError.
    var /** @type {?} */ MAT_INPUT_INVALID_TYPES = [
        'button',
        'checkbox',
        'file',
        'hidden',
        'image',
        'radio',
        'range',
        'reset',
        'submit'
    ];
    var /** @type {?} */ nextUniqueId$5 = 0;
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatInputBase = /** @class */ (function () {
        function MatInputBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            this._parentForm = _parentForm;
            this._parentFormGroup = _parentFormGroup;
            this.ngControl = ngControl;
        }
        return MatInputBase;
    }());
    var /** @type {?} */ _MatInputMixinBase = mixinErrorState(MatInputBase);
    /**
     * Directive that allows a native input to work inside a `MatFormField`.
     */
    var MatInput = /** @class */ (function (_super) {
        __extends(MatInput, _super);
        function MatInput(_elementRef, _platform, /** @docs-private */
        ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, inputValueAccessor, _autofillMonitor, ngZone) {
            var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._elementRef = _elementRef;
            _this._platform = _platform;
            _this.ngControl = ngControl;
            _this._autofillMonitor = _autofillMonitor;
            _this._uid = "mat-input-" + nextUniqueId$5++;
            /**
             * Whether the component is being rendered on the server.
             */
            _this._isServer = false;
            /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             */
            _this.focused = false;
            /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             */
            _this.stateChanges = new rxjs.Subject();
            /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             */
            _this.controlType = 'mat-input';
            /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             */
            _this.autofilled = false;
            _this._disabled = false;
            _this._required = false;
            _this._type = 'text';
            _this._readonly = false;
            _this._neverEmptyInputTypes = [
                'date',
                'datetime',
                'datetime-local',
                'month',
                'time',
                'week'
            ].filter(function (t) { return getSupportedInputTypes().has(t); });
            // If no input value accessor was explicitly specified, use the element as the input value
            // accessor.
            // If no input value accessor was explicitly specified, use the element as the input value
            // accessor.
            _this._inputValueAccessor = inputValueAccessor || _this._elementRef.nativeElement;
            _this._previousNativeValue = _this.value;
            // Force setter to be called in case id was not specified.
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            // On some versions of iOS the caret gets stuck in the wrong place when holding down the delete
            // key. In order to get around this we need to "jiggle" the caret loose. Since this bug only
            // exists on iOS, we only bother to install the listener on iOS.
            if (_platform.IOS) {
                ngZone.runOutsideAngular(function () {
                    _elementRef.nativeElement.addEventListener('keyup', function (event) {
                        var /** @type {?} */ el = /** @type {?} */ (event.target);
                        if (!el.value && !el.selectionStart && !el.selectionEnd) {
                            // Note: Just setting `0, 0` doesn't fix the issue. Setting
                            // `1, 1` fixes it for the first time that you type text and
                            // then hold delete. Toggling to `1, 1` and then back to
                            // `0, 0` seems to completely fix it.
                            el.setSelectionRange(1, 1);
                            el.setSelectionRange(0, 0);
                        }
                    });
                });
            }
            _this._isServer = !_this._platform.isBrowser;
            return _this;
        }
        Object.defineProperty(MatInput.prototype, "disabled", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                if (this.ngControl && this.ngControl.disabled !== null) {
                    return this.ngControl.disabled;
                }
                return this._disabled;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
                // Browsers may not fire the blur event if the input is disabled too quickly.
                // Reset from here to ensure that the element doesn't become stuck.
                if (this.focused) {
                    this.focused = false;
                    this.stateChanges.next();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "id", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this._id; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._id = value || this._uid; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "required", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._required = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "type", {
            get: /**
             * Input type of the element.
             * @return {?}
             */
            function () { return this._type; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._type = value || 'text';
                this._validateType();
                // When using Angular inputs, developers are no longer able to set the properties on the native
                // input element. To ensure that bindings for `type` work, we need to sync the setter
                // with the native property. Textarea elements don't support the type property or attribute.
                if (!this._isTextarea() && getSupportedInputTypes().has(this._type)) {
                    this._elementRef.nativeElement.type = this._type;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "value", {
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this._inputValueAccessor.value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== this.value) {
                    this._inputValueAccessor.value = value;
                    this.stateChanges.next();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "readonly", {
            get: /**
             * Whether the element is readonly.
             * @return {?}
             */
            function () { return this._readonly; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._readonly = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatInput.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._autofillMonitor.monitor(this._elementRef.nativeElement).subscribe(function (event) {
                _this.autofilled = event.isAutofilled;
                _this.stateChanges.next();
            });
        };
        /**
         * @return {?}
         */
        MatInput.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            this.stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatInput.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.stateChanges.complete();
            this._autofillMonitor.stopMonitoring(this._elementRef.nativeElement);
        };
        /**
         * @return {?}
         */
        MatInput.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
            // We need to dirty-check the native element's value, because there are some cases where
            // we won't be notified when it changes (e.g. the consumer isn't using forms or they're
            // updating the value using `emitEvent: false`).
            this._dirtyCheckNativeValue();
        };
        /** Focuses the input. */
        /**
         * Focuses the input.
         * @return {?}
         */
        MatInput.prototype.focus = /**
         * Focuses the input.
         * @return {?}
         */
        function () { this._elementRef.nativeElement.focus(); };
        /** Callback for the cases where the focused state of the input changes. */
        /**
         * Callback for the cases where the focused state of the input changes.
         * @param {?} isFocused
         * @return {?}
         */
        MatInput.prototype._focusChanged = /**
         * Callback for the cases where the focused state of the input changes.
         * @param {?} isFocused
         * @return {?}
         */
        function (isFocused) {
            if (isFocused !== this.focused && !this.readonly) {
                this.focused = isFocused;
                this.stateChanges.next();
            }
        };
        /**
         * @return {?}
         */
        MatInput.prototype._onInput = /**
         * @return {?}
         */
        function () {
            // This is a noop function and is used to let Angular know whenever the value changes.
            // Angular will run a new change detection each time the `input` event has been dispatched.
            // It's necessary that Angular recognizes the value change, because when floatingLabel
            // is set to false and Angular forms aren't used, the placeholder won't recognize the
            // value changes and will not disappear.
            // Listening to the input event wouldn't be necessary when the input is using the
            // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
        };
        /** Does some manual dirty checking on the native input `value` property. */
        /**
         * Does some manual dirty checking on the native input `value` property.
         * @return {?}
         */
        MatInput.prototype._dirtyCheckNativeValue = /**
         * Does some manual dirty checking on the native input `value` property.
         * @return {?}
         */
        function () {
            var /** @type {?} */ newValue = this.value;
            if (this._previousNativeValue !== newValue) {
                this._previousNativeValue = newValue;
                this.stateChanges.next();
            }
        };
        /** Make sure the input is a supported type. */
        /**
         * Make sure the input is a supported type.
         * @return {?}
         */
        MatInput.prototype._validateType = /**
         * Make sure the input is a supported type.
         * @return {?}
         */
        function () {
            if (MAT_INPUT_INVALID_TYPES.indexOf(this._type) > -1) {
                throw getMatInputUnsupportedTypeError(this._type);
            }
        };
        /** Checks whether the input type is one of the types that are never empty. */
        /**
         * Checks whether the input type is one of the types that are never empty.
         * @return {?}
         */
        MatInput.prototype._isNeverEmpty = /**
         * Checks whether the input type is one of the types that are never empty.
         * @return {?}
         */
        function () {
            return this._neverEmptyInputTypes.indexOf(this._type) > -1;
        };
        /** Checks whether the input is invalid based on the native validation. */
        /**
         * Checks whether the input is invalid based on the native validation.
         * @return {?}
         */
        MatInput.prototype._isBadInput = /**
         * Checks whether the input is invalid based on the native validation.
         * @return {?}
         */
        function () {
            // The `validity` property won't be present on platform-server.
            var /** @type {?} */ validity = (/** @type {?} */ (this._elementRef.nativeElement)).validity;
            return validity && validity.badInput;
        };
        /** Determines if the component host is a textarea. */
        /**
         * Determines if the component host is a textarea.
         * @return {?}
         */
        MatInput.prototype._isTextarea = /**
         * Determines if the component host is a textarea.
         * @return {?}
         */
        function () {
            return this._elementRef.nativeElement.nodeName.toLowerCase() === 'textarea';
        };
        Object.defineProperty(MatInput.prototype, "empty", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                return !this._isNeverEmpty() && !this._elementRef.nativeElement.value && !this._isBadInput() &&
                    !this.autofilled;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatInput.prototype, "shouldLabelFloat", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () { return this.focused || !this.empty; },
            enumerable: true,
            configurable: true
        });
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        MatInput.prototype.setDescribedByIds = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        function (ids) { this._ariaDescribedby = ids.join(' '); };
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        MatInput.prototype.onContainerClick = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        function () { this.focus(); };
        MatInput.decorators = [
            { type: core.Directive, args: [{
                        selector: "input[matInput], textarea[matInput]",
                        exportAs: 'matInput',
                        host: {
                            /**
                                 * @deletion-target 7.0.0 remove .mat-form-field-autofill-control in favor of AutofillMonitor.
                                 */
                            'class': 'mat-input-element mat-form-field-autofill-control',
                            '[class.mat-input-server]': '_isServer',
                            // Native input properties that are overwritten by Angular inputs need to be synced with
                            // the native input element. Otherwise property bindings for those don't work.
                            '[attr.id]': 'id',
                            '[attr.placeholder]': 'placeholder',
                            '[disabled]': 'disabled',
                            '[required]': 'required',
                            '[readonly]': 'readonly',
                            '[attr.aria-describedby]': '_ariaDescribedby || null',
                            '[attr.aria-invalid]': 'errorState',
                            '[attr.aria-required]': 'required.toString()',
                            '(blur)': '_focusChanged(false)',
                            '(focus)': '_focusChanged(true)',
                            '(input)': '_onInput()',
                        },
                        providers: [{ provide: MatFormFieldControl, useExisting: MatInput }],
                    },] },
        ];
        /** @nocollapse */
        MatInput.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: NgControl, decorators: [{ type: core.Optional }, { type: core.Self },] },
            { type: NgForm, decorators: [{ type: core.Optional },] },
            { type: FormGroupDirective, decorators: [{ type: core.Optional },] },
            { type: ErrorStateMatcher, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Self }, { type: core.Inject, args: [MAT_INPUT_VALUE_ACCESSOR,] },] },
            { type: AutofillMonitor, },
            { type: core.NgZone, },
        ]; };
        MatInput.propDecorators = {
            "disabled": [{ type: core.Input },],
            "id": [{ type: core.Input },],
            "placeholder": [{ type: core.Input },],
            "required": [{ type: core.Input },],
            "type": [{ type: core.Input },],
            "errorStateMatcher": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "readonly": [{ type: core.Input },],
        };
        return MatInput;
    }(_MatInputMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatInputModule = /** @class */ (function () {
        function MatInputModule() {
        }
        MatInputModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: [MatInput, MatTextareaAutosize],
                        imports: [
                            common.CommonModule,
                            TextFieldModule,
                            MatFormFieldModule,
                        ],
                        exports: [
                            TextFieldModule,
                            MatFormFieldModule,
                            MatInput,
                            MatTextareaAutosize,
                        ],
                        providers: [ErrorStateMatcher],
                    },] },
        ];
        return MatInputModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * \@docs-private
     * @param {?} provider
     * @return {?}
     */
    function createMissingDateImplError(provider) {
        return Error("MatDatepicker: No provider found for " + provider + ". You must import one of the following " +
            "modules at your application root: MatNativeDateModule, MatMomentDateModule, or provide a " +
            "custom implementation.");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Datepicker data that requires internationalization.
     */
    var MatDatepickerIntl = /** @class */ (function () {
        function MatDatepickerIntl() {
            /**
             * Stream that emits whenever the labels here are changed. Use this to notify
             * components if the labels have changed after initialization.
             */
            this.changes = new rxjs.Subject();
            /**
             * A label for the calendar popup (used by screen readers).
             */
            this.calendarLabel = 'Calendar';
            /**
             * A label for the button used to open the calendar popup (used by screen readers).
             */
            this.openCalendarLabel = 'Open calendar';
            /**
             * A label for the previous month button (used by screen readers).
             */
            this.prevMonthLabel = 'Previous month';
            /**
             * A label for the next month button (used by screen readers).
             */
            this.nextMonthLabel = 'Next month';
            /**
             * A label for the previous year button (used by screen readers).
             */
            this.prevYearLabel = 'Previous year';
            /**
             * A label for the next year button (used by screen readers).
             */
            this.nextYearLabel = 'Next year';
            /**
             * A label for the previous multi-year button (used by screen readers).
             */
            this.prevMultiYearLabel = 'Previous 20 years';
            /**
             * A label for the next multi-year button (used by screen readers).
             */
            this.nextMultiYearLabel = 'Next 20 years';
            /**
             * A label for the 'switch to month view' button (used by screen readers).
             */
            this.switchToMonthViewLabel = 'Choose date';
            /**
             * A label for the 'switch to year view' button (used by screen readers).
             */
            this.switchToMultiYearViewLabel = 'Choose month and year';
        }
        MatDatepickerIntl.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ MatDatepickerIntl.ngInjectableDef = core.defineInjectable({ factory: function MatDatepickerIntl_Factory() { return new MatDatepickerIntl(); }, token: MatDatepickerIntl, providedIn: "root" });
        return MatDatepickerIntl;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * An internal class that represents the data corresponding to a single calendar cell.
     * \@docs-private
     */
    var  /**
     * An internal class that represents the data corresponding to a single calendar cell.
     * \@docs-private
     */
    MatCalendarCell = /** @class */ (function () {
        function MatCalendarCell(value, displayValue, ariaLabel, enabled) {
            this.value = value;
            this.displayValue = displayValue;
            this.ariaLabel = ariaLabel;
            this.enabled = enabled;
        }
        return MatCalendarCell;
    }());
    /**
     * An internal component used to display calendar data in a table.
     * \@docs-private
     */
    var MatCalendarBody = /** @class */ (function () {
        function MatCalendarBody(_elementRef, _ngZone) {
            this._elementRef = _elementRef;
            this._ngZone = _ngZone;
            /**
             * The number of columns in the table.
             */
            this.numCols = 7;
            /**
             * Whether to allow selection of disabled cells.
             */
            this.allowDisabledSelection = false;
            /**
             * The cell number of the active cell in the table.
             */
            this.activeCell = 0;
            /**
             * The aspect ratio (width / height) to use for the cells in the table. This aspect ratio will be
             * maintained even as the table resizes.
             */
            this.cellAspectRatio = 1;
            /**
             * Emits when a new value is selected.
             */
            this.selectedValueChange = new core.EventEmitter();
        }
        /**
         * @param {?} cell
         * @return {?}
         */
        MatCalendarBody.prototype._cellClicked = /**
         * @param {?} cell
         * @return {?}
         */
        function (cell) {
            if (!this.allowDisabledSelection && !cell.enabled) {
                return;
            }
            this.selectedValueChange.emit(cell.value);
        };
        Object.defineProperty(MatCalendarBody.prototype, "_firstRowOffset", {
            /** The number of blank cells to put at the beginning for the first row. */
            get: /**
             * The number of blank cells to put at the beginning for the first row.
             * @return {?}
             */
            function () {
                return this.rows && this.rows.length && this.rows[0].length ?
                    this.numCols - this.rows[0].length : 0;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} rowIndex
         * @param {?} colIndex
         * @return {?}
         */
        MatCalendarBody.prototype._isActiveCell = /**
         * @param {?} rowIndex
         * @param {?} colIndex
         * @return {?}
         */
        function (rowIndex, colIndex) {
            var /** @type {?} */ cellNumber = rowIndex * this.numCols + colIndex;
            // Account for the fact that the first row may not have as many cells.
            if (rowIndex) {
                cellNumber -= this._firstRowOffset;
            }
            return cellNumber == this.activeCell;
        };
        /** Focuses the active cell after the microtask queue is empty. */
        /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        MatCalendarBody.prototype._focusActiveCell = /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                _this._ngZone.onStable.asObservable().pipe(operators.take(1)).subscribe(function () {
                    _this._elementRef.nativeElement.querySelector('.mat-calendar-body-active').focus();
                });
            });
        };
        MatCalendarBody.decorators = [
            { type: core.Component, args: [{selector: '[mat-calendar-body]',
                        template: "<tr *ngIf=\"_firstRowOffset < labelMinRequiredCells\" aria-hidden=\"true\"><td class=\"mat-calendar-body-label\" [attr.colspan]=\"numCols\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\">{{label}}</td></tr><tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\"><td *ngIf=\"rowIndex === 0 && _firstRowOffset\" aria-hidden=\"true\" class=\"mat-calendar-body-label\" [attr.colspan]=\"_firstRowOffset\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\">{{_firstRowOffset >= labelMinRequiredCells ? label : ''}}</td><td *ngFor=\"let item of row; let colIndex = index\" role=\"gridcell\" class=\"mat-calendar-body-cell\" [tabindex]=\"_isActiveCell(rowIndex, colIndex) ? 0 : -1\" [class.mat-calendar-body-disabled]=\"!item.enabled\" [class.mat-calendar-body-active]=\"_isActiveCell(rowIndex, colIndex)\" [attr.aria-label]=\"item.ariaLabel\" [attr.aria-disabled]=\"!item.enabled || null\" (click)=\"_cellClicked(item)\" [style.width.%]=\"100 / numCols\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\"><div class=\"mat-calendar-body-cell-content\" [class.mat-calendar-body-selected]=\"selectedValue === item.value\" [class.mat-calendar-body-today]=\"todayValue === item.value\">{{item.displayValue}}</div></td></tr>",
                        styles: [".mat-calendar-body{min-width:224px}.mat-calendar-body-label{height:0;line-height:0;text-align:left;padding-left:4.71429%;padding-right:4.71429%}.mat-calendar-body-cell{position:relative;height:0;line-height:0;text-align:center;outline:0;cursor:pointer}.mat-calendar-body-disabled{cursor:default}.mat-calendar-body-cell-content{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-width:1px;border-style:solid;border-radius:999px}@media screen and (-ms-high-contrast:active){.mat-calendar-body-cell-content{border:none}}@media screen and (-ms-high-contrast:active){.mat-calendar-body-selected,.mat-datepicker-popup{outline:solid 1px}.mat-calendar-body-today{outline:dotted 1px}}[dir=rtl] .mat-calendar-body-label{text-align:right}"],
                        host: {
                            'class': 'mat-calendar-body',
                            'role': 'grid',
                            'attr.aria-readonly': 'true'
                        },
                        exportAs: 'matCalendarBody',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatCalendarBody.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.NgZone, },
        ]; };
        MatCalendarBody.propDecorators = {
            "label": [{ type: core.Input },],
            "rows": [{ type: core.Input },],
            "todayValue": [{ type: core.Input },],
            "selectedValue": [{ type: core.Input },],
            "labelMinRequiredCells": [{ type: core.Input },],
            "numCols": [{ type: core.Input },],
            "allowDisabledSelection": [{ type: core.Input },],
            "activeCell": [{ type: core.Input },],
            "cellAspectRatio": [{ type: core.Input },],
            "selectedValueChange": [{ type: core.Output },],
        };
        return MatCalendarBody;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ DAYS_PER_WEEK = 7;
    /**
     * An internal component used to display a single month in the datepicker.
     * \@docs-private
     * @template D
     */
    var MatMonthView = /** @class */ (function () {
        function MatMonthView(_changeDetectorRef, _dateFormats, _dateAdapter, _dir) {
            this._changeDetectorRef = _changeDetectorRef;
            this._dateFormats = _dateFormats;
            this._dateAdapter = _dateAdapter;
            this._dir = _dir;
            /**
             * Emits when a new date is selected.
             */
            this.selectedChange = new core.EventEmitter();
            /**
             * Emits when any date is selected.
             */
            this._userSelection = new core.EventEmitter();
            /**
             * Emits when any date is activated.
             */
            this.activeDateChange = new core.EventEmitter();
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('MAT_DATE_FORMATS');
            }
            var /** @type {?} */ firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
            var /** @type {?} */ narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
            var /** @type {?} */ longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
            // Rotate the labels for days of the week based on the configured first day of the week.
            var /** @type {?} */ weekdays = longWeekdays.map(function (long, i) {
                return { long: long, narrow: narrowWeekdays[i] };
            });
            this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
            this._activeDate = this._dateAdapter.today();
        }
        Object.defineProperty(MatMonthView.prototype, "activeDate", {
            get: /**
             * The date to display in this month view (everything other than the month and year is ignored).
             * @return {?}
             */
            function () { return this._activeDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ oldActiveDate = this._activeDate;
                var /** @type {?} */ validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
                    this._init();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMonthView.prototype, "selected", {
            get: /**
             * The currently selected date.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                this._selectedDate = this._getDateInCurrentMonth(this._selected);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMonthView.prototype, "minDate", {
            get: /**
             * The minimum selectable date.
             * @return {?}
             */
            function () { return this._minDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMonthView.prototype, "maxDate", {
            get: /**
             * The maximum selectable date.
             * @return {?}
             */
            function () { return this._maxDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatMonthView.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._init();
        };
        /** Handles when a new date is selected. */
        /**
         * Handles when a new date is selected.
         * @param {?} date
         * @return {?}
         */
        MatMonthView.prototype._dateSelected = /**
         * Handles when a new date is selected.
         * @param {?} date
         * @return {?}
         */
        function (date) {
            if (this._selectedDate != date) {
                var /** @type {?} */ selectedYear = this._dateAdapter.getYear(this.activeDate);
                var /** @type {?} */ selectedMonth = this._dateAdapter.getMonth(this.activeDate);
                var /** @type {?} */ selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
                this.selectedChange.emit(selectedDate);
            }
            this._userSelection.emit();
        };
        /** Handles keydown events on the calendar body when calendar is in month view. */
        /**
         * Handles keydown events on the calendar body when calendar is in month view.
         * @param {?} event
         * @return {?}
         */
        MatMonthView.prototype._handleCalendarBodyKeydown = /**
         * Handles keydown events on the calendar body when calendar is in month view.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
            // disabled ones from being selected. This may not be ideal, we should look into whether
            // navigation should skip over disabled dates, and if so, how to implement that efficiently.
            var /** @type {?} */ oldActiveDate = this._activeDate;
            var /** @type {?} */ isRtl = this._isRtl();
            switch (event.keyCode) {
                case LEFT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? 1 : -1);
                    break;
                case RIGHT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? -1 : 1);
                    break;
                case UP_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
                    break;
                case DOWN_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
                    break;
                case HOME:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
                    break;
                case END:
                    this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, (this._dateAdapter.getNumDaysInMonth(this._activeDate) -
                        this._dateAdapter.getDate(this._activeDate)));
                    break;
                case PAGE_UP:
                    this.activeDate = event.altKey ?
                        this._dateAdapter.addCalendarYears(this._activeDate, -1) :
                        this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                    break;
                case PAGE_DOWN:
                    this.activeDate = event.altKey ?
                        this._dateAdapter.addCalendarYears(this._activeDate, 1) :
                        this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                    break;
                case ENTER:
                    if (!this.dateFilter || this.dateFilter(this._activeDate)) {
                        this._dateSelected(this._dateAdapter.getDate(this._activeDate));
                        this._userSelection.emit();
                        // Prevent unexpected default actions such as form submission.
                        event.preventDefault();
                    }
                    return;
                default:
                    // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                    return;
            }
            if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                this.activeDateChange.emit(this.activeDate);
            }
            this._focusActiveCell();
            // Prevent unexpected default actions such as form submission.
            event.preventDefault();
        };
        /** Initializes this month view. */
        /**
         * Initializes this month view.
         * @return {?}
         */
        MatMonthView.prototype._init = /**
         * Initializes this month view.
         * @return {?}
         */
        function () {
            this._selectedDate = this._getDateInCurrentMonth(this.selected);
            this._todayDate = this._getDateInCurrentMonth(this._dateAdapter.today());
            this._monthLabel =
                this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)]
                    .toLocaleUpperCase();
            var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
            this._firstWeekOffset =
                (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) -
                    this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
            this._createWeekCells();
            this._changeDetectorRef.markForCheck();
        };
        /** Focuses the active cell after the microtask queue is empty. */
        /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        MatMonthView.prototype._focusActiveCell = /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        function () {
            this._matCalendarBody._focusActiveCell();
        };
        /**
         * Creates MatCalendarCells for the dates in this month.
         * @return {?}
         */
        MatMonthView.prototype._createWeekCells = /**
         * Creates MatCalendarCells for the dates in this month.
         * @return {?}
         */
        function () {
            var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
            var /** @type {?} */ dateNames = this._dateAdapter.getDateNames();
            this._weeks = [[]];
            for (var /** @type {?} */ i = 0, /** @type {?} */ cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
                if (cell == DAYS_PER_WEEK) {
                    this._weeks.push([]);
                    cell = 0;
                }
                var /** @type {?} */ date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
                var /** @type {?} */ enabled = this._shouldEnableDate(date);
                var /** @type {?} */ ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
                this._weeks[this._weeks.length - 1]
                    .push(new MatCalendarCell(i + 1, dateNames[i], ariaLabel, enabled));
            }
        };
        /**
         * Date filter for the month
         * @param {?} date
         * @return {?}
         */
        MatMonthView.prototype._shouldEnableDate = /**
         * Date filter for the month
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return !!date &&
                (!this.dateFilter || this.dateFilter(date)) &&
                (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) &&
                (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0);
        };
        /**
         * Gets the date in this month that the given Date falls on.
         * Returns null if the given Date is in another month.
         * @param {?} date
         * @return {?}
         */
        MatMonthView.prototype._getDateInCurrentMonth = /**
         * Gets the date in this month that the given Date falls on.
         * Returns null if the given Date is in another month.
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date && this._hasSameMonthAndYear(date, this.activeDate) ?
                this._dateAdapter.getDate(date) : null;
        };
        /**
         * Checks whether the 2 dates are non-null and fall within the same month of the same year.
         * @param {?} d1
         * @param {?} d2
         * @return {?}
         */
        MatMonthView.prototype._hasSameMonthAndYear = /**
         * Checks whether the 2 dates are non-null and fall within the same month of the same year.
         * @param {?} d1
         * @param {?} d2
         * @return {?}
         */
        function (d1, d2) {
            return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) &&
                this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatMonthView.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        MatMonthView.prototype._isRtl = /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl';
        };
        MatMonthView.decorators = [
            { type: core.Component, args: [{selector: 'mat-month-view',
                        template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\">{{day.narrow}}</th></tr><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"7\" aria-hidden=\"true\"></th></tr></thead><tbody mat-calendar-body [label]=\"_monthLabel\" [rows]=\"_weeks\" [todayValue]=\"_todayDate\" [selectedValue]=\"_selectedDate\" [labelMinRequiredCells]=\"3\" [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\" (selectedValueChange)=\"_dateSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                        exportAs: 'matMonthView',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatMonthView.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_FORMATS,] },] },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatMonthView.propDecorators = {
            "activeDate": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "minDate": [{ type: core.Input },],
            "maxDate": [{ type: core.Input },],
            "dateFilter": [{ type: core.Input },],
            "selectedChange": [{ type: core.Output },],
            "_userSelection": [{ type: core.Output },],
            "activeDateChange": [{ type: core.Output },],
            "_matCalendarBody": [{ type: core.ViewChild, args: [MatCalendarBody,] },],
        };
        return MatMonthView;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ yearsPerPage = 24;
    var /** @type {?} */ yearsPerRow = 4;
    /**
     * An internal component used to display a year selector in the datepicker.
     * \@docs-private
     * @template D
     */
    var MatMultiYearView = /** @class */ (function () {
        function MatMultiYearView(_changeDetectorRef, _dateAdapter, _dir) {
            this._changeDetectorRef = _changeDetectorRef;
            this._dateAdapter = _dateAdapter;
            this._dir = _dir;
            /**
             * Emits when a new year is selected.
             */
            this.selectedChange = new core.EventEmitter();
            /**
             * Emits the selected year. This doesn't imply a change on the selected date
             */
            this.yearSelected = new core.EventEmitter();
            /**
             * Emits when any date is activated.
             */
            this.activeDateChange = new core.EventEmitter();
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            this._activeDate = this._dateAdapter.today();
        }
        Object.defineProperty(MatMultiYearView.prototype, "activeDate", {
            get: /**
             * The date to display in this multi-year view (everything other than the year is ignored).
             * @return {?}
             */
            function () { return this._activeDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ oldActiveDate = this._activeDate;
                var /** @type {?} */ validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                if (Math.floor(this._dateAdapter.getYear(oldActiveDate) / yearsPerPage) !=
                    Math.floor(this._dateAdapter.getYear(this._activeDate) / yearsPerPage)) {
                    this._init();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMultiYearView.prototype, "selected", {
            get: /**
             * The currently selected date.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                this._selectedYear = this._selected && this._dateAdapter.getYear(this._selected);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMultiYearView.prototype, "minDate", {
            get: /**
             * The minimum selectable date.
             * @return {?}
             */
            function () { return this._minDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMultiYearView.prototype, "maxDate", {
            get: /**
             * The maximum selectable date.
             * @return {?}
             */
            function () { return this._maxDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatMultiYearView.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._init();
        };
        /** Initializes this multi-year view. */
        /**
         * Initializes this multi-year view.
         * @return {?}
         */
        MatMultiYearView.prototype._init = /**
         * Initializes this multi-year view.
         * @return {?}
         */
        function () {
            var _this = this;
            this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
            var /** @type {?} */ activeYear = this._dateAdapter.getYear(this._activeDate);
            var /** @type {?} */ activeOffset = activeYear % yearsPerPage;
            this._years = [];
            for (var /** @type {?} */ i = 0, /** @type {?} */ row = []; i < yearsPerPage; i++) {
                row.push(activeYear - activeOffset + i);
                if (row.length == yearsPerRow) {
                    this._years.push(row.map(function (year) { return _this._createCellForYear(year); }));
                    row = [];
                }
            }
            this._changeDetectorRef.markForCheck();
        };
        /** Handles when a new year is selected. */
        /**
         * Handles when a new year is selected.
         * @param {?} year
         * @return {?}
         */
        MatMultiYearView.prototype._yearSelected = /**
         * Handles when a new year is selected.
         * @param {?} year
         * @return {?}
         */
        function (year) {
            this.yearSelected.emit(this._dateAdapter.createDate(year, 0, 1));
            var /** @type {?} */ month = this._dateAdapter.getMonth(this.activeDate);
            var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, month, 1));
            this.selectedChange.emit(this._dateAdapter.createDate(year, month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
        };
        /** Handles keydown events on the calendar body when calendar is in multi-year view. */
        /**
         * Handles keydown events on the calendar body when calendar is in multi-year view.
         * @param {?} event
         * @return {?}
         */
        MatMultiYearView.prototype._handleCalendarBodyKeydown = /**
         * Handles keydown events on the calendar body when calendar is in multi-year view.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
            // disabled ones from being selected. This may not be ideal, we should look into whether
            // navigation should skip over disabled dates, and if so, how to implement that efficiently.
            var /** @type {?} */ oldActiveDate = this._activeDate;
            var /** @type {?} */ isRtl = this._isRtl();
            switch (event.keyCode) {
                case LEFT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? 1 : -1);
                    break;
                case RIGHT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? -1 : 1);
                    break;
                case UP_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
                    break;
                case DOWN_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
                    break;
                case HOME:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -this._dateAdapter.getYear(this._activeDate) % yearsPerPage);
                    break;
                case END:
                    this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage - this._dateAdapter.getYear(this._activeDate) % yearsPerPage - 1);
                    break;
                case PAGE_UP:
                    this.activeDate =
                        this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage * 10 : -yearsPerPage);
                    break;
                case PAGE_DOWN:
                    this.activeDate =
                        this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage * 10 : yearsPerPage);
                    break;
                case ENTER:
                    this._yearSelected(this._dateAdapter.getYear(this._activeDate));
                    break;
                default:
                    // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                    return;
            }
            if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                this.activeDateChange.emit(this.activeDate);
            }
            this._focusActiveCell();
            // Prevent unexpected default actions such as form submission.
            event.preventDefault();
        };
        /**
         * @return {?}
         */
        MatMultiYearView.prototype._getActiveCell = /**
         * @return {?}
         */
        function () {
            return this._dateAdapter.getYear(this.activeDate) % yearsPerPage;
        };
        /** Focuses the active cell after the microtask queue is empty. */
        /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        MatMultiYearView.prototype._focusActiveCell = /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        function () {
            this._matCalendarBody._focusActiveCell();
        };
        /**
         * Creates an MatCalendarCell for the given year.
         * @param {?} year
         * @return {?}
         */
        MatMultiYearView.prototype._createCellForYear = /**
         * Creates an MatCalendarCell for the given year.
         * @param {?} year
         * @return {?}
         */
        function (year) {
            var /** @type {?} */ yearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(year, 0, 1));
            return new MatCalendarCell(year, yearName, yearName, this._shouldEnableYear(year));
        };
        /**
         * Whether the given year is enabled.
         * @param {?} year
         * @return {?}
         */
        MatMultiYearView.prototype._shouldEnableYear = /**
         * Whether the given year is enabled.
         * @param {?} year
         * @return {?}
         */
        function (year) {
            // disable if the year is greater than maxDate lower than minDate
            if (year === undefined || year === null ||
                (this.maxDate && year > this._dateAdapter.getYear(this.maxDate)) ||
                (this.minDate && year < this._dateAdapter.getYear(this.minDate))) {
                return false;
            }
            // enable if it reaches here and there's no filter defined
            if (!this.dateFilter) {
                return true;
            }
            var /** @type {?} */ firstOfYear = this._dateAdapter.createDate(year, 0, 1);
            // If any date in the year is enabled count the year as enabled.
            for (var /** @type {?} */ date = firstOfYear; this._dateAdapter.getYear(date) == year; date = this._dateAdapter.addCalendarDays(date, 1)) {
                if (this.dateFilter(date)) {
                    return true;
                }
            }
            return false;
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatMultiYearView.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        MatMultiYearView.prototype._isRtl = /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl';
        };
        MatMultiYearView.decorators = [
            { type: core.Component, args: [{selector: 'mat-multi-year-view',
                        template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body allowDisabledSelection=\"true\" [rows]=\"_years\" [todayValue]=\"_todayYear\" [selectedValue]=\"_selectedYear\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_getActiveCell()\" (selectedValueChange)=\"_yearSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                        exportAs: 'matMultiYearView',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatMultiYearView.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatMultiYearView.propDecorators = {
            "activeDate": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "minDate": [{ type: core.Input },],
            "maxDate": [{ type: core.Input },],
            "dateFilter": [{ type: core.Input },],
            "selectedChange": [{ type: core.Output },],
            "yearSelected": [{ type: core.Output },],
            "activeDateChange": [{ type: core.Output },],
            "_matCalendarBody": [{ type: core.ViewChild, args: [MatCalendarBody,] },],
        };
        return MatMultiYearView;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * An internal component used to display a single year in the datepicker.
     * \@docs-private
     * @template D
     */
    var MatYearView = /** @class */ (function () {
        function MatYearView(_changeDetectorRef, _dateFormats, _dateAdapter, _dir) {
            this._changeDetectorRef = _changeDetectorRef;
            this._dateFormats = _dateFormats;
            this._dateAdapter = _dateAdapter;
            this._dir = _dir;
            /**
             * Emits when a new month is selected.
             */
            this.selectedChange = new core.EventEmitter();
            /**
             * Emits the selected month. This doesn't imply a change on the selected date
             */
            this.monthSelected = new core.EventEmitter();
            /**
             * Emits when any date is activated.
             */
            this.activeDateChange = new core.EventEmitter();
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('MAT_DATE_FORMATS');
            }
            this._activeDate = this._dateAdapter.today();
        }
        Object.defineProperty(MatYearView.prototype, "activeDate", {
            get: /**
             * The date to display in this year view (everything other than the year is ignored).
             * @return {?}
             */
            function () { return this._activeDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ oldActiveDate = this._activeDate;
                var /** @type {?} */ validDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
                this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
                if (this._dateAdapter.getYear(oldActiveDate) !== this._dateAdapter.getYear(this._activeDate)) {
                    this._init();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatYearView.prototype, "selected", {
            get: /**
             * The currently selected date.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                this._selectedMonth = this._getMonthInCurrentYear(this._selected);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatYearView.prototype, "minDate", {
            get: /**
             * The minimum selectable date.
             * @return {?}
             */
            function () { return this._minDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatYearView.prototype, "maxDate", {
            get: /**
             * The maximum selectable date.
             * @return {?}
             */
            function () { return this._maxDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatYearView.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._init();
        };
        /** Handles when a new month is selected. */
        /**
         * Handles when a new month is selected.
         * @param {?} month
         * @return {?}
         */
        MatYearView.prototype._monthSelected = /**
         * Handles when a new month is selected.
         * @param {?} month
         * @return {?}
         */
        function (month) {
            var /** @type {?} */ normalizedDate = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
            this.monthSelected.emit(normalizedDate);
            var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(normalizedDate);
            this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
        };
        /** Handles keydown events on the calendar body when calendar is in year view. */
        /**
         * Handles keydown events on the calendar body when calendar is in year view.
         * @param {?} event
         * @return {?}
         */
        MatYearView.prototype._handleCalendarBodyKeydown = /**
         * Handles keydown events on the calendar body when calendar is in year view.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
            // disabled ones from being selected. This may not be ideal, we should look into whether
            // navigation should skip over disabled dates, and if so, how to implement that efficiently.
            var /** @type {?} */ oldActiveDate = this._activeDate;
            var /** @type {?} */ isRtl = this._isRtl();
            switch (event.keyCode) {
                case LEFT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? 1 : -1);
                    break;
                case RIGHT_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? -1 : 1);
                    break;
                case UP_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
                    break;
                case DOWN_ARROW:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
                    break;
                case HOME:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
                    break;
                case END:
                    this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
                    break;
                case PAGE_UP:
                    this.activeDate =
                        this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
                    break;
                case PAGE_DOWN:
                    this.activeDate =
                        this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
                    break;
                case ENTER:
                    this._monthSelected(this._dateAdapter.getMonth(this._activeDate));
                    break;
                default:
                    // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                    return;
            }
            if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
                this.activeDateChange.emit(this.activeDate);
            }
            this._focusActiveCell();
            // Prevent unexpected default actions such as form submission.
            event.preventDefault();
        };
        /** Initializes this year view. */
        /**
         * Initializes this year view.
         * @return {?}
         */
        MatYearView.prototype._init = /**
         * Initializes this year view.
         * @return {?}
         */
        function () {
            var _this = this;
            this._selectedMonth = this._getMonthInCurrentYear(this.selected);
            this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
            this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
            var /** @type {?} */ monthNames = this._dateAdapter.getMonthNames('short');
            // First row of months only contains 5 elements so we can fit the year label on the same row.
            this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(function (row) {
                return row.map(function (month) { return _this._createCellForMonth(month, monthNames[month]); });
            });
            this._changeDetectorRef.markForCheck();
        };
        /** Focuses the active cell after the microtask queue is empty. */
        /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        MatYearView.prototype._focusActiveCell = /**
         * Focuses the active cell after the microtask queue is empty.
         * @return {?}
         */
        function () {
            this._matCalendarBody._focusActiveCell();
        };
        /**
         * Gets the month in this year that the given Date falls on.
         * Returns null if the given Date is in another year.
         * @param {?} date
         * @return {?}
         */
        MatYearView.prototype._getMonthInCurrentYear = /**
         * Gets the month in this year that the given Date falls on.
         * Returns null if the given Date is in another year.
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ?
                this._dateAdapter.getMonth(date) : null;
        };
        /**
         * Creates an MatCalendarCell for the given month.
         * @param {?} month
         * @param {?} monthName
         * @return {?}
         */
        MatYearView.prototype._createCellForMonth = /**
         * Creates an MatCalendarCell for the given month.
         * @param {?} month
         * @param {?} monthName
         * @return {?}
         */
        function (month, monthName) {
            var /** @type {?} */ ariaLabel = this._dateAdapter.format(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1), this._dateFormats.display.monthYearA11yLabel);
            return new MatCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._shouldEnableMonth(month));
        };
        /**
         * Whether the given month is enabled.
         * @param {?} month
         * @return {?}
         */
        MatYearView.prototype._shouldEnableMonth = /**
         * Whether the given month is enabled.
         * @param {?} month
         * @return {?}
         */
        function (month) {
            var /** @type {?} */ activeYear = this._dateAdapter.getYear(this.activeDate);
            if (month === undefined || month === null ||
                this._isYearAndMonthAfterMaxDate(activeYear, month) ||
                this._isYearAndMonthBeforeMinDate(activeYear, month)) {
                return false;
            }
            if (!this.dateFilter) {
                return true;
            }
            var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
            // If any date in the month is enabled count the month as enabled.
            for (var /** @type {?} */ date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
                if (this.dateFilter(date)) {
                    return true;
                }
            }
            return false;
        };
        /**
         * Tests whether the combination month/year is after this.maxDate, considering
         * just the month and year of this.maxDate
         * @param {?} year
         * @param {?} month
         * @return {?}
         */
        MatYearView.prototype._isYearAndMonthAfterMaxDate = /**
         * Tests whether the combination month/year is after this.maxDate, considering
         * just the month and year of this.maxDate
         * @param {?} year
         * @param {?} month
         * @return {?}
         */
        function (year, month) {
            if (this.maxDate) {
                var /** @type {?} */ maxYear = this._dateAdapter.getYear(this.maxDate);
                var /** @type {?} */ maxMonth = this._dateAdapter.getMonth(this.maxDate);
                return year > maxYear || (year === maxYear && month > maxMonth);
            }
            return false;
        };
        /**
         * Tests whether the combination month/year is before this.minDate, considering
         * just the month and year of this.minDate
         * @param {?} year
         * @param {?} month
         * @return {?}
         */
        MatYearView.prototype._isYearAndMonthBeforeMinDate = /**
         * Tests whether the combination month/year is before this.minDate, considering
         * just the month and year of this.minDate
         * @param {?} year
         * @param {?} month
         * @return {?}
         */
        function (year, month) {
            if (this.minDate) {
                var /** @type {?} */ minYear = this._dateAdapter.getYear(this.minDate);
                var /** @type {?} */ minMonth = this._dateAdapter.getMonth(this.minDate);
                return year < minYear || (year === minYear && month < minMonth);
            }
            return false;
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatYearView.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        MatYearView.prototype._isRtl = /**
         * Determines whether the user has the RTL layout direction.
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl';
        };
        MatYearView.decorators = [
            { type: core.Component, args: [{selector: 'mat-year-view',
                        template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body allowDisabledSelection=\"true\" [label]=\"_yearLabel\" [rows]=\"_months\" [todayValue]=\"_todayMonth\" [selectedValue]=\"_selectedMonth\" [labelMinRequiredCells]=\"2\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_dateAdapter.getMonth(activeDate)\" (selectedValueChange)=\"_monthSelected($event)\" (keydown)=\"_handleCalendarBodyKeydown($event)\"></tbody></table>",
                        exportAs: 'matYearView',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatYearView.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_FORMATS,] },] },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatYearView.propDecorators = {
            "activeDate": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "minDate": [{ type: core.Input },],
            "maxDate": [{ type: core.Input },],
            "dateFilter": [{ type: core.Input },],
            "selectedChange": [{ type: core.Output },],
            "monthSelected": [{ type: core.Output },],
            "activeDateChange": [{ type: core.Output },],
            "_matCalendarBody": [{ type: core.ViewChild, args: [MatCalendarBody,] },],
        };
        return MatYearView;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Default header for MatCalendar
     * @template D
     */
    var MatCalendarHeader = /** @class */ (function () {
        function MatCalendarHeader(_intl, calendar, _dateAdapter, _dateFormats, changeDetectorRef) {
            this._intl = _intl;
            this.calendar = calendar;
            this._dateAdapter = _dateAdapter;
            this._dateFormats = _dateFormats;
            this.calendar.stateChanges.subscribe(function () { return changeDetectorRef.markForCheck(); });
        }
        Object.defineProperty(MatCalendarHeader.prototype, "periodButtonText", {
            /** The label for the current calendar view. */
            get: /**
             * The label for the current calendar view.
             * @return {?}
             */
            function () {
                if (this.calendar.currentView == 'month') {
                    return this._dateAdapter
                        .format(this.calendar.activeDate, this._dateFormats.display.monthYearLabel)
                        .toLocaleUpperCase();
                }
                if (this.calendar.currentView == 'year') {
                    return this._dateAdapter.getYearName(this.calendar.activeDate);
                }
                var /** @type {?} */ activeYear = this._dateAdapter.getYear(this.calendar.activeDate);
                var /** @type {?} */ firstYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear - activeYear % 24, 0, 1));
                var /** @type {?} */ lastYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear + yearsPerPage - 1 - activeYear % 24, 0, 1));
                return firstYearInView + " \u2013 " + lastYearInView;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendarHeader.prototype, "periodButtonLabel", {
            get: /**
             * @return {?}
             */
            function () {
                return this.calendar.currentView == 'month' ?
                    this._intl.switchToMultiYearViewLabel : this._intl.switchToMonthViewLabel;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendarHeader.prototype, "prevButtonLabel", {
            /** The label for the the previous button. */
            get: /**
             * The label for the the previous button.
             * @return {?}
             */
            function () {
                return {
                    'month': this._intl.prevMonthLabel,
                    'year': this._intl.prevYearLabel,
                    'multi-year': this._intl.prevMultiYearLabel
                }[this.calendar.currentView];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendarHeader.prototype, "nextButtonLabel", {
            /** The label for the the next button. */
            get: /**
             * The label for the the next button.
             * @return {?}
             */
            function () {
                return {
                    'month': this._intl.nextMonthLabel,
                    'year': this._intl.nextYearLabel,
                    'multi-year': this._intl.nextMultiYearLabel
                }[this.calendar.currentView];
            },
            enumerable: true,
            configurable: true
        });
        /** Handles user clicks on the period label. */
        /**
         * Handles user clicks on the period label.
         * @return {?}
         */
        MatCalendarHeader.prototype.currentPeriodClicked = /**
         * Handles user clicks on the period label.
         * @return {?}
         */
        function () {
            this.calendar.currentView = this.calendar.currentView == 'month' ? 'multi-year' : 'month';
        };
        /** Handles user clicks on the previous button. */
        /**
         * Handles user clicks on the previous button.
         * @return {?}
         */
        MatCalendarHeader.prototype.previousClicked = /**
         * Handles user clicks on the previous button.
         * @return {?}
         */
        function () {
            this.calendar.activeDate = this.calendar.currentView == 'month' ?
                this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) :
                this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? -1 : -yearsPerPage);
        };
        /** Handles user clicks on the next button. */
        /**
         * Handles user clicks on the next button.
         * @return {?}
         */
        MatCalendarHeader.prototype.nextClicked = /**
         * Handles user clicks on the next button.
         * @return {?}
         */
        function () {
            this.calendar.activeDate = this.calendar.currentView == 'month' ?
                this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) :
                this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? 1 : yearsPerPage);
        };
        /** Whether the previous period button is enabled. */
        /**
         * Whether the previous period button is enabled.
         * @return {?}
         */
        MatCalendarHeader.prototype.previousEnabled = /**
         * Whether the previous period button is enabled.
         * @return {?}
         */
        function () {
            if (!this.calendar.minDate) {
                return true;
            }
            return !this.calendar.minDate ||
                !this._isSameView(this.calendar.activeDate, this.calendar.minDate);
        };
        /** Whether the next period button is enabled. */
        /**
         * Whether the next period button is enabled.
         * @return {?}
         */
        MatCalendarHeader.prototype.nextEnabled = /**
         * Whether the next period button is enabled.
         * @return {?}
         */
        function () {
            return !this.calendar.maxDate ||
                !this._isSameView(this.calendar.activeDate, this.calendar.maxDate);
        };
        /**
         * Whether the two dates represent the same view in the current view mode (month or year).
         * @param {?} date1
         * @param {?} date2
         * @return {?}
         */
        MatCalendarHeader.prototype._isSameView = /**
         * Whether the two dates represent the same view in the current view mode (month or year).
         * @param {?} date1
         * @param {?} date2
         * @return {?}
         */
        function (date1, date2) {
            if (this.calendar.currentView == 'month') {
                return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
                    this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
            }
            if (this.calendar.currentView == 'year') {
                return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
            }
            // Otherwise we are in 'multi-year' view.
            return Math.floor(this._dateAdapter.getYear(date1) / yearsPerPage) ==
                Math.floor(this._dateAdapter.getYear(date2) / yearsPerPage);
        };
        MatCalendarHeader.decorators = [
            { type: core.Component, args: [{selector: 'mat-calendar-header',
                        template: "<div class=\"mat-calendar-header\"><div class=\"mat-calendar-controls\"><button mat-button type=\"button\" class=\"mat-calendar-period-button\" (click)=\"currentPeriodClicked()\" [attr.aria-label]=\"periodButtonLabel\" cdkAriaLive=\"polite\">{{periodButtonText}}<div class=\"mat-calendar-arrow\" [class.mat-calendar-invert]=\"calendar.currentView != 'month'\"></div></button><div class=\"mat-calendar-spacer\"></div><button mat-icon-button type=\"button\" class=\"mat-calendar-previous-button\" [disabled]=\"!previousEnabled()\" (click)=\"previousClicked()\" [attr.aria-label]=\"prevButtonLabel\"></button> <button mat-icon-button type=\"button\" class=\"mat-calendar-next-button\" [disabled]=\"!nextEnabled()\" (click)=\"nextClicked()\" [attr.aria-label]=\"nextButtonLabel\"></button></div></div>",
                        exportAs: 'matCalendarHeader',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatCalendarHeader.ctorParameters = function () { return [
            { type: MatDatepickerIntl, },
            { type: MatCalendar, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatCalendar; }),] },] },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_FORMATS,] },] },
            { type: core.ChangeDetectorRef, },
        ]; };
        return MatCalendarHeader;
    }());
    /**
     * A calendar that is used as part of the datepicker.
     * \@docs-private
     * @template D
     */
    var MatCalendar = /** @class */ (function () {
        function MatCalendar(_intl, _dateAdapter, _dateFormats, changeDetectorRef) {
            var _this = this;
            this._dateAdapter = _dateAdapter;
            this._dateFormats = _dateFormats;
            /**
             * Used for scheduling that focus should be moved to the active cell on the next tick.
             * We need to schedule it, rather than do it immediately, because we have to wait
             * for Angular to re-evaluate the view children.
             */
            this._moveFocusOnNextTick = false;
            /**
             * Whether the calendar should be started in month or year view.
             */
            this.startView = 'month';
            /**
             * Emits when the currently selected date changes.
             */
            this.selectedChange = new core.EventEmitter();
            /**
             * Emits the year chosen in multiyear view.
             * This doesn't imply a change on the selected date.
             */
            this.yearSelected = new core.EventEmitter();
            /**
             * Emits the month chosen in year view.
             * This doesn't imply a change on the selected date.
             */
            this.monthSelected = new core.EventEmitter();
            /**
             * Emits when any date is selected.
             */
            this._userSelection = new core.EventEmitter();
            /**
             * Emits whenever there is a state change that the header may need to respond to.
             */
            this.stateChanges = new rxjs.Subject();
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('MAT_DATE_FORMATS');
            }
            this._intlChanges = _intl.changes.subscribe(function () {
                changeDetectorRef.markForCheck();
                _this.stateChanges.next();
            });
        }
        Object.defineProperty(MatCalendar.prototype, "startAt", {
            get: /**
             * A date representing the period (month or year) to start the calendar in.
             * @return {?}
             */
            function () { return this._startAt; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendar.prototype, "selected", {
            get: /**
             * The currently selected date.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendar.prototype, "minDate", {
            get: /**
             * The minimum selectable date.
             * @return {?}
             */
            function () { return this._minDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendar.prototype, "maxDate", {
            get: /**
             * The maximum selectable date.
             * @return {?}
             */
            function () { return this._maxDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendar.prototype, "activeDate", {
            /**
             * The current active date. This determines which time period is shown and which date is
             * highlighted when using keyboard navigation.
             */
            get: /**
             * The current active date. This determines which time period is shown and which date is
             * highlighted when using keyboard navigation.
             * @return {?}
             */
            function () { return this._clampedActiveDate; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatCalendar.prototype, "currentView", {
            /** Whether the calendar is in month view. */
            get: /**
             * Whether the calendar is in month view.
             * @return {?}
             */
            function () { return this._currentView; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._currentView = value;
                this._moveFocusOnNextTick = true;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatCalendar.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._calendarHeaderPortal = new ComponentPortal(this.headerComponent || MatCalendarHeader);
            this.activeDate = this.startAt || this._dateAdapter.today();
            // Assign to the private property since we don't want to move focus on init.
            this._currentView = this.startView;
        };
        /**
         * @return {?}
         */
        MatCalendar.prototype.ngAfterViewChecked = /**
         * @return {?}
         */
        function () {
            if (this._moveFocusOnNextTick) {
                this._moveFocusOnNextTick = false;
                this.focusActiveCell();
            }
        };
        /**
         * @return {?}
         */
        MatCalendar.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._intlChanges.unsubscribe();
            this.stateChanges.complete();
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        MatCalendar.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            var /** @type {?} */ change = changes["minDate"] || changes["maxDate"] || changes["dateFilter"];
            if (change && !change.firstChange) {
                var /** @type {?} */ view = this._getCurrentViewComponent();
                if (view) {
                    view._init();
                }
            }
            this.stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatCalendar.prototype.focusActiveCell = /**
         * @return {?}
         */
        function () {
            this._getCurrentViewComponent()._focusActiveCell();
        };
        /** Handles date selection in the month view. */
        /**
         * Handles date selection in the month view.
         * @param {?} date
         * @return {?}
         */
        MatCalendar.prototype._dateSelected = /**
         * Handles date selection in the month view.
         * @param {?} date
         * @return {?}
         */
        function (date) {
            if (!this._dateAdapter.sameDate(date, this.selected)) {
                this.selectedChange.emit(date);
            }
        };
        /** Handles year selection in the multiyear view. */
        /**
         * Handles year selection in the multiyear view.
         * @param {?} normalizedYear
         * @return {?}
         */
        MatCalendar.prototype._yearSelectedInMultiYearView = /**
         * Handles year selection in the multiyear view.
         * @param {?} normalizedYear
         * @return {?}
         */
        function (normalizedYear) {
            this.yearSelected.emit(normalizedYear);
        };
        /** Handles month selection in the year view. */
        /**
         * Handles month selection in the year view.
         * @param {?} normalizedMonth
         * @return {?}
         */
        MatCalendar.prototype._monthSelectedInYearView = /**
         * Handles month selection in the year view.
         * @param {?} normalizedMonth
         * @return {?}
         */
        function (normalizedMonth) {
            this.monthSelected.emit(normalizedMonth);
        };
        /**
         * @return {?}
         */
        MatCalendar.prototype._userSelected = /**
         * @return {?}
         */
        function () {
            this._userSelection.emit();
        };
        /** Handles year/month selection in the multi-year/year views. */
        /**
         * Handles year/month selection in the multi-year/year views.
         * @param {?} date
         * @param {?} view
         * @return {?}
         */
        MatCalendar.prototype._goToDateInView = /**
         * Handles year/month selection in the multi-year/year views.
         * @param {?} date
         * @param {?} view
         * @return {?}
         */
        function (date, view) {
            this.activeDate = date;
            this.currentView = view;
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatCalendar.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        /**
         * Returns the component instance that corresponds to the current calendar view.
         * @return {?}
         */
        MatCalendar.prototype._getCurrentViewComponent = /**
         * Returns the component instance that corresponds to the current calendar view.
         * @return {?}
         */
        function () {
            return this.monthView || this.yearView || this.multiYearView;
        };
        MatCalendar.decorators = [
            { type: core.Component, args: [{selector: 'mat-calendar',
                        template: "<ng-template [cdkPortalOutlet]=\"_calendarHeaderPortal\"></ng-template><div class=\"mat-calendar-content\" [ngSwitch]=\"currentView\" cdkMonitorSubtreeFocus tabindex=\"-1\"><mat-month-view *ngSwitchCase=\"'month'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (selectedChange)=\"_dateSelected($event)\" (_userSelection)=\"_userSelected()\"></mat-month-view><mat-year-view *ngSwitchCase=\"'year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (monthSelected)=\"_monthSelectedInYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'month')\"></mat-year-view><mat-multi-year-view *ngSwitchCase=\"'multi-year'\" [(activeDate)]=\"activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (yearSelected)=\"_yearSelectedInMultiYearView($event)\" (selectedChange)=\"_goToDateInView($event, 'year')\"></mat-multi-year-view></div>",
                        styles: [".mat-calendar{display:block}.mat-calendar-header{padding:8px 8px 0 8px}.mat-calendar-content{padding:0 8px 8px 8px;outline:0}.mat-calendar-controls{display:flex;margin:5% calc(33% / 7 - 16px)}.mat-calendar-spacer{flex:1 1 auto}.mat-calendar-period-button{min-width:0}.mat-calendar-arrow{display:inline-block;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;margin:0 0 0 5px;vertical-align:middle}.mat-calendar-arrow.mat-calendar-invert{transform:rotate(180deg)}[dir=rtl] .mat-calendar-arrow{margin:0 5px 0 0}.mat-calendar-next-button,.mat-calendar-previous-button{position:relative}.mat-calendar-next-button::after,.mat-calendar-previous-button::after{top:0;left:0;right:0;bottom:0;position:absolute;content:'';margin:15.5px;border:0 solid currentColor;border-top-width:2px}[dir=rtl] .mat-calendar-next-button,[dir=rtl] .mat-calendar-previous-button{transform:rotate(180deg)}.mat-calendar-previous-button::after{border-left-width:2px;transform:translateX(2px) rotate(-45deg)}.mat-calendar-next-button::after{border-right-width:2px;transform:translateX(-2px) rotate(45deg)}.mat-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.mat-calendar-table-header th{text-align:center;padding:0 0 8px 0}.mat-calendar-table-header-divider{position:relative;height:1px}.mat-calendar-table-header-divider::after{content:'';position:absolute;top:0;left:-8px;right:-8px;height:1px}"],
                        host: {
                            'class': 'mat-calendar',
                        },
                        exportAs: 'matCalendar',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatCalendar.ctorParameters = function () { return [
            { type: MatDatepickerIntl, },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_FORMATS,] },] },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatCalendar.propDecorators = {
            "headerComponent": [{ type: core.Input },],
            "startAt": [{ type: core.Input },],
            "startView": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "minDate": [{ type: core.Input },],
            "maxDate": [{ type: core.Input },],
            "dateFilter": [{ type: core.Input },],
            "selectedChange": [{ type: core.Output },],
            "yearSelected": [{ type: core.Output },],
            "monthSelected": [{ type: core.Output },],
            "_userSelection": [{ type: core.Output },],
            "monthView": [{ type: core.ViewChild, args: [MatMonthView,] },],
            "yearView": [{ type: core.ViewChild, args: [MatYearView,] },],
            "multiYearView": [{ type: core.ViewChild, args: [MatMultiYearView,] },],
        };
        return MatCalendar;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material datepicker.
     */
    var /** @type {?} */ matDatepickerAnimations = {
        /** Transforms the height of the datepicker's calendar. */
        transformPanel: trigger('transformPanel', [
            state('void', style({ opacity: 0, transform: 'scale(1, 0)' })),
            state('enter', style({ opacity: 1, transform: 'scale(1, 1)' })),
            transition('void => enter', group([
                query('@fadeInCalendar', animateChild()),
                animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')
            ])),
            transition('* => void', animate('100ms linear', style({ opacity: 0 })))
        ]),
        /** Fades in the content of the calendar. */
        fadeInCalendar: trigger('fadeInCalendar', [
            state('void', style({ opacity: 0 })),
            state('enter', style({ opacity: 1 })),
            transition('void => *', animate('400ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)'))
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to generate a unique ID for each datepicker instance.
     */
    var /** @type {?} */ datepickerUid = 0;
    /**
     * Injection token that determines the scroll handling while the calendar is open.
     */
    var /** @type {?} */ MAT_DATEPICKER_SCROLL_STRATEGY = new core.InjectionToken('mat-datepicker-scroll-strategy');
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatDatepickerContentBase = /** @class */ (function () {
        function MatDatepickerContentBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatDatepickerContentBase;
    }());
    var /** @type {?} */ _MatDatepickerContentMixinBase = mixinColor(MatDatepickerContentBase);
    /**
     * Component used as the content for the datepicker dialog and popup. We use this instead of using
     * MatCalendar directly as the content so we can control the initial focus. This also gives us a
     * place to put additional features of the popup that are not part of the calendar itself in the
     * future. (e.g. confirmation buttons).
     * \@docs-private
     * @template D
     */
    var MatDatepickerContent = /** @class */ (function (_super) {
        __extends(MatDatepickerContent, _super);
        function MatDatepickerContent(elementRef) {
            return _super.call(this, elementRef) || this;
        }
        /**
         * @return {?}
         */
        MatDatepickerContent.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            this._calendar.focusActiveCell();
        };
        MatDatepickerContent.decorators = [
            { type: core.Component, args: [{selector: 'mat-datepicker-content',
                        template: "<mat-calendar cdkTrapFocus [id]=\"datepicker.id\" [ngClass]=\"datepicker.panelClass\" [startAt]=\"datepicker.startAt\" [startView]=\"datepicker.startView\" [minDate]=\"datepicker._minDate\" [maxDate]=\"datepicker._maxDate\" [dateFilter]=\"datepicker._dateFilter\" [headerComponent]=\"datepicker.calendarHeaderComponent\" [selected]=\"datepicker._selected\" [@fadeInCalendar]=\"'enter'\" (selectedChange)=\"datepicker._select($event)\" (yearSelected)=\"datepicker._selectYear($event)\" (monthSelected)=\"datepicker._selectMonth($event)\" (_userSelection)=\"datepicker.close()\"></mat-calendar>",
                        styles: [".mat-datepicker-content{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);display:block;border-radius:2px}.mat-datepicker-content .mat-calendar{width:296px;height:354px}.mat-datepicker-content-touch{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);display:block;max-height:80vh;overflow:auto;margin:-24px}.mat-datepicker-content-touch .mat-calendar{min-width:250px;min-height:312px;max-width:750px;max-height:788px}@media all and (orientation:landscape){.mat-datepicker-content-touch .mat-calendar{width:64vh;height:80vh}}@media all and (orientation:portrait){.mat-datepicker-content-touch .mat-calendar{width:80vw;height:100vw}}"],
                        host: {
                            'class': 'mat-datepicker-content',
                            '[@transformPanel]': '"enter"',
                            '[class.mat-datepicker-content-touch]': 'datepicker.touchUi',
                        },
                        animations: [
                            matDatepickerAnimations.transformPanel,
                            matDatepickerAnimations.fadeInCalendar,
                        ],
                        exportAs: 'matDatepickerContent',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['color'],
                    },] },
        ];
        /** @nocollapse */
        MatDatepickerContent.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        MatDatepickerContent.propDecorators = {
            "_calendar": [{ type: core.ViewChild, args: [MatCalendar,] },],
        };
        return MatDatepickerContent;
    }(_MatDatepickerContentMixinBase));
    /**
     * Component responsible for managing the datepicker popup/dialog.
     * @template D
     */
    var MatDatepicker = /** @class */ (function () {
        function MatDatepicker(_dialog, _overlay, _ngZone, _viewContainerRef, _scrollStrategy, _dateAdapter, _dir, _document) {
            this._dialog = _dialog;
            this._overlay = _overlay;
            this._ngZone = _ngZone;
            this._viewContainerRef = _viewContainerRef;
            this._scrollStrategy = _scrollStrategy;
            this._dateAdapter = _dateAdapter;
            this._dir = _dir;
            this._document = _document;
            /**
             * The view that the calendar should start in.
             */
            this.startView = 'month';
            this._touchUi = false;
            /**
             * Emits selected year in multiyear view.
             * This doesn't imply a change on the selected date.
             */
            this.yearSelected = new core.EventEmitter();
            /**
             * Emits selected month in year view.
             * This doesn't imply a change on the selected date.
             */
            this.monthSelected = new core.EventEmitter();
            /**
             * Emits when the datepicker has been opened.
             */
            this.openedStream = new core.EventEmitter();
            /**
             * Emits when the datepicker has been closed.
             */
            this.closedStream = new core.EventEmitter();
            this._opened = false;
            /**
             * The id for the datepicker calendar.
             */
            this.id = "mat-datepicker-" + datepickerUid++;
            this._validSelected = null;
            /**
             * The element that was focused before the datepicker was opened.
             */
            this._focusedElementBeforeOpen = null;
            /**
             * Subscription to value changes in the associated input element.
             */
            this._inputSubscription = rxjs.Subscription.EMPTY;
            /**
             * Emits when the datepicker is disabled.
             */
            this._disabledChange = new rxjs.Subject();
            /**
             * Emits new selected date when selected date changes.
             */
            this._selectedChanged = new rxjs.Subject();
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
        }
        Object.defineProperty(MatDatepicker.prototype, "startAt", {
            get: /**
             * The date to open the calendar to initially.
             * @return {?}
             */
            function () {
                // If an explicit startAt is set we start there, otherwise we start at whatever the currently
                // selected value is.
                return this._startAt || (this._datepickerInput ? this._datepickerInput.value : null);
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "color", {
            get: /**
             * Color palette to use on the datepicker's calendar.
             * @return {?}
             */
            function () {
                return this._color ||
                    (this._datepickerInput ? this._datepickerInput._getThemePalette() : undefined);
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._color = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "touchUi", {
            get: /**
             * Whether the calendar UI is in touch mode. In touch mode the calendar opens in a dialog rather
             * than a popup and elements have more padding to allow for bigger touch targets.
             * @return {?}
             */
            function () { return this._touchUi; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._touchUi = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "disabled", {
            get: /**
             * Whether the datepicker pop-up should be disabled.
             * @return {?}
             */
            function () {
                return this._disabled === undefined && this._datepickerInput ?
                    this._datepickerInput.disabled : !!this._disabled;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newValue = coerceBooleanProperty(value);
                if (newValue !== this._disabled) {
                    this._disabled = newValue;
                    this._disabledChange.next(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "opened", {
            get: /**
             * Whether the calendar is open.
             * @return {?}
             */
            function () { return this._opened; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { value ? this.open() : this.close(); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "_selected", {
            /** The currently selected date. */
            get: /**
             * The currently selected date.
             * @return {?}
             */
            function () { return this._validSelected; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._validSelected = value; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "_minDate", {
            /** The minimum selectable date. */
            get: /**
             * The minimum selectable date.
             * @return {?}
             */
            function () {
                return this._datepickerInput && this._datepickerInput.min;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "_maxDate", {
            /** The maximum selectable date. */
            get: /**
             * The maximum selectable date.
             * @return {?}
             */
            function () {
                return this._datepickerInput && this._datepickerInput.max;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepicker.prototype, "_dateFilter", {
            get: /**
             * @return {?}
             */
            function () {
                return this._datepickerInput && this._datepickerInput._dateFilter;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatDatepicker.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.close();
            this._inputSubscription.unsubscribe();
            this._disabledChange.complete();
            if (this._popupRef) {
                this._popupRef.dispose();
                this._popupComponentRef = null;
            }
        };
        /** Selects the given date */
        /**
         * Selects the given date
         * @param {?} date
         * @return {?}
         */
        MatDatepicker.prototype._select = /**
         * Selects the given date
         * @param {?} date
         * @return {?}
         */
        function (date) {
            var /** @type {?} */ oldValue = this._selected;
            this._selected = date;
            if (!this._dateAdapter.sameDate(oldValue, this._selected)) {
                this._selectedChanged.next(date);
            }
        };
        /** Emits the selected year in multiyear view */
        /**
         * Emits the selected year in multiyear view
         * @param {?} normalizedYear
         * @return {?}
         */
        MatDatepicker.prototype._selectYear = /**
         * Emits the selected year in multiyear view
         * @param {?} normalizedYear
         * @return {?}
         */
        function (normalizedYear) {
            this.yearSelected.emit(normalizedYear);
        };
        /** Emits selected month in year view */
        /**
         * Emits selected month in year view
         * @param {?} normalizedMonth
         * @return {?}
         */
        MatDatepicker.prototype._selectMonth = /**
         * Emits selected month in year view
         * @param {?} normalizedMonth
         * @return {?}
         */
        function (normalizedMonth) {
            this.monthSelected.emit(normalizedMonth);
        };
        /**
         * Register an input with this datepicker.
         * @param input The datepicker input to register with this datepicker.
         */
        /**
         * Register an input with this datepicker.
         * @param {?} input The datepicker input to register with this datepicker.
         * @return {?}
         */
        MatDatepicker.prototype._registerInput = /**
         * Register an input with this datepicker.
         * @param {?} input The datepicker input to register with this datepicker.
         * @return {?}
         */
        function (input) {
            var _this = this;
            if (this._datepickerInput) {
                throw Error('A MatDatepicker can only be associated with a single input.');
            }
            this._datepickerInput = input;
            this._inputSubscription =
                this._datepickerInput._valueChange.subscribe(function (value) { return _this._selected = value; });
        };
        /** Open the calendar. */
        /**
         * Open the calendar.
         * @return {?}
         */
        MatDatepicker.prototype.open = /**
         * Open the calendar.
         * @return {?}
         */
        function () {
            if (this._opened || this.disabled) {
                return;
            }
            if (!this._datepickerInput) {
                throw Error('Attempted to open an MatDatepicker with no associated input.');
            }
            if (this._document) {
                this._focusedElementBeforeOpen = this._document.activeElement;
            }
            this.touchUi ? this._openAsDialog() : this._openAsPopup();
            this._opened = true;
            this.openedStream.emit();
        };
        /** Close the calendar. */
        /**
         * Close the calendar.
         * @return {?}
         */
        MatDatepicker.prototype.close = /**
         * Close the calendar.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._opened) {
                return;
            }
            if (this._popupRef && this._popupRef.hasAttached()) {
                this._popupRef.detach();
            }
            if (this._dialogRef) {
                this._dialogRef.close();
                this._dialogRef = null;
            }
            if (this._calendarPortal && this._calendarPortal.isAttached) {
                this._calendarPortal.detach();
            }
            var /** @type {?} */ completeClose = function () {
                // The `_opened` could've been reset already if
                // we got two events in quick succession.
                if (_this._opened) {
                    _this._opened = false;
                    _this.closedStream.emit();
                    _this._focusedElementBeforeOpen = null;
                }
            };
            if (this._focusedElementBeforeOpen &&
                typeof this._focusedElementBeforeOpen.focus === 'function') {
                // Because IE moves focus asynchronously, we can't count on it being restored before we've
                // marked the datepicker as closed. If the event fires out of sequence and the element that
                // we're refocusing opens the datepicker on focus, the user could be stuck with not being
                // able to close the calendar at all. We work around it by making the logic, that marks
                // the datepicker as closed, async as well.
                this._focusedElementBeforeOpen.focus();
                setTimeout(completeClose);
            }
            else {
                completeClose();
            }
        };
        /**
         * Open the calendar as a dialog.
         * @return {?}
         */
        MatDatepicker.prototype._openAsDialog = /**
         * Open the calendar as a dialog.
         * @return {?}
         */
        function () {
            var _this = this;
            this._dialogRef = this._dialog.open(MatDatepickerContent, {
                direction: this._dir ? this._dir.value : 'ltr',
                viewContainerRef: this._viewContainerRef,
                panelClass: 'mat-datepicker-dialog',
            });
            this._dialogRef.afterClosed().subscribe(function () { return _this.close(); });
            this._dialogRef.componentInstance.datepicker = this;
            this._setColor();
        };
        /**
         * Open the calendar as a popup.
         * @return {?}
         */
        MatDatepicker.prototype._openAsPopup = /**
         * Open the calendar as a popup.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._calendarPortal) {
                this._calendarPortal = new ComponentPortal(MatDatepickerContent, this._viewContainerRef);
            }
            if (!this._popupRef) {
                this._createPopup();
            }
            if (!this._popupRef.hasAttached()) {
                this._popupComponentRef = this._popupRef.attach(this._calendarPortal);
                this._popupComponentRef.instance.datepicker = this;
                this._setColor();
                // Update the position once the calendar has rendered.
                this._ngZone.onStable.asObservable().pipe(operators.take(1)).subscribe(function () {
                    _this._popupRef.updatePosition();
                });
            }
        };
        /**
         * Create the popup.
         * @return {?}
         */
        MatDatepicker.prototype._createPopup = /**
         * Create the popup.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ overlayConfig = new OverlayConfig({
                positionStrategy: this._createPopupPositionStrategy(),
                hasBackdrop: true,
                backdropClass: 'mat-overlay-transparent-backdrop',
                direction: this._dir,
                scrollStrategy: this._scrollStrategy(),
                panelClass: 'mat-datepicker-popup',
            });
            this._popupRef = this._overlay.create(overlayConfig);
            rxjs.merge(this._popupRef.backdropClick(), this._popupRef.detachments(), this._popupRef.keydownEvents().pipe(operators.filter(function (event) {
                // Closing on alt + up is only valid when there's an input associated with the datepicker.
                return event.keyCode === ESCAPE ||
                    (_this._datepickerInput && event.altKey && event.keyCode === UP_ARROW);
            }))).subscribe(function () { return _this.close(); });
        };
        /**
         * Create the popup PositionStrategy.
         * @return {?}
         */
        MatDatepicker.prototype._createPopupPositionStrategy = /**
         * Create the popup PositionStrategy.
         * @return {?}
         */
        function () {
            return this._overlay.position()
                .flexibleConnectedTo(this._datepickerInput.getPopupConnectionElementRef())
                .withTransformOriginOn('.mat-datepicker-content')
                .withFlexibleDimensions(false)
                .withViewportMargin(8)
                .withPush(false)
                .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                },
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'bottom'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                },
                {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom'
                }
            ]);
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatDatepicker.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        /**
         * Passes the current theme color along to the calendar overlay.
         * @return {?}
         */
        MatDatepicker.prototype._setColor = /**
         * Passes the current theme color along to the calendar overlay.
         * @return {?}
         */
        function () {
            var /** @type {?} */ color = this.color;
            if (this._popupComponentRef) {
                this._popupComponentRef.instance.color = color;
            }
            if (this._dialogRef) {
                this._dialogRef.componentInstance.color = color;
            }
        };
        MatDatepicker.decorators = [
            { type: core.Component, args: [{selector: 'mat-datepicker',
                        template: '',
                        exportAs: 'matDatepicker',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatDatepicker.ctorParameters = function () { return [
            { type: MatDialog, },
            { type: Overlay, },
            { type: core.NgZone, },
            { type: core.ViewContainerRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_DATEPICKER_SCROLL_STRATEGY,] },] },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        MatDatepicker.propDecorators = {
            "calendarHeaderComponent": [{ type: core.Input },],
            "startAt": [{ type: core.Input },],
            "startView": [{ type: core.Input },],
            "color": [{ type: core.Input },],
            "touchUi": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "yearSelected": [{ type: core.Output },],
            "monthSelected": [{ type: core.Output },],
            "panelClass": [{ type: core.Input },],
            "openedStream": [{ type: core.Output, args: ['opened',] },],
            "closedStream": [{ type: core.Output, args: ['closed',] },],
            "opened": [{ type: core.Input },],
        };
        return MatDatepicker;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ MAT_DATEPICKER_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatDatepickerInput; }),
        multi: true
    };
    var /** @type {?} */ MAT_DATEPICKER_VALIDATORS = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return MatDatepickerInput; }),
        multi: true
    };
    /**
     * An event used for datepicker input and change events. We don't always have access to a native
     * input or change event because the event may have been triggered by the user clicking on the
     * calendar popup. For consistency, we always use MatDatepickerInputEvent instead.
     * @template D
     */
    var  /**
     * An event used for datepicker input and change events. We don't always have access to a native
     * input or change event because the event may have been triggered by the user clicking on the
     * calendar popup. For consistency, we always use MatDatepickerInputEvent instead.
     * @template D
     */
    MatDatepickerInputEvent = /** @class */ (function () {
        function MatDatepickerInputEvent(target, targetElement) {
            this.target = target;
            this.targetElement = targetElement;
            this.value = this.target.value;
        }
        return MatDatepickerInputEvent;
    }());
    /**
     * Directive used to connect an input to a MatDatepicker.
     * @template D
     */
    var MatDatepickerInput = /** @class */ (function () {
        function MatDatepickerInput(_elementRef, _dateAdapter, _dateFormats, _formField) {
            var _this = this;
            this._elementRef = _elementRef;
            this._dateAdapter = _dateAdapter;
            this._dateFormats = _dateFormats;
            this._formField = _formField;
            /**
             * Emits when a `change` event is fired on this `<input>`.
             */
            this.dateChange = new core.EventEmitter();
            /**
             * Emits when an `input` event is fired on this `<input>`.
             */
            this.dateInput = new core.EventEmitter();
            /**
             * Emits when the value changes (either due to user input or programmatic change).
             */
            this._valueChange = new core.EventEmitter();
            /**
             * Emits when the disabled state has changed
             */
            this._disabledChange = new core.EventEmitter();
            this._onTouched = function () { };
            this._cvaOnChange = function () { };
            this._validatorOnChange = function () { };
            this._datepickerSubscription = rxjs.Subscription.EMPTY;
            this._localeSubscription = rxjs.Subscription.EMPTY;
            /**
             * The form control validator for whether the input parses.
             */
            this._parseValidator = function () {
                return _this._lastValueValid ?
                    null : { 'matDatepickerParse': { 'text': _this._elementRef.nativeElement.value } };
            };
            /**
             * The form control validator for the min date.
             */
            this._minValidator = function (control) {
                var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                return (!_this.min || !controlValue ||
                    _this._dateAdapter.compareDate(_this.min, controlValue) <= 0) ?
                    null : { 'matDatepickerMin': { 'min': _this.min, 'actual': controlValue } };
            };
            /**
             * The form control validator for the max date.
             */
            this._maxValidator = function (control) {
                var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                return (!_this.max || !controlValue ||
                    _this._dateAdapter.compareDate(_this.max, controlValue) >= 0) ?
                    null : { 'matDatepickerMax': { 'max': _this.max, 'actual': controlValue } };
            };
            /**
             * The form control validator for the date filter.
             */
            this._filterValidator = function (control) {
                var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
                return !_this._dateFilter || !controlValue || _this._dateFilter(controlValue) ?
                    null : { 'matDatepickerFilter': true };
            };
            /**
             * The combined form control validator for this input.
             */
            this._validator = Validators.compose([this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator]);
            /**
             * Whether the last value set on the input was valid.
             */
            this._lastValueValid = false;
            if (!this._dateAdapter) {
                throw createMissingDateImplError('DateAdapter');
            }
            if (!this._dateFormats) {
                throw createMissingDateImplError('MAT_DATE_FORMATS');
            }
            // Update the displayed date when the locale changes.
            this._localeSubscription = _dateAdapter.localeChanges.subscribe(function () {
                _this.value = _this.value;
            });
        }
        Object.defineProperty(MatDatepickerInput.prototype, "matDatepicker", {
            set: /**
             * The datepicker that this input is associated with.
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this.registerDatepicker(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} value
         * @return {?}
         */
        MatDatepickerInput.prototype.registerDatepicker = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._datepicker = value;
                this._datepicker._registerInput(this);
            }
        };
        Object.defineProperty(MatDatepickerInput.prototype, "matDatepickerFilter", {
            set: /**
             * Function that can be used to filter out dates within the datepicker.
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._dateFilter = value;
                this._validatorOnChange();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepickerInput.prototype, "value", {
            get: /**
             * The value of the input.
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                value = this._dateAdapter.deserialize(value);
                this._lastValueValid = !value || this._dateAdapter.isValid(value);
                value = this._getValidDateOrNull(value);
                var /** @type {?} */ oldDate = this.value;
                this._value = value;
                this._formatValue(value);
                if (!this._dateAdapter.sameDate(oldDate, value)) {
                    this._valueChange.emit(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepickerInput.prototype, "min", {
            get: /**
             * The minimum valid date.
             * @return {?}
             */
            function () { return this._min; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._min = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                this._validatorOnChange();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepickerInput.prototype, "max", {
            get: /**
             * The maximum valid date.
             * @return {?}
             */
            function () { return this._max; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._max = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
                this._validatorOnChange();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDatepickerInput.prototype, "disabled", {
            get: /**
             * Whether the datepicker-input is disabled.
             * @return {?}
             */
            function () { return !!this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newValue = coerceBooleanProperty(value);
                var /** @type {?} */ element = this._elementRef.nativeElement;
                if (this._disabled !== newValue) {
                    this._disabled = newValue;
                    this._disabledChange.emit(newValue);
                }
                // We need to null check the `blur` method, because it's undefined during SSR.
                if (newValue && element.blur) {
                    // Normally, native input elements automatically blur if they turn disabled. This behavior
                    // is problematic, because it would mean that it triggers another change detection cycle,
                    // which then causes a changed after checked error if the input element was focused before.
                    element.blur();
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatDatepickerInput.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._datepicker) {
                this._datepickerSubscription = this._datepicker._selectedChanged.subscribe(function (selected) {
                    _this.value = selected;
                    _this._cvaOnChange(selected);
                    _this._onTouched();
                    _this.dateInput.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
                    _this.dateChange.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
                });
            }
        };
        /**
         * @return {?}
         */
        MatDatepickerInput.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._datepickerSubscription.unsubscribe();
            this._localeSubscription.unsubscribe();
            this._valueChange.complete();
            this._disabledChange.complete();
        };
        /** @docs-private */
        /**
         * \@docs-private
         * @param {?} fn
         * @return {?}
         */
        MatDatepickerInput.prototype.registerOnValidatorChange = /**
         * \@docs-private
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._validatorOnChange = fn;
        };
        /** @docs-private */
        /**
         * \@docs-private
         * @param {?} c
         * @return {?}
         */
        MatDatepickerInput.prototype.validate = /**
         * \@docs-private
         * @param {?} c
         * @return {?}
         */
        function (c) {
            return this._validator ? this._validator(c) : null;
        };
        /**
         * @deprecated
         * @deletion-target 7.0.0 Use `getConnectedOverlayOrigin` instead
         */
        /**
         * @deprecated
         * \@deletion-target 7.0.0 Use `getConnectedOverlayOrigin` instead
         * @return {?}
         */
        MatDatepickerInput.prototype.getPopupConnectionElementRef = /**
         * @deprecated
         * \@deletion-target 7.0.0 Use `getConnectedOverlayOrigin` instead
         * @return {?}
         */
        function () {
            return this.getConnectedOverlayOrigin();
        };
        /**
         * Gets the element that the datepicker popup should be connected to.
         * @return The element to connect the popup to.
         */
        /**
         * Gets the element that the datepicker popup should be connected to.
         * @return {?} The element to connect the popup to.
         */
        MatDatepickerInput.prototype.getConnectedOverlayOrigin = /**
         * Gets the element that the datepicker popup should be connected to.
         * @return {?} The element to connect the popup to.
         */
        function () {
            return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} value
         * @return {?}
         */
        MatDatepickerInput.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.value = value;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatDatepickerInput.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._cvaOnChange = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} fn
         * @return {?}
         */
        MatDatepickerInput.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        // Implemented as part of ControlValueAccessor.
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        MatDatepickerInput.prototype.setDisabledState = /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatDatepickerInput.prototype._onKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.altKey && event.keyCode === DOWN_ARROW) {
                this._datepicker.open();
                event.preventDefault();
            }
        };
        /**
         * @param {?} value
         * @return {?}
         */
        MatDatepickerInput.prototype._onInput = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
            this._lastValueValid = !date || this._dateAdapter.isValid(date);
            date = this._getValidDateOrNull(date);
            if (!this._dateAdapter.sameDate(date, this._value)) {
                this._value = date;
                this._cvaOnChange(date);
                this._valueChange.emit(date);
                this.dateInput.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
            }
        };
        /**
         * @return {?}
         */
        MatDatepickerInput.prototype._onChange = /**
         * @return {?}
         */
        function () {
            this.dateChange.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
        };
        /** Returns the palette used by the input's form field, if any. */
        /**
         * Returns the palette used by the input's form field, if any.
         * @return {?}
         */
        MatDatepickerInput.prototype._getThemePalette = /**
         * Returns the palette used by the input's form field, if any.
         * @return {?}
         */
        function () {
            return this._formField ? this._formField.color : undefined;
        };
        /** Handles blur events on the input. */
        /**
         * Handles blur events on the input.
         * @return {?}
         */
        MatDatepickerInput.prototype._onBlur = /**
         * Handles blur events on the input.
         * @return {?}
         */
        function () {
            // Reformat the input only if we have a valid value.
            if (this.value) {
                this._formatValue(this.value);
            }
            this._onTouched();
        };
        /**
         * Formats a value and sets it on the input element.
         * @param {?} value
         * @return {?}
         */
        MatDatepickerInput.prototype._formatValue = /**
         * Formats a value and sets it on the input element.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._elementRef.nativeElement.value =
                value ? this._dateAdapter.format(value, this._dateFormats.display.dateInput) : '';
        };
        /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        MatDatepickerInput.prototype._getValidDateOrNull = /**
         * @param {?} obj The object to check.
         * @return {?} The given object if it is both a date instance and valid, otherwise null.
         */
        function (obj) {
            return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
        };
        MatDatepickerInput.decorators = [
            { type: core.Directive, args: [{
                        selector: 'input[matDatepicker]',
                        providers: [
                            MAT_DATEPICKER_VALUE_ACCESSOR,
                            MAT_DATEPICKER_VALIDATORS,
                            { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MatDatepickerInput },
                        ],
                        host: {
                            '[attr.aria-haspopup]': 'true',
                            '[attr.aria-owns]': '(_datepicker?.opened && _datepicker.id) || null',
                            '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
                            '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
                            '[disabled]': 'disabled',
                            '(input)': '_onInput($event.target.value)',
                            '(change)': '_onChange()',
                            '(blur)': '_onBlur()',
                            '(keydown)': '_onKeydown($event)',
                        },
                        exportAs: 'matDatepickerInput',
                    },] },
        ];
        /** @nocollapse */
        MatDatepickerInput.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: DateAdapter, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_DATE_FORMATS,] },] },
            { type: MatFormField, decorators: [{ type: core.Optional },] },
        ]; };
        MatDatepickerInput.propDecorators = {
            "matDatepicker": [{ type: core.Input },],
            "matDatepickerFilter": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "min": [{ type: core.Input },],
            "max": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "dateChange": [{ type: core.Output },],
            "dateInput": [{ type: core.Output },],
        };
        return MatDatepickerInput;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Can be used to override the icon of a `matDatepickerToggle`.
     */
    var MatDatepickerToggleIcon = /** @class */ (function () {
        function MatDatepickerToggleIcon() {
        }
        MatDatepickerToggleIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matDatepickerToggleIcon]'
                    },] },
        ];
        return MatDatepickerToggleIcon;
    }());
    /**
     * @template D
     */
    var MatDatepickerToggle = /** @class */ (function () {
        function MatDatepickerToggle(_intl, _changeDetectorRef) {
            this._intl = _intl;
            this._changeDetectorRef = _changeDetectorRef;
            this._stateChanges = rxjs.Subscription.EMPTY;
        }
        Object.defineProperty(MatDatepickerToggle.prototype, "disabled", {
            get: /**
             * Whether the toggle button is disabled.
             * @return {?}
             */
            function () {
                return this._disabled === undefined ? this.datepicker.disabled : !!this._disabled;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} changes
         * @return {?}
         */
        MatDatepickerToggle.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            if (changes["datepicker"]) {
                this._watchStateChanges();
            }
        };
        /**
         * @return {?}
         */
        MatDatepickerToggle.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._stateChanges.unsubscribe();
        };
        /**
         * @return {?}
         */
        MatDatepickerToggle.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._watchStateChanges();
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatDatepickerToggle.prototype._open = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.datepicker && !this.disabled) {
                this.datepicker.open();
                event.stopPropagation();
            }
        };
        /**
         * @return {?}
         */
        MatDatepickerToggle.prototype._watchStateChanges = /**
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ datepickerDisabled = this.datepicker ? this.datepicker._disabledChange : rxjs.of();
            var /** @type {?} */ inputDisabled = this.datepicker && this.datepicker._datepickerInput ?
                this.datepicker._datepickerInput._disabledChange : rxjs.of();
            var /** @type {?} */ datepickerToggled = this.datepicker ?
                rxjs.merge(this.datepicker.openedStream, this.datepicker.closedStream) :
                rxjs.of();
            this._stateChanges.unsubscribe();
            this._stateChanges = rxjs.merge(this._intl.changes, datepickerDisabled, inputDisabled, datepickerToggled).subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
        };
        MatDatepickerToggle.decorators = [
            { type: core.Component, args: [{selector: 'mat-datepicker-toggle',
                        template: "<button mat-icon-button type=\"button\" [attr.aria-label]=\"_intl.openCalendarLabel\" [disabled]=\"disabled\" (click)=\"_open($event)\"><svg *ngIf=\"!_customIcon\" class=\"mat-datepicker-toggle-default-icon\" viewBox=\"0 0 24 24\" width=\"24px\" height=\"24px\" fill=\"currentColor\" focusable=\"false\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z\"/></svg><ng-content select=\"[matDatepickerToggleIcon]\"></ng-content></button>",
                        styles: [".mat-form-field-appearance-legacy .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-datepicker-toggle-default-icon{width:1em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-datepicker-toggle-default-icon{display:block;width:1.5em;height:1.5em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-datepicker-toggle-default-icon{margin:auto}"],
                        host: {
                            'class': 'mat-datepicker-toggle',
                            '[class.mat-datepicker-toggle-active]': 'datepicker && datepicker.opened',
                            '[class.mat-accent]': 'datepicker && datepicker.color === "accent"',
                            '[class.mat-warn]': 'datepicker && datepicker.color === "warn"',
                        },
                        exportAs: 'matDatepickerToggle',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatDatepickerToggle.ctorParameters = function () { return [
            { type: MatDatepickerIntl, },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatDatepickerToggle.propDecorators = {
            "datepicker": [{ type: core.Input, args: ['for',] },],
            "disabled": [{ type: core.Input },],
            "_customIcon": [{ type: core.ContentChild, args: [MatDatepickerToggleIcon,] },],
        };
        return MatDatepickerToggle;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatDivider = /** @class */ (function () {
        function MatDivider() {
            this._vertical = false;
            this._inset = false;
        }
        Object.defineProperty(MatDivider.prototype, "vertical", {
            get: /**
             * Whether the divider is vertically aligned.
             * @return {?}
             */
            function () { return this._vertical; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._vertical = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDivider.prototype, "inset", {
            get: /**
             * Whether the divider is an inset divider.
             * @return {?}
             */
            function () { return this._inset; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._inset = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        MatDivider.decorators = [
            { type: core.Component, args: [{selector: 'mat-divider',
                        host: {
                            'role': 'separator',
                            '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                            '[class.mat-divider-vertical]': 'vertical',
                            '[class.mat-divider-inset]': 'inset',
                            'class': 'mat-divider'
                        },
                        template: '',
                        styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatDivider.propDecorators = {
            "vertical": [{ type: core.Input },],
            "inset": [{ type: core.Input },],
        };
        return MatDivider;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to generate unique ID for each accordion.
     */
    var /** @type {?} */ nextId$2 = 0;
    /**
     * Directive whose purpose is to manage the expanded state of CdkAccordionItem children.
     */
    var CdkAccordion = /** @class */ (function () {
        function CdkAccordion() {
            /**
             * Stream that emits true/false when openAll/closeAll is triggered.
             */
            this._openCloseAllActions = new rxjs.Subject();
            /**
             * A readonly id value to use for unique selection coordination.
             */
            this.id = "cdk-accordion-" + nextId$2++;
            this._multi = false;
        }
        Object.defineProperty(CdkAccordion.prototype, "multi", {
            get: /**
             * Whether the accordion should allow multiple expanded accordion items simultaneously.
             * @return {?}
             */
            function () { return this._multi; },
            set: /**
             * @param {?} multi
             * @return {?}
             */
            function (multi) { this._multi = coerceBooleanProperty(multi); },
            enumerable: true,
            configurable: true
        });
        /** Opens all enabled accordion items in an accordion where multi is enabled. */
        /**
         * Opens all enabled accordion items in an accordion where multi is enabled.
         * @return {?}
         */
        CdkAccordion.prototype.openAll = /**
         * Opens all enabled accordion items in an accordion where multi is enabled.
         * @return {?}
         */
        function () {
            this._openCloseAll(true);
        };
        /** Closes all enabled accordion items in an accordion where multi is enabled. */
        /**
         * Closes all enabled accordion items in an accordion where multi is enabled.
         * @return {?}
         */
        CdkAccordion.prototype.closeAll = /**
         * Closes all enabled accordion items in an accordion where multi is enabled.
         * @return {?}
         */
        function () {
            this._openCloseAll(false);
        };
        /**
         * @param {?} expanded
         * @return {?}
         */
        CdkAccordion.prototype._openCloseAll = /**
         * @param {?} expanded
         * @return {?}
         */
        function (expanded) {
            if (this.multi) {
                this._openCloseAllActions.next(expanded);
            }
        };
        CdkAccordion.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-accordion, [cdkAccordion]',
                        exportAs: 'cdkAccordion',
                    },] },
        ];
        /** @nocollapse */
        CdkAccordion.propDecorators = {
            "multi": [{ type: core.Input },],
        };
        return CdkAccordion;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to generate unique ID for each accordion item.
     */
    var /** @type {?} */ nextId$1$1 = 0;
    var ɵ0$4 = undefined;
    /**
     * An basic directive expected to be extended and decorated as a component.  Sets up all
     * events and attributes needed to be managed by a CdkAccordion parent.
     */
    var CdkAccordionItem = /** @class */ (function () {
        function CdkAccordionItem(accordion, _changeDetectorRef, _expansionDispatcher) {
            var _this = this;
            this.accordion = accordion;
            this._changeDetectorRef = _changeDetectorRef;
            this._expansionDispatcher = _expansionDispatcher;
            /**
             * Subscription to openAll/closeAll events.
             */
            this._openCloseAllSubscription = rxjs.Subscription.EMPTY;
            /**
             * Event emitted every time the AccordionItem is closed.
             */
            this.closed = new core.EventEmitter();
            /**
             * Event emitted every time the AccordionItem is opened.
             */
            this.opened = new core.EventEmitter();
            /**
             * Event emitted when the AccordionItem is destroyed.
             */
            this.destroyed = new core.EventEmitter();
            /**
             * Emits whenever the expanded state of the accordion changes.
             * Primarily used to facilitate two-way binding.
             * \@docs-private
             */
            this.expandedChange = new core.EventEmitter();
            /**
             * The unique AccordionItem id.
             */
            this.id = "cdk-accordion-child-" + nextId$1$1++;
            this._expanded = false;
            this._disabled = false;
            /**
             * Unregister function for _expansionDispatcher.
             */
            this._removeUniqueSelectionListener = function () { };
            this._removeUniqueSelectionListener =
                _expansionDispatcher.listen(function (id, accordionId) {
                    if (_this.accordion && !_this.accordion.multi &&
                        _this.accordion.id === accordionId && _this.id !== id) {
                        _this.expanded = false;
                    }
                });
            // When an accordion item is hosted in an accordion, subscribe to open/close events.
            if (this.accordion) {
                this._openCloseAllSubscription = this._subscribeToOpenCloseAllActions();
            }
        }
        Object.defineProperty(CdkAccordionItem.prototype, "expanded", {
            get: /**
             * Whether the AccordionItem is expanded.
             * @return {?}
             */
            function () { return this._expanded; },
            set: /**
             * @param {?} expanded
             * @return {?}
             */
            function (expanded) {
                expanded = coerceBooleanProperty(expanded);
                // Only emit events and update the internal value if the value changes.
                if (this._expanded !== expanded) {
                    this._expanded = expanded;
                    this.expandedChange.emit(expanded);
                    if (expanded) {
                        this.opened.emit();
                        /**
                         * In the unique selection dispatcher, the id parameter is the id of the CdkAccordionItem,
                         * the name value is the id of the accordion.
                         */
                        var /** @type {?} */ accordionId = this.accordion ? this.accordion.id : this.id;
                        this._expansionDispatcher.notify(this.id, accordionId);
                    }
                    else {
                        this.closed.emit();
                    }
                    // Ensures that the animation will run when the value is set outside of an `@Input`.
                    // This includes cases like the open, close and toggle methods.
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkAccordionItem.prototype, "disabled", {
            get: /**
             * Whether the AccordionItem is disabled.
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} disabled
             * @return {?}
             */
            function (disabled) { this._disabled = coerceBooleanProperty(disabled); },
            enumerable: true,
            configurable: true
        });
        /** Emits an event for the accordion item being destroyed. */
        /**
         * Emits an event for the accordion item being destroyed.
         * @return {?}
         */
        CdkAccordionItem.prototype.ngOnDestroy = /**
         * Emits an event for the accordion item being destroyed.
         * @return {?}
         */
        function () {
            this.opened.complete();
            this.closed.complete();
            this.destroyed.emit();
            this.destroyed.complete();
            this._removeUniqueSelectionListener();
            this._openCloseAllSubscription.unsubscribe();
        };
        /** Toggles the expanded state of the accordion item. */
        /**
         * Toggles the expanded state of the accordion item.
         * @return {?}
         */
        CdkAccordionItem.prototype.toggle = /**
         * Toggles the expanded state of the accordion item.
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this.expanded = !this.expanded;
            }
        };
        /** Sets the expanded state of the accordion item to false. */
        /**
         * Sets the expanded state of the accordion item to false.
         * @return {?}
         */
        CdkAccordionItem.prototype.close = /**
         * Sets the expanded state of the accordion item to false.
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this.expanded = false;
            }
        };
        /** Sets the expanded state of the accordion item to true. */
        /**
         * Sets the expanded state of the accordion item to true.
         * @return {?}
         */
        CdkAccordionItem.prototype.open = /**
         * Sets the expanded state of the accordion item to true.
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this.expanded = true;
            }
        };
        /**
         * @return {?}
         */
        CdkAccordionItem.prototype._subscribeToOpenCloseAllActions = /**
         * @return {?}
         */
        function () {
            var _this = this;
            return this.accordion._openCloseAllActions.subscribe(function (expanded) {
                // Only change expanded state if item is enabled
                if (!_this.disabled) {
                    _this.expanded = expanded;
                }
            });
        };
        CdkAccordionItem.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-accordion-item, [cdkAccordionItem]',
                        exportAs: 'cdkAccordionItem',
                        providers: [
                            // Provide CdkAccordion as undefined to prevent nested accordion items from registering
                            // to the same accordion.
                            { provide: CdkAccordion, useValue: ɵ0$4 },
                        ],
                    },] },
        ];
        /** @nocollapse */
        CdkAccordionItem.ctorParameters = function () { return [
            { type: CdkAccordion, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
            { type: core.ChangeDetectorRef, },
            { type: UniqueSelectionDispatcher, },
        ]; };
        CdkAccordionItem.propDecorators = {
            "closed": [{ type: core.Output },],
            "opened": [{ type: core.Output },],
            "destroyed": [{ type: core.Output },],
            "expandedChange": [{ type: core.Output },],
            "expanded": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
        };
        return CdkAccordionItem;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Directive for a Material Design Accordion.
     */
    var MatAccordion = /** @class */ (function (_super) {
        __extends(MatAccordion, _super);
        function MatAccordion() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._hideToggle = false;
            /**
             * The display mode used for all expansion panels in the accordion. Currently two display
             * modes exist:
             *  default - a gutter-like spacing is placed around any expanded panel, placing the expanded
             *     panel at a different elevation from the reset of the accordion.
             *  flat - no spacing is placed around expanded panels, showing all panels at the same
             *     elevation.
             */
            _this.displayMode = 'default';
            return _this;
        }
        Object.defineProperty(MatAccordion.prototype, "hideToggle", {
            get: /**
             * Whether the expansion indicator should be hidden.
             * @return {?}
             */
            function () { return this._hideToggle; },
            set: /**
             * @param {?} show
             * @return {?}
             */
            function (show) { this._hideToggle = coerceBooleanProperty(show); },
            enumerable: true,
            configurable: true
        });
        MatAccordion.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-accordion',
                        exportAs: 'matAccordion',
                        host: {
                            class: 'mat-accordion'
                        }
                    },] },
        ];
        /** @nocollapse */
        MatAccordion.propDecorators = {
            "hideToggle": [{ type: core.Input },],
            "displayMode": [{ type: core.Input },],
        };
        return MatAccordion;
    }(CdkAccordion));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Time and timing curve for expansion panel animations.
     */
    var /** @type {?} */ EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
    /**
     * Animations used by the Material expansion panel.
     */
    var /** @type {?} */ matExpansionAnimations = {
        /** Animation that rotates the indicator arrow. */
        indicatorRotate: trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
        ]),
        /** Animation that expands and collapses the panel header height. */
        expansionHeaderHeight: trigger('expansionHeight', [
            state('collapsed', style({
                height: '{{collapsedHeight}}',
            }), {
                params: { collapsedHeight: '48px' },
            }),
            state('expanded', style({
                height: '{{expandedHeight}}'
            }), {
                params: { expandedHeight: '64px' }
            }),
            transition('expanded <=> collapsed', group([
                query('@indicatorRotate', animateChild(), { optional: true }),
                animate(EXPANSION_PANEL_ANIMATION_TIMING),
            ])),
        ]),
        /** Animation that expands and collapses the panel content. */
        bodyExpansion: trigger('bodyExpansion', [
            state('collapsed', style({ height: '0px', visibility: 'hidden' })),
            state('expanded', style({ height: '*', visibility: 'visible' })),
            transition('expanded <=> collapsed', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Expansion panel content that will be rendered lazily
     * after the panel is opened for the first time.
     */
    var MatExpansionPanelContent = /** @class */ (function () {
        function MatExpansionPanelContent(_template) {
            this._template = _template;
        }
        MatExpansionPanelContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'ng-template[matExpansionPanelContent]'
                    },] },
        ];
        /** @nocollapse */
        MatExpansionPanelContent.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatExpansionPanelContent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Counter for generating unique element ids.
     */
    var /** @type {?} */ uniqueId$1 = 0;
    var ɵ0$5 = undefined;
    /**
     * `<mat-expansion-panel>`
     *
     * This component can be used as a single element to show expandable content, or as one of
     * multiple children of an element with the MatAccordion directive attached.
     */
    var MatExpansionPanel = /** @class */ (function (_super) {
        __extends(MatExpansionPanel, _super);
        function MatExpansionPanel(accordion, _changeDetectorRef, _uniqueSelectionDispatcher, _viewContainerRef) {
            var _this = _super.call(this, accordion, _changeDetectorRef, _uniqueSelectionDispatcher) || this;
            _this._viewContainerRef = _viewContainerRef;
            _this._hideToggle = false;
            /**
             * Stream that emits for changes in `\@Input` properties.
             */
            _this._inputChanges = new rxjs.Subject();
            /**
             * ID for the associated header element. Used for a11y labelling.
             */
            _this._headerId = "mat-expansion-panel-header-" + uniqueId$1++;
            _this.accordion = accordion;
            return _this;
        }
        Object.defineProperty(MatExpansionPanel.prototype, "hideToggle", {
            get: /**
             * Whether the toggle indicator should be hidden.
             * @return {?}
             */
            function () { return this._hideToggle; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._hideToggle = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /** Whether the expansion indicator should be hidden. */
        /**
         * Whether the expansion indicator should be hidden.
         * @return {?}
         */
        MatExpansionPanel.prototype._getHideToggle = /**
         * Whether the expansion indicator should be hidden.
         * @return {?}
         */
        function () {
            if (this.accordion) {
                return this.accordion.hideToggle;
            }
            return this.hideToggle;
        };
        /** Determines whether the expansion panel should have spacing between it and its siblings. */
        /**
         * Determines whether the expansion panel should have spacing between it and its siblings.
         * @return {?}
         */
        MatExpansionPanel.prototype._hasSpacing = /**
         * Determines whether the expansion panel should have spacing between it and its siblings.
         * @return {?}
         */
        function () {
            if (this.accordion) {
                return (this.expanded ? this.accordion.displayMode : this._getExpandedState()) === 'default';
            }
            return false;
        };
        /** Gets the expanded state string. */
        /**
         * Gets the expanded state string.
         * @return {?}
         */
        MatExpansionPanel.prototype._getExpandedState = /**
         * Gets the expanded state string.
         * @return {?}
         */
        function () {
            return this.expanded ? 'expanded' : 'collapsed';
        };
        /**
         * @return {?}
         */
        MatExpansionPanel.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._lazyContent) {
                // Render the content as soon as the panel becomes open.
                this.opened.pipe(operators.startWith(/** @type {?} */ ((null))), operators.filter(function () { return _this.expanded && !_this._portal; }), operators.take(1)).subscribe(function () {
                    _this._portal = new TemplatePortal(_this._lazyContent._template, _this._viewContainerRef);
                });
            }
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        MatExpansionPanel.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            this._inputChanges.next(changes);
        };
        /**
         * @return {?}
         */
        MatExpansionPanel.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            _super.prototype.ngOnDestroy.call(this);
            this._inputChanges.complete();
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatExpansionPanel.prototype._bodyAnimation = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ classList = event.element.classList;
            var /** @type {?} */ cssClass = 'mat-expanded';
            var phaseName = event.phaseName, toState = event.toState;
            // Toggle the body's `overflow: hidden` class when closing starts or when expansion ends in
            // order to prevent the cases where switching too early would cause the animation to jump.
            // Note that we do it directly on the DOM element to avoid the slight delay that comes
            // with doing it via change detection.
            if (phaseName === 'done' && toState === 'expanded') {
                classList.add(cssClass);
            }
            else if (phaseName === 'start' && toState === 'collapsed') {
                classList.remove(cssClass);
            }
        };
        MatExpansionPanel.decorators = [
            { type: core.Component, args: [{styles: [".mat-expansion-panel{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);box-sizing:content-box;display:block;margin:0;transition:margin 225ms cubic-bezier(.4,0,.2,1)}.mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-expansion-panel{outline:solid 1px}}.mat-expansion-panel-content{overflow:hidden}.mat-expansion-panel-content.mat-expanded{overflow:visible}.mat-expansion-panel-body{padding:0 24px 16px}.mat-expansion-panel-spacing{margin:16px 0}.mat-accordion>.mat-expansion-panel-spacing:first-child,.mat-accordion>:first-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-top:0}.mat-accordion>.mat-expansion-panel-spacing:last-child,.mat-accordion>:last-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-bottom:0}.mat-action-row{border-top-style:solid;border-top-width:1px;display:flex;flex-direction:row;justify-content:flex-end;padding:16px 8px 16px 24px}.mat-action-row button.mat-button{margin-left:8px}[dir=rtl] .mat-action-row button.mat-button{margin-left:0;margin-right:8px}"],
                        selector: 'mat-expansion-panel',
                        exportAs: 'matExpansionPanel',
                        template: "<ng-content select=\"mat-expansion-panel-header\"></ng-content><div class=\"mat-expansion-panel-content\" role=\"region\" [@bodyExpansion]=\"_getExpandedState()\" (@bodyExpansion.done)=\"_bodyAnimation($event)\" (@bodyExpansion.start)=\"_bodyAnimation($event)\" [attr.aria-labelledby]=\"_headerId\" [id]=\"id\" #body><div class=\"mat-expansion-panel-body\"><ng-content></ng-content><ng-template [cdkPortalOutlet]=\"_portal\"></ng-template></div><ng-content select=\"mat-action-row\"></ng-content></div>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['disabled', 'expanded'],
                        outputs: ['opened', 'closed', 'expandedChange'],
                        animations: [matExpansionAnimations.bodyExpansion],
                        providers: [
                            // Provide MatAccordion as undefined to prevent nested expansion panels from registering
                            // to the same accordion.
                            { provide: MatAccordion, useValue: ɵ0$5 },
                        ],
                        host: {
                            'class': 'mat-expansion-panel',
                            '[class.mat-expanded]': 'expanded',
                            '[class.mat-expansion-panel-spacing]': '_hasSpacing()',
                        }
                    },] },
        ];
        /** @nocollapse */
        MatExpansionPanel.ctorParameters = function () { return [
            { type: MatAccordion, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
            { type: core.ChangeDetectorRef, },
            { type: UniqueSelectionDispatcher, },
            { type: core.ViewContainerRef, },
        ]; };
        MatExpansionPanel.propDecorators = {
            "hideToggle": [{ type: core.Input },],
            "_lazyContent": [{ type: core.ContentChild, args: [MatExpansionPanelContent,] },],
        };
        return MatExpansionPanel;
    }(CdkAccordionItem));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * `<mat-expansion-panel-header>`
     *
     * This component corresponds to the header element of an `<mat-expansion-panel>`.
     */
    var MatExpansionPanelHeader = /** @class */ (function () {
        function MatExpansionPanelHeader(panel, _element, _focusMonitor, _changeDetectorRef) {
            var _this = this;
            this.panel = panel;
            this._element = _element;
            this._focusMonitor = _focusMonitor;
            this._changeDetectorRef = _changeDetectorRef;
            this._parentChangeSubscription = rxjs.Subscription.EMPTY;
            // Since the toggle state depends on an @Input on the panel, we
            // need to  subscribe and trigger change detection manually.
            this._parentChangeSubscription = rxjs.merge(panel.opened, panel.closed, panel._inputChanges.pipe(operators.filter(function (changes) { return !!(changes["hideToggle"] || changes["disabled"]); })))
                .subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
            _focusMonitor.monitor(_element.nativeElement);
        }
        /** Toggles the expanded state of the panel. */
        /**
         * Toggles the expanded state of the panel.
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._toggle = /**
         * Toggles the expanded state of the panel.
         * @return {?}
         */
        function () {
            this.panel.toggle();
        };
        /** Gets whether the panel is expanded. */
        /**
         * Gets whether the panel is expanded.
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._isExpanded = /**
         * Gets whether the panel is expanded.
         * @return {?}
         */
        function () {
            return this.panel.expanded;
        };
        /** Gets the expanded state string of the panel. */
        /**
         * Gets the expanded state string of the panel.
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._getExpandedState = /**
         * Gets the expanded state string of the panel.
         * @return {?}
         */
        function () {
            return this.panel._getExpandedState();
        };
        /** Gets the panel id. */
        /**
         * Gets the panel id.
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._getPanelId = /**
         * Gets the panel id.
         * @return {?}
         */
        function () {
            return this.panel.id;
        };
        /** Gets whether the expand indicator should be shown. */
        /**
         * Gets whether the expand indicator should be shown.
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._showToggle = /**
         * Gets whether the expand indicator should be shown.
         * @return {?}
         */
        function () {
            return !this.panel.hideToggle && !this.panel.disabled;
        };
        /** Handle keydown event calling to toggle() if appropriate. */
        /**
         * Handle keydown event calling to toggle() if appropriate.
         * @param {?} event
         * @return {?}
         */
        MatExpansionPanelHeader.prototype._keydown = /**
         * Handle keydown event calling to toggle() if appropriate.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            switch (event.keyCode) {
                // Toggle for space and enter keys.
                case SPACE:
                case ENTER:
                    event.preventDefault();
                    this._toggle();
                    break;
                default:
                    return;
            }
        };
        /**
         * @return {?}
         */
        MatExpansionPanelHeader.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._parentChangeSubscription.unsubscribe();
            this._focusMonitor.stopMonitoring(this._element.nativeElement);
        };
        MatExpansionPanelHeader.decorators = [
            { type: core.Component, args: [{selector: 'mat-expansion-panel-header',
                        styles: [".mat-expansion-panel-header{display:flex;flex-direction:row;align-items:center;padding:0 24px}.mat-expansion-panel-header:focus,.mat-expansion-panel-header:hover{outline:0}.mat-expansion-panel-header.mat-expanded:focus,.mat-expansion-panel-header.mat-expanded:hover{background:inherit}.mat-expansion-panel-header:not([aria-disabled=true]){cursor:pointer}.mat-content{display:flex;flex:1;flex-direction:row;overflow:hidden}.mat-expansion-panel-header-description,.mat-expansion-panel-header-title{display:flex;flex-grow:1;margin-right:16px}[dir=rtl] .mat-expansion-panel-header-description,[dir=rtl] .mat-expansion-panel-header-title{margin-right:0;margin-left:16px}.mat-expansion-panel-header-description{flex-grow:2}.mat-expansion-indicator::after{border-style:solid;border-width:0 2px 2px 0;content:'';display:inline-block;padding:3px;transform:rotate(45deg);vertical-align:middle}"],
                        template: "<span class=\"mat-content\"><ng-content select=\"mat-panel-title\"></ng-content><ng-content select=\"mat-panel-description\"></ng-content><ng-content></ng-content></span><span [@indicatorRotate]=\"_getExpandedState()\" *ngIf=\"_showToggle()\" class=\"mat-expansion-indicator\"></span>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        animations: [
                            matExpansionAnimations.indicatorRotate,
                            matExpansionAnimations.expansionHeaderHeight
                        ],
                        host: {
                            'class': 'mat-expansion-panel-header',
                            'role': 'button',
                            '[attr.id]': 'panel._headerId',
                            '[attr.tabindex]': 'panel.disabled ? -1 : 0',
                            '[attr.aria-controls]': '_getPanelId()',
                            '[attr.aria-expanded]': '_isExpanded()',
                            '[attr.aria-disabled]': 'panel.disabled',
                            '[class.mat-expanded]': '_isExpanded()',
                            '(click)': '_toggle()',
                            '(keydown)': '_keydown($event)',
                            '[@expansionHeight]': "{\n        value: _getExpandedState(),\n        params: {\n          collapsedHeight: collapsedHeight,\n          expandedHeight: expandedHeight\n        }\n    }",
                        },
                    },] },
        ];
        /** @nocollapse */
        MatExpansionPanelHeader.ctorParameters = function () { return [
            { type: MatExpansionPanel, decorators: [{ type: core.Host },] },
            { type: core.ElementRef, },
            { type: FocusMonitor, },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatExpansionPanelHeader.propDecorators = {
            "expandedHeight": [{ type: core.Input },],
            "collapsedHeight": [{ type: core.Input },],
        };
        return MatExpansionPanelHeader;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Converts values into strings. Falsy values become empty strings.
     * \@docs-private
     * @param {?} value
     * @return {?}
     */
    function coerceToString(value) {
        return "" + (value || '');
    }
    /**
     * Converts a value that might be a string into a number.
     * \@docs-private
     * @param {?} value
     * @return {?}
     */
    function coerceToNumber(value) {
        return typeof value === 'string' ? parseInt(value, 10) : value;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatGridTile = /** @class */ (function () {
        function MatGridTile(_element) {
            this._element = _element;
            this._rowspan = 1;
            this._colspan = 1;
        }
        Object.defineProperty(MatGridTile.prototype, "rowspan", {
            get: /**
             * Amount of rows that the grid tile takes up.
             * @return {?}
             */
            function () { return this._rowspan; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._rowspan = coerceToNumber(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatGridTile.prototype, "colspan", {
            get: /**
             * Amount of columns that the grid tile takes up.
             * @return {?}
             */
            function () { return this._colspan; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._colspan = coerceToNumber(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets the style of the grid-tile element.  Needs to be set manually to avoid
         * "Changed after checked" errors that would occur with HostBinding.
         */
        /**
         * Sets the style of the grid-tile element.  Needs to be set manually to avoid
         * "Changed after checked" errors that would occur with HostBinding.
         * @param {?} property
         * @param {?} value
         * @return {?}
         */
        MatGridTile.prototype._setStyle = /**
         * Sets the style of the grid-tile element.  Needs to be set manually to avoid
         * "Changed after checked" errors that would occur with HostBinding.
         * @param {?} property
         * @param {?} value
         * @return {?}
         */
        function (property, value) {
            this._element.nativeElement.style[property] = value;
        };
        MatGridTile.decorators = [
            { type: core.Component, args: [{selector: 'mat-grid-tile',
                        exportAs: 'matGridTile',
                        host: {
                            'class': 'mat-grid-tile',
                        },
                        template: "<figure class=\"mat-figure\"><ng-content></ng-content></figure>",
                        styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatGridTile.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        MatGridTile.propDecorators = {
            "rowspan": [{ type: core.Input },],
            "colspan": [{ type: core.Input },],
        };
        return MatGridTile;
    }());
    var MatGridTileText = /** @class */ (function () {
        function MatGridTileText(_element) {
            this._element = _element;
        }
        /**
         * @return {?}
         */
        MatGridTileText.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._lineSetter = new MatLineSetter(this._lines, this._element);
        };
        MatGridTileText.decorators = [
            { type: core.Component, args: [{selector: 'mat-grid-tile-header, mat-grid-tile-footer',
                        template: "<ng-content select=\"[mat-grid-avatar], [matGridAvatar]\"></ng-content><div class=\"mat-grid-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatGridTileText.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        MatGridTileText.propDecorators = {
            "_lines": [{ type: core.ContentChildren, args: [MatLine,] },],
        };
        return MatGridTileText;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Class for determining, from a list of tiles, the (row, col) position of each of those tiles
     * in the grid. This is necessary (rather than just rendering the tiles in normal document flow)
     * because the tiles can have a rowspan.
     *
     * The positioning algorithm greedily places each tile as soon as it encounters a gap in the grid
     * large enough to accommodate it so that the tiles still render in the same order in which they
     * are given.
     *
     * The basis of the algorithm is the use of an array to track the already placed tiles. Each
     * element of the array corresponds to a column, and the value indicates how many cells in that
     * column are already occupied; zero indicates an empty cell. Moving "down" to the next row
     * decrements each value in the tracking array (indicating that the column is one cell closer to
     * being free).
     *
     * \@docs-private
     */
    var /**
     * Class for determining, from a list of tiles, the (row, col) position of each of those tiles
     * in the grid. This is necessary (rather than just rendering the tiles in normal document flow)
     * because the tiles can have a rowspan.
     *
     * The positioning algorithm greedily places each tile as soon as it encounters a gap in the grid
     * large enough to accommodate it so that the tiles still render in the same order in which they
     * are given.
     *
     * The basis of the algorithm is the use of an array to track the already placed tiles. Each
     * element of the array corresponds to a column, and the value indicates how many cells in that
     * column are already occupied; zero indicates an empty cell. Moving "down" to the next row
     * decrements each value in the tracking array (indicating that the column is one cell closer to
     * being free).
     *
     * \@docs-private
     */
    TileCoordinator = /** @class */ (function () {
        function TileCoordinator(numColumns, tiles) {
            var _this = this;
            /**
             * Index at which the search for the next gap will start.
             */
            this.columnIndex = 0;
            /**
             * The current row index.
             */
            this.rowIndex = 0;
            this.tracker = new Array(numColumns);
            this.tracker.fill(0, 0, this.tracker.length);
            this.positions = tiles.map(function (tile) { return _this._trackTile(tile); });
        }
        Object.defineProperty(TileCoordinator.prototype, "rowCount", {
            /** Gets the total number of rows occupied by tiles */
            get: /**
             * Gets the total number of rows occupied by tiles
             * @return {?}
             */
            function () { return this.rowIndex + 1; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TileCoordinator.prototype, "rowspan", {
            /**
             * Gets the total span of rows occupied by tiles.
             * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
             */
            get: /**
             * Gets the total span of rows occupied by tiles.
             * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
             * @return {?}
             */
            function () {
                var /** @type {?} */ lastRowMax = Math.max.apply(Math, this.tracker);
                // if any of the tiles has a rowspan that pushes it beyond the total row count,
                // add the difference to the rowcount
                return lastRowMax > 1 ? this.rowCount + lastRowMax - 1 : this.rowCount;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Calculates the row and col position of a tile.
         * @param {?} tile
         * @return {?}
         */
        TileCoordinator.prototype._trackTile = /**
         * Calculates the row and col position of a tile.
         * @param {?} tile
         * @return {?}
         */
        function (tile) {
            // Find a gap large enough for this tile.
            var /** @type {?} */ gapStartIndex = this._findMatchingGap(tile.colspan);
            // Place tile in the resulting gap.
            this._markTilePosition(gapStartIndex, tile);
            // The next time we look for a gap, the search will start at columnIndex, which should be
            // immediately after the tile that has just been placed.
            this.columnIndex = gapStartIndex + tile.colspan;
            return new TilePosition(this.rowIndex, gapStartIndex);
        };
        /**
         * Finds the next available space large enough to fit the tile.
         * @param {?} tileCols
         * @return {?}
         */
        TileCoordinator.prototype._findMatchingGap = /**
         * Finds the next available space large enough to fit the tile.
         * @param {?} tileCols
         * @return {?}
         */
        function (tileCols) {
            if (tileCols > this.tracker.length) {
                throw Error("mat-grid-list: tile with colspan " + tileCols + " is wider than " +
                    ("grid with cols=\"" + this.tracker.length + "\"."));
            }
            // Start index is inclusive, end index is exclusive.
            var /** @type {?} */ gapStartIndex = -1;
            var /** @type {?} */ gapEndIndex = -1;
            // Look for a gap large enough to fit the given tile. Empty spaces are marked with a zero.
            do {
                // If we've reached the end of the row, go to the next row.
                if (this.columnIndex + tileCols > this.tracker.length) {
                    this._nextRow();
                    continue;
                }
                gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
                // If there are no more empty spaces in this row at all, move on to the next row.
                if (gapStartIndex == -1) {
                    this._nextRow();
                    continue;
                }
                gapEndIndex = this._findGapEndIndex(gapStartIndex);
                // If a gap large enough isn't found, we want to start looking immediately after the current
                // gap on the next iteration.
                this.columnIndex = gapStartIndex + 1;
                // Continue iterating until we find a gap wide enough for this tile.
            } while (gapEndIndex - gapStartIndex < tileCols);
            // If we still didn't manage to find a gap, ensure that the index is
            // at least zero so the tile doesn't get pulled out of the grid.
            return Math.max(gapStartIndex, 0);
        };
        /**
         * Move "down" to the next row.
         * @return {?}
         */
        TileCoordinator.prototype._nextRow = /**
         * Move "down" to the next row.
         * @return {?}
         */
        function () {
            this.columnIndex = 0;
            this.rowIndex++;
            // Decrement all spaces by one to reflect moving down one row.
            for (var /** @type {?} */ i = 0; i < this.tracker.length; i++) {
                this.tracker[i] = Math.max(0, this.tracker[i] - 1);
            }
        };
        /**
         * Finds the end index (exclusive) of a gap given the index from which to start looking.
         * The gap ends when a non-zero value is found.
         * @param {?} gapStartIndex
         * @return {?}
         */
        TileCoordinator.prototype._findGapEndIndex = /**
         * Finds the end index (exclusive) of a gap given the index from which to start looking.
         * The gap ends when a non-zero value is found.
         * @param {?} gapStartIndex
         * @return {?}
         */
        function (gapStartIndex) {
            for (var /** @type {?} */ i = gapStartIndex + 1; i < this.tracker.length; i++) {
                if (this.tracker[i] != 0) {
                    return i;
                }
            }
            // The gap ends with the end of the row.
            return this.tracker.length;
        };
        /**
         * Update the tile tracker to account for the given tile in the given space.
         * @param {?} start
         * @param {?} tile
         * @return {?}
         */
        TileCoordinator.prototype._markTilePosition = /**
         * Update the tile tracker to account for the given tile in the given space.
         * @param {?} start
         * @param {?} tile
         * @return {?}
         */
        function (start, tile) {
            for (var /** @type {?} */ i = 0; i < tile.colspan; i++) {
                this.tracker[start + i] = tile.rowspan;
            }
        };
        return TileCoordinator;
    }());
    /**
     * Simple data structure for tile position (row, col).
     * \@docs-private
     */
    var /**
     * Simple data structure for tile position (row, col).
     * \@docs-private
     */
    TilePosition = /** @class */ (function () {
        function TilePosition(row, col) {
            this.row = row;
            this.col = col;
        }
        return TilePosition;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Sets the style properties for an individual tile, given the position calculated by the
     * Tile Coordinator.
     * \@docs-private
     * @abstract
     */
    var /**
     * Sets the style properties for an individual tile, given the position calculated by the
     * Tile Coordinator.
     * \@docs-private
     * @abstract
     */
    TileStyler = /** @class */ (function () {
        function TileStyler() {
            this._rows = 0;
            this._rowspan = 0;
        }
        /**
         * Adds grid-list layout info once it is available. Cannot be processed in the constructor
         * because these properties haven't been calculated by that point.
         *
         * @param gutterSize Size of the grid's gutter.
         * @param tracker Instance of the TileCoordinator.
         * @param cols Amount of columns in the grid.
         * @param direction Layout direction of the grid.
         */
        /**
         * Adds grid-list layout info once it is available. Cannot be processed in the constructor
         * because these properties haven't been calculated by that point.
         *
         * @param {?} gutterSize Size of the grid's gutter.
         * @param {?} tracker Instance of the TileCoordinator.
         * @param {?} cols Amount of columns in the grid.
         * @param {?} direction Layout direction of the grid.
         * @return {?}
         */
        TileStyler.prototype.init = /**
         * Adds grid-list layout info once it is available. Cannot be processed in the constructor
         * because these properties haven't been calculated by that point.
         *
         * @param {?} gutterSize Size of the grid's gutter.
         * @param {?} tracker Instance of the TileCoordinator.
         * @param {?} cols Amount of columns in the grid.
         * @param {?} direction Layout direction of the grid.
         * @return {?}
         */
        function (gutterSize, tracker, cols, direction) {
            this._gutterSize = normalizeUnits(gutterSize);
            this._rows = tracker.rowCount;
            this._rowspan = tracker.rowspan;
            this._cols = cols;
            this._direction = direction;
        };
        /**
         * Computes the amount of space a single 1x1 tile would take up (width or height).
         * Used as a basis for other calculations.
         * @param sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
         * @param gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
         * @return The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
         */
        /**
         * Computes the amount of space a single 1x1 tile would take up (width or height).
         * Used as a basis for other calculations.
         * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
         * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
         * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
         */
        TileStyler.prototype.getBaseTileSize = /**
         * Computes the amount of space a single 1x1 tile would take up (width or height).
         * Used as a basis for other calculations.
         * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
         * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
         * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
         */
        function (sizePercent, gutterFraction) {
            // Take the base size percent (as would be if evenly dividing the size between cells),
            // and then subtracting the size of one gutter. However, since there are no gutters on the
            // edges, each tile only uses a fraction (gutterShare = numGutters / numCells) of the gutter
            // size. (Imagine having one gutter per tile, and then breaking up the extra gutter on the
            // edge evenly among the cells).
            return "(" + sizePercent + "% - (" + this._gutterSize + " * " + gutterFraction + "))";
        };
        /**
         * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
         * @param offset Number of tiles that have already been rendered in the row/column.
         * @param baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @return Position of the tile as a CSS calc() expression.
         */
        /**
         * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
         * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @param {?} offset Number of tiles that have already been rendered in the row/column.
         * @return {?} Position of the tile as a CSS calc() expression.
         */
        TileStyler.prototype.getTilePosition = /**
         * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
         * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @param {?} offset Number of tiles that have already been rendered in the row/column.
         * @return {?} Position of the tile as a CSS calc() expression.
         */
        function (baseSize, offset) {
            // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
            // row/column (offset).
            return offset === 0 ? '0' : calc("(" + baseSize + " + " + this._gutterSize + ") * " + offset);
        };
        /**
         * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
         * @param baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @param span The tile's rowspan or colspan.
         * @return Size of the tile as a CSS calc() expression.
         */
        /**
         * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
         * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @param {?} span The tile's rowspan or colspan.
         * @return {?} Size of the tile as a CSS calc() expression.
         */
        TileStyler.prototype.getTileSize = /**
         * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
         * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
         * @param {?} span The tile's rowspan or colspan.
         * @return {?} Size of the tile as a CSS calc() expression.
         */
        function (baseSize, span) {
            return "(" + baseSize + " * " + span + ") + (" + (span - 1) + " * " + this._gutterSize + ")";
        };
        /**
         * Sets the style properties to be applied to a tile for the given row and column index.
         * @param tile Tile to which to apply the styling.
         * @param rowIndex Index of the tile's row.
         * @param colIndex Index of the tile's column.
         */
        /**
         * Sets the style properties to be applied to a tile for the given row and column index.
         * @param {?} tile Tile to which to apply the styling.
         * @param {?} rowIndex Index of the tile's row.
         * @param {?} colIndex Index of the tile's column.
         * @return {?}
         */
        TileStyler.prototype.setStyle = /**
         * Sets the style properties to be applied to a tile for the given row and column index.
         * @param {?} tile Tile to which to apply the styling.
         * @param {?} rowIndex Index of the tile's row.
         * @param {?} colIndex Index of the tile's column.
         * @return {?}
         */
        function (tile, rowIndex, colIndex) {
            // Percent of the available horizontal space that one column takes up.
            var /** @type {?} */ percentWidthPerTile = 100 / this._cols;
            // Fraction of the vertical gutter size that each column takes up.
            // For example, if there are 5 columns, each column uses 4/5 = 0.8 times the gutter width.
            var /** @type {?} */ gutterWidthFractionPerTile = (this._cols - 1) / this._cols;
            this.setColStyles(tile, colIndex, percentWidthPerTile, gutterWidthFractionPerTile);
            this.setRowStyles(tile, rowIndex, percentWidthPerTile, gutterWidthFractionPerTile);
        };
        /** Sets the horizontal placement of the tile in the list. */
        /**
         * Sets the horizontal placement of the tile in the list.
         * @param {?} tile
         * @param {?} colIndex
         * @param {?} percentWidth
         * @param {?} gutterWidth
         * @return {?}
         */
        TileStyler.prototype.setColStyles = /**
         * Sets the horizontal placement of the tile in the list.
         * @param {?} tile
         * @param {?} colIndex
         * @param {?} percentWidth
         * @param {?} gutterWidth
         * @return {?}
         */
        function (tile, colIndex, percentWidth, gutterWidth) {
            // Base horizontal size of a column.
            var /** @type {?} */ baseTileWidth = this.getBaseTileSize(percentWidth, gutterWidth);
            // The width and horizontal position of each tile is always calculated the same way, but the
            // height and vertical position depends on the rowMode.
            var /** @type {?} */ side = this._direction === 'rtl' ? 'right' : 'left';
            tile._setStyle(side, this.getTilePosition(baseTileWidth, colIndex));
            tile._setStyle('width', calc(this.getTileSize(baseTileWidth, tile.colspan)));
        };
        /**
         * Calculates the total size taken up by gutters across one axis of a list.
         */
        /**
         * Calculates the total size taken up by gutters across one axis of a list.
         * @return {?}
         */
        TileStyler.prototype.getGutterSpan = /**
         * Calculates the total size taken up by gutters across one axis of a list.
         * @return {?}
         */
        function () {
            return this._gutterSize + " * (" + this._rowspan + " - 1)";
        };
        /**
         * Calculates the total size taken up by tiles across one axis of a list.
         * @param tileHeight Height of the tile.
         */
        /**
         * Calculates the total size taken up by tiles across one axis of a list.
         * @param {?} tileHeight Height of the tile.
         * @return {?}
         */
        TileStyler.prototype.getTileSpan = /**
         * Calculates the total size taken up by tiles across one axis of a list.
         * @param {?} tileHeight Height of the tile.
         * @return {?}
         */
        function (tileHeight) {
            return this._rowspan + " * " + this.getTileSize(tileHeight, 1);
        };
        /**
         * Calculates the computed height and returns the correct style property to set.
         * This method can be implemented by each type of TileStyler.
         * @docs-private
         */
        /**
         * Calculates the computed height and returns the correct style property to set.
         * This method can be implemented by each type of TileStyler.
         * \@docs-private
         * @return {?}
         */
        TileStyler.prototype.getComputedHeight = /**
         * Calculates the computed height and returns the correct style property to set.
         * This method can be implemented by each type of TileStyler.
         * \@docs-private
         * @return {?}
         */
        function () { return null; };
        return TileStyler;
    }());
    /**
     * This type of styler is instantiated when the user passes in a fixed row height.
     * Example `<mat-grid-list cols="3" rowHeight="100px">`
     * \@docs-private
     */
    var /**
     * This type of styler is instantiated when the user passes in a fixed row height.
     * Example `<mat-grid-list cols="3" rowHeight="100px">`
     * \@docs-private
     */
    FixedTileStyler = /** @class */ (function (_super) {
        __extends(FixedTileStyler, _super);
        function FixedTileStyler(fixedRowHeight) {
            var _this = _super.call(this) || this;
            _this.fixedRowHeight = fixedRowHeight;
            return _this;
        }
        /**
         * @param {?} gutterSize
         * @param {?} tracker
         * @param {?} cols
         * @param {?} direction
         * @return {?}
         */
        FixedTileStyler.prototype.init = /**
         * @param {?} gutterSize
         * @param {?} tracker
         * @param {?} cols
         * @param {?} direction
         * @return {?}
         */
        function (gutterSize, tracker, cols, direction) {
            _super.prototype.init.call(this, gutterSize, tracker, cols, direction);
            this.fixedRowHeight = normalizeUnits(this.fixedRowHeight);
        };
        /**
         * @param {?} tile
         * @param {?} rowIndex
         * @return {?}
         */
        FixedTileStyler.prototype.setRowStyles = /**
         * @param {?} tile
         * @param {?} rowIndex
         * @return {?}
         */
        function (tile, rowIndex) {
            tile._setStyle('top', this.getTilePosition(this.fixedRowHeight, rowIndex));
            tile._setStyle('height', calc(this.getTileSize(this.fixedRowHeight, tile.rowspan)));
        };
        /**
         * @return {?}
         */
        FixedTileStyler.prototype.getComputedHeight = /**
         * @return {?}
         */
        function () {
            return [
                'height', calc(this.getTileSpan(this.fixedRowHeight) + " + " + this.getGutterSpan())
            ];
        };
        /**
         * @param {?} list
         * @return {?}
         */
        FixedTileStyler.prototype.reset = /**
         * @param {?} list
         * @return {?}
         */
        function (list) {
            list._setListStyle(['height', null]);
            list._tiles.forEach(function (tile) {
                tile._setStyle('top', null);
                tile._setStyle('height', null);
            });
        };
        return FixedTileStyler;
    }(TileStyler));
    /**
     * This type of styler is instantiated when the user passes in a width:height ratio
     * for the row height.  Example `<mat-grid-list cols="3" rowHeight="3:1">`
     * \@docs-private
     */
    var /**
     * This type of styler is instantiated when the user passes in a width:height ratio
     * for the row height.  Example `<mat-grid-list cols="3" rowHeight="3:1">`
     * \@docs-private
     */
    RatioTileStyler = /** @class */ (function (_super) {
        __extends(RatioTileStyler, _super);
        function RatioTileStyler(value) {
            var _this = _super.call(this) || this;
            _this._parseRatio(value);
            return _this;
        }
        /**
         * @param {?} tile
         * @param {?} rowIndex
         * @param {?} percentWidth
         * @param {?} gutterWidth
         * @return {?}
         */
        RatioTileStyler.prototype.setRowStyles = /**
         * @param {?} tile
         * @param {?} rowIndex
         * @param {?} percentWidth
         * @param {?} gutterWidth
         * @return {?}
         */
        function (tile, rowIndex, percentWidth, gutterWidth) {
            var /** @type {?} */ percentHeightPerTile = percentWidth / this.rowHeightRatio;
            this.baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterWidth);
            // Use padding-top and margin-top to maintain the given aspect ratio, as
            // a percentage-based value for these properties is applied versus the *width* of the
            // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
            tile._setStyle('marginTop', this.getTilePosition(this.baseTileHeight, rowIndex));
            tile._setStyle('paddingTop', calc(this.getTileSize(this.baseTileHeight, tile.rowspan)));
        };
        /**
         * @return {?}
         */
        RatioTileStyler.prototype.getComputedHeight = /**
         * @return {?}
         */
        function () {
            return [
                'paddingBottom', calc(this.getTileSpan(this.baseTileHeight) + " + " + this.getGutterSpan())
            ];
        };
        /**
         * @param {?} list
         * @return {?}
         */
        RatioTileStyler.prototype.reset = /**
         * @param {?} list
         * @return {?}
         */
        function (list) {
            list._setListStyle(['paddingBottom', null]);
            list._tiles.forEach(function (tile) {
                tile._setStyle('marginTop', null);
                tile._setStyle('paddingTop', null);
            });
        };
        /**
         * @param {?} value
         * @return {?}
         */
        RatioTileStyler.prototype._parseRatio = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ ratioParts = value.split(':');
            if (ratioParts.length !== 2) {
                throw Error("mat-grid-list: invalid ratio given for row-height: \"" + value + "\"");
            }
            this.rowHeightRatio = parseFloat(ratioParts[0]) / parseFloat(ratioParts[1]);
        };
        return RatioTileStyler;
    }(TileStyler));
    /**
     * This type of styler is instantiated when the user selects a "fit" row height mode.
     * In other words, the row height will reflect the total height of the container divided
     * by the number of rows.  Example `<mat-grid-list cols="3" rowHeight="fit">`
     *
     * \@docs-private
     */
    var /**
     * This type of styler is instantiated when the user selects a "fit" row height mode.
     * In other words, the row height will reflect the total height of the container divided
     * by the number of rows.  Example `<mat-grid-list cols="3" rowHeight="fit">`
     *
     * \@docs-private
     */
    FitTileStyler = /** @class */ (function (_super) {
        __extends(FitTileStyler, _super);
        function FitTileStyler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * @param {?} tile
         * @param {?} rowIndex
         * @return {?}
         */
        FitTileStyler.prototype.setRowStyles = /**
         * @param {?} tile
         * @param {?} rowIndex
         * @return {?}
         */
        function (tile, rowIndex) {
            // Percent of the available vertical space that one row takes up.
            var /** @type {?} */ percentHeightPerTile = 100 / this._rowspan;
            // Fraction of the horizontal gutter size that each column takes up.
            var /** @type {?} */ gutterHeightPerTile = (this._rows - 1) / this._rows;
            // Base vertical size of a column.
            var /** @type {?} */ baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterHeightPerTile);
            tile._setStyle('top', this.getTilePosition(baseTileHeight, rowIndex));
            tile._setStyle('height', calc(this.getTileSize(baseTileHeight, tile.rowspan)));
        };
        /**
         * @param {?} list
         * @return {?}
         */
        FitTileStyler.prototype.reset = /**
         * @param {?} list
         * @return {?}
         */
        function (list) {
            list._tiles.forEach(function (tile) {
                tile._setStyle('top', null);
                tile._setStyle('height', null);
            });
        };
        return FitTileStyler;
    }(TileStyler));
    /**
     * Wraps a CSS string in a calc function
     * @param {?} exp
     * @return {?}
     */
    function calc(exp) { return "calc(" + exp + ")"; }
    /**
     * Appends pixels to a CSS string if no units are given.
     * @param {?} value
     * @return {?}
     */
    function normalizeUnits(value) {
        return (value.match(/px|em|rem/)) ? value : value + 'px';
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // TODO(kara): Conditional (responsive) column count / row size.
    // TODO(kara): Re-layout on window resize / media change (debounced).
    // TODO(kara): gridTileHeader and gridTileFooter.
    var /** @type {?} */ MAT_FIT_MODE = 'fit';
    var MatGridList = /** @class */ (function () {
        function MatGridList(_element, _dir) {
            this._element = _element;
            this._dir = _dir;
            /**
             * The amount of space between tiles. This will be something like '5px' or '2em'.
             */
            this._gutter = '1px';
        }
        Object.defineProperty(MatGridList.prototype, "cols", {
            get: /**
             * Amount of columns in the grid list.
             * @return {?}
             */
            function () { return this._cols; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._cols = coerceToNumber(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatGridList.prototype, "gutterSize", {
            get: /**
             * Size of the grid list's gutter in pixels.
             * @return {?}
             */
            function () { return this._gutter; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._gutter = coerceToString(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatGridList.prototype, "rowHeight", {
            set: /**
             * Set internal representation of row height from the user-provided value.
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newValue = coerceToString(value);
                if (newValue !== this._rowHeight) {
                    this._rowHeight = newValue;
                    this._setTileStyler(this._rowHeight);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatGridList.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._checkCols();
            this._checkRowHeight();
        };
        /**
         * The layout calculation is fairly cheap if nothing changes, so there's little cost
         * to run it frequently.
         */
        /**
         * The layout calculation is fairly cheap if nothing changes, so there's little cost
         * to run it frequently.
         * @return {?}
         */
        MatGridList.prototype.ngAfterContentChecked = /**
         * The layout calculation is fairly cheap if nothing changes, so there's little cost
         * to run it frequently.
         * @return {?}
         */
        function () {
            this._layoutTiles();
        };
        /**
         * Throw a friendly error if cols property is missing
         * @return {?}
         */
        MatGridList.prototype._checkCols = /**
         * Throw a friendly error if cols property is missing
         * @return {?}
         */
        function () {
            if (!this.cols) {
                throw Error("mat-grid-list: must pass in number of columns. " +
                    "Example: <mat-grid-list cols=\"3\">");
            }
        };
        /**
         * Default to equal width:height if rowHeight property is missing
         * @return {?}
         */
        MatGridList.prototype._checkRowHeight = /**
         * Default to equal width:height if rowHeight property is missing
         * @return {?}
         */
        function () {
            if (!this._rowHeight) {
                this._setTileStyler('1:1');
            }
        };
        /**
         * Creates correct Tile Styler subtype based on rowHeight passed in by user
         * @param {?} rowHeight
         * @return {?}
         */
        MatGridList.prototype._setTileStyler = /**
         * Creates correct Tile Styler subtype based on rowHeight passed in by user
         * @param {?} rowHeight
         * @return {?}
         */
        function (rowHeight) {
            if (this._tileStyler) {
                this._tileStyler.reset(this);
            }
            if (rowHeight === MAT_FIT_MODE) {
                this._tileStyler = new FitTileStyler();
            }
            else if (rowHeight && rowHeight.indexOf(':') > -1) {
                this._tileStyler = new RatioTileStyler(rowHeight);
            }
            else {
                this._tileStyler = new FixedTileStyler(rowHeight);
            }
        };
        /**
         * Computes and applies the size and position for all children grid tiles.
         * @return {?}
         */
        MatGridList.prototype._layoutTiles = /**
         * Computes and applies the size and position for all children grid tiles.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ tracker = new TileCoordinator(this.cols, this._tiles);
            var /** @type {?} */ direction = this._dir ? this._dir.value : 'ltr';
            this._tileStyler.init(this.gutterSize, tracker, this.cols, direction);
            this._tiles.forEach(function (tile, index) {
                var /** @type {?} */ pos = tracker.positions[index];
                _this._tileStyler.setStyle(tile, pos.row, pos.col);
            });
            this._setListStyle(this._tileStyler.getComputedHeight());
        };
        /** Sets style on the main grid-list element, given the style name and value. */
        /**
         * Sets style on the main grid-list element, given the style name and value.
         * @param {?} style
         * @return {?}
         */
        MatGridList.prototype._setListStyle = /**
         * Sets style on the main grid-list element, given the style name and value.
         * @param {?} style
         * @return {?}
         */
        function (style) {
            if (style) {
                this._element.nativeElement.style[style[0]] = style[1];
            }
        };
        MatGridList.decorators = [
            { type: core.Component, args: [{selector: 'mat-grid-list',
                        exportAs: 'matGridList',
                        template: "<div><ng-content></ng-content></div>",
                        styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
                        host: {
                            'class': 'mat-grid-list',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatGridList.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatGridList.propDecorators = {
            "_tiles": [{ type: core.ContentChildren, args: [MatGridTile,] },],
            "cols": [{ type: core.Input },],
            "gutterSize": [{ type: core.Input },],
            "rowHeight": [{ type: core.Input },],
        };
        return MatGridList;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Returns an exception to be thrown in the case when attempting to
     * load an icon with a name that cannot be found.
     * \@docs-private
     * @param {?} iconName
     * @return {?}
     */
    function getMatIconNameNotFoundError(iconName) {
        return Error("Unable to find icon with the name \"" + iconName + "\"");
    }
    /**
     * Returns an exception to be thrown when the consumer attempts to use
     * `<mat-icon>` without including \@angular/http.
     * \@docs-private
     * @return {?}
     */
    function getMatIconNoHttpProviderError() {
        return Error('Could not find HttpClient provider for use with Angular Material icons. ' +
            'Please include the HttpClientModule from @angular/common/http in your ' +
            'app imports.');
    }
    /**
     * Returns an exception to be thrown when a URL couldn't be sanitized.
     * \@docs-private
     * @param {?} url URL that was attempted to be sanitized.
     * @return {?}
     */
    function getMatIconFailedToSanitizeUrlError(url) {
        return Error("The URL provided to MatIconRegistry was not trusted as a resource URL " +
            ("via Angular's DomSanitizer. Attempted URL was \"" + url + "\"."));
    }
    /**
     * Returns an exception to be thrown when a HTML string couldn't be sanitized.
     * \@docs-private
     * @param {?} literal HTML that was attempted to be sanitized.
     * @return {?}
     */
    function getMatIconFailedToSanitizeLiteralError(literal) {
        return Error("The literal provided to MatIconRegistry was not trusted as safe HTML by " +
            ("Angular's DomSanitizer. Attempted literal was \"" + literal + "\"."));
    }
    /**
     * Configuration for an icon, including the URL and possibly the cached SVG element.
     * \@docs-private
     */
    var /**
     * Configuration for an icon, including the URL and possibly the cached SVG element.
     * \@docs-private
     */
    SvgIconConfig = /** @class */ (function () {
        function SvgIconConfig(data) {
            // Note that we can't use `instanceof SVGElement` here,
            // because it'll break during server-side rendering.
            if (!!(/** @type {?} */ (data)).nodeName) {
                this.svgElement = /** @type {?} */ (data);
            }
            else {
                this.url = /** @type {?} */ (data);
            }
        }
        return SvgIconConfig;
    }());
    /**
     * Service to register and display icons used by the `<mat-icon>` component.
     * - Registers icon URLs by namespace and name.
     * - Registers icon set URLs by namespace.
     * - Registers aliases for CSS classes, for use with icon fonts.
     * - Loads icons from URLs and extracts individual icons from icon sets.
     */
    var MatIconRegistry = /** @class */ (function () {
        function MatIconRegistry(_httpClient, _sanitizer, document) {
            this._httpClient = _httpClient;
            this._sanitizer = _sanitizer;
            /**
             * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
             */
            this._svgIconConfigs = new Map();
            /**
             * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
             * Multiple icon sets can be registered under the same namespace.
             */
            this._iconSetConfigs = new Map();
            /**
             * Cache for icons loaded by direct URLs.
             */
            this._cachedIconsByUrl = new Map();
            /**
             * In-progress icon fetches. Used to coalesce multiple requests to the same URL.
             */
            this._inProgressUrlFetches = new Map();
            /**
             * Map from font identifiers to their CSS class names. Used for icon fonts.
             */
            this._fontCssClassesByAlias = new Map();
            /**
             * The CSS class to apply when an `<mat-icon>` component has no icon name, url, or font specified.
             * The default 'material-icons' value assumes that the material icon font has been loaded as
             * described at http://google.github.io/material-design-icons/#icon-font-for-the-web
             */
            this._defaultFontSetClass = 'material-icons';
            this._document = document;
        }
        /**
         * Registers an icon by URL in the default namespace.
         * @param iconName Name under which the icon should be registered.
         * @param url
         */
        /**
         * Registers an icon by URL in the default namespace.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} url
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIcon = /**
         * Registers an icon by URL in the default namespace.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} url
         * @return {?}
         */
        function (iconName, url) {
            return this.addSvgIconInNamespace('', iconName, url);
        };
        /**
         * Registers an icon using an HTML string in the default namespace.
         * @param iconName Name under which the icon should be registered.
         * @param literal SVG source of the icon.
         */
        /**
         * Registers an icon using an HTML string in the default namespace.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} literal SVG source of the icon.
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconLiteral = /**
         * Registers an icon using an HTML string in the default namespace.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} literal SVG source of the icon.
         * @return {?}
         */
        function (iconName, literal) {
            return this.addSvgIconLiteralInNamespace('', iconName, literal);
        };
        /**
         * Registers an icon by URL in the specified namespace.
         * @param namespace Namespace in which the icon should be registered.
         * @param iconName Name under which the icon should be registered.
         * @param url
         */
        /**
         * Registers an icon by URL in the specified namespace.
         * @param {?} namespace Namespace in which the icon should be registered.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} url
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconInNamespace = /**
         * Registers an icon by URL in the specified namespace.
         * @param {?} namespace Namespace in which the icon should be registered.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} url
         * @return {?}
         */
        function (namespace, iconName, url) {
            return this._addSvgIconConfig(namespace, iconName, new SvgIconConfig(url));
        };
        /**
         * Registers an icon using an HTML string in the specified namespace.
         * @param namespace Namespace in which the icon should be registered.
         * @param iconName Name under which the icon should be registered.
         * @param literal SVG source of the icon.
         */
        /**
         * Registers an icon using an HTML string in the specified namespace.
         * @param {?} namespace Namespace in which the icon should be registered.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} literal SVG source of the icon.
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconLiteralInNamespace = /**
         * Registers an icon using an HTML string in the specified namespace.
         * @param {?} namespace Namespace in which the icon should be registered.
         * @param {?} iconName Name under which the icon should be registered.
         * @param {?} literal SVG source of the icon.
         * @return {?}
         */
        function (namespace, iconName, literal) {
            var /** @type {?} */ sanitizedLiteral = this._sanitizer.sanitize(core.SecurityContext.HTML, literal);
            if (!sanitizedLiteral) {
                throw getMatIconFailedToSanitizeLiteralError(literal);
            }
            var /** @type {?} */ svgElement = this._createSvgElementForSingleIcon(sanitizedLiteral);
            return this._addSvgIconConfig(namespace, iconName, new SvgIconConfig(svgElement));
        };
        /**
         * Registers an icon set by URL in the default namespace.
         * @param url
         */
        /**
         * Registers an icon set by URL in the default namespace.
         * @param {?} url
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconSet = /**
         * Registers an icon set by URL in the default namespace.
         * @param {?} url
         * @return {?}
         */
        function (url) {
            return this.addSvgIconSetInNamespace('', url);
        };
        /**
         * Registers an icon set using an HTML string in the default namespace.
         * @param literal SVG source of the icon set.
         */
        /**
         * Registers an icon set using an HTML string in the default namespace.
         * @param {?} literal SVG source of the icon set.
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconSetLiteral = /**
         * Registers an icon set using an HTML string in the default namespace.
         * @param {?} literal SVG source of the icon set.
         * @return {?}
         */
        function (literal) {
            return this.addSvgIconSetLiteralInNamespace('', literal);
        };
        /**
         * Registers an icon set by URL in the specified namespace.
         * @param namespace Namespace in which to register the icon set.
         * @param url
         */
        /**
         * Registers an icon set by URL in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon set.
         * @param {?} url
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconSetInNamespace = /**
         * Registers an icon set by URL in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon set.
         * @param {?} url
         * @return {?}
         */
        function (namespace, url) {
            return this._addSvgIconSetConfig(namespace, new SvgIconConfig(url));
        };
        /**
         * Registers an icon set using an HTML string in the specified namespace.
         * @param namespace Namespace in which to register the icon set.
         * @param literal SVG source of the icon set.
         */
        /**
         * Registers an icon set using an HTML string in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon set.
         * @param {?} literal SVG source of the icon set.
         * @return {?}
         */
        MatIconRegistry.prototype.addSvgIconSetLiteralInNamespace = /**
         * Registers an icon set using an HTML string in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon set.
         * @param {?} literal SVG source of the icon set.
         * @return {?}
         */
        function (namespace, literal) {
            var /** @type {?} */ sanitizedLiteral = this._sanitizer.sanitize(core.SecurityContext.HTML, literal);
            if (!sanitizedLiteral) {
                throw getMatIconFailedToSanitizeLiteralError(literal);
            }
            var /** @type {?} */ svgElement = this._svgElementFromString(sanitizedLiteral);
            return this._addSvgIconSetConfig(namespace, new SvgIconConfig(svgElement));
        };
        /**
         * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
         * component with the alias as the fontSet input will cause the class name to be applied
         * to the `<mat-icon>` element.
         *
         * @param alias Alias for the font.
         * @param className Class name override to be used instead of the alias.
         */
        /**
         * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
         * component with the alias as the fontSet input will cause the class name to be applied
         * to the `<mat-icon>` element.
         *
         * @param {?} alias Alias for the font.
         * @param {?=} className Class name override to be used instead of the alias.
         * @return {?}
         */
        MatIconRegistry.prototype.registerFontClassAlias = /**
         * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
         * component with the alias as the fontSet input will cause the class name to be applied
         * to the `<mat-icon>` element.
         *
         * @param {?} alias Alias for the font.
         * @param {?=} className Class name override to be used instead of the alias.
         * @return {?}
         */
        function (alias, className) {
            if (className === void 0) { className = alias; }
            this._fontCssClassesByAlias.set(alias, className);
            return this;
        };
        /**
         * Returns the CSS class name associated with the alias by a previous call to
         * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
         */
        /**
         * Returns the CSS class name associated with the alias by a previous call to
         * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
         * @param {?} alias
         * @return {?}
         */
        MatIconRegistry.prototype.classNameForFontAlias = /**
         * Returns the CSS class name associated with the alias by a previous call to
         * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
         * @param {?} alias
         * @return {?}
         */
        function (alias) {
            return this._fontCssClassesByAlias.get(alias) || alias;
        };
        /**
         * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         *
         * @param className
         */
        /**
         * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         *
         * @param {?} className
         * @return {?}
         */
        MatIconRegistry.prototype.setDefaultFontSetClass = /**
         * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         *
         * @param {?} className
         * @return {?}
         */
        function (className) {
            this._defaultFontSetClass = className;
            return this;
        };
        /**
         * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         */
        /**
         * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         * @return {?}
         */
        MatIconRegistry.prototype.getDefaultFontSetClass = /**
         * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
         * have a fontSet input value, and is not loading an icon by name or URL.
         * @return {?}
         */
        function () {
            return this._defaultFontSetClass;
        };
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
         * The response from the URL may be cached so this will not always cause an HTTP request, but
         * the produced element will always be a new copy of the originally fetched icon. (That is,
         * it will not contain any modifications made to elements previously returned).
         *
         * @param safeUrl URL from which to fetch the SVG icon.
         */
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
         * The response from the URL may be cached so this will not always cause an HTTP request, but
         * the produced element will always be a new copy of the originally fetched icon. (That is,
         * it will not contain any modifications made to elements previously returned).
         *
         * @param {?} safeUrl URL from which to fetch the SVG icon.
         * @return {?}
         */
        MatIconRegistry.prototype.getSvgIconFromUrl = /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
         * The response from the URL may be cached so this will not always cause an HTTP request, but
         * the produced element will always be a new copy of the originally fetched icon. (That is,
         * it will not contain any modifications made to elements previously returned).
         *
         * @param {?} safeUrl URL from which to fetch the SVG icon.
         * @return {?}
         */
        function (safeUrl) {
            var _this = this;
            var /** @type {?} */ url = this._sanitizer.sanitize(core.SecurityContext.RESOURCE_URL, safeUrl);
            if (!url) {
                throw getMatIconFailedToSanitizeUrlError(safeUrl);
            }
            var /** @type {?} */ cachedIcon = this._cachedIconsByUrl.get(url);
            if (cachedIcon) {
                return rxjs.of(cloneSvg(cachedIcon));
            }
            return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(operators.tap(function (svg) { return _this._cachedIconsByUrl.set(/** @type {?} */ ((url)), svg); }), operators.map(function (svg) { return cloneSvg(svg); }));
        };
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
         * and namespace. The icon must have been previously registered with addIcon or addIconSet;
         * if not, the Observable will throw an error.
         *
         * @param name Name of the icon to be retrieved.
         * @param namespace Namespace in which to look for the icon.
         */
        /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
         * and namespace. The icon must have been previously registered with addIcon or addIconSet;
         * if not, the Observable will throw an error.
         *
         * @param {?} name Name of the icon to be retrieved.
         * @param {?=} namespace Namespace in which to look for the icon.
         * @return {?}
         */
        MatIconRegistry.prototype.getNamedSvgIcon = /**
         * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
         * and namespace. The icon must have been previously registered with addIcon or addIconSet;
         * if not, the Observable will throw an error.
         *
         * @param {?} name Name of the icon to be retrieved.
         * @param {?=} namespace Namespace in which to look for the icon.
         * @return {?}
         */
        function (name, namespace) {
            if (namespace === void 0) { namespace = ''; }
            // Return (copy of) cached icon if possible.
            var /** @type {?} */ key = iconKey(namespace, name);
            var /** @type {?} */ config = this._svgIconConfigs.get(key);
            if (config) {
                return this._getSvgFromConfig(config);
            }
            // See if we have any icon sets registered for the namespace.
            var /** @type {?} */ iconSetConfigs = this._iconSetConfigs.get(namespace);
            if (iconSetConfigs) {
                return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
            }
            return rxjs.throwError(getMatIconNameNotFoundError(key));
        };
        /**
         * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
         * @param {?} config
         * @return {?}
         */
        MatIconRegistry.prototype._getSvgFromConfig = /**
         * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
         * @param {?} config
         * @return {?}
         */
        function (config) {
            if (config.svgElement) {
                // We already have the SVG element for this icon, return a copy.
                return rxjs.of(cloneSvg(config.svgElement));
            }
            else {
                // Fetch the icon from the config's URL, cache it, and return a copy.
                return this._loadSvgIconFromConfig(config).pipe(operators.tap(function (svg) { return config.svgElement = svg; }), operators.map(function (svg) { return cloneSvg(svg); }));
            }
        };
        /**
         * Attempts to find an icon with the specified name in any of the SVG icon sets.
         * First searches the available cached icons for a nested element with a matching name, and
         * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
         * that have not been cached, and searches again after all fetches are completed.
         * The returned Observable produces the SVG element if possible, and throws
         * an error if no icon with the specified name can be found.
         * @param {?} name
         * @param {?} iconSetConfigs
         * @return {?}
         */
        MatIconRegistry.prototype._getSvgFromIconSetConfigs = /**
         * Attempts to find an icon with the specified name in any of the SVG icon sets.
         * First searches the available cached icons for a nested element with a matching name, and
         * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
         * that have not been cached, and searches again after all fetches are completed.
         * The returned Observable produces the SVG element if possible, and throws
         * an error if no icon with the specified name can be found.
         * @param {?} name
         * @param {?} iconSetConfigs
         * @return {?}
         */
        function (name, iconSetConfigs) {
            var _this = this;
            // For all the icon set SVG elements we've fetched, see if any contain an icon with the
            // requested name.
            var /** @type {?} */ namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
            if (namedIcon) {
                // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
                // time anyway, there's probably not much advantage compared to just always extracting
                // it from the icon set.
                return rxjs.of(namedIcon);
            }
            // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
            // fetched, fetch them now and look for iconName in the results.
            var /** @type {?} */ iconSetFetchRequests = iconSetConfigs
                .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
                .map(function (iconSetConfig) {
                return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(operators.catchError(function (err) {
                    var /** @type {?} */ url = _this._sanitizer.sanitize(core.SecurityContext.RESOURCE_URL, iconSetConfig.url);
                    // Swallow errors fetching individual URLs so the
                    // combined Observable won't necessarily fail.
                    console.error("Loading icon set URL: " + url + " failed: " + err.message);
                    return rxjs.of(null);
                }));
            });
            // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
            // cached SVG element (unless the request failed), and we can check again for the icon.
            return rxjs.forkJoin(iconSetFetchRequests).pipe(operators.map(function () {
                var /** @type {?} */ foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
                if (!foundIcon) {
                    throw getMatIconNameNotFoundError(name);
                }
                return foundIcon;
            }));
        };
        /**
         * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         * @param {?} iconName
         * @param {?} iconSetConfigs
         * @return {?}
         */
        MatIconRegistry.prototype._extractIconWithNameFromAnySet = /**
         * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         * @param {?} iconName
         * @param {?} iconSetConfigs
         * @return {?}
         */
        function (iconName, iconSetConfigs) {
            // Iterate backwards, so icon sets added later have precedence.
            for (var /** @type {?} */ i = iconSetConfigs.length - 1; i >= 0; i--) {
                var /** @type {?} */ config = iconSetConfigs[i];
                if (config.svgElement) {
                    var /** @type {?} */ foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName);
                    if (foundIcon) {
                        return foundIcon;
                    }
                }
            }
            return null;
        };
        /**
         * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         * @param {?} config
         * @return {?}
         */
        MatIconRegistry.prototype._loadSvgIconFromConfig = /**
         * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         * @param {?} config
         * @return {?}
         */
        function (config) {
            var _this = this;
            return this._fetchUrl(config.url)
                .pipe(operators.map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText); }));
        };
        /**
         * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         * @param {?} config
         * @return {?}
         */
        MatIconRegistry.prototype._loadSvgIconSetFromConfig = /**
         * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
         * from it.
         * @param {?} config
         * @return {?}
         */
        function (config) {
            var _this = this;
            // If the SVG for this icon set has already been parsed, do nothing.
            if (config.svgElement) {
                return rxjs.of(config.svgElement);
            }
            return this._fetchUrl(config.url).pipe(operators.map(function (svgText) {
                // It is possible that the icon set was parsed and cached by an earlier request, so parsing
                // only needs to occur if the cache is yet unset.
                if (!config.svgElement) {
                    config.svgElement = _this._svgElementFromString(svgText);
                }
                return config.svgElement;
            }));
        };
        /**
         * Creates a DOM element from the given SVG string, and adds default attributes.
         * @param {?} responseText
         * @return {?}
         */
        MatIconRegistry.prototype._createSvgElementForSingleIcon = /**
         * Creates a DOM element from the given SVG string, and adds default attributes.
         * @param {?} responseText
         * @return {?}
         */
        function (responseText) {
            var /** @type {?} */ svg = this._svgElementFromString(responseText);
            this._setSvgAttributes(svg);
            return svg;
        };
        /**
         * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         * @param {?} iconSet
         * @param {?} iconName
         * @return {?}
         */
        MatIconRegistry.prototype._extractSvgIconFromSet = /**
         * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
         * tag matches the specified name. If found, copies the nested element to a new SVG element and
         * returns it. Returns null if no matching element is found.
         * @param {?} iconSet
         * @param {?} iconName
         * @return {?}
         */
        function (iconSet, iconName) {
            var /** @type {?} */ iconSource = iconSet.querySelector('#' + iconName);
            if (!iconSource) {
                return null;
            }
            // Clone the element and remove the ID to prevent multiple elements from being added
            // to the page with the same ID.
            var /** @type {?} */ iconElement = /** @type {?} */ (iconSource.cloneNode(true));
            iconElement.removeAttribute('id');
            // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
            // the content of a new <svg> node.
            if (iconElement.nodeName.toLowerCase() === 'svg') {
                return this._setSvgAttributes(/** @type {?} */ (iconElement));
            }
            // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
            // that the same could be achieved by referring to it via <use href="#id">, however the <use>
            // tag is problematic on Firefox, because it needs to include the current page path.
            if (iconElement.nodeName.toLowerCase() === 'symbol') {
                return this._setSvgAttributes(this._toSvgElement(iconElement));
            }
            // createElement('SVG') doesn't work as expected; the DOM ends up with
            // the correct nodes, but the SVG content doesn't render. Instead we
            // have to create an empty SVG node using innerHTML and append its content.
            // Elements created using DOMParser.parseFromString have the same problem.
            // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
            var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
            // Clone the node so we don't remove it from the parent icon set element.
            svg.appendChild(iconElement);
            return this._setSvgAttributes(svg);
        };
        /**
         * Creates a DOM element from the given SVG string.
         * @param {?} str
         * @return {?}
         */
        MatIconRegistry.prototype._svgElementFromString = /**
         * Creates a DOM element from the given SVG string.
         * @param {?} str
         * @return {?}
         */
        function (str) {
            var /** @type {?} */ div = this._document.createElement('DIV');
            div.innerHTML = str;
            var /** @type {?} */ svg = /** @type {?} */ (div.querySelector('svg'));
            if (!svg) {
                throw Error('<svg> tag not found');
            }
            return svg;
        };
        /**
         * Converts an element into an SVG node by cloning all of its children.
         * @param {?} element
         * @return {?}
         */
        MatIconRegistry.prototype._toSvgElement = /**
         * Converts an element into an SVG node by cloning all of its children.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
            for (var /** @type {?} */ i = 0; i < element.childNodes.length; i++) {
                if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
                    svg.appendChild(element.childNodes[i].cloneNode(true));
                }
            }
            return svg;
        };
        /**
         * Sets the default attributes for an SVG element to be used as an icon.
         * @param {?} svg
         * @return {?}
         */
        MatIconRegistry.prototype._setSvgAttributes = /**
         * Sets the default attributes for an SVG element to be used as an icon.
         * @param {?} svg
         * @return {?}
         */
        function (svg) {
            svg.setAttribute('fit', '');
            svg.setAttribute('height', '100%');
            svg.setAttribute('width', '100%');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
            return svg;
        };
        /**
         * Returns an Observable which produces the string contents of the given URL. Results may be
         * cached, so future calls with the same URL may not cause another HTTP request.
         * @param {?} safeUrl
         * @return {?}
         */
        MatIconRegistry.prototype._fetchUrl = /**
         * Returns an Observable which produces the string contents of the given URL. Results may be
         * cached, so future calls with the same URL may not cause another HTTP request.
         * @param {?} safeUrl
         * @return {?}
         */
        function (safeUrl) {
            var _this = this;
            if (!this._httpClient) {
                throw getMatIconNoHttpProviderError();
            }
            if (safeUrl == null) {
                throw Error("Cannot fetch icon from URL \"" + safeUrl + "\".");
            }
            var /** @type {?} */ url = this._sanitizer.sanitize(core.SecurityContext.RESOURCE_URL, safeUrl);
            if (!url) {
                throw getMatIconFailedToSanitizeUrlError(safeUrl);
            }
            // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
            // already a request in progress for that URL. It's necessary to call share() on the
            // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
            var /** @type {?} */ inProgressFetch = this._inProgressUrlFetches.get(url);
            if (inProgressFetch) {
                return inProgressFetch;
            }
            // TODO(jelbourn): for some reason, the `finalize` operator "loses" the generic type on the
            // Observable. Figure out why and fix it.
            var /** @type {?} */ req = this._httpClient.get(url, { responseType: 'text' }).pipe(operators.finalize(function () { return _this._inProgressUrlFetches.delete(url); }), operators.share());
            this._inProgressUrlFetches.set(url, req);
            return req;
        };
        /**
         * Registers an icon config by name in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon config.
         * @param {?} iconName Name under which to register the config.
         * @param {?} config Config to be registered.
         * @return {?}
         */
        MatIconRegistry.prototype._addSvgIconConfig = /**
         * Registers an icon config by name in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon config.
         * @param {?} iconName Name under which to register the config.
         * @param {?} config Config to be registered.
         * @return {?}
         */
        function (namespace, iconName, config) {
            this._svgIconConfigs.set(iconKey(namespace, iconName), config);
            return this;
        };
        /**
         * Registers an icon set config in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon config.
         * @param {?} config Config to be registered.
         * @return {?}
         */
        MatIconRegistry.prototype._addSvgIconSetConfig = /**
         * Registers an icon set config in the specified namespace.
         * @param {?} namespace Namespace in which to register the icon config.
         * @param {?} config Config to be registered.
         * @return {?}
         */
        function (namespace, config) {
            var /** @type {?} */ configNamespace = this._iconSetConfigs.get(namespace);
            if (configNamespace) {
                configNamespace.push(config);
            }
            else {
                this._iconSetConfigs.set(namespace, [config]);
            }
            return this;
        };
        MatIconRegistry.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */
        MatIconRegistry.ctorParameters = function () { return [
            { type: HttpClient, decorators: [{ type: core.Optional },] },
            { type: DomSanitizer, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        /** @nocollapse */ MatIconRegistry.ngInjectableDef = core.defineInjectable({ factory: function MatIconRegistry_Factory() { return new MatIconRegistry(core.inject(HttpClient, 8), core.inject(DomSanitizer), core.inject(common.DOCUMENT, 8)); }, token: MatIconRegistry, providedIn: "root" });
        return MatIconRegistry;
    }());
    /**
     * \@docs-private
     * @param {?} parentRegistry
     * @param {?} httpClient
     * @param {?} sanitizer
     * @param {?=} document
     * @return {?}
     */
    function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document) {
        return parentRegistry || new MatIconRegistry(httpClient, sanitizer, document);
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ ICON_REGISTRY_PROVIDER = {
        // If there is already an MatIconRegistry available, use that. Otherwise, provide a new one.
        provide: MatIconRegistry,
        deps: [
            [new core.Optional(), new core.SkipSelf(), MatIconRegistry],
            [new core.Optional(), HttpClient],
            DomSanitizer,
            [new core.Optional(), /** @type {?} */ (common.DOCUMENT)],
        ],
        useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
    };
    /**
     * Clones an SVGElement while preserving type information.
     * @param {?} svg
     * @return {?}
     */
    function cloneSvg(svg) {
        return /** @type {?} */ (svg.cloneNode(true));
    }
    /**
     * Returns the cache key to use for an icon namespace and name.
     * @param {?} namespace
     * @param {?} name
     * @return {?}
     */
    function iconKey(namespace, name) {
        return namespace + ':' + name;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatIconBase = /** @class */ (function () {
        function MatIconBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatIconBase;
    }());
    var /** @type {?} */ _MatIconMixinBase = mixinColor(MatIconBase);
    /**
     * Component to display an icon. It can be used in the following ways:
     *
     * - Specify the svgIcon input to load an SVG icon from a URL previously registered with the
     *   addSvgIcon, addSvgIconInNamespace, addSvgIconSet, or addSvgIconSetInNamespace methods of
     *   MatIconRegistry. If the svgIcon value contains a colon it is assumed to be in the format
     *   "[namespace]:[name]", if not the value will be the name of an icon in the default namespace.
     *   Examples:
     *     `<mat-icon svgIcon="left-arrow"></mat-icon>
     *     <mat-icon svgIcon="animals:cat"></mat-icon>`
     *
     * - Use a font ligature as an icon by putting the ligature text in the content of the `<mat-icon>`
     *   component. By default the Material icons font is used as described at
     *   http://google.github.io/material-design-icons/#icon-font-for-the-web. You can specify an
     *   alternate font by setting the fontSet input to either the CSS class to apply to use the
     *   desired font, or to an alias previously registered with MatIconRegistry.registerFontClassAlias.
     *   Examples:
     *     `<mat-icon>home</mat-icon>
     *     <mat-icon fontSet="myfont">sun</mat-icon>`
     *
     * - Specify a font glyph to be included via CSS rules by setting the fontSet input to specify the
     *   font, and the fontIcon input to specify the icon. Typically the fontIcon will specify a
     *   CSS class which causes the glyph to be displayed via a :before selector, as in
     *   https://fortawesome.github.io/Font-Awesome/examples/
     *   Example:
     *     `<mat-icon fontSet="fa" fontIcon="alarm"></mat-icon>`
     */
    var MatIcon = /** @class */ (function (_super) {
        __extends(MatIcon, _super);
        function MatIcon(elementRef, _iconRegistry, ariaHidden) {
            var _this = _super.call(this, elementRef) || this;
            _this._iconRegistry = _iconRegistry;
            _this._inline = false;
            // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
            // the right thing to do for the majority of icon use-cases.
            if (!ariaHidden) {
                elementRef.nativeElement.setAttribute('aria-hidden', 'true');
            }
            return _this;
        }
        Object.defineProperty(MatIcon.prototype, "inline", {
            get: /**
             * Whether the icon should be inlined, automatically sizing the icon to match the font size of
             * the element the icon is contained in.
             * @return {?}
             */
            function () {
                return this._inline;
            },
            set: /**
             * @param {?} inline
             * @return {?}
             */
            function (inline) {
                this._inline = coerceBooleanProperty(inline);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatIcon.prototype, "fontSet", {
            get: /**
             * Font set that the icon is a part of.
             * @return {?}
             */
            function () { return this._fontSet; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._fontSet = this._cleanupFontValue(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatIcon.prototype, "fontIcon", {
            get: /**
             * Name of an icon within a font set.
             * @return {?}
             */
            function () { return this._fontIcon; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._fontIcon = this._cleanupFontValue(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Splits an svgIcon binding value into its icon set and icon name components.
         * Returns a 2-element array of [(icon set), (icon name)].
         * The separator for the two fields is ':'. If there is no separator, an empty
         * string is returned for the icon set and the entire value is returned for
         * the icon name. If the argument is falsy, returns an array of two empty strings.
         * Throws an error if the name contains two or more ':' separators.
         * Examples:
         *   `'social:cake' -> ['social', 'cake']
         *   'penguin' -> ['', 'penguin']
         *   null -> ['', '']
         *   'a:b:c' -> (throws Error)`
         * @param {?} iconName
         * @return {?}
         */
        MatIcon.prototype._splitIconName = /**
         * Splits an svgIcon binding value into its icon set and icon name components.
         * Returns a 2-element array of [(icon set), (icon name)].
         * The separator for the two fields is ':'. If there is no separator, an empty
         * string is returned for the icon set and the entire value is returned for
         * the icon name. If the argument is falsy, returns an array of two empty strings.
         * Throws an error if the name contains two or more ':' separators.
         * Examples:
         *   `'social:cake' -> ['social', 'cake']
         *   'penguin' -> ['', 'penguin']
         *   null -> ['', '']
         *   'a:b:c' -> (throws Error)`
         * @param {?} iconName
         * @return {?}
         */
        function (iconName) {
            if (!iconName) {
                return ['', ''];
            }
            var /** @type {?} */ parts = iconName.split(':');
            switch (parts.length) {
                case 1: return ['', parts[0]]; // Use default namespace.
                case 2: return /** @type {?} */ (parts);
                default: throw Error("Invalid icon name: \"" + iconName + "\"");
            }
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        MatIcon.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            var _this = this;
            // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
            if (changes["svgIcon"]) {
                if (this.svgIcon) {
                    var _a = this._splitIconName(this.svgIcon), namespace = _a[0], iconName = _a[1];
                    this._iconRegistry.getNamedSvgIcon(iconName, namespace).pipe(operators.take(1)).subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
                }
                else {
                    this._clearSvgElement();
                }
            }
            if (this._usingFontIcon()) {
                this._updateFontIconClasses();
            }
        };
        /**
         * @return {?}
         */
        MatIcon.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            // Update font classes because ngOnChanges won't be called if none of the inputs are present,
            // e.g. <mat-icon>arrow</mat-icon> In this case we need to add a CSS class for the default font.
            if (this._usingFontIcon()) {
                this._updateFontIconClasses();
            }
        };
        /**
         * @return {?}
         */
        MatIcon.prototype._usingFontIcon = /**
         * @return {?}
         */
        function () {
            return !this.svgIcon;
        };
        /**
         * @param {?} svg
         * @return {?}
         */
        MatIcon.prototype._setSvgElement = /**
         * @param {?} svg
         * @return {?}
         */
        function (svg) {
            this._clearSvgElement();
            // Workaround for IE11 and Edge ignoring `style` tags inside dynamically-created SVGs.
            // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
            // Do this before inserting the element into the DOM, in order to avoid a style recalculation.
            var /** @type {?} */ styleTags = /** @type {?} */ (svg.querySelectorAll('style'));
            for (var /** @type {?} */ i = 0; i < styleTags.length; i++) {
                styleTags[i].textContent += ' ';
            }
            this._elementRef.nativeElement.appendChild(svg);
        };
        /**
         * @return {?}
         */
        MatIcon.prototype._clearSvgElement = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ layoutElement = this._elementRef.nativeElement;
            var /** @type {?} */ childCount = layoutElement.childNodes.length;
            // Remove existing child nodes and add the new SVG element. Note that we can't
            // use innerHTML, because IE will throw if the element has a data binding.
            for (var /** @type {?} */ i = 0; i < childCount; i++) {
                layoutElement.removeChild(layoutElement.childNodes[i]);
            }
        };
        /**
         * @return {?}
         */
        MatIcon.prototype._updateFontIconClasses = /**
         * @return {?}
         */
        function () {
            if (!this._usingFontIcon()) {
                return;
            }
            var /** @type {?} */ elem = this._elementRef.nativeElement;
            var /** @type {?} */ fontSetClass = this.fontSet ?
                this._iconRegistry.classNameForFontAlias(this.fontSet) :
                this._iconRegistry.getDefaultFontSetClass();
            if (fontSetClass != this._previousFontSetClass) {
                if (this._previousFontSetClass) {
                    elem.classList.remove(this._previousFontSetClass);
                }
                if (fontSetClass) {
                    elem.classList.add(fontSetClass);
                }
                this._previousFontSetClass = fontSetClass;
            }
            if (this.fontIcon != this._previousFontIconClass) {
                if (this._previousFontIconClass) {
                    elem.classList.remove(this._previousFontIconClass);
                }
                if (this.fontIcon) {
                    elem.classList.add(this.fontIcon);
                }
                this._previousFontIconClass = this.fontIcon;
            }
        };
        /**
         * Cleans up a value to be used as a fontIcon or fontSet.
         * Since the value ends up being assigned as a CSS class, we
         * have to trim the value and omit space-separated values.
         * @param {?} value
         * @return {?}
         */
        MatIcon.prototype._cleanupFontValue = /**
         * Cleans up a value to be used as a fontIcon or fontSet.
         * Since the value ends up being assigned as a CSS class, we
         * have to trim the value and omit space-separated values.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            return typeof value === 'string' ? value.trim().split(' ')[0] : value;
        };
        MatIcon.decorators = [
            { type: core.Component, args: [{template: '<ng-content></ng-content>',
                        selector: 'mat-icon',
                        exportAs: 'matIcon',
                        styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px}.mat-icon.mat-icon-inline{font-size:inherit;height:inherit;line-height:inherit;width:inherit}[dir=rtl] .mat-icon-rtl-mirror{transform:scale(-1,1)}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon{display:block}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-icon{margin:auto}"],
                        inputs: ['color'],
                        host: {
                            'role': 'img',
                            'class': 'mat-icon',
                            '[class.mat-icon-inline]': 'inline',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatIcon.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: MatIconRegistry, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['aria-hidden',] },] },
        ]; };
        MatIcon.propDecorators = {
            "inline": [{ type: core.Input },],
            "svgIcon": [{ type: core.Input },],
            "fontSet": [{ type: core.Input },],
            "fontIcon": [{ type: core.Input },],
        };
        return MatIcon;
    }(_MatIconMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatIconModule = /** @class */ (function () {
        function MatIconModule() {
        }
        MatIconModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatCommonModule],
                        exports: [MatIcon, MatCommonModule],
                        declarations: [MatIcon],
                    },] },
        ];
        return MatIconModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatListBase = /** @class */ (function () {
        function MatListBase() {
        }
        return MatListBase;
    }());
    var /** @type {?} */ _MatListMixinBase = mixinDisableRipple(MatListBase);
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatListItemBase = /** @class */ (function () {
        function MatListItemBase() {
        }
        return MatListItemBase;
    }());
    var /** @type {?} */ _MatListItemMixinBase = mixinDisableRipple(MatListItemBase);
    var MatNavList = /** @class */ (function (_super) {
        __extends(MatNavList, _super);
        function MatNavList() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatNavList.decorators = [
            { type: core.Component, args: [{selector: 'mat-nav-list',
                        exportAs: 'matNavList',
                        host: {
                            'role': 'navigation',
                            'class': 'mat-nav-list'
                        },
                        template: "<ng-content></ng-content>",
                        styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
                        inputs: ['disableRipple'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        return MatNavList;
    }(_MatListMixinBase));
    var MatList = /** @class */ (function (_super) {
        __extends(MatList, _super);
        function MatList() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatList.decorators = [
            { type: core.Component, args: [{selector: 'mat-list',
                        exportAs: 'matList',
                        template: "<ng-content></ng-content>",
                        host: { 'class': 'mat-list' },
                        styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
                        inputs: ['disableRipple'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        return MatList;
    }(_MatListMixinBase));
    /**
     * Directive whose purpose is to add the mat- CSS styling to this selector.
     * \@docs-private
     */
    var MatListAvatarCssMatStyler = /** @class */ (function () {
        function MatListAvatarCssMatStyler() {
        }
        MatListAvatarCssMatStyler.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-list-avatar], [matListAvatar]',
                        host: { 'class': 'mat-list-avatar' }
                    },] },
        ];
        return MatListAvatarCssMatStyler;
    }());
    /**
     * An item within a Material Design list.
     */
    var MatListItem = /** @class */ (function (_super) {
        __extends(MatListItem, _super);
        function MatListItem(_element, _navList) {
            var _this = _super.call(this) || this;
            _this._element = _element;
            _this._navList = _navList;
            _this._isNavList = false;
            _this._isNavList = !!_navList;
            return _this;
        }
        /**
         * @return {?}
         */
        MatListItem.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            // TODO: consider turning the setter into a function, it doesn't do anything as a class.
            // tslint:disable-next-line:no-unused-expression
            new MatLineSetter(this._lines, this._element);
        };
        /** Whether this list item should show a ripple effect when clicked. */
        /**
         * Whether this list item should show a ripple effect when clicked.
         * @return {?}
         */
        MatListItem.prototype._isRippleDisabled = /**
         * Whether this list item should show a ripple effect when clicked.
         * @return {?}
         */
        function () {
            return !this._isNavList || this.disableRipple || this._navList.disableRipple;
        };
        /**
         * @return {?}
         */
        MatListItem.prototype._handleFocus = /**
         * @return {?}
         */
        function () {
            this._element.nativeElement.classList.add('mat-list-item-focus');
        };
        /**
         * @return {?}
         */
        MatListItem.prototype._handleBlur = /**
         * @return {?}
         */
        function () {
            this._element.nativeElement.classList.remove('mat-list-item-focus');
        };
        /** Retrieves the DOM element of the component host. */
        /**
         * Retrieves the DOM element of the component host.
         * @return {?}
         */
        MatListItem.prototype._getHostElement = /**
         * Retrieves the DOM element of the component host.
         * @return {?}
         */
        function () {
            return this._element.nativeElement;
        };
        MatListItem.decorators = [
            { type: core.Component, args: [{selector: 'mat-list-item, a[mat-list-item]',
                        exportAs: 'matListItem',
                        host: {
                            'class': 'mat-list-item',
                            // @deletion-target 7.0.0 Remove `mat-list-item-avatar` in favor of `mat-list-item-with-avatar`.
                            '[class.mat-list-item-avatar]': '_avatar',
                            '[class.mat-list-item-with-avatar]': '_avatar',
                            '(focus)': '_handleFocus()',
                            '(blur)': '_handleBlur()',
                        },
                        inputs: ['disableRipple'],
                        template: "<div class=\"mat-list-item-content\"><div class=\"mat-list-item-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><ng-content select=\"[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]\"></ng-content><div class=\"mat-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content></div>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatListItem.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: MatNavList, decorators: [{ type: core.Optional },] },
        ]; };
        MatListItem.propDecorators = {
            "_lines": [{ type: core.ContentChildren, args: [MatLine,] },],
            "_avatar": [{ type: core.ContentChild, args: [MatListAvatarCssMatStyler,] },],
        };
        return MatListItem;
    }(_MatListItemMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSelectionListBase = /** @class */ (function () {
        function MatSelectionListBase() {
        }
        return MatSelectionListBase;
    }());
    var /** @type {?} */ _MatSelectionListMixinBase = mixinDisableRipple(mixinDisabled(MatSelectionListBase));
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatListOptionBase = /** @class */ (function () {
        function MatListOptionBase() {
        }
        return MatListOptionBase;
    }());
    var /** @type {?} */ _MatListOptionMixinBase = mixinDisableRipple(MatListOptionBase);
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_SELECTION_LIST_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatSelectionList; }),
        multi: true
    };
    /**
     * Change event that is being fired whenever the selected state of an option changes.
     */
    var  /**
     * Change event that is being fired whenever the selected state of an option changes.
     */
    MatSelectionListChange = /** @class */ (function () {
        function MatSelectionListChange(source, option) {
            this.source = source;
            this.option = option;
        }
        return MatSelectionListChange;
    }());
    /**
     * Component for list-options of selection-list. Each list-option can automatically
     * generate a checkbox and can put current item into the selectionModel of selection-list
     * if the current item is selected.
     */
    var MatListOption = /** @class */ (function (_super) {
        __extends(MatListOption, _super);
        function MatListOption(_element, _changeDetector, /** @docs-private */
        selectionList) {
            var _this = _super.call(this) || this;
            _this._element = _element;
            _this._changeDetector = _changeDetector;
            _this.selectionList = selectionList;
            _this._selected = false;
            _this._disabled = false;
            /**
             * Whether the option has focus.
             */
            _this._hasFocus = false;
            /**
             * Whether the label should appear before or after the checkbox. Defaults to 'after'
             */
            _this.checkboxPosition = 'after';
            return _this;
        }
        Object.defineProperty(MatListOption.prototype, "disabled", {
            get: /**
             * Whether the option is disabled.
             * @return {?}
             */
            function () { return this._disabled || (this.selectionList && this.selectionList.disabled); },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newValue = coerceBooleanProperty(value);
                if (newValue !== this._disabled) {
                    this._disabled = newValue;
                    this._changeDetector.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatListOption.prototype, "selected", {
            get: /**
             * Whether the option is selected.
             * @return {?}
             */
            function () { return this.selectionList.selectedOptions.isSelected(this); },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ isSelected = coerceBooleanProperty(value);
                if (isSelected !== this._selected) {
                    this._setSelected(isSelected);
                    this.selectionList._reportValueChange();
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatListOption.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            // List options that are selected at initialization can't be reported properly to the form
            // control. This is because it takes some time until the selection-list knows about all
            // available options. Also it can happen that the ControlValueAccessor has an initial value
            // that should be used instead. Deferring the value change report to the next tick ensures
            // that the form control value is not being overwritten.
            var /** @type {?} */ wasSelected = this._selected;
            Promise.resolve().then(function () {
                if (_this._selected || wasSelected) {
                    _this.selected = true;
                    _this._changeDetector.markForCheck();
                }
            });
        };
        /**
         * @return {?}
         */
        MatListOption.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            // TODO: consider turning the setter into a function, it doesn't do anything as a class.
            // tslint:disable-next-line:no-unused-expression
            new MatLineSetter(this._lines, this._element);
        };
        /**
         * @return {?}
         */
        MatListOption.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this.selected) {
                // We have to delay this until the next tick in order
                // to avoid changed after checked errors.
                Promise.resolve().then(function () { return _this.selected = false; });
            }
            this.selectionList._removeOptionFromList(this);
        };
        /** Toggles the selection state of the option. */
        /**
         * Toggles the selection state of the option.
         * @return {?}
         */
        MatListOption.prototype.toggle = /**
         * Toggles the selection state of the option.
         * @return {?}
         */
        function () {
            this.selected = !this.selected;
        };
        /** Allows for programmatic focusing of the option. */
        /**
         * Allows for programmatic focusing of the option.
         * @return {?}
         */
        MatListOption.prototype.focus = /**
         * Allows for programmatic focusing of the option.
         * @return {?}
         */
        function () {
            this._element.nativeElement.focus();
        };
        /**
         * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
         * @docs-private
         */
        /**
         * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
         * \@docs-private
         * @return {?}
         */
        MatListOption.prototype.getLabel = /**
         * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
         * \@docs-private
         * @return {?}
         */
        function () {
            return this._text ? this._text.nativeElement.textContent : '';
        };
        /** Whether this list item should show a ripple effect when clicked. */
        /**
         * Whether this list item should show a ripple effect when clicked.
         * @return {?}
         */
        MatListOption.prototype._isRippleDisabled = /**
         * Whether this list item should show a ripple effect when clicked.
         * @return {?}
         */
        function () {
            return this.disabled || this.disableRipple || this.selectionList.disableRipple;
        };
        /**
         * @return {?}
         */
        MatListOption.prototype._handleClick = /**
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this.toggle();
                // Emit a change event if the selected state of the option changed through user interaction.
                this.selectionList._emitChangeEvent(this);
            }
        };
        /**
         * @return {?}
         */
        MatListOption.prototype._handleFocus = /**
         * @return {?}
         */
        function () {
            this._hasFocus = true;
            this.selectionList._setFocusedOption(this);
        };
        /**
         * @return {?}
         */
        MatListOption.prototype._handleBlur = /**
         * @return {?}
         */
        function () {
            this._hasFocus = false;
            this.selectionList._onTouched();
        };
        /** Retrieves the DOM element of the component host. */
        /**
         * Retrieves the DOM element of the component host.
         * @return {?}
         */
        MatListOption.prototype._getHostElement = /**
         * Retrieves the DOM element of the component host.
         * @return {?}
         */
        function () {
            return this._element.nativeElement;
        };
        /** Sets the selected state of the option. Returns whether the value has changed. */
        /**
         * Sets the selected state of the option. Returns whether the value has changed.
         * @param {?} selected
         * @return {?}
         */
        MatListOption.prototype._setSelected = /**
         * Sets the selected state of the option. Returns whether the value has changed.
         * @param {?} selected
         * @return {?}
         */
        function (selected) {
            if (selected === this._selected) {
                return false;
            }
            this._selected = selected;
            if (selected) {
                this.selectionList.selectedOptions.select(this);
            }
            else {
                this.selectionList.selectedOptions.deselect(this);
            }
            this._changeDetector.markForCheck();
            return true;
        };
        MatListOption.decorators = [
            { type: core.Component, args: [{selector: 'mat-list-option',
                        exportAs: 'matListOption',
                        inputs: ['disableRipple'],
                        host: {
                            'role': 'option',
                            'class': 'mat-list-item mat-list-option',
                            '(focus)': '_handleFocus()',
                            '(blur)': '_handleBlur()',
                            '(click)': '_handleClick()',
                            'tabindex': '-1',
                            '[class.mat-list-item-disabled]': 'disabled',
                            '[class.mat-list-item-focus]': '_hasFocus',
                            '[attr.aria-selected]': 'selected.toString()',
                            '[attr.aria-disabled]': 'disabled.toString()',
                        },
                        template: "<div class=\"mat-list-item-content\" [class.mat-list-item-content-reverse]=\"checkboxPosition == 'after'\"><div mat-ripple class=\"mat-list-item-ripple\" [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><mat-pseudo-checkbox [state]=\"selected ? 'checked' : 'unchecked'\" [disabled]=\"disabled\"></mat-pseudo-checkbox><div class=\"mat-list-text\" #text><ng-content></ng-content></div></div>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatListOption.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: MatSelectionList, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatSelectionList; }),] },] },
        ]; };
        MatListOption.propDecorators = {
            "_lines": [{ type: core.ContentChildren, args: [MatLine,] },],
            "_text": [{ type: core.ViewChild, args: ['text',] },],
            "checkboxPosition": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
        };
        return MatListOption;
    }(_MatListOptionMixinBase));
    /**
     * Material Design list component where each item is a selectable option. Behaves as a listbox.
     */
    var MatSelectionList = /** @class */ (function (_super) {
        __extends(MatSelectionList, _super);
        function MatSelectionList(_element, tabIndex) {
            var _this = _super.call(this) || this;
            _this._element = _element;
            /**
             * Emits a change event whenever the selected state of an option changes.
             */
            _this.selectionChange = new core.EventEmitter();
            /**
             * Tabindex of the selection list.
             */
            _this.tabIndex = 0;
            /**
             * The currently selected options.
             */
            _this.selectedOptions = new SelectionModel(true);
            /**
             * View to model callback that should be called whenever the selected options change.
             */
            _this._onChange = function (_) { };
            _this._modelChanges = rxjs.Subscription.EMPTY;
            /**
             * View to model callback that should be called if the list or its options lost focus.
             */
            _this._onTouched = function () { };
            _this.tabIndex = parseInt(tabIndex) || 0;
            return _this;
        }
        /**
         * @return {?}
         */
        MatSelectionList.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._keyManager = new FocusKeyManager(this.options)
                .withWrap()
                .withTypeAhead()
                .skipPredicate(function () { return false; });
            if (this._tempValues) {
                this._setOptionsFromValues(this._tempValues);
                this._tempValues = null;
            }
            // Sync external changes to the model back to the options.
            this._modelChanges = /** @type {?} */ ((this.selectedOptions.onChange)).subscribe(function (event) {
                if (event.added) {
                    for (var _i = 0, _a = event.added; _i < _a.length; _i++) {
                        var item = _a[_i];
                        item.selected = true;
                    }
                }
                if (event.removed) {
                    for (var _b = 0, _c = event.removed; _b < _c.length; _b++) {
                        var item = _c[_b];
                        item.selected = false;
                    }
                }
            });
        };
        /**
         * @return {?}
         */
        MatSelectionList.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._modelChanges.unsubscribe();
        };
        /** Focuses the last active list option. */
        /**
         * Focuses the last active list option.
         * @return {?}
         */
        MatSelectionList.prototype.focus = /**
         * Focuses the last active list option.
         * @return {?}
         */
        function () {
            this._element.nativeElement.focus();
        };
        /** Selects all of the options. */
        /**
         * Selects all of the options.
         * @return {?}
         */
        MatSelectionList.prototype.selectAll = /**
         * Selects all of the options.
         * @return {?}
         */
        function () {
            this._setAllOptionsSelected(true);
        };
        /** Deselects all of the options. */
        /**
         * Deselects all of the options.
         * @return {?}
         */
        MatSelectionList.prototype.deselectAll = /**
         * Deselects all of the options.
         * @return {?}
         */
        function () {
            this._setAllOptionsSelected(false);
        };
        /** Sets the focused option of the selection-list. */
        /**
         * Sets the focused option of the selection-list.
         * @param {?} option
         * @return {?}
         */
        MatSelectionList.prototype._setFocusedOption = /**
         * Sets the focused option of the selection-list.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            this._keyManager.updateActiveItemIndex(this._getOptionIndex(option));
        };
        /** Removes an option from the selection list and updates the active item. */
        /**
         * Removes an option from the selection list and updates the active item.
         * @param {?} option
         * @return {?}
         */
        MatSelectionList.prototype._removeOptionFromList = /**
         * Removes an option from the selection list and updates the active item.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            if (option._hasFocus) {
                var /** @type {?} */ optionIndex = this._getOptionIndex(option);
                // Check whether the option is the last item
                if (optionIndex > 0) {
                    this._keyManager.setPreviousItemActive();
                }
                else if (optionIndex === 0 && this.options.length > 1) {
                    this._keyManager.setNextItemActive();
                }
            }
        };
        /** Passes relevant key presses to our key manager. */
        /**
         * Passes relevant key presses to our key manager.
         * @param {?} event
         * @return {?}
         */
        MatSelectionList.prototype._keydown = /**
         * Passes relevant key presses to our key manager.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            var /** @type {?} */ manager = this._keyManager;
            var /** @type {?} */ previousFocusIndex = manager.activeItemIndex;
            switch (keyCode) {
                case SPACE:
                case ENTER:
                    if (!this.disabled) {
                        this._toggleSelectOnFocusedOption();
                        // Always prevent space from scrolling the page since the list has focus
                        event.preventDefault();
                    }
                    break;
                case HOME:
                case END:
                    keyCode === HOME ? manager.setFirstItemActive() : manager.setLastItemActive();
                    event.preventDefault();
                    break;
                case A:
                    if (event.ctrlKey) {
                        this.options.find(function (option) { return !option.selected; }) ? this.selectAll() : this.deselectAll();
                        event.preventDefault();
                    }
                    break;
                default:
                    manager.onKeydown(event);
            }
            if ((keyCode === UP_ARROW || keyCode === DOWN_ARROW) && event.shiftKey &&
                manager.activeItemIndex !== previousFocusIndex) {
                this._toggleSelectOnFocusedOption();
            }
        };
        /** Reports a value change to the ControlValueAccessor */
        /**
         * Reports a value change to the ControlValueAccessor
         * @return {?}
         */
        MatSelectionList.prototype._reportValueChange = /**
         * Reports a value change to the ControlValueAccessor
         * @return {?}
         */
        function () {
            if (this.options) {
                this._onChange(this._getSelectedOptionValues());
            }
        };
        /** Emits a change event if the selected state of an option changed. */
        /**
         * Emits a change event if the selected state of an option changed.
         * @param {?} option
         * @return {?}
         */
        MatSelectionList.prototype._emitChangeEvent = /**
         * Emits a change event if the selected state of an option changed.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            this.selectionChange.emit(new MatSelectionListChange(this, option));
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} values
         * @return {?}
         */
        MatSelectionList.prototype.writeValue = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} values
         * @return {?}
         */
        function (values) {
            if (this.options) {
                this._setOptionsFromValues(values || []);
            }
            else {
                this._tempValues = values;
            }
        };
        /** Implemented as a part of ControlValueAccessor. */
        /**
         * Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        MatSelectionList.prototype.setDisabledState = /**
         * Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            if (this.options) {
                this.options.forEach(function (option) { return option.disabled = isDisabled; });
            }
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        MatSelectionList.prototype.registerOnChange = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onChange = fn;
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        MatSelectionList.prototype.registerOnTouched = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        /**
         * Sets the selected options based on the specified values.
         * @param {?} values
         * @return {?}
         */
        MatSelectionList.prototype._setOptionsFromValues = /**
         * Sets the selected options based on the specified values.
         * @param {?} values
         * @return {?}
         */
        function (values) {
            var _this = this;
            this.options.forEach(function (option) { return option._setSelected(false); });
            values
                .map(function (value) {
                return _this.options.find(function (option) {
                    return _this.compareWith ? _this.compareWith(option.value, value) : option.value === value;
                });
            })
                .filter(Boolean)
                .forEach(function (option) { return ((option))._setSelected(true); });
        };
        /**
         * Returns the values of the selected options.
         * @return {?}
         */
        MatSelectionList.prototype._getSelectedOptionValues = /**
         * Returns the values of the selected options.
         * @return {?}
         */
        function () {
            return this.options.filter(function (option) { return option.selected; }).map(function (option) { return option.value; });
        };
        /**
         * Toggles the selected state of the currently focused option.
         * @return {?}
         */
        MatSelectionList.prototype._toggleSelectOnFocusedOption = /**
         * Toggles the selected state of the currently focused option.
         * @return {?}
         */
        function () {
            var /** @type {?} */ focusedIndex = this._keyManager.activeItemIndex;
            if (focusedIndex != null && this._isValidIndex(focusedIndex)) {
                var /** @type {?} */ focusedOption = this.options.toArray()[focusedIndex];
                if (focusedOption) {
                    focusedOption.toggle();
                    // Emit a change event because the focused option changed its state through user
                    // interaction.
                    this._emitChangeEvent(focusedOption);
                }
            }
        };
        /**
         * Sets the selected state on all of the options
         * and emits an event if anything changed.
         * @param {?} isSelected
         * @return {?}
         */
        MatSelectionList.prototype._setAllOptionsSelected = /**
         * Sets the selected state on all of the options
         * and emits an event if anything changed.
         * @param {?} isSelected
         * @return {?}
         */
        function (isSelected) {
            // Keep track of whether anything changed, because we only want to
            // emit the changed event when something actually changed.
            var /** @type {?} */ hasChanged = false;
            this.options.forEach(function (option) {
                if (option._setSelected(isSelected)) {
                    hasChanged = true;
                }
            });
            if (hasChanged) {
                this._reportValueChange();
            }
        };
        /**
         * Utility to ensure all indexes are valid.
         * @param {?} index The index to be checked.
         * @return {?} True if the index is valid for our list of options.
         */
        MatSelectionList.prototype._isValidIndex = /**
         * Utility to ensure all indexes are valid.
         * @param {?} index The index to be checked.
         * @return {?} True if the index is valid for our list of options.
         */
        function (index) {
            return index >= 0 && index < this.options.length;
        };
        /**
         * Returns the index of the specified list option.
         * @param {?} option
         * @return {?}
         */
        MatSelectionList.prototype._getOptionIndex = /**
         * Returns the index of the specified list option.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            return this.options.toArray().indexOf(option);
        };
        MatSelectionList.decorators = [
            { type: core.Component, args: [{selector: 'mat-selection-list',
                        exportAs: 'matSelectionList',
                        inputs: ['disabled', 'disableRipple', 'tabIndex'],
                        host: {
                            'role': 'listbox',
                            '[tabIndex]': 'tabIndex',
                            'class': 'mat-selection-list',
                            '(focus)': 'focus()',
                            '(blur)': '_onTouched()',
                            '(keydown)': '_keydown($event)',
                            '[attr.aria-disabled]': 'disabled.toString()',
                        },
                        template: '<ng-content></ng-content>',
                        styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
                        encapsulation: core.ViewEncapsulation.None,
                        providers: [MAT_SELECTION_LIST_VALUE_ACCESSOR],
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        MatSelectionList.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
        ]; };
        MatSelectionList.propDecorators = {
            "options": [{ type: core.ContentChildren, args: [MatListOption,] },],
            "selectionChange": [{ type: core.Output },],
            "tabIndex": [{ type: core.Input },],
            "compareWith": [{ type: core.Input },],
        };
        return MatSelectionList;
    }(_MatSelectionListMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Menu content that will be rendered lazily once the menu is opened.
     */
    var MatMenuContent = /** @class */ (function () {
        function MatMenuContent(_template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document) {
            this._template = _template;
            this._componentFactoryResolver = _componentFactoryResolver;
            this._appRef = _appRef;
            this._injector = _injector;
            this._viewContainerRef = _viewContainerRef;
            this._document = _document;
        }
        /**
         * Attaches the content with a particular context.
         * @docs-private
         */
        /**
         * Attaches the content with a particular context.
         * \@docs-private
         * @param {?=} context
         * @return {?}
         */
        MatMenuContent.prototype.attach = /**
         * Attaches the content with a particular context.
         * \@docs-private
         * @param {?=} context
         * @return {?}
         */
        function (context) {
            if (context === void 0) { context = {}; }
            if (!this._portal) {
                this._portal = new TemplatePortal(this._template, this._viewContainerRef);
            }
            this.detach();
            if (!this._outlet) {
                this._outlet = new DomPortalOutlet(this._document.createElement('div'), this._componentFactoryResolver, this._appRef, this._injector);
            }
            var /** @type {?} */ element = this._template.elementRef.nativeElement; /** @type {?} */
            ((
            // Because we support opening the same menu from different triggers (which in turn have their
            // own `OverlayRef` panel), we have to re-insert the host element every time, otherwise we
            // risk it staying attached to a pane that's no longer in the DOM.
            element.parentNode)).insertBefore(this._outlet.outletElement, element);
            this._portal.attach(this._outlet, context);
        };
        /**
         * Detaches the content.
         * @docs-private
         */
        /**
         * Detaches the content.
         * \@docs-private
         * @return {?}
         */
        MatMenuContent.prototype.detach = /**
         * Detaches the content.
         * \@docs-private
         * @return {?}
         */
        function () {
            if (this._portal.isAttached) {
                this._portal.detach();
            }
        };
        /**
         * @return {?}
         */
        MatMenuContent.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._outlet) {
                this._outlet.dispose();
            }
        };
        MatMenuContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'ng-template[matMenuContent]'
                    },] },
        ];
        /** @nocollapse */
        MatMenuContent.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.ComponentFactoryResolver, },
            { type: core.ApplicationRef, },
            { type: core.Injector, },
            { type: core.ViewContainerRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        return MatMenuContent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the mat-menu component.
     * Animation duration and timing values are based on:
     * https://material.io/guidelines/components/menus.html#menus-usage
     */
    var /** @type {?} */ matMenuAnimations = {
        /**
           * This animation controls the menu panel's entry and exit from the page.
           *
           * When the menu panel is added to the DOM, it scales in and fades in its border.
           *
           * When the menu panel is removed from the DOM, it simply fades out after a brief
           * delay to display the ripple.
           */
        transformMenu: trigger('transformMenu', [
            state('void', style({
                opacity: 0,
                // This starts off from 0.01, instead of 0, because there's an issue in the Angular animations
                // as of 4.2, which causes the animation to be skipped if it starts from 0.
                transform: 'scale(0.01, 0.01)'
            })),
            transition('void => enter', sequence([
                query('.mat-menu-content', style({ opacity: 0 })),
                animate('100ms linear', style({ opacity: 1, transform: 'scale(1, 0.5)' })),
                group([
                    query('.mat-menu-content', animate('400ms cubic-bezier(0.55, 0, 0.55, 0.2)', style({ opacity: 1 }))),
                    animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ transform: 'scale(1, 1)' })),
                ])
            ])),
            transition('* => void', animate('150ms 50ms linear', style({ opacity: 0 })))
        ]),
        /**
           * This animation fades in the background color and content of the menu panel
           * after its containing element is scaled in.
           */
        fadeInItems: trigger('fadeInItems', [
            // TODO(crisbeto): this is inside the `transformMenu`
            // now. Remove next time we do breaking changes.
            state('showing', style({ opacity: 1 })),
            transition('void => *', [
                style({ opacity: 0 }),
                animate('400ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
            ])
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Throws an exception for the case when menu trigger doesn't have a valid mat-menu instance
     * \@docs-private
     * @return {?}
     */
    function throwMatMenuMissingError() {
        throw Error("mat-menu-trigger: must pass in an mat-menu instance.\n\n    Example:\n      <mat-menu #menu=\"matMenu\"></mat-menu>\n      <button [matMenuTriggerFor]=\"menu\"></button>");
    }
    /**
     * Throws an exception for the case when menu's x-position value isn't valid.
     * In other words, it doesn't match 'before' or 'after'.
     * \@docs-private
     * @return {?}
     */
    function throwMatMenuInvalidPositionX() {
        throw Error("x-position value must be either 'before' or after'.\n      Example: <mat-menu x-position=\"before\" #menu=\"matMenu\"></mat-menu>");
    }
    /**
     * Throws an exception for the case when menu's y-position value isn't valid.
     * In other words, it doesn't match 'above' or 'below'.
     * \@docs-private
     * @return {?}
     */
    function throwMatMenuInvalidPositionY() {
        throw Error("y-position value must be either 'above' or below'.\n      Example: <mat-menu y-position=\"above\" #menu=\"matMenu\"></mat-menu>");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token used to provide the parent menu to menu-specific components.
     * \@docs-private
     */
    var /** @type {?} */ MAT_MENU_PANEL = new core.InjectionToken('MAT_MENU_PANEL');

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatMenuItemBase = /** @class */ (function () {
        function MatMenuItemBase() {
        }
        return MatMenuItemBase;
    }());
    var /** @type {?} */ _MatMenuItemMixinBase = mixinDisableRipple(mixinDisabled(MatMenuItemBase));
    /**
     * This directive is intended to be used inside an mat-menu tag.
     * It exists mostly to set the role attribute.
     */
    var MatMenuItem = /** @class */ (function (_super) {
        __extends(MatMenuItem, _super);
        function MatMenuItem(_elementRef, document, _focusMonitor, _parentMenu) {
            var _this = 
            // @deletion-target 7.0.0 make `_focusMonitor` and `document` required params.
            _super.call(this) || this;
            _this._elementRef = _elementRef;
            _this._focusMonitor = _focusMonitor;
            _this._parentMenu = _parentMenu;
            /**
             * Stream that emits when the menu item is hovered.
             */
            _this._hovered = new rxjs.Subject();
            /**
             * Whether the menu item is highlighted.
             */
            _this._highlighted = false;
            /**
             * Whether the menu item acts as a trigger for a sub-menu.
             */
            _this._triggersSubmenu = false;
            if (_focusMonitor) {
                // Start monitoring the element so it gets the appropriate focused classes. We want
                // to show the focus style for menu items only when the focus was not caused by a
                // mouse or touch interaction.
                _focusMonitor.monitor(_this._getHostElement(), false);
            }
            if (_parentMenu && _parentMenu.addItem) {
                _parentMenu.addItem(_this);
            }
            _this._document = document;
            return _this;
        }
        /** Focuses the menu item. */
        /**
         * Focuses the menu item.
         * @param {?=} origin
         * @return {?}
         */
        MatMenuItem.prototype.focus = /**
         * Focuses the menu item.
         * @param {?=} origin
         * @return {?}
         */
        function (origin) {
            if (origin === void 0) { origin = 'program'; }
            if (this._focusMonitor) {
                this._focusMonitor.focusVia(this._getHostElement(), origin);
            }
            else {
                this._getHostElement().focus();
            }
        };
        /**
         * @return {?}
         */
        MatMenuItem.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._focusMonitor) {
                this._focusMonitor.stopMonitoring(this._getHostElement());
            }
            if (this._parentMenu && this._parentMenu.removeItem) {
                this._parentMenu.removeItem(this);
            }
            this._hovered.complete();
        };
        /** Used to set the `tabindex`. */
        /**
         * Used to set the `tabindex`.
         * @return {?}
         */
        MatMenuItem.prototype._getTabIndex = /**
         * Used to set the `tabindex`.
         * @return {?}
         */
        function () {
            return this.disabled ? '-1' : '0';
        };
        /** Returns the host DOM element. */
        /**
         * Returns the host DOM element.
         * @return {?}
         */
        MatMenuItem.prototype._getHostElement = /**
         * Returns the host DOM element.
         * @return {?}
         */
        function () {
            return this._elementRef.nativeElement;
        };
        /** Prevents the default element actions if it is disabled. */
        /**
         * Prevents the default element actions if it is disabled.
         * @param {?} event
         * @return {?}
         */
        MatMenuItem.prototype._checkDisabled = /**
         * Prevents the default element actions if it is disabled.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        /** Emits to the hover stream. */
        /**
         * Emits to the hover stream.
         * @return {?}
         */
        MatMenuItem.prototype._handleMouseEnter = /**
         * Emits to the hover stream.
         * @return {?}
         */
        function () {
            this._hovered.next(this);
        };
        /** Gets the label to be used when determining whether the option should be focused. */
        /**
         * Gets the label to be used when determining whether the option should be focused.
         * @return {?}
         */
        MatMenuItem.prototype.getLabel = /**
         * Gets the label to be used when determining whether the option should be focused.
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this._elementRef.nativeElement;
            var /** @type {?} */ textNodeType = this._document ? this._document.TEXT_NODE : 3;
            var /** @type {?} */ output = '';
            if (element.childNodes) {
                var /** @type {?} */ length_1 = element.childNodes.length;
                // Go through all the top-level text nodes and extract their text.
                // We skip anything that's not a text node to prevent the text from
                // being thrown off by something like an icon.
                for (var /** @type {?} */ i = 0; i < length_1; i++) {
                    if (element.childNodes[i].nodeType === textNodeType) {
                        output += element.childNodes[i].textContent;
                    }
                }
            }
            return output.trim();
        };
        MatMenuItem.decorators = [
            { type: core.Component, args: [{selector: '[mat-menu-item]',
                        exportAs: 'matMenuItem',
                        inputs: ['disabled', 'disableRipple'],
                        host: {
                            'role': 'menuitem',
                            'class': 'mat-menu-item',
                            '[class.mat-menu-item-highlighted]': '_highlighted',
                            '[class.mat-menu-item-submenu-trigger]': '_triggersSubmenu',
                            '[attr.tabindex]': '_getTabIndex()',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.disabled]': 'disabled || null',
                            '(click)': '_checkDisabled($event)',
                            '(mouseenter)': '_handleMouseEnter()',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        template: "<ng-content></ng-content><div class=\"mat-menu-ripple\" matRipple [matRippleDisabled]=\"disableRipple || disabled\" [matRippleTrigger]=\"_getHostElement()\"></div>",
                    },] },
        ];
        /** @nocollapse */
        MatMenuItem.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: FocusMonitor, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_MENU_PANEL,] }, { type: core.Optional },] },
        ]; };
        return MatMenuItem;
    }(_MatMenuItemMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token to be used to override the default options for `mat-menu`.
     */
    var /** @type {?} */ MAT_MENU_DEFAULT_OPTIONS = new core.InjectionToken('mat-menu-default-options', {
        providedIn: 'root',
        factory: MAT_MENU_DEFAULT_OPTIONS_FACTORY
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_MENU_DEFAULT_OPTIONS_FACTORY() {
        return {
            overlapTrigger: true,
            xPosition: 'after',
            yPosition: 'below',
            backdropClass: 'cdk-overlay-transparent-backdrop',
        };
    }
    /**
     * Start elevation for the menu panel.
     * \@docs-private
     */
    var /** @type {?} */ MAT_MENU_BASE_ELEVATION = 2;
    var MatMenu = /** @class */ (function () {
        function MatMenu(_elementRef, _ngZone, _defaultOptions) {
            this._elementRef = _elementRef;
            this._ngZone = _ngZone;
            this._defaultOptions = _defaultOptions;
            this._xPosition = this._defaultOptions.xPosition;
            this._yPosition = this._defaultOptions.yPosition;
            /**
             * Menu items inside the current menu.
             */
            this._items = [];
            /**
             * Emits whenever the amount of menu items changes.
             */
            this._itemChanges = new rxjs.Subject();
            /**
             * Subscription to tab events on the menu panel
             */
            this._tabSubscription = rxjs.Subscription.EMPTY;
            /**
             * Config object to be passed into the menu's ngClass
             */
            this._classList = {};
            /**
             * Current state of the panel animation.
             */
            this._panelAnimationState = 'void';
            /**
             * Emits whenever an animation on the menu completes.
             */
            this._animationDone = new rxjs.Subject();
            /**
             * Class to be added to the backdrop element.
             */
            this.backdropClass = this._defaultOptions.backdropClass;
            this._overlapTrigger = this._defaultOptions.overlapTrigger;
            this._hasBackdrop = this._defaultOptions.hasBackdrop;
            /**
             * Event emitted when the menu is closed.
             */
            this.closed = new core.EventEmitter();
            /**
             * Event emitted when the menu is closed.
             * @deprecated Switch to `closed` instead
             * \@deletion-target 7.0.0
             */
            this.close = this.closed;
        }
        Object.defineProperty(MatMenu.prototype, "xPosition", {
            get: /**
             * Position of the menu in the X axis.
             * @return {?}
             */
            function () { return this._xPosition; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== 'before' && value !== 'after') {
                    throwMatMenuInvalidPositionX();
                }
                this._xPosition = value;
                this.setPositionClasses();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenu.prototype, "yPosition", {
            get: /**
             * Position of the menu in the Y axis.
             * @return {?}
             */
            function () { return this._yPosition; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== 'above' && value !== 'below') {
                    throwMatMenuInvalidPositionY();
                }
                this._yPosition = value;
                this.setPositionClasses();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenu.prototype, "overlapTrigger", {
            get: /**
             * Whether the menu should overlap its trigger.
             * @return {?}
             */
            function () { return this._overlapTrigger; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._overlapTrigger = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenu.prototype, "hasBackdrop", {
            get: /**
             * Whether the menu has a backdrop.
             * @return {?}
             */
            function () { return this._hasBackdrop; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._hasBackdrop = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenu.prototype, "panelClass", {
            set: /**
             * This method takes classes set on the host mat-menu element and applies them on the
             * menu template that displays in the overlay container.  Otherwise, it's difficult
             * to style the containing menu from outside the component.
             * @param {?} classes list of class names
             * @return {?}
             */
            function (classes) {
                if (classes && classes.length) {
                    this._classList = classes.split(' ').reduce(function (obj, className) {
                        obj[className] = true;
                        return obj;
                    }, {});
                    this._elementRef.nativeElement.className = '';
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenu.prototype, "classList", {
            get: /**
             * This method takes classes set on the host mat-menu element and applies them on the
             * menu template that displays in the overlay container.  Otherwise, it's difficult
             * to style the containing menu from outside the component.
             * @deprecated Use `panelClass` instead.
             * \@deletion-target 7.0.0
             * @return {?}
             */
            function () { return this.panelClass; },
            set: /**
             * @param {?} classes
             * @return {?}
             */
            function (classes) { this.panelClass = classes; },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatMenu.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.setPositionClasses();
        };
        /**
         * @return {?}
         */
        MatMenu.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._keyManager = new FocusKeyManager(this._items).withWrap().withTypeAhead();
            this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this.closed.emit('tab'); });
        };
        /**
         * @return {?}
         */
        MatMenu.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._tabSubscription.unsubscribe();
            this.closed.complete();
        };
        /** Stream that emits whenever the hovered menu item changes. */
        /**
         * Stream that emits whenever the hovered menu item changes.
         * @return {?}
         */
        MatMenu.prototype._hovered = /**
         * Stream that emits whenever the hovered menu item changes.
         * @return {?}
         */
        function () {
            return this._itemChanges.pipe(operators.startWith(this._items), operators.switchMap(function (items) { return rxjs.merge.apply(void 0, items.map(function (item) { return item._hovered; })); }));
        };
        /** Handle a keyboard event from the menu, delegating to the appropriate action. */
        /**
         * Handle a keyboard event from the menu, delegating to the appropriate action.
         * @param {?} event
         * @return {?}
         */
        MatMenu.prototype._handleKeydown = /**
         * Handle a keyboard event from the menu, delegating to the appropriate action.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            switch (keyCode) {
                case ESCAPE:
                    this.closed.emit('keydown');
                    event.stopPropagation();
                    break;
                case LEFT_ARROW:
                    if (this.parentMenu && this.direction === 'ltr') {
                        this.closed.emit('keydown');
                    }
                    break;
                case RIGHT_ARROW:
                    if (this.parentMenu && this.direction === 'rtl') {
                        this.closed.emit('keydown');
                    }
                    break;
                default:
                    if (keyCode === UP_ARROW || keyCode === DOWN_ARROW) {
                        this._keyManager.setFocusOrigin('keyboard');
                    }
                    this._keyManager.onKeydown(event);
            }
        };
        /**
         * Focus the first item in the menu.
         * @param origin Action from which the focus originated. Used to set the correct styling.
         */
        /**
         * Focus the first item in the menu.
         * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
         * @return {?}
         */
        MatMenu.prototype.focusFirstItem = /**
         * Focus the first item in the menu.
         * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
         * @return {?}
         */
        function (origin) {
            var _this = this;
            if (origin === void 0) { origin = 'program'; }
            // When the content is rendered lazily, it takes a bit before the items are inside the DOM.
            if (this.lazyContent) {
                this._ngZone.onStable.asObservable()
                    .pipe(operators.take(1))
                    .subscribe(function () { return _this._keyManager.setFocusOrigin(origin).setFirstItemActive(); });
            }
            else {
                this._keyManager.setFocusOrigin(origin).setFirstItemActive();
            }
        };
        /**
         * Resets the active item in the menu. This is used when the menu is opened, allowing
         * the user to start from the first option when pressing the down arrow.
         */
        /**
         * Resets the active item in the menu. This is used when the menu is opened, allowing
         * the user to start from the first option when pressing the down arrow.
         * @return {?}
         */
        MatMenu.prototype.resetActiveItem = /**
         * Resets the active item in the menu. This is used when the menu is opened, allowing
         * the user to start from the first option when pressing the down arrow.
         * @return {?}
         */
        function () {
            this._keyManager.setActiveItem(-1);
        };
        /**
         * Sets the menu panel elevation.
         * @param depth Number of parent menus that come before the menu.
         */
        /**
         * Sets the menu panel elevation.
         * @param {?} depth Number of parent menus that come before the menu.
         * @return {?}
         */
        MatMenu.prototype.setElevation = /**
         * Sets the menu panel elevation.
         * @param {?} depth Number of parent menus that come before the menu.
         * @return {?}
         */
        function (depth) {
            // The elevation starts at the base and increases by one for each level.
            var /** @type {?} */ newElevation = "mat-elevation-z" + (MAT_MENU_BASE_ELEVATION + depth);
            var /** @type {?} */ customElevation = Object.keys(this._classList).find(function (c) { return c.startsWith('mat-elevation-z'); });
            if (!customElevation || customElevation === this._previousElevation) {
                if (this._previousElevation) {
                    this._classList[this._previousElevation] = false;
                }
                this._classList[newElevation] = true;
                this._previousElevation = newElevation;
            }
        };
        /**
         * Registers a menu item with the menu.
         * @docs-private
         */
        /**
         * Registers a menu item with the menu.
         * \@docs-private
         * @param {?} item
         * @return {?}
         */
        MatMenu.prototype.addItem = /**
         * Registers a menu item with the menu.
         * \@docs-private
         * @param {?} item
         * @return {?}
         */
        function (item) {
            // We register the items through this method, rather than picking them up through
            // `ContentChildren`, because we need the items to be picked up by their closest
            // `mat-menu` ancestor. If we used `@ContentChildren(MatMenuItem, {descendants: true})`,
            // all descendant items will bleed into the top-level menu in the case where the consumer
            // has `mat-menu` instances nested inside each other.
            if (this._items.indexOf(item) === -1) {
                this._items.push(item);
                this._itemChanges.next(this._items);
            }
        };
        /**
         * Removes an item from the menu.
         * @docs-private
         */
        /**
         * Removes an item from the menu.
         * \@docs-private
         * @param {?} item
         * @return {?}
         */
        MatMenu.prototype.removeItem = /**
         * Removes an item from the menu.
         * \@docs-private
         * @param {?} item
         * @return {?}
         */
        function (item) {
            var /** @type {?} */ index = this._items.indexOf(item);
            if (this._items.indexOf(item) > -1) {
                this._items.splice(index, 1);
                this._itemChanges.next(this._items);
            }
        };
        /**
         * Adds classes to the menu panel based on its position. Can be used by
         * consumers to add specific styling based on the position.
         * @param posX Position of the menu along the x axis.
         * @param posY Position of the menu along the y axis.
         * @docs-private
         */
        /**
         * Adds classes to the menu panel based on its position. Can be used by
         * consumers to add specific styling based on the position.
         * \@docs-private
         * @param {?=} posX Position of the menu along the x axis.
         * @param {?=} posY Position of the menu along the y axis.
         * @return {?}
         */
        MatMenu.prototype.setPositionClasses = /**
         * Adds classes to the menu panel based on its position. Can be used by
         * consumers to add specific styling based on the position.
         * \@docs-private
         * @param {?=} posX Position of the menu along the x axis.
         * @param {?=} posY Position of the menu along the y axis.
         * @return {?}
         */
        function (posX, posY) {
            if (posX === void 0) { posX = this.xPosition; }
            if (posY === void 0) { posY = this.yPosition; }
            var /** @type {?} */ classes = this._classList;
            classes['mat-menu-before'] = posX === 'before';
            classes['mat-menu-after'] = posX === 'after';
            classes['mat-menu-above'] = posY === 'above';
            classes['mat-menu-below'] = posY === 'below';
        };
        /** Starts the enter animation. */
        /**
         * Starts the enter animation.
         * @return {?}
         */
        MatMenu.prototype._startAnimation = /**
         * Starts the enter animation.
         * @return {?}
         */
        function () {
            // @deletion-target 7.0.0 Combine with _resetAnimation.
            this._panelAnimationState = 'enter';
        };
        /** Resets the panel animation to its initial state. */
        /**
         * Resets the panel animation to its initial state.
         * @return {?}
         */
        MatMenu.prototype._resetAnimation = /**
         * Resets the panel animation to its initial state.
         * @return {?}
         */
        function () {
            // @deletion-target 7.0.0 Combine with _startAnimation.
            this._panelAnimationState = 'void';
        };
        /** Callback that is invoked when the panel animation completes. */
        /**
         * Callback that is invoked when the panel animation completes.
         * @param {?} event
         * @return {?}
         */
        MatMenu.prototype._onAnimationDone = /**
         * Callback that is invoked when the panel animation completes.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this._animationDone.next(event);
            this._isAnimating = false;
        };
        MatMenu.decorators = [
            { type: core.Component, args: [{selector: 'mat-menu',
                        template: "<ng-template><div class=\"mat-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_handleKeydown($event)\" (click)=\"closed.emit('click')\" [@transformMenu]=\"_panelAnimationState\" (@transformMenu.start)=\"_isAnimating = true\" (@transformMenu.done)=\"_onAnimationDone($event)\" tabindex=\"-1\" role=\"menu\"><div class=\"mat-menu-content\"><ng-content></ng-content></div></div></ng-template>",
                        styles: [".mat-menu-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 48px);border-radius:2px;outline:0}.mat-menu-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content{padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px;vertical-align:middle}.mat-menu-item .mat-icon svg{vertical-align:top}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px;margin-right:0}.mat-menu-item-submenu-trigger{padding-right:32px}.mat-menu-item-submenu-trigger::after{width:0;height:0;border-style:solid;border-width:5px 0 5px 5px;border-color:transparent transparent transparent currentColor;content:'';display:inline-block;position:absolute;top:50%;right:16px;transform:translateY(-50%)}[dir=rtl] .mat-menu-item-submenu-trigger{padding-right:16px;padding-left:32px}[dir=rtl] .mat-menu-item-submenu-trigger::after{right:auto;left:16px;transform:rotateY(180deg) translateY(-50%)}.mat-menu-panel.ng-animating .mat-menu-item-submenu-trigger{pointer-events:none}button.mat-menu-item{width:100%}.mat-menu-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matMenu',
                        animations: [
                            matMenuAnimations.transformMenu,
                            matMenuAnimations.fadeInItems
                        ],
                        providers: [
                            { provide: MAT_MENU_PANEL, useExisting: MatMenu }
                        ]
                    },] },
        ];
        /** @nocollapse */
        MatMenu.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_MENU_DEFAULT_OPTIONS,] },] },
        ]; };
        MatMenu.propDecorators = {
            "backdropClass": [{ type: core.Input },],
            "xPosition": [{ type: core.Input },],
            "yPosition": [{ type: core.Input },],
            "templateRef": [{ type: core.ViewChild, args: [core.TemplateRef,] },],
            "items": [{ type: core.ContentChildren, args: [MatMenuItem,] },],
            "lazyContent": [{ type: core.ContentChild, args: [MatMenuContent,] },],
            "overlapTrigger": [{ type: core.Input },],
            "hasBackdrop": [{ type: core.Input },],
            "panelClass": [{ type: core.Input, args: ['class',] },],
            "classList": [{ type: core.Input },],
            "closed": [{ type: core.Output },],
            "close": [{ type: core.Output },],
        };
        return MatMenu;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that determines the scroll handling while the menu is open.
     */
    var /** @type {?} */ MAT_MENU_SCROLL_STRATEGY = new core.InjectionToken('mat-menu-scroll-strategy');
    /**
     * \@docs-private
     * @param {?} overlay
     * @return {?}
     */
    function MAT_MENU_SCROLL_STRATEGY_FACTORY(overlay) {
        return function () { return overlay.scrollStrategies.reposition(); };
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER = {
        provide: MAT_MENU_SCROLL_STRATEGY,
        deps: [Overlay],
        useFactory: MAT_MENU_SCROLL_STRATEGY_FACTORY,
    };
    /**
     * Default top padding of the menu panel.
     */
    var /** @type {?} */ MENU_PANEL_TOP_PADDING = 8;
    /**
     * This directive is intended to be used in conjunction with an mat-menu tag.  It is
     * responsible for toggling the display of the provided menu instance.
     */
    var MatMenuTrigger = /** @class */ (function () {
        function MatMenuTrigger(_overlay, _element, _viewContainerRef, _scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
            this._overlay = _overlay;
            this._element = _element;
            this._viewContainerRef = _viewContainerRef;
            this._scrollStrategy = _scrollStrategy;
            this._parentMenu = _parentMenu;
            this._menuItemInstance = _menuItemInstance;
            this._dir = _dir;
            this._focusMonitor = _focusMonitor;
            this._overlayRef = null;
            this._menuOpen = false;
            this._closeSubscription = rxjs.Subscription.EMPTY;
            this._hoverSubscription = rxjs.Subscription.EMPTY;
            this._openedByMouse = false;
            /**
             * Event emitted when the associated menu is opened.
             */
            this.menuOpened = new core.EventEmitter();
            /**
             * Event emitted when the associated menu is opened.
             * @deprecated Switch to `menuOpened` instead
             * \@deletion-target 7.0.0
             */
            this.onMenuOpen = this.menuOpened;
            /**
             * Event emitted when the associated menu is closed.
             */
            this.menuClosed = new core.EventEmitter();
            /**
             * Event emitted when the associated menu is closed.
             * @deprecated Switch to `menuClosed` instead
             * \@deletion-target 7.0.0
             */
            this.onMenuClose = this.menuClosed;
            if (_menuItemInstance) {
                _menuItemInstance._triggersSubmenu = this.triggersSubmenu();
            }
        }
        Object.defineProperty(MatMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
            get: /**
             * @deprecated
             * \@deletion-target 7.0.0
             * @return {?}
             */
            function () {
                return this.menu;
            },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this.menu = v;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatMenuTrigger.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._checkMenu();
            this.menu.close.subscribe(function (reason) {
                _this._destroyMenu();
                // If a click closed the menu, we should close the entire chain of nested menus.
                if ((reason === 'click' || reason === 'tab') && _this._parentMenu) {
                    _this._parentMenu.closed.emit(reason);
                }
            });
            this._handleHover();
        };
        /**
         * @return {?}
         */
        MatMenuTrigger.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._overlayRef) {
                this._overlayRef.dispose();
                this._overlayRef = null;
            }
            this._cleanUpSubscriptions();
        };
        Object.defineProperty(MatMenuTrigger.prototype, "menuOpen", {
            /** Whether the menu is open. */
            get: /**
             * Whether the menu is open.
             * @return {?}
             */
            function () {
                return this._menuOpen;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatMenuTrigger.prototype, "dir", {
            /** The text direction of the containing app. */
            get: /**
             * The text direction of the containing app.
             * @return {?}
             */
            function () {
                return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
            },
            enumerable: true,
            configurable: true
        });
        /** Whether the menu triggers a sub-menu or a top-level one. */
        /**
         * Whether the menu triggers a sub-menu or a top-level one.
         * @return {?}
         */
        MatMenuTrigger.prototype.triggersSubmenu = /**
         * Whether the menu triggers a sub-menu or a top-level one.
         * @return {?}
         */
        function () {
            return !!(this._menuItemInstance && this._parentMenu);
        };
        /** Toggles the menu between the open and closed states. */
        /**
         * Toggles the menu between the open and closed states.
         * @return {?}
         */
        MatMenuTrigger.prototype.toggleMenu = /**
         * Toggles the menu between the open and closed states.
         * @return {?}
         */
        function () {
            return this._menuOpen ? this.closeMenu() : this.openMenu();
        };
        /** Opens the menu. */
        /**
         * Opens the menu.
         * @return {?}
         */
        MatMenuTrigger.prototype.openMenu = /**
         * Opens the menu.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._menuOpen) {
                return;
            }
            var /** @type {?} */ overlayRef = this._createOverlay();
            overlayRef.attach(this._portal);
            if (this.menu.lazyContent) {
                this.menu.lazyContent.attach(this.menuData);
            }
            this._closeSubscription = this._menuClosingActions().subscribe(function () { return _this.closeMenu(); });
            this._initMenu();
            if (this.menu instanceof MatMenu) {
                this.menu._startAnimation();
            }
        };
        /** Closes the menu. */
        /**
         * Closes the menu.
         * @return {?}
         */
        MatMenuTrigger.prototype.closeMenu = /**
         * Closes the menu.
         * @return {?}
         */
        function () {
            this.menu.close.emit();
        };
        /**
         * Focuses the menu trigger.
         * @param origin Source of the menu trigger's focus.
         */
        /**
         * Focuses the menu trigger.
         * @param {?=} origin Source of the menu trigger's focus.
         * @return {?}
         */
        MatMenuTrigger.prototype.focus = /**
         * Focuses the menu trigger.
         * @param {?=} origin Source of the menu trigger's focus.
         * @return {?}
         */
        function (origin) {
            if (origin === void 0) { origin = 'program'; }
            if (this._focusMonitor) {
                this._focusMonitor.focusVia(this._element.nativeElement, origin);
            }
            else {
                this._element.nativeElement.focus();
            }
        };
        /**
         * Closes the menu and does the necessary cleanup.
         * @return {?}
         */
        MatMenuTrigger.prototype._destroyMenu = /**
         * Closes the menu and does the necessary cleanup.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._overlayRef || !this.menuOpen) {
                return;
            }
            var /** @type {?} */ menu = this.menu;
            this._closeSubscription.unsubscribe();
            this._overlayRef.detach();
            if (menu instanceof MatMenu) {
                menu._resetAnimation();
                if (menu.lazyContent) {
                    // Wait for the exit animation to finish before detaching the content.
                    menu._animationDone
                        .pipe(operators.filter(function (event) { return event.toState === 'void'; }), operators.take(1))
                        .subscribe(function () {
                        /** @type {?} */ ((menu.lazyContent)).detach();
                        _this._resetMenu();
                    });
                }
                else {
                    this._resetMenu();
                }
            }
            else {
                this._resetMenu();
                if (menu.lazyContent) {
                    menu.lazyContent.detach();
                }
            }
        };
        /**
         * This method sets the menu state to open and focuses the first item if
         * the menu was opened via the keyboard.
         * @return {?}
         */
        MatMenuTrigger.prototype._initMenu = /**
         * This method sets the menu state to open and focuses the first item if
         * the menu was opened via the keyboard.
         * @return {?}
         */
        function () {
            this.menu.parentMenu = this.triggersSubmenu() ? this._parentMenu : undefined;
            this.menu.direction = this.dir;
            this._setMenuElevation();
            this._setIsMenuOpen(true);
            this.menu.focusFirstItem(this._openedByMouse ? 'mouse' : 'program');
        };
        /**
         * Updates the menu elevation based on the amount of parent menus that it has.
         * @return {?}
         */
        MatMenuTrigger.prototype._setMenuElevation = /**
         * Updates the menu elevation based on the amount of parent menus that it has.
         * @return {?}
         */
        function () {
            if (this.menu.setElevation) {
                var /** @type {?} */ depth = 0;
                var /** @type {?} */ parentMenu = this.menu.parentMenu;
                while (parentMenu) {
                    depth++;
                    parentMenu = parentMenu.parentMenu;
                }
                this.menu.setElevation(depth);
            }
        };
        /**
         * This method resets the menu when it's closed, most importantly restoring
         * focus to the menu trigger if the menu was opened via the keyboard.
         * @return {?}
         */
        MatMenuTrigger.prototype._resetMenu = /**
         * This method resets the menu when it's closed, most importantly restoring
         * focus to the menu trigger if the menu was opened via the keyboard.
         * @return {?}
         */
        function () {
            this._setIsMenuOpen(false);
            // We should reset focus if the user is navigating using a keyboard or
            // if we have a top-level trigger which might cause focus to be lost
            // when clicking on the backdrop.
            if (!this._openedByMouse) {
                // Note that the focus style will show up both for `program` and
                // `keyboard` so we don't have to specify which one it is.
                this.focus();
            }
            else if (!this.triggersSubmenu()) {
                this.focus('mouse');
            }
            this._openedByMouse = false;
        };
        /**
         * @param {?} isOpen
         * @return {?}
         */
        MatMenuTrigger.prototype._setIsMenuOpen = /**
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) {
            this._menuOpen = isOpen;
            this._menuOpen ? this.menuOpened.emit() : this.menuClosed.emit();
            if (this.triggersSubmenu()) {
                this._menuItemInstance._highlighted = isOpen;
            }
        };
        /**
         * This method checks that a valid instance of MatMenu has been passed into
         * matMenuTriggerFor. If not, an exception is thrown.
         * @return {?}
         */
        MatMenuTrigger.prototype._checkMenu = /**
         * This method checks that a valid instance of MatMenu has been passed into
         * matMenuTriggerFor. If not, an exception is thrown.
         * @return {?}
         */
        function () {
            if (!this.menu) {
                throwMatMenuMissingError();
            }
        };
        /**
         * This method creates the overlay from the provided menu's template and saves its
         * OverlayRef so that it can be attached to the DOM when openMenu is called.
         * @return {?}
         */
        MatMenuTrigger.prototype._createOverlay = /**
         * This method creates the overlay from the provided menu's template and saves its
         * OverlayRef so that it can be attached to the DOM when openMenu is called.
         * @return {?}
         */
        function () {
            if (!this._overlayRef) {
                this._portal = new TemplatePortal(this.menu.templateRef, this._viewContainerRef);
                var /** @type {?} */ config = this._getOverlayConfig();
                this._subscribeToPositions(/** @type {?} */ (config.positionStrategy));
                this._overlayRef = this._overlay.create(config);
            }
            return this._overlayRef;
        };
        /**
         * This method builds the configuration object needed to create the overlay, the OverlayState.
         * @return {?} OverlayConfig
         */
        MatMenuTrigger.prototype._getOverlayConfig = /**
         * This method builds the configuration object needed to create the overlay, the OverlayState.
         * @return {?} OverlayConfig
         */
        function () {
            return new OverlayConfig({
                positionStrategy: this._getPosition(),
                hasBackdrop: this.menu.hasBackdrop == null ? !this.triggersSubmenu() : this.menu.hasBackdrop,
                backdropClass: this.menu.backdropClass || 'cdk-overlay-transparent-backdrop',
                scrollStrategy: this._scrollStrategy(),
                direction: this._dir
            });
        };
        /**
         * Listens to changes in the position of the overlay and sets the correct classes
         * on the menu based on the new position. This ensures the animation origin is always
         * correct, even if a fallback position is used for the overlay.
         * @param {?} position
         * @return {?}
         */
        MatMenuTrigger.prototype._subscribeToPositions = /**
         * Listens to changes in the position of the overlay and sets the correct classes
         * on the menu based on the new position. This ensures the animation origin is always
         * correct, even if a fallback position is used for the overlay.
         * @param {?} position
         * @return {?}
         */
        function (position) {
            var _this = this;
            if (this.menu.setPositionClasses) {
                position.positionChanges.subscribe(function (change) {
                    var /** @type {?} */ posX = change.connectionPair.overlayX === 'start' ? 'after' : 'before';
                    var /** @type {?} */ posY = change.connectionPair.overlayY === 'top' ? 'below' : 'above'; /** @type {?} */
                    ((_this.menu.setPositionClasses))(posX, posY);
                });
            }
        };
        /**
         * This method builds the position strategy for the overlay, so the menu is properly connected
         * to the trigger.
         * @return {?} ConnectedPositionStrategy
         */
        MatMenuTrigger.prototype._getPosition = /**
         * This method builds the position strategy for the overlay, so the menu is properly connected
         * to the trigger.
         * @return {?} ConnectedPositionStrategy
         */
        function () {
            var _a = this.menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'], originX = _a[0], originFallbackX = _a[1];
            var _b = this.menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _b[0], overlayFallbackY = _b[1];
            var _c = [overlayY, overlayFallbackY], originY = _c[0], originFallbackY = _c[1];
            var _d = [originX, originFallbackX], overlayX = _d[0], overlayFallbackX = _d[1];
            var /** @type {?} */ offsetY = 0;
            if (this.triggersSubmenu()) {
                // When the menu is a sub-menu, it should always align itself
                // to the edges of the trigger, instead of overlapping it.
                overlayFallbackX = originX = this.menu.xPosition === 'before' ? 'start' : 'end';
                originFallbackX = overlayX = originX === 'end' ? 'start' : 'end';
                offsetY = overlayY === 'bottom' ? MENU_PANEL_TOP_PADDING : -MENU_PANEL_TOP_PADDING;
            }
            else if (!this.menu.overlapTrigger) {
                originY = overlayY === 'top' ? 'bottom' : 'top';
                originFallbackY = overlayFallbackY === 'top' ? 'bottom' : 'top';
            }
            return this._overlay.position()
                .flexibleConnectedTo(this._element)
                .withTransformOriginOn('.mat-menu-panel')
                .withPositions([
                { originX: originX, originY: originY, overlayX: overlayX, overlayY: overlayY, offsetY: offsetY },
                { originX: originFallbackX, originY: originY, overlayX: overlayFallbackX, overlayY: overlayY, offsetY: offsetY },
                {
                    originX: originX,
                    originY: originFallbackY,
                    overlayX: overlayX,
                    overlayY: overlayFallbackY,
                    offsetY: -offsetY
                },
                {
                    originX: originFallbackX,
                    originY: originFallbackY,
                    overlayX: overlayFallbackX,
                    overlayY: overlayFallbackY,
                    offsetY: -offsetY
                }
            ]);
        };
        /**
         * Cleans up the active subscriptions.
         * @return {?}
         */
        MatMenuTrigger.prototype._cleanUpSubscriptions = /**
         * Cleans up the active subscriptions.
         * @return {?}
         */
        function () {
            this._closeSubscription.unsubscribe();
            this._hoverSubscription.unsubscribe();
        };
        /**
         * Returns a stream that emits whenever an action that should close the menu occurs.
         * @return {?}
         */
        MatMenuTrigger.prototype._menuClosingActions = /**
         * Returns a stream that emits whenever an action that should close the menu occurs.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ backdrop = /** @type {?} */ ((this._overlayRef)).backdropClick();
            var /** @type {?} */ detachments = /** @type {?} */ ((this._overlayRef)).detachments();
            var /** @type {?} */ parentClose = this._parentMenu ? this._parentMenu.closed : rxjs.of();
            var /** @type {?} */ hover = this._parentMenu ? this._parentMenu._hovered().pipe(operators.filter(function (active) { return active !== _this._menuItemInstance; }), operators.filter(function () { return _this._menuOpen; })) : rxjs.of();
            return rxjs.merge(backdrop, parentClose, hover, detachments);
        };
        /** Handles mouse presses on the trigger. */
        /**
         * Handles mouse presses on the trigger.
         * @param {?} event
         * @return {?}
         */
        MatMenuTrigger.prototype._handleMousedown = /**
         * Handles mouse presses on the trigger.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (!isFakeMousedownFromScreenReader(event)) {
                this._openedByMouse = true;
                // Since clicking on the trigger won't close the menu if it opens a sub-menu,
                // we should prevent focus from moving onto it via click to avoid the
                // highlight from lingering on the menu item.
                if (this.triggersSubmenu()) {
                    event.preventDefault();
                }
            }
        };
        /** Handles key presses on the trigger. */
        /**
         * Handles key presses on the trigger.
         * @param {?} event
         * @return {?}
         */
        MatMenuTrigger.prototype._handleKeydown = /**
         * Handles key presses on the trigger.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            if (this.triggersSubmenu() && ((keyCode === RIGHT_ARROW && this.dir === 'ltr') ||
                (keyCode === LEFT_ARROW && this.dir === 'rtl'))) {
                this.openMenu();
            }
        };
        /** Handles click events on the trigger. */
        /**
         * Handles click events on the trigger.
         * @param {?} event
         * @return {?}
         */
        MatMenuTrigger.prototype._handleClick = /**
         * Handles click events on the trigger.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.triggersSubmenu()) {
                // Stop event propagation to avoid closing the parent menu.
                event.stopPropagation();
                this.openMenu();
            }
            else {
                this.toggleMenu();
            }
        };
        /**
         * Handles the cases where the user hovers over the trigger.
         * @return {?}
         */
        MatMenuTrigger.prototype._handleHover = /**
         * Handles the cases where the user hovers over the trigger.
         * @return {?}
         */
        function () {
            var _this = this;
            // Subscribe to changes in the hovered item in order to toggle the panel.
            if (!this.triggersSubmenu()) {
                return;
            }
            this._hoverSubscription = this._parentMenu._hovered()
                .pipe(operators.filter(function (active) { return active === _this._menuItemInstance && !active.disabled; }), operators.delay(0, rxjs.asapScheduler))
                .subscribe(function () {
                _this._openedByMouse = true;
                // If the same menu is used between multiple triggers, it might still be animating
                // while the new trigger tries to re-open it. Wait for the animation to finish
                // before doing so. Also interrupt if the user moves to another item.
                if (_this.menu instanceof MatMenu && _this.menu._isAnimating) {
                    _this.menu._animationDone
                        .pipe(operators.take(1), operators.takeUntil(_this._parentMenu._hovered()))
                        .subscribe(function () { return _this.openMenu(); });
                }
                else {
                    _this.openMenu();
                }
            });
        };
        MatMenuTrigger.decorators = [
            { type: core.Directive, args: [{
                        selector: "[mat-menu-trigger-for], [matMenuTriggerFor]",
                        host: {
                            'aria-haspopup': 'true',
                            '[attr.aria-expanded]': 'menuOpen || null',
                            '(mousedown)': '_handleMousedown($event)',
                            '(keydown)': '_handleKeydown($event)',
                            '(click)': '_handleClick($event)',
                        },
                        exportAs: 'matMenuTrigger'
                    },] },
        ];
        /** @nocollapse */
        MatMenuTrigger.ctorParameters = function () { return [
            { type: Overlay, },
            { type: core.ElementRef, },
            { type: core.ViewContainerRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_MENU_SCROLL_STRATEGY,] },] },
            { type: MatMenu, decorators: [{ type: core.Optional },] },
            { type: MatMenuItem, decorators: [{ type: core.Optional }, { type: core.Self },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: FocusMonitor, },
        ]; };
        MatMenuTrigger.propDecorators = {
            "_deprecatedMatMenuTriggerFor": [{ type: core.Input, args: ['mat-menu-trigger-for',] },],
            "menu": [{ type: core.Input, args: ['matMenuTriggerFor',] },],
            "menuData": [{ type: core.Input, args: ['matMenuTriggerData',] },],
            "menuOpened": [{ type: core.Output },],
            "onMenuOpen": [{ type: core.Output },],
            "menuClosed": [{ type: core.Output },],
            "onMenuClose": [{ type: core.Output },],
        };
        return MatMenuTrigger;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatMenuModule = /** @class */ (function () {
        function MatMenuModule() {
        }
        MatMenuModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            MatCommonModule,
                            MatRippleModule,
                            OverlayModule,
                        ],
                        exports: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent, MatCommonModule],
                        declarations: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent],
                        providers: [MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER]
                    },] },
        ];
        return MatMenuModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The following are all the animations for the mat-select component, with each
     * const containing the metadata for one animation.
     *
     * The values below match the implementation of the AngularJS Material mat-select animation.
     */
    var /** @type {?} */ matSelectAnimations = {
        /**
           * This animation transforms the select's overlay panel on and off the page.
           *
           * When the panel is attached to the DOM, it expands its width by the amount of padding, scales it
           * up to 100% on the Y axis, fades in its border, and translates slightly up and to the
           * side to ensure the option text correctly overlaps the trigger text.
           *
           * When the panel is removed from the DOM, it simply fades out linearly.
           */
        transformPanel: trigger('transformPanel', [
            state('void', style({
                transform: 'scaleY(0)',
                minWidth: '100%',
                opacity: 0
            })),
            state('showing', style({
                opacity: 1,
                minWidth: 'calc(100% + 32px)',
                // 32px = 2 * 16px padding
                transform: 'scaleY(1)'
            })),
            state('showing-multiple', style({
                opacity: 1,
                minWidth: 'calc(100% + 64px)',
                // 64px = 48px padding on the left + 16px padding on the right
                transform: 'scaleY(1)'
            })),
            transition('void => *', group([
                query('@fadeInContent', animateChild()),
                animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')
            ])),
            transition('* => void', [
                animate('250ms 100ms linear', style({ opacity: 0 }))
            ])
        ]),
        /**
           * This animation fades in the background color and text content of the
           * select's options. It is time delayed to occur 100ms after the overlay
           * panel has transformed in.
           */
        fadeInContent: trigger('fadeInContent', [
            state('showing', style({ opacity: 1 })),
            transition('void => showing', [
                style({ opacity: 0 }),
                animate('150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
            ])
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Returns an exception to be thrown when attempting to change a select's `multiple` option
     * after initialization.
     * \@docs-private
     * @return {?}
     */
    function getMatSelectDynamicMultipleError() {
        return Error('Cannot change `multiple` mode of select after initialization.');
    }
    /**
     * Returns an exception to be thrown when attempting to assign a non-array value to a select
     * in `multiple` mode. Note that `undefined` and `null` are still valid values to allow for
     * resetting the value.
     * \@docs-private
     * @return {?}
     */
    function getMatSelectNonArrayValueError() {
        return Error('Value must be an array in multiple-selection mode.');
    }
    /**
     * Returns an exception to be thrown when assigning a non-function value to the comparator
     * used to determine if a value corresponds to an option. Note that whether the function
     * actually takes two values and returns a boolean is not checked.
     * @return {?}
     */
    function getMatSelectNonFunctionValueError() {
        return Error('`compareWith` must be a function.');
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ nextUniqueId$6 = 0;
    /**
     * The max height of the select's overlay panel
     */
    var /** @type {?} */ SELECT_PANEL_MAX_HEIGHT = 256;
    /**
     * The panel's padding on the x-axis
     */
    var /** @type {?} */ SELECT_PANEL_PADDING_X = 16;
    /**
     * The panel's x axis padding if it is indented (e.g. there is an option group).
     */
    var /** @type {?} */ SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_PADDING_X * 2;
    /**
     * The height of the select items in `em` units.
     */
    var /** @type {?} */ SELECT_ITEM_HEIGHT_EM = 3;
    /**
     * Distance between the panel edge and the option text in
     * multi-selection mode.
     *
     * (SELECT_PANEL_PADDING_X * 1.5) + 20 = 44
     * The padding is multiplied by 1.5 because the checkbox's margin is half the padding.
     * The checkbox width is 20px.
     */
    var /** @type {?} */ SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_PANEL_PADDING_X * 1.5 + 20;
    /**
     * The select panel will only "fit" inside the viewport if it is positioned at
     * this value or more away from the viewport boundary.
     */
    var /** @type {?} */ SELECT_PANEL_VIEWPORT_PADDING = 8;
    /**
     * Injection token that determines the scroll handling while a select is open.
     */
    var /** @type {?} */ MAT_SELECT_SCROLL_STRATEGY = new core.InjectionToken('mat-select-scroll-strategy');
    /**
     * \@docs-private
     * @param {?} overlay
     * @return {?}
     */
    function MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
        return function () { return overlay.scrollStrategies.reposition(); };
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_SELECT_SCROLL_STRATEGY_PROVIDER = {
        provide: MAT_SELECT_SCROLL_STRATEGY,
        deps: [Overlay],
        useFactory: MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY,
    };
    /**
     * Change event object that is emitted when the select value has changed.
     */
    var  /**
     * Change event object that is emitted when the select value has changed.
     */
    MatSelectChange = /** @class */ (function () {
        function MatSelectChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MatSelectChange;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSelectBase = /** @class */ (function () {
        function MatSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            this._elementRef = _elementRef;
            this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            this._parentForm = _parentForm;
            this._parentFormGroup = _parentFormGroup;
            this.ngControl = ngControl;
        }
        return MatSelectBase;
    }());
    var /** @type {?} */ _MatSelectMixinBase = mixinDisableRipple(mixinTabIndex(mixinDisabled(mixinErrorState(MatSelectBase))));
    /**
     * Allows the user to customize the trigger that is displayed when the select has a value.
     */
    var MatSelectTrigger = /** @class */ (function () {
        function MatSelectTrigger() {
        }
        MatSelectTrigger.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-select-trigger'
                    },] },
        ];
        return MatSelectTrigger;
    }());
    var MatSelect = /** @class */ (function (_super) {
        __extends(MatSelect, _super);
        function MatSelect(_viewportRuler, _changeDetectorRef, _ngZone, _defaultErrorStateMatcher, elementRef, _dir, _parentForm, _parentFormGroup, _parentFormField, ngControl, tabIndex, _scrollStrategyFactory) {
            var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._viewportRuler = _viewportRuler;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._ngZone = _ngZone;
            _this._dir = _dir;
            _this._parentFormField = _parentFormField;
            _this.ngControl = ngControl;
            _this._scrollStrategyFactory = _scrollStrategyFactory;
            /**
             * Whether or not the overlay panel is open.
             */
            _this._panelOpen = false;
            /**
             * Whether filling out the select is required in the form.
             */
            _this._required = false;
            /**
             * The scroll position of the overlay panel, calculated to center the selected option.
             */
            _this._scrollTop = 0;
            /**
             * Whether the component is in multiple selection mode.
             */
            _this._multiple = false;
            /**
             * Comparison function to specify which option is displayed. Defaults to object equality.
             */
            _this._compareWith = function (o1, o2) { return o1 === o2; };
            /**
             * Unique id for this input.
             */
            _this._uid = "mat-select-" + nextUniqueId$6++;
            /**
             * Emits whenever the component is destroyed.
             */
            _this._destroy = new rxjs.Subject();
            /**
             * The cached font-size of the trigger element.
             */
            _this._triggerFontSize = 0;
            /**
             * `View -> model callback called when value changes`
             */
            _this._onChange = function () { };
            /**
             * `View -> model callback called when select has been touched`
             */
            _this._onTouched = function () { };
            /**
             * The IDs of child options to be passed to the aria-owns attribute.
             */
            _this._optionIds = '';
            /**
             * The value of the select panel's transform-origin property.
             */
            _this._transformOrigin = 'top';
            /**
             * Whether the panel's animation is done.
             */
            _this._panelDoneAnimating = false;
            /**
             * Emits when the panel element is finished transforming in.
             */
            _this._panelDoneAnimatingStream = new rxjs.Subject();
            /**
             * Strategy that will be used to handle scrolling while the select panel is open.
             */
            _this._scrollStrategy = _this._scrollStrategyFactory();
            /**
             * The y-offset of the overlay panel in relation to the trigger's top start corner.
             * This must be adjusted to align the selected option text over the trigger text.
             * when the panel opens. Will change based on the y-position of the selected option.
             */
            _this._offsetY = 0;
            /**
             * This position config ensures that the top "start" corner of the overlay
             * is aligned with with the top "start" of the origin by default (overlapping
             * the trigger completely). If the panel cannot fit below the trigger, it
             * will fall back to a position above the trigger.
             */
            _this._positions = [
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'top',
                },
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'bottom',
                },
            ];
            /**
             * Whether the component is disabling centering of the active option over the trigger.
             */
            _this._disableOptionCentering = false;
            /**
             * Whether the select is focused.
             */
            _this.focused = false;
            /**
             * A name for this control that can be used by `mat-form-field`.
             */
            _this.controlType = 'mat-select';
            /**
             * Aria label of the select. If not specified, the placeholder will be used as label.
             */
            _this.ariaLabel = '';
            /**
             * Combined stream of all of the child options' change events.
             */
            _this.optionSelectionChanges = rxjs.defer(function () {
                if (_this.options) {
                    return rxjs.merge.apply(void 0, _this.options.map(function (option) { return option.onSelectionChange; }));
                }
                return _this._ngZone.onStable
                    .asObservable()
                    .pipe(operators.take(1), operators.switchMap(function () { return _this.optionSelectionChanges; }));
            });
            /**
             * Event emitted when the select panel has been toggled.
             */
            _this.openedChange = new core.EventEmitter();
            /**
             * Event emitted when the select has been opened.
             */
            _this._openedStream = _this.openedChange.pipe(operators.filter(function (o) { return o; }), operators.map(function () { }));
            /**
             * Event emitted when the select has been closed.
             */
            _this._closedStream = _this.openedChange.pipe(operators.filter(function (o) { return !o; }), operators.map(function () { }));
            /**
             * Event emitted when the selected value has been changed by the user.
             */
            _this.selectionChange = new core.EventEmitter();
            /**
             * Event that emits whenever the raw value of the select changes. This is here primarily
             * to facilitate the two-way binding for the `value` input.
             * \@docs-private
             */
            _this.valueChange = new core.EventEmitter();
            if (_this.ngControl) {
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                _this.ngControl.valueAccessor = _this;
            }
            _this.tabIndex = parseInt(tabIndex) || 0;
            // Force setter to be called in case id was not specified.
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            return _this;
        }
        Object.defineProperty(MatSelect.prototype, "placeholder", {
            get: /**
             * Placeholder to be shown if no value has been selected.
             * @return {?}
             */
            function () { return this._placeholder; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._placeholder = value;
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "required", {
            get: /**
             * Whether the component is required.
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._required = coerceBooleanProperty(value);
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "multiple", {
            get: /**
             * Whether the user should be allowed to select multiple options.
             * @return {?}
             */
            function () { return this._multiple; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this._selectionModel) {
                    throw getMatSelectDynamicMultipleError();
                }
                this._multiple = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "disableOptionCentering", {
            get: /**
             * Whether to center the active option over the trigger.
             * @return {?}
             */
            function () { return this._disableOptionCentering; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disableOptionCentering = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "compareWith", {
            get: /**
             * A function to compare the option values with the selected values. The first argument
             * is a value from an option. The second is a value from the selection. A boolean
             * should be returned.
             * @return {?}
             */
            function () { return this._compareWith; },
            set: /**
             * @param {?} fn
             * @return {?}
             */
            function (fn) {
                if (typeof fn !== 'function') {
                    throw getMatSelectNonFunctionValueError();
                }
                this._compareWith = fn;
                if (this._selectionModel) {
                    // A different comparator means the selection could change.
                    this._initializeSelection();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "value", {
            get: /**
             * Value of the select control.
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} newValue
             * @return {?}
             */
            function (newValue) {
                if (newValue !== this._value) {
                    this.writeValue(newValue);
                    this._value = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "id", {
            get: /**
             * Unique id of the element.
             * @return {?}
             */
            function () { return this._id; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._id = value || this._uid;
                this.stateChanges.next();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatSelect.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._selectionModel = new SelectionModel(this.multiple);
            this.stateChanges.next();
            // We need `distinctUntilChanged` here, because some browsers will
            // fire the animation end event twice for the same animation. See:
            // https://github.com/angular/angular/issues/24084
            this._panelDoneAnimatingStream
                .pipe(operators.distinctUntilChanged(), operators.takeUntil(this._destroy))
                .subscribe(function () {
                if (_this.panelOpen) {
                    _this._scrollTop = 0;
                    _this.openedChange.emit(true);
                }
                else {
                    _this.openedChange.emit(false);
                    _this._panelDoneAnimating = false;
                    _this.overlayDir.offsetX = 0;
                    _this._changeDetectorRef.markForCheck();
                }
            });
        };
        /**
         * @return {?}
         */
        MatSelect.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._initKeyManager(); /** @type {?} */
            ((this._selectionModel.onChange)).pipe(operators.takeUntil(this._destroy)).subscribe(function (event) {
                event.added.forEach(function (option) { return option.select(); });
                event.removed.forEach(function (option) { return option.deselect(); });
            });
            this.options.changes.pipe(operators.startWith(null), operators.takeUntil(this._destroy)).subscribe(function () {
                _this._resetOptions();
                _this._initializeSelection();
            });
        };
        /**
         * @return {?}
         */
        MatSelect.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            if (this.ngControl) {
                this.updateErrorState();
            }
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        MatSelect.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            // Updating the disabled state is handled by `mixinDisabled`, but we need to additionally let
            // the parent form field know to run change detection when the disabled state changes.
            if (changes["disabled"]) {
                this.stateChanges.next();
            }
        };
        /**
         * @return {?}
         */
        MatSelect.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroy.next();
            this._destroy.complete();
            this.stateChanges.complete();
        };
        /** Toggles the overlay panel open or closed. */
        /**
         * Toggles the overlay panel open or closed.
         * @return {?}
         */
        MatSelect.prototype.toggle = /**
         * Toggles the overlay panel open or closed.
         * @return {?}
         */
        function () {
            this.panelOpen ? this.close() : this.open();
        };
        /** Opens the overlay panel. */
        /**
         * Opens the overlay panel.
         * @return {?}
         */
        MatSelect.prototype.open = /**
         * Opens the overlay panel.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this.disabled || !this.options || !this.options.length || this._panelOpen) {
                return;
            }
            this._triggerRect = this.trigger.nativeElement.getBoundingClientRect();
            // Note: The computed font-size will be a string pixel value (e.g. "16px").
            // `parseInt` ignores the trailing 'px' and converts this to a number.
            this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement)['font-size']);
            this._panelOpen = true;
            this._keyManager.withHorizontalOrientation(null);
            this._calculateOverlayPosition();
            this._highlightCorrectOption();
            this._changeDetectorRef.markForCheck();
            // Set the font size on the panel element once it exists.
            this._ngZone.onStable.asObservable().pipe(operators.take(1)).subscribe(function () {
                if (_this._triggerFontSize && _this.overlayDir.overlayRef &&
                    _this.overlayDir.overlayRef.overlayElement) {
                    _this.overlayDir.overlayRef.overlayElement.style.fontSize = _this._triggerFontSize + "px";
                }
            });
        };
        /** Closes the overlay panel and focuses the host element. */
        /**
         * Closes the overlay panel and focuses the host element.
         * @return {?}
         */
        MatSelect.prototype.close = /**
         * Closes the overlay panel and focuses the host element.
         * @return {?}
         */
        function () {
            if (this._panelOpen) {
                this._panelOpen = false;
                this._keyManager.withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
                this._changeDetectorRef.markForCheck();
                this._onTouched();
            }
        };
        /**
         * Sets the select's value. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param value New value to be written to the model.
         */
        /**
         * Sets the select's value. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param {?} value New value to be written to the model.
         * @return {?}
         */
        MatSelect.prototype.writeValue = /**
         * Sets the select's value. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param {?} value New value to be written to the model.
         * @return {?}
         */
        function (value) {
            if (this.options) {
                this._setSelectionByValue(value);
            }
        };
        /**
         * Saves a callback function to be invoked when the select's value
         * changes from user input. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param fn Callback to be triggered when the value changes.
         */
        /**
         * Saves a callback function to be invoked when the select's value
         * changes from user input. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param {?} fn Callback to be triggered when the value changes.
         * @return {?}
         */
        MatSelect.prototype.registerOnChange = /**
         * Saves a callback function to be invoked when the select's value
         * changes from user input. Part of the ControlValueAccessor interface
         * required to integrate with Angular's core forms API.
         *
         * @param {?} fn Callback to be triggered when the value changes.
         * @return {?}
         */
        function (fn) {
            this._onChange = fn;
        };
        /**
         * Saves a callback function to be invoked when the select is blurred
         * by the user. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param fn Callback to be triggered when the component has been touched.
         */
        /**
         * Saves a callback function to be invoked when the select is blurred
         * by the user. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param {?} fn Callback to be triggered when the component has been touched.
         * @return {?}
         */
        MatSelect.prototype.registerOnTouched = /**
         * Saves a callback function to be invoked when the select is blurred
         * by the user. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param {?} fn Callback to be triggered when the component has been touched.
         * @return {?}
         */
        function (fn) {
            this._onTouched = fn;
        };
        /**
         * Disables the select. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param isDisabled Sets whether the component is disabled.
         */
        /**
         * Disables the select. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param {?} isDisabled Sets whether the component is disabled.
         * @return {?}
         */
        MatSelect.prototype.setDisabledState = /**
         * Disables the select. Part of the ControlValueAccessor interface required
         * to integrate with Angular's core forms API.
         *
         * @param {?} isDisabled Sets whether the component is disabled.
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
            this._changeDetectorRef.markForCheck();
            this.stateChanges.next();
        };
        Object.defineProperty(MatSelect.prototype, "panelOpen", {
            /** Whether or not the overlay panel is open. */
            get: /**
             * Whether or not the overlay panel is open.
             * @return {?}
             */
            function () {
                return this._panelOpen;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "selected", {
            /** The currently selected option. */
            get: /**
             * The currently selected option.
             * @return {?}
             */
            function () {
                return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSelect.prototype, "triggerValue", {
            /** The value displayed in the trigger. */
            get: /**
             * The value displayed in the trigger.
             * @return {?}
             */
            function () {
                if (this.empty) {
                    return '';
                }
                if (this._multiple) {
                    var /** @type {?} */ selectedOptions = this._selectionModel.selected.map(function (option) { return option.viewValue; });
                    if (this._isRtl()) {
                        selectedOptions.reverse();
                    }
                    // TODO(crisbeto): delimiter should be configurable for proper localization.
                    return selectedOptions.join(', ');
                }
                return this._selectionModel.selected[0].viewValue;
            },
            enumerable: true,
            configurable: true
        });
        /** Whether the element is in RTL mode. */
        /**
         * Whether the element is in RTL mode.
         * @return {?}
         */
        MatSelect.prototype._isRtl = /**
         * Whether the element is in RTL mode.
         * @return {?}
         */
        function () {
            return this._dir ? this._dir.value === 'rtl' : false;
        };
        /** Handles all keydown events on the select. */
        /**
         * Handles all keydown events on the select.
         * @param {?} event
         * @return {?}
         */
        MatSelect.prototype._handleKeydown = /**
         * Handles all keydown events on the select.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (!this.disabled) {
                this.panelOpen ? this._handleOpenKeydown(event) : this._handleClosedKeydown(event);
            }
        };
        /**
         * Handles keyboard events while the select is closed.
         * @param {?} event
         * @return {?}
         */
        MatSelect.prototype._handleClosedKeydown = /**
         * Handles keyboard events while the select is closed.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            var /** @type {?} */ isArrowKey = keyCode === DOWN_ARROW || keyCode === UP_ARROW ||
                keyCode === LEFT_ARROW || keyCode === RIGHT_ARROW;
            var /** @type {?} */ isOpenKey = keyCode === ENTER || keyCode === SPACE;
            // Open the select on ALT + arrow key to match the native <select>
            if (isOpenKey || ((this.multiple || event.altKey) && isArrowKey)) {
                event.preventDefault(); // prevents the page from scrolling down when pressing space
                this.open();
            }
            else if (!this.multiple) {
                this._keyManager.onKeydown(event);
            }
        };
        /**
         * Handles keyboard events when the selected is open.
         * @param {?} event
         * @return {?}
         */
        MatSelect.prototype._handleOpenKeydown = /**
         * Handles keyboard events when the selected is open.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            var /** @type {?} */ isArrowKey = keyCode === DOWN_ARROW || keyCode === UP_ARROW;
            var /** @type {?} */ manager = this._keyManager;
            if (keyCode === HOME || keyCode === END) {
                event.preventDefault();
                keyCode === HOME ? manager.setFirstItemActive() : manager.setLastItemActive();
            }
            else if (isArrowKey && event.altKey) {
                // Close the select on ALT + arrow key to match the native <select>
                event.preventDefault();
                this.close();
            }
            else if ((keyCode === ENTER || keyCode === SPACE) && manager.activeItem) {
                event.preventDefault();
                manager.activeItem._selectViaInteraction();
            }
            else {
                var /** @type {?} */ previouslyFocusedIndex = manager.activeItemIndex;
                manager.onKeydown(event);
                if (this._multiple && isArrowKey && event.shiftKey && manager.activeItem &&
                    manager.activeItemIndex !== previouslyFocusedIndex) {
                    manager.activeItem._selectViaInteraction();
                }
            }
        };
        /**
         * When the panel content is done fading in, the _panelDoneAnimating property is
         * set so the proper class can be added to the panel.
         */
        /**
         * When the panel content is done fading in, the _panelDoneAnimating property is
         * set so the proper class can be added to the panel.
         * @return {?}
         */
        MatSelect.prototype._onFadeInDone = /**
         * When the panel content is done fading in, the _panelDoneAnimating property is
         * set so the proper class can be added to the panel.
         * @return {?}
         */
        function () {
            this._panelDoneAnimating = this.panelOpen;
            this._changeDetectorRef.markForCheck();
        };
        /**
         * @return {?}
         */
        MatSelect.prototype._onFocus = /**
         * @return {?}
         */
        function () {
            if (!this.disabled) {
                this.focused = true;
                this.stateChanges.next();
            }
        };
        /**
         * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
         * "blur" to the panel when it opens, causing a false positive.
         */
        /**
         * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
         * "blur" to the panel when it opens, causing a false positive.
         * @return {?}
         */
        MatSelect.prototype._onBlur = /**
         * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
         * "blur" to the panel when it opens, causing a false positive.
         * @return {?}
         */
        function () {
            this.focused = false;
            if (!this.disabled && !this.panelOpen) {
                this._onTouched();
                this._changeDetectorRef.markForCheck();
                this.stateChanges.next();
            }
        };
        /**
         * Callback that is invoked when the overlay panel has been attached.
         */
        /**
         * Callback that is invoked when the overlay panel has been attached.
         * @return {?}
         */
        MatSelect.prototype._onAttached = /**
         * Callback that is invoked when the overlay panel has been attached.
         * @return {?}
         */
        function () {
            var _this = this;
            this.overlayDir.positionChange.pipe(operators.take(1)).subscribe(function () {
                _this._changeDetectorRef.detectChanges();
                _this._calculateOverlayOffsetX();
                _this.panel.nativeElement.scrollTop = _this._scrollTop;
            });
        };
        /** Returns the theme to be used on the panel. */
        /**
         * Returns the theme to be used on the panel.
         * @return {?}
         */
        MatSelect.prototype._getPanelTheme = /**
         * Returns the theme to be used on the panel.
         * @return {?}
         */
        function () {
            return this._parentFormField ? "mat-" + this._parentFormField.color : '';
        };
        Object.defineProperty(MatSelect.prototype, "empty", {
            /** Whether the select has a value. */
            get: /**
             * Whether the select has a value.
             * @return {?}
             */
            function () {
                return !this._selectionModel || this._selectionModel.isEmpty();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatSelect.prototype._initializeSelection = /**
         * @return {?}
         */
        function () {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value);
            });
        };
        /**
         * Sets the selected option based on a value. If no option can be
         * found with the designated value, the select trigger is cleared.
         * @param {?} value
         * @return {?}
         */
        MatSelect.prototype._setSelectionByValue = /**
         * Sets the selected option based on a value. If no option can be
         * found with the designated value, the select trigger is cleared.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            if (this.multiple && value) {
                if (!Array.isArray(value)) {
                    throw getMatSelectNonArrayValueError();
                }
                this._selectionModel.clear();
                value.forEach(function (currentValue) { return _this._selectValue(currentValue); });
                this._sortValues();
            }
            else {
                this._selectionModel.clear();
                var /** @type {?} */ correspondingOption = this._selectValue(value);
                // Shift focus to the active item. Note that we shouldn't do this in multiple
                // mode, because we don't know what option the user interacted with last.
                if (correspondingOption) {
                    this._keyManager.setActiveItem(correspondingOption);
                }
            }
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Finds and selects and option based on its value.
         * @param {?} value
         * @return {?} Option that has the corresponding value.
         */
        MatSelect.prototype._selectValue = /**
         * Finds and selects and option based on its value.
         * @param {?} value
         * @return {?} Option that has the corresponding value.
         */
        function (value) {
            var _this = this;
            var /** @type {?} */ correspondingOption = this.options.find(function (option) {
                try {
                    // Treat null as a special reset value.
                    return option.value != null && _this._compareWith(option.value, value);
                }
                catch (/** @type {?} */ error) {
                    if (core.isDevMode()) {
                        // Notify developers of errors in their comparator.
                        console.warn(error);
                    }
                    return false;
                }
            });
            if (correspondingOption) {
                this._selectionModel.select(correspondingOption);
            }
            return correspondingOption;
        };
        /**
         * Sets up a key manager to listen to keyboard events on the overlay panel.
         * @return {?}
         */
        MatSelect.prototype._initKeyManager = /**
         * Sets up a key manager to listen to keyboard events on the overlay panel.
         * @return {?}
         */
        function () {
            var _this = this;
            this._keyManager = new ActiveDescendantKeyManager(this.options)
                .withTypeAhead()
                .withVerticalOrientation()
                .withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
            this._keyManager.tabOut.pipe(operators.takeUntil(this._destroy)).subscribe(function () {
                // Restore focus to the trigger before closing. Ensures that the focus
                // position won't be lost if the user got focus into the overlay.
                // Restore focus to the trigger before closing. Ensures that the focus
                // position won't be lost if the user got focus into the overlay.
                _this.focus();
                _this.close();
            });
            this._keyManager.change.pipe(operators.takeUntil(this._destroy)).subscribe(function () {
                if (_this._panelOpen && _this.panel) {
                    _this._scrollActiveOptionIntoView();
                }
                else if (!_this._panelOpen && !_this.multiple && _this._keyManager.activeItem) {
                    _this._keyManager.activeItem._selectViaInteraction();
                }
            });
        };
        /**
         * Drops current option subscriptions and IDs and resets from scratch.
         * @return {?}
         */
        MatSelect.prototype._resetOptions = /**
         * Drops current option subscriptions and IDs and resets from scratch.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ changedOrDestroyed = rxjs.merge(this.options.changes, this._destroy);
            this.optionSelectionChanges.pipe(operators.takeUntil(changedOrDestroyed)).subscribe(function (event) {
                _this._onSelect(event.source, event.isUserInput);
                if (event.isUserInput && !_this.multiple && _this._panelOpen) {
                    _this.close();
                    _this.focus();
                }
            });
            // Listen to changes in the internal state of the options and react accordingly.
            // Handles cases like the labels of the selected options changing.
            rxjs.merge.apply(void 0, this.options.map(function (option) { return option._stateChanges; })).pipe(operators.takeUntil(changedOrDestroyed))
                .subscribe(function () {
                _this._changeDetectorRef.markForCheck();
                _this.stateChanges.next();
            });
            this._setOptionIds();
        };
        /**
         * Invoked when an option is clicked.
         * @param {?} option
         * @param {?} isUserInput
         * @return {?}
         */
        MatSelect.prototype._onSelect = /**
         * Invoked when an option is clicked.
         * @param {?} option
         * @param {?} isUserInput
         * @return {?}
         */
        function (option, isUserInput) {
            var /** @type {?} */ wasSelected = this._selectionModel.isSelected(option);
            if (option.value == null && !this._multiple) {
                this._selectionModel.clear();
                this._propagateChanges(option.value);
            }
            else {
                option.selected ? this._selectionModel.select(option) : this._selectionModel.deselect(option);
                if (this.multiple) {
                    this._sortValues();
                    if (isUserInput) {
                        this._keyManager.setActiveItem(option);
                        // In case the user selected the option with their mouse, we
                        // want to restore focus back to the trigger, in order to
                        // prevent the select keyboard controls from clashing with
                        // the ones from `mat-option`.
                        this.focus();
                    }
                }
            }
            if (wasSelected !== this._selectionModel.isSelected(option)) {
                this._propagateChanges();
            }
            this.stateChanges.next();
        };
        /**
         * Sorts the selected values in the selected based on their order in the panel.
         * @return {?}
         */
        MatSelect.prototype._sortValues = /**
         * Sorts the selected values in the selected based on their order in the panel.
         * @return {?}
         */
        function () {
            if (this.multiple) {
                var /** @type {?} */ options_1 = this.options.toArray();
                this._selectionModel.sort(function (a, b) { return options_1.indexOf(a) - options_1.indexOf(b); });
                this.stateChanges.next();
            }
        };
        /**
         * Emits change event to set the model value.
         * @param {?=} fallbackValue
         * @return {?}
         */
        MatSelect.prototype._propagateChanges = /**
         * Emits change event to set the model value.
         * @param {?=} fallbackValue
         * @return {?}
         */
        function (fallbackValue) {
            var /** @type {?} */ valueToEmit = null;
            if (this.multiple) {
                valueToEmit = (/** @type {?} */ (this.selected)).map(function (option) { return option.value; });
            }
            else {
                valueToEmit = this.selected ? (/** @type {?} */ (this.selected)).value : fallbackValue;
            }
            this._value = valueToEmit;
            this.valueChange.emit(valueToEmit);
            this._onChange(valueToEmit);
            this.selectionChange.emit(new MatSelectChange(this, valueToEmit));
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Records option IDs to pass to the aria-owns property.
         * @return {?}
         */
        MatSelect.prototype._setOptionIds = /**
         * Records option IDs to pass to the aria-owns property.
         * @return {?}
         */
        function () {
            this._optionIds = this.options.map(function (option) { return option.id; }).join(' ');
        };
        /**
         * Highlights the selected item. If no option is selected, it will highlight
         * the first item instead.
         * @return {?}
         */
        MatSelect.prototype._highlightCorrectOption = /**
         * Highlights the selected item. If no option is selected, it will highlight
         * the first item instead.
         * @return {?}
         */
        function () {
            if (this._keyManager) {
                if (this.empty) {
                    this._keyManager.setFirstItemActive();
                }
                else {
                    this._keyManager.setActiveItem(this._selectionModel.selected[0]);
                }
            }
        };
        /**
         * Scrolls the active option into view.
         * @return {?}
         */
        MatSelect.prototype._scrollActiveOptionIntoView = /**
         * Scrolls the active option into view.
         * @return {?}
         */
        function () {
            var /** @type {?} */ activeOptionIndex = this._keyManager.activeItemIndex || 0;
            var /** @type {?} */ labelCount = _countGroupLabelsBeforeOption(activeOptionIndex, this.options, this.optionGroups);
            this.panel.nativeElement.scrollTop = _getOptionScrollPosition(activeOptionIndex + labelCount, this._getItemHeight(), this.panel.nativeElement.scrollTop, SELECT_PANEL_MAX_HEIGHT);
        };
        /** Focuses the select element. */
        /**
         * Focuses the select element.
         * @return {?}
         */
        MatSelect.prototype.focus = /**
         * Focuses the select element.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.focus();
        };
        /**
         * Gets the index of the provided option in the option list.
         * @param {?} option
         * @return {?}
         */
        MatSelect.prototype._getOptionIndex = /**
         * Gets the index of the provided option in the option list.
         * @param {?} option
         * @return {?}
         */
        function (option) {
            return this.options.reduce(function (result, current, index) {
                return result === undefined ? (option === current ? index : undefined) : result;
            }, undefined);
        };
        /**
         * Calculates the scroll position and x- and y-offsets of the overlay panel.
         * @return {?}
         */
        MatSelect.prototype._calculateOverlayPosition = /**
         * Calculates the scroll position and x- and y-offsets of the overlay panel.
         * @return {?}
         */
        function () {
            var /** @type {?} */ itemHeight = this._getItemHeight();
            var /** @type {?} */ items = this._getItemCount();
            var /** @type {?} */ panelHeight = Math.min(items * itemHeight, SELECT_PANEL_MAX_HEIGHT);
            var /** @type {?} */ scrollContainerHeight = items * itemHeight;
            // The farthest the panel can be scrolled before it hits the bottom
            var /** @type {?} */ maxScroll = scrollContainerHeight - panelHeight;
            // If no value is selected we open the popup to the first item.
            var /** @type {?} */ selectedOptionOffset = this.empty ? 0 : /** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0])));
            selectedOptionOffset += _countGroupLabelsBeforeOption(selectedOptionOffset, this.options, this.optionGroups);
            // We must maintain a scroll buffer so the selected option will be scrolled to the
            // center of the overlay panel rather than the top.
            var /** @type {?} */ scrollBuffer = panelHeight / 2;
            this._scrollTop = this._calculateOverlayScroll(selectedOptionOffset, scrollBuffer, maxScroll);
            this._offsetY = this._calculateOverlayOffsetY(selectedOptionOffset, scrollBuffer, maxScroll);
            this._checkOverlayWithinViewport(maxScroll);
        };
        /**
         * Calculates the scroll position of the select's overlay panel.
         *
         * Attempts to center the selected option in the panel. If the option is
         * too high or too low in the panel to be scrolled to the center, it clamps the
         * scroll position to the min or max scroll positions respectively.
         */
        /**
         * Calculates the scroll position of the select's overlay panel.
         *
         * Attempts to center the selected option in the panel. If the option is
         * too high or too low in the panel to be scrolled to the center, it clamps the
         * scroll position to the min or max scroll positions respectively.
         * @param {?} selectedIndex
         * @param {?} scrollBuffer
         * @param {?} maxScroll
         * @return {?}
         */
        MatSelect.prototype._calculateOverlayScroll = /**
         * Calculates the scroll position of the select's overlay panel.
         *
         * Attempts to center the selected option in the panel. If the option is
         * too high or too low in the panel to be scrolled to the center, it clamps the
         * scroll position to the min or max scroll positions respectively.
         * @param {?} selectedIndex
         * @param {?} scrollBuffer
         * @param {?} maxScroll
         * @return {?}
         */
        function (selectedIndex, scrollBuffer, maxScroll) {
            var /** @type {?} */ itemHeight = this._getItemHeight();
            var /** @type {?} */ optionOffsetFromScrollTop = itemHeight * selectedIndex;
            var /** @type {?} */ halfOptionHeight = itemHeight / 2;
            // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
            // scroll container, then subtracts the scroll buffer to scroll the option down to
            // the center of the overlay panel. Half the option height must be re-added to the
            // scrollTop so the option is centered based on its middle, not its top edge.
            var /** @type {?} */ optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
            return Math.min(Math.max(0, optimalScrollPosition), maxScroll);
        };
        /** Returns the aria-label of the select component. */
        /**
         * Returns the aria-label of the select component.
         * @return {?}
         */
        MatSelect.prototype._getAriaLabel = /**
         * Returns the aria-label of the select component.
         * @return {?}
         */
        function () {
            // If an ariaLabelledby value has been set by the consumer, the select should not overwrite the
            // `aria-labelledby` value by setting the ariaLabel to the placeholder.
            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
        };
        /** Returns the aria-labelledby of the select component. */
        /**
         * Returns the aria-labelledby of the select component.
         * @return {?}
         */
        MatSelect.prototype._getAriaLabelledby = /**
         * Returns the aria-labelledby of the select component.
         * @return {?}
         */
        function () {
            if (this.ariaLabelledby) {
                return this.ariaLabelledby;
            }
            // Note: we use `_getAriaLabel` here, because we want to check whether there's a
            // computed label. `this.ariaLabel` is only the user-specified label.
            if (!this._parentFormField || this._getAriaLabel()) {
                return null;
            }
            return this._parentFormField._labelId || null;
        };
        /** Determines the `aria-activedescendant` to be set on the host. */
        /**
         * Determines the `aria-activedescendant` to be set on the host.
         * @return {?}
         */
        MatSelect.prototype._getAriaActiveDescendant = /**
         * Determines the `aria-activedescendant` to be set on the host.
         * @return {?}
         */
        function () {
            if (this.panelOpen && this._keyManager && this._keyManager.activeItem) {
                return this._keyManager.activeItem.id;
            }
            return null;
        };
        /**
         * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
         * This must be adjusted to align the selected option text over the trigger text when
         * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
         * can't be calculated until the panel has been attached, because we need to know the
         * content width in order to constrain the panel within the viewport.
         * @return {?}
         */
        MatSelect.prototype._calculateOverlayOffsetX = /**
         * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
         * This must be adjusted to align the selected option text over the trigger text when
         * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
         * can't be calculated until the panel has been attached, because we need to know the
         * content width in order to constrain the panel within the viewport.
         * @return {?}
         */
        function () {
            var /** @type {?} */ overlayRect = this.overlayDir.overlayRef.overlayElement.getBoundingClientRect();
            var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
            var /** @type {?} */ isRtl = this._isRtl();
            var /** @type {?} */ paddingWidth = this.multiple ? SELECT_MULTIPLE_PANEL_PADDING_X + SELECT_PANEL_PADDING_X :
                SELECT_PANEL_PADDING_X * 2;
            var /** @type {?} */ offsetX;
            // Adjust the offset, depending on the option padding.
            if (this.multiple) {
                offsetX = SELECT_MULTIPLE_PANEL_PADDING_X;
            }
            else {
                var /** @type {?} */ selected = this._selectionModel.selected[0] || this.options.first;
                offsetX = selected && selected.group ? SELECT_PANEL_INDENT_PADDING_X : SELECT_PANEL_PADDING_X;
            }
            // Invert the offset in LTR.
            if (!isRtl) {
                offsetX *= -1;
            }
            // Determine how much the select overflows on each side.
            var /** @type {?} */ leftOverflow = 0 - (overlayRect.left + offsetX - (isRtl ? paddingWidth : 0));
            var /** @type {?} */ rightOverflow = overlayRect.right + offsetX - viewportSize.width
                + (isRtl ? 0 : paddingWidth);
            // If the element overflows on either side, reduce the offset to allow it to fit.
            if (leftOverflow > 0) {
                offsetX += leftOverflow + SELECT_PANEL_VIEWPORT_PADDING;
            }
            else if (rightOverflow > 0) {
                offsetX -= rightOverflow + SELECT_PANEL_VIEWPORT_PADDING;
            }
            // Set the offset directly in order to avoid having to go through change detection and
            // potentially triggering "changed after it was checked" errors. Round the value to avoid
            // blurry content in some browsers.
            this.overlayDir.offsetX = Math.round(offsetX);
            this.overlayDir.overlayRef.updatePosition();
        };
        /**
         * Calculates the y-offset of the select's overlay panel in relation to the
         * top start corner of the trigger. It has to be adjusted in order for the
         * selected option to be aligned over the trigger when the panel opens.
         * @param {?} selectedIndex
         * @param {?} scrollBuffer
         * @param {?} maxScroll
         * @return {?}
         */
        MatSelect.prototype._calculateOverlayOffsetY = /**
         * Calculates the y-offset of the select's overlay panel in relation to the
         * top start corner of the trigger. It has to be adjusted in order for the
         * selected option to be aligned over the trigger when the panel opens.
         * @param {?} selectedIndex
         * @param {?} scrollBuffer
         * @param {?} maxScroll
         * @return {?}
         */
        function (selectedIndex, scrollBuffer, maxScroll) {
            var /** @type {?} */ itemHeight = this._getItemHeight();
            var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
            var /** @type {?} */ maxOptionsDisplayed = Math.floor(SELECT_PANEL_MAX_HEIGHT / itemHeight);
            var /** @type {?} */ optionOffsetFromPanelTop;
            // Disable offset if requested by user by returning 0 as value to offset
            if (this._disableOptionCentering) {
                return 0;
            }
            if (this._scrollTop === 0) {
                optionOffsetFromPanelTop = selectedIndex * itemHeight;
            }
            else if (this._scrollTop === maxScroll) {
                var /** @type {?} */ firstDisplayedIndex = this._getItemCount() - maxOptionsDisplayed;
                var /** @type {?} */ selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
                // The first item is partially out of the viewport. Therefore we need to calculate what
                // portion of it is shown in the viewport and account for it in our offset.
                var /** @type {?} */ partialItemHeight = itemHeight - (this._getItemCount() * itemHeight - SELECT_PANEL_MAX_HEIGHT) % itemHeight;
                // Because the panel height is longer than the height of the options alone,
                // there is always extra padding at the top or bottom of the panel. When
                // scrolled to the very bottom, this padding is at the top of the panel and
                // must be added to the offset.
                optionOffsetFromPanelTop = selectedDisplayIndex * itemHeight + partialItemHeight;
            }
            else {
                // If the option was scrolled to the middle of the panel using a scroll buffer,
                // its offset will be the scroll buffer minus the half height that was added to
                // center it.
                optionOffsetFromPanelTop = scrollBuffer - itemHeight / 2;
            }
            // The final offset is the option's offset from the top, adjusted for the height difference,
            // multiplied by -1 to ensure that the overlay moves in the correct direction up the page.
            // The value is rounded to prevent some browsers from blurring the content.
            return Math.round(optionOffsetFromPanelTop * -1 - optionHeightAdjustment);
        };
        /**
         * Checks that the attempted overlay position will fit within the viewport.
         * If it will not fit, tries to adjust the scroll position and the associated
         * y-offset so the panel can open fully on-screen. If it still won't fit,
         * sets the offset back to 0 to allow the fallback position to take over.
         * @param {?} maxScroll
         * @return {?}
         */
        MatSelect.prototype._checkOverlayWithinViewport = /**
         * Checks that the attempted overlay position will fit within the viewport.
         * If it will not fit, tries to adjust the scroll position and the associated
         * y-offset so the panel can open fully on-screen. If it still won't fit,
         * sets the offset back to 0 to allow the fallback position to take over.
         * @param {?} maxScroll
         * @return {?}
         */
        function (maxScroll) {
            var /** @type {?} */ itemHeight = this._getItemHeight();
            var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
            var /** @type {?} */ topSpaceAvailable = this._triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
            var /** @type {?} */ bottomSpaceAvailable = viewportSize.height - this._triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
            var /** @type {?} */ panelHeightTop = Math.abs(this._offsetY);
            var /** @type {?} */ totalPanelHeight = Math.min(this._getItemCount() * itemHeight, SELECT_PANEL_MAX_HEIGHT);
            var /** @type {?} */ panelHeightBottom = totalPanelHeight - panelHeightTop - this._triggerRect.height;
            if (panelHeightBottom > bottomSpaceAvailable) {
                this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
            }
            else if (panelHeightTop > topSpaceAvailable) {
                this._adjustPanelDown(panelHeightTop, topSpaceAvailable, maxScroll);
            }
            else {
                this._transformOrigin = this._getOriginBasedOnOption();
            }
        };
        /**
         * Adjusts the overlay panel up to fit in the viewport.
         * @param {?} panelHeightBottom
         * @param {?} bottomSpaceAvailable
         * @return {?}
         */
        MatSelect.prototype._adjustPanelUp = /**
         * Adjusts the overlay panel up to fit in the viewport.
         * @param {?} panelHeightBottom
         * @param {?} bottomSpaceAvailable
         * @return {?}
         */
        function (panelHeightBottom, bottomSpaceAvailable) {
            // Browsers ignore fractional scroll offsets, so we need to round.
            var /** @type {?} */ distanceBelowViewport = Math.round(panelHeightBottom - bottomSpaceAvailable);
            // Scrolls the panel up by the distance it was extending past the boundary, then
            // adjusts the offset by that amount to move the panel up into the viewport.
            this._scrollTop -= distanceBelowViewport;
            this._offsetY -= distanceBelowViewport;
            this._transformOrigin = this._getOriginBasedOnOption();
            // If the panel is scrolled to the very top, it won't be able to fit the panel
            // by scrolling, so set the offset to 0 to allow the fallback position to take
            // effect.
            if (this._scrollTop <= 0) {
                this._scrollTop = 0;
                this._offsetY = 0;
                this._transformOrigin = "50% bottom 0px";
            }
        };
        /**
         * Adjusts the overlay panel down to fit in the viewport.
         * @param {?} panelHeightTop
         * @param {?} topSpaceAvailable
         * @param {?} maxScroll
         * @return {?}
         */
        MatSelect.prototype._adjustPanelDown = /**
         * Adjusts the overlay panel down to fit in the viewport.
         * @param {?} panelHeightTop
         * @param {?} topSpaceAvailable
         * @param {?} maxScroll
         * @return {?}
         */
        function (panelHeightTop, topSpaceAvailable, maxScroll) {
            // Browsers ignore fractional scroll offsets, so we need to round.
            var /** @type {?} */ distanceAboveViewport = Math.round(panelHeightTop - topSpaceAvailable);
            // Scrolls the panel down by the distance it was extending past the boundary, then
            // adjusts the offset by that amount to move the panel down into the viewport.
            this._scrollTop += distanceAboveViewport;
            this._offsetY += distanceAboveViewport;
            this._transformOrigin = this._getOriginBasedOnOption();
            // If the panel is scrolled to the very bottom, it won't be able to fit the
            // panel by scrolling, so set the offset to 0 to allow the fallback position
            // to take effect.
            if (this._scrollTop >= maxScroll) {
                this._scrollTop = maxScroll;
                this._offsetY = 0;
                this._transformOrigin = "50% top 0px";
                return;
            }
        };
        /**
         * Sets the transform origin point based on the selected option.
         * @return {?}
         */
        MatSelect.prototype._getOriginBasedOnOption = /**
         * Sets the transform origin point based on the selected option.
         * @return {?}
         */
        function () {
            var /** @type {?} */ itemHeight = this._getItemHeight();
            var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
            var /** @type {?} */ originY = Math.abs(this._offsetY) - optionHeightAdjustment + itemHeight / 2;
            return "50% " + originY + "px 0px";
        };
        /**
         * Calculates the amount of items in the select. This includes options and group labels.
         * @return {?}
         */
        MatSelect.prototype._getItemCount = /**
         * Calculates the amount of items in the select. This includes options and group labels.
         * @return {?}
         */
        function () {
            return this.options.length + this.optionGroups.length;
        };
        /**
         * Calculates the height of the select's options.
         * @return {?}
         */
        MatSelect.prototype._getItemHeight = /**
         * Calculates the height of the select's options.
         * @return {?}
         */
        function () {
            return this._triggerFontSize * SELECT_ITEM_HEIGHT_EM;
        };
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        MatSelect.prototype.setDescribedByIds = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @param {?} ids
         * @return {?}
         */
        function (ids) {
            this._ariaDescribedby = ids.join(' ');
        };
        /**
         * Implemented as part of MatFormFieldControl.
         * @docs-private
         */
        /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        MatSelect.prototype.onContainerClick = /**
         * Implemented as part of MatFormFieldControl.
         * \@docs-private
         * @return {?}
         */
        function () {
            this.focus();
            this.open();
        };
        Object.defineProperty(MatSelect.prototype, "shouldLabelFloat", {
            /**
             * Implemented as part of MatFormFieldControl.
             * @docs-private
             */
            get: /**
             * Implemented as part of MatFormFieldControl.
             * \@docs-private
             * @return {?}
             */
            function () {
                return this._panelOpen || !this.empty;
            },
            enumerable: true,
            configurable: true
        });
        MatSelect.decorators = [
            { type: core.Component, args: [{selector: 'mat-select',
                        exportAs: 'matSelect',
                        template: "<div cdk-overlay-origin class=\"mat-select-trigger\" aria-hidden=\"true\" (click)=\"toggle()\" #origin=\"cdkOverlayOrigin\" #trigger><div class=\"mat-select-value\" [ngSwitch]=\"empty\"><span class=\"mat-select-placeholder\" *ngSwitchCase=\"true\">{{placeholder || '\u00A0'}}</span> <span class=\"mat-select-value-text\" *ngSwitchCase=\"false\" [ngSwitch]=\"!!customTrigger\"><span *ngSwitchDefault>{{triggerValue}}</span><ng-content select=\"mat-select-trigger\" *ngSwitchCase=\"true\"></ng-content></span></div><div class=\"mat-select-arrow-wrapper\"><div class=\"mat-select-arrow\"></div></div></div><ng-template cdk-connected-overlay cdkConnectedOverlayLockPosition cdkConnectedOverlayHasBackdrop cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\" [cdkConnectedOverlayScrollStrategy]=\"_scrollStrategy\" [cdkConnectedOverlayOrigin]=\"origin\" [cdkConnectedOverlayOpen]=\"panelOpen\" [cdkConnectedOverlayPositions]=\"_positions\" [cdkConnectedOverlayMinWidth]=\"_triggerRect?.width\" [cdkConnectedOverlayOffsetY]=\"_offsetY\" (backdropClick)=\"close()\" (attach)=\"_onAttached()\" (detach)=\"close()\"><div #panel class=\"mat-select-panel {{ _getPanelTheme() }}\" [ngClass]=\"panelClass\" [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\" (@transformPanel.done)=\"_panelDoneAnimatingStream.next($event.toState)\" [style.transformOrigin]=\"_transformOrigin\" [class.mat-select-panel-done-animating]=\"_panelDoneAnimating\" [style.font-size.px]=\"_triggerFontSize\" (keydown)=\"_handleKeydown($event)\"><div class=\"mat-select-content\" [@fadeInContent]=\"'showing'\" (@fadeInContent.done)=\"_onFadeInDone()\"><ng-content></ng-content></div></div></ng-template>",
                        styles: [".mat-select{display:inline-block;width:100%;outline:0}.mat-select-trigger{display:inline-table;cursor:pointer;position:relative;box-sizing:border-box}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-select-value{display:table-cell;max-width:0;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{display:table-cell;vertical-align:middle}.mat-form-field-appearance-fill .mat-select-arrow-wrapper,.mat-form-field-appearance-standard .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-outline .mat-select-arrow-wrapper{transform:translateY(-25%)}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}._mat-animation-noopable .mat-select-placeholder{transition:none}.mat-form-field-hide-placeholder .mat-select-placeholder{color:transparent;transition:none;display:block}"],
                        inputs: ['disabled', 'disableRipple', 'tabIndex'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        host: {
                            'role': 'listbox',
                            '[attr.id]': 'id',
                            '[attr.tabindex]': 'tabIndex',
                            '[attr.aria-label]': '_getAriaLabel()',
                            '[attr.aria-labelledby]': '_getAriaLabelledby()',
                            '[attr.aria-required]': 'required.toString()',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.aria-invalid]': 'errorState',
                            '[attr.aria-owns]': 'panelOpen ? _optionIds : null',
                            '[attr.aria-multiselectable]': 'multiple',
                            '[attr.aria-describedby]': '_ariaDescribedby || null',
                            '[attr.aria-activedescendant]': '_getAriaActiveDescendant()',
                            '[class.mat-select-disabled]': 'disabled',
                            '[class.mat-select-invalid]': 'errorState',
                            '[class.mat-select-required]': 'required',
                            'class': 'mat-select',
                            '(keydown)': '_handleKeydown($event)',
                            '(focus)': '_onFocus()',
                            '(blur)': '_onBlur()',
                        },
                        animations: [
                            matSelectAnimations.transformPanel,
                            matSelectAnimations.fadeInContent
                        ],
                        providers: [
                            { provide: MatFormFieldControl, useExisting: MatSelect },
                            { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: MatSelect }
                        ],
                    },] },
        ];
        /** @nocollapse */
        MatSelect.ctorParameters = function () { return [
            { type: ViewportRuler, },
            { type: core.ChangeDetectorRef, },
            { type: core.NgZone, },
            { type: ErrorStateMatcher, },
            { type: core.ElementRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: NgForm, decorators: [{ type: core.Optional },] },
            { type: FormGroupDirective, decorators: [{ type: core.Optional },] },
            { type: MatFormField, decorators: [{ type: core.Optional },] },
            { type: NgControl, decorators: [{ type: core.Self }, { type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_SELECT_SCROLL_STRATEGY,] },] },
        ]; };
        MatSelect.propDecorators = {
            "trigger": [{ type: core.ViewChild, args: ['trigger',] },],
            "panel": [{ type: core.ViewChild, args: ['panel',] },],
            "overlayDir": [{ type: core.ViewChild, args: [CdkConnectedOverlay,] },],
            "options": [{ type: core.ContentChildren, args: [MatOption, { descendants: true },] },],
            "optionGroups": [{ type: core.ContentChildren, args: [MatOptgroup,] },],
            "panelClass": [{ type: core.Input },],
            "customTrigger": [{ type: core.ContentChild, args: [MatSelectTrigger,] },],
            "placeholder": [{ type: core.Input },],
            "required": [{ type: core.Input },],
            "multiple": [{ type: core.Input },],
            "disableOptionCentering": [{ type: core.Input },],
            "compareWith": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "ariaLabel": [{ type: core.Input, args: ['aria-label',] },],
            "ariaLabelledby": [{ type: core.Input, args: ['aria-labelledby',] },],
            "errorStateMatcher": [{ type: core.Input },],
            "id": [{ type: core.Input },],
            "openedChange": [{ type: core.Output },],
            "_openedStream": [{ type: core.Output, args: ['opened',] },],
            "_closedStream": [{ type: core.Output, args: ['closed',] },],
            "selectionChange": [{ type: core.Output },],
            "valueChange": [{ type: core.Output },],
        };
        return MatSelect;
    }(_MatSelectMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatSelectModule = /** @class */ (function () {
        function MatSelectModule() {
        }
        MatSelectModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            OverlayModule,
                            MatOptionModule,
                            MatCommonModule,
                        ],
                        exports: [MatFormFieldModule, MatSelect, MatSelectTrigger, MatOptionModule, MatCommonModule],
                        declarations: [MatSelect, MatSelectTrigger],
                        providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER]
                    },] },
        ];
        return MatSelectModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by MatTooltip.
     */
    var /** @type {?} */ matTooltipAnimations = {
        /** Animation that transitions a tooltip in and out. */
        tooltipState: trigger('state', [
            state('initial, void, hidden', style({ transform: 'scale(0)' })),
            state('visible', style({ transform: 'scale(1)' })),
            transition('* => visible', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
            transition('* => hidden', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Time in ms to throttle repositioning after scroll events.
     */
    var /** @type {?} */ SCROLL_THROTTLE_MS = 20;
    /**
     * CSS class that will be attached to the overlay panel.
     */
    var /** @type {?} */ TOOLTIP_PANEL_CLASS = 'mat-tooltip-panel';
    /**
     * Creates an error to be thrown if the user supplied an invalid tooltip position.
     * @param {?} position
     * @return {?}
     */
    function getMatTooltipInvalidPositionError(position) {
        return Error("Tooltip position \"" + position + "\" is invalid.");
    }
    /**
     * Injection token that determines the scroll handling while a tooltip is visible.
     */
    var /** @type {?} */ MAT_TOOLTIP_SCROLL_STRATEGY = new core.InjectionToken('mat-tooltip-scroll-strategy');
    /**
     * \@docs-private
     * @param {?} overlay
     * @return {?}
     */
    function MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY(overlay) {
        return function () { return overlay.scrollStrategies.reposition({ scrollThrottle: SCROLL_THROTTLE_MS }); };
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER = {
        provide: MAT_TOOLTIP_SCROLL_STRATEGY,
        deps: [Overlay],
        useFactory: MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY,
    };
    /**
     * Injection token to be used to override the default options for `matTooltip`.
     */
    var /** @type {?} */ MAT_TOOLTIP_DEFAULT_OPTIONS = new core.InjectionToken('mat-tooltip-default-options', {
        providedIn: 'root',
        factory: MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY
    });
    /**
     * @return {?}
     */
    function MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY() {
        return {
            showDelay: 0,
            hideDelay: 0,
            touchendHideDelay: 1500,
        };
    }
    /**
     * Directive that attaches a material design tooltip to the host element. Animates the showing and
     * hiding of a tooltip provided position (defaults to below the element).
     *
     * https://material.google.com/components/tooltips.html
     */
    var MatTooltip = /** @class */ (function () {
        function MatTooltip(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions) {
            var _this = this;
            this._overlay = _overlay;
            this._elementRef = _elementRef;
            this._scrollDispatcher = _scrollDispatcher;
            this._viewContainerRef = _viewContainerRef;
            this._ngZone = _ngZone;
            this._platform = _platform;
            this._ariaDescriber = _ariaDescriber;
            this._focusMonitor = _focusMonitor;
            this._scrollStrategy = _scrollStrategy;
            this._dir = _dir;
            this._defaultOptions = _defaultOptions;
            this._position = 'below';
            this._disabled = false;
            /**
             * The default delay in ms before showing the tooltip after show is called
             */
            this.showDelay = this._defaultOptions.showDelay;
            /**
             * The default delay in ms before hiding the tooltip after hide is called
             */
            this.hideDelay = this._defaultOptions.hideDelay;
            this._message = '';
            this._manualListeners = new Map();
            /**
             * Emits when the component is destroyed.
             */
            this._destroyed = new rxjs.Subject();
            var /** @type {?} */ element = _elementRef.nativeElement;
            // The mouse events shouldn't be bound on iOS devices, because
            // they can prevent the first tap from firing its click event.
            if (!_platform.IOS) {
                this._manualListeners.set('mouseenter', function () { return _this.show(); });
                this._manualListeners.set('mouseleave', function () { return _this.hide(); });
                this._manualListeners
                    .forEach(function (listener, event) { return _elementRef.nativeElement.addEventListener(event, listener); });
            }
            else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                // When we bind a gesture event on an element (in this case `longpress`), HammerJS
                // will add some inline styles by default, including `user-select: none`. This is
                // problematic on iOS, because it will prevent users from typing in inputs. If
                // we're on iOS and the tooltip is attached on an input or textarea, we clear
                // the `user-select` to avoid these issues.
                element.style.webkitUserSelect = element.style.userSelect = '';
            }
            _focusMonitor.monitor(element).pipe(operators.takeUntil(this._destroyed)).subscribe(function (origin) {
                // Note that the focus monitor runs outside the Angular zone.
                if (!origin) {
                    _ngZone.run(function () { return _this.hide(0); });
                }
                else if (origin === 'keyboard') {
                    _ngZone.run(function () { return _this.show(); });
                }
            });
        }
        Object.defineProperty(MatTooltip.prototype, "position", {
            get: /**
             * Allows the user to define the position of the tooltip relative to the parent element
             * @return {?}
             */
            function () { return this._position; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== this._position) {
                    this._position = value;
                    if (this._overlayRef) {
                        this._updatePosition();
                        if (this._tooltipInstance) {
                            /** @type {?} */ ((this._tooltipInstance)).show(0);
                        }
                        this._overlayRef.updatePosition();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTooltip.prototype, "disabled", {
            get: /**
             * Disables the display of the tooltip.
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
                // If tooltip is disabled, hide immediately.
                if (this._disabled) {
                    this.hide(0);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTooltip.prototype, "message", {
            get: /**
             * The message to be displayed in the tooltip
             * @return {?}
             */
            function () { return this._message; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this._message);
                // If the message is not a string (e.g. number), convert it to a string and trim it.
                this._message = value != null ? ("" + value).trim() : '';
                if (!this._message && this._isTooltipVisible()) {
                    this.hide(0);
                }
                else {
                    this._updateTooltipMessage();
                    this._ariaDescriber.describe(this._elementRef.nativeElement, this.message);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTooltip.prototype, "tooltipClass", {
            get: /**
             * Classes to be passed to the tooltip. Supports the same syntax as `ngClass`.
             * @return {?}
             */
            function () { return this._tooltipClass; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._tooltipClass = value;
                if (this._tooltipInstance) {
                    this._setTooltipClass(this._tooltipClass);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Dispose the tooltip when destroyed.
         */
        /**
         * Dispose the tooltip when destroyed.
         * @return {?}
         */
        MatTooltip.prototype.ngOnDestroy = /**
         * Dispose the tooltip when destroyed.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._overlayRef) {
                this._overlayRef.dispose();
                this._tooltipInstance = null;
            }
            // Clean up the event listeners set in the constructor
            if (!this._platform.IOS) {
                this._manualListeners.forEach(function (listener, event) {
                    return _this._elementRef.nativeElement.removeEventListener(event, listener);
                });
                this._manualListeners.clear();
            }
            this._destroyed.next();
            this._destroyed.complete();
            this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this.message);
            this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
        };
        /** Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input */
        /**
         * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
         * @param {?=} delay
         * @return {?}
         */
        MatTooltip.prototype.show = /**
         * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
         * @param {?=} delay
         * @return {?}
         */
        function (delay) {
            var _this = this;
            if (delay === void 0) { delay = this.showDelay; }
            if (this.disabled || !this.message) {
                return;
            }
            var /** @type {?} */ overlayRef = this._createOverlay();
            this._detach();
            this._portal = this._portal || new ComponentPortal(TooltipComponent, this._viewContainerRef);
            this._tooltipInstance = overlayRef.attach(this._portal).instance;
            this._tooltipInstance.afterHidden()
                .pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._detach(); });
            this._setTooltipClass(this._tooltipClass);
            this._updateTooltipMessage(); /** @type {?} */
            ((this._tooltipInstance)).show(delay);
        };
        /** Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input */
        /**
         * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
         * @param {?=} delay
         * @return {?}
         */
        MatTooltip.prototype.hide = /**
         * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
         * @param {?=} delay
         * @return {?}
         */
        function (delay) {
            if (delay === void 0) { delay = this.hideDelay; }
            if (this._tooltipInstance) {
                this._tooltipInstance.hide(delay);
            }
        };
        /** Shows/hides the tooltip */
        /**
         * Shows/hides the tooltip
         * @return {?}
         */
        MatTooltip.prototype.toggle = /**
         * Shows/hides the tooltip
         * @return {?}
         */
        function () {
            this._isTooltipVisible() ? this.hide() : this.show();
        };
        /** Returns true if the tooltip is currently visible to the user */
        /**
         * Returns true if the tooltip is currently visible to the user
         * @return {?}
         */
        MatTooltip.prototype._isTooltipVisible = /**
         * Returns true if the tooltip is currently visible to the user
         * @return {?}
         */
        function () {
            return !!this._tooltipInstance && this._tooltipInstance.isVisible();
        };
        /** Handles the keydown events on the host element. */
        /**
         * Handles the keydown events on the host element.
         * @param {?} e
         * @return {?}
         */
        MatTooltip.prototype._handleKeydown = /**
         * Handles the keydown events on the host element.
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (this._isTooltipVisible() && e.keyCode === ESCAPE) {
                e.stopPropagation();
                this.hide(0);
            }
        };
        /** Handles the touchend events on the host element. */
        /**
         * Handles the touchend events on the host element.
         * @return {?}
         */
        MatTooltip.prototype._handleTouchend = /**
         * Handles the touchend events on the host element.
         * @return {?}
         */
        function () {
            this.hide(this._defaultOptions.touchendHideDelay);
        };
        /**
         * Create the overlay config and position strategy
         * @return {?}
         */
        MatTooltip.prototype._createOverlay = /**
         * Create the overlay config and position strategy
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._overlayRef) {
                return this._overlayRef;
            }
            // Create connected position strategy that listens for scroll events to reposition.
            var /** @type {?} */ strategy = this._overlay.position()
                .flexibleConnectedTo(this._elementRef)
                .withTransformOriginOn('.mat-tooltip')
                .withFlexibleDimensions(false)
                .withViewportMargin(8);
            var /** @type {?} */ scrollableAncestors = this._scrollDispatcher
                .getAncestorScrollContainers(this._elementRef);
            strategy.withScrollableContainers(scrollableAncestors);
            strategy.positionChanges.pipe(operators.takeUntil(this._destroyed)).subscribe(function (change) {
                if (_this._tooltipInstance) {
                    if (change.scrollableViewProperties.isOverlayClipped && _this._tooltipInstance.isVisible()) {
                        // After position changes occur and the overlay is clipped by
                        // a parent scrollable then close the tooltip.
                        // After position changes occur and the overlay is clipped by
                        // a parent scrollable then close the tooltip.
                        _this._ngZone.run(function () { return _this.hide(0); });
                    }
                }
            });
            this._overlayRef = this._overlay.create({
                direction: this._dir,
                positionStrategy: strategy,
                panelClass: TOOLTIP_PANEL_CLASS,
                scrollStrategy: this._scrollStrategy()
            });
            this._updatePosition();
            this._overlayRef.detachments()
                .pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._detach(); });
            return this._overlayRef;
        };
        /**
         * Detaches the currently-attached tooltip.
         * @return {?}
         */
        MatTooltip.prototype._detach = /**
         * Detaches the currently-attached tooltip.
         * @return {?}
         */
        function () {
            if (this._overlayRef && this._overlayRef.hasAttached()) {
                this._overlayRef.detach();
            }
            this._tooltipInstance = null;
        };
        /**
         * Updates the position of the current tooltip.
         * @return {?}
         */
        MatTooltip.prototype._updatePosition = /**
         * Updates the position of the current tooltip.
         * @return {?}
         */
        function () {
            var /** @type {?} */ position = /** @type {?} */ (((this._overlayRef)).getConfig().positionStrategy);
            var /** @type {?} */ origin = this._getOrigin();
            var /** @type {?} */ overlay = this._getOverlayPosition();
            position.withPositions([
                __assign({}, origin.main, overlay.main),
                __assign({}, origin.fallback, overlay.fallback)
            ]);
        };
        /**
         * Returns the origin position and a fallback position based on the user's position preference.
         * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
         */
        /**
         * Returns the origin position and a fallback position based on the user's position preference.
         * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
         * @return {?}
         */
        MatTooltip.prototype._getOrigin = /**
         * Returns the origin position and a fallback position based on the user's position preference.
         * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
         * @return {?}
         */
        function () {
            var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
            var /** @type {?} */ position = this.position;
            var /** @type {?} */ originPosition;
            if (position == 'above' || position == 'below') {
                originPosition = { originX: 'center', originY: position == 'above' ? 'top' : 'bottom' };
            }
            else if (position == 'before' ||
                (position == 'left' && isLtr) ||
                (position == 'right' && !isLtr)) {
                originPosition = { originX: 'start', originY: 'center' };
            }
            else if (position == 'after' ||
                (position == 'right' && isLtr) ||
                (position == 'left' && !isLtr)) {
                originPosition = { originX: 'end', originY: 'center' };
            }
            else {
                throw getMatTooltipInvalidPositionError(position);
            }
            var _a = this._invertPosition(originPosition.originX, originPosition.originY), x = _a.x, y = _a.y;
            return {
                main: originPosition,
                fallback: { originX: x, originY: y }
            };
        };
        /** Returns the overlay position and a fallback position based on the user's preference */
        /**
         * Returns the overlay position and a fallback position based on the user's preference
         * @return {?}
         */
        MatTooltip.prototype._getOverlayPosition = /**
         * Returns the overlay position and a fallback position based on the user's preference
         * @return {?}
         */
        function () {
            var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
            var /** @type {?} */ position = this.position;
            var /** @type {?} */ overlayPosition;
            if (position == 'above') {
                overlayPosition = { overlayX: 'center', overlayY: 'bottom' };
            }
            else if (position == 'below') {
                overlayPosition = { overlayX: 'center', overlayY: 'top' };
            }
            else if (position == 'before' ||
                (position == 'left' && isLtr) ||
                (position == 'right' && !isLtr)) {
                overlayPosition = { overlayX: 'end', overlayY: 'center' };
            }
            else if (position == 'after' ||
                (position == 'right' && isLtr) ||
                (position == 'left' && !isLtr)) {
                overlayPosition = { overlayX: 'start', overlayY: 'center' };
            }
            else {
                throw getMatTooltipInvalidPositionError(position);
            }
            var _a = this._invertPosition(overlayPosition.overlayX, overlayPosition.overlayY), x = _a.x, y = _a.y;
            return {
                main: overlayPosition,
                fallback: { overlayX: x, overlayY: y }
            };
        };
        /**
         * Updates the tooltip message and repositions the overlay according to the new message length
         * @return {?}
         */
        MatTooltip.prototype._updateTooltipMessage = /**
         * Updates the tooltip message and repositions the overlay according to the new message length
         * @return {?}
         */
        function () {
            var _this = this;
            // Must wait for the message to be painted to the tooltip so that the overlay can properly
            // calculate the correct positioning based on the size of the text.
            if (this._tooltipInstance) {
                this._tooltipInstance.message = this.message;
                this._tooltipInstance._markForCheck();
                this._ngZone.onMicrotaskEmpty.asObservable().pipe(operators.take(1), operators.takeUntil(this._destroyed)).subscribe(function () {
                    if (_this._tooltipInstance) {
                        /** @type {?} */ ((_this._overlayRef)).updatePosition();
                    }
                });
            }
        };
        /**
         * Updates the tooltip class
         * @param {?} tooltipClass
         * @return {?}
         */
        MatTooltip.prototype._setTooltipClass = /**
         * Updates the tooltip class
         * @param {?} tooltipClass
         * @return {?}
         */
        function (tooltipClass) {
            if (this._tooltipInstance) {
                this._tooltipInstance.tooltipClass = tooltipClass;
                this._tooltipInstance._markForCheck();
            }
        };
        /**
         * Inverts an overlay position.
         * @param {?} x
         * @param {?} y
         * @return {?}
         */
        MatTooltip.prototype._invertPosition = /**
         * Inverts an overlay position.
         * @param {?} x
         * @param {?} y
         * @return {?}
         */
        function (x, y) {
            if (this.position === 'above' || this.position === 'below') {
                if (y === 'top') {
                    y = 'bottom';
                }
                else if (y === 'bottom') {
                    y = 'top';
                }
            }
            else {
                if (x === 'end') {
                    x = 'start';
                }
                else if (x === 'start') {
                    x = 'end';
                }
            }
            return { x: x, y: y };
        };
        MatTooltip.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTooltip]',
                        exportAs: 'matTooltip',
                        host: {
                            '(longpress)': 'show()',
                            '(keydown)': '_handleKeydown($event)',
                            '(touchend)': '_handleTouchend()',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatTooltip.ctorParameters = function () { return [
            { type: Overlay, },
            { type: core.ElementRef, },
            { type: ScrollDispatcher, },
            { type: core.ViewContainerRef, },
            { type: core.NgZone, },
            { type: Platform, },
            { type: AriaDescriber, },
            { type: FocusMonitor, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_TOOLTIP_SCROLL_STRATEGY,] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_TOOLTIP_DEFAULT_OPTIONS,] },] },
        ]; };
        MatTooltip.propDecorators = {
            "position": [{ type: core.Input, args: ['matTooltipPosition',] },],
            "disabled": [{ type: core.Input, args: ['matTooltipDisabled',] },],
            "showDelay": [{ type: core.Input, args: ['matTooltipShowDelay',] },],
            "hideDelay": [{ type: core.Input, args: ['matTooltipHideDelay',] },],
            "message": [{ type: core.Input, args: ['matTooltip',] },],
            "tooltipClass": [{ type: core.Input, args: ['matTooltipClass',] },],
        };
        return MatTooltip;
    }());
    /**
     * Internal component that wraps the tooltip's content.
     * \@docs-private
     */
    var TooltipComponent = /** @class */ (function () {
        function TooltipComponent(_changeDetectorRef, _breakpointObserver) {
            this._changeDetectorRef = _changeDetectorRef;
            this._breakpointObserver = _breakpointObserver;
            /**
             * Property watched by the animation framework to show or hide the tooltip
             */
            this._visibility = 'initial';
            /**
             * Whether interactions on the page should close the tooltip
             */
            this._closeOnInteraction = false;
            /**
             * Subject for notifying that the tooltip has been hidden from the view
             */
            this._onHide = new rxjs.Subject();
            /**
             * Stream that emits whether the user has a handset-sized display.
             */
            this._isHandset = this._breakpointObserver.observe(Breakpoints.Handset);
        }
        /**
         * Shows the tooltip with an animation originating from the provided origin
         * @param delay Amount of milliseconds to the delay showing the tooltip.
         */
        /**
         * Shows the tooltip with an animation originating from the provided origin
         * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
         * @return {?}
         */
        TooltipComponent.prototype.show = /**
         * Shows the tooltip with an animation originating from the provided origin
         * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
         * @return {?}
         */
        function (delay) {
            var _this = this;
            // Cancel the delayed hide if it is scheduled
            if (this._hideTimeoutId) {
                clearTimeout(this._hideTimeoutId);
            }
            // Body interactions should cancel the tooltip if there is a delay in showing.
            this._closeOnInteraction = true;
            this._showTimeoutId = setTimeout(function () {
                _this._visibility = 'visible';
                // Mark for check so if any parent component has set the
                // ChangeDetectionStrategy to OnPush it will be checked anyways
                // Mark for check so if any parent component has set the
                // ChangeDetectionStrategy to OnPush it will be checked anyways
                _this._markForCheck();
            }, delay);
        };
        /**
         * Begins the animation to hide the tooltip after the provided delay in ms.
         * @param delay Amount of milliseconds to delay showing the tooltip.
         */
        /**
         * Begins the animation to hide the tooltip after the provided delay in ms.
         * @param {?} delay Amount of milliseconds to delay showing the tooltip.
         * @return {?}
         */
        TooltipComponent.prototype.hide = /**
         * Begins the animation to hide the tooltip after the provided delay in ms.
         * @param {?} delay Amount of milliseconds to delay showing the tooltip.
         * @return {?}
         */
        function (delay) {
            var _this = this;
            // Cancel the delayed show if it is scheduled
            if (this._showTimeoutId) {
                clearTimeout(this._showTimeoutId);
            }
            this._hideTimeoutId = setTimeout(function () {
                _this._visibility = 'hidden';
                // Mark for check so if any parent component has set the
                // ChangeDetectionStrategy to OnPush it will be checked anyways
                // Mark for check so if any parent component has set the
                // ChangeDetectionStrategy to OnPush it will be checked anyways
                _this._markForCheck();
            }, delay);
        };
        /** Returns an observable that notifies when the tooltip has been hidden from view. */
        /**
         * Returns an observable that notifies when the tooltip has been hidden from view.
         * @return {?}
         */
        TooltipComponent.prototype.afterHidden = /**
         * Returns an observable that notifies when the tooltip has been hidden from view.
         * @return {?}
         */
        function () {
            return this._onHide.asObservable();
        };
        /** Whether the tooltip is being displayed. */
        /**
         * Whether the tooltip is being displayed.
         * @return {?}
         */
        TooltipComponent.prototype.isVisible = /**
         * Whether the tooltip is being displayed.
         * @return {?}
         */
        function () {
            return this._visibility === 'visible';
        };
        /**
         * @return {?}
         */
        TooltipComponent.prototype._animationStart = /**
         * @return {?}
         */
        function () {
            this._closeOnInteraction = false;
        };
        /**
         * @param {?} event
         * @return {?}
         */
        TooltipComponent.prototype._animationDone = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ toState = /** @type {?} */ (event.toState);
            if (toState === 'hidden' && !this.isVisible()) {
                this._onHide.next();
            }
            if (toState === 'visible' || toState === 'hidden') {
                this._closeOnInteraction = true;
            }
        };
        /**
         * Interactions on the HTML body should close the tooltip immediately as defined in the
         * material design spec.
         * https://material.google.com/components/tooltips.html#tooltips-interaction
         */
        /**
         * Interactions on the HTML body should close the tooltip immediately as defined in the
         * material design spec.
         * https://material.google.com/components/tooltips.html#tooltips-interaction
         * @return {?}
         */
        TooltipComponent.prototype._handleBodyInteraction = /**
         * Interactions on the HTML body should close the tooltip immediately as defined in the
         * material design spec.
         * https://material.google.com/components/tooltips.html#tooltips-interaction
         * @return {?}
         */
        function () {
            if (this._closeOnInteraction) {
                this.hide(0);
            }
        };
        /**
         * Marks that the tooltip needs to be checked in the next change detection run.
         * Mainly used for rendering the initial text before positioning a tooltip, which
         * can be problematic in components with OnPush change detection.
         */
        /**
         * Marks that the tooltip needs to be checked in the next change detection run.
         * Mainly used for rendering the initial text before positioning a tooltip, which
         * can be problematic in components with OnPush change detection.
         * @return {?}
         */
        TooltipComponent.prototype._markForCheck = /**
         * Marks that the tooltip needs to be checked in the next change detection run.
         * Mainly used for rendering the initial text before positioning a tooltip, which
         * can be problematic in components with OnPush change detection.
         * @return {?}
         */
        function () {
            this._changeDetectorRef.markForCheck();
        };
        TooltipComponent.decorators = [
            { type: core.Component, args: [{selector: 'mat-tooltip-component',
                        template: "<div class=\"mat-tooltip\" [ngClass]=\"tooltipClass\" [class.mat-tooltip-handset]=\"(_isHandset | async)!.matches\" [@state]=\"_visibility\" (@state.start)=\"_animationStart()\" (@state.done)=\"_animationDone($event)\">{{message}}</div>",
                        styles: [".mat-tooltip-panel{pointer-events:none!important}.mat-tooltip{color:#fff;border-radius:2px;margin:14px;max-width:250px;padding-left:8px;padding-right:8px;overflow:hidden;text-overflow:ellipsis}@media screen and (-ms-high-contrast:active){.mat-tooltip{outline:solid 1px}}.mat-tooltip-handset{margin:24px;padding-left:16px;padding-right:16px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        animations: [matTooltipAnimations.tooltipState],
                        host: {
                            // Forces the element to have a layout in IE and Edge. This fixes issues where the element
                            // won't be rendered if the animations are disabled or there is no web animations polyfill.
                            '[style.zoom]': '_visibility === "visible" ? 1 : null',
                            '(body:click)': 'this._handleBodyInteraction()',
                            'aria-hidden': 'true',
                        }
                    },] },
        ];
        /** @nocollapse */
        TooltipComponent.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: BreakpointObserver, },
        ]; };
        return TooltipComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatTooltipModule = /** @class */ (function () {
        function MatTooltipModule() {
        }
        MatTooltipModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            A11yModule,
                            common.CommonModule,
                            OverlayModule,
                            MatCommonModule,
                        ],
                        exports: [MatTooltip, TooltipComponent, MatCommonModule],
                        declarations: [MatTooltip, TooltipComponent],
                        entryComponents: [TooltipComponent],
                        providers: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER]
                    },] },
        ];
        return MatTooltipModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * To modify the labels and text displayed, create a new instance of MatPaginatorIntl and
     * include it in a custom provider
     */
    var MatPaginatorIntl = /** @class */ (function () {
        function MatPaginatorIntl() {
            /**
             * Stream that emits whenever the labels here are changed. Use this to notify
             * components if the labels have changed after initialization.
             */
            this.changes = new rxjs.Subject();
            /**
             * A label for the page size selector.
             */
            this.itemsPerPageLabel = 'Items per page:';
            /**
             * A label for the button that increments the current page.
             */
            this.nextPageLabel = 'Next page';
            /**
             * A label for the button that decrements the current page.
             */
            this.previousPageLabel = 'Previous page';
            /**
             * A label for the button that moves to the first page.
             */
            this.firstPageLabel = 'First page';
            /**
             * A label for the button that moves to the last page.
             */
            this.lastPageLabel = 'Last page';
            /**
             * A label for the range of items within the current page and the length of the whole list.
             */
            this.getRangeLabel = function (page, pageSize, length) {
                if (length == 0 || pageSize == 0) {
                    return "0 of " + length;
                }
                length = Math.max(length, 0);
                var /** @type {?} */ startIndex = page * pageSize;
                // If the start index exceeds the list length, do not try and fix the end index to the end.
                var /** @type {?} */ endIndex = startIndex < length ?
                    Math.min(startIndex + pageSize, length) :
                    startIndex + pageSize;
                return startIndex + 1 + " - " + endIndex + " of " + length;
            };
        }
        MatPaginatorIntl.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ MatPaginatorIntl.ngInjectableDef = core.defineInjectable({ factory: function MatPaginatorIntl_Factory() { return new MatPaginatorIntl(); }, token: MatPaginatorIntl, providedIn: "root" });
        return MatPaginatorIntl;
    }());
    /**
     * \@docs-private
     * @param {?} parentIntl
     * @return {?}
     */
    function MAT_PAGINATOR_INTL_PROVIDER_FACTORY(parentIntl) {
        return parentIntl || new MatPaginatorIntl();
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_PAGINATOR_INTL_PROVIDER = {
        // If there is already an MatPaginatorIntl available, use that. Otherwise, provide a new one.
        provide: MatPaginatorIntl,
        deps: [[new core.Optional(), new core.SkipSelf(), MatPaginatorIntl]],
        useFactory: MAT_PAGINATOR_INTL_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The default page size if there is no page size and there are no provided page size options.
     */
    var /** @type {?} */ DEFAULT_PAGE_SIZE = 50;
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatPaginatorBase = /** @class */ (function () {
        function MatPaginatorBase() {
        }
        return MatPaginatorBase;
    }());
    var /** @type {?} */ _MatPaginatorBase = mixinInitialized(MatPaginatorBase);
    /**
     * Component to provide navigation between paged information. Displays the size of the current
     * page, user-selectable options to change that size, what items are being shown, and
     * navigational button to go to the previous or next page.
     */
    var MatPaginator = /** @class */ (function (_super) {
        __extends(MatPaginator, _super);
        function MatPaginator(_intl, _changeDetectorRef) {
            var _this = _super.call(this) || this;
            _this._intl = _intl;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._pageIndex = 0;
            _this._length = 0;
            _this._pageSizeOptions = [];
            _this._hidePageSize = false;
            _this._showFirstLastButtons = false;
            /**
             * Event emitted when the paginator changes the page size or page index.
             */
            _this.page = new core.EventEmitter();
            _this._intlChanges = _intl.changes.subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
            return _this;
        }
        Object.defineProperty(MatPaginator.prototype, "pageIndex", {
            get: /**
             * The zero-based page index of the displayed list of items. Defaulted to 0.
             * @return {?}
             */
            function () { return this._pageIndex; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._pageIndex = Math.max(coerceNumberProperty(value), 0);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatPaginator.prototype, "length", {
            get: /**
             * The length of the total number of items that are being paginated. Defaulted to 0.
             * @return {?}
             */
            function () { return this._length; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._length = coerceNumberProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatPaginator.prototype, "pageSize", {
            get: /**
             * Number of items to display on a page. By default set to 50.
             * @return {?}
             */
            function () { return this._pageSize; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._pageSize = Math.max(coerceNumberProperty(value), 0);
                this._updateDisplayedPageSizeOptions();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatPaginator.prototype, "pageSizeOptions", {
            get: /**
             * The set of provided page size options to display to the user.
             * @return {?}
             */
            function () { return this._pageSizeOptions; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._pageSizeOptions = (value || []).map(function (p) { return coerceNumberProperty(p); });
                this._updateDisplayedPageSizeOptions();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatPaginator.prototype, "hidePageSize", {
            get: /**
             * Whether to hide the page size selection UI from the user.
             * @return {?}
             */
            function () { return this._hidePageSize; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._hidePageSize = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatPaginator.prototype, "showFirstLastButtons", {
            get: /**
             * Whether to show the first/last buttons UI to the user.
             * @return {?}
             */
            function () { return this._showFirstLastButtons; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._showFirstLastButtons = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatPaginator.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._initialized = true;
            this._updateDisplayedPageSizeOptions();
            this._markInitialized();
        };
        /**
         * @return {?}
         */
        MatPaginator.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._intlChanges.unsubscribe();
        };
        /** Advances to the next page if it exists. */
        /**
         * Advances to the next page if it exists.
         * @return {?}
         */
        MatPaginator.prototype.nextPage = /**
         * Advances to the next page if it exists.
         * @return {?}
         */
        function () {
            if (!this.hasNextPage()) {
                return;
            }
            var /** @type {?} */ previousPageIndex = this.pageIndex;
            this.pageIndex++;
            this._emitPageEvent(previousPageIndex);
        };
        /** Move back to the previous page if it exists. */
        /**
         * Move back to the previous page if it exists.
         * @return {?}
         */
        MatPaginator.prototype.previousPage = /**
         * Move back to the previous page if it exists.
         * @return {?}
         */
        function () {
            if (!this.hasPreviousPage()) {
                return;
            }
            var /** @type {?} */ previousPageIndex = this.pageIndex;
            this.pageIndex--;
            this._emitPageEvent(previousPageIndex);
        };
        /** Move to the first page if not already there. */
        /**
         * Move to the first page if not already there.
         * @return {?}
         */
        MatPaginator.prototype.firstPage = /**
         * Move to the first page if not already there.
         * @return {?}
         */
        function () {
            // hasPreviousPage being false implies at the start
            if (!this.hasPreviousPage()) {
                return;
            }
            var /** @type {?} */ previousPageIndex = this.pageIndex;
            this.pageIndex = 0;
            this._emitPageEvent(previousPageIndex);
        };
        /** Move to the last page if not already there. */
        /**
         * Move to the last page if not already there.
         * @return {?}
         */
        MatPaginator.prototype.lastPage = /**
         * Move to the last page if not already there.
         * @return {?}
         */
        function () {
            // hasNextPage being false implies at the end
            if (!this.hasNextPage()) {
                return;
            }
            var /** @type {?} */ previousPageIndex = this.pageIndex;
            this.pageIndex = this.getNumberOfPages();
            this._emitPageEvent(previousPageIndex);
        };
        /** Whether there is a previous page. */
        /**
         * Whether there is a previous page.
         * @return {?}
         */
        MatPaginator.prototype.hasPreviousPage = /**
         * Whether there is a previous page.
         * @return {?}
         */
        function () {
            return this.pageIndex >= 1 && this.pageSize != 0;
        };
        /** Whether there is a next page. */
        /**
         * Whether there is a next page.
         * @return {?}
         */
        MatPaginator.prototype.hasNextPage = /**
         * Whether there is a next page.
         * @return {?}
         */
        function () {
            var /** @type {?} */ numberOfPages = this.getNumberOfPages();
            return this.pageIndex < numberOfPages && this.pageSize != 0;
        };
        /** Calculate the number of pages */
        /**
         * Calculate the number of pages
         * @return {?}
         */
        MatPaginator.prototype.getNumberOfPages = /**
         * Calculate the number of pages
         * @return {?}
         */
        function () {
            return Math.ceil(this.length / this.pageSize) - 1;
        };
        /**
         * Changes the page size so that the first item displayed on the page will still be
         * displayed using the new page size.
         *
         * For example, if the page size is 10 and on the second page (items indexed 10-19) then
         * switching so that the page size is 5 will set the third page as the current page so
         * that the 10th item will still be displayed.
         */
        /**
         * Changes the page size so that the first item displayed on the page will still be
         * displayed using the new page size.
         *
         * For example, if the page size is 10 and on the second page (items indexed 10-19) then
         * switching so that the page size is 5 will set the third page as the current page so
         * that the 10th item will still be displayed.
         * @param {?} pageSize
         * @return {?}
         */
        MatPaginator.prototype._changePageSize = /**
         * Changes the page size so that the first item displayed on the page will still be
         * displayed using the new page size.
         *
         * For example, if the page size is 10 and on the second page (items indexed 10-19) then
         * switching so that the page size is 5 will set the third page as the current page so
         * that the 10th item will still be displayed.
         * @param {?} pageSize
         * @return {?}
         */
        function (pageSize) {
            // Current page needs to be updated to reflect the new page size. Navigate to the page
            // containing the previous page's first item.
            var /** @type {?} */ startIndex = this.pageIndex * this.pageSize;
            var /** @type {?} */ previousPageIndex = this.pageIndex;
            this.pageIndex = Math.floor(startIndex / pageSize) || 0;
            this.pageSize = pageSize;
            this._emitPageEvent(previousPageIndex);
        };
        /**
         * Updates the list of page size options to display to the user. Includes making sure that
         * the page size is an option and that the list is sorted.
         * @return {?}
         */
        MatPaginator.prototype._updateDisplayedPageSizeOptions = /**
         * Updates the list of page size options to display to the user. Includes making sure that
         * the page size is an option and that the list is sorted.
         * @return {?}
         */
        function () {
            if (!this._initialized) {
                return;
            }
            // If no page size is provided, use the first page size option or the default page size.
            if (!this.pageSize) {
                this._pageSize = this.pageSizeOptions.length != 0 ?
                    this.pageSizeOptions[0] :
                    DEFAULT_PAGE_SIZE;
            }
            this._displayedPageSizeOptions = this.pageSizeOptions.slice();
            if (this._displayedPageSizeOptions.indexOf(this.pageSize) === -1) {
                this._displayedPageSizeOptions.push(this.pageSize);
            }
            // Sort the numbers using a number-specific sort function.
            this._displayedPageSizeOptions.sort(function (a, b) { return a - b; });
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Emits an event notifying that a change of the paginator's properties has been triggered.
         * @param {?} previousPageIndex
         * @return {?}
         */
        MatPaginator.prototype._emitPageEvent = /**
         * Emits an event notifying that a change of the paginator's properties has been triggered.
         * @param {?} previousPageIndex
         * @return {?}
         */
        function (previousPageIndex) {
            this.page.emit({
                previousPageIndex: previousPageIndex,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                length: this.length
            });
        };
        MatPaginator.decorators = [
            { type: core.Component, args: [{selector: 'mat-paginator',
                        exportAs: 'matPaginator',
                        template: "<div class=\"mat-paginator-container\"><div class=\"mat-paginator-page-size\" *ngIf=\"!hidePageSize\"><div class=\"mat-paginator-page-size-label\">{{_intl.itemsPerPageLabel}}</div><mat-form-field *ngIf=\"_displayedPageSizeOptions.length > 1\" class=\"mat-paginator-page-size-select\"><mat-select [value]=\"pageSize\" [aria-label]=\"_intl.itemsPerPageLabel\" (selectionChange)=\"_changePageSize($event.value)\"><mat-option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\">{{pageSizeOption}}</mat-option></mat-select></mat-form-field><div *ngIf=\"_displayedPageSizeOptions.length <= 1\">{{pageSize}}</div></div><div class=\"mat-paginator-range-actions\"><div class=\"mat-paginator-range-label\">{{_intl.getRangeLabel(pageIndex, pageSize, length)}}</div><button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-first\" (click)=\"firstPage()\" [attr.aria-label]=\"_intl.firstPageLabel\" [matTooltip]=\"_intl.firstPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasPreviousPage()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-previous\" (click)=\"previousPage()\" [attr.aria-label]=\"_intl.previousPageLabel\" [matTooltip]=\"_intl.previousPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasPreviousPage()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-next\" (click)=\"nextPage()\" [attr.aria-label]=\"_intl.nextPageLabel\" [matTooltip]=\"_intl.nextPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasNextPage()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-last\" (click)=\"lastPage()\" [attr.aria-label]=\"_intl.lastPageLabel\" [matTooltip]=\"_intl.lastPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasNextPage()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z\"/></svg></button></div></div>",
                        styles: [".mat-paginator{display:block}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0 4px;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-page-size-select.mat-form-field-appearance-fill{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center;min-height:48px}.mat-paginator-icon{width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}"],
                        host: {
                            'class': 'mat-paginator',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatPaginator.ctorParameters = function () { return [
            { type: MatPaginatorIntl, },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatPaginator.propDecorators = {
            "pageIndex": [{ type: core.Input },],
            "length": [{ type: core.Input },],
            "pageSize": [{ type: core.Input },],
            "pageSizeOptions": [{ type: core.Input },],
            "hidePageSize": [{ type: core.Input },],
            "showFirstLastButtons": [{ type: core.Input },],
            "page": [{ type: core.Output },],
        };
        return MatPaginator;
    }(_MatPaginatorBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatPaginatorModule = /** @class */ (function () {
        function MatPaginatorModule() {
        }
        MatPaginatorModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            MatButtonModule,
                            MatSelectModule,
                            MatTooltipModule,
                        ],
                        exports: [MatPaginator],
                        declarations: [MatPaginator],
                        providers: [MAT_PAGINATOR_INTL_PROVIDER],
                    },] },
        ];
        return MatPaginatorModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatProgressBarBase = /** @class */ (function () {
        function MatProgressBarBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatProgressBarBase;
    }());
    var /** @type {?} */ _MatProgressBarMixinBase = mixinColor(MatProgressBarBase, 'primary');
    /**
     * Counter used to generate unique IDs for progress bars.
     */
    var /** @type {?} */ progressbarId = 0;
    /**
     * `<mat-progress-bar>` component.
     */
    var MatProgressBar = /** @class */ (function (_super) {
        __extends(MatProgressBar, _super);
        function MatProgressBar(_elementRef, _animationMode) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._animationMode = _animationMode;
            _this._value = 0;
            _this._bufferValue = 0;
            /**
             * Mode of the progress bar.
             *
             * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
             * 'determinate'.
             * Mirrored to mode attribute.
             */
            _this.mode = 'determinate';
            /**
             * The id of the progress bar.
             */
            _this.progressbarId = "mat-progress-bar-" + progressbarId++;
            return _this;
        }
        Object.defineProperty(MatProgressBar.prototype, "value", {
            get: /**
             * Value of the progress bar. Defaults to zero. Mirrored to aria-valuenow.
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) { this._value = clamp(v || 0); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressBar.prototype, "bufferValue", {
            get: /**
             * Buffer value of the progress bar. Defaults to zero.
             * @return {?}
             */
            function () { return this._bufferValue; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) { this._bufferValue = clamp(v || 0); },
            enumerable: true,
            configurable: true
        });
        /** Gets the current transform value for the progress bar's primary indicator. */
        /**
         * Gets the current transform value for the progress bar's primary indicator.
         * @return {?}
         */
        MatProgressBar.prototype._primaryTransform = /**
         * Gets the current transform value for the progress bar's primary indicator.
         * @return {?}
         */
        function () {
            var /** @type {?} */ scale = this.value / 100;
            return { transform: "scaleX(" + scale + ")" };
        };
        /**
         * Gets the current transform value for the progress bar's buffer indicator. Only used if the
         * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
         */
        /**
         * Gets the current transform value for the progress bar's buffer indicator. Only used if the
         * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
         * @return {?}
         */
        MatProgressBar.prototype._bufferTransform = /**
         * Gets the current transform value for the progress bar's buffer indicator. Only used if the
         * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
         * @return {?}
         */
        function () {
            if (this.mode === 'buffer') {
                var /** @type {?} */ scale = this.bufferValue / 100;
                return { transform: "scaleX(" + scale + ")" };
            }
        };
        MatProgressBar.decorators = [
            { type: core.Component, args: [{selector: 'mat-progress-bar',
                        exportAs: 'matProgressBar',
                        host: {
                            'role': 'progressbar',
                            'aria-valuemin': '0',
                            'aria-valuemax': '100',
                            '[attr.aria-valuenow]': 'value',
                            '[attr.mode]': 'mode',
                            'class': 'mat-progress-bar',
                            '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                        },
                        inputs: ['color'],
                        template: "<svg width=\"100%\" height=\"5\" focusable=\"false\" class=\"mat-progress-bar-background mat-progress-bar-element\"><defs><pattern [id]=\"progressbarId\" x=\"5\" y=\"0\" width=\"10\" height=\"5\" patternUnits=\"userSpaceOnUse\"><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\"/></pattern></defs><rect [attr.fill]=\"'url(#' + progressbarId + ')'\" width=\"100%\" height=\"100%\"/></svg><div class=\"mat-progress-bar-buffer mat-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div><div class=\"mat-progress-bar-primary mat-progress-bar-fill mat-progress-bar-element\" [ngStyle]=\"_primaryTransform()\"></div><div class=\"mat-progress-bar-secondary mat-progress-bar-fill mat-progress-bar-element\"></div>",
                        styles: [".mat-progress-bar{display:block;height:5px;overflow:hidden;position:relative;transition:opacity 250ms linear;width:100%}._mat-animation-noopable.mat-progress-bar{transition:none;animation:none}.mat-progress-bar .mat-progress-bar-element,.mat-progress-bar .mat-progress-bar-fill::after{height:100%;position:absolute;width:100%}.mat-progress-bar .mat-progress-bar-background{width:calc(100% + 10px)}@media screen and (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-background{display:none}}.mat-progress-bar .mat-progress-bar-buffer{transform-origin:top left;transition:transform 250ms ease}._mat-animation-noopable.mat-progress-bar .mat-progress-bar-buffer{transition:none;animation:none}@media screen and (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-buffer{border-top:solid 5px;opacity:.5}}.mat-progress-bar .mat-progress-bar-secondary{display:none}.mat-progress-bar .mat-progress-bar-fill{animation:none;transform-origin:top left;transition:transform 250ms ease}._mat-animation-noopable.mat-progress-bar .mat-progress-bar-fill{transition:none;animation:none}@media screen and (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-fill{border-top:solid 5px}}.mat-progress-bar .mat-progress-bar-fill::after{animation:none;content:'';display:inline-block;left:0}._mat-animation-noopable.mat-progress-bar .mat-progress-bar-fill::after{transition:none;animation:none}.mat-progress-bar[dir=rtl],[dir=rtl] .mat-progress-bar{transform:rotateY(180deg)}.mat-progress-bar[mode=query]{transform:rotateZ(180deg)}.mat-progress-bar[mode=query][dir=rtl],[dir=rtl] .mat-progress-bar[mode=query]{transform:rotateZ(180deg) rotateY(180deg)}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-fill,.mat-progress-bar[mode=query] .mat-progress-bar-fill{transition:none}._mat-animation-noopable.mat-progress-bar[mode=indeterminate] .mat-progress-bar-fill,.mat-progress-bar[mode=query] .mat-progress-bar-fill{transition:none;animation:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary,.mat-progress-bar[mode=query] .mat-progress-bar-primary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-translate 2s infinite linear;left:-145.166611%}._mat-animation-noopable.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary,.mat-progress-bar[mode=query] .mat-progress-bar-primary{transition:none;animation:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-scale 2s infinite linear}._mat-animation-noopable.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{transition:none;animation:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary,.mat-progress-bar[mode=query] .mat-progress-bar-secondary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-translate 2s infinite linear;left:-54.888891%;display:block}._mat-animation-noopable.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary,.mat-progress-bar[mode=query] .mat-progress-bar-secondary{transition:none;animation:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-scale 2s infinite linear}._mat-animation-noopable.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{transition:none;animation:none}.mat-progress-bar[mode=buffer] .mat-progress-bar-background{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-background-scroll 250ms infinite linear;display:block}._mat-animation-noopable.mat-progress-bar[mode=buffer] .mat-progress-bar-background{transition:none;animation:none}@keyframes mat-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(.5,0,.70173,.49582);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);transform:translateX(83.67142%)}100%{transform:translateX(200.61106%)}}@keyframes mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.66148)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:translateX(37.65191%)}48.35%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:translateX(84.38617%)}100%{transform:translateX(160.27778%)}}@keyframes mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:scaleX(.4571)}44.15%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:scaleX(.72796)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-background-scroll{to{transform:translateX(-10px)}}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatProgressBar.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatProgressBar.propDecorators = {
            "value": [{ type: core.Input },],
            "bufferValue": [{ type: core.Input },],
            "mode": [{ type: core.Input },],
        };
        return MatProgressBar;
    }(_MatProgressBarMixinBase));
    /**
     * Clamps a value to be between two numbers, by default 0 and 100.
     * @param {?} v
     * @param {?=} min
     * @param {?=} max
     * @return {?}
     */
    function clamp(v, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 100; }
        return Math.max(min, Math.min(max, v));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatProgressBarModule = /** @class */ (function () {
        function MatProgressBarModule() {
        }
        MatProgressBarModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, MatCommonModule],
                        exports: [MatProgressBar, MatCommonModule],
                        declarations: [MatProgressBar],
                    },] },
        ];
        return MatProgressBarModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Base reference size of the spinner.
     * \@docs-private
     */
    var /** @type {?} */ BASE_SIZE = 100;
    /**
     * Base reference stroke width of the spinner.
     * \@docs-private
     */
    var /** @type {?} */ BASE_STROKE_WIDTH = 10;
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatProgressSpinnerBase = /** @class */ (function () {
        function MatProgressSpinnerBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatProgressSpinnerBase;
    }());
    var /** @type {?} */ _MatProgressSpinnerMixinBase = mixinColor(MatProgressSpinnerBase, 'primary');
    /**
     * Injection token to be used to override the default options for `mat-progress-spinner`.
     */
    var /** @type {?} */ MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS = new core.InjectionToken('mat-progress-spinner-default-options', {
        providedIn: 'root',
        factory: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY() {
        return { diameter: BASE_SIZE };
    }
    // .0001 percentage difference is necessary in order to avoid unwanted animation frames
    // for example because the animation duration is 4 seconds, .1% accounts to 4ms
    // which are enough to see the flicker described in
    // https://github.com/angular/material2/issues/8984
    var /** @type {?} */ INDETERMINATE_ANIMATION_TEMPLATE = "\n @keyframes mat-progress-spinner-stroke-rotate-DIAMETER {\n    0%      { stroke-dashoffset: START_VALUE;  transform: rotate(0); }\n    12.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(0); }\n    12.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(72.5deg); }\n    25%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(72.5deg); }\n\n    25.0001%   { stroke-dashoffset: START_VALUE;  transform: rotate(270deg); }\n    37.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(270deg); }\n    37.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(161.5deg); }\n    50%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(161.5deg); }\n\n    50.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(180deg); }\n    62.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(180deg); }\n    62.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(251.5deg); }\n    75%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(251.5deg); }\n\n    75.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(90deg); }\n    87.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(90deg); }\n    87.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(341.5deg); }\n    100%    { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(341.5deg); }\n  }\n";
    /**
     * `<mat-progress-spinner>` component.
     */
    var MatProgressSpinner = /** @class */ (function (_super) {
        __extends(MatProgressSpinner, _super);
        function MatProgressSpinner(_elementRef, platform, _document, 
        // @deletion-target 7.0.0 _animationMode and defaults parameters to be made required.
        _animationMode, defaults) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._document = _document;
            _this._animationMode = _animationMode;
            _this._value = 0;
            _this._fallbackAnimation = false;
            _this._diameter = BASE_SIZE;
            /**
             * Mode of the progress circle
             */
            _this.mode = 'determinate';
            _this._fallbackAnimation = platform.EDGE || platform.TRIDENT;
            if (defaults) {
                if (defaults.diameter) {
                    _this.diameter = defaults.diameter;
                }
                if (defaults.strokeWidth) {
                    _this.strokeWidth = defaults.strokeWidth;
                }
            }
            // On IE and Edge, we can't animate the `stroke-dashoffset`
            // reliably so we fall back to a non-spec animation.
            var /** @type {?} */ animationClass = "mat-progress-spinner-indeterminate" + (_this._fallbackAnimation ? '-fallback' : '') + "-animation";
            _elementRef.nativeElement.classList.add(animationClass);
            return _this;
        }
        Object.defineProperty(MatProgressSpinner.prototype, "diameter", {
            get: /**
             * The diameter of the progress spinner (will set width and height of svg).
             * @return {?}
             */
            function () { return this._diameter; },
            set: /**
             * @param {?} size
             * @return {?}
             */
            function (size) {
                this._diameter = coerceNumberProperty(size);
                if (!this._fallbackAnimation && !MatProgressSpinner.diameters.has(this._diameter)) {
                    this._attachStyleNode();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "strokeWidth", {
            get: /**
             * Stroke width of the progress spinner.
             * @return {?}
             */
            function () {
                return this._strokeWidth || this.diameter / 10;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._strokeWidth = coerceNumberProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "value", {
            get: /**
             * Value of the progress circle.
             * @return {?}
             */
            function () {
                return this.mode === 'determinate' ? this._value : 0;
            },
            set: /**
             * @param {?} newValue
             * @return {?}
             */
            function (newValue) {
                this._value = Math.max(0, Math.min(100, coerceNumberProperty(newValue)));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "_circleRadius", {
            /** The radius of the spinner, adjusted for stroke width. */
            get: /**
             * The radius of the spinner, adjusted for stroke width.
             * @return {?}
             */
            function () {
                return (this.diameter - BASE_STROKE_WIDTH) / 2;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "_viewBox", {
            /** The view box of the spinner's svg element. */
            get: /**
             * The view box of the spinner's svg element.
             * @return {?}
             */
            function () {
                var /** @type {?} */ viewBox = this._circleRadius * 2 + this.strokeWidth;
                return "0 0 " + viewBox + " " + viewBox;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "_strokeCircumference", {
            /** The stroke circumference of the svg circle. */
            get: /**
             * The stroke circumference of the svg circle.
             * @return {?}
             */
            function () {
                return 2 * Math.PI * this._circleRadius;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "_strokeDashOffset", {
            /** The dash offset of the svg circle. */
            get: /**
             * The dash offset of the svg circle.
             * @return {?}
             */
            function () {
                if (this.mode === 'determinate') {
                    return this._strokeCircumference * (100 - this._value) / 100;
                }
                // In fallback mode set the circle to 80% and rotate it with CSS.
                if (this._fallbackAnimation && this.mode === 'indeterminate') {
                    return this._strokeCircumference * 0.2;
                }
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatProgressSpinner.prototype, "_circleStrokeWidth", {
            /** Stroke width of the circle in percent. */
            get: /**
             * Stroke width of the circle in percent.
             * @return {?}
             */
            function () {
                return this.strokeWidth / this.diameter * 100;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Dynamically generates a style tag containing the correct animation for this diameter.
         * @return {?}
         */
        MatProgressSpinner.prototype._attachStyleNode = /**
         * Dynamically generates a style tag containing the correct animation for this diameter.
         * @return {?}
         */
        function () {
            var /** @type {?} */ styleTag = MatProgressSpinner.styleTag;
            if (!styleTag) {
                styleTag = this._document.createElement('style');
                this._document.head.appendChild(styleTag);
                MatProgressSpinner.styleTag = styleTag;
            }
            if (styleTag && styleTag.sheet) {
                (/** @type {?} */ (styleTag.sheet)).insertRule(this._getAnimationText(), 0);
            }
            MatProgressSpinner.diameters.add(this.diameter);
        };
        /**
         * Generates animation styles adjusted for the spinner's diameter.
         * @return {?}
         */
        MatProgressSpinner.prototype._getAnimationText = /**
         * Generates animation styles adjusted for the spinner's diameter.
         * @return {?}
         */
        function () {
            return INDETERMINATE_ANIMATION_TEMPLATE
                .replace(/START_VALUE/g, "" + 0.95 * this._strokeCircumference)
                .replace(/END_VALUE/g, "" + 0.2 * this._strokeCircumference)
                .replace(/DIAMETER/g, "" + this.diameter);
        };
        /**
         * Tracks diameters of existing instances to de-dupe generated styles (default d = 100)
         */
        MatProgressSpinner.diameters = new Set([BASE_SIZE]);
        /**
         * Used for storing all of the generated keyframe animations.
         * \@dynamic
         */
        MatProgressSpinner.styleTag = null;
        MatProgressSpinner.decorators = [
            { type: core.Component, args: [{selector: 'mat-progress-spinner',
                        exportAs: 'matProgressSpinner',
                        host: {
                            'role': 'progressbar',
                            'class': 'mat-progress-spinner',
                            '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                            '[style.width.px]': 'diameter',
                            '[style.height.px]': 'diameter',
                            '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
                            '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
                            '[attr.aria-valuenow]': 'value',
                            '[attr.mode]': 'mode',
                        },
                        inputs: ['color'],
                        template: "<svg [style.width.px]=\"diameter\" [style.height.px]=\"diameter\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
                        styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}._mat-animation-noopable.mat-progress-spinner circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition:none;animation:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatProgressSpinner.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,] },] },
        ]; };
        MatProgressSpinner.propDecorators = {
            "diameter": [{ type: core.Input },],
            "strokeWidth": [{ type: core.Input },],
            "mode": [{ type: core.Input },],
            "value": [{ type: core.Input },],
        };
        return MatProgressSpinner;
    }(_MatProgressSpinnerMixinBase));
    /**
     * `<mat-spinner>` component.
     *
     * This is a component definition to be used as a convenience reference to create an
     * indeterminate `<mat-progress-spinner>` instance.
     */
    var MatSpinner = /** @class */ (function (_super) {
        __extends(MatSpinner, _super);
        function MatSpinner(elementRef, platform, document, 
        // @deletion-targets 7.0.0 animationMode and defaults parameters to be made required.
        animationMode, defaults) {
            var _this = _super.call(this, elementRef, platform, document, animationMode, defaults) || this;
            _this.mode = 'indeterminate';
            return _this;
        }
        MatSpinner.decorators = [
            { type: core.Component, args: [{selector: 'mat-spinner',
                        host: {
                            'role': 'progressbar',
                            'mode': 'indeterminate',
                            'class': 'mat-spinner mat-progress-spinner',
                            '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                            '[style.width.px]': 'diameter',
                            '[style.height.px]': 'diameter',
                        },
                        inputs: ['color'],
                        template: "<svg [style.width.px]=\"diameter\" [style.height.px]=\"diameter\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
                        styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}._mat-animation-noopable.mat-progress-spinner circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{transition:none;animation:none}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}._mat-animation-noopable.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition:none;animation:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatSpinner.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,] },] },
        ]; };
        return MatSpinner;
    }(MatProgressSpinner));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatProgressSpinnerModule = /** @class */ (function () {
        function MatProgressSpinnerModule() {
        }
        MatProgressSpinnerModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatCommonModule],
                        exports: [
                            MatProgressSpinner,
                            MatSpinner,
                            MatCommonModule
                        ],
                        declarations: [
                            MatProgressSpinner,
                            MatSpinner
                        ],
                    },] },
        ];
        return MatProgressSpinnerModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Increasing integer for generating unique ids for radio components.
    var /** @type {?} */ nextUniqueId$7 = 0;
    /**
     * Provider Expression that allows mat-radio-group to register as a ControlValueAccessor. This
     * allows it to support [(ngModel)] and ngControl.
     * \@docs-private
     */
    var /** @type {?} */ MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatRadioGroup; }),
        multi: true
    };
    /**
     * Change event object emitted by MatRadio and MatRadioGroup.
     */
    var  /**
     * Change event object emitted by MatRadio and MatRadioGroup.
     */
    MatRadioChange = /** @class */ (function () {
        function MatRadioChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MatRadioChange;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatRadioGroupBase = /** @class */ (function () {
        function MatRadioGroupBase() {
        }
        return MatRadioGroupBase;
    }());
    var /** @type {?} */ _MatRadioGroupMixinBase = mixinDisabled(MatRadioGroupBase);
    /**
     * A group of radio buttons. May contain one or more `<mat-radio-button>` elements.
     */
    var MatRadioGroup = /** @class */ (function (_super) {
        __extends(MatRadioGroup, _super);
        function MatRadioGroup(_changeDetector) {
            var _this = _super.call(this) || this;
            _this._changeDetector = _changeDetector;
            /**
             * Selected value for group. Should equal the value of the selected radio button if there *is*
             * a corresponding radio button with a matching value. If there is *not* such a corresponding
             * radio button, this value persists to be applied in case a new radio button is added with a
             * matching value.
             */
            _this._value = null;
            /**
             * The HTML name attribute applied to radio buttons in this group.
             */
            _this._name = "mat-radio-group-" + nextUniqueId$7++;
            /**
             * The currently selected radio button. Should match value.
             */
            _this._selected = null;
            /**
             * Whether the `value` has been set to its initial value.
             */
            _this._isInitialized = false;
            /**
             * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
             */
            _this._labelPosition = 'after';
            /**
             * Whether the radio group is disabled.
             */
            _this._disabled = false;
            /**
             * Whether the radio group is required.
             */
            _this._required = false;
            /**
             * The method to be called in order to update ngModel
             */
            _this._controlValueAccessorChangeFn = function () { };
            /**
             * onTouch function registered via registerOnTouch (ControlValueAccessor).
             * \@docs-private
             */
            _this.onTouched = function () { };
            /**
             * Event emitted when the group value changes.
             * Change events are only emitted when the value changes due to user interaction with
             * a radio button (the same behavior as `<input type-"radio">`).
             */
            _this.change = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(MatRadioGroup.prototype, "name", {
            get: /**
             * Name of the radio button group. All radio buttons inside this group will use this name.
             * @return {?}
             */
            function () { return this._name; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._name = value;
                this._updateRadioButtonNames();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioGroup.prototype, "labelPosition", {
            get: /**
             * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
             * @return {?}
             */
            function () {
                return this._labelPosition;
            },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._labelPosition = v === 'before' ? 'before' : 'after';
                this._markRadiosForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioGroup.prototype, "value", {
            get: /**
             * Value of the radio button.
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} newValue
             * @return {?}
             */
            function (newValue) {
                if (this._value !== newValue) {
                    // Set this before proceeding to ensure no circular loop occurs with selection.
                    this._value = newValue;
                    this._updateSelectedRadioFromValue();
                    this._checkSelectedRadioButton();
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatRadioGroup.prototype._checkSelectedRadioButton = /**
         * @return {?}
         */
        function () {
            if (this._selected && !this._selected.checked) {
                this._selected.checked = true;
            }
        };
        Object.defineProperty(MatRadioGroup.prototype, "selected", {
            get: /**
             * Whether the radio button is selected.
             * @return {?}
             */
            function () { return this._selected; },
            set: /**
             * @param {?} selected
             * @return {?}
             */
            function (selected) {
                this._selected = selected;
                this.value = selected ? selected.value : null;
                this._checkSelectedRadioButton();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioGroup.prototype, "disabled", {
            get: /**
             * Whether the radio group is disabled
             * @return {?}
             */
            function () { return this._disabled; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._disabled = coerceBooleanProperty(value);
                this._markRadiosForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioGroup.prototype, "required", {
            get: /**
             * Whether the radio group is required
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._required = coerceBooleanProperty(value);
                this._markRadiosForCheck();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Initialize properties once content children are available.
         * This allows us to propagate relevant attributes to associated buttons.
         */
        /**
         * Initialize properties once content children are available.
         * This allows us to propagate relevant attributes to associated buttons.
         * @return {?}
         */
        MatRadioGroup.prototype.ngAfterContentInit = /**
         * Initialize properties once content children are available.
         * This allows us to propagate relevant attributes to associated buttons.
         * @return {?}
         */
        function () {
            // Mark this component as initialized in AfterContentInit because the initial value can
            // possibly be set by NgModel on MatRadioGroup, and it is possible that the OnInit of the
            // NgModel occurs *after* the OnInit of the MatRadioGroup.
            this._isInitialized = true;
        };
        /**
         * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
         * radio buttons upon their blur.
         */
        /**
         * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
         * radio buttons upon their blur.
         * @return {?}
         */
        MatRadioGroup.prototype._touch = /**
         * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
         * radio buttons upon their blur.
         * @return {?}
         */
        function () {
            if (this.onTouched) {
                this.onTouched();
            }
        };
        /**
         * @return {?}
         */
        MatRadioGroup.prototype._updateRadioButtonNames = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._radios) {
                this._radios.forEach(function (radio) {
                    radio.name = _this.name;
                });
            }
        };
        /**
         * Updates the `selected` radio button from the internal _value state.
         * @return {?}
         */
        MatRadioGroup.prototype._updateSelectedRadioFromValue = /**
         * Updates the `selected` radio button from the internal _value state.
         * @return {?}
         */
        function () {
            var _this = this;
            // If the value already matches the selected radio, do nothing.
            var /** @type {?} */ isAlreadySelected = this._selected !== null && this._selected.value === this._value;
            if (this._radios && !isAlreadySelected) {
                this._selected = null;
                this._radios.forEach(function (radio) {
                    radio.checked = _this.value === radio.value;
                    if (radio.checked) {
                        _this._selected = radio;
                    }
                });
            }
        };
        /** Dispatch change event with current selection and group value. */
        /**
         * Dispatch change event with current selection and group value.
         * @return {?}
         */
        MatRadioGroup.prototype._emitChangeEvent = /**
         * Dispatch change event with current selection and group value.
         * @return {?}
         */
        function () {
            if (this._isInitialized) {
                this.change.emit(new MatRadioChange(/** @type {?} */ ((this._selected)), this._value));
            }
        };
        /**
         * @return {?}
         */
        MatRadioGroup.prototype._markRadiosForCheck = /**
         * @return {?}
         */
        function () {
            if (this._radios) {
                this._radios.forEach(function (radio) { return radio._markForCheck(); });
            }
        };
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param value
         */
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        MatRadioGroup.prototype.writeValue = /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.value = value;
            this._changeDetector.markForCheck();
        };
        /**
         * Registers a callback to be triggered when the model value changes.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        /**
         * Registers a callback to be triggered when the model value changes.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        MatRadioGroup.prototype.registerOnChange = /**
         * Registers a callback to be triggered when the model value changes.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        /**
         * Registers a callback to be triggered when the control is touched.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        /**
         * Registers a callback to be triggered when the control is touched.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        MatRadioGroup.prototype.registerOnTouched = /**
         * Registers a callback to be triggered when the control is touched.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        function (fn) {
            this.onTouched = fn;
        };
        /**
         * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
         * @param isDisabled Whether the control should be disabled.
         */
        /**
         * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled Whether the control should be disabled.
         * @return {?}
         */
        MatRadioGroup.prototype.setDisabledState = /**
         * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled Whether the control should be disabled.
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
            this._changeDetector.markForCheck();
        };
        MatRadioGroup.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-radio-group',
                        exportAs: 'matRadioGroup',
                        providers: [MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                        host: {
                            'role': 'radiogroup',
                            'class': 'mat-radio-group',
                        },
                        inputs: ['disabled'],
                    },] },
        ];
        /** @nocollapse */
        MatRadioGroup.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
        ]; };
        MatRadioGroup.propDecorators = {
            "change": [{ type: core.Output },],
            "_radios": [{ type: core.ContentChildren, args: [core.forwardRef(function () { return MatRadioButton; }), { descendants: true },] },],
            "name": [{ type: core.Input },],
            "labelPosition": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "required": [{ type: core.Input },],
        };
        return MatRadioGroup;
    }(_MatRadioGroupMixinBase));
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatRadioButtonBase = /** @class */ (function () {
        function MatRadioButtonBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatRadioButtonBase;
    }());
    // As per Material design specifications the selection control radio should use the accent color
    // palette by default. https://material.io/guidelines/components/selection-controls.html
    var /** @type {?} */ _MatRadioButtonMixinBase = mixinColor(mixinDisableRipple(mixinTabIndex(MatRadioButtonBase)), 'accent');
    /**
     * A Material design radio-button. Typically placed inside of `<mat-radio-group>` elements.
     */
    var MatRadioButton = /** @class */ (function (_super) {
        __extends(MatRadioButton, _super);
        function MatRadioButton(radioGroup, elementRef, _changeDetector, _focusMonitor, _radioDispatcher, _animationMode) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetector = _changeDetector;
            _this._focusMonitor = _focusMonitor;
            _this._radioDispatcher = _radioDispatcher;
            _this._animationMode = _animationMode;
            _this._uniqueId = "mat-radio-" + ++nextUniqueId$7;
            /**
             * The unique ID for the radio button.
             */
            _this.id = _this._uniqueId;
            /**
             * Event emitted when the checked state of this radio button changes.
             * Change events are only emitted when the value changes due to user interaction with
             * the radio button (the same behavior as `<input type-"radio">`).
             */
            _this.change = new core.EventEmitter();
            /**
             * Whether this radio is checked.
             */
            _this._checked = false;
            /**
             * Value assigned to this radio.
             */
            _this._value = null;
            /**
             * Unregister function for _radioDispatcher
             */
            _this._removeUniqueSelectionListener = function () { };
            // Assertions. Ideally these should be stripped out by the compiler.
            // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
            // Assertions. Ideally these should be stripped out by the compiler.
            // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
            _this.radioGroup = radioGroup;
            _this._removeUniqueSelectionListener =
                _radioDispatcher.listen(function (id, name) {
                    if (id !== _this.id && name === _this.name) {
                        _this.checked = false;
                    }
                });
            return _this;
        }
        Object.defineProperty(MatRadioButton.prototype, "checked", {
            get: /**
             * Whether this radio button is checked.
             * @return {?}
             */
            function () { return this._checked; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newCheckedState = coerceBooleanProperty(value);
                if (this._checked !== newCheckedState) {
                    this._checked = newCheckedState;
                    if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                        this.radioGroup.selected = this;
                    }
                    else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                        // When unchecking the selected radio button, update the selected radio
                        // property on the group.
                        this.radioGroup.selected = null;
                    }
                    if (newCheckedState) {
                        // Notify all radio buttons with the same name to un-check.
                        this._radioDispatcher.notify(this.id, this.name);
                    }
                    this._changeDetector.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioButton.prototype, "value", {
            get: /**
             * The value of this radio button.
             * @return {?}
             */
            function () { return this._value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this._value !== value) {
                    this._value = value;
                    if (this.radioGroup !== null) {
                        if (!this.checked) {
                            // Update checked when the value changed to match the radio group's value
                            this.checked = this.radioGroup.value === value;
                        }
                        if (this.checked) {
                            this.radioGroup.selected = this;
                        }
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioButton.prototype, "labelPosition", {
            get: /**
             * Whether the label should appear after or before the radio button. Defaults to 'after'
             * @return {?}
             */
            function () {
                return this._labelPosition || (this.radioGroup && this.radioGroup.labelPosition) || 'after';
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._labelPosition = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioButton.prototype, "disabled", {
            get: /**
             * Whether the radio button is disabled.
             * @return {?}
             */
            function () {
                return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ newDisabledState = coerceBooleanProperty(value);
                if (this._disabled !== newDisabledState) {
                    this._disabled = newDisabledState;
                    this._changeDetector.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioButton.prototype, "required", {
            get: /**
             * Whether the radio button is required.
             * @return {?}
             */
            function () {
                return this._required || (this.radioGroup && this.radioGroup.required);
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._required = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatRadioButton.prototype, "inputId", {
            /** ID of the native input element inside `<mat-radio-button>` */
            get: /**
             * ID of the native input element inside `<mat-radio-button>`
             * @return {?}
             */
            function () { return (this.id || this._uniqueId) + "-input"; },
            enumerable: true,
            configurable: true
        });
        /** Focuses the radio button. */
        /**
         * Focuses the radio button.
         * @return {?}
         */
        MatRadioButton.prototype.focus = /**
         * Focuses the radio button.
         * @return {?}
         */
        function () {
            this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
        };
        /**
         * Marks the radio button as needing checking for change detection.
         * This method is exposed because the parent radio group will directly
         * update bound properties of the radio button.
         */
        /**
         * Marks the radio button as needing checking for change detection.
         * This method is exposed because the parent radio group will directly
         * update bound properties of the radio button.
         * @return {?}
         */
        MatRadioButton.prototype._markForCheck = /**
         * Marks the radio button as needing checking for change detection.
         * This method is exposed because the parent radio group will directly
         * update bound properties of the radio button.
         * @return {?}
         */
        function () {
            // When group value changes, the button will not be notified. Use `markForCheck` to explicit
            // update radio button's status
            this._changeDetector.markForCheck();
        };
        /**
         * @return {?}
         */
        MatRadioButton.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            if (this.radioGroup) {
                // If the radio is inside a radio group, determine if it should be checked
                this.checked = this.radioGroup.value === this._value;
                // Copy name from parent radio group
                this.name = this.radioGroup.name;
            }
        };
        /**
         * @return {?}
         */
        MatRadioButton.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._focusMonitor
                .monitor(this._inputElement.nativeElement)
                .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
        };
        /**
         * @return {?}
         */
        MatRadioButton.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
            this._removeUniqueSelectionListener();
        };
        /**
         * Dispatch change event with current value.
         * @return {?}
         */
        MatRadioButton.prototype._emitChangeEvent = /**
         * Dispatch change event with current value.
         * @return {?}
         */
        function () {
            this.change.emit(new MatRadioChange(this, this._value));
        };
        /**
         * @return {?}
         */
        MatRadioButton.prototype._isRippleDisabled = /**
         * @return {?}
         */
        function () {
            return this.disableRipple || this.disabled;
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatRadioButton.prototype._onInputClick = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We have to stop propagation for click events on the visual hidden input element.
            // By default, when a user clicks on a label element, a generated click event will be
            // dispatched on the associated input element. Since we are using a label element as our
            // root container, the click event on the `radio-button` will be executed twice.
            // The real click event will bubble up, and the generated click event also tries to bubble up.
            // This will lead to multiple click events.
            // Preventing bubbling for the second event will solve that issue.
            event.stopPropagation();
        };
        /**
         * Triggered when the radio button received a click or the input recognized any change.
         * Clicking on a label element, will trigger a change event on the associated input.
         */
        /**
         * Triggered when the radio button received a click or the input recognized any change.
         * Clicking on a label element, will trigger a change event on the associated input.
         * @param {?} event
         * @return {?}
         */
        MatRadioButton.prototype._onInputChange = /**
         * Triggered when the radio button received a click or the input recognized any change.
         * Clicking on a label element, will trigger a change event on the associated input.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We always have to stop propagation on the change event.
            // Otherwise the change event, from the input element, will bubble up and
            // emit its event object to the `change` output.
            event.stopPropagation();
            var /** @type {?} */ groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
            this.checked = true;
            this._emitChangeEvent();
            if (this.radioGroup) {
                this.radioGroup._controlValueAccessorChangeFn(this.value);
                this.radioGroup._touch();
                if (groupValueChanged) {
                    this.radioGroup._emitChangeEvent();
                }
            }
        };
        /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        MatRadioButton.prototype._onInputFocusChange = /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        function (focusOrigin) {
            // TODO(paul): support `program`. See https://github.com/angular/material2/issues/9889
            if (!this._focusRipple && focusOrigin === 'keyboard') {
                this._focusRipple = this._ripple.launch(0, 0, { persistent: true });
            }
            else if (!focusOrigin) {
                if (this.radioGroup) {
                    this.radioGroup._touch();
                }
                if (this._focusRipple) {
                    this._focusRipple.fadeOut();
                    this._focusRipple = null;
                }
            }
        };
        MatRadioButton.decorators = [
            { type: core.Component, args: [{selector: 'mat-radio-button',
                        template: "<label [attr.for]=\"inputId\" class=\"mat-radio-label\" #label><div class=\"mat-radio-container\"><div class=\"mat-radio-outer-circle\"></div><div class=\"mat-radio-inner-circle\"></div><div mat-ripple class=\"mat-radio-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"true\" [matRippleRadius]=\"23\" [matRippleAnimation]=\"{enterDuration: 150}\"></div></div><input #input class=\"mat-radio-input cdk-visually-hidden\" type=\"radio\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [tabIndex]=\"tabIndex\" [attr.name]=\"name\" [required]=\"required\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-describedby]=\"ariaDescribedby\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-radio-label-content\" [class.mat-radio-label-before]=\"labelPosition == 'before'\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></div></label>",
                        styles: [".mat-radio-button{display:inline-block;-webkit-tap-highlight-color:transparent}.mat-radio-label{cursor:pointer;display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle}.mat-radio-container{box-sizing:border-box;display:inline-block;position:relative;width:20px;height:20px;flex-shrink:0}.mat-radio-outer-circle{box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:border-color ease 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}._mat-animation-noopable .mat-radio-outer-circle{transition:none}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:transform ease 280ms,background-color ease 280ms;width:20px;transform:scale(.001)}._mat-animation-noopable .mat-radio-inner-circle{transition:none}.mat-radio-checked .mat-radio-inner-circle{transform:scale(.5)}@media screen and (-ms-high-contrast:active){.mat-radio-checked .mat-radio-inner-circle{border:solid 10px}}.mat-radio-label-content{display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"],
                        inputs: ['color', 'disableRipple', 'tabIndex'],
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matRadioButton',
                        host: {
                            'class': 'mat-radio-button',
                            '[class.mat-radio-checked]': 'checked',
                            '[class.mat-radio-disabled]': 'disabled',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                            '[attr.id]': 'id',
                            // Note: under normal conditions focus shouldn't land on this element, however it may be
                            // programmatically set, for example inside of a focus trap, in this case we want to forward
                            // the focus to the native element.
                            '(focus)': '_inputElement.nativeElement.focus()',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatRadioButton.ctorParameters = function () { return [
            { type: MatRadioGroup, decorators: [{ type: core.Optional },] },
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: FocusMonitor, },
            { type: UniqueSelectionDispatcher, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatRadioButton.propDecorators = {
            "id": [{ type: core.Input },],
            "name": [{ type: core.Input },],
            "ariaLabel": [{ type: core.Input, args: ['aria-label',] },],
            "ariaLabelledby": [{ type: core.Input, args: ['aria-labelledby',] },],
            "ariaDescribedby": [{ type: core.Input, args: ['aria-describedby',] },],
            "checked": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "labelPosition": [{ type: core.Input },],
            "disabled": [{ type: core.Input },],
            "required": [{ type: core.Input },],
            "change": [{ type: core.Output },],
            "_ripple": [{ type: core.ViewChild, args: [MatRipple,] },],
            "_inputElement": [{ type: core.ViewChild, args: ['input',] },],
        };
        return MatRadioButton;
    }(_MatRadioButtonMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material drawers.
     */
    var /** @type {?} */ matDrawerAnimations = {
        /** Animation that slides a drawer in and out. */
        transformDrawer: trigger('transform', [
            state('open, open-instant', style({
                'transform': 'translate3d(0, 0, 0)',
                'visibility': 'visible',
            })),
            state('void', style({
                // Avoids the shadow showing up when closed in SSR.
                'box-shadow': 'none',
                'visibility': 'hidden',
            })),
            transition('void => open-instant', animate('0ms')),
            transition('void <=> open, open-instant => void', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Throws an exception when two MatDrawer are matching the same position.
     * @param {?} position
     * @return {?}
     */
    function throwMatDuplicatedDrawerError(position) {
        throw Error("A drawer was already declared for 'position=\"" + position + "\"'");
    }
    /**
     * Configures whether drawers should use auto sizing by default.
     */
    var /** @type {?} */ MAT_DRAWER_DEFAULT_AUTOSIZE = new core.InjectionToken('MAT_DRAWER_DEFAULT_AUTOSIZE', {
        providedIn: 'root',
        factory: MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY() {
        return false;
    }
    var MatDrawerContent = /** @class */ (function () {
        function MatDrawerContent(_changeDetectorRef, _container) {
            this._changeDetectorRef = _changeDetectorRef;
            this._container = _container;
        }
        /**
         * @return {?}
         */
        MatDrawerContent.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._container._contentMarginChanges.subscribe(function () {
                _this._changeDetectorRef.markForCheck();
            });
        };
        MatDrawerContent.decorators = [
            { type: core.Component, args: [{selector: 'mat-drawer-content',
                        template: '<ng-content></ng-content>',
                        host: {
                            'class': 'mat-drawer-content',
                            '[style.margin-left.px]': '_container._contentMargins.left',
                            '[style.margin-right.px]': '_container._contentMargins.right',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatDrawerContent.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: MatDrawerContainer, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatDrawerContainer; }),] },] },
        ]; };
        return MatDrawerContent;
    }());
    /**
     * This component corresponds to a drawer that can be opened on the drawer container.
     */
    var MatDrawer = /** @class */ (function () {
        function MatDrawer(_elementRef, _focusTrapFactory, _focusMonitor, _platform, _ngZone, _doc) {
            var _this = this;
            this._elementRef = _elementRef;
            this._focusTrapFactory = _focusTrapFactory;
            this._focusMonitor = _focusMonitor;
            this._platform = _platform;
            this._ngZone = _ngZone;
            this._doc = _doc;
            this._elementFocusedBeforeDrawerWasOpened = null;
            /**
             * Whether the drawer is initialized. Used for disabling the initial animation.
             */
            this._enableAnimations = false;
            this._position = 'start';
            this._mode = 'over';
            this._disableClose = false;
            this._autoFocus = true;
            /**
             * Emits whenever the drawer has started animating.
             */
            this._animationStarted = new core.EventEmitter();
            /**
             * Current state of the sidenav animation.
             */
            this._animationState = 'void';
            /**
             * Event emitted when the drawer open state is changed.
             */
            this.openedChange = 
            // Note this has to be async in order to avoid some issues with two-bindings (see #8872).
            new core.EventEmitter(/* isAsync */ /* isAsync */ true);
            /**
             * Event emitted when the drawer's position changes.
             */
            this.onPositionChanged = new core.EventEmitter();
            /**
             * An observable that emits when the drawer mode changes. This is used by the drawer container to
             * to know when to when the mode changes so it can adapt the margins on the content.
             */
            this._modeChanged = new rxjs.Subject();
            this._opened = false;
            this.openedChange.subscribe(function (opened) {
                if (opened) {
                    if (_this._doc) {
                        _this._elementFocusedBeforeDrawerWasOpened = /** @type {?} */ (_this._doc.activeElement);
                    }
                    if (_this._isFocusTrapEnabled && _this._focusTrap) {
                        _this._trapFocus();
                    }
                }
                else {
                    _this._restoreFocus();
                }
            });
            /**
                 * Listen to `keydown` events outside the zone so that change detection is not run every
                 * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
                 * and we don't have close disabled.
                 */
            this._ngZone.runOutsideAngular(function () {
                rxjs.fromEvent(_this._elementRef.nativeElement, 'keydown').pipe(operators.filter(function (event) { return event.keyCode === ESCAPE && !_this.disableClose; })).subscribe(function (event) {
                    return _this._ngZone.run(function () {
                        _this.close();
                        event.stopPropagation();
                    });
                });
            });
        }
        Object.defineProperty(MatDrawer.prototype, "position", {
            get: /**
             * The side that the drawer is attached to.
             * @return {?}
             */
            function () { return this._position; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                // Make sure we have a valid value.
                value = value === 'end' ? 'end' : 'start';
                if (value != this._position) {
                    this._position = value;
                    this.onPositionChanged.emit();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "mode", {
            get: /**
             * Mode of the drawer; one of 'over', 'push' or 'side'.
             * @return {?}
             */
            function () { return this._mode; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._mode = value;
                this._modeChanged.next();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "disableClose", {
            get: /**
             * Whether the drawer can be closed with the escape key or by clicking on the backdrop.
             * @return {?}
             */
            function () { return this._disableClose; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._disableClose = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "autoFocus", {
            get: /**
             * Whether the drawer should focus the first focusable element automatically when opened.
             * @return {?}
             */
            function () { return this._autoFocus; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._autoFocus = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "_openedStream", {
            get: /**
             * Event emitted when the drawer has been opened.
             * @return {?}
             */
            function () {
                return this.openedChange.pipe(operators.filter(function (o) { return o; }), operators.map(function () { }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "openedStart", {
            get: /**
             * Event emitted when the drawer has started opening.
             * @return {?}
             */
            function () {
                return this._animationStarted.pipe(operators.filter(function (e) { return e.fromState !== e.toState && e.toState.indexOf('open') === 0; }), operators.map(function () { }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "_closedStream", {
            get: /**
             * Event emitted when the drawer has been closed.
             * @return {?}
             */
            function () {
                return this.openedChange.pipe(operators.filter(function (o) { return !o; }), operators.map(function () { }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "closedStart", {
            get: /**
             * Event emitted when the drawer has started closing.
             * @return {?}
             */
            function () {
                return this._animationStarted.pipe(operators.filter(function (e) { return e.fromState !== e.toState && e.toState === 'void'; }), operators.map(function () { }));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawer.prototype, "_isFocusTrapEnabled", {
            get: /**
             * @return {?}
             */
            function () {
                // The focus trap is only enabled when the drawer is open in any mode other than side.
                return this.opened && this.mode !== 'side';
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Traps focus inside the drawer.
         * @return {?}
         */
        MatDrawer.prototype._trapFocus = /**
         * Traps focus inside the drawer.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this.autoFocus) {
                return;
            }
            this._focusTrap.focusInitialElementWhenReady().then(function (hasMovedFocus) {
                // If there were no focusable elements, focus the sidenav itself so the keyboard navigation
                // still works. We need to check that `focus` is a function due to Universal.
                if (!hasMovedFocus && typeof _this._elementRef.nativeElement.focus === 'function') {
                    _this._elementRef.nativeElement.focus();
                }
            });
        };
        /**
         * If focus is currently inside the drawer, restores it to where it was before the drawer
         * opened.
         * @return {?}
         */
        MatDrawer.prototype._restoreFocus = /**
         * If focus is currently inside the drawer, restores it to where it was before the drawer
         * opened.
         * @return {?}
         */
        function () {
            if (!this.autoFocus) {
                return;
            }
            var /** @type {?} */ activeEl = this._doc && this._doc.activeElement;
            if (activeEl && this._elementRef.nativeElement.contains(activeEl)) {
                if (this._elementFocusedBeforeDrawerWasOpened instanceof HTMLElement) {
                    this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, this._openedVia);
                }
                else {
                    this._elementRef.nativeElement.blur();
                }
            }
            this._elementFocusedBeforeDrawerWasOpened = null;
            this._openedVia = null;
        };
        /**
         * @return {?}
         */
        MatDrawer.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
            this._focusTrap.enabled = this._isFocusTrapEnabled;
        };
        /**
         * @return {?}
         */
        MatDrawer.prototype.ngAfterContentChecked = /**
         * @return {?}
         */
        function () {
            // Enable the animations after the lifecycle hooks have run, in order to avoid animating
            // drawers that are open by default. When we're on the server, we shouldn't enable the
            // animations, because we don't want the drawer to animate the first time the user sees
            // the page.
            if (this._platform.isBrowser) {
                this._enableAnimations = true;
            }
        };
        /**
         * @return {?}
         */
        MatDrawer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            if (this._focusTrap) {
                this._focusTrap.destroy();
            }
        };
        Object.defineProperty(MatDrawer.prototype, "opened", {
            get: /**
             * Whether the drawer is opened. We overload this because we trigger an event when it
             * starts or end.
             * @return {?}
             */
            function () { return this._opened; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this.toggle(coerceBooleanProperty(value)); },
            enumerable: true,
            configurable: true
        });
        /**
         * Open the drawer.
         * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         */
        /**
         * Open the drawer.
         * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         * @return {?}
         */
        MatDrawer.prototype.open = /**
         * Open the drawer.
         * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         * @return {?}
         */
        function (openedVia) {
            return this.toggle(true, openedVia);
        };
        /** Close the drawer. */
        /**
         * Close the drawer.
         * @return {?}
         */
        MatDrawer.prototype.close = /**
         * Close the drawer.
         * @return {?}
         */
        function () {
            return this.toggle(false);
        };
        /**
         * Toggle this drawer.
         * @param isOpen Whether the drawer should be open.
         * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         */
        /**
         * Toggle this drawer.
         * @param {?=} isOpen Whether the drawer should be open.
         * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         * @return {?}
         */
        MatDrawer.prototype.toggle = /**
         * Toggle this drawer.
         * @param {?=} isOpen Whether the drawer should be open.
         * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
         * Used for focus management after the sidenav is closed.
         * @return {?}
         */
        function (isOpen, openedVia) {
            var _this = this;
            if (isOpen === void 0) { isOpen = !this.opened; }
            if (openedVia === void 0) { openedVia = 'program'; }
            this._opened = isOpen;
            if (isOpen) {
                this._animationState = this._enableAnimations ? 'open' : 'open-instant';
                this._openedVia = openedVia;
            }
            else {
                this._animationState = 'void';
                this._restoreFocus();
            }
            if (this._focusTrap) {
                this._focusTrap.enabled = this._isFocusTrapEnabled;
            }
            return new Promise(function (resolve) {
                _this.openedChange.pipe(operators.take(1)).subscribe(function (open) { return resolve(open ? 'open' : 'close'); });
            });
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatDrawer.prototype._onAnimationStart = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this._animationStarted.emit(event);
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatDrawer.prototype._onAnimationEnd = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var fromState = event.fromState, toState = event.toState;
            if ((toState.indexOf('open') === 0 && fromState === 'void') ||
                (toState === 'void' && fromState.indexOf('open') === 0)) {
                this.openedChange.emit(this._opened);
            }
        };
        Object.defineProperty(MatDrawer.prototype, "_width", {
            get: /**
             * @return {?}
             */
            function () {
                return this._elementRef.nativeElement ? (this._elementRef.nativeElement.offsetWidth || 0) : 0;
            },
            enumerable: true,
            configurable: true
        });
        MatDrawer.decorators = [
            { type: core.Component, args: [{selector: 'mat-drawer',
                        exportAs: 'matDrawer',
                        template: '<ng-content></ng-content>',
                        animations: [matDrawerAnimations.transformDrawer],
                        host: {
                            'class': 'mat-drawer',
                            '[@transform]': '_animationState',
                            '(@transform.start)': '_onAnimationStart($event)',
                            '(@transform.done)': '_onAnimationEnd($event)',
                            // must prevent the browser from aligning text based on value
                            '[attr.align]': 'null',
                            '[class.mat-drawer-end]': 'position === "end"',
                            '[class.mat-drawer-over]': 'mode === "over"',
                            '[class.mat-drawer-push]': 'mode === "push"',
                            '[class.mat-drawer-side]': 'mode === "side"',
                            'tabIndex': '-1',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatDrawer.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: FocusTrapFactory, },
            { type: FocusMonitor, },
            { type: Platform, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        MatDrawer.propDecorators = {
            "position": [{ type: core.Input },],
            "mode": [{ type: core.Input },],
            "disableClose": [{ type: core.Input },],
            "autoFocus": [{ type: core.Input },],
            "openedChange": [{ type: core.Output },],
            "_openedStream": [{ type: core.Output, args: ['opened',] },],
            "openedStart": [{ type: core.Output },],
            "_closedStream": [{ type: core.Output, args: ['closed',] },],
            "closedStart": [{ type: core.Output },],
            "onPositionChanged": [{ type: core.Output, args: ['positionChanged',] },],
            "opened": [{ type: core.Input },],
        };
        return MatDrawer;
    }());
    /**
     * `<mat-drawer-container>` component.
     *
     * This is the parent component to one or two `<mat-drawer>`s that validates the state internally
     * and coordinates the backdrop and content styling.
     */
    var MatDrawerContainer = /** @class */ (function () {
        function MatDrawerContainer(_dir, _element, _ngZone, _changeDetectorRef, defaultAutosize, _animationMode) {
            if (defaultAutosize === void 0) { defaultAutosize = false; }
            var _this = this;
            this._dir = _dir;
            this._element = _element;
            this._ngZone = _ngZone;
            this._changeDetectorRef = _changeDetectorRef;
            this._animationMode = _animationMode;
            /**
             * Event emitted when the drawer backdrop is clicked.
             */
            this.backdropClick = new core.EventEmitter();
            /**
             * Emits when the component is destroyed.
             */
            this._destroyed = new rxjs.Subject();
            /**
             * Emits on every ngDoCheck. Used for debouncing reflows.
             */
            this._doCheckSubject = new rxjs.Subject();
            /**
             * Margins to be applied to the content. These are used to push / shrink the drawer content when a
             * drawer is open. We use margin rather than transform even for push mode because transform breaks
             * fixed position elements inside of the transformed element.
             */
            this._contentMargins = { left: null, right: null };
            this._contentMarginChanges = new rxjs.Subject();
            // If a `Dir` directive exists up the tree, listen direction changes
            // and update the left/right properties to point to the proper start/end.
            if (_dir) {
                _dir.change.pipe(operators.takeUntil(this._destroyed)).subscribe(function () {
                    _this._validateDrawers();
                    _this._updateContentMargins();
                });
            }
            this._autosize = defaultAutosize;
        }
        Object.defineProperty(MatDrawerContainer.prototype, "start", {
            /** The drawer child with the `start` position. */
            get: /**
             * The drawer child with the `start` position.
             * @return {?}
             */
            function () { return this._start; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawerContainer.prototype, "end", {
            /** The drawer child with the `end` position. */
            get: /**
             * The drawer child with the `end` position.
             * @return {?}
             */
            function () { return this._end; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawerContainer.prototype, "autosize", {
            get: /**
             * Whether to automatically resize the container whenever
             * the size of any of its drawers changes.
             *
             * **Use at your own risk!** Enabling this option can cause layout thrashing by measuring
             * the drawers on every change detection cycle. Can be configured globally via the
             * `MAT_DRAWER_DEFAULT_AUTOSIZE` token.
             * @return {?}
             */
            function () { return this._autosize; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._autosize = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatDrawerContainer.prototype, "hasBackdrop", {
            get: /**
             * Whether the drawer container should have a backdrop while one of the sidenavs is open.
             * If explicitly set to `true`, the backdrop will be enabled for drawers in the `side`
             * mode as well.
             * @return {?}
             */
            function () {
                if (this._backdropOverride == null) {
                    return !this._start || this._start.mode !== 'side' || !this._end || this._end.mode !== 'side';
                }
                return this._backdropOverride;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._backdropOverride = value == null ? null : coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._drawers.changes.pipe(operators.startWith(null)).subscribe(function () {
                _this._validateDrawers();
                _this._drawers.forEach(function (drawer) {
                    _this._watchDrawerToggle(drawer);
                    _this._watchDrawerPosition(drawer);
                    _this._watchDrawerMode(drawer);
                });
                if (!_this._drawers.length ||
                    _this._isDrawerOpen(_this._start) ||
                    _this._isDrawerOpen(_this._end)) {
                    _this._updateContentMargins();
                }
                _this._changeDetectorRef.markForCheck();
            });
            this._doCheckSubject.pipe(operators.debounceTime(10), // Arbitrary debounce time, less than a frame at 60fps
            // Arbitrary debounce time, less than a frame at 60fps
            operators.takeUntil(this._destroyed)).subscribe(function () { return _this._updateContentMargins(); });
        };
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._doCheckSubject.complete();
            this._destroyed.next();
            this._destroyed.complete();
        };
        /** Calls `open` of both start and end drawers */
        /**
         * Calls `open` of both start and end drawers
         * @return {?}
         */
        MatDrawerContainer.prototype.open = /**
         * Calls `open` of both start and end drawers
         * @return {?}
         */
        function () {
            this._drawers.forEach(function (drawer) { return drawer.open(); });
        };
        /** Calls `close` of both start and end drawers */
        /**
         * Calls `close` of both start and end drawers
         * @return {?}
         */
        MatDrawerContainer.prototype.close = /**
         * Calls `close` of both start and end drawers
         * @return {?}
         */
        function () {
            this._drawers.forEach(function (drawer) { return drawer.close(); });
        };
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            var _this = this;
            // If users opted into autosizing, do a check every change detection cycle.
            if (this._autosize && this._isPushed()) {
                // Run outside the NgZone, otherwise the debouncer will throw us into an infinite loop.
                this._ngZone.runOutsideAngular(function () { return _this._doCheckSubject.next(); });
            }
        };
        /**
         * Subscribes to drawer events in order to set a class on the main container element when the
         * drawer is open and the backdrop is visible. This ensures any overflow on the container element
         * is properly hidden.
         * @param {?} drawer
         * @return {?}
         */
        MatDrawerContainer.prototype._watchDrawerToggle = /**
         * Subscribes to drawer events in order to set a class on the main container element when the
         * drawer is open and the backdrop is visible. This ensures any overflow on the container element
         * is properly hidden.
         * @param {?} drawer
         * @return {?}
         */
        function (drawer) {
            var _this = this;
            drawer._animationStarted.pipe(operators.takeUntil(this._drawers.changes), operators.filter(function (event) { return event.fromState !== event.toState; }))
                .subscribe(function (event) {
                // Set the transition class on the container so that the animations occur. This should not
                // be set initially because animations should only be triggered via a change in state.
                if (event.toState !== 'open-instant' && _this._animationMode !== 'NoopAnimations') {
                    _this._element.nativeElement.classList.add('mat-drawer-transition');
                }
                _this._updateContentMargins();
                _this._changeDetectorRef.markForCheck();
            });
            if (drawer.mode !== 'side') {
                drawer.openedChange.pipe(operators.takeUntil(this._drawers.changes)).subscribe(function () {
                    return _this._setContainerClass(drawer.opened);
                });
            }
        };
        /**
         * Subscribes to drawer onPositionChanged event in order to
         * re-validate drawers when the position changes.
         * @param {?} drawer
         * @return {?}
         */
        MatDrawerContainer.prototype._watchDrawerPosition = /**
         * Subscribes to drawer onPositionChanged event in order to
         * re-validate drawers when the position changes.
         * @param {?} drawer
         * @return {?}
         */
        function (drawer) {
            var _this = this;
            if (!drawer) {
                return;
            }
            // NOTE: We need to wait for the microtask queue to be empty before validating,
            // since both drawers may be swapping positions at the same time.
            drawer.onPositionChanged.pipe(operators.takeUntil(this._drawers.changes)).subscribe(function () {
                _this._ngZone.onMicrotaskEmpty.asObservable().pipe(operators.take(1)).subscribe(function () {
                    _this._validateDrawers();
                });
            });
        };
        /**
         * Subscribes to changes in drawer mode so we can run change detection.
         * @param {?} drawer
         * @return {?}
         */
        MatDrawerContainer.prototype._watchDrawerMode = /**
         * Subscribes to changes in drawer mode so we can run change detection.
         * @param {?} drawer
         * @return {?}
         */
        function (drawer) {
            var _this = this;
            if (drawer) {
                drawer._modeChanged.pipe(operators.takeUntil(rxjs.merge(this._drawers.changes, this._destroyed)))
                    .subscribe(function () {
                    _this._updateContentMargins();
                    _this._changeDetectorRef.markForCheck();
                });
            }
        };
        /**
         * Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element.
         * @param {?} isAdd
         * @return {?}
         */
        MatDrawerContainer.prototype._setContainerClass = /**
         * Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element.
         * @param {?} isAdd
         * @return {?}
         */
        function (isAdd) {
            if (isAdd) {
                this._element.nativeElement.classList.add('mat-drawer-opened');
            }
            else {
                this._element.nativeElement.classList.remove('mat-drawer-opened');
            }
        };
        /**
         * Validate the state of the drawer children components.
         * @return {?}
         */
        MatDrawerContainer.prototype._validateDrawers = /**
         * Validate the state of the drawer children components.
         * @return {?}
         */
        function () {
            var _this = this;
            this._start = this._end = null;
            // Ensure that we have at most one start and one end drawer.
            this._drawers.forEach(function (drawer) {
                if (drawer.position == 'end') {
                    if (_this._end != null) {
                        throwMatDuplicatedDrawerError('end');
                    }
                    _this._end = drawer;
                }
                else {
                    if (_this._start != null) {
                        throwMatDuplicatedDrawerError('start');
                    }
                    _this._start = drawer;
                }
            });
            this._right = this._left = null;
            // Detect if we're LTR or RTL.
            if (this._dir && this._dir.value === 'rtl') {
                this._left = this._end;
                this._right = this._start;
            }
            else {
                this._left = this._start;
                this._right = this._end;
            }
        };
        /**
         * Whether the container is being pushed to the side by one of the drawers.
         * @return {?}
         */
        MatDrawerContainer.prototype._isPushed = /**
         * Whether the container is being pushed to the side by one of the drawers.
         * @return {?}
         */
        function () {
            return (this._isDrawerOpen(this._start) && this._start.mode != 'over') ||
                (this._isDrawerOpen(this._end) && this._end.mode != 'over');
        };
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype._onBackdropClicked = /**
         * @return {?}
         */
        function () {
            this.backdropClick.emit();
            this._closeModalDrawer();
        };
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype._closeModalDrawer = /**
         * @return {?}
         */
        function () {
            var _this = this;
            // Close all open drawers where closing is not disabled and the mode is not `side`.
            [this._start, this._end]
                .filter(function (drawer) { return drawer && !drawer.disableClose && _this._canHaveBackdrop(drawer); })
                .forEach(function (drawer) { return ((drawer)).close(); });
        };
        /**
         * @return {?}
         */
        MatDrawerContainer.prototype._isShowingBackdrop = /**
         * @return {?}
         */
        function () {
            return (this._isDrawerOpen(this._start) && this._canHaveBackdrop(this._start)) ||
                (this._isDrawerOpen(this._end) && this._canHaveBackdrop(this._end));
        };
        /**
         * @param {?} drawer
         * @return {?}
         */
        MatDrawerContainer.prototype._canHaveBackdrop = /**
         * @param {?} drawer
         * @return {?}
         */
        function (drawer) {
            return drawer.mode !== 'side' || !!this._backdropOverride;
        };
        /**
         * @param {?} drawer
         * @return {?}
         */
        MatDrawerContainer.prototype._isDrawerOpen = /**
         * @param {?} drawer
         * @return {?}
         */
        function (drawer) {
            return drawer != null && drawer.opened;
        };
        /**
         * Recalculates and updates the inline styles for the content. Note that this should be used
         * sparingly, because it causes a reflow.
         * @return {?}
         */
        MatDrawerContainer.prototype._updateContentMargins = /**
         * Recalculates and updates the inline styles for the content. Note that this should be used
         * sparingly, because it causes a reflow.
         * @return {?}
         */
        function () {
            var _this = this;
            // 1. For drawers in `over` mode, they don't affect the content.
            // 2. For drawers in `side` mode they should shrink the content. We do this by adding to the
            //    left margin (for left drawer) or right margin (for right the drawer).
            // 3. For drawers in `push` mode the should shift the content without resizing it. We do this by
            //    adding to the left or right margin and simultaneously subtracting the same amount of
            //    margin from the other side.
            var /** @type {?} */ left = 0;
            var /** @type {?} */ right = 0;
            if (this._left && this._left.opened) {
                if (this._left.mode == 'side') {
                    left += this._left._width;
                }
                else if (this._left.mode == 'push') {
                    var /** @type {?} */ width = this._left._width;
                    left += width;
                    right -= width;
                }
            }
            if (this._right && this._right.opened) {
                if (this._right.mode == 'side') {
                    right += this._right._width;
                }
                else if (this._right.mode == 'push') {
                    var /** @type {?} */ width = this._right._width;
                    right += width;
                    left -= width;
                }
            }
            if (left !== this._contentMargins.left || right !== this._contentMargins.right) {
                this._contentMargins = { left: left, right: right };
                // Pull back into the NgZone since in some cases we could be outside. We need to be careful
                // to do it only when something changed, otherwise we can end up hitting the zone too often.
                this._ngZone.run(function () { return _this._contentMarginChanges.next(_this._contentMargins); });
            }
        };
        MatDrawerContainer.decorators = [
            { type: core.Component, args: [{selector: 'mat-drawer-container',
                        exportAs: 'matDrawerContainer',
                        template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-drawer\"></ng-content><ng-content select=\"mat-drawer-content\"></ng-content><mat-drawer-content *ngIf=\"!_content\" cdkScrollable><ng-content></ng-content></mat-drawer-content>",
                        styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-opened{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media screen and (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}@media screen and (-ms-high-contrast:active){.mat-drawer,[dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}}@media screen and (-ms-high-contrast:active){.mat-drawer.mat-drawer-end,[dir=rtl] .mat-drawer{border-left:solid 1px currentColor;border-right:none}}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.mat-sidenav-fixed{position:fixed}"],
                        host: {
                            'class': 'mat-drawer-container',
                            '[class.mat-drawer-container-explicit-backdrop]': '_backdropOverride',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatDrawerContainer.ctorParameters = function () { return [
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_DRAWER_DEFAULT_AUTOSIZE,] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatDrawerContainer.propDecorators = {
            "_drawers": [{ type: core.ContentChildren, args: [MatDrawer,] },],
            "_content": [{ type: core.ContentChild, args: [MatDrawerContent,] },],
            "autosize": [{ type: core.Input },],
            "hasBackdrop": [{ type: core.Input },],
            "backdropClick": [{ type: core.Output },],
            "scrollable": [{ type: core.ViewChild, args: [CdkScrollable,] },],
        };
        return MatDrawerContainer;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatSidenavContent = /** @class */ (function (_super) {
        __extends(MatSidenavContent, _super);
        function MatSidenavContent(changeDetectorRef, container) {
            return _super.call(this, changeDetectorRef, container) || this;
        }
        MatSidenavContent.decorators = [
            { type: core.Component, args: [{selector: 'mat-sidenav-content',
                        template: '<ng-content></ng-content>',
                        host: {
                            'class': 'mat-drawer-content mat-sidenav-content',
                            '[style.margin-left.px]': '_container._contentMargins.left',
                            '[style.margin-right.px]': '_container._contentMargins.right',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatSidenavContent.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef, },
            { type: MatSidenavContainer, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatSidenavContainer; }),] },] },
        ]; };
        return MatSidenavContent;
    }(MatDrawerContent));
    var MatSidenav = /** @class */ (function (_super) {
        __extends(MatSidenav, _super);
        function MatSidenav() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._fixedInViewport = false;
            _this._fixedTopGap = 0;
            _this._fixedBottomGap = 0;
            return _this;
        }
        Object.defineProperty(MatSidenav.prototype, "fixedInViewport", {
            get: /**
             * Whether the sidenav is fixed in the viewport.
             * @return {?}
             */
            function () { return this._fixedInViewport; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._fixedInViewport = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSidenav.prototype, "fixedTopGap", {
            get: /**
             * The gap between the top of the sidenav and the top of the viewport when the sidenav is in fixed
             * mode.
             * @return {?}
             */
            function () { return this._fixedTopGap; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._fixedTopGap = coerceNumberProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSidenav.prototype, "fixedBottomGap", {
            get: /**
             * The gap between the bottom of the sidenav and the bottom of the viewport when the sidenav is in
             * fixed mode.
             * @return {?}
             */
            function () { return this._fixedBottomGap; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._fixedBottomGap = coerceNumberProperty(value); },
            enumerable: true,
            configurable: true
        });
        MatSidenav.decorators = [
            { type: core.Component, args: [{selector: 'mat-sidenav',
                        exportAs: 'matSidenav',
                        template: '<ng-content></ng-content>',
                        animations: [matDrawerAnimations.transformDrawer],
                        host: {
                            'class': 'mat-drawer mat-sidenav',
                            'tabIndex': '-1',
                            '[@transform]': '_animationState',
                            '(@transform.start)': '_onAnimationStart($event)',
                            '(@transform.done)': '_onAnimationEnd($event)',
                            // must prevent the browser from aligning text based on value
                            '[attr.align]': 'null',
                            '[class.mat-drawer-end]': 'position === "end"',
                            '[class.mat-drawer-over]': 'mode === "over"',
                            '[class.mat-drawer-push]': 'mode === "push"',
                            '[class.mat-drawer-side]': 'mode === "side"',
                            '[class.mat-sidenav-fixed]': 'fixedInViewport',
                            '[style.top.px]': 'fixedInViewport ? fixedTopGap : null',
                            '[style.bottom.px]': 'fixedInViewport ? fixedBottomGap : null',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatSidenav.propDecorators = {
            "fixedInViewport": [{ type: core.Input },],
            "fixedTopGap": [{ type: core.Input },],
            "fixedBottomGap": [{ type: core.Input },],
        };
        return MatSidenav;
    }(MatDrawer));
    var MatSidenavContainer = /** @class */ (function (_super) {
        __extends(MatSidenavContainer, _super);
        function MatSidenavContainer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatSidenavContainer.decorators = [
            { type: core.Component, args: [{selector: 'mat-sidenav-container',
                        exportAs: 'matSidenavContainer',
                        template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-sidenav\"></ng-content><ng-content select=\"mat-sidenav-content\"></ng-content><mat-sidenav-content *ngIf=\"!_content\" cdkScrollable><ng-content></ng-content></mat-sidenav-content>",
                        styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-opened{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media screen and (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}@media screen and (-ms-high-contrast:active){.mat-drawer,[dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}}@media screen and (-ms-high-contrast:active){.mat-drawer.mat-drawer-end,[dir=rtl] .mat-drawer{border-left:solid 1px currentColor;border-right:none}}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.mat-sidenav-fixed{position:fixed}"],
                        host: {
                            'class': 'mat-drawer-container mat-sidenav-container',
                            '[class.mat-drawer-container-explicit-backdrop]': '_backdropOverride',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatSidenavContainer.propDecorators = {
            "_drawers": [{ type: core.ContentChildren, args: [MatSidenav,] },],
            "_content": [{ type: core.ContentChild, args: [MatSidenavContent,] },],
        };
        return MatSidenavContainer;
    }(MatDrawerContainer));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // Increasing integer for generating unique ids for slide-toggle components.
    var /** @type {?} */ nextUniqueId$8 = 0;
    var /** @type {?} */ MAT_SLIDE_TOGGLE_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatSlideToggle; }),
        multi: true
    };
    /**
     * Change event object emitted by a MatSlideToggle.
     */
    var  /**
     * Change event object emitted by a MatSlideToggle.
     */
    MatSlideToggleChange = /** @class */ (function () {
        function MatSlideToggleChange(source, checked) {
            this.source = source;
            this.checked = checked;
        }
        return MatSlideToggleChange;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSlideToggleBase = /** @class */ (function () {
        function MatSlideToggleBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatSlideToggleBase;
    }());
    var /** @type {?} */ _MatSlideToggleMixinBase = mixinTabIndex(mixinColor(mixinDisableRipple(mixinDisabled(MatSlideToggleBase)), 'accent'));
    /**
     * Represents a slidable "switch" toggle that can be moved between on and off.
     */
    var MatSlideToggle = /** @class */ (function (_super) {
        __extends(MatSlideToggle, _super);
        function MatSlideToggle(elementRef, /**
                       * @deprecated The `_platform` parameter to be removed.
                       * @deletion-target 7.0.0
                       */
        /**
         * @deprecated The `_platform` parameter to be removed.
         * @deletion-target 7.0.0
         */
        _platform, _focusMonitor, _changeDetectorRef, tabIndex, _ngZone, _animationMode) {
            var _this = _super.call(this, elementRef) || this;
            _this._focusMonitor = _focusMonitor;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._ngZone = _ngZone;
            _this._animationMode = _animationMode;
            _this.onChange = function (_) { };
            _this.onTouched = function () { };
            _this._uniqueId = "mat-slide-toggle-" + ++nextUniqueId$8;
            _this._required = false;
            _this._checked = false;
            /**
             * Whether the thumb is currently being dragged.
             */
            _this._dragging = false;
            /**
             * Name value will be applied to the input element if present
             */
            _this.name = null;
            /**
             * A unique id for the slide-toggle input. If none is supplied, it will be auto-generated.
             */
            _this.id = _this._uniqueId;
            /**
             * Whether the label should appear after or before the slide-toggle. Defaults to 'after'
             */
            _this.labelPosition = 'after';
            /**
             * Used to set the aria-label attribute on the underlying input element.
             */
            _this.ariaLabel = null;
            /**
             * Used to set the aria-labelledby attribute on the underlying input element.
             */
            _this.ariaLabelledby = null;
            /**
             * An event will be dispatched each time the slide-toggle changes its value.
             */
            _this.change = new core.EventEmitter();
            _this.tabIndex = parseInt(tabIndex) || 0;
            return _this;
        }
        Object.defineProperty(MatSlideToggle.prototype, "required", {
            get: /**
             * Whether the slide-toggle is required.
             * @return {?}
             */
            function () { return this._required; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._required = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlideToggle.prototype, "checked", {
            get: /**
             * Whether the slide-toggle element is checked or not
             * @return {?}
             */
            function () { return this._checked; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._checked = coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlideToggle.prototype, "inputId", {
            /** Returns the unique id for the visual hidden input. */
            get: /**
             * Returns the unique id for the visual hidden input.
             * @return {?}
             */
            function () { return (this.id || this._uniqueId) + "-input"; },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatSlideToggle.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._focusMonitor
                .monitor(this._inputElement.nativeElement)
                .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
        };
        /**
         * @return {?}
         */
        MatSlideToggle.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
        };
        /** Method being called whenever the underlying input emits a change event. */
        /**
         * Method being called whenever the underlying input emits a change event.
         * @param {?} event
         * @return {?}
         */
        MatSlideToggle.prototype._onChangeEvent = /**
         * Method being called whenever the underlying input emits a change event.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We always have to stop propagation on the change event.
            // Otherwise the change event, from the input element, will bubble up and
            // emit its event object to the component's `change` output.
            event.stopPropagation();
            // Releasing the pointer over the `<label>` element while dragging triggers another
            // click event on the `<label>` element. This means that the checked state of the underlying
            // input changed unintentionally and needs to be changed back.
            if (this._dragging) {
                this._inputElement.nativeElement.checked = this.checked;
                return;
            }
            // Sync the value from the underlying input element with the component instance.
            this.checked = this._inputElement.nativeElement.checked;
            // Emit our custom change event only if the underlying input emitted one. This ensures that
            // there is no change event, when the checked state changes programmatically.
            this._emitChangeEvent();
        };
        /** Method being called whenever the slide-toggle has been clicked. */
        /**
         * Method being called whenever the slide-toggle has been clicked.
         * @param {?} event
         * @return {?}
         */
        MatSlideToggle.prototype._onInputClick = /**
         * Method being called whenever the slide-toggle has been clicked.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            // We have to stop propagation for click events on the visual hidden input element.
            // By default, when a user clicks on a label element, a generated click event will be
            // dispatched on the associated input element. Since we are using a label element as our
            // root container, the click event on the `slide-toggle` will be executed twice.
            // The real click event will bubble up, and the generated click event also tries to bubble up.
            // This will lead to multiple click events.
            // Preventing bubbling for the second event will solve that issue.
            event.stopPropagation();
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        MatSlideToggle.prototype.writeValue = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.checked = !!value;
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        MatSlideToggle.prototype.registerOnChange = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onChange = fn;
        };
        /** Implemented as part of ControlValueAccessor. */
        /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        MatSlideToggle.prototype.registerOnTouched = /**
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onTouched = fn;
        };
        /** Implemented as a part of ControlValueAccessor. */
        /**
         * Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        MatSlideToggle.prototype.setDisabledState = /**
         * Implemented as a part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
            this._changeDetectorRef.markForCheck();
        };
        /** Focuses the slide-toggle. */
        /**
         * Focuses the slide-toggle.
         * @return {?}
         */
        MatSlideToggle.prototype.focus = /**
         * Focuses the slide-toggle.
         * @return {?}
         */
        function () {
            this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
        };
        /** Toggles the checked state of the slide-toggle. */
        /**
         * Toggles the checked state of the slide-toggle.
         * @return {?}
         */
        MatSlideToggle.prototype.toggle = /**
         * Toggles the checked state of the slide-toggle.
         * @return {?}
         */
        function () {
            this.checked = !this.checked;
        };
        /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        MatSlideToggle.prototype._onInputFocusChange = /**
         * Function is called whenever the focus changes for the input element.
         * @param {?} focusOrigin
         * @return {?}
         */
        function (focusOrigin) {
            // TODO(paul): support `program`. See https://github.com/angular/material2/issues/9889
            if (!this._focusRipple && focusOrigin === 'keyboard') {
                // For keyboard focus show a persistent ripple as focus indicator.
                this._focusRipple = this._ripple.launch(0, 0, { persistent: true });
            }
            else if (!focusOrigin) {
                this.onTouched();
                // Fade out and clear the focus ripple if one is currently present.
                if (this._focusRipple) {
                    this._focusRipple.fadeOut();
                    this._focusRipple = null;
                }
            }
        };
        /**
         * Emits a change event on the `change` output. Also notifies the FormControl about the change.
         * @return {?}
         */
        MatSlideToggle.prototype._emitChangeEvent = /**
         * Emits a change event on the `change` output. Also notifies the FormControl about the change.
         * @return {?}
         */
        function () {
            this.onChange(this.checked);
            this.change.emit(new MatSlideToggleChange(this, this.checked));
        };
        /**
         * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
         * @param {?} distance
         * @return {?}
         */
        MatSlideToggle.prototype._getDragPercentage = /**
         * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
         * @param {?} distance
         * @return {?}
         */
        function (distance) {
            var /** @type {?} */ percentage = (distance / this._thumbBarWidth) * 100;
            // When the toggle was initially checked, then we have to start the drag at the end.
            if (this._previousChecked) {
                percentage += 100;
            }
            return Math.max(0, Math.min(percentage, 100));
        };
        /**
         * @return {?}
         */
        MatSlideToggle.prototype._onDragStart = /**
         * @return {?}
         */
        function () {
            if (!this.disabled && !this._dragging) {
                var /** @type {?} */ thumbEl = this._thumbEl.nativeElement;
                this._thumbBarWidth = this._thumbBarEl.nativeElement.clientWidth - thumbEl.clientWidth;
                thumbEl.classList.add('mat-dragging');
                this._previousChecked = this.checked;
                this._dragging = true;
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatSlideToggle.prototype._onDrag = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this._dragging) {
                this._dragPercentage = this._getDragPercentage(event.deltaX);
                // Calculate the moved distance based on the thumb bar width.
                var /** @type {?} */ dragX = (this._dragPercentage / 100) * this._thumbBarWidth;
                this._thumbEl.nativeElement.style.transform = "translate3d(" + dragX + "px, 0, 0)";
            }
        };
        /**
         * @return {?}
         */
        MatSlideToggle.prototype._onDragEnd = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._dragging) {
                var /** @type {?} */ newCheckedValue = this._dragPercentage > 50;
                if (newCheckedValue !== this.checked) {
                    this.checked = newCheckedValue;
                    this._emitChangeEvent();
                }
                // The drag should be stopped outside of the current event handler, otherwise the
                // click event will be fired before it and will revert the drag change.
                this._ngZone.runOutsideAngular(function () {
                    return setTimeout(function () {
                        if (_this._dragging) {
                            _this._dragging = false;
                            _this._thumbEl.nativeElement.classList.remove('mat-dragging');
                            // Reset the transform because the component will take care
                            // of the thumb position after drag.
                            // Reset the transform because the component will take care
                            // of the thumb position after drag.
                            _this._thumbEl.nativeElement.style.transform = '';
                        }
                    });
                });
            }
        };
        /** Method being called whenever the label text changes. */
        /**
         * Method being called whenever the label text changes.
         * @return {?}
         */
        MatSlideToggle.prototype._onLabelTextChange = /**
         * Method being called whenever the label text changes.
         * @return {?}
         */
        function () {
            // This method is getting called whenever the label of the slide-toggle changes.
            // Since the slide-toggle uses the OnPush strategy we need to notify it about the change
            // that has been recognized by the cdkObserveContent directive.
            this._changeDetectorRef.markForCheck();
        };
        MatSlideToggle.decorators = [
            { type: core.Component, args: [{selector: 'mat-slide-toggle',
                        exportAs: 'matSlideToggle',
                        host: {
                            'class': 'mat-slide-toggle',
                            '[id]': 'id',
                            '[class.mat-checked]': 'checked',
                            '[class.mat-disabled]': 'disabled',
                            '[class.mat-slide-toggle-label-before]': 'labelPosition == "before"',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        },
                        template: "<label class=\"mat-slide-toggle-label\" #label><div #toggleBar class=\"mat-slide-toggle-bar\" [class.mat-slide-toggle-bar-no-side-margin]=\"!labelContent.textContent || !labelContent.textContent.trim()\"><input #input class=\"mat-slide-toggle-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [tabIndex]=\"tabIndex\" [checked]=\"checked\" [disabled]=\"disabled\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-slide-toggle-thumb-container\" #thumbContainer (slidestart)=\"_onDragStart()\" (slide)=\"_onDrag($event)\" (slideend)=\"_onDragEnd()\"><div class=\"mat-slide-toggle-thumb\"></div><div class=\"mat-slide-toggle-ripple\" mat-ripple [matRippleTrigger]=\"label\" [matRippleDisabled]=\"disableRipple || disabled\" [matRippleCentered]=\"true\" [matRippleRadius]=\"23\" [matRippleAnimation]=\"{enterDuration: 150}\"></div></div></div><span class=\"mat-slide-toggle-content\" #labelContent (cdkObserveContent)=\"_onLabelTextChange()\"><ng-content></ng-content></span></label>",
                        styles: [".mat-slide-toggle{display:inline-block;height:24px;max-width:100%;line-height:24px;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(16px,0,0)}.mat-slide-toggle.mat-disabled .mat-slide-toggle-label,.mat-slide-toggle.mat-disabled .mat-slide-toggle-thumb-container{cursor:default}.mat-slide-toggle-label{display:flex;flex:1;flex-direction:row;align-items:center;height:inherit;cursor:pointer}.mat-slide-toggle-content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-slide-toggle-label-before .mat-slide-toggle-label{order:1}.mat-slide-toggle-label-before .mat-slide-toggle-bar{order:2}.mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-label-before .mat-slide-toggle-bar{margin-right:8px;margin-left:0}.mat-slide-toggle-label-before .mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-bar{margin-left:8px;margin-right:0}.mat-slide-toggle-bar-no-side-margin{margin-left:0;margin-right:0}.mat-slide-toggle-thumb-container{position:absolute;z-index:1;width:20px;height:20px;top:-3px;left:0;transform:translate3d(0,0,0);transition:all 80ms linear;transition-property:transform;cursor:-webkit-grab;cursor:grab}.mat-slide-toggle-thumb-container.mat-dragging,.mat-slide-toggle-thumb-container:active{cursor:-webkit-grabbing;cursor:grabbing;transition-duration:0s}._mat-animation-noopable .mat-slide-toggle-thumb-container{transition:none}.mat-slide-toggle-thumb{height:20px;width:20px;border-radius:50%;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-thumb{background:#fff;border:solid 1px #000}}.mat-slide-toggle-bar{position:relative;width:36px;height:14px;flex-shrink:0;border-radius:8px}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-bar{background:#fff}}.mat-slide-toggle-input{bottom:0;left:10px}.mat-slide-toggle-bar,.mat-slide-toggle-thumb{transition:all 80ms linear;transition-property:background-color;transition-delay:50ms}._mat-animation-noopable .mat-slide-toggle-bar,._mat-animation-noopable .mat-slide-toggle-thumb{transition:none}.mat-slide-toggle-ripple{position:absolute;top:calc(50% - 23px);left:calc(50% - 23px);height:46px;width:46px;z-index:1;pointer-events:none}"],
                        providers: [MAT_SLIDE_TOGGLE_VALUE_ACCESSOR],
                        inputs: ['disabled', 'disableRipple', 'color', 'tabIndex'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatSlideToggle.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: FocusMonitor, },
            { type: core.ChangeDetectorRef, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatSlideToggle.propDecorators = {
            "_thumbEl": [{ type: core.ViewChild, args: ['thumbContainer',] },],
            "_thumbBarEl": [{ type: core.ViewChild, args: ['toggleBar',] },],
            "name": [{ type: core.Input },],
            "id": [{ type: core.Input },],
            "labelPosition": [{ type: core.Input },],
            "ariaLabel": [{ type: core.Input, args: ['aria-label',] },],
            "ariaLabelledby": [{ type: core.Input, args: ['aria-labelledby',] },],
            "required": [{ type: core.Input },],
            "checked": [{ type: core.Input },],
            "change": [{ type: core.Output },],
            "_inputElement": [{ type: core.ViewChild, args: ['input',] },],
            "_ripple": [{ type: core.ViewChild, args: [MatRipple,] },],
        };
        return MatSlideToggle;
    }(_MatSlideToggleMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Visually, a 30px separation between tick marks looks best. This is very subjective but it is
     * the default separation we chose.
     */
    var /** @type {?} */ MIN_AUTO_TICK_SEPARATION = 30;
    /**
     * The thumb gap size for a disabled slider.
     */
    var /** @type {?} */ DISABLED_THUMB_GAP = 7;
    /**
     * The thumb gap size for a non-active slider at its minimum value.
     */
    var /** @type {?} */ MIN_VALUE_NONACTIVE_THUMB_GAP = 7;
    /**
     * The thumb gap size for an active slider at its minimum value.
     */
    var /** @type {?} */ MIN_VALUE_ACTIVE_THUMB_GAP = 10;
    /**
     * Provider Expression that allows mat-slider to register as a ControlValueAccessor.
     * This allows it to support [(ngModel)] and [formControl].
     */
    var /** @type {?} */ MAT_SLIDER_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MatSlider; }),
        multi: true
    };
    /**
     * A simple change event emitted by the MatSlider component.
     */
    var  /**
     * A simple change event emitted by the MatSlider component.
     */
    MatSliderChange = /** @class */ (function () {
        function MatSliderChange() {
        }
        return MatSliderChange;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSliderBase = /** @class */ (function () {
        function MatSliderBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatSliderBase;
    }());
    var /** @type {?} */ _MatSliderMixinBase = mixinTabIndex(mixinColor(mixinDisabled(MatSliderBase), 'accent'));
    /**
     * Allows users to select from a range of values by moving the slider thumb. It is similar in
     * behavior to the native `<input type="range">` element.
     */
    var MatSlider = /** @class */ (function (_super) {
        __extends(MatSlider, _super);
        function MatSlider(elementRef, _focusMonitor, _changeDetectorRef, _dir, tabIndex, 
        // @deletion-target 7.0.0 `_animationMode` parameter to be made required.
        _animationMode) {
            var _this = _super.call(this, elementRef) || this;
            _this._focusMonitor = _focusMonitor;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._dir = _dir;
            _this._animationMode = _animationMode;
            _this._invert = false;
            _this._max = 100;
            _this._min = 0;
            _this._step = 1;
            _this._thumbLabel = false;
            _this._tickInterval = 0;
            _this._value = null;
            _this._vertical = false;
            /**
             * Event emitted when the slider value has changed.
             */
            _this.change = new core.EventEmitter();
            /**
             * Event emitted when the slider thumb moves.
             */
            _this.input = new core.EventEmitter();
            /**
             * onTouch function registered via registerOnTouch (ControlValueAccessor).
             */
            _this.onTouched = function () { };
            _this._percent = 0;
            /**
             * Whether or not the thumb is sliding.
             * Used to determine if there should be a transition for the thumb and fill track.
             */
            _this._isSliding = false;
            /**
             * Whether or not the slider is active (clicked or sliding).
             * Used to shrink and grow the thumb as according to the Material Design spec.
             */
            _this._isActive = false;
            /**
             * The size of a tick interval as a percentage of the size of the track.
             */
            _this._tickIntervalPercent = 0;
            /**
             * The dimensions of the slider.
             */
            _this._sliderDimensions = null;
            _this._controlValueAccessorChangeFn = function () { };
            /**
             * Subscription to the Directionality change EventEmitter.
             */
            _this._dirChangeSubscription = rxjs.Subscription.EMPTY;
            _this.tabIndex = parseInt(tabIndex) || 0;
            return _this;
        }
        Object.defineProperty(MatSlider.prototype, "invert", {
            get: /**
             * Whether the slider is inverted.
             * @return {?}
             */
            function () { return this._invert; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._invert = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "max", {
            get: /**
             * The maximum value that the slider can have.
             * @return {?}
             */
            function () { return this._max; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._max = coerceNumberProperty(v, this._max);
                this._percent = this._calculatePercentage(this._value);
                // Since this also modifies the percentage, we need to let the change detection know.
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "min", {
            get: /**
             * The minimum value that the slider can have.
             * @return {?}
             */
            function () { return this._min; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._min = coerceNumberProperty(v, this._min);
                // If the value wasn't explicitly set by the user, set it to the min.
                if (this._value === null) {
                    this.value = this._min;
                }
                this._percent = this._calculatePercentage(this._value);
                // Since this also modifies the percentage, we need to let the change detection know.
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "step", {
            get: /**
             * The values at which the thumb will snap.
             * @return {?}
             */
            function () { return this._step; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._step = coerceNumberProperty(v, this._step);
                if (this._step % 1 !== 0) {
                    this._roundToDecimal = /** @type {?} */ ((this._step.toString().split('.').pop())).length;
                }
                // Since this could modify the label, we need to notify the change detection.
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "thumbLabel", {
            get: /**
             * Whether or not to show the thumb label.
             * @return {?}
             */
            function () { return this._thumbLabel; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._thumbLabel = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "tickInterval", {
            get: /**
             * How often to show ticks. Relative to the step so that a tick always appears on a step.
             * Ex: Tick interval of 4 with a step of 3 will draw a tick every 4 steps (every 12 values).
             * @return {?}
             */
            function () { return this._tickInterval; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value === 'auto') {
                    this._tickInterval = 'auto';
                }
                else if (typeof value === 'number' || typeof value === 'string') {
                    this._tickInterval = coerceNumberProperty(value, /** @type {?} */ (this._tickInterval));
                }
                else {
                    this._tickInterval = 0;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "value", {
            get: /**
             * Value of the slider.
             * @return {?}
             */
            function () {
                // If the value needs to be read and it is still uninitialized, initialize it to the min.
                if (this._value === null) {
                    this.value = this._min;
                }
                return this._value;
            },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                if (v !== this._value) {
                    var /** @type {?} */ value = coerceNumberProperty(v);
                    // While incrementing by a decimal we can end up with values like 33.300000000000004.
                    // Truncate it to ensure that it matches the label and to make it easier to work with.
                    if (this._roundToDecimal) {
                        value = parseFloat(value.toFixed(this._roundToDecimal));
                    }
                    this._value = value;
                    this._percent = this._calculatePercentage(this._value);
                    // Since this also modifies the percentage, we need to let the change detection know.
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "vertical", {
            get: /**
             * Whether the slider is vertical.
             * @return {?}
             */
            function () { return this._vertical; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._vertical = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "displayValue", {
            /** The value to be used for display purposes. */
            get: /**
             * The value to be used for display purposes.
             * @return {?}
             */
            function () {
                if (this.displayWith) {
                    return this.displayWith(this.value);
                }
                // Note that this could be improved further by rounding something like 0.999 to 1 or
                // 0.899 to 0.9, however it is very performance sensitive, because it gets called on
                // every change detection cycle.
                if (this._roundToDecimal && this.value && this.value % 1 !== 0) {
                    return this.value.toFixed(this._roundToDecimal);
                }
                return this.value || 0;
            },
            enumerable: true,
            configurable: true
        });
        /** set focus to the host element */
        /**
         * set focus to the host element
         * @return {?}
         */
        MatSlider.prototype.focus = /**
         * set focus to the host element
         * @return {?}
         */
        function () {
            this._focusHostElement();
        };
        /** blur the host element */
        /**
         * blur the host element
         * @return {?}
         */
        MatSlider.prototype.blur = /**
         * blur the host element
         * @return {?}
         */
        function () {
            this._blurHostElement();
        };
        Object.defineProperty(MatSlider.prototype, "percent", {
            /** The percentage of the slider that coincides with the value. */
            get: /**
             * The percentage of the slider that coincides with the value.
             * @return {?}
             */
            function () { return this._clamp(this._percent); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_invertAxis", {
            /**
             * Whether the axis of the slider is inverted.
             * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
             */
            get: /**
             * Whether the axis of the slider is inverted.
             * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
             * @return {?}
             */
            function () {
                // Standard non-inverted mode for a vertical slider should be dragging the thumb from bottom to
                // top. However from a y-axis standpoint this is inverted.
                return this.vertical ? !this.invert : this.invert;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_isMinValue", {
            /** Whether the slider is at its minimum value. */
            get: /**
             * Whether the slider is at its minimum value.
             * @return {?}
             */
            function () {
                return this.percent === 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_thumbGap", {
            /**
             * The amount of space to leave between the slider thumb and the track fill & track background
             * elements.
             */
            get: /**
             * The amount of space to leave between the slider thumb and the track fill & track background
             * elements.
             * @return {?}
             */
            function () {
                if (this.disabled) {
                    return DISABLED_THUMB_GAP;
                }
                if (this._isMinValue && !this.thumbLabel) {
                    return this._isActive ? MIN_VALUE_ACTIVE_THUMB_GAP : MIN_VALUE_NONACTIVE_THUMB_GAP;
                }
                return 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_trackBackgroundStyles", {
            /** CSS styles for the track background element. */
            get: /**
             * CSS styles for the track background element.
             * @return {?}
             */
            function () {
                var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
                var /** @type {?} */ sign = this._invertMouseCoords ? '-' : '';
                return {
                    'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + (1 - this.percent) + ")"
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_trackFillStyles", {
            /** CSS styles for the track fill element. */
            get: /**
             * CSS styles for the track fill element.
             * @return {?}
             */
            function () {
                var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
                var /** @type {?} */ sign = this._invertMouseCoords ? '' : '-';
                return {
                    'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + this.percent + ")"
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_ticksContainerStyles", {
            /** CSS styles for the ticks container element. */
            get: /**
             * CSS styles for the ticks container element.
             * @return {?}
             */
            function () {
                var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
                // For a horizontal slider in RTL languages we push the ticks container off the left edge
                // instead of the right edge to avoid causing a horizontal scrollbar to appear.
                var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '' : '-';
                var /** @type {?} */ offset = this._tickIntervalPercent / 2 * 100;
                return {
                    'transform': "translate" + axis + "(" + sign + offset + "%)"
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_ticksStyles", {
            /** CSS styles for the ticks element. */
            get: /**
             * CSS styles for the ticks element.
             * @return {?}
             */
            function () {
                var /** @type {?} */ tickSize = this._tickIntervalPercent * 100;
                var /** @type {?} */ backgroundSize = this.vertical ? "2px " + tickSize + "%" : tickSize + "% 2px";
                var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
                // Depending on the direction we pushed the ticks container, push the ticks the opposite
                // direction to re-center them but clip off the end edge. In RTL languages we need to flip the
                // ticks 180 degrees so we're really cutting off the end edge abd not the start.
                var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '-' : '';
                var /** @type {?} */ rotate = !this.vertical && this._direction == 'rtl' ? ' rotate(180deg)' : '';
                var /** @type {?} */ styles = {
                    'backgroundSize': backgroundSize,
                    // Without translateZ ticks sometimes jitter as the slider moves on Chrome & Firefox.
                    'transform': "translateZ(0) translate" + axis + "(" + sign + tickSize / 2 + "%)" + rotate
                };
                if (this._isMinValue && this._thumbGap) {
                    var /** @type {?} */ side = this.vertical ?
                        (this._invertAxis ? 'Bottom' : 'Top') :
                        (this._invertAxis ? 'Right' : 'Left');
                    styles["padding" + side] = this._thumbGap + "px";
                }
                return styles;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_thumbContainerStyles", {
            get: /**
             * @return {?}
             */
            function () {
                var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
                // For a horizontal slider in RTL languages we push the thumb container off the left edge
                // instead of the right edge to avoid causing a horizontal scrollbar to appear.
                var /** @type {?} */ invertOffset = (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
                var /** @type {?} */ offset = (invertOffset ? this.percent : 1 - this.percent) * 100;
                return {
                    'transform': "translate" + axis + "(-" + offset + "%)"
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_invertMouseCoords", {
            get: /**
             * Whether mouse events should be converted to a slider position by calculating their distance
             * from the right or bottom edge of the slider as opposed to the top or left.
             * @return {?}
             */
            function () {
                return (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSlider.prototype, "_direction", {
            get: /**
             * The language direction for this slider element.
             * @return {?}
             */
            function () {
                return (this._dir && this._dir.value == 'rtl') ? 'rtl' : 'ltr';
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatSlider.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._focusMonitor
                .monitor(this._elementRef.nativeElement, true)
                .subscribe(function (origin) {
                _this._isActive = !!origin && origin !== 'keyboard';
                _this._changeDetectorRef.detectChanges();
            });
            if (this._dir) {
                this._dirChangeSubscription = this._dir.change.subscribe(function () {
                    _this._changeDetectorRef.markForCheck();
                });
            }
        };
        /**
         * @return {?}
         */
        MatSlider.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
            this._dirChangeSubscription.unsubscribe();
        };
        /**
         * @return {?}
         */
        MatSlider.prototype._onMouseenter = /**
         * @return {?}
         */
        function () {
            if (this.disabled) {
                return;
            }
            // We save the dimensions of the slider here so we can use them to update the spacing of the
            // ticks and determine where on the slider click and slide events happen.
            this._sliderDimensions = this._getSliderDimensions();
            this._updateTickIntervalPercent();
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatSlider.prototype._onClick = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                return;
            }
            var /** @type {?} */ oldValue = this.value;
            this._isSliding = false;
            this._focusHostElement();
            this._updateValueFromPosition({ x: event.clientX, y: event.clientY });
            // Emit a change and input event if the value changed.
            if (oldValue != this.value) {
                this._emitInputEvent();
                this._emitChangeEvent();
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatSlider.prototype._onSlide = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                return;
            }
            // The slide start event sometimes fails to fire on iOS, so if we're not already in the sliding
            // state, call the slide start handler manually.
            if (!this._isSliding) {
                this._onSlideStart(null);
            }
            // Prevent the slide from selecting anything else.
            event.preventDefault();
            var /** @type {?} */ oldValue = this.value;
            this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
            // Native range elements always emit `input` events when the value changed while sliding.
            if (oldValue != this.value) {
                this._emitInputEvent();
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatSlider.prototype._onSlideStart = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled || this._isSliding) {
                return;
            }
            // Simulate mouseenter in case this is a mobile device.
            this._onMouseenter();
            this._isSliding = true;
            this._focusHostElement();
            this._valueOnSlideStart = this.value;
            if (event) {
                this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
                event.preventDefault();
            }
        };
        /**
         * @return {?}
         */
        MatSlider.prototype._onSlideEnd = /**
         * @return {?}
         */
        function () {
            this._isSliding = false;
            if (this._valueOnSlideStart != this.value && !this.disabled) {
                this._emitChangeEvent();
            }
            this._valueOnSlideStart = null;
        };
        /**
         * @return {?}
         */
        MatSlider.prototype._onFocus = /**
         * @return {?}
         */
        function () {
            // We save the dimensions of the slider here so we can use them to update the spacing of the
            // ticks and determine where on the slider click and slide events happen.
            this._sliderDimensions = this._getSliderDimensions();
            this._updateTickIntervalPercent();
        };
        /**
         * @return {?}
         */
        MatSlider.prototype._onBlur = /**
         * @return {?}
         */
        function () {
            this.onTouched();
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatSlider.prototype._onKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                return;
            }
            var /** @type {?} */ oldValue = this.value;
            switch (event.keyCode) {
                case PAGE_UP:
                    this._increment(10);
                    break;
                case PAGE_DOWN:
                    this._increment(-10);
                    break;
                case END:
                    this.value = this.max;
                    break;
                case HOME:
                    this.value = this.min;
                    break;
                case LEFT_ARROW:
                    // NOTE: For a sighted user it would make more sense that when they press an arrow key on an
                    // inverted slider the thumb moves in that direction. However for a blind user, nothing
                    // about the slider indicates that it is inverted. They will expect left to be decrement,
                    // regardless of how it appears on the screen. For speakers ofRTL languages, they probably
                    // expect left to mean increment. Therefore we flip the meaning of the side arrow keys for
                    // RTL. For inverted sliders we prefer a good a11y experience to having it "look right" for
                    // sighted users, therefore we do not swap the meaning.
                    this._increment(this._direction == 'rtl' ? 1 : -1);
                    break;
                case UP_ARROW:
                    this._increment(1);
                    break;
                case RIGHT_ARROW:
                    // See comment on LEFT_ARROW about the conditions under which we flip the meaning.
                    this._increment(this._direction == 'rtl' ? -1 : 1);
                    break;
                case DOWN_ARROW:
                    this._increment(-1);
                    break;
                default:
                    // Return if the key is not one that we explicitly handle to avoid calling preventDefault on
                    // it.
                    return;
            }
            if (oldValue != this.value) {
                this._emitInputEvent();
                this._emitChangeEvent();
            }
            this._isSliding = true;
            event.preventDefault();
        };
        /**
         * @return {?}
         */
        MatSlider.prototype._onKeyup = /**
         * @return {?}
         */
        function () {
            this._isSliding = false;
        };
        /**
         * Increments the slider by the given number of steps (negative number decrements).
         * @param {?} numSteps
         * @return {?}
         */
        MatSlider.prototype._increment = /**
         * Increments the slider by the given number of steps (negative number decrements).
         * @param {?} numSteps
         * @return {?}
         */
        function (numSteps) {
            this.value = this._clamp((this.value || 0) + this.step * numSteps, this.min, this.max);
        };
        /**
         * Calculate the new value from the new physical location. The value will always be snapped.
         * @param {?} pos
         * @return {?}
         */
        MatSlider.prototype._updateValueFromPosition = /**
         * Calculate the new value from the new physical location. The value will always be snapped.
         * @param {?} pos
         * @return {?}
         */
        function (pos) {
            if (!this._sliderDimensions) {
                return;
            }
            var /** @type {?} */ offset = this.vertical ? this._sliderDimensions.top : this._sliderDimensions.left;
            var /** @type {?} */ size = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
            var /** @type {?} */ posComponent = this.vertical ? pos.y : pos.x;
            // The exact value is calculated from the event and used to find the closest snap value.
            var /** @type {?} */ percent = this._clamp((posComponent - offset) / size);
            if (this._invertMouseCoords) {
                percent = 1 - percent;
            }
            // Since the steps may not divide cleanly into the max value, if the user
            // slid to 0 or 100 percent, we jump to the min/max value. This approach
            // is slightly more intuitive than using `Math.ceil` below, because it
            // follows the user's pointer closer.
            if (percent === 0) {
                this.value = this.min;
            }
            else if (percent === 1) {
                this.value = this.max;
            }
            else {
                var /** @type {?} */ exactValue = this._calculateValue(percent);
                // This calculation finds the closest step by finding the closest
                // whole number divisible by the step relative to the min.
                var /** @type {?} */ closestValue = Math.round((exactValue - this.min) / this.step) * this.step + this.min;
                // The value needs to snap to the min and max.
                this.value = this._clamp(closestValue, this.min, this.max);
            }
        };
        /**
         * Emits a change event if the current value is different from the last emitted value.
         * @return {?}
         */
        MatSlider.prototype._emitChangeEvent = /**
         * Emits a change event if the current value is different from the last emitted value.
         * @return {?}
         */
        function () {
            this._controlValueAccessorChangeFn(this.value);
            this.change.emit(this._createChangeEvent());
        };
        /**
         * Emits an input event when the current value is different from the last emitted value.
         * @return {?}
         */
        MatSlider.prototype._emitInputEvent = /**
         * Emits an input event when the current value is different from the last emitted value.
         * @return {?}
         */
        function () {
            this.input.emit(this._createChangeEvent());
        };
        /**
         * Updates the amount of space between ticks as a percentage of the width of the slider.
         * @return {?}
         */
        MatSlider.prototype._updateTickIntervalPercent = /**
         * Updates the amount of space between ticks as a percentage of the width of the slider.
         * @return {?}
         */
        function () {
            if (!this.tickInterval || !this._sliderDimensions) {
                return;
            }
            if (this.tickInterval == 'auto') {
                var /** @type {?} */ trackSize = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
                var /** @type {?} */ pixelsPerStep = trackSize * this.step / (this.max - this.min);
                var /** @type {?} */ stepsPerTick = Math.ceil(MIN_AUTO_TICK_SEPARATION / pixelsPerStep);
                var /** @type {?} */ pixelsPerTick = stepsPerTick * this.step;
                this._tickIntervalPercent = pixelsPerTick / trackSize;
            }
            else {
                this._tickIntervalPercent = this.tickInterval * this.step / (this.max - this.min);
            }
        };
        /**
         * Creates a slider change object from the specified value.
         * @param {?=} value
         * @return {?}
         */
        MatSlider.prototype._createChangeEvent = /**
         * Creates a slider change object from the specified value.
         * @param {?=} value
         * @return {?}
         */
        function (value) {
            if (value === void 0) { value = this.value; }
            var /** @type {?} */ event = new MatSliderChange();
            event.source = this;
            event.value = value;
            return event;
        };
        /**
         * Calculates the percentage of the slider that a value is.
         * @param {?} value
         * @return {?}
         */
        MatSlider.prototype._calculatePercentage = /**
         * Calculates the percentage of the slider that a value is.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            return ((value || 0) - this.min) / (this.max - this.min);
        };
        /**
         * Calculates the value a percentage of the slider corresponds to.
         * @param {?} percentage
         * @return {?}
         */
        MatSlider.prototype._calculateValue = /**
         * Calculates the value a percentage of the slider corresponds to.
         * @param {?} percentage
         * @return {?}
         */
        function (percentage) {
            return this.min + percentage * (this.max - this.min);
        };
        /**
         * Return a number between two numbers.
         * @param {?} value
         * @param {?=} min
         * @param {?=} max
         * @return {?}
         */
        MatSlider.prototype._clamp = /**
         * Return a number between two numbers.
         * @param {?} value
         * @param {?=} min
         * @param {?=} max
         * @return {?}
         */
        function (value, min, max) {
            if (min === void 0) { min = 0; }
            if (max === void 0) { max = 1; }
            return Math.max(min, Math.min(value, max));
        };
        /**
         * Get the bounding client rect of the slider track element.
         * The track is used rather than the native element to ignore the extra space that the thumb can
         * take up.
         * @return {?}
         */
        MatSlider.prototype._getSliderDimensions = /**
         * Get the bounding client rect of the slider track element.
         * The track is used rather than the native element to ignore the extra space that the thumb can
         * take up.
         * @return {?}
         */
        function () {
            return this._sliderWrapper ? this._sliderWrapper.nativeElement.getBoundingClientRect() : null;
        };
        /**
         * Focuses the native element.
         * Currently only used to allow a blur event to fire but will be used with keyboard input later.
         * @return {?}
         */
        MatSlider.prototype._focusHostElement = /**
         * Focuses the native element.
         * Currently only used to allow a blur event to fire but will be used with keyboard input later.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.focus();
        };
        /**
         * Blurs the native element.
         * @return {?}
         */
        MatSlider.prototype._blurHostElement = /**
         * Blurs the native element.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.blur();
        };
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param value
         */
        /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        MatSlider.prototype.writeValue = /**
         * Sets the model value. Implemented as part of ControlValueAccessor.
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.value = value;
        };
        /**
         * Registers a callback to be triggered when the value has changed.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        /**
         * Registers a callback to be triggered when the value has changed.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        MatSlider.prototype.registerOnChange = /**
         * Registers a callback to be triggered when the value has changed.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        /**
         * Registers a callback to be triggered when the component is touched.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        /**
         * Registers a callback to be triggered when the component is touched.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        MatSlider.prototype.registerOnTouched = /**
         * Registers a callback to be triggered when the component is touched.
         * Implemented as part of ControlValueAccessor.
         * @param {?} fn Callback to be registered.
         * @return {?}
         */
        function (fn) {
            this.onTouched = fn;
        };
        /**
         * Sets whether the component should be disabled.
         * Implemented as part of ControlValueAccessor.
         * @param isDisabled
         */
        /**
         * Sets whether the component should be disabled.
         * Implemented as part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        MatSlider.prototype.setDisabledState = /**
         * Sets whether the component should be disabled.
         * Implemented as part of ControlValueAccessor.
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) {
            this.disabled = isDisabled;
        };
        MatSlider.decorators = [
            { type: core.Component, args: [{selector: 'mat-slider',
                        exportAs: 'matSlider',
                        providers: [MAT_SLIDER_VALUE_ACCESSOR],
                        host: {
                            '(focus)': '_onFocus()',
                            '(blur)': '_onBlur()',
                            '(click)': '_onClick($event)',
                            '(keydown)': '_onKeydown($event)',
                            '(keyup)': '_onKeyup()',
                            '(mouseenter)': '_onMouseenter()',
                            '(slide)': '_onSlide($event)',
                            '(slideend)': '_onSlideEnd()',
                            '(slidestart)': '_onSlideStart($event)',
                            'class': 'mat-slider',
                            'role': 'slider',
                            '[tabIndex]': 'tabIndex',
                            '[attr.aria-disabled]': 'disabled',
                            '[attr.aria-valuemax]': 'max',
                            '[attr.aria-valuemin]': 'min',
                            '[attr.aria-valuenow]': 'value',
                            '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                            '[class.mat-slider-disabled]': 'disabled',
                            '[class.mat-slider-has-ticks]': 'tickInterval',
                            '[class.mat-slider-horizontal]': '!vertical',
                            '[class.mat-slider-axis-inverted]': '_invertAxis',
                            '[class.mat-slider-sliding]': '_isSliding',
                            '[class.mat-slider-thumb-label-showing]': 'thumbLabel',
                            '[class.mat-slider-vertical]': 'vertical',
                            '[class.mat-slider-min-value]': '_isMinValue',
                            '[class.mat-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
                            '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        },
                        template: "<div class=\"mat-slider-wrapper\" #sliderWrapper><div class=\"mat-slider-track-wrapper\"><div class=\"mat-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div><div class=\"mat-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div></div><div class=\"mat-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\"><div class=\"mat-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div></div><div class=\"mat-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\"><div class=\"mat-slider-focus-ring\"></div><div class=\"mat-slider-thumb\"></div><div class=\"mat-slider-thumb-label\"><span class=\"mat-slider-thumb-label-text\">{{displayValue}}</span></div></div></div>",
                        styles: [".mat-slider{display:inline-block;position:relative;box-sizing:border-box;padding:8px;outline:0;vertical-align:middle}.mat-slider-wrapper{position:absolute}.mat-slider-track-wrapper{position:absolute;top:0;left:0;overflow:hidden}.mat-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-ticks-container{position:absolute;left:0;top:0;overflow:hidden}.mat-slider-ticks{background-repeat:repeat;background-clip:content-box;box-sizing:border-box;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-focus-ring{position:absolute;width:30px;height:30px;border-radius:50%;transform:scale(0);opacity:0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.cdk-keyboard-focused .mat-slider-focus-ring,.cdk-program-focused .mat-slider-focus-ring{transform:scale(1);opacity:1}.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label{cursor:-webkit-grab;cursor:grab}.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb-label,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label:active,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb:active{cursor:-webkit-grabbing;cursor:grabbing}.mat-slider-thumb{position:absolute;right:-10px;bottom:-10px;box-sizing:border-box;width:20px;height:20px;border:3px solid transparent;border-radius:50%;transform:scale(.7);transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label{display:none;align-items:center;justify-content:center;position:absolute;width:28px;height:28px;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label-text{z-index:1;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-sliding .mat-slider-thumb-container,.mat-slider-sliding .mat-slider-track-background,.mat-slider-sliding .mat-slider-track-fill{transition-duration:0s}.mat-slider-has-ticks .mat-slider-wrapper::after{content:'';position:absolute;border-width:0;border-style:solid;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after,.mat-slider-has-ticks:hover:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after{opacity:1}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks:hover:not(.mat-slider-disabled) .mat-slider-ticks{opacity:1}.mat-slider-thumb-label-showing .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-thumb-label-showing .mat-slider-thumb-label{display:flex}.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:100% 100%}.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:0 0}.mat-slider:not(.mat-slider-disabled).cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(0)}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label{border-radius:50% 50% 0}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label-text{opacity:1}.mat-slider:not(.mat-slider-disabled).cdk-mouse-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-program-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-touch-focused .mat-slider-thumb{border-width:2px;transform:scale(1)}.mat-slider-disabled .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-disabled .mat-slider-thumb{border-width:4px;transform:scale(.5)}.mat-slider-disabled .mat-slider-thumb-label{display:none}.mat-slider-horizontal{height:48px;min-width:128px}.mat-slider-horizontal .mat-slider-wrapper{height:2px;top:23px;left:8px;right:8px}.mat-slider-horizontal .mat-slider-wrapper::after{height:2px;border-left-width:2px;right:0;top:0}.mat-slider-horizontal .mat-slider-track-wrapper{height:2px;width:100%}.mat-slider-horizontal .mat-slider-track-fill{height:2px;width:100%;transform:scaleX(0)}.mat-slider-horizontal .mat-slider-track-background{height:2px;width:100%;transform:scaleX(1)}.mat-slider-horizontal .mat-slider-ticks-container{height:2px;width:100%}@media screen and (-ms-high-contrast:active){.mat-slider-horizontal .mat-slider-ticks-container{height:0;outline:solid 2px;top:1px}}.mat-slider-horizontal .mat-slider-ticks{height:2px;width:100%}.mat-slider-horizontal .mat-slider-thumb-container{width:100%;height:0;top:50%}.mat-slider-horizontal .mat-slider-focus-ring{top:-15px;right:-15px}.mat-slider-horizontal .mat-slider-thumb-label{right:-14px;top:-40px;transform:translateY(26px) scale(.01) rotate(45deg)}.mat-slider-horizontal .mat-slider-thumb-label-text{transform:rotate(-45deg)}.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label{transform:rotate(45deg)}.mat-slider-vertical{width:48px;min-height:128px}.mat-slider-vertical .mat-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.mat-slider-vertical .mat-slider-wrapper::after{width:2px;border-top-width:2px;bottom:0;left:0}.mat-slider-vertical .mat-slider-track-wrapper{height:100%;width:2px}.mat-slider-vertical .mat-slider-track-fill{height:100%;width:2px;transform:scaleY(0)}.mat-slider-vertical .mat-slider-track-background{height:100%;width:2px;transform:scaleY(1)}.mat-slider-vertical .mat-slider-ticks-container{width:2px;height:100%}@media screen and (-ms-high-contrast:active){.mat-slider-vertical .mat-slider-ticks-container{width:0;outline:solid 2px;left:1px}}.mat-slider-vertical .mat-slider-focus-ring{bottom:-15px;left:-15px}.mat-slider-vertical .mat-slider-ticks{width:2px;height:100%}.mat-slider-vertical .mat-slider-thumb-container{height:100%;width:0;left:50%}.mat-slider-vertical .mat-slider-thumb{-webkit-backface-visibility:hidden;backface-visibility:hidden}.mat-slider-vertical .mat-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.mat-slider-vertical .mat-slider-thumb-label-text{transform:rotate(45deg)}.mat-slider-vertical.cdk-focused .mat-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .mat-slider-wrapper::after{left:0;right:auto}[dir=rtl] .mat-slider-horizontal .mat-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .mat-slider-horizontal .mat-slider-track-background{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:100% 100%}.mat-slider._mat-animation-noopable .mat-slider-focus-ring,.mat-slider._mat-animation-noopable .mat-slider-has-ticks .mat-slider-wrapper::after,.mat-slider._mat-animation-noopable .mat-slider-thumb,.mat-slider._mat-animation-noopable .mat-slider-thumb-container,.mat-slider._mat-animation-noopable .mat-slider-thumb-label,.mat-slider._mat-animation-noopable .mat-slider-thumb-label-text,.mat-slider._mat-animation-noopable .mat-slider-ticks,.mat-slider._mat-animation-noopable .mat-slider-track-background,.mat-slider._mat-animation-noopable .mat-slider-track-fill{transition:none}"],
                        inputs: ['disabled', 'color', 'tabIndex'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatSlider.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: FocusMonitor, },
            { type: core.ChangeDetectorRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [ANIMATION_MODULE_TYPE,] },] },
        ]; };
        MatSlider.propDecorators = {
            "invert": [{ type: core.Input },],
            "max": [{ type: core.Input },],
            "min": [{ type: core.Input },],
            "step": [{ type: core.Input },],
            "thumbLabel": [{ type: core.Input },],
            "tickInterval": [{ type: core.Input },],
            "value": [{ type: core.Input },],
            "displayWith": [{ type: core.Input },],
            "vertical": [{ type: core.Input },],
            "change": [{ type: core.Output },],
            "input": [{ type: core.Output },],
            "_sliderWrapper": [{ type: core.ViewChild, args: ['sliderWrapper',] },],
        };
        return MatSlider;
    }(_MatSliderMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Reference to a snack bar dispatched from the snack bar service.
     * @template T
     */
    var  /**
     * Reference to a snack bar dispatched from the snack bar service.
     * @template T
     */
    MatSnackBarRef = /** @class */ (function () {
        function MatSnackBarRef(containerInstance, _overlayRef) {
            var _this = this;
            this._overlayRef = _overlayRef;
            /**
             * Subject for notifying the user that the snack bar has been dismissed.
             */
            this._afterDismissed = new rxjs.Subject();
            /**
             * Subject for notifying the user that the snack bar has opened and appeared.
             */
            this._afterOpened = new rxjs.Subject();
            /**
             * Subject for notifying the user that the snack bar action was called.
             */
            this._onAction = new rxjs.Subject();
            /**
             * Whether the snack bar was dismissed using the action button.
             */
            this._dismissedByAction = false;
            this.containerInstance = containerInstance;
            // Dismiss snackbar on action.
            this.onAction().subscribe(function () { return _this.dismiss(); });
            containerInstance._onExit.subscribe(function () { return _this._finishDismiss(); });
        }
        /** Dismisses the snack bar. */
        /**
         * Dismisses the snack bar.
         * @return {?}
         */
        MatSnackBarRef.prototype.dismiss = /**
         * Dismisses the snack bar.
         * @return {?}
         */
        function () {
            if (!this._afterDismissed.closed) {
                this.containerInstance.exit();
            }
            clearTimeout(this._durationTimeoutId);
        };
        /** Marks the snackbar action clicked. */
        /**
         * Marks the snackbar action clicked.
         * @return {?}
         */
        MatSnackBarRef.prototype.dismissWithAction = /**
         * Marks the snackbar action clicked.
         * @return {?}
         */
        function () {
            if (!this._onAction.closed) {
                this._dismissedByAction = true;
                this._onAction.next();
                this._onAction.complete();
            }
        };
        /**
         * Marks the snackbar action clicked.
         * @deprecated Use `dismissWithAction` instead.
         * @deletion-target 7.0.0
         */
        /**
         * Marks the snackbar action clicked.
         * @deprecated Use `dismissWithAction` instead.
         * \@deletion-target 7.0.0
         * @return {?}
         */
        MatSnackBarRef.prototype.closeWithAction = /**
         * Marks the snackbar action clicked.
         * @deprecated Use `dismissWithAction` instead.
         * \@deletion-target 7.0.0
         * @return {?}
         */
        function () {
            this.dismissWithAction();
        };
        /** Dismisses the snack bar after some duration */
        /**
         * Dismisses the snack bar after some duration
         * @param {?} duration
         * @return {?}
         */
        MatSnackBarRef.prototype._dismissAfter = /**
         * Dismisses the snack bar after some duration
         * @param {?} duration
         * @return {?}
         */
        function (duration) {
            var _this = this;
            this._durationTimeoutId = setTimeout(function () { return _this.dismiss(); }, duration);
        };
        /** Marks the snackbar as opened */
        /**
         * Marks the snackbar as opened
         * @return {?}
         */
        MatSnackBarRef.prototype._open = /**
         * Marks the snackbar as opened
         * @return {?}
         */
        function () {
            if (!this._afterOpened.closed) {
                this._afterOpened.next();
                this._afterOpened.complete();
            }
        };
        /**
         * Cleans up the DOM after closing.
         * @return {?}
         */
        MatSnackBarRef.prototype._finishDismiss = /**
         * Cleans up the DOM after closing.
         * @return {?}
         */
        function () {
            this._overlayRef.dispose();
            if (!this._onAction.closed) {
                this._onAction.complete();
            }
            this._afterDismissed.next({ dismissedByAction: this._dismissedByAction });
            this._afterDismissed.complete();
            this._dismissedByAction = false;
        };
        /** Gets an observable that is notified when the snack bar is finished closing. */
        /**
         * Gets an observable that is notified when the snack bar is finished closing.
         * @return {?}
         */
        MatSnackBarRef.prototype.afterDismissed = /**
         * Gets an observable that is notified when the snack bar is finished closing.
         * @return {?}
         */
        function () {
            return this._afterDismissed.asObservable();
        };
        /** Gets an observable that is notified when the snack bar has opened and appeared. */
        /**
         * Gets an observable that is notified when the snack bar has opened and appeared.
         * @return {?}
         */
        MatSnackBarRef.prototype.afterOpened = /**
         * Gets an observable that is notified when the snack bar has opened and appeared.
         * @return {?}
         */
        function () {
            return this.containerInstance._onEnter;
        };
        /** Gets an observable that is notified when the snack bar action is called. */
        /**
         * Gets an observable that is notified when the snack bar action is called.
         * @return {?}
         */
        MatSnackBarRef.prototype.onAction = /**
         * Gets an observable that is notified when the snack bar action is called.
         * @return {?}
         */
        function () {
            return this._onAction.asObservable();
        };
        return MatSnackBarRef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to access the data that was passed in to a snack bar.
     */
    var /** @type {?} */ MAT_SNACK_BAR_DATA = new core.InjectionToken('MatSnackBarData');
    /**
     * Configuration used when opening a snack-bar.
     * @template D
     */
    var  /**
     * Configuration used when opening a snack-bar.
     * @template D
     */
    MatSnackBarConfig = /** @class */ (function () {
        function MatSnackBarConfig() {
            /**
             * The politeness level for the MatAriaLiveAnnouncer announcement.
             */
            this.politeness = 'assertive';
            /**
             * Message to be announced by the MatAriaLiveAnnouncer
             */
            this.announcementMessage = '';
            /**
             * The length of time in milliseconds to wait before automatically dismissing the snack bar.
             */
            this.duration = 0;
            /**
             * Data being injected into the child component.
             */
            this.data = null;
            /**
             * The horizontal position to place the snack bar.
             */
            this.horizontalPosition = 'center';
            /**
             * The vertical position to place the snack bar.
             */
            this.verticalPosition = 'bottom';
        }
        return MatSnackBarConfig;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material snack bar.
     */
    var /** @type {?} */ matSnackBarAnimations = {
        /** Animation that slides the dialog in and out of view and fades the opacity. */
        contentFade: trigger('contentFade', [
            transition(':enter', [
                style({ opacity: '0' }),
                animate(AnimationDurations.COMPLEX + " " + AnimationCurves.STANDARD_CURVE)
            ])
        ]),
        /** Animation that shows and hides a snack bar. */
        snackBarState: trigger('state', [
            state('visible-top, visible-bottom', style({ transform: 'translateY(0%)' })),
            transition('visible-top => hidden-top, visible-bottom => hidden-bottom', animate(AnimationDurations.EXITING + " " + AnimationCurves.ACCELERATION_CURVE)),
            transition('void => visible-top, void => visible-bottom', animate(AnimationDurations.ENTERING + " " + AnimationCurves.DECELERATION_CURVE)),
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * A component used to open as the default snack bar, matching material spec.
     * This should only be used internally by the snack bar service.
     */
    var SimpleSnackBar = /** @class */ (function () {
        function SimpleSnackBar(snackBarRef, data) {
            this.snackBarRef = snackBarRef;
            this.data = data;
        }
        /** Performs the action on the snack bar. */
        /**
         * Performs the action on the snack bar.
         * @return {?}
         */
        SimpleSnackBar.prototype.action = /**
         * Performs the action on the snack bar.
         * @return {?}
         */
        function () {
            this.snackBarRef.dismissWithAction();
        };
        Object.defineProperty(SimpleSnackBar.prototype, "hasAction", {
            /** If the action button should be shown. */
            get: /**
             * If the action button should be shown.
             * @return {?}
             */
            function () {
                return !!this.data.action;
            },
            enumerable: true,
            configurable: true
        });
        SimpleSnackBar.decorators = [
            { type: core.Component, args: [{selector: 'simple-snack-bar',
                        template: "{{data.message}}<div class=\"mat-simple-snackbar-action\" *ngIf=\"hasAction\"><button mat-button (click)=\"action()\">{{data.action}}</button></div>",
                        styles: [".mat-simple-snackbar{display:flex;justify-content:space-between;line-height:20px;opacity:1}.mat-simple-snackbar-action{display:flex;flex-direction:column;flex-shrink:0;justify-content:space-around;margin:-8px 0 -8px 8px}.mat-simple-snackbar-action button{flex:1;max-height:36px}[dir=rtl] .mat-simple-snackbar-action{margin-left:0;margin-right:8px}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        animations: [matSnackBarAnimations.contentFade],
                        host: {
                            '[@contentFade]': '',
                            'class': 'mat-simple-snackbar',
                        }
                    },] },
        ];
        /** @nocollapse */
        SimpleSnackBar.ctorParameters = function () { return [
            { type: MatSnackBarRef, },
            { type: undefined, decorators: [{ type: core.Inject, args: [MAT_SNACK_BAR_DATA,] },] },
        ]; };
        return SimpleSnackBar;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Internal component that wraps user-provided snack bar content.
     * \@docs-private
     */
    var MatSnackBarContainer = /** @class */ (function (_super) {
        __extends(MatSnackBarContainer, _super);
        function MatSnackBarContainer(_ngZone, _elementRef, _changeDetectorRef, snackBarConfig) {
            var _this = _super.call(this) || this;
            _this._ngZone = _ngZone;
            _this._elementRef = _elementRef;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.snackBarConfig = snackBarConfig;
            /**
             * Whether the component has been destroyed.
             */
            _this._destroyed = false;
            /**
             * Subject for notifying that the snack bar has exited from view.
             */
            _this._onExit = new rxjs.Subject();
            /**
             * Subject for notifying that the snack bar has finished entering the view.
             */
            _this._onEnter = new rxjs.Subject();
            /**
             * The state of the snack bar animations.
             */
            _this._animationState = 'void';
            return _this;
        }
        /** Attach a component portal as content to this snack bar container. */
        /**
         * Attach a component portal as content to this snack bar container.
         * @template T
         * @param {?} portal
         * @return {?}
         */
        MatSnackBarContainer.prototype.attachComponentPortal = /**
         * Attach a component portal as content to this snack bar container.
         * @template T
         * @param {?} portal
         * @return {?}
         */
        function (portal) {
            this._assertNotAttached();
            this._applySnackBarClasses();
            return this._portalOutlet.attachComponentPortal(portal);
        };
        /** Attach a template portal as content to this snack bar container. */
        /**
         * Attach a template portal as content to this snack bar container.
         * @template C
         * @param {?} portal
         * @return {?}
         */
        MatSnackBarContainer.prototype.attachTemplatePortal = /**
         * Attach a template portal as content to this snack bar container.
         * @template C
         * @param {?} portal
         * @return {?}
         */
        function (portal) {
            this._assertNotAttached();
            this._applySnackBarClasses();
            return this._portalOutlet.attachTemplatePortal(portal);
        };
        /** Handle end of animations, updating the state of the snackbar. */
        /**
         * Handle end of animations, updating the state of the snackbar.
         * @param {?} event
         * @return {?}
         */
        MatSnackBarContainer.prototype.onAnimationEnd = /**
         * Handle end of animations, updating the state of the snackbar.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var fromState = event.fromState, toState = event.toState;
            if ((toState === 'void' && fromState !== 'void') || toState.startsWith('hidden')) {
                this._completeExit();
            }
            if (toState.startsWith('visible')) {
                // Note: we shouldn't use `this` inside the zone callback,
                // because it can cause a memory leak.
                var /** @type {?} */ onEnter_1 = this._onEnter;
                this._ngZone.run(function () {
                    onEnter_1.next();
                    onEnter_1.complete();
                });
            }
        };
        /** Begin animation of snack bar entrance into view. */
        /**
         * Begin animation of snack bar entrance into view.
         * @return {?}
         */
        MatSnackBarContainer.prototype.enter = /**
         * Begin animation of snack bar entrance into view.
         * @return {?}
         */
        function () {
            if (!this._destroyed) {
                this._animationState = "visible-" + this.snackBarConfig.verticalPosition;
                this._changeDetectorRef.detectChanges();
            }
        };
        /** Begin animation of the snack bar exiting from view. */
        /**
         * Begin animation of the snack bar exiting from view.
         * @return {?}
         */
        MatSnackBarContainer.prototype.exit = /**
         * Begin animation of the snack bar exiting from view.
         * @return {?}
         */
        function () {
            this._animationState = "hidden-" + this.snackBarConfig.verticalPosition;
            return this._onExit;
        };
        /** Makes sure the exit callbacks have been invoked when the element is destroyed. */
        /**
         * Makes sure the exit callbacks have been invoked when the element is destroyed.
         * @return {?}
         */
        MatSnackBarContainer.prototype.ngOnDestroy = /**
         * Makes sure the exit callbacks have been invoked when the element is destroyed.
         * @return {?}
         */
        function () {
            this._destroyed = true;
            this._completeExit();
        };
        /**
         * Waits for the zone to settle before removing the element. Helps prevent
         * errors where we end up removing an element which is in the middle of an animation.
         * @return {?}
         */
        MatSnackBarContainer.prototype._completeExit = /**
         * Waits for the zone to settle before removing the element. Helps prevent
         * errors where we end up removing an element which is in the middle of an animation.
         * @return {?}
         */
        function () {
            var _this = this;
            this._ngZone.onMicrotaskEmpty.asObservable().pipe(operators.take(1)).subscribe(function () {
                _this._onExit.next();
                _this._onExit.complete();
            });
        };
        /**
         * Applies the various positioning and user-configured CSS classes to the snack bar.
         * @return {?}
         */
        MatSnackBarContainer.prototype._applySnackBarClasses = /**
         * Applies the various positioning and user-configured CSS classes to the snack bar.
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this._elementRef.nativeElement;
            var /** @type {?} */ panelClasses = this.snackBarConfig.panelClass;
            if (panelClasses) {
                if (Array.isArray(panelClasses)) {
                    // Note that we can't use a spread here, because IE doesn't support multiple arguments.
                    panelClasses.forEach(function (cssClass) { return element.classList.add(cssClass); });
                }
                else {
                    element.classList.add(panelClasses);
                }
            }
            if (this.snackBarConfig.horizontalPosition === 'center') {
                element.classList.add('mat-snack-bar-center');
            }
            if (this.snackBarConfig.verticalPosition === 'top') {
                element.classList.add('mat-snack-bar-top');
            }
        };
        /**
         * Asserts that no content is already attached to the container.
         * @return {?}
         */
        MatSnackBarContainer.prototype._assertNotAttached = /**
         * Asserts that no content is already attached to the container.
         * @return {?}
         */
        function () {
            if (this._portalOutlet.hasAttached()) {
                throw Error('Attempting to attach snack bar content after content is already attached');
            }
        };
        MatSnackBarContainer.decorators = [
            { type: core.Component, args: [{selector: 'snack-bar-container',
                        template: "<ng-template cdkPortalOutlet></ng-template>",
                        styles: [".mat-snack-bar-container{border-radius:2px;box-sizing:border-box;display:block;margin:24px;max-width:568px;min-width:288px;padding:14px 24px;transform:translateY(100%) translateY(24px)}.mat-snack-bar-container.mat-snack-bar-center{margin:0;transform:translateY(100%)}.mat-snack-bar-container.mat-snack-bar-top{transform:translateY(-100%) translateY(-24px)}.mat-snack-bar-container.mat-snack-bar-top.mat-snack-bar-center{transform:translateY(-100%)}@media screen and (-ms-high-contrast:active){.mat-snack-bar-container{border:solid 1px}}.mat-snack-bar-handset{width:100%}.mat-snack-bar-handset .mat-snack-bar-container{margin:0;max-width:inherit;width:100%}"],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        animations: [matSnackBarAnimations.snackBarState],
                        host: {
                            'role': 'alert',
                            'class': 'mat-snack-bar-container',
                            '[@state]': '_animationState',
                            '(@state.done)': 'onAnimationEnd($event)'
                        },
                    },] },
        ];
        /** @nocollapse */
        MatSnackBarContainer.ctorParameters = function () { return [
            { type: core.NgZone, },
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: MatSnackBarConfig, },
        ]; };
        MatSnackBarContainer.propDecorators = {
            "_portalOutlet": [{ type: core.ViewChild, args: [CdkPortalOutlet,] },],
        };
        return MatSnackBarContainer;
    }(BasePortalOutlet));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatSnackBarModule = /** @class */ (function () {
        function MatSnackBarModule() {
        }
        MatSnackBarModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            OverlayModule,
                            PortalModule,
                            common.CommonModule,
                            MatButtonModule,
                            MatCommonModule,
                        ],
                        exports: [MatSnackBarContainer, MatCommonModule],
                        declarations: [MatSnackBarContainer, SimpleSnackBar],
                        entryComponents: [MatSnackBarContainer, SimpleSnackBar],
                    },] },
        ];
        return MatSnackBarModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token that can be used to specify default snack bar.
     */
    var /** @type {?} */ MAT_SNACK_BAR_DEFAULT_OPTIONS = new core.InjectionToken('mat-snack-bar-default-options', {
        providedIn: 'root',
        factory: MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY,
    });
    /**
     * \@docs-private
     * @return {?}
     */
    function MAT_SNACK_BAR_DEFAULT_OPTIONS_FACTORY() {
        return new MatSnackBarConfig();
    }
    /**
     * Service to dispatch Material Design snack bar messages.
     */
    var MatSnackBar = /** @class */ (function () {
        function MatSnackBar(_overlay, _live, _injector, _breakpointObserver, _parentSnackBar, _defaultConfig) {
            this._overlay = _overlay;
            this._live = _live;
            this._injector = _injector;
            this._breakpointObserver = _breakpointObserver;
            this._parentSnackBar = _parentSnackBar;
            this._defaultConfig = _defaultConfig;
            /**
             * Reference to the current snack bar in the view *at this level* (in the Angular injector tree).
             * If there is a parent snack-bar service, all operations should delegate to that parent
             * via `_openedSnackBarRef`.
             */
            this._snackBarRefAtThisLevel = null;
        }
        Object.defineProperty(MatSnackBar.prototype, "_openedSnackBarRef", {
            /** Reference to the currently opened snackbar at *any* level. */
            get: /**
             * Reference to the currently opened snackbar at *any* level.
             * @return {?}
             */
            function () {
                var /** @type {?} */ parent = this._parentSnackBar;
                return parent ? parent._openedSnackBarRef : this._snackBarRefAtThisLevel;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this._parentSnackBar) {
                    this._parentSnackBar._openedSnackBarRef = value;
                }
                else {
                    this._snackBarRefAtThisLevel = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Creates and dispatches a snack bar with a custom component for the content, removing any
         * currently opened snack bars.
         *
         * @param component Component to be instantiated.
         * @param config Extra configuration for the snack bar.
         */
        /**
         * Creates and dispatches a snack bar with a custom component for the content, removing any
         * currently opened snack bars.
         *
         * @template T
         * @param {?} component Component to be instantiated.
         * @param {?=} config Extra configuration for the snack bar.
         * @return {?}
         */
        MatSnackBar.prototype.openFromComponent = /**
         * Creates and dispatches a snack bar with a custom component for the content, removing any
         * currently opened snack bars.
         *
         * @template T
         * @param {?} component Component to be instantiated.
         * @param {?=} config Extra configuration for the snack bar.
         * @return {?}
         */
        function (component, config) {
            return /** @type {?} */ (this._attach(component, config));
        };
        /**
         * Creates and dispatches a snack bar with a custom template for the content, removing any
         * currently opened snack bars.
         *
         * @param template Template to be instantiated.
         * @param config Extra configuration for the snack bar.
         */
        /**
         * Creates and dispatches a snack bar with a custom template for the content, removing any
         * currently opened snack bars.
         *
         * @param {?} template Template to be instantiated.
         * @param {?=} config Extra configuration for the snack bar.
         * @return {?}
         */
        MatSnackBar.prototype.openFromTemplate = /**
         * Creates and dispatches a snack bar with a custom template for the content, removing any
         * currently opened snack bars.
         *
         * @param {?} template Template to be instantiated.
         * @param {?=} config Extra configuration for the snack bar.
         * @return {?}
         */
        function (template, config) {
            return this._attach(template, config);
        };
        /**
         * Opens a snackbar with a message and an optional action.
         * @param message The message to show in the snackbar.
         * @param action The label for the snackbar action.
         * @param config Additional configuration options for the snackbar.
         */
        /**
         * Opens a snackbar with a message and an optional action.
         * @param {?} message The message to show in the snackbar.
         * @param {?=} action The label for the snackbar action.
         * @param {?=} config Additional configuration options for the snackbar.
         * @return {?}
         */
        MatSnackBar.prototype.open = /**
         * Opens a snackbar with a message and an optional action.
         * @param {?} message The message to show in the snackbar.
         * @param {?=} action The label for the snackbar action.
         * @param {?=} config Additional configuration options for the snackbar.
         * @return {?}
         */
        function (message, action, config) {
            if (action === void 0) { action = ''; }
            var /** @type {?} */ _config = __assign({}, this._defaultConfig, config);
            // Since the user doesn't have access to the component, we can
            // override the data to pass in our own message and action.
            _config.data = { message: message, action: action };
            _config.announcementMessage = message;
            return this.openFromComponent(SimpleSnackBar, _config);
        };
        /**
         * Dismisses the currently-visible snack bar.
         */
        /**
         * Dismisses the currently-visible snack bar.
         * @return {?}
         */
        MatSnackBar.prototype.dismiss = /**
         * Dismisses the currently-visible snack bar.
         * @return {?}
         */
        function () {
            if (this._openedSnackBarRef) {
                this._openedSnackBarRef.dismiss();
            }
        };
        /**
         * Attaches the snack bar container component to the overlay.
         * @param {?} overlayRef
         * @param {?} config
         * @return {?}
         */
        MatSnackBar.prototype._attachSnackBarContainer = /**
         * Attaches the snack bar container component to the overlay.
         * @param {?} overlayRef
         * @param {?} config
         * @return {?}
         */
        function (overlayRef, config) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            var /** @type {?} */ injector = new PortalInjector(userInjector || this._injector, new WeakMap([
                [MatSnackBarConfig, config]
            ]));
            var /** @type {?} */ containerPortal = new ComponentPortal(MatSnackBarContainer, config.viewContainerRef, injector);
            var /** @type {?} */ containerRef = overlayRef.attach(containerPortal);
            containerRef.instance.snackBarConfig = config;
            return containerRef.instance;
        };
        /**
         * Places a new component or a template as the content of the snack bar container.
         * @template T
         * @param {?} content
         * @param {?=} userConfig
         * @return {?}
         */
        MatSnackBar.prototype._attach = /**
         * Places a new component or a template as the content of the snack bar container.
         * @template T
         * @param {?} content
         * @param {?=} userConfig
         * @return {?}
         */
        function (content, userConfig) {
            var /** @type {?} */ config = __assign({}, new MatSnackBarConfig(), this._defaultConfig, userConfig);
            var /** @type {?} */ overlayRef = this._createOverlay(config);
            var /** @type {?} */ container = this._attachSnackBarContainer(overlayRef, config);
            var /** @type {?} */ snackBarRef = new MatSnackBarRef(container, overlayRef);
            if (content instanceof core.TemplateRef) {
                var /** @type {?} */ portal = new TemplatePortal(content, /** @type {?} */ ((null)), /** @type {?} */ ({
                    $implicit: config.data,
                    snackBarRef: snackBarRef
                }));
                snackBarRef.instance = container.attachTemplatePortal(portal);
            }
            else {
                var /** @type {?} */ injector = this._createInjector(config, snackBarRef);
                var /** @type {?} */ portal = new ComponentPortal(content, undefined, injector);
                var /** @type {?} */ contentRef = container.attachComponentPortal(portal);
                // We can't pass this via the injector, because the injector is created earlier.
                snackBarRef.instance = contentRef.instance;
            }
            // Subscribe to the breakpoint observer and attach the mat-snack-bar-handset class as
            // appropriate. This class is applied to the overlay element because the overlay must expand to
            // fill the width of the screen for full width snackbars.
            this._breakpointObserver.observe(Breakpoints.Handset).pipe(operators.takeUntil(overlayRef.detachments().pipe(operators.take(1)))).subscribe(function (state$$1) {
                if (state$$1.matches) {
                    overlayRef.overlayElement.classList.add('mat-snack-bar-handset');
                }
                else {
                    overlayRef.overlayElement.classList.remove('mat-snack-bar-handset');
                }
            });
            this._animateSnackBar(snackBarRef, config);
            this._openedSnackBarRef = snackBarRef;
            return this._openedSnackBarRef;
        };
        /**
         * Animates the old snack bar out and the new one in.
         * @param {?} snackBarRef
         * @param {?} config
         * @return {?}
         */
        MatSnackBar.prototype._animateSnackBar = /**
         * Animates the old snack bar out and the new one in.
         * @param {?} snackBarRef
         * @param {?} config
         * @return {?}
         */
        function (snackBarRef, config) {
            var _this = this;
            // When the snackbar is dismissed, clear the reference to it.
            snackBarRef.afterDismissed().subscribe(function () {
                // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
                if (_this._openedSnackBarRef == snackBarRef) {
                    _this._openedSnackBarRef = null;
                }
            });
            if (this._openedSnackBarRef) {
                // If a snack bar is already in view, dismiss it and enter the
                // new snack bar after exit animation is complete.
                this._openedSnackBarRef.afterDismissed().subscribe(function () {
                    snackBarRef.containerInstance.enter();
                });
                this._openedSnackBarRef.dismiss();
            }
            else {
                // If no snack bar is in view, enter the new snack bar.
                snackBarRef.containerInstance.enter();
            }
            // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
            if (config.duration && config.duration > 0) {
                snackBarRef.afterOpened().subscribe(function () { return snackBarRef._dismissAfter(/** @type {?} */ ((config.duration))); });
            }
            if (config.announcementMessage) {
                this._live.announce(config.announcementMessage, config.politeness);
            }
        };
        /**
         * Creates a new overlay and places it in the correct location.
         * @param {?} config The user-specified snack bar config.
         * @return {?}
         */
        MatSnackBar.prototype._createOverlay = /**
         * Creates a new overlay and places it in the correct location.
         * @param {?} config The user-specified snack bar config.
         * @return {?}
         */
        function (config) {
            var /** @type {?} */ overlayConfig = new OverlayConfig();
            overlayConfig.direction = config.direction;
            var /** @type {?} */ positionStrategy = this._overlay.position().global();
            // Set horizontal position.
            var /** @type {?} */ isRtl = config.direction === 'rtl';
            var /** @type {?} */ isLeft = (config.horizontalPosition === 'left' ||
                (config.horizontalPosition === 'start' && !isRtl) ||
                (config.horizontalPosition === 'end' && isRtl));
            var /** @type {?} */ isRight = !isLeft && config.horizontalPosition !== 'center';
            if (isLeft) {
                positionStrategy.left('0');
            }
            else if (isRight) {
                positionStrategy.right('0');
            }
            else {
                positionStrategy.centerHorizontally();
            }
            // Set horizontal position.
            if (config.verticalPosition === 'top') {
                positionStrategy.top('0');
            }
            else {
                positionStrategy.bottom('0');
            }
            overlayConfig.positionStrategy = positionStrategy;
            return this._overlay.create(overlayConfig);
        };
        /**
         * Creates an injector to be used inside of a snack bar component.
         * @template T
         * @param {?} config Config that was used to create the snack bar.
         * @param {?} snackBarRef Reference to the snack bar.
         * @return {?}
         */
        MatSnackBar.prototype._createInjector = /**
         * Creates an injector to be used inside of a snack bar component.
         * @template T
         * @param {?} config Config that was used to create the snack bar.
         * @param {?} snackBarRef Reference to the snack bar.
         * @return {?}
         */
        function (config, snackBarRef) {
            var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
            return new PortalInjector(userInjector || this._injector, new WeakMap([
                [MatSnackBarRef, snackBarRef],
                [MAT_SNACK_BAR_DATA, config.data]
            ]));
        };
        MatSnackBar.decorators = [
            { type: core.Injectable, args: [{ providedIn: MatSnackBarModule },] },
        ];
        /** @nocollapse */
        MatSnackBar.ctorParameters = function () { return [
            { type: Overlay, },
            { type: LiveAnnouncer, },
            { type: core.Injector, },
            { type: BreakpointObserver, },
            { type: MatSnackBar, decorators: [{ type: core.Optional }, { type: core.SkipSelf },] },
            { type: MatSnackBarConfig, decorators: [{ type: core.Inject, args: [MAT_SNACK_BAR_DEFAULT_OPTIONS,] },] },
        ]; };
        /** @nocollapse */ MatSnackBar.ngInjectableDef = core.defineInjectable({ factory: function MatSnackBar_Factory() { return new MatSnackBar(core.inject(Overlay), core.inject(LiveAnnouncer), core.inject(core.INJECTOR), core.inject(BreakpointObserver), core.inject(MatSnackBar, 12), core.inject(MAT_SNACK_BAR_DEFAULT_OPTIONS)); }, token: MatSnackBar, providedIn: MatSnackBarModule });
        return MatSnackBar;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Mixin to provide a directive with a function that checks if the sticky input has been
     * changed since the last time the function was called. Essentially adds a dirty-check to the
     * sticky value.
     * @template T
     * @param {?} base
     * @return {?}
     */
    function mixinHasStickyInput(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, args) || this;
                _this._sticky = false;
                /**
                 * Whether the sticky input has changed since it was last checked.
                 */
                _this._hasStickyChanged = false;
                return _this;
            }
            Object.defineProperty(class_1.prototype, "sticky", {
                /** Whether sticky positioning should be applied. */
                get: /**
                 * Whether sticky positioning should be applied.
                 * @return {?}
                 */
                function () { return this._sticky; },
                set: /**
                 * @param {?} v
                 * @return {?}
                 */
                function (v) {
                    var /** @type {?} */ prevValue = this._sticky;
                    this._sticky = coerceBooleanProperty(v);
                    this._hasStickyChanged = prevValue !== this._sticky;
                },
                enumerable: true,
                configurable: true
            });
            /** Whether the sticky value has changed since this was last called. */
            /**
             * Whether the sticky value has changed since this was last called.
             * @return {?}
             */
            class_1.prototype.hasStickyChanged = /**
             * Whether the sticky value has changed since this was last called.
             * @return {?}
             */
            function () {
                var /** @type {?} */ hasStickyChanged = this._hasStickyChanged;
                this._hasStickyChanged = false;
                return hasStickyChanged;
            };
            /** Resets the dirty check for cases where the sticky state has been used without checking. */
            /**
             * Resets the dirty check for cases where the sticky state has been used without checking.
             * @return {?}
             */
            class_1.prototype.resetStickyChanged = /**
             * Resets the dirty check for cases where the sticky state has been used without checking.
             * @return {?}
             */
            function () {
                this._hasStickyChanged = false;
            };
            return class_1;
        }(base));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Cell definition for a CDK table.
     * Captures the template of a column's data row cell as well as cell-specific properties.
     */
    var CdkCellDef = /** @class */ (function () {
        function CdkCellDef(template) {
            this.template = template;
        }
        CdkCellDef.decorators = [
            { type: core.Directive, args: [{ selector: '[cdkCellDef]' },] },
        ];
        /** @nocollapse */
        CdkCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return CdkCellDef;
    }());
    /**
     * Header cell definition for a CDK table.
     * Captures the template of a column's header cell and as well as cell-specific properties.
     */
    var CdkHeaderCellDef = /** @class */ (function () {
        function CdkHeaderCellDef(template) {
            this.template = template;
        }
        CdkHeaderCellDef.decorators = [
            { type: core.Directive, args: [{ selector: '[cdkHeaderCellDef]' },] },
        ];
        /** @nocollapse */
        CdkHeaderCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return CdkHeaderCellDef;
    }());
    /**
     * Footer cell definition for a CDK table.
     * Captures the template of a column's footer cell and as well as cell-specific properties.
     */
    var CdkFooterCellDef = /** @class */ (function () {
        function CdkFooterCellDef(template) {
            this.template = template;
        }
        CdkFooterCellDef.decorators = [
            { type: core.Directive, args: [{ selector: '[cdkFooterCellDef]' },] },
        ];
        /** @nocollapse */
        CdkFooterCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return CdkFooterCellDef;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    CdkColumnDefBase = /** @class */ (function () {
        function CdkColumnDefBase() {
        }
        return CdkColumnDefBase;
    }());
    var /** @type {?} */ _CdkColumnDefBase = mixinHasStickyInput(CdkColumnDefBase);
    /**
     * Column definition for the CDK table.
     * Defines a set of cells available for a table column.
     */
    var CdkColumnDef = /** @class */ (function (_super) {
        __extends(CdkColumnDef, _super);
        function CdkColumnDef() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._stickyEnd = false;
            return _this;
        }
        Object.defineProperty(CdkColumnDef.prototype, "name", {
            get: /**
             * Unique name for this column.
             * @return {?}
             */
            function () { return this._name; },
            set: /**
             * @param {?} name
             * @return {?}
             */
            function (name) {
                // If the directive is set without a name (updated programatically), then this setter will
                // trigger with an empty string and should not overwrite the programatically set value.
                if (!name) {
                    return;
                }
                this._name = name;
                this.cssClassFriendlyName = name.replace(/[^a-z0-9_-]/ig, '-');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkColumnDef.prototype, "stickyEnd", {
            get: /**
             * Whether this column should be sticky positioned on the end of the row. Should make sure
             * that it mimics the `CanStick` mixin such that `_hasStickyChanged` is set to true if the value
             * has been changed.
             * @return {?}
             */
            function () { return this._stickyEnd; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                var /** @type {?} */ prevValue = this._stickyEnd;
                this._stickyEnd = coerceBooleanProperty(v);
                this._hasStickyChanged = prevValue !== this._stickyEnd;
            },
            enumerable: true,
            configurable: true
        });
        CdkColumnDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkColumnDef]',
                        inputs: ['sticky']
                    },] },
        ];
        /** @nocollapse */
        CdkColumnDef.propDecorators = {
            "name": [{ type: core.Input, args: ['cdkColumnDef',] },],
            "stickyEnd": [{ type: core.Input, args: ['stickyEnd',] },],
            "cell": [{ type: core.ContentChild, args: [CdkCellDef,] },],
            "headerCell": [{ type: core.ContentChild, args: [CdkHeaderCellDef,] },],
            "footerCell": [{ type: core.ContentChild, args: [CdkFooterCellDef,] },],
        };
        return CdkColumnDef;
    }(_CdkColumnDefBase));
    /**
     * Base class for the cells. Adds a CSS classname that identifies the column it renders in.
     */
    var  /**
     * Base class for the cells. Adds a CSS classname that identifies the column it renders in.
     */
    BaseCdkCell = /** @class */ (function () {
        function BaseCdkCell(columnDef, elementRef) {
            var /** @type {?} */ columnClassName = "cdk-column-" + columnDef.cssClassFriendlyName;
            elementRef.nativeElement.classList.add(columnClassName);
        }
        return BaseCdkCell;
    }());
    /**
     * Header cell template container that adds the right classes and role.
     */
    var CdkHeaderCell = /** @class */ (function (_super) {
        __extends(CdkHeaderCell, _super);
        function CdkHeaderCell(columnDef, elementRef) {
            return _super.call(this, columnDef, elementRef) || this;
        }
        CdkHeaderCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-header-cell, th[cdk-header-cell]',
                        host: {
                            'class': 'cdk-header-cell',
                            'role': 'columnheader',
                        },
                    },] },
        ];
        /** @nocollapse */
        CdkHeaderCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return CdkHeaderCell;
    }(BaseCdkCell));
    /**
     * Footer cell template container that adds the right classes and role.
     */
    var CdkFooterCell = /** @class */ (function (_super) {
        __extends(CdkFooterCell, _super);
        function CdkFooterCell(columnDef, elementRef) {
            return _super.call(this, columnDef, elementRef) || this;
        }
        CdkFooterCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-footer-cell, td[cdk-footer-cell]',
                        host: {
                            'class': 'cdk-footer-cell',
                            'role': 'gridcell',
                        },
                    },] },
        ];
        /** @nocollapse */
        CdkFooterCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return CdkFooterCell;
    }(BaseCdkCell));
    /**
     * Cell template container that adds the right classes and role.
     */
    var CdkCell = /** @class */ (function (_super) {
        __extends(CdkCell, _super);
        function CdkCell(columnDef, elementRef) {
            return _super.call(this, columnDef, elementRef) || this;
        }
        CdkCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-cell, td[cdk-cell]',
                        host: {
                            'class': 'cdk-cell',
                            'role': 'gridcell',
                        },
                    },] },
        ];
        /** @nocollapse */
        CdkCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return CdkCell;
    }(BaseCdkCell));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The row template that can be used by the mat-table. Should not be used outside of the
     * material library.
     */
    var /** @type {?} */ CDK_ROW_TEMPLATE = "<ng-container cdkCellOutlet></ng-container>";
    /**
     * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
     * for changes and notifying the table.
     * @abstract
     */
    var  /**
     * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
     * for changes and notifying the table.
     * @abstract
     */
    BaseRowDef = /** @class */ (function () {
        function BaseRowDef(template, _differs) {
            this.template = template;
            this._differs = _differs;
        }
        /**
         * @param {?} changes
         * @return {?}
         */
        BaseRowDef.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            // Create a new columns differ if one does not yet exist. Initialize it based on initial value
            // of the columns property or an empty array if none is provided.
            if (!this._columnsDiffer) {
                var /** @type {?} */ columns = (changes['columns'] && changes['columns'].currentValue) || [];
                this._columnsDiffer = this._differs.find(columns).create();
                this._columnsDiffer.diff(columns);
            }
        };
        /**
         * Returns the difference between the current columns and the columns from the last diff, or null
         * if there is no difference.
         */
        /**
         * Returns the difference between the current columns and the columns from the last diff, or null
         * if there is no difference.
         * @return {?}
         */
        BaseRowDef.prototype.getColumnsDiff = /**
         * Returns the difference between the current columns and the columns from the last diff, or null
         * if there is no difference.
         * @return {?}
         */
        function () {
            return this._columnsDiffer.diff(this.columns);
        };
        /** Gets this row def's relevant cell template from the provided column def. */
        /**
         * Gets this row def's relevant cell template from the provided column def.
         * @param {?} column
         * @return {?}
         */
        BaseRowDef.prototype.extractCellTemplate = /**
         * Gets this row def's relevant cell template from the provided column def.
         * @param {?} column
         * @return {?}
         */
        function (column) {
            if (this instanceof CdkHeaderRowDef) {
                return column.headerCell.template;
            }
            if (this instanceof CdkFooterRowDef) {
                return column.footerCell.template;
            }
            else {
                return column.cell.template;
            }
        };
        return BaseRowDef;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    CdkHeaderRowDefBase = /** @class */ (function (_super) {
        __extends(CdkHeaderRowDefBase, _super);
        function CdkHeaderRowDefBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return CdkHeaderRowDefBase;
    }(BaseRowDef));
    var /** @type {?} */ _CdkHeaderRowDefBase = mixinHasStickyInput(CdkHeaderRowDefBase);
    /**
     * Header row definition for the CDK table.
     * Captures the header row's template and other header properties such as the columns to display.
     */
    var CdkHeaderRowDef = /** @class */ (function (_super) {
        __extends(CdkHeaderRowDef, _super);
        function CdkHeaderRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
        // Explicitly define it so that the method is called as part of the Angular lifecycle.
        /**
         * @param {?} changes
         * @return {?}
         */
        CdkHeaderRowDef.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            _super.prototype.ngOnChanges.call(this, changes);
        };
        CdkHeaderRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkHeaderRowDef]',
                        inputs: ['columns: cdkHeaderRowDef', 'sticky: cdkHeaderRowDefSticky'],
                    },] },
        ];
        /** @nocollapse */
        CdkHeaderRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return CdkHeaderRowDef;
    }(_CdkHeaderRowDefBase));
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    CdkFooterRowDefBase = /** @class */ (function (_super) {
        __extends(CdkFooterRowDefBase, _super);
        function CdkFooterRowDefBase() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return CdkFooterRowDefBase;
    }(BaseRowDef));
    var /** @type {?} */ _CdkFooterRowDefBase = mixinHasStickyInput(CdkFooterRowDefBase);
    /**
     * Footer row definition for the CDK table.
     * Captures the footer row's template and other footer properties such as the columns to display.
     */
    var CdkFooterRowDef = /** @class */ (function (_super) {
        __extends(CdkFooterRowDef, _super);
        function CdkFooterRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
        // Explicitly define it so that the method is called as part of the Angular lifecycle.
        /**
         * @param {?} changes
         * @return {?}
         */
        CdkFooterRowDef.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            _super.prototype.ngOnChanges.call(this, changes);
        };
        CdkFooterRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkFooterRowDef]',
                        inputs: ['columns: cdkFooterRowDef', 'sticky: cdkFooterRowDefSticky'],
                    },] },
        ];
        /** @nocollapse */
        CdkFooterRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return CdkFooterRowDef;
    }(_CdkFooterRowDefBase));
    /**
     * Data row definition for the CDK table.
     * Captures the header row's template and other row properties such as the columns to display and
     * a when predicate that describes when this row should be used.
     * @template T
     */
    var CdkRowDef = /** @class */ (function (_super) {
        __extends(CdkRowDef, _super);
        // TODO(andrewseguin): Add an input for providing a switch function to determine
        //   if this template should be used.
        function CdkRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        CdkRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkRowDef]',
                        inputs: ['columns: cdkRowDefColumns', 'when: cdkRowDefWhen'],
                    },] },
        ];
        /** @nocollapse */
        CdkRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return CdkRowDef;
    }(BaseRowDef));
    /**
     * Outlet for rendering cells inside of a row or header row.
     * \@docs-private
     */
    var CdkCellOutlet = /** @class */ (function () {
        function CdkCellOutlet(_viewContainer) {
            this._viewContainer = _viewContainer;
            CdkCellOutlet.mostRecentCellOutlet = this;
        }
        /**
         * Static property containing the latest constructed instance of this class.
         * Used by the CDK table when each CdkHeaderRow and CdkRow component is created using
         * createEmbeddedView. After one of these components are created, this property will provide
         * a handle to provide that component's cells and context. After init, the CdkCellOutlet will
         * construct the cells with the provided context.
         */
        CdkCellOutlet.mostRecentCellOutlet = null;
        CdkCellOutlet.decorators = [
            { type: core.Directive, args: [{ selector: '[cdkCellOutlet]' },] },
        ];
        /** @nocollapse */
        CdkCellOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        return CdkCellOutlet;
    }());
    /**
     * Header template container that contains the cell outlet. Adds the right class and role.
     */
    var CdkHeaderRow = /** @class */ (function () {
        function CdkHeaderRow() {
        }
        CdkHeaderRow.decorators = [
            { type: core.Component, args: [{selector: 'cdk-header-row, tr[cdk-header-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'cdk-header-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        return CdkHeaderRow;
    }());
    /**
     * Footer template container that contains the cell outlet. Adds the right class and role.
     */
    var CdkFooterRow = /** @class */ (function () {
        function CdkFooterRow() {
        }
        CdkFooterRow.decorators = [
            { type: core.Component, args: [{selector: 'cdk-footer-row, tr[cdk-footer-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'cdk-footer-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        return CdkFooterRow;
    }());
    /**
     * Data row template container that contains the cell outlet. Adds the right class and role.
     */
    var CdkRow = /** @class */ (function () {
        function CdkRow() {
        }
        CdkRow.decorators = [
            { type: core.Component, args: [{selector: 'cdk-row, tr[cdk-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'cdk-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        return CdkRow;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Returns an error to be thrown when attempting to find an unexisting column.
     * \@docs-private
     * @param {?} id Id whose lookup failed.
     * @return {?}
     */
    function getTableUnknownColumnError(id) {
        return Error("Could not find column with id \"" + id + "\".");
    }
    /**
     * Returns an error to be thrown when two column definitions have the same name.
     * \@docs-private
     * @param {?} name
     * @return {?}
     */
    function getTableDuplicateColumnNameError(name) {
        return Error("Duplicate column definition name provided: \"" + name + "\".");
    }
    /**
     * Returns an error to be thrown when there are multiple rows that are missing a when function.
     * \@docs-private
     * @return {?}
     */
    function getTableMultipleDefaultRowDefsError() {
        return Error("There can only be one default row without a when predicate function.");
    }
    /**
     * Returns an error to be thrown when there are no matching row defs for a particular set of data.
     * \@docs-private
     * @param {?} data
     * @return {?}
     */
    function getTableMissingMatchingRowDefError(data) {
        return Error("Could not find a matching row definition for the" +
            ("provided row data: " + JSON.stringify(data)));
    }
    /**
     * Returns an error to be thrown when there is no row definitions present in the content.
     * \@docs-private
     * @return {?}
     */
    function getTableMissingRowDefsError() {
        return Error('Missing definitions for header, footer, and row; ' +
            'cannot determine which columns should be rendered.');
    }
    /**
     * Returns an error to be thrown when the data source does not match the compatible types.
     * \@docs-private
     * @return {?}
     */
    function getTableUnknownDataSourceError() {
        return Error("Provided data source did not match an array, Observable, or DataSource");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * List of all possible directions that can be used for sticky positioning.
     * \@docs-private
     */
    var /** @type {?} */ STICKY_DIRECTIONS = ['top', 'bottom', 'left', 'right'];
    /**
     * Applies and removes sticky positioning styles to the `CdkTable` rows and columns cells.
     * \@docs-private
     */
    var  /**
     * Applies and removes sticky positioning styles to the `CdkTable` rows and columns cells.
     * \@docs-private
     */
    StickyStyler = /** @class */ (function () {
        /**
         * @param isNativeHtmlTable Whether the sticky logic should be based on a table
         *     that uses the native `<table>` element.
         * @param stickCellCss The CSS class that will be applied to every row/cell that has
         *     sticky positioning applied.
         * @param direction The directionality context of the table (ltr/rtl); affects column positioning
         *     by reversing left/right positions.
         */
        function StickyStyler(isNativeHtmlTable, stickCellCss, direction) {
            this.isNativeHtmlTable = isNativeHtmlTable;
            this.stickCellCss = stickCellCss;
            this.direction = direction;
        }
        /**
         * Clears the sticky positioning styles from the row and its cells by resetting the `position`
         * style, setting the zIndex to 0, and unsetting each provided sticky direction.
         * @param rows The list of rows that should be cleared from sticking in the provided directions
         * @param stickyDirections The directions that should no longer be set as sticky on the rows.
         */
        /**
         * Clears the sticky positioning styles from the row and its cells by resetting the `position`
         * style, setting the zIndex to 0, and unsetting each provided sticky direction.
         * @param {?} rows The list of rows that should be cleared from sticking in the provided directions
         * @param {?} stickyDirections The directions that should no longer be set as sticky on the rows.
         * @return {?}
         */
        StickyStyler.prototype.clearStickyPositioning = /**
         * Clears the sticky positioning styles from the row and its cells by resetting the `position`
         * style, setting the zIndex to 0, and unsetting each provided sticky direction.
         * @param {?} rows The list of rows that should be cleared from sticking in the provided directions
         * @param {?} stickyDirections The directions that should no longer be set as sticky on the rows.
         * @return {?}
         */
        function (rows, stickyDirections) {
            for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                var row = rows_1[_i];
                this._removeStickyStyle(row, stickyDirections);
                for (var /** @type {?} */ i = 0; i < row.children.length; i++) {
                    var /** @type {?} */ cell = /** @type {?} */ (row.children[i]);
                    this._removeStickyStyle(cell, stickyDirections);
                }
            }
        };
        /**
         * Applies sticky left and right positions to the cells of each row according to the sticky
         * states of the rendered column definitions.
         * @param rows The rows that should have its set of cells stuck according to the sticky states.
         * @param stickyStartStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the start of the row.
         * @param stickyEndStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the end of the row.
         */
        /**
         * Applies sticky left and right positions to the cells of each row according to the sticky
         * states of the rendered column definitions.
         * @param {?} rows The rows that should have its set of cells stuck according to the sticky states.
         * @param {?} stickyStartStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the start of the row.
         * @param {?} stickyEndStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the end of the row.
         * @return {?}
         */
        StickyStyler.prototype.updateStickyColumns = /**
         * Applies sticky left and right positions to the cells of each row according to the sticky
         * states of the rendered column definitions.
         * @param {?} rows The rows that should have its set of cells stuck according to the sticky states.
         * @param {?} stickyStartStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the start of the row.
         * @param {?} stickyEndStates A list of boolean states where each state represents whether the cell
         *     in this index position should be stuck to the end of the row.
         * @return {?}
         */
        function (rows, stickyStartStates, stickyEndStates) {
            var /** @type {?} */ hasStickyColumns = stickyStartStates.some(function (state) { return state; }) || stickyEndStates.some(function (state) { return state; });
            if (!rows.length || !hasStickyColumns) {
                return;
            }
            var /** @type {?} */ firstRow = rows[0];
            var /** @type {?} */ numCells = firstRow.children.length;
            var /** @type {?} */ cellWidths = this._getCellWidths(firstRow);
            var /** @type {?} */ startPositions = this._getStickyStartColumnPositions(cellWidths, stickyStartStates);
            var /** @type {?} */ endPositions = this._getStickyEndColumnPositions(cellWidths, stickyEndStates);
            var /** @type {?} */ isRtl = this.direction === 'rtl';
            for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
                var row = rows_2[_i];
                for (var /** @type {?} */ i = 0; i < numCells; i++) {
                    var /** @type {?} */ cell = /** @type {?} */ (row.children[i]);
                    if (stickyStartStates[i]) {
                        this._addStickyStyle(cell, isRtl ? 'right' : 'left', startPositions[i]);
                    }
                    if (stickyEndStates[i]) {
                        this._addStickyStyle(cell, isRtl ? 'left' : 'right', endPositions[i]);
                    }
                }
            }
        };
        /**
         * Applies sticky positioning to the row's cells if using the native table layout, and to the
         * row itself otherwise.
         * @param rowsToStick The list of rows that should be stuck according to their corresponding
         *     sticky state and to the provided top or bottom position.
         * @param stickyStates A list of boolean states where each state represents whether the row
         *     should be stuck in the particular top or bottom position.
         * @param position The position direction in which the row should be stuck if that row should be
         *     sticky.
         *
         */
        /**
         * Applies sticky positioning to the row's cells if using the native table layout, and to the
         * row itself otherwise.
         * @param {?} rowsToStick The list of rows that should be stuck according to their corresponding
         *     sticky state and to the provided top or bottom position.
         * @param {?} stickyStates A list of boolean states where each state represents whether the row
         *     should be stuck in the particular top or bottom position.
         * @param {?} position The position direction in which the row should be stuck if that row should be
         *     sticky.
         *
         * @return {?}
         */
        StickyStyler.prototype.stickRows = /**
         * Applies sticky positioning to the row's cells if using the native table layout, and to the
         * row itself otherwise.
         * @param {?} rowsToStick The list of rows that should be stuck according to their corresponding
         *     sticky state and to the provided top or bottom position.
         * @param {?} stickyStates A list of boolean states where each state represents whether the row
         *     should be stuck in the particular top or bottom position.
         * @param {?} position The position direction in which the row should be stuck if that row should be
         *     sticky.
         *
         * @return {?}
         */
        function (rowsToStick, stickyStates, position) {
            // If positioning the rows to the bottom, reverse their order when evaluating the sticky
            // position such that the last row stuck will be "bottom: 0px" and so on.
            var /** @type {?} */ rows = position === 'bottom' ? rowsToStick.reverse() : rowsToStick;
            var /** @type {?} */ stickyHeight = 0;
            for (var /** @type {?} */ rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                if (!stickyStates[rowIndex]) {
                    continue;
                }
                var /** @type {?} */ row = rows[rowIndex];
                if (this.isNativeHtmlTable) {
                    for (var /** @type {?} */ j = 0; j < row.children.length; j++) {
                        var /** @type {?} */ cell = /** @type {?} */ (row.children[j]);
                        this._addStickyStyle(cell, position, stickyHeight);
                    }
                }
                else {
                    // Flex does not respect the stick positioning on the cells, needs to be applied to the row.
                    // If this is applied on a native table, Safari causes the header to fly in wrong direction.
                    this._addStickyStyle(row, position, stickyHeight);
                }
                stickyHeight += row.getBoundingClientRect().height;
            }
        };
        /**
         * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
         * footer rows is to apply sticky styling to the tfoot container. This should only be done if
         * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
         * the tfoot element.
         */
        /**
         * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
         * footer rows is to apply sticky styling to the tfoot container. This should only be done if
         * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
         * the tfoot element.
         * @param {?} tableElement
         * @param {?} stickyStates
         * @return {?}
         */
        StickyStyler.prototype.updateStickyFooterContainer = /**
         * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
         * footer rows is to apply sticky styling to the tfoot container. This should only be done if
         * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
         * the tfoot element.
         * @param {?} tableElement
         * @param {?} stickyStates
         * @return {?}
         */
        function (tableElement, stickyStates) {
            if (!this.isNativeHtmlTable) {
                return;
            }
            var /** @type {?} */ tfoot = /** @type {?} */ ((tableElement.querySelector('tfoot')));
            if (stickyStates.some(function (state) { return !state; })) {
                this._removeStickyStyle(tfoot, ['bottom']);
            }
            else {
                this._addStickyStyle(tfoot, 'bottom', 0);
            }
        };
        /**
         * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
         * the zIndex, removing each of the provided sticky directions, and removing the
         * sticky position if there are no more directions.
         */
        /**
         * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
         * the zIndex, removing each of the provided sticky directions, and removing the
         * sticky position if there are no more directions.
         * @param {?} element
         * @param {?} stickyDirections
         * @return {?}
         */
        StickyStyler.prototype._removeStickyStyle = /**
         * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
         * the zIndex, removing each of the provided sticky directions, and removing the
         * sticky position if there are no more directions.
         * @param {?} element
         * @param {?} stickyDirections
         * @return {?}
         */
        function (element, stickyDirections) {
            for (var _i = 0, stickyDirections_1 = stickyDirections; _i < stickyDirections_1.length; _i++) {
                var dir = stickyDirections_1[_i];
                element.style[dir] = '';
            }
            element.style.zIndex = this._getCalculatedZIndex(element);
            // If the element no longer has any more sticky directions, remove sticky positioning and
            // the sticky CSS class.
            var /** @type {?} */ hasDirection = STICKY_DIRECTIONS.some(function (dir) { return !!element.style[dir]; });
            if (!hasDirection) {
                element.style.position = '';
                element.classList.remove(this.stickCellCss);
            }
        };
        /**
         * Adds the sticky styling to the element by adding the sticky style class, changing position
         * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
         * direction and value.
         */
        /**
         * Adds the sticky styling to the element by adding the sticky style class, changing position
         * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
         * direction and value.
         * @param {?} element
         * @param {?} dir
         * @param {?} dirValue
         * @return {?}
         */
        StickyStyler.prototype._addStickyStyle = /**
         * Adds the sticky styling to the element by adding the sticky style class, changing position
         * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
         * direction and value.
         * @param {?} element
         * @param {?} dir
         * @param {?} dirValue
         * @return {?}
         */
        function (element, dir, dirValue) {
            element.classList.add(this.stickCellCss);
            element.style[dir] = dirValue + "px";
            element.style.cssText += 'position: -webkit-sticky; position: sticky; ';
            element.style.zIndex = this._getCalculatedZIndex(element);
        };
        /**
         * Calculate what the z-index should be for the element, depending on what directions (top,
         * bottom, left, right) have been set. It should be true that elements with a top direction
         * should have the highest index since these are elements like a table header. If any of those
         * elements are also sticky in another direction, then they should appear above other elements
         * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
         * (e.g. footer rows) should then be next in the ordering such that they are below the header
         * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
         * should minimally increment so that they are above non-sticky elements but below top and bottom
         * elements.
         */
        /**
         * Calculate what the z-index should be for the element, depending on what directions (top,
         * bottom, left, right) have been set. It should be true that elements with a top direction
         * should have the highest index since these are elements like a table header. If any of those
         * elements are also sticky in another direction, then they should appear above other elements
         * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
         * (e.g. footer rows) should then be next in the ordering such that they are below the header
         * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
         * should minimally increment so that they are above non-sticky elements but below top and bottom
         * elements.
         * @param {?} element
         * @return {?}
         */
        StickyStyler.prototype._getCalculatedZIndex = /**
         * Calculate what the z-index should be for the element, depending on what directions (top,
         * bottom, left, right) have been set. It should be true that elements with a top direction
         * should have the highest index since these are elements like a table header. If any of those
         * elements are also sticky in another direction, then they should appear above other elements
         * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
         * (e.g. footer rows) should then be next in the ordering such that they are below the header
         * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
         * should minimally increment so that they are above non-sticky elements but below top and bottom
         * elements.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ zIndexIncrements = {
                top: 100,
                bottom: 10,
                left: 1,
                right: 1,
            };
            var /** @type {?} */ zIndex = 0;
            for (var _i = 0, STICKY_DIRECTIONS_1 = STICKY_DIRECTIONS; _i < STICKY_DIRECTIONS_1.length; _i++) {
                var dir = STICKY_DIRECTIONS_1[_i];
                if (element.style[dir]) {
                    zIndex += zIndexIncrements[dir];
                }
            }
            return zIndex ? "" + zIndex : '';
        };
        /** Gets the widths for each cell in the provided row. */
        /**
         * Gets the widths for each cell in the provided row.
         * @param {?} row
         * @return {?}
         */
        StickyStyler.prototype._getCellWidths = /**
         * Gets the widths for each cell in the provided row.
         * @param {?} row
         * @return {?}
         */
        function (row) {
            var /** @type {?} */ cellWidths = [];
            var /** @type {?} */ firstRowCells = row.children;
            for (var /** @type {?} */ i = 0; i < firstRowCells.length; i++) {
                var /** @type {?} */ cell = /** @type {?} */ (firstRowCells[i]);
                cellWidths.push(cell.getBoundingClientRect().width);
            }
            return cellWidths;
        };
        /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         */
        /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         * @param {?} widths
         * @param {?} stickyStates
         * @return {?}
         */
        StickyStyler.prototype._getStickyStartColumnPositions = /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         * @param {?} widths
         * @param {?} stickyStates
         * @return {?}
         */
        function (widths, stickyStates) {
            var /** @type {?} */ positions = [];
            var /** @type {?} */ nextPosition = 0;
            for (var /** @type {?} */ i = 0; i < widths.length; i++) {
                if (stickyStates[i]) {
                    positions[i] = nextPosition;
                    nextPosition += widths[i];
                }
            }
            return positions;
        };
        /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         */
        /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         * @param {?} widths
         * @param {?} stickyStates
         * @return {?}
         */
        StickyStyler.prototype._getStickyEndColumnPositions = /**
         * Determines the left and right positions of each sticky column cell, which will be the
         * accumulation of all sticky column cell widths to the left and right, respectively.
         * Non-sticky cells do not need to have a value set since their positions will not be applied.
         * @param {?} widths
         * @param {?} stickyStates
         * @return {?}
         */
        function (widths, stickyStates) {
            var /** @type {?} */ positions = [];
            var /** @type {?} */ nextPosition = 0;
            for (var /** @type {?} */ i = widths.length; i > 0; i--) {
                if (stickyStates[i]) {
                    positions[i] = nextPosition;
                    nextPosition += widths[i];
                }
            }
            return positions;
        };
        return StickyStyler;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Provides a handle for the table to grab the view container's ng-container to insert data rows.
     * \@docs-private
     */
    var DataRowOutlet = /** @class */ (function () {
        function DataRowOutlet(viewContainer, elementRef) {
            this.viewContainer = viewContainer;
            this.elementRef = elementRef;
        }
        DataRowOutlet.decorators = [
            { type: core.Directive, args: [{ selector: '[rowOutlet]' },] },
        ];
        /** @nocollapse */
        DataRowOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
            { type: core.ElementRef, },
        ]; };
        return DataRowOutlet;
    }());
    /**
     * Provides a handle for the table to grab the view container's ng-container to insert the header.
     * \@docs-private
     */
    var HeaderRowOutlet = /** @class */ (function () {
        function HeaderRowOutlet(viewContainer, elementRef) {
            this.viewContainer = viewContainer;
            this.elementRef = elementRef;
        }
        HeaderRowOutlet.decorators = [
            { type: core.Directive, args: [{ selector: '[headerRowOutlet]' },] },
        ];
        /** @nocollapse */
        HeaderRowOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
            { type: core.ElementRef, },
        ]; };
        return HeaderRowOutlet;
    }());
    /**
     * Provides a handle for the table to grab the view container's ng-container to insert the footer.
     * \@docs-private
     */
    var FooterRowOutlet = /** @class */ (function () {
        function FooterRowOutlet(viewContainer, elementRef) {
            this.viewContainer = viewContainer;
            this.elementRef = elementRef;
        }
        FooterRowOutlet.decorators = [
            { type: core.Directive, args: [{ selector: '[footerRowOutlet]' },] },
        ];
        /** @nocollapse */
        FooterRowOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
            { type: core.ElementRef, },
        ]; };
        return FooterRowOutlet;
    }());
    /**
     * The table template that can be used by the mat-table. Should not be used outside of the
     * material library.
     * \@docs-private
     */
    var /** @type {?} */ CDK_TABLE_TEMPLATE = "\n  <ng-container headerRowOutlet></ng-container>\n  <ng-container rowOutlet></ng-container>\n  <ng-container footerRowOutlet></ng-container>";
    /**
     * Class used to conveniently type the embedded view ref for rows with a context.
     * \@docs-private
     * @abstract
     * @template T
     */
    var /**
     * Class used to conveniently type the embedded view ref for rows with a context.
     * \@docs-private
     * @abstract
     * @template T
     */
    RowViewRef = /** @class */ (function (_super) {
        __extends(RowViewRef, _super);
        function RowViewRef() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return RowViewRef;
    }(core.EmbeddedViewRef));
    /**
     * A data table that can render a header row, data rows, and a footer row.
     * Uses the dataSource input to determine the data to be rendered. The data can be provided either
     * as a data array, an Observable stream that emits the data array to render, or a DataSource with a
     * connect function that will return an Observable stream that emits the data array to render.
     * @template T
     */
    var CdkTable = /** @class */ (function () {
        function CdkTable(_differs, _changeDetectorRef, _elementRef, role, _dir) {
            this._differs = _differs;
            this._changeDetectorRef = _changeDetectorRef;
            this._elementRef = _elementRef;
            this._dir = _dir;
            /**
             * Subject that emits when the component has been destroyed.
             */
            this._onDestroy = new rxjs.Subject();
            /**
             * Map of all the user's defined columns (header, data, and footer cell template) identified by
             * name. Collection populated by the column definitions gathered by `ContentChildren` as well as
             * any custom column definitions added to `_customColumnDefs`.
             */
            this._columnDefsByName = new Map();
            /**
             * Column definitions that were defined outside of the direct content children of the table.
             * These will be defined when, e.g., creating a wrapper around the cdkTable that has
             * column definitions as *it's* content child.
             */
            this._customColumnDefs = new Set();
            /**
             * Data row definitions that were defined outside of the direct content children of the table.
             * These will be defined when, e.g., creating a wrapper around the cdkTable that has
             * built-in data rows as *it's* content child.
             */
            this._customRowDefs = new Set();
            /**
             * Header row definitions that were defined outside of the direct content children of the table.
             * These will be defined when, e.g., creating a wrapper around the cdkTable that has
             * built-in header rows as *it's* content child.
             */
            this._customHeaderRowDefs = new Set();
            /**
             * Footer row definitions that were defined outside of the direct content children of the table.
             * These will be defined when, e.g., creating a wrapper around the cdkTable that has a
             * built-in footer row as *it's* content child.
             */
            this._customFooterRowDefs = new Set();
            /**
             * Whether the header row definition has been changed. Triggers an update to the header row after
             * content is checked. Initialized as true so that the table renders the initial set of rows.
             */
            this._headerRowDefChanged = true;
            /**
             * Whether the footer row definition has been changed. Triggers an update to the footer row after
             * content is checked. Initialized as true so that the table renders the initial set of rows.
             */
            this._footerRowDefChanged = true;
            /**
             * Cache of the latest rendered `RenderRow` objects as a map for easy retrieval when constructing
             * a new list of `RenderRow` objects for rendering rows. Since the new list is constructed with
             * the cached `RenderRow` objects when possible, the row identity is preserved when the data
             * and row template matches, which allows the `IterableDiffer` to check rows by reference
             * and understand which rows are added/moved/removed.
             *
             * Implemented as a map of maps where the first key is the `data: T` object and the second is the
             * `CdkRowDef<T>` object. With the two keys, the cache points to a `RenderRow<T>` object that
             * contains an array of created pairs. The array is necessary to handle cases where the data
             * array contains multiple duplicate data objects and each instantiated `RenderRow` must be
             * stored.
             */
            this._cachedRenderRowsMap = new Map();
            /**
             * CSS class added to any row or cell that has sticky positioning applied. May be overriden by
             * table subclasses.
             */
            this.stickyCssClass = 'cdk-table-sticky';
            this._multiTemplateDataRows = false;
            /**
             * Stream containing the latest information on what rows are being displayed on screen.
             * Can be used by the data source to as a heuristic of what data should be provided.
             */
            this.viewChange = new rxjs.BehaviorSubject({ start: 0, end: Number.MAX_VALUE });
            if (!role) {
                this._elementRef.nativeElement.setAttribute('role', 'grid');
            }
            this._isNativeHtmlTable = this._elementRef.nativeElement.nodeName === 'TABLE';
        }
        Object.defineProperty(CdkTable.prototype, "trackBy", {
            get: /**
             * Tracking function that will be used to check the differences in data changes. Used similarly
             * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
             * relative to the function to know if a row should be added/removed/moved.
             * Accepts a function that takes two parameters, `index` and `item`.
             * @return {?}
             */
            function () { return this._trackByFn; },
            set: /**
             * @param {?} fn
             * @return {?}
             */
            function (fn) {
                if (core.isDevMode() &&
                    fn != null && typeof fn !== 'function' && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
                    console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ".");
                }
                this._trackByFn = fn;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTable.prototype, "dataSource", {
            get: /**
             * The table's source of data, which can be provided in three ways (in order of complexity):
             *   - Simple data array (each object represents one table row)
             *   - Stream that emits a data array each time the array changes
             *   - `DataSource` object that implements the connect/disconnect interface.
             *
             * If a data array is provided, the table must be notified when the array's objects are
             * added, removed, or moved. This can be done by calling the `renderRows()` function which will
             * render the diff since the last table render. If the data array reference is changed, the table
             * will automatically trigger an update to the rows.
             *
             * When providing an Observable stream, the table will trigger an update automatically when the
             * stream emits a new array of data.
             *
             * Finally, when providing a `DataSource` object, the table will use the Observable stream
             * provided by the connect function and trigger updates when that stream emits new data array
             * values. During the table's ngOnDestroy or when the data source is removed from the table, the
             * table will call the DataSource's `disconnect` function (may be useful for cleaning up any
             * subscriptions registered during the connect process).
             * @return {?}
             */
            function () { return this._dataSource; },
            set: /**
             * @param {?} dataSource
             * @return {?}
             */
            function (dataSource) {
                if (this._dataSource !== dataSource) {
                    this._switchDataSource(dataSource);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTable.prototype, "multiTemplateDataRows", {
            get: /**
             * Whether to allow multiple rows per data object by evaluating which rows evaluate their 'when'
             * predicate to true. If `multiTemplateDataRows` is false, which is the default value, then each
             * dataobject will render the first row that evaluates its when predicate to true, in the order
             * defined in the table, or otherwise the default row which does not have a when predicate.
             * @return {?}
             */
            function () { return this._multiTemplateDataRows; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._multiTemplateDataRows = coerceBooleanProperty(v);
                if (this._rowOutlet.viewContainer.length) {
                    this._forceRenderDataRows();
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkTable.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._setupStickyStyler();
            if (this._isNativeHtmlTable) {
                this._applyNativeTableSections();
            }
            // Set up the trackBy function so that it uses the `RenderRow` as its identity by default. If
            // the user has provided a custom trackBy, return the result of that function as evaluated
            // with the values of the `RenderRow`'s data and index.
            this._dataDiffer = this._differs.find([]).create(function (_i, dataRow) {
                return _this.trackBy ? _this.trackBy(dataRow.dataIndex, dataRow.data) : dataRow;
            });
        };
        /**
         * @return {?}
         */
        CdkTable.prototype.ngAfterContentChecked = /**
         * @return {?}
         */
        function () {
            // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
            this._cacheRowDefs();
            this._cacheColumnDefs();
            // Make sure that the user has at least added header, footer, or data row def.
            if (!this._headerRowDefs.length && !this._footerRowDefs.length && !this._rowDefs.length) {
                throw getTableMissingRowDefsError();
            }
            // Render updates if the list of columns have been changed for the header, row, or footer defs.
            this._renderUpdatedColumns();
            // If the header row definition has been changed, trigger a render to the header row.
            if (this._headerRowDefChanged) {
                this._forceRenderHeaderRows();
                this._headerRowDefChanged = false;
            }
            // If the footer row definition has been changed, trigger a render to the footer row.
            if (this._footerRowDefChanged) {
                this._forceRenderFooterRows();
                this._footerRowDefChanged = false;
            }
            // If there is a data source and row definitions, connect to the data source unless a
            // connection has already been made.
            if (this.dataSource && this._rowDefs.length > 0 && !this._renderChangeSubscription) {
                this._observeRenderChanges();
            }
            this._checkStickyStates();
        };
        /**
         * @return {?}
         */
        CdkTable.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._rowOutlet.viewContainer.clear();
            this._headerRowOutlet.viewContainer.clear();
            this._footerRowOutlet.viewContainer.clear();
            this._cachedRenderRowsMap.clear();
            this._onDestroy.next();
            this._onDestroy.complete();
            if (this.dataSource instanceof DataSource) {
                this.dataSource.disconnect(this);
            }
        };
        /**
         * Renders rows based on the table's latest set of data, which was either provided directly as an
         * input or retrieved through an Observable stream (directly or from a DataSource).
         * Checks for differences in the data since the last diff to perform only the necessary
         * changes (add/remove/move rows).
         *
         * If the table's data source is a DataSource or Observable, this will be invoked automatically
         * each time the provided Observable stream emits a new data array. Otherwise if your data is
         * an array, this function will need to be called to render any changes.
         */
        /**
         * Renders rows based on the table's latest set of data, which was either provided directly as an
         * input or retrieved through an Observable stream (directly or from a DataSource).
         * Checks for differences in the data since the last diff to perform only the necessary
         * changes (add/remove/move rows).
         *
         * If the table's data source is a DataSource or Observable, this will be invoked automatically
         * each time the provided Observable stream emits a new data array. Otherwise if your data is
         * an array, this function will need to be called to render any changes.
         * @return {?}
         */
        CdkTable.prototype.renderRows = /**
         * Renders rows based on the table's latest set of data, which was either provided directly as an
         * input or retrieved through an Observable stream (directly or from a DataSource).
         * Checks for differences in the data since the last diff to perform only the necessary
         * changes (add/remove/move rows).
         *
         * If the table's data source is a DataSource or Observable, this will be invoked automatically
         * each time the provided Observable stream emits a new data array. Otherwise if your data is
         * an array, this function will need to be called to render any changes.
         * @return {?}
         */
        function () {
            var _this = this;
            this._renderRows = this._getAllRenderRows();
            var /** @type {?} */ changes = this._dataDiffer.diff(this._renderRows);
            if (!changes) {
                return;
            }
            var /** @type {?} */ viewContainer = this._rowOutlet.viewContainer;
            changes.forEachOperation(function (record, prevIndex, currentIndex) {
                if (record.previousIndex == null) {
                    _this._insertRow(record.item, currentIndex);
                }
                else if (currentIndex == null) {
                    viewContainer.remove(prevIndex);
                }
                else {
                    var /** @type {?} */ view = /** @type {?} */ (viewContainer.get(prevIndex));
                    viewContainer.move(/** @type {?} */ ((view)), currentIndex);
                }
            });
            // Update the meta context of a row's context data (index, count, first, last, ...)
            this._updateRowIndexContext();
            // Update rows that did not get added/removed/moved but may have had their identity changed,
            // e.g. if trackBy matched data on some property but the actual data reference changed.
            changes.forEachIdentityChange(function (record) {
                var /** @type {?} */ rowView = /** @type {?} */ (viewContainer.get(/** @type {?} */ ((record.currentIndex))));
                rowView.context.$implicit = record.item.data;
            });
            this.updateStickyColumnStyles();
        };
        /**
         * Sets the header row definition to be used. Overrides the header row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
         * table's content is checked.
         * @docs-private
         * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
         * @deletion-target 8.0.0
         */
        /**
         * Sets the header row definition to be used. Overrides the header row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
         * table's content is checked.
         * \@docs-private
         * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
         * \@deletion-target 8.0.0
         * @param {?} headerRowDef
         * @return {?}
         */
        CdkTable.prototype.setHeaderRowDef = /**
         * Sets the header row definition to be used. Overrides the header row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
         * table's content is checked.
         * \@docs-private
         * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
         * \@deletion-target 8.0.0
         * @param {?} headerRowDef
         * @return {?}
         */
        function (headerRowDef) {
            this._customHeaderRowDefs = new Set([headerRowDef]);
            this._headerRowDefChanged = true;
        };
        /**
         * Sets the footer row definition to be used. Overrides the footer row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
         * table's content is checked.
         * @docs-private
         * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
         * @deletion-target 8.0.0
         */
        /**
         * Sets the footer row definition to be used. Overrides the footer row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
         * table's content is checked.
         * \@docs-private
         * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
         * \@deletion-target 8.0.0
         * @param {?} footerRowDef
         * @return {?}
         */
        CdkTable.prototype.setFooterRowDef = /**
         * Sets the footer row definition to be used. Overrides the footer row definition gathered by
         * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
         * table's content is checked.
         * \@docs-private
         * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
         * \@deletion-target 8.0.0
         * @param {?} footerRowDef
         * @return {?}
         */
        function (footerRowDef) {
            this._customFooterRowDefs = new Set([footerRowDef]);
            this._footerRowDefChanged = true;
        };
        /** Adds a column definition that was not included as part of the content children. */
        /**
         * Adds a column definition that was not included as part of the content children.
         * @param {?} columnDef
         * @return {?}
         */
        CdkTable.prototype.addColumnDef = /**
         * Adds a column definition that was not included as part of the content children.
         * @param {?} columnDef
         * @return {?}
         */
        function (columnDef) {
            this._customColumnDefs.add(columnDef);
        };
        /** Removes a column definition that was not included as part of the content children. */
        /**
         * Removes a column definition that was not included as part of the content children.
         * @param {?} columnDef
         * @return {?}
         */
        CdkTable.prototype.removeColumnDef = /**
         * Removes a column definition that was not included as part of the content children.
         * @param {?} columnDef
         * @return {?}
         */
        function (columnDef) {
            this._customColumnDefs.delete(columnDef);
        };
        /** Adds a row definition that was not included as part of the content children. */
        /**
         * Adds a row definition that was not included as part of the content children.
         * @param {?} rowDef
         * @return {?}
         */
        CdkTable.prototype.addRowDef = /**
         * Adds a row definition that was not included as part of the content children.
         * @param {?} rowDef
         * @return {?}
         */
        function (rowDef) {
            this._customRowDefs.add(rowDef);
        };
        /** Removes a row definition that was not included as part of the content children. */
        /**
         * Removes a row definition that was not included as part of the content children.
         * @param {?} rowDef
         * @return {?}
         */
        CdkTable.prototype.removeRowDef = /**
         * Removes a row definition that was not included as part of the content children.
         * @param {?} rowDef
         * @return {?}
         */
        function (rowDef) {
            this._customRowDefs.delete(rowDef);
        };
        /** Adds a header row definition that was not included as part of the content children. */
        /**
         * Adds a header row definition that was not included as part of the content children.
         * @param {?} headerRowDef
         * @return {?}
         */
        CdkTable.prototype.addHeaderRowDef = /**
         * Adds a header row definition that was not included as part of the content children.
         * @param {?} headerRowDef
         * @return {?}
         */
        function (headerRowDef) {
            this._customHeaderRowDefs.add(headerRowDef);
            this._headerRowDefChanged = true;
        };
        /** Removes a header row definition that was not included as part of the content children. */
        /**
         * Removes a header row definition that was not included as part of the content children.
         * @param {?} headerRowDef
         * @return {?}
         */
        CdkTable.prototype.removeHeaderRowDef = /**
         * Removes a header row definition that was not included as part of the content children.
         * @param {?} headerRowDef
         * @return {?}
         */
        function (headerRowDef) {
            this._customHeaderRowDefs.delete(headerRowDef);
            this._headerRowDefChanged = true;
        };
        /** Adds a footer row definition that was not included as part of the content children. */
        /**
         * Adds a footer row definition that was not included as part of the content children.
         * @param {?} footerRowDef
         * @return {?}
         */
        CdkTable.prototype.addFooterRowDef = /**
         * Adds a footer row definition that was not included as part of the content children.
         * @param {?} footerRowDef
         * @return {?}
         */
        function (footerRowDef) {
            this._customFooterRowDefs.add(footerRowDef);
            this._footerRowDefChanged = true;
        };
        /** Removes a footer row definition that was not included as part of the content children. */
        /**
         * Removes a footer row definition that was not included as part of the content children.
         * @param {?} footerRowDef
         * @return {?}
         */
        CdkTable.prototype.removeFooterRowDef = /**
         * Removes a footer row definition that was not included as part of the content children.
         * @param {?} footerRowDef
         * @return {?}
         */
        function (footerRowDef) {
            this._customFooterRowDefs.delete(footerRowDef);
            this._footerRowDefChanged = true;
        };
        /**
         * Updates the header sticky styles. First resets all applied styles with respect to the cells
         * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
         * automatically called when the header row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         */
        /**
         * Updates the header sticky styles. First resets all applied styles with respect to the cells
         * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
         * automatically called when the header row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         * @return {?}
         */
        CdkTable.prototype.updateStickyHeaderRowStyles = /**
         * Updates the header sticky styles. First resets all applied styles with respect to the cells
         * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
         * automatically called when the header row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         * @return {?}
         */
        function () {
            var /** @type {?} */ headerRows = this._getRenderedRows(this._headerRowOutlet);
            this._stickyStyler.clearStickyPositioning(headerRows, ['top']);
            var /** @type {?} */ stickyStates = this._headerRowDefs.map(function (def) { return def.sticky; });
            this._stickyStyler.stickRows(headerRows, stickyStates, 'top');
            // Reset the dirty state of the sticky input change since it has been used.
            this._headerRowDefs.forEach(function (def) { return def.resetStickyChanged(); });
        };
        /**
         * Updates the footer sticky styles. First resets all applied styles with respect to the cells
         * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
         * automatically called when the footer row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         */
        /**
         * Updates the footer sticky styles. First resets all applied styles with respect to the cells
         * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
         * automatically called when the footer row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         * @return {?}
         */
        CdkTable.prototype.updateStickyFooterRowStyles = /**
         * Updates the footer sticky styles. First resets all applied styles with respect to the cells
         * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
         * automatically called when the footer row changes its displayed set of columns, or if its
         * sticky input changes. May be called manually for cases where the cell content changes outside
         * of these events.
         * @return {?}
         */
        function () {
            var /** @type {?} */ footerRows = this._getRenderedRows(this._footerRowOutlet);
            this._stickyStyler.clearStickyPositioning(footerRows, ['bottom']);
            var /** @type {?} */ stickyStates = this._footerRowDefs.map(function (def) { return def.sticky; });
            this._stickyStyler.stickRows(footerRows, stickyStates, 'bottom');
            this._stickyStyler.updateStickyFooterContainer(this._elementRef.nativeElement, stickyStates);
            // Reset the dirty state of the sticky input change since it has been used.
            this._footerRowDefs.forEach(function (def) { return def.resetStickyChanged(); });
        };
        /**
         * Updates the column sticky styles. First resets all applied styles with respect to the cells
         * sticking to the left and right. Then sticky styles are added for the left and right according
         * to the column definitions for each cell in each row. This is automatically called when
         * the data source provides a new set of data or when a column definition changes its sticky
         * input. May be called manually for cases where the cell content changes outside of these events.
         */
        /**
         * Updates the column sticky styles. First resets all applied styles with respect to the cells
         * sticking to the left and right. Then sticky styles are added for the left and right according
         * to the column definitions for each cell in each row. This is automatically called when
         * the data source provides a new set of data or when a column definition changes its sticky
         * input. May be called manually for cases where the cell content changes outside of these events.
         * @return {?}
         */
        CdkTable.prototype.updateStickyColumnStyles = /**
         * Updates the column sticky styles. First resets all applied styles with respect to the cells
         * sticking to the left and right. Then sticky styles are added for the left and right according
         * to the column definitions for each cell in each row. This is automatically called when
         * the data source provides a new set of data or when a column definition changes its sticky
         * input. May be called manually for cases where the cell content changes outside of these events.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ headerRows = this._getRenderedRows(this._headerRowOutlet);
            var /** @type {?} */ dataRows = this._getRenderedRows(this._rowOutlet);
            var /** @type {?} */ footerRows = this._getRenderedRows(this._footerRowOutlet);
            // Clear the left and right positioning from all columns in the table across all rows since
            // sticky columns span across all table sections (header, data, footer)
            this._stickyStyler.clearStickyPositioning(headerRows.concat(dataRows, footerRows), ['left', 'right']);
            // Update the sticky styles for each header row depending on the def's sticky state
            headerRows.forEach(function (headerRow, i) {
                _this._addStickyColumnStyles([headerRow], _this._headerRowDefs[i]);
            });
            // Update the sticky styles for each data row depending on its def's sticky state
            this._rowDefs.forEach(function (rowDef) {
                // Collect all the rows rendered with this row definition.
                var /** @type {?} */ rows = [];
                for (var /** @type {?} */ i = 0; i < dataRows.length; i++) {
                    if (_this._renderRows[i].rowDef === rowDef) {
                        rows.push(dataRows[i]);
                    }
                }
                _this._addStickyColumnStyles(rows, rowDef);
            });
            // Update the sticky styles for each footer row depending on the def's sticky state
            footerRows.forEach(function (footerRow, i) {
                _this._addStickyColumnStyles([footerRow], _this._footerRowDefs[i]);
            });
            // Reset the dirty state of the sticky input change since it has been used.
            Array.from(this._columnDefsByName.values()).forEach(function (def) { return def.resetStickyChanged(); });
        };
        /**
         * Get the list of RenderRow objects to render according to the current list of data and defined
         * row definitions. If the previous list already contained a particular pair, it should be reused
         * so that the differ equates their references.
         * @return {?}
         */
        CdkTable.prototype._getAllRenderRows = /**
         * Get the list of RenderRow objects to render according to the current list of data and defined
         * row definitions. If the previous list already contained a particular pair, it should be reused
         * so that the differ equates their references.
         * @return {?}
         */
        function () {
            var /** @type {?} */ renderRows = [];
            // Store the cache and create a new one. Any re-used RenderRow objects will be moved into the
            // new cache while unused ones can be picked up by garbage collection.
            var /** @type {?} */ prevCachedRenderRows = this._cachedRenderRowsMap;
            this._cachedRenderRowsMap = new Map();
            // For each data object, get the list of rows that should be rendered, represented by the
            // respective `RenderRow` object which is the pair of `data` and `CdkRowDef`.
            for (var /** @type {?} */ i = 0; i < this._data.length; i++) {
                var /** @type {?} */ data = this._data[i];
                var /** @type {?} */ renderRowsForData = this._getRenderRowsForData(data, i, prevCachedRenderRows.get(data));
                if (!this._cachedRenderRowsMap.has(data)) {
                    this._cachedRenderRowsMap.set(data, new WeakMap());
                }
                for (var /** @type {?} */ j = 0; j < renderRowsForData.length; j++) {
                    var /** @type {?} */ renderRow = renderRowsForData[j];
                    var /** @type {?} */ cache = /** @type {?} */ ((this._cachedRenderRowsMap.get(renderRow.data)));
                    if (cache.has(renderRow.rowDef)) {
                        /** @type {?} */ ((cache.get(renderRow.rowDef))).push(renderRow);
                    }
                    else {
                        cache.set(renderRow.rowDef, [renderRow]);
                    }
                    renderRows.push(renderRow);
                }
            }
            return renderRows;
        };
        /**
         * Gets a list of `RenderRow<T>` for the provided data object and any `CdkRowDef` objects that
         * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
         * `(T, CdkRowDef)` pair.
         * @param {?} data
         * @param {?} dataIndex
         * @param {?=} cache
         * @return {?}
         */
        CdkTable.prototype._getRenderRowsForData = /**
         * Gets a list of `RenderRow<T>` for the provided data object and any `CdkRowDef` objects that
         * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
         * `(T, CdkRowDef)` pair.
         * @param {?} data
         * @param {?} dataIndex
         * @param {?=} cache
         * @return {?}
         */
        function (data, dataIndex, cache) {
            var /** @type {?} */ rowDefs = this._getRowDefs(data, dataIndex);
            return rowDefs.map(function (rowDef) {
                var /** @type {?} */ cachedRenderRows = (cache && cache.has(rowDef)) ? /** @type {?} */ ((cache.get(rowDef))) : [];
                if (cachedRenderRows.length) {
                    var /** @type {?} */ dataRow = /** @type {?} */ ((cachedRenderRows.shift()));
                    dataRow.dataIndex = dataIndex;
                    return dataRow;
                }
                else {
                    return { data: data, rowDef: rowDef, dataIndex: dataIndex };
                }
            });
        };
        /**
         * Update the map containing the content's column definitions.
         * @return {?}
         */
        CdkTable.prototype._cacheColumnDefs = /**
         * Update the map containing the content's column definitions.
         * @return {?}
         */
        function () {
            var _this = this;
            this._columnDefsByName.clear();
            var /** @type {?} */ columnDefs = mergeQueryListAndSet(this._contentColumnDefs, this._customColumnDefs);
            columnDefs.forEach(function (columnDef) {
                if (_this._columnDefsByName.has(columnDef.name)) {
                    throw getTableDuplicateColumnNameError(columnDef.name);
                }
                _this._columnDefsByName.set(columnDef.name, columnDef);
            });
        };
        /**
         * Update the list of all available row definitions that can be used.
         * @return {?}
         */
        CdkTable.prototype._cacheRowDefs = /**
         * Update the list of all available row definitions that can be used.
         * @return {?}
         */
        function () {
            this._headerRowDefs =
                mergeQueryListAndSet(this._contentHeaderRowDefs, this._customHeaderRowDefs);
            this._footerRowDefs =
                mergeQueryListAndSet(this._contentFooterRowDefs, this._customFooterRowDefs);
            this._rowDefs =
                mergeQueryListAndSet(this._contentRowDefs, this._customRowDefs);
            // After all row definitions are determined, find the row definition to be considered default.
            var /** @type {?} */ defaultRowDefs = this._rowDefs.filter(function (def) { return !def.when; });
            if (!this.multiTemplateDataRows && defaultRowDefs.length > 1) {
                throw getTableMultipleDefaultRowDefsError();
            }
            this._defaultRowDef = defaultRowDefs[0];
        };
        /**
         * Check if the header, data, or footer rows have changed what columns they want to display or
         * whether the sticky states have changed for the header or footer. If there is a diff, then
         * re-render that section.
         * @return {?}
         */
        CdkTable.prototype._renderUpdatedColumns = /**
         * Check if the header, data, or footer rows have changed what columns they want to display or
         * whether the sticky states have changed for the header or footer. If there is a diff, then
         * re-render that section.
         * @return {?}
         */
        function () {
            var /** @type {?} */ columnsDiffReducer = function (acc, def) { return acc || !!def.getColumnsDiff(); };
            // Force re-render data rows if the list of column definitions have changed.
            if (this._rowDefs.reduce(columnsDiffReducer, false)) {
                this._forceRenderDataRows();
            }
            // Force re-render header/footer rows if the list of column definitions have changed..
            if (this._headerRowDefs.reduce(columnsDiffReducer, false)) {
                this._forceRenderHeaderRows();
            }
            if (this._footerRowDefs.reduce(columnsDiffReducer, false)) {
                this._forceRenderFooterRows();
            }
        };
        /**
         * Switch to the provided data source by resetting the data and unsubscribing from the current
         * render change subscription if one exists. If the data source is null, interpret this by
         * clearing the row outlet. Otherwise start listening for new data.
         * @param {?} dataSource
         * @return {?}
         */
        CdkTable.prototype._switchDataSource = /**
         * Switch to the provided data source by resetting the data and unsubscribing from the current
         * render change subscription if one exists. If the data source is null, interpret this by
         * clearing the row outlet. Otherwise start listening for new data.
         * @param {?} dataSource
         * @return {?}
         */
        function (dataSource) {
            this._data = [];
            if (this.dataSource instanceof DataSource) {
                this.dataSource.disconnect(this);
            }
            // Stop listening for data from the previous data source.
            if (this._renderChangeSubscription) {
                this._renderChangeSubscription.unsubscribe();
                this._renderChangeSubscription = null;
            }
            if (!dataSource) {
                if (this._dataDiffer) {
                    this._dataDiffer.diff([]);
                }
                this._rowOutlet.viewContainer.clear();
            }
            this._dataSource = dataSource;
        };
        /**
         * Set up a subscription for the data provided by the data source.
         * @return {?}
         */
        CdkTable.prototype._observeRenderChanges = /**
         * Set up a subscription for the data provided by the data source.
         * @return {?}
         */
        function () {
            var _this = this;
            // If no data source has been set, there is nothing to observe for changes.
            if (!this.dataSource) {
                return;
            }
            var /** @type {?} */ dataStream;
            // Check if the datasource is a DataSource object by observing if it has a connect function.
            // Cannot check this.dataSource['connect'] due to potential property renaming, nor can it
            // checked as an instanceof DataSource<T> since the table should allow for data sources
            // that did not explicitly extend DataSource<T>.
            if ((/** @type {?} */ (this.dataSource)).connect instanceof Function) {
                dataStream = (/** @type {?} */ (this.dataSource)).connect(this);
            }
            else if (this.dataSource instanceof rxjs.Observable) {
                dataStream = this.dataSource;
            }
            else if (Array.isArray(this.dataSource)) {
                dataStream = rxjs.of(this.dataSource);
            }
            if (dataStream === undefined) {
                throw getTableUnknownDataSourceError();
            }
            this._renderChangeSubscription = dataStream
                .pipe(operators.takeUntil(this._onDestroy))
                .subscribe(function (data) {
                _this._data = data || [];
                _this.renderRows();
            });
        };
        /**
         * Clears any existing content in the header row outlet and creates a new embedded view
         * in the outlet using the header row definition.
         * @return {?}
         */
        CdkTable.prototype._forceRenderHeaderRows = /**
         * Clears any existing content in the header row outlet and creates a new embedded view
         * in the outlet using the header row definition.
         * @return {?}
         */
        function () {
            var _this = this;
            // Clear the header row outlet if any content exists.
            if (this._headerRowOutlet.viewContainer.length > 0) {
                this._headerRowOutlet.viewContainer.clear();
            }
            this._headerRowDefs.forEach(function (def, i) { return _this._renderRow(_this._headerRowOutlet, def, i); });
            this.updateStickyHeaderRowStyles();
            this.updateStickyColumnStyles();
        };
        /**
         * Clears any existing content in the footer row outlet and creates a new embedded view
         * in the outlet using the footer row definition.
         * @return {?}
         */
        CdkTable.prototype._forceRenderFooterRows = /**
         * Clears any existing content in the footer row outlet and creates a new embedded view
         * in the outlet using the footer row definition.
         * @return {?}
         */
        function () {
            var _this = this;
            // Clear the footer row outlet if any content exists.
            if (this._footerRowOutlet.viewContainer.length > 0) {
                this._footerRowOutlet.viewContainer.clear();
            }
            this._footerRowDefs.forEach(function (def, i) { return _this._renderRow(_this._footerRowOutlet, def, i); });
            this.updateStickyFooterRowStyles();
            this.updateStickyColumnStyles();
        };
        /**
         * Adds the sticky column styles for the rows according to the columns' stick states.
         * @param {?} rows
         * @param {?} rowDef
         * @return {?}
         */
        CdkTable.prototype._addStickyColumnStyles = /**
         * Adds the sticky column styles for the rows according to the columns' stick states.
         * @param {?} rows
         * @param {?} rowDef
         * @return {?}
         */
        function (rows, rowDef) {
            var _this = this;
            var /** @type {?} */ columnDefs = Array.from(rowDef.columns || []).map(function (c) { return ((_this._columnDefsByName.get(c))); });
            var /** @type {?} */ stickyStartStates = columnDefs.map(function (columnDef) { return columnDef.sticky; });
            var /** @type {?} */ stickyEndStates = columnDefs.map(function (columnDef) { return columnDef.stickyEnd; });
            this._stickyStyler.updateStickyColumns(rows, stickyStartStates, stickyEndStates);
        };
        /** Gets the list of rows that have been rendered in the row outlet. */
        /**
         * Gets the list of rows that have been rendered in the row outlet.
         * @param {?} rowOutlet
         * @return {?}
         */
        CdkTable.prototype._getRenderedRows = /**
         * Gets the list of rows that have been rendered in the row outlet.
         * @param {?} rowOutlet
         * @return {?}
         */
        function (rowOutlet) {
            var /** @type {?} */ renderedRows = [];
            for (var /** @type {?} */ i = 0; i < rowOutlet.viewContainer.length; i++) {
                var /** @type {?} */ viewRef = (/** @type {?} */ (((rowOutlet.viewContainer.get(i)))));
                renderedRows.push(viewRef.rootNodes[0]);
            }
            return renderedRows;
        };
        /**
         * Get the matching row definitions that should be used for this row data. If there is only
         * one row definition, it is returned. Otherwise, find the row definitions that has a when
         * predicate that returns true with the data. If none return true, return the default row
         * definition.
         */
        /**
         * Get the matching row definitions that should be used for this row data. If there is only
         * one row definition, it is returned. Otherwise, find the row definitions that has a when
         * predicate that returns true with the data. If none return true, return the default row
         * definition.
         * @param {?} data
         * @param {?} dataIndex
         * @return {?}
         */
        CdkTable.prototype._getRowDefs = /**
         * Get the matching row definitions that should be used for this row data. If there is only
         * one row definition, it is returned. Otherwise, find the row definitions that has a when
         * predicate that returns true with the data. If none return true, return the default row
         * definition.
         * @param {?} data
         * @param {?} dataIndex
         * @return {?}
         */
        function (data, dataIndex) {
            if (this._rowDefs.length == 1) {
                return [this._rowDefs[0]];
            }
            var /** @type {?} */ rowDefs = [];
            if (this.multiTemplateDataRows) {
                rowDefs = this._rowDefs.filter(function (def) { return !def.when || def.when(dataIndex, data); });
            }
            else {
                var /** @type {?} */ rowDef = this._rowDefs.find(function (def) { return def.when && def.when(dataIndex, data); }) || this._defaultRowDef;
                if (rowDef) {
                    rowDefs.push(rowDef);
                }
            }
            if (!rowDefs.length) {
                throw getTableMissingMatchingRowDefError(data);
            }
            return rowDefs;
        };
        /**
         * Create the embedded view for the data row template and place it in the correct index location
         * within the data row view container.
         * @param {?} renderRow
         * @param {?} renderIndex
         * @return {?}
         */
        CdkTable.prototype._insertRow = /**
         * Create the embedded view for the data row template and place it in the correct index location
         * within the data row view container.
         * @param {?} renderRow
         * @param {?} renderIndex
         * @return {?}
         */
        function (renderRow, renderIndex) {
            var /** @type {?} */ rowDef = renderRow.rowDef;
            var /** @type {?} */ context = { $implicit: renderRow.data };
            this._renderRow(this._rowOutlet, rowDef, renderIndex, context);
        };
        /**
         * Creates a new row template in the outlet and fills it with the set of cell templates.
         * Optionally takes a context to provide to the row and cells, as well as an optional index
         * of where to place the new row template in the outlet.
         * @param {?} outlet
         * @param {?} rowDef
         * @param {?} index
         * @param {?=} context
         * @return {?}
         */
        CdkTable.prototype._renderRow = /**
         * Creates a new row template in the outlet and fills it with the set of cell templates.
         * Optionally takes a context to provide to the row and cells, as well as an optional index
         * of where to place the new row template in the outlet.
         * @param {?} outlet
         * @param {?} rowDef
         * @param {?} index
         * @param {?=} context
         * @return {?}
         */
        function (outlet, rowDef, index, context) {
            if (context === void 0) { context = {}; }
            // TODO(andrewseguin): enforce that one outlet was instantiated from createEmbeddedView
            outlet.viewContainer.createEmbeddedView(rowDef.template, context, index);
            for (var _a = 0, _b = this._getCellTemplates(rowDef); _a < _b.length; _a++) {
                var cellTemplate = _b[_a];
                if (CdkCellOutlet.mostRecentCellOutlet) {
                    CdkCellOutlet.mostRecentCellOutlet._viewContainer.createEmbeddedView(cellTemplate, context);
                }
            }
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Updates the index-related context for each row to reflect any changes in the index of the rows,
         * e.g. first/last/even/odd.
         * @return {?}
         */
        CdkTable.prototype._updateRowIndexContext = /**
         * Updates the index-related context for each row to reflect any changes in the index of the rows,
         * e.g. first/last/even/odd.
         * @return {?}
         */
        function () {
            var /** @type {?} */ viewContainer = this._rowOutlet.viewContainer;
            for (var /** @type {?} */ renderIndex = 0, /** @type {?} */ count = viewContainer.length; renderIndex < count; renderIndex++) {
                var /** @type {?} */ viewRef = /** @type {?} */ (viewContainer.get(renderIndex));
                var /** @type {?} */ context = /** @type {?} */ (viewRef.context);
                context.count = count;
                context.first = renderIndex === 0;
                context.last = renderIndex === count - 1;
                context.even = renderIndex % 2 === 0;
                context.odd = !context.even;
                if (this.multiTemplateDataRows) {
                    context.dataIndex = this._renderRows[renderIndex].dataIndex;
                    context.renderIndex = renderIndex;
                }
                else {
                    context.index = this._renderRows[renderIndex].dataIndex;
                }
            }
        };
        /**
         * Gets the column definitions for the provided row def.
         * @param {?} rowDef
         * @return {?}
         */
        CdkTable.prototype._getCellTemplates = /**
         * Gets the column definitions for the provided row def.
         * @param {?} rowDef
         * @return {?}
         */
        function (rowDef) {
            var _this = this;
            if (!rowDef || !rowDef.columns) {
                return [];
            }
            return Array.from(rowDef.columns, function (columnId) {
                var /** @type {?} */ column = _this._columnDefsByName.get(columnId);
                if (!column) {
                    throw getTableUnknownColumnError(columnId);
                }
                return rowDef.extractCellTemplate(column);
            });
        };
        /**
         * Adds native table sections (e.g. tbody) and moves the row outlets into them.
         * @return {?}
         */
        CdkTable.prototype._applyNativeTableSections = /**
         * Adds native table sections (e.g. tbody) and moves the row outlets into them.
         * @return {?}
         */
        function () {
            var /** @type {?} */ sections = [
                { tag: 'thead', outlet: this._headerRowOutlet },
                { tag: 'tbody', outlet: this._rowOutlet },
                { tag: 'tfoot', outlet: this._footerRowOutlet },
            ];
            for (var _a = 0, sections_1 = sections; _a < sections_1.length; _a++) {
                var section = sections_1[_a];
                var /** @type {?} */ element = document.createElement(section.tag);
                element.appendChild(section.outlet.elementRef.nativeElement);
                this._elementRef.nativeElement.appendChild(element);
            }
        };
        /**
         * Forces a re-render of the data rows. Should be called in cases where there has been an input
         * change that affects the evaluation of which rows should be rendered, e.g. toggling
         * `multiTemplateDataRows` or adding/removing row definitions.
         * @return {?}
         */
        CdkTable.prototype._forceRenderDataRows = /**
         * Forces a re-render of the data rows. Should be called in cases where there has been an input
         * change that affects the evaluation of which rows should be rendered, e.g. toggling
         * `multiTemplateDataRows` or adding/removing row definitions.
         * @return {?}
         */
        function () {
            this._dataDiffer.diff([]);
            this._rowOutlet.viewContainer.clear();
            this.renderRows();
            this.updateStickyColumnStyles();
        };
        /**
         * Checks if there has been a change in sticky states since last check and applies the correct
         * sticky styles. Since checking resets the "dirty" state, this should only be performed once
         * during a change detection and after the inputs are settled (after content check).
         * @return {?}
         */
        CdkTable.prototype._checkStickyStates = /**
         * Checks if there has been a change in sticky states since last check and applies the correct
         * sticky styles. Since checking resets the "dirty" state, this should only be performed once
         * during a change detection and after the inputs are settled (after content check).
         * @return {?}
         */
        function () {
            var /** @type {?} */ stickyCheckReducer = function (acc, d) {
                return acc || d.hasStickyChanged();
            };
            // Note that the check needs to occur for every definition since it notifies the definition
            // that it can reset its dirty state. Using another operator like `some` may short-circuit
            // remaining definitions and leave them in an unchecked state.
            if (this._headerRowDefs.reduce(stickyCheckReducer, false)) {
                this.updateStickyHeaderRowStyles();
            }
            if (this._footerRowDefs.reduce(stickyCheckReducer, false)) {
                this.updateStickyFooterRowStyles();
            }
            if (Array.from(this._columnDefsByName.values()).reduce(stickyCheckReducer, false)) {
                this.updateStickyColumnStyles();
            }
        };
        /**
         * Creates the sticky styler that will be used for sticky rows and columns. Listens
         * for directionality changes and provides the latest direction to the styler. Re-applies column
         * stickiness when directionality changes.
         * @return {?}
         */
        CdkTable.prototype._setupStickyStyler = /**
         * Creates the sticky styler that will be used for sticky rows and columns. Listens
         * for directionality changes and provides the latest direction to the styler. Re-applies column
         * stickiness when directionality changes.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ direction = this._dir ? this._dir.value : 'ltr';
            this._stickyStyler = new StickyStyler(this._isNativeHtmlTable, this.stickyCssClass, direction);
            (this._dir ? this._dir.change : rxjs.of())
                .pipe(operators.takeUntil(this._onDestroy))
                .subscribe(function (value) {
                _this._stickyStyler.direction = value;
                _this.updateStickyColumnStyles();
            });
        };
        CdkTable.decorators = [
            { type: core.Component, args: [{selector: 'cdk-table, table[cdk-table]',
                        exportAs: 'cdkTable',
                        template: CDK_TABLE_TEMPLATE,
                        host: {
                            'class': 'cdk-table',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        CdkTable.ctorParameters = function () { return [
            { type: core.IterableDiffers, },
            { type: core.ChangeDetectorRef, },
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['role',] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        CdkTable.propDecorators = {
            "trackBy": [{ type: core.Input },],
            "dataSource": [{ type: core.Input },],
            "multiTemplateDataRows": [{ type: core.Input },],
            "_rowOutlet": [{ type: core.ViewChild, args: [DataRowOutlet,] },],
            "_headerRowOutlet": [{ type: core.ViewChild, args: [HeaderRowOutlet,] },],
            "_footerRowOutlet": [{ type: core.ViewChild, args: [FooterRowOutlet,] },],
            "_contentColumnDefs": [{ type: core.ContentChildren, args: [CdkColumnDef,] },],
            "_contentRowDefs": [{ type: core.ContentChildren, args: [CdkRowDef,] },],
            "_contentHeaderRowDefs": [{ type: core.ContentChildren, args: [CdkHeaderRowDef,] },],
            "_contentFooterRowDefs": [{ type: core.ContentChildren, args: [CdkFooterRowDef,] },],
        };
        return CdkTable;
    }());
    /**
     * Utility function that gets a merged list of the entries in a QueryList and values of a Set.
     * @template T
     * @param {?} queryList
     * @param {?} set
     * @return {?}
     */
    function mergeQueryListAndSet(queryList, set) {
        return queryList.toArray().concat(Array.from(set));
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ EXPORTED_DECLARATIONS = [
        CdkTable,
        CdkRowDef,
        CdkCellDef,
        CdkCellOutlet,
        CdkHeaderCellDef,
        CdkFooterCellDef,
        CdkColumnDef,
        CdkCell,
        CdkRow,
        CdkHeaderCell,
        CdkFooterCell,
        CdkHeaderRow,
        CdkHeaderRowDef,
        CdkFooterRow,
        CdkFooterRowDef,
        DataRowOutlet,
        HeaderRowOutlet,
        FooterRowOutlet,
    ];
    var CdkTableModule = /** @class */ (function () {
        function CdkTableModule() {
        }
        CdkTableModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: EXPORTED_DECLARATIONS,
                        declarations: EXPORTED_DECLARATIONS
                    },] },
        ];
        return CdkTableModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * \@docs-private
     * @param {?} id
     * @return {?}
     */
    function getSortDuplicateSortableIdError(id) {
        return Error("Cannot have two MatSortables with the same id (" + id + ").");
    }
    /**
     * \@docs-private
     * @return {?}
     */
    function getSortHeaderNotContainedWithinSortError() {
        return Error("MatSortHeader must be placed within a parent element with the MatSort directive.");
    }
    /**
     * \@docs-private
     * @return {?}
     */
    function getSortHeaderMissingIdError() {
        return Error("MatSortHeader must be provided with a unique id.");
    }
    /**
     * \@docs-private
     * @param {?} direction
     * @return {?}
     */
    function getSortInvalidDirectionError(direction) {
        return Error(direction + " is not a valid sort direction ('asc' or 'desc').");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSortBase = /** @class */ (function () {
        function MatSortBase() {
        }
        return MatSortBase;
    }());
    var /** @type {?} */ _MatSortMixinBase = mixinInitialized(mixinDisabled(MatSortBase));
    /**
     * Container for MatSortables to manage the sort state and provide default sort parameters.
     */
    var MatSort = /** @class */ (function (_super) {
        __extends(MatSort, _super);
        function MatSort() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /**
             * Collection of all registered sortables that this directive manages.
             */
            _this.sortables = new Map();
            /**
             * Used to notify any child components listening to state changes.
             */
            _this._stateChanges = new rxjs.Subject();
            /**
             * The direction to set when an MatSortable is initially sorted.
             * May be overriden by the MatSortable's sort start.
             */
            _this.start = 'asc';
            _this._direction = '';
            /**
             * Event emitted when the user changes either the active sort or sort direction.
             */
            _this.sortChange = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(MatSort.prototype, "direction", {
            get: /**
             * The sort direction of the currently active MatSortable.
             * @return {?}
             */
            function () { return this._direction; },
            set: /**
             * @param {?} direction
             * @return {?}
             */
            function (direction) {
                if (core.isDevMode() && direction && direction !== 'asc' && direction !== 'desc') {
                    throw getSortInvalidDirectionError(direction);
                }
                this._direction = direction;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatSort.prototype, "disableClear", {
            get: /**
             * Whether to disable the user from clearing the sort by finishing the sort direction cycle.
             * May be overriden by the MatSortable's disable clear input.
             * @return {?}
             */
            function () { return this._disableClear; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) { this._disableClear = coerceBooleanProperty(v); },
            enumerable: true,
            configurable: true
        });
        /**
         * Register function to be used by the contained MatSortables. Adds the MatSortable to the
         * collection of MatSortables.
         */
        /**
         * Register function to be used by the contained MatSortables. Adds the MatSortable to the
         * collection of MatSortables.
         * @param {?} sortable
         * @return {?}
         */
        MatSort.prototype.register = /**
         * Register function to be used by the contained MatSortables. Adds the MatSortable to the
         * collection of MatSortables.
         * @param {?} sortable
         * @return {?}
         */
        function (sortable) {
            if (!sortable.id) {
                throw getSortHeaderMissingIdError();
            }
            if (this.sortables.has(sortable.id)) {
                throw getSortDuplicateSortableIdError(sortable.id);
            }
            this.sortables.set(sortable.id, sortable);
        };
        /**
         * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
         * collection of contained MatSortables.
         */
        /**
         * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
         * collection of contained MatSortables.
         * @param {?} sortable
         * @return {?}
         */
        MatSort.prototype.deregister = /**
         * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
         * collection of contained MatSortables.
         * @param {?} sortable
         * @return {?}
         */
        function (sortable) {
            this.sortables.delete(sortable.id);
        };
        /** Sets the active sort id and determines the new sort direction. */
        /**
         * Sets the active sort id and determines the new sort direction.
         * @param {?} sortable
         * @return {?}
         */
        MatSort.prototype.sort = /**
         * Sets the active sort id and determines the new sort direction.
         * @param {?} sortable
         * @return {?}
         */
        function (sortable) {
            if (this.active != sortable.id) {
                this.active = sortable.id;
                this.direction = sortable.start ? sortable.start : this.start;
            }
            else {
                this.direction = this.getNextSortDirection(sortable);
            }
            this.sortChange.emit({ active: this.active, direction: this.direction });
        };
        /** Returns the next sort direction of the active sortable, checking for potential overrides. */
        /**
         * Returns the next sort direction of the active sortable, checking for potential overrides.
         * @param {?} sortable
         * @return {?}
         */
        MatSort.prototype.getNextSortDirection = /**
         * Returns the next sort direction of the active sortable, checking for potential overrides.
         * @param {?} sortable
         * @return {?}
         */
        function (sortable) {
            if (!sortable) {
                return '';
            }
            // Get the sort direction cycle with the potential sortable overrides.
            var /** @type {?} */ disableClear = sortable.disableClear != null ? sortable.disableClear : this.disableClear;
            var /** @type {?} */ sortDirectionCycle = getSortDirectionCycle(sortable.start || this.start, disableClear);
            // Get and return the next direction in the cycle
            var /** @type {?} */ nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
            if (nextDirectionIndex >= sortDirectionCycle.length) {
                nextDirectionIndex = 0;
            }
            return sortDirectionCycle[nextDirectionIndex];
        };
        /**
         * @return {?}
         */
        MatSort.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._markInitialized();
        };
        /**
         * @return {?}
         */
        MatSort.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            this._stateChanges.next();
        };
        /**
         * @return {?}
         */
        MatSort.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._stateChanges.complete();
        };
        MatSort.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matSort]',
                        exportAs: 'matSort',
                        inputs: ['disabled: matSortDisabled']
                    },] },
        ];
        /** @nocollapse */
        MatSort.propDecorators = {
            "active": [{ type: core.Input, args: ['matSortActive',] },],
            "start": [{ type: core.Input, args: ['matSortStart',] },],
            "direction": [{ type: core.Input, args: ['matSortDirection',] },],
            "disableClear": [{ type: core.Input, args: ['matSortDisableClear',] },],
            "sortChange": [{ type: core.Output, args: ['matSortChange',] },],
        };
        return MatSort;
    }(_MatSortMixinBase));
    /**
     * Returns the sort direction cycle to use given the provided parameters of order and clear.
     * @param {?} start
     * @param {?} disableClear
     * @return {?}
     */
    function getSortDirectionCycle(start, disableClear) {
        var /** @type {?} */ sortOrder = ['asc', 'desc'];
        if (start == 'desc') {
            sortOrder.reverse();
        }
        if (!disableClear) {
            sortOrder.push('');
        }
        return sortOrder;
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ SORT_ANIMATION_TRANSITION = AnimationDurations.ENTERING + ' ' +
        AnimationCurves.STANDARD_CURVE;
    /**
     * Animations used by MatSort.
     */
    var /** @type {?} */ matSortAnimations = {
        /** Animation that moves the sort indicator. */
        indicator: trigger('indicator', [
            state('active-asc, asc', style({ transform: 'translateY(0px)' })),
            // 10px is the height of the sort indicator, minus the width of the pointers
            state('active-desc, desc', style({ transform: 'translateY(10px)' })),
            transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
        ]),
        /** Animation that rotates the left pointer of the indicator based on the sorting direction. */
        leftPointer: trigger('leftPointer', [
            state('active-asc, asc', style({ transform: 'rotate(-45deg)' })),
            state('active-desc, desc', style({ transform: 'rotate(45deg)' })),
            transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
        ]),
        /** Animation that rotates the right pointer of the indicator based on the sorting direction. */
        rightPointer: trigger('rightPointer', [
            state('active-asc, asc', style({ transform: 'rotate(45deg)' })),
            state('active-desc, desc', style({ transform: 'rotate(-45deg)' })),
            transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
        ]),
        /** Animation that controls the arrow opacity. */
        arrowOpacity: trigger('arrowOpacity', [
            state('desc-to-active, asc-to-active, active', style({ opacity: 1 })),
            state('desc-to-hint, asc-to-hint, hint', style({ opacity: .54 })),
            state('hint-to-desc, active-to-desc, desc, hint-to-asc, active-to-asc, asc', style({ opacity: 0 })),
            // Transition between all states except for immediate transitions
            transition('* => asc, * => desc, * => active, * => hint', animate('0ms')),
            transition('* <=> *', animate(SORT_ANIMATION_TRANSITION))
        ]),
        /**
           * Animation for the translation of the arrow as a whole. States are separated into two
           * groups: ones with animations and others that are immediate. Immediate states are asc, desc,
           * peek, and active. The other states define a specific animation (source-to-destination)
           * and are determined as a function of their prev user-perceived state and what the next state
           * should be.
           */
        arrowPosition: trigger('arrowPosition', [
            // Hidden Above => Hint Center
            transition('* => desc-to-hint, * => desc-to-active', animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({ transform: 'translateY(-25%)' }),
                style({ transform: 'translateY(0)' })
            ]))),
            // Hint Center => Hidden Below
            transition('* => hint-to-desc, * => active-to-desc', animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({ transform: 'translateY(0)' }),
                style({ transform: 'translateY(25%)' })
            ]))),
            // Hidden Below => Hint Center
            transition('* => asc-to-hint, * => asc-to-active', animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({ transform: 'translateY(25%)' }),
                style({ transform: 'translateY(0)' })
            ]))),
            // Hint Center => Hidden Above
            transition('* => hint-to-asc, * => active-to-asc', animate(SORT_ANIMATION_TRANSITION, keyframes([
                style({ transform: 'translateY(0)' }),
                style({ transform: 'translateY(-25%)' })
            ]))),
            state('desc-to-hint, asc-to-hint, hint, desc-to-active, asc-to-active, active', style({ transform: 'translateY(0)' })),
            state('hint-to-desc, active-to-desc, desc', style({ transform: 'translateY(-25%)' })),
            state('hint-to-asc, active-to-asc, asc', style({ transform: 'translateY(25%)' })),
        ]),
        /** Necessary trigger that calls animate on children animations. */
        allowChildren: trigger('allowChildren', [
            transition('* <=> *', [
                query('@*', animateChild(), { optional: true })
            ])
        ]),
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * To modify the labels and text displayed, create a new instance of MatSortHeaderIntl and
     * include it in a custom provider.
     */
    var MatSortHeaderIntl = /** @class */ (function () {
        function MatSortHeaderIntl() {
            /**
             * Stream that emits whenever the labels here are changed. Use this to notify
             * components if the labels have changed after initialization.
             */
            this.changes = new rxjs.Subject();
            /**
             * ARIA label for the sorting button.
             */
            this.sortButtonLabel = function (id) {
                return "Change sorting for " + id;
            };
        }
        MatSortHeaderIntl.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ MatSortHeaderIntl.ngInjectableDef = core.defineInjectable({ factory: function MatSortHeaderIntl_Factory() { return new MatSortHeaderIntl(); }, token: MatSortHeaderIntl, providedIn: "root" });
        return MatSortHeaderIntl;
    }());
    /**
     * \@docs-private
     * @param {?} parentIntl
     * @return {?}
     */
    function MAT_SORT_HEADER_INTL_PROVIDER_FACTORY(parentIntl) {
        return parentIntl || new MatSortHeaderIntl();
    }
    /**
     * \@docs-private
     */
    var /** @type {?} */ MAT_SORT_HEADER_INTL_PROVIDER = {
        // If there is already an MatSortHeaderIntl available, use that. Otherwise, provide a new one.
        provide: MatSortHeaderIntl,
        deps: [[new core.Optional(), new core.SkipSelf(), MatSortHeaderIntl]],
        useFactory: MAT_SORT_HEADER_INTL_PROVIDER_FACTORY
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatSortHeaderBase = /** @class */ (function () {
        function MatSortHeaderBase() {
        }
        return MatSortHeaderBase;
    }());
    var /** @type {?} */ _MatSortHeaderMixinBase = mixinDisabled(MatSortHeaderBase);
    /**
     * Applies sorting behavior (click to change sort) and styles to an element, including an
     * arrow to display the current sort direction.
     *
     * Must be provided with an id and contained within a parent MatSort directive.
     *
     * If used on header cells in a CdkTable, it will automatically default its id from its containing
     * column definition.
     */
    var MatSortHeader = /** @class */ (function (_super) {
        __extends(MatSortHeader, _super);
        function MatSortHeader(_intl, changeDetectorRef, _sort, _cdkColumnDef) {
            var _this = _super.call(this) || this;
            _this._intl = _intl;
            _this._sort = _sort;
            _this._cdkColumnDef = _cdkColumnDef;
            /**
             * Flag set to true when the indicator should be displayed while the sort is not active. Used to
             * provide an affordance that the header is sortable by showing on focus and hover.
             */
            _this._showIndicatorHint = false;
            /**
             * The direction the arrow should be facing according to the current state.
             */
            _this._arrowDirection = '';
            /**
             * Whether the view state animation should show the transition between the `from` and `to` states.
             */
            _this._disableViewStateAnimation = false;
            /**
             * Sets the position of the arrow that displays when sorted.
             */
            _this.arrowPosition = 'after';
            if (!_sort) {
                throw getSortHeaderNotContainedWithinSortError();
            }
            _this._rerenderSubscription = rxjs.merge(_sort.sortChange, _sort._stateChanges, _intl.changes)
                .subscribe(function () {
                if (_this._isSorted()) {
                    _this._updateArrowDirection();
                }
                // If this header was recently active and now no longer sorted, animate away the arrow.
                if (!_this._isSorted() && _this._viewState && _this._viewState.toState === 'active') {
                    _this._disableViewStateAnimation = false;
                    _this._setAnimationTransitionState({ fromState: 'active', toState: _this._arrowDirection });
                }
                changeDetectorRef.markForCheck();
            });
            return _this;
        }
        Object.defineProperty(MatSortHeader.prototype, "disableClear", {
            get: /**
             * Overrides the disable clear value of the containing MatSort for this MatSortable.
             * @return {?}
             */
            function () { return this._disableClear; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) { this._disableClear = coerceBooleanProperty(v); },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatSortHeader.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            if (!this.id && this._cdkColumnDef) {
                this.id = this._cdkColumnDef.name;
            }
            // Initialize the direction of the arrow and set the view state to be immediately that state.
            this._updateArrowDirection();
            this._setAnimationTransitionState({ toState: this._isSorted() ? 'active' : this._arrowDirection });
            this._sort.register(this);
        };
        /**
         * @return {?}
         */
        MatSortHeader.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._sort.deregister(this);
            this._rerenderSubscription.unsubscribe();
        };
        /**
         * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
         * user showing what the active sort will become. If set to false, the arrow will fade away.
         */
        /**
         * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
         * user showing what the active sort will become. If set to false, the arrow will fade away.
         * @param {?} visible
         * @return {?}
         */
        MatSortHeader.prototype._setIndicatorHintVisible = /**
         * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
         * user showing what the active sort will become. If set to false, the arrow will fade away.
         * @param {?} visible
         * @return {?}
         */
        function (visible) {
            // No-op if the sort header is disabled - should not make the hint visible.
            if (this._isDisabled() && visible) {
                return;
            }
            this._showIndicatorHint = visible;
            if (!this._isSorted()) {
                this._updateArrowDirection();
                if (this._showIndicatorHint) {
                    this._setAnimationTransitionState({ fromState: this._arrowDirection, toState: 'hint' });
                }
                else {
                    this._setAnimationTransitionState({ fromState: 'hint', toState: this._arrowDirection });
                }
            }
        };
        /**
         * Sets the animation transition view state for the arrow's position and opacity. If the
         * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
         * no animation appears.
         */
        /**
         * Sets the animation transition view state for the arrow's position and opacity. If the
         * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
         * no animation appears.
         * @param {?} viewState
         * @return {?}
         */
        MatSortHeader.prototype._setAnimationTransitionState = /**
         * Sets the animation transition view state for the arrow's position and opacity. If the
         * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
         * no animation appears.
         * @param {?} viewState
         * @return {?}
         */
        function (viewState) {
            this._viewState = viewState;
            // If the animation for arrow position state (opacity/translation) should be disabled,
            // remove the fromState so that it jumps right to the toState.
            if (this._disableViewStateAnimation) {
                this._viewState = { toState: viewState.toState };
            }
        };
        /** Triggers the sort on this sort header and removes the indicator hint. */
        /**
         * Triggers the sort on this sort header and removes the indicator hint.
         * @return {?}
         */
        MatSortHeader.prototype._handleClick = /**
         * Triggers the sort on this sort header and removes the indicator hint.
         * @return {?}
         */
        function () {
            if (this._isDisabled()) {
                return;
            }
            this._sort.sort(this);
            // Do not show the animation if the header was already shown in the right position.
            if (this._viewState.toState === 'hint' || this._viewState.toState === 'active') {
                this._disableViewStateAnimation = true;
            }
            // If the arrow is now sorted, animate the arrow into place. Otherwise, animate it away into
            // the direction it is facing.
            var /** @type {?} */ viewState = this._isSorted() ?
                { fromState: this._arrowDirection, toState: 'active' } :
                { fromState: 'active', toState: this._arrowDirection };
            this._setAnimationTransitionState(viewState);
            this._showIndicatorHint = false;
        };
        /** Whether this MatSortHeader is currently sorted in either ascending or descending order. */
        /**
         * Whether this MatSortHeader is currently sorted in either ascending or descending order.
         * @return {?}
         */
        MatSortHeader.prototype._isSorted = /**
         * Whether this MatSortHeader is currently sorted in either ascending or descending order.
         * @return {?}
         */
        function () {
            return this._sort.active == this.id &&
                (this._sort.direction === 'asc' || this._sort.direction === 'desc');
        };
        /** Returns the animation state for the arrow direction (indicator and pointers). */
        /**
         * Returns the animation state for the arrow direction (indicator and pointers).
         * @return {?}
         */
        MatSortHeader.prototype._getArrowDirectionState = /**
         * Returns the animation state for the arrow direction (indicator and pointers).
         * @return {?}
         */
        function () {
            return "" + (this._isSorted() ? 'active-' : '') + this._arrowDirection;
        };
        /** Returns the arrow position state (opacity, translation). */
        /**
         * Returns the arrow position state (opacity, translation).
         * @return {?}
         */
        MatSortHeader.prototype._getArrowViewState = /**
         * Returns the arrow position state (opacity, translation).
         * @return {?}
         */
        function () {
            var /** @type {?} */ fromState = this._viewState.fromState;
            return (fromState ? fromState + "-to-" : '') + this._viewState.toState;
        };
        /**
         * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
         * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
         * active sorted direction. The reason this is updated through a function is because the direction
         * should only be changed at specific times - when deactivated but the hint is displayed and when
         * the sort is active and the direction changes. Otherwise the arrow's direction should linger
         * in cases such as the sort becoming deactivated but we want to animate the arrow away while
         * preserving its direction, even though the next sort direction is actually different and should
         * only be changed once the arrow displays again (hint or activation).
         */
        /**
         * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
         * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
         * active sorted direction. The reason this is updated through a function is because the direction
         * should only be changed at specific times - when deactivated but the hint is displayed and when
         * the sort is active and the direction changes. Otherwise the arrow's direction should linger
         * in cases such as the sort becoming deactivated but we want to animate the arrow away while
         * preserving its direction, even though the next sort direction is actually different and should
         * only be changed once the arrow displays again (hint or activation).
         * @return {?}
         */
        MatSortHeader.prototype._updateArrowDirection = /**
         * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
         * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
         * active sorted direction. The reason this is updated through a function is because the direction
         * should only be changed at specific times - when deactivated but the hint is displayed and when
         * the sort is active and the direction changes. Otherwise the arrow's direction should linger
         * in cases such as the sort becoming deactivated but we want to animate the arrow away while
         * preserving its direction, even though the next sort direction is actually different and should
         * only be changed once the arrow displays again (hint or activation).
         * @return {?}
         */
        function () {
            this._arrowDirection = this._isSorted() ?
                this._sort.direction :
                (this.start || this._sort.start);
        };
        /**
         * @return {?}
         */
        MatSortHeader.prototype._isDisabled = /**
         * @return {?}
         */
        function () {
            return this._sort.disabled || this.disabled;
        };
        /**
         * Gets the aria-sort attribute that should be applied to this sort header. If this header
         * is not sorted, returns null so that the attribute is removed from the host element. Aria spec
         * says that the aria-sort property should only be present on one header at a time, so removing
         * ensures this is true.
         */
        /**
         * Gets the aria-sort attribute that should be applied to this sort header. If this header
         * is not sorted, returns null so that the attribute is removed from the host element. Aria spec
         * says that the aria-sort property should only be present on one header at a time, so removing
         * ensures this is true.
         * @return {?}
         */
        MatSortHeader.prototype._getAriaSortAttribute = /**
         * Gets the aria-sort attribute that should be applied to this sort header. If this header
         * is not sorted, returns null so that the attribute is removed from the host element. Aria spec
         * says that the aria-sort property should only be present on one header at a time, so removing
         * ensures this is true.
         * @return {?}
         */
        function () {
            if (!this._isSorted()) {
                return null;
            }
            return this._sort.direction == 'asc' ? 'ascending' : 'descending';
        };
        MatSortHeader.decorators = [
            { type: core.Component, args: [{selector: '[mat-sort-header]',
                        exportAs: 'matSortHeader',
                        template: "<div class=\"mat-sort-header-container\" [class.mat-sort-header-sorted]=\"_isSorted()\" [class.mat-sort-header-position-before]=\"arrowPosition == 'before'\"><button class=\"mat-sort-header-button\" type=\"button\" [attr.disabled]=\"_isDisabled() || null\" [attr.aria-label]=\"_intl.sortButtonLabel(id)\" (focus)=\"_setIndicatorHintVisible(true)\" (blur)=\"_setIndicatorHintVisible(false)\"><ng-content></ng-content></button><div class=\"mat-sort-header-arrow\" [@arrowOpacity]=\"_getArrowViewState()\" [@arrowPosition]=\"_getArrowViewState()\" [@allowChildren]=\"_getArrowDirectionState()\" (@arrowPosition.start)=\"_disableViewStateAnimation = true\" (@arrowPosition.done)=\"_disableViewStateAnimation = false\"><div class=\"mat-sort-header-stem\"></div><div class=\"mat-sort-header-indicator\" [@indicator]=\"_getArrowDirectionState()\"><div class=\"mat-sort-header-pointer-left\" [@leftPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-right\" [@rightPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-middle\"></div></div></div></div>",
                        styles: [".mat-sort-header-container{display:flex;cursor:pointer;align-items:center}.mat-sort-header-disabled .mat-sort-header-container{cursor:default}.mat-sort-header-position-before{flex-direction:row-reverse}.mat-sort-header-button{border:none;background:0 0;display:flex;align-items:center;padding:0;cursor:inherit;outline:0;font:inherit;color:currentColor}.mat-sort-header-arrow{height:12px;width:12px;min-width:12px;position:relative;display:flex}.mat-sort-header-arrow,[dir=rtl] .mat-sort-header-position-before .mat-sort-header-arrow{margin:0 0 0 6px}.mat-sort-header-position-before .mat-sort-header-arrow,[dir=rtl] .mat-sort-header-arrow{margin:0 6px 0 0}.mat-sort-header-stem{background:currentColor;height:10px;width:2px;margin:auto;display:flex;align-items:center}.mat-sort-header-indicator{width:100%;height:2px;display:flex;align-items:center;position:absolute;top:0;left:0}.mat-sort-header-pointer-middle{margin:auto;height:2px;width:2px;background:currentColor;transform:rotate(45deg)}.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{background:currentColor;width:6px;height:2px;position:absolute;top:0}.mat-sort-header-pointer-left{transform-origin:right;left:0}.mat-sort-header-pointer-right{transform-origin:left;right:0}"],
                        host: {
                            '(click)': '_handleClick()',
                            '(mouseenter)': '_setIndicatorHintVisible(true)',
                            '(longpress)': '_setIndicatorHintVisible(true)',
                            '(mouseleave)': '_setIndicatorHintVisible(false)',
                            '[attr.aria-sort]': '_getAriaSortAttribute()',
                            '[class.mat-sort-header-disabled]': '_isDisabled()',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['disabled'],
                        animations: [
                            matSortAnimations.indicator,
                            matSortAnimations.leftPointer,
                            matSortAnimations.rightPointer,
                            matSortAnimations.arrowOpacity,
                            matSortAnimations.arrowPosition,
                            matSortAnimations.allowChildren,
                        ]
                    },] },
        ];
        /** @nocollapse */
        MatSortHeader.ctorParameters = function () { return [
            { type: MatSortHeaderIntl, },
            { type: core.ChangeDetectorRef, },
            { type: MatSort, decorators: [{ type: core.Optional },] },
            { type: CdkColumnDef, decorators: [{ type: core.Optional },] },
        ]; };
        MatSortHeader.propDecorators = {
            "id": [{ type: core.Input, args: ['mat-sort-header',] },],
            "arrowPosition": [{ type: core.Input },],
            "start": [{ type: core.Input },],
            "disableClear": [{ type: core.Input },],
        };
        return MatSortHeader;
    }(_MatSortHeaderMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatSortModule = /** @class */ (function () {
        function MatSortModule() {
        }
        MatSortModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [MatSort, MatSortHeader],
                        declarations: [MatSort, MatSortHeader],
                        providers: [MAT_SORT_HEADER_INTL_PROVIDER]
                    },] },
        ];
        return MatSortModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var CdkStepLabel = /** @class */ (function () {
        function CdkStepLabel(template) {
            this.template = template;
        }
        CdkStepLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkStepLabel]',
                    },] },
        ];
        /** @nocollapse */
        CdkStepLabel.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return CdkStepLabel;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to generate unique ID for each stepper component.
     */
    var /** @type {?} */ nextId$3 = 0;
    var CdkStep = /** @class */ (function () {
        function CdkStep(_stepper) {
            this._stepper = _stepper;
            /**
             * Whether user has seen the expanded step content or not.
             */
            this.interacted = false;
            this._editable = true;
            this._optional = false;
            this._customCompleted = null;
        }
        Object.defineProperty(CdkStep.prototype, "editable", {
            get: /**
             * Whether the user can return to this step once it has been marked as complted.
             * @return {?}
             */
            function () { return this._editable; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._editable = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkStep.prototype, "optional", {
            get: /**
             * Whether the completion of step is optional.
             * @return {?}
             */
            function () { return this._optional; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._optional = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkStep.prototype, "completed", {
            get: /**
             * Whether step is marked as completed.
             * @return {?}
             */
            function () {
                return this._customCompleted == null ? this._defaultCompleted : this._customCompleted;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._customCompleted = coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkStep.prototype, "_defaultCompleted", {
            get: /**
             * @return {?}
             */
            function () {
                return this.stepControl ? this.stepControl.valid && this.interacted : this.interacted;
            },
            enumerable: true,
            configurable: true
        });
        /** Selects this step component. */
        /**
         * Selects this step component.
         * @return {?}
         */
        CdkStep.prototype.select = /**
         * Selects this step component.
         * @return {?}
         */
        function () {
            this._stepper.selected = this;
        };
        /** Resets the step to its initial state. Note that this includes resetting form data. */
        /**
         * Resets the step to its initial state. Note that this includes resetting form data.
         * @return {?}
         */
        CdkStep.prototype.reset = /**
         * Resets the step to its initial state. Note that this includes resetting form data.
         * @return {?}
         */
        function () {
            this.interacted = false;
            if (this._customCompleted != null) {
                this._customCompleted = false;
            }
            if (this.stepControl) {
                this.stepControl.reset();
            }
        };
        /**
         * @return {?}
         */
        CdkStep.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            // Since basically all inputs of the MatStep get proxied through the view down to the
            // underlying MatStepHeader, we have to make sure that change detection runs correctly.
            this._stepper._stateChanged();
        };
        CdkStep.decorators = [
            { type: core.Component, args: [{selector: 'cdk-step',
                        exportAs: 'cdkStep',
                        template: '<ng-template><ng-content></ng-content></ng-template>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        CdkStep.ctorParameters = function () { return [
            { type: CdkStepper, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return CdkStepper; }),] },] },
        ]; };
        CdkStep.propDecorators = {
            "stepLabel": [{ type: core.ContentChild, args: [CdkStepLabel,] },],
            "content": [{ type: core.ViewChild, args: [core.TemplateRef,] },],
            "stepControl": [{ type: core.Input },],
            "label": [{ type: core.Input },],
            "editable": [{ type: core.Input },],
            "optional": [{ type: core.Input },],
            "completed": [{ type: core.Input },],
        };
        return CdkStep;
    }());
    var CdkStepper = /** @class */ (function () {
        function CdkStepper(_dir, _changeDetectorRef) {
            this._dir = _dir;
            this._changeDetectorRef = _changeDetectorRef;
            /**
             * Emits when the component is destroyed.
             */
            this._destroyed = new rxjs.Subject();
            this._linear = false;
            this._selectedIndex = 0;
            /**
             * Event emitted when the selected step has changed.
             */
            this.selectionChange = new core.EventEmitter();
            this._orientation = 'horizontal';
            this._groupId = nextId$3++;
        }
        Object.defineProperty(CdkStepper.prototype, "linear", {
            get: /**
             * Whether the validity of previous steps should be checked or not.
             * @return {?}
             */
            function () { return this._linear; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._linear = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkStepper.prototype, "selectedIndex", {
            get: /**
             * The index of the selected step.
             * @return {?}
             */
            function () { return this._selectedIndex; },
            set: /**
             * @param {?} index
             * @return {?}
             */
            function (index) {
                if (this._steps) {
                    // Ensure that the index can't be out of bounds.
                    if (index < 0 || index > this._steps.length - 1) {
                        throw Error('cdkStepper: Cannot assign out-of-bounds value to `selectedIndex`.');
                    }
                    if (this._selectedIndex != index &&
                        !this._anyControlsInvalidOrPending(index) &&
                        (index >= this._selectedIndex || this._steps.toArray()[index].editable)) {
                        this._updateSelectedItemIndex(index);
                    }
                }
                else {
                    this._selectedIndex = index;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkStepper.prototype, "selected", {
            get: /**
             * The step that is selected.
             * @return {?}
             */
            function () {
                // @deletion-target 7.0.0 Change return type to `CdkStep | undefined`.
                return this._steps ? this._steps.toArray()[this.selectedIndex] : /** @type {?} */ ((undefined));
            },
            set: /**
             * @param {?} step
             * @return {?}
             */
            function (step) {
                this.selectedIndex = this._steps ? this._steps.toArray().indexOf(step) : -1;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkStepper.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._keyManager = new FocusKeyManager(this._stepHeader)
                .withWrap()
                .withVerticalOrientation(this._orientation === 'vertical');
            (this._dir ? /** @type {?} */ (this._dir.change) : rxjs.of())
                .pipe(operators.startWith(this._layoutDirection()), operators.takeUntil(this._destroyed))
                .subscribe(function (direction) { return _this._keyManager.withHorizontalOrientation(direction); });
            this._keyManager.updateActiveItemIndex(this._selectedIndex);
        };
        /**
         * @return {?}
         */
        CdkStepper.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroyed.next();
            this._destroyed.complete();
        };
        /** Selects and focuses the next step in list. */
        /**
         * Selects and focuses the next step in list.
         * @return {?}
         */
        CdkStepper.prototype.next = /**
         * Selects and focuses the next step in list.
         * @return {?}
         */
        function () {
            this.selectedIndex = Math.min(this._selectedIndex + 1, this._steps.length - 1);
        };
        /** Selects and focuses the previous step in list. */
        /**
         * Selects and focuses the previous step in list.
         * @return {?}
         */
        CdkStepper.prototype.previous = /**
         * Selects and focuses the previous step in list.
         * @return {?}
         */
        function () {
            this.selectedIndex = Math.max(this._selectedIndex - 1, 0);
        };
        /** Resets the stepper to its initial state. Note that this includes clearing form data. */
        /**
         * Resets the stepper to its initial state. Note that this includes clearing form data.
         * @return {?}
         */
        CdkStepper.prototype.reset = /**
         * Resets the stepper to its initial state. Note that this includes clearing form data.
         * @return {?}
         */
        function () {
            this._updateSelectedItemIndex(0);
            this._steps.forEach(function (step) { return step.reset(); });
            this._stateChanged();
        };
        /** Returns a unique id for each step label element. */
        /**
         * Returns a unique id for each step label element.
         * @param {?} i
         * @return {?}
         */
        CdkStepper.prototype._getStepLabelId = /**
         * Returns a unique id for each step label element.
         * @param {?} i
         * @return {?}
         */
        function (i) {
            return "cdk-step-label-" + this._groupId + "-" + i;
        };
        /** Returns unique id for each step content element. */
        /**
         * Returns unique id for each step content element.
         * @param {?} i
         * @return {?}
         */
        CdkStepper.prototype._getStepContentId = /**
         * Returns unique id for each step content element.
         * @param {?} i
         * @return {?}
         */
        function (i) {
            return "cdk-step-content-" + this._groupId + "-" + i;
        };
        /** Marks the component to be change detected. */
        /**
         * Marks the component to be change detected.
         * @return {?}
         */
        CdkStepper.prototype._stateChanged = /**
         * Marks the component to be change detected.
         * @return {?}
         */
        function () {
            this._changeDetectorRef.markForCheck();
        };
        /** Returns position state of the step with the given index. */
        /**
         * Returns position state of the step with the given index.
         * @param {?} index
         * @return {?}
         */
        CdkStepper.prototype._getAnimationDirection = /**
         * Returns position state of the step with the given index.
         * @param {?} index
         * @return {?}
         */
        function (index) {
            var /** @type {?} */ position = index - this._selectedIndex;
            if (position < 0) {
                return this._layoutDirection() === 'rtl' ? 'next' : 'previous';
            }
            else if (position > 0) {
                return this._layoutDirection() === 'rtl' ? 'previous' : 'next';
            }
            return 'current';
        };
        /** Returns the type of icon to be displayed. */
        /**
         * Returns the type of icon to be displayed.
         * @param {?} index
         * @return {?}
         */
        CdkStepper.prototype._getIndicatorType = /**
         * Returns the type of icon to be displayed.
         * @param {?} index
         * @return {?}
         */
        function (index) {
            var /** @type {?} */ step = this._steps.toArray()[index];
            if (!step.completed || this._selectedIndex == index) {
                return 'number';
            }
            else {
                return step.editable ? 'edit' : 'done';
            }
        };
        /** Returns the index of the currently-focused step header. */
        /**
         * Returns the index of the currently-focused step header.
         * @return {?}
         */
        CdkStepper.prototype._getFocusIndex = /**
         * Returns the index of the currently-focused step header.
         * @return {?}
         */
        function () {
            return this._keyManager ? this._keyManager.activeItemIndex : this._selectedIndex;
        };
        /**
         * @param {?} newIndex
         * @return {?}
         */
        CdkStepper.prototype._updateSelectedItemIndex = /**
         * @param {?} newIndex
         * @return {?}
         */
        function (newIndex) {
            var /** @type {?} */ stepsArray = this._steps.toArray();
            this.selectionChange.emit({
                selectedIndex: newIndex,
                previouslySelectedIndex: this._selectedIndex,
                selectedStep: stepsArray[newIndex],
                previouslySelectedStep: stepsArray[this._selectedIndex],
            });
            this._keyManager.updateActiveItemIndex(newIndex);
            this._selectedIndex = newIndex;
            this._stateChanged();
        };
        /**
         * @param {?} event
         * @return {?}
         */
        CdkStepper.prototype._onKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ keyCode = event.keyCode;
            if (this._keyManager.activeItemIndex != null && (keyCode === SPACE || keyCode === ENTER)) {
                this.selectedIndex = this._keyManager.activeItemIndex;
                event.preventDefault();
            }
            else if (keyCode === HOME) {
                this._keyManager.setFirstItemActive();
                event.preventDefault();
            }
            else if (keyCode === END) {
                this._keyManager.setLastItemActive();
                event.preventDefault();
            }
            else {
                this._keyManager.onKeydown(event);
            }
        };
        /**
         * @param {?} index
         * @return {?}
         */
        CdkStepper.prototype._anyControlsInvalidOrPending = /**
         * @param {?} index
         * @return {?}
         */
        function (index) {
            var /** @type {?} */ steps = this._steps.toArray();
            steps[this._selectedIndex].interacted = true;
            if (this._linear && index >= 0) {
                return steps.slice(0, index).some(function (step) {
                    var /** @type {?} */ control = step.stepControl;
                    var /** @type {?} */ isIncomplete = control ?
                        (control.invalid || control.pending || !step.interacted) :
                        !step.completed;
                    return isIncomplete && !step.optional;
                });
            }
            return false;
        };
        /**
         * @return {?}
         */
        CdkStepper.prototype._layoutDirection = /**
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
        };
        CdkStepper.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkStepper]',
                        exportAs: 'cdkStepper',
                    },] },
        ];
        /** @nocollapse */
        CdkStepper.ctorParameters = function () { return [
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: core.ChangeDetectorRef, },
        ]; };
        CdkStepper.propDecorators = {
            "_steps": [{ type: core.ContentChildren, args: [CdkStep,] },],
            "linear": [{ type: core.Input },],
            "selectedIndex": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "selectionChange": [{ type: core.Output },],
        };
        return CdkStepper;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Button that moves to the next step in a stepper workflow.
     */
    var CdkStepperNext = /** @class */ (function () {
        function CdkStepperNext(_stepper) {
            this._stepper = _stepper;
            /**
             * Type of the next button. Defaults to "submit" if not specified.
             */
            this.type = 'submit';
        }
        CdkStepperNext.decorators = [
            { type: core.Directive, args: [{
                        selector: 'button[cdkStepperNext]',
                        host: {
                            '(click)': '_stepper.next()',
                            '[type]': 'type',
                        }
                    },] },
        ];
        /** @nocollapse */
        CdkStepperNext.ctorParameters = function () { return [
            { type: CdkStepper, },
        ]; };
        CdkStepperNext.propDecorators = {
            "type": [{ type: core.Input },],
        };
        return CdkStepperNext;
    }());
    /**
     * Button that moves to the previous step in a stepper workflow.
     */
    var CdkStepperPrevious = /** @class */ (function () {
        function CdkStepperPrevious(_stepper) {
            this._stepper = _stepper;
            /**
             * Type of the previous button. Defaults to "button" if not specified.
             */
            this.type = 'button';
        }
        CdkStepperPrevious.decorators = [
            { type: core.Directive, args: [{
                        selector: 'button[cdkStepperPrevious]',
                        host: {
                            '(click)': '_stepper.previous()',
                            '[type]': 'type',
                        }
                    },] },
        ];
        /** @nocollapse */
        CdkStepperPrevious.ctorParameters = function () { return [
            { type: CdkStepper, },
        ]; };
        CdkStepperPrevious.propDecorators = {
            "type": [{ type: core.Input },],
        };
        return CdkStepperPrevious;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatStepLabel = /** @class */ (function (_super) {
        __extends(MatStepLabel, _super);
        function MatStepLabel(template) {
            return _super.call(this, template) || this;
        }
        MatStepLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matStepLabel]',
                    },] },
        ];
        /** @nocollapse */
        MatStepLabel.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatStepLabel;
    }(CdkStepLabel));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Stepper data that is required for internationalization.
     */
    var MatStepperIntl = /** @class */ (function () {
        function MatStepperIntl() {
            /**
             * Stream that emits whenever the labels here are changed. Use this to notify
             * components if the labels have changed after initialization.
             */
            this.changes = new rxjs.Subject();
            /**
             * Label that is rendered below optional steps.
             */
            this.optionalLabel = 'Optional';
        }
        MatStepperIntl.decorators = [
            { type: core.Injectable, args: [{ providedIn: 'root' },] },
        ];
        /** @nocollapse */ MatStepperIntl.ngInjectableDef = core.defineInjectable({ factory: function MatStepperIntl_Factory() { return new MatStepperIntl(); }, token: MatStepperIntl, providedIn: "root" });
        return MatStepperIntl;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatStepHeader = /** @class */ (function () {
        function MatStepHeader(_intl, _focusMonitor, _element, changeDetectorRef) {
            this._intl = _intl;
            this._focusMonitor = _focusMonitor;
            this._element = _element;
            _focusMonitor.monitor(_element.nativeElement, true);
            this._intlSubscription = _intl.changes.subscribe(function () { return changeDetectorRef.markForCheck(); });
        }
        /**
         * @return {?}
         */
        MatStepHeader.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._intlSubscription.unsubscribe();
            this._focusMonitor.stopMonitoring(this._element.nativeElement);
        };
        /** Returns string label of given step if it is a text label. */
        /**
         * Returns string label of given step if it is a text label.
         * @return {?}
         */
        MatStepHeader.prototype._stringLabel = /**
         * Returns string label of given step if it is a text label.
         * @return {?}
         */
        function () {
            return this.label instanceof MatStepLabel ? null : this.label;
        };
        /** Returns MatStepLabel if the label of given step is a template label. */
        /**
         * Returns MatStepLabel if the label of given step is a template label.
         * @return {?}
         */
        MatStepHeader.prototype._templateLabel = /**
         * Returns MatStepLabel if the label of given step is a template label.
         * @return {?}
         */
        function () {
            return this.label instanceof MatStepLabel ? this.label : null;
        };
        /** Returns the host HTML element. */
        /**
         * Returns the host HTML element.
         * @return {?}
         */
        MatStepHeader.prototype._getHostElement = /**
         * Returns the host HTML element.
         * @return {?}
         */
        function () {
            return this._element.nativeElement;
        };
        /** Template context variables that are exposed to the `matStepperIcon` instances. */
        /**
         * Template context variables that are exposed to the `matStepperIcon` instances.
         * @return {?}
         */
        MatStepHeader.prototype._getIconContext = /**
         * Template context variables that are exposed to the `matStepperIcon` instances.
         * @return {?}
         */
        function () {
            return {
                index: this.index,
                active: this.active,
                optional: this.optional
            };
        };
        /**
         * @return {?}
         */
        MatStepHeader.prototype.focus = /**
         * @return {?}
         */
        function () {
            this._getHostElement().focus();
        };
        MatStepHeader.decorators = [
            { type: core.Component, args: [{selector: 'mat-step-header',
                        template: "<div class=\"mat-step-header-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\"></div><div [class.mat-step-icon]=\"state !== 'number' || selected\" [class.mat-step-icon-not-touched]=\"state == 'number' && !selected\" [ngSwitch]=\"state\"><ng-container *ngSwitchCase=\"'number'\" [ngSwitch]=\"!!(iconOverrides && iconOverrides.number)\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides.number\" [ngTemplateOutletContext]=\"_getIconContext()\"></ng-container><span *ngSwitchDefault>{{index + 1}}</span></ng-container><ng-container *ngSwitchCase=\"'edit'\" [ngSwitch]=\"!!(iconOverrides && iconOverrides.edit)\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides.edit\" [ngTemplateOutletContext]=\"_getIconContext()\"></ng-container><mat-icon *ngSwitchDefault>create</mat-icon></ng-container><ng-container *ngSwitchCase=\"'done'\" [ngSwitch]=\"!!(iconOverrides && iconOverrides.done)\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides.done\" [ngTemplateOutletContext]=\"_getIconContext()\"></ng-container><mat-icon *ngSwitchDefault>done</mat-icon></ng-container></div><div class=\"mat-step-label\" [class.mat-step-label-active]=\"active\" [class.mat-step-label-selected]=\"selected\"><ng-container *ngIf=\"_templateLabel()\" [ngTemplateOutlet]=\"_templateLabel()!.template\"></ng-container><div class=\"mat-step-text-label\" *ngIf=\"_stringLabel()\">{{label}}</div><div class=\"mat-step-optional\" *ngIf=\"optional\">{{_intl.optionalLabel}}</div></div>",
                        styles: [".mat-step-header{overflow:hidden;outline:0;cursor:pointer;position:relative;box-sizing:content-box}.mat-step-optional{font-size:12px}.mat-step-icon,.mat-step-icon-not-touched{border-radius:50%;height:24px;width:24px;align-items:center;justify-content:center;display:flex;flex-shrink:0}.mat-step-icon .mat-icon{font-size:16px;height:16px;width:16px}.mat-step-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:50px;vertical-align:middle}.mat-step-text-label{text-overflow:ellipsis;overflow:hidden}.mat-step-header-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
                        host: {
                            'class': 'mat-step-header',
                            'role': 'tab',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatStepHeader.ctorParameters = function () { return [
            { type: MatStepperIntl, },
            { type: FocusMonitor, },
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatStepHeader.propDecorators = {
            "state": [{ type: core.Input },],
            "label": [{ type: core.Input },],
            "iconOverrides": [{ type: core.Input },],
            "index": [{ type: core.Input },],
            "selected": [{ type: core.Input },],
            "active": [{ type: core.Input },],
            "optional": [{ type: core.Input },],
        };
        return MatStepHeader;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material steppers.
     */
    var /** @type {?} */ matStepperAnimations = {
        /** Animation that transitions the step along the X axis in a horizontal stepper. */
        horizontalStepTransition: trigger('stepTransition', [
            state('previous', style({ transform: 'translate3d(-100%, 0, 0)', visibility: 'hidden' })),
            state('current', style({ transform: 'none', visibility: 'visible' })),
            state('next', style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
            transition('* => *', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)'))
        ]),
        /** Animation that transitions the step along the Y axis in a vertical stepper. */
        verticalStepTransition: trigger('stepTransition', [
            state('previous', style({ height: '0px', visibility: 'hidden' })),
            state('next', style({ height: '0px', visibility: 'hidden' })),
            state('current', style({ height: '*', visibility: 'visible' })),
            transition('* <=> current', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Template to be used to override the icons inside the step header.
     */
    var MatStepperIcon = /** @class */ (function () {
        function MatStepperIcon(templateRef) {
            this.templateRef = templateRef;
        }
        MatStepperIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: 'ng-template[matStepperIcon]',
                    },] },
        ];
        /** @nocollapse */
        MatStepperIcon.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        MatStepperIcon.propDecorators = {
            "name": [{ type: core.Input, args: ['matStepperIcon',] },],
        };
        return MatStepperIcon;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatStep = /** @class */ (function (_super) {
        __extends(MatStep, _super);
        function MatStep(stepper, _errorStateMatcher) {
            var _this = _super.call(this, stepper) || this;
            _this._errorStateMatcher = _errorStateMatcher;
            return _this;
        }
        /** Custom error state matcher that additionally checks for validity of interacted form. */
        /**
         * Custom error state matcher that additionally checks for validity of interacted form.
         * @param {?} control
         * @param {?} form
         * @return {?}
         */
        MatStep.prototype.isErrorState = /**
         * Custom error state matcher that additionally checks for validity of interacted form.
         * @param {?} control
         * @param {?} form
         * @return {?}
         */
        function (control, form) {
            var /** @type {?} */ originalErrorState = this._errorStateMatcher.isErrorState(control, form);
            // Custom error state checks for the validity of form that is not submitted or touched
            // since user can trigger a form change by calling for another step without directly
            // interacting with the current form.
            var /** @type {?} */ customErrorState = !!(control && control.invalid && this.interacted);
            return originalErrorState || customErrorState;
        };
        MatStep.decorators = [
            { type: core.Component, args: [{selector: 'mat-step',
                        template: "<ng-template><ng-content></ng-content></ng-template>",
                        providers: [{ provide: ErrorStateMatcher, useExisting: MatStep }],
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matStep',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatStep.ctorParameters = function () { return [
            { type: MatStepper, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatStepper; }),] },] },
            { type: ErrorStateMatcher, decorators: [{ type: core.SkipSelf },] },
        ]; };
        MatStep.propDecorators = {
            "stepLabel": [{ type: core.ContentChild, args: [MatStepLabel,] },],
        };
        return MatStep;
    }(CdkStep));
    var MatStepper = /** @class */ (function (_super) {
        __extends(MatStepper, _super);
        function MatStepper() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /**
             * Event emitted when the current step is done transitioning in.
             */
            _this.animationDone = new core.EventEmitter();
            /**
             * Consumer-specified template-refs to be used to override the header icons.
             */
            _this._iconOverrides = {};
            return _this;
        }
        /**
         * @return {?}
         */
        MatStepper.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ icons = this._icons.toArray();
            ['edit', 'done', 'number'].forEach(function (name) {
                var /** @type {?} */ override = icons.find(function (icon) { return icon.name === name; });
                if (override) {
                    _this._iconOverrides[name] = override.templateRef;
                }
            });
            // Mark the component for change detection whenever the content children query changes
            this._steps.changes.pipe(operators.takeUntil(this._destroyed)).subscribe(function () { return _this._stateChanged(); });
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatStepper.prototype._animationDone = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if ((/** @type {?} */ (event.toState)) === 'current') {
                this.animationDone.emit();
            }
        };
        MatStepper.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matStepper]'
                    },] },
        ];
        /** @nocollapse */
        MatStepper.propDecorators = {
            "_stepHeader": [{ type: core.ViewChildren, args: [MatStepHeader,] },],
            "_steps": [{ type: core.ContentChildren, args: [MatStep,] },],
            "_icons": [{ type: core.ContentChildren, args: [MatStepperIcon,] },],
            "animationDone": [{ type: core.Output },],
        };
        return MatStepper;
    }(CdkStepper));
    var MatHorizontalStepper = /** @class */ (function (_super) {
        __extends(MatHorizontalStepper, _super);
        function MatHorizontalStepper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatHorizontalStepper.decorators = [
            { type: core.Component, args: [{selector: 'mat-horizontal-stepper',
                        exportAs: 'matHorizontalStepper',
                        template: "<div class=\"mat-horizontal-stepper-header-container\"><ng-container *ngFor=\"let step of _steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-horizontal-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_getFocusIndex() === i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"_steps.length\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [index]=\"i\" [state]=\"_getIndicatorType(i)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [iconOverrides]=\"_iconOverrides\"></mat-step-header><div *ngIf=\"!isLast\" class=\"mat-stepper-horizontal-line\"></div></ng-container></div><div class=\"mat-horizontal-content-container\"><div *ngFor=\"let step of _steps; let i = index\" class=\"mat-horizontal-stepper-content\" role=\"tabpanel\" [@stepTransition]=\"_getAnimationDirection(i)\" (@stepTransition.done)=\"_animationDone($event)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div>",
                        styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon,.mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon,[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:8px}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;max-height:24px}.mat-vertical-stepper-header .mat-step-icon,.mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon,[dir=rtl] .mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
                        inputs: ['selectedIndex'],
                        host: {
                            'class': 'mat-stepper-horizontal',
                            'aria-orientation': 'horizontal',
                            'role': 'tablist',
                        },
                        animations: [matStepperAnimations.horizontalStepTransition],
                        providers: [{ provide: MatStepper, useExisting: MatHorizontalStepper }],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        return MatHorizontalStepper;
    }(MatStepper));
    var MatVerticalStepper = /** @class */ (function (_super) {
        __extends(MatVerticalStepper, _super);
        function MatVerticalStepper(dir, changeDetectorRef) {
            var _this = _super.call(this, dir, changeDetectorRef) || this;
            _this._orientation = 'vertical';
            return _this;
        }
        MatVerticalStepper.decorators = [
            { type: core.Component, args: [{selector: 'mat-vertical-stepper',
                        exportAs: 'matVerticalStepper',
                        template: "<div class=\"mat-step\" *ngFor=\"let step of _steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-vertical-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_getFocusIndex() == i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"_steps.length\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex === i\" [index]=\"i\" [state]=\"_getIndicatorType(i)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [iconOverrides]=\"_iconOverrides\"></mat-step-header><div class=\"mat-vertical-content-container\" [class.mat-stepper-vertical-line]=\"!isLast\"><div class=\"mat-vertical-stepper-content\" role=\"tabpanel\" [@stepTransition]=\"_getAnimationDirection(i)\" (@stepTransition.done)=\"_animationDone($event)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><div class=\"mat-vertical-content\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div></div></div>",
                        styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon,.mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon,[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:8px}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;max-height:24px}.mat-vertical-stepper-header .mat-step-icon,.mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon,[dir=rtl] .mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content[aria-expanded=false]{height:0;overflow:hidden}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
                        inputs: ['selectedIndex'],
                        host: {
                            'class': 'mat-stepper-vertical',
                            'aria-orientation': 'vertical',
                            'role': 'tablist',
                        },
                        animations: [matStepperAnimations.verticalStepTransition],
                        providers: [{ provide: MatStepper, useExisting: MatVerticalStepper }],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatVerticalStepper.ctorParameters = function () { return [
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: core.ChangeDetectorRef, },
        ]; };
        return MatVerticalStepper;
    }(MatStepper));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Button that moves to the next step in a stepper workflow.
     */
    var MatStepperNext = /** @class */ (function (_super) {
        __extends(MatStepperNext, _super);
        function MatStepperNext() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatStepperNext.decorators = [
            { type: core.Directive, args: [{
                        selector: 'button[matStepperNext]',
                        host: {
                            '(click)': '_stepper.next()',
                            '[type]': 'type',
                        },
                        inputs: ['type'],
                        providers: [{ provide: CdkStepper, useExisting: MatStepper }]
                    },] },
        ];
        return MatStepperNext;
    }(CdkStepperNext));
    /**
     * Button that moves to the previous step in a stepper workflow.
     */
    var MatStepperPrevious = /** @class */ (function (_super) {
        __extends(MatStepperPrevious, _super);
        function MatStepperPrevious() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatStepperPrevious.decorators = [
            { type: core.Directive, args: [{
                        selector: 'button[matStepperPrevious]',
                        host: {
                            '(click)': '_stepper.previous()',
                            '[type]': 'type',
                        },
                        inputs: ['type'],
                        providers: [{ provide: CdkStepper, useExisting: MatStepper }]
                    },] },
        ];
        return MatStepperPrevious;
    }(CdkStepperPrevious));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Wrapper for the CdkTable with Material design styles.
     * @template T
     */
    var MatTable = /** @class */ (function (_super) {
        __extends(MatTable, _super);
        // TODO(andrewseguin): Remove this explicitly set constructor when the compiler knows how to
        // properly build the es6 version of the class. Currently sets ctorParameters to empty due to a
        // fixed bug.
        // https://github.com/angular/tsickle/pull/760 - tsickle PR that fixed this
        // https://github.com/angular/angular/pull/23531 - updates compiler-cli to fixed version
        function MatTable(_differs, _changeDetectorRef, _elementRef, role, _dir) {
            var _this = _super.call(this, _differs, _changeDetectorRef, _elementRef, role, _dir) || this;
            _this._differs = _differs;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._elementRef = _elementRef;
            _this._dir = _dir;
            /**
             * Overrides the sticky CSS class set by the `CdkTable`.
             */
            _this.stickyCssClass = 'mat-table-sticky';
            return _this;
        }
        MatTable.decorators = [
            { type: core.Component, args: [{selector: 'mat-table, table[mat-table]',
                        exportAs: 'matTable',
                        template: CDK_TABLE_TEMPLATE,
                        styles: ["mat-table{display:block}mat-header-row{min-height:56px}mat-footer-row,mat-row{min-height:48px}mat-footer-row,mat-header-row,mat-row{display:flex;border-width:0;border-bottom-width:1px;border-style:solid;align-items:center;box-sizing:border-box}mat-footer-row::after,mat-header-row::after,mat-row::after{display:inline-block;min-height:inherit;content:''}mat-cell:first-child,mat-footer-cell:first-child,mat-header-cell:first-child{padding-left:24px}[dir=rtl] mat-cell:first-child,[dir=rtl] mat-footer-cell:first-child,[dir=rtl] mat-header-cell:first-child{padding-left:0;padding-right:24px}mat-cell:last-child,mat-footer-cell:last-child,mat-header-cell:last-child{padding-right:24px}[dir=rtl] mat-cell:last-child,[dir=rtl] mat-footer-cell:last-child,[dir=rtl] mat-header-cell:last-child{padding-right:0;padding-left:24px}mat-cell,mat-footer-cell,mat-header-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}table.mat-table{border-spacing:0}tr.mat-header-row{height:56px}tr.mat-footer-row,tr.mat-row{height:48px}th.mat-header-cell{text-align:left}td.mat-cell,td.mat-footer-cell,th.mat-header-cell{padding:0;border-bottom-width:1px;border-bottom-style:solid}td.mat-cell:first-child,td.mat-footer-cell:first-child,th.mat-header-cell:first-child{padding-left:24px}td.mat-cell:last-child,td.mat-footer-cell:last-child,th.mat-header-cell:last-child{padding-right:24px}"],
                        host: {
                            'class': 'mat-table',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatTable.ctorParameters = function () { return [
            { type: core.IterableDiffers, },
            { type: core.ChangeDetectorRef, },
            { type: core.ElementRef, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['role',] },] },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        return MatTable;
    }(CdkTable));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Cell definition for the mat-table.
     * Captures the template of a column's data row cell as well as cell-specific properties.
     */
    var MatCellDef = /** @class */ (function (_super) {
        __extends(MatCellDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatCellDef(template) {
            var _this = _super.call(this, template) || this;
            _this.template = template;
            return _this;
        }
        MatCellDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matCellDef]',
                        providers: [{ provide: CdkCellDef, useExisting: MatCellDef }]
                    },] },
        ];
        /** @nocollapse */
        MatCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatCellDef;
    }(CdkCellDef));
    /**
     * Header cell definition for the mat-table.
     * Captures the template of a column's header cell and as well as cell-specific properties.
     */
    var MatHeaderCellDef = /** @class */ (function (_super) {
        __extends(MatHeaderCellDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatHeaderCellDef(template) {
            var _this = _super.call(this, template) || this;
            _this.template = template;
            return _this;
        }
        MatHeaderCellDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matHeaderCellDef]',
                        providers: [{ provide: CdkHeaderCellDef, useExisting: MatHeaderCellDef }]
                    },] },
        ];
        /** @nocollapse */
        MatHeaderCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatHeaderCellDef;
    }(CdkHeaderCellDef));
    /**
     * Footer cell definition for the mat-table.
     * Captures the template of a column's footer cell and as well as cell-specific properties.
     */
    var MatFooterCellDef = /** @class */ (function (_super) {
        __extends(MatFooterCellDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatFooterCellDef(template) {
            var _this = _super.call(this, template) || this;
            _this.template = template;
            return _this;
        }
        MatFooterCellDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matFooterCellDef]',
                        providers: [{ provide: CdkFooterCellDef, useExisting: MatFooterCellDef }]
                    },] },
        ];
        /** @nocollapse */
        MatFooterCellDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatFooterCellDef;
    }(CdkFooterCellDef));
    /**
     * Column definition for the mat-table.
     * Defines a set of cells available for a table column.
     */
    var MatColumnDef = /** @class */ (function (_super) {
        __extends(MatColumnDef, _super);
        function MatColumnDef() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatColumnDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matColumnDef]',
                        providers: [{ provide: CdkColumnDef, useExisting: MatColumnDef }],
                    },] },
        ];
        /** @nocollapse */
        MatColumnDef.propDecorators = {
            "name": [{ type: core.Input, args: ['matColumnDef',] },],
            "sticky": [{ type: core.Input },],
            "stickyEnd": [{ type: core.Input },],
        };
        return MatColumnDef;
    }(CdkColumnDef));
    /**
     * Header cell template container that adds the right classes and role.
     */
    var MatHeaderCell = /** @class */ (function (_super) {
        __extends(MatHeaderCell, _super);
        function MatHeaderCell(columnDef, elementRef) {
            var _this = _super.call(this, columnDef, elementRef) || this;
            elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
            return _this;
        }
        MatHeaderCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-header-cell, th[mat-header-cell]',
                        host: {
                            'class': 'mat-header-cell',
                            'role': 'columnheader',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatHeaderCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return MatHeaderCell;
    }(CdkHeaderCell));
    /**
     * Footer cell template container that adds the right classes and role.
     */
    var MatFooterCell = /** @class */ (function (_super) {
        __extends(MatFooterCell, _super);
        function MatFooterCell(columnDef, elementRef) {
            var _this = _super.call(this, columnDef, elementRef) || this;
            elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
            return _this;
        }
        MatFooterCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-footer-cell, td[mat-footer-cell]',
                        host: {
                            'class': 'mat-footer-cell',
                            'role': 'gridcell',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatFooterCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return MatFooterCell;
    }(CdkFooterCell));
    /**
     * Cell template container that adds the right classes and role.
     */
    var MatCell = /** @class */ (function (_super) {
        __extends(MatCell, _super);
        function MatCell(columnDef, elementRef) {
            var _this = _super.call(this, columnDef, elementRef) || this;
            elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
            return _this;
        }
        MatCell.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-cell, td[mat-cell]',
                        host: {
                            'class': 'mat-cell',
                            'role': 'gridcell',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatCell.ctorParameters = function () { return [
            { type: CdkColumnDef, },
            { type: core.ElementRef, },
        ]; };
        return MatCell;
    }(CdkCell));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Header row definition for the mat-table.
     * Captures the header row's template and other header properties such as the columns to display.
     */
    var MatHeaderRowDef = /** @class */ (function (_super) {
        __extends(MatHeaderRowDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatHeaderRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        MatHeaderRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matHeaderRowDef]',
                        providers: [{ provide: CdkHeaderRowDef, useExisting: MatHeaderRowDef }],
                        inputs: ['columns: matHeaderRowDef', 'sticky: matHeaderRowDefSticky'],
                    },] },
        ];
        /** @nocollapse */
        MatHeaderRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return MatHeaderRowDef;
    }(CdkHeaderRowDef));
    /**
     * Footer row definition for the mat-table.
     * Captures the footer row's template and other footer properties such as the columns to display.
     */
    var MatFooterRowDef = /** @class */ (function (_super) {
        __extends(MatFooterRowDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatFooterRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        MatFooterRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matFooterRowDef]',
                        providers: [{ provide: CdkFooterRowDef, useExisting: MatFooterRowDef }],
                        inputs: ['columns: matFooterRowDef', 'sticky: matFooterRowDefSticky'],
                    },] },
        ];
        /** @nocollapse */
        MatFooterRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return MatFooterRowDef;
    }(CdkFooterRowDef));
    /**
     * Data row definition for the mat-table.
     * Captures the footer row's template and other footer properties such as the columns to display and
     * a when predicate that describes when this row should be used.
     * @template T
     */
    var MatRowDef = /** @class */ (function (_super) {
        __extends(MatRowDef, _super);
        // TODO(andrewseguin): Remove this constructor after compiler-cli is updated; see issue #9329
        function MatRowDef(template, _differs) {
            return _super.call(this, template, _differs) || this;
        }
        MatRowDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matRowDef]',
                        providers: [{ provide: CdkRowDef, useExisting: MatRowDef }],
                        inputs: ['columns: matRowDefColumns', 'when: matRowDefWhen'],
                    },] },
        ];
        /** @nocollapse */
        MatRowDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.IterableDiffers, },
        ]; };
        return MatRowDef;
    }(CdkRowDef));
    /**
     * Footer template container that contains the cell outlet. Adds the right class and role.
     */
    var MatHeaderRow = /** @class */ (function (_super) {
        __extends(MatHeaderRow, _super);
        function MatHeaderRow() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatHeaderRow.decorators = [
            { type: core.Component, args: [{selector: 'mat-header-row, tr[mat-header-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'mat-header-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matHeaderRow',
                        providers: [{ provide: CdkHeaderRow, useExisting: MatHeaderRow }],
                    },] },
        ];
        return MatHeaderRow;
    }(CdkHeaderRow));
    /**
     * Footer template container that contains the cell outlet. Adds the right class and role.
     */
    var MatFooterRow = /** @class */ (function (_super) {
        __extends(MatFooterRow, _super);
        function MatFooterRow() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatFooterRow.decorators = [
            { type: core.Component, args: [{selector: 'mat-footer-row, tr[mat-footer-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'mat-footer-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matFooterRow',
                        providers: [{ provide: CdkFooterRow, useExisting: MatFooterRow }],
                    },] },
        ];
        return MatFooterRow;
    }(CdkFooterRow));
    /**
     * Data row template container that contains the cell outlet. Adds the right class and role.
     */
    var MatRow = /** @class */ (function (_super) {
        __extends(MatRow, _super);
        function MatRow() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatRow.decorators = [
            { type: core.Component, args: [{selector: 'mat-row, tr[mat-row]',
                        template: CDK_ROW_TEMPLATE,
                        host: {
                            'class': 'mat-row',
                            'role': 'row',
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matRow',
                        providers: [{ provide: CdkRow, useExisting: MatRow }],
                    },] },
        ];
        return MatRow;
    }(CdkRow));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ EXPORTED_DECLARATIONS$1 = [
        MatTable,
        MatHeaderCellDef,
        MatHeaderRowDef,
        MatColumnDef,
        MatCellDef,
        MatRowDef,
        MatFooterCellDef,
        MatFooterRowDef,
        MatHeaderCell,
        MatCell,
        MatFooterCell,
        MatHeaderRow,
        MatRow,
        MatFooterRow,
    ];
    var MatTableModule = /** @class */ (function () {
        function MatTableModule() {
        }
        MatTableModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [CdkTableModule, common.CommonModule, MatCommonModule],
                        exports: EXPORTED_DECLARATIONS$1,
                        declarations: EXPORTED_DECLARATIONS$1,
                    },] },
        ];
        return MatTableModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Data source that accepts a client-side data array and includes native support of filtering,
     * sorting (using MatSort), and pagination (using MatPaginator).
     *
     * Allows for sort customization by overriding sortingDataAccessor, which defines how data
     * properties are accessed. Also allows for filter customization by overriding filterTermAccessor,
     * which defines how row data is converted to a string for filter matching.
     * @template T
     */
    var  /**
     * Data source that accepts a client-side data array and includes native support of filtering,
     * sorting (using MatSort), and pagination (using MatPaginator).
     *
     * Allows for sort customization by overriding sortingDataAccessor, which defines how data
     * properties are accessed. Also allows for filter customization by overriding filterTermAccessor,
     * which defines how row data is converted to a string for filter matching.
     * @template T
     */
    MatTableDataSource = /** @class */ (function (_super) {
        __extends(MatTableDataSource, _super);
        function MatTableDataSource(initialData) {
            if (initialData === void 0) { initialData = []; }
            var _this = _super.call(this) || this;
            /**
             * Stream emitting render data to the table (depends on ordered data changes).
             */
            _this._renderData = new rxjs.BehaviorSubject([]);
            /**
             * Stream that emits when a new filter string is set on the data source.
             */
            _this._filter = new rxjs.BehaviorSubject('');
            /**
             * Subscription to the changes that should trigger an update to the table's rendered rows, such
             * as filtering, sorting, pagination, or base data changes.
             */
            _this._renderChangesSubscription = rxjs.Subscription.EMPTY;
            /**
             * Data accessor function that is used for accessing data properties for sorting through
             * the default sortData function.
             * This default function assumes that the sort header IDs (which defaults to the column name)
             * matches the data's properties (e.g. column Xyz represents data['Xyz']).
             * May be set to a custom function for different behavior.
             * @param data Data object that is being accessed.
             * @param sortHeaderId The name of the column that represents the data.
             */
            _this.sortingDataAccessor = function (data, sortHeaderId) {
                var /** @type {?} */ value = data[sortHeaderId];
                return _isNumberValue(value) ? Number(value) : value;
            };
            /**
             * Gets a sorted copy of the data array based on the state of the MatSort. Called
             * after changes are made to the filtered data or when sort changes are emitted from MatSort.
             * By default, the function retrieves the active sort and its direction and compares data
             * by retrieving data using the sortingDataAccessor. May be overridden for a custom implementation
             * of data ordering.
             * @param data The array of data that should be sorted.
             * @param sort The connected MatSort that holds the current sort state.
             */
            _this.sortData = function (data, sort) {
                var /** @type {?} */ active = sort.active;
                var /** @type {?} */ direction = sort.direction;
                if (!active || direction == '') {
                    return data;
                }
                return data.sort(function (a, b) {
                    var /** @type {?} */ valueA = _this.sortingDataAccessor(a, active);
                    var /** @type {?} */ valueB = _this.sortingDataAccessor(b, active);
                    // If both valueA and valueB exist (truthy), then compare the two. Otherwise, check if
                    // one value exists while the other doesn't. In this case, existing value should come first.
                    // This avoids inconsistent results when comparing values to undefined/null.
                    // If neither value exists, return 0 (equal).
                    var /** @type {?} */ comparatorResult = 0;
                    if (valueA != null && valueB != null) {
                        // Check if one value is greater than the other; if equal, comparatorResult should remain 0.
                        if (valueA > valueB) {
                            comparatorResult = 1;
                        }
                        else if (valueA < valueB) {
                            comparatorResult = -1;
                        }
                    }
                    else if (valueA != null) {
                        comparatorResult = 1;
                    }
                    else if (valueB != null) {
                        comparatorResult = -1;
                    }
                    return comparatorResult * (direction == 'asc' ? 1 : -1);
                });
            };
            /**
             * Checks if a data object matches the data source's filter string. By default, each data object
             * is converted to a string of its properties and returns true if the filter has
             * at least one occurrence in that string. By default, the filter string has its whitespace
             * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
             * filter matching.
             * @param data Data object used to check against the filter.
             * @param filter Filter string that has been set on the data source.
             * @return Whether the filter matches against the data
             */
            _this.filterPredicate = function (data, filter) {
                // Transform the data into a lowercase string of all property values.
                var /** @type {?} */ accumulator = function (currentTerm, key) { return currentTerm + data[key]; };
                var /** @type {?} */ dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                // Transform the filter by converting it to lowercase and removing whitespace.
                var /** @type {?} */ transformedFilter = filter.trim().toLowerCase();
                return dataStr.indexOf(transformedFilter) != -1;
            };
            _this._data = new rxjs.BehaviorSubject(initialData);
            _this._updateChangeSubscription();
            return _this;
        }
        Object.defineProperty(MatTableDataSource.prototype, "data", {
            /** Array of data that should be rendered by the table, where each object represents one row. */
            get: /**
             * Array of data that should be rendered by the table, where each object represents one row.
             * @return {?}
             */
            function () { return this._data.value; },
            set: /**
             * @param {?} data
             * @return {?}
             */
            function (data) { this._data.next(data); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTableDataSource.prototype, "filter", {
            /**
             * Filter term that should be used to filter out objects from the data array. To override how
             * data objects match to this filter string, provide a custom function for filterPredicate.
             */
            get: /**
             * Filter term that should be used to filter out objects from the data array. To override how
             * data objects match to this filter string, provide a custom function for filterPredicate.
             * @return {?}
             */
            function () { return this._filter.value; },
            set: /**
             * @param {?} filter
             * @return {?}
             */
            function (filter) { this._filter.next(filter); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTableDataSource.prototype, "sort", {
            /**
             * Instance of the MatSort directive used by the table to control its sorting. Sort changes
             * emitted by the MatSort will trigger an update to the table's rendered data.
             */
            get: /**
             * Instance of the MatSort directive used by the table to control its sorting. Sort changes
             * emitted by the MatSort will trigger an update to the table's rendered data.
             * @return {?}
             */
            function () { return this._sort; },
            set: /**
             * @param {?} sort
             * @return {?}
             */
            function (sort) {
                this._sort = sort;
                this._updateChangeSubscription();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTableDataSource.prototype, "paginator", {
            /**
             * Instance of the MatPaginator component used by the table to control what page of the data is
             * displayed. Page changes emitted by the MatPaginator will trigger an update to the
             * table's rendered data.
             *
             * Note that the data source uses the paginator's properties to calculate which page of data
             * should be displayed. If the paginator receives its properties as template inputs,
             * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
             * initialized before assigning it to this data source.
             */
            get: /**
             * Instance of the MatPaginator component used by the table to control what page of the data is
             * displayed. Page changes emitted by the MatPaginator will trigger an update to the
             * table's rendered data.
             *
             * Note that the data source uses the paginator's properties to calculate which page of data
             * should be displayed. If the paginator receives its properties as template inputs,
             * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
             * initialized before assigning it to this data source.
             * @return {?}
             */
            function () { return this._paginator; },
            set: /**
             * @param {?} paginator
             * @return {?}
             */
            function (paginator) {
                this._paginator = paginator;
                this._updateChangeSubscription();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Subscribe to changes that should trigger an update to the table's rendered rows. When the
         * changes occur, process the current state of the filter, sort, and pagination along with
         * the provided base data and send it to the table for rendering.
         */
        /**
         * Subscribe to changes that should trigger an update to the table's rendered rows. When the
         * changes occur, process the current state of the filter, sort, and pagination along with
         * the provided base data and send it to the table for rendering.
         * @return {?}
         */
        MatTableDataSource.prototype._updateChangeSubscription = /**
         * Subscribe to changes that should trigger an update to the table's rendered rows. When the
         * changes occur, process the current state of the filter, sort, and pagination along with
         * the provided base data and send it to the table for rendering.
         * @return {?}
         */
        function () {
            var _this = this;
            // Sorting and/or pagination should be watched if MatSort and/or MatPaginator are provided.
            // The events should emit whenever the component emits a change or initializes, or if no
            // component is provided, a stream with just a null event should be provided.
            // The `sortChange` and `pageChange` acts as a signal to the combineLatests below so that the
            // pipeline can progress to the next step. Note that the value from these streams are not used,
            // they purely act as a signal to progress in the pipeline.
            var /** @type {?} */ sortChange = this._sort ?
                rxjs.merge(this._sort.sortChange, this._sort.initialized) :
                rxjs.of(null);
            var /** @type {?} */ pageChange = this._paginator ?
                rxjs.merge(this._paginator.page, this._paginator.initialized) :
                rxjs.of(null);
            var /** @type {?} */ dataStream = this._data;
            // Watch for base data or filter changes to provide a filtered set of data.
            var /** @type {?} */ filteredData = rxjs.combineLatest(dataStream, this._filter)
                .pipe(operators.map(function (_a) {
                var data = _a[0];
                return _this._filterData(data);
            }));
            // Watch for filtered data or sort changes to provide an ordered set of data.
            var /** @type {?} */ orderedData = rxjs.combineLatest(filteredData, sortChange)
                .pipe(operators.map(function (_a) {
                var data = _a[0];
                return _this._orderData(data);
            }));
            // Watch for ordered data or page changes to provide a paged set of data.
            var /** @type {?} */ paginatedData = rxjs.combineLatest(orderedData, pageChange)
                .pipe(operators.map(function (_a) {
                var data = _a[0];
                return _this._pageData(data);
            }));
            // Watched for paged data changes and send the result to the table to render.
            this._renderChangesSubscription.unsubscribe();
            this._renderChangesSubscription = paginatedData.subscribe(function (data) { return _this._renderData.next(data); });
        };
        /**
         * Returns a filtered data array where each filter object contains the filter string within
         * the result of the filterTermAccessor function. If no filter is set, returns the data array
         * as provided.
         */
        /**
         * Returns a filtered data array where each filter object contains the filter string within
         * the result of the filterTermAccessor function. If no filter is set, returns the data array
         * as provided.
         * @param {?} data
         * @return {?}
         */
        MatTableDataSource.prototype._filterData = /**
         * Returns a filtered data array where each filter object contains the filter string within
         * the result of the filterTermAccessor function. If no filter is set, returns the data array
         * as provided.
         * @param {?} data
         * @return {?}
         */
        function (data) {
            var _this = this;
            // If there is a filter string, filter out data that does not contain it.
            // Each data object is converted to a string using the function defined by filterTermAccessor.
            // May be overridden for customization.
            this.filteredData =
                !this.filter ? data : data.filter(function (obj) { return _this.filterPredicate(obj, _this.filter); });
            if (this.paginator) {
                this._updatePaginator(this.filteredData.length);
            }
            return this.filteredData;
        };
        /**
         * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
         * data array as provided. Uses the default data accessor for data lookup, unless a
         * sortDataAccessor function is defined.
         */
        /**
         * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
         * data array as provided. Uses the default data accessor for data lookup, unless a
         * sortDataAccessor function is defined.
         * @param {?} data
         * @return {?}
         */
        MatTableDataSource.prototype._orderData = /**
         * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
         * data array as provided. Uses the default data accessor for data lookup, unless a
         * sortDataAccessor function is defined.
         * @param {?} data
         * @return {?}
         */
        function (data) {
            // If there is no active sort or direction, return the data without trying to sort.
            if (!this.sort) {
                return data;
            }
            return this.sortData(data.slice(), this.sort);
        };
        /**
         * Returns a paged splice of the provided data array according to the provided MatPaginator's page
         * index and length. If there is no paginator provided, returns the data array as provided.
         */
        /**
         * Returns a paged splice of the provided data array according to the provided MatPaginator's page
         * index and length. If there is no paginator provided, returns the data array as provided.
         * @param {?} data
         * @return {?}
         */
        MatTableDataSource.prototype._pageData = /**
         * Returns a paged splice of the provided data array according to the provided MatPaginator's page
         * index and length. If there is no paginator provided, returns the data array as provided.
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (!this.paginator) {
                return data;
            }
            var /** @type {?} */ startIndex = this.paginator.pageIndex * this.paginator.pageSize;
            return data.slice().splice(startIndex, this.paginator.pageSize);
        };
        /**
         * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
         * index does not exceed the paginator's last page. Values are changed in a resolved promise to
         * guard against making property changes within a round of change detection.
         */
        /**
         * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
         * index does not exceed the paginator's last page. Values are changed in a resolved promise to
         * guard against making property changes within a round of change detection.
         * @param {?} filteredDataLength
         * @return {?}
         */
        MatTableDataSource.prototype._updatePaginator = /**
         * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
         * index does not exceed the paginator's last page. Values are changed in a resolved promise to
         * guard against making property changes within a round of change detection.
         * @param {?} filteredDataLength
         * @return {?}
         */
        function (filteredDataLength) {
            var _this = this;
            Promise.resolve().then(function () {
                if (!_this.paginator) {
                    return;
                }
                _this.paginator.length = filteredDataLength;
                // If the page index is set beyond the page, reduce it to the last page.
                if (_this.paginator.pageIndex > 0) {
                    var /** @type {?} */ lastPageIndex = Math.ceil(_this.paginator.length / _this.paginator.pageSize) - 1 || 0;
                    _this.paginator.pageIndex = Math.min(_this.paginator.pageIndex, lastPageIndex);
                }
            });
        };
        /**
         * Used by the MatTable. Called when it connects to the data source.
         * @docs-private
         */
        /**
         * Used by the MatTable. Called when it connects to the data source.
         * \@docs-private
         * @return {?}
         */
        MatTableDataSource.prototype.connect = /**
         * Used by the MatTable. Called when it connects to the data source.
         * \@docs-private
         * @return {?}
         */
        function () { return this._renderData; };
        /**
         * Used by the MatTable. Called when it is destroyed. No-op.
         * @docs-private
         */
        /**
         * Used by the MatTable. Called when it is destroyed. No-op.
         * \@docs-private
         * @return {?}
         */
        MatTableDataSource.prototype.disconnect = /**
         * Used by the MatTable. Called when it is destroyed. No-op.
         * \@docs-private
         * @return {?}
         */
        function () { };
        return MatTableDataSource;
    }(DataSource));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Injection token for the MatInkBar's Positioner.
     */
    var /** @type {?} */ _MAT_INK_BAR_POSITIONER = new core.InjectionToken('MatInkBarPositioner', {
        providedIn: 'root',
        factory: _MAT_INK_BAR_POSITIONER_FACTORY
    });
    /**
     * The default positioner function for the MatInkBar.
     * \@docs-private
     * @return {?}
     */
    function _MAT_INK_BAR_POSITIONER_FACTORY() {
        var /** @type {?} */ method = function (element) {
            return ({
                left: element ? (element.offsetLeft || 0) + 'px' : '0',
                width: element ? (element.offsetWidth || 0) + 'px' : '0',
            });
        };
        return method;
    }
    /**
     * The ink-bar is used to display and animate the line underneath the current active tab label.
     * \@docs-private
     */
    var MatInkBar = /** @class */ (function () {
        function MatInkBar(_elementRef, _ngZone, _inkBarPositioner) {
            this._elementRef = _elementRef;
            this._ngZone = _ngZone;
            this._inkBarPositioner = _inkBarPositioner;
        }
        /**
         * Calculates the styles from the provided element in order to align the ink-bar to that element.
         * Shows the ink bar if previously set as hidden.
         * @param element
         */
        /**
         * Calculates the styles from the provided element in order to align the ink-bar to that element.
         * Shows the ink bar if previously set as hidden.
         * @param {?} element
         * @return {?}
         */
        MatInkBar.prototype.alignToElement = /**
         * Calculates the styles from the provided element in order to align the ink-bar to that element.
         * Shows the ink bar if previously set as hidden.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var _this = this;
            this.show();
            if (typeof requestAnimationFrame !== 'undefined') {
                this._ngZone.runOutsideAngular(function () {
                    requestAnimationFrame(function () { return _this._setStyles(element); });
                });
            }
            else {
                this._setStyles(element);
            }
        };
        /** Shows the ink bar. */
        /**
         * Shows the ink bar.
         * @return {?}
         */
        MatInkBar.prototype.show = /**
         * Shows the ink bar.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.style.visibility = 'visible';
        };
        /** Hides the ink bar. */
        /**
         * Hides the ink bar.
         * @return {?}
         */
        MatInkBar.prototype.hide = /**
         * Hides the ink bar.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.style.visibility = 'hidden';
        };
        /**
         * Sets the proper styles to the ink bar element.
         * @param {?} element
         * @return {?}
         */
        MatInkBar.prototype._setStyles = /**
         * Sets the proper styles to the ink bar element.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ positions = this._inkBarPositioner(element);
            var /** @type {?} */ inkBar = this._elementRef.nativeElement;
            inkBar.style.left = positions.left;
            inkBar.style.width = positions.width;
        };
        MatInkBar.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-ink-bar',
                        host: {
                            'class': 'mat-ink-bar',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatInkBar.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: undefined, decorators: [{ type: core.Inject, args: [_MAT_INK_BAR_POSITIONER,] },] },
        ]; };
        return MatInkBar;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to flag tab labels for use with the portal directive
     */
    var MatTabLabel = /** @class */ (function (_super) {
        __extends(MatTabLabel, _super);
        function MatTabLabel(templateRef, viewContainerRef) {
            return _super.call(this, templateRef, viewContainerRef) || this;
        }
        MatTabLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-tab-label], [matTabLabel]',
                    },] },
        ];
        /** @nocollapse */
        MatTabLabel.ctorParameters = function () { return [
            { type: core.TemplateRef, },
            { type: core.ViewContainerRef, },
        ]; };
        return MatTabLabel;
    }(CdkPortal));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Decorates the `ng-template` tags and reads out the template from it.
     */
    var MatTabContent = /** @class */ (function () {
        function MatTabContent(template) {
            this.template = template;
        }
        MatTabContent.decorators = [
            { type: core.Directive, args: [{ selector: '[matTabContent]' },] },
        ];
        /** @nocollapse */
        MatTabContent.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return MatTabContent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatTabBase = /** @class */ (function () {
        function MatTabBase() {
        }
        return MatTabBase;
    }());
    var /** @type {?} */ _MatTabMixinBase = mixinDisabled(MatTabBase);
    var MatTab = /** @class */ (function (_super) {
        __extends(MatTab, _super);
        function MatTab(_viewContainerRef) {
            var _this = _super.call(this) || this;
            _this._viewContainerRef = _viewContainerRef;
            /**
             * The plain text label for the tab, used when there is no template label.
             */
            _this.textLabel = '';
            /**
             * The portal that will be the hosted content of the tab
             */
            _this._contentPortal = null;
            /**
             * Emits whenever the label changes.
             */
            _this._labelChange = new rxjs.Subject();
            /**
             * Emits whenever the disable changes
             */
            _this._disableChange = new rxjs.Subject();
            /**
             * The relatively indexed position where 0 represents the center, negative is left, and positive
             * represents the right.
             */
            _this.position = null;
            /**
             * The initial relatively index origin of the tab if it was created and selected after there
             * was already a selected tab. Provides context of what position the tab should originate from.
             */
            _this.origin = null;
            /**
             * Whether the tab is currently active.
             */
            _this.isActive = false;
            return _this;
        }
        Object.defineProperty(MatTab.prototype, "content", {
            /** @docs-private */
            get: /**
             * \@docs-private
             * @return {?}
             */
            function () {
                return this._contentPortal;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} changes
         * @return {?}
         */
        MatTab.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            if (changes.hasOwnProperty('textLabel')) {
                this._labelChange.next();
            }
            if (changes.hasOwnProperty('disabled')) {
                this._disableChange.next();
            }
        };
        /**
         * @return {?}
         */
        MatTab.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._disableChange.complete();
            this._labelChange.complete();
        };
        /**
         * @return {?}
         */
        MatTab.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._contentPortal = new TemplatePortal(this._explicitContent || this._implicitContent, this._viewContainerRef);
        };
        MatTab.decorators = [
            { type: core.Component, args: [{selector: 'mat-tab',
                        template: "<ng-template><ng-content></ng-content></ng-template>",
                        inputs: ['disabled'],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        exportAs: 'matTab',
                    },] },
        ];
        /** @nocollapse */
        MatTab.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        MatTab.propDecorators = {
            "templateLabel": [{ type: core.ContentChild, args: [MatTabLabel,] },],
            "_explicitContent": [{ type: core.ContentChild, args: [MatTabContent, { read: core.TemplateRef },] },],
            "_implicitContent": [{ type: core.ViewChild, args: [core.TemplateRef,] },],
            "textLabel": [{ type: core.Input, args: ['label',] },],
        };
        return MatTab;
    }(_MatTabMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Animations used by the Material tabs.
     */
    var /** @type {?} */ matTabsAnimations = {
        /** Animation translates a tab along the X axis. */
        translateTab: trigger('translateTab', [
            // Note: transitions to `none` instead of 0, because some browsers might blur the content.
            state('center, void, left-origin-center, right-origin-center', style({ transform: 'none' })),
            state('left', style({ transform: 'translate3d(-100%, 0, 0)' })),
            state('right', style({ transform: 'translate3d(100%, 0, 0)' })),
            transition('* => left, * => right, left => center, right => center', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
            transition('void => left-origin-center', [
                style({ transform: 'translate3d(-100%, 0, 0)' }),
                animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')
            ]),
            transition('void => right-origin-center', [
                style({ transform: 'translate3d(100%, 0, 0)' }),
                animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')
            ])
        ])
    };

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The portal host directive for the contents of the tab.
     * \@docs-private
     */
    var MatTabBodyPortal = /** @class */ (function (_super) {
        __extends(MatTabBodyPortal, _super);
        function MatTabBodyPortal(componentFactoryResolver, viewContainerRef, _host) {
            var _this = _super.call(this, componentFactoryResolver, viewContainerRef) || this;
            _this._host = _host;
            /**
             * Subscription to events for when the tab body begins centering.
             */
            _this._centeringSub = rxjs.Subscription.EMPTY;
            /**
             * Subscription to events for when the tab body finishes leaving from center position.
             */
            _this._leavingSub = rxjs.Subscription.EMPTY;
            return _this;
        }
        /** Set initial visibility or set up subscription for changing visibility. */
        /**
         * Set initial visibility or set up subscription for changing visibility.
         * @return {?}
         */
        MatTabBodyPortal.prototype.ngOnInit = /**
         * Set initial visibility or set up subscription for changing visibility.
         * @return {?}
         */
        function () {
            var _this = this;
            _super.prototype.ngOnInit.call(this);
            this._centeringSub = this._host._beforeCentering
                .pipe(operators.startWith(this._host._isCenterPosition(this._host._position)))
                .subscribe(function (isCentering) {
                if (isCentering && !_this.hasAttached()) {
                    _this.attach(_this._host._content);
                }
            });
            this._leavingSub = this._host._afterLeavingCenter.subscribe(function () {
                _this.detach();
            });
        };
        /** Clean up centering subscription. */
        /**
         * Clean up centering subscription.
         * @return {?}
         */
        MatTabBodyPortal.prototype.ngOnDestroy = /**
         * Clean up centering subscription.
         * @return {?}
         */
        function () {
            _super.prototype.ngOnDestroy.call(this);
            this._centeringSub.unsubscribe();
            this._leavingSub.unsubscribe();
        };
        MatTabBodyPortal.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTabBodyHost]'
                    },] },
        ];
        /** @nocollapse */
        MatTabBodyPortal.ctorParameters = function () { return [
            { type: core.ComponentFactoryResolver, },
            { type: core.ViewContainerRef, },
            { type: MatTabBody, decorators: [{ type: core.Inject, args: [core.forwardRef(function () { return MatTabBody; }),] },] },
        ]; };
        return MatTabBodyPortal;
    }(CdkPortalOutlet));
    /**
     * Wrapper for the contents of a tab.
     * \@docs-private
     */
    var MatTabBody = /** @class */ (function () {
        function MatTabBody(_elementRef, _dir) {
            this._elementRef = _elementRef;
            this._dir = _dir;
            /**
             * Event emitted when the tab begins to animate towards the center as the active tab.
             */
            this._onCentering = new core.EventEmitter();
            /**
             * Event emitted before the centering of the tab begins.
             */
            this._beforeCentering = new core.EventEmitter();
            /**
             * Event emitted before the centering of the tab begins.
             */
            this._afterLeavingCenter = new core.EventEmitter();
            /**
             * Event emitted when the tab completes its animation towards the center.
             */
            this._onCentered = new core.EventEmitter(true);
        }
        Object.defineProperty(MatTabBody.prototype, "position", {
            set: /**
             * The shifted index position of the tab body, where zero represents the active center tab.
             * @param {?} position
             * @return {?}
             */
            function (position) {
                if (position < 0) {
                    this._position = this._getLayoutDirection() == 'ltr' ? 'left' : 'right';
                }
                else if (position > 0) {
                    this._position = this._getLayoutDirection() == 'ltr' ? 'right' : 'left';
                }
                else {
                    this._position = 'center';
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTabBody.prototype, "origin", {
            set: /**
             * The origin position from which this tab should appear when it is centered into view.
             * @param {?} origin
             * @return {?}
             */
            function (origin) {
                if (origin == null) {
                    return;
                }
                var /** @type {?} */ dir = this._getLayoutDirection();
                if ((dir == 'ltr' && origin <= 0) || (dir == 'rtl' && origin > 0)) {
                    this._origin = 'left';
                }
                else {
                    this._origin = 'right';
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * After initialized, check if the content is centered and has an origin. If so, set the
         * special position states that transition the tab from the left or right before centering.
         */
        /**
         * After initialized, check if the content is centered and has an origin. If so, set the
         * special position states that transition the tab from the left or right before centering.
         * @return {?}
         */
        MatTabBody.prototype.ngOnInit = /**
         * After initialized, check if the content is centered and has an origin. If so, set the
         * special position states that transition the tab from the left or right before centering.
         * @return {?}
         */
        function () {
            if (this._position == 'center' && this._origin) {
                this._position = this._origin == 'left' ? 'left-origin-center' : 'right-origin-center';
            }
        };
        /**
         * @param {?} e
         * @return {?}
         */
        MatTabBody.prototype._onTranslateTabStarted = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            var /** @type {?} */ isCentering = this._isCenterPosition(e.toState);
            this._beforeCentering.emit(isCentering);
            if (isCentering) {
                this._onCentering.emit(this._elementRef.nativeElement.clientHeight);
            }
        };
        /**
         * @param {?} e
         * @return {?}
         */
        MatTabBody.prototype._onTranslateTabComplete = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            // If the transition to the center is complete, emit an event.
            if (this._isCenterPosition(e.toState) && this._isCenterPosition(this._position)) {
                this._onCentered.emit();
            }
            if (this._isCenterPosition(e.fromState) && !this._isCenterPosition(this._position)) {
                this._afterLeavingCenter.emit();
            }
        };
        /** The text direction of the containing app. */
        /**
         * The text direction of the containing app.
         * @return {?}
         */
        MatTabBody.prototype._getLayoutDirection = /**
         * The text direction of the containing app.
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
        };
        /** Whether the provided position state is considered center, regardless of origin. */
        /**
         * Whether the provided position state is considered center, regardless of origin.
         * @param {?} position
         * @return {?}
         */
        MatTabBody.prototype._isCenterPosition = /**
         * Whether the provided position state is considered center, regardless of origin.
         * @param {?} position
         * @return {?}
         */
        function (position) {
            return position == 'center' ||
                position == 'left-origin-center' ||
                position == 'right-origin-center';
        };
        MatTabBody.decorators = [
            { type: core.Component, args: [{selector: 'mat-tab-body',
                        template: "<div class=\"mat-tab-body-content\" #content [@translateTab]=\"_position\" (@translateTab.start)=\"_onTranslateTabStarted($event)\" (@translateTab.done)=\"_onTranslateTabComplete($event)\"><ng-template matTabBodyHost></ng-template></div>",
                        styles: [".mat-tab-body-content{height:100%;overflow:auto}.mat-tab-group-dynamic-height .mat-tab-body-content{overflow:hidden}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        animations: [matTabsAnimations.translateTab],
                        host: {
                            'class': 'mat-tab-body',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatTabBody.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatTabBody.propDecorators = {
            "_onCentering": [{ type: core.Output },],
            "_beforeCentering": [{ type: core.Output },],
            "_afterLeavingCenter": [{ type: core.Output },],
            "_onCentered": [{ type: core.Output },],
            "_portalHost": [{ type: core.ViewChild, args: [CdkPortalOutlet,] },],
            "_content": [{ type: core.Input, args: ['content',] },],
            "position": [{ type: core.Input },],
            "origin": [{ type: core.Input },],
        };
        return MatTabBody;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatTabLabelWrapperBase = /** @class */ (function () {
        function MatTabLabelWrapperBase() {
        }
        return MatTabLabelWrapperBase;
    }());
    var /** @type {?} */ _MatTabLabelWrapperMixinBase = mixinDisabled(MatTabLabelWrapperBase);
    /**
     * Used in the `mat-tab-group` view to display tab labels.
     * \@docs-private
     */
    var MatTabLabelWrapper = /** @class */ (function (_super) {
        __extends(MatTabLabelWrapper, _super);
        function MatTabLabelWrapper(elementRef) {
            var _this = _super.call(this) || this;
            _this.elementRef = elementRef;
            return _this;
        }
        /** Sets focus on the wrapper element */
        /**
         * Sets focus on the wrapper element
         * @return {?}
         */
        MatTabLabelWrapper.prototype.focus = /**
         * Sets focus on the wrapper element
         * @return {?}
         */
        function () {
            this.elementRef.nativeElement.focus();
        };
        /**
         * @return {?}
         */
        MatTabLabelWrapper.prototype.getOffsetLeft = /**
         * @return {?}
         */
        function () {
            return this.elementRef.nativeElement.offsetLeft;
        };
        /**
         * @return {?}
         */
        MatTabLabelWrapper.prototype.getOffsetWidth = /**
         * @return {?}
         */
        function () {
            return this.elementRef.nativeElement.offsetWidth;
        };
        MatTabLabelWrapper.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTabLabelWrapper]',
                        inputs: ['disabled'],
                        host: {
                            '[class.mat-tab-disabled]': 'disabled'
                        }
                    },] },
        ];
        /** @nocollapse */
        MatTabLabelWrapper.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        return MatTabLabelWrapper;
    }(_MatTabLabelWrapperMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * The distance in pixels that will be overshot when scrolling a tab label into view. This helps
     * provide a small affordance to the label next to it.
     */
    var /** @type {?} */ EXAGGERATED_OVERSCROLL = 60;
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatTabHeaderBase = /** @class */ (function () {
        function MatTabHeaderBase() {
        }
        return MatTabHeaderBase;
    }());
    var /** @type {?} */ _MatTabHeaderMixinBase = mixinDisableRipple(MatTabHeaderBase);
    /**
     * The header of the tab group which displays a list of all the tabs in the tab group. Includes
     * an ink bar that follows the currently selected tab. When the tabs list's width exceeds the
     * width of the header container, then arrows will be displayed to allow the user to scroll
     * left and right across the header.
     * \@docs-private
     */
    var MatTabHeader = /** @class */ (function (_super) {
        __extends(MatTabHeader, _super);
        function MatTabHeader(_elementRef, _changeDetectorRef, _viewportRuler, _dir) {
            var _this = _super.call(this) || this;
            _this._elementRef = _elementRef;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._viewportRuler = _viewportRuler;
            _this._dir = _dir;
            /**
             * The distance in pixels that the tab labels should be translated to the left.
             */
            _this._scrollDistance = 0;
            /**
             * Whether the header should scroll to the selected index after the view has been checked.
             */
            _this._selectedIndexChanged = false;
            /**
             * Combines listeners that will re-align the ink bar whenever they're invoked.
             */
            _this._realignInkBar = rxjs.Subscription.EMPTY;
            /**
             * Whether the controls for pagination should be displayed
             */
            _this._showPaginationControls = false;
            /**
             * Whether the tab list can be scrolled more towards the end of the tab label list.
             */
            _this._disableScrollAfter = true;
            /**
             * Whether the tab list can be scrolled more towards the beginning of the tab label list.
             */
            _this._disableScrollBefore = true;
            _this._selectedIndex = 0;
            /**
             * Event emitted when the option is selected.
             */
            _this.selectFocusedIndex = new core.EventEmitter();
            /**
             * Event emitted when a label is focused.
             */
            _this.indexFocused = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(MatTabHeader.prototype, "selectedIndex", {
            get: /**
             * The index of the active tab.
             * @return {?}
             */
            function () { return this._selectedIndex; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                value = coerceNumberProperty(value);
                this._selectedIndexChanged = this._selectedIndex != value;
                this._selectedIndex = value;
                if (this._keyManager) {
                    this._keyManager.updateActiveItemIndex(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatTabHeader.prototype.ngAfterContentChecked = /**
         * @return {?}
         */
        function () {
            // If the number of tab labels have changed, check if scrolling should be enabled
            if (this._tabLabelCount != this._labelWrappers.length) {
                this._updatePagination();
                this._tabLabelCount = this._labelWrappers.length;
                this._changeDetectorRef.markForCheck();
            }
            // If the selected index has changed, scroll to the label and check if the scrolling controls
            // should be disabled.
            if (this._selectedIndexChanged) {
                this._scrollToLabel(this._selectedIndex);
                this._checkScrollingControls();
                this._alignInkBarToSelectedTab();
                this._selectedIndexChanged = false;
                this._changeDetectorRef.markForCheck();
            }
            // If the scroll distance has been changed (tab selected, focused, scroll controls activated),
            // then translate the header to reflect this.
            if (this._scrollDistanceChanged) {
                this._updateTabScrollPosition();
                this._scrollDistanceChanged = false;
                this._changeDetectorRef.markForCheck();
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        MatTabHeader.prototype._handleKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            switch (event.keyCode) {
                case HOME:
                    this._keyManager.setFirstItemActive();
                    event.preventDefault();
                    break;
                case END:
                    this._keyManager.setLastItemActive();
                    event.preventDefault();
                    break;
                case ENTER:
                case SPACE:
                    this.selectFocusedIndex.emit(this.focusIndex);
                    event.preventDefault();
                    break;
                default:
                    this._keyManager.onKeydown(event);
            }
        };
        /**
         * Aligns the ink bar to the selected tab on load.
         */
        /**
         * Aligns the ink bar to the selected tab on load.
         * @return {?}
         */
        MatTabHeader.prototype.ngAfterContentInit = /**
         * Aligns the ink bar to the selected tab on load.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ dirChange = this._dir ? this._dir.change : rxjs.of(null);
            var /** @type {?} */ resize = this._viewportRuler.change(150);
            var /** @type {?} */ realign = function () {
                _this._updatePagination();
                _this._alignInkBarToSelectedTab();
            };
            this._keyManager = new FocusKeyManager(this._labelWrappers)
                .withHorizontalOrientation(this._getLayoutDirection());
            this._keyManager.updateActiveItemIndex(0);
            // Defer the first call in order to allow for slower browsers to lay out the elements.
            // This helps in cases where the user lands directly on a page with paginated tabs.
            typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame(realign) : realign();
            this._realignInkBar = rxjs.merge(dirChange, resize).subscribe(function () {
                realign();
                _this._keyManager.withHorizontalOrientation(_this._getLayoutDirection());
            });
        };
        /**
         * @return {?}
         */
        MatTabHeader.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._realignInkBar.unsubscribe();
        };
        /**
         * Callback for when the MutationObserver detects that the content has changed.
         */
        /**
         * Callback for when the MutationObserver detects that the content has changed.
         * @return {?}
         */
        MatTabHeader.prototype._onContentChanges = /**
         * Callback for when the MutationObserver detects that the content has changed.
         * @return {?}
         */
        function () {
            this._updatePagination();
            this._alignInkBarToSelectedTab();
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Updating the view whether pagination should be enabled or not
         */
        /**
         * Updating the view whether pagination should be enabled or not
         * @return {?}
         */
        MatTabHeader.prototype._updatePagination = /**
         * Updating the view whether pagination should be enabled or not
         * @return {?}
         */
        function () {
            this._checkPaginationEnabled();
            this._checkScrollingControls();
            this._updateTabScrollPosition();
        };
        Object.defineProperty(MatTabHeader.prototype, "focusIndex", {
            /** Tracks which element has focus; used for keyboard navigation */
            get: /**
             * Tracks which element has focus; used for keyboard navigation
             * @return {?}
             */
            function () {
                return this._keyManager ? /** @type {?} */ ((this._keyManager.activeItemIndex)) : 0;
            },
            /** When the focus index is set, we must manually send focus to the correct label */
            set: /**
             * When the focus index is set, we must manually send focus to the correct label
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (!this._isValidIndex(value) || this.focusIndex == value || !this._keyManager) {
                    return;
                }
                this._keyManager.setActiveItem(value);
                this.indexFocused.emit(value);
                this._setTabFocus(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
         * providing a valid index and return true.
         */
        /**
         * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
         * providing a valid index and return true.
         * @param {?} index
         * @return {?}
         */
        MatTabHeader.prototype._isValidIndex = /**
         * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
         * providing a valid index and return true.
         * @param {?} index
         * @return {?}
         */
        function (index) {
            if (!this._labelWrappers) {
                return true;
            }
            var /** @type {?} */ tab = this._labelWrappers ? this._labelWrappers.toArray()[index] : null;
            return !!tab && !tab.disabled;
        };
        /**
         * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
         * scrolling is enabled.
         */
        /**
         * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
         * scrolling is enabled.
         * @param {?} tabIndex
         * @return {?}
         */
        MatTabHeader.prototype._setTabFocus = /**
         * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
         * scrolling is enabled.
         * @param {?} tabIndex
         * @return {?}
         */
        function (tabIndex) {
            if (this._showPaginationControls) {
                this._scrollToLabel(tabIndex);
            }
            if (this._labelWrappers && this._labelWrappers.length) {
                this._labelWrappers.toArray()[tabIndex].focus();
                // Do not let the browser manage scrolling to focus the element, this will be handled
                // by using translation. In LTR, the scroll left should be 0. In RTL, the scroll width
                // should be the full width minus the offset width.
                var /** @type {?} */ containerEl = this._tabListContainer.nativeElement;
                var /** @type {?} */ dir = this._getLayoutDirection();
                if (dir == 'ltr') {
                    containerEl.scrollLeft = 0;
                }
                else {
                    containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
                }
            }
        };
        /** The layout direction of the containing app. */
        /**
         * The layout direction of the containing app.
         * @return {?}
         */
        MatTabHeader.prototype._getLayoutDirection = /**
         * The layout direction of the containing app.
         * @return {?}
         */
        function () {
            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
        };
        /** Performs the CSS transformation on the tab list that will cause the list to scroll. */
        /**
         * Performs the CSS transformation on the tab list that will cause the list to scroll.
         * @return {?}
         */
        MatTabHeader.prototype._updateTabScrollPosition = /**
         * Performs the CSS transformation on the tab list that will cause the list to scroll.
         * @return {?}
         */
        function () {
            var /** @type {?} */ scrollDistance = this.scrollDistance;
            var /** @type {?} */ translateX = this._getLayoutDirection() === 'ltr' ? -scrollDistance : scrollDistance;
            this._tabList.nativeElement.style.transform = "translate3d(" + translateX + "px, 0, 0)";
        };
        Object.defineProperty(MatTabHeader.prototype, "scrollDistance", {
            /** Sets the distance in pixels that the tab header should be transformed in the X-axis. */
            get: /**
             * Sets the distance in pixels that the tab header should be transformed in the X-axis.
             * @return {?}
             */
            function () { return this._scrollDistance; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), v));
                // Mark that the scroll distance has changed so that after the view is checked, the CSS
                // transformation can move the header.
                this._scrollDistanceChanged = true;
                this._checkScrollingControls();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
         * the end of the list, respectively). The distance to scroll is computed to be a third of the
         * length of the tab list view window.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         */
        /**
         * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
         * the end of the list, respectively). The distance to scroll is computed to be a third of the
         * length of the tab list view window.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @param {?} scrollDir
         * @return {?}
         */
        MatTabHeader.prototype._scrollHeader = /**
         * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
         * the end of the list, respectively). The distance to scroll is computed to be a third of the
         * length of the tab list view window.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @param {?} scrollDir
         * @return {?}
         */
        function (scrollDir) {
            var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
            // Move the scroll distance one-third the length of the tab list's viewport.
            this.scrollDistance += (scrollDir == 'before' ? -1 : 1) * viewLength / 3;
        };
        /**
         * Moves the tab list such that the desired tab label (marked by index) is moved into view.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         */
        /**
         * Moves the tab list such that the desired tab label (marked by index) is moved into view.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @param {?} labelIndex
         * @return {?}
         */
        MatTabHeader.prototype._scrollToLabel = /**
         * Moves the tab list such that the desired tab label (marked by index) is moved into view.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @param {?} labelIndex
         * @return {?}
         */
        function (labelIndex) {
            var /** @type {?} */ selectedLabel = this._labelWrappers ? this._labelWrappers.toArray()[labelIndex] : null;
            if (!selectedLabel) {
                return;
            }
            // The view length is the visible width of the tab labels.
            var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
            var /** @type {?} */ labelBeforePos, /** @type {?} */ labelAfterPos;
            if (this._getLayoutDirection() == 'ltr') {
                labelBeforePos = selectedLabel.getOffsetLeft();
                labelAfterPos = labelBeforePos + selectedLabel.getOffsetWidth();
            }
            else {
                labelAfterPos = this._tabList.nativeElement.offsetWidth - selectedLabel.getOffsetLeft();
                labelBeforePos = labelAfterPos - selectedLabel.getOffsetWidth();
            }
            var /** @type {?} */ beforeVisiblePos = this.scrollDistance;
            var /** @type {?} */ afterVisiblePos = this.scrollDistance + viewLength;
            if (labelBeforePos < beforeVisiblePos) {
                // Scroll header to move label to the before direction
                this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
            }
            else if (labelAfterPos > afterVisiblePos) {
                // Scroll header to move label to the after direction
                this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
            }
        };
        /**
         * Evaluate whether the pagination controls should be displayed. If the scroll width of the
         * tab list is wider than the size of the header container, then the pagination controls should
         * be shown.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         */
        /**
         * Evaluate whether the pagination controls should be displayed. If the scroll width of the
         * tab list is wider than the size of the header container, then the pagination controls should
         * be shown.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        MatTabHeader.prototype._checkPaginationEnabled = /**
         * Evaluate whether the pagination controls should be displayed. If the scroll width of the
         * tab list is wider than the size of the header container, then the pagination controls should
         * be shown.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        function () {
            var /** @type {?} */ isEnabled = this._tabList.nativeElement.scrollWidth > this._elementRef.nativeElement.offsetWidth;
            if (!isEnabled) {
                this.scrollDistance = 0;
            }
            if (isEnabled !== this._showPaginationControls) {
                this._changeDetectorRef.markForCheck();
            }
            this._showPaginationControls = isEnabled;
        };
        /**
         * Evaluate whether the before and after controls should be enabled or disabled.
         * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
         * before button. If the header is at the end of the list (scroll distance is equal to the
         * maximum distance we can scroll), then disable the after button.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         */
        /**
         * Evaluate whether the before and after controls should be enabled or disabled.
         * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
         * before button. If the header is at the end of the list (scroll distance is equal to the
         * maximum distance we can scroll), then disable the after button.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        MatTabHeader.prototype._checkScrollingControls = /**
         * Evaluate whether the before and after controls should be enabled or disabled.
         * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
         * before button. If the header is at the end of the list (scroll distance is equal to the
         * maximum distance we can scroll), then disable the after button.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        function () {
            // Check if the pagination arrows should be activated.
            this._disableScrollBefore = this.scrollDistance == 0;
            this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Determines what is the maximum length in pixels that can be set for the scroll distance. This
         * is equal to the difference in width between the tab list container and tab header container.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         */
        /**
         * Determines what is the maximum length in pixels that can be set for the scroll distance. This
         * is equal to the difference in width between the tab list container and tab header container.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        MatTabHeader.prototype._getMaxScrollDistance = /**
         * Determines what is the maximum length in pixels that can be set for the scroll distance. This
         * is equal to the difference in width between the tab list container and tab header container.
         *
         * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
         * should be called sparingly.
         * @return {?}
         */
        function () {
            var /** @type {?} */ lengthOfTabList = this._tabList.nativeElement.scrollWidth;
            var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
            return (lengthOfTabList - viewLength) || 0;
        };
        /** Tells the ink-bar to align itself to the current label wrapper */
        /**
         * Tells the ink-bar to align itself to the current label wrapper
         * @return {?}
         */
        MatTabHeader.prototype._alignInkBarToSelectedTab = /**
         * Tells the ink-bar to align itself to the current label wrapper
         * @return {?}
         */
        function () {
            var /** @type {?} */ selectedLabelWrapper = this._labelWrappers && this._labelWrappers.length ?
                this._labelWrappers.toArray()[this.selectedIndex].elementRef.nativeElement :
                null;
            this._inkBar.alignToElement(selectedLabelWrapper);
        };
        MatTabHeader.decorators = [
            { type: core.Component, args: [{selector: 'mat-tab-header',
                        template: "<div class=\"mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4\" aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollBefore || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_scrollHeader('before')\"><div class=\"mat-tab-header-pagination-chevron\"></div></div><div class=\"mat-tab-label-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"><div class=\"mat-tab-list\" #tabList role=\"tablist\" (cdkObserveContent)=\"_onContentChanges()\"><div class=\"mat-tab-labels\"><ng-content></ng-content></div><mat-ink-bar></mat-ink-bar></div></div><div class=\"mat-tab-header-pagination mat-tab-header-pagination-after mat-elevation-z4\" aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollAfter || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollAfter\" (click)=\"_scrollHeader('after')\"><div class=\"mat-tab-header-pagination-chevron\"></div></div>",
                        styles: [".mat-tab-header{display:flex;overflow:hidden;position:relative;flex-shrink:0}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-label.mat-tab-disabled{cursor:default}.mat-tab-label .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (max-width:599px){.mat-tab-label{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media screen and (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}.mat-tab-header-pagination{position:relative;display:none;justify-content:center;align-items:center;min-width:32px;cursor:pointer;z-index:2}.mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination{display:flex}.mat-tab-header-pagination-before,.mat-tab-header-rtl .mat-tab-header-pagination-after{padding-left:4px}.mat-tab-header-pagination-before .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-after .mat-tab-header-pagination-chevron{transform:rotate(-135deg)}.mat-tab-header-pagination-after,.mat-tab-header-rtl .mat-tab-header-pagination-before{padding-right:4px}.mat-tab-header-pagination-after .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-before .mat-tab-header-pagination-chevron{transform:rotate(45deg)}.mat-tab-header-pagination-chevron{border-style:solid;border-width:2px 2px 0 0;content:'';height:8px;width:8px}.mat-tab-header-pagination-disabled{box-shadow:none;cursor:default}.mat-tab-label-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}.mat-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.mat-tab-labels{display:flex}"],
                        inputs: ['disableRipple'],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        host: {
                            'class': 'mat-tab-header',
                            '[class.mat-tab-header-pagination-controls-enabled]': '_showPaginationControls',
                            '[class.mat-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
                        },
                    },] },
        ];
        /** @nocollapse */
        MatTabHeader.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
            { type: ViewportRuler, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        MatTabHeader.propDecorators = {
            "_labelWrappers": [{ type: core.ContentChildren, args: [MatTabLabelWrapper,] },],
            "_inkBar": [{ type: core.ViewChild, args: [MatInkBar,] },],
            "_tabListContainer": [{ type: core.ViewChild, args: ['tabListContainer',] },],
            "_tabList": [{ type: core.ViewChild, args: ['tabList',] },],
            "selectedIndex": [{ type: core.Input },],
            "selectFocusedIndex": [{ type: core.Output },],
            "indexFocused": [{ type: core.Output },],
        };
        return MatTabHeader;
    }(_MatTabHeaderMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Used to generate unique ID's for each tab component
     */
    var /** @type {?} */ nextId$4 = 0;
    /**
     * A simple change event emitted on focus or selection changes.
     */
    var  /**
     * A simple change event emitted on focus or selection changes.
     */
    MatTabChangeEvent = /** @class */ (function () {
        function MatTabChangeEvent() {
        }
        return MatTabChangeEvent;
    }());
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatTabGroupBase = /** @class */ (function () {
        function MatTabGroupBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatTabGroupBase;
    }());
    var /** @type {?} */ _MatTabGroupMixinBase = mixinColor(mixinDisableRipple(MatTabGroupBase), 'primary');
    /**
     * Material design tab-group component.  Supports basic tab pairs (label + content) and includes
     * animated ink-bar, keyboard navigation, and screen reader.
     * See: https://material.io/design/components/tabs.html
     */
    var MatTabGroup = /** @class */ (function (_super) {
        __extends(MatTabGroup, _super);
        function MatTabGroup(elementRef, _changeDetectorRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            /**
             * The tab index that should be selected after the content has been checked.
             */
            _this._indexToSelect = 0;
            /**
             * Snapshot of the height of the tab body wrapper before another tab is activated.
             */
            _this._tabBodyWrapperHeight = 0;
            /**
             * Subscription to tabs being added/removed.
             */
            _this._tabsSubscription = rxjs.Subscription.EMPTY;
            /**
             * Subscription to changes in the tab labels.
             */
            _this._tabLabelSubscription = rxjs.Subscription.EMPTY;
            _this._dynamicHeight = false;
            _this._selectedIndex = null;
            /**
             * Position of the tab header.
             */
            _this.headerPosition = 'above';
            /**
             * Output to enable support for two-way binding on `[(selectedIndex)]`
             */
            _this.selectedIndexChange = new core.EventEmitter();
            /**
             * Event emitted when focus has changed within a tab group.
             */
            _this.focusChange = new core.EventEmitter();
            /**
             * Event emitted when the body animation has completed
             */
            _this.animationDone = new core.EventEmitter();
            /**
             * Event emitted when the tab selection has changed.
             */
            _this.selectedTabChange = new core.EventEmitter(true);
            _this._groupId = nextId$4++;
            return _this;
        }
        Object.defineProperty(MatTabGroup.prototype, "dynamicHeight", {
            get: /**
             * Whether the tab group should grow to the size of the active tab.
             * @return {?}
             */
            function () { return this._dynamicHeight; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._dynamicHeight = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTabGroup.prototype, "selectedIndex", {
            get: /**
             * The index of the active tab.
             * @return {?}
             */
            function () { return this._selectedIndex; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._indexToSelect = coerceNumberProperty(value, null);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTabGroup.prototype, "backgroundColor", {
            get: /**
             * Background color of the tab group.
             * @return {?}
             */
            function () { return this._backgroundColor; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
                nativeElement.classList.remove("mat-background-" + this.backgroundColor);
                if (value) {
                    nativeElement.classList.add("mat-background-" + value);
                }
                this._backgroundColor = value;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * After the content is checked, this component knows what tabs have been defined
         * and what the selected index should be. This is where we can know exactly what position
         * each tab should be in according to the new selected index, and additionally we know how
         * a new selected tab should transition in (from the left or right).
         */
        /**
         * After the content is checked, this component knows what tabs have been defined
         * and what the selected index should be. This is where we can know exactly what position
         * each tab should be in according to the new selected index, and additionally we know how
         * a new selected tab should transition in (from the left or right).
         * @return {?}
         */
        MatTabGroup.prototype.ngAfterContentChecked = /**
         * After the content is checked, this component knows what tabs have been defined
         * and what the selected index should be. This is where we can know exactly what position
         * each tab should be in according to the new selected index, and additionally we know how
         * a new selected tab should transition in (from the left or right).
         * @return {?}
         */
        function () {
            var _this = this;
            // Clamp the next selected index to the boundsof 0 and the tabs length.
            // Note the `|| 0`, which ensures that values like NaN can't get through
            // and which would otherwise throw the component into an infinite loop
            // (since Math.max(NaN, 0) === NaN).
            var /** @type {?} */ indexToSelect = this._indexToSelect =
                Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
            // If there is a change in selected index, emit a change event. Should not trigger if
            // the selected index has not yet been initialized.
            if (this._selectedIndex != indexToSelect && this._selectedIndex != null) {
                var /** @type {?} */ tabChangeEvent = this._createChangeEvent(indexToSelect);
                this.selectedTabChange.emit(tabChangeEvent);
                // Emitting this value after change detection has run
                // since the checked content may contain this variable'
                Promise.resolve().then(function () { return _this.selectedIndexChange.emit(indexToSelect); });
            }
            // Setup the position for each tab and optionally setup an origin on the next selected tab.
            this._tabs.forEach(function (tab, index) {
                tab.position = index - indexToSelect;
                tab.isActive = index === indexToSelect;
                // If there is already a selected tab, then set up an origin for the next selected tab
                // if it doesn't have one already.
                if (_this._selectedIndex != null && tab.position == 0 && !tab.origin) {
                    tab.origin = indexToSelect - _this._selectedIndex;
                }
            });
            if (this._selectedIndex !== indexToSelect) {
                this._selectedIndex = indexToSelect;
                this._changeDetectorRef.markForCheck();
            }
        };
        /**
         * @return {?}
         */
        MatTabGroup.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._subscribeToTabLabels();
            // Subscribe to changes in the amount of tabs, in order to be
            // able to re-render the content as new tabs are added or removed.
            this._tabsSubscription = this._tabs.changes.subscribe(function () {
                _this._subscribeToTabLabels();
                _this._changeDetectorRef.markForCheck();
            });
        };
        /**
         * @return {?}
         */
        MatTabGroup.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._tabsSubscription.unsubscribe();
            this._tabLabelSubscription.unsubscribe();
        };
        /** Re-aligns the ink bar to the selected tab element. */
        /**
         * Re-aligns the ink bar to the selected tab element.
         * @return {?}
         */
        MatTabGroup.prototype.realignInkBar = /**
         * Re-aligns the ink bar to the selected tab element.
         * @return {?}
         */
        function () {
            if (this._tabHeader) {
                this._tabHeader._alignInkBarToSelectedTab();
            }
        };
        /**
         * @param {?} index
         * @return {?}
         */
        MatTabGroup.prototype._focusChanged = /**
         * @param {?} index
         * @return {?}
         */
        function (index) {
            this.focusChange.emit(this._createChangeEvent(index));
        };
        /**
         * @param {?} index
         * @return {?}
         */
        MatTabGroup.prototype._createChangeEvent = /**
         * @param {?} index
         * @return {?}
         */
        function (index) {
            var /** @type {?} */ event = new MatTabChangeEvent;
            event.index = index;
            if (this._tabs && this._tabs.length) {
                event.tab = this._tabs.toArray()[index];
            }
            return event;
        };
        /**
         * Subscribes to changes in the tab labels. This is needed, because the \@Input for the label is
         * on the MatTab component, whereas the data binding is inside the MatTabGroup. In order for the
         * binding to be updated, we need to subscribe to changes in it and trigger change detection
         * manually.
         * @return {?}
         */
        MatTabGroup.prototype._subscribeToTabLabels = /**
         * Subscribes to changes in the tab labels. This is needed, because the \@Input for the label is
         * on the MatTab component, whereas the data binding is inside the MatTabGroup. In order for the
         * binding to be updated, we need to subscribe to changes in it and trigger change detection
         * manually.
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._tabLabelSubscription) {
                this._tabLabelSubscription.unsubscribe();
            }
            this._tabLabelSubscription = rxjs.merge.apply(void 0, this._tabs.map(function (tab) { return tab._disableChange; }).concat(this._tabs.map(function (tab) { return tab._labelChange; }))).subscribe(function () {
                _this._changeDetectorRef.markForCheck();
            });
        };
        /** Returns a unique id for each tab label element */
        /**
         * Returns a unique id for each tab label element
         * @param {?} i
         * @return {?}
         */
        MatTabGroup.prototype._getTabLabelId = /**
         * Returns a unique id for each tab label element
         * @param {?} i
         * @return {?}
         */
        function (i) {
            return "mat-tab-label-" + this._groupId + "-" + i;
        };
        /** Returns a unique id for each tab content element */
        /**
         * Returns a unique id for each tab content element
         * @param {?} i
         * @return {?}
         */
        MatTabGroup.prototype._getTabContentId = /**
         * Returns a unique id for each tab content element
         * @param {?} i
         * @return {?}
         */
        function (i) {
            return "mat-tab-content-" + this._groupId + "-" + i;
        };
        /**
         * Sets the height of the body wrapper to the height of the activating tab if dynamic
         * height property is true.
         */
        /**
         * Sets the height of the body wrapper to the height of the activating tab if dynamic
         * height property is true.
         * @param {?} tabHeight
         * @return {?}
         */
        MatTabGroup.prototype._setTabBodyWrapperHeight = /**
         * Sets the height of the body wrapper to the height of the activating tab if dynamic
         * height property is true.
         * @param {?} tabHeight
         * @return {?}
         */
        function (tabHeight) {
            if (!this._dynamicHeight || !this._tabBodyWrapperHeight) {
                return;
            }
            var /** @type {?} */ wrapper = this._tabBodyWrapper.nativeElement;
            wrapper.style.height = this._tabBodyWrapperHeight + 'px';
            // This conditional forces the browser to paint the height so that
            // the animation to the new height can have an origin.
            if (this._tabBodyWrapper.nativeElement.offsetHeight) {
                wrapper.style.height = tabHeight + 'px';
            }
        };
        /** Removes the height of the tab body wrapper. */
        /**
         * Removes the height of the tab body wrapper.
         * @return {?}
         */
        MatTabGroup.prototype._removeTabBodyWrapperHeight = /**
         * Removes the height of the tab body wrapper.
         * @return {?}
         */
        function () {
            this._tabBodyWrapperHeight = this._tabBodyWrapper.nativeElement.clientHeight;
            this._tabBodyWrapper.nativeElement.style.height = '';
            this.animationDone.emit();
        };
        /** Handle click events, setting new selected index if appropriate. */
        /**
         * Handle click events, setting new selected index if appropriate.
         * @param {?} tab
         * @param {?} tabHeader
         * @param {?} idx
         * @return {?}
         */
        MatTabGroup.prototype._handleClick = /**
         * Handle click events, setting new selected index if appropriate.
         * @param {?} tab
         * @param {?} tabHeader
         * @param {?} idx
         * @return {?}
         */
        function (tab, tabHeader, idx) {
            if (!tab.disabled) {
                this.selectedIndex = tabHeader.focusIndex = idx;
            }
        };
        /** Retrieves the tabindex for the tab. */
        /**
         * Retrieves the tabindex for the tab.
         * @param {?} tab
         * @param {?} idx
         * @return {?}
         */
        MatTabGroup.prototype._getTabIndex = /**
         * Retrieves the tabindex for the tab.
         * @param {?} tab
         * @param {?} idx
         * @return {?}
         */
        function (tab, idx) {
            if (tab.disabled) {
                return null;
            }
            return this.selectedIndex === idx ? 0 : -1;
        };
        MatTabGroup.decorators = [
            { type: core.Component, args: [{selector: 'mat-tab-group',
                        exportAs: 'matTabGroup',
                        template: "<mat-tab-header #tabHeader [selectedIndex]=\"selectedIndex\" [disableRipple]=\"disableRipple\" (indexFocused)=\"_focusChanged($event)\" (selectFocusedIndex)=\"selectedIndex = $event\"><div class=\"mat-tab-label\" role=\"tab\" matTabLabelWrapper mat-ripple *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabLabelId(i)\" [attr.tabIndex]=\"_getTabIndex(tab, i)\" [attr.aria-posinset]=\"i + 1\" [attr.aria-setsize]=\"_tabs.length\" [attr.aria-controls]=\"_getTabContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [class.mat-tab-label-active]=\"selectedIndex == i\" [disabled]=\"tab.disabled\" [matRippleDisabled]=\"tab.disabled || disableRipple\" (click)=\"_handleClick(tab, tabHeader, i)\"><div class=\"mat-tab-label-content\"><ng-template [ngIf]=\"tab.templateLabel\"><ng-template [cdkPortalOutlet]=\"tab.templateLabel\"></ng-template></ng-template><ng-template [ngIf]=\"!tab.templateLabel\">{{tab.textLabel}}</ng-template></div></div></mat-tab-header><div class=\"mat-tab-body-wrapper\" #tabBodyWrapper><mat-tab-body role=\"tabpanel\" *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabContentId(i)\" [attr.aria-labelledby]=\"_getTabLabelId(i)\" [class.mat-tab-body-active]=\"selectedIndex == i\" [content]=\"tab.content\" [position]=\"tab.position\" [origin]=\"tab.origin\" (_onCentered)=\"_removeTabBodyWrapperHeight()\" (_onCentering)=\"_setTabBodyWrapperHeight($event)\"></mat-tab-body></div>",
                        styles: [".mat-tab-group{display:flex;flex-direction:column}.mat-tab-group.mat-tab-group-inverted-header{flex-direction:column-reverse}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-label.mat-tab-disabled{cursor:default}.mat-tab-label .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (max-width:599px){.mat-tab-label{padding:0 12px}}@media (max-width:959px){.mat-tab-label{padding:0 12px}}.mat-tab-group[mat-stretch-tabs] .mat-tab-label{flex-basis:0;flex-grow:1}.mat-tab-body-wrapper{position:relative;overflow:hidden;display:flex;transition:height .5s cubic-bezier(.35,0,.25,1)}.mat-tab-body{top:0;left:0;right:0;bottom:0;position:absolute;display:block;overflow:hidden;flex-basis:100%}.mat-tab-body.mat-tab-body-active{position:relative;overflow-x:hidden;overflow-y:auto;z-index:1;flex-grow:1}.mat-tab-group.mat-tab-group-dynamic-height .mat-tab-body.mat-tab-body-active{overflow-y:hidden}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        inputs: ['color', 'disableRipple'],
                        host: {
                            'class': 'mat-tab-group',
                            '[class.mat-tab-group-dynamic-height]': 'dynamicHeight',
                            '[class.mat-tab-group-inverted-header]': 'headerPosition === "below"',
                        },
                    },] },
        ];
        /** @nocollapse */
        MatTabGroup.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
        ]; };
        MatTabGroup.propDecorators = {
            "_tabs": [{ type: core.ContentChildren, args: [MatTab,] },],
            "_tabBodyWrapper": [{ type: core.ViewChild, args: ['tabBodyWrapper',] },],
            "_tabHeader": [{ type: core.ViewChild, args: ['tabHeader',] },],
            "dynamicHeight": [{ type: core.Input },],
            "selectedIndex": [{ type: core.Input },],
            "headerPosition": [{ type: core.Input },],
            "backgroundColor": [{ type: core.Input },],
            "selectedIndexChange": [{ type: core.Output },],
            "focusChange": [{ type: core.Output },],
            "animationDone": [{ type: core.Output },],
            "selectedTabChange": [{ type: core.Output },],
        };
        return MatTabGroup;
    }(_MatTabGroupMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatTabNavBase = /** @class */ (function () {
        function MatTabNavBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatTabNavBase;
    }());
    var /** @type {?} */ _MatTabNavMixinBase = mixinDisableRipple(mixinColor(MatTabNavBase, 'primary'));
    /**
     * Navigation component matching the styles of the tab group header.
     * Provides anchored navigation with animated ink bar.
     */
    var MatTabNav = /** @class */ (function (_super) {
        __extends(MatTabNav, _super);
        function MatTabNav(elementRef, _dir, _ngZone, _changeDetectorRef, _viewportRuler) {
            var _this = _super.call(this, elementRef) || this;
            _this._dir = _dir;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._viewportRuler = _viewportRuler;
            /**
             * Subject that emits when the component has been destroyed.
             */
            _this._onDestroy = new rxjs.Subject();
            return _this;
        }
        Object.defineProperty(MatTabNav.prototype, "backgroundColor", {
            get: /**
             * Background color of the tab nav.
             * @return {?}
             */
            function () { return this._backgroundColor; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
                nativeElement.classList.remove("mat-background-" + this.backgroundColor);
                if (value) {
                    nativeElement.classList.add("mat-background-" + value);
                }
                this._backgroundColor = value;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Notifies the component that the active link has been changed.
         * @deletion-target 7.0.0 `element` parameter to be removed.
         */
        /**
         * Notifies the component that the active link has been changed.
         * \@deletion-target 7.0.0 `element` parameter to be removed.
         * @param {?} element
         * @return {?}
         */
        MatTabNav.prototype.updateActiveLink = /**
         * Notifies the component that the active link has been changed.
         * \@deletion-target 7.0.0 `element` parameter to be removed.
         * @param {?} element
         * @return {?}
         */
        function (element) {
            // Note: keeping the `element` for backwards-compat, but isn't being used for anything.
            // @deletion-target 7.0.0
            this._activeLinkChanged = !!element;
            this._changeDetectorRef.markForCheck();
        };
        /**
         * @return {?}
         */
        MatTabNav.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                var /** @type {?} */ dirChange = _this._dir ? _this._dir.change : rxjs.of(null);
                return rxjs.merge(dirChange, _this._viewportRuler.change(10))
                    .pipe(operators.takeUntil(_this._onDestroy))
                    .subscribe(function () { return _this._alignInkBar(); });
            });
        };
        /** Checks if the active link has been changed and, if so, will update the ink bar. */
        /**
         * Checks if the active link has been changed and, if so, will update the ink bar.
         * @return {?}
         */
        MatTabNav.prototype.ngAfterContentChecked = /**
         * Checks if the active link has been changed and, if so, will update the ink bar.
         * @return {?}
         */
        function () {
            if (this._activeLinkChanged) {
                var /** @type {?} */ activeTab = this._tabLinks.find(function (tab) { return tab.active; });
                this._activeLinkElement = activeTab ? activeTab._elementRef : null;
                this._alignInkBar();
                this._activeLinkChanged = false;
            }
        };
        /**
         * @return {?}
         */
        MatTabNav.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._onDestroy.next();
            this._onDestroy.complete();
        };
        /** Aligns the ink bar to the active link. */
        /**
         * Aligns the ink bar to the active link.
         * @return {?}
         */
        MatTabNav.prototype._alignInkBar = /**
         * Aligns the ink bar to the active link.
         * @return {?}
         */
        function () {
            if (this._activeLinkElement) {
                this._inkBar.show();
                this._inkBar.alignToElement(this._activeLinkElement.nativeElement);
            }
            else {
                this._inkBar.hide();
            }
        };
        MatTabNav.decorators = [
            { type: core.Component, args: [{selector: '[mat-tab-nav-bar]',
                        exportAs: 'matTabNavBar, matTabNav',
                        inputs: ['color', 'disableRipple'],
                        template: "<div class=\"mat-tab-links\" (cdkObserveContent)=\"_alignInkBar()\"><ng-content></ng-content><mat-ink-bar></mat-ink-bar></div>",
                        styles: [".mat-tab-nav-bar{overflow:hidden;position:relative;flex-shrink:0}.mat-tab-links{position:relative;display:flex}.mat-tab-link{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;vertical-align:top;text-decoration:none;position:relative;overflow:hidden}.mat-tab-link:focus{outline:0}.mat-tab-link:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-link.mat-tab-disabled{cursor:default}.mat-tab-link .mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}[mat-stretch-tabs] .mat-tab-link{flex-basis:0;flex-grow:1}@media (max-width:599px){.mat-tab-link{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media screen and (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}"],
                        host: { 'class': 'mat-tab-nav-bar' },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                    },] },
        ];
        /** @nocollapse */
        MatTabNav.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
            { type: core.NgZone, },
            { type: core.ChangeDetectorRef, },
            { type: ViewportRuler, },
        ]; };
        MatTabNav.propDecorators = {
            "_inkBar": [{ type: core.ViewChild, args: [MatInkBar,] },],
            "_tabLinks": [{ type: core.ContentChildren, args: [core.forwardRef(function () { return MatTabLink; }), { descendants: true },] },],
            "backgroundColor": [{ type: core.Input },],
        };
        return MatTabNav;
    }(_MatTabNavMixinBase));
    var MatTabLinkBase = /** @class */ (function () {
        function MatTabLinkBase() {
        }
        return MatTabLinkBase;
    }());
    var /** @type {?} */ _MatTabLinkMixinBase = mixinTabIndex(mixinDisableRipple(mixinDisabled(MatTabLinkBase)));
    /**
     * Link inside of a `mat-tab-nav-bar`.
     */
    var MatTabLink = /** @class */ (function (_super) {
        __extends(MatTabLink, _super);
        function MatTabLink(_tabNavBar, _elementRef, ngZone, platform, globalOptions, tabIndex) {
            var _this = _super.call(this) || this;
            _this._tabNavBar = _tabNavBar;
            _this._elementRef = _elementRef;
            /**
             * Whether the tab link is active or not.
             */
            _this._isActive = false;
            /**
             * Ripple configuration for ripples that are launched on pointer down.
             * \@docs-private
             */
            _this.rippleConfig = {};
            _this._tabLinkRipple = new RippleRenderer(_this, ngZone, _elementRef, platform);
            _this._tabLinkRipple.setupTriggerEvents(_elementRef.nativeElement);
            _this.tabIndex = parseInt(tabIndex) || 0;
            if (globalOptions) {
                _this.rippleConfig = {
                    terminateOnPointerUp: globalOptions.terminateOnPointerUp,
                    speedFactor: globalOptions.baseSpeedFactor,
                    animation: globalOptions.animation,
                };
            }
            return _this;
        }
        Object.defineProperty(MatTabLink.prototype, "active", {
            get: /**
             * Whether the link is active.
             * @return {?}
             */
            function () { return this._isActive; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value !== this._isActive) {
                    this._isActive = value;
                    this._tabNavBar.updateActiveLink(this._elementRef);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MatTabLink.prototype, "rippleDisabled", {
            /**
             * Whether ripples are disabled on interaction
             * @docs-private
             */
            get: /**
             * Whether ripples are disabled on interaction
             * \@docs-private
             * @return {?}
             */
            function () {
                return this.disabled || this.disableRipple || this._tabNavBar.disableRipple;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        MatTabLink.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._tabLinkRipple._removeTriggerEvents();
        };
        /**
         * Handles the click event, preventing default navigation if the tab link is disabled.
         */
        /**
         * Handles the click event, preventing default navigation if the tab link is disabled.
         * @param {?} event
         * @return {?}
         */
        MatTabLink.prototype._handleClick = /**
         * Handles the click event, preventing default navigation if the tab link is disabled.
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (this.disabled) {
                event.preventDefault();
            }
        };
        MatTabLink.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mat-tab-link], [matTabLink]',
                        exportAs: 'matTabLink',
                        inputs: ['disabled', 'disableRipple', 'tabIndex'],
                        host: {
                            'class': 'mat-tab-link',
                            '[attr.aria-current]': 'active',
                            '[attr.aria-disabled]': 'disabled.toString()',
                            '[attr.tabIndex]': 'tabIndex',
                            '[class.mat-tab-disabled]': 'disabled',
                            '[class.mat-tab-label-active]': 'active',
                            '(click)': '_handleClick($event)'
                        }
                    },] },
        ];
        /** @nocollapse */
        MatTabLink.ctorParameters = function () { return [
            { type: MatTabNav, },
            { type: core.ElementRef, },
            { type: core.NgZone, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
        ]; };
        MatTabLink.propDecorators = {
            "active": [{ type: core.Input },],
        };
        return MatTabLink;
    }(_MatTabLinkMixinBase));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * \@docs-private
     */
    var  /**
     * \@docs-private
     */
    MatToolbarBase = /** @class */ (function () {
        function MatToolbarBase(_elementRef) {
            this._elementRef = _elementRef;
        }
        return MatToolbarBase;
    }());
    var /** @type {?} */ _MatToolbarMixinBase = mixinColor(MatToolbarBase);
    var MatToolbarRow = /** @class */ (function () {
        function MatToolbarRow() {
        }
        MatToolbarRow.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-toolbar-row',
                        exportAs: 'matToolbarRow',
                        host: { 'class': 'mat-toolbar-row' },
                    },] },
        ];
        return MatToolbarRow;
    }());
    var MatToolbar = /** @class */ (function (_super) {
        __extends(MatToolbar, _super);
        function MatToolbar(elementRef, _platform, document) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            // TODO: make the document a required param when doing breaking changes.
            // TODO: make the document a required param when doing breaking changes.
            _this._document = document;
            return _this;
        }
        /**
         * @return {?}
         */
        MatToolbar.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (!core.isDevMode() || !this._platform.isBrowser) {
                return;
            }
            this._checkToolbarMixedModes();
            this._toolbarRows.changes.subscribe(function () { return _this._checkToolbarMixedModes(); });
        };
        /**
         * Throws an exception when developers are attempting to combine the different toolbar row modes.
         * @return {?}
         */
        MatToolbar.prototype._checkToolbarMixedModes = /**
         * Throws an exception when developers are attempting to combine the different toolbar row modes.
         * @return {?}
         */
        function () {
            var _this = this;
            if (!this._toolbarRows.length) {
                return;
            }
            // Check if there are any other DOM nodes that can display content but aren't inside of
            // a <mat-toolbar-row> element.
            var /** @type {?} */ isCombinedUsage = [].slice.call(this._elementRef.nativeElement.childNodes)
                .filter(function (node) { return !(node.classList && node.classList.contains('mat-toolbar-row')); })
                .filter(function (node) { return node.nodeType !== (_this._document ? _this._document.COMMENT_NODE : 8); })
                .some(function (node) { return node.textContent.trim(); });
            if (isCombinedUsage) {
                throwToolbarMixedModesError();
            }
        };
        MatToolbar.decorators = [
            { type: core.Component, args: [{selector: 'mat-toolbar',
                        exportAs: 'matToolbar',
                        template: "<ng-content></ng-content><ng-content select=\"mat-toolbar-row\"></ng-content>",
                        styles: ["@media screen and (-ms-high-contrast:active){.mat-toolbar{outline:solid 1px}}.mat-toolbar-row,.mat-toolbar-single-row{display:flex;box-sizing:border-box;padding:0 16px;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar-multiple-rows{display:flex;box-sizing:border-box;flex-direction:column;width:100%}.mat-toolbar-multiple-rows{min-height:64px}.mat-toolbar-row,.mat-toolbar-single-row{height:64px}@media (max-width:599px){.mat-toolbar-multiple-rows{min-height:56px}.mat-toolbar-row,.mat-toolbar-single-row{height:56px}}"],
                        inputs: ['color'],
                        host: {
                            'class': 'mat-toolbar',
                            '[class.mat-toolbar-multiple-rows]': 'this._toolbarRows.length',
                            '[class.mat-toolbar-single-row]': '!this._toolbarRows.length'
                        },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                    },] },
        ];
        /** @nocollapse */
        MatToolbar.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: Platform, },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] },] },
        ]; };
        MatToolbar.propDecorators = {
            "_toolbarRows": [{ type: core.ContentChildren, args: [MatToolbarRow,] },],
        };
        return MatToolbar;
    }(_MatToolbarMixinBase));
    /**
     * Throws an exception when attempting to combine the different toolbar row modes.
     * \@docs-private
     * @return {?}
     */
    function throwToolbarMixedModesError() {
        throw Error('MatToolbar: Attempting to combine different toolbar modes. ' +
            'Either specify multiple `<mat-toolbar-row>` elements explicitly or just place content ' +
            'inside of a `<mat-toolbar>` for a single row.');
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MatToolbarModule = /** @class */ (function () {
        function MatToolbarModule() {
        }
        MatToolbarModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [MatCommonModule],
                        exports: [MatToolbar, MatToolbarRow, MatCommonModule],
                        declarations: [MatToolbar, MatToolbarRow],
                    },] },
        ];
        return MatToolbarModule;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Base tree control. It has basic toggle/expand/collapse operations on a single data node.
     * @abstract
     * @template T
     */
    var  /**
     * Base tree control. It has basic toggle/expand/collapse operations on a single data node.
     * @abstract
     * @template T
     */
    BaseTreeControl = /** @class */ (function () {
        function BaseTreeControl() {
            /**
             * A selection model with multi-selection to track expansion status.
             */
            this.expansionModel = new SelectionModel(true);
        }
        /** Toggles one single data node's expanded/collapsed state. */
        /**
         * Toggles one single data node's expanded/collapsed state.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.toggle = /**
         * Toggles one single data node's expanded/collapsed state.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            this.expansionModel.toggle(dataNode);
        };
        /** Expands one single data node. */
        /**
         * Expands one single data node.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.expand = /**
         * Expands one single data node.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            this.expansionModel.select(dataNode);
        };
        /** Collapses one single data node. */
        /**
         * Collapses one single data node.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.collapse = /**
         * Collapses one single data node.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            this.expansionModel.deselect(dataNode);
        };
        /** Whether a given data node is expanded or not. Returns true if the data node is expanded. */
        /**
         * Whether a given data node is expanded or not. Returns true if the data node is expanded.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.isExpanded = /**
         * Whether a given data node is expanded or not. Returns true if the data node is expanded.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            return this.expansionModel.isSelected(dataNode);
        };
        /** Toggles a subtree rooted at `node` recursively. */
        /**
         * Toggles a subtree rooted at `node` recursively.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.toggleDescendants = /**
         * Toggles a subtree rooted at `node` recursively.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            this.expansionModel.isSelected(dataNode)
                ? this.collapseDescendants(dataNode)
                : this.expandDescendants(dataNode);
        };
        /** Collapse all dataNodes in the tree. */
        /**
         * Collapse all dataNodes in the tree.
         * @return {?}
         */
        BaseTreeControl.prototype.collapseAll = /**
         * Collapse all dataNodes in the tree.
         * @return {?}
         */
        function () {
            this.expansionModel.clear();
        };
        /** Expands a subtree rooted at given data node recursively. */
        /**
         * Expands a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.expandDescendants = /**
         * Expands a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            var /** @type {?} */ toBeProcessed = [dataNode];
            toBeProcessed.push.apply(toBeProcessed, this.getDescendants(dataNode));
            (_a = this.expansionModel).select.apply(_a, toBeProcessed);
            var _a;
        };
        /** Collapses a subtree rooted at given data node recursively. */
        /**
         * Collapses a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        BaseTreeControl.prototype.collapseDescendants = /**
         * Collapses a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            var /** @type {?} */ toBeProcessed = [dataNode];
            toBeProcessed.push.apply(toBeProcessed, this.getDescendants(dataNode));
            (_a = this.expansionModel).deselect.apply(_a, toBeProcessed);
            var _a;
        };
        return BaseTreeControl;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Flat tree control. Able to expand/collapse a subtree recursively for flattened tree.
     * @template T
     */
    var  /**
     * Flat tree control. Able to expand/collapse a subtree recursively for flattened tree.
     * @template T
     */
    FlatTreeControl = /** @class */ (function (_super) {
        __extends(FlatTreeControl, _super);
        /** Construct with flat tree data node functions getLevel and isExpandable. */
        function FlatTreeControl(getLevel, isExpandable) {
            var _this = _super.call(this) || this;
            _this.getLevel = getLevel;
            _this.isExpandable = isExpandable;
            return _this;
        }
        /**
         * Gets a list of the data node's subtree of descendent data nodes.
         *
         * To make this working, the `dataNodes` of the TreeControl must be flattened tree nodes
         * with correct levels.
         */
        /**
         * Gets a list of the data node's subtree of descendent data nodes.
         *
         * To make this working, the `dataNodes` of the TreeControl must be flattened tree nodes
         * with correct levels.
         * @param {?} dataNode
         * @return {?}
         */
        FlatTreeControl.prototype.getDescendants = /**
         * Gets a list of the data node's subtree of descendent data nodes.
         *
         * To make this working, the `dataNodes` of the TreeControl must be flattened tree nodes
         * with correct levels.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            var /** @type {?} */ startIndex = this.dataNodes.indexOf(dataNode);
            var /** @type {?} */ results = [];
            // Goes through flattened tree nodes in the `dataNodes` array, and get all descendants.
            // The level of descendants of a tree node must be greater than the level of the given
            // tree node.
            // If we reach a node whose level is equal to the level of the tree node, we hit a sibling.
            // If we reach a node whose level is greater than the level of the tree node, we hit a
            // sibling of an ancestor.
            for (var /** @type {?} */ i = startIndex + 1; i < this.dataNodes.length && this.getLevel(dataNode) < this.getLevel(this.dataNodes[i]); i++) {
                results.push(this.dataNodes[i]);
            }
            return results;
        };
        /**
         * Expands all data nodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all flattened
         * data nodes of the tree.
         */
        /**
         * Expands all data nodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all flattened
         * data nodes of the tree.
         * @return {?}
         */
        FlatTreeControl.prototype.expandAll = /**
         * Expands all data nodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all flattened
         * data nodes of the tree.
         * @return {?}
         */
        function () {
            (_a = this.expansionModel).select.apply(_a, this.dataNodes);
            var _a;
        };
        return FlatTreeControl;
    }(BaseTreeControl));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Nested tree control. Able to expand/collapse a subtree recursively for NestedNode type.
     * @template T
     */
    var  /**
     * Nested tree control. Able to expand/collapse a subtree recursively for NestedNode type.
     * @template T
     */
    NestedTreeControl = /** @class */ (function (_super) {
        __extends(NestedTreeControl, _super);
        /** Construct with nested tree function getChildren. */
        function NestedTreeControl(getChildren) {
            var _this = _super.call(this) || this;
            _this.getChildren = getChildren;
            return _this;
        }
        /**
         * Expands all dataNodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all root level
         * data nodes of the tree.
         */
        /**
         * Expands all dataNodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all root level
         * data nodes of the tree.
         * @return {?}
         */
        NestedTreeControl.prototype.expandAll = /**
         * Expands all dataNodes in the tree.
         *
         * To make this working, the `dataNodes` variable of the TreeControl must be set to all root level
         * data nodes of the tree.
         * @return {?}
         */
        function () {
            var _this = this;
            this.expansionModel.clear();
            var /** @type {?} */ allNodes = this.dataNodes.reduce(function (accumulator, dataNode) {
                return accumulator.concat(_this.getDescendants(dataNode), [dataNode]);
            }, []);
            (_a = this.expansionModel).select.apply(_a, allNodes);
            var _a;
        };
        /** Gets a list of descendant dataNodes of a subtree rooted at given data node recursively. */
        /**
         * Gets a list of descendant dataNodes of a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        NestedTreeControl.prototype.getDescendants = /**
         * Gets a list of descendant dataNodes of a subtree rooted at given data node recursively.
         * @param {?} dataNode
         * @return {?}
         */
        function (dataNode) {
            var /** @type {?} */ descendants = [];
            this._getDescendants(descendants, dataNode);
            // Remove the node itself
            return descendants.splice(1);
        };
        /** A helper function to get descendants recursively. */
        /**
         * A helper function to get descendants recursively.
         * @param {?} descendants
         * @param {?} dataNode
         * @return {?}
         */
        NestedTreeControl.prototype._getDescendants = /**
         * A helper function to get descendants recursively.
         * @param {?} descendants
         * @param {?} dataNode
         * @return {?}
         */
        function (descendants, dataNode) {
            var _this = this;
            descendants.push(dataNode);
            this.getChildren(dataNode).pipe(operators.take(1)).subscribe(function (children) {
                if (children && children.length > 0) {
                    children.forEach(function (child) { return _this._getDescendants(descendants, child); });
                }
            });
        };
        return NestedTreeControl;
    }(BaseTreeControl));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Context provided to the tree node component.
     * @template T
     */
    var  /**
     * Context provided to the tree node component.
     * @template T
     */
    CdkTreeNodeOutletContext = /** @class */ (function () {
        function CdkTreeNodeOutletContext(data) {
            this.$implicit = data;
        }
        return CdkTreeNodeOutletContext;
    }());
    /**
     * Data node definition for the CdkTree.
     * Captures the node's template and a when predicate that describes when this node should be used.
     * @template T
     */
    var CdkTreeNodeDef = /** @class */ (function () {
        /** @docs-private */
        function CdkTreeNodeDef(template) {
            this.template = template;
        }
        CdkTreeNodeDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkTreeNodeDef]',
                        inputs: [
                            'when: cdkTreeNodeDefWhen'
                        ],
                    },] },
        ];
        /** @nocollapse */
        CdkTreeNodeDef.ctorParameters = function () { return [
            { type: core.TemplateRef, },
        ]; };
        return CdkTreeNodeDef;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Outlet for nested CdkNode. Put `[cdkTreeNodeOutlet]` on a tag to place children dataNodes
     * inside the outlet.
     */
    var CdkTreeNodeOutlet = /** @class */ (function () {
        function CdkTreeNodeOutlet(viewContainer) {
            this.viewContainer = viewContainer;
        }
        CdkTreeNodeOutlet.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkTreeNodeOutlet]'
                    },] },
        ];
        /** @nocollapse */
        CdkTreeNodeOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        return CdkTreeNodeOutlet;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * Returns an error to be thrown when there is no usable data.
     * \@docs-private
     * @return {?}
     */
    function getTreeNoValidDataSourceError() {
        return Error("A valid data source must be provided.");
    }
    /**
     * Returns an error to be thrown when there are multiple nodes that are missing a when function.
     * \@docs-private
     * @return {?}
     */
    function getTreeMultipleDefaultNodeDefsError() {
        return Error("There can only be one default row without a when predicate function.");
    }
    /**
     * Returns an error to be thrown when there are no matching node defs for a particular set of data.
     * \@docs-private
     * @return {?}
     */
    function getTreeMissingMatchingNodeDefError() {
        return Error("Could not find a matching node definition for the provided node data.");
    }
    /**
     * Returns an error to be thrown when there are tree control.
     * \@docs-private
     * @return {?}
     */
    function getTreeControlMissingError() {
        return Error("Could not find a tree control for the tree.");
    }
    /**
     * Returns an error to be thrown when tree control did not implement functions for flat/nested node.
     * \@docs-private
     * @return {?}
     */
    function getTreeControlFunctionsMissingError() {
        return Error("Could not find functions for nested/flat tree in tree control.");
    }

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Tree node for CdkTree. It contains the data in the tree node.
     * @template T
     */
    var CdkTreeNode = /** @class */ (function () {
        function CdkTreeNode(_elementRef, _tree) {
            this._elementRef = _elementRef;
            this._tree = _tree;
            /**
             * Subject that emits when the component has been destroyed.
             */
            this._destroyed = new rxjs.Subject();
            /**
             * The role of the node should be 'group' if it's an internal node,
             * and 'treeitem' if it's a leaf node.
             */
            this.role = 'treeitem';
            CdkTreeNode.mostRecentTreeNode = /** @type {?} */ (this);
        }
        Object.defineProperty(CdkTreeNode.prototype, "data", {
            /** The tree node's data. */
            get: /**
             * The tree node's data.
             * @return {?}
             */
            function () { return this._data; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._data = value;
                this._setRoleFromData();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTreeNode.prototype, "isExpanded", {
            get: /**
             * @return {?}
             */
            function () {
                return this._tree.treeControl.isExpanded(this._data);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTreeNode.prototype, "level", {
            get: /**
             * @return {?}
             */
            function () {
                return this._tree.treeControl.getLevel ? this._tree.treeControl.getLevel(this._data) : 0;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkTreeNode.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroyed.next();
            this._destroyed.complete();
        };
        /** Focuses the menu item. Implements for FocusableOption. */
        /**
         * Focuses the menu item. Implements for FocusableOption.
         * @return {?}
         */
        CdkTreeNode.prototype.focus = /**
         * Focuses the menu item. Implements for FocusableOption.
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.focus();
        };
        /**
         * @return {?}
         */
        CdkTreeNode.prototype._setRoleFromData = /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this._tree.treeControl.isExpandable) {
                this.role = this._tree.treeControl.isExpandable(this._data) ? 'group' : 'treeitem';
            }
            else {
                if (!this._tree.treeControl.getChildren) {
                    throw getTreeControlFunctionsMissingError();
                }
                this._tree.treeControl.getChildren(this._data).pipe(operators.takeUntil(this._destroyed))
                    .subscribe(function (children) {
                    _this.role = children && children.length ? 'group' : 'treeitem';
                });
            }
        };
        /**
         * The most recently created `CdkTreeNode`. We save it in static variable so we can retrieve it
         * in `CdkTree` and set the data to it.
         */
        CdkTreeNode.mostRecentTreeNode = null;
        CdkTreeNode.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-tree-node',
                        exportAs: 'cdkTreeNode',
                        host: {
                            '[attr.aria-expanded]': 'isExpanded',
                            '[attr.aria-level]': 'role === "treeitem" ? level : null',
                            '[attr.role]': 'role',
                            'class': 'cdk-tree-node',
                        },
                    },] },
        ];
        /** @nocollapse */
        CdkTreeNode.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: CdkTree, },
        ]; };
        CdkTreeNode.propDecorators = {
            "role": [{ type: core.Input },],
        };
        return CdkTreeNode;
    }());
    /**
     * CDK tree component that connects with a data source to retrieve data of type `T` and renders
     * dataNodes with hierarchy. Updates the dataNodes when new data is provided by the data source.
     * @template T
     */
    var CdkTree = /** @class */ (function () {
        function CdkTree(_differs, _changeDetectorRef) {
            this._differs = _differs;
            this._changeDetectorRef = _changeDetectorRef;
            /**
             * Subject that emits when the component has been destroyed.
             */
            this._onDestroy = new rxjs.Subject();
            /**
             * Level of nodes
             */
            this._levels = new Map();
            /**
             * Stream containing the latest information on what rows are being displayed on screen.
             * Can be used by the data source to as a heuristic of what data should be provided.
             */
            this.viewChange = new rxjs.BehaviorSubject({ start: 0, end: Number.MAX_VALUE });
        }
        Object.defineProperty(CdkTree.prototype, "dataSource", {
            get: /**
             * Provides a stream containing the latest data array to render. Influenced by the tree's
             * stream of view window (what dataNodes are currently on screen).
             * Data source can be an observable of data array, or a dara array to render.
             * @return {?}
             */
            function () { return this._dataSource; },
            set: /**
             * @param {?} dataSource
             * @return {?}
             */
            function (dataSource) {
                if (this._dataSource !== dataSource) {
                    this._switchDataSource(dataSource);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkTree.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this._dataDiffer = this._differs.find([]).create(this.trackBy);
            if (!this.treeControl) {
                throw getTreeControlMissingError();
            }
        };
        /**
         * @return {?}
         */
        CdkTree.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._nodeOutlet.viewContainer.clear();
            this._onDestroy.next();
            this._onDestroy.complete();
            if (this._dataSource && typeof (/** @type {?} */ (this._dataSource)).disconnect === 'function') {
                (/** @type {?} */ (this.dataSource)).disconnect(this);
            }
            if (this._dataSubscription) {
                this._dataSubscription.unsubscribe();
                this._dataSubscription = null;
            }
        };
        /**
         * @return {?}
         */
        CdkTree.prototype.ngAfterContentChecked = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ defaultNodeDefs = this._nodeDefs.filter(function (def) { return !def.when; });
            if (defaultNodeDefs.length > 1) {
                throw getTreeMultipleDefaultNodeDefsError();
            }
            this._defaultNodeDef = defaultNodeDefs[0];
            if (this.dataSource && this._nodeDefs && !this._dataSubscription) {
                this._observeRenderChanges();
            }
        };
        /**
         * Switch to the provided data source by resetting the data and unsubscribing from the current
         * render change subscription if one exists. If the data source is null, interpret this by
         * clearing the node outlet. Otherwise start listening for new data.
         * @param {?} dataSource
         * @return {?}
         */
        CdkTree.prototype._switchDataSource = /**
         * Switch to the provided data source by resetting the data and unsubscribing from the current
         * render change subscription if one exists. If the data source is null, interpret this by
         * clearing the node outlet. Otherwise start listening for new data.
         * @param {?} dataSource
         * @return {?}
         */
        function (dataSource) {
            if (this._dataSource && typeof (/** @type {?} */ (this._dataSource)).disconnect === 'function') {
                (/** @type {?} */ (this.dataSource)).disconnect(this);
            }
            if (this._dataSubscription) {
                this._dataSubscription.unsubscribe();
                this._dataSubscription = null;
            }
            // Remove the all dataNodes if there is now no data source
            if (!dataSource) {
                this._nodeOutlet.viewContainer.clear();
            }
            this._dataSource = dataSource;
            if (this._nodeDefs) {
                this._observeRenderChanges();
            }
        };
        /**
         * Set up a subscription for the data provided by the data source.
         * @return {?}
         */
        CdkTree.prototype._observeRenderChanges = /**
         * Set up a subscription for the data provided by the data source.
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ dataStream;
            // Cannot use `instanceof DataSource` since the data source could be a literal with
            // `connect` function and may not extends DataSource.
            if (typeof (/** @type {?} */ (this._dataSource)).connect === 'function') {
                dataStream = (/** @type {?} */ (this._dataSource)).connect(this);
            }
            else if (this._dataSource instanceof rxjs.Observable) {
                dataStream = this._dataSource;
            }
            else if (Array.isArray(this._dataSource)) {
                dataStream = rxjs.of(this._dataSource);
            }
            if (dataStream) {
                this._dataSubscription = dataStream.pipe(operators.takeUntil(this._onDestroy))
                    .subscribe(function (data) { return _this.renderNodeChanges(data); });
            }
            else {
                throw getTreeNoValidDataSourceError();
            }
        };
        /** Check for changes made in the data and render each change (node added/removed/moved). */
        /**
         * Check for changes made in the data and render each change (node added/removed/moved).
         * @param {?} data
         * @param {?=} dataDiffer
         * @param {?=} viewContainer
         * @param {?=} parentData
         * @return {?}
         */
        CdkTree.prototype.renderNodeChanges = /**
         * Check for changes made in the data and render each change (node added/removed/moved).
         * @param {?} data
         * @param {?=} dataDiffer
         * @param {?=} viewContainer
         * @param {?=} parentData
         * @return {?}
         */
        function (data, dataDiffer, viewContainer, parentData) {
            var _this = this;
            if (dataDiffer === void 0) { dataDiffer = this._dataDiffer; }
            if (viewContainer === void 0) { viewContainer = this._nodeOutlet.viewContainer; }
            var /** @type {?} */ changes = dataDiffer.diff(data);
            if (!changes) {
                return;
            }
            changes.forEachOperation(function (item, adjustedPreviousIndex, currentIndex) {
                if (item.previousIndex == null) {
                    _this.insertNode(data[currentIndex], currentIndex, viewContainer, parentData);
                }
                else if (currentIndex == null) {
                    viewContainer.remove(adjustedPreviousIndex);
                    _this._levels.delete(item.item);
                }
                else {
                    var /** @type {?} */ view = viewContainer.get(adjustedPreviousIndex);
                    viewContainer.move(/** @type {?} */ ((view)), currentIndex);
                }
            });
            this._changeDetectorRef.detectChanges();
        };
        /**
         * Finds the matching node definition that should be used for this node data. If there is only
         * one node definition, it is returned. Otherwise, find the node definition that has a when
         * predicate that returns true with the data. If none return true, return the default node
         * definition.
         */
        /**
         * Finds the matching node definition that should be used for this node data. If there is only
         * one node definition, it is returned. Otherwise, find the node definition that has a when
         * predicate that returns true with the data. If none return true, return the default node
         * definition.
         * @param {?} data
         * @param {?} i
         * @return {?}
         */
        CdkTree.prototype._getNodeDef = /**
         * Finds the matching node definition that should be used for this node data. If there is only
         * one node definition, it is returned. Otherwise, find the node definition that has a when
         * predicate that returns true with the data. If none return true, return the default node
         * definition.
         * @param {?} data
         * @param {?} i
         * @return {?}
         */
        function (data, i) {
            if (this._nodeDefs.length === 1) {
                return this._nodeDefs.first;
            }
            var /** @type {?} */ nodeDef = this._nodeDefs.find(function (def) { return def.when && def.when(i, data); }) || this._defaultNodeDef;
            if (!nodeDef) {
                throw getTreeMissingMatchingNodeDefError();
            }
            return nodeDef;
        };
        /**
         * Create the embedded view for the data node template and place it in the correct index location
         * within the data node view container.
         */
        /**
         * Create the embedded view for the data node template and place it in the correct index location
         * within the data node view container.
         * @param {?} nodeData
         * @param {?} index
         * @param {?=} viewContainer
         * @param {?=} parentData
         * @return {?}
         */
        CdkTree.prototype.insertNode = /**
         * Create the embedded view for the data node template and place it in the correct index location
         * within the data node view container.
         * @param {?} nodeData
         * @param {?} index
         * @param {?=} viewContainer
         * @param {?=} parentData
         * @return {?}
         */
        function (nodeData, index, viewContainer, parentData) {
            var /** @type {?} */ node = this._getNodeDef(nodeData, index);
            // Node context that will be provided to created embedded view
            var /** @type {?} */ context = new CdkTreeNodeOutletContext(nodeData);
            // If the tree is flat tree, then use the `getLevel` function in flat tree control
            // Otherwise, use the level of parent node.
            if (this.treeControl.getLevel) {
                context.level = this.treeControl.getLevel(nodeData);
            }
            else if (typeof parentData !== 'undefined' && this._levels.has(parentData)) {
                context.level = /** @type {?} */ ((this._levels.get(parentData))) + 1;
            }
            else {
                context.level = 0;
            }
            this._levels.set(nodeData, context.level);
            // Use default tree nodeOutlet, or nested node's nodeOutlet
            var /** @type {?} */ container = viewContainer ? viewContainer : this._nodeOutlet.viewContainer;
            container.createEmbeddedView(node.template, context, index);
            // Set the data to just created `CdkTreeNode`.
            // The `CdkTreeNode` created from `createEmbeddedView` will be saved in static variable
            //     `mostRecentTreeNode`. We get it from static variable and pass the node data to it.
            if (CdkTreeNode.mostRecentTreeNode) {
                CdkTreeNode.mostRecentTreeNode.data = nodeData;
            }
        };
        CdkTree.decorators = [
            { type: core.Component, args: [{selector: 'cdk-tree',
                        exportAs: 'cdkTree',
                        template: "<ng-container cdkTreeNodeOutlet></ng-container>",
                        host: {
                            'class': 'cdk-tree',
                            'role': 'tree',
                        },
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    },] },
        ];
        /** @nocollapse */
        CdkTree.ctorParameters = function () { return [
            { type: core.IterableDiffers, },
            { type: core.ChangeDetectorRef, },
        ]; };
        CdkTree.propDecorators = {
            "dataSource": [{ type: core.Input },],
            "treeControl": [{ type: core.Input },],
            "trackBy": [{ type: core.Input },],
            "_nodeOutlet": [{ type: core.ViewChild, args: [CdkTreeNodeOutlet,] },],
            "_nodeDefs": [{ type: core.ContentChildren, args: [CdkTreeNodeDef,] },],
        };
        return CdkTree;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Nested node is a child of `<cdk-tree>`. It works with nested tree.
     * By using `cdk-nested-tree-node` component in tree node template, children of the parent node will
     * be added in the `cdkTreeNodeOutlet` in tree node template.
     * For example:
     *   ```html
     *   <cdk-mested-tree-node>
     *     {{node.name}}
     *     <ng-template cdkTreeNodeOutlet></ng-template>
     *   </cdk-tree-node>
     *   ```
     * The children of node will be automatically added to `cdkTreeNodeOutlet`, the result dom will be
     * like this:
     *   ```html
     *   <cdk-nested-tree-node>
     *     {{node.name}}
     *      <cdk-nested-tree-node>{{child1.name}}</cdk-tree-node>
     *      <cdk-nested-tree-node>{{child2.name}}</cdk-tree-node>
     *   </cdk-tree-node>
     *   ```
     * @template T
     */
    var CdkNestedTreeNode = /** @class */ (function (_super) {
        __extends(CdkNestedTreeNode, _super);
        function CdkNestedTreeNode(_elementRef, _tree, _differs) {
            var _this = _super.call(this, _elementRef, _tree) || this;
            _this._elementRef = _elementRef;
            _this._tree = _tree;
            _this._differs = _differs;
            return _this;
        }
        /**
         * @return {?}
         */
        CdkNestedTreeNode.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this._dataDiffer = this._differs.find([]).create(this._tree.trackBy);
            if (!this._tree.treeControl.getChildren) {
                throw getTreeControlFunctionsMissingError();
            }
            this._tree.treeControl.getChildren(this.data).pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (result) {
                _this._children = result;
                _this.updateChildrenNodes();
            });
            this.nodeOutlet.changes.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this.updateChildrenNodes(); });
        };
        /**
         * @return {?}
         */
        CdkNestedTreeNode.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._clear();
            _super.prototype.ngOnDestroy.call(this);
        };
        /** Add children dataNodes to the NodeOutlet */
        /**
         * Add children dataNodes to the NodeOutlet
         * @return {?}
         */
        CdkNestedTreeNode.prototype.updateChildrenNodes = /**
         * Add children dataNodes to the NodeOutlet
         * @return {?}
         */
        function () {
            if (this.nodeOutlet.length && this._children) {
                var /** @type {?} */ viewContainer = this.nodeOutlet.first.viewContainer;
                this._tree.renderNodeChanges(this._children, this._dataDiffer, viewContainer, this._data);
            }
            else {
                // Reset the data differ if there's no children nodes displayed
                this._dataDiffer.diff([]);
            }
        };
        /** Clear the children dataNodes. */
        /**
         * Clear the children dataNodes.
         * @return {?}
         */
        CdkNestedTreeNode.prototype._clear = /**
         * Clear the children dataNodes.
         * @return {?}
         */
        function () {
            if (this.nodeOutlet && this.nodeOutlet.first) {
                this.nodeOutlet.first.viewContainer.clear();
                this._dataDiffer.diff([]);
            }
        };
        CdkNestedTreeNode.decorators = [
            { type: core.Directive, args: [{
                        selector: 'cdk-nested-tree-node',
                        exportAs: 'cdkNestedTreeNode',
                        host: {
                            '[attr.aria-expanded]': 'isExpanded',
                            '[attr.role]': 'role',
                            'class': 'cdk-tree-node cdk-nested-tree-node',
                        },
                        providers: [{ provide: CdkTreeNode, useExisting: CdkNestedTreeNode }]
                    },] },
        ];
        /** @nocollapse */
        CdkNestedTreeNode.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: CdkTree, },
            { type: core.IterableDiffers, },
        ]; };
        CdkNestedTreeNode.propDecorators = {
            "nodeOutlet": [{ type: core.ContentChildren, args: [CdkTreeNodeOutlet,] },],
        };
        return CdkNestedTreeNode;
    }(CdkTreeNode));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Indent for the children tree dataNodes.
     * This directive will add left-padding to the node to show hierarchy.
     * @template T
     */
    var CdkTreeNodePadding = /** @class */ (function () {
        function CdkTreeNodePadding(_treeNode, _tree, _renderer, _element, _dir) {
            var _this = this;
            this._treeNode = _treeNode;
            this._tree = _tree;
            this._renderer = _renderer;
            this._element = _element;
            this._dir = _dir;
            /**
             * Subject that emits when the component has been destroyed.
             */
            this._destroyed = new rxjs.Subject();
            this._indent = 40;
            this._setPadding();
            if (this._dir) {
                this._dir.change.pipe(operators.takeUntil(this._destroyed)).subscribe(function () { return _this._setPadding(); });
            }
        }
        Object.defineProperty(CdkTreeNodePadding.prototype, "level", {
            get: /**
             * The level of depth of the tree node. The padding will be `level * indent` pixels.
             * @return {?}
             */
            function () { return this._level; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._level = coerceNumberProperty(value);
                this._setPadding();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CdkTreeNodePadding.prototype, "indent", {
            get: /**
             * The indent for each level. Default number 40px from material design menu sub-menu spec.
             * @return {?}
             */
            function () { return this._indent; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._indent = coerceNumberProperty(value);
                this._setPadding();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        CdkTreeNodePadding.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this._destroyed.next();
            this._destroyed.complete();
        };
        /** The padding indent value for the tree node. Returns a string with px numbers if not null. */
        /**
         * The padding indent value for the tree node. Returns a string with px numbers if not null.
         * @return {?}
         */
        CdkTreeNodePadding.prototype._paddingIndent = /**
         * The padding indent value for the tree node. Returns a string with px numbers if not null.
         * @return {?}
         */
        function () {
            var /** @type {?} */ nodeLevel = (this._treeNode.data && this._tree.treeControl.getLevel)
                ? this._tree.treeControl.getLevel(this._treeNode.data)
                : null;
            var /** @type {?} */ level = this._level || nodeLevel;
            return level ? level * this._indent + "px" : null;
        };
        /**
         * @return {?}
         */
        CdkTreeNodePadding.prototype._setPadding = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ padding = this._paddingIndent();
            var /** @type {?} */ paddingProp = this._dir && this._dir.value === 'rtl' ? 'paddingRight' : 'paddingLeft';
            this._renderer.setStyle(this._element.nativeElement, paddingProp, padding);
        };
        CdkTreeNodePadding.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkTreeNodePadding]',
                    },] },
        ];
        /** @nocollapse */
        CdkTreeNodePadding.ctorParameters = function () { return [
            { type: CdkTreeNode, },
            { type: CdkTree, },
            { type: core.Renderer2, },
            { type: core.ElementRef, },
            { type: Directionality, decorators: [{ type: core.Optional },] },
        ]; };
        CdkTreeNodePadding.propDecorators = {
            "level": [{ type: core.Input, args: ['cdkTreeNodePadding',] },],
            "indent": [{ type: core.Input, args: ['cdkTreeNodePaddingIndent',] },],
        };
        return CdkTreeNodePadding;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Node toggle to expand/collapse the node.
     * @template T
     */
    var CdkTreeNodeToggle = /** @class */ (function () {
        function CdkTreeNodeToggle(_tree, _treeNode) {
            this._tree = _tree;
            this._treeNode = _treeNode;
            this._recursive = false;
        }
        Object.defineProperty(CdkTreeNodeToggle.prototype, "recursive", {
            get: /**
             * Whether expand/collapse the node recursively.
             * @return {?}
             */
            function () { return this._recursive; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._recursive = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} event
         * @return {?}
         */
        CdkTreeNodeToggle.prototype._toggle = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this.recursive
                ? this._tree.treeControl.toggleDescendants(this._treeNode.data)
                : this._tree.treeControl.toggle(this._treeNode.data);
            event.stopPropagation();
        };
        CdkTreeNodeToggle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[cdkTreeNodeToggle]',
                        host: {
                            '(click)': '_toggle($event)',
                        }
                    },] },
        ];
        /** @nocollapse */
        CdkTreeNodeToggle.ctorParameters = function () { return [
            { type: CdkTree, },
            { type: CdkTreeNode, },
        ]; };
        CdkTreeNodeToggle.propDecorators = {
            "recursive": [{ type: core.Input, args: ['cdkTreeNodeToggleRecursive',] },],
        };
        return CdkTreeNodeToggle;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Outlet for nested CdkNode. Put `[matTreeNodeOutlet]` on a tag to place children dataNodes
     * inside the outlet.
     */
    var MatTreeNodeOutlet = /** @class */ (function () {
        function MatTreeNodeOutlet(viewContainer) {
            this.viewContainer = viewContainer;
        }
        MatTreeNodeOutlet.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTreeNodeOutlet]'
                    },] },
        ];
        /** @nocollapse */
        MatTreeNodeOutlet.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        return MatTreeNodeOutlet;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ _MatTreeNodeMixinBase = mixinTabIndex(mixinDisabled(CdkTreeNode));
    var /** @type {?} */ _MatNestedTreeNodeMixinBase = mixinTabIndex(mixinDisabled(CdkNestedTreeNode));
    /**
     * Wrapper for the CdkTree node with Material design styles.
     * @template T
     */
    var MatTreeNode = /** @class */ (function (_super) {
        __extends(MatTreeNode, _super);
        function MatTreeNode(_elementRef, _tree, tabIndex) {
            var _this = _super.call(this, _elementRef, _tree) || this;
            _this._elementRef = _elementRef;
            _this._tree = _tree;
            _this.role = 'treeitem';
            _this.tabIndex = Number(tabIndex) || 0;
            return _this;
        }
        MatTreeNode.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-tree-node',
                        exportAs: 'matTreeNode',
                        inputs: ['disabled', 'tabIndex'],
                        host: {
                            '[attr.aria-expanded]': 'isExpanded',
                            '[attr.aria-level]': 'role === "treeitem" ? level : null',
                            '[attr.role]': 'role',
                            'class': 'mat-tree-node'
                        },
                        providers: [{ provide: CdkTreeNode, useExisting: MatTreeNode }]
                    },] },
        ];
        /** @nocollapse */
        MatTreeNode.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: CdkTree, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
        ]; };
        MatTreeNode.propDecorators = {
            "role": [{ type: core.Input },],
        };
        return MatTreeNode;
    }(_MatTreeNodeMixinBase));
    /**
     * Wrapper for the CdkTree node definition with Material design styles.
     * @template T
     */
    var MatTreeNodeDef = /** @class */ (function (_super) {
        __extends(MatTreeNodeDef, _super);
        function MatTreeNodeDef() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatTreeNodeDef.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTreeNodeDef]',
                        inputs: [
                            'when: matTreeNodeDefWhen'
                        ],
                        providers: [{ provide: CdkTreeNodeDef, useExisting: MatTreeNodeDef }]
                    },] },
        ];
        /** @nocollapse */
        MatTreeNodeDef.propDecorators = {
            "data": [{ type: core.Input, args: ['matTreeNode',] },],
        };
        return MatTreeNodeDef;
    }(CdkTreeNodeDef));
    /**
     * Wrapper for the CdkTree nested node with Material design styles.
     * @template T
     */
    var MatNestedTreeNode = /** @class */ (function (_super) {
        __extends(MatNestedTreeNode, _super);
        function MatNestedTreeNode(_elementRef, _tree, _differs, tabIndex) {
            var _this = _super.call(this, _elementRef, _tree, _differs) || this;
            _this._elementRef = _elementRef;
            _this._tree = _tree;
            _this._differs = _differs;
            _this.tabIndex = Number(tabIndex) || 0;
            return _this;
        }
        // This is a workaround for https://github.com/angular/angular/issues/23091
        // In aot mode, the lifecycle hooks from parent class are not called.
        // TODO(tinayuangao): Remove when the angular issue #23091 is fixed
        /**
         * @return {?}
         */
        MatNestedTreeNode.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
            _super.prototype.ngAfterContentInit.call(this);
        };
        /**
         * @return {?}
         */
        MatNestedTreeNode.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            _super.prototype.ngOnDestroy.call(this);
        };
        MatNestedTreeNode.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mat-nested-tree-node',
                        exportAs: 'matNestedTreeNode',
                        host: {
                            '[attr.aria-expanded]': 'isExpanded',
                            '[attr.role]': 'role',
                            'class': 'mat-nested-tree-node',
                        },
                        inputs: ['disabled', 'tabIndex'],
                        providers: [
                            { provide: CdkNestedTreeNode, useExisting: MatNestedTreeNode },
                            { provide: CdkTreeNode, useExisting: MatNestedTreeNode }
                        ]
                    },] },
        ];
        /** @nocollapse */
        MatNestedTreeNode.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: CdkTree, },
            { type: core.IterableDiffers, },
            { type: undefined, decorators: [{ type: core.Attribute, args: ['tabindex',] },] },
        ]; };
        MatNestedTreeNode.propDecorators = {
            "node": [{ type: core.Input, args: ['matNestedTreeNode',] },],
            "nodeOutlet": [{ type: core.ContentChildren, args: [MatTreeNodeOutlet,] },],
        };
        return MatNestedTreeNode;
    }(_MatNestedTreeNodeMixinBase));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Wrapper for the CdkTree padding with Material design styles.
     * @template T
     */
    var MatTreeNodePadding = /** @class */ (function (_super) {
        __extends(MatTreeNodePadding, _super);
        function MatTreeNodePadding() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatTreeNodePadding.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTreeNodePadding]',
                        providers: [{ provide: CdkTreeNodePadding, useExisting: MatTreeNodePadding }]
                    },] },
        ];
        /** @nocollapse */
        MatTreeNodePadding.propDecorators = {
            "level": [{ type: core.Input, args: ['matTreeNodePadding',] },],
            "indent": [{ type: core.Input, args: ['matTreeNodePaddingIndent',] },],
        };
        return MatTreeNodePadding;
    }(CdkTreeNodePadding));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Wrapper for the CdkTable with Material design styles.
     * @template T
     */
    var MatTree = /** @class */ (function (_super) {
        __extends(MatTree, _super);
        function MatTree() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MatTree.decorators = [
            { type: core.Component, args: [{selector: 'mat-tree',
                        exportAs: 'matTree',
                        template: "<ng-container matTreeNodeOutlet></ng-container>",
                        host: {
                            'class': 'mat-tree',
                            'role': 'tree',
                        },
                        styles: [".mat-tree{display:block}.mat-tree-node{display:flex;align-items:center;min-height:48px;flex:1;overflow:hidden;word-wrap:break-word}.mat-nested-tree-ndoe{border-bottom-width:0}"],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [{ provide: CdkTree, useExisting: MatTree }]
                    },] },
        ];
        /** @nocollapse */
        MatTree.propDecorators = {
            "_nodeOutlet": [{ type: core.ViewChild, args: [MatTreeNodeOutlet,] },],
        };
        return MatTree;
    }(CdkTree));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Wrapper for the CdkTree's toggle with Material design styles.
     * @template T
     */
    var MatTreeNodeToggle = /** @class */ (function (_super) {
        __extends(MatTreeNodeToggle, _super);
        function MatTreeNodeToggle() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.recursive = false;
            return _this;
        }
        MatTreeNodeToggle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[matTreeNodeToggle]',
                        host: {
                            '(click)': '_toggle($event)',
                        },
                        providers: [{ provide: CdkTreeNodeToggle, useExisting: MatTreeNodeToggle }]
                    },] },
        ];
        /** @nocollapse */
        MatTreeNodeToggle.propDecorators = {
            "recursive": [{ type: core.Input, args: ['matTreeNodeToggleRecursive',] },],
        };
        return MatTreeNodeToggle;
    }(CdkTreeNodeToggle));
    /**
     * Data source for flat tree.
     * The data source need to handle expansion/collapsion of the tree node and change the data feed
     * to `MatTree`.
     * The nested tree nodes of type `T` are flattened through `MatTreeFlattener`, and converted
     * to type `F` for `MatTree` to consume.
     * @template T, F
     */
    var  /**
     * Data source for flat tree.
     * The data source need to handle expansion/collapsion of the tree node and change the data feed
     * to `MatTree`.
     * The nested tree nodes of type `T` are flattened through `MatTreeFlattener`, and converted
     * to type `F` for `MatTree` to consume.
     * @template T, F
     */
    MatTreeFlatDataSource = /** @class */ (function (_super) {
        __extends(MatTreeFlatDataSource, _super);
        function MatTreeFlatDataSource(treeControl, treeFlattener, initialData) {
            if (initialData === void 0) { initialData = []; }
            var _this = _super.call(this) || this;
            _this.treeControl = treeControl;
            _this.treeFlattener = treeFlattener;
            _this._flattenedData = new rxjs.BehaviorSubject([]);
            _this._expandedData = new rxjs.BehaviorSubject([]);
            _this._data = new rxjs.BehaviorSubject(initialData);
            return _this;
        }
        Object.defineProperty(MatTreeFlatDataSource.prototype, "data", {
            get: /**
             * @return {?}
             */
            function () { return this._data.value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                this._data.next(value);
                this._flattenedData.next(this.treeFlattener.flattenNodes(this.data));
                this.treeControl.dataNodes = this._flattenedData.value;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} collectionViewer
         * @return {?}
         */
        MatTreeFlatDataSource.prototype.connect = /**
         * @param {?} collectionViewer
         * @return {?}
         */
        function (collectionViewer) {
            var _this = this;
            var /** @type {?} */ changes = [
                collectionViewer.viewChange,
                /** @type {?} */ ((this.treeControl.expansionModel.onChange)),
                this._flattenedData
            ];
            return rxjs.merge.apply(void 0, changes).pipe(operators.map(function () {
                _this._expandedData.next(_this.treeFlattener.expandFlattenedNodes(_this._flattenedData.value, _this.treeControl));
                return _this._expandedData.value;
            }));
        };
        /**
         * @return {?}
         */
        MatTreeFlatDataSource.prototype.disconnect = /**
         * @return {?}
         */
        function () {
            // no op
        };
        return MatTreeFlatDataSource;
    }(DataSource));

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Data source for nested tree.
     *
     * The data source for nested tree doesn't have to consider node flattener, or the way to expand
     * or collapse. The expansion/collapsion will be handled by TreeControl and each non-leaf node.
     * @template T
     */
    var  /**
     * Data source for nested tree.
     *
     * The data source for nested tree doesn't have to consider node flattener, or the way to expand
     * or collapse. The expansion/collapsion will be handled by TreeControl and each non-leaf node.
     * @template T
     */
    MatTreeNestedDataSource = /** @class */ (function (_super) {
        __extends(MatTreeNestedDataSource, _super);
        function MatTreeNestedDataSource() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._data = new rxjs.BehaviorSubject([]);
            return _this;
        }
        Object.defineProperty(MatTreeNestedDataSource.prototype, "data", {
            /**
             * Data for the nested tree
             */
            get: /**
             * Data for the nested tree
             * @return {?}
             */
            function () { return this._data.value; },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) { this._data.next(value); },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} collectionViewer
         * @return {?}
         */
        MatTreeNestedDataSource.prototype.connect = /**
         * @param {?} collectionViewer
         * @return {?}
         */
        function (collectionViewer) {
            var _this = this;
            return rxjs.merge.apply(void 0, [collectionViewer.viewChange, this._data]).pipe(operators.map(function () {
                return _this.data;
            }));
        };
        /**
         * @return {?}
         */
        MatTreeNestedDataSource.prototype.disconnect = /**
         * @return {?}
         */
        function () {
            // no op
        };
        return MatTreeNestedDataSource;
    }(DataSource));

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    /**
     * Current version of Angular Material.
     */
    var /** @type {?} */ VERSION$2 = new core.Version('6.3.0');

    // 4.7.13 (2018-05-16)
    (function () {
    (function () {

      var noop = function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
      };
      var noarg = function (f) {
        return function () {
          var x = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
          }
          return f();
        };
      };
      var compose = function (fa, fb) {
        return function () {
          var x = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
          }
          return fa(fb.apply(null, arguments));
        };
      };
      var constant = function (value) {
        return function () {
          return value;
        };
      };
      var identity = function (x) {
        return x;
      };
      var tripleEquals = function (a, b) {
        return a === b;
      };
      var curry = function (f) {
        var x = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          x[_i - 1] = arguments[_i];
        }
        var args = new Array(arguments.length - 1);
        for (var i = 1; i < arguments.length; i++)
          args[i - 1] = arguments[i];
        return function () {
          var x = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
          }
          var newArgs = new Array(arguments.length);
          for (var j = 0; j < newArgs.length; j++)
            newArgs[j] = arguments[j];
          var all = args.concat(newArgs);
          return f.apply(null, all);
        };
      };
      var not = function (f) {
        return function () {
          var x = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
          }
          return !f.apply(null, arguments);
        };
      };
      var die = function (msg) {
        return function () {
          throw new Error(msg);
        };
      };
      var apply = function (f) {
        return f();
      };
      var call = function (f) {
        f();
      };
      var never = constant(false);
      var always = constant(true);
      var $_eqpqvr6jh8lyw3s = {
        noop: noop,
        noarg: noarg,
        compose: compose,
        constant: constant,
        identity: identity,
        tripleEquals: tripleEquals,
        curry: curry,
        not: not,
        die: die,
        apply: apply,
        call: call,
        never: never,
        always: always
      };

      var never$1 = $_eqpqvr6jh8lyw3s.never;
      var always$1 = $_eqpqvr6jh8lyw3s.always;
      var none = function () {
        return NONE;
      };
      var NONE = function () {
        var eq = function (o) {
          return o.isNone();
        };
        var call = function (thunk) {
          return thunk();
        };
        var id = function (n) {
          return n;
        };
        var noop = function () {
        };
        var me = {
          fold: function (n, s) {
            return n();
          },
          is: never$1,
          isSome: never$1,
          isNone: always$1,
          getOr: id,
          getOrThunk: call,
          getOrDie: function (msg) {
            throw new Error(msg || 'error: getOrDie called on none.');
          },
          or: id,
          orThunk: call,
          map: none,
          ap: none,
          each: noop,
          bind: none,
          flatten: none,
          exists: never$1,
          forall: always$1,
          filter: none,
          equals: eq,
          equals_: eq,
          toArray: function () {
            return [];
          },
          toString: $_eqpqvr6jh8lyw3s.constant('none()')
        };
        if (Object.freeze)
          Object.freeze(me);
        return me;
      }();
      var some = function (a) {
        var constant_a = function () {
          return a;
        };
        var self = function () {
          return me;
        };
        var map = function (f) {
          return some(f(a));
        };
        var bind = function (f) {
          return f(a);
        };
        var me = {
          fold: function (n, s) {
            return s(a);
          },
          is: function (v) {
            return a === v;
          },
          isSome: always$1,
          isNone: never$1,
          getOr: constant_a,
          getOrThunk: constant_a,
          getOrDie: constant_a,
          or: self,
          orThunk: self,
          map: map,
          ap: function (optfab) {
            return optfab.fold(none, function (fab) {
              return some(fab(a));
            });
          },
          each: function (f) {
            f(a);
          },
          bind: bind,
          flatten: constant_a,
          exists: bind,
          forall: bind,
          filter: function (f) {
            return f(a) ? me : NONE;
          },
          equals: function (o) {
            return o.is(a);
          },
          equals_: function (o, elementEq) {
            return o.fold(never$1, function (b) {
              return elementEq(a, b);
            });
          },
          toArray: function () {
            return [a];
          },
          toString: function () {
            return 'some(' + a + ')';
          }
        };
        return me;
      };
      var from = function (value) {
        return value === null || value === undefined ? NONE : some(value);
      };
      var Option = {
        some: some,
        none: none,
        from: from
      };

      var typeOf = function (x) {
        if (x === null)
          return 'null';
        var t = typeof x;
        if (t === 'object' && Array.prototype.isPrototypeOf(x))
          return 'array';
        if (t === 'object' && String.prototype.isPrototypeOf(x))
          return 'string';
        return t;
      };
      var isType = function (type) {
        return function (value) {
          return typeOf(value) === type;
        };
      };
      var $_dp4g6d7jh8lyw3y = {
        isString: isType('string'),
        isObject: isType('object'),
        isArray: isType('array'),
        isNull: isType('null'),
        isBoolean: isType('boolean'),
        isUndefined: isType('undefined'),
        isFunction: isType('function'),
        isNumber: isType('number')
      };

      var rawIndexOf = function () {
        var pIndexOf = Array.prototype.indexOf;
        var fastIndex = function (xs, x) {
          return pIndexOf.call(xs, x);
        };
        var slowIndex = function (xs, x) {
          return slowIndexOf(xs, x);
        };
        return pIndexOf === undefined ? slowIndex : fastIndex;
      }();
      var indexOf = function (xs, x) {
        var r = rawIndexOf(xs, x);
        return r === -1 ? Option.none() : Option.some(r);
      };
      var contains = function (xs, x) {
        return rawIndexOf(xs, x) > -1;
      };
      var exists = function (xs, pred) {
        return findIndex(xs, pred).isSome();
      };
      var range = function (num, f) {
        var r = [];
        for (var i = 0; i < num; i++) {
          r.push(f(i));
        }
        return r;
      };
      var chunk = function (array, size) {
        var r = [];
        for (var i = 0; i < array.length; i += size) {
          var s = array.slice(i, i + size);
          r.push(s);
        }
        return r;
      };
      var map = function (xs, f) {
        var len = xs.length;
        var r = new Array(len);
        for (var i = 0; i < len; i++) {
          var x = xs[i];
          r[i] = f(x, i, xs);
        }
        return r;
      };
      var each = function (xs, f) {
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          f(x, i, xs);
        }
      };
      var eachr = function (xs, f) {
        for (var i = xs.length - 1; i >= 0; i--) {
          var x = xs[i];
          f(x, i, xs);
        }
      };
      var partition = function (xs, pred) {
        var pass = [];
        var fail = [];
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          var arr = pred(x, i, xs) ? pass : fail;
          arr.push(x);
        }
        return {
          pass: pass,
          fail: fail
        };
      };
      var filter = function (xs, pred) {
        var r = [];
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          if (pred(x, i, xs)) {
            r.push(x);
          }
        }
        return r;
      };
      var groupBy = function (xs, f) {
        if (xs.length === 0) {
          return [];
        } else {
          var wasType = f(xs[0]);
          var r = [];
          var group = [];
          for (var i = 0, len = xs.length; i < len; i++) {
            var x = xs[i];
            var type = f(x);
            if (type !== wasType) {
              r.push(group);
              group = [];
            }
            wasType = type;
            group.push(x);
          }
          if (group.length !== 0) {
            r.push(group);
          }
          return r;
        }
      };
      var foldr = function (xs, f, acc) {
        eachr(xs, function (x) {
          acc = f(acc, x);
        });
        return acc;
      };
      var foldl = function (xs, f, acc) {
        each(xs, function (x) {
          acc = f(acc, x);
        });
        return acc;
      };
      var find = function (xs, pred) {
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          if (pred(x, i, xs)) {
            return Option.some(x);
          }
        }
        return Option.none();
      };
      var findIndex = function (xs, pred) {
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          if (pred(x, i, xs)) {
            return Option.some(i);
          }
        }
        return Option.none();
      };
      var slowIndexOf = function (xs, x) {
        for (var i = 0, len = xs.length; i < len; ++i) {
          if (xs[i] === x) {
            return i;
          }
        }
        return -1;
      };
      var push = Array.prototype.push;
      var flatten = function (xs) {
        var r = [];
        for (var i = 0, len = xs.length; i < len; ++i) {
          if (!Array.prototype.isPrototypeOf(xs[i]))
            throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
          push.apply(r, xs[i]);
        }
        return r;
      };
      var bind = function (xs, f) {
        var output = map(xs, f);
        return flatten(output);
      };
      var forall = function (xs, pred) {
        for (var i = 0, len = xs.length; i < len; ++i) {
          var x = xs[i];
          if (pred(x, i, xs) !== true) {
            return false;
          }
        }
        return true;
      };
      var equal = function (a1, a2) {
        return a1.length === a2.length && forall(a1, function (x, i) {
          return x === a2[i];
        });
      };
      var slice = Array.prototype.slice;
      var reverse = function (xs) {
        var r = slice.call(xs, 0);
        r.reverse();
        return r;
      };
      var difference = function (a1, a2) {
        return filter(a1, function (x) {
          return !contains(a2, x);
        });
      };
      var mapToObject = function (xs, f) {
        var r = {};
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          r[String(x)] = f(x, i);
        }
        return r;
      };
      var pure = function (x) {
        return [x];
      };
      var sort = function (xs, comparator) {
        var copy = slice.call(xs, 0);
        copy.sort(comparator);
        return copy;
      };
      var head = function (xs) {
        return xs.length === 0 ? Option.none() : Option.some(xs[0]);
      };
      var last = function (xs) {
        return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
      };
      var from$1 = $_dp4g6d7jh8lyw3y.isFunction(Array.from) ? Array.from : function (x) {
        return slice.call(x);
      };
      var $_5wjzy24jh8lyw2t = {
        map: map,
        each: each,
        eachr: eachr,
        partition: partition,
        filter: filter,
        groupBy: groupBy,
        indexOf: indexOf,
        foldr: foldr,
        foldl: foldl,
        find: find,
        findIndex: findIndex,
        flatten: flatten,
        bind: bind,
        forall: forall,
        exists: exists,
        contains: contains,
        equal: equal,
        reverse: reverse,
        chunk: chunk,
        difference: difference,
        mapToObject: mapToObject,
        pure: pure,
        sort: sort,
        range: range,
        head: head,
        last: last,
        from: from$1
      };

      var global = typeof window !== 'undefined' ? window : Function('return this;')();

      var path = function (parts, scope) {
        var o = scope !== undefined && scope !== null ? scope : global;
        for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i)
          o = o[parts[i]];
        return o;
      };
      var resolve = function (p, scope) {
        var parts = p.split('.');
        return path(parts, scope);
      };
      var step = function (o, part) {
        if (o[part] === undefined || o[part] === null)
          o[part] = {};
        return o[part];
      };
      var forge = function (parts, target) {
        var o = target !== undefined ? target : global;
        for (var i = 0; i < parts.length; ++i)
          o = step(o, parts[i]);
        return o;
      };
      var namespace = function (name, target) {
        var parts = name.split('.');
        return forge(parts, target);
      };
      var $_br50dmdjh8lyw6o = {
        path: path,
        resolve: resolve,
        forge: forge,
        namespace: namespace
      };

      var unsafe = function (name, scope) {
        return $_br50dmdjh8lyw6o.resolve(name, scope);
      };
      var getOrDie = function (name, scope) {
        var actual = unsafe(name, scope);
        if (actual === undefined || actual === null)
          throw name + ' not available on this browser';
        return actual;
      };
      var $_99xmy7cjh8lyw6k = { getOrDie: getOrDie };

      var url = function () {
        return $_99xmy7cjh8lyw6k.getOrDie('URL');
      };
      var createObjectURL = function (blob) {
        return url().createObjectURL(blob);
      };
      var revokeObjectURL = function (u) {
        url().revokeObjectURL(u);
      };
      var $_ge0pt0bjh8lyw6g = {
        createObjectURL: createObjectURL,
        revokeObjectURL: revokeObjectURL
      };

      var nav = navigator;
      var userAgent = nav.userAgent;
      var opera;
      var webkit;
      var ie;
      var ie11;
      var ie12;
      var gecko;
      var mac;
      var iDevice;
      var android;
      var fileApi;
      var phone;
      var tablet;
      var windowsPhone;
      var matchMediaQuery = function (query) {
        return 'matchMedia' in window ? matchMedia(query).matches : false;
      };
      opera = false;
      android = /Android/.test(userAgent);
      webkit = /WebKit/.test(userAgent);
      ie = !webkit && !opera && /MSIE/gi.test(userAgent) && /Explorer/gi.test(nav.appName);
      ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
      ie11 = userAgent.indexOf('Trident/') !== -1 && (userAgent.indexOf('rv:') !== -1 || nav.appName.indexOf('Netscape') !== -1) ? 11 : false;
      ie12 = userAgent.indexOf('Edge/') !== -1 && !ie && !ie11 ? 12 : false;
      ie = ie || ie11 || ie12;
      gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
      mac = userAgent.indexOf('Mac') !== -1;
      iDevice = /(iPad|iPhone)/.test(userAgent);
      fileApi = 'FormData' in window && 'FileReader' in window && 'URL' in window && !!$_ge0pt0bjh8lyw6g.createObjectURL;
      phone = matchMediaQuery('only screen and (max-device-width: 480px)') && (android || iDevice);
      tablet = matchMediaQuery('only screen and (min-width: 800px)') && (android || iDevice);
      windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
      if (ie12) {
        webkit = false;
      }
      var contentEditable = !iDevice || fileApi || parseInt(userAgent.match(/AppleWebKit\/(\d*)/)[1], 10) >= 534;
      var $_9bpim8ajh8lyw68 = {
        opera: opera,
        webkit: webkit,
        ie: ie,
        gecko: gecko,
        mac: mac,
        iOS: iDevice,
        android: android,
        contentEditable: contentEditable,
        transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
        caretAfter: ie !== 8,
        range: window.getSelection && 'Range' in window,
        documentMode: ie && !ie12 ? document.documentMode || 7 : 10,
        fileApi: fileApi,
        ceFalse: ie === false || ie > 8,
        cacheSuffix: null,
        container: null,
        overrideViewPort: null,
        experimentalShadowDom: false,
        canHaveCSP: ie === false || ie > 11,
        desktop: !phone && !tablet,
        windowsPhone: windowsPhone
      };

      var promise = function () {
        function bind(fn, thisArg) {
          return function () {
            fn.apply(thisArg, arguments);
          };
        }
        var isArray = Array.isArray || function (value) {
          return Object.prototype.toString.call(value) === '[object Array]';
        };
        var Promise = function (fn) {
          if (typeof this !== 'object') {
            throw new TypeError('Promises must be constructed via new');
          }
          if (typeof fn !== 'function') {
            throw new TypeError('not a function');
          }
          this._state = null;
          this._value = null;
          this._deferreds = [];
          doResolve(fn, bind(resolve, this), bind(reject, this));
        };
        var asap = Promise.immediateFn || typeof setImmediate === 'function' && setImmediate || function (fn) {
          setTimeout(fn, 1);
        };
        function handle(deferred) {
          var me = this;
          if (this._state === null) {
            this._deferreds.push(deferred);
            return;
          }
          asap(function () {
            var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
            if (cb === null) {
              (me._state ? deferred.resolve : deferred.reject)(me._value);
              return;
            }
            var ret;
            try {
              ret = cb(me._value);
            } catch (e) {
              deferred.reject(e);
              return;
            }
            deferred.resolve(ret);
          });
        }
        function resolve(newValue) {
          try {
            if (newValue === this) {
              throw new TypeError('A promise cannot be resolved with itself.');
            }
            if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
              var then = newValue.then;
              if (typeof then === 'function') {
                doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
                return;
              }
            }
            this._state = true;
            this._value = newValue;
            finale.call(this);
          } catch (e) {
            reject.call(this, e);
          }
        }
        function reject(newValue) {
          this._state = false;
          this._value = newValue;
          finale.call(this);
        }
        function finale() {
          for (var i = 0, len = this._deferreds.length; i < len; i++) {
            handle.call(this, this._deferreds[i]);
          }
          this._deferreds = null;
        }
        function Handler(onFulfilled, onRejected, resolve, reject) {
          this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
          this.onRejected = typeof onRejected === 'function' ? onRejected : null;
          this.resolve = resolve;
          this.reject = reject;
        }
        function doResolve(fn, onFulfilled, onRejected) {
          var done = false;
          try {
            fn(function (value) {
              if (done) {
                return;
              }
              done = true;
              onFulfilled(value);
            }, function (reason) {
              if (done) {
                return;
              }
              done = true;
              onRejected(reason);
            });
          } catch (ex) {
            if (done) {
              return;
            }
            done = true;
            onRejected(ex);
          }
        }
        Promise.prototype.catch = function (onRejected) {
          return this.then(null, onRejected);
        };
        Promise.prototype.then = function (onFulfilled, onRejected) {
          var me = this;
          return new Promise(function (resolve, reject) {
            handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
          });
        };
        Promise.all = function () {
          var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
          return new Promise(function (resolve, reject) {
            if (args.length === 0) {
              return resolve([]);
            }
            var remaining = args.length;
            function res(i, val) {
              try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                  var then = val.then;
                  if (typeof then === 'function') {
                    then.call(val, function (val) {
                      res(i, val);
                    }, reject);
                    return;
                  }
                }
                args[i] = val;
                if (--remaining === 0) {
                  resolve(args);
                }
              } catch (ex) {
                reject(ex);
              }
            }
            for (var i = 0; i < args.length; i++) {
              res(i, args[i]);
            }
          });
        };
        Promise.resolve = function (value) {
          if (value && typeof value === 'object' && value.constructor === Promise) {
            return value;
          }
          return new Promise(function (resolve) {
            resolve(value);
          });
        };
        Promise.reject = function (value) {
          return new Promise(function (resolve, reject) {
            reject(value);
          });
        };
        Promise.race = function (values) {
          return new Promise(function (resolve, reject) {
            for (var i = 0, len = values.length; i < len; i++) {
              values[i].then(resolve, reject);
            }
          });
        };
        return Promise;
      };
      var promiseObj = window.Promise ? window.Promise : promise();

      var requestAnimationFramePromise;
      var requestAnimationFrame = function (callback, element) {
        var i, requestAnimationFrameFunc = window.requestAnimationFrame;
        var vendors = [
          'ms',
          'moz',
          'webkit'
        ];
        var featurefill = function (callback) {
          window.setTimeout(callback, 0);
        };
        for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
          requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
        }
        if (!requestAnimationFrameFunc) {
          requestAnimationFrameFunc = featurefill;
        }
        requestAnimationFrameFunc(callback, element);
      };
      var wrappedSetTimeout = function (callback, time) {
        if (typeof time !== 'number') {
          time = 0;
        }
        return setTimeout(callback, time);
      };
      var wrappedSetInterval = function (callback, time) {
        if (typeof time !== 'number') {
          time = 1;
        }
        return setInterval(callback, time);
      };
      var wrappedClearTimeout = function (id) {
        return clearTimeout(id);
      };
      var wrappedClearInterval = function (id) {
        return clearInterval(id);
      };
      var debounce = function (callback, time) {
        var timer, func;
        func = function () {
          var args = arguments;
          clearTimeout(timer);
          timer = wrappedSetTimeout(function () {
            callback.apply(this, args);
          }, time);
        };
        func.stop = function () {
          clearTimeout(timer);
        };
        return func;
      };
      var $_8sy3pfhjh8lyw95 = {
        requestAnimationFrame: function (callback, element) {
          if (requestAnimationFramePromise) {
            requestAnimationFramePromise.then(callback);
            return;
          }
          requestAnimationFramePromise = new promiseObj(function (resolve) {
            if (!element) {
              element = document.body;
            }
            requestAnimationFrame(resolve, element);
          }).then(callback);
        },
        setTimeout: wrappedSetTimeout,
        setInterval: wrappedSetInterval,
        setEditorTimeout: function (editor, callback, time) {
          return wrappedSetTimeout(function () {
            if (!editor.removed) {
              callback();
            }
          }, time);
        },
        setEditorInterval: function (editor, callback, time) {
          var timer;
          timer = wrappedSetInterval(function () {
            if (!editor.removed) {
              callback();
            } else {
              clearInterval(timer);
            }
          }, time);
          return timer;
        },
        debounce: debounce,
        throttle: debounce,
        clearInterval: wrappedClearInterval,
        clearTimeout: wrappedClearTimeout
      };

      var eventExpandoPrefix = 'mce-data-';
      var mouseEventRe = /^(?:mouse|contextmenu)|click/;
      var deprecated = {
        keyLocation: 1,
        layerX: 1,
        layerY: 1,
        returnValue: 1,
        webkitMovementX: 1,
        webkitMovementY: 1,
        keyIdentifier: 1
      };
      var hasIsDefaultPrevented = function (event) {
        return event.isDefaultPrevented === returnTrue || event.isDefaultPrevented === returnFalse;
      };
      var returnFalse = function () {
        return false;
      };
      var returnTrue = function () {
        return true;
      };
      var addEvent = function (target, name, callback, capture) {
        if (target.addEventListener) {
          target.addEventListener(name, callback, capture || false);
        } else if (target.attachEvent) {
          target.attachEvent('on' + name, callback);
        }
      };
      var removeEvent = function (target, name, callback, capture) {
        if (target.removeEventListener) {
          target.removeEventListener(name, callback, capture || false);
        } else if (target.detachEvent) {
          target.detachEvent('on' + name, callback);
        }
      };
      var getTargetFromShadowDom = function (event, defaultTarget) {
        var path, target = defaultTarget;
        path = event.path;
        if (path && path.length > 0) {
          target = path[0];
        }
        if (event.composedPath) {
          path = event.composedPath();
          if (path && path.length > 0) {
            target = path[0];
          }
        }
        return target;
      };
      var fix = function (originalEvent, data) {
        var name;
        var event = data || {};
        for (name in originalEvent) {
          if (!deprecated[name]) {
            event[name] = originalEvent[name];
          }
        }
        if (!event.target) {
          event.target = event.srcElement || document;
        }
        if ($_9bpim8ajh8lyw68.experimentalShadowDom) {
          event.target = getTargetFromShadowDom(originalEvent, event.target);
        }
        if (originalEvent && mouseEventRe.test(originalEvent.type) && originalEvent.pageX === undefined && originalEvent.clientX !== undefined) {
          var eventDoc = event.target.ownerDocument || document;
          var doc = eventDoc.documentElement;
          var body = eventDoc.body;
          event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        }
        event.preventDefault = function () {
          event.isDefaultPrevented = returnTrue;
          if (originalEvent) {
            if (originalEvent.preventDefault) {
              originalEvent.preventDefault();
            } else {
              originalEvent.returnValue = false;
            }
          }
        };
        event.stopPropagation = function () {
          event.isPropagationStopped = returnTrue;
          if (originalEvent) {
            if (originalEvent.stopPropagation) {
              originalEvent.stopPropagation();
            } else {
              originalEvent.cancelBubble = true;
            }
          }
        };
        event.stopImmediatePropagation = function () {
          event.isImmediatePropagationStopped = returnTrue;
          event.stopPropagation();
        };
        if (hasIsDefaultPrevented(event) === false) {
          event.isDefaultPrevented = returnFalse;
          event.isPropagationStopped = returnFalse;
          event.isImmediatePropagationStopped = returnFalse;
        }
        if (typeof event.metaKey === 'undefined') {
          event.metaKey = false;
        }
        return event;
      };
      var bindOnReady = function (win, callback, eventUtils) {
        var doc = win.document, event = { type: 'ready' };
        if (eventUtils.domLoaded) {
          callback(event);
          return;
        }
        var isDocReady = function () {
          return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
        };
        var readyHandler = function () {
          if (!eventUtils.domLoaded) {
            eventUtils.domLoaded = true;
            callback(event);
          }
        };
        var waitForDomLoaded = function () {
          if (isDocReady()) {
            removeEvent(doc, 'readystatechange', waitForDomLoaded);
            readyHandler();
          }
        };
        var tryScroll = function () {
          try {
            doc.documentElement.doScroll('left');
          } catch (ex) {
            $_8sy3pfhjh8lyw95.setTimeout(tryScroll);
            return;
          }
          readyHandler();
        };
        if (doc.addEventListener && !($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 11)) {
          if (isDocReady()) {
            readyHandler();
          } else {
            addEvent(win, 'DOMContentLoaded', readyHandler);
          }
        } else {
          addEvent(doc, 'readystatechange', waitForDomLoaded);
          if (doc.documentElement.doScroll && win.self === win.top) {
            tryScroll();
          }
        }
        addEvent(win, 'load', readyHandler);
      };
      var EventUtils = function () {
        var self = this;
        var events = {}, count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
        expando = eventExpandoPrefix + (+new Date()).toString(32);
        hasMouseEnterLeave = 'onmouseenter' in document.documentElement;
        hasFocusIn = 'onfocusin' in document.documentElement;
        mouseEnterLeave = {
          mouseenter: 'mouseover',
          mouseleave: 'mouseout'
        };
        count = 1;
        self.domLoaded = false;
        self.events = events;
        var executeHandlers = function (evt, id) {
          var callbackList, i, l, callback;
          var container = events[id];
          callbackList = container && container[evt.type];
          if (callbackList) {
            for (i = 0, l = callbackList.length; i < l; i++) {
              callback = callbackList[i];
              if (callback && callback.func.call(callback.scope, evt) === false) {
                evt.preventDefault();
              }
              if (evt.isImmediatePropagationStopped()) {
                return;
              }
            }
          }
        };
        self.bind = function (target, names, callback, scope) {
          var id, callbackList, i, name, fakeName, nativeHandler, capture;
          var win = window;
          var defaultNativeHandler = function (evt) {
            executeHandlers(fix(evt || win.event), id);
          };
          if (!target || target.nodeType === 3 || target.nodeType === 8) {
            return;
          }
          if (!target[expando]) {
            id = count++;
            target[expando] = id;
            events[id] = {};
          } else {
            id = target[expando];
          }
          scope = scope || target;
          names = names.split(' ');
          i = names.length;
          while (i--) {
            name = names[i];
            nativeHandler = defaultNativeHandler;
            fakeName = capture = false;
            if (name === 'DOMContentLoaded') {
              name = 'ready';
            }
            if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
              callback.call(scope, fix({ type: name }));
              continue;
            }
            if (!hasMouseEnterLeave) {
              fakeName = mouseEnterLeave[name];
              if (fakeName) {
                nativeHandler = function (evt) {
                  var current, related;
                  current = evt.currentTarget;
                  related = evt.relatedTarget;
                  if (related && current.contains) {
                    related = current.contains(related);
                  } else {
                    while (related && related !== current) {
                      related = related.parentNode;
                    }
                  }
                  if (!related) {
                    evt = fix(evt || win.event);
                    evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
                    evt.target = current;
                    executeHandlers(evt, id);
                  }
                };
              }
            }
            if (!hasFocusIn && (name === 'focusin' || name === 'focusout')) {
              capture = true;
              fakeName = name === 'focusin' ? 'focus' : 'blur';
              nativeHandler = function (evt) {
                evt = fix(evt || win.event);
                evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
                executeHandlers(evt, id);
              };
            }
            callbackList = events[id][name];
            if (!callbackList) {
              events[id][name] = callbackList = [{
                  func: callback,
                  scope: scope
                }];
              callbackList.fakeName = fakeName;
              callbackList.capture = capture;
              callbackList.nativeHandler = nativeHandler;
              if (name === 'ready') {
                bindOnReady(target, nativeHandler, self);
              } else {
                addEvent(target, fakeName || name, nativeHandler, capture);
              }
            } else {
              if (name === 'ready' && self.domLoaded) {
                callback({ type: name });
              } else {
                callbackList.push({
                  func: callback,
                  scope: scope
                });
              }
            }
          }
          target = callbackList = 0;
          return callback;
        };
        self.unbind = function (target, names, callback) {
          var id, callbackList, i, ci, name, eventMap;
          if (!target || target.nodeType === 3 || target.nodeType === 8) {
            return self;
          }
          id = target[expando];
          if (id) {
            eventMap = events[id];
            if (names) {
              names = names.split(' ');
              i = names.length;
              while (i--) {
                name = names[i];
                callbackList = eventMap[name];
                if (callbackList) {
                  if (callback) {
                    ci = callbackList.length;
                    while (ci--) {
                      if (callbackList[ci].func === callback) {
                        var nativeHandler = callbackList.nativeHandler;
                        var fakeName = callbackList.fakeName, capture = callbackList.capture;
                        callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
                        callbackList.nativeHandler = nativeHandler;
                        callbackList.fakeName = fakeName;
                        callbackList.capture = capture;
                        eventMap[name] = callbackList;
                      }
                    }
                  }
                  if (!callback || callbackList.length === 0) {
                    delete eventMap[name];
                    removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
                  }
                }
              }
            } else {
              for (name in eventMap) {
                callbackList = eventMap[name];
                removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
              }
              eventMap = {};
            }
            for (name in eventMap) {
              return self;
            }
            delete events[id];
            try {
              delete target[expando];
            } catch (ex) {
              target[expando] = null;
            }
          }
          return self;
        };
        self.fire = function (target, name, args) {
          var id;
          if (!target || target.nodeType === 3 || target.nodeType === 8) {
            return self;
          }
          args = fix(null, args);
          args.type = name;
          args.target = target;
          do {
            id = target[expando];
            if (id) {
              executeHandlers(args, id);
            }
            target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
          } while (target && !args.isPropagationStopped());
          return self;
        };
        self.clean = function (target) {
          var i, children;
          var unbind = self.unbind;
          if (!target || target.nodeType === 3 || target.nodeType === 8) {
            return self;
          }
          if (target[expando]) {
            unbind(target);
          }
          if (!target.getElementsByTagName) {
            target = target.document;
          }
          if (target && target.getElementsByTagName) {
            unbind(target);
            children = target.getElementsByTagName('*');
            i = children.length;
            while (i--) {
              target = children[i];
              if (target[expando]) {
                unbind(target);
              }
            }
          }
          return self;
        };
        self.destroy = function () {
          events = {};
        };
        self.cancel = function (e) {
          if (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
          return false;
        };
      };
      EventUtils.Event = new EventUtils();
      EventUtils.Event.bind(window, 'ready', function () {
      });

      var i;
      var support;
      var Expr;
      var getText;
      var isXML;
      var tokenize;
      var compile;
      var select;
      var outermostContext;
      var sortInput;
      var hasDuplicate;
      var setDocument;
      var document$1;
      var docElem;
      var documentIsHTML;
      var rbuggyQSA;
      var rbuggyMatches;
      var matches;
      var contains$1;
      var expando = 'sizzle' + -new Date();
      var preferredDoc = window.document;
      var dirruns = 0;
      var done = 0;
      var classCache = createCache();
      var tokenCache = createCache();
      var compilerCache = createCache();
      var sortOrder = function (a, b) {
          if (a === b) {
            hasDuplicate = true;
          }
          return 0;
        };
      var strundefined = typeof undefined;
      var MAX_NEGATIVE = 1 << 31;
      var hasOwn = {}.hasOwnProperty;
      var arr = [];
      var pop = arr.pop;
      var push_native = arr.push;
      var push$1 = arr.push;
      var slice$1 = arr.slice;
      var indexOf$1 = arr.indexOf || function (elem) {
          var i = 0, len = this.length;
          for (; i < len; i++) {
            if (this[i] === elem) {
              return i;
            }
          }
          return -1;
        };
      var booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped';
      var whitespace = '[\\x20\\t\\r\\n\\f]';
      var identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+';
      var attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]';
      var pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)';
      var rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g');
      var rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*');
      var rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*');
      var rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g');
      var rpseudo = new RegExp(pseudos);
      var ridentifier = new RegExp('^' + identifier + '$');
      var matchExpr = {
          ID: new RegExp('^#(' + identifier + ')'),
          CLASS: new RegExp('^\\.(' + identifier + ')'),
          TAG: new RegExp('^(' + identifier + '|[*])'),
          ATTR: new RegExp('^' + attributes),
          PSEUDO: new RegExp('^' + pseudos),
          CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
          bool: new RegExp('^(?:' + booleans + ')$', 'i'),
          needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
        };
      var rinputs = /^(?:input|select|textarea|button)$/i;
      var rheader = /^h\d$/i;
      var rnative = /^[^{]+\{\s*\[native \w/;
      var rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/;
      var rsibling = /[+~]/;
      var rescape = /'|\\/g;
      var runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig');
      var funescape = function (_, escaped, escapedWhitespace) {
          var high = '0x' + escaped - 65536;
          return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
        };
      try {
        push$1.apply(arr = slice$1.call(preferredDoc.childNodes), preferredDoc.childNodes);
        arr[preferredDoc.childNodes.length].nodeType;
      } catch (e) {
        push$1 = {
          apply: arr.length ? function (target, els) {
            push_native.apply(target, slice$1.call(els));
          } : function (target, els) {
            var j = target.length, i = 0;
            while (target[j++] = els[i++]) {
            }
            target.length = j - 1;
          }
        };
      }
      var Sizzle = function (selector, context, results, seed) {
        var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
        if ((context ? context.ownerDocument || context : preferredDoc) !== document$1) {
          setDocument(context);
        }
        context = context || document$1;
        results = results || [];
        if (!selector || typeof selector !== 'string') {
          return results;
        }
        if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
          return [];
        }
        if (documentIsHTML && !seed) {
          if (match = rquickExpr.exec(selector)) {
            if (m = match[1]) {
              if (nodeType === 9) {
                elem = context.getElementById(m);
                if (elem && elem.parentNode) {
                  if (elem.id === m) {
                    results.push(elem);
                    return results;
                  }
                } else {
                  return results;
                }
              } else {
                if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains$1(context, elem) && elem.id === m) {
                  results.push(elem);
                  return results;
                }
              }
            } else if (match[2]) {
              push$1.apply(results, context.getElementsByTagName(selector));
              return results;
            } else if ((m = match[3]) && support.getElementsByClassName) {
              push$1.apply(results, context.getElementsByClassName(m));
              return results;
            }
          }
          if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
            nid = old = expando;
            newContext = context;
            newSelector = nodeType === 9 && selector;
            if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
              groups = tokenize(selector);
              if (old = context.getAttribute('id')) {
                nid = old.replace(rescape, '\\$&');
              } else {
                context.setAttribute('id', nid);
              }
              nid = '[id=\'' + nid + '\'] ';
              i = groups.length;
              while (i--) {
                groups[i] = nid + toSelector(groups[i]);
              }
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
              newSelector = groups.join(',');
            }
            if (newSelector) {
              try {
                push$1.apply(results, newContext.querySelectorAll(newSelector));
                return results;
              } catch (qsaError) {
              } finally {
                if (!old) {
                  context.removeAttribute('id');
                }
              }
            }
          }
        }
        return select(selector.replace(rtrim, '$1'), context, results, seed);
      };
      function createCache() {
        var keys = [];
        function cache(key, value) {
          if (keys.push(key + ' ') > Expr.cacheLength) {
            delete cache[keys.shift()];
          }
          return cache[key + ' '] = value;
        }
        return cache;
      }
      function markFunction(fn) {
        fn[expando] = true;
        return fn;
      }
      function siblingCheck(a, b) {
        var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
        if (diff) {
          return diff;
        }
        if (cur) {
          while (cur = cur.nextSibling) {
            if (cur === b) {
              return -1;
            }
          }
        }
        return a ? 1 : -1;
      }
      function createInputPseudo(type) {
        return function (elem) {
          var name = elem.nodeName.toLowerCase();
          return name === 'input' && elem.type === type;
        };
      }
      function createButtonPseudo(type) {
        return function (elem) {
          var name = elem.nodeName.toLowerCase();
          return (name === 'input' || name === 'button') && elem.type === type;
        };
      }
      function createPositionalPseudo(fn) {
        return markFunction(function (argument) {
          argument = +argument;
          return markFunction(function (seed, matches) {
            var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
            while (i--) {
              if (seed[j = matchIndexes[i]]) {
                seed[j] = !(matches[j] = seed[j]);
              }
            }
          });
        });
      }
      function testContext(context) {
        return context && typeof context.getElementsByTagName !== strundefined && context;
      }
      support = Sizzle.support = {};
      isXML = Sizzle.isXML = function (elem) {
        var documentElement = elem && (elem.ownerDocument || elem).documentElement;
        return documentElement ? documentElement.nodeName !== 'HTML' : false;
      };
      setDocument = Sizzle.setDocument = function (node) {
        var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
        function getTop(win) {
          try {
            return win.top;
          } catch (ex) {
          }
          return null;
        }
        if (doc === document$1 || doc.nodeType !== 9 || !doc.documentElement) {
          return document$1;
        }
        document$1 = doc;
        docElem = doc.documentElement;
        documentIsHTML = !isXML(doc);
        if (parent && parent !== getTop(parent)) {
          if (parent.addEventListener) {
            parent.addEventListener('unload', function () {
              setDocument();
            }, false);
          } else if (parent.attachEvent) {
            parent.attachEvent('onunload', function () {
              setDocument();
            });
          }
        }
        support.attributes = true;
        support.getElementsByTagName = true;
        support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
        support.getById = true;
        Expr.find.ID = function (id, context) {
          if (typeof context.getElementById !== strundefined && documentIsHTML) {
            var m = context.getElementById(id);
            return m && m.parentNode ? [m] : [];
          }
        };
        Expr.filter.ID = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            return elem.getAttribute('id') === attrId;
          };
        };
        Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
          if (typeof context.getElementsByTagName !== strundefined) {
            return context.getElementsByTagName(tag);
          }
        } : function (tag, context) {
          var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
          if (tag === '*') {
            while (elem = results[i++]) {
              if (elem.nodeType === 1) {
                tmp.push(elem);
              }
            }
            return tmp;
          }
          return results;
        };
        Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
          if (documentIsHTML) {
            return context.getElementsByClassName(className);
          }
        };
        rbuggyMatches = [];
        rbuggyQSA = [];
        support.disconnectedMatch = true;
        rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
        rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
        hasCompare = rnative.test(docElem.compareDocumentPosition);
        contains$1 = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
          var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
          return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        } : function (a, b) {
          if (b) {
            while (b = b.parentNode) {
              if (b === a) {
                return true;
              }
            }
          }
          return false;
        };
        sortOrder = hasCompare ? function (a, b) {
          if (a === b) {
            hasDuplicate = true;
            return 0;
          }
          var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
          if (compare) {
            return compare;
          }
          compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
          if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
            if (a === doc || a.ownerDocument === preferredDoc && contains$1(preferredDoc, a)) {
              return -1;
            }
            if (b === doc || b.ownerDocument === preferredDoc && contains$1(preferredDoc, b)) {
              return 1;
            }
            return sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
          }
          return compare & 4 ? -1 : 1;
        } : function (a, b) {
          if (a === b) {
            hasDuplicate = true;
            return 0;
          }
          var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
          if (!aup || !bup) {
            return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf$1.call(sortInput, a) - indexOf$1.call(sortInput, b) : 0;
          } else if (aup === bup) {
            return siblingCheck(a, b);
          }
          cur = a;
          while (cur = cur.parentNode) {
            ap.unshift(cur);
          }
          cur = b;
          while (cur = cur.parentNode) {
            bp.unshift(cur);
          }
          while (ap[i] === bp[i]) {
            i++;
          }
          return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
        };
        return doc;
      };
      Sizzle.matches = function (expr, elements) {
        return Sizzle(expr, null, null, elements);
      };
      Sizzle.matchesSelector = function (elem, expr) {
        if ((elem.ownerDocument || elem) !== document$1) {
          setDocument(elem);
        }
        expr = expr.replace(rattributeQuotes, '=\'$1\']');
        if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
          try {
            var ret = matches.call(elem, expr);
            if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
              return ret;
            }
          } catch (e) {
          }
        }
        return Sizzle(expr, document$1, null, [elem]).length > 0;
      };
      Sizzle.contains = function (context, elem) {
        if ((context.ownerDocument || context) !== document$1) {
          setDocument(context);
        }
        return contains$1(context, elem);
      };
      Sizzle.attr = function (elem, name) {
        if ((elem.ownerDocument || elem) !== document$1) {
          setDocument(elem);
        }
        var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
        return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
      };
      Sizzle.error = function (msg) {
        throw new Error('Syntax error, unrecognized expression: ' + msg);
      };
      Sizzle.uniqueSort = function (results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = !support.detectDuplicates;
        sortInput = !support.sortStable && results.slice(0);
        results.sort(sortOrder);
        if (hasDuplicate) {
          while (elem = results[i++]) {
            if (elem === results[i]) {
              j = duplicates.push(i);
            }
          }
          while (j--) {
            results.splice(duplicates[j], 1);
          }
        }
        sortInput = null;
        return results;
      };
      getText = Sizzle.getText = function (elem) {
        var node, ret = '', i = 0, nodeType = elem.nodeType;
        if (!nodeType) {
          while (node = elem[i++]) {
            ret += getText(node);
          }
        } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
          if (typeof elem.textContent === 'string') {
            return elem.textContent;
          } else {
            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
              ret += getText(elem);
            }
          }
        } else if (nodeType === 3 || nodeType === 4) {
          return elem.nodeValue;
        }
        return ret;
      };
      Expr = Sizzle.selectors = {
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        attrHandle: {},
        find: {},
        relative: {
          '>': {
            dir: 'parentNode',
            first: true
          },
          ' ': { dir: 'parentNode' },
          '+': {
            dir: 'previousSibling',
            first: true
          },
          '~': { dir: 'previousSibling' }
        },
        preFilter: {
          ATTR: function (match) {
            match[1] = match[1].replace(runescape, funescape);
            match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
            if (match[2] === '~=') {
              match[3] = ' ' + match[3] + ' ';
            }
            return match.slice(0, 4);
          },
          CHILD: function (match) {
            match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === 'nth') {
              if (!match[3]) {
                Sizzle.error(match[0]);
              }
              match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
              match[5] = +(match[7] + match[8] || match[3] === 'odd');
            } else if (match[3]) {
              Sizzle.error(match[0]);
            }
            return match;
          },
          PSEUDO: function (match) {
            var excess, unquoted = !match[6] && match[2];
            if (matchExpr.CHILD.test(match[0])) {
              return null;
            }
            if (match[3]) {
              match[2] = match[4] || match[5] || '';
            } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
              match[0] = match[0].slice(0, excess);
              match[2] = unquoted.slice(0, excess);
            }
            return match.slice(0, 3);
          }
        },
        filter: {
          TAG: function (nodeNameSelector) {
            var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
            return nodeNameSelector === '*' ? function () {
              return true;
            } : function (elem) {
              return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
            };
          },
          CLASS: function (className) {
            var pattern = classCache[className + ' '];
            return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
              return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
            });
          },
          ATTR: function (name, operator, check) {
            return function (elem) {
              var result = Sizzle.attr(elem, name);
              if (result == null) {
                return operator === '!=';
              }
              if (!operator) {
                return true;
              }
              result += '';
              return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
            };
          },
          CHILD: function (type, what, argument, first, last) {
            var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
            return first === 1 && last === 0 ? function (elem) {
              return !!elem.parentNode;
            } : function (elem, context, xml) {
              var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
              if (parent) {
                if (simple) {
                  while (dir) {
                    node = elem;
                    while (node = node[dir]) {
                      if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                        return false;
                      }
                    }
                    start = dir = type === 'only' && !start && 'nextSibling';
                  }
                  return true;
                }
                start = [forward ? parent.firstChild : parent.lastChild];
                if (forward && useCache) {
                  outerCache = parent[expando] || (parent[expando] = {});
                  cache = outerCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = cache[0] === dirruns && cache[2];
                  node = nodeIndex && parent.childNodes[nodeIndex];
                  while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                    if (node.nodeType === 1 && ++diff && node === elem) {
                      outerCache[type] = [
                        dirruns,
                        nodeIndex,
                        diff
                      ];
                      break;
                    }
                  }
                } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
                  diff = cache[1];
                } else {
                  while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                      if (useCache) {
                        (node[expando] || (node[expando] = {}))[type] = [
                          dirruns,
                          diff
                        ];
                      }
                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
                diff -= last;
                return diff === first || diff % first === 0 && diff / first >= 0;
              }
            };
          },
          PSEUDO: function (pseudo, argument) {
            var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
            if (fn[expando]) {
              return fn(argument);
            }
            if (fn.length > 1) {
              args = [
                pseudo,
                pseudo,
                '',
                argument
              ];
              return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
                var idx, matched = fn(seed, argument), i = matched.length;
                while (i--) {
                  idx = indexOf$1.call(seed, matched[i]);
                  seed[idx] = !(matches[idx] = matched[i]);
                }
              }) : function (elem) {
                return fn(elem, 0, args);
              };
            }
            return fn;
          }
        },
        pseudos: {
          not: markFunction(function (selector) {
            var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
            return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
              var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
              while (i--) {
                if (elem = unmatched[i]) {
                  seed[i] = !(matches[i] = elem);
                }
              }
            }) : function (elem, context, xml) {
              input[0] = elem;
              matcher(input, null, xml, results);
              return !results.pop();
            };
          }),
          has: markFunction(function (selector) {
            return function (elem) {
              return Sizzle(selector, elem).length > 0;
            };
          }),
          contains: markFunction(function (text) {
            text = text.replace(runescape, funescape);
            return function (elem) {
              return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
            };
          }),
          lang: markFunction(function (lang) {
            if (!ridentifier.test(lang || '')) {
              Sizzle.error('unsupported lang: ' + lang);
            }
            lang = lang.replace(runescape, funescape).toLowerCase();
            return function (elem) {
              var elemLang;
              do {
                if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
                  elemLang = elemLang.toLowerCase();
                  return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
                }
              } while ((elem = elem.parentNode) && elem.nodeType === 1);
              return false;
            };
          }),
          target: function (elem) {
            var hash = window.location && window.location.hash;
            return hash && hash.slice(1) === elem.id;
          },
          root: function (elem) {
            return elem === docElem;
          },
          focus: function (elem) {
            return elem === document$1.activeElement && (!document$1.hasFocus || document$1.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
          },
          enabled: function (elem) {
            return elem.disabled === false;
          },
          disabled: function (elem) {
            return elem.disabled === true;
          },
          checked: function (elem) {
            var nodeName = elem.nodeName.toLowerCase();
            return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
          },
          selected: function (elem) {
            if (elem.parentNode) {
              elem.parentNode.selectedIndex;
            }
            return elem.selected === true;
          },
          empty: function (elem) {
            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
              if (elem.nodeType < 6) {
                return false;
              }
            }
            return true;
          },
          parent: function (elem) {
            return !Expr.pseudos.empty(elem);
          },
          header: function (elem) {
            return rheader.test(elem.nodeName);
          },
          input: function (elem) {
            return rinputs.test(elem.nodeName);
          },
          button: function (elem) {
            var name = elem.nodeName.toLowerCase();
            return name === 'input' && elem.type === 'button' || name === 'button';
          },
          text: function (elem) {
            var attr;
            return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
          },
          first: createPositionalPseudo(function () {
            return [0];
          }),
          last: createPositionalPseudo(function (matchIndexes, length) {
            return [length - 1];
          }),
          eq: createPositionalPseudo(function (matchIndexes, length, argument) {
            return [argument < 0 ? argument + length : argument];
          }),
          even: createPositionalPseudo(function (matchIndexes, length) {
            var i = 0;
            for (; i < length; i += 2) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          odd: createPositionalPseudo(function (matchIndexes, length) {
            var i = 1;
            for (; i < length; i += 2) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          lt: createPositionalPseudo(function (matchIndexes, length, argument) {
            var i = argument < 0 ? argument + length : argument;
            for (; --i >= 0;) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          }),
          gt: createPositionalPseudo(function (matchIndexes, length, argument) {
            var i = argument < 0 ? argument + length : argument;
            for (; ++i < length;) {
              matchIndexes.push(i);
            }
            return matchIndexes;
          })
        }
      };
      Expr.pseudos.nth = Expr.pseudos.eq;
      for (i in {
          radio: true,
          checkbox: true,
          file: true,
          password: true,
          image: true
        }) {
        Expr.pseudos[i] = createInputPseudo(i);
      }
      for (i in {
          submit: true,
          reset: true
        }) {
        Expr.pseudos[i] = createButtonPseudo(i);
      }
      function setFilters() {
      }
      setFilters.prototype = Expr.filters = Expr.pseudos;
      Expr.setFilters = new setFilters();
      tokenize = Sizzle.tokenize = function (selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
        if (cached) {
          return parseOnly ? 0 : cached.slice(0);
        }
        soFar = selector;
        groups = [];
        preFilters = Expr.preFilter;
        while (soFar) {
          if (!matched || (match = rcomma.exec(soFar))) {
            if (match) {
              soFar = soFar.slice(match[0].length) || soFar;
            }
            groups.push(tokens = []);
          }
          matched = false;
          if (match = rcombinators.exec(soFar)) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: match[0].replace(rtrim, ' ')
            });
            soFar = soFar.slice(matched.length);
          }
          for (type in Expr.filter) {
            if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
              matched = match.shift();
              tokens.push({
                value: matched,
                type: type,
                matches: match
              });
              soFar = soFar.slice(matched.length);
            }
          }
          if (!matched) {
            break;
          }
        }
        return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
      };
      function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = '';
        for (; i < len; i++) {
          selector += tokens[i].value;
        }
        return selector;
      }
      function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
        return combinator.first ? function (elem, context, xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              return matcher(elem, context, xml);
            }
          }
        } : function (elem, context, xml) {
          var oldCache, outerCache, newCache = [
              dirruns,
              doneName
            ];
          if (xml) {
            while (elem = elem[dir]) {
              if (elem.nodeType === 1 || checkNonElements) {
                if (matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          } else {
            while (elem = elem[dir]) {
              if (elem.nodeType === 1 || checkNonElements) {
                outerCache = elem[expando] || (elem[expando] = {});
                if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                  return newCache[2] = oldCache[2];
                } else {
                  outerCache[dir] = newCache;
                  if (newCache[2] = matcher(elem, context, xml)) {
                    return true;
                  }
                }
              }
            }
          }
        };
      }
      function elementMatcher(matchers) {
        return matchers.length > 1 ? function (elem, context, xml) {
          var i = matchers.length;
          while (i--) {
            if (!matchers[i](elem, context, xml)) {
              return false;
            }
          }
          return true;
        } : matchers[0];
      }
      function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for (; i < len; i++) {
          Sizzle(selector, contexts[i], results);
        }
        return results;
      }
      function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for (; i < len; i++) {
          if (elem = unmatched[i]) {
            if (!filter || filter(elem, context, xml)) {
              newUnmatched.push(elem);
              if (mapped) {
                map.push(i);
              }
            }
          }
        }
        return newUnmatched;
      }
      function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[expando]) {
          postFilter = setMatcher(postFilter);
        }
        if (postFinder && !postFinder[expando]) {
          postFinder = setMatcher(postFinder, postSelector);
        }
        return markFunction(function (seed, results, context, xml) {
          var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
          if (matcher) {
            matcher(matcherIn, matcherOut, context, xml);
          }
          if (postFilter) {
            temp = condense(matcherOut, postMap);
            postFilter(temp, [], context, xml);
            i = temp.length;
            while (i--) {
              if (elem = temp[i]) {
                matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
              }
            }
          }
          if (seed) {
            if (postFinder || preFilter) {
              if (postFinder) {
                temp = [];
                i = matcherOut.length;
                while (i--) {
                  if (elem = matcherOut[i]) {
                    temp.push(matcherIn[i] = elem);
                  }
                }
                postFinder(null, matcherOut = [], temp, xml);
              }
              i = matcherOut.length;
              while (i--) {
                if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf$1.call(seed, elem) : preMap[i]) > -1) {
                  seed[temp] = !(results[temp] = elem);
                }
              }
            }
          } else {
            matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
            if (postFinder) {
              postFinder(null, results, matcherOut, xml);
            } else {
              push$1.apply(results, matcherOut);
            }
          }
        });
      }
      function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
            return elem === checkContext;
          }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
            return indexOf$1.call(checkContext, elem) > -1;
          }, implicitRelative, true), matchers = [function (elem, context, xml) {
              return !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
            }];
        for (; i < len; i++) {
          if (matcher = Expr.relative[tokens[i].type]) {
            matchers = [addCombinator(elementMatcher(matchers), matcher)];
          } else {
            matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            if (matcher[expando]) {
              j = ++i;
              for (; j < len; j++) {
                if (Expr.relative[tokens[j].type]) {
                  break;
                }
              }
              return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
          }
        }
        return elementMatcher(matchers);
      }
      function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
            if (outermost) {
              outermostContext = context !== document$1 && context;
            }
            for (; i !== len && (elem = elems[i]) != null; i++) {
              if (byElement && elem) {
                j = 0;
                while (matcher = elementMatchers[j++]) {
                  if (matcher(elem, context, xml)) {
                    results.push(elem);
                    break;
                  }
                }
                if (outermost) {
                  dirruns = dirrunsUnique;
                }
              }
              if (bySet) {
                if (elem = !matcher && elem) {
                  matchedCount--;
                }
                if (seed) {
                  unmatched.push(elem);
                }
              }
            }
            matchedCount += i;
            if (bySet && i !== matchedCount) {
              j = 0;
              while (matcher = setMatchers[j++]) {
                matcher(unmatched, setMatched, context, xml);
              }
              if (seed) {
                if (matchedCount > 0) {
                  while (i--) {
                    if (!(unmatched[i] || setMatched[i])) {
                      setMatched[i] = pop.call(results);
                    }
                  }
                }
                setMatched = condense(setMatched);
              }
              push$1.apply(results, setMatched);
              if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                Sizzle.uniqueSort(results);
              }
            }
            if (outermost) {
              dirruns = dirrunsUnique;
              outermostContext = contextBackup;
            }
            return unmatched;
          };
        return bySet ? markFunction(superMatcher) : superMatcher;
      }
      compile = Sizzle.compile = function (selector, match) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
        if (!cached) {
          if (!match) {
            match = tokenize(selector);
          }
          i = match.length;
          while (i--) {
            cached = matcherFromTokens(match[i]);
            if (cached[expando]) {
              setMatchers.push(cached);
            } else {
              elementMatchers.push(cached);
            }
          }
          cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
          cached.selector = selector;
        }
        return cached;
      };
      select = Sizzle.select = function (selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        if (match.length === 1) {
          tokens = match[0] = match[0].slice(0);
          if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
            context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
            if (!context) {
              return results;
            } else if (compiled) {
              context = context.parentNode;
            }
            selector = selector.slice(tokens.shift().value.length);
          }
          i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
          while (i--) {
            token = tokens[i];
            if (Expr.relative[type = token.type]) {
              break;
            }
            if (find = Expr.find[type]) {
              if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                tokens.splice(i, 1);
                selector = seed.length && toSelector(tokens);
                if (!selector) {
                  push$1.apply(results, seed);
                  return results;
                }
                break;
              }
            }
          }
        }
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
      };
      support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
      support.detectDuplicates = !!hasDuplicate;
      setDocument();
      support.sortDetached = true;

      var isArray = Array.isArray;
      var toArray = function (obj) {
        var array = obj, i, l;
        if (!isArray(obj)) {
          array = [];
          for (i = 0, l = obj.length; i < l; i++) {
            array[i] = obj[i];
          }
        }
        return array;
      };
      var each$1 = function (o, cb, s) {
        var n, l;
        if (!o) {
          return 0;
        }
        s = s || o;
        if (o.length !== undefined) {
          for (n = 0, l = o.length; n < l; n++) {
            if (cb.call(s, o[n], n, o) === false) {
              return 0;
            }
          }
        } else {
          for (n in o) {
            if (o.hasOwnProperty(n)) {
              if (cb.call(s, o[n], n, o) === false) {
                return 0;
              }
            }
          }
        }
        return 1;
      };
      var map$1 = function (array, callback) {
        var out = [];
        each$1(array, function (item, index) {
          out.push(callback(item, index, array));
        });
        return out;
      };
      var filter$1 = function (a, f) {
        var o = [];
        each$1(a, function (v, index) {
          if (!f || f(v, index, a)) {
            o.push(v);
          }
        });
        return o;
      };
      var indexOf$2 = function (a, v) {
        var i, l;
        if (a) {
          for (i = 0, l = a.length; i < l; i++) {
            if (a[i] === v) {
              return i;
            }
          }
        }
        return -1;
      };
      var reduce = function (collection, iteratee, accumulator, thisArg) {
        var i = 0;
        if (arguments.length < 3) {
          accumulator = collection[0];
        }
        for (; i < collection.length; i++) {
          accumulator = iteratee.call(thisArg, accumulator, collection[i], i);
        }
        return accumulator;
      };
      var findIndex$1 = function (array, predicate, thisArg) {
        var i, l;
        for (i = 0, l = array.length; i < l; i++) {
          if (predicate.call(thisArg, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      var find$1 = function (array, predicate, thisArg) {
        var idx = findIndex$1(array, predicate, thisArg);
        if (idx !== -1) {
          return array[idx];
        }
        return undefined;
      };
      var last$1 = function (collection) {
        return collection[collection.length - 1];
      };
      var $_9tjm51ljh8lywbq = {
        isArray: isArray,
        toArray: toArray,
        each: each$1,
        map: map$1,
        filter: filter$1,
        indexOf: indexOf$2,
        reduce: reduce,
        findIndex: findIndex$1,
        find: find$1,
        last: last$1
      };

      var whiteSpaceRegExp = /^\s*|\s*$/g;
      var trim = function (str) {
        return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
      };
      var is = function (obj, type) {
        if (!type) {
          return obj !== undefined;
        }
        if (type === 'array' && $_9tjm51ljh8lywbq.isArray(obj)) {
          return true;
        }
        return typeof obj === type;
      };
      var makeMap = function (items, delim, map) {
        var i;
        items = items || [];
        delim = delim || ',';
        if (typeof items === 'string') {
          items = items.split(delim);
        }
        map = map || {};
        i = items.length;
        while (i--) {
          map[items[i]] = {};
        }
        return map;
      };
      var hasOwnProperty = function (obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
      };
      var create = function (s, p, root) {
        var self = this;
        var sp, ns, cn, scn, c, de = 0;
        s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
        cn = s[3].match(/(^|\.)(\w+)$/i)[2];
        ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
        if (ns[cn]) {
          return;
        }
        if (s[2] === 'static') {
          ns[cn] = p;
          if (this.onCreate) {
            this.onCreate(s[2], s[3], ns[cn]);
          }
          return;
        }
        if (!p[cn]) {
          p[cn] = function () {
          };
          de = 1;
        }
        ns[cn] = p[cn];
        self.extend(ns[cn].prototype, p);
        if (s[5]) {
          sp = self.resolve(s[5]).prototype;
          scn = s[5].match(/\.(\w+)$/i)[1];
          c = ns[cn];
          if (de) {
            ns[cn] = function () {
              return sp[scn].apply(this, arguments);
            };
          } else {
            ns[cn] = function () {
              this.parent = sp[scn];
              return c.apply(this, arguments);
            };
          }
          ns[cn].prototype[cn] = ns[cn];
          self.each(sp, function (f, n) {
            ns[cn].prototype[n] = sp[n];
          });
          self.each(p, function (f, n) {
            if (sp[n]) {
              ns[cn].prototype[n] = function () {
                this.parent = sp[n];
                return f.apply(this, arguments);
              };
            } else {
              if (n !== cn) {
                ns[cn].prototype[n] = f;
              }
            }
          });
        }
        self.each(p.static, function (f, n) {
          ns[cn][n] = f;
        });
      };
      var extend = function (obj, ext) {
        var x = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          x[_i - 2] = arguments[_i];
        }
        var i, l, name;
        var args = arguments;
        var value;
        for (i = 1, l = args.length; i < l; i++) {
          ext = args[i];
          for (name in ext) {
            if (ext.hasOwnProperty(name)) {
              value = ext[name];
              if (value !== undefined) {
                obj[name] = value;
              }
            }
          }
        }
        return obj;
      };
      var walk = function (o, f, n, s) {
        s = s || this;
        if (o) {
          if (n) {
            o = o[n];
          }
          $_9tjm51ljh8lywbq.each(o, function (o, i) {
            if (f.call(s, o, i, n) === false) {
              return false;
            }
            walk(o, f, n, s);
          });
        }
      };
      var createNS = function (n, o) {
        var i, v;
        o = o || window;
        n = n.split('.');
        for (i = 0; i < n.length; i++) {
          v = n[i];
          if (!o[v]) {
            o[v] = {};
          }
          o = o[v];
        }
        return o;
      };
      var resolve$1 = function (n, o) {
        var i, l;
        o = o || window;
        n = n.split('.');
        for (i = 0, l = n.length; i < l; i++) {
          o = o[n[i]];
          if (!o) {
            break;
          }
        }
        return o;
      };
      var explode = function (s, d) {
        if (!s || is(s, 'array')) {
          return s;
        }
        return $_9tjm51ljh8lywbq.map(s.split(d || ','), trim);
      };
      var _addCacheSuffix = function (url) {
        var cacheSuffix = $_9bpim8ajh8lyw68.cacheSuffix;
        if (cacheSuffix) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
        }
        return url;
      };
      var $_ahowuxkjh8lywbj = {
        trim: trim,
        isArray: $_9tjm51ljh8lywbq.isArray,
        is: is,
        toArray: $_9tjm51ljh8lywbq.toArray,
        makeMap: makeMap,
        each: $_9tjm51ljh8lywbq.each,
        map: $_9tjm51ljh8lywbq.map,
        grep: $_9tjm51ljh8lywbq.filter,
        inArray: $_9tjm51ljh8lywbq.indexOf,
        hasOwn: hasOwnProperty,
        extend: extend,
        create: create,
        walk: walk,
        createNS: createNS,
        resolve: resolve$1,
        explode: explode,
        _addCacheSuffix: _addCacheSuffix
      };

      var doc = document;
      var push$2 = Array.prototype.push;
      var slice$2 = Array.prototype.slice;
      var rquickExpr$1 = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
      var Event = EventUtils.Event;
      var skipUniques = $_ahowuxkjh8lywbj.makeMap('children,contents,next,prev');
      var isDefined = function (obj) {
        return typeof obj !== 'undefined';
      };
      var isString = function (obj) {
        return typeof obj === 'string';
      };
      var isWindow = function (obj) {
        return obj && obj === obj.window;
      };
      var createFragment = function (html, fragDoc) {
        var frag, node, container;
        fragDoc = fragDoc || doc;
        container = fragDoc.createElement('div');
        frag = fragDoc.createDocumentFragment();
        container.innerHTML = html;
        while (node = container.firstChild) {
          frag.appendChild(node);
        }
        return frag;
      };
      var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
        var i;
        if (isString(sourceItem)) {
          sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
        } else if (sourceItem.length && !sourceItem.nodeType) {
          sourceItem = DomQuery.makeArray(sourceItem);
          if (reverse) {
            for (i = sourceItem.length - 1; i >= 0; i--) {
              domManipulate(targetNodes, sourceItem[i], callback, reverse);
            }
          } else {
            for (i = 0; i < sourceItem.length; i++) {
              domManipulate(targetNodes, sourceItem[i], callback, reverse);
            }
          }
          return targetNodes;
        }
        if (sourceItem.nodeType) {
          i = targetNodes.length;
          while (i--) {
            callback.call(targetNodes[i], sourceItem);
          }
        }
        return targetNodes;
      };
      var hasClass = function (node, className) {
        return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
      };
      var wrap = function (elements, wrapper, all) {
        var lastParent, newWrapper;
        wrapper = DomQuery(wrapper)[0];
        elements.each(function () {
          var self = this;
          if (!all || lastParent !== self.parentNode) {
            lastParent = self.parentNode;
            newWrapper = wrapper.cloneNode(false);
            self.parentNode.insertBefore(newWrapper, self);
            newWrapper.appendChild(self);
          } else {
            newWrapper.appendChild(self);
          }
        });
        return elements;
      };
      var numericCssMap = $_ahowuxkjh8lywbj.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
      var booleanMap = $_ahowuxkjh8lywbj.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
      var propFix = {
        for: 'htmlFor',
        class: 'className',
        readonly: 'readOnly'
      };
      var cssFix = { float: 'cssFloat' };
      var attrHooks = {};
      var cssHooks = {};
      var DomQuery = function (selector, context) {
        return new DomQuery.fn.init(selector, context);
      };
      var inArray = function (item, array) {
        var i;
        if (array.indexOf) {
          return array.indexOf(item);
        }
        i = array.length;
        while (i--) {
          if (array[i] === item) {
            return i;
          }
        }
        return -1;
      };
      var whiteSpaceRegExp$1 = /^\s*|\s*$/g;
      var trim$1 = function (str) {
        return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$1, '');
      };
      var each$2 = function (obj, callback) {
        var length, key, i, value;
        if (obj) {
          length = obj.length;
          if (length === undefined) {
            for (key in obj) {
              if (obj.hasOwnProperty(key)) {
                value = obj[key];
                if (callback.call(value, key, value) === false) {
                  break;
                }
              }
            }
          } else {
            for (i = 0; i < length; i++) {
              value = obj[i];
              if (callback.call(value, i, value) === false) {
                break;
              }
            }
          }
        }
        return obj;
      };
      var grep = function (array, callback) {
        var out = [];
        each$2(array, function (i, item) {
          if (callback(item, i)) {
            out.push(item);
          }
        });
        return out;
      };
      var getElementDocument = function (element) {
        if (!element) {
          return doc;
        }
        if (element.nodeType === 9) {
          return element;
        }
        return element.ownerDocument;
      };
      DomQuery.fn = DomQuery.prototype = {
        constructor: DomQuery,
        selector: '',
        context: null,
        length: 0,
        init: function (selector, context) {
          var self = this;
          var match, node;
          if (!selector) {
            return self;
          }
          if (selector.nodeType) {
            self.context = self[0] = selector;
            self.length = 1;
            return self;
          }
          if (context && context.nodeType) {
            self.context = context;
          } else {
            if (context) {
              return DomQuery(selector).attr(context);
            }
            self.context = context = document;
          }
          if (isString(selector)) {
            self.selector = selector;
            if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
              match = [
                null,
                selector,
                null
              ];
            } else {
              match = rquickExpr$1.exec(selector);
            }
            if (match) {
              if (match[1]) {
                node = createFragment(selector, getElementDocument(context)).firstChild;
                while (node) {
                  push$2.call(self, node);
                  node = node.nextSibling;
                }
              } else {
                node = getElementDocument(context).getElementById(match[2]);
                if (!node) {
                  return self;
                }
                if (node.id !== match[2]) {
                  return self.find(selector);
                }
                self.length = 1;
                self[0] = node;
              }
            } else {
              return DomQuery(context).find(selector);
            }
          } else {
            this.add(selector, false);
          }
          return self;
        },
        toArray: function () {
          return $_ahowuxkjh8lywbj.toArray(this);
        },
        add: function (items, sort) {
          var self = this;
          var nodes, i;
          if (isString(items)) {
            return self.add(DomQuery(items));
          }
          if (sort !== false) {
            nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
            self.length = nodes.length;
            for (i = 0; i < nodes.length; i++) {
              self[i] = nodes[i];
            }
          } else {
            push$2.apply(self, DomQuery.makeArray(items));
          }
          return self;
        },
        attr: function (name, value) {
          var self = this;
          var hook;
          if (typeof name === 'object') {
            each$2(name, function (name, value) {
              self.attr(name, value);
            });
          } else if (isDefined(value)) {
            this.each(function () {
              var hook;
              if (this.nodeType === 1) {
                hook = attrHooks[name];
                if (hook && hook.set) {
                  hook.set(this, value);
                  return;
                }
                if (value === null) {
                  this.removeAttribute(name, 2);
                } else {
                  this.setAttribute(name, value, 2);
                }
              }
            });
          } else {
            if (self[0] && self[0].nodeType === 1) {
              hook = attrHooks[name];
              if (hook && hook.get) {
                return hook.get(self[0], name);
              }
              if (booleanMap[name]) {
                return self.prop(name) ? name : undefined;
              }
              value = self[0].getAttribute(name, 2);
              if (value === null) {
                value = undefined;
              }
            }
            return value;
          }
          return self;
        },
        removeAttr: function (name) {
          return this.attr(name, null);
        },
        prop: function (name, value) {
          var self = this;
          name = propFix[name] || name;
          if (typeof name === 'object') {
            each$2(name, function (name, value) {
              self.prop(name, value);
            });
          } else if (isDefined(value)) {
            this.each(function () {
              if (this.nodeType === 1) {
                this[name] = value;
              }
            });
          } else {
            if (self[0] && self[0].nodeType && name in self[0]) {
              return self[0][name];
            }
            return value;
          }
          return self;
        },
        css: function (name, value) {
          var self = this;
          var elm, hook;
          var camel = function (name) {
            return name.replace(/-(\D)/g, function (a, b) {
              return b.toUpperCase();
            });
          };
          var dashed = function (name) {
            return name.replace(/[A-Z]/g, function (a) {
              return '-' + a;
            });
          };
          if (typeof name === 'object') {
            each$2(name, function (name, value) {
              self.css(name, value);
            });
          } else {
            if (isDefined(value)) {
              name = camel(name);
              if (typeof value === 'number' && !numericCssMap[name]) {
                value = value.toString() + 'px';
              }
              self.each(function () {
                var style = this.style;
                hook = cssHooks[name];
                if (hook && hook.set) {
                  hook.set(this, value);
                  return;
                }
                try {
                  this.style[cssFix[name] || name] = value;
                } catch (ex) {
                }
                if (value === null || value === '') {
                  if (style.removeProperty) {
                    style.removeProperty(dashed(name));
                  } else {
                    style.removeAttribute(name);
                  }
                }
              });
            } else {
              elm = self[0];
              hook = cssHooks[name];
              if (hook && hook.get) {
                return hook.get(elm);
              }
              if (elm.ownerDocument.defaultView) {
                try {
                  return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
                } catch (ex) {
                  return undefined;
                }
              } else if (elm.currentStyle) {
                return elm.currentStyle[camel(name)];
              } else {
                return '';
              }
            }
          }
          return self;
        },
        remove: function () {
          var self = this;
          var node, i = this.length;
          while (i--) {
            node = self[i];
            Event.clean(node);
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
          }
          return this;
        },
        empty: function () {
          var self = this;
          var node, i = this.length;
          while (i--) {
            node = self[i];
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
          }
          return this;
        },
        html: function (value) {
          var self = this;
          var i;
          if (isDefined(value)) {
            i = self.length;
            try {
              while (i--) {
                self[i].innerHTML = value;
              }
            } catch (ex) {
              DomQuery(self[i]).empty().append(value);
            }
            return self;
          }
          return self[0] ? self[0].innerHTML : '';
        },
        text: function (value) {
          var self = this;
          var i;
          if (isDefined(value)) {
            i = self.length;
            while (i--) {
              if ('innerText' in self[i]) {
                self[i].innerText = value;
              } else {
                self[0].textContent = value;
              }
            }
            return self;
          }
          return self[0] ? self[0].innerText || self[0].textContent : '';
        },
        append: function () {
          return domManipulate(this, arguments, function (node) {
            if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
              this.appendChild(node);
            }
          });
        },
        prepend: function () {
          return domManipulate(this, arguments, function (node) {
            if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
              this.insertBefore(node, this.firstChild);
            }
          }, true);
        },
        before: function () {
          var self = this;
          if (self[0] && self[0].parentNode) {
            return domManipulate(self, arguments, function (node) {
              this.parentNode.insertBefore(node, this);
            });
          }
          return self;
        },
        after: function () {
          var self = this;
          if (self[0] && self[0].parentNode) {
            return domManipulate(self, arguments, function (node) {
              this.parentNode.insertBefore(node, this.nextSibling);
            }, true);
          }
          return self;
        },
        appendTo: function (val) {
          DomQuery(val).append(this);
          return this;
        },
        prependTo: function (val) {
          DomQuery(val).prepend(this);
          return this;
        },
        replaceWith: function (content) {
          return this.before(content).remove();
        },
        wrap: function (content) {
          return wrap(this, content);
        },
        wrapAll: function (content) {
          return wrap(this, content, true);
        },
        wrapInner: function (content) {
          this.each(function () {
            DomQuery(this).contents().wrapAll(content);
          });
          return this;
        },
        unwrap: function () {
          return this.parent().each(function () {
            DomQuery(this).replaceWith(this.childNodes);
          });
        },
        clone: function () {
          var result = [];
          this.each(function () {
            result.push(this.cloneNode(true));
          });
          return DomQuery(result);
        },
        addClass: function (className) {
          return this.toggleClass(className, true);
        },
        removeClass: function (className) {
          return this.toggleClass(className, false);
        },
        toggleClass: function (className, state) {
          var self = this;
          if (typeof className !== 'string') {
            return self;
          }
          if (className.indexOf(' ') !== -1) {
            each$2(className.split(' '), function () {
              self.toggleClass(this, state);
            });
          } else {
            self.each(function (index, node) {
              var existingClassName, classState;
              classState = hasClass(node, className);
              if (classState !== state) {
                existingClassName = node.className;
                if (classState) {
                  node.className = trim$1((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
                } else {
                  node.className += existingClassName ? ' ' + className : className;
                }
              }
            });
          }
          return self;
        },
        hasClass: function (className) {
          return hasClass(this[0], className);
        },
        each: function (callback) {
          return each$2(this, callback);
        },
        on: function (name, callback) {
          return this.each(function () {
            Event.bind(this, name, callback);
          });
        },
        off: function (name, callback) {
          return this.each(function () {
            Event.unbind(this, name, callback);
          });
        },
        trigger: function (name) {
          return this.each(function () {
            if (typeof name === 'object') {
              Event.fire(this, name.type, name);
            } else {
              Event.fire(this, name);
            }
          });
        },
        show: function () {
          return this.css('display', '');
        },
        hide: function () {
          return this.css('display', 'none');
        },
        slice: function () {
          return new DomQuery(slice$2.apply(this, arguments));
        },
        eq: function (index) {
          return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        find: function (selector) {
          var i, l;
          var ret = [];
          for (i = 0, l = this.length; i < l; i++) {
            DomQuery.find(selector, this[i], ret);
          }
          return DomQuery(ret);
        },
        filter: function (selector) {
          if (typeof selector === 'function') {
            return DomQuery(grep(this.toArray(), function (item, i) {
              return selector(i, item);
            }));
          }
          return DomQuery(DomQuery.filter(selector, this.toArray()));
        },
        closest: function (selector) {
          var result = [];
          if (selector instanceof DomQuery) {
            selector = selector[0];
          }
          this.each(function (i, node) {
            while (node) {
              if (typeof selector === 'string' && DomQuery(node).is(selector)) {
                result.push(node);
                break;
              } else if (node === selector) {
                result.push(node);
                break;
              }
              node = node.parentNode;
            }
          });
          return DomQuery(result);
        },
        offset: function (offset) {
          var elm, doc, docElm;
          var x = 0, y = 0, pos;
          if (!offset) {
            elm = this[0];
            if (elm) {
              doc = elm.ownerDocument;
              docElm = doc.documentElement;
              if (elm.getBoundingClientRect) {
                pos = elm.getBoundingClientRect();
                x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
                y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
              }
            }
            return {
              left: x,
              top: y
            };
          }
          return this.css(offset);
        },
        push: push$2,
        sort: [].sort,
        splice: [].splice
      };
      $_ahowuxkjh8lywbj.extend(DomQuery, {
        extend: $_ahowuxkjh8lywbj.extend,
        makeArray: function (object) {
          if (isWindow(object) || object.nodeType) {
            return [object];
          }
          return $_ahowuxkjh8lywbj.toArray(object);
        },
        inArray: inArray,
        isArray: $_ahowuxkjh8lywbj.isArray,
        each: each$2,
        trim: trim$1,
        grep: grep,
        find: Sizzle,
        expr: Sizzle.selectors,
        unique: Sizzle.uniqueSort,
        text: Sizzle.getText,
        contains: Sizzle.contains,
        filter: function (expr, elems, not) {
          var i = elems.length;
          if (not) {
            expr = ':not(' + expr + ')';
          }
          while (i--) {
            if (elems[i].nodeType !== 1) {
              elems.splice(i, 1);
            }
          }
          if (elems.length === 1) {
            elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
          } else {
            elems = DomQuery.find.matches(expr, elems);
          }
          return elems;
        }
      });
      var dir = function (el, prop, until) {
        var matched = [];
        var cur = el[prop];
        if (typeof until !== 'string' && until instanceof DomQuery) {
          until = until[0];
        }
        while (cur && cur.nodeType !== 9) {
          if (until !== undefined) {
            if (cur === until) {
              break;
            }
            if (typeof until === 'string' && DomQuery(cur).is(until)) {
              break;
            }
          }
          if (cur.nodeType === 1) {
            matched.push(cur);
          }
          cur = cur[prop];
        }
        return matched;
      };
      var sibling = function (node, siblingName, nodeType, until) {
        var result = [];
        if (until instanceof DomQuery) {
          until = until[0];
        }
        for (; node; node = node[siblingName]) {
          if (nodeType && node.nodeType !== nodeType) {
            continue;
          }
          if (until !== undefined) {
            if (node === until) {
              break;
            }
            if (typeof until === 'string' && DomQuery(node).is(until)) {
              break;
            }
          }
          result.push(node);
        }
        return result;
      };
      var firstSibling = function (node, siblingName, nodeType) {
        for (node = node[siblingName]; node; node = node[siblingName]) {
          if (node.nodeType === nodeType) {
            return node;
          }
        }
        return null;
      };
      each$2({
        parent: function (node) {
          var parent = node.parentNode;
          return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function (node) {
          return dir(node, 'parentNode');
        },
        next: function (node) {
          return firstSibling(node, 'nextSibling', 1);
        },
        prev: function (node) {
          return firstSibling(node, 'previousSibling', 1);
        },
        children: function (node) {
          return sibling(node.firstChild, 'nextSibling', 1);
        },
        contents: function (node) {
          return $_ahowuxkjh8lywbj.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
        }
      }, function (name, fn) {
        DomQuery.fn[name] = function (selector) {
          var self = this;
          var result = [];
          self.each(function () {
            var nodes = fn.call(result, this, selector, result);
            if (nodes) {
              if (DomQuery.isArray(nodes)) {
                result.push.apply(result, nodes);
              } else {
                result.push(nodes);
              }
            }
          });
          if (this.length > 1) {
            if (!skipUniques[name]) {
              result = DomQuery.unique(result);
            }
            if (name.indexOf('parents') === 0) {
              result = result.reverse();
            }
          }
          result = DomQuery(result);
          if (selector) {
            return result.filter(selector);
          }
          return result;
        };
      });
      each$2({
        parentsUntil: function (node, until) {
          return dir(node, 'parentNode', until);
        },
        nextUntil: function (node, until) {
          return sibling(node, 'nextSibling', 1, until).slice(1);
        },
        prevUntil: function (node, until) {
          return sibling(node, 'previousSibling', 1, until).slice(1);
        }
      }, function (name, fn) {
        DomQuery.fn[name] = function (selector, filter) {
          var self = this;
          var result = [];
          self.each(function () {
            var nodes = fn.call(result, this, selector, result);
            if (nodes) {
              if (DomQuery.isArray(nodes)) {
                result.push.apply(result, nodes);
              } else {
                result.push(nodes);
              }
            }
          });
          if (this.length > 1) {
            result = DomQuery.unique(result);
            if (name.indexOf('parents') === 0 || name === 'prevUntil') {
              result = result.reverse();
            }
          }
          result = DomQuery(result);
          if (filter) {
            return result.filter(filter);
          }
          return result;
        };
      });
      DomQuery.fn.is = function (selector) {
        return !!selector && this.filter(selector).length > 0;
      };
      DomQuery.fn.init.prototype = DomQuery.fn;
      DomQuery.overrideDefaults = function (callback) {
        var defaults;
        var sub = function (selector, context) {
          defaults = defaults || callback();
          if (arguments.length === 0) {
            selector = defaults.element;
          }
          if (!context) {
            context = defaults.context;
          }
          return new sub.fn.init(selector, context);
        };
        DomQuery.extend(sub, this);
        return sub;
      };
      var appendHooks = function (targetHooks, prop, hooks) {
        each$2(hooks, function (name, func) {
          targetHooks[name] = targetHooks[name] || {};
          targetHooks[name][prop] = func;
        });
      };
      if ($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 8) {
        appendHooks(attrHooks, 'get', {
          maxlength: function (elm) {
            var value = elm.maxLength;
            if (value === 2147483647) {
              return undefined;
            }
            return value;
          },
          size: function (elm) {
            var value = elm.size;
            if (value === 20) {
              return undefined;
            }
            return value;
          },
          class: function (elm) {
            return elm.className;
          },
          style: function (elm) {
            var value = elm.style.cssText;
            if (value.length === 0) {
              return undefined;
            }
            return value;
          }
        });
        appendHooks(attrHooks, 'set', {
          class: function (elm, value) {
            elm.className = value;
          },
          style: function (elm, value) {
            elm.style.cssText = value;
          }
        });
      }
      if ($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 9) {
        cssFix.float = 'styleFloat';
        appendHooks(cssHooks, 'set', {
          opacity: function (elm, value) {
            var style = elm.style;
            if (value === null || value === '') {
              style.removeAttribute('filter');
            } else {
              style.zoom = 1;
              style.filter = 'alpha(opacity=' + value * 100 + ')';
            }
          }
        });
      }
      DomQuery.attrHooks = attrHooks;
      DomQuery.cssHooks = cssHooks;

      var cached = function (f) {
        var called = false;
        var r;
        return function () {
          if (!called) {
            called = true;
            r = f.apply(null, arguments);
          }
          return r;
        };
      };
      var $_bbi2igojh8lywc9 = { cached: cached };

      var firstMatch = function (regexes, s) {
        for (var i = 0; i < regexes.length; i++) {
          var x = regexes[i];
          if (x.test(s))
            return x;
        }
        return undefined;
      };
      var find$2 = function (regexes, agent) {
        var r = firstMatch(regexes, agent);
        if (!r)
          return {
            major: 0,
            minor: 0
          };
        var group = function (i) {
          return Number(agent.replace(r, '$' + i));
        };
        return nu(group(1), group(2));
      };
      var detect = function (versionRegexes, agent) {
        var cleanedAgent = String(agent).toLowerCase();
        if (versionRegexes.length === 0)
          return unknown();
        return find$2(versionRegexes, cleanedAgent);
      };
      var unknown = function () {
        return nu(0, 0);
      };
      var nu = function (major, minor) {
        return {
          major: major,
          minor: minor
        };
      };
      var $_a84zfnrjh8lywch = {
        nu: nu,
        detect: detect,
        unknown: unknown
      };

      var edge = 'Edge';
      var chrome = 'Chrome';
      var ie$1 = 'IE';
      var opera$1 = 'Opera';
      var firefox = 'Firefox';
      var safari = 'Safari';
      var isBrowser = function (name, current) {
        return function () {
          return current === name;
        };
      };
      var unknown$1 = function () {
        return nu$1({
          current: undefined,
          version: $_a84zfnrjh8lywch.unknown()
        });
      };
      var nu$1 = function (info) {
        var current = info.current;
        var version = info.version;
        return {
          current: current,
          version: version,
          isEdge: isBrowser(edge, current),
          isChrome: isBrowser(chrome, current),
          isIE: isBrowser(ie$1, current),
          isOpera: isBrowser(opera$1, current),
          isFirefox: isBrowser(firefox, current),
          isSafari: isBrowser(safari, current)
        };
      };
      var $_dckbfzqjh8lywcd = {
        unknown: unknown$1,
        nu: nu$1,
        edge: $_eqpqvr6jh8lyw3s.constant(edge),
        chrome: $_eqpqvr6jh8lyw3s.constant(chrome),
        ie: $_eqpqvr6jh8lyw3s.constant(ie$1),
        opera: $_eqpqvr6jh8lyw3s.constant(opera$1),
        firefox: $_eqpqvr6jh8lyw3s.constant(firefox),
        safari: $_eqpqvr6jh8lyw3s.constant(safari)
      };

      var windows = 'Windows';
      var ios = 'iOS';
      var android$1 = 'Android';
      var linux = 'Linux';
      var osx = 'OSX';
      var solaris = 'Solaris';
      var freebsd = 'FreeBSD';
      var isOS = function (name, current) {
        return function () {
          return current === name;
        };
      };
      var unknown$2 = function () {
        return nu$2({
          current: undefined,
          version: $_a84zfnrjh8lywch.unknown()
        });
      };
      var nu$2 = function (info) {
        var current = info.current;
        var version = info.version;
        return {
          current: current,
          version: version,
          isWindows: isOS(windows, current),
          isiOS: isOS(ios, current),
          isAndroid: isOS(android$1, current),
          isOSX: isOS(osx, current),
          isLinux: isOS(linux, current),
          isSolaris: isOS(solaris, current),
          isFreeBSD: isOS(freebsd, current)
        };
      };
      var $_dixfehsjh8lywcw = {
        unknown: unknown$2,
        nu: nu$2,
        windows: $_eqpqvr6jh8lyw3s.constant(windows),
        ios: $_eqpqvr6jh8lyw3s.constant(ios),
        android: $_eqpqvr6jh8lyw3s.constant(android$1),
        linux: $_eqpqvr6jh8lyw3s.constant(linux),
        osx: $_eqpqvr6jh8lyw3s.constant(osx),
        solaris: $_eqpqvr6jh8lyw3s.constant(solaris),
        freebsd: $_eqpqvr6jh8lyw3s.constant(freebsd)
      };

      function DeviceType (os, browser, userAgent) {
        var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
        var isiPhone = os.isiOS() && !isiPad;
        var isAndroid3 = os.isAndroid() && os.version.major === 3;
        var isAndroid4 = os.isAndroid() && os.version.major === 4;
        var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
        var isTouch = os.isiOS() || os.isAndroid();
        var isPhone = isTouch && !isTablet;
        var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
        return {
          isiPad: $_eqpqvr6jh8lyw3s.constant(isiPad),
          isiPhone: $_eqpqvr6jh8lyw3s.constant(isiPhone),
          isTablet: $_eqpqvr6jh8lyw3s.constant(isTablet),
          isPhone: $_eqpqvr6jh8lyw3s.constant(isPhone),
          isTouch: $_eqpqvr6jh8lyw3s.constant(isTouch),
          isAndroid: os.isAndroid,
          isiOS: os.isiOS,
          isWebView: $_eqpqvr6jh8lyw3s.constant(iOSwebview)
        };
      }

      var detect$1 = function (candidates, userAgent) {
        var agent = String(userAgent).toLowerCase();
        return $_5wjzy24jh8lyw2t.find(candidates, function (candidate) {
          return candidate.search(agent);
        });
      };
      var detectBrowser = function (browsers, userAgent) {
        return detect$1(browsers, userAgent).map(function (browser) {
          var version = $_a84zfnrjh8lywch.detect(browser.versionRegexes, userAgent);
          return {
            current: browser.name,
            version: version
          };
        });
      };
      var detectOs = function (oses, userAgent) {
        return detect$1(oses, userAgent).map(function (os) {
          var version = $_a84zfnrjh8lywch.detect(os.versionRegexes, userAgent);
          return {
            current: os.name,
            version: version
          };
        });
      };
      var $_deu818ujh8lywd4 = {
        detectBrowser: detectBrowser,
        detectOs: detectOs
      };

      var addToStart = function (str, prefix) {
        return prefix + str;
      };
      var addToEnd = function (str, suffix) {
        return str + suffix;
      };
      var removeFromStart = function (str, numChars) {
        return str.substring(numChars);
      };
      var removeFromEnd = function (str, numChars) {
        return str.substring(0, str.length - numChars);
      };
      var $_4h6f09xjh8lywdm = {
        addToStart: addToStart,
        addToEnd: addToEnd,
        removeFromStart: removeFromStart,
        removeFromEnd: removeFromEnd
      };

      var first = function (str, count) {
        return str.substr(0, count);
      };
      var last$2 = function (str, count) {
        return str.substr(str.length - count, str.length);
      };
      var head$1 = function (str) {
        return str === '' ? Option.none() : Option.some(str.substr(0, 1));
      };
      var tail = function (str) {
        return str === '' ? Option.none() : Option.some(str.substring(1));
      };
      var $_amulxnyjh8lywdo = {
        first: first,
        last: last$2,
        head: head$1,
        tail: tail
      };

      var checkRange = function (str, substr, start) {
        if (substr === '')
          return true;
        if (str.length < substr.length)
          return false;
        var x = str.substr(start, start + substr.length);
        return x === substr;
      };
      var supplant = function (str, obj) {
        var isStringOrNumber = function (a) {
          var t = typeof a;
          return t === 'string' || t === 'number';
        };
        return str.replace(/\${([^{}]*)}/g, function (a, b) {
          var value = obj[b];
          return isStringOrNumber(value) ? value : a;
        });
      };
      var removeLeading = function (str, prefix) {
        return startsWith(str, prefix) ? $_4h6f09xjh8lywdm.removeFromStart(str, prefix.length) : str;
      };
      var removeTrailing = function (str, prefix) {
        return endsWith(str, prefix) ? $_4h6f09xjh8lywdm.removeFromEnd(str, prefix.length) : str;
      };
      var ensureLeading = function (str, prefix) {
        return startsWith(str, prefix) ? str : $_4h6f09xjh8lywdm.addToStart(str, prefix);
      };
      var ensureTrailing = function (str, prefix) {
        return endsWith(str, prefix) ? str : $_4h6f09xjh8lywdm.addToEnd(str, prefix);
      };
      var contains$2 = function (str, substr) {
        return str.indexOf(substr) !== -1;
      };
      var capitalize = function (str) {
        return $_amulxnyjh8lywdo.head(str).bind(function (head) {
          return $_amulxnyjh8lywdo.tail(str).map(function (tail) {
            return head.toUpperCase() + tail;
          });
        }).getOr(str);
      };
      var startsWith = function (str, prefix) {
        return checkRange(str, prefix, 0);
      };
      var endsWith = function (str, suffix) {
        return checkRange(str, suffix, str.length - suffix.length);
      };
      var trim$2 = function (str) {
        return str.replace(/^\s+|\s+$/g, '');
      };
      var lTrim = function (str) {
        return str.replace(/^\s+/g, '');
      };
      var rTrim = function (str) {
        return str.replace(/\s+$/g, '');
      };
      var $_4w196awjh8lywdj = {
        supplant: supplant,
        startsWith: startsWith,
        removeLeading: removeLeading,
        removeTrailing: removeTrailing,
        ensureLeading: ensureLeading,
        ensureTrailing: ensureTrailing,
        endsWith: endsWith,
        contains: contains$2,
        trim: trim$2,
        lTrim: lTrim,
        rTrim: rTrim,
        capitalize: capitalize
      };

      var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
      var checkContains = function (target) {
        return function (uastring) {
          return $_4w196awjh8lywdj.contains(uastring, target);
        };
      };
      var browsers = [
        {
          name: 'Edge',
          versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
          search: function (uastring) {
            var monstrosity = $_4w196awjh8lywdj.contains(uastring, 'edge/') && $_4w196awjh8lywdj.contains(uastring, 'chrome') && $_4w196awjh8lywdj.contains(uastring, 'safari') && $_4w196awjh8lywdj.contains(uastring, 'applewebkit');
            return monstrosity;
          }
        },
        {
          name: 'Chrome',
          versionRegexes: [
            /.*?chrome\/([0-9]+)\.([0-9]+).*/,
            normalVersionRegex
          ],
          search: function (uastring) {
            return $_4w196awjh8lywdj.contains(uastring, 'chrome') && !$_4w196awjh8lywdj.contains(uastring, 'chromeframe');
          }
        },
        {
          name: 'IE',
          versionRegexes: [
            /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
            /.*?rv:([0-9]+)\.([0-9]+).*/
          ],
          search: function (uastring) {
            return $_4w196awjh8lywdj.contains(uastring, 'msie') || $_4w196awjh8lywdj.contains(uastring, 'trident');
          }
        },
        {
          name: 'Opera',
          versionRegexes: [
            normalVersionRegex,
            /.*?opera\/([0-9]+)\.([0-9]+).*/
          ],
          search: checkContains('opera')
        },
        {
          name: 'Firefox',
          versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
          search: checkContains('firefox')
        },
        {
          name: 'Safari',
          versionRegexes: [
            normalVersionRegex,
            /.*?cpu os ([0-9]+)_([0-9]+).*/
          ],
          search: function (uastring) {
            return ($_4w196awjh8lywdj.contains(uastring, 'safari') || $_4w196awjh8lywdj.contains(uastring, 'mobile/')) && $_4w196awjh8lywdj.contains(uastring, 'applewebkit');
          }
        }
      ];
      var oses = [
        {
          name: 'Windows',
          search: checkContains('win'),
          versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
        },
        {
          name: 'iOS',
          search: function (uastring) {
            return $_4w196awjh8lywdj.contains(uastring, 'iphone') || $_4w196awjh8lywdj.contains(uastring, 'ipad');
          },
          versionRegexes: [
            /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
            /.*cpu os ([0-9]+)_([0-9]+).*/,
            /.*cpu iphone os ([0-9]+)_([0-9]+).*/
          ]
        },
        {
          name: 'Android',
          search: checkContains('android'),
          versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
        },
        {
          name: 'OSX',
          search: checkContains('os x'),
          versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
        },
        {
          name: 'Linux',
          search: checkContains('linux'),
          versionRegexes: []
        },
        {
          name: 'Solaris',
          search: checkContains('sunos'),
          versionRegexes: []
        },
        {
          name: 'FreeBSD',
          search: checkContains('freebsd'),
          versionRegexes: []
        }
      ];
      var $_8gakxrvjh8lywdb = {
        browsers: $_eqpqvr6jh8lyw3s.constant(browsers),
        oses: $_eqpqvr6jh8lyw3s.constant(oses)
      };

      var detect$2 = function (userAgent) {
        var browsers = $_8gakxrvjh8lywdb.browsers();
        var oses = $_8gakxrvjh8lywdb.oses();
        var browser = $_deu818ujh8lywd4.detectBrowser(browsers, userAgent).fold($_dckbfzqjh8lywcd.unknown, $_dckbfzqjh8lywcd.nu);
        var os = $_deu818ujh8lywd4.detectOs(oses, userAgent).fold($_dixfehsjh8lywcw.unknown, $_dixfehsjh8lywcw.nu);
        var deviceType = DeviceType(os, browser, userAgent);
        return {
          browser: browser,
          os: os,
          deviceType: deviceType
        };
      };
      var $_3cj09epjh8lywcb = { detect: detect$2 };

      var detect$3 = $_bbi2igojh8lywc9.cached(function () {
        var userAgent = navigator.userAgent;
        return $_3cj09epjh8lywcb.detect(userAgent);
      });
      var $_9hkktfnjh8lywc6 = { detect: detect$3 };

      var fromHtml = function (html, scope) {
        var doc = scope || document;
        var div = doc.createElement('div');
        div.innerHTML = html;
        if (!div.hasChildNodes() || div.childNodes.length > 1) {
          console.error('HTML does not have a single root node', html);
          throw 'HTML must have a single root node';
        }
        return fromDom(div.childNodes[0]);
      };
      var fromTag = function (tag, scope) {
        var doc = scope || document;
        var node = doc.createElement(tag);
        return fromDom(node);
      };
      var fromText = function (text, scope) {
        var doc = scope || document;
        var node = doc.createTextNode(text);
        return fromDom(node);
      };
      var fromDom = function (node) {
        if (node === null || node === undefined)
          throw new Error('Node cannot be null or undefined');
        return { dom: $_eqpqvr6jh8lyw3s.constant(node) };
      };
      var fromPoint = function (doc, x, y) {
        return Option.from(doc.dom().elementFromPoint(x, y)).map(fromDom);
      };
      var $_cgttw3zjh8lywdq = {
        fromHtml: fromHtml,
        fromTag: fromTag,
        fromText: fromText,
        fromDom: fromDom,
        fromPoint: fromPoint
      };

      var $_2ctxk11jh8lywdy = {
        ATTRIBUTE: 2,
        CDATA_SECTION: 4,
        COMMENT: 8,
        DOCUMENT: 9,
        DOCUMENT_TYPE: 10,
        DOCUMENT_FRAGMENT: 11,
        ELEMENT: 1,
        TEXT: 3,
        PROCESSING_INSTRUCTION: 7,
        ENTITY_REFERENCE: 5,
        ENTITY: 6,
        NOTATION: 12
      };

      var name$1 = function (element) {
        var r = element.dom().nodeName;
        return r.toLowerCase();
      };
      var type = function (element) {
        return element.dom().nodeType;
      };
      var value = function (element) {
        return element.dom().nodeValue;
      };
      var isType$1 = function (t) {
        return function (element) {
          return type(element) === t;
        };
      };
      var isComment = function (element) {
        return type(element) === $_2ctxk11jh8lywdy.COMMENT || name$1(element) === '#comment';
      };
      var isElement = isType$1($_2ctxk11jh8lywdy.ELEMENT);
      var isText = isType$1($_2ctxk11jh8lywdy.TEXT);
      var isDocument = isType$1($_2ctxk11jh8lywdy.DOCUMENT);
      var $_7j1jt210jh8lywdx = {
        name: name$1,
        type: type,
        value: value,
        isElement: isElement,
        isText: isText,
        isDocument: isDocument,
        isComment: isComment
      };

      var keys = function () {
        var fastKeys = Object.keys;
        var slowKeys = function (o) {
          var r = [];
          for (var i in o) {
            if (o.hasOwnProperty(i)) {
              r.push(i);
            }
          }
          return r;
        };
        return fastKeys === undefined ? slowKeys : fastKeys;
      }();
      var each$3 = function (obj, f) {
        var props = keys(obj);
        for (var k = 0, len = props.length; k < len; k++) {
          var i = props[k];
          var x = obj[i];
          f(x, i, obj);
        }
      };
      var objectMap = function (obj, f) {
        return tupleMap(obj, function (x, i, obj) {
          return {
            k: i,
            v: f(x, i, obj)
          };
        });
      };
      var tupleMap = function (obj, f) {
        var r = {};
        each$3(obj, function (x, i) {
          var tuple = f(x, i, obj);
          r[tuple.k] = tuple.v;
        });
        return r;
      };
      var bifilter = function (obj, pred) {
        var t = {};
        var f = {};
        each$3(obj, function (x, i) {
          var branch = pred(x, i) ? t : f;
          branch[i] = x;
        });
        return {
          t: t,
          f: f
        };
      };
      var mapToArray = function (obj, f) {
        var r = [];
        each$3(obj, function (value, name) {
          r.push(f(value, name));
        });
        return r;
      };
      var find$3 = function (obj, pred) {
        var props = keys(obj);
        for (var k = 0, len = props.length; k < len; k++) {
          var i = props[k];
          var x = obj[i];
          if (pred(x, i, obj)) {
            return Option.some(x);
          }
        }
        return Option.none();
      };
      var values = function (obj) {
        return mapToArray(obj, function (v) {
          return v;
        });
      };
      var size = function (obj) {
        return values(obj).length;
      };
      var $_g63v2c13jh8lywej = {
        bifilter: bifilter,
        each: each$3,
        map: objectMap,
        mapToArray: mapToArray,
        tupleMap: tupleMap,
        find: find$3,
        keys: keys,
        values: values,
        size: size
      };

      var rawSet = function (dom, key, value) {
        if ($_dp4g6d7jh8lyw3y.isString(value) || $_dp4g6d7jh8lyw3y.isBoolean(value) || $_dp4g6d7jh8lyw3y.isNumber(value)) {
          dom.setAttribute(key, value + '');
        } else {
          console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
          throw new Error('Attribute value was not simple');
        }
      };
      var set = function (element, key, value) {
        rawSet(element.dom(), key, value);
      };
      var setAll = function (element, attrs) {
        var dom = element.dom();
        $_g63v2c13jh8lywej.each(attrs, function (v, k) {
          rawSet(dom, k, v);
        });
      };
      var get = function (element, key) {
        var v = element.dom().getAttribute(key);
        return v === null ? undefined : v;
      };
      var has = function (element, key) {
        var dom = element.dom();
        return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
      };
      var remove = function (element, key) {
        element.dom().removeAttribute(key);
      };
      var hasNone = function (element) {
        var attrs = element.dom().attributes;
        return attrs === undefined || attrs === null || attrs.length === 0;
      };
      var clone = function (element) {
        return $_5wjzy24jh8lyw2t.foldl(element.dom().attributes, function (acc, attr) {
          acc[attr.name] = attr.value;
          return acc;
        }, {});
      };
      var transferOne = function (source, destination, attr) {
        if (has(source, attr) && !has(destination, attr))
          set(destination, attr, get(source, attr));
      };
      var transfer = function (source, destination, attrs) {
        if (!$_7j1jt210jh8lywdx.isElement(source) || !$_7j1jt210jh8lywdx.isElement(destination))
          return;
        $_5wjzy24jh8lyw2t.each(attrs, function (attr) {
          transferOne(source, destination, attr);
        });
      };
      var $_3da62i14jh8lyweo = {
        clone: clone,
        set: set,
        setAll: setAll,
        get: get,
        has: has,
        remove: remove,
        hasNone: hasNone,
        transfer: transfer
      };

      var inBody = function (element) {
        var dom = $_7j1jt210jh8lywdx.isText(element) ? element.dom().parentNode : element.dom();
        return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
      };
      var body = $_bbi2igojh8lywc9.cached(function () {
        return getBody($_cgttw3zjh8lywdq.fromDom(document));
      });
      var getBody = function (doc) {
        var body = doc.dom().body;
        if (body === null || body === undefined)
          throw 'Body is not available yet';
        return $_cgttw3zjh8lywdq.fromDom(body);
      };
      var $_boa99a15jh8lywey = {
        body: body,
        getBody: getBody,
        inBody: inBody
      };

      var isSupported = function (dom) {
        return dom.style !== undefined;
      };
      var $_fjd24o16jh8lywfc = { isSupported: isSupported };

      var internalSet = function (dom, property, value) {
        if (!$_dp4g6d7jh8lyw3y.isString(value)) {
          console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
          throw new Error('CSS value must be a string: ' + value);
        }
        if ($_fjd24o16jh8lywfc.isSupported(dom))
          dom.style.setProperty(property, value);
      };
      var internalRemove = function (dom, property) {
        if ($_fjd24o16jh8lywfc.isSupported(dom))
          dom.style.removeProperty(property);
      };
      var set$1 = function (element, property, value) {
        var dom = element.dom();
        internalSet(dom, property, value);
      };
      var setAll$1 = function (element, css) {
        var dom = element.dom();
        $_g63v2c13jh8lywej.each(css, function (v, k) {
          internalSet(dom, k, v);
        });
      };
      var setOptions = function (element, css) {
        var dom = element.dom();
        $_g63v2c13jh8lywej.each(css, function (v, k) {
          v.fold(function () {
            internalRemove(dom, k);
          }, function (value) {
            internalSet(dom, k, value);
          });
        });
      };
      var get$1 = function (element, property) {
        var dom = element.dom();
        var styles = window.getComputedStyle(dom);
        var r = styles.getPropertyValue(property);
        var v = r === '' && !$_boa99a15jh8lywey.inBody(element) ? getUnsafeProperty(dom, property) : r;
        return v === null ? undefined : v;
      };
      var getUnsafeProperty = function (dom, property) {
        return $_fjd24o16jh8lywfc.isSupported(dom) ? dom.style.getPropertyValue(property) : '';
      };
      var getRaw = function (element, property) {
        var dom = element.dom();
        var raw = getUnsafeProperty(dom, property);
        return Option.from(raw).filter(function (r) {
          return r.length > 0;
        });
      };
      var getAllRaw = function (element) {
        var css = {};
        var dom = element.dom();
        if ($_fjd24o16jh8lywfc.isSupported(dom)) {
          for (var i = 0; i < dom.style.length; i++) {
            var ruleName = dom.style.item(i);
            css[ruleName] = dom.style[ruleName];
          }
        }
        return css;
      };
      var isValidValue = function (tag, property, value) {
        var element = $_cgttw3zjh8lywdq.fromTag(tag);
        set$1(element, property, value);
        var style = getRaw(element, property);
        return style.isSome();
      };
      var remove$1 = function (element, property) {
        var dom = element.dom();
        internalRemove(dom, property);
        if ($_3da62i14jh8lyweo.has(element, 'style') && $_4w196awjh8lywdj.trim($_3da62i14jh8lyweo.get(element, 'style')) === '') {
          $_3da62i14jh8lyweo.remove(element, 'style');
        }
      };
      var preserve = function (element, f) {
        var oldStyles = $_3da62i14jh8lyweo.get(element, 'style');
        var result = f(element);
        var restore = oldStyles === undefined ? $_3da62i14jh8lyweo.remove : $_3da62i14jh8lyweo.set;
        restore(element, 'style', oldStyles);
        return result;
      };
      var copy = function (source, target) {
        var sourceDom = source.dom();
        var targetDom = target.dom();
        if ($_fjd24o16jh8lywfc.isSupported(sourceDom) && $_fjd24o16jh8lywfc.isSupported(targetDom)) {
          targetDom.style.cssText = sourceDom.style.cssText;
        }
      };
      var reflow = function (e) {
        return e.dom().offsetWidth;
      };
      var transferOne$1 = function (source, destination, style) {
        getRaw(source, style).each(function (value) {
          if (getRaw(destination, style).isNone())
            set$1(destination, style, value);
        });
      };
      var transfer$1 = function (source, destination, styles) {
        if (!$_7j1jt210jh8lywdx.isElement(source) || !$_7j1jt210jh8lywdx.isElement(destination))
          return;
        $_5wjzy24jh8lyw2t.each(styles, function (style) {
          transferOne$1(source, destination, style);
        });
      };
      var $_36knnd12jh8lywe1 = {
        copy: copy,
        set: set$1,
        preserve: preserve,
        setAll: setAll$1,
        setOptions: setOptions,
        remove: remove$1,
        get: get$1,
        getRaw: getRaw,
        getAllRaw: getAllRaw,
        isValidValue: isValidValue,
        reflow: reflow,
        transfer: transfer$1
      };

      function Immutable () {
        var fields = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          fields[_i] = arguments[_i];
        }
        return function () {
          var values = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
          }
          if (fields.length !== values.length) {
            throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
          }
          var struct = {};
          $_5wjzy24jh8lyw2t.each(fields, function (name, i) {
            struct[name] = $_eqpqvr6jh8lyw3s.constant(values[i]);
          });
          return struct;
        };
      }

      var sort$1 = function (arr) {
        return arr.slice(0).sort();
      };
      var reqMessage = function (required, keys) {
        throw new Error('All required keys (' + sort$1(required).join(', ') + ') were not specified. Specified keys were: ' + sort$1(keys).join(', ') + '.');
      };
      var unsuppMessage = function (unsupported) {
        throw new Error('Unsupported keys for object: ' + sort$1(unsupported).join(', '));
      };
      var validateStrArr = function (label, array) {
        if (!$_dp4g6d7jh8lyw3y.isArray(array))
          throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
        $_5wjzy24jh8lyw2t.each(array, function (a) {
          if (!$_dp4g6d7jh8lyw3y.isString(a))
            throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
        });
      };
      var invalidTypeMessage = function (incorrect, type) {
        throw new Error('All values need to be of type: ' + type + '. Keys (' + sort$1(incorrect).join(', ') + ') were not.');
      };
      var checkDupes = function (everything) {
        var sorted = sort$1(everything);
        var dupe = $_5wjzy24jh8lyw2t.find(sorted, function (s, i) {
          return i < sorted.length - 1 && s === sorted[i + 1];
        });
        dupe.each(function (d) {
          throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
        });
      };
      var $_8ab5mm1bjh8lywg2 = {
        sort: sort$1,
        reqMessage: reqMessage,
        unsuppMessage: unsuppMessage,
        validateStrArr: validateStrArr,
        invalidTypeMessage: invalidTypeMessage,
        checkDupes: checkDupes
      };

      function MixedBag (required, optional) {
        var everything = required.concat(optional);
        if (everything.length === 0)
          throw new Error('You must specify at least one required or optional field.');
        $_8ab5mm1bjh8lywg2.validateStrArr('required', required);
        $_8ab5mm1bjh8lywg2.validateStrArr('optional', optional);
        $_8ab5mm1bjh8lywg2.checkDupes(everything);
        return function (obj) {
          var keys = $_g63v2c13jh8lywej.keys(obj);
          var allReqd = $_5wjzy24jh8lyw2t.forall(required, function (req) {
            return $_5wjzy24jh8lyw2t.contains(keys, req);
          });
          if (!allReqd)
            $_8ab5mm1bjh8lywg2.reqMessage(required, keys);
          var unsupported = $_5wjzy24jh8lyw2t.filter(keys, function (key) {
            return !$_5wjzy24jh8lyw2t.contains(everything, key);
          });
          if (unsupported.length > 0)
            $_8ab5mm1bjh8lywg2.unsuppMessage(unsupported);
          var r = {};
          $_5wjzy24jh8lyw2t.each(required, function (req) {
            r[req] = $_eqpqvr6jh8lyw3s.constant(obj[req]);
          });
          $_5wjzy24jh8lyw2t.each(optional, function (opt) {
            r[opt] = $_eqpqvr6jh8lyw3s.constant(Object.prototype.hasOwnProperty.call(obj, opt) ? Option.some(obj[opt]) : Option.none());
          });
          return r;
        };
      }

      var $_4jz0ce18jh8lywft = {
        immutable: Immutable,
        immutableBag: MixedBag
      };

      var toArray$1 = function (target, f) {
        var r = [];
        var recurse = function (e) {
          r.push(e);
          return f(e);
        };
        var cur = f(target);
        do {
          cur = cur.bind(recurse);
        } while (cur.isSome());
        return r;
      };
      var $_42xx4d1cjh8lywg4 = { toArray: toArray$1 };

      var node = function () {
        var f = $_99xmy7cjh8lyw6k.getOrDie('Node');
        return f;
      };
      var compareDocumentPosition = function (a, b, match) {
        return (a.compareDocumentPosition(b) & match) !== 0;
      };
      var documentPositionPreceding = function (a, b) {
        return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
      };
      var documentPositionContainedBy = function (a, b) {
        return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
      };
      var $_1zkvjk1ejh8lywgg = {
        documentPositionPreceding: documentPositionPreceding,
        documentPositionContainedBy: documentPositionContainedBy
      };

      var ELEMENT = $_2ctxk11jh8lywdy.ELEMENT;
      var DOCUMENT = $_2ctxk11jh8lywdy.DOCUMENT;
      var is$1 = function (element, selector) {
        var elem = element.dom();
        if (elem.nodeType !== ELEMENT)
          return false;
        else if (elem.matches !== undefined)
          return elem.matches(selector);
        else if (elem.msMatchesSelector !== undefined)
          return elem.msMatchesSelector(selector);
        else if (elem.webkitMatchesSelector !== undefined)
          return elem.webkitMatchesSelector(selector);
        else if (elem.mozMatchesSelector !== undefined)
          return elem.mozMatchesSelector(selector);
        else
          throw new Error('Browser lacks native selectors');
      };
      var bypassSelector = function (dom) {
        return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT || dom.childElementCount === 0;
      };
      var all = function (selector, scope) {
        var base = scope === undefined ? document : scope.dom();
        return bypassSelector(base) ? [] : $_5wjzy24jh8lyw2t.map(base.querySelectorAll(selector), $_cgttw3zjh8lywdq.fromDom);
      };
      var one = function (selector, scope) {
        var base = scope === undefined ? document : scope.dom();
        return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map($_cgttw3zjh8lywdq.fromDom);
      };
      var $_5h4ipt1fjh8lywgi = {
        all: all,
        is: is$1,
        one: one
      };

      var eq = function (e1, e2) {
        return e1.dom() === e2.dom();
      };
      var isEqualNode = function (e1, e2) {
        return e1.dom().isEqualNode(e2.dom());
      };
      var member = function (element, elements) {
        return $_5wjzy24jh8lyw2t.exists(elements, $_eqpqvr6jh8lyw3s.curry(eq, element));
      };
      var regularContains = function (e1, e2) {
        var d1 = e1.dom(), d2 = e2.dom();
        return d1 === d2 ? false : d1.contains(d2);
      };
      var ieContains = function (e1, e2) {
        return $_1zkvjk1ejh8lywgg.documentPositionContainedBy(e1.dom(), e2.dom());
      };
      var browser = $_9hkktfnjh8lywc6.detect().browser;
      var contains$3 = browser.isIE() ? ieContains : regularContains;
      var $_5f6gpb1djh8lywg5 = {
        eq: eq,
        isEqualNode: isEqualNode,
        member: member,
        contains: contains$3,
        is: $_5h4ipt1fjh8lywgi.is
      };

      var owner = function (element) {
        return $_cgttw3zjh8lywdq.fromDom(element.dom().ownerDocument);
      };
      var documentElement = function (element) {
        var doc = owner(element);
        return $_cgttw3zjh8lywdq.fromDom(doc.dom().documentElement);
      };
      var defaultView = function (element) {
        var el = element.dom();
        var defaultView = el.ownerDocument.defaultView;
        return $_cgttw3zjh8lywdq.fromDom(defaultView);
      };
      var parent = function (element) {
        var dom = element.dom();
        return Option.from(dom.parentNode).map($_cgttw3zjh8lywdq.fromDom);
      };
      var findIndex$2 = function (element) {
        return parent(element).bind(function (p) {
          var kin = children(p);
          return $_5wjzy24jh8lyw2t.findIndex(kin, function (elem) {
            return $_5f6gpb1djh8lywg5.eq(element, elem);
          });
        });
      };
      var parents = function (element, isRoot) {
        var stop = $_dp4g6d7jh8lyw3y.isFunction(isRoot) ? isRoot : $_eqpqvr6jh8lyw3s.constant(false);
        var dom = element.dom();
        var ret = [];
        while (dom.parentNode !== null && dom.parentNode !== undefined) {
          var rawParent = dom.parentNode;
          var parent = $_cgttw3zjh8lywdq.fromDom(rawParent);
          ret.push(parent);
          if (stop(parent) === true)
            break;
          else
            dom = rawParent;
        }
        return ret;
      };
      var siblings = function (element) {
        var filterSelf = function (elements) {
          return $_5wjzy24jh8lyw2t.filter(elements, function (x) {
            return !$_5f6gpb1djh8lywg5.eq(element, x);
          });
        };
        return parent(element).map(children).map(filterSelf).getOr([]);
      };
      var offsetParent = function (element) {
        var dom = element.dom();
        return Option.from(dom.offsetParent).map($_cgttw3zjh8lywdq.fromDom);
      };
      var prevSibling = function (element) {
        var dom = element.dom();
        return Option.from(dom.previousSibling).map($_cgttw3zjh8lywdq.fromDom);
      };
      var nextSibling = function (element) {
        var dom = element.dom();
        return Option.from(dom.nextSibling).map($_cgttw3zjh8lywdq.fromDom);
      };
      var prevSiblings = function (element) {
        return $_5wjzy24jh8lyw2t.reverse($_42xx4d1cjh8lywg4.toArray(element, prevSibling));
      };
      var nextSiblings = function (element) {
        return $_42xx4d1cjh8lywg4.toArray(element, nextSibling);
      };
      var children = function (element) {
        var dom = element.dom();
        return $_5wjzy24jh8lyw2t.map(dom.childNodes, $_cgttw3zjh8lywdq.fromDom);
      };
      var child = function (element, index) {
        var children = element.dom().childNodes;
        return Option.from(children[index]).map($_cgttw3zjh8lywdq.fromDom);
      };
      var firstChild = function (element) {
        return child(element, 0);
      };
      var lastChild = function (element) {
        return child(element, element.dom().childNodes.length - 1);
      };
      var childNodesCount = function (element) {
        return element.dom().childNodes.length;
      };
      var hasChildNodes = function (element) {
        return element.dom().hasChildNodes();
      };
      var spot = $_4jz0ce18jh8lywft.immutable('element', 'offset');
      var leaf = function (element, offset) {
        var cs = children(element);
        return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
      };
      var $_a43q0i17jh8lywfe = {
        owner: owner,
        defaultView: defaultView,
        documentElement: documentElement,
        parent: parent,
        findIndex: findIndex$2,
        parents: parents,
        siblings: siblings,
        prevSibling: prevSibling,
        offsetParent: offsetParent,
        prevSiblings: prevSiblings,
        nextSibling: nextSibling,
        nextSiblings: nextSiblings,
        children: children,
        child: child,
        firstChild: firstChild,
        lastChild: lastChild,
        childNodesCount: childNodesCount,
        hasChildNodes: hasChildNodes,
        leaf: leaf
      };

      var browser$1 = $_9hkktfnjh8lywc6.detect().browser;
      var firstElement = function (nodes) {
        return $_5wjzy24jh8lyw2t.find(nodes, $_7j1jt210jh8lywdx.isElement);
      };
      var getTableCaptionDeltaY = function (elm) {
        if (browser$1.isFirefox() && $_7j1jt210jh8lywdx.name(elm) === 'table') {
          return firstElement($_a43q0i17jh8lywfe.children(elm)).filter(function (elm) {
            return $_7j1jt210jh8lywdx.name(elm) === 'caption';
          }).bind(function (caption) {
            return firstElement($_a43q0i17jh8lywfe.nextSiblings(caption)).map(function (body) {
              var bodyTop = body.dom().offsetTop;
              var captionTop = caption.dom().offsetTop;
              var captionHeight = caption.dom().offsetHeight;
              return bodyTop <= captionTop ? -captionHeight : 0;
            });
          }).getOr(0);
        } else {
          return 0;
        }
      };
      var getPos = function (body, elm, rootElm) {
        var x = 0, y = 0, offsetParent;
        var doc = body.ownerDocument;
        var pos;
        rootElm = rootElm ? rootElm : body;
        if (elm) {
          if (rootElm === body && elm.getBoundingClientRect && $_36knnd12jh8lywe1.get($_cgttw3zjh8lywdq.fromDom(body), 'position') === 'static') {
            pos = elm.getBoundingClientRect();
            x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
            y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
            return {
              x: x,
              y: y
            };
          }
          offsetParent = elm;
          while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
            x += offsetParent.offsetLeft || 0;
            y += offsetParent.offsetTop || 0;
            offsetParent = offsetParent.offsetParent;
          }
          offsetParent = elm.parentNode;
          while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
            x -= offsetParent.scrollLeft || 0;
            y -= offsetParent.scrollTop || 0;
            offsetParent = offsetParent.parentNode;
          }
          y += getTableCaptionDeltaY($_cgttw3zjh8lywdq.fromDom(elm));
        }
        return {
          x: x,
          y: y
        };
      };
      var $_6pe7rlmjh8lywbu = { getPos: getPos };

      var nu$3 = function (baseFn) {
        var data = Option.none();
        var callbacks = [];
        var map = function (f) {
          return nu$3(function (nCallback) {
            get(function (data) {
              nCallback(f(data));
            });
          });
        };
        var get = function (nCallback) {
          if (isReady())
            call(nCallback);
          else
            callbacks.push(nCallback);
        };
        var set = function (x) {
          data = Option.some(x);
          run(callbacks);
          callbacks = [];
        };
        var isReady = function () {
          return data.isSome();
        };
        var run = function (cbs) {
          $_5wjzy24jh8lyw2t.each(cbs, call);
        };
        var call = function (cb) {
          data.each(function (x) {
            setTimeout(function () {
              cb(x);
            }, 0);
          });
        };
        baseFn(set);
        return {
          get: get,
          map: map,
          isReady: isReady
        };
      };
      var pure$1 = function (a) {
        return nu$3(function (callback) {
          callback(a);
        });
      };
      var LazyValue = {
        nu: nu$3,
        pure: pure$1
      };

      var bounce = function (f) {
        return function () {
          var args = Array.prototype.slice.call(arguments);
          var me = this;
          setTimeout(function () {
            f.apply(me, args);
          }, 0);
        };
      };
      var $_fhsj121jjh8lywh5 = { bounce: bounce };

      var nu$4 = function (baseFn) {
        var get = function (callback) {
          baseFn($_fhsj121jjh8lywh5.bounce(callback));
        };
        var map = function (fab) {
          return nu$4(function (callback) {
            get(function (a) {
              var value = fab(a);
              callback(value);
            });
          });
        };
        var bind = function (aFutureB) {
          return nu$4(function (callback) {
            get(function (a) {
              aFutureB(a).get(callback);
            });
          });
        };
        var anonBind = function (futureB) {
          return nu$4(function (callback) {
            get(function (a) {
              futureB.get(callback);
            });
          });
        };
        var toLazy = function () {
          return LazyValue.nu(get);
        };
        return {
          map: map,
          bind: bind,
          anonBind: anonBind,
          toLazy: toLazy,
          get: get
        };
      };
      var pure$2 = function (a) {
        return nu$4(function (callback) {
          callback(a);
        });
      };
      var Future = {
        nu: nu$4,
        pure: pure$2
      };

      var par = function (asyncValues, nu) {
        return nu(function (callback) {
          var r = [];
          var count = 0;
          var cb = function (i) {
            return function (value) {
              r[i] = value;
              count++;
              if (count >= asyncValues.length) {
                callback(r);
              }
            };
          };
          if (asyncValues.length === 0) {
            callback([]);
          } else {
            $_5wjzy24jh8lyw2t.each(asyncValues, function (asyncValue, i) {
              asyncValue.get(cb(i));
            });
          }
        });
      };
      var $_8nbwrm1ljh8lywh8 = { par: par };

      var par$1 = function (futures) {
        return $_8nbwrm1ljh8lywh8.par(futures, Future.nu);
      };
      var mapM = function (array, fn) {
        var futures = $_5wjzy24jh8lyw2t.map(array, fn);
        return par$1(futures);
      };
      var compose$1 = function (f, g) {
        return function (a) {
          return g(a).bind(f);
        };
      };
      var $_5lpsz51kjh8lywh6 = {
        par: par$1,
        mapM: mapM,
        compose: compose$1
      };

      var value$1 = function (o) {
        var is = function (v) {
          return o === v;
        };
        var or = function (opt) {
          return value$1(o);
        };
        var orThunk = function (f) {
          return value$1(o);
        };
        var map = function (f) {
          return value$1(f(o));
        };
        var each = function (f) {
          f(o);
        };
        var bind = function (f) {
          return f(o);
        };
        var fold = function (_, onValue) {
          return onValue(o);
        };
        var exists = function (f) {
          return f(o);
        };
        var forall = function (f) {
          return f(o);
        };
        var toOption = function () {
          return Option.some(o);
        };
        return {
          is: is,
          isValue: $_eqpqvr6jh8lyw3s.always,
          isError: $_eqpqvr6jh8lyw3s.never,
          getOr: $_eqpqvr6jh8lyw3s.constant(o),
          getOrThunk: $_eqpqvr6jh8lyw3s.constant(o),
          getOrDie: $_eqpqvr6jh8lyw3s.constant(o),
          or: or,
          orThunk: orThunk,
          fold: fold,
          map: map,
          each: each,
          bind: bind,
          exists: exists,
          forall: forall,
          toOption: toOption
        };
      };
      var error = function (message) {
        var getOrThunk = function (f) {
          return f();
        };
        var getOrDie = function () {
          return $_eqpqvr6jh8lyw3s.die(String(message))();
        };
        var or = function (opt) {
          return opt;
        };
        var orThunk = function (f) {
          return f();
        };
        var map = function (f) {
          return error(message);
        };
        var bind = function (f) {
          return error(message);
        };
        var fold = function (onError, _) {
          return onError(message);
        };
        return {
          is: $_eqpqvr6jh8lyw3s.never,
          isValue: $_eqpqvr6jh8lyw3s.never,
          isError: $_eqpqvr6jh8lyw3s.always,
          getOr: $_eqpqvr6jh8lyw3s.identity,
          getOrThunk: getOrThunk,
          getOrDie: getOrDie,
          or: or,
          orThunk: orThunk,
          fold: fold,
          map: map,
          each: $_eqpqvr6jh8lyw3s.noop,
          bind: bind,
          exists: $_eqpqvr6jh8lyw3s.never,
          forall: $_eqpqvr6jh8lyw3s.always,
          toOption: Option.none
        };
      };
      var Result = {
        value: value$1,
        error: error
      };

      function StyleSheetLoader(document, settings) {
        var idCount = 0;
        var loadedStates = {};
        var maxLoadTime;
        settings = settings || {};
        maxLoadTime = settings.maxLoadTime || 5000;
        var appendToHead = function (node) {
          document.getElementsByTagName('head')[0].appendChild(node);
        };
        var load = function (url, loadedCallback, errorCallback) {
          var link, style, startTime, state;
          var passed = function () {
            var callbacks = state.passed;
            var i = callbacks.length;
            while (i--) {
              callbacks[i]();
            }
            state.status = 2;
            state.passed = [];
            state.failed = [];
          };
          var failed = function () {
            var callbacks = state.failed;
            var i = callbacks.length;
            while (i--) {
              callbacks[i]();
            }
            state.status = 3;
            state.passed = [];
            state.failed = [];
          };
          var isOldWebKit = function () {
            var webKitChunks = navigator.userAgent.match(/WebKit\/(\d*)/);
            return !!(webKitChunks && parseInt(webKitChunks[1], 10) < 536);
          };
          var wait = function (testCallback, waitCallback) {
            if (!testCallback()) {
              if (new Date().getTime() - startTime < maxLoadTime) {
                $_8sy3pfhjh8lyw95.setTimeout(waitCallback);
              } else {
                failed();
              }
            }
          };
          var waitForWebKitLinkLoaded = function () {
            wait(function () {
              var styleSheets = document.styleSheets;
              var styleSheet, i = styleSheets.length, owner;
              while (i--) {
                styleSheet = styleSheets[i];
                owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
                if (owner && owner.id === link.id) {
                  passed();
                  return true;
                }
              }
            }, waitForWebKitLinkLoaded);
          };
          var waitForGeckoLinkLoaded = function () {
            wait(function () {
              try {
                var cssRules = style.sheet.cssRules;
                passed();
                return !!cssRules;
              } catch (ex) {
              }
            }, waitForGeckoLinkLoaded);
          };
          url = $_ahowuxkjh8lywbj._addCacheSuffix(url);
          if (!loadedStates[url]) {
            state = {
              passed: [],
              failed: []
            };
            loadedStates[url] = state;
          } else {
            state = loadedStates[url];
          }
          if (loadedCallback) {
            state.passed.push(loadedCallback);
          }
          if (errorCallback) {
            state.failed.push(errorCallback);
          }
          if (state.status === 1) {
            return;
          }
          if (state.status === 2) {
            passed();
            return;
          }
          if (state.status === 3) {
            failed();
            return;
          }
          state.status = 1;
          link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.id = 'u' + idCount++;
          link.async = false;
          link.defer = false;
          startTime = new Date().getTime();
          if ('onload' in link && !isOldWebKit()) {
            link.onload = waitForWebKitLinkLoaded;
            link.onerror = failed;
          } else {
            if (navigator.userAgent.indexOf('Firefox') > 0) {
              style = document.createElement('style');
              style.textContent = '@import "' + url + '"';
              waitForGeckoLinkLoaded();
              appendToHead(style);
              return;
            }
            waitForWebKitLinkLoaded();
          }
          appendToHead(link);
          link.href = url;
        };
        var loadF = function (url) {
          return Future.nu(function (resolve) {
            load(url, $_eqpqvr6jh8lyw3s.compose(resolve, $_eqpqvr6jh8lyw3s.constant(Result.value(url))), $_eqpqvr6jh8lyw3s.compose(resolve, $_eqpqvr6jh8lyw3s.constant(Result.error(url))));
          });
        };
        var unbox = function (result) {
          return result.fold($_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity);
        };
        var loadAll = function (urls, success, failure) {
          $_5lpsz51kjh8lywh6.par($_5wjzy24jh8lyw2t.map(urls, loadF)).get(function (result) {
            var parts = $_5wjzy24jh8lyw2t.partition(result, function (r) {
              return r.isValue();
            });
            if (parts.fail.length > 0) {
              failure(parts.fail.map(unbox));
            } else {
              success(parts.pass.map(unbox));
            }
          });
        };
        return {
          load: load,
          loadAll: loadAll
        };
      }

      function TreeWalker (startNode, rootNode) {
        var node = startNode;
        var findSibling = function (node, startName, siblingName, shallow) {
          var sibling, parent;
          if (node) {
            if (!shallow && node[startName]) {
              return node[startName];
            }
            if (node !== rootNode) {
              sibling = node[siblingName];
              if (sibling) {
                return sibling;
              }
              for (parent = node.parentNode; parent && parent !== rootNode; parent = parent.parentNode) {
                sibling = parent[siblingName];
                if (sibling) {
                  return sibling;
                }
              }
            }
          }
        };
        var findPreviousNode = function (node, startName, siblingName, shallow) {
          var sibling, parent, child;
          if (node) {
            sibling = node[siblingName];
            if (rootNode && sibling === rootNode) {
              return;
            }
            if (sibling) {
              if (!shallow) {
                for (child = sibling[startName]; child; child = child[startName]) {
                  if (!child[startName]) {
                    return child;
                  }
                }
              }
              return sibling;
            }
            parent = node.parentNode;
            if (parent && parent !== rootNode) {
              return parent;
            }
          }
        };
        this.current = function () {
          return node;
        };
        this.next = function (shallow) {
          node = findSibling(node, 'firstChild', 'nextSibling', shallow);
          return node;
        };
        this.prev = function (shallow) {
          node = findSibling(node, 'lastChild', 'previousSibling', shallow);
          return node;
        };
        this.prev2 = function (shallow) {
          node = findPreviousNode(node, 'lastChild', 'previousSibling', shallow);
          return node;
        };
      }

      var blocks = [
        'article',
        'aside',
        'details',
        'div',
        'dt',
        'figcaption',
        'footer',
        'form',
        'fieldset',
        'header',
        'hgroup',
        'html',
        'main',
        'nav',
        'section',
        'summary',
        'body',
        'p',
        'dl',
        'multicol',
        'dd',
        'figure',
        'address',
        'center',
        'blockquote',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'listing',
        'xmp',
        'pre',
        'plaintext',
        'menu',
        'dir',
        'ul',
        'ol',
        'li',
        'hr',
        'table',
        'tbody',
        'thead',
        'tfoot',
        'th',
        'tr',
        'td',
        'caption'
      ];
      var voids = [
        'area',
        'base',
        'basefont',
        'br',
        'col',
        'frame',
        'hr',
        'img',
        'input',
        'isindex',
        'link',
        'meta',
        'param',
        'embed',
        'source',
        'wbr',
        'track'
      ];
      var tableCells = [
        'td',
        'th'
      ];
      var tableSections = [
        'thead',
        'tbody',
        'tfoot'
      ];
      var textBlocks = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p',
        'div',
        'address',
        'pre',
        'form',
        'blockquote',
        'center',
        'dir',
        'fieldset',
        'header',
        'footer',
        'article',
        'section',
        'hgroup',
        'aside',
        'nav',
        'figure'
      ];
      var headings = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
      ];
      var listItems = [
        'li',
        'dd',
        'dt'
      ];
      var lists = [
        'ul',
        'ol',
        'dl'
      ];
      var wsElements = [
        'pre',
        'script',
        'textarea',
        'style'
      ];
      var lazyLookup = function (items) {
        var lookup;
        return function (node) {
          lookup = lookup ? lookup : $_5wjzy24jh8lyw2t.mapToObject(items, $_eqpqvr6jh8lyw3s.constant(true));
          return lookup.hasOwnProperty($_7j1jt210jh8lywdx.name(node));
        };
      };
      var isHeading = lazyLookup(headings);
      var isBlock = lazyLookup(blocks);
      var isInline = function (node) {
        return $_7j1jt210jh8lywdx.isElement(node) && !isBlock(node);
      };
      var isBr = function (node) {
        return $_7j1jt210jh8lywdx.isElement(node) && $_7j1jt210jh8lywdx.name(node) === 'br';
      };
      var isTextBlock = lazyLookup(textBlocks);
      var isList = lazyLookup(lists);
      var isListItem = lazyLookup(listItems);
      var isVoid = lazyLookup(voids);
      var isTableSection = lazyLookup(tableSections);
      var isTableCell = lazyLookup(tableCells);
      var isWsPreserveElement = lazyLookup(wsElements);

      var isNodeType = function (type) {
        return function (node) {
          return !!node && node.nodeType === type;
        };
      };
      var isElement$1 = isNodeType(1);
      var matchNodeNames = function (names) {
        var items = names.toLowerCase().split(' ');
        return function (node) {
          var i, name;
          if (node && node.nodeType) {
            name = node.nodeName.toLowerCase();
            for (i = 0; i < items.length; i++) {
              if (name === items[i]) {
                return true;
              }
            }
          }
          return false;
        };
      };
      var matchStyleValues = function (name, values) {
        var items = values.toLowerCase().split(' ');
        return function (node) {
          var i, cssValue;
          if (isElement$1(node)) {
            for (i = 0; i < items.length; i++) {
              var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
              cssValue = computed ? computed.getPropertyValue(name) : null;
              if (cssValue === items[i]) {
                return true;
              }
            }
          }
          return false;
        };
      };
      var hasPropValue = function (propName, propValue) {
        return function (node) {
          return isElement$1(node) && node[propName] === propValue;
        };
      };
      var hasAttribute = function (attrName, attrValue) {
        return function (node) {
          return isElement$1(node) && node.hasAttribute(attrName);
        };
      };
      var hasAttributeValue = function (attrName, attrValue) {
        return function (node) {
          return isElement$1(node) && node.getAttribute(attrName) === attrValue;
        };
      };
      var isBogus = function (node) {
        return isElement$1(node) && node.hasAttribute('data-mce-bogus');
      };
      var isBogusAll = function (node) {
        return isElement$1(node) && node.getAttribute('data-mce-bogus') === 'all';
      };
      var isTable = function (node) {
        return isElement$1(node) && node.tagName === 'TABLE';
      };
      var hasContentEditableState = function (value) {
        return function (node) {
          if (isElement$1(node)) {
            if (node.contentEditable === value) {
              return true;
            }
            if (node.getAttribute('data-mce-contenteditable') === value) {
              return true;
            }
          }
          return false;
        };
      };
      var isText$1 = isNodeType(3);
      var isComment$1 = isNodeType(8);
      var isDocument$1 = isNodeType(9);
      var isBr$1 = matchNodeNames('br');
      var isContentEditableTrue = hasContentEditableState('true');
      var isContentEditableFalse = hasContentEditableState('false');
      var $_5oonaz1qjh8lywhz = {
        isText: isText$1,
        isElement: isElement$1,
        isComment: isComment$1,
        isDocument: isDocument$1,
        isBr: isBr$1,
        isContentEditableTrue: isContentEditableTrue,
        isContentEditableFalse: isContentEditableFalse,
        matchNodeNames: matchNodeNames,
        hasPropValue: hasPropValue,
        hasAttribute: hasAttribute,
        hasAttributeValue: hasAttributeValue,
        matchStyleValues: matchStyleValues,
        isBogus: isBogus,
        isBogusAll: isBogusAll,
        isTable: isTable
      };

      var surroundedBySpans = function (node) {
        var previousIsSpan = node.previousSibling && node.previousSibling.nodeName === 'SPAN';
        var nextIsSpan = node.nextSibling && node.nextSibling.nodeName === 'SPAN';
        return previousIsSpan && nextIsSpan;
      };
      var isBookmarkNode = function (node) {
        return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
      };
      var trimNode = function (dom, node) {
        var i, children = node.childNodes;
        if ($_5oonaz1qjh8lywhz.isElement(node) && isBookmarkNode(node)) {
          return;
        }
        for (i = children.length - 1; i >= 0; i--) {
          trimNode(dom, children[i]);
        }
        if ($_5oonaz1qjh8lywhz.isDocument(node) === false) {
          if ($_5oonaz1qjh8lywhz.isText(node) && node.nodeValue.length > 0) {
            var trimmedLength = $_ahowuxkjh8lywbj.trim(node.nodeValue).length;
            if (dom.isBlock(node.parentNode) || trimmedLength > 0) {
              return;
            }
            if (trimmedLength === 0 && surroundedBySpans(node)) {
              return;
            }
          } else if ($_5oonaz1qjh8lywhz.isElement(node)) {
            children = node.childNodes;
            if (children.length === 1 && isBookmarkNode(children[0])) {
              node.parentNode.insertBefore(children[0], node);
            }
            if (children.length || isVoid($_cgttw3zjh8lywdq.fromDom(node))) {
              return;
            }
          }
          dom.remove(node);
        }
        return node;
      };
      var $_cm6fub1ojh8lywhl = { trimNode: trimNode };

      var makeMap$1 = $_ahowuxkjh8lywbj.makeMap;
      var namedEntities;
      var baseEntities;
      var reverseEntities;
      var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
      var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
      var rawCharsRegExp = /[<>&\"\']/g;
      var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
      var asciiMap = {
        128: '\u20AC',
        130: '\u201A',
        131: '\u0192',
        132: '\u201E',
        133: '\u2026',
        134: '\u2020',
        135: '\u2021',
        136: '\u02c6',
        137: '\u2030',
        138: '\u0160',
        139: '\u2039',
        140: '\u0152',
        142: '\u017d',
        145: '\u2018',
        146: '\u2019',
        147: '\u201C',
        148: '\u201D',
        149: '\u2022',
        150: '\u2013',
        151: '\u2014',
        152: '\u02DC',
        153: '\u2122',
        154: '\u0161',
        155: '\u203A',
        156: '\u0153',
        158: '\u017e',
        159: '\u0178'
      };
      baseEntities = {
        '"': '&quot;',
        '\'': '&#39;',
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '`': '&#96;'
      };
      reverseEntities = {
        '&lt;': '<',
        '&gt;': '>',
        '&amp;': '&',
        '&quot;': '"',
        '&apos;': '\''
      };
      var nativeDecode = function (text) {
        var elm;
        elm = $_cgttw3zjh8lywdq.fromTag('div').dom();
        elm.innerHTML = text;
        return elm.textContent || elm.innerText || text;
      };
      var buildEntitiesLookup = function (items, radix) {
        var i, chr, entity;
        var lookup = {};
        if (items) {
          items = items.split(',');
          radix = radix || 10;
          for (i = 0; i < items.length; i += 2) {
            chr = String.fromCharCode(parseInt(items[i], radix));
            if (!baseEntities[chr]) {
              entity = '&' + items[i + 1] + ';';
              lookup[chr] = entity;
              lookup[entity] = chr;
            }
          }
          return lookup;
        }
      };
      namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
      var encodeRaw = function (text, attr) {
        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
          return baseEntities[chr] || chr;
        });
      };
      var encodeAllRaw = function (text) {
        return ('' + text).replace(rawCharsRegExp, function (chr) {
          return baseEntities[chr] || chr;
        });
      };
      var encodeNumeric = function (text, attr) {
        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
          if (chr.length > 1) {
            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
          }
          return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
        });
      };
      var encodeNamed = function (text, attr, entities) {
        entities = entities || namedEntities;
        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
          return baseEntities[chr] || entities[chr] || chr;
        });
      };
      var getEncodeFunc = function (name, entities) {
        var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
        var encodeNamedAndNumeric = function (text, attr) {
          return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
            if (baseEntities[chr] !== undefined) {
              return baseEntities[chr];
            }
            if (entitiesMap[chr] !== undefined) {
              return entitiesMap[chr];
            }
            if (chr.length > 1) {
              return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
            }
            return '&#' + chr.charCodeAt(0) + ';';
          });
        };
        var encodeCustomNamed = function (text, attr) {
          return encodeNamed(text, attr, entitiesMap);
        };
        var nameMap = makeMap$1(name.replace(/\+/g, ','));
        if (nameMap.named && nameMap.numeric) {
          return encodeNamedAndNumeric;
        }
        if (nameMap.named) {
          if (entities) {
            return encodeCustomNamed;
          }
          return encodeNamed;
        }
        if (nameMap.numeric) {
          return encodeNumeric;
        }
        return encodeRaw;
      };
      var decode = function (text) {
        return text.replace(entityRegExp, function (all, numeric) {
          if (numeric) {
            if (numeric.charAt(0).toLowerCase() === 'x') {
              numeric = parseInt(numeric.substr(1), 16);
            } else {
              numeric = parseInt(numeric, 10);
            }
            if (numeric > 65535) {
              numeric -= 65536;
              return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
            }
            return asciiMap[numeric] || String.fromCharCode(numeric);
          }
          return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
        });
      };
      var $_gex7a11rjh8lywi4 = {
        encodeRaw: encodeRaw,
        encodeAllRaw: encodeAllRaw,
        encodeNumeric: encodeNumeric,
        encodeNamed: encodeNamed,
        getEncodeFunc: getEncodeFunc,
        decode: decode
      };

      var mapCache = {};
      var dummyObj = {};
      var makeMap$2 = $_ahowuxkjh8lywbj.makeMap;
      var each$4 = $_ahowuxkjh8lywbj.each;
      var extend$1 = $_ahowuxkjh8lywbj.extend;
      var explode$1 = $_ahowuxkjh8lywbj.explode;
      var inArray$1 = $_ahowuxkjh8lywbj.inArray;
      var split = function (items, delim) {
        items = $_ahowuxkjh8lywbj.trim(items);
        return items ? items.split(delim || ' ') : [];
      };
      var compileSchema = function (type) {
        var schema = {};
        var globalAttributes, blockContent;
        var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
        var add = function (name, attributes, children) {
          var ni, attributesOrder, element;
          var arrayToMap = function (array, obj) {
            var map = {};
            var i, l;
            for (i = 0, l = array.length; i < l; i++) {
              map[array[i]] = obj || {};
            }
            return map;
          };
          children = children || [];
          attributes = attributes || '';
          if (typeof children === 'string') {
            children = split(children);
          }
          name = split(name);
          ni = name.length;
          while (ni--) {
            attributesOrder = split([
              globalAttributes,
              attributes
            ].join(' '));
            element = {
              attributes: arrayToMap(attributesOrder),
              attributesOrder: attributesOrder,
              children: arrayToMap(children, dummyObj)
            };
            schema[name[ni]] = element;
          }
        };
        var addAttrs = function (name, attributes) {
          var ni, schemaItem, i, l;
          name = split(name);
          ni = name.length;
          attributes = split(attributes);
          while (ni--) {
            schemaItem = schema[name[ni]];
            for (i = 0, l = attributes.length; i < l; i++) {
              schemaItem.attributes[attributes[i]] = {};
              schemaItem.attributesOrder.push(attributes[i]);
            }
          }
        };
        if (mapCache[type]) {
          return mapCache[type];
        }
        globalAttributes = 'id accesskey class dir lang style tabindex title role';
        blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
        phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
        if (type !== 'html4') {
          globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
          blockContent += ' article aside details dialog figure header footer hgroup section nav';
          phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
        }
        if (type !== 'html5-strict') {
          globalAttributes += ' xml:lang';
          html4PhrasingContent = 'acronym applet basefont big font strike tt';
          phrasingContent = [
            phrasingContent,
            html4PhrasingContent
          ].join(' ');
          each$4(split(html4PhrasingContent), function (name) {
            add(name, '', phrasingContent);
          });
          html4BlockContent = 'center dir isindex noframes';
          blockContent = [
            blockContent,
            html4BlockContent
          ].join(' ');
          flowContent = [
            blockContent,
            phrasingContent
          ].join(' ');
          each$4(split(html4BlockContent), function (name) {
            add(name, '', flowContent);
          });
        }
        flowContent = flowContent || [
          blockContent,
          phrasingContent
        ].join(' ');
        add('html', 'manifest', 'head body');
        add('head', '', 'base command link meta noscript script style title');
        add('title hr noscript br');
        add('base', 'href target');
        add('link', 'href rel media hreflang type sizes hreflang');
        add('meta', 'name http-equiv content charset');
        add('style', 'media type scoped');
        add('script', 'src async defer type charset');
        add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
        add('address dt dd div caption', '', flowContent);
        add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
        add('blockquote', 'cite', flowContent);
        add('ol', 'reversed start type', 'li');
        add('ul', '', 'li');
        add('li', 'value', flowContent);
        add('dl', '', 'dt dd');
        add('a', 'href target rel media hreflang type', phrasingContent);
        add('q', 'cite', phrasingContent);
        add('ins del', 'cite datetime', flowContent);
        add('img', 'src sizes srcset alt usemap ismap width height');
        add('iframe', 'src name width height', flowContent);
        add('embed', 'src type width height');
        add('object', 'data type typemustmatch name usemap form width height', [
          flowContent,
          'param'
        ].join(' '));
        add('param', 'name value');
        add('map', 'name', [
          flowContent,
          'area'
        ].join(' '));
        add('area', 'alt coords shape href target rel media hreflang type');
        add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
        add('colgroup', 'span', 'col');
        add('col', 'span');
        add('tbody thead tfoot', '', 'tr');
        add('tr', '', 'td th');
        add('td', 'colspan rowspan headers', flowContent);
        add('th', 'colspan rowspan headers scope abbr', flowContent);
        add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
        add('fieldset', 'disabled form name', [
          flowContent,
          'legend'
        ].join(' '));
        add('label', 'form for', phrasingContent);
        add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
        add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
        add('select', 'disabled form multiple name required size', 'option optgroup');
        add('optgroup', 'disabled label', 'option');
        add('option', 'disabled label selected value');
        add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
        add('menu', 'type label', [
          flowContent,
          'li'
        ].join(' '));
        add('noscript', '', flowContent);
        if (type !== 'html4') {
          add('wbr');
          add('ruby', '', [
            phrasingContent,
            'rt rp'
          ].join(' '));
          add('figcaption', '', flowContent);
          add('mark rt rp summary bdi', '', phrasingContent);
          add('canvas', 'width height', flowContent);
          add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
            flowContent,
            'track source'
          ].join(' '));
          add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
            flowContent,
            'track source'
          ].join(' '));
          add('picture', '', 'img source');
          add('source', 'src srcset type media sizes');
          add('track', 'kind src srclang label default');
          add('datalist', '', [
            phrasingContent,
            'option'
          ].join(' '));
          add('article section nav aside header footer', '', flowContent);
          add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
          add('figure', '', [
            flowContent,
            'figcaption'
          ].join(' '));
          add('time', 'datetime', phrasingContent);
          add('dialog', 'open', flowContent);
          add('command', 'type label icon disabled checked radiogroup command');
          add('output', 'for form name', phrasingContent);
          add('progress', 'value max', phrasingContent);
          add('meter', 'value min max low high optimum', phrasingContent);
          add('details', 'open', [
            flowContent,
            'summary'
          ].join(' '));
          add('keygen', 'autofocus challenge disabled form keytype name');
        }
        if (type !== 'html5-strict') {
          addAttrs('script', 'language xml:space');
          addAttrs('style', 'xml:space');
          addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
          addAttrs('embed', 'align name hspace vspace');
          addAttrs('param', 'valuetype type');
          addAttrs('a', 'charset name rev shape coords');
          addAttrs('br', 'clear');
          addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
          addAttrs('img', 'name longdesc align border hspace vspace');
          addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
          addAttrs('font basefont', 'size color face');
          addAttrs('input', 'usemap align');
          addAttrs('select', 'onchange');
          addAttrs('textarea');
          addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
          addAttrs('ul', 'type compact');
          addAttrs('li', 'type');
          addAttrs('ol dl menu dir', 'compact');
          addAttrs('pre', 'width xml:space');
          addAttrs('hr', 'align noshade size width');
          addAttrs('isindex', 'prompt');
          addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
          addAttrs('col', 'width align char charoff valign');
          addAttrs('colgroup', 'width align char charoff valign');
          addAttrs('thead', 'align char charoff valign');
          addAttrs('tr', 'align char charoff valign bgcolor');
          addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
          addAttrs('form', 'accept');
          addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
          addAttrs('tfoot', 'align char charoff valign');
          addAttrs('tbody', 'align char charoff valign');
          addAttrs('area', 'nohref');
          addAttrs('body', 'background bgcolor text link vlink alink');
        }
        if (type !== 'html4') {
          addAttrs('input button select textarea', 'autofocus');
          addAttrs('input textarea', 'placeholder');
          addAttrs('a', 'download');
          addAttrs('link script img', 'crossorigin');
          addAttrs('iframe', 'sandbox seamless allowfullscreen');
        }
        each$4(split('a form meter progress dfn'), function (name) {
          if (schema[name]) {
            delete schema[name].children[name];
          }
        });
        delete schema.caption.children.table;
        delete schema.script;
        mapCache[type] = schema;
        return schema;
      };
      var compileElementMap = function (value, mode) {
        var styles;
        if (value) {
          styles = {};
          if (typeof value === 'string') {
            value = { '*': value };
          }
          each$4(value, function (value, key) {
            styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$1(value, /[, ]/);
          });
        }
        return styles;
      };
      function Schema(settings) {
        var elements = {};
        var children = {};
        var patternElements = [];
        var validStyles;
        var invalidStyles;
        var schemaItems;
        var whiteSpaceElementsMap, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
        var blockElementsMap, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
        var customElementsMap = {}, specialElements = {};
        var createLookupTable = function (option, defaultValue, extendWith) {
          var value = settings[option];
          if (!value) {
            value = mapCache[option];
            if (!value) {
              value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
              value = extend$1(value, extendWith);
              mapCache[option] = value;
            }
          } else {
            value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
          }
          return value;
        };
        settings = settings || {};
        schemaItems = compileSchema(settings.schema);
        if (settings.verify_html === false) {
          settings.valid_elements = '*[*]';
        }
        validStyles = compileElementMap(settings.valid_styles);
        invalidStyles = compileElementMap(settings.invalid_styles, 'map');
        validClasses = compileElementMap(settings.valid_classes, 'map');
        whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
        selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
        shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
        boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
        nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object ' + 'script pre code', shortEndedElementsMap);
        moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
        textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside nav figure');
        blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
        textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' + 'dfn code mark q sup sub samp');
        each$4((settings.special || 'script noscript noframes noembed title style textarea xmp').split(' '), function (name) {
          specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
        });
        var patternToRegExp = function (str) {
          return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
        };
        var addValidElements = function (validElements) {
          var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, key, value;
          var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
          if (validElements) {
            validElements = split(validElements, ',');
            if (elements['@']) {
              globalAttributes = elements['@'].attributes;
              globalAttributesOrder = elements['@'].attributesOrder;
            }
            for (ei = 0, el = validElements.length; ei < el; ei++) {
              matches = elementRuleRegExp.exec(validElements[ei]);
              if (matches) {
                prefix = matches[1];
                elementName = matches[2];
                outputName = matches[3];
                attrData = matches[5];
                attributes = {};
                attributesOrder = [];
                element = {
                  attributes: attributes,
                  attributesOrder: attributesOrder
                };
                if (prefix === '#') {
                  element.paddEmpty = true;
                }
                if (prefix === '-') {
                  element.removeEmpty = true;
                }
                if (matches[4] === '!') {
                  element.removeEmptyAttrs = true;
                }
                if (globalAttributes) {
                  for (key in globalAttributes) {
                    attributes[key] = globalAttributes[key];
                  }
                  attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
                }
                if (attrData) {
                  attrData = split(attrData, '|');
                  for (ai = 0, al = attrData.length; ai < al; ai++) {
                    matches = attrRuleRegExp.exec(attrData[ai]);
                    if (matches) {
                      attr = {};
                      attrType = matches[1];
                      attrName = matches[2].replace(/[\\:]:/g, ':');
                      prefix = matches[3];
                      value = matches[4];
                      if (attrType === '!') {
                        element.attributesRequired = element.attributesRequired || [];
                        element.attributesRequired.push(attrName);
                        attr.required = true;
                      }
                      if (attrType === '-') {
                        delete attributes[attrName];
                        attributesOrder.splice(inArray$1(attributesOrder, attrName), 1);
                        continue;
                      }
                      if (prefix) {
                        if (prefix === '=') {
                          element.attributesDefault = element.attributesDefault || [];
                          element.attributesDefault.push({
                            name: attrName,
                            value: value
                          });
                          attr.defaultValue = value;
                        }
                        if (prefix === ':') {
                          element.attributesForced = element.attributesForced || [];
                          element.attributesForced.push({
                            name: attrName,
                            value: value
                          });
                          attr.forcedValue = value;
                        }
                        if (prefix === '<') {
                          attr.validValues = makeMap$2(value, '?');
                        }
                      }
                      if (hasPatternsRegExp.test(attrName)) {
                        element.attributePatterns = element.attributePatterns || [];
                        attr.pattern = patternToRegExp(attrName);
                        element.attributePatterns.push(attr);
                      } else {
                        if (!attributes[attrName]) {
                          attributesOrder.push(attrName);
                        }
                        attributes[attrName] = attr;
                      }
                    }
                  }
                }
                if (!globalAttributes && elementName === '@') {
                  globalAttributes = attributes;
                  globalAttributesOrder = attributesOrder;
                }
                if (outputName) {
                  element.outputName = elementName;
                  elements[outputName] = element;
                }
                if (hasPatternsRegExp.test(elementName)) {
                  element.pattern = patternToRegExp(elementName);
                  patternElements.push(element);
                } else {
                  elements[elementName] = element;
                }
              }
            }
          }
        };
        var setValidElements = function (validElements) {
          elements = {};
          patternElements = [];
          addValidElements(validElements);
          each$4(schemaItems, function (element, name) {
            children[name] = element.children;
          });
        };
        var addCustomElements = function (customElements) {
          var customElementRegExp = /^(~)?(.+)$/;
          if (customElements) {
            mapCache.text_block_elements = mapCache.block_elements = null;
            each$4(split(customElements, ','), function (rule) {
              var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
              children[name] = children[cloneName];
              customElementsMap[name] = cloneName;
              if (!inline) {
                blockElementsMap[name.toUpperCase()] = {};
                blockElementsMap[name] = {};
              }
              if (!elements[name]) {
                var customRule = elements[cloneName];
                customRule = extend$1({}, customRule);
                delete customRule.removeEmptyAttrs;
                delete customRule.removeEmpty;
                elements[name] = customRule;
              }
              each$4(children, function (element, elmName) {
                if (element[cloneName]) {
                  children[elmName] = element = extend$1({}, children[elmName]);
                  element[name] = element[cloneName];
                }
              });
            });
          }
        };
        var addValidChildren = function (validChildren) {
          var childRuleRegExp = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
          mapCache[settings.schema] = null;
          if (validChildren) {
            each$4(split(validChildren, ','), function (rule) {
              var matches = childRuleRegExp.exec(rule);
              var parent, prefix;
              if (matches) {
                prefix = matches[1];
                if (prefix) {
                  parent = children[matches[2]];
                } else {
                  parent = children[matches[2]] = { '#comment': {} };
                }
                parent = children[matches[2]];
                each$4(split(matches[3], '|'), function (child) {
                  if (prefix === '-') {
                    delete parent[child];
                  } else {
                    parent[child] = {};
                  }
                });
              }
            });
          }
        };
        var getElementRule = function (name) {
          var element = elements[name], i;
          if (element) {
            return element;
          }
          i = patternElements.length;
          while (i--) {
            element = patternElements[i];
            if (element.pattern.test(name)) {
              return element;
            }
          }
        };
        if (!settings.valid_elements) {
          each$4(schemaItems, function (element, name) {
            elements[name] = {
              attributes: element.attributes,
              attributesOrder: element.attributesOrder
            };
            children[name] = element.children;
          });
          if (settings.schema !== 'html5') {
            each$4(split('strong/b em/i'), function (item) {
              item = split(item, '/');
              elements[item[1]].outputName = item[0];
            });
          }
          each$4(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function (name) {
            if (elements[name]) {
              elements[name].removeEmpty = true;
            }
          });
          each$4(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
            elements[name].paddEmpty = true;
          });
          each$4(split('span'), function (name) {
            elements[name].removeEmptyAttrs = true;
          });
        } else {
          setValidElements(settings.valid_elements);
        }
        addCustomElements(settings.custom_elements);
        addValidChildren(settings.valid_children);
        addValidElements(settings.extended_valid_elements);
        addValidChildren('+ol[ul|ol],+ul[ul|ol]');
        each$4({
          dd: 'dl',
          dt: 'dl',
          li: 'ul ol',
          td: 'tr',
          th: 'tr',
          tr: 'tbody thead tfoot',
          tbody: 'table',
          thead: 'table',
          tfoot: 'table',
          legend: 'fieldset',
          area: 'map',
          param: 'video audio object'
        }, function (parents, item) {
          if (elements[item]) {
            elements[item].parentsRequired = split(parents);
          }
        });
        if (settings.invalid_elements) {
          each$4(explode$1(settings.invalid_elements), function (item) {
            if (elements[item]) {
              delete elements[item];
            }
          });
        }
        if (!getElementRule('span')) {
          addValidElements('span[!data-mce-type|*]');
        }
        var getValidStyles = function () {
          return validStyles;
        };
        var getInvalidStyles = function () {
          return invalidStyles;
        };
        var getValidClasses = function () {
          return validClasses;
        };
        var getBoolAttrs = function () {
          return boolAttrMap;
        };
        var getBlockElements = function () {
          return blockElementsMap;
        };
        var getTextBlockElements = function () {
          return textBlockElementsMap;
        };
        var getTextInlineElements = function () {
          return textInlineElementsMap;
        };
        var getShortEndedElements = function () {
          return shortEndedElementsMap;
        };
        var getSelfClosingElements = function () {
          return selfClosingElementsMap;
        };
        var getNonEmptyElements = function () {
          return nonEmptyElementsMap;
        };
        var getMoveCaretBeforeOnEnterElements = function () {
          return moveCaretBeforeOnEnterElementsMap;
        };
        var getWhiteSpaceElements = function () {
          return whiteSpaceElementsMap;
        };
        var getSpecialElements = function () {
          return specialElements;
        };
        var isValidChild = function (name, child) {
          var parent = children[name.toLowerCase()];
          return !!(parent && parent[child.toLowerCase()]);
        };
        var isValid = function (name, attr) {
          var attrPatterns, i;
          var rule = getElementRule(name);
          if (rule) {
            if (attr) {
              if (rule.attributes[attr]) {
                return true;
              }
              attrPatterns = rule.attributePatterns;
              if (attrPatterns) {
                i = attrPatterns.length;
                while (i--) {
                  if (attrPatterns[i].pattern.test(name)) {
                    return true;
                  }
                }
              }
            } else {
              return true;
            }
          }
          return false;
        };
        var getCustomElements = function () {
          return customElementsMap;
        };
        return {
          children: children,
          elements: elements,
          getValidStyles: getValidStyles,
          getValidClasses: getValidClasses,
          getBlockElements: getBlockElements,
          getInvalidStyles: getInvalidStyles,
          getShortEndedElements: getShortEndedElements,
          getTextBlockElements: getTextBlockElements,
          getTextInlineElements: getTextInlineElements,
          getBoolAttrs: getBoolAttrs,
          getElementRule: getElementRule,
          getSelfClosingElements: getSelfClosingElements,
          getNonEmptyElements: getNonEmptyElements,
          getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
          getWhiteSpaceElements: getWhiteSpaceElements,
          getSpecialElements: getSpecialElements,
          isValidChild: isValidChild,
          isValid: isValid,
          getCustomElements: getCustomElements,
          addValidElements: addValidElements,
          setValidElements: setValidElements,
          addCustomElements: addCustomElements,
          addValidChildren: addValidChildren
        };
      }

      var toHex = function (match, r, g, b) {
        var hex = function (val) {
          val = parseInt(val, 10).toString(16);
          return val.length > 1 ? val : '0' + val;
        };
        return '#' + hex(r) + hex(g) + hex(b);
      };
      function Styles(settings, schema) {
        var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
        var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
        var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
        var trimRightRegExp = /\s+$/;
        var i;
        var encodingLookup = {};
        var encodingItems;
        var validStyles;
        var invalidStyles;
        var invisibleChar = '\uFEFF';
        settings = settings || {};
        if (schema) {
          validStyles = schema.getValidStyles();
          invalidStyles = schema.getInvalidStyles();
        }
        encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
        for (i = 0; i < encodingItems.length; i++) {
          encodingLookup[encodingItems[i]] = invisibleChar + i;
          encodingLookup[invisibleChar + i] = encodingItems[i];
        }
        return {
          toHex: function (color) {
            return color.replace(rgbRegExp, toHex);
          },
          parse: function (css) {
            var styles = {};
            var matches, name, value, isEncoded;
            var urlConverter = settings.url_converter;
            var urlConverterScope = settings.url_converter_scope || this;
            var compress = function (prefix, suffix, noJoin) {
              var top, right, bottom, left;
              top = styles[prefix + '-top' + suffix];
              if (!top) {
                return;
              }
              right = styles[prefix + '-right' + suffix];
              if (!right) {
                return;
              }
              bottom = styles[prefix + '-bottom' + suffix];
              if (!bottom) {
                return;
              }
              left = styles[prefix + '-left' + suffix];
              if (!left) {
                return;
              }
              var box = [
                top,
                right,
                bottom,
                left
              ];
              i = box.length - 1;
              while (i--) {
                if (box[i] !== box[i + 1]) {
                  break;
                }
              }
              if (i > -1 && noJoin) {
                return;
              }
              styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
              delete styles[prefix + '-top' + suffix];
              delete styles[prefix + '-right' + suffix];
              delete styles[prefix + '-bottom' + suffix];
              delete styles[prefix + '-left' + suffix];
            };
            var canCompress = function (key) {
              var value = styles[key], i;
              if (!value) {
                return;
              }
              value = value.split(' ');
              i = value.length;
              while (i--) {
                if (value[i] !== value[0]) {
                  return false;
                }
              }
              styles[key] = value[0];
              return true;
            };
            var compress2 = function (target, a, b, c) {
              if (!canCompress(a)) {
                return;
              }
              if (!canCompress(b)) {
                return;
              }
              if (!canCompress(c)) {
                return;
              }
              styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
              delete styles[a];
              delete styles[b];
              delete styles[c];
            };
            var encode = function (str) {
              isEncoded = true;
              return encodingLookup[str];
            };
            var decode = function (str, keepSlashes) {
              if (isEncoded) {
                str = str.replace(/\uFEFF[0-9]/g, function (str) {
                  return encodingLookup[str];
                });
              }
              if (!keepSlashes) {
                str = str.replace(/\\([\'\";:])/g, '$1');
              }
              return str;
            };
            var decodeSingleHexSequence = function (escSeq) {
              return String.fromCharCode(parseInt(escSeq.slice(1), 16));
            };
            var decodeHexSequences = function (value) {
              return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
            };
            var processUrl = function (match, url, url2, url3, str, str2) {
              str = str || str2;
              if (str) {
                str = decode(str);
                return '\'' + str.replace(/\'/g, '\\\'') + '\'';
              }
              url = decode(url || url2 || url3);
              if (!settings.allow_script_urls) {
                var scriptUrl = url.replace(/[\s\r\n]+/g, '');
                if (/(java|vb)script:/i.test(scriptUrl)) {
                  return '';
                }
                if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
                  return '';
                }
              }
              if (urlConverter) {
                url = urlConverter.call(urlConverterScope, url, 'style');
              }
              return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
            };
            if (css) {
              css = css.replace(/[\u0000-\u001F]/g, '');
              css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
                return str.replace(/[;:]/g, encode);
              });
              while (matches = styleRegExp.exec(css)) {
                styleRegExp.lastIndex = matches.index + matches[0].length;
                name = matches[1].replace(trimRightRegExp, '').toLowerCase();
                value = matches[2].replace(trimRightRegExp, '');
                if (name && value) {
                  name = decodeHexSequences(name);
                  value = decodeHexSequences(value);
                  if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
                    continue;
                  }
                  if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
                    continue;
                  }
                  if (name === 'font-weight' && value === '700') {
                    value = 'bold';
                  } else if (name === 'color' || name === 'background-color') {
                    value = value.toLowerCase();
                  }
                  value = value.replace(rgbRegExp, toHex);
                  value = value.replace(urlOrStrRegExp, processUrl);
                  styles[name] = isEncoded ? decode(value, true) : value;
                }
              }
              compress('border', '', true);
              compress('border', '-width');
              compress('border', '-color');
              compress('border', '-style');
              compress('padding', '');
              compress('margin', '');
              compress2('border', 'border-width', 'border-style', 'border-color');
              if (styles.border === 'medium none') {
                delete styles.border;
              }
              if (styles['border-image'] === 'none') {
                delete styles['border-image'];
              }
            }
            return styles;
          },
          serialize: function (styles, elementName) {
            var css = '', name, value;
            var serializeStyles = function (name) {
              var styleList, i, l, value;
              styleList = validStyles[name];
              if (styleList) {
                for (i = 0, l = styleList.length; i < l; i++) {
                  name = styleList[i];
                  value = styles[name];
                  if (value) {
                    css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
                  }
                }
              }
            };
            var isValid = function (name, elementName) {
              var styleMap;
              styleMap = invalidStyles['*'];
              if (styleMap && styleMap[name]) {
                return false;
              }
              styleMap = invalidStyles[elementName];
              if (styleMap && styleMap[name]) {
                return false;
              }
              return true;
            };
            if (elementName && validStyles) {
              serializeStyles('*');
              serializeStyles(elementName);
            } else {
              for (name in styles) {
                value = styles[name];
                if (value && (!invalidStyles || isValid(name, elementName))) {
                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
                }
              }
            }
            return css;
          }
        };
      }

      var each$5 = $_ahowuxkjh8lywbj.each;
      var grep$1 = $_ahowuxkjh8lywbj.grep;
      var isIE = $_9bpim8ajh8lyw68.ie;
      var simpleSelectorRe = /^([a-z0-9],?)+$/i;
      var whiteSpaceRegExp$2 = /^[ \t\r\n]*$/;
      var setupAttrHooks = function (styles, settings, getContext) {
        var attrHooks = {};
        var keepValues = settings.keep_values;
        var keepUrlHook = {
          set: function ($elm, value, name) {
            if (settings.url_converter) {
              value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
            }
            $elm.attr('data-mce-' + name, value).attr(name, value);
          },
          get: function ($elm, name) {
            return $elm.attr('data-mce-' + name) || $elm.attr(name);
          }
        };
        attrHooks = {
          style: {
            set: function ($elm, value) {
              if (value !== null && typeof value === 'object') {
                $elm.css(value);
                return;
              }
              if (keepValues) {
                $elm.attr('data-mce-style', value);
              }
              $elm.attr('style', value);
            },
            get: function ($elm) {
              var value = $elm.attr('data-mce-style') || $elm.attr('style');
              value = styles.serialize(styles.parse(value), $elm[0].nodeName);
              return value;
            }
          }
        };
        if (keepValues) {
          attrHooks.href = attrHooks.src = keepUrlHook;
        }
        return attrHooks;
      };
      var updateInternalStyleAttr = function (styles, $elm) {
        var rawValue = $elm.attr('style');
        var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
        if (!value) {
          value = null;
        }
        $elm.attr('data-mce-style', value);
      };
      var findNodeIndex = function (node, normalized) {
        var idx = 0, lastNodeType, nodeType;
        if (node) {
          for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
            nodeType = node.nodeType;
            if (normalized && nodeType === 3) {
              if (nodeType === lastNodeType || !node.nodeValue.length) {
                continue;
              }
            }
            idx++;
            lastNodeType = nodeType;
          }
        }
        return idx;
      };
      function DOMUtils(doc, settings) {
        var _this = this;
        if (settings === void 0) {
          settings = {};
        }
        var attrHooks;
        var addedStyles = {};
        var win = window;
        var files = {};
        var counter = 0;
        var stdMode = true;
        var boxModel = true;
        var styleSheetLoader = StyleSheetLoader(doc);
        var boundEvents = [];
        var schema = settings.schema ? settings.schema : Schema({});
        var styles = Styles({
          url_converter: settings.url_converter,
          url_converter_scope: settings.url_converter_scope
        }, settings.schema);
        var events = settings.ownEvents ? new EventUtils(settings.proxy) : EventUtils.Event;
        var blockElementsMap = schema.getBlockElements();
        var $ = DomQuery.overrideDefaults(function () {
          return {
            context: doc,
            element: self.getRoot()
          };
        });
        var isBlock = function (node) {
          if (typeof node === 'string') {
            return !!blockElementsMap[node];
          } else if (node) {
            var type = node.nodeType;
            if (type) {
              return !!(type === 1 && blockElementsMap[node.nodeName]);
            }
          }
          return false;
        };
        var get = function (elm) {
          if (elm && doc && typeof elm === 'string') {
            var node = doc.getElementById(elm);
            if (node && node.id !== elm) {
              return doc.getElementsByName(elm)[1];
            } else {
              return node;
            }
          }
          return elm;
        };
        var $$ = function (elm) {
          if (typeof elm === 'string') {
            elm = get(elm);
          }
          return $(elm);
        };
        var getAttrib = function (elm, name, defaultVal) {
          var hook, value;
          var $elm = $$(elm);
          if ($elm.length) {
            hook = attrHooks[name];
            if (hook && hook.get) {
              value = hook.get($elm, name);
            } else {
              value = $elm.attr(name);
            }
          }
          if (typeof value === 'undefined') {
            value = defaultVal || '';
          }
          return value;
        };
        var getAttribs = function (elm) {
          var node = get(elm);
          if (!node) {
            return [];
          }
          return node.attributes;
        };
        var setAttrib = function (elm, name, value) {
          var originalValue, hook;
          if (value === '') {
            value = null;
          }
          var $elm = $$(elm);
          originalValue = $elm.attr(name);
          if (!$elm.length) {
            return;
          }
          hook = attrHooks[name];
          if (hook && hook.set) {
            hook.set($elm, value, name);
          } else {
            $elm.attr(name, value);
          }
          if (originalValue !== value && settings.onSetAttrib) {
            settings.onSetAttrib({
              attrElm: $elm,
              attrName: name,
              attrValue: value
            });
          }
        };
        var clone = function (node, deep) {
          if (!isIE || node.nodeType !== 1 || deep) {
            return node.cloneNode(deep);
          }
          if (!deep) {
            var clone_1 = doc.createElement(node.nodeName);
            each$5(getAttribs(node), function (attr) {
              setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
            });
            return clone_1;
          }
          return null;
        };
        var getRoot = function () {
          return settings.root_element || doc.body;
        };
        var getViewPort = function (argWin) {
          var actWin = !argWin ? win : argWin;
          var doc = actWin.document;
          var rootElm = boxModel ? doc.documentElement : doc.body;
          return {
            x: actWin.pageXOffset || rootElm.scrollLeft,
            y: actWin.pageYOffset || rootElm.scrollTop,
            w: actWin.innerWidth || rootElm.clientWidth,
            h: actWin.innerHeight || rootElm.clientHeight
          };
        };
        var getPos = function (elm, rootElm) {
          return $_6pe7rlmjh8lywbu.getPos(doc.body, get(elm), rootElm);
        };
        var setStyle = function (elm, name, value) {
          var $elm = $$(elm).css(name, value);
          if (settings.update_styles) {
            updateInternalStyleAttr(styles, $elm);
          }
        };
        var setStyles = function (elm, stylesArg) {
          var $elm = $$(elm).css(stylesArg);
          if (settings.update_styles) {
            updateInternalStyleAttr(styles, $elm);
          }
        };
        var getStyle = function (elm, name, computed) {
          var $elm = $$(elm);
          if (computed) {
            return $elm.css(name);
          }
          name = name.replace(/-(\D)/g, function (a, b) {
            return b.toUpperCase();
          });
          if (name === 'float') {
            name = $_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 12 ? 'styleFloat' : 'cssFloat';
          }
          return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
        };
        var getSize = function (elm) {
          var w, h;
          elm = get(elm);
          w = getStyle(elm, 'width');
          h = getStyle(elm, 'height');
          if (w.indexOf('px') === -1) {
            w = 0;
          }
          if (h.indexOf('px') === -1) {
            h = 0;
          }
          return {
            w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
            h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
          };
        };
        var getRect = function (elm) {
          var pos, size;
          elm = get(elm);
          pos = getPos(elm);
          size = getSize(elm);
          return {
            x: pos.x,
            y: pos.y,
            w: size.w,
            h: size.h
          };
        };
        var is = function (elm, selector) {
          var i;
          if (!elm) {
            return false;
          }
          if (!Array.isArray(elm)) {
            if (selector === '*') {
              return elm.nodeType === 1;
            }
            if (simpleSelectorRe.test(selector)) {
              var selectors = selector.toLowerCase().split(/,/);
              var elmName = elm.nodeName.toLowerCase();
              for (i = selectors.length - 1; i >= 0; i--) {
                if (selectors[i] === elmName) {
                  return true;
                }
              }
              return false;
            }
            if (elm.nodeType && elm.nodeType !== 1) {
              return false;
            }
          }
          var elms = !Array.isArray(elm) ? [elm] : elm;
          return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
        };
        var getParents = function (elm, selector, root, collect) {
          var result = [];
          var selectorVal;
          var node = get(elm);
          collect = collect === undefined;
          root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
          if ($_ahowuxkjh8lywbj.is(selector, 'string')) {
            selectorVal = selector;
            if (selector === '*') {
              selector = function (node) {
                return node.nodeType === 1;
              };
            } else {
              selector = function (node) {
                return is(node, selectorVal);
              };
            }
          }
          while (node) {
            if (node === root || !node.nodeType || node.nodeType === 9) {
              break;
            }
            if (!selector || typeof selector === 'function' && selector(node)) {
              if (collect) {
                result.push(node);
              } else {
                return [node];
              }
            }
            node = node.parentNode;
          }
          return collect ? result : null;
        };
        var getParent = function (node, selector, root) {
          var parents = getParents(node, selector, root, false);
          return parents && parents.length > 0 ? parents[0] : null;
        };
        var _findSib = function (node, selector, name) {
          var func = selector;
          if (node) {
            if (typeof selector === 'string') {
              func = function (node) {
                return is(node, selector);
              };
            }
            for (node = node[name]; node; node = node[name]) {
              if (typeof func === 'function' && func(node)) {
                return node;
              }
            }
          }
          return null;
        };
        var getNext = function (node, selector) {
          return _findSib(node, selector, 'nextSibling');
        };
        var getPrev = function (node, selector) {
          return _findSib(node, selector, 'previousSibling');
        };
        var select = function (selector, scope) {
          return Sizzle(selector, get(scope) || settings.root_element || doc, []);
        };
        var run = function (elm, func, scope) {
          var result;
          var node = typeof elm === 'string' ? get(elm) : elm;
          if (!node) {
            return false;
          }
          if ($_ahowuxkjh8lywbj.isArray(node) && (node.length || node.length === 0)) {
            result = [];
            each$5(node, function (elm, i) {
              if (elm) {
                if (typeof elm === 'string') {
                  elm = get(elm);
                }
                result.push(func.call(scope, elm, i));
              }
            });
            return result;
          }
          var context = scope ? scope : _this;
          return func.call(context, node);
        };
        var setAttribs = function (elm, attrs) {
          $$(elm).each(function (i, node) {
            each$5(attrs, function (value, name) {
              setAttrib(node, name, value);
            });
          });
        };
        var setHTML = function (elm, html) {
          var $elm = $$(elm);
          if (isIE) {
            $elm.each(function (i, target) {
              if (target.canHaveHTML === false) {
                return;
              }
              while (target.firstChild) {
                target.removeChild(target.firstChild);
              }
              try {
                target.innerHTML = '<br>' + html;
                target.removeChild(target.firstChild);
              } catch (ex) {
                DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
              }
              return html;
            });
          } else {
            $elm.html(html);
          }
        };
        var add = function (parentElm, name, attrs, html, create) {
          return run(parentElm, function (parentElm) {
            var newElm = typeof name === 'string' ? doc.createElement(name) : name;
            setAttribs(newElm, attrs);
            if (html) {
              if (typeof html !== 'string' && html.nodeType) {
                newElm.appendChild(html);
              } else if (typeof html === 'string') {
                setHTML(newElm, html);
              }
            }
            return !create ? parentElm.appendChild(newElm) : newElm;
          });
        };
        var create = function (name, attrs, html) {
          return add(doc.createElement(name), name, attrs, html, true);
        };
        var decode = $_gex7a11rjh8lywi4.decode;
        var encode = $_gex7a11rjh8lywi4.encodeAllRaw;
        var createHTML = function (name, attrs, html) {
          var outHtml = '', key;
          outHtml += '<' + name;
          for (key in attrs) {
            if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] !== 'undefined') {
              outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
            }
          }
          if (typeof html !== 'undefined') {
            return outHtml + '>' + html + '</' + name + '>';
          }
          return outHtml + ' />';
        };
        var createFragment = function (html) {
          var node;
          var container = doc.createElement('div');
          var frag = doc.createDocumentFragment();
          if (html) {
            container.innerHTML = html;
          }
          while (node = container.firstChild) {
            frag.appendChild(node);
          }
          return frag;
        };
        var remove = function (node, keepChildren) {
          var $node = $$(node);
          if (keepChildren) {
            $node.each(function () {
              var child;
              while (child = this.firstChild) {
                if (child.nodeType === 3 && child.data.length === 0) {
                  this.removeChild(child);
                } else {
                  this.parentNode.insertBefore(child, this);
                }
              }
            }).remove();
          } else {
            $node.remove();
          }
          return $node.length > 1 ? $node.toArray() : $node[0];
        };
        var removeAllAttribs = function (e) {
          return run(e, function (e) {
            var i;
            var attrs = e.attributes;
            for (i = attrs.length - 1; i >= 0; i--) {
              e.removeAttributeNode(attrs.item(i));
            }
          });
        };
        var parseStyle = function (cssText) {
          return styles.parse(cssText);
        };
        var serializeStyle = function (stylesArg, name) {
          return styles.serialize(stylesArg, name);
        };
        var addStyle = function (cssText) {
          var head, styleElm;
          if (self !== DOMUtils.DOM && doc === document) {
            if (addedStyles[cssText]) {
              return;
            }
            addedStyles[cssText] = true;
          }
          styleElm = doc.getElementById('mceDefaultStyles');
          if (!styleElm) {
            styleElm = doc.createElement('style');
            styleElm.id = 'mceDefaultStyles';
            styleElm.type = 'text/css';
            head = doc.getElementsByTagName('head')[0];
            if (head.firstChild) {
              head.insertBefore(styleElm, head.firstChild);
            } else {
              head.appendChild(styleElm);
            }
          }
          if (styleElm.styleSheet) {
            styleElm.styleSheet.cssText += cssText;
          } else {
            styleElm.appendChild(doc.createTextNode(cssText));
          }
        };
        var loadCSS = function (url) {
          var head;
          if (self !== DOMUtils.DOM && doc === document) {
            DOMUtils.DOM.loadCSS(url);
            return;
          }
          if (!url) {
            url = '';
          }
          head = doc.getElementsByTagName('head')[0];
          each$5(url.split(','), function (url) {
            var link;
            url = $_ahowuxkjh8lywbj._addCacheSuffix(url);
            if (files[url]) {
              return;
            }
            files[url] = true;
            link = create('link', {
              rel: 'stylesheet',
              href: url
            });
            head.appendChild(link);
          });
        };
        var toggleClass = function (elm, cls, state) {
          $$(elm).toggleClass(cls, state).each(function () {
            if (this.className === '') {
              DomQuery(this).attr('class', null);
            }
          });
        };
        var addClass = function (elm, cls) {
          $$(elm).addClass(cls);
        };
        var removeClass = function (elm, cls) {
          toggleClass(elm, cls, false);
        };
        var hasClass = function (elm, cls) {
          return $$(elm).hasClass(cls);
        };
        var show = function (elm) {
          $$(elm).show();
        };
        var hide = function (elm) {
          $$(elm).hide();
        };
        var isHidden = function (elm) {
          return $$(elm).css('display') === 'none';
        };
        var uniqueId = function (prefix) {
          return (!prefix ? 'mce_' : prefix) + counter++;
        };
        var getOuterHTML = function (elm) {
          var node = typeof elm === 'string' ? get(elm) : elm;
          return $_5oonaz1qjh8lywhz.isElement(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
        };
        var setOuterHTML = function (elm, html) {
          $$(elm).each(function () {
            try {
              if ('outerHTML' in this) {
                this.outerHTML = html;
                return;
              }
            } catch (ex) {
            }
            remove(DomQuery(this).html(html), true);
          });
        };
        var insertAfter = function (node, reference) {
          var referenceNode = get(reference);
          return run(node, function (node) {
            var parent, nextSibling;
            parent = referenceNode.parentNode;
            nextSibling = referenceNode.nextSibling;
            if (nextSibling) {
              parent.insertBefore(node, nextSibling);
            } else {
              parent.appendChild(node);
            }
            return node;
          });
        };
        var replace = function (newElm, oldElm, keepChildren) {
          return run(oldElm, function (oldElm) {
            if ($_ahowuxkjh8lywbj.is(oldElm, 'array')) {
              newElm = newElm.cloneNode(true);
            }
            if (keepChildren) {
              each$5(grep$1(oldElm.childNodes), function (node) {
                newElm.appendChild(node);
              });
            }
            return oldElm.parentNode.replaceChild(newElm, oldElm);
          });
        };
        var rename = function (elm, name) {
          var newElm;
          if (elm.nodeName !== name.toUpperCase()) {
            newElm = create(name);
            each$5(getAttribs(elm), function (attrNode) {
              setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
            });
            replace(newElm, elm, true);
          }
          return newElm || elm;
        };
        var findCommonAncestor = function (a, b) {
          var ps = a, pe;
          while (ps) {
            pe = b;
            while (pe && ps !== pe) {
              pe = pe.parentNode;
            }
            if (ps === pe) {
              break;
            }
            ps = ps.parentNode;
          }
          if (!ps && a.ownerDocument) {
            return a.ownerDocument.documentElement;
          }
          return ps;
        };
        var toHex = function (rgbVal) {
          return styles.toHex($_ahowuxkjh8lywbj.trim(rgbVal));
        };
        var isEmpty = function (node, elements) {
          var i, attributes, type, whitespace, walker, name, brCount = 0;
          node = node.firstChild;
          if (node) {
            walker = new TreeWalker(node, node.parentNode);
            elements = elements || (schema ? schema.getNonEmptyElements() : null);
            whitespace = schema ? schema.getWhiteSpaceElements() : {};
            do {
              type = node.nodeType;
              if ($_5oonaz1qjh8lywhz.isElement(node)) {
                var bogusVal = node.getAttribute('data-mce-bogus');
                if (bogusVal) {
                  node = walker.next(bogusVal === 'all');
                  continue;
                }
                name = node.nodeName.toLowerCase();
                if (elements && elements[name]) {
                  if (name === 'br') {
                    brCount++;
                    node = walker.next();
                    continue;
                  }
                  return false;
                }
                attributes = getAttribs(node);
                i = attributes.length;
                while (i--) {
                  name = attributes[i].nodeName;
                  if (name === 'name' || name === 'data-mce-bookmark') {
                    return false;
                  }
                }
              }
              if (type === 8) {
                return false;
              }
              if (type === 3 && !whiteSpaceRegExp$2.test(node.nodeValue)) {
                return false;
              }
              if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && whiteSpaceRegExp$2.test(node.nodeValue)) {
                return false;
              }
              node = walker.next();
            } while (node);
          }
          return brCount <= 1;
        };
        var createRng = function () {
          return doc.createRange();
        };
        var split = function (parentElm, splitElm, replacementElm) {
          var r = createRng(), bef, aft, pa;
          if (parentElm && splitElm) {
            r.setStart(parentElm.parentNode, findNodeIndex(parentElm));
            r.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
            bef = r.extractContents();
            r = createRng();
            r.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
            r.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
            aft = r.extractContents();
            pa = parentElm.parentNode;
            pa.insertBefore($_cm6fub1ojh8lywhl.trimNode(self, bef), parentElm);
            if (replacementElm) {
              pa.insertBefore(replacementElm, parentElm);
            } else {
              pa.insertBefore(splitElm, parentElm);
            }
            pa.insertBefore($_cm6fub1ojh8lywhl.trimNode(self, aft), parentElm);
            remove(parentElm);
            return replacementElm || splitElm;
          }
        };
        var bind = function (target, name, func, scope) {
          if ($_ahowuxkjh8lywbj.isArray(target)) {
            var i = target.length;
            while (i--) {
              target[i] = bind(target[i], name, func, scope);
            }
            return target;
          }
          if (settings.collect && (target === doc || target === win)) {
            boundEvents.push([
              target,
              name,
              func,
              scope
            ]);
          }
          return events.bind(target, name, func, scope || self);
        };
        var unbind = function (target, name, func) {
          var i;
          if ($_ahowuxkjh8lywbj.isArray(target)) {
            i = target.length;
            while (i--) {
              target[i] = unbind(target[i], name, func);
            }
            return target;
          }
          if (boundEvents && (target === doc || target === win)) {
            i = boundEvents.length;
            while (i--) {
              var item = boundEvents[i];
              if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
                events.unbind(item[0], item[1], item[2]);
              }
            }
          }
          return events.unbind(target, name, func);
        };
        var fire = function (target, name, evt) {
          return events.fire(target, name, evt);
        };
        var getContentEditable = function (node) {
          if (node && $_5oonaz1qjh8lywhz.isElement(node)) {
            var contentEditable = node.getAttribute('data-mce-contenteditable');
            if (contentEditable && contentEditable !== 'inherit') {
              return contentEditable;
            }
            return node.contentEditable !== 'inherit' ? node.contentEditable : null;
          } else {
            return null;
          }
        };
        var getContentEditableParent = function (node) {
          var root = getRoot();
          var state = null;
          for (; node && node !== root; node = node.parentNode) {
            state = getContentEditable(node);
            if (state !== null) {
              break;
            }
          }
          return state;
        };
        var destroy = function () {
          if (boundEvents) {
            var i = boundEvents.length;
            while (i--) {
              var item = boundEvents[i];
              events.unbind(item[0], item[1], item[2]);
            }
          }
          if (Sizzle.setDocument) {
            Sizzle.setDocument();
          }
        };
        var isChildOf = function (node, parent) {
          while (node) {
            if (parent === node) {
              return true;
            }
            node = node.parentNode;
          }
          return false;
        };
        var dumpRng = function (r) {
          return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
        };
        var self = {
          doc: doc,
          settings: settings,
          win: win,
          files: files,
          stdMode: stdMode,
          boxModel: boxModel,
          styleSheetLoader: styleSheetLoader,
          boundEvents: boundEvents,
          styles: styles,
          schema: schema,
          events: events,
          isBlock: isBlock,
          $: $,
          $$: $$,
          root: null,
          clone: clone,
          getRoot: getRoot,
          getViewPort: getViewPort,
          getRect: getRect,
          getSize: getSize,
          getParent: getParent,
          getParents: getParents,
          get: get,
          getNext: getNext,
          getPrev: getPrev,
          select: select,
          is: is,
          add: add,
          create: create,
          createHTML: createHTML,
          createFragment: createFragment,
          remove: remove,
          setStyle: setStyle,
          getStyle: getStyle,
          setStyles: setStyles,
          removeAllAttribs: removeAllAttribs,
          setAttrib: setAttrib,
          setAttribs: setAttribs,
          getAttrib: getAttrib,
          getPos: getPos,
          parseStyle: parseStyle,
          serializeStyle: serializeStyle,
          addStyle: addStyle,
          loadCSS: loadCSS,
          addClass: addClass,
          removeClass: removeClass,
          hasClass: hasClass,
          toggleClass: toggleClass,
          show: show,
          hide: hide,
          isHidden: isHidden,
          uniqueId: uniqueId,
          setHTML: setHTML,
          getOuterHTML: getOuterHTML,
          setOuterHTML: setOuterHTML,
          decode: decode,
          encode: encode,
          insertAfter: insertAfter,
          replace: replace,
          rename: rename,
          findCommonAncestor: findCommonAncestor,
          toHex: toHex,
          run: run,
          getAttribs: getAttribs,
          isEmpty: isEmpty,
          createRng: createRng,
          nodeIndex: findNodeIndex,
          split: split,
          bind: bind,
          unbind: unbind,
          fire: fire,
          getContentEditable: getContentEditable,
          getContentEditableParent: getContentEditableParent,
          destroy: destroy,
          isChildOf: isChildOf,
          dumpRng: dumpRng
        };
        attrHooks = setupAttrHooks(styles, settings, function () {
          return self;
        });
        return self;
      }
      (function (DOMUtils) {
        DOMUtils.DOM = DOMUtils(document);
        DOMUtils.nodeIndex = findNodeIndex;
      }(DOMUtils || (DOMUtils = {})));
      var DOMUtils$1 = DOMUtils;

      var DOM = DOMUtils$1.DOM;
      var each$6 = $_ahowuxkjh8lywbj.each;
      var grep$2 = $_ahowuxkjh8lywbj.grep;
      var isFunction = function (f) {
        return typeof f === 'function';
      };
      var ScriptLoader = function () {
        var QUEUED = 0;
        var LOADING = 1;
        var LOADED = 2;
        var FAILED = 3;
        var states = {};
        var queue = [];
        var scriptLoadedCallbacks = {};
        var queueLoadedCallbacks = [];
        var loading = 0;
        var loadScript = function (url, success, failure) {
          var dom = DOM;
          var elm, id;
          var done = function () {
            dom.remove(id);
            if (elm) {
              elm.onreadystatechange = elm.onload = elm = null;
            }
            success();
          };
          var error = function () {
            if (isFunction(failure)) {
              failure();
            } else {
              if (typeof console !== 'undefined' && console.log) {
                console.log('Failed to load script: ' + url);
              }
            }
          };
          id = dom.uniqueId();
          elm = document.createElement('script');
          elm.id = id;
          elm.type = 'text/javascript';
          elm.src = $_ahowuxkjh8lywbj._addCacheSuffix(url);
          if ('onreadystatechange' in elm) {
            elm.onreadystatechange = function () {
              if (/loaded|complete/.test(elm.readyState)) {
                done();
              }
            };
          } else {
            elm.onload = done;
          }
          elm.onerror = error;
          (document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
        };
        this.isDone = function (url) {
          return states[url] === LOADED;
        };
        this.markDone = function (url) {
          states[url] = LOADED;
        };
        this.add = this.load = function (url, success, scope, failure) {
          var state = states[url];
          if (state === undefined) {
            queue.push(url);
            states[url] = QUEUED;
          }
          if (success) {
            if (!scriptLoadedCallbacks[url]) {
              scriptLoadedCallbacks[url] = [];
            }
            scriptLoadedCallbacks[url].push({
              success: success,
              failure: failure,
              scope: scope || this
            });
          }
        };
        this.remove = function (url) {
          delete states[url];
          delete scriptLoadedCallbacks[url];
        };
        this.loadQueue = function (success, scope, failure) {
          this.loadScripts(queue, success, scope, failure);
        };
        this.loadScripts = function (scripts, success, scope, failure) {
          var loadScripts;
          var failures = [];
          var execCallbacks = function (name, url) {
            each$6(scriptLoadedCallbacks[url], function (callback) {
              if (isFunction(callback[name])) {
                callback[name].call(callback.scope);
              }
            });
            scriptLoadedCallbacks[url] = undefined;
          };
          queueLoadedCallbacks.push({
            success: success,
            failure: failure,
            scope: scope || this
          });
          loadScripts = function () {
            var loadingScripts = grep$2(scripts);
            scripts.length = 0;
            each$6(loadingScripts, function (url) {
              if (states[url] === LOADED) {
                execCallbacks('success', url);
                return;
              }
              if (states[url] === FAILED) {
                execCallbacks('failure', url);
                return;
              }
              if (states[url] !== LOADING) {
                states[url] = LOADING;
                loading++;
                loadScript(url, function () {
                  states[url] = LOADED;
                  loading--;
                  execCallbacks('success', url);
                  loadScripts();
                }, function () {
                  states[url] = FAILED;
                  loading--;
                  failures.push(url);
                  execCallbacks('failure', url);
                  loadScripts();
                });
              }
            });
            if (!loading) {
              var notifyCallbacks = queueLoadedCallbacks.slice(0);
              queueLoadedCallbacks.length = 0;
              each$6(notifyCallbacks, function (callback) {
                if (failures.length === 0) {
                  if (isFunction(callback.success)) {
                    callback.success.call(callback.scope);
                  }
                } else {
                  if (isFunction(callback.failure)) {
                    callback.failure.call(callback.scope, failures);
                  }
                }
              });
            }
          };
          loadScripts();
        };
      };
      ScriptLoader.ScriptLoader = new ScriptLoader();

      var each$7 = $_ahowuxkjh8lywbj.each;
      function AddOnManager() {
        var _this = this;
        var items = [];
        var urls = {};
        var lookup = {};
        var _listeners = [];
        var get = function (name) {
          if (lookup[name]) {
            return lookup[name].instance;
          }
          return undefined;
        };
        var dependencies = function (name) {
          var result;
          if (lookup[name]) {
            result = lookup[name].dependencies;
          }
          return result || [];
        };
        var requireLangPack = function (name, languages) {
          var language = AddOnManager.language;
          if (language && AddOnManager.languageLoad !== false) {
            if (languages) {
              languages = ',' + languages + ',';
              if (languages.indexOf(',' + language.substr(0, 2) + ',') !== -1) {
                language = language.substr(0, 2);
              } else if (languages.indexOf(',' + language + ',') === -1) {
                return;
              }
            }
            ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
          }
        };
        var add = function (id, addOn, dependencies) {
          items.push(addOn);
          lookup[id] = {
            instance: addOn,
            dependencies: dependencies
          };
          var result = $_5wjzy24jh8lyw2t.partition(_listeners, function (listener) {
            return listener.name === id;
          });
          _listeners = result.fail;
          each$7(result.pass, function (listener) {
            listener.callback();
          });
          return addOn;
        };
        var remove = function (name) {
          delete urls[name];
          delete lookup[name];
        };
        var createUrl = function (baseUrl, dep) {
          if (typeof dep === 'object') {
            return dep;
          }
          return typeof baseUrl === 'string' ? {
            prefix: '',
            resource: dep,
            suffix: ''
          } : {
            prefix: baseUrl.prefix,
            resource: dep,
            suffix: baseUrl.suffix
          };
        };
        var addComponents = function (pluginName, scripts) {
          var pluginUrl = _this.urls[pluginName];
          each$7(scripts, function (script) {
            ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
          });
        };
        var loadDependencies = function (addOnUrl, success, scope) {
          var deps = dependencies(name);
          each$7(deps, function (dep) {
            var newUrl = createUrl(addOnUrl, dep);
            load(newUrl.resource, newUrl, undefined, undefined);
          });
          if (success) {
            if (scope) {
              success.call(scope);
            } else {
              success.call(ScriptLoader);
            }
          }
        };
        var load = function (name, addOnUrl, success, scope, failure) {
          if (urls[name]) {
            return;
          }
          var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
          if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
            urlString = AddOnManager.baseURL + '/' + urlString;
          }
          urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
          if (lookup[name]) {
            loadDependencies(addOnUrl, success, scope);
          } else {
            ScriptLoader.ScriptLoader.add(urlString, function () {
              return loadDependencies(addOnUrl, success, scope);
            }, scope, failure);
          }
        };
        var waitFor = function (name, callback) {
          if (lookup.hasOwnProperty(name)) {
            callback();
          } else {
            _listeners.push({
              name: name,
              callback: callback
            });
          }
        };
        return {
          items: items,
          urls: urls,
          lookup: lookup,
          _listeners: _listeners,
          get: get,
          dependencies: dependencies,
          requireLangPack: requireLangPack,
          add: add,
          remove: remove,
          createUrl: createUrl,
          addComponents: addComponents,
          load: load,
          waitFor: waitFor
        };
      }
      (function (AddOnManager) {
        AddOnManager.PluginManager = AddOnManager();
        AddOnManager.ThemeManager = AddOnManager();
      }(AddOnManager || (AddOnManager = {})));

      var ZWSP = '\uFEFF';
      var isZwsp = function (chr) {
        return chr === ZWSP;
      };
      var trim$3 = function (text) {
        return text.replace(new RegExp(ZWSP, 'g'), '');
      };
      var $_d383mr21jh8lywlv = {
        isZwsp: isZwsp,
        ZWSP: ZWSP,
        trim: trim$3
      };

      var isElement$2 = $_5oonaz1qjh8lywhz.isElement;
      var isText$2 = $_5oonaz1qjh8lywhz.isText;
      var isCaretContainerBlock = function (node) {
        if (isText$2(node)) {
          node = node.parentNode;
        }
        return isElement$2(node) && node.hasAttribute('data-mce-caret');
      };
      var isCaretContainerInline = function (node) {
        return isText$2(node) && $_d383mr21jh8lywlv.isZwsp(node.data);
      };
      var isCaretContainer = function (node) {
        return isCaretContainerBlock(node) || isCaretContainerInline(node);
      };
      var hasContent = function (node) {
        return node.firstChild !== node.lastChild || !$_5oonaz1qjh8lywhz.isBr(node.firstChild);
      };
      var insertInline = function (node, before) {
        var doc, sibling, textNode, parentNode;
        doc = node.ownerDocument;
        textNode = doc.createTextNode($_d383mr21jh8lywlv.ZWSP);
        parentNode = node.parentNode;
        if (!before) {
          sibling = node.nextSibling;
          if (isText$2(sibling)) {
            if (isCaretContainer(sibling)) {
              return sibling;
            }
            if (startsWithCaretContainer(sibling)) {
              sibling.splitText(1);
              return sibling;
            }
          }
          if (node.nextSibling) {
            parentNode.insertBefore(textNode, node.nextSibling);
          } else {
            parentNode.appendChild(textNode);
          }
        } else {
          sibling = node.previousSibling;
          if (isText$2(sibling)) {
            if (isCaretContainer(sibling)) {
              return sibling;
            }
            if (endsWithCaretContainer(sibling)) {
              return sibling.splitText(sibling.data.length - 1);
            }
          }
          parentNode.insertBefore(textNode, node);
        }
        return textNode;
      };
      var isBeforeInline = function (pos) {
        var container = pos.container();
        return pos && $_5oonaz1qjh8lywhz.isText(container) && container.data.charAt(pos.offset()) === $_d383mr21jh8lywlv.ZWSP;
      };
      var isAfterInline = function (pos) {
        var container = pos.container();
        return pos && $_5oonaz1qjh8lywhz.isText(container) && container.data.charAt(pos.offset() - 1) === $_d383mr21jh8lywlv.ZWSP;
      };
      var createBogusBr = function () {
        var br = document.createElement('br');
        br.setAttribute('data-mce-bogus', '1');
        return br;
      };
      var insertBlock = function (blockName, node, before) {
        var doc, blockNode, parentNode;
        doc = node.ownerDocument;
        blockNode = doc.createElement(blockName);
        blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
        blockNode.setAttribute('data-mce-bogus', 'all');
        blockNode.appendChild(createBogusBr());
        parentNode = node.parentNode;
        if (!before) {
          if (node.nextSibling) {
            parentNode.insertBefore(blockNode, node.nextSibling);
          } else {
            parentNode.appendChild(blockNode);
          }
        } else {
          parentNode.insertBefore(blockNode, node);
        }
        return blockNode;
      };
      var startsWithCaretContainer = function (node) {
        return isText$2(node) && node.data[0] === $_d383mr21jh8lywlv.ZWSP;
      };
      var endsWithCaretContainer = function (node) {
        return isText$2(node) && node.data[node.data.length - 1] === $_d383mr21jh8lywlv.ZWSP;
      };
      var trimBogusBr = function (elm) {
        var brs = elm.getElementsByTagName('br');
        var lastBr = brs[brs.length - 1];
        if ($_5oonaz1qjh8lywhz.isBogus(lastBr)) {
          lastBr.parentNode.removeChild(lastBr);
        }
      };
      var showCaretContainerBlock = function (caretContainer) {
        if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
          trimBogusBr(caretContainer);
          caretContainer.removeAttribute('data-mce-caret');
          caretContainer.removeAttribute('data-mce-bogus');
          caretContainer.removeAttribute('style');
          caretContainer.removeAttribute('_moz_abspos');
          return caretContainer;
        }
        return null;
      };
      var isRangeInCaretContainerBlock = function (range) {
        return isCaretContainerBlock(range.startContainer);
      };

      var isContentEditableTrue$1 = $_5oonaz1qjh8lywhz.isContentEditableTrue;
      var isContentEditableFalse$1 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isBr$2 = $_5oonaz1qjh8lywhz.isBr;
      var isText$3 = $_5oonaz1qjh8lywhz.isText;
      var isInvalidTextElement = $_5oonaz1qjh8lywhz.matchNodeNames('script style textarea');
      var isAtomicInline = $_5oonaz1qjh8lywhz.matchNodeNames('img input textarea hr iframe video audio object');
      var isTable$1 = $_5oonaz1qjh8lywhz.matchNodeNames('table');
      var isCaretContainer$1 = isCaretContainer;
      var isCaretCandidate = function (node) {
        if (isCaretContainer$1(node)) {
          return false;
        }
        if (isText$3(node)) {
          if (isInvalidTextElement(node.parentNode)) {
            return false;
          }
          return true;
        }
        return isAtomicInline(node) || isBr$2(node) || isTable$1(node) || isNonUiContentEditableFalse(node);
      };
      var isUnselectable = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && node.getAttribute('unselectable') === 'true';
      };
      var isNonUiContentEditableFalse = function (node) {
        return isUnselectable(node) === false && isContentEditableFalse$1(node);
      };
      var isInEditable = function (node, root) {
        for (node = node.parentNode; node && node !== root; node = node.parentNode) {
          if (isNonUiContentEditableFalse(node)) {
            return false;
          }
          if (isContentEditableTrue$1(node)) {
            return true;
          }
        }
        return true;
      };
      var isAtomicContentEditableFalse = function (node) {
        if (!isNonUiContentEditableFalse(node)) {
          return false;
        }
        return $_9tjm51ljh8lywbq.reduce(node.getElementsByTagName('*'), function (result, elm) {
          return result || isContentEditableTrue$1(elm);
        }, false) !== true;
      };
      var isAtomic = function (node) {
        return isAtomicInline(node) || isAtomicContentEditableFalse(node);
      };
      var isEditableCaretCandidate = function (node, root) {
        return isCaretCandidate(node) && isInEditable(node, root);
      };

      var round = Math.round;
      var clone$1 = function (rect) {
        if (!rect) {
          return {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            width: 0,
            height: 0
          };
        }
        return {
          left: round(rect.left),
          top: round(rect.top),
          bottom: round(rect.bottom),
          right: round(rect.right),
          width: round(rect.width),
          height: round(rect.height)
        };
      };
      var collapse = function (rect, toStart) {
        rect = clone$1(rect);
        if (toStart) {
          rect.right = rect.left;
        } else {
          rect.left = rect.left + rect.width;
          rect.right = rect.left;
        }
        rect.width = 0;
        return rect;
      };
      var isEqual = function (rect1, rect2) {
        return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
      };
      var isValidOverflow = function (overflowY, rect1, rect2) {
        return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
      };
      var isAbove = function (rect1, rect2) {
        if (rect1.bottom - rect1.height / 2 < rect2.top) {
          return true;
        }
        if (rect1.top > rect2.bottom) {
          return false;
        }
        return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
      };
      var isBelow = function (rect1, rect2) {
        if (rect1.top > rect2.bottom) {
          return true;
        }
        if (rect1.bottom < rect2.top) {
          return false;
        }
        return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
      };
      var containsXY = function (rect, clientX, clientY) {
        return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
      };
      var overflowX = function (outer, inner) {
        if (inner.left > outer.left && inner.right < outer.right) {
          return 0;
        } else {
          return inner.left < outer.left ? inner.left - outer.left : inner.right - outer.right;
        }
      };
      var overflowY = function (outer, inner) {
        if (inner.top > outer.top && inner.bottom < outer.bottom) {
          return 0;
        } else {
          return inner.top < outer.top ? inner.top - outer.top : inner.bottom - outer.bottom;
        }
      };
      var getOverflow = function (outer, inner) {
        return {
          x: overflowX(outer, inner),
          y: overflowY(outer, inner)
        };
      };

      var getSelectedNode = function (range) {
        var startContainer = range.startContainer, startOffset = range.startOffset;
        if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
          return startContainer.childNodes[startOffset];
        }
        return null;
      };
      var getNode = function (container, offset) {
        if (container.nodeType === 1 && container.hasChildNodes()) {
          if (offset >= container.childNodes.length) {
            offset = container.childNodes.length - 1;
          }
          container = container.childNodes[offset];
        }
        return container;
      };

      var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08E3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\uA69E-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\uFE2F\uff9e-\uff9f]');
      var isExtendingChar = function (ch) {
        return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
      };

      var slice$3 = [].slice;
      var constant$1 = function (value) {
        return function () {
          return value;
        };
      };
      var negate = function (predicate) {
        return function (x) {
          return !predicate(x);
        };
      };
      var compose$2 = function (f, g) {
        return function (x) {
          return f(g(x));
        };
      };
      var or = function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var args = slice$3.call(arguments);
        return function (x) {
          for (var i = 0; i < args.length; i++) {
            if (args[i](x)) {
              return true;
            }
          }
          return false;
        };
      };
      var and = function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var args = slice$3.call(arguments);
        return function (x) {
          for (var i = 0; i < args.length; i++) {
            if (!args[i](x)) {
              return false;
            }
          }
          return true;
        };
      };
      var curry$1 = function (fn) {
        var x = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          x[_i - 1] = arguments[_i];
        }
        var args = slice$3.call(arguments);
        if (args.length - 1 >= fn.length) {
          return fn.apply(this, args.slice(1));
        }
        return function () {
          var tempArgs = args.concat([].slice.call(arguments));
          return curry$1.apply(this, tempArgs);
        };
      };
      var noop$1 = function () {
      };
      var $_8aqzj925jh8lywmj = {
        constant: constant$1,
        negate: negate,
        and: and,
        or: or,
        curry: curry$1,
        compose: compose$2,
        noop: noop$1
      };

      var cat = function (arr) {
        var r = [];
        var push = function (x) {
          r.push(x);
        };
        for (var i = 0; i < arr.length; i++) {
          arr[i].each(push);
        }
        return r;
      };
      var findMap = function (arr, f) {
        for (var i = 0; i < arr.length; i++) {
          var r = f(arr[i], i);
          if (r.isSome()) {
            return r;
          }
        }
        return Option.none();
      };
      var liftN = function (arr, f) {
        var r = [];
        for (var i = 0; i < arr.length; i++) {
          var x = arr[i];
          if (x.isSome()) {
            r.push(x.getOrDie());
          } else {
            return Option.none();
          }
        }
        return Option.some(f.apply(null, r));
      };
      var $_b8twwq26jh8lywmm = {
        cat: cat,
        findMap: findMap,
        liftN: liftN
      };

      var isElement$3 = $_5oonaz1qjh8lywhz.isElement;
      var isCaretCandidate$1 = isCaretCandidate;
      var isBlock$1 = $_5oonaz1qjh8lywhz.matchStyleValues('display', 'block table');
      var isFloated = $_5oonaz1qjh8lywhz.matchStyleValues('float', 'left right');
      var isValidElementCaretCandidate = $_8aqzj925jh8lywmj.and(isElement$3, isCaretCandidate$1, $_8aqzj925jh8lywmj.negate(isFloated));
      var isNotPre = $_8aqzj925jh8lywmj.negate($_5oonaz1qjh8lywhz.matchStyleValues('white-space', 'pre pre-line pre-wrap'));
      var isText$4 = $_5oonaz1qjh8lywhz.isText;
      var isBr$3 = $_5oonaz1qjh8lywhz.isBr;
      var nodeIndex = DOMUtils$1.nodeIndex;
      var resolveIndex = getNode;
      var createRange = function (doc) {
        return 'createRange' in doc ? doc.createRange() : DOMUtils$1.DOM.createRng();
      };
      var isWhiteSpace = function (chr) {
        return chr && /[\r\n\t ]/.test(chr);
      };
      var isRange = function (rng) {
        return !!rng.setStart && !!rng.setEnd;
      };
      var isHiddenWhiteSpaceRange = function (range) {
        var container = range.startContainer;
        var offset = range.startOffset;
        var text;
        if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode) && $_5oonaz1qjh8lywhz.isText(container)) {
          text = container.data;
          if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
            return true;
          }
        }
        return false;
      };
      var getBrClientRect = function (brNode) {
        var doc = brNode.ownerDocument;
        var rng = createRange(doc);
        var nbsp = doc.createTextNode('\xA0');
        var parentNode = brNode.parentNode;
        var clientRect;
        parentNode.insertBefore(nbsp, brNode);
        rng.setStart(nbsp, 0);
        rng.setEnd(nbsp, 1);
        clientRect = clone$1(rng.getBoundingClientRect());
        parentNode.removeChild(nbsp);
        return clientRect;
      };
      var getBoundingClientRectWebKitText = function (rng) {
        var sc = rng.startContainer;
        var ec = rng.endContainer;
        var so = rng.startOffset;
        var eo = rng.endOffset;
        if (sc === ec && $_5oonaz1qjh8lywhz.isText(ec) && so === 0 && eo === 1) {
          var newRng = rng.cloneRange();
          newRng.setEndAfter(ec);
          return getBoundingClientRect(newRng);
        } else {
          return null;
        }
      };
      var isZeroRect = function (r) {
        return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
      };
      var getBoundingClientRect = function (item) {
        var clientRect, clientRects;
        clientRects = item.getClientRects();
        if (clientRects.length > 0) {
          clientRect = clone$1(clientRects[0]);
        } else {
          clientRect = clone$1(item.getBoundingClientRect());
        }
        if (!isRange(item) && isBr$3(item) && isZeroRect(clientRect)) {
          return getBrClientRect(item);
        }
        if (isZeroRect(clientRect) && isRange(item)) {
          return getBoundingClientRectWebKitText(item);
        }
        return clientRect;
      };
      var collapseAndInflateWidth = function (clientRect, toStart) {
        var newClientRect = collapse(clientRect, toStart);
        newClientRect.width = 1;
        newClientRect.right = newClientRect.left + 1;
        return newClientRect;
      };
      var getCaretPositionClientRects = function (caretPosition) {
        var clientRects = [];
        var beforeNode, node;
        var addUniqueAndValidRect = function (clientRect) {
          if (clientRect.height === 0) {
            return;
          }
          if (clientRects.length > 0) {
            if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
              return;
            }
          }
          clientRects.push(clientRect);
        };
        var addCharacterOffset = function (container, offset) {
          var range = createRange(container.ownerDocument);
          if (offset < container.data.length) {
            if (isExtendingChar(container.data[offset])) {
              return clientRects;
            }
            if (isExtendingChar(container.data[offset - 1])) {
              range.setStart(container, offset);
              range.setEnd(container, offset + 1);
              if (!isHiddenWhiteSpaceRange(range)) {
                addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
                return clientRects;
              }
            }
          }
          if (offset > 0) {
            range.setStart(container, offset - 1);
            range.setEnd(container, offset);
            if (!isHiddenWhiteSpaceRange(range)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
            }
          }
          if (offset < container.data.length) {
            range.setStart(container, offset);
            range.setEnd(container, offset + 1);
            if (!isHiddenWhiteSpaceRange(range)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
            }
          }
        };
        if (isText$4(caretPosition.container())) {
          addCharacterOffset(caretPosition.container(), caretPosition.offset());
          return clientRects;
        }
        if (isElement$3(caretPosition.container())) {
          if (caretPosition.isAtEnd()) {
            node = resolveIndex(caretPosition.container(), caretPosition.offset());
            if (isText$4(node)) {
              addCharacterOffset(node, node.data.length);
            }
            if (isValidElementCaretCandidate(node) && !isBr$3(node)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
            }
          } else {
            node = resolveIndex(caretPosition.container(), caretPosition.offset());
            if (isText$4(node)) {
              addCharacterOffset(node, 0);
            }
            if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
              return clientRects;
            }
            beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
            if (isValidElementCaretCandidate(beforeNode) && !isBr$3(beforeNode)) {
              if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
                addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
              }
            }
            if (isValidElementCaretCandidate(node)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
            }
          }
        }
        return clientRects;
      };
      function CaretPosition(container, offset, clientRects) {
        var isAtStart = function () {
          if (isText$4(container)) {
            return offset === 0;
          }
          return offset === 0;
        };
        var isAtEnd = function () {
          if (isText$4(container)) {
            return offset >= container.data.length;
          }
          return offset >= container.childNodes.length;
        };
        var toRange = function () {
          var range;
          range = createRange(container.ownerDocument);
          range.setStart(container, offset);
          range.setEnd(container, offset);
          return range;
        };
        var getClientRects = function () {
          if (!clientRects) {
            clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
          }
          return clientRects;
        };
        var isVisible = function () {
          return getClientRects().length > 0;
        };
        var isEqual$$1 = function (caretPosition) {
          return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
        };
        var getNode$$1 = function (before) {
          return resolveIndex(container, before ? offset - 1 : offset);
        };
        return {
          container: $_8aqzj925jh8lywmj.constant(container),
          offset: $_8aqzj925jh8lywmj.constant(offset),
          toRange: toRange,
          getClientRects: getClientRects,
          isVisible: isVisible,
          isAtStart: isAtStart,
          isAtEnd: isAtEnd,
          isEqual: isEqual$$1,
          getNode: getNode$$1
        };
      }
      (function (CaretPosition) {
        CaretPosition.fromRangeStart = function (range) {
          return CaretPosition(range.startContainer, range.startOffset);
        };
        CaretPosition.fromRangeEnd = function (range) {
          return CaretPosition(range.endContainer, range.endOffset);
        };
        CaretPosition.after = function (node) {
          return CaretPosition(node.parentNode, nodeIndex(node) + 1);
        };
        CaretPosition.before = function (node) {
          return CaretPosition(node.parentNode, nodeIndex(node));
        };
        CaretPosition.isAbove = function (pos1, pos2) {
          return $_b8twwq26jh8lywmm.liftN([
            $_5wjzy24jh8lyw2t.head(pos2.getClientRects()),
            $_5wjzy24jh8lyw2t.last(pos1.getClientRects())
          ], isAbove).getOr(false);
        };
        CaretPosition.isBelow = function (pos1, pos2) {
          return $_b8twwq26jh8lywmm.liftN([
            $_5wjzy24jh8lyw2t.last(pos2.getClientRects()),
            $_5wjzy24jh8lyw2t.head(pos1.getClientRects())
          ], isBelow).getOr(false);
        };
        CaretPosition.isAtStart = function (pos) {
          return pos ? pos.isAtStart() : false;
        };
        CaretPosition.isAtEnd = function (pos) {
          return pos ? pos.isAtEnd() : false;
        };
        CaretPosition.isTextPosition = function (pos) {
          return pos ? $_5oonaz1qjh8lywhz.isText(pos.container()) : false;
        };
        CaretPosition.isElementPosition = function (pos) {
          return CaretPosition.isTextPosition(pos) === false;
        };
      }(CaretPosition || (CaretPosition = {})));
      var CaretPosition$1 = CaretPosition;

      var isElement$4 = $_5oonaz1qjh8lywhz.isElement;
      var isText$5 = $_5oonaz1qjh8lywhz.isText;
      var removeNode = function (node) {
        var parentNode = node.parentNode;
        if (parentNode) {
          parentNode.removeChild(node);
        }
      };
      var getNodeValue = function (node) {
        try {
          return node.nodeValue;
        } catch (ex) {
          return '';
        }
      };
      var setNodeValue = function (node, text) {
        if (text.length === 0) {
          removeNode(node);
        } else {
          node.nodeValue = text;
        }
      };
      var trimCount = function (text) {
        var trimmedText = $_d383mr21jh8lywlv.trim(text);
        return {
          count: text.length - trimmedText.length,
          text: trimmedText
        };
      };
      var removeUnchanged = function (caretContainer, pos) {
        remove$2(caretContainer);
        return pos;
      };
      var removeTextAndReposition = function (caretContainer, pos) {
        var before = trimCount(caretContainer.data.substr(0, pos.offset()));
        var after = trimCount(caretContainer.data.substr(pos.offset()));
        var text = before.text + after.text;
        if (text.length > 0) {
          setNodeValue(caretContainer, text);
          return CaretPosition$1(caretContainer, pos.offset() - before.count);
        } else {
          return pos;
        }
      };
      var removeElementAndReposition = function (caretContainer, pos) {
        var parentNode = pos.container();
        var newPosition = $_5wjzy24jh8lyw2t.indexOf($_5wjzy24jh8lyw2t.from(parentNode.childNodes), caretContainer).map(function (index) {
          return index < pos.offset() ? CaretPosition$1(parentNode, pos.offset() - 1) : pos;
        }).getOr(pos);
        remove$2(caretContainer);
        return newPosition;
      };
      var removeTextCaretContainer = function (caretContainer, pos) {
        return isText$5(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
      };
      var removeElementCaretContainer = function (caretContainer, pos) {
        return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
      };
      var removeAndReposition = function (container, pos) {
        return CaretPosition$1.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
      };
      var remove$2 = function (caretContainerNode) {
        if (isElement$4(caretContainerNode) && isCaretContainer(caretContainerNode)) {
          if (hasContent(caretContainerNode)) {
            caretContainerNode.removeAttribute('data-mce-caret');
          } else {
            removeNode(caretContainerNode);
          }
        }
        if (isText$5(caretContainerNode)) {
          var text = $_d383mr21jh8lywlv.trim(getNodeValue(caretContainerNode));
          setNodeValue(caretContainerNode, text);
        }
      };
      var $_9nl16f2ajh8lywne = {
        removeAndReposition: removeAndReposition,
        remove: remove$2
      };

      var walkToPositionIn = function (forward, root, start) {
        var position = forward ? CaretPosition$1.before(start) : CaretPosition$1.after(start);
        return fromPosition(forward, root, position);
      };
      var afterElement = function (node) {
        return $_5oonaz1qjh8lywhz.isBr(node) ? CaretPosition$1.before(node) : CaretPosition$1.after(node);
      };
      var isBeforeOrStart = function (position) {
        if (CaretPosition$1.isTextPosition(position)) {
          return position.offset() === 0;
        } else {
          return isCaretCandidate(position.getNode());
        }
      };
      var isAfterOrEnd = function (position) {
        if (CaretPosition$1.isTextPosition(position)) {
          var container = position.container();
          return position.offset() === container.data.length;
        } else {
          return isCaretCandidate(position.getNode(true));
        }
      };
      var isBeforeAfterSameElement = function (from, to) {
        return !CaretPosition$1.isTextPosition(from) && !CaretPosition$1.isTextPosition(to) && from.getNode() === to.getNode(true);
      };
      var isAtBr = function (position) {
        return !CaretPosition$1.isTextPosition(position) && $_5oonaz1qjh8lywhz.isBr(position.getNode());
      };
      var shouldSkipPosition = function (forward, from, to) {
        if (forward) {
          return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
        } else {
          return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
        }
      };
      var fromPosition = function (forward, root, pos) {
        var walker = CaretWalker(root);
        return Option.from(forward ? walker.next(pos) : walker.prev(pos));
      };
      var navigate = function (forward, root, from) {
        return fromPosition(forward, root, from).bind(function (to) {
          if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
            return fromPosition(forward, root, to);
          } else {
            return Option.some(to);
          }
        });
      };
      var positionIn = function (forward, element) {
        var startNode = forward ? element.firstChild : element.lastChild;
        if ($_5oonaz1qjh8lywhz.isText(startNode)) {
          return Option.some(CaretPosition$1(startNode, forward ? 0 : startNode.data.length));
        } else if (startNode) {
          if (isCaretCandidate(startNode)) {
            return Option.some(forward ? CaretPosition$1.before(startNode) : afterElement(startNode));
          } else {
            return walkToPositionIn(forward, element, startNode);
          }
        } else {
          return Option.none();
        }
      };
      var $_9kvypj2cjh8lywnz = {
        fromPosition: fromPosition,
        nextPosition: $_eqpqvr6jh8lyw3s.curry(fromPosition, true),
        prevPosition: $_eqpqvr6jh8lyw3s.curry(fromPosition, false),
        navigate: navigate,
        positionIn: positionIn,
        firstPositionIn: $_eqpqvr6jh8lyw3s.curry(positionIn, true),
        lastPositionIn: $_eqpqvr6jh8lyw3s.curry(positionIn, false)
      };

      var isContentEditableTrue$2 = $_5oonaz1qjh8lywhz.isContentEditableTrue;
      var isContentEditableFalse$2 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var showCaret = function (direction, editor, node, before, scrollIntoView) {
        return editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView);
      };
      var getNodeRange = function (node) {
        var rng = node.ownerDocument.createRange();
        rng.selectNode(node);
        return rng;
      };
      var selectNode = function (editor, node) {
        var e = editor.fire('BeforeObjectSelected', { target: node });
        if (e.isDefaultPrevented()) {
          return null;
        }
        return getNodeRange(node);
      };
      var renderCaretAtRange = function (editor, range, scrollIntoView) {
        var normalizedRange = normalizeRange(1, editor.getBody(), range);
        var caretPosition = CaretPosition$1.fromRangeStart(normalizedRange);
        var caretPositionNode = caretPosition.getNode();
        if (isContentEditableFalse$2(caretPositionNode)) {
          return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
        }
        var caretPositionBeforeNode = caretPosition.getNode(true);
        if (isContentEditableFalse$2(caretPositionBeforeNode)) {
          return showCaret(1, editor, caretPositionBeforeNode, false, false);
        }
        var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
          return isContentEditableFalse$2(node) || isContentEditableTrue$2(node);
        });
        if (isContentEditableFalse$2(ceRoot)) {
          return showCaret(1, editor, ceRoot, false, scrollIntoView);
        }
        return null;
      };
      var renderRangeCaret = function (editor, range, scrollIntoView) {
        if (!range || !range.collapsed) {
          return range;
        }
        var caretRange = renderCaretAtRange(editor, range, scrollIntoView);
        if (caretRange) {
          return caretRange;
        }
        return range;
      };

      var BreakType;
      (function (BreakType) {
        BreakType[BreakType['Br'] = 0] = 'Br';
        BreakType[BreakType['Block'] = 1] = 'Block';
        BreakType[BreakType['Wrap'] = 2] = 'Wrap';
        BreakType[BreakType['Eol'] = 3] = 'Eol';
      }(BreakType || (BreakType = {})));
      var flip = function (direction, positions) {
        return direction === HDirection.Backwards ? positions.reverse() : positions;
      };
      var walk$1 = function (direction, caretWalker, pos) {
        return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
      };
      var getBreakType = function (scope, direction, currentPos, nextPos) {
        if ($_5oonaz1qjh8lywhz.isBr(nextPos.getNode(direction === HDirection.Forwards))) {
          return BreakType.Br;
        } else if (isInSameBlock(currentPos, nextPos) === false) {
          return BreakType.Block;
        } else {
          return BreakType.Wrap;
        }
      };
      var getPositionsUntil = function (predicate, direction, scope, start) {
        var caretWalker = CaretWalker(scope);
        var currentPos = start, nextPos;
        var positions = [];
        while (currentPos) {
          nextPos = walk$1(direction, caretWalker, currentPos);
          if (!nextPos) {
            break;
          }
          if ($_5oonaz1qjh8lywhz.isBr(nextPos.getNode(false))) {
            if (direction === HDirection.Forwards) {
              return {
                positions: flip(direction, positions).concat([nextPos]),
                breakType: BreakType.Br,
                breakAt: Option.some(nextPos)
              };
            } else {
              return {
                positions: flip(direction, positions),
                breakType: BreakType.Br,
                breakAt: Option.some(nextPos)
              };
            }
          }
          if (!nextPos.isVisible()) {
            currentPos = nextPos;
            continue;
          }
          if (predicate(currentPos, nextPos)) {
            var breakType = getBreakType(scope, direction, currentPos, nextPos);
            return {
              positions: flip(direction, positions),
              breakType: breakType,
              breakAt: Option.some(nextPos)
            };
          }
          positions.push(nextPos);
          currentPos = nextPos;
        }
        return {
          positions: flip(direction, positions),
          breakType: BreakType.Eol,
          breakAt: Option.none()
        };
      };
      var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
        return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
          var positions = getPositionsUntilBreak(scope, pos).positions;
          return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
        }).getOr([]);
      };
      var findClosestHorizontalPositionFromPoint = function (positions, x) {
        return $_5wjzy24jh8lyw2t.foldl(positions, function (acc, newPos) {
          return acc.fold(function () {
            return Option.some(newPos);
          }, function (lastPos) {
            return $_b8twwq26jh8lywmm.liftN([
              $_5wjzy24jh8lyw2t.head(lastPos.getClientRects()),
              $_5wjzy24jh8lyw2t.head(newPos.getClientRects())
            ], function (lastRect, newRect) {
              var lastDist = Math.abs(x - lastRect.left);
              var newDist = Math.abs(x - newRect.left);
              return newDist <= lastDist ? newPos : lastPos;
            }).or(acc);
          });
        }, Option.none());
      };
      var findClosestHorizontalPosition = function (positions, pos) {
        return $_5wjzy24jh8lyw2t.head(pos.getClientRects()).bind(function (targetRect) {
          return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
        });
      };
      var getPositionsUntilPreviousLine = $_eqpqvr6jh8lyw3s.curry(getPositionsUntil, CaretPosition.isAbove, -1);
      var getPositionsUntilNextLine = $_eqpqvr6jh8lyw3s.curry(getPositionsUntil, CaretPosition.isBelow, 1);
      var getPositionsAbove = $_eqpqvr6jh8lyw3s.curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
      var getPositionsBelow = $_eqpqvr6jh8lyw3s.curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
      var getFirstLinePositions = function (scope) {
        return $_9kvypj2cjh8lywnz.firstPositionIn(scope).map(function (pos) {
          return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
        }).getOr([]);
      };
      var getLastLinePositions = function (scope) {
        return $_9kvypj2cjh8lywnz.lastPositionIn(scope).map(function (pos) {
          return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
        }).getOr([]);
      };

      var all$1 = function (predicate) {
        return descendants($_boa99a15jh8lywey.body(), predicate);
      };
      var ancestors = function (scope, predicate, isRoot) {
        return $_5wjzy24jh8lyw2t.filter($_a43q0i17jh8lywfe.parents(scope, isRoot), predicate);
      };
      var siblings$1 = function (scope, predicate) {
        return $_5wjzy24jh8lyw2t.filter($_a43q0i17jh8lywfe.siblings(scope), predicate);
      };
      var children$1 = function (scope, predicate) {
        return $_5wjzy24jh8lyw2t.filter($_a43q0i17jh8lywfe.children(scope), predicate);
      };
      var descendants = function (scope, predicate) {
        var result = [];
        $_5wjzy24jh8lyw2t.each($_a43q0i17jh8lywfe.children(scope), function (x) {
          if (predicate(x)) {
            result = result.concat([x]);
          }
          result = result.concat(descendants(x, predicate));
        });
        return result;
      };
      var $_6y3ft32hjh8lywp5 = {
        all: all$1,
        ancestors: ancestors,
        siblings: siblings$1,
        children: children$1,
        descendants: descendants
      };

      var all$2 = function (selector) {
        return $_5h4ipt1fjh8lywgi.all(selector);
      };
      var ancestors$1 = function (scope, selector, isRoot) {
        return $_6y3ft32hjh8lywp5.ancestors(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        }, isRoot);
      };
      var siblings$2 = function (scope, selector) {
        return $_6y3ft32hjh8lywp5.siblings(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        });
      };
      var children$2 = function (scope, selector) {
        return $_6y3ft32hjh8lywp5.children(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        });
      };
      var descendants$1 = function (scope, selector) {
        return $_5h4ipt1fjh8lywgi.all(selector, scope);
      };
      var $_eebxu2gjh8lywp3 = {
        all: all$2,
        ancestors: ancestors$1,
        siblings: siblings$2,
        children: children$2,
        descendants: descendants$1
      };

      var deflate = function (rect, delta) {
        return {
          left: rect.left - delta,
          top: rect.top - delta,
          right: rect.right + delta * 2,
          bottom: rect.bottom + delta * 2,
          width: rect.width + delta,
          height: rect.height + delta
        };
      };
      var getCorners = function (getYAxisValue, tds) {
        return $_5wjzy24jh8lyw2t.bind(tds, function (td) {
          var rect = deflate(td.getBoundingClientRect(), -1);
          return [
            {
              x: rect.left,
              y: getYAxisValue(rect),
              cell: td
            },
            {
              x: rect.right,
              y: getYAxisValue(rect),
              cell: td
            }
          ];
        });
      };
      var findClosestCorner = function (corners, x, y) {
        return $_5wjzy24jh8lyw2t.foldl(corners, function (acc, newCorner) {
          return acc.fold(function () {
            return Option.some(newCorner);
          }, function (oldCorner) {
            var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
            var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
            return Option.some(newDist < oldDist ? newCorner : oldCorner);
          });
        }, Option.none());
      };
      var getClosestCell = function (getYAxisValue, isTargetCorner, table, x, y) {
        var cells = $_eebxu2gjh8lywp3.descendants($_cgttw3zjh8lywdq.fromDom(table), 'td,th').map(function (e) {
          return e.dom();
        });
        var corners = $_5wjzy24jh8lyw2t.filter(getCorners(getYAxisValue, cells), function (corner) {
          return isTargetCorner(corner, y);
        });
        return findClosestCorner(corners, x, y).map(function (corner) {
          return corner.cell;
        });
      };
      var getBottomValue = function (rect) {
        return rect.bottom;
      };
      var getTopValue = function (rect) {
        return rect.top;
      };
      var isAbove$1 = function (corner, y) {
        return corner.y < y;
      };
      var isBelow$1 = function (corner, y) {
        return corner.y > y;
      };
      var getClosestCellAbove = $_eqpqvr6jh8lyw3s.curry(getClosestCell, getBottomValue, isAbove$1);
      var getClosestCellBelow = $_eqpqvr6jh8lyw3s.curry(getClosestCell, getTopValue, isBelow$1);
      var findClosestPositionInAboveCell = function (table, pos) {
        return $_5wjzy24jh8lyw2t.head(pos.getClientRects()).bind(function (rect) {
          return getClosestCellAbove(table, rect.left, rect.top);
        }).bind(function (cell) {
          return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
        });
      };
      var findClosestPositionInBelowCell = function (table, pos) {
        return $_5wjzy24jh8lyw2t.last(pos.getClientRects()).bind(function (rect) {
          return getClosestCellBelow(table, rect.left, rect.top);
        }).bind(function (cell) {
          return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
        });
      };

      var getPos$1 = function (elm) {
        var x = 0, y = 0;
        var offsetParent = elm;
        while (offsetParent && offsetParent.nodeType) {
          x += offsetParent.offsetLeft || 0;
          y += offsetParent.offsetTop || 0;
          offsetParent = offsetParent.offsetParent;
        }
        return {
          x: x,
          y: y
        };
      };
      var fireScrollIntoViewEvent = function (editor, elm, alignToTop) {
        var scrollEvent = {
          elm: elm,
          alignToTop: alignToTop
        };
        editor.fire('scrollIntoView', scrollEvent);
        return scrollEvent.isDefaultPrevented();
      };
      var scrollElementIntoView = function (editor, elm, alignToTop) {
        var y, viewPort;
        var dom = editor.dom;
        var root = dom.getRoot();
        var viewPortY, viewPortH, offsetY = 0;
        if (fireScrollIntoViewEvent(editor, elm, alignToTop)) {
          return;
        }
        if (!$_5oonaz1qjh8lywhz.isElement(elm)) {
          return;
        }
        if (alignToTop === false) {
          offsetY = elm.offsetHeight;
        }
        if (root.nodeName !== 'BODY') {
          var scrollContainer = editor.selection.getScrollContainer();
          if (scrollContainer) {
            y = getPos$1(elm).y - getPos$1(scrollContainer).y + offsetY;
            viewPortH = scrollContainer.clientHeight;
            viewPortY = scrollContainer.scrollTop;
            if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
              scrollContainer.scrollTop = y < viewPortY ? y : y - viewPortH + 25;
            }
            return;
          }
        }
        viewPort = dom.getViewPort(editor.getWin());
        y = dom.getPos(elm).y + offsetY;
        viewPortY = viewPort.y;
        viewPortH = viewPort.h;
        if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
          editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25);
        }
      };
      var getViewPortRect = function (editor) {
        if (editor.inline) {
          return editor.getBody().getBoundingClientRect();
        } else {
          var win = editor.getWin();
          return {
            left: 0,
            right: win.innerWidth,
            top: 0,
            bottom: win.innerHeight,
            width: win.innerWidth,
            height: win.innerHeight
          };
        }
      };
      var scrollBy = function (editor, dx, dy) {
        if (editor.inline) {
          editor.getBody().scrollLeft += dx;
          editor.getBody().scrollTop += dy;
        } else {
          editor.getWin().scrollBy(dx, dy);
        }
      };
      var scrollRangeIntoView = function (editor, rng) {
        $_5wjzy24jh8lyw2t.head(CaretPosition.fromRangeStart(rng).getClientRects()).each(function (rngRect) {
          var bodyRect = getViewPortRect(editor);
          var overflow = getOverflow(bodyRect, rngRect);
          var margin = 4;
          var dx = overflow.x > 0 ? overflow.x + margin : overflow.x - margin;
          var dy = overflow.y > 0 ? overflow.y + margin : overflow.y - margin;
          scrollBy(editor, overflow.x !== 0 ? dx : 0, overflow.y !== 0 ? dy : 0);
        });
      };
      var $_cosk3k2ijh8lywpa = {
        scrollElementIntoView: scrollElementIntoView,
        scrollRangeIntoView: scrollRangeIntoView
      };

      var getBodySetting = function (editor, name, defaultValue) {
        var value = editor.getParam(name, defaultValue);
        if (value.indexOf('=') !== -1) {
          var bodyObj = editor.getParam(name, '', 'hash');
          return bodyObj.hasOwnProperty(editor.id) ? bodyObj[editor.id] : defaultValue;
        } else {
          return value;
        }
      };
      var getIframeAttrs = function (editor) {
        return editor.getParam('iframe_attrs', {});
      };
      var getDocType = function (editor) {
        return editor.getParam('doctype', '<!DOCTYPE html>');
      };
      var getDocumentBaseUrl = function (editor) {
        return editor.getParam('document_base_url', '');
      };
      var getBodyId = function (editor) {
        return getBodySetting(editor, 'body_id', 'tinymce');
      };
      var getBodyClass = function (editor) {
        return getBodySetting(editor, 'body_class', '');
      };
      var getContentSecurityPolicy = function (editor) {
        return editor.getParam('content_security_policy', '');
      };
      var shouldPutBrInPre = function (editor) {
        return editor.getParam('br_in_pre', true);
      };
      var getForcedRootBlock = function (editor) {
        if (editor.getParam('force_p_newlines', false)) {
          return 'p';
        }
        var block = editor.getParam('forced_root_block', 'p');
        return block === false ? '' : block;
      };
      var getForcedRootBlockAttrs = function (editor) {
        return editor.getParam('forced_root_block_attrs', {});
      };
      var getBrNewLineSelector = function (editor) {
        return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
      };
      var getNoNewLineSelector = function (editor) {
        return editor.getParam('no_newline_selector', '');
      };
      var shouldKeepStyles = function (editor) {
        return editor.getParam('keep_styles', true);
      };
      var shouldEndContainerOnEmptyBlock = function (editor) {
        return editor.getParam('end_container_on_empty_block', false);
      };
      var getFontStyleValues = function (editor) {
        return $_ahowuxkjh8lywbj.explode(editor.getParam('font_size_style_values', ''));
      };
      var getFontSizeClasses = function (editor) {
        return $_ahowuxkjh8lywbj.explode(editor.getParam('font_size_classes', ''));
      };
      var $_66vr6g2jjh8lywpf = {
        getIframeAttrs: getIframeAttrs,
        getDocType: getDocType,
        getDocumentBaseUrl: getDocumentBaseUrl,
        getBodyId: getBodyId,
        getBodyClass: getBodyClass,
        getContentSecurityPolicy: getContentSecurityPolicy,
        shouldPutBrInPre: shouldPutBrInPre,
        getForcedRootBlock: getForcedRootBlock,
        getForcedRootBlockAttrs: getForcedRootBlockAttrs,
        getBrNewLineSelector: getBrNewLineSelector,
        getNoNewLineSelector: getNoNewLineSelector,
        shouldKeepStyles: shouldKeepStyles,
        shouldEndContainerOnEmptyBlock: shouldEndContainerOnEmptyBlock,
        getFontStyleValues: getFontStyleValues,
        getFontSizeClasses: getFontSizeClasses
      };

      var before = function (marker, element) {
        var parent = $_a43q0i17jh8lywfe.parent(marker);
        parent.each(function (v) {
          v.dom().insertBefore(element.dom(), marker.dom());
        });
      };
      var after = function (marker, element) {
        var sibling = $_a43q0i17jh8lywfe.nextSibling(marker);
        sibling.fold(function () {
          var parent = $_a43q0i17jh8lywfe.parent(marker);
          parent.each(function (v) {
            append(v, element);
          });
        }, function (v) {
          before(v, element);
        });
      };
      var prepend = function (parent, element) {
        var firstChild = $_a43q0i17jh8lywfe.firstChild(parent);
        firstChild.fold(function () {
          append(parent, element);
        }, function (v) {
          parent.dom().insertBefore(element.dom(), v.dom());
        });
      };
      var append = function (parent, element) {
        parent.dom().appendChild(element.dom());
      };
      var appendAt = function (parent, element, index) {
        $_a43q0i17jh8lywfe.child(parent, index).fold(function () {
          append(parent, element);
        }, function (v) {
          before(v, element);
        });
      };
      var wrap$1 = function (element, wrapper) {
        before(element, wrapper);
        append(wrapper, element);
      };
      var $_4m7u2e2kjh8lywpi = {
        before: before,
        after: after,
        prepend: prepend,
        append: append,
        appendAt: appendAt,
        wrap: wrap$1
      };

      var browser$2 = $_9hkktfnjh8lywc6.detect().browser;
      var isFakeCaretTableBrowser = function () {
        return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
      };
      var moveToRange = function (editor, rng) {
        editor.selection.setRng(rng);
        $_cosk3k2ijh8lywpa.scrollRangeIntoView(editor, rng);
      };
      var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
        var lineInfo = getPositionsUntil(scope, pos);
        if (lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0) {
          return lineInfo.breakAt.map(function (breakPos) {
            return getPositionsUntil(scope, breakPos).breakAt.isNone();
          }).getOr(true);
        } else {
          return lineInfo.breakAt.isNone();
        }
      };
      var isAtFirstTableCellLine = $_8aqzj925jh8lywmj.curry(isAtTableCellLine, getPositionsUntilPreviousLine);
      var isAtLastTableCellLine = $_8aqzj925jh8lywmj.curry(isAtTableCellLine, getPositionsUntilNextLine);
      var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
        var caretPos = CaretPosition$1.fromRangeStart(rng);
        return $_9kvypj2cjh8lywnz.positionIn(!forward, table).map(function (pos) {
          return pos.isEqual(caretPos);
        }).getOr(false);
      };
      var navigateHorizontally = function (editor, forward, table, td) {
        var rng = editor.selection.getRng();
        var direction = forward ? 1 : -1;
        if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
          var newRng = showCaret(direction, editor, table, !forward, true);
          moveToRange(editor, newRng);
          return true;
        }
        return false;
      };
      var getClosestAbovePosition = function (root, table, start) {
        return findClosestPositionInAboveCell(table, start).orThunk(function () {
          return $_5wjzy24jh8lyw2t.head(start.getClientRects()).bind(function (rect) {
            return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition$1.before(table)), rect.left);
          });
        }).getOr(CaretPosition$1.before(table));
      };
      var getClosestBelowPosition = function (root, table, start) {
        return findClosestPositionInBelowCell(table, start).orThunk(function () {
          return $_5wjzy24jh8lyw2t.head(start.getClientRects()).bind(function (rect) {
            return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition$1.after(table)), rect.left);
          });
        }).getOr(CaretPosition$1.after(table));
      };
      var getTable = function (previous, pos) {
        var node = pos.getNode(previous);
        return $_5oonaz1qjh8lywhz.isElement(node) && node.nodeName === 'TABLE' ? Option.some(node) : Option.none();
      };
      var renderBlock = function (down, editor, table, pos) {
        var forcedRootBlock = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
        if (forcedRootBlock) {
          editor.undoManager.transact(function () {
            var element = $_cgttw3zjh8lywdq.fromTag(forcedRootBlock);
            $_3da62i14jh8lyweo.setAll(element, $_66vr6g2jjh8lywpf.getForcedRootBlockAttrs(editor));
            $_4m7u2e2kjh8lywpi.append(element, $_cgttw3zjh8lywdq.fromTag('br'));
            if (down) {
              $_4m7u2e2kjh8lywpi.after($_cgttw3zjh8lywdq.fromDom(table), element);
            } else {
              $_4m7u2e2kjh8lywpi.before($_cgttw3zjh8lywdq.fromDom(table), element);
            }
            var rng = editor.dom.createRng();
            rng.setStart(element.dom(), 0);
            rng.setEnd(element.dom(), 0);
            moveToRange(editor, rng);
          });
        } else {
          moveToRange(editor, pos.toRange());
        }
      };
      var moveCaret = function (editor, down, pos) {
        var table = down ? getTable(true, pos) : getTable(false, pos);
        var last = down === false;
        table.fold(function () {
          return moveToRange(editor, pos.toRange());
        }, function (table) {
          return $_9kvypj2cjh8lywnz.positionIn(last, editor.getBody()).filter(function (lastPos) {
            return lastPos.isEqual(pos);
          }).fold(function () {
            return moveToRange(editor, pos.toRange());
          }, function (_) {
            return renderBlock(down, editor, table, pos);
          });
        });
      };
      var navigateVertically = function (editor, down, table, td) {
        var rng = editor.selection.getRng();
        var pos = CaretPosition$1.fromRangeStart(rng);
        var root = editor.getBody();
        if (!down && isAtFirstTableCellLine(td, pos)) {
          var newPos = getClosestAbovePosition(root, table, pos);
          moveCaret(editor, down, newPos);
          return true;
        } else if (down && isAtLastTableCellLine(td, pos)) {
          var newPos = getClosestBelowPosition(root, table, pos);
          moveCaret(editor, down, newPos);
          return true;
        } else {
          return false;
        }
      };
      var moveH = function (editor, forward) {
        return function () {
          return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
            return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
              return navigateHorizontally(editor, forward, table, td);
            });
          }).getOr(false);
        };
      };
      var moveV = function (editor, forward) {
        return function () {
          return Option.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
            return Option.from(editor.dom.getParent(td, 'table')).map(function (table) {
              return navigateVertically(editor, forward, table, td);
            });
          }).getOr(false);
        };
      };

      var Cell = function (initial) {
        var value = initial;
        var get = function () {
          return value;
        };
        var set = function (v) {
          value = v;
        };
        var clone = function () {
          return Cell(get());
        };
        return {
          get: get,
          set: set,
          clone: clone
        };
      };

      var isContentEditableFalse$3 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isTableCell$1 = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && /^(TD|TH)$/i.test(node.tagName);
      };
      var getAbsoluteClientRect = function (root, element, before) {
        var clientRect = collapse(element.getBoundingClientRect(), before);
        var docElm, scrollX, scrollY, margin, rootRect;
        if (root.tagName === 'BODY') {
          docElm = root.ownerDocument.documentElement;
          scrollX = root.scrollLeft || docElm.scrollLeft;
          scrollY = root.scrollTop || docElm.scrollTop;
        } else {
          rootRect = root.getBoundingClientRect();
          scrollX = root.scrollLeft - rootRect.left;
          scrollY = root.scrollTop - rootRect.top;
        }
        clientRect.left += scrollX;
        clientRect.right += scrollX;
        clientRect.top += scrollY;
        clientRect.bottom += scrollY;
        clientRect.width = 1;
        margin = element.offsetWidth - element.clientWidth;
        if (margin > 0) {
          if (before) {
            margin *= -1;
          }
          clientRect.left += margin;
          clientRect.right += margin;
        }
        return clientRect;
      };
      var trimInlineCaretContainers = function (root) {
        var contentEditableFalseNodes, node, sibling, i, data;
        contentEditableFalseNodes = DomQuery('*[contentEditable=false]', root);
        for (i = 0; i < contentEditableFalseNodes.length; i++) {
          node = contentEditableFalseNodes[i];
          sibling = node.previousSibling;
          if (endsWithCaretContainer(sibling)) {
            data = sibling.data;
            if (data.length === 1) {
              sibling.parentNode.removeChild(sibling);
            } else {
              sibling.deleteData(data.length - 1, 1);
            }
          }
          sibling = node.nextSibling;
          if (startsWithCaretContainer(sibling)) {
            data = sibling.data;
            if (data.length === 1) {
              sibling.parentNode.removeChild(sibling);
            } else {
              sibling.deleteData(0, 1);
            }
          }
        }
      };
      var FakeCaret = function (root, isBlock, hasFocus) {
        var lastVisualCaret = Cell(Option.none());
        var cursorInterval, caretContainerNode;
        var show = function (before, element) {
          var clientRect, rng;
          hide();
          if (isTableCell$1(element)) {
            return null;
          }
          if (isBlock(element)) {
            caretContainerNode = insertBlock('p', element, before);
            clientRect = getAbsoluteClientRect(root, element, before);
            DomQuery(caretContainerNode).css('top', clientRect.top);
            var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(root)[0];
            lastVisualCaret.set(Option.some({
              caret: caret,
              element: element,
              before: before
            }));
            lastVisualCaret.get().each(function (caretState) {
              if (before) {
                DomQuery(caretState.caret).addClass('mce-visual-caret-before');
              }
            });
            startBlink();
            rng = element.ownerDocument.createRange();
            rng.setStart(caretContainerNode, 0);
            rng.setEnd(caretContainerNode, 0);
          } else {
            caretContainerNode = insertInline(element, before);
            rng = element.ownerDocument.createRange();
            if (isContentEditableFalse$3(caretContainerNode.nextSibling)) {
              rng.setStart(caretContainerNode, 0);
              rng.setEnd(caretContainerNode, 0);
            } else {
              rng.setStart(caretContainerNode, 1);
              rng.setEnd(caretContainerNode, 1);
            }
            return rng;
          }
          return rng;
        };
        var hide = function () {
          trimInlineCaretContainers(root);
          if (caretContainerNode) {
            $_9nl16f2ajh8lywne.remove(caretContainerNode);
            caretContainerNode = null;
          }
          lastVisualCaret.get().each(function (caretState) {
            DomQuery(caretState.caret).remove();
            lastVisualCaret.set(Option.none());
          });
          clearInterval(cursorInterval);
        };
        var startBlink = function () {
          cursorInterval = $_8sy3pfhjh8lyw95.setInterval(function () {
            if (hasFocus()) {
              DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
            } else {
              DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
            }
          }, 500);
        };
        var reposition = function () {
          lastVisualCaret.get().each(function (caretState) {
            var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
            DomQuery(caretState.caret).css(clientRect);
          });
        };
        var destroy = function () {
          return $_8sy3pfhjh8lyw95.clearInterval(cursorInterval);
        };
        var getCss = function () {
          return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
        };
        return {
          show: show,
          hide: hide,
          getCss: getCss,
          reposition: reposition,
          destroy: destroy
        };
      };
      var isFakeCaretTarget = function (node) {
        return isContentEditableFalse$3(node) || $_5oonaz1qjh8lywhz.isTable(node) && isFakeCaretTableBrowser();
      };

      var isContentEditableFalse$4 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isBlockLike = $_5oonaz1qjh8lywhz.matchStyleValues('display', 'block table table-cell table-caption list-item');
      var isCaretContainer$2 = isCaretContainer;
      var isCaretContainerBlock$1 = isCaretContainerBlock;
      var curry$2 = $_8aqzj925jh8lywmj.curry;
      var isElement$5 = $_5oonaz1qjh8lywhz.isElement;
      var isCaretCandidate$2 = isCaretCandidate;
      var isForwards = function (direction) {
        return direction > 0;
      };
      var isBackwards = function (direction) {
        return direction < 0;
      };
      var skipCaretContainers = function (walk, shallow) {
        var node;
        while (node = walk(shallow)) {
          if (!isCaretContainerBlock$1(node)) {
            return node;
          }
        }
        return null;
      };
      var findNode = function (node, direction, predicateFn, rootNode, shallow) {
        var walker = new TreeWalker(node, rootNode);
        if (isBackwards(direction)) {
          if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
            node = skipCaretContainers(walker.prev, true);
            if (predicateFn(node)) {
              return node;
            }
          }
          while (node = skipCaretContainers(walker.prev, shallow)) {
            if (predicateFn(node)) {
              return node;
            }
          }
        }
        if (isForwards(direction)) {
          if (isContentEditableFalse$4(node) || isCaretContainerBlock$1(node)) {
            node = skipCaretContainers(walker.next, true);
            if (predicateFn(node)) {
              return node;
            }
          }
          while (node = skipCaretContainers(walker.next, shallow)) {
            if (predicateFn(node)) {
              return node;
            }
          }
        }
        return null;
      };
      var getParentBlock = function (node, rootNode) {
        while (node && node !== rootNode) {
          if (isBlockLike(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
        return getParentBlock(caretPosition1.container(), rootNode) === getParentBlock(caretPosition2.container(), rootNode);
      };
      var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
        var container, offset;
        if (!caretPosition) {
          return null;
        }
        container = caretPosition.container();
        offset = caretPosition.offset();
        if (!isElement$5(container)) {
          return null;
        }
        return container.childNodes[offset + relativeOffset];
      };
      var beforeAfter = function (before, node) {
        var range = node.ownerDocument.createRange();
        if (before) {
          range.setStartBefore(node);
          range.setEndBefore(node);
        } else {
          range.setStartAfter(node);
          range.setEndAfter(node);
        }
        return range;
      };
      var isNodesInSameBlock = function (root, node1, node2) {
        return getParentBlock(node1, root) === getParentBlock(node2, root);
      };
      var lean = function (left, root, node) {
        var sibling, siblingName;
        if (left) {
          siblingName = 'previousSibling';
        } else {
          siblingName = 'nextSibling';
        }
        while (node && node !== root) {
          sibling = node[siblingName];
          if (isCaretContainer$2(sibling)) {
            sibling = sibling[siblingName];
          }
          if (isContentEditableFalse$4(sibling)) {
            if (isNodesInSameBlock(root, sibling, node)) {
              return sibling;
            }
            break;
          }
          if (isCaretCandidate$2(sibling)) {
            break;
          }
          node = node.parentNode;
        }
        return null;
      };
      var before$1 = curry$2(beforeAfter, true);
      var after$1 = curry$2(beforeAfter, false);
      var normalizeRange = function (direction, root, range) {
        var node, container, offset, location;
        var leanLeft = curry$2(lean, true, root);
        var leanRight = curry$2(lean, false, root);
        container = range.startContainer;
        offset = range.startOffset;
        if (isCaretContainerBlock(container)) {
          if (!isElement$5(container)) {
            container = container.parentNode;
          }
          location = container.getAttribute('data-mce-caret');
          if (location === 'before') {
            node = container.nextSibling;
            if (isFakeCaretTarget(node)) {
              return before$1(node);
            }
          }
          if (location === 'after') {
            node = container.previousSibling;
            if (isFakeCaretTarget(node)) {
              return after$1(node);
            }
          }
        }
        if (!range.collapsed) {
          return range;
        }
        if ($_5oonaz1qjh8lywhz.isText(container)) {
          if (isCaretContainer$2(container)) {
            if (direction === 1) {
              node = leanRight(container);
              if (node) {
                return before$1(node);
              }
              node = leanLeft(container);
              if (node) {
                return after$1(node);
              }
            }
            if (direction === -1) {
              node = leanLeft(container);
              if (node) {
                return after$1(node);
              }
              node = leanRight(container);
              if (node) {
                return before$1(node);
              }
            }
            return range;
          }
          if (endsWithCaretContainer(container) && offset >= container.data.length - 1) {
            if (direction === 1) {
              node = leanRight(container);
              if (node) {
                return before$1(node);
              }
            }
            return range;
          }
          if (startsWithCaretContainer(container) && offset <= 1) {
            if (direction === -1) {
              node = leanLeft(container);
              if (node) {
                return after$1(node);
              }
            }
            return range;
          }
          if (offset === container.data.length) {
            node = leanRight(container);
            if (node) {
              return before$1(node);
            }
            return range;
          }
          if (offset === 0) {
            node = leanLeft(container);
            if (node) {
              return after$1(node);
            }
            return range;
          }
        }
        return range;
      };
      var isNextToContentEditableFalse = function (relativeOffset, caretPosition) {
        var node = getChildNodeAtRelativeOffset(relativeOffset, caretPosition);
        return isContentEditableFalse$4(node) && !$_5oonaz1qjh8lywhz.isBogusAll(node);
      };
      var isNextToTable = function (relativeOffset, caretPosition) {
        return $_5oonaz1qjh8lywhz.isTable(getChildNodeAtRelativeOffset(relativeOffset, caretPosition));
      };
      var getRelativeCefElm = function (forward, caretPosition) {
        return Option.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$4);
      };
      var getNormalizedRangeEndPoint = function (direction, root, range) {
        var normalizedRange = normalizeRange(direction, root, range);
        if (direction === -1) {
          return CaretPosition.fromRangeStart(normalizedRange);
        }
        return CaretPosition.fromRangeEnd(normalizedRange);
      };
      var isBeforeContentEditableFalse = curry$2(isNextToContentEditableFalse, 0);
      var isAfterContentEditableFalse = curry$2(isNextToContentEditableFalse, -1);
      var isBeforeTable = curry$2(isNextToTable, 0);
      var isAfterTable = curry$2(isNextToTable, -1);

      var HDirection;
      (function (HDirection) {
        HDirection[HDirection['Backwards'] = -1] = 'Backwards';
        HDirection[HDirection['Forwards'] = 1] = 'Forwards';
      }(HDirection || (HDirection = {})));
      var isContentEditableFalse$5 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isText$6 = $_5oonaz1qjh8lywhz.isText;
      var isElement$6 = $_5oonaz1qjh8lywhz.isElement;
      var isBr$4 = $_5oonaz1qjh8lywhz.isBr;
      var isCaretCandidate$3 = isCaretCandidate;
      var isAtomic$1 = isAtomic;
      var isEditableCaretCandidate$1 = isEditableCaretCandidate;
      var getParents = function (node, root) {
        var parents = [];
        while (node && node !== root) {
          parents.push(node);
          node = node.parentNode;
        }
        return parents;
      };
      var nodeAtIndex = function (container, offset) {
        if (container.hasChildNodes() && offset < container.childNodes.length) {
          return container.childNodes[offset];
        }
        return null;
      };
      var getCaretCandidatePosition = function (direction, node) {
        if (isForwards(direction)) {
          if (isCaretCandidate$3(node.previousSibling) && !isText$6(node.previousSibling)) {
            return CaretPosition$1.before(node);
          }
          if (isText$6(node)) {
            return CaretPosition$1(node, 0);
          }
        }
        if (isBackwards(direction)) {
          if (isCaretCandidate$3(node.nextSibling) && !isText$6(node.nextSibling)) {
            return CaretPosition$1.after(node);
          }
          if (isText$6(node)) {
            return CaretPosition$1(node, node.data.length);
          }
        }
        if (isBackwards(direction)) {
          if (isBr$4(node)) {
            return CaretPosition$1.before(node);
          }
          return CaretPosition$1.after(node);
        }
        return CaretPosition$1.before(node);
      };
      var isBrBeforeBlock = function (node, root) {
        var next;
        if (!$_5oonaz1qjh8lywhz.isBr(node)) {
          return false;
        }
        next = findCaretPosition(1, CaretPosition$1.after(node), root);
        if (!next) {
          return false;
        }
        return !isInSameBlock(CaretPosition$1.before(node), CaretPosition$1.before(next), root);
      };
      var findCaretPosition = function (direction, startPos, root) {
        var node, nextNode, innerNode;
        var rootContentEditableFalseElm, caretPosition;
        if (!isElement$6(root) || !startPos) {
          return null;
        }
        if (startPos.isEqual(CaretPosition$1.after(root)) && root.lastChild) {
          caretPosition = CaretPosition$1.after(root.lastChild);
          if (isBackwards(direction) && isCaretCandidate$3(root.lastChild) && isElement$6(root.lastChild)) {
            return isBr$4(root.lastChild) ? CaretPosition$1.before(root.lastChild) : caretPosition;
          }
        } else {
          caretPosition = startPos;
        }
        var container = caretPosition.container();
        var offset = caretPosition.offset();
        if (isText$6(container)) {
          if (isBackwards(direction) && offset > 0) {
            return CaretPosition$1(container, --offset);
          }
          if (isForwards(direction) && offset < container.length) {
            return CaretPosition$1(container, ++offset);
          }
          node = container;
        } else {
          if (isBackwards(direction) && offset > 0) {
            nextNode = nodeAtIndex(container, offset - 1);
            if (isCaretCandidate$3(nextNode)) {
              if (!isAtomic$1(nextNode)) {
                innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
                if (innerNode) {
                  if (isText$6(innerNode)) {
                    return CaretPosition$1(innerNode, innerNode.data.length);
                  }
                  return CaretPosition$1.after(innerNode);
                }
              }
              if (isText$6(nextNode)) {
                return CaretPosition$1(nextNode, nextNode.data.length);
              }
              return CaretPosition$1.before(nextNode);
            }
          }
          if (isForwards(direction) && offset < container.childNodes.length) {
            nextNode = nodeAtIndex(container, offset);
            if (isCaretCandidate$3(nextNode)) {
              if (isBr$4(nextNode) && root.lastChild === nextNode) {
                return null;
              }
              if (isBrBeforeBlock(nextNode, root)) {
                return findCaretPosition(direction, CaretPosition$1.after(nextNode), root);
              }
              if (!isAtomic$1(nextNode)) {
                innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
                if (innerNode) {
                  if (isText$6(innerNode)) {
                    return CaretPosition$1(innerNode, 0);
                  }
                  return CaretPosition$1.before(innerNode);
                }
              }
              if (isText$6(nextNode)) {
                return CaretPosition$1(nextNode, 0);
              }
              return CaretPosition$1.after(nextNode);
            }
          }
          node = nextNode ? nextNode : caretPosition.getNode();
        }
        if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
          node = findNode(node, direction, $_8aqzj925jh8lywmj.constant(true), root, true);
          if (isEditableCaretCandidate$1(node, root)) {
            return getCaretCandidatePosition(direction, node);
          }
        }
        nextNode = findNode(node, direction, isEditableCaretCandidate$1, root);
        rootContentEditableFalseElm = $_9tjm51ljh8lywbq.last($_9tjm51ljh8lywbq.filter(getParents(container, root), isContentEditableFalse$5));
        if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
          if (isForwards(direction)) {
            caretPosition = CaretPosition$1.after(rootContentEditableFalseElm);
          } else {
            caretPosition = CaretPosition$1.before(rootContentEditableFalseElm);
          }
          return caretPosition;
        }
        if (nextNode) {
          return getCaretCandidatePosition(direction, nextNode);
        }
        return null;
      };
      var CaretWalker = function (root) {
        return {
          next: function (caretPosition) {
            return findCaretPosition(HDirection.Forwards, caretPosition, root);
          },
          prev: function (caretPosition) {
            return findCaretPosition(HDirection.Backwards, caretPosition, root);
          }
        };
      };

      var hasOnlyOneChild = function (node) {
        return node.firstChild && node.firstChild === node.lastChild;
      };
      var isPaddingNode = function (node) {
        return node.name === 'br' || node.value === '\xA0';
      };
      var isPaddedEmptyBlock = function (schema, node) {
        var blockElements = schema.getBlockElements();
        return blockElements[node.name] && hasOnlyOneChild(node) && isPaddingNode(node.firstChild);
      };
      var isEmptyFragmentElement = function (schema, node) {
        var nonEmptyElements = schema.getNonEmptyElements();
        return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
      };
      var isListFragment = function (schema, fragment) {
        var firstChild = fragment.firstChild;
        var lastChild = fragment.lastChild;
        if (firstChild && firstChild.name === 'meta') {
          firstChild = firstChild.next;
        }
        if (lastChild && lastChild.attr('id') === 'mce_marker') {
          lastChild = lastChild.prev;
        }
        if (isEmptyFragmentElement(schema, lastChild)) {
          lastChild = lastChild.prev;
        }
        if (!firstChild || firstChild !== lastChild) {
          return false;
        }
        return firstChild.name === 'ul' || firstChild.name === 'ol';
      };
      var cleanupDomFragment = function (domFragment) {
        var firstChild = domFragment.firstChild;
        var lastChild = domFragment.lastChild;
        if (firstChild && firstChild.nodeName === 'META') {
          firstChild.parentNode.removeChild(firstChild);
        }
        if (lastChild && lastChild.id === 'mce_marker') {
          lastChild.parentNode.removeChild(lastChild);
        }
        return domFragment;
      };
      var toDomFragment = function (dom, serializer, fragment) {
        var html = serializer.serialize(fragment);
        var domFragment = dom.createFragment(html);
        return cleanupDomFragment(domFragment);
      };
      var listItems$1 = function (elm) {
        return $_ahowuxkjh8lywbj.grep(elm.childNodes, function (child) {
          return child.nodeName === 'LI';
        });
      };
      var isPadding = function (node) {
        return node.data === '\xA0' || $_5oonaz1qjh8lywhz.isBr(node);
      };
      var isListItemPadded = function (node) {
        return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
      };
      var isEmptyOrPadded = function (elm) {
        return !elm.firstChild || isListItemPadded(elm);
      };
      var trimListItems = function (elms) {
        return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
      };
      var getParentLi = function (dom, node) {
        var parentBlock = dom.getParent(node, dom.isBlock);
        return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
      };
      var isParentBlockLi = function (dom, node) {
        return !!getParentLi(dom, node);
      };
      var getSplit = function (parentNode, rng) {
        var beforeRng = rng.cloneRange();
        var afterRng = rng.cloneRange();
        beforeRng.setStartBefore(parentNode);
        afterRng.setEndAfter(parentNode);
        return [
          beforeRng.cloneContents(),
          afterRng.cloneContents()
        ];
      };
      var findFirstIn = function (node, rootNode) {
        var caretPos = CaretPosition$1.before(node);
        var caretWalker = CaretWalker(rootNode);
        var newCaretPos = caretWalker.next(caretPos);
        return newCaretPos ? newCaretPos.toRange() : null;
      };
      var findLastOf = function (node, rootNode) {
        var caretPos = CaretPosition$1.after(node);
        var caretWalker = CaretWalker(rootNode);
        var newCaretPos = caretWalker.prev(caretPos);
        return newCaretPos ? newCaretPos.toRange() : null;
      };
      var insertMiddle = function (target, elms, rootNode, rng) {
        var parts = getSplit(target, rng);
        var parentElm = target.parentNode;
        parentElm.insertBefore(parts[0], target);
        $_ahowuxkjh8lywbj.each(elms, function (li) {
          parentElm.insertBefore(li, target);
        });
        parentElm.insertBefore(parts[1], target);
        parentElm.removeChild(target);
        return findLastOf(elms[elms.length - 1], rootNode);
      };
      var insertBefore = function (target, elms, rootNode) {
        var parentElm = target.parentNode;
        $_ahowuxkjh8lywbj.each(elms, function (elm) {
          parentElm.insertBefore(elm, target);
        });
        return findFirstIn(target, rootNode);
      };
      var insertAfter = function (target, elms, rootNode, dom) {
        dom.insertAfter(elms.reverse(), target);
        return findLastOf(elms[0], rootNode);
      };
      var insertAtCaret = function (serializer, dom, rng, fragment) {
        var domFragment = toDomFragment(dom, serializer, fragment);
        var liTarget = getParentLi(dom, rng.startContainer);
        var liElms = trimListItems(listItems$1(domFragment.firstChild));
        var BEGINNING = 1, END = 2;
        var rootNode = dom.getRoot();
        var isAt = function (location) {
          var caretPos = CaretPosition$1.fromRangeStart(rng);
          var caretWalker = CaretWalker(dom.getRoot());
          var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
          return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
        };
        if (isAt(BEGINNING)) {
          return insertBefore(liTarget, liElms, rootNode);
        } else if (isAt(END)) {
          return insertAfter(liTarget, liElms, rootNode, dom);
        }
        return insertMiddle(liTarget, liElms, rootNode, rng);
      };
      var $_eajoh11xjh8lywl6 = {
        isListFragment: isListFragment,
        insertAtCaret: insertAtCaret,
        isParentBlockLi: isParentBlockLi,
        trimListItems: trimListItems,
        listItems: listItems$1
      };

      var isText$7 = $_5oonaz1qjh8lywhz.isText;
      var isBogus$1 = $_5oonaz1qjh8lywhz.isBogus;
      var nodeIndex$1 = DOMUtils$1.nodeIndex;
      var normalizedParent = function (node) {
        var parentNode = node.parentNode;
        if (isBogus$1(parentNode)) {
          return normalizedParent(parentNode);
        }
        return parentNode;
      };
      var getChildNodes = function (node) {
        if (!node) {
          return [];
        }
        return $_9tjm51ljh8lywbq.reduce(node.childNodes, function (result, node) {
          if (isBogus$1(node) && node.nodeName !== 'BR') {
            result = result.concat(getChildNodes(node));
          } else {
            result.push(node);
          }
          return result;
        }, []);
      };
      var normalizedTextOffset = function (node, offset) {
        while (node = node.previousSibling) {
          if (!isText$7(node)) {
            break;
          }
          offset += node.data.length;
        }
        return offset;
      };
      var equal$1 = function (a) {
        return function (b) {
          return a === b;
        };
      };
      var normalizedNodeIndex = function (node) {
        var nodes, index, numTextFragments;
        nodes = getChildNodes(normalizedParent(node));
        index = $_9tjm51ljh8lywbq.findIndex(nodes, equal$1(node), node);
        nodes = nodes.slice(0, index + 1);
        numTextFragments = $_9tjm51ljh8lywbq.reduce(nodes, function (result, node, i) {
          if (isText$7(node) && isText$7(nodes[i - 1])) {
            result++;
          }
          return result;
        }, 0);
        nodes = $_9tjm51ljh8lywbq.filter(nodes, $_5oonaz1qjh8lywhz.matchNodeNames(node.nodeName));
        index = $_9tjm51ljh8lywbq.findIndex(nodes, equal$1(node), node);
        return index - numTextFragments;
      };
      var createPathItem = function (node) {
        var name;
        if (isText$7(node)) {
          name = 'text()';
        } else {
          name = node.nodeName.toLowerCase();
        }
        return name + '[' + normalizedNodeIndex(node) + ']';
      };
      var parentsUntil = function (root, node, predicate) {
        var parents = [];
        for (node = node.parentNode; node !== root; node = node.parentNode) {
          if (predicate && predicate(node)) {
            break;
          }
          parents.push(node);
        }
        return parents;
      };
      var create$1 = function (root, caretPosition) {
        var container, offset, path = [], outputOffset, childNodes, parents;
        container = caretPosition.container();
        offset = caretPosition.offset();
        if (isText$7(container)) {
          outputOffset = normalizedTextOffset(container, offset);
        } else {
          childNodes = container.childNodes;
          if (offset >= childNodes.length) {
            outputOffset = 'after';
            offset = childNodes.length - 1;
          } else {
            outputOffset = 'before';
          }
          container = childNodes[offset];
        }
        path.push(createPathItem(container));
        parents = parentsUntil(root, container);
        parents = $_9tjm51ljh8lywbq.filter(parents, $_8aqzj925jh8lywmj.negate($_5oonaz1qjh8lywhz.isBogus));
        path = path.concat($_9tjm51ljh8lywbq.map(parents, function (node) {
          return createPathItem(node);
        }));
        return path.reverse().join('/') + ',' + outputOffset;
      };
      var resolvePathItem = function (node, name, index) {
        var nodes = getChildNodes(node);
        nodes = $_9tjm51ljh8lywbq.filter(nodes, function (node, index) {
          return !isText$7(node) || !isText$7(nodes[index - 1]);
        });
        nodes = $_9tjm51ljh8lywbq.filter(nodes, $_5oonaz1qjh8lywhz.matchNodeNames(name));
        return nodes[index];
      };
      var findTextPosition = function (container, offset) {
        var node = container, targetOffset = 0, dataLen;
        while (isText$7(node)) {
          dataLen = node.data.length;
          if (offset >= targetOffset && offset <= targetOffset + dataLen) {
            container = node;
            offset = offset - targetOffset;
            break;
          }
          if (!isText$7(node.nextSibling)) {
            container = node;
            offset = dataLen;
            break;
          }
          targetOffset += dataLen;
          node = node.nextSibling;
        }
        if (isText$7(container) && offset > container.data.length) {
          offset = container.data.length;
        }
        return CaretPosition$1(container, offset);
      };
      var resolve$2 = function (root, path) {
        var parts, container, offset;
        if (!path) {
          return null;
        }
        parts = path.split(',');
        path = parts[0].split('/');
        offset = parts.length > 1 ? parts[1] : 'before';
        container = $_9tjm51ljh8lywbq.reduce(path, function (result, value) {
          value = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
          if (!value) {
            return null;
          }
          if (value[1] === 'text()') {
            value[1] = '#text';
          }
          return resolvePathItem(result, value[1], parseInt(value[2], 10));
        }, root);
        if (!container) {
          return null;
        }
        if (!isText$7(container)) {
          if (offset === 'after') {
            offset = nodeIndex$1(container) + 1;
          } else {
            offset = nodeIndex$1(container);
          }
          return CaretPosition$1(container.parentNode, offset);
        }
        return findTextPosition(container, parseInt(offset, 10));
      };

      var isContentEditableFalse$6 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var getNormalizedTextOffset = function (trim, container, offset) {
        var node, trimmedOffset;
        trimmedOffset = trim(container.data.slice(0, offset)).length;
        for (node = container.previousSibling; node && $_5oonaz1qjh8lywhz.isText(node); node = node.previousSibling) {
          trimmedOffset += trim(node.data).length;
        }
        return trimmedOffset;
      };
      var getPoint = function (dom, trim, normalized, rng, start) {
        var container = rng[start ? 'startContainer' : 'endContainer'];
        var offset = rng[start ? 'startOffset' : 'endOffset'];
        var point = [];
        var childNodes, after = 0;
        var root = dom.getRoot();
        if ($_5oonaz1qjh8lywhz.isText(container)) {
          point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
        } else {
          childNodes = container.childNodes;
          if (offset >= childNodes.length && childNodes.length) {
            after = 1;
            offset = Math.max(0, childNodes.length - 1);
          }
          point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
        }
        for (; container && container !== root; container = container.parentNode) {
          point.push(dom.nodeIndex(container, normalized));
        }
        return point;
      };
      var getLocation = function (trim, selection, normalized, rng) {
        var dom = selection.dom, bookmark = {};
        bookmark.start = getPoint(dom, trim, normalized, rng, true);
        if (!selection.isCollapsed()) {
          bookmark.end = getPoint(dom, trim, normalized, rng, false);
        }
        return bookmark;
      };
      var trimEmptyTextNode = function (node) {
        if ($_5oonaz1qjh8lywhz.isText(node) && node.data.length === 0) {
          node.parentNode.removeChild(node);
        }
      };
      var findIndex$3 = function (dom, name, element) {
        var count = 0;
        $_ahowuxkjh8lywbj.each(dom.select(name), function (node) {
          if (node.getAttribute('data-mce-bogus') === 'all') {
            return;
          }
          if (node === element) {
            return false;
          }
          count++;
        });
        return count;
      };
      var moveEndPoint = function (rng, start) {
        var container, offset, childNodes;
        var prefix = start ? 'start' : 'end';
        container = rng[prefix + 'Container'];
        offset = rng[prefix + 'Offset'];
        if ($_5oonaz1qjh8lywhz.isElement(container) && container.nodeName === 'TR') {
          childNodes = container.childNodes;
          container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
          if (container) {
            offset = start ? 0 : container.childNodes.length;
            rng['set' + (start ? 'Start' : 'End')](container, offset);
          }
        }
      };
      var normalizeTableCellSelection = function (rng) {
        moveEndPoint(rng, true);
        moveEndPoint(rng, false);
        return rng;
      };
      var findSibling = function (node, offset) {
        var sibling;
        if ($_5oonaz1qjh8lywhz.isElement(node)) {
          node = getNode(node, offset);
          if (isContentEditableFalse$6(node)) {
            return node;
          }
        }
        if (isCaretContainer(node)) {
          if ($_5oonaz1qjh8lywhz.isText(node) && isCaretContainerBlock(node)) {
            node = node.parentNode;
          }
          sibling = node.previousSibling;
          if (isContentEditableFalse$6(sibling)) {
            return sibling;
          }
          sibling = node.nextSibling;
          if (isContentEditableFalse$6(sibling)) {
            return sibling;
          }
        }
      };
      var findAdjacentContentEditableFalseElm = function (rng) {
        return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
      };
      var getOffsetBookmark = function (trim, normalized, selection) {
        var element = selection.getNode();
        var name = element ? element.nodeName : null;
        var rng = selection.getRng();
        if (isContentEditableFalse$6(element) || name === 'IMG') {
          return {
            name: name,
            index: findIndex$3(selection.dom, name, element)
          };
        }
        var sibling = findAdjacentContentEditableFalseElm(rng);
        if (sibling) {
          name = sibling.tagName;
          return {
            name: name,
            index: findIndex$3(selection.dom, name, sibling)
          };
        }
        return getLocation(trim, selection, normalized, rng);
      };
      var getCaretBookmark = function (selection) {
        var rng = selection.getRng();
        return {
          start: create$1(selection.dom.getRoot(), CaretPosition$1.fromRangeStart(rng)),
          end: create$1(selection.dom.getRoot(), CaretPosition$1.fromRangeEnd(rng))
        };
      };
      var getRangeBookmark = function (selection) {
        return { rng: selection.getRng() };
      };
      var createBookmarkSpan = function (dom, id, filled) {
        var args = {
          'data-mce-type': 'bookmark',
          'id': id,
          'style': 'overflow:hidden;line-height:0px'
        };
        return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
      };
      var getPersistentBookmark = function (selection, filled) {
        var dom = selection.dom;
        var rng = selection.getRng();
        var id = dom.uniqueId();
        var collapsed = selection.isCollapsed();
        var element = selection.getNode();
        var name = element.nodeName;
        if (name === 'IMG') {
          return {
            name: name,
            index: findIndex$3(dom, name, element)
          };
        }
        var rng2 = normalizeTableCellSelection(rng.cloneRange());
        if (!collapsed) {
          rng2.collapse(false);
          var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
          rng2.insertNode(endBookmarkNode);
          trimEmptyTextNode(endBookmarkNode.nextSibling);
        }
        rng = normalizeTableCellSelection(rng);
        rng.collapse(true);
        var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
        rng.insertNode(startBookmarkNode);
        trimEmptyTextNode(startBookmarkNode.previousSibling);
        selection.moveToBookmark({
          id: id,
          keep: 1
        });
        return { id: id };
      };
      var getBookmark = function (selection, type, normalized) {
        if (type === 2) {
          return getOffsetBookmark($_d383mr21jh8lywlv.trim, normalized, selection);
        } else if (type === 3) {
          return getCaretBookmark(selection);
        } else if (type) {
          return getRangeBookmark(selection);
        } else {
          return getPersistentBookmark(selection, false);
        }
      };
      var $_8b82yg2ojh8lywpq = {
        getBookmark: getBookmark,
        getUndoBookmark: $_eqpqvr6jh8lyw3s.curry(getOffsetBookmark, $_eqpqvr6jh8lyw3s.identity, true),
        getPersistentBookmark: getPersistentBookmark
      };

      var CARET_ID = '_mce_caret';
      var isCaretNode = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && node.id === CARET_ID;
      };
      var getParentCaretContainer = function (body, node) {
        while (node && node !== body) {
          if (node.id === CARET_ID) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };

      var isStringPathBookmark = function (bookmark) {
        return typeof bookmark.start === 'string';
      };
      var isRangeBookmark = function (bookmark) {
        return bookmark.hasOwnProperty('rng');
      };
      var isIdBookmark = function (bookmark) {
        return bookmark.hasOwnProperty('id');
      };
      var isIndexBookmark = function (bookmark) {
        return bookmark.hasOwnProperty('name');
      };
      var isPathBookmark = function (bookmark) {
        return $_ahowuxkjh8lywbj.isArray(bookmark.start);
      };

      var addBogus = function (dom, node) {
        if (dom.isBlock(node) && !node.innerHTML && !$_9bpim8ajh8lyw68.ie) {
          node.innerHTML = '<br data-mce-bogus="1" />';
        }
        return node;
      };
      var resolveCaretPositionBookmark = function (dom, bookmark) {
        var rng, pos;
        rng = dom.createRng();
        pos = resolve$2(dom.getRoot(), bookmark.start);
        rng.setStart(pos.container(), pos.offset());
        pos = resolve$2(dom.getRoot(), bookmark.end);
        rng.setEnd(pos.container(), pos.offset());
        return rng;
      };
      var insertZwsp = function (node, rng) {
        var textNode = node.ownerDocument.createTextNode($_d383mr21jh8lywlv.ZWSP);
        node.appendChild(textNode);
        rng.setStart(textNode, 0);
        rng.setEnd(textNode, 0);
      };
      var isEmpty = function (node) {
        return node.hasChildNodes() === false;
      };
      var tryFindRangePosition = function (node, rng) {
        return $_9kvypj2cjh8lywnz.lastPositionIn(node).fold(function () {
          return false;
        }, function (pos) {
          rng.setStart(pos.container(), pos.offset());
          rng.setEnd(pos.container(), pos.offset());
          return true;
        });
      };
      var padEmptyCaretContainer = function (root, node, rng) {
        if (isEmpty(node) && getParentCaretContainer(root, node)) {
          insertZwsp(node, rng);
          return true;
        } else {
          return false;
        }
      };
      var setEndPoint = function (dom, start, bookmark, rng) {
        var point = bookmark[start ? 'start' : 'end'];
        var i, node, offset, children;
        var root = dom.getRoot();
        if (point) {
          offset = point[0];
          for (node = root, i = point.length - 1; i >= 1; i--) {
            children = node.childNodes;
            if (padEmptyCaretContainer(root, node, rng)) {
              return true;
            }
            if (point[i] > children.length - 1) {
              if (padEmptyCaretContainer(root, node, rng)) {
                return true;
              }
              return tryFindRangePosition(node, rng);
            }
            node = children[point[i]];
          }
          if (node.nodeType === 3) {
            offset = Math.min(point[0], node.nodeValue.length);
          }
          if (node.nodeType === 1) {
            offset = Math.min(point[0], node.childNodes.length);
          }
          if (start) {
            rng.setStart(node, offset);
          } else {
            rng.setEnd(node, offset);
          }
        }
        return true;
      };
      var isValidTextNode = function (node) {
        return $_5oonaz1qjh8lywhz.isText(node) && node.data.length > 0;
      };
      var restoreEndPoint = function (dom, suffix, bookmark) {
        var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
        var keep = bookmark.keep;
        var container, offset;
        if (marker) {
          node = marker.parentNode;
          if (suffix === 'start') {
            if (!keep) {
              idx = dom.nodeIndex(marker);
            } else {
              if (marker.hasChildNodes()) {
                node = marker.firstChild;
                idx = 1;
              } else if (isValidTextNode(marker.nextSibling)) {
                node = marker.nextSibling;
                idx = 0;
              } else if (isValidTextNode(marker.previousSibling)) {
                node = marker.previousSibling;
                idx = marker.previousSibling.data.length;
              } else {
                node = marker.parentNode;
                idx = dom.nodeIndex(marker) + 1;
              }
            }
            container = node;
            offset = idx;
          } else {
            if (!keep) {
              idx = dom.nodeIndex(marker);
            } else {
              if (marker.hasChildNodes()) {
                node = marker.firstChild;
                idx = 1;
              } else if (isValidTextNode(marker.previousSibling)) {
                node = marker.previousSibling;
                idx = marker.previousSibling.data.length;
              } else {
                node = marker.parentNode;
                idx = dom.nodeIndex(marker);
              }
            }
            container = node;
            offset = idx;
          }
          if (!keep) {
            prev = marker.previousSibling;
            next = marker.nextSibling;
            $_ahowuxkjh8lywbj.each($_ahowuxkjh8lywbj.grep(marker.childNodes), function (node) {
              if ($_5oonaz1qjh8lywhz.isText(node)) {
                node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
              }
            });
            while (marker = dom.get(bookmark.id + '_' + suffix)) {
              dom.remove(marker, true);
            }
            if (prev && next && prev.nodeType === next.nodeType && $_5oonaz1qjh8lywhz.isText(prev) && !$_9bpim8ajh8lyw68.opera) {
              idx = prev.nodeValue.length;
              prev.appendData(next.nodeValue);
              dom.remove(next);
              if (suffix === 'start') {
                container = prev;
                offset = idx;
              } else {
                container = prev;
                offset = idx;
              }
            }
          }
          return Option.some(CaretPosition$1(container, offset));
        } else {
          return Option.none();
        }
      };
      var alt = function (o1, o2) {
        return o1.isSome() ? o1 : o2;
      };
      var resolvePaths = function (dom, bookmark) {
        var rng = dom.createRng();
        if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
          return Option.some(rng);
        } else {
          return Option.none();
        }
      };
      var resolveId = function (dom, bookmark) {
        var startPos = restoreEndPoint(dom, 'start', bookmark);
        var endPos = restoreEndPoint(dom, 'end', bookmark);
        return $_b8twwq26jh8lywmm.liftN([
          startPos,
          alt(endPos, startPos)
        ], function (spos, epos) {
          var rng = dom.createRng();
          rng.setStart(addBogus(dom, spos.container()), spos.offset());
          rng.setEnd(addBogus(dom, epos.container()), epos.offset());
          return rng;
        });
      };
      var resolveIndex$1 = function (dom, bookmark) {
        return Option.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
          var rng = dom.createRng();
          rng.selectNode(elm);
          return rng;
        });
      };
      var resolve$3 = function (selection, bookmark) {
        var dom = selection.dom;
        if (bookmark) {
          if (isPathBookmark(bookmark)) {
            return resolvePaths(dom, bookmark);
          } else if (isStringPathBookmark(bookmark)) {
            return Option.some(resolveCaretPositionBookmark(dom, bookmark));
          } else if (isIdBookmark(bookmark)) {
            return resolveId(dom, bookmark);
          } else if (isIndexBookmark(bookmark)) {
            return resolveIndex$1(dom, bookmark);
          } else if (isRangeBookmark(bookmark)) {
            return Option.some(bookmark.rng);
          }
        }
        return Option.none();
      };
      var $_bncspc2qjh8lywq4 = { resolve: resolve$3 };

      var getBookmark$1 = function (selection, type, normalized) {
        return $_8b82yg2ojh8lywpq.getBookmark(selection, type, normalized);
      };
      var moveToBookmark = function (selection, bookmark) {
        $_bncspc2qjh8lywq4.resolve(selection, bookmark).each(function (rng) {
          selection.setRng(rng);
        });
      };
      var isBookmarkNode$1 = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
      };
      var $_eyp5ec2njh8lywpo = {
        getBookmark: getBookmark$1,
        moveToBookmark: moveToBookmark,
        isBookmarkNode: isBookmarkNode$1
      };

      var each$8 = $_ahowuxkjh8lywbj.each;
      var ElementUtils = function (dom) {
        this.compare = function (node1, node2) {
          if (node1.nodeName !== node2.nodeName) {
            return false;
          }
          var getAttribs = function (node) {
            var attribs = {};
            each$8(dom.getAttribs(node), function (attr) {
              var name = attr.nodeName.toLowerCase();
              if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
                attribs[name] = dom.getAttrib(node, name);
              }
            });
            return attribs;
          };
          var compareObjects = function (obj1, obj2) {
            var value, name;
            for (name in obj1) {
              if (obj1.hasOwnProperty(name)) {
                value = obj2[name];
                if (typeof value === 'undefined') {
                  return false;
                }
                if (obj1[name] !== value) {
                  return false;
                }
                delete obj2[name];
              }
            }
            for (name in obj2) {
              if (obj2.hasOwnProperty(name)) {
                return false;
              }
            }
            return true;
          };
          if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
            return false;
          }
          if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
            return false;
          }
          return !$_eyp5ec2njh8lywpo.isBookmarkNode(node1) && !$_eyp5ec2njh8lywpo.isBookmarkNode(node2);
        };
      };

      var before$2 = function (marker, elements) {
        $_5wjzy24jh8lyw2t.each(elements, function (x) {
          $_4m7u2e2kjh8lywpi.before(marker, x);
        });
      };
      var after$2 = function (marker, elements) {
        $_5wjzy24jh8lyw2t.each(elements, function (x, i) {
          var e = i === 0 ? marker : elements[i - 1];
          $_4m7u2e2kjh8lywpi.after(e, x);
        });
      };
      var prepend$1 = function (parent, elements) {
        $_5wjzy24jh8lyw2t.each(elements.slice().reverse(), function (x) {
          $_4m7u2e2kjh8lywpi.prepend(parent, x);
        });
      };
      var append$1 = function (parent, elements) {
        $_5wjzy24jh8lyw2t.each(elements, function (x) {
          $_4m7u2e2kjh8lywpi.append(parent, x);
        });
      };
      var $_9hl8mu2vjh8lywr4 = {
        before: before$2,
        after: after$2,
        prepend: prepend$1,
        append: append$1
      };

      var empty = function (element) {
        element.dom().textContent = '';
        $_5wjzy24jh8lyw2t.each($_a43q0i17jh8lywfe.children(element), function (rogue) {
          remove$3(rogue);
        });
      };
      var remove$3 = function (element) {
        var dom = element.dom();
        if (dom.parentNode !== null)
          dom.parentNode.removeChild(dom);
      };
      var unwrap = function (wrapper) {
        var children = $_a43q0i17jh8lywfe.children(wrapper);
        if (children.length > 0)
          $_9hl8mu2vjh8lywr4.before(wrapper, children);
        remove$3(wrapper);
      };
      var $_bfmuql2ujh8lywr1 = {
        empty: empty,
        remove: remove$3,
        unwrap: unwrap
      };

      function NodeValue (is, name) {
        var get = function (element) {
          if (!is(element))
            throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
          return getOption(element).getOr('');
        };
        var getOptionIE10 = function (element) {
          try {
            return getOptionSafe(element);
          } catch (e) {
            return Option.none();
          }
        };
        var getOptionSafe = function (element) {
          return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
        };
        var browser = $_9hkktfnjh8lywc6.detect().browser;
        var getOption = browser.isIE() && browser.version.major === 10 ? getOptionIE10 : getOptionSafe;
        var set = function (element, value) {
          if (!is(element))
            throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
          element.dom().nodeValue = value;
        };
        return {
          get: get,
          getOption: getOption,
          set: set
        };
      }

      var api = NodeValue($_7j1jt210jh8lywdx.isText, 'text');
      var get$2 = function (element) {
        return api.get(element);
      };
      var getOption = function (element) {
        return api.getOption(element);
      };
      var set$2 = function (element, value) {
        api.set(element, value);
      };
      var $_lh5l42wjh8lywr8 = {
        get: get$2,
        getOption: getOption,
        set: set$2
      };

      var getLastChildren = function (elm) {
        var children = [];
        var rawNode = elm.dom();
        while (rawNode) {
          children.push($_cgttw3zjh8lywdq.fromDom(rawNode));
          rawNode = rawNode.lastChild;
        }
        return children;
      };
      var removeTrailingBr = function (elm) {
        var allBrs = $_eebxu2gjh8lywp3.descendants(elm, 'br');
        var brs = $_5wjzy24jh8lyw2t.filter(getLastChildren(elm).slice(-1), isBr);
        if (allBrs.length === brs.length) {
          $_5wjzy24jh8lyw2t.each(brs, $_bfmuql2ujh8lywr1.remove);
        }
      };
      var fillWithPaddingBr = function (elm) {
        $_bfmuql2ujh8lywr1.empty(elm);
        $_4m7u2e2kjh8lywpi.append(elm, $_cgttw3zjh8lywdq.fromHtml('<br data-mce-bogus="1">'));
      };
      var isPaddingContents = function (elm) {
        return $_7j1jt210jh8lywdx.isText(elm) ? $_lh5l42wjh8lywr8.get(elm) === '\xA0' : isBr(elm);
      };
      var isPaddedElement = function (elm) {
        return $_5wjzy24jh8lyw2t.filter($_a43q0i17jh8lywfe.children(elm), isPaddingContents).length === 1;
      };
      var trimBlockTrailingBr = function (elm) {
        $_a43q0i17jh8lywfe.lastChild(elm).each(function (lastChild) {
          $_a43q0i17jh8lywfe.prevSibling(lastChild).each(function (lastChildPrevSibling) {
            if (isBlock(elm) && isBr(lastChild) && isBlock(lastChildPrevSibling)) {
              $_bfmuql2ujh8lywr1.remove(lastChild);
            }
          });
        });
      };
      var $_2bvsfb2tjh8lywqo = {
        removeTrailingBr: removeTrailingBr,
        fillWithPaddingBr: fillWithPaddingBr,
        isPaddedElement: isPaddedElement,
        trimBlockTrailingBr: trimBlockTrailingBr
      };

      var makeMap$3 = $_ahowuxkjh8lywbj.makeMap;
      function Writer (settings) {
        var html = [];
        var indent, indentBefore, indentAfter, encode, htmlOutput;
        settings = settings || {};
        indent = settings.indent;
        indentBefore = makeMap$3(settings.indent_before || '');
        indentAfter = makeMap$3(settings.indent_after || '');
        encode = $_gex7a11rjh8lywi4.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
        htmlOutput = settings.element_format === 'html';
        return {
          start: function (name, attrs, empty) {
            var i, l, attr, value;
            if (indent && indentBefore[name] && html.length > 0) {
              value = html[html.length - 1];
              if (value.length > 0 && value !== '\n') {
                html.push('\n');
              }
            }
            html.push('<', name);
            if (attrs) {
              for (i = 0, l = attrs.length; i < l; i++) {
                attr = attrs[i];
                html.push(' ', attr.name, '="', encode(attr.value, true), '"');
              }
            }
            if (!empty || htmlOutput) {
              html[html.length] = '>';
            } else {
              html[html.length] = ' />';
            }
            if (empty && indent && indentAfter[name] && html.length > 0) {
              value = html[html.length - 1];
              if (value.length > 0 && value !== '\n') {
                html.push('\n');
              }
            }
          },
          end: function (name) {
            var value;
            html.push('</', name, '>');
            if (indent && indentAfter[name] && html.length > 0) {
              value = html[html.length - 1];
              if (value.length > 0 && value !== '\n') {
                html.push('\n');
              }
            }
          },
          text: function (text, raw) {
            if (text.length > 0) {
              html[html.length] = raw ? text : encode(text);
            }
          },
          cdata: function (text) {
            html.push('<![CDATA[', text, ']]>');
          },
          comment: function (text) {
            html.push('<!--', text, '-->');
          },
          pi: function (name, text) {
            if (text) {
              html.push('<?', name, ' ', encode(text), '?>');
            } else {
              html.push('<?', name, '?>');
            }
            if (indent) {
              html.push('\n');
            }
          },
          doctype: function (text) {
            html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
          },
          reset: function () {
            html.length = 0;
          },
          getContent: function () {
            return html.join('').replace(/\n$/, '');
          }
        };
      }

      function HtmlSerializer (settings, schema) {
        if (schema === void 0) {
          schema = Schema();
        }
        var writer = Writer(settings);
        settings = settings || {};
        settings.validate = 'validate' in settings ? settings.validate : true;
        var serialize = function (node) {
          var handlers, validate;
          validate = settings.validate;
          handlers = {
            3: function (node) {
              writer.text(node.value, node.raw);
            },
            8: function (node) {
              writer.comment(node.value);
            },
            7: function (node) {
              writer.pi(node.name, node.value);
            },
            10: function (node) {
              writer.doctype(node.value);
            },
            4: function (node) {
              writer.cdata(node.value);
            },
            11: function (node) {
              if (node = node.firstChild) {
                do {
                  walk(node);
                } while (node = node.next);
              }
            }
          };
          writer.reset();
          var walk = function (node) {
            var handler = handlers[node.type];
            var name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
            if (!handler) {
              name = node.name;
              isEmpty = node.shortEnded;
              attrs = node.attributes;
              if (validate && attrs && attrs.length > 1) {
                sortedAttrs = [];
                sortedAttrs.map = {};
                elementRule = schema.getElementRule(node.name);
                if (elementRule) {
                  for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
                    attrName = elementRule.attributesOrder[i];
                    if (attrName in attrs.map) {
                      attrValue = attrs.map[attrName];
                      sortedAttrs.map[attrName] = attrValue;
                      sortedAttrs.push({
                        name: attrName,
                        value: attrValue
                      });
                    }
                  }
                  for (i = 0, l = attrs.length; i < l; i++) {
                    attrName = attrs[i].name;
                    if (!(attrName in sortedAttrs.map)) {
                      attrValue = attrs.map[attrName];
                      sortedAttrs.map[attrName] = attrValue;
                      sortedAttrs.push({
                        name: attrName,
                        value: attrValue
                      });
                    }
                  }
                  attrs = sortedAttrs;
                }
              }
              writer.start(node.name, attrs, isEmpty);
              if (!isEmpty) {
                if (node = node.firstChild) {
                  do {
                    walk(node);
                  } while (node = node.next);
                }
                writer.end(name);
              }
            } else {
              handler(node);
            }
          };
          if (node.type === 1 && !settings.inner) {
            walk(node);
          } else {
            handlers[11](node);
          }
          return writer.getContent();
        };
        return { serialize: serialize };
      }

      var createRange$1 = function (sc, so, ec, eo) {
        var rng = document.createRange();
        rng.setStart(sc, so);
        rng.setEnd(ec, eo);
        return rng;
      };
      var normalizeBlockSelectionRange = function (rng) {
        var startPos = CaretPosition$1.fromRangeStart(rng);
        var endPos = CaretPosition$1.fromRangeEnd(rng);
        var rootNode = rng.commonAncestorContainer;
        return $_9kvypj2cjh8lywnz.fromPosition(false, rootNode, endPos).map(function (newEndPos) {
          if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
            return createRange$1(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
          } else {
            return rng;
          }
        }).getOr(rng);
      };
      var normalize = function (rng) {
        return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
      };
      var $_cnbluh30jh8lywrn = { normalize: normalize };

      var isTableCell$2 = $_5oonaz1qjh8lywhz.matchNodeNames('td th');
      var validInsertion = function (editor, value, parentNode) {
        if (parentNode.getAttribute('data-mce-bogus') === 'all') {
          parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
        } else {
          var node = parentNode.firstChild;
          var node2 = parentNode.lastChild;
          if (!node || node === node2 && node.nodeName === 'BR') {
            editor.dom.setHTML(parentNode, value);
          } else {
            editor.selection.setContent(value);
          }
        }
      };
      var trimBrsFromTableCell = function (dom, elm) {
        Option.from(dom.getParent(elm, 'td,th')).map($_cgttw3zjh8lywdq.fromDom).each($_2bvsfb2tjh8lywqo.trimBlockTrailingBr);
      };
      var insertHtmlAtCaret = function (editor, value, details) {
        var parser, serializer, parentNode, rootNode, fragment, args;
        var marker, rng, node, node2, bookmarkHtml, merge;
        var textInlineElements = editor.schema.getTextInlineElements();
        var selection = editor.selection, dom = editor.dom;
        var trimOrPaddLeftRight = function (html) {
          var rng, container, offset;
          rng = selection.getRng();
          container = rng.startContainer;
          offset = rng.startOffset;
          var hasSiblingText = function (siblingName) {
            return container[siblingName] && container[siblingName].nodeType === 3;
          };
          if (container.nodeType === 3) {
            if (offset > 0) {
              html = html.replace(/^&nbsp;/, ' ');
            } else if (!hasSiblingText('previousSibling')) {
              html = html.replace(/^ /, '&nbsp;');
            }
            if (offset < container.length) {
              html = html.replace(/&nbsp;(<br>|)$/, ' ');
            } else if (!hasSiblingText('nextSibling')) {
              html = html.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;');
            }
          }
          return html;
        };
        var trimNbspAfterDeleteAndPaddValue = function () {
          var rng, container, offset;
          rng = selection.getRng();
          container = rng.startContainer;
          offset = rng.startOffset;
          if (container.nodeType === 3 && rng.collapsed) {
            if (container.data[offset] === '\xA0') {
              container.deleteData(offset, 1);
              if (!/[\u00a0| ]$/.test(value)) {
                value += ' ';
              }
            } else if (container.data[offset - 1] === '\xA0') {
              container.deleteData(offset - 1, 1);
              if (!/[\u00a0| ]$/.test(value)) {
                value = ' ' + value;
              }
            }
          }
        };
        var reduceInlineTextElements = function () {
          if (merge) {
            var root_1 = editor.getBody(), elementUtils_1 = new ElementUtils(dom);
            $_ahowuxkjh8lywbj.each(dom.select('*[data-mce-fragment]'), function (node) {
              for (var testNode = node.parentNode; testNode && testNode !== root_1; testNode = testNode.parentNode) {
                if (textInlineElements[node.nodeName.toLowerCase()] && elementUtils_1.compare(testNode, node)) {
                  dom.remove(node, true);
                }
              }
            });
          }
        };
        var markFragmentElements = function (fragment) {
          var node = fragment;
          while (node = node.walk()) {
            if (node.type === 1) {
              node.attr('data-mce-fragment', '1');
            }
          }
        };
        var umarkFragmentElements = function (elm) {
          $_ahowuxkjh8lywbj.each(elm.getElementsByTagName('*'), function (elm) {
            elm.removeAttribute('data-mce-fragment');
          });
        };
        var isPartOfFragment = function (node) {
          return !!node.getAttribute('data-mce-fragment');
        };
        var canHaveChildren = function (node) {
          return node && !editor.schema.getShortEndedElements()[node.nodeName];
        };
        var moveSelectionToMarker = function (marker) {
          var parentEditableFalseElm, parentBlock, nextRng;
          var getContentEditableFalseParent = function (node) {
            var root = editor.getBody();
            for (; node && node !== root; node = node.parentNode) {
              if (editor.dom.getContentEditable(node) === 'false') {
                return node;
              }
            }
            return null;
          };
          if (!marker) {
            return;
          }
          selection.scrollIntoView(marker);
          parentEditableFalseElm = getContentEditableFalseParent(marker);
          if (parentEditableFalseElm) {
            dom.remove(marker);
            selection.select(parentEditableFalseElm);
            return;
          }
          rng = dom.createRng();
          node = marker.previousSibling;
          if (node && node.nodeType === 3) {
            rng.setStart(node, node.nodeValue.length);
            if (!$_9bpim8ajh8lyw68.ie) {
              node2 = marker.nextSibling;
              if (node2 && node2.nodeType === 3) {
                node.appendData(node2.data);
                node2.parentNode.removeChild(node2);
              }
            }
          } else {
            rng.setStartBefore(marker);
            rng.setEndBefore(marker);
          }
          var findNextCaretRng = function (rng) {
            var caretPos = CaretPosition$1.fromRangeStart(rng);
            var caretWalker = CaretWalker(editor.getBody());
            caretPos = caretWalker.next(caretPos);
            if (caretPos) {
              return caretPos.toRange();
            }
          };
          parentBlock = dom.getParent(marker, dom.isBlock);
          dom.remove(marker);
          if (parentBlock && dom.isEmpty(parentBlock)) {
            editor.$(parentBlock).empty();
            rng.setStart(parentBlock, 0);
            rng.setEnd(parentBlock, 0);
            if (!isTableCell$2(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
              rng = nextRng;
              dom.remove(parentBlock);
            } else {
              dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
            }
          }
          selection.setRng(rng);
        };
        if (/^ | $/.test(value)) {
          value = trimOrPaddLeftRight(value);
        }
        parser = editor.parser;
        merge = details.merge;
        serializer = HtmlSerializer({ validate: editor.settings.validate }, editor.schema);
        bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
        args = {
          content: value,
          format: 'html',
          selection: true,
          paste: details.paste
        };
        args = editor.fire('BeforeSetContent', args);
        if (args.isDefaultPrevented()) {
          editor.fire('SetContent', {
            content: args.content,
            format: 'html',
            selection: true,
            paste: details.paste
          });
          return;
        }
        value = args.content;
        if (value.indexOf('{$caret}') === -1) {
          value += '{$caret}';
        }
        value = value.replace(/\{\$caret\}/, bookmarkHtml);
        rng = selection.getRng();
        var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
        var body = editor.getBody();
        if (caretElement === body && selection.isCollapsed()) {
          if (dom.isBlock(body.firstChild) && canHaveChildren(body.firstChild) && dom.isEmpty(body.firstChild)) {
            rng = dom.createRng();
            rng.setStart(body.firstChild, 0);
            rng.setEnd(body.firstChild, 0);
            selection.setRng(rng);
          }
        }
        if (!selection.isCollapsed()) {
          editor.selection.setRng($_cnbluh30jh8lywrn.normalize(editor.selection.getRng()));
          editor.getDoc().execCommand('Delete', false, null);
          trimNbspAfterDeleteAndPaddValue();
        }
        parentNode = selection.getNode();
        var parserArgs = {
          context: parentNode.nodeName.toLowerCase(),
          data: details.data,
          insert: true
        };
        fragment = parser.parse(value, parserArgs);
        if (details.paste === true && $_eajoh11xjh8lywl6.isListFragment(editor.schema, fragment) && $_eajoh11xjh8lywl6.isParentBlockLi(dom, parentNode)) {
          rng = $_eajoh11xjh8lywl6.insertAtCaret(serializer, dom, editor.selection.getRng(), fragment);
          editor.selection.setRng(rng);
          editor.fire('SetContent', args);
          return;
        }
        markFragmentElements(fragment);
        node = fragment.lastChild;
        if (node.attr('id') === 'mce_marker') {
          marker = node;
          for (node = node.prev; node; node = node.walk(true)) {
            if (node.type === 3 || !dom.isBlock(node.name)) {
              if (editor.schema.isValidChild(node.parent.name, 'span')) {
                node.parent.insert(marker, node, node.name === 'br');
              }
              break;
            }
          }
        }
        editor._selectionOverrides.showBlockCaretContainer(parentNode);
        if (!parserArgs.invalid) {
          value = serializer.serialize(fragment);
          validInsertion(editor, value, parentNode);
        } else {
          selection.setContent(bookmarkHtml);
          parentNode = selection.getNode();
          rootNode = editor.getBody();
          if (parentNode.nodeType === 9) {
            parentNode = node = rootNode;
          } else {
            node = parentNode;
          }
          while (node !== rootNode) {
            parentNode = node;
            node = node.parentNode;
          }
          value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
          value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
            return serializer.serialize(fragment);
          })));
          if (parentNode === rootNode) {
            dom.setHTML(rootNode, value);
          } else {
            dom.setOuterHTML(parentNode, value);
          }
        }
        reduceInlineTextElements();
        moveSelectionToMarker(dom.get('mce_marker'));
        umarkFragmentElements(editor.getBody());
        trimBrsFromTableCell(editor.dom, editor.selection.getStart());
        editor.fire('SetContent', args);
        editor.addVisual();
      };
      var processValue = function (value) {
        var details;
        if (typeof value !== 'string') {
          details = $_ahowuxkjh8lywbj.extend({
            paste: value.paste,
            data: { paste: value.paste }
          }, value);
          return {
            content: value.content,
            details: details
          };
        }
        return {
          content: value,
          details: {}
        };
      };
      var insertAtCaret$1 = function (editor, value) {
        var result = processValue(value);
        insertHtmlAtCaret(editor, result.content, result.details);
      };
      var $_13xltl1wjh8lywkr = { insertAtCaret: insertAtCaret$1 };

      function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
        return is(scope, a) ? Option.some(scope) : $_dp4g6d7jh8lyw3y.isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
      }

      var first$1 = function (predicate) {
        return descendant($_boa99a15jh8lywey.body(), predicate);
      };
      var ancestor = function (scope, predicate, isRoot) {
        var element = scope.dom();
        var stop = $_dp4g6d7jh8lyw3y.isFunction(isRoot) ? isRoot : $_eqpqvr6jh8lyw3s.constant(false);
        while (element.parentNode) {
          element = element.parentNode;
          var el = $_cgttw3zjh8lywdq.fromDom(element);
          if (predicate(el))
            return Option.some(el);
          else if (stop(el))
            break;
        }
        return Option.none();
      };
      var closest = function (scope, predicate, isRoot) {
        var is = function (scope) {
          return predicate(scope);
        };
        return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
      };
      var sibling$1 = function (scope, predicate) {
        var element = scope.dom();
        if (!element.parentNode)
          return Option.none();
        return child$1($_cgttw3zjh8lywdq.fromDom(element.parentNode), function (x) {
          return !$_5f6gpb1djh8lywg5.eq(scope, x) && predicate(x);
        });
      };
      var child$1 = function (scope, predicate) {
        var result = $_5wjzy24jh8lyw2t.find(scope.dom().childNodes, $_eqpqvr6jh8lyw3s.compose(predicate, $_cgttw3zjh8lywdq.fromDom));
        return result.map($_cgttw3zjh8lywdq.fromDom);
      };
      var descendant = function (scope, predicate) {
        var descend = function (element) {
          for (var i = 0; i < element.childNodes.length; i++) {
            if (predicate($_cgttw3zjh8lywdq.fromDom(element.childNodes[i])))
              return Option.some($_cgttw3zjh8lywdq.fromDom(element.childNodes[i]));
            var res = descend(element.childNodes[i]);
            if (res.isSome())
              return res;
          }
          return Option.none();
        };
        return descend(scope.dom());
      };
      var $_6hl03835jh8lywsm = {
        first: first$1,
        ancestor: ancestor,
        closest: closest,
        sibling: sibling$1,
        child: child$1,
        descendant: descendant
      };

      var sectionResult = $_4jz0ce18jh8lywft.immutable('sections', 'settings');
      var detection = $_9hkktfnjh8lywc6.detect();
      var isTouch = detection.deviceType.isTouch();
      var mobilePlugins = [
        'lists',
        'autolink',
        'autosave'
      ];
      var defaultMobileSettings = { theme: 'mobile' };
      var normalizePlugins = function (plugins) {
        var pluginNames = $_dp4g6d7jh8lyw3y.isArray(plugins) ? plugins.join(' ') : plugins;
        var trimmedPlugins = $_5wjzy24jh8lyw2t.map($_dp4g6d7jh8lyw3y.isString(pluginNames) ? pluginNames.split(' ') : [], $_4w196awjh8lywdj.trim);
        return $_5wjzy24jh8lyw2t.filter(trimmedPlugins, function (item) {
          return item.length > 0;
        });
      };
      var filterMobilePlugins = function (plugins) {
        return $_5wjzy24jh8lyw2t.filter(plugins, $_eqpqvr6jh8lyw3s.curry($_5wjzy24jh8lyw2t.contains, mobilePlugins));
      };
      var extractSections = function (keys, settings) {
        var result = $_g63v2c13jh8lywej.bifilter(settings, function (value, key) {
          return $_5wjzy24jh8lyw2t.contains(keys, key);
        });
        return sectionResult(result.t, result.f);
      };
      var getSection = function (sectionResult, name, defaults) {
        var sections = sectionResult.sections();
        var sectionSettings = sections.hasOwnProperty(name) ? sections[name] : {};
        return $_ahowuxkjh8lywbj.extend({}, defaults, sectionSettings);
      };
      var hasSection = function (sectionResult, name) {
        return sectionResult.sections().hasOwnProperty(name);
      };
      var getDefaultSettings = function (id, documentBaseUrl, editor) {
        return {
          id: id,
          theme: 'modern',
          delta_width: 0,
          delta_height: 0,
          popup_css: '',
          plugins: '',
          document_base_url: documentBaseUrl,
          add_form_submit_trigger: true,
          submit_patch: true,
          add_unload_trigger: true,
          convert_urls: true,
          relative_urls: true,
          remove_script_host: true,
          object_resizing: true,
          doctype: '<!DOCTYPE html>',
          visual: true,
          font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
          font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
          forced_root_block: 'p',
          hidden_input: true,
          render_ui: true,
          indentation: '30px',
          inline_styles: true,
          convert_fonts_to_spans: true,
          indent: 'simple',
          indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
          indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
          entity_encoding: 'named',
          url_converter: editor.convertURL,
          url_converter_scope: editor,
          ie7_compat: true
        };
      };
      var getExternalPlugins = function (overrideSettings, settings) {
        var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
        if (overrideSettings && overrideSettings.external_plugins) {
          return $_ahowuxkjh8lywbj.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
        } else {
          return userDefinedExternalPlugins;
        }
      };
      var combinePlugins = function (forcedPlugins, plugins) {
        return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
      };
      var processPlugins = function (isTouchDevice, sectionResult, defaultOverrideSettings, settings) {
        var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
        var plugins = normalizePlugins(settings.plugins);
        var platformPlugins = isTouchDevice && hasSection(sectionResult, 'mobile') ? filterMobilePlugins(plugins) : plugins;
        var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
        return $_ahowuxkjh8lywbj.extend(settings, { plugins: combinedPlugins.join(' ') });
      };
      var isOnMobile = function (isTouchDevice, sectionResult) {
        var isInline = sectionResult.settings().inline;
        return isTouchDevice && hasSection(sectionResult, 'mobile') && !isInline;
      };
      var combineSettings = function (isTouchDevice, defaultSettings, defaultOverrideSettings, settings) {
        var sectionResult = extractSections(['mobile'], settings);
        var extendedSettings = $_ahowuxkjh8lywbj.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isTouchDevice, sectionResult) ? getSection(sectionResult, 'mobile', defaultMobileSettings) : {}, {
          validate: true,
          content_editable: sectionResult.settings().inline,
          external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
        });
        return processPlugins(isTouchDevice, sectionResult, defaultOverrideSettings, extendedSettings);
      };
      var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
        var defaultSettings = getDefaultSettings(id, documentBaseUrl, editor);
        return combineSettings(isTouch, defaultSettings, defaultOverrideSettings, settings);
      };
      var getFiltered = function (predicate, editor, name) {
        return Option.from(editor.settings[name]).filter(predicate);
      };
      var getString = $_eqpqvr6jh8lyw3s.curry(getFiltered, $_dp4g6d7jh8lyw3y.isString);
      var getParamObject = function (value) {
        var output = {};
        if (typeof value === 'string') {
          $_5wjzy24jh8lyw2t.each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
            var arr = val.split('=');
            if (arr.length > 1) {
              output[$_ahowuxkjh8lywbj.trim(arr[0])] = $_ahowuxkjh8lywbj.trim(arr[1]);
            } else {
              output[$_ahowuxkjh8lywbj.trim(arr[0])] = $_ahowuxkjh8lywbj.trim(arr);
            }
          });
        } else {
          output = value;
        }
        return output;
      };
      var isArrayOf = function (p) {
        return function (a) {
          return $_dp4g6d7jh8lyw3y.isArray(a) && $_5wjzy24jh8lyw2t.forall(a, p);
        };
      };
      var getParam = function (editor, name, defaultVal, type) {
        var value = name in editor.settings ? editor.settings[name] : defaultVal;
        if (type === 'hash') {
          return getParamObject(value);
        } else if (type === 'string') {
          return getFiltered($_dp4g6d7jh8lyw3y.isString, editor, name).getOr(defaultVal);
        } else if (type === 'number') {
          return getFiltered($_dp4g6d7jh8lyw3y.isNumber, editor, name).getOr(defaultVal);
        } else if (type === 'boolean') {
          return getFiltered($_dp4g6d7jh8lyw3y.isBoolean, editor, name).getOr(defaultVal);
        } else if (type === 'object') {
          return getFiltered($_dp4g6d7jh8lyw3y.isObject, editor, name).getOr(defaultVal);
        } else if (type === 'array') {
          return getFiltered($_dp4g6d7jh8lyw3y.isArray, editor, name).getOr(defaultVal);
        } else if (type === 'string[]') {
          return getFiltered(isArrayOf($_dp4g6d7jh8lyw3y.isString), editor, name).getOr(defaultVal);
        } else if (type === 'function') {
          return getFiltered($_dp4g6d7jh8lyw3y.isFunction, editor, name).getOr(defaultVal);
        } else {
          return value;
        }
      };

      var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
      var hasStrongRtl = function (text) {
        return strongRtl.test(text);
      };

      var isInlineTarget = function (editor, elm) {
        var selector = getString(editor, 'inline_boundaries_selector').getOr('a[href],code');
        return $_5h4ipt1fjh8lywgi.is($_cgttw3zjh8lywdq.fromDom(elm), selector);
      };
      var isRtl = function (element) {
        return DOMUtils$1.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
      };
      var findInlineParents = function (isInlineTarget, rootNode, pos) {
        return $_5wjzy24jh8lyw2t.filter(DOMUtils$1.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
      };
      var findRootInline = function (isInlineTarget, rootNode, pos) {
        var parents = findInlineParents(isInlineTarget, rootNode, pos);
        return Option.from(parents[parents.length - 1]);
      };
      var hasSameParentBlock = function (rootNode, node1, node2) {
        var block1 = getParentBlock(node1, rootNode);
        var block2 = getParentBlock(node2, rootNode);
        return block1 && block1 === block2;
      };
      var isAtZwsp = function (pos) {
        return isBeforeInline(pos) || isAfterInline(pos);
      };
      var normalizePosition = function (forward, pos) {
        var container = pos.container(), offset = pos.offset();
        if (forward) {
          if (isCaretContainerInline(container)) {
            if ($_5oonaz1qjh8lywhz.isText(container.nextSibling)) {
              return CaretPosition$1(container.nextSibling, 0);
            } else {
              return CaretPosition$1.after(container);
            }
          } else {
            return isBeforeInline(pos) ? CaretPosition$1(container, offset + 1) : pos;
          }
        } else {
          if (isCaretContainerInline(container)) {
            if ($_5oonaz1qjh8lywhz.isText(container.previousSibling)) {
              return CaretPosition$1(container.previousSibling, container.previousSibling.data.length);
            } else {
              return CaretPosition$1.before(container);
            }
          } else {
            return isAfterInline(pos) ? CaretPosition$1(container, offset - 1) : pos;
          }
        }
      };
      var normalizeForwards = $_eqpqvr6jh8lyw3s.curry(normalizePosition, true);
      var normalizeBackwards = $_eqpqvr6jh8lyw3s.curry(normalizePosition, false);
      var $_231v7s37jh8lywt3 = {
        isInlineTarget: isInlineTarget,
        findRootInline: findRootInline,
        isRtl: isRtl,
        isAtZwsp: isAtZwsp,
        normalizePosition: normalizePosition,
        normalizeForwards: normalizeForwards,
        normalizeBackwards: normalizeBackwards,
        hasSameParentBlock: hasSameParentBlock
      };

      var isBeforeRoot = function (rootNode) {
        return function (elm) {
          return $_5f6gpb1djh8lywg5.eq(rootNode, $_cgttw3zjh8lywdq.fromDom(elm.dom().parentNode));
        };
      };
      var getParentBlock$1 = function (rootNode, elm) {
        return $_5f6gpb1djh8lywg5.contains(rootNode, elm) ? $_6hl03835jh8lywsm.closest(elm, function (element) {
          return isTextBlock(element) || isListItem(element);
        }, isBeforeRoot(rootNode)) : Option.none();
      };
      var placeCaretInEmptyBody = function (editor) {
        var body = editor.getBody();
        var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
        editor.selection.setCursorLocation(node, 0);
      };
      var paddEmptyBody = function (editor) {
        if (editor.dom.isEmpty(editor.getBody())) {
          editor.setContent('');
          placeCaretInEmptyBody(editor);
        }
      };
      var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
        return $_b8twwq26jh8lywmm.liftN([
          $_9kvypj2cjh8lywnz.firstPositionIn(elm),
          $_9kvypj2cjh8lywnz.lastPositionIn(elm)
        ], function (firstPos, lastPos) {
          var normalizedFirstPos = $_231v7s37jh8lywt3.normalizePosition(true, firstPos);
          var normalizedLastPos = $_231v7s37jh8lywt3.normalizePosition(false, lastPos);
          var normalizedFromPos = $_231v7s37jh8lywt3.normalizePosition(false, fromPos);
          if (forward) {
            return $_9kvypj2cjh8lywnz.nextPosition(elm, normalizedFromPos).map(function (nextPos) {
              return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
            }).getOr(false);
          } else {
            return $_9kvypj2cjh8lywnz.prevPosition(elm, normalizedFromPos).map(function (prevPos) {
              return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
            }).getOr(false);
          }
        }).getOr(true);
      };
      var $_aj8isd34jh8lyws4 = {
        getParentBlock: getParentBlock$1,
        paddEmptyBody: paddEmptyBody,
        willDeleteLastPositionInElement: willDeleteLastPositionInElement
      };

      var first$2 = function (selector) {
        return $_5h4ipt1fjh8lywgi.one(selector);
      };
      var ancestor$1 = function (scope, selector, isRoot) {
        return $_6hl03835jh8lywsm.ancestor(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        }, isRoot);
      };
      var sibling$2 = function (scope, selector) {
        return $_6hl03835jh8lywsm.sibling(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        });
      };
      var child$2 = function (scope, selector) {
        return $_6hl03835jh8lywsm.child(scope, function (e) {
          return $_5h4ipt1fjh8lywgi.is(e, selector);
        });
      };
      var descendant$1 = function (scope, selector) {
        return $_5h4ipt1fjh8lywgi.one(selector, scope);
      };
      var closest$1 = function (scope, selector, isRoot) {
        return ClosestOrAncestor($_5h4ipt1fjh8lywgi.is, ancestor$1, scope, selector, isRoot);
      };
      var $_7sg18r3cjh8lywu1 = {
        first: first$2,
        ancestor: ancestor$1,
        sibling: sibling$2,
        child: child$2,
        descendant: descendant$1,
        closest: closest$1
      };

      var any = function (selector) {
        return $_7sg18r3cjh8lywu1.first(selector).isSome();
      };
      var ancestor$2 = function (scope, selector, isRoot) {
        return $_7sg18r3cjh8lywu1.ancestor(scope, selector, isRoot).isSome();
      };
      var sibling$3 = function (scope, selector) {
        return $_7sg18r3cjh8lywu1.sibling(scope, selector).isSome();
      };
      var child$3 = function (scope, selector) {
        return $_7sg18r3cjh8lywu1.child(scope, selector).isSome();
      };
      var descendant$2 = function (scope, selector) {
        return $_7sg18r3cjh8lywu1.descendant(scope, selector).isSome();
      };
      var closest$2 = function (scope, selector, isRoot) {
        return $_7sg18r3cjh8lywu1.closest(scope, selector, isRoot).isSome();
      };
      var $_8b29ae3bjh8lywu0 = {
        any: any,
        ancestor: ancestor$2,
        sibling: sibling$3,
        child: child$3,
        descendant: descendant$2,
        closest: closest$2
      };

      var hasWhitespacePreserveParent = function (rootNode, node) {
        var rootElement = $_cgttw3zjh8lywdq.fromDom(rootNode);
        var startNode = $_cgttw3zjh8lywdq.fromDom(node);
        return $_8b29ae3bjh8lywu0.ancestor(startNode, 'pre,code', $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, rootElement));
      };
      var isWhitespace = function (rootNode, node) {
        return $_5oonaz1qjh8lywhz.isText(node) && /^[ \t\r\n]*$/.test(node.data) && hasWhitespacePreserveParent(rootNode, node) === false;
      };
      var isNamedAnchor = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && node.nodeName === 'A' && node.hasAttribute('name');
      };
      var isContent = function (rootNode, node) {
        return isCaretCandidate(node) && isWhitespace(rootNode, node) === false || isNamedAnchor(node) || isBookmark(node);
      };
      var isBookmark = $_5oonaz1qjh8lywhz.hasAttribute('data-mce-bookmark');
      var isBogus$2 = $_5oonaz1qjh8lywhz.hasAttribute('data-mce-bogus');
      var isBogusAll$1 = $_5oonaz1qjh8lywhz.hasAttributeValue('data-mce-bogus', 'all');
      var isEmptyNode = function (targetNode) {
        var walker, node, brCount = 0;
        if (isContent(targetNode, targetNode)) {
          return false;
        } else {
          node = targetNode.firstChild;
          if (!node) {
            return true;
          }
          walker = new TreeWalker(node, targetNode);
          do {
            if (isBogusAll$1(node)) {
              node = walker.next(true);
              continue;
            }
            if (isBogus$2(node)) {
              node = walker.next();
              continue;
            }
            if ($_5oonaz1qjh8lywhz.isBr(node)) {
              brCount++;
              node = walker.next();
              continue;
            }
            if (isContent(targetNode, node)) {
              return false;
            }
            node = walker.next();
          } while (node);
          return brCount <= 1;
        }
      };
      var isEmpty$1 = function (elm) {
        return isEmptyNode(elm.dom());
      };
      var $_b1urh33ajh8lywts = { isEmpty: isEmpty$1 };

      var BlockPosition = $_4jz0ce18jh8lywft.immutable('block', 'position');
      var BlockBoundary = $_4jz0ce18jh8lywft.immutable('from', 'to');
      var getBlockPosition = function (rootNode, pos) {
        var rootElm = $_cgttw3zjh8lywdq.fromDom(rootNode);
        var containerElm = $_cgttw3zjh8lywdq.fromDom(pos.container());
        return $_aj8isd34jh8lyws4.getParentBlock(rootElm, containerElm).map(function (block) {
          return BlockPosition(block, pos);
        });
      };
      var isDifferentBlocks = function (blockBoundary) {
        return $_5f6gpb1djh8lywg5.eq(blockBoundary.from().block(), blockBoundary.to().block()) === false;
      };
      var hasSameParent = function (blockBoundary) {
        return $_a43q0i17jh8lywfe.parent(blockBoundary.from().block()).bind(function (parent1) {
          return $_a43q0i17jh8lywfe.parent(blockBoundary.to().block()).filter(function (parent2) {
            return $_5f6gpb1djh8lywg5.eq(parent1, parent2);
          });
        }).isSome();
      };
      var isEditable = function (blockBoundary) {
        return $_5oonaz1qjh8lywhz.isContentEditableFalse(blockBoundary.from().block()) === false && $_5oonaz1qjh8lywhz.isContentEditableFalse(blockBoundary.to().block()) === false;
      };
      var skipLastBr = function (rootNode, forward, blockPosition) {
        if ($_5oonaz1qjh8lywhz.isBr(blockPosition.position().getNode()) && $_b1urh33ajh8lywts.isEmpty(blockPosition.block()) === false) {
          return $_9kvypj2cjh8lywnz.positionIn(false, blockPosition.block().dom()).bind(function (lastPositionInBlock) {
            if (lastPositionInBlock.isEqual(blockPosition.position())) {
              return $_9kvypj2cjh8lywnz.fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
                return getBlockPosition(rootNode, to);
              });
            } else {
              return Option.some(blockPosition);
            }
          }).getOr(blockPosition);
        } else {
          return blockPosition;
        }
      };
      var readFromRange = function (rootNode, forward, rng) {
        var fromBlockPos = getBlockPosition(rootNode, CaretPosition$1.fromRangeStart(rng));
        var toBlockPos = fromBlockPos.bind(function (blockPos) {
          return $_9kvypj2cjh8lywnz.fromPosition(forward, rootNode, blockPos.position()).bind(function (to) {
            return getBlockPosition(rootNode, to).map(function (blockPos) {
              return skipLastBr(rootNode, forward, blockPos);
            });
          });
        });
        return $_b8twwq26jh8lywmm.liftN([
          fromBlockPos,
          toBlockPos
        ], BlockBoundary).filter(function (blockBoundary) {
          return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable(blockBoundary);
        });
      };
      var read = function (rootNode, forward, rng) {
        return rng.collapsed ? readFromRange(rootNode, forward, rng) : Option.none();
      };
      var $_bmbex333jh8lywru = { read: read };

      var dropLast = function (xs) {
        return xs.slice(0, -1);
      };
      var parentsUntil$1 = function (startNode, rootElm, predicate) {
        if ($_5f6gpb1djh8lywg5.contains(rootElm, startNode)) {
          return dropLast($_a43q0i17jh8lywfe.parents(startNode, function (elm) {
            return predicate(elm) || $_5f6gpb1djh8lywg5.eq(elm, rootElm);
          }));
        } else {
          return [];
        }
      };
      var parents$1 = function (startNode, rootElm) {
        return parentsUntil$1(startNode, rootElm, $_eqpqvr6jh8lyw3s.constant(false));
      };
      var parentsAndSelf = function (startNode, rootElm) {
        return [startNode].concat(parents$1(startNode, rootElm));
      };
      var $_dyxtub3ejh8lywxq = {
        parentsUntil: parentsUntil$1,
        parents: parents$1,
        parentsAndSelf: parentsAndSelf
      };

      var getChildrenUntilBlockBoundary = function (block) {
        var children = $_a43q0i17jh8lywfe.children(block);
        return $_5wjzy24jh8lyw2t.findIndex(children, isBlock).fold(function () {
          return children;
        }, function (index) {
          return children.slice(0, index);
        });
      };
      var extractChildren = function (block) {
        var children = getChildrenUntilBlockBoundary(block);
        $_5wjzy24jh8lyw2t.each(children, function (node) {
          $_bfmuql2ujh8lywr1.remove(node);
        });
        return children;
      };
      var trimBr = function (first, block) {
        $_9kvypj2cjh8lywnz.positionIn(first, block.dom()).each(function (position) {
          var node = position.getNode();
          if ($_5oonaz1qjh8lywhz.isBr(node)) {
            $_bfmuql2ujh8lywr1.remove($_cgttw3zjh8lywdq.fromDom(node));
          }
        });
      };
      var removeEmptyRoot = function (rootNode, block) {
        var parents = $_dyxtub3ejh8lywxq.parentsAndSelf(block, rootNode);
        return $_5wjzy24jh8lyw2t.find(parents.reverse(), $_b1urh33ajh8lywts.isEmpty).each($_bfmuql2ujh8lywr1.remove);
      };
      var findParentInsertPoint = function (toBlock, block) {
        var parents = $_a43q0i17jh8lywfe.parents(block, function (elm) {
          return $_5f6gpb1djh8lywg5.eq(elm, toBlock);
        });
        return Option.from(parents[parents.length - 2]);
      };
      var getInsertionPoint = function (fromBlock, toBlock) {
        if ($_5f6gpb1djh8lywg5.contains(toBlock, fromBlock)) {
          return $_a43q0i17jh8lywfe.parent(fromBlock).bind(function (parent) {
            return $_5f6gpb1djh8lywg5.eq(parent, toBlock) ? Option.some(fromBlock) : findParentInsertPoint(toBlock, fromBlock);
          });
        } else {
          return Option.none();
        }
      };
      var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
        if ($_b1urh33ajh8lywts.isEmpty(toBlock)) {
          $_bfmuql2ujh8lywr1.remove(toBlock);
          if ($_b1urh33ajh8lywts.isEmpty(fromBlock)) {
            $_2bvsfb2tjh8lywqo.fillWithPaddingBr(fromBlock);
          }
          return $_9kvypj2cjh8lywnz.firstPositionIn(fromBlock.dom());
        } else {
          trimBr(true, fromBlock);
          trimBr(false, toBlock);
          var children_1 = extractChildren(fromBlock);
          return getInsertionPoint(fromBlock, toBlock).fold(function () {
            removeEmptyRoot(rootNode, fromBlock);
            var position = $_9kvypj2cjh8lywnz.lastPositionIn(toBlock.dom());
            $_5wjzy24jh8lyw2t.each(children_1, function (node) {
              $_4m7u2e2kjh8lywpi.append(toBlock, node);
            });
            return position;
          }, function (target) {
            var position = $_9kvypj2cjh8lywnz.prevPosition(toBlock.dom(), CaretPosition$1.before(target.dom()));
            $_5wjzy24jh8lyw2t.each(children_1, function (node) {
              $_4m7u2e2kjh8lywpi.before(target, node);
            });
            removeEmptyRoot(rootNode, fromBlock);
            return position;
          });
        }
      };
      var mergeBlocks = function (rootNode, forward, block1, block2) {
        return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
      };
      var $_4yurvx3djh8lywu4 = { mergeBlocks: mergeBlocks };

      var backspaceDelete = function (editor, forward) {
        var position;
        var rootNode = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        position = $_bmbex333jh8lywru.read(rootNode.dom(), forward, editor.selection.getRng()).bind(function (blockBoundary) {
          return $_4yurvx3djh8lywu4.mergeBlocks(rootNode, forward, blockBoundary.from().block(), blockBoundary.to().block());
        });
        position.each(function (pos) {
          editor.selection.setRng(pos.toRange());
        });
        return position.isSome();
      };
      var $_5jmwsv32jh8lywrr = { backspaceDelete: backspaceDelete };

      var deleteRangeMergeBlocks = function (rootNode, selection) {
        var rng = selection.getRng();
        return $_b8twwq26jh8lywmm.liftN([
          $_aj8isd34jh8lyws4.getParentBlock(rootNode, $_cgttw3zjh8lywdq.fromDom(rng.startContainer)),
          $_aj8isd34jh8lyws4.getParentBlock(rootNode, $_cgttw3zjh8lywdq.fromDom(rng.endContainer))
        ], function (block1, block2) {
          if ($_5f6gpb1djh8lywg5.eq(block1, block2) === false) {
            rng.deleteContents();
            $_4yurvx3djh8lywu4.mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
              selection.setRng(pos.toRange());
            });
            return true;
          } else {
            return false;
          }
        }).getOr(false);
      };
      var isRawNodeInTable = function (root, rawNode) {
        var node = $_cgttw3zjh8lywdq.fromDom(rawNode);
        var isRoot = $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, root);
        return $_6hl03835jh8lywsm.ancestor(node, isTableCell, isRoot).isSome();
      };
      var isSelectionInTable = function (root, rng) {
        return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
      };
      var isEverythingSelected = function (root, rng) {
        var noPrevious = $_9kvypj2cjh8lywnz.prevPosition(root.dom(), CaretPosition$1.fromRangeStart(rng)).isNone();
        var noNext = $_9kvypj2cjh8lywnz.nextPosition(root.dom(), CaretPosition$1.fromRangeEnd(rng)).isNone();
        return !isSelectionInTable(root, rng) && noPrevious && noNext;
      };
      var emptyEditor = function (editor) {
        editor.setContent('');
        editor.selection.setCursorLocation();
        return true;
      };
      var deleteRange = function (editor) {
        var rootNode = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        var rng = editor.selection.getRng();
        return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
      };
      var backspaceDelete$1 = function (editor, forward) {
        return editor.selection.isCollapsed() ? false : deleteRange(editor);
      };
      var $_lcy1p3fjh8lywxx = { backspaceDelete: backspaceDelete$1 };

      var generate = function (cases) {
        if (!$_dp4g6d7jh8lyw3y.isArray(cases)) {
          throw new Error('cases must be an array');
        }
        if (cases.length === 0) {
          throw new Error('there must be at least one case');
        }
        var constructors = [];
        var adt = {};
        $_5wjzy24jh8lyw2t.each(cases, function (acase, count) {
          var keys = $_g63v2c13jh8lywej.keys(acase);
          if (keys.length !== 1) {
            throw new Error('one and only one name per case');
          }
          var key = keys[0];
          var value = acase[key];
          if (adt[key] !== undefined) {
            throw new Error('duplicate key detected:' + key);
          } else if (key === 'cata') {
            throw new Error('cannot have a case named cata (sorry)');
          } else if (!$_dp4g6d7jh8lyw3y.isArray(value)) {
            throw new Error('case arguments must be an array');
          }
          constructors.push(key);
          adt[key] = function () {
            var argLength = arguments.length;
            if (argLength !== value.length) {
              throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
            }
            var args = new Array(argLength);
            for (var i = 0; i < args.length; i++)
              args[i] = arguments[i];
            var match = function (branches) {
              var branchKeys = $_g63v2c13jh8lywej.keys(branches);
              if (constructors.length !== branchKeys.length) {
                throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
              }
              var allReqd = $_5wjzy24jh8lyw2t.forall(constructors, function (reqKey) {
                return $_5wjzy24jh8lyw2t.contains(branchKeys, reqKey);
              });
              if (!allReqd)
                throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
              return branches[key].apply(null, args);
            };
            return {
              fold: function () {
                if (arguments.length !== cases.length) {
                  throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
                }
                var target = arguments[count];
                return target.apply(null, args);
              },
              match: match,
              log: function (label) {
                console.log(label, {
                  constructors: constructors,
                  constructor: key,
                  params: args
                });
              }
            };
          };
        });
        return adt;
      };
      var $_1ml90g3ijh8lywyp = { generate: generate };

      var isCompoundElement = function (node) {
        return isTableCell($_cgttw3zjh8lywdq.fromDom(node)) || isListItem($_cgttw3zjh8lywdq.fromDom(node));
      };
      var DeleteAction = $_1ml90g3ijh8lywyp.generate([
        { remove: ['element'] },
        { moveToElement: ['element'] },
        { moveToPosition: ['position'] }
      ]);
      var isAtContentEditableBlockCaret = function (forward, from) {
        var elm = from.getNode(forward === false);
        var caretLocation = forward ? 'after' : 'before';
        return $_5oonaz1qjh8lywhz.isElement(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
      };
      var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
        var inSameBlock = function (elm) {
          return isInline($_cgttw3zjh8lywdq.fromDom(elm)) && !isInSameBlock(from, to, root);
        };
        return getRelativeCefElm(!forward, from).fold(function () {
          return getRelativeCefElm(forward, to).fold($_eqpqvr6jh8lyw3s.constant(false), inSameBlock);
        }, inSameBlock);
      };
      var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
        var toCefElm = to.getNode(forward === false);
        return $_aj8isd34jh8lyws4.getParentBlock($_cgttw3zjh8lywdq.fromDom(root), $_cgttw3zjh8lywdq.fromDom(from.getNode())).map(function (blockElm) {
          return $_b1urh33ajh8lywts.isEmpty(blockElm) ? DeleteAction.remove(blockElm.dom()) : DeleteAction.moveToElement(toCefElm);
        }).orThunk(function () {
          return Option.some(DeleteAction.moveToElement(toCefElm));
        });
      };
      var findCefPosition = function (root, forward, from) {
        return $_9kvypj2cjh8lywnz.fromPosition(forward, root, from).bind(function (to) {
          if (isCompoundElement(to.getNode())) {
            return Option.none();
          } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
            return Option.none();
          } else if (forward && $_5oonaz1qjh8lywhz.isContentEditableFalse(to.getNode())) {
            return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
          } else if (forward === false && $_5oonaz1qjh8lywhz.isContentEditableFalse(to.getNode(true))) {
            return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
          } else if (forward && isAfterContentEditableFalse(from)) {
            return Option.some(DeleteAction.moveToPosition(to));
          } else if (forward === false && isBeforeContentEditableFalse(from)) {
            return Option.some(DeleteAction.moveToPosition(to));
          } else {
            return Option.none();
          }
        });
      };
      var getContentEditableBlockAction = function (forward, elm) {
        if (forward && $_5oonaz1qjh8lywhz.isContentEditableFalse(elm.nextSibling)) {
          return Option.some(DeleteAction.moveToElement(elm.nextSibling));
        } else if (forward === false && $_5oonaz1qjh8lywhz.isContentEditableFalse(elm.previousSibling)) {
          return Option.some(DeleteAction.moveToElement(elm.previousSibling));
        } else {
          return Option.none();
        }
      };
      var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
        return deleteAction.fold(function (elm) {
          return Option.some(DeleteAction.remove(elm));
        }, function (elm) {
          return Option.some(DeleteAction.moveToElement(elm));
        }, function (to) {
          if (isInSameBlock(from, to, root)) {
            return Option.none();
          } else {
            return Option.some(DeleteAction.moveToPosition(to));
          }
        });
      };
      var getContentEditableAction = function (root, forward, from) {
        if (isAtContentEditableBlockCaret(forward, from)) {
          return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
            return findCefPosition(root, forward, from);
          }, Option.some);
        } else {
          return findCefPosition(root, forward, from).bind(function (deleteAction) {
            return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
          });
        }
      };
      var read$1 = function (root, forward, rng) {
        var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
        var from = CaretPosition$1.fromRangeStart(normalizedRange);
        if (forward === false && isAfterContentEditableFalse(from)) {
          return Option.some(DeleteAction.remove(from.getNode(true)));
        } else if (forward && isBeforeContentEditableFalse(from)) {
          return Option.some(DeleteAction.remove(from.getNode()));
        } else {
          return getContentEditableAction(root, forward, from);
        }
      };

      var needsReposition = function (pos, elm) {
        var container = pos.container();
        var offset = pos.offset();
        return CaretPosition$1.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition$1.before(elm).offset();
      };
      var reposition = function (elm, pos) {
        return needsReposition(pos, elm) ? CaretPosition$1(pos.container(), pos.offset() - 1) : pos;
      };
      var beforeOrStartOf = function (node) {
        return $_5oonaz1qjh8lywhz.isText(node) ? CaretPosition$1(node, 0) : CaretPosition$1.before(node);
      };
      var afterOrEndOf = function (node) {
        return $_5oonaz1qjh8lywhz.isText(node) ? CaretPosition$1(node, node.data.length) : CaretPosition$1.after(node);
      };
      var getPreviousSiblingCaretPosition = function (elm) {
        if (isCaretCandidate(elm.previousSibling)) {
          return Option.some(afterOrEndOf(elm.previousSibling));
        } else {
          return elm.previousSibling ? $_9kvypj2cjh8lywnz.lastPositionIn(elm.previousSibling) : Option.none();
        }
      };
      var getNextSiblingCaretPosition = function (elm) {
        if (isCaretCandidate(elm.nextSibling)) {
          return Option.some(beforeOrStartOf(elm.nextSibling));
        } else {
          return elm.nextSibling ? $_9kvypj2cjh8lywnz.firstPositionIn(elm.nextSibling) : Option.none();
        }
      };
      var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
        var startPosition = CaretPosition$1.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
        return $_9kvypj2cjh8lywnz.prevPosition(rootElement, startPosition).fold(function () {
          return $_9kvypj2cjh8lywnz.nextPosition(rootElement, CaretPosition$1.after(elm));
        }, Option.some);
      };
      var findCaretPositionForwardsFromElm = function (rootElement, elm) {
        return $_9kvypj2cjh8lywnz.nextPosition(rootElement, CaretPosition$1.after(elm)).fold(function () {
          return $_9kvypj2cjh8lywnz.prevPosition(rootElement, CaretPosition$1.before(elm));
        }, Option.some);
      };
      var findCaretPositionBackwards = function (rootElement, elm) {
        return getPreviousSiblingCaretPosition(elm).orThunk(function () {
          return getNextSiblingCaretPosition(elm);
        }).orThunk(function () {
          return findCaretPositionBackwardsFromElm(rootElement, elm);
        });
      };
      var findCaretPositionForward = function (rootElement, elm) {
        return getNextSiblingCaretPosition(elm).orThunk(function () {
          return getPreviousSiblingCaretPosition(elm);
        }).orThunk(function () {
          return findCaretPositionForwardsFromElm(rootElement, elm);
        });
      };
      var findCaretPosition$1 = function (forward, rootElement, elm) {
        return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
      };
      var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
        return findCaretPosition$1(forward, rootElement, elm).map($_eqpqvr6jh8lyw3s.curry(reposition, elm));
      };
      var setSelection = function (editor, forward, pos) {
        pos.fold(function () {
          editor.focus();
        }, function (pos) {
          editor.selection.setRng(pos.toRange(), forward);
        });
      };
      var eqRawNode = function (rawNode) {
        return function (elm) {
          return elm.dom() === rawNode;
        };
      };
      var isBlock$2 = function (editor, elm) {
        return elm && editor.schema.getBlockElements().hasOwnProperty($_7j1jt210jh8lywdx.name(elm));
      };
      var paddEmptyBlock = function (elm) {
        if ($_b1urh33ajh8lywts.isEmpty(elm)) {
          var br = $_cgttw3zjh8lywdq.fromHtml('<br data-mce-bogus="1">');
          $_bfmuql2ujh8lywr1.empty(elm);
          $_4m7u2e2kjh8lywpi.append(elm, br);
          return Option.some(CaretPosition$1.before(br.dom()));
        } else {
          return Option.none();
        }
      };
      var deleteNormalized = function (elm, afterDeletePosOpt) {
        return $_b8twwq26jh8lywmm.liftN([
          $_a43q0i17jh8lywfe.prevSibling(elm),
          $_a43q0i17jh8lywfe.nextSibling(elm),
          afterDeletePosOpt
        ], function (prev, next, afterDeletePos) {
          var offset;
          var prevNode = prev.dom();
          var nextNode = next.dom();
          if ($_5oonaz1qjh8lywhz.isText(prevNode) && $_5oonaz1qjh8lywhz.isText(nextNode)) {
            offset = prevNode.data.length;
            prevNode.appendData(nextNode.data);
            $_bfmuql2ujh8lywr1.remove(next);
            $_bfmuql2ujh8lywr1.remove(elm);
            if (afterDeletePos.container() === nextNode) {
              return CaretPosition$1(prevNode, offset);
            } else {
              return afterDeletePos;
            }
          } else {
            $_bfmuql2ujh8lywr1.remove(elm);
            return afterDeletePos;
          }
        }).orThunk(function () {
          $_bfmuql2ujh8lywr1.remove(elm);
          return afterDeletePosOpt;
        });
      };
      var deleteElement = function (editor, forward, elm) {
        var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom());
        var parentBlock = $_6hl03835jh8lywsm.ancestor(elm, $_eqpqvr6jh8lyw3s.curry(isBlock$2, editor), eqRawNode(editor.getBody()));
        var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos);
        if (editor.dom.isEmpty(editor.getBody())) {
          editor.setContent('');
          editor.selection.setCursorLocation();
        } else {
          parentBlock.bind(paddEmptyBlock).fold(function () {
            setSelection(editor, forward, normalizedAfterDeletePos);
          }, function (paddPos) {
            setSelection(editor, forward, Option.some(paddPos));
          });
        }
      };
      var $_1al0sh3jjh8lywyv = { deleteElement: deleteElement };

      var deleteElement$1 = function (editor, forward) {
        return function (element) {
          editor._selectionOverrides.hideFakeCaret();
          $_1al0sh3jjh8lywyv.deleteElement(editor, forward, $_cgttw3zjh8lywdq.fromDom(element));
          return true;
        };
      };
      var moveToElement = function (editor, forward) {
        return function (element) {
          var pos = forward ? CaretPosition$1.before(element) : CaretPosition$1.after(element);
          editor.selection.setRng(pos.toRange());
          return true;
        };
      };
      var moveToPosition = function (editor) {
        return function (pos) {
          editor.selection.setRng(pos.toRange());
          return true;
        };
      };
      var backspaceDeleteCaret = function (editor, forward) {
        var result = read$1(editor.getBody(), forward, editor.selection.getRng()).map(function (deleteAction) {
          return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
        });
        return result.getOr(false);
      };
      var deleteOffscreenSelection = function (rootElement) {
        $_5wjzy24jh8lyw2t.each($_eebxu2gjh8lywp3.descendants(rootElement, '.mce-offscreen-selection'), $_bfmuql2ujh8lywr1.remove);
      };
      var backspaceDeleteRange = function (editor, forward) {
        var selectedElement = editor.selection.getNode();
        if ($_5oonaz1qjh8lywhz.isContentEditableFalse(selectedElement)) {
          deleteOffscreenSelection($_cgttw3zjh8lywdq.fromDom(editor.getBody()));
          $_1al0sh3jjh8lywyv.deleteElement(editor, forward, $_cgttw3zjh8lywdq.fromDom(editor.selection.getNode()));
          $_aj8isd34jh8lyws4.paddEmptyBody(editor);
          return true;
        } else {
          return false;
        }
      };
      var getContentEditableRoot = function (root, node) {
        while (node && node !== root) {
          if ($_5oonaz1qjh8lywhz.isContentEditableTrue(node) || $_5oonaz1qjh8lywhz.isContentEditableFalse(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var paddEmptyElement = function (editor) {
        var br;
        var ceRoot = getContentEditableRoot(editor.getBody(), editor.selection.getNode());
        if ($_5oonaz1qjh8lywhz.isContentEditableTrue(ceRoot) && editor.dom.isBlock(ceRoot) && editor.dom.isEmpty(ceRoot)) {
          br = editor.dom.create('br', { 'data-mce-bogus': '1' });
          editor.dom.setHTML(ceRoot, '');
          ceRoot.appendChild(br);
          editor.selection.setRng(CaretPosition$1.before(br).toRange());
        }
        return true;
      };
      var backspaceDelete$2 = function (editor, forward) {
        if (editor.selection.isCollapsed()) {
          return backspaceDeleteCaret(editor, forward);
        } else {
          return backspaceDeleteRange(editor, forward);
        }
      };
      var $_ar80r13gjh8lywy7 = {
        backspaceDelete: backspaceDelete$2,
        paddEmptyElement: paddEmptyElement
      };

      var isText$8 = $_5oonaz1qjh8lywhz.isText;
      var startsWithCaretContainer$1 = function (node) {
        return isText$8(node) && node.data[0] === $_d383mr21jh8lywlv.ZWSP;
      };
      var endsWithCaretContainer$1 = function (node) {
        return isText$8(node) && node.data[node.data.length - 1] === $_d383mr21jh8lywlv.ZWSP;
      };
      var createZwsp = function (node) {
        return node.ownerDocument.createTextNode($_d383mr21jh8lywlv.ZWSP);
      };
      var insertBefore$1 = function (node) {
        if (isText$8(node.previousSibling)) {
          if (endsWithCaretContainer$1(node.previousSibling)) {
            return node.previousSibling;
          } else {
            node.previousSibling.appendData($_d383mr21jh8lywlv.ZWSP);
            return node.previousSibling;
          }
        } else if (isText$8(node)) {
          if (startsWithCaretContainer$1(node)) {
            return node;
          } else {
            node.insertData(0, $_d383mr21jh8lywlv.ZWSP);
            return node;
          }
        } else {
          var newNode = createZwsp(node);
          node.parentNode.insertBefore(newNode, node);
          return newNode;
        }
      };
      var insertAfter$1 = function (node) {
        if (isText$8(node.nextSibling)) {
          if (startsWithCaretContainer$1(node.nextSibling)) {
            return node.nextSibling;
          } else {
            node.nextSibling.insertData(0, $_d383mr21jh8lywlv.ZWSP);
            return node.nextSibling;
          }
        } else if (isText$8(node)) {
          if (endsWithCaretContainer$1(node)) {
            return node;
          } else {
            node.appendData($_d383mr21jh8lywlv.ZWSP);
            return node;
          }
        } else {
          var newNode = createZwsp(node);
          if (node.nextSibling) {
            node.parentNode.insertBefore(newNode, node.nextSibling);
          } else {
            node.parentNode.appendChild(newNode);
          }
          return newNode;
        }
      };
      var insertInline$1 = function (before, node) {
        return before ? insertBefore$1(node) : insertAfter$1(node);
      };
      var insertInlineBefore = $_eqpqvr6jh8lyw3s.curry(insertInline$1, true);
      var insertInlineAfter = $_eqpqvr6jh8lyw3s.curry(insertInline$1, false);

      var insertInlinePos = function (pos, before) {
        if ($_5oonaz1qjh8lywhz.isText(pos.container())) {
          return insertInline$1(before, pos.container());
        } else {
          return insertInline$1(before, pos.getNode());
        }
      };
      var isPosCaretContainer = function (pos, caret) {
        var caretNode = caret.get();
        return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
      };
      var renderCaret = function (caret, location) {
        return location.fold(function (element) {
          $_9nl16f2ajh8lywne.remove(caret.get());
          var text = insertInlineBefore(element);
          caret.set(text);
          return Option.some(CaretPosition$1(text, text.length - 1));
        }, function (element) {
          return $_9kvypj2cjh8lywnz.firstPositionIn(element).map(function (pos) {
            if (!isPosCaretContainer(pos, caret)) {
              $_9nl16f2ajh8lywne.remove(caret.get());
              var text = insertInlinePos(pos, true);
              caret.set(text);
              return CaretPosition$1(text, 1);
            } else {
              return CaretPosition$1(caret.get(), 1);
            }
          });
        }, function (element) {
          return $_9kvypj2cjh8lywnz.lastPositionIn(element).map(function (pos) {
            if (!isPosCaretContainer(pos, caret)) {
              $_9nl16f2ajh8lywne.remove(caret.get());
              var text = insertInlinePos(pos, false);
              caret.set(text);
              return CaretPosition$1(text, text.length - 1);
            } else {
              return CaretPosition$1(caret.get(), caret.get().length - 1);
            }
          });
        }, function (element) {
          $_9nl16f2ajh8lywne.remove(caret.get());
          var text = insertInlineAfter(element);
          caret.set(text);
          return Option.some(CaretPosition$1(text, 1));
        });
      };
      var $_biul8i3ljh8lywzl = { renderCaret: renderCaret };

      var evaluateUntil = function (fns, args) {
        for (var i = 0; i < fns.length; i++) {
          var result = fns[i].apply(null, args);
          if (result.isSome()) {
            return result;
          }
        }
        return Option.none();
      };
      var $_7r5om73ojh8lyx09 = { evaluateUntil: evaluateUntil };

      var Location = $_1ml90g3ijh8lywyp.generate([
        { before: ['element'] },
        { start: ['element'] },
        { end: ['element'] },
        { after: ['element'] }
      ]);
      var rescope = function (rootNode, node) {
        var parentBlock = getParentBlock(node, rootNode);
        return parentBlock ? parentBlock : rootNode;
      };
      var before$3 = function (isInlineTarget, rootNode, pos) {
        var nPos = $_231v7s37jh8lywt3.normalizeForwards(pos);
        var scope = rescope(rootNode, nPos.container());
        return $_231v7s37jh8lywt3.findRootInline(isInlineTarget, scope, nPos).fold(function () {
          return $_9kvypj2cjh8lywnz.nextPosition(scope, nPos).bind($_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.findRootInline, isInlineTarget, scope)).map(function (inline) {
            return Location.before(inline);
          });
        }, Option.none);
      };
      var isNotInsideFormatCaretContainer = function (rootNode, elm) {
        return getParentCaretContainer(rootNode, elm) === null;
      };
      var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
        return $_231v7s37jh8lywt3.findRootInline(isInlineTarget, rootNode, pos).filter($_eqpqvr6jh8lyw3s.curry(isNotInsideFormatCaretContainer, rootNode));
      };
      var start = function (isInlineTarget, rootNode, pos) {
        var nPos = $_231v7s37jh8lywt3.normalizeBackwards(pos);
        return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
          var prevPos = $_9kvypj2cjh8lywnz.prevPosition(inline, nPos);
          return prevPos.isNone() ? Option.some(Location.start(inline)) : Option.none();
        });
      };
      var end = function (isInlineTarget, rootNode, pos) {
        var nPos = $_231v7s37jh8lywt3.normalizeForwards(pos);
        return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
          var nextPos = $_9kvypj2cjh8lywnz.nextPosition(inline, nPos);
          return nextPos.isNone() ? Option.some(Location.end(inline)) : Option.none();
        });
      };
      var after$3 = function (isInlineTarget, rootNode, pos) {
        var nPos = $_231v7s37jh8lywt3.normalizeBackwards(pos);
        var scope = rescope(rootNode, nPos.container());
        return $_231v7s37jh8lywt3.findRootInline(isInlineTarget, scope, nPos).fold(function () {
          return $_9kvypj2cjh8lywnz.prevPosition(scope, nPos).bind($_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.findRootInline, isInlineTarget, scope)).map(function (inline) {
            return Location.after(inline);
          });
        }, Option.none);
      };
      var isValidLocation = function (location) {
        return $_231v7s37jh8lywt3.isRtl(getElement(location)) === false;
      };
      var readLocation = function (isInlineTarget, rootNode, pos) {
        var location = $_7r5om73ojh8lyx09.evaluateUntil([
          before$3,
          start,
          end,
          after$3
        ], [
          isInlineTarget,
          rootNode,
          pos
        ]);
        return location.filter(isValidLocation);
      };
      var getElement = function (location) {
        return location.fold($_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity);
      };
      var getName = function (location) {
        return location.fold($_eqpqvr6jh8lyw3s.constant('before'), $_eqpqvr6jh8lyw3s.constant('start'), $_eqpqvr6jh8lyw3s.constant('end'), $_eqpqvr6jh8lyw3s.constant('after'));
      };
      var outside = function (location) {
        return location.fold(Location.before, Location.before, Location.after, Location.after);
      };
      var inside = function (location) {
        return location.fold(Location.start, Location.start, Location.end, Location.end);
      };
      var isEq = function (location1, location2) {
        return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
      };
      var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
        return $_b8twwq26jh8lywmm.liftN([
          $_231v7s37jh8lywt3.findRootInline(isInlineTarget, rootNode, from),
          $_231v7s37jh8lywt3.findRootInline(isInlineTarget, rootNode, to)
        ], function (fromInline, toInline) {
          if (fromInline !== toInline && $_231v7s37jh8lywt3.hasSameParentBlock(rootNode, fromInline, toInline)) {
            return Location.after(forward ? fromInline : toInline);
          } else {
            return location;
          }
        }).getOr(location);
      };
      var skipNoMovement = function (fromLocation, toLocation) {
        return fromLocation.fold($_eqpqvr6jh8lyw3s.constant(true), function (fromLocation) {
          return !isEq(fromLocation, toLocation);
        });
      };
      var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
        var from = $_231v7s37jh8lywt3.normalizePosition(forward, pos);
        var to = $_9kvypj2cjh8lywnz.fromPosition(forward, rootNode, from).map($_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.normalizePosition, forward));
        var location = to.fold(function () {
          return fromLocation.map(outside);
        }, function (to) {
          return readLocation(isInlineTarget, rootNode, to).map($_eqpqvr6jh8lyw3s.curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter($_eqpqvr6jh8lyw3s.curry(skipNoMovement, fromLocation));
        });
        return location.filter(isValidLocation);
      };
      var findLocationSimple = function (forward, location) {
        if (forward) {
          return location.fold($_eqpqvr6jh8lyw3s.compose(Option.some, Location.start), Option.none, $_eqpqvr6jh8lyw3s.compose(Option.some, Location.after), Option.none);
        } else {
          return location.fold(Option.none, $_eqpqvr6jh8lyw3s.compose(Option.some, Location.before), Option.none, $_eqpqvr6jh8lyw3s.compose(Option.some, Location.end));
        }
      };
      var findLocation = function (forward, isInlineTarget, rootNode, pos) {
        var from = $_231v7s37jh8lywt3.normalizePosition(forward, pos);
        var fromLocation = readLocation(isInlineTarget, rootNode, from);
        return readLocation(isInlineTarget, rootNode, from).bind($_eqpqvr6jh8lyw3s.curry(findLocationSimple, forward)).orThunk(function () {
          return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
        });
      };
      var $_6kjy7r3njh8lywzz = {
        readLocation: readLocation,
        findLocation: findLocation,
        prevLocation: $_eqpqvr6jh8lyw3s.curry(findLocation, false),
        nextLocation: $_eqpqvr6jh8lyw3s.curry(findLocation, true),
        getElement: getElement,
        outside: outside,
        inside: inside
      };

      var hasSelectionModifyApi = function (editor) {
        return $_dp4g6d7jh8lyw3y.isFunction(editor.selection.getSel().modify);
      };
      var moveRel = function (forward, selection, pos) {
        var delta = forward ? 1 : -1;
        selection.setRng(CaretPosition$1(pos.container(), pos.offset() + delta).toRange());
        selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
        return true;
      };
      var moveByWord = function (forward, editor) {
        var rng = editor.selection.getRng();
        var pos = forward ? CaretPosition$1.fromRangeEnd(rng) : CaretPosition$1.fromRangeStart(rng);
        if (!hasSelectionModifyApi(editor)) {
          return false;
        } else if (forward && isBeforeInline(pos)) {
          return moveRel(true, editor.selection, pos);
        } else if (!forward && isAfterInline(pos)) {
          return moveRel(false, editor.selection, pos);
        } else {
          return false;
        }
      };
      var $_d48vbn3qjh8lyx0k = {
        hasSelectionModifyApi: hasSelectionModifyApi,
        moveByWord: moveByWord
      };

      var setCaretPosition = function (editor, pos) {
        var rng = editor.dom.createRng();
        rng.setStart(pos.container(), pos.offset());
        rng.setEnd(pos.container(), pos.offset());
        editor.selection.setRng(rng);
      };
      var isFeatureEnabled = function (editor) {
        return editor.settings.inline_boundaries !== false;
      };
      var setSelected = function (state, elm) {
        if (state) {
          elm.setAttribute('data-mce-selected', 'inline-boundary');
        } else {
          elm.removeAttribute('data-mce-selected');
        }
      };
      var renderCaretLocation = function (editor, caret, location) {
        return $_biul8i3ljh8lywzl.renderCaret(caret, location).map(function (pos) {
          setCaretPosition(editor, pos);
          return location;
        });
      };
      var findLocation$1 = function (editor, caret, forward) {
        var rootNode = editor.getBody();
        var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        var location = $_6kjy7r3njh8lywzz.findLocation(forward, isInlineTarget, rootNode, from);
        return location.bind(function (location) {
          return renderCaretLocation(editor, caret, location);
        });
      };
      var toggleInlines = function (isInlineTarget, dom, elms) {
        var selectedInlines = $_5wjzy24jh8lyw2t.filter(dom.select('*[data-mce-selected="inline-boundary"]'), isInlineTarget);
        var targetInlines = $_5wjzy24jh8lyw2t.filter(elms, isInlineTarget);
        $_5wjzy24jh8lyw2t.each($_5wjzy24jh8lyw2t.difference(selectedInlines, targetInlines), $_eqpqvr6jh8lyw3s.curry(setSelected, false));
        $_5wjzy24jh8lyw2t.each($_5wjzy24jh8lyw2t.difference(targetInlines, selectedInlines), $_eqpqvr6jh8lyw3s.curry(setSelected, true));
      };
      var safeRemoveCaretContainer = function (editor, caret) {
        if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
          var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
          if (CaretPosition$1.isTextPosition(pos) && $_231v7s37jh8lywt3.isAtZwsp(pos) === false) {
            setCaretPosition(editor, $_9nl16f2ajh8lywne.removeAndReposition(caret.get(), pos));
            caret.set(null);
          }
        }
      };
      var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
        if (editor.selection.isCollapsed()) {
          var inlines = $_5wjzy24jh8lyw2t.filter(elms, isInlineTarget);
          $_5wjzy24jh8lyw2t.each(inlines, function (inline) {
            var pos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
            $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
              return renderCaretLocation(editor, caret, location);
            });
          });
        }
      };
      var move = function (editor, caret, forward) {
        return function () {
          return isFeatureEnabled(editor) ? findLocation$1(editor, caret, forward).isSome() : false;
        };
      };
      var moveWord = function (forward, editor, caret) {
        return function () {
          return isFeatureEnabled(editor) ? $_d48vbn3qjh8lyx0k.moveByWord(forward, editor) : false;
        };
      };
      var setupSelectedState = function (editor) {
        var caret = Cell(null);
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        editor.on('NodeChange', function (e) {
          if (isFeatureEnabled(editor)) {
            toggleInlines(isInlineTarget, editor.dom, e.parents);
            safeRemoveCaretContainer(editor, caret);
            renderInsideInlineCaret(isInlineTarget, editor, caret, e.parents);
          }
        });
        return caret;
      };
      var moveNextWord = $_eqpqvr6jh8lyw3s.curry(moveWord, true);
      var movePrevWord = $_eqpqvr6jh8lyw3s.curry(moveWord, false);
      var $_65xx7w3pjh8lyx0d = {
        move: move,
        moveNextWord: moveNextWord,
        movePrevWord: movePrevWord,
        setupSelectedState: setupSelectedState,
        setCaretPosition: setCaretPosition
      };

      var isFeatureEnabled$1 = function (editor) {
        return editor.settings.inline_boundaries !== false;
      };
      var rangeFromPositions = function (from, to) {
        var range = document.createRange();
        range.setStart(from.container(), from.offset());
        range.setEnd(to.container(), to.offset());
        return range;
      };
      var hasOnlyTwoOrLessPositionsLeft = function (elm) {
        return $_b8twwq26jh8lywmm.liftN([
          $_9kvypj2cjh8lywnz.firstPositionIn(elm),
          $_9kvypj2cjh8lywnz.lastPositionIn(elm)
        ], function (firstPos, lastPos) {
          var normalizedFirstPos = $_231v7s37jh8lywt3.normalizePosition(true, firstPos);
          var normalizedLastPos = $_231v7s37jh8lywt3.normalizePosition(false, lastPos);
          return $_9kvypj2cjh8lywnz.nextPosition(elm, normalizedFirstPos).map(function (pos) {
            return pos.isEqual(normalizedLastPos);
          }).getOr(true);
        }).getOr(true);
      };
      var setCaretLocation = function (editor, caret) {
        return function (location) {
          return $_biul8i3ljh8lywzl.renderCaret(caret, location).map(function (pos) {
            $_65xx7w3pjh8lyx0d.setCaretPosition(editor, pos);
            return true;
          }).getOr(false);
        };
      };
      var deleteFromTo = function (editor, caret, from, to) {
        var rootNode = editor.getBody();
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        editor.undoManager.ignore(function () {
          editor.selection.setRng(rangeFromPositions(from, to));
          editor.execCommand('Delete');
          $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, rootNode, CaretPosition$1.fromRangeStart(editor.selection.getRng())).map($_6kjy7r3njh8lywzz.inside).map(setCaretLocation(editor, caret));
        });
        editor.nodeChanged();
      };
      var rescope$1 = function (rootNode, node) {
        var parentBlock = getParentBlock(node, rootNode);
        return parentBlock ? parentBlock : rootNode;
      };
      var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
        var rootNode = rescope$1(editor.getBody(), from.container());
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        var fromLocation = $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, rootNode, from);
        return fromLocation.bind(function (location) {
          if (forward) {
            return location.fold($_eqpqvr6jh8lyw3s.constant(Option.some($_6kjy7r3njh8lywzz.inside(location))), Option.none, $_eqpqvr6jh8lyw3s.constant(Option.some($_6kjy7r3njh8lywzz.outside(location))), Option.none);
          } else {
            return location.fold(Option.none, $_eqpqvr6jh8lyw3s.constant(Option.some($_6kjy7r3njh8lywzz.outside(location))), Option.none, $_eqpqvr6jh8lyw3s.constant(Option.some($_6kjy7r3njh8lywzz.inside(location))));
          }
        }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
          var toPosition = $_9kvypj2cjh8lywnz.navigate(forward, rootNode, from);
          var toLocation = toPosition.bind(function (pos) {
            return $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, rootNode, pos);
          });
          if (fromLocation.isSome() && toLocation.isSome()) {
            return $_231v7s37jh8lywt3.findRootInline(isInlineTarget, rootNode, from).map(function (elm) {
              if (hasOnlyTwoOrLessPositionsLeft(elm)) {
                $_1al0sh3jjh8lywyv.deleteElement(editor, forward, $_cgttw3zjh8lywdq.fromDom(elm));
                return true;
              } else {
                return false;
              }
            }).getOr(false);
          } else {
            return toLocation.bind(function (_) {
              return toPosition.map(function (to) {
                if (forward) {
                  deleteFromTo(editor, caret, from, to);
                } else {
                  deleteFromTo(editor, caret, to, from);
                }
                return true;
              });
            }).getOr(false);
          }
        });
      };
      var backspaceDelete$3 = function (editor, caret, forward) {
        if (editor.selection.isCollapsed() && isFeatureEnabled$1(editor)) {
          var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
          return backspaceDeleteCollapsed(editor, caret, forward, from);
        }
        return false;
      };
      var $_ej9d8d3kjh8lywzc = { backspaceDelete: backspaceDelete$3 };

      var tableCellRng = $_4jz0ce18jh8lywft.immutable('start', 'end');
      var tableSelection = $_4jz0ce18jh8lywft.immutable('rng', 'table', 'cells');
      var deleteAction = $_1ml90g3ijh8lywyp.generate([
        { removeTable: ['element'] },
        { emptyCells: ['cells'] }
      ]);
      var isRootFromElement = function (root) {
        return $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, root);
      };
      var getClosestCell$1 = function (container, isRoot) {
        return $_7sg18r3cjh8lywu1.closest($_cgttw3zjh8lywdq.fromDom(container), 'td,th', isRoot);
      };
      var getClosestTable = function (cell, isRoot) {
        return $_7sg18r3cjh8lywu1.ancestor(cell, 'table', isRoot);
      };
      var isExpandedCellRng = function (cellRng) {
        return $_5f6gpb1djh8lywg5.eq(cellRng.start(), cellRng.end()) === false;
      };
      var getTableFromCellRng = function (cellRng, isRoot) {
        return getClosestTable(cellRng.start(), isRoot).bind(function (startParentTable) {
          return getClosestTable(cellRng.end(), isRoot).bind(function (endParentTable) {
            return $_5f6gpb1djh8lywg5.eq(startParentTable, endParentTable) ? Option.some(startParentTable) : Option.none();
          });
        });
      };
      var getTableCells = function (table) {
        return $_eebxu2gjh8lywp3.descendants(table, 'td,th');
      };
      var getCellRangeFromStartTable = function (cellRng, isRoot) {
        return getClosestTable(cellRng.start(), isRoot).bind(function (table) {
          return $_5wjzy24jh8lyw2t.last(getTableCells(table)).map(function (endCell) {
            return tableCellRng(cellRng.start(), endCell);
          });
        });
      };
      var partialSelection = function (isRoot, rng) {
        var startCell = getClosestCell$1(rng.startContainer, isRoot);
        var endCell = getClosestCell$1(rng.endContainer, isRoot);
        return rng.collapsed ? Option.none() : $_b8twwq26jh8lywmm.liftN([
          startCell,
          endCell
        ], tableCellRng).fold(function () {
          return startCell.fold(function () {
            return endCell.bind(function (endCell) {
              return getClosestTable(endCell, isRoot).bind(function (table) {
                return $_5wjzy24jh8lyw2t.head(getTableCells(table)).map(function (startCell) {
                  return tableCellRng(startCell, endCell);
                });
              });
            });
          }, function (startCell) {
            return getClosestTable(startCell, isRoot).bind(function (table) {
              return $_5wjzy24jh8lyw2t.last(getTableCells(table)).map(function (endCell) {
                return tableCellRng(startCell, endCell);
              });
            });
          });
        }, function (cellRng) {
          return isWithinSameTable(isRoot, cellRng) ? Option.none() : getCellRangeFromStartTable(cellRng, isRoot);
        });
      };
      var isWithinSameTable = function (isRoot, cellRng) {
        return getTableFromCellRng(cellRng, isRoot).isSome();
      };
      var getCellRng = function (rng, isRoot) {
        var startCell = getClosestCell$1(rng.startContainer, isRoot);
        var endCell = getClosestCell$1(rng.endContainer, isRoot);
        return $_b8twwq26jh8lywmm.liftN([
          startCell,
          endCell
        ], tableCellRng).filter(isExpandedCellRng).filter(function (cellRng) {
          return isWithinSameTable(isRoot, cellRng);
        }).orThunk(function () {
          return partialSelection(isRoot, rng);
        });
      };
      var getTableSelectionFromCellRng = function (cellRng, isRoot) {
        return getTableFromCellRng(cellRng, isRoot).map(function (table) {
          return tableSelection(cellRng, table, getTableCells(table));
        });
      };
      var getTableSelectionFromRng = function (root, rng) {
        var isRoot = isRootFromElement(root);
        return getCellRng(rng, isRoot).bind(function (cellRng) {
          return getTableSelectionFromCellRng(cellRng, isRoot);
        });
      };
      var getCellIndex = function (cells, cell) {
        return $_5wjzy24jh8lyw2t.findIndex(cells, function (x) {
          return $_5f6gpb1djh8lywg5.eq(x, cell);
        });
      };
      var getSelectedCells = function (tableSelection) {
        return $_b8twwq26jh8lywmm.liftN([
          getCellIndex(tableSelection.cells(), tableSelection.rng().start()),
          getCellIndex(tableSelection.cells(), tableSelection.rng().end())
        ], function (startIndex, endIndex) {
          return tableSelection.cells().slice(startIndex, endIndex + 1);
        });
      };
      var getAction = function (tableSelection) {
        return getSelectedCells(tableSelection).map(function (selected) {
          var cells = tableSelection.cells();
          return selected.length === cells.length ? deleteAction.removeTable(tableSelection.table()) : deleteAction.emptyCells(selected);
        });
      };
      var getActionFromCells = function (cells) {
        return deleteAction.emptyCells(cells);
      };
      var getActionFromRange = function (root, rng) {
        return getTableSelectionFromRng(root, rng).bind(getAction);
      };
      var $_g0m0zq3sjh8lyx10 = {
        getActionFromRange: getActionFromRange,
        getActionFromCells: getActionFromCells
      };

      var getRanges = function (selection) {
        var ranges = [];
        if (selection) {
          for (var i = 0; i < selection.rangeCount; i++) {
            ranges.push(selection.getRangeAt(i));
          }
        }
        return ranges;
      };
      var getSelectedNodes = function (ranges) {
        return $_5wjzy24jh8lyw2t.bind(ranges, function (range) {
          var node = getSelectedNode(range);
          return node ? [$_cgttw3zjh8lywdq.fromDom(node)] : [];
        });
      };
      var hasMultipleRanges = function (selection) {
        return getRanges(selection).length > 1;
      };
      var $_d1o8uj3ujh8lyx1u = {
        getRanges: getRanges,
        getSelectedNodes: getSelectedNodes,
        hasMultipleRanges: hasMultipleRanges
      };

      var getCellsFromRanges = function (ranges) {
        return $_5wjzy24jh8lyw2t.filter($_d1o8uj3ujh8lyx1u.getSelectedNodes(ranges), isTableCell);
      };
      var getCellsFromElement = function (elm) {
        var selectedCells = $_eebxu2gjh8lywp3.descendants(elm, 'td[data-mce-selected],th[data-mce-selected]');
        return selectedCells;
      };
      var getCellsFromElementOrRanges = function (ranges, element) {
        var selectedCells = getCellsFromElement(element);
        var rangeCells = getCellsFromRanges(ranges);
        return selectedCells.length > 0 ? selectedCells : rangeCells;
      };
      var getCellsFromEditor = function (editor) {
        return getCellsFromElementOrRanges($_d1o8uj3ujh8lyx1u.getRanges(editor.selection.getSel()), $_cgttw3zjh8lywdq.fromDom(editor.getBody()));
      };
      var $_bwjtq63tjh8lyx1g = {
        getCellsFromRanges: getCellsFromRanges,
        getCellsFromElement: getCellsFromElement,
        getCellsFromElementOrRanges: getCellsFromElementOrRanges,
        getCellsFromEditor: getCellsFromEditor
      };

      var emptyCells = function (editor, cells) {
        $_5wjzy24jh8lyw2t.each(cells, $_2bvsfb2tjh8lywqo.fillWithPaddingBr);
        editor.selection.setCursorLocation(cells[0].dom(), 0);
        return true;
      };
      var deleteTableElement = function (editor, table) {
        $_1al0sh3jjh8lywyv.deleteElement(editor, false, table);
        return true;
      };
      var deleteCellRange = function (editor, rootElm, rng) {
        return $_g0m0zq3sjh8lyx10.getActionFromRange(rootElm, rng).map(function (action) {
          return action.fold($_eqpqvr6jh8lyw3s.curry(deleteTableElement, editor), $_eqpqvr6jh8lyw3s.curry(emptyCells, editor));
        });
      };
      var deleteCaptionRange = function (editor, caption) {
        return emptyElement(editor, caption);
      };
      var deleteTableRange = function (editor, rootElm, rng, startElm) {
        return getParentCaption(rootElm, startElm).fold(function () {
          return deleteCellRange(editor, rootElm, rng);
        }, function (caption) {
          return deleteCaptionRange(editor, caption);
        }).getOr(false);
      };
      var deleteRange$1 = function (editor, startElm) {
        var rootNode = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        var rng = editor.selection.getRng();
        var selectedCells = $_bwjtq63tjh8lyx1g.getCellsFromEditor(editor);
        return selectedCells.length !== 0 ? emptyCells(editor, selectedCells) : deleteTableRange(editor, rootNode, rng, startElm);
      };
      var getParentCell = function (rootElm, elm) {
        return $_5wjzy24jh8lyw2t.find($_dyxtub3ejh8lywxq.parentsAndSelf(elm, rootElm), isTableCell);
      };
      var getParentCaption = function (rootElm, elm) {
        return $_5wjzy24jh8lyw2t.find($_dyxtub3ejh8lywxq.parentsAndSelf(elm, rootElm), function (elm) {
          return $_7j1jt210jh8lywdx.name(elm) === 'caption';
        });
      };
      var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
        return $_9kvypj2cjh8lywnz.navigate(forward, editor.getBody(), from).bind(function (to) {
          return getParentCell(rootElm, $_cgttw3zjh8lywdq.fromDom(to.getNode())).map(function (toCell) {
            return $_5f6gpb1djh8lywg5.eq(toCell, fromCell) === false;
          });
        });
      };
      var emptyElement = function (editor, elm) {
        $_2bvsfb2tjh8lywqo.fillWithPaddingBr(elm);
        editor.selection.setCursorLocation(elm.dom(), 0);
        return Option.some(true);
      };
      var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
        return $_9kvypj2cjh8lywnz.firstPositionIn(fromCaption.dom()).bind(function (first) {
          return $_9kvypj2cjh8lywnz.lastPositionIn(fromCaption.dom()).map(function (last) {
            return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
          });
        }).getOr(true);
      };
      var emptyCaretCaption = function (editor, elm) {
        return emptyElement(editor, elm);
      };
      var validateCaretCaption = function (rootElm, fromCaption, to) {
        return getParentCaption(rootElm, $_cgttw3zjh8lywdq.fromDom(to.getNode())).map(function (toCaption) {
          return $_5f6gpb1djh8lywg5.eq(toCaption, fromCaption) === false;
        });
      };
      var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
        return $_9kvypj2cjh8lywnz.navigate(forward, editor.getBody(), from).bind(function (to) {
          return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
        }).or(Option.some(true));
      };
      var deleteCaretCells = function (editor, forward, rootElm, startElm) {
        var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
        return getParentCell(rootElm, startElm).bind(function (fromCell) {
          return $_b1urh33ajh8lywts.isEmpty(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
        });
      };
      var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
        var from = CaretPosition$1.fromRangeStart(editor.selection.getRng());
        return $_b1urh33ajh8lywts.isEmpty(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
      };
      var deleteCaret = function (editor, forward, startElm) {
        var rootElm = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        return getParentCaption(rootElm, startElm).fold(function () {
          return deleteCaretCells(editor, forward, rootElm, startElm);
        }, function (fromCaption) {
          return deleteCaretCaption(editor, forward, rootElm, fromCaption);
        }).getOr(false);
      };
      var backspaceDelete$4 = function (editor, forward) {
        var startElm = $_cgttw3zjh8lywdq.fromDom(editor.selection.getStart(true));
        var cells = $_bwjtq63tjh8lyx1g.getCellsFromEditor(editor);
        return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret(editor, forward, startElm) : deleteRange$1(editor, startElm);
      };
      var $_746feo3rjh8lyx0o = { backspaceDelete: backspaceDelete$4 };

      var nativeCommand = function (editor, command) {
        editor.getDoc().execCommand(command, false, null);
      };
      var deleteCommand = function (editor) {
        if ($_ar80r13gjh8lywy7.backspaceDelete(editor, false)) {
          return;
        } else if ($_ej9d8d3kjh8lywzc.backspaceDelete(editor, false)) {
          return;
        } else if ($_5jmwsv32jh8lywrr.backspaceDelete(editor, false)) {
          return;
        } else if ($_746feo3rjh8lyx0o.backspaceDelete(editor)) {
          return;
        } else if ($_lcy1p3fjh8lywxx.backspaceDelete(editor, false)) {
          return;
        } else {
          nativeCommand(editor, 'Delete');
          $_aj8isd34jh8lyws4.paddEmptyBody(editor);
        }
      };
      var forwardDeleteCommand = function (editor) {
        if ($_ar80r13gjh8lywy7.backspaceDelete(editor, true)) {
          return;
        } else if ($_ej9d8d3kjh8lywzc.backspaceDelete(editor, true)) {
          return;
        } else if ($_5jmwsv32jh8lywrr.backspaceDelete(editor, true)) {
          return;
        } else if ($_746feo3rjh8lyx0o.backspaceDelete(editor)) {
          return;
        } else if ($_lcy1p3fjh8lywxx.backspaceDelete(editor, true)) {
          return;
        } else {
          nativeCommand(editor, 'ForwardDelete');
        }
      };
      var $_fmagiy31jh8lywrp = {
        deleteCommand: deleteCommand,
        forwardDeleteCommand: forwardDeleteCommand
      };

      var getSpecifiedFontProp = function (propName, rootElm, elm) {
        var getProperty = function (elm) {
          return $_36knnd12jh8lywe1.getRaw(elm, propName);
        };
        var isRoot = function (elm) {
          return $_5f6gpb1djh8lywg5.eq($_cgttw3zjh8lywdq.fromDom(rootElm), elm);
        };
        return $_6hl03835jh8lywsm.closest($_cgttw3zjh8lywdq.fromDom(elm), function (elm) {
          return getProperty(elm).isSome();
        }, isRoot).bind(getProperty);
      };
      var round$1 = function (number, precision) {
        var factor = Math.pow(10, precision);
        return Math.round(number * factor) / factor;
      };
      var toPt = function (fontSize, precision) {
        if (/[0-9.]+px$/.test(fontSize)) {
          return round$1(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
        }
        return fontSize;
      };
      var normalizeFontFamily = function (fontFamily) {
        return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
      };
      var getComputedFontProp = function (propName, elm) {
        return Option.from(DOMUtils$1.DOM.getStyle(elm, propName, true));
      };
      var getFontProp = function (propName) {
        return function (rootElm, elm) {
          return Option.from(elm).map($_cgttw3zjh8lywdq.fromDom).filter($_7j1jt210jh8lywdx.isElement).bind(function (element) {
            return getSpecifiedFontProp(propName, rootElm, element.dom()).or(getComputedFontProp(propName, element.dom()));
          }).getOr('');
        };
      };
      var $_9wj7cv3wjh8lyx23 = {
        getFontSize: getFontProp('font-size'),
        getFontFamily: $_eqpqvr6jh8lyw3s.compose(normalizeFontFamily, getFontProp('font-family')),
        toPt: toPt
      };

      var findFirstCaretElement = function (editor) {
        return $_9kvypj2cjh8lywnz.firstPositionIn(editor.getBody()).map(function (caret) {
          var container = caret.container();
          return $_5oonaz1qjh8lywhz.isText(container) ? container.parentNode : container;
        });
      };
      var isRangeAtStartOfNode = function (rng, root) {
        return rng.startContainer === root && rng.startOffset === 0;
      };
      var getCaretElement = function (editor) {
        return Option.from(editor.selection.getRng()).bind(function (rng) {
          var root = editor.getBody();
          return isRangeAtStartOfNode(rng, root) ? Option.none() : Option.from(editor.selection.getStart(true));
        });
      };
      var fromFontSizeNumber = function (editor, value) {
        if (/^[0-9\.]+$/.test(value)) {
          var fontSizeNumber = parseInt(value, 10);
          if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
            var fontSizes = $_66vr6g2jjh8lywpf.getFontStyleValues(editor);
            var fontClasses = $_66vr6g2jjh8lywpf.getFontSizeClasses(editor);
            if (fontClasses) {
              return fontClasses[fontSizeNumber - 1] || value;
            } else {
              return fontSizes[fontSizeNumber - 1] || value;
            }
          } else {
            return value;
          }
        } else {
          return value;
        }
      };
      var fontNameAction = function (editor, value) {
        editor.formatter.toggle('fontname', { value: fromFontSizeNumber(editor, value) });
        editor.nodeChanged();
      };
      var fontNameQuery = function (editor) {
        return getCaretElement(editor).fold(function () {
          return findFirstCaretElement(editor).map(function (caretElement) {
            return $_9wj7cv3wjh8lyx23.getFontFamily(editor.getBody(), caretElement);
          }).getOr('');
        }, function (caretElement) {
          return $_9wj7cv3wjh8lyx23.getFontFamily(editor.getBody(), caretElement);
        });
      };
      var fontSizeAction = function (editor, value) {
        editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
        editor.nodeChanged();
      };
      var fontSizeQuery = function (editor) {
        return getCaretElement(editor).fold(function () {
          return findFirstCaretElement(editor).map(function (caretElement) {
            return $_9wj7cv3wjh8lyx23.getFontSize(editor.getBody(), caretElement);
          }).getOr('');
        }, function (caretElement) {
          return $_9wj7cv3wjh8lyx23.getFontSize(editor.getBody(), caretElement);
        });
      };

      var isEq$1 = function (rng1, rng2) {
        return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
      };
      var $_aayq8q3zjh8lyx2z = { isEq: isEq$1 };

      var findParent = function (node, rootNode, predicate) {
        while (node && node !== rootNode) {
          if (predicate(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var hasParent = function (node, rootNode, predicate) {
        return findParent(node, rootNode, predicate) !== null;
      };
      var hasParentWithName = function (node, rootNode, name) {
        return hasParent(node, rootNode, function (node) {
          return node.nodeName === name;
        });
      };
      var isTable$2 = function (node) {
        return node && node.nodeName === 'TABLE';
      };
      var isTableCell$3 = function (node) {
        return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
      };
      var isCeFalseCaretContainer = function (node, rootNode) {
        return isCaretContainer(node) && hasParent(node, rootNode, isCaretNode) === false;
      };
      var hasBrBeforeAfter = function (dom, node, left) {
        var walker = new TreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
        while (node = walker[left ? 'prev' : 'next']()) {
          if ($_5oonaz1qjh8lywhz.isBr(node)) {
            return true;
          }
        }
      };
      var isPrevNode = function (node, name) {
        return node.previousSibling && node.previousSibling.nodeName === name;
      };
      var hasContentEditableFalseParent = function (body, node) {
        while (node && node !== body) {
          if ($_5oonaz1qjh8lywhz.isContentEditableFalse(node)) {
            return true;
          }
          node = node.parentNode;
        }
        return false;
      };
      var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
        var walker, lastInlineElement, parentBlockContainer;
        var body = dom.getRoot();
        var node;
        var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
        parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
        if (left && $_5oonaz1qjh8lywhz.isBr(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
          return Option.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
        }
        walker = new TreeWalker(startNode, parentBlockContainer);
        while (node = walker[left ? 'prev' : 'next']()) {
          if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
            return Option.none();
          }
          if ($_5oonaz1qjh8lywhz.isText(node) && node.nodeValue.length > 0) {
            if (hasParentWithName(node, body, 'A') === false) {
              return Option.some(CaretPosition(node, left ? node.nodeValue.length : 0));
            }
            return Option.none();
          }
          if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
            return Option.none();
          }
          lastInlineElement = node;
        }
        if (collapsed && lastInlineElement) {
          return Option.some(CaretPosition(lastInlineElement, 0));
        }
        return Option.none();
      };
      var normalizeEndPoint = function (dom, collapsed, start, rng) {
        var container, offset, walker;
        var body = dom.getRoot();
        var node, nonEmptyElementsMap;
        var directionLeft, isAfterNode, normalized = false;
        container = rng[(start ? 'start' : 'end') + 'Container'];
        offset = rng[(start ? 'start' : 'end') + 'Offset'];
        isAfterNode = $_5oonaz1qjh8lywhz.isElement(container) && offset === container.childNodes.length;
        nonEmptyElementsMap = dom.schema.getNonEmptyElements();
        directionLeft = start;
        if (isCaretContainer(container)) {
          return Option.none();
        }
        if ($_5oonaz1qjh8lywhz.isElement(container) && offset > container.childNodes.length - 1) {
          directionLeft = false;
        }
        if ($_5oonaz1qjh8lywhz.isDocument(container)) {
          container = body;
          offset = 0;
        }
        if (container === body) {
          if (directionLeft) {
            node = container.childNodes[offset > 0 ? offset - 1 : 0];
            if (node) {
              if (isCaretContainer(node)) {
                return Option.none();
              }
              if (nonEmptyElementsMap[node.nodeName] || isTable$2(node)) {
                return Option.none();
              }
            }
          }
          if (container.hasChildNodes()) {
            offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
            container = container.childNodes[offset];
            offset = $_5oonaz1qjh8lywhz.isText(container) && isAfterNode ? container.data.length : 0;
            if (!collapsed && container === body.lastChild && isTable$2(container)) {
              return Option.none();
            }
            if (hasContentEditableFalseParent(body, container) || isCaretContainer(container)) {
              return Option.none();
            }
            if (container.hasChildNodes() && isTable$2(container) === false) {
              node = container;
              walker = new TreeWalker(container, body);
              do {
                if ($_5oonaz1qjh8lywhz.isContentEditableFalse(node) || isCaretContainer(node)) {
                  normalized = false;
                  break;
                }
                if ($_5oonaz1qjh8lywhz.isText(node) && node.nodeValue.length > 0) {
                  offset = directionLeft ? 0 : node.nodeValue.length;
                  container = node;
                  normalized = true;
                  break;
                }
                if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$3(node)) {
                  offset = dom.nodeIndex(node);
                  container = node.parentNode;
                  if (!directionLeft) {
                    offset++;
                  }
                  normalized = true;
                  break;
                }
              } while (node = directionLeft ? walker.next() : walker.prev());
            }
          }
        }
        if (collapsed) {
          if ($_5oonaz1qjh8lywhz.isText(container) && offset === 0) {
            findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
              container = pos.container();
              offset = pos.offset();
              normalized = true;
            });
          }
          if ($_5oonaz1qjh8lywhz.isElement(container)) {
            node = container.childNodes[offset];
            if (!node) {
              node = container.childNodes[offset - 1];
            }
            if (node && $_5oonaz1qjh8lywhz.isBr(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
              findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
                container = pos.container();
                offset = pos.offset();
                normalized = true;
              });
            }
          }
        }
        if (directionLeft && !collapsed && $_5oonaz1qjh8lywhz.isText(container) && offset === container.nodeValue.length) {
          findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
            container = pos.container();
            offset = pos.offset();
            normalized = true;
          });
        }
        return normalized ? Option.some(CaretPosition(container, offset)) : Option.none();
      };
      var normalize$1 = function (dom, rng) {
        var collapsed = rng.collapsed, normRng = rng.cloneRange();
        var startPos = CaretPosition.fromRangeStart(rng);
        normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
          if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
            normRng.setStart(pos.container(), pos.offset());
          }
        });
        if (!collapsed) {
          normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
            normRng.setEnd(pos.container(), pos.offset());
          });
        }
        if (collapsed) {
          normRng.collapse(true);
        }
        return $_aayq8q3zjh8lyx2z.isEq(rng, normRng) ? Option.none() : Option.some(normRng);
      };
      var $_4v2pn63yjh8lyx2s = { normalize: normalize$1 };

      var hasRightSideContent = function (schema, container, parentBlock) {
        var walker = new TreeWalker(container, parentBlock);
        var node;
        var nonEmptyElementsMap = schema.getNonEmptyElements();
        while (node = walker.next()) {
          if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
            return true;
          }
        }
      };
      var scrollToBr = function (dom, selection, brElm) {
        var marker = dom.create('span', {}, '&nbsp;');
        brElm.parentNode.insertBefore(marker, brElm);
        selection.scrollIntoView(marker);
        dom.remove(marker);
      };
      var moveSelectionToBr = function (dom, selection, brElm, extraBr) {
        var rng = dom.createRng();
        if (!extraBr) {
          rng.setStartAfter(brElm);
          rng.setEndAfter(brElm);
        } else {
          rng.setStartBefore(brElm);
          rng.setEndBefore(brElm);
        }
        selection.setRng(rng);
      };
      var insertBrAtCaret = function (editor, evt) {
        var selection = editor.selection, dom = editor.dom;
        var brElm, extraBr;
        var rng = selection.getRng();
        $_4v2pn63yjh8lyx2s.normalize(dom, rng).each(function (normRng) {
          rng.setStart(normRng.startContainer, normRng.startOffset);
          rng.setEnd(normRng.endContainer, normRng.endOffset);
        });
        var offset = rng.startOffset;
        var container = rng.startContainer;
        if (container.nodeType === 1 && container.hasChildNodes()) {
          var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
          container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
          if (isAfterLastNodeInContainer && container.nodeType === 3) {
            offset = container.nodeValue.length;
          } else {
            offset = 0;
          }
        }
        var parentBlock = dom.getParent(container, dom.isBlock);
        var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
        var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
        var isControlKey = evt && evt.ctrlKey;
        if (containerBlockName === 'LI' && !isControlKey) {
          parentBlock = containerBlock;
        }
        if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
          if (!hasRightSideContent(editor.schema, container, parentBlock)) {
            brElm = dom.create('br');
            rng.insertNode(brElm);
            rng.setStartAfter(brElm);
            rng.setEndAfter(brElm);
            extraBr = true;
          }
        }
        brElm = dom.create('br');
        rng.insertNode(brElm);
        scrollToBr(dom, selection, brElm);
        moveSelectionToBr(dom, selection, brElm, extraBr);
        editor.undoManager.add();
      };
      var insertBrBefore = function (editor, inline) {
        var br = $_cgttw3zjh8lywdq.fromTag('br');
        $_4m7u2e2kjh8lywpi.before($_cgttw3zjh8lywdq.fromDom(inline), br);
        editor.undoManager.add();
      };
      var insertBrAfter = function (editor, inline) {
        if (!hasBrAfter(editor.getBody(), inline)) {
          $_4m7u2e2kjh8lywpi.after($_cgttw3zjh8lywdq.fromDom(inline), $_cgttw3zjh8lywdq.fromTag('br'));
        }
        var br = $_cgttw3zjh8lywdq.fromTag('br');
        $_4m7u2e2kjh8lywpi.after($_cgttw3zjh8lywdq.fromDom(inline), br);
        scrollToBr(editor.dom, editor.selection, br.dom());
        moveSelectionToBr(editor.dom, editor.selection, br.dom(), false);
        editor.undoManager.add();
      };
      var isBeforeBr = function (pos) {
        return $_5oonaz1qjh8lywhz.isBr(pos.getNode());
      };
      var hasBrAfter = function (rootNode, startNode) {
        if (isBeforeBr(CaretPosition$1.after(startNode))) {
          return true;
        } else {
          return $_9kvypj2cjh8lywnz.nextPosition(rootNode, CaretPosition$1.after(startNode)).map(function (pos) {
            return $_5oonaz1qjh8lywhz.isBr(pos.getNode());
          }).getOr(false);
        }
      };
      var isAnchorLink = function (elm) {
        return elm && elm.nodeName === 'A' && 'href' in elm;
      };
      var isInsideAnchor = function (location) {
        return location.fold($_eqpqvr6jh8lyw3s.constant(false), isAnchorLink, isAnchorLink, $_eqpqvr6jh8lyw3s.constant(false));
      };
      var readInlineAnchorLocation = function (editor) {
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        var position = CaretPosition$1.fromRangeStart(editor.selection.getRng());
        return $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, editor.getBody(), position).filter(isInsideAnchor);
      };
      var insertBrOutsideAnchor = function (editor, location) {
        location.fold($_eqpqvr6jh8lyw3s.noop, $_eqpqvr6jh8lyw3s.curry(insertBrBefore, editor), $_eqpqvr6jh8lyw3s.curry(insertBrAfter, editor), $_eqpqvr6jh8lyw3s.noop);
      };
      var insert = function (editor, evt) {
        var anchorLocation = readInlineAnchorLocation(editor);
        if (anchorLocation.isSome()) {
          anchorLocation.each($_eqpqvr6jh8lyw3s.curry(insertBrOutsideAnchor, editor));
        } else {
          insertBrAtCaret(editor, evt);
        }
      };
      var $_cg4dz53xjh8lyx2g = { insert: insert };

      var adt = $_1ml90g3ijh8lywyp.generate([
        { 'before': ['element'] },
        {
          'on': [
            'element',
            'offset'
          ]
        },
        { after: ['element'] }
      ]);
      var cata = function (subject, onBefore, onOn, onAfter) {
        return subject.fold(onBefore, onOn, onAfter);
      };
      var getStart = function (situ) {
        return situ.fold($_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity, $_eqpqvr6jh8lyw3s.identity);
      };
      var $_fn8a2o42jh8lyx3r = {
        before: adt.before,
        on: adt.on,
        after: adt.after,
        cata: cata,
        getStart: getStart
      };

      var type$1 = $_1ml90g3ijh8lywyp.generate([
        { domRange: ['rng'] },
        {
          relative: [
            'startSitu',
            'finishSitu'
          ]
        },
        {
          exact: [
            'start',
            'soffset',
            'finish',
            'foffset'
          ]
        }
      ]);
      var range$1 = $_4jz0ce18jh8lywft.immutable('start', 'soffset', 'finish', 'foffset');
      var exactFromRange = function (simRange) {
        return type$1.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
      };
      var getStart$1 = function (selection) {
        return selection.match({
          domRange: function (rng) {
            return $_cgttw3zjh8lywdq.fromDom(rng.startContainer);
          },
          relative: function (startSitu, finishSitu) {
            return $_fn8a2o42jh8lyx3r.getStart(startSitu);
          },
          exact: function (start, soffset, finish, foffset) {
            return start;
          }
        });
      };
      var getWin = function (selection) {
        var start = getStart$1(selection);
        return $_a43q0i17jh8lywfe.defaultView(start);
      };
      var $_bx4foa41jh8lyx3f = {
        domRange: type$1.domRange,
        relative: type$1.relative,
        exact: type$1.exact,
        exactFromRange: exactFromRange,
        range: range$1,
        getWin: getWin
      };

      var browser$3 = $_9hkktfnjh8lywc6.detect().browser;
      var clamp = function (offset, element) {
        var max = $_7j1jt210jh8lywdx.isText(element) ? $_lh5l42wjh8lywr8.get(element).length : $_a43q0i17jh8lywfe.children(element).length + 1;
        if (offset > max) {
          return max;
        } else if (offset < 0) {
          return 0;
        }
        return offset;
      };
      var normalizeRng = function (rng) {
        return $_bx4foa41jh8lyx3f.range(rng.start(), clamp(rng.soffset(), rng.start()), rng.finish(), clamp(rng.foffset(), rng.finish()));
      };
      var isOrContains = function (root, elm) {
        return $_5f6gpb1djh8lywg5.contains(root, elm) || $_5f6gpb1djh8lywg5.eq(root, elm);
      };
      var isRngInRoot = function (root) {
        return function (rng) {
          return isOrContains(root, rng.start()) && isOrContains(root, rng.finish());
        };
      };
      var shouldStore = function (editor) {
        return editor.inline === true || browser$3.isIE();
      };
      var nativeRangeToSelectionRange = function (r) {
        return $_bx4foa41jh8lyx3f.range($_cgttw3zjh8lywdq.fromDom(r.startContainer), r.startOffset, $_cgttw3zjh8lywdq.fromDom(r.endContainer), r.endOffset);
      };
      var readRange = function (win) {
        var selection = win.getSelection();
        var rng = !selection || selection.rangeCount === 0 ? Option.none() : Option.from(selection.getRangeAt(0));
        return rng.map(nativeRangeToSelectionRange);
      };
      var getBookmark$2 = function (root) {
        var win = $_a43q0i17jh8lywfe.defaultView(root);
        return readRange(win.dom()).filter(isRngInRoot(root));
      };
      var validate = function (root, bookmark) {
        return Option.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
      };
      var bookmarkToNativeRng = function (bookmark) {
        var rng = document.createRange();
        try {
          rng.setStart(bookmark.start().dom(), bookmark.soffset());
          rng.setEnd(bookmark.finish().dom(), bookmark.foffset());
          return Option.some(rng);
        } catch (_) {
          return Option.none();
        }
      };
      var store = function (editor) {
        var newBookmark = shouldStore(editor) ? getBookmark$2($_cgttw3zjh8lywdq.fromDom(editor.getBody())) : Option.none();
        editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
      };
      var storeNative = function (editor, rng) {
        var root = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        var range = shouldStore(editor) ? Option.from(rng) : Option.none();
        var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
        editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
      };
      var getRng = function (editor) {
        var bookmark = editor.bookmark ? editor.bookmark : Option.none();
        return bookmark.bind($_eqpqvr6jh8lyw3s.curry(validate, $_cgttw3zjh8lywdq.fromDom(editor.getBody()))).bind(bookmarkToNativeRng);
      };
      var restore = function (editor) {
        getRng(editor).each(function (rng) {
          editor.selection.setRng(rng);
        });
      };
      var $_eqs11m40jh8lyx31 = {
        store: store,
        storeNative: storeNative,
        readRange: readRange,
        restore: restore,
        getRng: getRng,
        getBookmark: getBookmark$2,
        validate: validate
      };

      var indentElement = function (dom, command, useMargin, value, unit, element) {
        if (dom.getContentEditable(element) === 'false') {
          return;
        }
        if (element.nodeName !== 'LI') {
          var indentStyleName = useMargin ? 'margin' : 'padding';
          indentStyleName = element.nodeName === 'TABLE' ? 'margin' : indentStyleName;
          indentStyleName += dom.getStyle(element, 'direction', true) === 'rtl' ? 'Right' : 'Left';
          if (command === 'outdent') {
            var styleValue = Math.max(0, parseInt(element.style[indentStyleName] || 0, 10) - value);
            dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
          } else {
            var styleValue = parseInt(element.style[indentStyleName] || 0, 10) + value + unit;
            dom.setStyle(element, indentStyleName, styleValue);
          }
        }
      };
      var handle = function (editor, command) {
        var settings = editor.settings, dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
        var indentUnit = /[a-z%]+$/i.exec(settings.indentation)[0];
        var indentValue = parseInt(settings.indentation, 10);
        var useMargin = editor.getParam('indent_use_margin', false);
        if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
          if (!settings.forced_root_block && !dom.getParent(selection.getNode(), dom.isBlock)) {
            formatter.apply('div');
          }
          $_5wjzy24jh8lyw2t.each(selection.getSelectedBlocks(), function (element) {
            return indentElement(dom, command, useMargin, indentValue, indentUnit, element);
          });
        }
      };

      var each$9 = $_ahowuxkjh8lywbj.each;
      var extend$2 = $_ahowuxkjh8lywbj.extend;
      var map$2 = $_ahowuxkjh8lywbj.map;
      var inArray$2 = $_ahowuxkjh8lywbj.inArray;
      function EditorCommands (editor) {
        var dom, selection, formatter;
        var commands = {
          state: {},
          exec: {},
          value: {}
        };
        var settings = editor.settings, bookmark;
        editor.on('PreInit', function () {
          dom = editor.dom;
          selection = editor.selection;
          settings = editor.settings;
          formatter = editor.formatter;
        });
        var execCommand = function (command, ui, value, args) {
          var func, customCommand, state = false;
          if (editor.removed) {
            return;
          }
          if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
            editor.focus();
          } else {
            $_eqs11m40jh8lyx31.restore(editor);
          }
          args = editor.fire('BeforeExecCommand', {
            command: command,
            ui: ui,
            value: value
          });
          if (args.isDefaultPrevented()) {
            return false;
          }
          customCommand = command.toLowerCase();
          if (func = commands.exec[customCommand]) {
            func(customCommand, ui, value);
            editor.fire('ExecCommand', {
              command: command,
              ui: ui,
              value: value
            });
            return true;
          }
          each$9(editor.plugins, function (p) {
            if (p.execCommand && p.execCommand(command, ui, value)) {
              editor.fire('ExecCommand', {
                command: command,
                ui: ui,
                value: value
              });
              state = true;
              return false;
            }
          });
          if (state) {
            return state;
          }
          if (editor.theme && editor.theme.execCommand && editor.theme.execCommand(command, ui, value)) {
            editor.fire('ExecCommand', {
              command: command,
              ui: ui,
              value: value
            });
            return true;
          }
          try {
            state = editor.getDoc().execCommand(command, ui, value);
          } catch (ex) {
          }
          if (state) {
            editor.fire('ExecCommand', {
              command: command,
              ui: ui,
              value: value
            });
            return true;
          }
          return false;
        };
        var queryCommandState = function (command) {
          var func;
          if (editor.quirks.isHidden() || editor.removed) {
            return;
          }
          command = command.toLowerCase();
          if (func = commands.state[command]) {
            return func(command);
          }
          try {
            return editor.getDoc().queryCommandState(command);
          } catch (ex) {
          }
          return false;
        };
        var queryCommandValue = function (command) {
          var func;
          if (editor.quirks.isHidden() || editor.removed) {
            return;
          }
          command = command.toLowerCase();
          if (func = commands.value[command]) {
            return func(command);
          }
          try {
            return editor.getDoc().queryCommandValue(command);
          } catch (ex) {
          }
        };
        var addCommands = function (commandList, type) {
          type = type || 'exec';
          each$9(commandList, function (callback, command) {
            each$9(command.toLowerCase().split(','), function (command) {
              commands[type][command] = callback;
            });
          });
        };
        var addCommand = function (command, callback, scope) {
          command = command.toLowerCase();
          commands.exec[command] = function (command, ui, value, args) {
            return callback.call(scope || editor, ui, value, args);
          };
        };
        var queryCommandSupported = function (command) {
          command = command.toLowerCase();
          if (commands.exec[command]) {
            return true;
          }
          try {
            return editor.getDoc().queryCommandSupported(command);
          } catch (ex) {
          }
          return false;
        };
        var addQueryStateHandler = function (command, callback, scope) {
          command = command.toLowerCase();
          commands.state[command] = function () {
            return callback.call(scope || editor);
          };
        };
        var addQueryValueHandler = function (command, callback, scope) {
          command = command.toLowerCase();
          commands.value[command] = function () {
            return callback.call(scope || editor);
          };
        };
        var hasCustomCommand = function (command) {
          command = command.toLowerCase();
          return !!commands.exec[command];
        };
        extend$2(this, {
          execCommand: execCommand,
          queryCommandState: queryCommandState,
          queryCommandValue: queryCommandValue,
          queryCommandSupported: queryCommandSupported,
          addCommands: addCommands,
          addCommand: addCommand,
          addQueryStateHandler: addQueryStateHandler,
          addQueryValueHandler: addQueryValueHandler,
          hasCustomCommand: hasCustomCommand
        });
        var execNativeCommand = function (command, ui, value) {
          if (ui === undefined) {
            ui = false;
          }
          if (value === undefined) {
            value = null;
          }
          return editor.getDoc().execCommand(command, ui, value);
        };
        var isFormatMatch = function (name) {
          return formatter.match(name);
        };
        var toggleFormat = function (name, value) {
          formatter.toggle(name, value ? { value: value } : undefined);
          editor.nodeChanged();
        };
        var storeSelection = function (type) {
          bookmark = selection.getBookmark(type);
        };
        var restoreSelection = function () {
          selection.moveToBookmark(bookmark);
        };
        addCommands({
          'mceResetDesignMode,mceBeginUndoLevel': function () {
          },
          'mceEndUndoLevel,mceAddUndoLevel': function () {
            editor.undoManager.add();
          },
          'Cut,Copy,Paste': function (command) {
            var doc = editor.getDoc();
            var failed;
            try {
              execNativeCommand(command);
            } catch (ex) {
              failed = true;
            }
            if (command === 'paste' && !doc.queryCommandEnabled(command)) {
              failed = true;
            }
            if (failed || !doc.queryCommandSupported(command)) {
              var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
              if ($_9bpim8ajh8lyw68.mac) {
                msg = msg.replace(/Ctrl\+/g, '\u2318+');
              }
              editor.notificationManager.open({
                text: msg,
                type: 'error'
              });
            }
          },
          'unlink': function () {
            if (selection.isCollapsed()) {
              var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
              if (elm) {
                editor.dom.remove(elm, true);
              }
              return;
            }
            formatter.remove('link');
          },
          'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
            var align = command.substring(7);
            if (align === 'full') {
              align = 'justify';
            }
            each$9('left,center,right,justify'.split(','), function (name) {
              if (align !== name) {
                formatter.remove('align' + name);
              }
            });
            if (align !== 'none') {
              toggleFormat('align' + align);
            }
          },
          'InsertUnorderedList,InsertOrderedList': function (command) {
            var listElm, listParent;
            execNativeCommand(command);
            listElm = dom.getParent(selection.getNode(), 'ol,ul');
            if (listElm) {
              listParent = listElm.parentNode;
              if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
                storeSelection();
                dom.split(listParent, listElm);
                restoreSelection();
              }
            }
          },
          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
            toggleFormat(command);
          },
          'ForeColor,HiliteColor': function (command, ui, value) {
            toggleFormat(command, value);
          },
          'FontName': function (command, ui, value) {
            fontNameAction(editor, value);
          },
          'FontSize': function (command, ui, value) {
            fontSizeAction(editor, value);
          },
          'RemoveFormat': function (command) {
            formatter.remove(command);
          },
          'mceBlockQuote': function () {
            toggleFormat('blockquote');
          },
          'FormatBlock': function (command, ui, value) {
            return toggleFormat(value || 'p');
          },
          'mceCleanup': function () {
            var bookmark = selection.getBookmark();
            editor.setContent(editor.getContent());
            selection.moveToBookmark(bookmark);
          },
          'mceRemoveNode': function (command, ui, value) {
            var node = value || selection.getNode();
            if (node !== editor.getBody()) {
              storeSelection();
              editor.dom.remove(node, true);
              restoreSelection();
            }
          },
          'mceSelectNodeDepth': function (command, ui, value) {
            var counter = 0;
            dom.getParent(selection.getNode(), function (node) {
              if (node.nodeType === 1 && counter++ === value) {
                selection.select(node);
                return false;
              }
            }, editor.getBody());
          },
          'mceSelectNode': function (command, ui, value) {
            selection.select(value);
          },
          'mceInsertContent': function (command, ui, value) {
            $_13xltl1wjh8lywkr.insertAtCaret(editor, value);
          },
          'mceInsertRawHTML': function (command, ui, value) {
            var content = editor.getContent();
            selection.setContent('tiny_mce_marker');
            editor.setContent(content.replace(/tiny_mce_marker/g, function () {
              return value;
            }));
          },
          'mceToggleFormat': function (command, ui, value) {
            toggleFormat(value);
          },
          'mceSetContent': function (command, ui, value) {
            editor.setContent(value);
          },
          'Indent,Outdent': function (command) {
            handle(editor, command);
          },
          'mceRepaint': function () {
          },
          'InsertHorizontalRule': function () {
            editor.execCommand('mceInsertContent', false, '<hr />');
          },
          'mceToggleVisualAid': function () {
            editor.hasVisual = !editor.hasVisual;
            editor.addVisual();
          },
          'mceReplaceContent': function (command, ui, value) {
            editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, selection.getContent({ format: 'text' })));
          },
          'mceInsertLink': function (command, ui, value) {
            var anchor;
            if (typeof value === 'string') {
              value = { href: value };
            }
            anchor = dom.getParent(selection.getNode(), 'a');
            value.href = value.href.replace(' ', '%20');
            if (!anchor || !value.href) {
              formatter.remove('link');
            }
            if (value.href) {
              formatter.apply('link', value, anchor);
            }
          },
          'selectAll': function () {
            var editingHost = dom.getParent(selection.getStart(), $_5oonaz1qjh8lywhz.isContentEditableTrue);
            if (editingHost) {
              var rng = dom.createRng();
              rng.selectNodeContents(editingHost);
              selection.setRng(rng);
            }
          },
          'delete': function () {
            $_fmagiy31jh8lywrp.deleteCommand(editor);
          },
          'forwardDelete': function () {
            $_fmagiy31jh8lywrp.forwardDeleteCommand(editor);
          },
          'mceNewDocument': function () {
            editor.setContent('');
          },
          'InsertLineBreak': function (command, ui, value) {
            $_cg4dz53xjh8lyx2g.insert(editor, value);
            return true;
          }
        });
        var alignStates = function (name) {
          return function () {
            var nodes = selection.isCollapsed() ? [dom.getParent(selection.getNode(), dom.isBlock)] : selection.getSelectedBlocks();
            var matches = map$2(nodes, function (node) {
              return !!formatter.matchNode(node, name);
            });
            return inArray$2(matches, true) !== -1;
          };
        };
        addCommands({
          'JustifyLeft': alignStates('alignleft'),
          'JustifyCenter': alignStates('aligncenter'),
          'JustifyRight': alignStates('alignright'),
          'JustifyFull': alignStates('alignjustify'),
          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
            return isFormatMatch(command);
          },
          'mceBlockQuote': function () {
            return isFormatMatch('blockquote');
          },
          'Outdent': function () {
            var node;
            if (settings.inline_styles) {
              if ((node = dom.getParent(selection.getStart(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
                return true;
              }
              if ((node = dom.getParent(selection.getEnd(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
                return true;
              }
            }
            return queryCommandState('InsertUnorderedList') || queryCommandState('InsertOrderedList') || !settings.inline_styles && !!dom.getParent(selection.getNode(), 'BLOCKQUOTE');
          },
          'InsertUnorderedList,InsertOrderedList': function (command) {
            var list = dom.getParent(selection.getNode(), 'ul,ol');
            return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
          }
        }, 'state');
        addCommands({
          Undo: function () {
            editor.undoManager.undo();
          },
          Redo: function () {
            editor.undoManager.redo();
          }
        });
        addQueryValueHandler('FontName', function () {
          return fontNameQuery(editor);
        }, this);
        addQueryValueHandler('FontSize', function () {
          return fontSizeQuery(editor);
        }, this);
      }

      var nativeEvents = $_ahowuxkjh8lywbj.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend', ' ');
      var Dispatcher = function (settings) {
        var self = this;
        var scope, bindings = {}, toggleEvent;
        var returnFalse = function () {
          return false;
        };
        var returnTrue = function () {
          return true;
        };
        settings = settings || {};
        scope = settings.scope || self;
        toggleEvent = settings.toggleEvent || returnFalse;
        var fire = function (name, args) {
          var handlers, i, l, callback;
          name = name.toLowerCase();
          args = args || {};
          args.type = name;
          if (!args.target) {
            args.target = scope;
          }
          if (!args.preventDefault) {
            args.preventDefault = function () {
              args.isDefaultPrevented = returnTrue;
            };
            args.stopPropagation = function () {
              args.isPropagationStopped = returnTrue;
            };
            args.stopImmediatePropagation = function () {
              args.isImmediatePropagationStopped = returnTrue;
            };
            args.isDefaultPrevented = returnFalse;
            args.isPropagationStopped = returnFalse;
            args.isImmediatePropagationStopped = returnFalse;
          }
          if (settings.beforeFire) {
            settings.beforeFire(args);
          }
          handlers = bindings[name];
          if (handlers) {
            for (i = 0, l = handlers.length; i < l; i++) {
              callback = handlers[i];
              if (callback.once) {
                off(name, callback.func);
              }
              if (args.isImmediatePropagationStopped()) {
                args.stopPropagation();
                return args;
              }
              if (callback.func.call(scope, args) === false) {
                args.preventDefault();
                return args;
              }
            }
          }
          return args;
        };
        var on = function (name, callback, prepend, extra) {
          var handlers, names, i;
          if (callback === false) {
            callback = returnFalse;
          }
          if (callback) {
            callback = { func: callback };
            if (extra) {
              $_ahowuxkjh8lywbj.extend(callback, extra);
            }
            names = name.toLowerCase().split(' ');
            i = names.length;
            while (i--) {
              name = names[i];
              handlers = bindings[name];
              if (!handlers) {
                handlers = bindings[name] = [];
                toggleEvent(name, true);
              }
              if (prepend) {
                handlers.unshift(callback);
              } else {
                handlers.push(callback);
              }
            }
          }
          return self;
        };
        var off = function (name, callback) {
          var i, handlers, bindingName, names, hi;
          if (name) {
            names = name.toLowerCase().split(' ');
            i = names.length;
            while (i--) {
              name = names[i];
              handlers = bindings[name];
              if (!name) {
                for (bindingName in bindings) {
                  toggleEvent(bindingName, false);
                  delete bindings[bindingName];
                }
                return self;
              }
              if (handlers) {
                if (!callback) {
                  handlers.length = 0;
                } else {
                  hi = handlers.length;
                  while (hi--) {
                    if (handlers[hi].func === callback) {
                      handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
                      bindings[name] = handlers;
                    }
                  }
                }
                if (!handlers.length) {
                  toggleEvent(name, false);
                  delete bindings[name];
                }
              }
            }
          } else {
            for (name in bindings) {
              toggleEvent(name, false);
            }
            bindings = {};
          }
          return self;
        };
        var once = function (name, callback, prepend) {
          return on(name, callback, prepend, { once: true });
        };
        var has = function (name) {
          name = name.toLowerCase();
          return !(!bindings[name] || bindings[name].length === 0);
        };
        self.fire = fire;
        self.on = on;
        self.off = off;
        self.once = once;
        self.has = has;
      };
      Dispatcher.isNative = function (name) {
        return !!nativeEvents[name.toLowerCase()];
      };

      var getEventDispatcher = function (obj) {
        if (!obj._eventDispatcher) {
          obj._eventDispatcher = new Dispatcher({
            scope: obj,
            toggleEvent: function (name, state) {
              if (Dispatcher.isNative(name) && obj.toggleNativeEvent) {
                obj.toggleNativeEvent(name, state);
              }
            }
          });
        }
        return obj._eventDispatcher;
      };
      var $_fuzxjg45jh8lyx45 = {
        fire: function (name, args, bubble) {
          var self = this;
          if (self.removed && name !== 'remove') {
            return args;
          }
          args = getEventDispatcher(self).fire(name, args, bubble);
          if (bubble !== false && self.parent) {
            var parent_1 = self.parent();
            while (parent_1 && !args.isPropagationStopped()) {
              parent_1.fire(name, args, false);
              parent_1 = parent_1.parent();
            }
          }
          return args;
        },
        on: function (name, callback, prepend) {
          return getEventDispatcher(this).on(name, callback, prepend);
        },
        off: function (name, callback) {
          return getEventDispatcher(this).off(name, callback);
        },
        once: function (name, callback) {
          return getEventDispatcher(this).once(name, callback);
        },
        hasEventListeners: function (name) {
          return getEventDispatcher(this).has(name);
        }
      };

      function Toggler (turnOff, turnOn, initial) {
        var active = initial || false;
        var on = function () {
          turnOn();
          active = true;
        };
        var off = function () {
          turnOff();
          active = false;
        };
        var toggle = function () {
          var f = active ? off : on;
          f();
        };
        var isOn = function () {
          return active;
        };
        return {
          on: on,
          off: off,
          toggle: toggle,
          isOn: isOn
        };
      }

      var read$2 = function (element, attr) {
        var value = $_3da62i14jh8lyweo.get(element, attr);
        return value === undefined || value === '' ? [] : value.split(' ');
      };
      var add = function (element, attr, id) {
        var old = read$2(element, attr);
        var nu = old.concat([id]);
        $_3da62i14jh8lyweo.set(element, attr, nu.join(' '));
      };
      var remove$4 = function (element, attr, id) {
        var nu = $_5wjzy24jh8lyw2t.filter(read$2(element, attr), function (v) {
          return v !== id;
        });
        if (nu.length > 0)
          $_3da62i14jh8lyweo.set(element, attr, nu.join(' '));
        else
          $_3da62i14jh8lyweo.remove(element, attr);
      };
      var $_5xj9rq4bjh8lyx4m = {
        read: read$2,
        add: add,
        remove: remove$4
      };

      var supports = function (element) {
        return element.dom().classList !== undefined;
      };
      var get$4 = function (element) {
        return $_5xj9rq4bjh8lyx4m.read(element, 'class');
      };
      var add$1 = function (element, clazz) {
        return $_5xj9rq4bjh8lyx4m.add(element, 'class', clazz);
      };
      var remove$5 = function (element, clazz) {
        return $_5xj9rq4bjh8lyx4m.remove(element, 'class', clazz);
      };
      var toggle = function (element, clazz) {
        if ($_5wjzy24jh8lyw2t.contains(get$4(element), clazz)) {
          remove$5(element, clazz);
        } else {
          add$1(element, clazz);
        }
      };
      var $_eprb6o4ajh8lyx4j = {
        get: get$4,
        add: add$1,
        remove: remove$5,
        toggle: toggle,
        supports: supports
      };

      var add$2 = function (element, clazz) {
        if ($_eprb6o4ajh8lyx4j.supports(element))
          element.dom().classList.add(clazz);
        else
          $_eprb6o4ajh8lyx4j.add(element, clazz);
      };
      var cleanClass = function (element) {
        var classList = $_eprb6o4ajh8lyx4j.supports(element) ? element.dom().classList : $_eprb6o4ajh8lyx4j.get(element);
        if (classList.length === 0) {
          $_3da62i14jh8lyweo.remove(element, 'class');
        }
      };
      var remove$6 = function (element, clazz) {
        if ($_eprb6o4ajh8lyx4j.supports(element)) {
          var classList = element.dom().classList;
          classList.remove(clazz);
        } else
          $_eprb6o4ajh8lyx4j.remove(element, clazz);
        cleanClass(element);
      };
      var toggle$1 = function (element, clazz) {
        return $_eprb6o4ajh8lyx4j.supports(element) ? element.dom().classList.toggle(clazz) : $_eprb6o4ajh8lyx4j.toggle(element, clazz);
      };
      var toggler = function (element, clazz) {
        var hasClasslist = $_eprb6o4ajh8lyx4j.supports(element);
        var classList = element.dom().classList;
        var off = function () {
          if (hasClasslist)
            classList.remove(clazz);
          else
            $_eprb6o4ajh8lyx4j.remove(element, clazz);
        };
        var on = function () {
          if (hasClasslist)
            classList.add(clazz);
          else
            $_eprb6o4ajh8lyx4j.add(element, clazz);
        };
        return Toggler(off, on, has$1(element, clazz));
      };
      var has$1 = function (element, clazz) {
        return $_eprb6o4ajh8lyx4j.supports(element) && element.dom().classList.contains(clazz);
      };
      var $_6hv60f48jh8lyx4g = {
        add: add$2,
        remove: remove$6,
        toggle: toggle$1,
        toggler: toggler,
        has: has$1
      };

      var firePreProcess = function (editor, args) {
        return editor.fire('PreProcess', args);
      };
      var firePostProcess = function (editor, args) {
        return editor.fire('PostProcess', args);
      };
      var fireRemove = function (editor) {
        return editor.fire('remove');
      };
      var fireSwitchMode = function (editor, mode) {
        return editor.fire('SwitchMode', { mode: mode });
      };
      var fireObjectResizeStart = function (editor, target, width, height) {
        editor.fire('ObjectResizeStart', {
          target: target,
          width: width,
          height: height
        });
      };
      var fireObjectResized = function (editor, target, width, height) {
        editor.fire('ObjectResized', {
          target: target,
          width: width,
          height: height
        });
      };
      var $_a4fgrn4cjh8lyx4q = {
        firePreProcess: firePreProcess,
        firePostProcess: firePostProcess,
        fireRemove: fireRemove,
        fireSwitchMode: fireSwitchMode,
        fireObjectResizeStart: fireObjectResizeStart,
        fireObjectResized: fireObjectResized
      };

      var setEditorCommandState = function (editor, cmd, state) {
        try {
          editor.getDoc().execCommand(cmd, false, state);
        } catch (ex) {
        }
      };
      var toggleClass = function (elm, cls, state) {
        if ($_6hv60f48jh8lyx4g.has(elm, cls) && state === false) {
          $_6hv60f48jh8lyx4g.remove(elm, cls);
        } else if (state) {
          $_6hv60f48jh8lyx4g.add(elm, cls);
        }
      };
      var toggleReadOnly = function (editor, state) {
        toggleClass($_cgttw3zjh8lywdq.fromDom(editor.getBody()), 'mce-content-readonly', state);
        if (state) {
          editor.selection.controlSelection.hideResizeRect();
          editor.readonly = true;
          editor.getBody().contentEditable = 'false';
        } else {
          editor.readonly = false;
          editor.getBody().contentEditable = 'true';
          setEditorCommandState(editor, 'StyleWithCSS', false);
          setEditorCommandState(editor, 'enableInlineTableEditing', false);
          setEditorCommandState(editor, 'enableObjectResizing', false);
          editor.focus();
          editor.nodeChanged();
        }
      };
      var setMode = function (editor, mode) {
        if (mode === getMode(editor)) {
          return;
        }
        if (editor.initialized) {
          toggleReadOnly(editor, mode === 'readonly');
        } else {
          editor.on('init', function () {
            toggleReadOnly(editor, mode === 'readonly');
          });
        }
        $_a4fgrn4cjh8lyx4q.fireSwitchMode(editor, mode);
      };
      var getMode = function (editor) {
        return editor.readonly ? 'readonly' : 'design';
      };
      var isReadOnly = function (editor) {
        return editor.readonly === true;
      };

      var DOM$1 = DOMUtils$1.DOM;
      var customEventRootDelegates;
      var getEventTarget = function (editor, eventName) {
        if (eventName === 'selectionchange') {
          return editor.getDoc();
        }
        if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
          return editor.getDoc().documentElement;
        }
        if (editor.settings.event_root) {
          if (!editor.eventRoot) {
            editor.eventRoot = DOM$1.select(editor.settings.event_root)[0];
          }
          return editor.eventRoot;
        }
        return editor.getBody();
      };
      var isListening = function (editor) {
        return !editor.hidden && !editor.readonly;
      };
      var fireEvent = function (editor, eventName, e) {
        if (isListening(editor)) {
          editor.fire(eventName, e);
        } else if (isReadOnly(editor)) {
          e.preventDefault();
        }
      };
      var bindEventDelegate = function (editor, eventName) {
        var eventRootElm, delegate;
        if (!editor.delegates) {
          editor.delegates = {};
        }
        if (editor.delegates[eventName] || editor.removed) {
          return;
        }
        eventRootElm = getEventTarget(editor, eventName);
        if (editor.settings.event_root) {
          if (!customEventRootDelegates) {
            customEventRootDelegates = {};
            editor.editorManager.on('removeEditor', function () {
              var name;
              if (!editor.editorManager.activeEditor) {
                if (customEventRootDelegates) {
                  for (name in customEventRootDelegates) {
                    editor.dom.unbind(getEventTarget(editor, name));
                  }
                  customEventRootDelegates = null;
                }
              }
            });
          }
          if (customEventRootDelegates[eventName]) {
            return;
          }
          delegate = function (e) {
            var target = e.target;
            var editors = editor.editorManager.get();
            var i = editors.length;
            while (i--) {
              var body = editors[i].getBody();
              if (body === target || DOM$1.isChildOf(target, body)) {
                fireEvent(editors[i], eventName, e);
              }
            }
          };
          customEventRootDelegates[eventName] = delegate;
          DOM$1.bind(eventRootElm, eventName, delegate);
        } else {
          delegate = function (e) {
            fireEvent(editor, eventName, e);
          };
          DOM$1.bind(eventRootElm, eventName, delegate);
          editor.delegates[eventName] = delegate;
        }
      };
      var EditorObservable = {
        bindPendingEventDelegates: function () {
          var self = this;
          $_ahowuxkjh8lywbj.each(self._pendingNativeEvents, function (name) {
            bindEventDelegate(self, name);
          });
        },
        toggleNativeEvent: function (name, state) {
          var self = this;
          if (name === 'focus' || name === 'blur') {
            return;
          }
          if (state) {
            if (self.initialized) {
              bindEventDelegate(self, name);
            } else {
              if (!self._pendingNativeEvents) {
                self._pendingNativeEvents = [name];
              } else {
                self._pendingNativeEvents.push(name);
              }
            }
          } else if (self.initialized) {
            self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
            delete self.delegates[name];
          }
        },
        unbindAllNativeEvents: function () {
          var self = this;
          var body = self.getBody();
          var dom = self.dom;
          var name;
          if (self.delegates) {
            for (name in self.delegates) {
              self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
            }
            delete self.delegates;
          }
          if (!self.inline && body && dom) {
            body.onload = null;
            dom.unbind(self.getWin());
            dom.unbind(self.getDoc());
          }
          if (dom) {
            dom.unbind(body);
            dom.unbind(self.getContainer());
          }
        }
      };
      EditorObservable = $_ahowuxkjh8lywbj.extend({}, $_fuzxjg45jh8lyx45, EditorObservable);
      var EditorObservable$1 = EditorObservable;

      var each$10 = $_ahowuxkjh8lywbj.each;
      var explode$2 = $_ahowuxkjh8lywbj.explode;
      var keyCodeLookup = {
        f9: 120,
        f10: 121,
        f11: 122
      };
      var modifierNames = $_ahowuxkjh8lywbj.makeMap('alt,ctrl,shift,meta,access');
      function Shortcuts (editor) {
        var self = this;
        var shortcuts = {};
        var pendingPatterns = [];
        var parseShortcut = function (pattern) {
          var id, key;
          var shortcut = {};
          each$10(explode$2(pattern, '+'), function (value) {
            if (value in modifierNames) {
              shortcut[value] = true;
            } else {
              if (/^[0-9]{2,}$/.test(value)) {
                shortcut.keyCode = parseInt(value, 10);
              } else {
                shortcut.charCode = value.charCodeAt(0);
                shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
              }
            }
          });
          id = [shortcut.keyCode];
          for (key in modifierNames) {
            if (shortcut[key]) {
              id.push(key);
            } else {
              shortcut[key] = false;
            }
          }
          shortcut.id = id.join(',');
          if (shortcut.access) {
            shortcut.alt = true;
            if ($_9bpim8ajh8lyw68.mac) {
              shortcut.ctrl = true;
            } else {
              shortcut.shift = true;
            }
          }
          if (shortcut.meta) {
            if ($_9bpim8ajh8lyw68.mac) {
              shortcut.meta = true;
            } else {
              shortcut.ctrl = true;
              shortcut.meta = false;
            }
          }
          return shortcut;
        };
        var createShortcut = function (pattern, desc, cmdFunc, scope) {
          var shortcuts;
          shortcuts = $_ahowuxkjh8lywbj.map(explode$2(pattern, '>'), parseShortcut);
          shortcuts[shortcuts.length - 1] = $_ahowuxkjh8lywbj.extend(shortcuts[shortcuts.length - 1], {
            func: cmdFunc,
            scope: scope || editor
          });
          return $_ahowuxkjh8lywbj.extend(shortcuts[0], {
            desc: editor.translate(desc),
            subpatterns: shortcuts.slice(1)
          });
        };
        var hasModifier = function (e) {
          return e.altKey || e.ctrlKey || e.metaKey;
        };
        var isFunctionKey = function (e) {
          return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
        };
        var matchShortcut = function (e, shortcut) {
          if (!shortcut) {
            return false;
          }
          if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
            return false;
          }
          if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
            return false;
          }
          if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
            e.preventDefault();
            return true;
          }
          return false;
        };
        var executeShortcutAction = function (shortcut) {
          return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
        };
        editor.on('keyup keypress keydown', function (e) {
          if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
            each$10(shortcuts, function (shortcut) {
              if (matchShortcut(e, shortcut)) {
                pendingPatterns = shortcut.subpatterns.slice(0);
                if (e.type === 'keydown') {
                  executeShortcutAction(shortcut);
                }
                return true;
              }
            });
            if (matchShortcut(e, pendingPatterns[0])) {
              if (pendingPatterns.length === 1) {
                if (e.type === 'keydown') {
                  executeShortcutAction(pendingPatterns[0]);
                }
              }
              pendingPatterns.shift();
            }
          }
        });
        self.add = function (pattern, desc, cmdFunc, scope) {
          var cmd;
          cmd = cmdFunc;
          if (typeof cmdFunc === 'string') {
            cmdFunc = function () {
              editor.execCommand(cmd, false, null);
            };
          } else if ($_ahowuxkjh8lywbj.isArray(cmd)) {
            cmdFunc = function () {
              editor.execCommand(cmd[0], cmd[1], cmd[2]);
            };
          }
          each$10(explode$2($_ahowuxkjh8lywbj.trim(pattern.toLowerCase())), function (pattern) {
            var shortcut = createShortcut(pattern, desc, cmdFunc, scope);
            shortcuts[shortcut.id] = shortcut;
          });
          return true;
        };
        self.remove = function (pattern) {
          var shortcut = createShortcut(pattern);
          if (shortcuts[shortcut.id]) {
            delete shortcuts[shortcut.id];
            return true;
          }
          return false;
        };
      }

      var any$1 = function (predicate) {
        return $_6hl03835jh8lywsm.first(predicate).isSome();
      };
      var ancestor$3 = function (scope, predicate, isRoot) {
        return $_6hl03835jh8lywsm.ancestor(scope, predicate, isRoot).isSome();
      };
      var closest$3 = function (scope, predicate, isRoot) {
        return $_6hl03835jh8lywsm.closest(scope, predicate, isRoot).isSome();
      };
      var sibling$4 = function (scope, predicate) {
        return $_6hl03835jh8lywsm.sibling(scope, predicate).isSome();
      };
      var child$4 = function (scope, predicate) {
        return $_6hl03835jh8lywsm.child(scope, predicate).isSome();
      };
      var descendant$3 = function (scope, predicate) {
        return $_6hl03835jh8lywsm.descendant(scope, predicate).isSome();
      };
      var $_1jfttr4gjh8lyx5b = {
        any: any$1,
        ancestor: ancestor$3,
        closest: closest$3,
        sibling: sibling$4,
        child: child$4,
        descendant: descendant$3
      };

      var focus = function (element) {
        element.dom().focus();
      };
      var blur = function (element) {
        element.dom().blur();
      };
      var hasFocus = function (element) {
        var doc = $_a43q0i17jh8lywfe.owner(element).dom();
        return element.dom() === doc.activeElement;
      };
      var active = function (_doc) {
        var doc = _doc !== undefined ? _doc.dom() : document;
        return Option.from(doc.activeElement).map($_cgttw3zjh8lywdq.fromDom);
      };
      var focusInside = function (element) {
        var doc = $_a43q0i17jh8lywfe.owner(element);
        var inside = active(doc).filter(function (a) {
          return $_1jfttr4gjh8lyx5b.closest(a, $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, element));
        });
        inside.fold(function () {
          focus(element);
        }, $_eqpqvr6jh8lyw3s.noop);
      };
      var search = function (element) {
        return active($_a43q0i17jh8lywfe.owner(element)).filter(function (e) {
          return element.dom().contains(e.dom());
        });
      };
      var $_717ku14fjh8lyx55 = {
        hasFocus: hasFocus,
        focus: focus,
        blur: blur,
        active: active,
        search: search,
        focusInside: focusInside
      };

      var getContentEditableHost = function (editor, node) {
        return editor.dom.getParent(node, function (node) {
          return editor.dom.getContentEditable(node) === 'true';
        });
      };
      var getCollapsedNode = function (rng) {
        return rng.collapsed ? Option.from(getNode(rng.startContainer, rng.startOffset)).map($_cgttw3zjh8lywdq.fromDom) : Option.none();
      };
      var getFocusInElement = function (root, rng) {
        return getCollapsedNode(rng).bind(function (node) {
          if (isTableSection(node)) {
            return Option.some(node);
          } else if ($_5f6gpb1djh8lywg5.contains(root, node) === false) {
            return Option.some(root);
          } else {
            return Option.none();
          }
        });
      };
      var normalizeSelection = function (editor, rng) {
        getFocusInElement($_cgttw3zjh8lywdq.fromDom(editor.getBody()), rng).bind(function (elm) {
          return $_9kvypj2cjh8lywnz.firstPositionIn(elm.dom());
        }).fold(function () {
          editor.selection.normalize();
          return;
        }, function (caretPos) {
          return editor.selection.setRng(caretPos.toRange());
        });
      };
      var focusBody = function (body) {
        if (body.setActive) {
          try {
            body.setActive();
          } catch (ex) {
            body.focus();
          }
        } else {
          body.focus();
        }
      };
      var hasElementFocus = function (elm) {
        return $_717ku14fjh8lyx55.hasFocus(elm) || $_717ku14fjh8lyx55.search(elm).isSome();
      };
      var hasIframeFocus = function (editor) {
        return editor.iframeElement && $_717ku14fjh8lyx55.hasFocus($_cgttw3zjh8lywdq.fromDom(editor.iframeElement));
      };
      var hasInlineFocus = function (editor) {
        var rawBody = editor.getBody();
        return rawBody && hasElementFocus($_cgttw3zjh8lywdq.fromDom(rawBody));
      };
      var hasFocus$1 = function (editor) {
        return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
      };
      var focusEditor = function (editor) {
        var selection = editor.selection, contentEditable = editor.settings.content_editable;
        var body = editor.getBody();
        var rng = selection.getRng();
        editor.quirks.refreshContentEditable();
        var contentEditableHost = getContentEditableHost(editor, selection.getNode());
        if (editor.$.contains(body, contentEditableHost)) {
          focusBody(contentEditableHost);
          normalizeSelection(editor, rng);
          activateEditor(editor);
          return;
        }
        if (editor.bookmark !== undefined && hasFocus$1(editor) === false) {
          $_eqs11m40jh8lyx31.getRng(editor).each(function (bookmarkRng) {
            editor.selection.setRng(bookmarkRng);
            rng = bookmarkRng;
          });
        }
        if (!contentEditable) {
          if (!$_9bpim8ajh8lyw68.opera) {
            focusBody(body);
          }
          editor.getWin().focus();
        }
        if ($_9bpim8ajh8lyw68.gecko || contentEditable) {
          focusBody(body);
          normalizeSelection(editor, rng);
        }
        activateEditor(editor);
      };
      var activateEditor = function (editor) {
        return editor.editorManager.setActive(editor);
      };
      var focus$1 = function (editor, skipFocus) {
        if (editor.removed) {
          return;
        }
        skipFocus ? activateEditor(editor) : focusEditor(editor);
      };
      var $_cnu79r4ejh8lyx4x = {
        focus: focus$1,
        hasFocus: hasFocus$1
      };

      var getProp = function (propName, elm) {
        var rawElm = elm.dom();
        return rawElm[propName];
      };
      var getComputedSizeProp = function (propName, elm) {
        return parseInt($_36knnd12jh8lywe1.get(elm, propName), 10);
      };
      var getClientWidth = $_eqpqvr6jh8lyw3s.curry(getProp, 'clientWidth');
      var getClientHeight = $_eqpqvr6jh8lyw3s.curry(getProp, 'clientHeight');
      var getMarginTop = $_eqpqvr6jh8lyw3s.curry(getComputedSizeProp, 'margin-top');
      var getMarginLeft = $_eqpqvr6jh8lyw3s.curry(getComputedSizeProp, 'margin-left');
      var getBoundingClientRect$1 = function (elm) {
        return elm.dom().getBoundingClientRect();
      };
      var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
        var clientWidth = getClientWidth(bodyElm);
        var clientHeight = getClientHeight(bodyElm);
        return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
      };
      var transpose = function (inline, elm, clientX, clientY) {
        var clientRect = getBoundingClientRect$1(elm);
        var deltaX = inline ? clientRect.left + elm.dom().clientLeft + getMarginLeft(elm) : 0;
        var deltaY = inline ? clientRect.top + elm.dom().clientTop + getMarginTop(elm) : 0;
        var x = clientX - deltaX;
        var y = clientY - deltaY;
        return {
          x: x,
          y: y
        };
      };
      var isXYInContentArea = function (editor, clientX, clientY) {
        var bodyElm = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        var targetElm = editor.inline ? bodyElm : $_a43q0i17jh8lywfe.documentElement(bodyElm);
        var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
        return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
      };
      var fromDomSafe = function (node) {
        return Option.from(node).map($_cgttw3zjh8lywdq.fromDom);
      };
      var isEditorAttachedToDom = function (editor) {
        var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
        return fromDomSafe(rawContainer).map(function (container) {
          return $_5f6gpb1djh8lywg5.contains($_a43q0i17jh8lywfe.owner(container), container);
        }).getOr(false);
      };
      var $_7f1iw94jjh8lyx60 = {
        isXYInContentArea: isXYInContentArea,
        isEditorAttachedToDom: isEditorAttachedToDom
      };

      function NotificationManagerImpl () {
        var unimplemented = function () {
          throw new Error('Theme did not provide a NotificationManager implementation.');
        };
        return {
          open: unimplemented,
          close: unimplemented,
          reposition: unimplemented,
          getArgs: unimplemented
        };
      }

      function NotificationManager (editor) {
        var notifications = [];
        var getImplementation = function () {
          var theme = editor.theme;
          return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
        };
        var getTopNotification = function () {
          return Option.from(notifications[0]);
        };
        var isEqual = function (a, b) {
          return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
        };
        var reposition = function () {
          if (notifications.length > 0) {
            getImplementation().reposition(notifications);
          }
        };
        var addNotification = function (notification) {
          notifications.push(notification);
        };
        var closeNotification = function (notification) {
          $_5wjzy24jh8lyw2t.findIndex(notifications, function (otherNotification) {
            return otherNotification === notification;
          }).each(function (index) {
            notifications.splice(index, 1);
          });
        };
        var open = function (args) {
          if (editor.removed || !$_7f1iw94jjh8lyx60.isEditorAttachedToDom(editor)) {
            return;
          }
          return $_5wjzy24jh8lyw2t.find(notifications, function (notification) {
            return isEqual(getImplementation().getArgs(notification), args);
          }).getOrThunk(function () {
            editor.editorManager.setActive(editor);
            var notification = getImplementation().open(args, function () {
              closeNotification(notification);
              reposition();
            });
            addNotification(notification);
            reposition();
            return notification;
          });
        };
        var close = function () {
          getTopNotification().each(function (notification) {
            getImplementation().close(notification);
            closeNotification(notification);
            reposition();
          });
        };
        var getNotifications = function () {
          return notifications;
        };
        var registerEvents = function (editor) {
          editor.on('SkinLoaded', function () {
            var serviceMessage = editor.settings.service_message;
            if (serviceMessage) {
              open({
                text: serviceMessage,
                type: 'warning',
                timeout: 0,
                icon: ''
              });
            }
          });
          editor.on('ResizeEditor ResizeWindow', function () {
            $_8sy3pfhjh8lyw95.requestAnimationFrame(reposition);
          });
          editor.on('remove', function () {
            $_5wjzy24jh8lyw2t.each(notifications, function (notification) {
              getImplementation().close(notification);
            });
          });
        };
        registerEvents(editor);
        return {
          open: open,
          close: close,
          getNotifications: getNotifications
        };
      }

      function WindowManagerImpl () {
        var unimplemented = function () {
          throw new Error('Theme did not provide a WindowManager implementation.');
        };
        return {
          open: unimplemented,
          alert: unimplemented,
          confirm: unimplemented,
          close: unimplemented,
          getParams: unimplemented,
          setParams: unimplemented
        };
      }

      function WindowManager (editor) {
        var windows = [];
        var getImplementation = function () {
          var theme = editor.theme;
          return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
        };
        var funcBind = function (scope, f) {
          return function () {
            return f ? f.apply(scope, arguments) : undefined;
          };
        };
        var fireOpenEvent = function (win) {
          editor.fire('OpenWindow', { win: win });
        };
        var fireCloseEvent = function (win) {
          editor.fire('CloseWindow', { win: win });
        };
        var addWindow = function (win) {
          windows.push(win);
          fireOpenEvent(win);
        };
        var closeWindow = function (win) {
          $_5wjzy24jh8lyw2t.findIndex(windows, function (otherWindow) {
            return otherWindow === win;
          }).each(function (index) {
            windows.splice(index, 1);
            fireCloseEvent(win);
            if (windows.length === 0) {
              editor.focus();
            }
          });
        };
        var getTopWindow = function () {
          return Option.from(windows[windows.length - 1]);
        };
        var open = function (args, params) {
          editor.editorManager.setActive(editor);
          $_eqs11m40jh8lyx31.store(editor);
          var win = getImplementation().open(args, params, closeWindow);
          addWindow(win);
          return win;
        };
        var alert = function (message, callback, scope) {
          var win = getImplementation().alert(message, funcBind(scope ? scope : this, callback), closeWindow);
          addWindow(win);
        };
        var confirm = function (message, callback, scope) {
          var win = getImplementation().confirm(message, funcBind(scope ? scope : this, callback), closeWindow);
          addWindow(win);
        };
        var close = function () {
          getTopWindow().each(function (win) {
            getImplementation().close(win);
            closeWindow(win);
          });
        };
        var getParams = function () {
          return getTopWindow().map(getImplementation().getParams).getOr(null);
        };
        var setParams = function (params) {
          getTopWindow().each(function (win) {
            getImplementation().setParams(win, params);
          });
        };
        var getWindows = function () {
          return windows;
        };
        editor.on('remove', function () {
          $_5wjzy24jh8lyw2t.each(windows.slice(0), function (win) {
            getImplementation().close(win);
          });
        });
        return {
          windows: windows,
          open: open,
          alert: alert,
          confirm: confirm,
          close: close,
          getParams: getParams,
          setParams: setParams,
          getWindows: getWindows
        };
      }

      var PluginManager = AddOnManager.PluginManager;
      var resolvePluginName = function (targetUrl, suffix) {
        for (var name_1 in PluginManager.urls) {
          var matchUrl = PluginManager.urls[name_1] + '/plugin' + suffix + '.js';
          if (matchUrl === targetUrl) {
            return name_1;
          }
        }
        return null;
      };
      var pluginUrlToMessage = function (editor, url) {
        var plugin = resolvePluginName(url, editor.suffix);
        return plugin ? 'Failed to load plugin: ' + plugin + ' from url ' + url : 'Failed to load plugin url: ' + url;
      };
      var displayNotification = function (editor, message) {
        editor.notificationManager.open({
          type: 'error',
          text: message
        });
      };
      var displayError = function (editor, message) {
        if (editor._skinLoaded) {
          displayNotification(editor, message);
        } else {
          editor.on('SkinLoaded', function () {
            displayNotification(editor, message);
          });
        }
      };
      var uploadError = function (editor, message) {
        displayError(editor, 'Failed to upload image: ' + message);
      };
      var pluginLoadError = function (editor, url) {
        displayError(editor, pluginUrlToMessage(editor, url));
      };
      var initError = function (message) {
        var x = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          x[_i - 1] = arguments[_i];
        }
        var console = window.console;
        if (console) {
          if (console.error) {
            console.error.apply(console, arguments);
          } else {
            console.log.apply(console, arguments);
          }
        }
      };
      var $_5vy074njh8lyx6h = {
        pluginLoadError: pluginLoadError,
        uploadError: uploadError,
        displayError: displayError,
        initError: initError
      };

      var PluginManager$1 = AddOnManager.PluginManager;

      var ThemeManager = AddOnManager.ThemeManager;

      function XMLHttpRequest () {
        var f = $_99xmy7cjh8lyw6k.getOrDie('XMLHttpRequest');
        return new f();
      }

      function Uploader (uploadStatus, settings) {
        var pendingPromises = {};
        var pathJoin = function (path1, path2) {
          if (path1) {
            return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
          }
          return path2;
        };
        var defaultHandler = function (blobInfo, success, failure, progress) {
          var xhr, formData;
          xhr = new XMLHttpRequest();
          xhr.open('POST', settings.url);
          xhr.withCredentials = settings.credentials;
          xhr.upload.onprogress = function (e) {
            progress(e.loaded / e.total * 100);
          };
          xhr.onerror = function () {
            failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
          };
          xhr.onload = function () {
            var json;
            if (xhr.status < 200 || xhr.status >= 300) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.location !== 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }
            success(pathJoin(settings.basePath, json.location));
          };
          formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());
          xhr.send(formData);
        };
        var noUpload = function () {
          return new promiseObj(function (resolve) {
            resolve([]);
          });
        };
        var handlerSuccess = function (blobInfo, url) {
          return {
            url: url,
            blobInfo: blobInfo,
            status: true
          };
        };
        var handlerFailure = function (blobInfo, error) {
          return {
            url: '',
            blobInfo: blobInfo,
            status: false,
            error: error
          };
        };
        var resolvePending = function (blobUri, result) {
          $_ahowuxkjh8lywbj.each(pendingPromises[blobUri], function (resolve) {
            resolve(result);
          });
          delete pendingPromises[blobUri];
        };
        var uploadBlobInfo = function (blobInfo, handler, openNotification) {
          uploadStatus.markPending(blobInfo.blobUri());
          return new promiseObj(function (resolve) {
            var notification, progress;
            var noop = function () {
            };
            try {
              var closeNotification_1 = function () {
                if (notification) {
                  notification.close();
                  progress = noop;
                }
              };
              var success = function (url) {
                closeNotification_1();
                uploadStatus.markUploaded(blobInfo.blobUri(), url);
                resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
                resolve(handlerSuccess(blobInfo, url));
              };
              var failure = function (error) {
                closeNotification_1();
                uploadStatus.removeFailed(blobInfo.blobUri());
                resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error));
                resolve(handlerFailure(blobInfo, error));
              };
              progress = function (percent) {
                if (percent < 0 || percent > 100) {
                  return;
                }
                if (!notification) {
                  notification = openNotification();
                }
                notification.progressBar.value(percent);
              };
              handler(blobInfo, success, failure, progress);
            } catch (ex) {
              resolve(handlerFailure(blobInfo, ex.message));
            }
          });
        };
        var isDefaultHandler = function (handler) {
          return handler === defaultHandler;
        };
        var pendingUploadBlobInfo = function (blobInfo) {
          var blobUri = blobInfo.blobUri();
          return new promiseObj(function (resolve) {
            pendingPromises[blobUri] = pendingPromises[blobUri] || [];
            pendingPromises[blobUri].push(resolve);
          });
        };
        var uploadBlobs = function (blobInfos, openNotification) {
          blobInfos = $_ahowuxkjh8lywbj.grep(blobInfos, function (blobInfo) {
            return !uploadStatus.isUploaded(blobInfo.blobUri());
          });
          return promiseObj.all($_ahowuxkjh8lywbj.map(blobInfos, function (blobInfo) {
            return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
          }));
        };
        var upload = function (blobInfos, openNotification) {
          return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
        };
        settings = $_ahowuxkjh8lywbj.extend({
          credentials: false,
          handler: defaultHandler
        }, settings);
        return { upload: upload };
      }

      function Blob (parts, properties) {
        var f = $_99xmy7cjh8lyw6k.getOrDie('Blob');
        return new f(parts, properties);
      }

      function FileReader () {
        var f = $_99xmy7cjh8lyw6k.getOrDie('FileReader');
        return new f();
      }

      function Uint8Array (arr) {
        var f = $_99xmy7cjh8lyw6k.getOrDie('Uint8Array');
        return new f(arr);
      }

      var requestAnimationFrame$1 = function (callback) {
        var f = $_99xmy7cjh8lyw6k.getOrDie('requestAnimationFrame');
        f(callback);
      };
      var atob = function (base64) {
        var f = $_99xmy7cjh8lyw6k.getOrDie('atob');
        return f(base64);
      };
      var $_bfbm2n50jh8lyx88 = {
        atob: atob,
        requestAnimationFrame: requestAnimationFrame$1
      };

      var blobUriToBlob = function (url) {
        return new promiseObj(function (resolve, reject) {
          var rejectWithError = function () {
            reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
          };
          try {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
              if (this.status === 200) {
                resolve(this.response);
              } else {
                rejectWithError();
              }
            };
            xhr.onerror = rejectWithError;
            xhr.send();
          } catch (ex) {
            rejectWithError();
          }
        });
      };
      var parseDataUri = function (uri) {
        var type, matches;
        uri = decodeURIComponent(uri).split(',');
        matches = /data:([^;]+)/.exec(uri[0]);
        if (matches) {
          type = matches[1];
        }
        return {
          type: type,
          data: uri[1]
        };
      };
      var dataUriToBlob = function (uri) {
        return new promiseObj(function (resolve) {
          var str, arr, i;
          uri = parseDataUri(uri);
          try {
            str = $_bfbm2n50jh8lyx88.atob(uri.data);
          } catch (e) {
            resolve(new Blob([]));
            return;
          }
          arr = new Uint8Array(str.length);
          for (i = 0; i < arr.length; i++) {
            arr[i] = str.charCodeAt(i);
          }
          resolve(new Blob([arr], { type: uri.type }));
        });
      };
      var uriToBlob = function (url) {
        if (url.indexOf('blob:') === 0) {
          return blobUriToBlob(url);
        }
        if (url.indexOf('data:') === 0) {
          return dataUriToBlob(url);
        }
        return null;
      };
      var blobToDataUri = function (blob) {
        return new promiseObj(function (resolve) {
          var reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });
      };
      var $_ap7oid4wjh8lyx7y = {
        uriToBlob: uriToBlob,
        blobToDataUri: blobToDataUri,
        parseDataUri: parseDataUri
      };

      var count = 0;
      var uniqueId = function (prefix) {
        return (prefix || 'blobid') + count++;
      };
      var imageToBlobInfo = function (blobCache, img, resolve, reject) {
        var base64, blobInfo;
        if (img.src.indexOf('blob:') === 0) {
          blobInfo = blobCache.getByUri(img.src);
          if (blobInfo) {
            resolve({
              image: img,
              blobInfo: blobInfo
            });
          } else {
            $_ap7oid4wjh8lyx7y.uriToBlob(img.src).then(function (blob) {
              $_ap7oid4wjh8lyx7y.blobToDataUri(blob).then(function (dataUri) {
                base64 = $_ap7oid4wjh8lyx7y.parseDataUri(dataUri).data;
                blobInfo = blobCache.create(uniqueId(), blob, base64);
                blobCache.add(blobInfo);
                resolve({
                  image: img,
                  blobInfo: blobInfo
                });
              });
            }, function (err) {
              reject(err);
            });
          }
          return;
        }
        base64 = $_ap7oid4wjh8lyx7y.parseDataUri(img.src).data;
        blobInfo = blobCache.findFirst(function (cachedBlobInfo) {
          return cachedBlobInfo.base64() === base64;
        });
        if (blobInfo) {
          resolve({
            image: img,
            blobInfo: blobInfo
          });
        } else {
          $_ap7oid4wjh8lyx7y.uriToBlob(img.src).then(function (blob) {
            blobInfo = blobCache.create(uniqueId(), blob, base64);
            blobCache.add(blobInfo);
            resolve({
              image: img,
              blobInfo: blobInfo
            });
          }, function (err) {
            reject(err);
          });
        }
      };
      var getAllImages = function (elm) {
        return elm ? elm.getElementsByTagName('img') : [];
      };
      function ImageScanner (uploadStatus, blobCache) {
        var cachedPromises = {};
        var findAll = function (elm, predicate) {
          var images;
          if (!predicate) {
            predicate = $_8aqzj925jh8lywmj.constant(true);
          }
          images = $_9tjm51ljh8lywbq.filter(getAllImages(elm), function (img) {
            var src = img.src;
            if (!$_9bpim8ajh8lyw68.fileApi) {
              return false;
            }
            if (img.hasAttribute('data-mce-bogus')) {
              return false;
            }
            if (img.hasAttribute('data-mce-placeholder')) {
              return false;
            }
            if (!src || src === $_9bpim8ajh8lyw68.transparentSrc) {
              return false;
            }
            if (src.indexOf('blob:') === 0) {
              return !uploadStatus.isUploaded(src);
            }
            if (src.indexOf('data:') === 0) {
              return predicate(img);
            }
            return false;
          });
          var promises = $_9tjm51ljh8lywbq.map(images, function (img) {
            if (cachedPromises[img.src]) {
              return new promiseObj(function (resolve) {
                cachedPromises[img.src].then(function (imageInfo) {
                  if (typeof imageInfo === 'string') {
                    return imageInfo;
                  }
                  resolve({
                    image: img,
                    blobInfo: imageInfo.blobInfo
                  });
                });
              });
            }
            var newPromise = new promiseObj(function (resolve, reject) {
              imageToBlobInfo(blobCache, img, resolve, reject);
            }).then(function (result) {
              delete cachedPromises[result.image.src];
              return result;
            }).catch(function (error) {
              delete cachedPromises[img.src];
              return error;
            });
            cachedPromises[img.src] = newPromise;
            return newPromise;
          });
          return promiseObj.all(promises);
        };
        return { findAll: findAll };
      }

      var count$1 = 0;
      var seed = function () {
        var rnd = function () {
          return Math.round(Math.random() * 4294967295).toString(36);
        };
        var now = new Date().getTime();
        return 's' + now.toString(36) + rnd() + rnd() + rnd();
      };
      var uuid = function (prefix) {
        return prefix + count$1++ + seed();
      };
      var $_co2y7g52jh8lyx8f = { uuid: uuid };

      function BlobCache () {
        var cache = [];
        var constant = $_8aqzj925jh8lywmj.constant;
        var mimeToExt = function (mime) {
          var mimes = {
            'image/jpeg': 'jpg',
            'image/jpg': 'jpg',
            'image/gif': 'gif',
            'image/png': 'png'
          };
          return mimes[mime.toLowerCase()] || 'dat';
        };
        var create = function (o, blob, base64, filename) {
          return typeof o === 'object' ? toBlobInfo(o) : toBlobInfo({
            id: o,
            name: filename,
            blob: blob,
            base64: base64
          });
        };
        var toBlobInfo = function (o) {
          var id, name;
          if (!o.blob || !o.base64) {
            throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
          }
          id = o.id || $_co2y7g52jh8lyx8f.uuid('blobid');
          name = o.name || id;
          return {
            id: constant(id),
            name: constant(name),
            filename: constant(name + '.' + mimeToExt(o.blob.type)),
            blob: constant(o.blob),
            base64: constant(o.base64),
            blobUri: constant(o.blobUri || $_ge0pt0bjh8lyw6g.createObjectURL(o.blob)),
            uri: constant(o.uri)
          };
        };
        var add = function (blobInfo) {
          if (!get(blobInfo.id())) {
            cache.push(blobInfo);
          }
        };
        var get = function (id) {
          return findFirst(function (cachedBlobInfo) {
            return cachedBlobInfo.id() === id;
          });
        };
        var findFirst = function (predicate) {
          return $_9tjm51ljh8lywbq.filter(cache, predicate)[0];
        };
        var getByUri = function (blobUri) {
          return findFirst(function (blobInfo) {
            return blobInfo.blobUri() === blobUri;
          });
        };
        var removeByUri = function (blobUri) {
          cache = $_9tjm51ljh8lywbq.filter(cache, function (blobInfo) {
            if (blobInfo.blobUri() === blobUri) {
              $_ge0pt0bjh8lyw6g.revokeObjectURL(blobInfo.blobUri());
              return false;
            }
            return true;
          });
        };
        var destroy = function () {
          $_9tjm51ljh8lywbq.each(cache, function (cachedBlobInfo) {
            $_ge0pt0bjh8lyw6g.revokeObjectURL(cachedBlobInfo.blobUri());
          });
          cache = [];
        };
        return {
          create: create,
          add: add,
          get: get,
          getByUri: getByUri,
          findFirst: findFirst,
          removeByUri: removeByUri,
          destroy: destroy
        };
      }

      function UploadStatus () {
        var PENDING = 1, UPLOADED = 2;
        var blobUriStatuses = {};
        var createStatus = function (status, resultUri) {
          return {
            status: status,
            resultUri: resultUri
          };
        };
        var hasBlobUri = function (blobUri) {
          return blobUri in blobUriStatuses;
        };
        var getResultUri = function (blobUri) {
          var result = blobUriStatuses[blobUri];
          return result ? result.resultUri : null;
        };
        var isPending = function (blobUri) {
          return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
        };
        var isUploaded = function (blobUri) {
          return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
        };
        var markPending = function (blobUri) {
          blobUriStatuses[blobUri] = createStatus(PENDING, null);
        };
        var markUploaded = function (blobUri, resultUri) {
          blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
        };
        var removeFailed = function (blobUri) {
          delete blobUriStatuses[blobUri];
        };
        var destroy = function () {
          blobUriStatuses = {};
        };
        return {
          hasBlobUri: hasBlobUri,
          getResultUri: getResultUri,
          isPending: isPending,
          isUploaded: isUploaded,
          markPending: markPending,
          markUploaded: markUploaded,
          removeFailed: removeFailed,
          destroy: destroy
        };
      }

      function EditorUpload (editor) {
        var blobCache = BlobCache();
        var uploader, imageScanner;
        var settings = editor.settings;
        var uploadStatus = UploadStatus();
        var aliveGuard = function (callback) {
          return function (result) {
            if (editor.selection) {
              return callback(result);
            }
            return [];
          };
        };
        var cacheInvalidator = function () {
          return '?' + new Date().getTime();
        };
        var replaceString = function (content, search, replace) {
          var index = 0;
          do {
            index = content.indexOf(search, index);
            if (index !== -1) {
              content = content.substring(0, index) + replace + content.substr(index + search.length);
              index += replace.length - search.length + 1;
            }
          } while (index !== -1);
          return content;
        };
        var replaceImageUrl = function (content, targetUrl, replacementUrl) {
          content = replaceString(content, 'src="' + targetUrl + '"', 'src="' + replacementUrl + '"');
          content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
          return content;
        };
        var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
          $_9tjm51ljh8lywbq.each(editor.undoManager.data, function (level) {
            if (level.type === 'fragmented') {
              level.fragments = $_9tjm51ljh8lywbq.map(level.fragments, function (fragment) {
                return replaceImageUrl(fragment, targetUrl, replacementUrl);
              });
            } else {
              level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
            }
          });
        };
        var openNotification = function () {
          return editor.notificationManager.open({
            text: editor.translate('Image uploading...'),
            type: 'info',
            timeout: -1,
            progressBar: true
          });
        };
        var replaceImageUri = function (image, resultUri) {
          blobCache.removeByUri(image.src);
          replaceUrlInUndoStack(image.src, resultUri);
          editor.$(image).attr({
            'src': settings.images_reuse_filename ? resultUri + cacheInvalidator() : resultUri,
            'data-mce-src': editor.convertURL(resultUri, 'src')
          });
        };
        var uploadImages = function (callback) {
          if (!uploader) {
            uploader = Uploader(uploadStatus, {
              url: settings.images_upload_url,
              basePath: settings.images_upload_base_path,
              credentials: settings.images_upload_credentials,
              handler: settings.images_upload_handler
            });
          }
          return scanForImages().then(aliveGuard(function (imageInfos) {
            var blobInfos;
            blobInfos = $_9tjm51ljh8lywbq.map(imageInfos, function (imageInfo) {
              return imageInfo.blobInfo;
            });
            return uploader.upload(blobInfos, openNotification).then(aliveGuard(function (result) {
              var filteredResult = $_9tjm51ljh8lywbq.map(result, function (uploadInfo, index) {
                var image = imageInfos[index].image;
                if (uploadInfo.status && editor.settings.images_replace_blob_uris !== false) {
                  replaceImageUri(image, uploadInfo.url);
                } else if (uploadInfo.error) {
                  $_5vy074njh8lyx6h.uploadError(editor, uploadInfo.error);
                }
                return {
                  element: image,
                  status: uploadInfo.status
                };
              });
              if (callback) {
                callback(filteredResult);
              }
              return filteredResult;
            }));
          }));
        };
        var uploadImagesAuto = function (callback) {
          if (settings.automatic_uploads !== false) {
            return uploadImages(callback);
          }
        };
        var isValidDataUriImage = function (imgElm) {
          return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
        };
        var scanForImages = function () {
          if (!imageScanner) {
            imageScanner = ImageScanner(uploadStatus, blobCache);
          }
          return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
            result = $_9tjm51ljh8lywbq.filter(result, function (resultItem) {
              if (typeof resultItem === 'string') {
                $_5vy074njh8lyx6h.displayError(editor, resultItem);
                return false;
              }
              return true;
            });
            $_9tjm51ljh8lywbq.each(result, function (resultItem) {
              replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
              resultItem.image.src = resultItem.blobInfo.blobUri();
              resultItem.image.removeAttribute('data-mce-src');
            });
            return result;
          }));
        };
        var destroy = function () {
          blobCache.destroy();
          uploadStatus.destroy();
          imageScanner = uploader = null;
        };
        var replaceBlobUris = function (content) {
          return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
            var resultUri = uploadStatus.getResultUri(blobUri);
            if (resultUri) {
              return 'src="' + resultUri + '"';
            }
            var blobInfo = blobCache.getByUri(blobUri);
            if (!blobInfo) {
              blobInfo = $_9tjm51ljh8lywbq.reduce(editor.editorManager.get(), function (result, editor) {
                return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
              }, null);
            }
            if (blobInfo) {
              return 'src="data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64() + '"';
            }
            return match;
          });
        };
        editor.on('setContent', function () {
          if (editor.settings.automatic_uploads !== false) {
            uploadImagesAuto();
          } else {
            scanForImages();
          }
        });
        editor.on('RawSaveContent', function (e) {
          e.content = replaceBlobUris(e.content);
        });
        editor.on('getContent', function (e) {
          if (e.source_view || e.format === 'raw') {
            return;
          }
          e.content = replaceBlobUris(e.content);
        });
        editor.on('PostRender', function () {
          editor.parser.addNodeFilter('img', function (images) {
            $_9tjm51ljh8lywbq.each(images, function (img) {
              var src = img.attr('src');
              if (blobCache.getByUri(src)) {
                return;
              }
              var resultUri = uploadStatus.getResultUri(src);
              if (resultUri) {
                img.attr('src', resultUri);
              }
            });
          });
        });
        return {
          blobCache: blobCache,
          uploadImages: uploadImages,
          uploadImagesAuto: uploadImagesAuto,
          scanForImages: scanForImages,
          destroy: destroy
        };
      }

      var isBlockElement = function (blockElements, node) {
        return blockElements.hasOwnProperty(node.nodeName);
      };
      var isValidTarget = function (blockElements, node) {
        if ($_5oonaz1qjh8lywhz.isText(node)) {
          return true;
        } else if ($_5oonaz1qjh8lywhz.isElement(node)) {
          return !isBlockElement(blockElements, node) && !$_eyp5ec2njh8lywpo.isBookmarkNode(node);
        } else {
          return false;
        }
      };
      var hasBlockParent = function (blockElements, root, node) {
        return $_5wjzy24jh8lyw2t.exists($_dyxtub3ejh8lywxq.parents($_cgttw3zjh8lywdq.fromDom(node), $_cgttw3zjh8lywdq.fromDom(root)), function (elm) {
          return isBlockElement(blockElements, elm.dom());
        });
      };
      var shouldRemoveTextNode = function (blockElements, node) {
        if ($_5oonaz1qjh8lywhz.isText(node)) {
          if (node.nodeValue.length === 0) {
            return true;
          } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
            return true;
          }
        }
        return false;
      };
      var addRootBlocks = function (editor) {
        var settings = editor.settings, dom = editor.dom, selection = editor.selection;
        var schema = editor.schema, blockElements = schema.getBlockElements();
        var node = selection.getStart();
        var rootNode = editor.getBody();
        var rng;
        var startContainer, startOffset, endContainer, endOffset, rootBlockNode;
        var tempNode, wrapped, restoreSelection;
        var rootNodeName, forcedRootBlock;
        forcedRootBlock = settings.forced_root_block;
        if (!node || !$_5oonaz1qjh8lywhz.isElement(node) || !forcedRootBlock) {
          return;
        }
        rootNodeName = rootNode.nodeName.toLowerCase();
        if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
          return;
        }
        rng = selection.getRng();
        startContainer = rng.startContainer;
        startOffset = rng.startOffset;
        endContainer = rng.endContainer;
        endOffset = rng.endOffset;
        restoreSelection = $_cnu79r4ejh8lyx4x.hasFocus(editor);
        node = rootNode.firstChild;
        while (node) {
          if (isValidTarget(blockElements, node)) {
            if (shouldRemoveTextNode(blockElements, node)) {
              tempNode = node;
              node = node.nextSibling;
              dom.remove(tempNode);
              continue;
            }
            if (!rootBlockNode) {
              rootBlockNode = dom.create(forcedRootBlock, editor.settings.forced_root_block_attrs);
              node.parentNode.insertBefore(rootBlockNode, node);
              wrapped = true;
            }
            tempNode = node;
            node = node.nextSibling;
            rootBlockNode.appendChild(tempNode);
          } else {
            rootBlockNode = null;
            node = node.nextSibling;
          }
        }
        if (wrapped && restoreSelection) {
          rng.setStart(startContainer, startOffset);
          rng.setEnd(endContainer, endOffset);
          selection.setRng(rng);
          editor.nodeChanged();
        }
      };
      var setup = function (editor) {
        if (editor.settings.forced_root_block) {
          editor.on('NodeChange', $_eqpqvr6jh8lyw3s.curry(addRootBlocks, editor));
        }
      };
      var $_85z7kh54jh8lyx8j = { setup: setup };

      var getStartNode = function (rng) {
        var sc = rng.startContainer, so = rng.startOffset;
        if ($_5oonaz1qjh8lywhz.isText(sc)) {
          return so === 0 ? Option.some($_cgttw3zjh8lywdq.fromDom(sc)) : Option.none();
        } else {
          return Option.from(sc.childNodes[so]).map($_cgttw3zjh8lywdq.fromDom);
        }
      };
      var getEndNode = function (rng) {
        var ec = rng.endContainer, eo = rng.endOffset;
        if ($_5oonaz1qjh8lywhz.isText(ec)) {
          return eo === ec.data.length ? Option.some($_cgttw3zjh8lywdq.fromDom(ec)) : Option.none();
        } else {
          return Option.from(ec.childNodes[eo - 1]).map($_cgttw3zjh8lywdq.fromDom);
        }
      };
      var getFirstChildren = function (node) {
        return $_a43q0i17jh8lywfe.firstChild(node).fold($_eqpqvr6jh8lyw3s.constant([node]), function (child) {
          return [node].concat(getFirstChildren(child));
        });
      };
      var getLastChildren$1 = function (node) {
        return $_a43q0i17jh8lywfe.lastChild(node).fold($_eqpqvr6jh8lyw3s.constant([node]), function (child) {
          if ($_7j1jt210jh8lywdx.name(child) === 'br') {
            return $_a43q0i17jh8lywfe.prevSibling(child).map(function (sibling) {
              return [node].concat(getLastChildren$1(sibling));
            }).getOr([]);
          } else {
            return [node].concat(getLastChildren$1(child));
          }
        });
      };
      var hasAllContentsSelected = function (elm, rng) {
        return $_b8twwq26jh8lywmm.liftN([
          getStartNode(rng),
          getEndNode(rng)
        ], function (startNode, endNode) {
          var start = $_5wjzy24jh8lyw2t.find(getFirstChildren(elm), $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, startNode));
          var end = $_5wjzy24jh8lyw2t.find(getLastChildren$1(elm), $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, endNode));
          return start.isSome() && end.isSome();
        }).getOr(false);
      };
      var moveEndPoint$1 = function (dom, rng, node, start) {
        var root = node, walker = new TreeWalker(node, root);
        var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
        do {
          if (node.nodeType === 3 && $_ahowuxkjh8lywbj.trim(node.nodeValue).length !== 0) {
            if (start) {
              rng.setStart(node, 0);
            } else {
              rng.setEnd(node, node.nodeValue.length);
            }
            return;
          }
          if (nonEmptyElementsMap[node.nodeName] && !/^(TD|TH)$/.test(node.nodeName)) {
            if (start) {
              rng.setStartBefore(node);
            } else {
              if (node.nodeName === 'BR') {
                rng.setEndBefore(node);
              } else {
                rng.setEndAfter(node);
              }
            }
            return;
          }
          if ($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 11 && dom.isBlock(node) && dom.isEmpty(node)) {
            if (start) {
              rng.setStart(node, 0);
            } else {
              rng.setEnd(node, 0);
            }
            return;
          }
        } while (node = start ? walker.next() : walker.prev());
        if (root.nodeName === 'BODY') {
          if (start) {
            rng.setStart(root, 0);
          } else {
            rng.setEnd(root, root.childNodes.length);
          }
        }
      };
      var hasAnyRanges = function (editor) {
        var sel = editor.selection.getSel();
        return sel && sel.rangeCount > 0;
      };

      function NodeChange (editor) {
        var lastRng, lastPath = [];
        var isSameElementPath = function (startElm) {
          var i, currentPath;
          currentPath = editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);
          if (currentPath.length === lastPath.length) {
            for (i = currentPath.length; i >= 0; i--) {
              if (currentPath[i] !== lastPath[i]) {
                break;
              }
            }
            if (i === -1) {
              lastPath = currentPath;
              return true;
            }
          }
          lastPath = currentPath;
          return false;
        };
        if (!('onselectionchange' in editor.getDoc())) {
          editor.on('NodeChange Click MouseUp KeyUp Focus', function (e) {
            var nativeRng, fakeRng;
            nativeRng = editor.selection.getRng();
            fakeRng = {
              startContainer: nativeRng.startContainer,
              startOffset: nativeRng.startOffset,
              endContainer: nativeRng.endContainer,
              endOffset: nativeRng.endOffset
            };
            if (e.type === 'nodechange' || !$_aayq8q3zjh8lyx2z.isEq(fakeRng, lastRng)) {
              editor.fire('SelectionChange');
            }
            lastRng = fakeRng;
          });
        }
        editor.on('contextmenu', function () {
          editor.fire('SelectionChange');
        });
        editor.on('SelectionChange', function () {
          var startElm = editor.selection.getStart(true);
          if (!startElm || !$_9bpim8ajh8lyw68.range && editor.selection.isCollapsed()) {
            return;
          }
          if (hasAnyRanges(editor) && !isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
            editor.nodeChanged({ selectionChange: true });
          }
        });
        editor.on('MouseUp', function (e) {
          if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
            if (editor.selection.getNode().nodeName === 'IMG') {
              $_8sy3pfhjh8lyw95.setEditorTimeout(editor, function () {
                editor.nodeChanged();
              });
            } else {
              editor.nodeChanged();
            }
          }
        });
        this.nodeChanged = function (args) {
          var selection = editor.selection;
          var node, parents, root;
          if (editor.initialized && selection && !editor.settings.disable_nodechange && !editor.readonly) {
            root = editor.getBody();
            node = selection.getStart(true) || root;
            if (node.ownerDocument !== editor.getDoc() || !editor.dom.isChildOf(node, root)) {
              node = root;
            }
            parents = [];
            editor.dom.getParent(node, function (node) {
              if (node === root) {
                return true;
              }
              parents.push(node);
            });
            args = args || {};
            args.element = node;
            args.parents = parents;
            editor.fire('NodeChange', args);
          }
        };
      }

      var getAbsolutePosition = function (elm) {
        var doc, docElem, win, clientRect;
        clientRect = elm.getBoundingClientRect();
        doc = elm.ownerDocument;
        docElem = doc.documentElement;
        win = doc.defaultView;
        return {
          top: clientRect.top + win.pageYOffset - docElem.clientTop,
          left: clientRect.left + win.pageXOffset - docElem.clientLeft
        };
      };
      var getBodyPosition = function (editor) {
        return editor.inline ? getAbsolutePosition(editor.getBody()) : {
          left: 0,
          top: 0
        };
      };
      var getScrollPosition = function (editor) {
        var body = editor.getBody();
        return editor.inline ? {
          left: body.scrollLeft,
          top: body.scrollTop
        } : {
          left: 0,
          top: 0
        };
      };
      var getBodyScroll = function (editor) {
        var body = editor.getBody(), docElm = editor.getDoc().documentElement;
        var inlineScroll = {
          left: body.scrollLeft,
          top: body.scrollTop
        };
        var iframeScroll = {
          left: body.scrollLeft || docElm.scrollLeft,
          top: body.scrollTop || docElm.scrollTop
        };
        return editor.inline ? inlineScroll : iframeScroll;
      };
      var getMousePosition = function (editor, event) {
        if (event.target.ownerDocument !== editor.getDoc()) {
          var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
          var scrollPosition = getBodyScroll(editor);
          return {
            left: event.pageX - iframePosition.left + scrollPosition.left,
            top: event.pageY - iframePosition.top + scrollPosition.top
          };
        }
        return {
          left: event.pageX,
          top: event.pageY
        };
      };
      var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
        return {
          pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
          pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
        };
      };
      var calc = function (editor, event) {
        return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
      };
      var $_car16w59jh8lyxa8 = { calc: calc };

      var isContentEditableFalse$7 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isContentEditableTrue$4 = $_5oonaz1qjh8lywhz.isContentEditableTrue;
      var isDraggable = function (rootElm, elm) {
        return isContentEditableFalse$7(elm) && elm !== rootElm;
      };
      var isValidDropTarget = function (editor, targetElement, dragElement) {
        if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
          return false;
        }
        if (isContentEditableFalse$7(targetElement)) {
          return false;
        }
        return true;
      };
      var cloneElement = function (elm) {
        var cloneElm = elm.cloneNode(true);
        cloneElm.removeAttribute('data-mce-selected');
        return cloneElm;
      };
      var createGhost = function (editor, elm, width, height) {
        var clonedElm = elm.cloneNode(true);
        editor.dom.setStyles(clonedElm, {
          width: width,
          height: height
        });
        editor.dom.setAttrib(clonedElm, 'data-mce-selected', null);
        var ghostElm = editor.dom.create('div', {
          'class': 'mce-drag-container',
          'data-mce-bogus': 'all',
          'unselectable': 'on',
          'contenteditable': 'false'
        });
        editor.dom.setStyles(ghostElm, {
          position: 'absolute',
          opacity: 0.5,
          overflow: 'hidden',
          border: 0,
          padding: 0,
          margin: 0,
          width: width,
          height: height
        });
        editor.dom.setStyles(clonedElm, {
          margin: 0,
          boxSizing: 'border-box'
        });
        ghostElm.appendChild(clonedElm);
        return ghostElm;
      };
      var appendGhostToBody = function (ghostElm, bodyElm) {
        if (ghostElm.parentNode !== bodyElm) {
          bodyElm.appendChild(ghostElm);
        }
      };
      var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
        var overflowX = 0, overflowY = 0;
        ghostElm.style.left = position.pageX + 'px';
        ghostElm.style.top = position.pageY + 'px';
        if (position.pageX + width > maxX) {
          overflowX = position.pageX + width - maxX;
        }
        if (position.pageY + height > maxY) {
          overflowY = position.pageY + height - maxY;
        }
        ghostElm.style.width = width - overflowX + 'px';
        ghostElm.style.height = height - overflowY + 'px';
      };
      var removeElement = function (elm) {
        if (elm && elm.parentNode) {
          elm.parentNode.removeChild(elm);
        }
      };
      var isLeftMouseButtonPressed = function (e) {
        return e.button === 0;
      };
      var hasDraggableElement = function (state) {
        return state.element;
      };
      var applyRelPos = function (state, position) {
        return {
          pageX: position.pageX - state.relX,
          pageY: position.pageY + 5
        };
      };
      var start$1 = function (state, editor) {
        return function (e) {
          if (isLeftMouseButtonPressed(e)) {
            var ceElm = $_9tjm51ljh8lywbq.find(editor.dom.getParents(e.target), $_8aqzj925jh8lywmj.or(isContentEditableFalse$7, isContentEditableTrue$4));
            if (isDraggable(editor.getBody(), ceElm)) {
              var elmPos = editor.dom.getPos(ceElm);
              var bodyElm = editor.getBody();
              var docElm = editor.getDoc().documentElement;
              state.element = ceElm;
              state.screenX = e.screenX;
              state.screenY = e.screenY;
              state.maxX = (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2;
              state.maxY = (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2;
              state.relX = e.pageX - elmPos.x;
              state.relY = e.pageY - elmPos.y;
              state.width = ceElm.offsetWidth;
              state.height = ceElm.offsetHeight;
              state.ghost = createGhost(editor, ceElm, state.width, state.height);
            }
          }
        };
      };
      var move$1 = function (state, editor) {
        var throttledPlaceCaretAt = $_8sy3pfhjh8lyw95.throttle(function (clientX, clientY) {
          editor._selectionOverrides.hideFakeCaret();
          editor.selection.placeCaretAt(clientX, clientY);
        }, 0);
        return function (e) {
          var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
          if (hasDraggableElement(state) && !state.dragging && movement > 10) {
            var args = editor.fire('dragstart', { target: state.element });
            if (args.isDefaultPrevented()) {
              return;
            }
            state.dragging = true;
            editor.focus();
          }
          if (state.dragging) {
            var targetPos = applyRelPos(state, $_car16w59jh8lyxa8.calc(editor, e));
            appendGhostToBody(state.ghost, editor.getBody());
            moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
            throttledPlaceCaretAt(e.clientX, e.clientY);
          }
        };
      };
      var getRawTarget = function (selection) {
        var rng = selection.getSel().getRangeAt(0);
        var startContainer = rng.startContainer;
        return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
      };
      var drop = function (state, editor) {
        return function (e) {
          if (state.dragging) {
            if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
              var targetClone_1 = cloneElement(state.element);
              var args = editor.fire('drop', {
                targetClone: targetClone_1,
                clientX: e.clientX,
                clientY: e.clientY
              });
              if (!args.isDefaultPrevented()) {
                targetClone_1 = args.targetClone;
                editor.undoManager.transact(function () {
                  removeElement(state.element);
                  editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
                  editor._selectionOverrides.hideFakeCaret();
                });
              }
            }
          }
          removeDragState(state);
        };
      };
      var stop = function (state, editor) {
        return function () {
          if (state.dragging) {
            editor.fire('dragend');
          }
          removeDragState(state);
        };
      };
      var removeDragState = function (state) {
        state.dragging = false;
        state.element = null;
        removeElement(state.ghost);
      };
      var bindFakeDragEvents = function (editor) {
        var state = {};
        var pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
        pageDom = DOMUtils$1.DOM;
        rootDocument = document;
        dragStartHandler = start$1(state, editor);
        dragHandler = move$1(state, editor);
        dropHandler = drop(state, editor);
        dragEndHandler = stop(state, editor);
        editor.on('mousedown', dragStartHandler);
        editor.on('mousemove', dragHandler);
        editor.on('mouseup', dropHandler);
        pageDom.bind(rootDocument, 'mousemove', dragHandler);
        pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
        editor.on('remove', function () {
          pageDom.unbind(rootDocument, 'mousemove', dragHandler);
          pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
        });
      };
      var blockIeDrop = function (editor) {
        editor.on('drop', function (e) {
          var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
          if (isContentEditableFalse$7(realTarget) || isContentEditableFalse$7(editor.dom.getContentEditableParent(realTarget))) {
            e.preventDefault();
          }
        });
      };
      var init = function (editor) {
        bindFakeDragEvents(editor);
        blockIeDrop(editor);
      };
      var $_8bbr0a58jh8lyxa1 = { init: init };

      var getNodeClientRects = function (node) {
        var toArrayWithNode = function (clientRects) {
          return $_9tjm51ljh8lywbq.map(clientRects, function (clientRect) {
            clientRect = clone$1(clientRect);
            clientRect.node = node;
            return clientRect;
          });
        };
        if ($_5oonaz1qjh8lywhz.isElement(node)) {
          return toArrayWithNode(node.getClientRects());
        }
        if ($_5oonaz1qjh8lywhz.isText(node)) {
          var rng = node.ownerDocument.createRange();
          rng.setStart(node, 0);
          rng.setEnd(node, node.data.length);
          return toArrayWithNode(rng.getClientRects());
        }
      };
      var getClientRects = function (node) {
        return $_9tjm51ljh8lywbq.reduce(node, function (result, node) {
          return result.concat(getNodeClientRects(node));
        }, []);
      };

      var VDirection;
      (function (VDirection) {
        VDirection[VDirection['Up'] = -1] = 'Up';
        VDirection[VDirection['Down'] = 1] = 'Down';
      }(VDirection || (VDirection = {})));
      var findUntil = function (direction, root, predicateFn, node) {
        while (node = findNode(node, direction, isEditableCaretCandidate, root)) {
          if (predicateFn(node)) {
            return;
          }
        }
      };
      var walkUntil = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
        var line = 0, node;
        var result = [];
        var targetClientRect;
        var add = function (node) {
          var i, clientRect, clientRects;
          clientRects = getClientRects([node]);
          if (direction === -1) {
            clientRects = clientRects.reverse();
          }
          for (i = 0; i < clientRects.length; i++) {
            clientRect = clientRects[i];
            if (isBeflowFn(clientRect, targetClientRect)) {
              continue;
            }
            if (result.length > 0 && isAboveFn(clientRect, $_9tjm51ljh8lywbq.last(result))) {
              line++;
            }
            clientRect.line = line;
            if (predicateFn(clientRect)) {
              return true;
            }
            result.push(clientRect);
          }
        };
        targetClientRect = $_9tjm51ljh8lywbq.last(caretPosition.getClientRects());
        if (!targetClientRect) {
          return result;
        }
        node = caretPosition.getNode();
        add(node);
        findUntil(direction, root, add, node);
        return result;
      };
      var aboveLineNumber = function (lineNumber, clientRect) {
        return clientRect.line > lineNumber;
      };
      var isLineNumber = function (lineNumber, clientRect) {
        return clientRect.line === lineNumber;
      };
      var upUntil = $_eqpqvr6jh8lyw3s.curry(walkUntil, VDirection.Up, isAbove, isBelow);
      var downUntil = $_eqpqvr6jh8lyw3s.curry(walkUntil, VDirection.Down, isBelow, isAbove);
      var positionsUntil = function (direction, root, predicateFn, node) {
        var caretWalker = CaretWalker(root);
        var walkFn, isBelowFn, isAboveFn, caretPosition;
        var result = [];
        var line = 0, clientRect, targetClientRect;
        var getClientRect = function (caretPosition) {
          if (direction === 1) {
            return $_9tjm51ljh8lywbq.last(caretPosition.getClientRects());
          }
          return $_9tjm51ljh8lywbq.last(caretPosition.getClientRects());
        };
        if (direction === 1) {
          walkFn = caretWalker.next;
          isBelowFn = isBelow;
          isAboveFn = isAbove;
          caretPosition = CaretPosition$1.after(node);
        } else {
          walkFn = caretWalker.prev;
          isBelowFn = isAbove;
          isAboveFn = isBelow;
          caretPosition = CaretPosition$1.before(node);
        }
        targetClientRect = getClientRect(caretPosition);
        do {
          if (!caretPosition.isVisible()) {
            continue;
          }
          clientRect = getClientRect(caretPosition);
          if (isAboveFn(clientRect, targetClientRect)) {
            continue;
          }
          if (result.length > 0 && isBelowFn(clientRect, $_9tjm51ljh8lywbq.last(result))) {
            line++;
          }
          clientRect = clone$1(clientRect);
          clientRect.position = caretPosition;
          clientRect.line = line;
          if (predicateFn(clientRect)) {
            return result;
          }
          result.push(clientRect);
        } while (caretPosition = walkFn(caretPosition));
        return result;
      };
      var isAboveLine = function (lineNumber) {
        return function (clientRect) {
          return aboveLineNumber(lineNumber, clientRect);
        };
      };
      var isLine = function (lineNumber) {
        return function (clientRect) {
          return isLineNumber(lineNumber, clientRect);
        };
      };

      var isContentEditableFalse$8 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var findNode$1 = findNode;
      var distanceToRectLeft = function (clientRect, clientX) {
        return Math.abs(clientRect.left - clientX);
      };
      var distanceToRectRight = function (clientRect, clientX) {
        return Math.abs(clientRect.right - clientX);
      };
      var isInside = function (clientX, clientRect) {
        return clientX >= clientRect.left && clientX <= clientRect.right;
      };
      var findClosestClientRect = function (clientRects, clientX) {
        return $_9tjm51ljh8lywbq.reduce(clientRects, function (oldClientRect, clientRect) {
          var oldDistance, newDistance;
          oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
          newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
          if (isInside(clientX, clientRect)) {
            return clientRect;
          }
          if (isInside(clientX, oldClientRect)) {
            return oldClientRect;
          }
          if (newDistance === oldDistance && isContentEditableFalse$8(clientRect.node)) {
            return clientRect;
          }
          if (newDistance < oldDistance) {
            return clientRect;
          }
          return oldClientRect;
        });
      };
      var walkUntil$1 = function (direction, root, predicateFn, node) {
        while (node = findNode$1(node, direction, isEditableCaretCandidate, root)) {
          if (predicateFn(node)) {
            return;
          }
        }
      };
      var findLineNodeRects = function (root, targetNodeRect) {
        var clientRects = [];
        var collect = function (checkPosFn, node) {
          var lineRects;
          lineRects = $_9tjm51ljh8lywbq.filter(getClientRects([node]), function (clientRect) {
            return !checkPosFn(clientRect, targetNodeRect);
          });
          clientRects = clientRects.concat(lineRects);
          return lineRects.length === 0;
        };
        clientRects.push(targetNodeRect);
        walkUntil$1(VDirection.Up, root, $_eqpqvr6jh8lyw3s.curry(collect, isAbove), targetNodeRect.node);
        walkUntil$1(VDirection.Down, root, $_eqpqvr6jh8lyw3s.curry(collect, isBelow), targetNodeRect.node);
        return clientRects;
      };
      var getFakeCaretTargets = function (root) {
        return $_9tjm51ljh8lywbq.filter($_9tjm51ljh8lywbq.toArray(root.getElementsByTagName('*')), isFakeCaretTarget);
      };
      var caretInfo = function (clientRect, clientX) {
        return {
          node: clientRect.node,
          before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
        };
      };
      var closestCaret = function (root, clientX, clientY) {
        var closestNodeRect;
        var contentEditableFalseNodeRects = getClientRects(getFakeCaretTargets(root));
        var targetNodeRects = $_9tjm51ljh8lywbq.filter(contentEditableFalseNodeRects, function (rect) {
          return clientY >= rect.top && clientY <= rect.bottom;
        });
        closestNodeRect = findClosestClientRect(targetNodeRects, clientX);
        if (closestNodeRect) {
          closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect), clientX);
          if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
            return caretInfo(closestNodeRect, clientX);
          }
        }
        return null;
      };

      var isXYWithinRange = function (clientX, clientY, range) {
        if (range.collapsed) {
          return false;
        }
        return $_5wjzy24jh8lyw2t.foldl(range.getClientRects(), function (state, rect) {
          return state || containsXY(rect, clientX, clientY);
        }, false);
      };
      var $_3kj84i5djh8lyxan = { isXYWithinRange: isXYWithinRange };

      var adaptable = function (fn, rate) {
        var timer = null;
        var args = null;
        var cancel = function () {
          if (timer !== null) {
            clearTimeout(timer);
            timer = null;
            args = null;
          }
        };
        var throttle = function () {
          args = arguments;
          if (timer === null) {
            timer = setTimeout(function () {
              fn.apply(null, args);
              timer = null;
              args = null;
            }, rate);
          }
        };
        return {
          cancel: cancel,
          throttle: throttle
        };
      };
      var first$3 = function (fn, rate) {
        var timer = null;
        var cancel = function () {
          if (timer !== null) {
            clearTimeout(timer);
            timer = null;
          }
        };
        var throttle = function () {
          var args = arguments;
          if (timer === null) {
            timer = setTimeout(function () {
              fn.apply(null, args);
              timer = null;
              args = null;
            }, rate);
          }
        };
        return {
          cancel: cancel,
          throttle: throttle
        };
      };
      var last$3 = function (fn, rate) {
        var timer = null;
        var cancel = function () {
          if (timer !== null) {
            clearTimeout(timer);
            timer = null;
          }
        };
        var throttle = function () {
          var args = arguments;
          if (timer !== null)
            clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(null, args);
            timer = null;
            args = null;
          }, rate);
        };
        return {
          cancel: cancel,
          throttle: throttle
        };
      };
      var $_de600j5fjh8lyxas = {
        adaptable: adaptable,
        first: first$3,
        last: last$3
      };

      var setup$1 = function (editor) {
        var renderFocusCaret = $_de600j5fjh8lyxas.first(function () {
          if (!editor.removed) {
            var rng = editor.selection.getRng();
            if (rng.collapsed) {
              var caretRange = renderRangeCaret(editor, editor.selection.getRng(), false);
              editor.selection.setRng(caretRange);
            }
          }
        }, 0);
        editor.on('focus', function () {
          renderFocusCaret.throttle();
        });
        editor.on('blur', function () {
          renderFocusCaret.cancel();
        });
      };
      var $_plloj5ejh8lyxap = { setup: setup$1 };

      var $_6lsk4i5gjh8lyxau = {
        BACKSPACE: 8,
        DELETE: 46,
        DOWN: 40,
        ENTER: 13,
        LEFT: 37,
        RIGHT: 39,
        SPACEBAR: 32,
        TAB: 9,
        UP: 38,
        modifierPressed: function (e) {
          return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e);
        },
        metaKeyPressed: function (e) {
          return $_9bpim8ajh8lyw68.mac ? e.metaKey : e.ctrlKey && !e.altKey;
        }
      };

      var isContentEditableTrue$5 = $_5oonaz1qjh8lywhz.isContentEditableTrue;
      var isContentEditableFalse$9 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isAfterContentEditableFalse$1 = isAfterContentEditableFalse;
      var isBeforeContentEditableFalse$1 = isBeforeContentEditableFalse;
      var getContentEditableRoot$1 = function (editor, node) {
        var root = editor.getBody();
        while (node && node !== root) {
          if (isContentEditableTrue$5(node) || isContentEditableFalse$9(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var SelectionOverrides = function (editor) {
        var isBlock = function (node) {
          return editor.dom.isBlock(node);
        };
        var rootNode = editor.getBody();
        var fakeCaret = FakeCaret(editor.getBody(), isBlock, function () {
          return $_cnu79r4ejh8lyx4x.hasFocus(editor);
        });
        var realSelectionId = 'sel-' + editor.dom.uniqueId();
        var selectedContentEditableNode;
        var isFakeSelectionElement = function (elm) {
          return editor.dom.hasClass(elm, 'mce-offscreen-selection');
        };
        var getRealSelectionElement = function () {
          var container = editor.dom.get(realSelectionId);
          return container ? container.getElementsByTagName('*')[0] : container;
        };
        var setRange = function (range) {
          if (range) {
            editor.selection.setRng(range);
          }
        };
        var getRange = function () {
          return editor.selection.getRng();
        };
        var showCaret$$1 = function (direction, node, before, scrollIntoView) {
          if (scrollIntoView === void 0) {
            scrollIntoView = true;
          }
          var e;
          e = editor.fire('ShowCaret', {
            target: node,
            direction: direction,
            before: before
          });
          if (e.isDefaultPrevented()) {
            return null;
          }
          if (scrollIntoView) {
            editor.selection.scrollIntoView(node, direction === -1);
          }
          return fakeCaret.show(before, node);
        };
        var getNormalizedRangeEndPoint$$1 = function (direction, range) {
          range = normalizeRange(direction, rootNode, range);
          if (direction === -1) {
            return CaretPosition$1.fromRangeStart(range);
          }
          return CaretPosition$1.fromRangeEnd(range);
        };
        var showBlockCaretContainer = function (blockCaretContainer) {
          if (blockCaretContainer.hasAttribute('data-mce-caret')) {
            showCaretContainerBlock(blockCaretContainer);
            setRange(getRange());
            editor.selection.scrollIntoView(blockCaretContainer[0]);
          }
        };
        var registerEvents = function () {
          editor.on('mouseup', function (e) {
            var range = getRange();
            if (range.collapsed && $_7f1iw94jjh8lyx60.isXYInContentArea(editor, e.clientX, e.clientY)) {
              setRange(renderCaretAtRange(editor, range, false));
            }
          });
          editor.on('click', function (e) {
            var contentEditableRoot;
            contentEditableRoot = getContentEditableRoot$1(editor, e.target);
            if (contentEditableRoot) {
              if (isContentEditableFalse$9(contentEditableRoot)) {
                e.preventDefault();
                editor.focus();
              }
              if (isContentEditableTrue$5(contentEditableRoot)) {
                if (editor.dom.isChildOf(contentEditableRoot, editor.selection.getNode())) {
                  removeContentEditableSelection();
                }
              }
            }
          });
          editor.on('blur NewBlock', function () {
            removeContentEditableSelection();
          });
          editor.on('ResizeWindow FullscreenStateChanged', function () {
            return fakeCaret.reposition();
          });
          var handleTouchSelect = function (editor) {
            var moved = false;
            editor.on('touchstart', function () {
              moved = false;
            });
            editor.on('touchmove', function () {
              moved = true;
            });
            editor.on('touchend', function (e) {
              var contentEditableRoot = getContentEditableRoot$1(editor, e.target);
              if (isContentEditableFalse$9(contentEditableRoot)) {
                if (!moved) {
                  e.preventDefault();
                  setContentEditableSelection(selectNode(editor, contentEditableRoot));
                }
              }
            });
          };
          var hasNormalCaretPosition = function (elm) {
            var caretWalker = CaretWalker(elm);
            if (!elm.firstChild) {
              return false;
            }
            var startPos = CaretPosition$1.before(elm.firstChild);
            var newPos = caretWalker.next(startPos);
            return newPos && !isBeforeContentEditableFalse$1(newPos) && !isAfterContentEditableFalse$1(newPos);
          };
          var isInSameBlock$$1 = function (node1, node2) {
            var block1 = editor.dom.getParent(node1, editor.dom.isBlock);
            var block2 = editor.dom.getParent(node2, editor.dom.isBlock);
            return block1 === block2;
          };
          var hasBetterMouseTarget = function (targetNode, caretNode) {
            var targetBlock = editor.dom.getParent(targetNode, editor.dom.isBlock);
            var caretBlock = editor.dom.getParent(caretNode, editor.dom.isBlock);
            if (targetBlock && editor.dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse$9(getContentEditableRoot$1(editor, targetBlock)) === false) {
              return true;
            }
            return targetBlock && !isInSameBlock$$1(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
          };
          handleTouchSelect(editor);
          editor.on('mousedown', function (e) {
            var contentEditableRoot;
            var targetElm = e.target;
            if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !editor.dom.isChildOf(targetElm, rootNode)) {
              return;
            }
            if ($_7f1iw94jjh8lyx60.isXYInContentArea(editor, e.clientX, e.clientY) === false) {
              return;
            }
            contentEditableRoot = getContentEditableRoot$1(editor, targetElm);
            if (contentEditableRoot) {
              if (isContentEditableFalse$9(contentEditableRoot)) {
                e.preventDefault();
                setContentEditableSelection(selectNode(editor, contentEditableRoot));
              } else {
                removeContentEditableSelection();
                if (!(isContentEditableTrue$5(contentEditableRoot) && e.shiftKey) && !$_3kj84i5djh8lyxan.isXYWithinRange(e.clientX, e.clientY, editor.selection.getRng())) {
                  hideFakeCaret();
                  editor.selection.placeCaretAt(e.clientX, e.clientY);
                }
              }
            } else if (isFakeCaretTarget(targetElm) === false) {
              removeContentEditableSelection();
              hideFakeCaret();
              var caretInfo = closestCaret(rootNode, e.clientX, e.clientY);
              if (caretInfo) {
                if (!hasBetterMouseTarget(e.target, caretInfo.node)) {
                  e.preventDefault();
                  var range = showCaret$$1(1, caretInfo.node, caretInfo.before, false);
                  editor.getBody().focus();
                  setRange(range);
                }
              }
            }
          });
          editor.on('keypress', function (e) {
            if ($_6lsk4i5gjh8lyxau.modifierPressed(e)) {
              return;
            }
            switch (e.keyCode) {
            default:
              if (isContentEditableFalse$9(editor.selection.getNode())) {
                e.preventDefault();
              }
              break;
            }
          });
          editor.on('getSelectionRange', function (e) {
            var rng = e.range;
            if (selectedContentEditableNode) {
              if (!selectedContentEditableNode.parentNode) {
                selectedContentEditableNode = null;
                return;
              }
              rng = rng.cloneRange();
              rng.selectNode(selectedContentEditableNode);
              e.range = rng;
            }
          });
          editor.on('setSelectionRange', function (e) {
            var rng;
            rng = setContentEditableSelection(e.range, e.forward);
            if (rng) {
              e.range = rng;
            }
          });
          editor.on('AfterSetSelectionRange', function (e) {
            var rng = e.range;
            if (!isRangeInCaretContainer(rng)) {
              hideFakeCaret();
            }
            if (!isFakeSelectionElement(rng.startContainer.parentNode)) {
              removeContentEditableSelection();
            }
          });
          editor.on('copy', function (e) {
            var clipboardData = e.clipboardData;
            if (!e.isDefaultPrevented() && e.clipboardData && !$_9bpim8ajh8lyw68.ie) {
              var realSelectionElement = getRealSelectionElement();
              if (realSelectionElement) {
                e.preventDefault();
                clipboardData.clearData();
                clipboardData.setData('text/html', realSelectionElement.outerHTML);
                clipboardData.setData('text/plain', realSelectionElement.outerText);
              }
            }
          });
          $_8bbr0a58jh8lyxa1.init(editor);
          $_plloj5ejh8lyxap.setup(editor);
        };
        var addCss = function () {
          var styles = editor.contentStyles, rootClass = '.mce-content-body';
          styles.push(fakeCaret.getCss());
          styles.push(rootClass + ' .mce-offscreen-selection {' + 'position: absolute;' + 'left: -9999999999px;' + 'max-width: 1000000px;' + '}' + rootClass + ' *[contentEditable=false] {' + 'cursor: default;' + '}' + rootClass + ' *[contentEditable=true] {' + 'cursor: text;' + '}');
        };
        var isWithinCaretContainer = function (node) {
          return isCaretContainer(node) || startsWithCaretContainer(node) || endsWithCaretContainer(node);
        };
        var isRangeInCaretContainer = function (rng) {
          return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
        };
        var setContentEditableSelection = function (range, forward) {
          var node;
          var $ = editor.$;
          var dom = editor.dom;
          var $realSelectionContainer, sel, startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
          if (!range) {
            return null;
          }
          if (range.collapsed) {
            if (!isRangeInCaretContainer(range)) {
              if (forward === false) {
                caretPosition = getNormalizedRangeEndPoint$$1(-1, range);
                if (isFakeCaretTarget(caretPosition.getNode(true))) {
                  return showCaret$$1(-1, caretPosition.getNode(true), false, false);
                }
                if (isFakeCaretTarget(caretPosition.getNode())) {
                  return showCaret$$1(-1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
                }
              } else {
                caretPosition = getNormalizedRangeEndPoint$$1(1, range);
                if (isFakeCaretTarget(caretPosition.getNode())) {
                  return showCaret$$1(1, caretPosition.getNode(), !caretPosition.isAtEnd(), false);
                }
                if (isFakeCaretTarget(caretPosition.getNode(true))) {
                  return showCaret$$1(1, caretPosition.getNode(true), false, false);
                }
              }
            }
            return null;
          }
          startContainer = range.startContainer;
          startOffset = range.startOffset;
          endOffset = range.endOffset;
          if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse$9(startContainer.parentNode)) {
            startContainer = startContainer.parentNode;
            startOffset = dom.nodeIndex(startContainer);
            startContainer = startContainer.parentNode;
          }
          if (startContainer.nodeType !== 1) {
            return null;
          }
          if (endOffset === startOffset + 1) {
            node = startContainer.childNodes[startOffset];
          }
          if (!isContentEditableFalse$9(node)) {
            return null;
          }
          targetClone = origTargetClone = node.cloneNode(true);
          e = editor.fire('ObjectSelected', {
            target: node,
            targetClone: targetClone
          });
          if (e.isDefaultPrevented()) {
            return null;
          }
          $realSelectionContainer = $_7sg18r3cjh8lywu1.descendant($_cgttw3zjh8lywdq.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
            return $([]);
          }, function (elm) {
            return $([elm.dom()]);
          });
          targetClone = e.targetClone;
          if ($realSelectionContainer.length === 0) {
            $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
            $realSelectionContainer.appendTo(editor.getBody());
          }
          range = editor.dom.createRng();
          if (targetClone === origTargetClone && $_9bpim8ajh8lyw68.ie) {
            $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
            range.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
            range.setEndAfter(targetClone);
          } else {
            $realSelectionContainer.empty().append('\xA0').append(targetClone).append('\xA0');
            range.setStart($realSelectionContainer[0].firstChild, 1);
            range.setEnd($realSelectionContainer[0].lastChild, 0);
          }
          $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
          $realSelectionContainer[0].focus();
          sel = editor.selection.getSel();
          sel.removeAllRanges();
          sel.addRange(range);
          $_5wjzy24jh8lyw2t.each($_eebxu2gjh8lywp3.descendants($_cgttw3zjh8lywdq.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
            $_3da62i14jh8lyweo.remove(elm, 'data-mce-selected');
          });
          node.setAttribute('data-mce-selected', '1');
          selectedContentEditableNode = node;
          hideFakeCaret();
          return range;
        };
        var removeContentEditableSelection = function () {
          if (selectedContentEditableNode) {
            selectedContentEditableNode.removeAttribute('data-mce-selected');
          }
          $_7sg18r3cjh8lywu1.descendant($_cgttw3zjh8lywdq.fromDom(editor.getBody()), '#' + realSelectionId).each($_bfmuql2ujh8lywr1.remove);
          selectedContentEditableNode = null;
        };
        var destroy = function () {
          fakeCaret.destroy();
          selectedContentEditableNode = null;
        };
        var hideFakeCaret = function () {
          fakeCaret.hide();
        };
        if ($_9bpim8ajh8lyw68.ceFalse) {
          registerEvents();
          addCss();
        }
        return {
          showCaret: showCaret$$1,
          showBlockCaretContainer: showBlockCaretContainer,
          hideFakeCaret: hideFakeCaret,
          destroy: destroy
        };
      };

      var isValidPrefixAttrName = function (name) {
        return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
      };
      var trimComments = function (text) {
        return text.replace(/<!--|-->/g, '');
      };
      var isInvalidUri = function (settings, uri) {
        if (settings.allow_html_data_urls) {
          return false;
        } else if (/^data:image\//i.test(uri)) {
          return settings.allow_svg_data_urls === false && /^data:image\/svg\+xml/i.test(uri);
        } else {
          return /^data:/i.test(uri);
        }
      };
      var findEndTagIndex = function (schema, html, startIndex) {
        var count = 1, index, matches, tokenRegExp, shortEndedElements;
        shortEndedElements = schema.getShortEndedElements();
        tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
        tokenRegExp.lastIndex = index = startIndex;
        while (matches = tokenRegExp.exec(html)) {
          index = tokenRegExp.lastIndex;
          if (matches[1] === '/') {
            count--;
          } else if (!matches[1]) {
            if (matches[2] in shortEndedElements) {
              continue;
            }
            count++;
          }
          if (count === 0) {
            break;
          }
        }
        return index;
      };
      function SaxParser(settings, schema) {
        if (schema === void 0) {
          schema = Schema();
        }
        var noop = function () {
        };
        settings = settings || {};
        if (settings.fix_self_closing !== false) {
          settings.fix_self_closing = true;
        }
        var comment = settings.comment ? settings.comment : noop;
        var cdata = settings.cdata ? settings.cdata : noop;
        var text = settings.text ? settings.text : noop;
        var start = settings.start ? settings.start : noop;
        var end = settings.end ? settings.end : noop;
        var pi = settings.pi ? settings.pi : noop;
        var doctype = settings.doctype ? settings.doctype : noop;
        var parse = function (html) {
          var matches, index = 0, value, endRegExp;
          var stack = [];
          var attrList, i, textData, name;
          var isInternalElement, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
          var validate, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
          var attributesRequired, attributesDefault, attributesForced, processHtml;
          var anyAttributesRequired, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
          var decode = $_gex7a11rjh8lywi4.decode;
          var fixSelfClosing;
          var filteredUrlAttrs = $_ahowuxkjh8lywbj.makeMap('src,href,data,background,formaction,poster,xlink:href');
          var scriptUriRegExp = /((java|vb)script|mhtml):/i;
          var processEndTag = function (name) {
            var pos, i;
            pos = stack.length;
            while (pos--) {
              if (stack[pos].name === name) {
                break;
              }
            }
            if (pos >= 0) {
              for (i = stack.length - 1; i >= pos; i--) {
                name = stack[i];
                if (name.valid) {
                  end(name.name);
                }
              }
              stack.length = pos;
            }
          };
          var parseAttribute = function (match, name, value, val2, val3) {
            var attrRule, i;
            var trimRegExp = /[\s\u0000-\u001F]+/g;
            name = name.toLowerCase();
            value = name in fillAttrsMap ? name : decode(value || val2 || val3 || '');
            if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
              attrRule = validAttributesMap[name];
              if (!attrRule && validAttributePatterns) {
                i = validAttributePatterns.length;
                while (i--) {
                  attrRule = validAttributePatterns[i];
                  if (attrRule.pattern.test(name)) {
                    break;
                  }
                }
                if (i === -1) {
                  attrRule = null;
                }
              }
              if (!attrRule) {
                return;
              }
              if (attrRule.validValues && !(value in attrRule.validValues)) {
                return;
              }
            }
            if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
              var uri = value.replace(trimRegExp, '');
              try {
                uri = decodeURIComponent(uri);
              } catch (ex) {
                uri = unescape(uri);
              }
              if (scriptUriRegExp.test(uri)) {
                return;
              }
              if (isInvalidUri(settings, uri)) {
                return;
              }
            }
            if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
              return;
            }
            attrList.map[name] = value;
            attrList.push({
              name: name,
              value: value
            });
          };
          tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)-->)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:!DOCTYPE([\\w\\W]*?)>)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + ')', 'g');
          attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
          shortEndedElements = schema.getShortEndedElements();
          selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
          fillAttrsMap = schema.getBoolAttrs();
          validate = settings.validate;
          removeInternalElements = settings.remove_internals;
          fixSelfClosing = settings.fix_self_closing;
          specialElements = schema.getSpecialElements();
          processHtml = html + '>';
          while (matches = tokenRegExp.exec(processHtml)) {
            if (index < matches.index) {
              text(decode(html.substr(index, matches.index - index)));
            }
            if (value = matches[6]) {
              value = value.toLowerCase();
              if (value.charAt(0) === ':') {
                value = value.substr(1);
              }
              processEndTag(value);
            } else if (value = matches[7]) {
              if (matches.index + matches[0].length > html.length) {
                text(decode(html.substr(matches.index)));
                index = matches.index + matches[0].length;
                continue;
              }
              value = value.toLowerCase();
              if (value.charAt(0) === ':') {
                value = value.substr(1);
              }
              isShortEnded = value in shortEndedElements;
              if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
                processEndTag(value);
              }
              if (!validate || (elementRule = schema.getElementRule(value))) {
                isValidElement = true;
                if (validate) {
                  validAttributesMap = elementRule.attributes;
                  validAttributePatterns = elementRule.attributePatterns;
                }
                if (attribsValue = matches[8]) {
                  isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
                  if (isInternalElement && removeInternalElements) {
                    isValidElement = false;
                  }
                  attrList = [];
                  attrList.map = {};
                  attribsValue.replace(attrRegExp, parseAttribute);
                } else {
                  attrList = [];
                  attrList.map = {};
                }
                if (validate && !isInternalElement) {
                  attributesRequired = elementRule.attributesRequired;
                  attributesDefault = elementRule.attributesDefault;
                  attributesForced = elementRule.attributesForced;
                  anyAttributesRequired = elementRule.removeEmptyAttrs;
                  if (anyAttributesRequired && !attrList.length) {
                    isValidElement = false;
                  }
                  if (attributesForced) {
                    i = attributesForced.length;
                    while (i--) {
                      attr = attributesForced[i];
                      name = attr.name;
                      attrValue = attr.value;
                      if (attrValue === '{$uid}') {
                        attrValue = 'mce_' + idCount++;
                      }
                      attrList.map[name] = attrValue;
                      attrList.push({
                        name: name,
                        value: attrValue
                      });
                    }
                  }
                  if (attributesDefault) {
                    i = attributesDefault.length;
                    while (i--) {
                      attr = attributesDefault[i];
                      name = attr.name;
                      if (!(name in attrList.map)) {
                        attrValue = attr.value;
                        if (attrValue === '{$uid}') {
                          attrValue = 'mce_' + idCount++;
                        }
                        attrList.map[name] = attrValue;
                        attrList.push({
                          name: name,
                          value: attrValue
                        });
                      }
                    }
                  }
                  if (attributesRequired) {
                    i = attributesRequired.length;
                    while (i--) {
                      if (attributesRequired[i] in attrList.map) {
                        break;
                      }
                    }
                    if (i === -1) {
                      isValidElement = false;
                    }
                  }
                  if (attr = attrList.map['data-mce-bogus']) {
                    if (attr === 'all') {
                      index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
                      tokenRegExp.lastIndex = index;
                      continue;
                    }
                    isValidElement = false;
                  }
                }
                if (isValidElement) {
                  start(value, attrList, isShortEnded);
                }
              } else {
                isValidElement = false;
              }
              if (endRegExp = specialElements[value]) {
                endRegExp.lastIndex = index = matches.index + matches[0].length;
                if (matches = endRegExp.exec(html)) {
                  if (isValidElement) {
                    textData = html.substr(index, matches.index - index);
                  }
                  index = matches.index + matches[0].length;
                } else {
                  textData = html.substr(index);
                  index = html.length;
                }
                if (isValidElement) {
                  if (textData.length > 0) {
                    text(textData, true);
                  }
                  end(value);
                }
                tokenRegExp.lastIndex = index;
                continue;
              }
              if (!isShortEnded) {
                if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
                  stack.push({
                    name: value,
                    valid: isValidElement
                  });
                } else if (isValidElement) {
                  end(value);
                }
              }
            } else if (value = matches[1]) {
              if (value.charAt(0) === '>') {
                value = ' ' + value;
              }
              if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
                value = ' ' + value;
              }
              comment(value);
            } else if (value = matches[2]) {
              cdata(trimComments(value));
            } else if (value = matches[3]) {
              doctype(value);
            } else if (value = matches[4]) {
              pi(value, matches[5]);
            }
            index = matches.index + matches[0].length;
          }
          if (index < html.length) {
            text(decode(html.substr(index)));
          }
          for (i = stack.length - 1; i >= 0; i--) {
            value = stack[i];
            if (value.valid) {
              end(value.name);
            }
          }
        };
        return { parse: parse };
      }
      (function (SaxParser) {
        SaxParser.findEndTag = findEndTagIndex;
      }(SaxParser || (SaxParser = {})));
      var SaxParser$1 = SaxParser;

      var trimHtml = function (tempAttrs, html) {
        var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
        return html.replace(trimContentRegExp, '');
      };
      var trimInternal = function (serializer, html) {
        var content = html;
        var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
        var endTagIndex, index, matchLength, matches, shortEndedElements;
        var schema = serializer.schema;
        content = trimHtml(serializer.getTempAttrs(), content);
        shortEndedElements = schema.getShortEndedElements();
        while (matches = bogusAllRegExp.exec(content)) {
          index = bogusAllRegExp.lastIndex;
          matchLength = matches[0].length;
          if (shortEndedElements[matches[1]]) {
            endTagIndex = index;
          } else {
            endTagIndex = SaxParser$1.findEndTag(schema, content, index);
          }
          content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
          bogusAllRegExp.lastIndex = index - matchLength;
        }
        return $_d383mr21jh8lywlv.trim(content);
      };
      var trimExternal = trimInternal;
      var $_8lol015jjh8lyxbf = {
        trimExternal: trimExternal,
        trimInternal: trimInternal
      };

      var KEEP = 0;
      var INSERT = 1;
      var DELETE = 2;
      var diff = function (left, right) {
        var size = left.length + right.length + 2;
        var vDown = new Array(size);
        var vUp = new Array(size);
        var snake = function (start, end, diag) {
          return {
            start: start,
            end: end,
            diag: diag
          };
        };
        var buildScript = function (start1, end1, start2, end2, script) {
          var middle = getMiddleSnake(start1, end1, start2, end2);
          if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
            var i = start1;
            var j = start2;
            while (i < end1 || j < end2) {
              if (i < end1 && j < end2 && left[i] === right[j]) {
                script.push([
                  KEEP,
                  left[i]
                ]);
                ++i;
                ++j;
              } else {
                if (end1 - start1 > end2 - start2) {
                  script.push([
                    DELETE,
                    left[i]
                  ]);
                  ++i;
                } else {
                  script.push([
                    INSERT,
                    right[j]
                  ]);
                  ++j;
                }
              }
            }
          } else {
            buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
            for (var i2 = middle.start; i2 < middle.end; ++i2) {
              script.push([
                KEEP,
                left[i2]
              ]);
            }
            buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
          }
        };
        var buildSnake = function (start, diag, end1, end2) {
          var end = start;
          while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
            ++end;
          }
          return snake(start, end, diag);
        };
        var getMiddleSnake = function (start1, end1, start2, end2) {
          var m = end1 - start1;
          var n = end2 - start2;
          if (m === 0 || n === 0) {
            return null;
          }
          var delta = m - n;
          var sum = n + m;
          var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
          vDown[1 + offset] = start1;
          vUp[1 + offset] = end1 + 1;
          var d, k, i, x, y;
          for (d = 0; d <= offset; ++d) {
            for (k = -d; k <= d; k += 2) {
              i = k + offset;
              if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
                vDown[i] = vDown[i + 1];
              } else {
                vDown[i] = vDown[i - 1] + 1;
              }
              x = vDown[i];
              y = x - start1 + start2 - k;
              while (x < end1 && y < end2 && left[x] === right[y]) {
                vDown[i] = ++x;
                ++y;
              }
              if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
                if (vUp[i - delta] <= vDown[i]) {
                  return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
                }
              }
            }
            for (k = delta - d; k <= delta + d; k += 2) {
              i = k + offset - delta;
              if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
                vUp[i] = vUp[i + 1] - 1;
              } else {
                vUp[i] = vUp[i - 1];
              }
              x = vUp[i] - 1;
              y = x - start1 + start2 - k;
              while (x >= start1 && y >= start2 && left[x] === right[y]) {
                vUp[i] = x--;
                y--;
              }
              if (delta % 2 === 0 && -d <= k && k <= d) {
                if (vUp[i] <= vDown[i + delta]) {
                  return buildSnake(vUp[i], k + start1 - start2, end1, end2);
                }
              }
            }
          }
        };
        var script = [];
        buildScript(0, left.length, 0, right.length, script);
        return script;
      };
      var $_5dhayi5mjh8lyxc5 = {
        KEEP: KEEP,
        DELETE: DELETE,
        INSERT: INSERT,
        diff: diff
      };

      var getOuterHtml = function (elm) {
        if ($_5oonaz1qjh8lywhz.isElement(elm)) {
          return elm.outerHTML;
        } else if ($_5oonaz1qjh8lywhz.isText(elm)) {
          return $_gex7a11rjh8lywi4.encodeRaw(elm.data, false);
        } else if ($_5oonaz1qjh8lywhz.isComment(elm)) {
          return '<!--' + elm.data + '-->';
        }
        return '';
      };
      var createFragment$1 = function (html) {
        var frag, node, container;
        container = document.createElement('div');
        frag = document.createDocumentFragment();
        if (html) {
          container.innerHTML = html;
        }
        while (node = container.firstChild) {
          frag.appendChild(node);
        }
        return frag;
      };
      var insertAt = function (elm, html, index) {
        var fragment = createFragment$1(html);
        if (elm.hasChildNodes() && index < elm.childNodes.length) {
          var target = elm.childNodes[index];
          target.parentNode.insertBefore(fragment, target);
        } else {
          elm.appendChild(fragment);
        }
      };
      var removeAt = function (elm, index) {
        if (elm.hasChildNodes() && index < elm.childNodes.length) {
          var target = elm.childNodes[index];
          target.parentNode.removeChild(target);
        }
      };
      var applyDiff = function (diff, elm) {
        var index = 0;
        $_9tjm51ljh8lywbq.each(diff, function (action) {
          if (action[0] === $_5dhayi5mjh8lyxc5.KEEP) {
            index++;
          } else if (action[0] === $_5dhayi5mjh8lyxc5.INSERT) {
            insertAt(elm, action[1], index);
            index++;
          } else if (action[0] === $_5dhayi5mjh8lyxc5.DELETE) {
            removeAt(elm, index);
          }
        });
      };
      var read$3 = function (elm) {
        return $_9tjm51ljh8lywbq.filter($_9tjm51ljh8lywbq.map(elm.childNodes, getOuterHtml), function (item) {
          return item.length > 0;
        });
      };
      var write = function (fragments, elm) {
        var currentFragments = $_9tjm51ljh8lywbq.map(elm.childNodes, getOuterHtml);
        applyDiff($_5dhayi5mjh8lyxc5.diff(currentFragments, fragments), elm);
        return elm;
      };
      var $_9x5cnf5ljh8lyxc2 = {
        read: read$3,
        write: write
      };

      var fromHtml$1 = function (html, scope) {
        var doc = scope || document;
        var div = doc.createElement('div');
        div.innerHTML = html;
        return $_a43q0i17jh8lywfe.children($_cgttw3zjh8lywdq.fromDom(div));
      };
      var fromTags = function (tags, scope) {
        return $_5wjzy24jh8lyw2t.map(tags, function (x) {
          return $_cgttw3zjh8lywdq.fromTag(x, scope);
        });
      };
      var fromText$1 = function (texts, scope) {
        return $_5wjzy24jh8lyw2t.map(texts, function (x) {
          return $_cgttw3zjh8lywdq.fromText(x, scope);
        });
      };
      var fromDom$1 = function (nodes) {
        return $_5wjzy24jh8lyw2t.map(nodes, $_cgttw3zjh8lywdq.fromDom);
      };
      var $_egn65r5ojh8lyxcb = {
        fromHtml: fromHtml$1,
        fromTags: fromTags,
        fromText: fromText$1,
        fromDom: fromDom$1
      };

      var get$5 = function (element) {
        return element.dom().innerHTML;
      };
      var set$3 = function (element, content) {
        var owner = $_a43q0i17jh8lywfe.owner(element);
        var docDom = owner.dom();
        var fragment = $_cgttw3zjh8lywdq.fromDom(docDom.createDocumentFragment());
        var contentElements = $_egn65r5ojh8lyxcb.fromHtml(content, docDom);
        $_9hl8mu2vjh8lywr4.append(fragment, contentElements);
        $_bfmuql2ujh8lywr1.empty(element);
        $_4m7u2e2kjh8lywpi.append(element, fragment);
      };
      var getOuter = function (element) {
        var container = $_cgttw3zjh8lywdq.fromTag('div');
        var clone = $_cgttw3zjh8lywdq.fromDom(element.dom().cloneNode(true));
        $_4m7u2e2kjh8lywpi.append(container, clone);
        return get$5(container);
      };
      var $_cxg0x95njh8lyxc9 = {
        get: get$5,
        set: set$3,
        getOuter: getOuter
      };

      var undoLevelDocument = Cell(Option.none());
      var lazyTempDocument = function () {
        return undoLevelDocument.get().getOrThunk(function () {
          var doc = document.implementation.createHTMLDocument('undo');
          undoLevelDocument.set(Option.some(doc));
          return doc;
        });
      };
      var hasIframes = function (html) {
        return html.indexOf('</iframe>') !== -1;
      };
      var createFragmentedLevel = function (fragments) {
        return {
          type: 'fragmented',
          fragments: fragments,
          content: '',
          bookmark: null,
          beforeBookmark: null
        };
      };
      var createCompleteLevel = function (content) {
        return {
          type: 'complete',
          fragments: null,
          content: content,
          bookmark: null,
          beforeBookmark: null
        };
      };
      var createFromEditor = function (editor) {
        var fragments, content, trimmedFragments;
        fragments = $_9x5cnf5ljh8lyxc2.read(editor.getBody());
        trimmedFragments = $_5wjzy24jh8lyw2t.bind(fragments, function (html) {
          var trimmed = $_8lol015jjh8lyxbf.trimInternal(editor.serializer, html);
          return trimmed.length > 0 ? [trimmed] : [];
        });
        content = trimmedFragments.join('');
        return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
      };
      var applyToEditor = function (editor, level, before) {
        if (level.type === 'fragmented') {
          $_9x5cnf5ljh8lyxc2.write(level.fragments, editor.getBody());
        } else {
          editor.setContent(level.content, { format: 'raw' });
        }
        editor.selection.moveToBookmark(before ? level.beforeBookmark : level.bookmark);
      };
      var getLevelContent = function (level) {
        return level.type === 'fragmented' ? level.fragments.join('') : level.content;
      };
      var getCleanLevelContent = function (level) {
        var elm = $_cgttw3zjh8lywdq.fromTag('body', lazyTempDocument());
        $_cxg0x95njh8lyxc9.set(elm, getLevelContent(level));
        $_5wjzy24jh8lyw2t.each($_eebxu2gjh8lywp3.descendants(elm, '*[data-mce-bogus]'), $_bfmuql2ujh8lywr1.unwrap);
        return $_cxg0x95njh8lyxc9.get(elm);
      };
      var hasEqualContent = function (level1, level2) {
        return getLevelContent(level1) === getLevelContent(level2);
      };
      var hasEqualCleanedContent = function (level1, level2) {
        return getCleanLevelContent(level1) === getCleanLevelContent(level2);
      };
      var isEq$2 = function (level1, level2) {
        if (!level1 || !level2) {
          return false;
        } else if (hasEqualContent(level1, level2)) {
          return true;
        } else {
          return hasEqualCleanedContent(level1, level2);
        }
      };
      var $_dxjj465ijh8lyxb4 = {
        createFragmentedLevel: createFragmentedLevel,
        createCompleteLevel: createCompleteLevel,
        createFromEditor: createFromEditor,
        applyToEditor: applyToEditor,
        isEq: isEq$2
      };

      function UndoManager (editor) {
        var self = this, index = 0, data = [], beforeBookmark, isFirstTypedCharacter, locks = 0;
        var isUnlocked = function () {
          return locks === 0;
        };
        var setTyping = function (typing) {
          if (isUnlocked()) {
            self.typing = typing;
          }
        };
        var setDirty = function (state) {
          editor.setDirty(state);
        };
        var addNonTypingUndoLevel = function (e) {
          setTyping(false);
          self.add({}, e);
        };
        var endTyping = function () {
          if (self.typing) {
            setTyping(false);
            self.add();
          }
        };
        editor.on('init', function () {
          self.add();
        });
        editor.on('BeforeExecCommand', function (e) {
          var cmd = e.command;
          if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
            endTyping();
            self.beforeChange();
          }
        });
        editor.on('ExecCommand', function (e) {
          var cmd = e.command;
          if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
            addNonTypingUndoLevel(e);
          }
        });
        editor.on('ObjectResizeStart Cut', function () {
          self.beforeChange();
        });
        editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
        editor.on('DragEnd', addNonTypingUndoLevel);
        editor.on('KeyUp', function (e) {
          var keyCode = e.keyCode;
          if (e.isDefaultPrevented()) {
            return;
          }
          if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
            addNonTypingUndoLevel();
            editor.nodeChanged();
          }
          if (keyCode === 46 || keyCode === 8) {
            editor.nodeChanged();
          }
          if (isFirstTypedCharacter && self.typing && $_dxjj465ijh8lyxb4.isEq($_dxjj465ijh8lyxb4.createFromEditor(editor), data[0]) === false) {
            if (editor.isDirty() === false) {
              setDirty(true);
              editor.fire('change', {
                level: data[0],
                lastLevel: null
              });
            }
            editor.fire('TypingUndo');
            isFirstTypedCharacter = false;
            editor.nodeChanged();
          }
        });
        editor.on('KeyDown', function (e) {
          var keyCode = e.keyCode;
          if (e.isDefaultPrevented()) {
            return;
          }
          if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
            if (self.typing) {
              addNonTypingUndoLevel(e);
            }
            return;
          }
          var modKey = e.ctrlKey && !e.altKey || e.metaKey;
          if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !self.typing && !modKey) {
            self.beforeChange();
            setTyping(true);
            self.add({}, e);
            isFirstTypedCharacter = true;
          }
        });
        editor.on('MouseDown', function (e) {
          if (self.typing) {
            addNonTypingUndoLevel(e);
          }
        });
        var isInsertReplacementText = function (event) {
          return event.inputType === 'insertReplacementText';
        };
        var isInsertTextDataNull = function (event) {
          return event.inputType === 'insertText' && event.data === null;
        };
        editor.on('input', function (e) {
          if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e))) {
            addNonTypingUndoLevel(e);
          }
        });
        editor.addShortcut('meta+z', '', 'Undo');
        editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
        editor.on('AddUndo Undo Redo ClearUndos', function (e) {
          if (!e.isDefaultPrevented()) {
            editor.nodeChanged();
          }
        });
        self = {
          data: data,
          typing: false,
          beforeChange: function () {
            if (isUnlocked()) {
              beforeBookmark = $_8b82yg2ojh8lywpq.getUndoBookmark(editor.selection);
            }
          },
          add: function (level, event) {
            var i;
            var settings = editor.settings;
            var lastLevel, currentLevel;
            currentLevel = $_dxjj465ijh8lyxb4.createFromEditor(editor);
            level = level || {};
            level = $_ahowuxkjh8lywbj.extend(level, currentLevel);
            if (isUnlocked() === false || editor.removed) {
              return null;
            }
            lastLevel = data[index];
            if (editor.fire('BeforeAddUndo', {
                level: level,
                lastLevel: lastLevel,
                originalEvent: event
              }).isDefaultPrevented()) {
              return null;
            }
            if (lastLevel && $_dxjj465ijh8lyxb4.isEq(lastLevel, level)) {
              return null;
            }
            if (data[index]) {
              data[index].beforeBookmark = beforeBookmark;
            }
            if (settings.custom_undo_redo_levels) {
              if (data.length > settings.custom_undo_redo_levels) {
                for (i = 0; i < data.length - 1; i++) {
                  data[i] = data[i + 1];
                }
                data.length--;
                index = data.length;
              }
            }
            level.bookmark = $_8b82yg2ojh8lywpq.getUndoBookmark(editor.selection);
            if (index < data.length - 1) {
              data.length = index + 1;
            }
            data.push(level);
            index = data.length - 1;
            var args = {
              level: level,
              lastLevel: lastLevel,
              originalEvent: event
            };
            editor.fire('AddUndo', args);
            if (index > 0) {
              setDirty(true);
              editor.fire('change', args);
            }
            return level;
          },
          undo: function () {
            var level;
            if (self.typing) {
              self.add();
              self.typing = false;
              setTyping(false);
            }
            if (index > 0) {
              level = data[--index];
              $_dxjj465ijh8lyxb4.applyToEditor(editor, level, true);
              setDirty(true);
              editor.fire('undo', { level: level });
            }
            return level;
          },
          redo: function () {
            var level;
            if (index < data.length - 1) {
              level = data[++index];
              $_dxjj465ijh8lyxb4.applyToEditor(editor, level, false);
              setDirty(true);
              editor.fire('redo', { level: level });
            }
            return level;
          },
          clear: function () {
            data = [];
            index = 0;
            self.typing = false;
            self.data = data;
            editor.fire('ClearUndos');
          },
          hasUndo: function () {
            return index > 0 || self.typing && data[0] && !$_dxjj465ijh8lyxb4.isEq($_dxjj465ijh8lyxb4.createFromEditor(editor), data[0]);
          },
          hasRedo: function () {
            return index < data.length - 1 && !self.typing;
          },
          transact: function (callback) {
            endTyping();
            self.beforeChange();
            self.ignore(callback);
            return self.add();
          },
          ignore: function (callback) {
            try {
              locks++;
              callback();
            } finally {
              locks--;
            }
          },
          extra: function (callback1, callback2) {
            var lastLevel, bookmark;
            if (self.transact(callback1)) {
              bookmark = data[index].bookmark;
              lastLevel = data[index - 1];
              $_dxjj465ijh8lyxb4.applyToEditor(editor, lastLevel, true);
              if (self.transact(callback2)) {
                data[index - 1].beforeBookmark = bookmark;
              }
            }
          }
        };
        return self;
      }

      var isInlineBlock = function (node) {
        return node && /^(IMG)$/.test(node.nodeName);
      };
      var moveStart = function (dom, selection, rng) {
        var offset = rng.startOffset;
        var container = rng.startContainer, walker, node, nodes;
        if (rng.startContainer === rng.endContainer) {
          if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
            return;
          }
        }
        if (container.nodeType === 1) {
          nodes = container.childNodes;
          if (offset < nodes.length) {
            container = nodes[offset];
            walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
          } else {
            container = nodes[nodes.length - 1];
            walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
            walker.next(true);
          }
          for (node = walker.current(); node; node = walker.next()) {
            if (node.nodeType === 3 && !isWhiteSpaceNode(node)) {
              rng.setStart(node, 0);
              selection.setRng(rng);
              return;
            }
          }
        }
      };
      var getNonWhiteSpaceSibling = function (node, next, inc) {
        if (node) {
          next = next ? 'nextSibling' : 'previousSibling';
          for (node = inc ? node : node[next]; node; node = node[next]) {
            if (node.nodeType === 1 || !isWhiteSpaceNode(node)) {
              return node;
            }
          }
        }
      };
      var isTextBlock$1 = function (editor, name) {
        if (name.nodeType) {
          name = name.nodeName;
        }
        return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
      };
      var isValid = function (ed, parent, child) {
        return ed.schema.isValidChild(parent, child);
      };
      var isWhiteSpaceNode = function (node) {
        return node && node.nodeType === 3 && /^([\t \r\n]+|)$/.test(node.nodeValue);
      };
      var replaceVars = function (value, vars) {
        if (typeof value !== 'string') {
          value = value(vars);
        } else if (vars) {
          value = value.replace(/%(\w+)/g, function (str, name) {
            return vars[name] || str;
          });
        }
        return value;
      };
      var isEq$3 = function (str1, str2) {
        str1 = str1 || '';
        str2 = str2 || '';
        str1 = '' + (str1.nodeName || str1);
        str2 = '' + (str2.nodeName || str2);
        return str1.toLowerCase() === str2.toLowerCase();
      };
      var normalizeStyleValue = function (dom, value, name) {
        if (name === 'color' || name === 'backgroundColor') {
          value = dom.toHex(value);
        }
        if (name === 'fontWeight' && value === 700) {
          value = 'bold';
        }
        if (name === 'fontFamily') {
          value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
        }
        return '' + value;
      };
      var getStyle = function (dom, node, name) {
        return normalizeStyleValue(dom, dom.getStyle(node, name), name);
      };
      var getTextDecoration = function (dom, node) {
        var decoration;
        dom.getParent(node, function (n) {
          decoration = dom.getStyle(n, 'text-decoration');
          return decoration && decoration !== 'none';
        });
        return decoration;
      };
      var getParents$1 = function (dom, node, selector) {
        return dom.getParents(node, selector, dom.getRoot());
      };
      var $_dodtof5tjh8lyxdh = {
        isInlineBlock: isInlineBlock,
        moveStart: moveStart,
        getNonWhiteSpaceSibling: getNonWhiteSpaceSibling,
        isTextBlock: isTextBlock$1,
        isValid: isValid,
        isWhiteSpaceNode: isWhiteSpaceNode,
        replaceVars: replaceVars,
        isEq: isEq$3,
        normalizeStyleValue: normalizeStyleValue,
        getStyle: getStyle,
        getTextDecoration: getTextDecoration,
        getParents: getParents$1
      };

      var isBookmarkNode$2 = $_eyp5ec2njh8lywpo.isBookmarkNode;
      var getParents$2 = $_dodtof5tjh8lyxdh.getParents;
      var isWhiteSpaceNode$1 = $_dodtof5tjh8lyxdh.isWhiteSpaceNode;
      var isTextBlock$2 = $_dodtof5tjh8lyxdh.isTextBlock;
      var findLeaf = function (node, offset) {
        if (typeof offset === 'undefined') {
          offset = node.nodeType === 3 ? node.length : node.childNodes.length;
        }
        while (node && node.hasChildNodes()) {
          node = node.childNodes[offset];
          if (node) {
            offset = node.nodeType === 3 ? node.length : node.childNodes.length;
          }
        }
        return {
          node: node,
          offset: offset
        };
      };
      var excludeTrailingWhitespace = function (endContainer, endOffset) {
        var leaf = findLeaf(endContainer, endOffset);
        if (leaf.node) {
          while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
            leaf = findLeaf(leaf.node.previousSibling);
          }
          if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 && leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
            if (leaf.offset > 1) {
              endContainer = leaf.node;
              endContainer.splitText(leaf.offset - 1);
            }
          }
        }
        return endContainer;
      };
      var isBogusBr = function (node) {
        return node.nodeName === 'BR' && node.getAttribute('data-mce-bogus') && !node.nextSibling;
      };
      var findParentContentEditable = function (dom, node) {
        var parent = node;
        while (parent) {
          if (parent.nodeType === 1 && dom.getContentEditable(parent)) {
            return dom.getContentEditable(parent) === 'false' ? parent : node;
          }
          parent = parent.parentNode;
        }
        return node;
      };
      var findSpace = function (start, remove, node, offset) {
        var pos, pos2;
        var str = node.nodeValue;
        if (typeof offset === 'undefined') {
          offset = start ? str.length : 0;
        }
        if (start) {
          pos = str.lastIndexOf(' ', offset);
          pos2 = str.lastIndexOf('\xA0', offset);
          pos = pos > pos2 ? pos : pos2;
          if (pos !== -1 && !remove) {
            pos++;
          }
        } else {
          pos = str.indexOf(' ', offset);
          pos2 = str.indexOf('\xA0', offset);
          pos = pos !== -1 && (pos2 === -1 || pos < pos2) ? pos : pos2;
        }
        return pos;
      };
      var findWordEndPoint = function (dom, body, container, offset, start, remove) {
        var walker, node, pos, lastTextNode;
        if (container.nodeType === 3) {
          pos = findSpace(start, remove, container, offset);
          if (pos !== -1) {
            return {
              container: container,
              offset: pos
            };
          }
          lastTextNode = container;
        }
        walker = new TreeWalker(container, dom.getParent(container, dom.isBlock) || body);
        while (node = walker[start ? 'prev' : 'next']()) {
          if (node.nodeType === 3) {
            lastTextNode = node;
            pos = findSpace(start, remove, node);
            if (pos !== -1) {
              return {
                container: node,
                offset: pos
              };
            }
          } else if (dom.isBlock(node)) {
            break;
          }
        }
        if (lastTextNode) {
          if (start) {
            offset = 0;
          } else {
            offset = lastTextNode.length;
          }
          return {
            container: lastTextNode,
            offset: offset
          };
        }
      };
      var findSelectorEndPoint = function (dom, format, rng, container, siblingName) {
        var parents, i, y, curFormat;
        if (container.nodeType === 3 && container.nodeValue.length === 0 && container[siblingName]) {
          container = container[siblingName];
        }
        parents = getParents$2(dom, container);
        for (i = 0; i < parents.length; i++) {
          for (y = 0; y < format.length; y++) {
            curFormat = format[y];
            if ('collapsed' in curFormat && curFormat.collapsed !== rng.collapsed) {
              continue;
            }
            if (dom.is(parents[i], curFormat.selector)) {
              return parents[i];
            }
          }
        }
        return container;
      };
      var findBlockEndPoint = function (editor, format, container, siblingName) {
        var node;
        var dom = editor.dom;
        var root = dom.getRoot();
        if (!format[0].wrapper) {
          node = dom.getParent(container, format[0].block, root);
        }
        if (!node) {
          var scopeRoot = dom.getParent(container, 'LI,TD,TH');
          node = dom.getParent(container.nodeType === 3 ? container.parentNode : container, function (node) {
            return node !== root && isTextBlock$2(editor, node);
          }, scopeRoot);
        }
        if (node && format[0].wrapper) {
          node = getParents$2(dom, node, 'ul,ol').reverse()[0] || node;
        }
        if (!node) {
          node = container;
          while (node[siblingName] && !dom.isBlock(node[siblingName])) {
            node = node[siblingName];
            if ($_dodtof5tjh8lyxdh.isEq(node, 'br')) {
              break;
            }
          }
        }
        return node || container;
      };
      var findParentContainer = function (dom, format, startContainer, startOffset, endContainer, endOffset, start) {
        var container, parent, sibling, siblingName, root;
        container = parent = start ? startContainer : endContainer;
        siblingName = start ? 'previousSibling' : 'nextSibling';
        root = dom.getRoot();
        if (container.nodeType === 3 && !isWhiteSpaceNode$1(container)) {
          if (start ? startOffset > 0 : endOffset < container.nodeValue.length) {
            return container;
          }
        }
        while (true) {
          if (!format[0].block_expand && dom.isBlock(parent)) {
            return parent;
          }
          for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
            if (!isBookmarkNode$2(sibling) && !isWhiteSpaceNode$1(sibling) && !isBogusBr(sibling)) {
              return parent;
            }
          }
          if (parent === root || parent.parentNode === root) {
            container = parent;
            break;
          }
          parent = parent.parentNode;
        }
        return container;
      };
      var expandRng = function (editor, rng, format, remove) {
        var endPoint, startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
        var dom = editor.dom;
        if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
          startContainer = getNode(startContainer, startOffset);
          if (startContainer.nodeType === 3) {
            startOffset = 0;
          }
        }
        if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
          endContainer = getNode(endContainer, rng.collapsed ? endOffset : endOffset - 1);
          if (endContainer.nodeType === 3) {
            endOffset = endContainer.nodeValue.length;
          }
        }
        startContainer = findParentContentEditable(dom, startContainer);
        endContainer = findParentContentEditable(dom, endContainer);
        if (isBookmarkNode$2(startContainer.parentNode) || isBookmarkNode$2(startContainer)) {
          startContainer = isBookmarkNode$2(startContainer) ? startContainer : startContainer.parentNode;
          startContainer = startContainer.nextSibling || startContainer;
          if (startContainer.nodeType === 3) {
            startOffset = 0;
          }
        }
        if (isBookmarkNode$2(endContainer.parentNode) || isBookmarkNode$2(endContainer)) {
          endContainer = isBookmarkNode$2(endContainer) ? endContainer : endContainer.parentNode;
          endContainer = endContainer.previousSibling || endContainer;
          if (endContainer.nodeType === 3) {
            endOffset = endContainer.length;
          }
        }
        if (format[0].inline) {
          if (rng.collapsed) {
            endPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, remove);
            if (endPoint) {
              startContainer = endPoint.container;
              startOffset = endPoint.offset;
            }
            endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, remove);
            if (endPoint) {
              endContainer = endPoint.container;
              endOffset = endPoint.offset;
            }
          }
          endContainer = remove ? endContainer : excludeTrailingWhitespace(endContainer, endOffset);
        }
        if (format[0].inline || format[0].block_expand) {
          if (!format[0].inline || (startContainer.nodeType !== 3 || startOffset === 0)) {
            startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
          }
          if (!format[0].inline || (endContainer.nodeType !== 3 || endOffset === endContainer.nodeValue.length)) {
            endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
          }
        }
        if (format[0].selector && format[0].expand !== false && !format[0].inline) {
          startContainer = findSelectorEndPoint(dom, format, rng, startContainer, 'previousSibling');
          endContainer = findSelectorEndPoint(dom, format, rng, endContainer, 'nextSibling');
        }
        if (format[0].block || format[0].selector) {
          startContainer = findBlockEndPoint(editor, format, startContainer, 'previousSibling');
          endContainer = findBlockEndPoint(editor, format, endContainer, 'nextSibling');
          if (format[0].block) {
            if (!dom.isBlock(startContainer)) {
              startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
            }
            if (!dom.isBlock(endContainer)) {
              endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
            }
          }
        }
        if (startContainer.nodeType === 1) {
          startOffset = dom.nodeIndex(startContainer);
          startContainer = startContainer.parentNode;
        }
        if (endContainer.nodeType === 1) {
          endOffset = dom.nodeIndex(endContainer) + 1;
          endContainer = endContainer.parentNode;
        }
        return {
          startContainer: startContainer,
          startOffset: startOffset,
          endContainer: endContainer,
          endOffset: endOffset
        };
      };
      var $_fryklb5sjh8lyxd9 = { expandRng: expandRng };

      var isEq$4 = $_dodtof5tjh8lyxdh.isEq;
      var matchesUnInheritedFormatSelector = function (ed, node, name) {
        var formatList = ed.formatter.get(name);
        if (formatList) {
          for (var i = 0; i < formatList.length; i++) {
            if (formatList[i].inherit === false && ed.dom.is(node, formatList[i].selector)) {
              return true;
            }
          }
        }
        return false;
      };
      var matchParents = function (editor, node, name, vars) {
        var root = editor.dom.getRoot();
        if (node === root) {
          return false;
        }
        node = editor.dom.getParent(node, function (node) {
          if (matchesUnInheritedFormatSelector(editor, node, name)) {
            return true;
          }
          return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
        });
        return matchNode(editor, node, name, vars);
      };
      var matchName = function (dom, node, format) {
        if (isEq$4(node, format.inline)) {
          return true;
        }
        if (isEq$4(node, format.block)) {
          return true;
        }
        if (format.selector) {
          return node.nodeType === 1 && dom.is(node, format.selector);
        }
      };
      var matchItems = function (dom, node, format, itemName, similar, vars) {
        var key, value;
        var items = format[itemName];
        var i;
        if (format.onmatch) {
          return format.onmatch(node, format, itemName);
        }
        if (items) {
          if (typeof items.length === 'undefined') {
            for (key in items) {
              if (items.hasOwnProperty(key)) {
                if (itemName === 'attributes') {
                  value = dom.getAttrib(node, key);
                } else {
                  value = $_dodtof5tjh8lyxdh.getStyle(dom, node, key);
                }
                if (similar && !value && !format.exact) {
                  return;
                }
                if ((!similar || format.exact) && !isEq$4(value, $_dodtof5tjh8lyxdh.normalizeStyleValue(dom, $_dodtof5tjh8lyxdh.replaceVars(items[key], vars), key))) {
                  return;
                }
              }
            }
          } else {
            for (i = 0; i < items.length; i++) {
              if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : $_dodtof5tjh8lyxdh.getStyle(dom, node, items[i])) {
                return format;
              }
            }
          }
        }
        return format;
      };
      var matchNode = function (ed, node, name, vars, similar) {
        var formatList = ed.formatter.get(name);
        var format, i, x, classes;
        var dom = ed.dom;
        if (formatList && node) {
          for (i = 0; i < formatList.length; i++) {
            format = formatList[i];
            if (matchName(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
              if (classes = format.classes) {
                for (x = 0; x < classes.length; x++) {
                  if (!ed.dom.hasClass(node, classes[x])) {
                    return;
                  }
                }
              }
              return format;
            }
          }
        }
      };
      var match = function (editor, name, vars, node) {
        var startNode;
        if (node) {
          return matchParents(editor, node, name, vars);
        }
        node = editor.selection.getNode();
        if (matchParents(editor, node, name, vars)) {
          return true;
        }
        startNode = editor.selection.getStart();
        if (startNode !== node) {
          if (matchParents(editor, startNode, name, vars)) {
            return true;
          }
        }
        return false;
      };
      var matchAll = function (editor, names, vars) {
        var startElement;
        var matchedFormatNames = [];
        var checkedMap = {};
        startElement = editor.selection.getStart();
        editor.dom.getParent(startElement, function (node) {
          var i, name;
          for (i = 0; i < names.length; i++) {
            name = names[i];
            if (!checkedMap[name] && matchNode(editor, node, name, vars)) {
              checkedMap[name] = true;
              matchedFormatNames.push(name);
            }
          }
        }, editor.dom.getRoot());
        return matchedFormatNames;
      };
      var canApply = function (editor, name) {
        var formatList = editor.formatter.get(name);
        var startNode, parents, i, x, selector;
        var dom = editor.dom;
        if (formatList) {
          startNode = editor.selection.getStart();
          parents = $_dodtof5tjh8lyxdh.getParents(dom, startNode);
          for (x = formatList.length - 1; x >= 0; x--) {
            selector = formatList[x].selector;
            if (!selector || formatList[x].defaultBlock) {
              return true;
            }
            for (i = parents.length - 1; i >= 0; i--) {
              if (dom.is(parents[i], selector)) {
                return true;
              }
            }
          }
        }
        return false;
      };
      var $_8qd8fq5ujh8lyxdx = {
        matchNode: matchNode,
        matchName: matchName,
        match: match,
        matchAll: matchAll,
        canApply: canApply,
        matchesUnInheritedFormatSelector: matchesUnInheritedFormatSelector
      };

      var splitText = function (node, offset) {
        return node.splitText(offset);
      };
      var split$1 = function (rng) {
        var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
        if (startContainer === endContainer && $_5oonaz1qjh8lywhz.isText(startContainer)) {
          if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
            endContainer = splitText(startContainer, startOffset);
            startContainer = endContainer.previousSibling;
            if (endOffset > startOffset) {
              endOffset = endOffset - startOffset;
              startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
              endOffset = endContainer.nodeValue.length;
              startOffset = 0;
            } else {
              endOffset = 0;
            }
          }
        } else {
          if ($_5oonaz1qjh8lywhz.isText(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
            startContainer = splitText(startContainer, startOffset);
            startOffset = 0;
          }
          if ($_5oonaz1qjh8lywhz.isText(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
            endContainer = splitText(endContainer, endOffset).previousSibling;
            endOffset = endContainer.nodeValue.length;
          }
        }
        return {
          startContainer: startContainer,
          startOffset: startOffset,
          endContainer: endContainer,
          endOffset: endOffset
        };
      };
      var $_5hrcpr5vjh8lyxe2 = { split: split$1 };

      var ZWSP$1 = $_d383mr21jh8lywlv.ZWSP;
      var CARET_ID$1 = '_mce_caret';
      var importNode = function (ownerDocument, node) {
        return ownerDocument.importNode(node, true);
      };
      var getEmptyCaretContainers = function (node) {
        var nodes = [];
        while (node) {
          if (node.nodeType === 3 && node.nodeValue !== ZWSP$1 || node.childNodes.length > 1) {
            return [];
          }
          if (node.nodeType === 1) {
            nodes.push(node);
          }
          node = node.firstChild;
        }
        return nodes;
      };
      var isCaretContainerEmpty = function (node) {
        return getEmptyCaretContainers(node).length > 0;
      };
      var findFirstTextNode = function (node) {
        var walker;
        if (node) {
          walker = new TreeWalker(node, node);
          for (node = walker.current(); node; node = walker.next()) {
            if (node.nodeType === 3) {
              return node;
            }
          }
        }
        return null;
      };
      var createCaretContainer = function (fill) {
        var caretContainer = $_cgttw3zjh8lywdq.fromTag('span');
        $_3da62i14jh8lyweo.setAll(caretContainer, {
          'id': CARET_ID$1,
          'data-mce-bogus': '1',
          'data-mce-type': 'format-caret'
        });
        if (fill) {
          $_4m7u2e2kjh8lywpi.append(caretContainer, $_cgttw3zjh8lywdq.fromText(ZWSP$1));
        }
        return caretContainer;
      };
      var trimZwspFromCaretContainer = function (caretContainerNode) {
        var textNode = findFirstTextNode(caretContainerNode);
        if (textNode && textNode.nodeValue.charAt(0) === ZWSP$1) {
          textNode.deleteData(0, 1);
        }
        return textNode;
      };
      var removeCaretContainerNode = function (dom, selection, node, moveCaret) {
        var rng, block, textNode;
        rng = selection.getRng(true);
        block = dom.getParent(node, dom.isBlock);
        if (isCaretContainerEmpty(node)) {
          if (moveCaret !== false) {
            rng.setStartBefore(node);
            rng.setEndBefore(node);
          }
          dom.remove(node);
        } else {
          textNode = trimZwspFromCaretContainer(node);
          if (rng.startContainer === textNode && rng.startOffset > 0) {
            rng.setStart(textNode, rng.startOffset - 1);
          }
          if (rng.endContainer === textNode && rng.endOffset > 0) {
            rng.setEnd(textNode, rng.endOffset - 1);
          }
          dom.remove(node, true);
        }
        if (block && dom.isEmpty(block)) {
          $_2bvsfb2tjh8lywqo.fillWithPaddingBr($_cgttw3zjh8lywdq.fromDom(block));
        }
        selection.setRng(rng);
      };
      var removeCaretContainer = function (body, dom, selection, node, moveCaret) {
        if (!node) {
          node = getParentCaretContainer(body, selection.getStart());
          if (!node) {
            while (node = dom.get(CARET_ID$1)) {
              removeCaretContainerNode(dom, selection, node, false);
            }
          }
        } else {
          removeCaretContainerNode(dom, selection, node, moveCaret);
        }
      };
      var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
        var dom = editor.dom, block = dom.getParent(formatNode, $_8aqzj925jh8lywmj.curry($_dodtof5tjh8lyxdh.isTextBlock, editor));
        if (block && dom.isEmpty(block)) {
          formatNode.parentNode.replaceChild(caretContainer, formatNode);
        } else {
          $_2bvsfb2tjh8lywqo.removeTrailingBr($_cgttw3zjh8lywdq.fromDom(formatNode));
          if (dom.isEmpty(formatNode)) {
            formatNode.parentNode.replaceChild(caretContainer, formatNode);
          } else {
            dom.insertAfter(caretContainer, formatNode);
          }
        }
      };
      var appendNode = function (parentNode, node) {
        parentNode.appendChild(node);
        return node;
      };
      var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
        var innerMostFormatNode = $_5wjzy24jh8lyw2t.foldr(formatNodes, function (parentNode, formatNode) {
          return appendNode(parentNode, formatNode.cloneNode(false));
        }, caretContainer);
        return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP$1));
      };
      var applyCaretFormat = function (editor, name, vars) {
        var rng, caretContainer, textNode, offset, bookmark, container, text;
        var selection = editor.selection;
        rng = selection.getRng(true);
        offset = rng.startOffset;
        container = rng.startContainer;
        text = container.nodeValue;
        caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
        if (caretContainer) {
          textNode = findFirstTextNode(caretContainer);
        }
        var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
        if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
          bookmark = selection.getBookmark();
          rng.collapse(true);
          rng = $_fryklb5sjh8lyxd9.expandRng(editor, rng, editor.formatter.get(name));
          rng = $_5hrcpr5vjh8lyxe2.split(rng);
          editor.formatter.apply(name, vars, rng);
          selection.moveToBookmark(bookmark);
        } else {
          if (!caretContainer || textNode.nodeValue !== ZWSP$1) {
            caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom());
            textNode = caretContainer.firstChild;
            rng.insertNode(caretContainer);
            offset = 1;
            editor.formatter.apply(name, vars, caretContainer);
          } else {
            editor.formatter.apply(name, vars, caretContainer);
          }
          selection.setCursorLocation(textNode, offset);
        }
      };
      var removeCaretFormat = function (editor, name, vars, similar) {
        var dom = editor.dom, selection = editor.selection;
        var container, offset, bookmark;
        var hasContentAfter, node, formatNode;
        var parents = [], rng = selection.getRng();
        var caretContainer;
        container = rng.startContainer;
        offset = rng.startOffset;
        node = container;
        if (container.nodeType === 3) {
          if (offset !== container.nodeValue.length) {
            hasContentAfter = true;
          }
          node = node.parentNode;
        }
        while (node) {
          if ($_8qd8fq5ujh8lyxdx.matchNode(editor, node, name, vars, similar)) {
            formatNode = node;
            break;
          }
          if (node.nextSibling) {
            hasContentAfter = true;
          }
          parents.push(node);
          node = node.parentNode;
        }
        if (!formatNode) {
          return;
        }
        if (hasContentAfter) {
          bookmark = selection.getBookmark();
          rng.collapse(true);
          var expandedRng = $_fryklb5sjh8lyxd9.expandRng(editor, rng, editor.formatter.get(name), true);
          expandedRng = $_5hrcpr5vjh8lyxe2.split(expandedRng);
          editor.formatter.remove(name, vars, expandedRng);
          selection.moveToBookmark(bookmark);
        } else {
          caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
          var newCaretContainer = createCaretContainer(false).dom();
          var caretNode = insertFormatNodesIntoCaretContainer(parents, newCaretContainer);
          if (caretContainer) {
            insertCaretContainerNode(editor, newCaretContainer, caretContainer);
          } else {
            insertCaretContainerNode(editor, newCaretContainer, formatNode);
          }
          removeCaretContainerNode(dom, selection, caretContainer, false);
          selection.setCursorLocation(caretNode, 1);
          if (dom.isEmpty(formatNode)) {
            dom.remove(formatNode);
          }
        }
      };
      var disableCaretContainer = function (body, dom, selection, keyCode) {
        removeCaretContainer(body, dom, selection, null, false);
        if (keyCode === 8 && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP$1) {
          removeCaretContainer(body, dom, selection, getParentCaretContainer(body, selection.getStart()));
        }
        if (keyCode === 37 || keyCode === 39) {
          removeCaretContainer(body, dom, selection, getParentCaretContainer(body, selection.getStart()));
        }
      };
      var setup$2 = function (editor) {
        var dom = editor.dom, selection = editor.selection;
        var body = editor.getBody();
        editor.on('mouseup keydown', function (e) {
          disableCaretContainer(body, dom, selection, e.keyCode);
        });
      };
      var replaceWithCaretFormat = function (targetNode, formatNodes) {
        var caretContainer = createCaretContainer(false);
        var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom());
        $_4m7u2e2kjh8lywpi.before($_cgttw3zjh8lywdq.fromDom(targetNode), caretContainer);
        $_bfmuql2ujh8lywr1.remove($_cgttw3zjh8lywdq.fromDom(targetNode));
        return CaretPosition$1(innerMost, 0);
      };
      var isFormatElement = function (editor, element) {
        var inlineElements = editor.schema.getTextInlineElements();
        return inlineElements.hasOwnProperty($_7j1jt210jh8lywdx.name(element)) && !isCaretNode(element.dom()) && !$_5oonaz1qjh8lywhz.isBogus(element.dom());
      };

      var postProcessHooks = {};
      var filter$2 = $_9tjm51ljh8lywbq.filter;
      var each$11 = $_9tjm51ljh8lywbq.each;
      var addPostProcessHook = function (name, hook) {
        var hooks = postProcessHooks[name];
        if (!hooks) {
          postProcessHooks[name] = hooks = [];
        }
        postProcessHooks[name].push(hook);
      };
      var postProcess = function (name, editor) {
        each$11(postProcessHooks[name], function (hook) {
          hook(editor);
        });
      };
      addPostProcessHook('pre', function (editor) {
        var rng = editor.selection.getRng();
        var isPre, blocks;
        var hasPreSibling = function (pre) {
          return isPre(pre.previousSibling) && $_9tjm51ljh8lywbq.indexOf(blocks, pre.previousSibling) !== -1;
        };
        var joinPre = function (pre1, pre2) {
          DomQuery(pre2).remove();
          DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
        };
        isPre = $_5oonaz1qjh8lywhz.matchNodeNames('pre');
        if (!rng.collapsed) {
          blocks = editor.selection.getSelectedBlocks();
          each$11(filter$2(filter$2(blocks, isPre), hasPreSibling), function (pre) {
            joinPre(pre.previousSibling, pre);
          });
        }
      });
      var $_78e03d5wjh8lyxe4 = { postProcess: postProcess };

      var each$12 = $_ahowuxkjh8lywbj.each;
      var getEndChild = function (container, index) {
        var childNodes = container.childNodes;
        index--;
        if (index > childNodes.length - 1) {
          index = childNodes.length - 1;
        } else if (index < 0) {
          index = 0;
        }
        return childNodes[index] || container;
      };
      var walk$2 = function (dom, rng, callback) {
        var startContainer = rng.startContainer;
        var startOffset = rng.startOffset;
        var endContainer = rng.endContainer;
        var endOffset = rng.endOffset;
        var ancestor;
        var startPoint;
        var endPoint;
        var node;
        var parent;
        var siblings;
        var nodes;
        nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
        if (nodes.length > 0) {
          each$12(nodes, function (node) {
            callback([node]);
          });
          return;
        }
        var exclude = function (nodes) {
          var node;
          node = nodes[0];
          if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
            nodes.splice(0, 1);
          }
          node = nodes[nodes.length - 1];
          if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
            nodes.splice(nodes.length - 1, 1);
          }
          return nodes;
        };
        var collectSiblings = function (node, name, endNode) {
          var siblings = [];
          for (; node && node !== endNode; node = node[name]) {
            siblings.push(node);
          }
          return siblings;
        };
        var findEndPoint = function (node, root) {
          do {
            if (node.parentNode === root) {
              return node;
            }
            node = node.parentNode;
          } while (node);
        };
        var walkBoundary = function (startNode, endNode, next) {
          var siblingName = next ? 'nextSibling' : 'previousSibling';
          for (node = startNode, parent = node.parentNode; node && node !== endNode; node = parent) {
            parent = node.parentNode;
            siblings = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
            if (siblings.length) {
              if (!next) {
                siblings.reverse();
              }
              callback(exclude(siblings));
            }
          }
        };
        if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
          startContainer = startContainer.childNodes[startOffset];
        }
        if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
          endContainer = getEndChild(endContainer, endOffset);
        }
        if (startContainer === endContainer) {
          return callback(exclude([startContainer]));
        }
        ancestor = dom.findCommonAncestor(startContainer, endContainer);
        for (node = startContainer; node; node = node.parentNode) {
          if (node === endContainer) {
            return walkBoundary(startContainer, ancestor, true);
          }
          if (node === ancestor) {
            break;
          }
        }
        for (node = endContainer; node; node = node.parentNode) {
          if (node === startContainer) {
            return walkBoundary(endContainer, ancestor);
          }
          if (node === ancestor) {
            break;
          }
        }
        startPoint = findEndPoint(startContainer, ancestor) || startContainer;
        endPoint = findEndPoint(endContainer, ancestor) || endContainer;
        walkBoundary(startContainer, startPoint, true);
        siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
        if (siblings.length) {
          callback(exclude(siblings));
        }
        walkBoundary(endContainer, endPoint);
      };
      var $_90itx05zjh8lyxeq = { walk: walk$2 };

      var MCE_ATTR_RE = /^(src|href|style)$/;
      var each$13 = $_ahowuxkjh8lywbj.each;
      var isEq$5 = $_dodtof5tjh8lyxdh.isEq;
      var isTableCell$4 = function (node) {
        return /^(TH|TD)$/.test(node.nodeName);
      };
      var getContainer = function (ed, rng, start) {
        var container, offset, lastIdx;
        container = rng[start ? 'startContainer' : 'endContainer'];
        offset = rng[start ? 'startOffset' : 'endOffset'];
        if ($_5oonaz1qjh8lywhz.isElement(container)) {
          lastIdx = container.childNodes.length - 1;
          if (!start && offset) {
            offset--;
          }
          container = container.childNodes[offset > lastIdx ? lastIdx : offset];
        }
        if ($_5oonaz1qjh8lywhz.isText(container) && start && offset >= container.nodeValue.length) {
          container = new TreeWalker(container, ed.getBody()).next() || container;
        }
        if ($_5oonaz1qjh8lywhz.isText(container) && !start && offset === 0) {
          container = new TreeWalker(container, ed.getBody()).prev() || container;
        }
        return container;
      };
      var wrap$2 = function (dom, node, name, attrs) {
        var wrapper = dom.create(name, attrs);
        node.parentNode.insertBefore(wrapper, node);
        wrapper.appendChild(node);
        return wrapper;
      };
      var matchName$1 = function (dom, node, format) {
        if (isEq$5(node, format.inline)) {
          return true;
        }
        if (isEq$5(node, format.block)) {
          return true;
        }
        if (format.selector) {
          return $_5oonaz1qjh8lywhz.isElement(node) && dom.is(node, format.selector);
        }
      };
      var isColorFormatAndAnchor = function (node, format) {
        return format.links && node.tagName === 'A';
      };
      var find$4 = function (dom, node, next, inc) {
        node = $_dodtof5tjh8lyxdh.getNonWhiteSpaceSibling(node, next, inc);
        return !node || (node.nodeName === 'BR' || dom.isBlock(node));
      };
      var removeNode$1 = function (ed, node, format) {
        var parentNode = node.parentNode;
        var rootBlockElm;
        var dom = ed.dom, forcedRootBlock = ed.settings.forced_root_block;
        if (format.block) {
          if (!forcedRootBlock) {
            if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
              if (!find$4(dom, node, false) && !find$4(dom, node.firstChild, true, 1)) {
                node.insertBefore(dom.create('br'), node.firstChild);
              }
              if (!find$4(dom, node, true) && !find$4(dom, node.lastChild, false, 1)) {
                node.appendChild(dom.create('br'));
              }
            }
          } else {
            if (parentNode === dom.getRoot()) {
              if (!format.list_block || !isEq$5(node, format.list_block)) {
                each$13($_ahowuxkjh8lywbj.grep(node.childNodes), function (node) {
                  if ($_dodtof5tjh8lyxdh.isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
                    if (!rootBlockElm) {
                      rootBlockElm = wrap$2(dom, node, forcedRootBlock);
                      dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
                    } else {
                      rootBlockElm.appendChild(node);
                    }
                  } else {
                    rootBlockElm = 0;
                  }
                });
              }
            }
          }
        }
        if (format.selector && format.inline && !isEq$5(format.inline, node)) {
          return;
        }
        dom.remove(node, 1);
      };
      var removeFormat = function (ed, format, vars, node, compareNode) {
        var i, attrs, stylesModified;
        var dom = ed.dom;
        if (!matchName$1(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
          return false;
        }
        if (format.remove !== 'all') {
          each$13(format.styles, function (value, name) {
            value = $_dodtof5tjh8lyxdh.normalizeStyleValue(dom, $_dodtof5tjh8lyxdh.replaceVars(value, vars), name);
            if (typeof name === 'number') {
              name = value;
              compareNode = 0;
            }
            if (format.remove_similar || (!compareNode || isEq$5($_dodtof5tjh8lyxdh.getStyle(dom, compareNode, name), value))) {
              dom.setStyle(node, name, '');
            }
            stylesModified = 1;
          });
          if (stylesModified && dom.getAttrib(node, 'style') === '') {
            node.removeAttribute('style');
            node.removeAttribute('data-mce-style');
          }
          each$13(format.attributes, function (value, name) {
            var valueOut;
            value = $_dodtof5tjh8lyxdh.replaceVars(value, vars);
            if (typeof name === 'number') {
              name = value;
              compareNode = 0;
            }
            if (!compareNode || isEq$5(dom.getAttrib(compareNode, name), value)) {
              if (name === 'class') {
                value = dom.getAttrib(node, name);
                if (value) {
                  valueOut = '';
                  each$13(value.split(/\s+/), function (cls) {
                    if (/mce\-\w+/.test(cls)) {
                      valueOut += (valueOut ? ' ' : '') + cls;
                    }
                  });
                  if (valueOut) {
                    dom.setAttrib(node, name, valueOut);
                    return;
                  }
                }
              }
              if (name === 'class') {
                node.removeAttribute('className');
              }
              if (MCE_ATTR_RE.test(name)) {
                node.removeAttribute('data-mce-' + name);
              }
              node.removeAttribute(name);
            }
          });
          each$13(format.classes, function (value) {
            value = $_dodtof5tjh8lyxdh.replaceVars(value, vars);
            if (!compareNode || dom.hasClass(compareNode, value)) {
              dom.removeClass(node, value);
            }
          });
          attrs = dom.getAttribs(node);
          for (i = 0; i < attrs.length; i++) {
            var attrName = attrs[i].nodeName;
            if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
              return false;
            }
          }
        }
        if (format.remove !== 'none') {
          removeNode$1(ed, node, format);
          return true;
        }
      };
      var findFormatRoot = function (editor, container, name, vars, similar) {
        var formatRoot;
        each$13($_dodtof5tjh8lyxdh.getParents(editor.dom, container.parentNode).reverse(), function (parent) {
          var format;
          if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
            format = $_8qd8fq5ujh8lyxdx.matchNode(editor, parent, name, vars, similar);
            if (format && format.split !== false) {
              formatRoot = parent;
            }
          }
        });
        return formatRoot;
      };
      var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
        var parent, clone, lastClone, firstClone, i, formatRootParent;
        var dom = editor.dom;
        if (formatRoot) {
          formatRootParent = formatRoot.parentNode;
          for (parent = container.parentNode; parent && parent !== formatRootParent; parent = parent.parentNode) {
            clone = dom.clone(parent, false);
            for (i = 0; i < formatList.length; i++) {
              if (removeFormat(editor, formatList[i], vars, clone, clone)) {
                clone = 0;
                break;
              }
            }
            if (clone) {
              if (lastClone) {
                clone.appendChild(lastClone);
              }
              if (!firstClone) {
                firstClone = clone;
              }
              lastClone = clone;
            }
          }
          if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
            container = dom.split(formatRoot, container);
          }
          if (lastClone) {
            target.parentNode.insertBefore(lastClone, target);
            firstClone.appendChild(target);
          }
        }
        return container;
      };
      var remove$7 = function (ed, name, vars, node, similar) {
        var formatList = ed.formatter.get(name), format = formatList[0];
        var bookmark, rng, contentEditable = true;
        var dom = ed.dom;
        var selection = ed.selection;
        var splitToFormatRoot = function (container) {
          var formatRoot = findFormatRoot(ed, container, name, vars, similar);
          return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
        };
        var process = function (node) {
          var children, i, l, lastContentEditable, hasContentEditableState;
          if ($_5oonaz1qjh8lywhz.isElement(node) && dom.getContentEditable(node)) {
            lastContentEditable = contentEditable;
            contentEditable = dom.getContentEditable(node) === 'true';
            hasContentEditableState = true;
          }
          children = $_ahowuxkjh8lywbj.grep(node.childNodes);
          if (contentEditable && !hasContentEditableState) {
            for (i = 0, l = formatList.length; i < l; i++) {
              if (removeFormat(ed, formatList[i], vars, node, node)) {
                break;
              }
            }
          }
          if (format.deep) {
            if (children.length) {
              for (i = 0, l = children.length; i < l; i++) {
                process(children[i]);
              }
              if (hasContentEditableState) {
                contentEditable = lastContentEditable;
              }
            }
          }
        };
        var unwrap = function (start) {
          var node = dom.get(start ? '_start' : '_end');
          var out = node[start ? 'firstChild' : 'lastChild'];
          if ($_eyp5ec2njh8lywpo.isBookmarkNode(out)) {
            out = out[start ? 'firstChild' : 'lastChild'];
          }
          if ($_5oonaz1qjh8lywhz.isText(out) && out.data.length === 0) {
            out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
          }
          dom.remove(node, true);
          return out;
        };
        var removeRngStyle = function (rng) {
          var startContainer, endContainer;
          var commonAncestorContainer = rng.commonAncestorContainer;
          rng = $_fryklb5sjh8lyxd9.expandRng(ed, rng, formatList, true);
          if (format.split) {
            startContainer = getContainer(ed, rng, true);
            endContainer = getContainer(ed, rng);
            if (startContainer !== endContainer) {
              if (/^(TR|TH|TD)$/.test(startContainer.nodeName) && startContainer.firstChild) {
                if (startContainer.nodeName === 'TR') {
                  startContainer = startContainer.firstChild.firstChild || startContainer;
                } else {
                  startContainer = startContainer.firstChild || startContainer;
                }
              }
              if (commonAncestorContainer && /^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName) && isTableCell$4(endContainer) && endContainer.firstChild) {
                endContainer = endContainer.firstChild || endContainer;
              }
              if (dom.isChildOf(startContainer, endContainer) && startContainer !== endContainer && !dom.isBlock(endContainer) && !isTableCell$4(startContainer) && !isTableCell$4(endContainer)) {
                startContainer = wrap$2(dom, startContainer, 'span', {
                  'id': '_start',
                  'data-mce-type': 'bookmark'
                });
                splitToFormatRoot(startContainer);
                startContainer = unwrap(true);
                return;
              }
              startContainer = wrap$2(dom, startContainer, 'span', {
                'id': '_start',
                'data-mce-type': 'bookmark'
              });
              endContainer = wrap$2(dom, endContainer, 'span', {
                'id': '_end',
                'data-mce-type': 'bookmark'
              });
              splitToFormatRoot(startContainer);
              splitToFormatRoot(endContainer);
              startContainer = unwrap(true);
              endContainer = unwrap();
            } else {
              startContainer = endContainer = splitToFormatRoot(startContainer);
            }
            rng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
            rng.startOffset = dom.nodeIndex(startContainer);
            rng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
            rng.endOffset = dom.nodeIndex(endContainer) + 1;
          }
          $_90itx05zjh8lyxeq.walk(dom, rng, function (nodes) {
            each$13(nodes, function (node) {
              process(node);
              if ($_5oonaz1qjh8lywhz.isElement(node) && ed.dom.getStyle(node, 'text-decoration') === 'underline' && node.parentNode && $_dodtof5tjh8lyxdh.getTextDecoration(dom, node.parentNode) === 'underline') {
                removeFormat(ed, {
                  deep: false,
                  exact: true,
                  inline: 'span',
                  styles: { textDecoration: 'underline' }
                }, null, node);
              }
            });
          });
        };
        if (node) {
          if (node.nodeType) {
            rng = dom.createRng();
            rng.setStartBefore(node);
            rng.setEndAfter(node);
            removeRngStyle(rng);
          } else {
            removeRngStyle(node);
          }
          return;
        }
        if (dom.getContentEditable(selection.getNode()) === 'false') {
          node = selection.getNode();
          for (var i = 0, l = formatList.length; i < l; i++) {
            if (formatList[i].ceFalseOverride) {
              if (removeFormat(ed, formatList[i], vars, node, node)) {
                break;
              }
            }
          }
          return;
        }
        if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
          bookmark = $_8b82yg2ojh8lywpq.getPersistentBookmark(ed.selection, true);
          removeRngStyle(selection.getRng());
          selection.moveToBookmark(bookmark);
          if (format.inline && $_8qd8fq5ujh8lyxdx.match(ed, name, vars, selection.getStart())) {
            $_dodtof5tjh8lyxdh.moveStart(dom, selection, selection.getRng());
          }
          ed.nodeChanged();
        } else {
          removeCaretFormat(ed, name, vars, similar);
        }
      };
      var $_7cys7h5yjh8lyxeg = {
        removeFormat: removeFormat,
        remove: remove$7
      };

      var each$14 = $_ahowuxkjh8lywbj.each;
      var isElementNode = function (node) {
        return node && node.nodeType === 1 && !$_eyp5ec2njh8lywpo.isBookmarkNode(node) && !isCaretNode(node) && !$_5oonaz1qjh8lywhz.isBogus(node);
      };
      var findElementSibling = function (node, siblingName) {
        var sibling;
        for (sibling = node; sibling; sibling = sibling[siblingName]) {
          if (sibling.nodeType === 3 && sibling.nodeValue.length !== 0) {
            return node;
          }
          if (sibling.nodeType === 1 && !$_eyp5ec2njh8lywpo.isBookmarkNode(sibling)) {
            return sibling;
          }
        }
        return node;
      };
      var mergeSiblingsNodes = function (dom, prev, next) {
        var sibling, tmpSibling;
        var elementUtils = new ElementUtils(dom);
        if (prev && next) {
          prev = findElementSibling(prev, 'previousSibling');
          next = findElementSibling(next, 'nextSibling');
          if (elementUtils.compare(prev, next)) {
            for (sibling = prev.nextSibling; sibling && sibling !== next;) {
              tmpSibling = sibling;
              sibling = sibling.nextSibling;
              prev.appendChild(tmpSibling);
            }
            dom.remove(next);
            $_ahowuxkjh8lywbj.each($_ahowuxkjh8lywbj.grep(next.childNodes), function (node) {
              prev.appendChild(node);
            });
            return prev;
          }
        }
        return next;
      };
      var processChildElements = function (node, filter, process) {
        each$14(node.childNodes, function (node) {
          if (isElementNode(node)) {
            if (filter(node)) {
              process(node);
            }
            if (node.hasChildNodes()) {
              processChildElements(node, filter, process);
            }
          }
        });
      };
      var hasStyle = function (dom, name) {
        return $_eqpqvr6jh8lyw3s.curry(function (name, node) {
          return !!(node && $_dodtof5tjh8lyxdh.getStyle(dom, node, name));
        }, name);
      };
      var applyStyle = function (dom, name, value) {
        return $_eqpqvr6jh8lyw3s.curry(function (name, value, node) {
          dom.setStyle(node, name, value);
          if (node.getAttribute('style') === '') {
            node.removeAttribute('style');
          }
          unwrapEmptySpan(dom, node);
        }, name, value);
      };
      var unwrapEmptySpan = function (dom, node) {
        if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
          dom.remove(node, true);
        }
      };
      var processUnderlineAndColor = function (dom, node) {
        var textDecoration;
        if (node.nodeType === 1 && node.parentNode && node.parentNode.nodeType === 1) {
          textDecoration = $_dodtof5tjh8lyxdh.getTextDecoration(dom, node.parentNode);
          if (dom.getStyle(node, 'color') && textDecoration) {
            dom.setStyle(node, 'text-decoration', textDecoration);
          } else if (dom.getStyle(node, 'text-decoration') === textDecoration) {
            dom.setStyle(node, 'text-decoration', null);
          }
        }
      };
      var mergeUnderlineAndColor = function (dom, format, vars, node) {
        if (format.styles.color || format.styles.textDecoration) {
          $_ahowuxkjh8lywbj.walk(node, $_eqpqvr6jh8lyw3s.curry(processUnderlineAndColor, dom), 'childNodes');
          processUnderlineAndColor(dom, node);
        }
      };
      var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
        if (format.styles && format.styles.backgroundColor) {
          processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', $_dodtof5tjh8lyxdh.replaceVars(format.styles.backgroundColor, vars)));
        }
      };
      var mergeSubSup = function (dom, format, vars, node) {
        if (format.inline === 'sub' || format.inline === 'sup') {
          processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
          dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
        }
      };
      var mergeSiblings = function (dom, format, vars, node) {
        if (node && format.merge_siblings !== false) {
          node = mergeSiblingsNodes(dom, $_dodtof5tjh8lyxdh.getNonWhiteSpaceSibling(node), node);
          node = mergeSiblingsNodes(dom, node, $_dodtof5tjh8lyxdh.getNonWhiteSpaceSibling(node, true));
        }
      };
      var clearChildStyles = function (dom, format, node) {
        if (format.clear_child_styles) {
          var selector = format.links ? '*:not(a)' : '*';
          each$14(dom.select(selector, node), function (node) {
            if (isElementNode(node)) {
              each$14(format.styles, function (value, name) {
                dom.setStyle(node, name, '');
              });
            }
          });
        }
      };
      var mergeWithChildren = function (editor, formatList, vars, node) {
        each$14(formatList, function (format) {
          each$14(editor.dom.select(format.inline, node), function (child) {
            if (!isElementNode(child)) {
              return;
            }
            $_7cys7h5yjh8lyxeg.removeFormat(editor, format, vars, child, format.exact ? child : null);
          });
          clearChildStyles(editor.dom, format, node);
        });
      };
      var mergeWithParents = function (editor, format, name, vars, node) {
        if ($_8qd8fq5ujh8lyxdx.matchNode(editor, node.parentNode, name, vars)) {
          if ($_7cys7h5yjh8lyxeg.removeFormat(editor, format, vars, node)) {
            return;
          }
        }
        if (format.merge_with_parents) {
          editor.dom.getParent(node.parentNode, function (parent) {
            if ($_8qd8fq5ujh8lyxdx.matchNode(editor, parent, name, vars)) {
              $_7cys7h5yjh8lyxeg.removeFormat(editor, format, vars, node);
              return true;
            }
          });
        }
      };
      var $_3fattg5xjh8lyxe7 = {
        mergeWithChildren: mergeWithChildren,
        mergeUnderlineAndColor: mergeUnderlineAndColor,
        mergeBackgroundColorAndFontSize: mergeBackgroundColorAndFontSize,
        mergeSubSup: mergeSubSup,
        mergeSiblings: mergeSiblings,
        mergeWithParents: mergeWithParents
      };

      var each$15 = $_ahowuxkjh8lywbj.each;
      var isElementNode$1 = function (node) {
        return node && node.nodeType === 1 && !$_eyp5ec2njh8lywpo.isBookmarkNode(node) && !isCaretNode(node) && !$_5oonaz1qjh8lywhz.isBogus(node);
      };
      var applyFormat = function (ed, name, vars, node) {
        var formatList = ed.formatter.get(name);
        var format = formatList[0];
        var bookmark, rng;
        var isCollapsed = !node && ed.selection.isCollapsed();
        var dom = ed.dom, selection = ed.selection;
        var setElementFormat = function (elm, fmt) {
          fmt = fmt || format;
          if (elm) {
            if (fmt.onformat) {
              fmt.onformat(elm, fmt, vars, node);
            }
            each$15(fmt.styles, function (value, name) {
              dom.setStyle(elm, name, $_dodtof5tjh8lyxdh.replaceVars(value, vars));
            });
            if (fmt.styles) {
              var styleVal = dom.getAttrib(elm, 'style');
              if (styleVal) {
                elm.setAttribute('data-mce-style', styleVal);
              }
            }
            each$15(fmt.attributes, function (value, name) {
              dom.setAttrib(elm, name, $_dodtof5tjh8lyxdh.replaceVars(value, vars));
            });
            each$15(fmt.classes, function (value) {
              value = $_dodtof5tjh8lyxdh.replaceVars(value, vars);
              if (!dom.hasClass(elm, value)) {
                dom.addClass(elm, value);
              }
            });
          }
        };
        var applyNodeStyle = function (formatList, node) {
          var found = false;
          if (!format.selector) {
            return false;
          }
          each$15(formatList, function (format) {
            if ('collapsed' in format && format.collapsed !== isCollapsed) {
              return;
            }
            if (dom.is(node, format.selector) && !isCaretNode(node)) {
              setElementFormat(node, format);
              found = true;
              return false;
            }
          });
          return found;
        };
        var applyRngStyle = function (dom, rng, bookmark, nodeSpecific) {
          var newWrappers = [];
          var wrapName, wrapElm, contentEditable = true;
          wrapName = format.inline || format.block;
          wrapElm = dom.create(wrapName);
          setElementFormat(wrapElm);
          $_90itx05zjh8lyxeq.walk(dom, rng, function (nodes) {
            var currentWrapElm;
            var process = function (node) {
              var nodeName, parentName, hasContentEditableState, lastContentEditable;
              lastContentEditable = contentEditable;
              nodeName = node.nodeName.toLowerCase();
              parentName = node.parentNode.nodeName.toLowerCase();
              if (node.nodeType === 1 && dom.getContentEditable(node)) {
                lastContentEditable = contentEditable;
                contentEditable = dom.getContentEditable(node) === 'true';
                hasContentEditableState = true;
              }
              if ($_dodtof5tjh8lyxdh.isEq(nodeName, 'br')) {
                currentWrapElm = 0;
                if (format.block) {
                  dom.remove(node);
                }
                return;
              }
              if (format.wrapper && $_8qd8fq5ujh8lyxdx.matchNode(ed, node, name, vars)) {
                currentWrapElm = 0;
                return;
              }
              if (contentEditable && !hasContentEditableState && format.block && !format.wrapper && $_dodtof5tjh8lyxdh.isTextBlock(ed, nodeName) && $_dodtof5tjh8lyxdh.isValid(ed, parentName, wrapName)) {
                node = dom.rename(node, wrapName);
                setElementFormat(node);
                newWrappers.push(node);
                currentWrapElm = 0;
                return;
              }
              if (format.selector) {
                var found = applyNodeStyle(formatList, node);
                if (!format.inline || found) {
                  currentWrapElm = 0;
                  return;
                }
              }
              if (contentEditable && !hasContentEditableState && $_dodtof5tjh8lyxdh.isValid(ed, wrapName, nodeName) && $_dodtof5tjh8lyxdh.isValid(ed, parentName, wrapName) && !(!nodeSpecific && node.nodeType === 3 && node.nodeValue.length === 1 && node.nodeValue.charCodeAt(0) === 65279) && !isCaretNode(node) && (!format.inline || !dom.isBlock(node))) {
                if (!currentWrapElm) {
                  currentWrapElm = dom.clone(wrapElm, false);
                  node.parentNode.insertBefore(currentWrapElm, node);
                  newWrappers.push(currentWrapElm);
                }
                currentWrapElm.appendChild(node);
              } else {
                currentWrapElm = 0;
                each$15($_ahowuxkjh8lywbj.grep(node.childNodes), process);
                if (hasContentEditableState) {
                  contentEditable = lastContentEditable;
                }
                currentWrapElm = 0;
              }
            };
            each$15(nodes, process);
          });
          if (format.links === true) {
            each$15(newWrappers, function (node) {
              var process = function (node) {
                if (node.nodeName === 'A') {
                  setElementFormat(node, format);
                }
                each$15($_ahowuxkjh8lywbj.grep(node.childNodes), process);
              };
              process(node);
            });
          }
          each$15(newWrappers, function (node) {
            var childCount;
            var getChildCount = function (node) {
              var count = 0;
              each$15(node.childNodes, function (node) {
                if (!$_dodtof5tjh8lyxdh.isWhiteSpaceNode(node) && !$_eyp5ec2njh8lywpo.isBookmarkNode(node)) {
                  count++;
                }
              });
              return count;
            };
            var getChildElementNode = function (root) {
              var child = false;
              each$15(root.childNodes, function (node) {
                if (isElementNode$1(node)) {
                  child = node;
                  return false;
                }
              });
              return child;
            };
            var mergeStyles = function (node) {
              var child, clone;
              child = getChildElementNode(node);
              if (child && !$_eyp5ec2njh8lywpo.isBookmarkNode(child) && $_8qd8fq5ujh8lyxdx.matchName(dom, child, format)) {
                clone = dom.clone(child, false);
                setElementFormat(clone);
                dom.replace(clone, node, true);
                dom.remove(child, 1);
              }
              return clone || node;
            };
            childCount = getChildCount(node);
            if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
              dom.remove(node, 1);
              return;
            }
            if (format.inline || format.wrapper) {
              if (!format.exact && childCount === 1) {
                node = mergeStyles(node);
              }
              $_3fattg5xjh8lyxe7.mergeWithChildren(ed, formatList, vars, node);
              $_3fattg5xjh8lyxe7.mergeWithParents(ed, format, name, vars, node);
              $_3fattg5xjh8lyxe7.mergeBackgroundColorAndFontSize(dom, format, vars, node);
              $_3fattg5xjh8lyxe7.mergeSubSup(dom, format, vars, node);
              $_3fattg5xjh8lyxe7.mergeSiblings(dom, format, vars, node);
            }
          });
        };
        if (dom.getContentEditable(selection.getNode()) === 'false') {
          node = selection.getNode();
          for (var i = 0, l = formatList.length; i < l; i++) {
            if (formatList[i].ceFalseOverride && dom.is(node, formatList[i].selector)) {
              setElementFormat(node, formatList[i]);
              return;
            }
          }
          return;
        }
        if (format) {
          if (node) {
            if (node.nodeType) {
              if (!applyNodeStyle(formatList, node)) {
                rng = dom.createRng();
                rng.setStartBefore(node);
                rng.setEndAfter(node);
                applyRngStyle(dom, $_fryklb5sjh8lyxd9.expandRng(ed, rng, formatList), null, true);
              }
            } else {
              applyRngStyle(dom, node, null, true);
            }
          } else {
            if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
              var curSelNode = ed.selection.getNode();
              if (!ed.settings.forced_root_block && formatList[0].defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
                applyFormat(ed, formatList[0].defaultBlock);
              }
              ed.selection.setRng($_cnbluh30jh8lywrn.normalize(ed.selection.getRng()));
              bookmark = $_8b82yg2ojh8lywpq.getPersistentBookmark(ed.selection, true);
              applyRngStyle(dom, $_fryklb5sjh8lyxd9.expandRng(ed, selection.getRng(), formatList), bookmark);
              if (format.styles) {
                $_3fattg5xjh8lyxe7.mergeUnderlineAndColor(dom, format, vars, curSelNode);
              }
              selection.moveToBookmark(bookmark);
              $_dodtof5tjh8lyxdh.moveStart(dom, selection, selection.getRng());
              ed.nodeChanged();
            } else {
              applyCaretFormat(ed, name, vars);
            }
          }
          $_78e03d5wjh8lyxe4.postProcess(name, ed);
        }
      };
      var $_36ocwe5qjh8lyxck = { applyFormat: applyFormat };

      var each$16 = $_ahowuxkjh8lywbj.each;
      var setup$3 = function (formatChangeData, editor) {
        var currentFormats = {};
        formatChangeData.set({});
        editor.on('NodeChange', function (e) {
          var parents = $_dodtof5tjh8lyxdh.getParents(editor.dom, e.element);
          var matchedFormats = {};
          parents = $_ahowuxkjh8lywbj.grep(parents, function (node) {
            return node.nodeType === 1 && !node.getAttribute('data-mce-bogus');
          });
          each$16(formatChangeData.get(), function (callbacks, format) {
            each$16(parents, function (node) {
              if (editor.formatter.matchNode(node, format, {}, callbacks.similar)) {
                if (!currentFormats[format]) {
                  each$16(callbacks, function (callback) {
                    callback(true, {
                      node: node,
                      format: format,
                      parents: parents
                    });
                  });
                  currentFormats[format] = callbacks;
                }
                matchedFormats[format] = callbacks;
                return false;
              }
              if ($_8qd8fq5ujh8lyxdx.matchesUnInheritedFormatSelector(editor, node, format)) {
                return false;
              }
            });
          });
          each$16(currentFormats, function (callbacks, format) {
            if (!matchedFormats[format]) {
              delete currentFormats[format];
              each$16(callbacks, function (callback) {
                callback(false, {
                  node: e.element,
                  format: format,
                  parents: parents
                });
              });
            }
          });
        });
      };
      var addListeners = function (formatChangeData, formats, callback, similar) {
        var formatChangeItems = formatChangeData.get();
        each$16(formats.split(','), function (format) {
          if (!formatChangeItems[format]) {
            formatChangeItems[format] = [];
            formatChangeItems[format].similar = similar;
          }
          formatChangeItems[format].push(callback);
        });
        formatChangeData.set(formatChangeItems);
      };
      var formatChanged = function (editor, formatChangeState, formats, callback, similar) {
        if (formatChangeState.get() === null) {
          setup$3(formatChangeState, editor);
        }
        addListeners(formatChangeState, formats, callback, similar);
      };
      var $_cpfal560jh8lyxeu = { formatChanged: formatChanged };

      var get$6 = function (dom) {
        var formats = {
          valigntop: [{
              selector: 'td,th',
              styles: { verticalAlign: 'top' }
            }],
          valignmiddle: [{
              selector: 'td,th',
              styles: { verticalAlign: 'middle' }
            }],
          valignbottom: [{
              selector: 'td,th',
              styles: { verticalAlign: 'bottom' }
            }],
          alignleft: [
            {
              selector: 'figure.image',
              collapsed: false,
              classes: 'align-left',
              ceFalseOverride: true,
              preview: 'font-family font-size'
            },
            {
              selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
              styles: { textAlign: 'left' },
              inherit: false,
              preview: false,
              defaultBlock: 'div'
            },
            {
              selector: 'img,table',
              collapsed: false,
              styles: { float: 'left' },
              preview: 'font-family font-size'
            }
          ],
          aligncenter: [
            {
              selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
              styles: { textAlign: 'center' },
              inherit: false,
              preview: 'font-family font-size',
              defaultBlock: 'div'
            },
            {
              selector: 'figure.image',
              collapsed: false,
              classes: 'align-center',
              ceFalseOverride: true,
              preview: 'font-family font-size'
            },
            {
              selector: 'img',
              collapsed: false,
              styles: {
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto'
              },
              preview: false
            },
            {
              selector: 'table',
              collapsed: false,
              styles: {
                marginLeft: 'auto',
                marginRight: 'auto'
              },
              preview: 'font-family font-size'
            }
          ],
          alignright: [
            {
              selector: 'figure.image',
              collapsed: false,
              classes: 'align-right',
              ceFalseOverride: true,
              preview: 'font-family font-size'
            },
            {
              selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
              styles: { textAlign: 'right' },
              inherit: false,
              preview: 'font-family font-size',
              defaultBlock: 'div'
            },
            {
              selector: 'img,table',
              collapsed: false,
              styles: { float: 'right' },
              preview: 'font-family font-size'
            }
          ],
          alignjustify: [{
              selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
              styles: { textAlign: 'justify' },
              inherit: false,
              defaultBlock: 'div',
              preview: 'font-family font-size'
            }],
          bold: [
            {
              inline: 'strong',
              remove: 'all'
            },
            {
              inline: 'span',
              styles: { fontWeight: 'bold' }
            },
            {
              inline: 'b',
              remove: 'all'
            }
          ],
          italic: [
            {
              inline: 'em',
              remove: 'all'
            },
            {
              inline: 'span',
              styles: { fontStyle: 'italic' }
            },
            {
              inline: 'i',
              remove: 'all'
            }
          ],
          underline: [
            {
              inline: 'span',
              styles: { textDecoration: 'underline' },
              exact: true
            },
            {
              inline: 'u',
              remove: 'all'
            }
          ],
          strikethrough: [
            {
              inline: 'span',
              styles: { textDecoration: 'line-through' },
              exact: true
            },
            {
              inline: 'strike',
              remove: 'all'
            }
          ],
          forecolor: {
            inline: 'span',
            styles: { color: '%value' },
            links: true,
            remove_similar: true,
            clear_child_styles: true
          },
          hilitecolor: {
            inline: 'span',
            styles: { backgroundColor: '%value' },
            links: true,
            remove_similar: true,
            clear_child_styles: true
          },
          fontname: {
            inline: 'span',
            toggle: false,
            styles: { fontFamily: '%value' },
            clear_child_styles: true
          },
          fontsize: {
            inline: 'span',
            toggle: false,
            styles: { fontSize: '%value' },
            clear_child_styles: true
          },
          fontsize_class: {
            inline: 'span',
            attributes: { class: '%value' }
          },
          blockquote: {
            block: 'blockquote',
            wrapper: 1,
            remove: 'all'
          },
          subscript: { inline: 'sub' },
          superscript: { inline: 'sup' },
          code: { inline: 'code' },
          link: {
            inline: 'a',
            selector: 'a',
            remove: 'all',
            split: true,
            deep: true,
            onmatch: function () {
              return true;
            },
            onformat: function (elm, fmt, vars) {
              $_ahowuxkjh8lywbj.each(vars, function (value, key) {
                dom.setAttrib(elm, key, value);
              });
            }
          },
          removeformat: [
            {
              selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
              remove: 'all',
              split: true,
              expand: false,
              block_expand: true,
              deep: true
            },
            {
              selector: 'span',
              attributes: [
                'style',
                'class'
              ],
              remove: 'empty',
              split: true,
              expand: false,
              deep: true
            },
            {
              selector: '*',
              attributes: [
                'style',
                'class'
              ],
              split: false,
              expand: false,
              deep: true
            }
          ]
        };
        $_ahowuxkjh8lywbj.each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function (name) {
          formats[name] = {
            block: name,
            remove: 'all'
          };
        });
        return formats;
      };
      var $_3zwfyl62jh8lyxez = { get: get$6 };

      function FormatRegistry (editor) {
        var formats = {};
        var get = function (name) {
          return name ? formats[name] : formats;
        };
        var register = function (name, format) {
          if (name) {
            if (typeof name !== 'string') {
              $_ahowuxkjh8lywbj.each(name, function (format, name) {
                register(name, format);
              });
            } else {
              format = format.length ? format : [format];
              $_ahowuxkjh8lywbj.each(format, function (format) {
                if (typeof format.deep === 'undefined') {
                  format.deep = !format.selector;
                }
                if (typeof format.split === 'undefined') {
                  format.split = !format.selector || format.inline;
                }
                if (typeof format.remove === 'undefined' && format.selector && !format.inline) {
                  format.remove = 'none';
                }
                if (format.selector && format.inline) {
                  format.mixed = true;
                  format.block_expand = true;
                }
                if (typeof format.classes === 'string') {
                  format.classes = format.classes.split(/\s+/);
                }
              });
              formats[name] = format;
            }
          }
        };
        var unregister = function (name) {
          if (name && formats[name]) {
            delete formats[name];
          }
          return formats;
        };
        register($_3zwfyl62jh8lyxez.get(editor.dom));
        register(editor.settings.formats);
        return {
          get: get,
          register: register,
          unregister: unregister
        };
      }

      var each$17 = $_ahowuxkjh8lywbj.each;
      var dom = DOMUtils$1.DOM;
      var parsedSelectorToHtml = function (ancestry, editor) {
        var elm, item, fragment;
        var schema = editor && editor.schema || Schema({});
        var decorate = function (elm, item) {
          if (item.classes.length) {
            dom.addClass(elm, item.classes.join(' '));
          }
          dom.setAttribs(elm, item.attrs);
        };
        var createElement = function (sItem) {
          var elm;
          item = typeof sItem === 'string' ? {
            name: sItem,
            classes: [],
            attrs: {}
          } : sItem;
          elm = dom.create(item.name);
          decorate(elm, item);
          return elm;
        };
        var getRequiredParent = function (elm, candidate) {
          var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
          var elmRule = schema.getElementRule(name);
          var parentsRequired = elmRule && elmRule.parentsRequired;
          if (parentsRequired && parentsRequired.length) {
            return candidate && $_ahowuxkjh8lywbj.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
          } else {
            return false;
          }
        };
        var wrapInHtml = function (elm, ancestry, siblings) {
          var parent, parentCandidate, parentRequired;
          var ancestor = ancestry.length > 0 && ancestry[0];
          var ancestorName = ancestor && ancestor.name;
          parentRequired = getRequiredParent(elm, ancestorName);
          if (parentRequired) {
            if (ancestorName === parentRequired) {
              parentCandidate = ancestry[0];
              ancestry = ancestry.slice(1);
            } else {
              parentCandidate = parentRequired;
            }
          } else if (ancestor) {
            parentCandidate = ancestry[0];
            ancestry = ancestry.slice(1);
          } else if (!siblings) {
            return elm;
          }
          if (parentCandidate) {
            parent = createElement(parentCandidate);
            parent.appendChild(elm);
          }
          if (siblings) {
            if (!parent) {
              parent = dom.create('div');
              parent.appendChild(elm);
            }
            $_ahowuxkjh8lywbj.each(siblings, function (sibling) {
              var siblingElm = createElement(sibling);
              parent.insertBefore(siblingElm, elm);
            });
          }
          return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
        };
        if (ancestry && ancestry.length) {
          item = ancestry[0];
          elm = createElement(item);
          fragment = dom.create('div');
          fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
          return fragment;
        } else {
          return '';
        }
      };
      var selectorToHtml = function (selector, editor) {
        return parsedSelectorToHtml(parseSelector(selector), editor);
      };
      var parseSelectorItem = function (item) {
        var tagName;
        var obj = {
          classes: [],
          attrs: {}
        };
        item = obj.selector = $_ahowuxkjh8lywbj.trim(item);
        if (item !== '*') {
          tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
            switch ($1) {
            case '#':
              obj.attrs.id = $2;
              break;
            case '.':
              obj.classes.push($2);
              break;
            case ':':
              if ($_ahowuxkjh8lywbj.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
                obj.attrs[$2] = $2;
              }
              break;
            }
            if ($3 === '[') {
              var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
              if (m) {
                obj.attrs[m[1]] = m[2];
              }
            }
            return '';
          });
        }
        obj.name = tagName || 'div';
        return obj;
      };
      var parseSelector = function (selector) {
        if (!selector || typeof selector !== 'string') {
          return [];
        }
        selector = selector.split(/\s*,\s*/)[0];
        selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
        return $_ahowuxkjh8lywbj.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
          var siblings = $_ahowuxkjh8lywbj.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
          var obj = siblings.pop();
          if (siblings.length) {
            obj.siblings = siblings;
          }
          return obj;
        }).reverse();
      };
      var getCssText = function (editor, format) {
        var name, previewFrag, previewElm, items;
        var previewCss = '', parentFontSize, previewStyles;
        previewStyles = editor.settings.preview_styles;
        if (previewStyles === false) {
          return '';
        }
        if (typeof previewStyles !== 'string') {
          previewStyles = 'font-family font-size font-weight font-style text-decoration ' + 'text-transform color background-color border border-radius outline text-shadow';
        }
        var removeVars = function (val) {
          return val.replace(/%(\w+)/g, '');
        };
        if (typeof format === 'string') {
          format = editor.formatter.get(format);
          if (!format) {
            return;
          }
          format = format[0];
        }
        if ('preview' in format) {
          previewStyles = format.preview;
          if (previewStyles === false) {
            return '';
          }
        }
        name = format.block || format.inline || 'span';
        items = parseSelector(format.selector);
        if (items.length) {
          if (!items[0].name) {
            items[0].name = name;
          }
          name = format.selector;
          previewFrag = parsedSelectorToHtml(items, editor);
        } else {
          previewFrag = parsedSelectorToHtml([name], editor);
        }
        previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
        each$17(format.styles, function (value, name) {
          value = removeVars(value);
          if (value) {
            dom.setStyle(previewElm, name, value);
          }
        });
        each$17(format.attributes, function (value, name) {
          value = removeVars(value);
          if (value) {
            dom.setAttrib(previewElm, name, value);
          }
        });
        each$17(format.classes, function (value) {
          value = removeVars(value);
          if (!dom.hasClass(previewElm, value)) {
            dom.addClass(previewElm, value);
          }
        });
        editor.fire('PreviewFormats');
        dom.setStyles(previewFrag, {
          position: 'absolute',
          left: -65535
        });
        editor.getBody().appendChild(previewFrag);
        parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
        parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
        each$17(previewStyles.split(' '), function (name) {
          var value = dom.getStyle(previewElm, name, true);
          if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
            value = dom.getStyle(editor.getBody(), name, true);
            if (dom.toHex(value).toLowerCase() === '#ffffff') {
              return;
            }
          }
          if (name === 'color') {
            if (dom.toHex(value).toLowerCase() === '#000000') {
              return;
            }
          }
          if (name === 'font-size') {
            if (/em|%$/.test(value)) {
              if (parentFontSize === 0) {
                return;
              }
              var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
              value = numValue * parentFontSize + 'px';
            }
          }
          if (name === 'border' && value) {
            previewCss += 'padding:0 2px;';
          }
          previewCss += name + ':' + value + ';';
        });
        editor.fire('AfterPreviewFormats');
        dom.remove(previewFrag);
        return previewCss;
      };
      var $_fwiqkm63jh8lyxf5 = {
        getCssText: getCssText,
        parseSelector: parseSelector,
        selectorToHtml: selectorToHtml
      };

      var toggle$2 = function (editor, formats, name, vars, node) {
        var fmt = formats.get(name);
        if ($_8qd8fq5ujh8lyxdx.match(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
          $_7cys7h5yjh8lyxeg.remove(editor, name, vars, node);
        } else {
          $_36ocwe5qjh8lyxck.applyFormat(editor, name, vars, node);
        }
      };
      var $_5bc2se64jh8lyxfc = { toggle: toggle$2 };

      var setup$4 = function (editor) {
        editor.addShortcut('meta+b', '', 'Bold');
        editor.addShortcut('meta+i', '', 'Italic');
        editor.addShortcut('meta+u', '', 'Underline');
        for (var i = 1; i <= 6; i++) {
          editor.addShortcut('access+' + i, '', [
            'FormatBlock',
            false,
            'h' + i
          ]);
        }
        editor.addShortcut('access+7', '', [
          'FormatBlock',
          false,
          'p'
        ]);
        editor.addShortcut('access+8', '', [
          'FormatBlock',
          false,
          'div'
        ]);
        editor.addShortcut('access+9', '', [
          'FormatBlock',
          false,
          'address'
        ]);
      };
      var $_3p946b65jh8lyxfe = { setup: setup$4 };

      function Formatter (editor) {
        var formats = FormatRegistry(editor);
        var formatChangeState = Cell(null);
        $_3p946b65jh8lyxfe.setup(editor);
        setup$2(editor);
        return {
          get: formats.get,
          register: formats.register,
          unregister: formats.unregister,
          apply: $_eqpqvr6jh8lyw3s.curry($_36ocwe5qjh8lyxck.applyFormat, editor),
          remove: $_eqpqvr6jh8lyw3s.curry($_7cys7h5yjh8lyxeg.remove, editor),
          toggle: $_eqpqvr6jh8lyw3s.curry($_5bc2se64jh8lyxfc.toggle, editor, formats),
          match: $_eqpqvr6jh8lyw3s.curry($_8qd8fq5ujh8lyxdx.match, editor),
          matchAll: $_eqpqvr6jh8lyw3s.curry($_8qd8fq5ujh8lyxdx.matchAll, editor),
          matchNode: $_eqpqvr6jh8lyw3s.curry($_8qd8fq5ujh8lyxdx.matchNode, editor),
          canApply: $_eqpqvr6jh8lyw3s.curry($_8qd8fq5ujh8lyxdx.canApply, editor),
          formatChanged: $_eqpqvr6jh8lyw3s.curry($_cpfal560jh8lyxeu.formatChanged, editor, formatChangeState),
          getCssText: $_eqpqvr6jh8lyw3s.curry($_fwiqkm63jh8lyxf5.getCssText, editor)
        };
      }

      var shallow = function (old, nu) {
        return nu;
      };
      var deep = function (old, nu) {
        var bothObjects = $_dp4g6d7jh8lyw3y.isObject(old) && $_dp4g6d7jh8lyw3y.isObject(nu);
        return bothObjects ? deepMerge(old, nu) : nu;
      };
      var baseMerge = function (merger) {
        return function () {
          var objects = new Array(arguments.length);
          for (var i = 0; i < objects.length; i++)
            objects[i] = arguments[i];
          if (objects.length === 0)
            throw new Error('Can\'t merge zero objects');
          var ret = {};
          for (var j = 0; j < objects.length; j++) {
            var curObject = objects[j];
            for (var key in curObject)
              if (curObject.hasOwnProperty(key)) {
                ret[key] = merger(ret[key], curObject[key]);
              }
          }
          return ret;
        };
      };
      var deepMerge = baseMerge(deep);
      var merge = baseMerge(shallow);
      var $_7ffry568jh8lyxfy = {
        deepMerge: deepMerge,
        merge: merge
      };

      var register = function (htmlParser, settings, dom) {
        htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
            node.attr(name, null);
          }
        });
        htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
          var i = nodes.length, node, value;
          var internalName = 'data-mce-' + name;
          var urlConverter = settings.url_converter;
          var urlConverterScope = settings.url_converter_scope;
          while (i--) {
            node = nodes[i];
            value = node.attributes.map[internalName];
            if (value !== undefined) {
              node.attr(name, value.length > 0 ? value : null);
              node.attr(internalName, null);
            } else {
              value = node.attributes.map[name];
              if (name === 'style') {
                value = dom.serializeStyle(dom.parseStyle(value), node.name);
              } else if (urlConverter) {
                value = urlConverter.call(urlConverterScope, value, name, node.name);
              }
              node.attr(name, value.length > 0 ? value : null);
            }
          }
        });
        htmlParser.addAttributeFilter('class', function (nodes) {
          var i = nodes.length, node, value;
          while (i--) {
            node = nodes[i];
            value = node.attr('class');
            if (value) {
              value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
              node.attr('class', value.length > 0 ? value : null);
            }
          }
        });
        htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            if (node.attributes.map['data-mce-type'] === 'bookmark' && !args.cleanup) {
              node.remove();
            }
          }
        });
        htmlParser.addNodeFilter('noscript', function (nodes) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i].firstChild;
            if (node) {
              node.value = $_gex7a11rjh8lywi4.decode(node.value);
            }
          }
        });
        htmlParser.addNodeFilter('script,style', function (nodes, name) {
          var i = nodes.length, node, value, type;
          var trim = function (value) {
            return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
          };
          while (i--) {
            node = nodes[i];
            value = node.firstChild ? node.firstChild.value : '';
            if (name === 'script') {
              type = node.attr('type');
              if (type) {
                node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
              }
              if (settings.element_format === 'xhtml' && value.length > 0) {
                node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
              }
            } else {
              if (settings.element_format === 'xhtml' && value.length > 0) {
                node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
              }
            }
          }
        });
        htmlParser.addNodeFilter('#comment', function (nodes) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            if (node.value.indexOf('[CDATA[') === 0) {
              node.name = '#cdata';
              node.type = 4;
              node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '');
            } else if (node.value.indexOf('mce:protected ') === 0) {
              node.name = '#text';
              node.type = 3;
              node.raw = true;
              node.value = unescape(node.value).substr(14);
            }
          }
        });
        htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            if (node.type === 7) {
              node.remove();
            } else if (node.type === 1) {
              if (name === 'input' && !('type' in node.attributes.map)) {
                node.attr('type', 'text');
              }
            }
          }
        });
        htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
          $_5wjzy24jh8lyw2t.each(nodes, function (node) {
            if (node.attr('data-mce-type') === 'format-caret') {
              if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
                node.remove();
              } else {
                node.unwrap();
              }
            }
          });
        });
        htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize', function (nodes, name) {
          var i = nodes.length;
          while (i--) {
            nodes[i].attr(name, null);
          }
        });
      };
      var trimTrailingBr = function (rootNode) {
        var brNode1, brNode2;
        var isBr = function (node) {
          return node && node.name === 'br';
        };
        brNode1 = rootNode.lastChild;
        if (isBr(brNode1)) {
          brNode2 = brNode1.prev;
          if (isBr(brNode2)) {
            brNode1.remove();
            brNode2.remove();
          }
        }
      };
      var $_834niu69jh8lyxg1 = {
        register: register,
        trimTrailingBr: trimTrailingBr
      };

      var preProcess = function (editor, node, args) {
        var impl, doc, oldDoc;
        var dom = editor.dom;
        node = node.cloneNode(true);
        impl = document.implementation;
        if (impl.createHTMLDocument) {
          doc = impl.createHTMLDocument('');
          $_ahowuxkjh8lywbj.each(node.nodeName === 'BODY' ? node.childNodes : [node], function (node) {
            doc.body.appendChild(doc.importNode(node, true));
          });
          if (node.nodeName !== 'BODY') {
            node = doc.body.firstChild;
          } else {
            node = doc.body;
          }
          oldDoc = dom.doc;
          dom.doc = doc;
        }
        $_a4fgrn4cjh8lyx4q.firePreProcess(editor, $_7ffry568jh8lyxfy.merge(args, { node: node }));
        if (oldDoc) {
          dom.doc = oldDoc;
        }
        return node;
      };
      var shouldFireEvent = function (editor, args) {
        return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
      };
      var process = function (editor, node, args) {
        return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
      };
      var $_gg1aca6ajh8lyxg7 = { process: process };

      var removeAttrs = function (node, names) {
        $_5wjzy24jh8lyw2t.each(names, function (name) {
          node.attr(name, null);
        });
      };
      var addFontToSpansFilter = function (domParser, styles, fontSizes) {
        domParser.addNodeFilter('font', function (nodes) {
          $_5wjzy24jh8lyw2t.each(nodes, function (node) {
            var props = styles.parse(node.attr('style'));
            var color = node.attr('color');
            var face = node.attr('face');
            var size = node.attr('size');
            if (color) {
              props.color = color;
            }
            if (face) {
              props['font-family'] = face;
            }
            if (size) {
              props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
            }
            node.name = 'span';
            node.attr('style', styles.serialize(props));
            removeAttrs(node, [
              'color',
              'face',
              'size'
            ]);
          });
        });
      };
      var addStrikeToSpanFilter = function (domParser, styles) {
        domParser.addNodeFilter('strike', function (nodes) {
          $_5wjzy24jh8lyw2t.each(nodes, function (node) {
            var props = styles.parse(node.attr('style'));
            props['text-decoration'] = 'line-through';
            node.name = 'span';
            node.attr('style', styles.serialize(props));
          });
        });
      };
      var addFilters = function (domParser, settings) {
        var styles = Styles();
        if (settings.convert_fonts_to_spans) {
          addFontToSpansFilter(domParser, styles, $_ahowuxkjh8lywbj.explode(settings.font_size_legacy_values));
        }
        addStrikeToSpanFilter(domParser, styles);
      };
      var register$1 = function (domParser, settings) {
        if (settings.inline_styles) {
          addFilters(domParser, settings);
        }
      };
      var $_9ewhzh6cjh8lyxgp = { register: register$1 };

      var whiteSpaceRegExp$3 = /^[ \t\r\n]*$/;
      var typeLookup = {
        '#text': 3,
        '#comment': 8,
        '#cdata': 4,
        '#pi': 7,
        '#doctype': 10,
        '#document-fragment': 11
      };
      var walk$3 = function (node, root, prev) {
        var sibling;
        var parent;
        var startName = prev ? 'lastChild' : 'firstChild';
        var siblingName = prev ? 'prev' : 'next';
        if (node[startName]) {
          return node[startName];
        }
        if (node !== root) {
          sibling = node[siblingName];
          if (sibling) {
            return sibling;
          }
          for (parent = node.parent; parent && parent !== root; parent = parent.parent) {
            sibling = parent[siblingName];
            if (sibling) {
              return sibling;
            }
          }
        }
      };
      var Node$2 = function () {
        function Node(name, type) {
          this.name = name;
          this.type = type;
          if (type === 1) {
            this.attributes = [];
            this.attributes.map = {};
          }
        }
        Node.create = function (name, attrs) {
          var node, attrName;
          node = new Node(name, typeLookup[name] || 1);
          if (attrs) {
            for (attrName in attrs) {
              node.attr(attrName, attrs[attrName]);
            }
          }
          return node;
        };
        Node.prototype.replace = function (node) {
          var self = this;
          if (node.parent) {
            node.remove();
          }
          self.insert(node, self);
          self.remove();
          return self;
        };
        Node.prototype.attr = function (name, value) {
          var self = this;
          var attrs, i;
          if (typeof name !== 'string') {
            for (i in name) {
              self.attr(i, name[i]);
            }
            return self;
          }
          if (attrs = self.attributes) {
            if (value !== undefined) {
              if (value === null) {
                if (name in attrs.map) {
                  delete attrs.map[name];
                  i = attrs.length;
                  while (i--) {
                    if (attrs[i].name === name) {
                      attrs = attrs.splice(i, 1);
                      return self;
                    }
                  }
                }
                return self;
              }
              if (name in attrs.map) {
                i = attrs.length;
                while (i--) {
                  if (attrs[i].name === name) {
                    attrs[i].value = value;
                    break;
                  }
                }
              } else {
                attrs.push({
                  name: name,
                  value: value
                });
              }
              attrs.map[name] = value;
              return self;
            }
            return attrs.map[name];
          }
        };
        Node.prototype.clone = function () {
          var self = this;
          var clone = new Node(self.name, self.type);
          var i, l, selfAttrs, selfAttr, cloneAttrs;
          if (selfAttrs = self.attributes) {
            cloneAttrs = [];
            cloneAttrs.map = {};
            for (i = 0, l = selfAttrs.length; i < l; i++) {
              selfAttr = selfAttrs[i];
              if (selfAttr.name !== 'id') {
                cloneAttrs[cloneAttrs.length] = {
                  name: selfAttr.name,
                  value: selfAttr.value
                };
                cloneAttrs.map[selfAttr.name] = selfAttr.value;
              }
            }
            clone.attributes = cloneAttrs;
          }
          clone.value = self.value;
          clone.shortEnded = self.shortEnded;
          return clone;
        };
        Node.prototype.wrap = function (wrapper) {
          var self = this;
          self.parent.insert(wrapper, self);
          wrapper.append(self);
          return self;
        };
        Node.prototype.unwrap = function () {
          var self = this;
          var node, next;
          for (node = self.firstChild; node;) {
            next = node.next;
            self.insert(node, self, true);
            node = next;
          }
          self.remove();
        };
        Node.prototype.remove = function () {
          var self = this, parent = self.parent, next = self.next, prev = self.prev;
          if (parent) {
            if (parent.firstChild === self) {
              parent.firstChild = next;
              if (next) {
                next.prev = null;
              }
            } else {
              prev.next = next;
            }
            if (parent.lastChild === self) {
              parent.lastChild = prev;
              if (prev) {
                prev.next = null;
              }
            } else {
              next.prev = prev;
            }
            self.parent = self.next = self.prev = null;
          }
          return self;
        };
        Node.prototype.append = function (node) {
          var self = this;
          var last;
          if (node.parent) {
            node.remove();
          }
          last = self.lastChild;
          if (last) {
            last.next = node;
            node.prev = last;
            self.lastChild = node;
          } else {
            self.lastChild = self.firstChild = node;
          }
          node.parent = self;
          return node;
        };
        Node.prototype.insert = function (node, refNode, before) {
          var parent;
          if (node.parent) {
            node.remove();
          }
          parent = refNode.parent || this;
          if (before) {
            if (refNode === parent.firstChild) {
              parent.firstChild = node;
            } else {
              refNode.prev.next = node;
            }
            node.prev = refNode.prev;
            node.next = refNode;
            refNode.prev = node;
          } else {
            if (refNode === parent.lastChild) {
              parent.lastChild = node;
            } else {
              refNode.next.prev = node;
            }
            node.next = refNode.next;
            node.prev = refNode;
            refNode.next = node;
          }
          node.parent = parent;
          return node;
        };
        Node.prototype.getAll = function (name) {
          var self = this;
          var node;
          var collection = [];
          for (node = self.firstChild; node; node = walk$3(node, self)) {
            if (node.name === name) {
              collection.push(node);
            }
          }
          return collection;
        };
        Node.prototype.empty = function () {
          var self = this;
          var nodes, i, node;
          if (self.firstChild) {
            nodes = [];
            for (node = self.firstChild; node; node = walk$3(node, self)) {
              nodes.push(node);
            }
            i = nodes.length;
            while (i--) {
              node = nodes[i];
              node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
            }
          }
          self.firstChild = self.lastChild = null;
          return self;
        };
        Node.prototype.isEmpty = function (elements, whitespace, predicate) {
          var self = this;
          var node = self.firstChild, i, name;
          whitespace = whitespace || {};
          if (node) {
            do {
              if (node.type === 1) {
                if (node.attributes.map['data-mce-bogus']) {
                  continue;
                }
                if (elements[node.name]) {
                  return false;
                }
                i = node.attributes.length;
                while (i--) {
                  name = node.attributes[i].name;
                  if (name === 'name' || name.indexOf('data-mce-bookmark') === 0) {
                    return false;
                  }
                }
              }
              if (node.type === 8) {
                return false;
              }
              if (node.type === 3 && !whiteSpaceRegExp$3.test(node.value)) {
                return false;
              }
              if (node.type === 3 && node.parent && whitespace[node.parent.name] && whiteSpaceRegExp$3.test(node.value)) {
                return false;
              }
              if (predicate && predicate(node)) {
                return false;
              }
            } while (node = walk$3(node, self));
          }
          return true;
        };
        Node.prototype.walk = function (prev) {
          return walk$3(this, null, prev);
        };
        return Node;
      }();

      var paddEmptyNode = function (settings, args, blockElements, node) {
        var brPreferred = settings.padd_empty_with_br || args.insert;
        if (brPreferred && blockElements[node.name]) {
          node.empty().append(new Node$2('br', 1)).shortEnded = true;
        } else {
          node.empty().append(new Node$2('#text', 3)).value = '\xA0';
        }
      };
      var isPaddedWithNbsp = function (node) {
        return hasOnlyChild(node, '#text') && node.firstChild.value === '\xA0';
      };
      var hasOnlyChild = function (node, name) {
        return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
      };
      var isPadded = function (schema, node) {
        var rule = schema.getElementRule(node.name);
        return rule && rule.paddEmpty;
      };
      var isEmpty$2 = function (schema, nonEmptyElements, whitespaceElements, node) {
        return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
          return isPadded(schema, node);
        });
      };
      var isLineBreakNode = function (node, blockElements) {
        return node && (blockElements[node.name] || node.name === 'br');
      };

      var register$2 = function (parser, settings) {
        var schema = parser.schema;
        if (settings.remove_trailing_brs) {
          parser.addNodeFilter('br', function (nodes, _, args) {
            var i;
            var l = nodes.length;
            var node;
            var blockElements = $_ahowuxkjh8lywbj.extend({}, schema.getBlockElements());
            var nonEmptyElements = schema.getNonEmptyElements();
            var parent, lastParent, prev, prevName;
            var whiteSpaceElements = schema.getNonEmptyElements();
            var elementRule, textNode;
            blockElements.body = 1;
            for (i = 0; i < l; i++) {
              node = nodes[i];
              parent = node.parent;
              if (blockElements[node.parent.name] && node === parent.lastChild) {
                prev = node.prev;
                while (prev) {
                  prevName = prev.name;
                  if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
                    if (prevName !== 'br') {
                      break;
                    }
                    if (prevName === 'br') {
                      node = null;
                      break;
                    }
                  }
                  prev = prev.prev;
                }
                if (node) {
                  node.remove();
                  if (isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, parent)) {
                    elementRule = schema.getElementRule(parent.name);
                    if (elementRule) {
                      if (elementRule.removeEmpty) {
                        parent.remove();
                      } else if (elementRule.paddEmpty) {
                        paddEmptyNode(settings, args, blockElements, parent);
                      }
                    }
                  }
                }
              } else {
                lastParent = node;
                while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
                  lastParent = parent;
                  if (blockElements[parent.name]) {
                    break;
                  }
                  parent = parent.parent;
                }
                if (lastParent === parent && settings.padd_empty_with_br !== true) {
                  textNode = new Node$2('#text', 3);
                  textNode.value = '\xA0';
                  node.replace(textNode);
                }
              }
            }
          });
        }
        parser.addAttributeFilter('href', function (nodes) {
          var i = nodes.length, node;
          var appendRel = function (rel) {
            var parts = rel.split(' ').filter(function (p) {
              return p.length > 0;
            });
            return parts.concat(['noopener']).sort().join(' ');
          };
          var addNoOpener = function (rel) {
            var newRel = rel ? $_ahowuxkjh8lywbj.trim(rel) : '';
            if (!/\b(noopener)\b/g.test(newRel)) {
              return appendRel(newRel);
            } else {
              return newRel;
            }
          };
          if (!settings.allow_unsafe_link_target) {
            while (i--) {
              node = nodes[i];
              if (node.name === 'a' && node.attr('target') === '_blank') {
                node.attr('rel', addNoOpener(node.attr('rel')));
              }
            }
          }
        });
        if (!settings.allow_html_in_named_anchor) {
          parser.addAttributeFilter('id,name', function (nodes) {
            var i = nodes.length, sibling, prevSibling, parent, node;
            while (i--) {
              node = nodes[i];
              if (node.name === 'a' && node.firstChild && !node.attr('href')) {
                parent = node.parent;
                sibling = node.lastChild;
                do {
                  prevSibling = sibling.prev;
                  parent.insert(sibling, node);
                  sibling = prevSibling;
                } while (sibling);
              }
            }
          });
        }
        if (settings.fix_list_elements) {
          parser.addNodeFilter('ul,ol', function (nodes) {
            var i = nodes.length, node, parentNode;
            while (i--) {
              node = nodes[i];
              parentNode = node.parent;
              if (parentNode.name === 'ul' || parentNode.name === 'ol') {
                if (node.prev && node.prev.name === 'li') {
                  node.prev.append(node);
                } else {
                  var li = new Node$2('li', 1);
                  li.attr('style', 'list-style-type: none');
                  node.wrap(li);
                }
              }
            }
          });
        }
        if (settings.validate && schema.getValidClasses()) {
          parser.addAttributeFilter('class', function (nodes) {
            var i = nodes.length, node, classList, ci, className, classValue;
            var validClasses = schema.getValidClasses();
            var validClassesMap, valid;
            while (i--) {
              node = nodes[i];
              classList = node.attr('class').split(' ');
              classValue = '';
              for (ci = 0; ci < classList.length; ci++) {
                className = classList[ci];
                valid = false;
                validClassesMap = validClasses['*'];
                if (validClassesMap && validClassesMap[className]) {
                  valid = true;
                }
                validClassesMap = validClasses[node.name];
                if (!valid && validClassesMap && validClassesMap[className]) {
                  valid = true;
                }
                if (valid) {
                  if (classValue) {
                    classValue += ' ';
                  }
                  classValue += className;
                }
              }
              if (!classValue.length) {
                classValue = null;
              }
              node.attr('class', classValue);
            }
          });
        }
      };

      var makeMap$4 = $_ahowuxkjh8lywbj.makeMap;
      var each$18 = $_ahowuxkjh8lywbj.each;
      var explode$3 = $_ahowuxkjh8lywbj.explode;
      var extend$3 = $_ahowuxkjh8lywbj.extend;
      function DomParser (settings, schema) {
        if (schema === void 0) {
          schema = Schema();
        }
        var nodeFilters = {};
        var attributeFilters = [];
        var matchedNodes = {};
        var matchedAttributes = {};
        settings = settings || {};
        settings.validate = 'validate' in settings ? settings.validate : true;
        settings.root_name = settings.root_name || 'body';
        var fixInvalidChildren = function (nodes) {
          var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
          var nonEmptyElements, whitespaceElements, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
          nonSplitableElements = makeMap$4('tr,td,th,tbody,thead,tfoot,table');
          nonEmptyElements = schema.getNonEmptyElements();
          whitespaceElements = schema.getWhiteSpaceElements();
          textBlockElements = schema.getTextBlockElements();
          specialElements = schema.getSpecialElements();
          for (ni = 0; ni < nodes.length; ni++) {
            node = nodes[ni];
            if (!node.parent || node.fixed) {
              continue;
            }
            if (textBlockElements[node.name] && node.parent.name === 'li') {
              sibling = node.next;
              while (sibling) {
                if (textBlockElements[sibling.name]) {
                  sibling.name = 'li';
                  sibling.fixed = true;
                  node.parent.insert(sibling, node.parent);
                } else {
                  break;
                }
                sibling = sibling.next;
              }
              node.unwrap(node);
              continue;
            }
            parents = [node];
            for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) && !nonSplitableElements[parent.name]; parent = parent.parent) {
              parents.push(parent);
            }
            if (parent && parents.length > 1) {
              parents.reverse();
              newParent = currentNode = filterNode(parents[0].clone());
              for (i = 0; i < parents.length - 1; i++) {
                if (schema.isValidChild(currentNode.name, parents[i].name)) {
                  tempNode = filterNode(parents[i].clone());
                  currentNode.append(tempNode);
                } else {
                  tempNode = currentNode;
                }
                for (childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
                  nextNode = childNode.next;
                  tempNode.append(childNode);
                  childNode = nextNode;
                }
                currentNode = tempNode;
              }
              if (!isEmpty$2(schema, nonEmptyElements, whitespaceElements, newParent)) {
                parent.insert(newParent, parents[0], true);
                parent.insert(node, newParent);
              } else {
                parent.insert(node, parents[0], true);
              }
              parent = parents[0];
              if (isEmpty$2(schema, nonEmptyElements, whitespaceElements, parent) || hasOnlyChild(parent, 'br')) {
                parent.empty().remove();
              }
            } else if (node.parent) {
              if (node.name === 'li') {
                sibling = node.prev;
                if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
                  sibling.append(node);
                  continue;
                }
                sibling = node.next;
                if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
                  sibling.insert(node, sibling.firstChild, true);
                  continue;
                }
                node.wrap(filterNode(new Node$2('ul', 1)));
                continue;
              }
              if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
                node.wrap(filterNode(new Node$2('div', 1)));
              } else {
                if (specialElements[node.name]) {
                  node.empty().remove();
                } else {
                  node.unwrap();
                }
              }
            }
          }
        };
        var filterNode = function (node) {
          var i, name, list;
          if (name in nodeFilters) {
            list = matchedNodes[name];
            if (list) {
              list.push(node);
            } else {
              matchedNodes[name] = [node];
            }
          }
          i = attributeFilters.length;
          while (i--) {
            name = attributeFilters[i].name;
            if (name in node.attributes.map) {
              list = matchedAttributes[name];
              if (list) {
                list.push(node);
              } else {
                matchedAttributes[name] = [node];
              }
            }
          }
          return node;
        };
        var addNodeFilter = function (name, callback) {
          each$18(explode$3(name), function (name) {
            var list = nodeFilters[name];
            if (!list) {
              nodeFilters[name] = list = [];
            }
            list.push(callback);
          });
        };
        var getNodeFilters = function () {
          var out = [];
          for (var name_1 in nodeFilters) {
            if (nodeFilters.hasOwnProperty(name_1)) {
              out.push({
                name: name_1,
                callbacks: nodeFilters[name_1]
              });
            }
          }
          return out;
        };
        var addAttributeFilter = function (name, callback) {
          each$18(explode$3(name), function (name) {
            var i;
            for (i = 0; i < attributeFilters.length; i++) {
              if (attributeFilters[i].name === name) {
                attributeFilters[i].callbacks.push(callback);
                return;
              }
            }
            attributeFilters.push({
              name: name,
              callbacks: [callback]
            });
          });
        };
        var getAttributeFilters = function () {
          return [].concat(attributeFilters);
        };
        var parse = function (html, args) {
          var parser, nodes, i, l, fi, fl, list, name;
          var blockElements;
          var invalidChildren = [];
          var isInWhiteSpacePreservedElement;
          var node;
          args = args || {};
          matchedNodes = {};
          matchedAttributes = {};
          blockElements = extend$3(makeMap$4('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
          var nonEmptyElements = schema.getNonEmptyElements();
          var children = schema.children;
          var validate = settings.validate;
          var rootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
          var whiteSpaceElements = schema.getWhiteSpaceElements();
          var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
          var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
          var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
          var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
          isInWhiteSpacePreservedElement = whiteSpaceElements.hasOwnProperty(args.context) || whiteSpaceElements.hasOwnProperty(settings.root_name);
          var addRootBlocks = function () {
            var node = rootNode.firstChild, next, rootBlockNode;
            var trim = function (rootBlockNode) {
              if (rootBlockNode) {
                node = rootBlockNode.firstChild;
                if (node && node.type === 3) {
                  node.value = node.value.replace(startWhiteSpaceRegExp, '');
                }
                node = rootBlockNode.lastChild;
                if (node && node.type === 3) {
                  node.value = node.value.replace(endWhiteSpaceRegExp, '');
                }
              }
            };
            if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
              return;
            }
            while (node) {
              next = node.next;
              if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
                if (!rootBlockNode) {
                  rootBlockNode = createNode(rootBlockName, 1);
                  rootBlockNode.attr(settings.forced_root_block_attrs);
                  rootNode.insert(rootBlockNode, node);
                  rootBlockNode.append(node);
                } else {
                  rootBlockNode.append(node);
                }
              } else {
                trim(rootBlockNode);
                rootBlockNode = null;
              }
              node = next;
            }
            trim(rootBlockNode);
          };
          var createNode = function (name, type) {
            var node = new Node$2(name, type);
            var list;
            if (name in nodeFilters) {
              list = matchedNodes[name];
              if (list) {
                list.push(node);
              } else {
                matchedNodes[name] = [node];
              }
            }
            return node;
          };
          var removeWhitespaceBefore = function (node) {
            var textNode, textNodeNext, textVal, sibling;
            var blockElements = schema.getBlockElements();
            for (textNode = node.prev; textNode && textNode.type === 3;) {
              textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
              if (textVal.length > 0) {
                textNode.value = textVal;
                return;
              }
              textNodeNext = textNode.next;
              if (textNodeNext) {
                if (textNodeNext.type === 3 && textNodeNext.value.length) {
                  textNode = textNode.prev;
                  continue;
                }
                if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
                  textNode = textNode.prev;
                  continue;
                }
              }
              sibling = textNode.prev;
              textNode.remove();
              textNode = sibling;
            }
          };
          var cloneAndExcludeBlocks = function (input) {
            var name;
            var output = {};
            for (name in input) {
              if (name !== 'li' && name !== 'p') {
                output[name] = input[name];
              }
            }
            return output;
          };
          parser = SaxParser$1({
            validate: validate,
            allow_script_urls: settings.allow_script_urls,
            allow_conditional_comments: settings.allow_conditional_comments,
            self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
            cdata: function (text) {
              node.append(createNode('#cdata', 4)).value = text;
            },
            text: function (text, raw) {
              var textNode;
              if (!isInWhiteSpacePreservedElement) {
                text = text.replace(allWhiteSpaceRegExp, ' ');
                if (isLineBreakNode(node.lastChild, blockElements)) {
                  text = text.replace(startWhiteSpaceRegExp, '');
                }
              }
              if (text.length !== 0) {
                textNode = createNode('#text', 3);
                textNode.raw = !!raw;
                node.append(textNode).value = text;
              }
            },
            comment: function (text) {
              node.append(createNode('#comment', 8)).value = text;
            },
            pi: function (name, text) {
              node.append(createNode(name, 7)).value = text;
              removeWhitespaceBefore(node);
            },
            doctype: function (text) {
              var newNode;
              newNode = node.append(createNode('#doctype', 10));
              newNode.value = text;
              removeWhitespaceBefore(node);
            },
            start: function (name, attrs, empty) {
              var newNode, attrFiltersLen, elementRule, attrName, parent;
              elementRule = validate ? schema.getElementRule(name) : {};
              if (elementRule) {
                newNode = createNode(elementRule.outputName || name, 1);
                newNode.attributes = attrs;
                newNode.shortEnded = empty;
                node.append(newNode);
                parent = children[node.name];
                if (parent && children[newNode.name] && !parent[newNode.name]) {
                  invalidChildren.push(newNode);
                }
                attrFiltersLen = attributeFilters.length;
                while (attrFiltersLen--) {
                  attrName = attributeFilters[attrFiltersLen].name;
                  if (attrName in attrs.map) {
                    list = matchedAttributes[attrName];
                    if (list) {
                      list.push(newNode);
                    } else {
                      matchedAttributes[attrName] = [newNode];
                    }
                  }
                }
                if (blockElements[name]) {
                  removeWhitespaceBefore(newNode);
                }
                if (!empty) {
                  node = newNode;
                }
                if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
                  isInWhiteSpacePreservedElement = true;
                }
              }
            },
            end: function (name) {
              var textNode, elementRule, text, sibling, tempNode;
              elementRule = validate ? schema.getElementRule(name) : {};
              if (elementRule) {
                if (blockElements[name]) {
                  if (!isInWhiteSpacePreservedElement) {
                    textNode = node.firstChild;
                    if (textNode && textNode.type === 3) {
                      text = textNode.value.replace(startWhiteSpaceRegExp, '');
                      if (text.length > 0) {
                        textNode.value = text;
                        textNode = textNode.next;
                      } else {
                        sibling = textNode.next;
                        textNode.remove();
                        textNode = sibling;
                        while (textNode && textNode.type === 3) {
                          text = textNode.value;
                          sibling = textNode.next;
                          if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                            textNode.remove();
                            textNode = sibling;
                          }
                          textNode = sibling;
                        }
                      }
                    }
                    textNode = node.lastChild;
                    if (textNode && textNode.type === 3) {
                      text = textNode.value.replace(endWhiteSpaceRegExp, '');
                      if (text.length > 0) {
                        textNode.value = text;
                        textNode = textNode.prev;
                      } else {
                        sibling = textNode.prev;
                        textNode.remove();
                        textNode = sibling;
                        while (textNode && textNode.type === 3) {
                          text = textNode.value;
                          sibling = textNode.prev;
                          if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                            textNode.remove();
                            textNode = sibling;
                          }
                          textNode = sibling;
                        }
                      }
                    }
                  }
                }
                if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
                  isInWhiteSpacePreservedElement = false;
                }
                if (elementRule.removeEmpty && isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node)) {
                  if (!node.attributes.map.name && !node.attr('id')) {
                    tempNode = node.parent;
                    if (blockElements[node.name]) {
                      node.empty().remove();
                    } else {
                      node.unwrap();
                    }
                    node = tempNode;
                    return;
                  }
                }
                if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node))) {
                  paddEmptyNode(settings, args, blockElements, node);
                }
                node = node.parent;
              }
            }
          }, schema);
          var rootNode = node = new Node$2(args.context || settings.root_name, 11);
          parser.parse(html);
          if (validate && invalidChildren.length) {
            if (!args.context) {
              fixInvalidChildren(invalidChildren);
            } else {
              args.invalid = true;
            }
          }
          if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
            addRootBlocks();
          }
          if (!args.invalid) {
            for (name in matchedNodes) {
              list = nodeFilters[name];
              nodes = matchedNodes[name];
              fi = nodes.length;
              while (fi--) {
                if (!nodes[fi].parent) {
                  nodes.splice(fi, 1);
                }
              }
              for (i = 0, l = list.length; i < l; i++) {
                list[i](nodes, name, args);
              }
            }
            for (i = 0, l = attributeFilters.length; i < l; i++) {
              list = attributeFilters[i];
              if (list.name in matchedAttributes) {
                nodes = matchedAttributes[list.name];
                fi = nodes.length;
                while (fi--) {
                  if (!nodes[fi].parent) {
                    nodes.splice(fi, 1);
                  }
                }
                for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
                  list.callbacks[fi](nodes, list.name, args);
                }
              }
            }
          }
          return rootNode;
        };
        var exports = {
          schema: schema,
          addAttributeFilter: addAttributeFilter,
          getAttributeFilters: getAttributeFilters,
          addNodeFilter: addNodeFilter,
          getNodeFilters: getNodeFilters,
          filterNode: filterNode,
          parse: parse
        };
        register$2(exports, settings);
        $_9ewhzh6cjh8lyxgp.register(exports, settings);
        return exports;
      }

      var addTempAttr = function (htmlParser, tempAttrs, name) {
        if ($_ahowuxkjh8lywbj.inArray(tempAttrs, name) === -1) {
          htmlParser.addAttributeFilter(name, function (nodes, name) {
            var i = nodes.length;
            while (i--) {
              nodes[i].attr(name, null);
            }
          });
          tempAttrs.push(name);
        }
      };
      var postProcess$1 = function (editor, args, content) {
        if (!args.no_events && editor) {
          var outArgs = $_a4fgrn4cjh8lyx4q.firePostProcess(editor, $_7ffry568jh8lyxfy.merge(args, { content: content }));
          return outArgs.content;
        } else {
          return content;
        }
      };
      var getHtmlFromNode = function (dom, node, args) {
        var html = $_d383mr21jh8lywlv.trim(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
        return args.selection || isWsPreserveElement($_cgttw3zjh8lywdq.fromDom(node)) ? html : $_ahowuxkjh8lywbj.trim(html);
      };
      var parseHtml = function (htmlParser, html, args) {
        var parserArgs = args.selection ? $_7ffry568jh8lyxfy.merge({ forced_root_block: false }, args) : args;
        var rootNode = htmlParser.parse(html, parserArgs);
        $_834niu69jh8lyxg1.trimTrailingBr(rootNode);
        return rootNode;
      };
      var serializeNode = function (settings, schema, node) {
        var htmlSerializer = HtmlSerializer(settings, schema);
        return htmlSerializer.serialize(node);
      };
      var toHtml = function (editor, settings, schema, rootNode, args) {
        var content = serializeNode(settings, schema, rootNode);
        return postProcess$1(editor, args, content);
      };
      function DomSerializer (settings, editor) {
        var dom, schema, htmlParser;
        var tempAttrs = ['data-mce-selected'];
        dom = editor && editor.dom ? editor.dom : DOMUtils$1.DOM;
        schema = editor && editor.schema ? editor.schema : Schema(settings);
        settings.entity_encoding = settings.entity_encoding || 'named';
        settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
        htmlParser = DomParser(settings, schema);
        $_834niu69jh8lyxg1.register(htmlParser, settings, dom);
        var serialize = function (node, parserArgs) {
          var args = $_7ffry568jh8lyxfy.merge({ format: 'html' }, parserArgs ? parserArgs : {});
          var targetNode = $_gg1aca6ajh8lyxg7.process(editor, node, args);
          var html = getHtmlFromNode(dom, targetNode, args);
          var rootNode = parseHtml(htmlParser, html, args);
          return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
        };
        return {
          schema: schema,
          addNodeFilter: htmlParser.addNodeFilter,
          addAttributeFilter: htmlParser.addAttributeFilter,
          serialize: serialize,
          addRules: function (rules) {
            schema.addValidElements(rules);
          },
          setRules: function (rules) {
            schema.setValidElements(rules);
          },
          addTempAttr: $_eqpqvr6jh8lyw3s.curry(addTempAttr, htmlParser, tempAttrs),
          getTempAttrs: function () {
            return tempAttrs;
          }
        };
      }

      function DomSerializer$1 (settings, editor) {
        var domSerializer = DomSerializer(settings, editor);
        return {
          schema: domSerializer.schema,
          addNodeFilter: domSerializer.addNodeFilter,
          addAttributeFilter: domSerializer.addAttributeFilter,
          serialize: domSerializer.serialize,
          addRules: domSerializer.addRules,
          setRules: domSerializer.setRules,
          addTempAttr: domSerializer.addTempAttr,
          getTempAttrs: domSerializer.getTempAttrs
        };
      }

      function BookmarkManager(selection) {
        return {
          getBookmark: $_eqpqvr6jh8lyw3s.curry($_eyp5ec2njh8lywpo.getBookmark, selection),
          moveToBookmark: $_eqpqvr6jh8lyw3s.curry($_eyp5ec2njh8lywpo.moveToBookmark, selection)
        };
      }
      (function (BookmarkManager) {
        BookmarkManager.isBookmarkNode = $_eyp5ec2njh8lywpo.isBookmarkNode;
      }(BookmarkManager || (BookmarkManager = {})));
      var BookmarkManager$1 = BookmarkManager;

      var isContentEditableFalse$10 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var isContentEditableTrue$6 = $_5oonaz1qjh8lywhz.isContentEditableTrue;
      var getContentEditableRoot$2 = function (root, node) {
        while (node && node !== root) {
          if (isContentEditableTrue$6(node) || isContentEditableFalse$10(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var ControlSelection = function (selection, editor) {
        var dom = editor.dom, each = $_ahowuxkjh8lywbj.each;
        var selectedElm, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle;
        var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
        var width, height;
        var editableDoc = editor.getDoc(), rootDocument = document;
        var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
        var startScrollWidth, startScrollHeight;
        resizeHandles = {
          nw: [
            0,
            0,
            -1,
            -1
          ],
          ne: [
            1,
            0,
            1,
            -1
          ],
          se: [
            1,
            1,
            1,
            1
          ],
          sw: [
            0,
            1,
            -1,
            1
          ]
        };
        var rootClass = '.mce-content-body';
        editor.contentStyles.push(rootClass + ' div.mce-resizehandle {' + 'position: absolute;' + 'border: 1px solid black;' + 'box-sizing: content-box;' + 'background: #FFF;' + 'width: 7px;' + 'height: 7px;' + 'z-index: 10000' + '}' + rootClass + ' .mce-resizehandle:hover {' + 'background: #000' + '}' + rootClass + ' img[data-mce-selected],' + rootClass + ' hr[data-mce-selected] {' + 'outline: 1px solid black;' + 'resize: none' + '}' + rootClass + ' .mce-clonedresizable {' + 'position: absolute;' + ($_9bpim8ajh8lyw68.gecko ? '' : 'outline: 1px dashed black;') + 'opacity: .5;' + 'filter: alpha(opacity=50);' + 'z-index: 10000' + '}' + rootClass + ' .mce-resize-helper {' + 'background: #555;' + 'background: rgba(0,0,0,0.75);' + 'border-radius: 3px;' + 'border: 1px;' + 'color: white;' + 'display: none;' + 'font-family: sans-serif;' + 'font-size: 12px;' + 'white-space: nowrap;' + 'line-height: 14px;' + 'margin: 5px 10px;' + 'padding: 5px;' + 'position: absolute;' + 'z-index: 10001' + '}');
        var isImage = function (elm) {
          return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
        };
        var isEventOnImageOutsideRange = function (evt, range) {
          return isImage(evt.target) && !$_3kj84i5djh8lyxan.isXYWithinRange(evt.clientX, evt.clientY, range);
        };
        var contextMenuSelectImage = function (evt) {
          var target = evt.target;
          if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
            evt.preventDefault();
            editor.selection.select(target);
          }
        };
        var getResizeTarget = function (elm) {
          return editor.dom.is(elm, 'figure.image') ? elm.querySelector('img') : elm;
        };
        var isResizable = function (elm) {
          var selector = editor.settings.object_resizing;
          if (selector === false || $_9bpim8ajh8lyw68.iOS) {
            return false;
          }
          if (typeof selector !== 'string') {
            selector = 'table,img,figure.image,div';
          }
          if (elm.getAttribute('data-mce-resize') === 'false') {
            return false;
          }
          if (elm === editor.getBody()) {
            return false;
          }
          return $_5h4ipt1fjh8lywgi.is($_cgttw3zjh8lywdq.fromDom(elm), selector);
        };
        var resizeGhostElement = function (e) {
          var deltaX, deltaY, proportional;
          var resizeHelperX, resizeHelperY;
          deltaX = e.screenX - startX;
          deltaY = e.screenY - startY;
          width = deltaX * selectedHandle[2] + startW;
          height = deltaY * selectedHandle[3] + startH;
          width = width < 5 ? 5 : width;
          height = height < 5 ? 5 : height;
          if (isImage(selectedElm) && editor.settings.resize_img_proportional !== false) {
            proportional = !$_6lsk4i5gjh8lyxau.modifierPressed(e);
          } else {
            proportional = $_6lsk4i5gjh8lyxau.modifierPressed(e) || isImage(selectedElm) && selectedHandle[2] * selectedHandle[3] !== 0;
          }
          if (proportional) {
            if (abs(deltaX) > abs(deltaY)) {
              height = round(width * ratio);
              width = round(height / ratio);
            } else {
              width = round(height / ratio);
              height = round(width * ratio);
            }
          }
          dom.setStyles(getResizeTarget(selectedElmGhost), {
            width: width,
            height: height
          });
          resizeHelperX = selectedHandle.startPos.x + deltaX;
          resizeHelperY = selectedHandle.startPos.y + deltaY;
          resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
          resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
          dom.setStyles(resizeHelper, {
            left: resizeHelperX,
            top: resizeHelperY,
            display: 'block'
          });
          resizeHelper.innerHTML = width + ' &times; ' + height;
          if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
            dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
          }
          if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
            dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
          }
          deltaX = rootElement.scrollWidth - startScrollWidth;
          deltaY = rootElement.scrollHeight - startScrollHeight;
          if (deltaX + deltaY !== 0) {
            dom.setStyles(resizeHelper, {
              left: resizeHelperX - deltaX,
              top: resizeHelperY - deltaY
            });
          }
          if (!resizeStarted) {
            $_a4fgrn4cjh8lyx4q.fireObjectResizeStart(editor, selectedElm, startW, startH);
            resizeStarted = true;
          }
        };
        var endGhostResize = function () {
          resizeStarted = false;
          var setSizeProp = function (name, value) {
            if (value) {
              if (selectedElm.style[name] || !editor.schema.isValid(selectedElm.nodeName.toLowerCase(), name)) {
                dom.setStyle(getResizeTarget(selectedElm), name, value);
              } else {
                dom.setAttrib(getResizeTarget(selectedElm), name, value);
              }
            }
          };
          setSizeProp('width', width);
          setSizeProp('height', height);
          dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
          dom.unbind(editableDoc, 'mouseup', endGhostResize);
          if (rootDocument !== editableDoc) {
            dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
            dom.unbind(rootDocument, 'mouseup', endGhostResize);
          }
          dom.remove(selectedElmGhost);
          dom.remove(resizeHelper);
          showResizeRect(selectedElm);
          $_a4fgrn4cjh8lyx4q.fireObjectResized(editor, selectedElm, width, height);
          dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
          editor.nodeChanged();
        };
        var showResizeRect = function (targetElm) {
          var position, targetWidth, targetHeight, e, rect;
          hideResizeRect();
          unbindResizeHandleEvents();
          position = dom.getPos(targetElm, rootElement);
          selectedElmX = position.x;
          selectedElmY = position.y;
          rect = targetElm.getBoundingClientRect();
          targetWidth = rect.width || rect.right - rect.left;
          targetHeight = rect.height || rect.bottom - rect.top;
          if (selectedElm !== targetElm) {
            selectedElm = targetElm;
            width = height = 0;
          }
          e = editor.fire('ObjectSelected', { target: targetElm });
          if (isResizable(targetElm) && !e.isDefaultPrevented()) {
            each(resizeHandles, function (handle, name) {
              var handleElm;
              var startDrag = function (e) {
                startX = e.screenX;
                startY = e.screenY;
                startW = getResizeTarget(selectedElm).clientWidth;
                startH = getResizeTarget(selectedElm).clientHeight;
                ratio = startH / startW;
                selectedHandle = handle;
                handle.startPos = {
                  x: targetWidth * handle[0] + selectedElmX,
                  y: targetHeight * handle[1] + selectedElmY
                };
                startScrollWidth = rootElement.scrollWidth;
                startScrollHeight = rootElement.scrollHeight;
                selectedElmGhost = selectedElm.cloneNode(true);
                dom.addClass(selectedElmGhost, 'mce-clonedresizable');
                dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
                selectedElmGhost.contentEditable = false;
                selectedElmGhost.unSelectabe = true;
                dom.setStyles(selectedElmGhost, {
                  left: selectedElmX,
                  top: selectedElmY,
                  margin: 0
                });
                selectedElmGhost.removeAttribute('data-mce-selected');
                rootElement.appendChild(selectedElmGhost);
                dom.bind(editableDoc, 'mousemove', resizeGhostElement);
                dom.bind(editableDoc, 'mouseup', endGhostResize);
                if (rootDocument !== editableDoc) {
                  dom.bind(rootDocument, 'mousemove', resizeGhostElement);
                  dom.bind(rootDocument, 'mouseup', endGhostResize);
                }
                resizeHelper = dom.add(rootElement, 'div', {
                  'class': 'mce-resize-helper',
                  'data-mce-bogus': 'all'
                }, startW + ' &times; ' + startH);
              };
              handleElm = dom.get('mceResizeHandle' + name);
              if (handleElm) {
                dom.remove(handleElm);
              }
              handleElm = dom.add(rootElement, 'div', {
                'id': 'mceResizeHandle' + name,
                'data-mce-bogus': 'all',
                'class': 'mce-resizehandle',
                'unselectable': true,
                'style': 'cursor:' + name + '-resize; margin:0; padding:0'
              });
              if ($_9bpim8ajh8lyw68.ie === 11) {
                handleElm.contentEditable = false;
              }
              dom.bind(handleElm, 'mousedown', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                startDrag(e);
              });
              handle.elm = handleElm;
              dom.setStyles(handleElm, {
                left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
                top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
              });
            });
          } else {
            hideResizeRect();
          }
          selectedElm.setAttribute('data-mce-selected', '1');
        };
        var hideResizeRect = function () {
          var name, handleElm;
          unbindResizeHandleEvents();
          if (selectedElm) {
            selectedElm.removeAttribute('data-mce-selected');
          }
          for (name in resizeHandles) {
            handleElm = dom.get('mceResizeHandle' + name);
            if (handleElm) {
              dom.unbind(handleElm);
              dom.remove(handleElm);
            }
          }
        };
        var updateResizeRect = function (e) {
          var startElm, controlElm;
          var isChildOrEqual = function (node, parent) {
            if (node) {
              do {
                if (node === parent) {
                  return true;
                }
              } while (node = node.parentNode);
            }
          };
          if (resizeStarted || editor.removed) {
            return;
          }
          each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
            img.removeAttribute('data-mce-selected');
          });
          controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
          controlElm = dom.$(controlElm).closest('table,img,figure.image,hr')[0];
          if (isChildOrEqual(controlElm, rootElement)) {
            disableGeckoResize();
            startElm = selection.getStart(true);
            if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
              showResizeRect(controlElm);
              return;
            }
          }
          hideResizeRect();
        };
        var isWithinContentEditableFalse = function (elm) {
          return isContentEditableFalse$10(getContentEditableRoot$2(editor.getBody(), elm));
        };
        var unbindResizeHandleEvents = function () {
          for (var name_1 in resizeHandles) {
            var handle = resizeHandles[name_1];
            if (handle.elm) {
              dom.unbind(handle.elm);
              delete handle.elm;
            }
          }
        };
        var disableGeckoResize = function () {
          try {
            editor.getDoc().execCommand('enableObjectResizing', false, false);
          } catch (ex) {
          }
        };
        editor.on('init', function () {
          disableGeckoResize();
          if ($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie >= 11) {
            editor.on('mousedown click', function (e) {
              var target = e.target, nodeName = target.nodeName;
              if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
                if (e.button !== 2) {
                  editor.selection.select(target, nodeName === 'TABLE');
                }
                if (e.type === 'mousedown') {
                  editor.nodeChanged();
                }
              }
            });
            editor.dom.bind(rootElement, 'mscontrolselect', function (e) {
              var delayedSelect = function (node) {
                $_8sy3pfhjh8lyw95.setEditorTimeout(editor, function () {
                  editor.selection.select(node);
                });
              };
              if (isWithinContentEditableFalse(e.target)) {
                e.preventDefault();
                delayedSelect(e.target);
                return;
              }
              if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
                e.preventDefault();
                if (e.target.tagName === 'IMG') {
                  delayedSelect(e.target);
                }
              }
            });
          }
          var throttledUpdateResizeRect = $_8sy3pfhjh8lyw95.throttle(function (e) {
            if (!editor.composing) {
              updateResizeRect(e);
            }
          });
          editor.on('nodechange ResizeEditor ResizeWindow drop FullscreenStateChanged', throttledUpdateResizeRect);
          editor.on('keyup compositionend', function (e) {
            if (selectedElm && selectedElm.nodeName === 'TABLE') {
              throttledUpdateResizeRect(e);
            }
          });
          editor.on('hide blur', hideResizeRect);
          editor.on('contextmenu', contextMenuSelectImage);
        });
        editor.on('remove', unbindResizeHandleEvents);
        var destroy = function () {
          selectedElm = selectedElmGhost = null;
        };
        return {
          isResizable: isResizable,
          showResizeRect: showResizeRect,
          hideResizeRect: hideResizeRect,
          updateResizeRect: updateResizeRect,
          destroy: destroy
        };
      };

      var hasCeProperty = function (node) {
        return $_5oonaz1qjh8lywhz.isContentEditableTrue(node) || $_5oonaz1qjh8lywhz.isContentEditableFalse(node);
      };
      var findParent$1 = function (node, rootNode, predicate) {
        while (node && node !== rootNode) {
          if (predicate(node)) {
            return node;
          }
          node = node.parentNode;
        }
        return null;
      };
      var findClosestIeRange = function (clientX, clientY, doc) {
        var element, rng, rects;
        element = doc.elementFromPoint(clientX, clientY);
        rng = doc.body.createTextRange();
        if (!element || element.tagName === 'HTML') {
          element = doc.body;
        }
        rng.moveToElementText(element);
        rects = $_ahowuxkjh8lywbj.toArray(rng.getClientRects());
        rects = rects.sort(function (a, b) {
          a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
          b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
          return a - b;
        });
        if (rects.length > 0) {
          clientY = (rects[0].bottom + rects[0].top) / 2;
          try {
            rng.moveToPoint(clientX, clientY);
            rng.collapse(true);
            return rng;
          } catch (ex) {
          }
        }
        return null;
      };
      var moveOutOfContentEditableFalse = function (rng, rootNode) {
        var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
        return $_5oonaz1qjh8lywhz.isContentEditableFalse(findParent$1(parentElement, rootNode, hasCeProperty)) ? null : rng;
      };
      var fromPoint$1 = function (clientX, clientY, doc) {
        var rng, point;
        var pointDoc = doc;
        if (pointDoc.caretPositionFromPoint) {
          point = pointDoc.caretPositionFromPoint(clientX, clientY);
          if (point) {
            rng = doc.createRange();
            rng.setStart(point.offsetNode, point.offset);
            rng.collapse(true);
          }
        } else if (doc.caretRangeFromPoint) {
          rng = doc.caretRangeFromPoint(clientX, clientY);
        } else if (pointDoc.body.createTextRange) {
          rng = pointDoc.body.createTextRange();
          try {
            rng.moveToPoint(clientX, clientY);
            rng.collapse(true);
          } catch (ex) {
            rng = findClosestIeRange(clientX, clientY, doc);
          }
          return moveOutOfContentEditableFalse(rng, doc.body);
        }
        return rng;
      };
      var $_ct0ht56jjh8lyxif = { fromPoint: fromPoint$1 };

      var processRanges = function (editor, ranges) {
        return $_5wjzy24jh8lyw2t.map(ranges, function (range) {
          var evt = editor.fire('GetSelectionRange', { range: range });
          return evt.range !== range ? evt.range : range;
        });
      };
      var $_8o0eax6kjh8lyxii = { processRanges: processRanges };

      var clone$2 = function (original, deep) {
        return $_cgttw3zjh8lywdq.fromDom(original.dom().cloneNode(deep));
      };
      var shallow$1 = function (original) {
        return clone$2(original, false);
      };
      var deep$1 = function (original) {
        return clone$2(original, true);
      };
      var shallowAs = function (original, tag) {
        var nu = $_cgttw3zjh8lywdq.fromTag(tag);
        var attributes = $_3da62i14jh8lyweo.clone(original);
        $_3da62i14jh8lyweo.setAll(nu, attributes);
        return nu;
      };
      var copy$1 = function (original, tag) {
        var nu = shallowAs(original, tag);
        var cloneChildren = $_a43q0i17jh8lywfe.children(deep$1(original));
        $_9hl8mu2vjh8lywr4.append(nu, cloneChildren);
        return nu;
      };
      var mutate = function (original, tag) {
        var nu = shallowAs(original, tag);
        $_4m7u2e2kjh8lywpi.before(original, nu);
        var children = $_a43q0i17jh8lywfe.children(original);
        $_9hl8mu2vjh8lywr4.append(nu, children);
        $_bfmuql2ujh8lywr1.remove(original);
        return nu;
      };
      var $_azl0s66njh8lyxj4 = {
        shallow: shallow$1,
        shallowAs: shallowAs,
        deep: deep$1,
        copy: copy$1,
        mutate: mutate
      };

      var fromElements = function (elements, scope) {
        var doc = scope || document;
        var fragment = doc.createDocumentFragment();
        $_5wjzy24jh8lyw2t.each(elements, function (element) {
          fragment.appendChild(element.dom());
        });
        return $_cgttw3zjh8lywdq.fromDom(fragment);
      };
      var $_401op36ojh8lyxj6 = { fromElements: fromElements };

      var tableModel = $_4jz0ce18jh8lywft.immutable('element', 'width', 'rows');
      var tableRow = $_4jz0ce18jh8lywft.immutable('element', 'cells');
      var cellPosition = $_4jz0ce18jh8lywft.immutable('x', 'y');
      var getSpan = function (td, key) {
        var value = parseInt($_3da62i14jh8lyweo.get(td, key), 10);
        return isNaN(value) ? 1 : value;
      };
      var fillout = function (table, x, y, tr, td) {
        var rowspan = getSpan(td, 'rowspan');
        var colspan = getSpan(td, 'colspan');
        var rows = table.rows();
        for (var y2 = y; y2 < y + rowspan; y2++) {
          if (!rows[y2]) {
            rows[y2] = tableRow($_azl0s66njh8lyxj4.deep(tr), []);
          }
          for (var x2 = x; x2 < x + colspan; x2++) {
            var cells = rows[y2].cells();
            cells[x2] = y2 === y && x2 === x ? td : $_azl0s66njh8lyxj4.shallow(td);
          }
        }
      };
      var cellExists = function (table, x, y) {
        var rows = table.rows();
        var cells = rows[y] ? rows[y].cells() : [];
        return !!cells[x];
      };
      var skipCellsX = function (table, x, y) {
        while (cellExists(table, x, y)) {
          x++;
        }
        return x;
      };
      var getWidth = function (rows) {
        return $_5wjzy24jh8lyw2t.foldl(rows, function (acc, row) {
          return row.cells().length > acc ? row.cells().length : acc;
        }, 0);
      };
      var findElementPos = function (table, element) {
        var rows = table.rows();
        for (var y = 0; y < rows.length; y++) {
          var cells = rows[y].cells();
          for (var x = 0; x < cells.length; x++) {
            if ($_5f6gpb1djh8lywg5.eq(cells[x], element)) {
              return Option.some(cellPosition(x, y));
            }
          }
        }
        return Option.none();
      };
      var extractRows = function (table, sx, sy, ex, ey) {
        var newRows = [];
        var rows = table.rows();
        for (var y = sy; y <= ey; y++) {
          var cells = rows[y].cells();
          var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
          newRows.push(tableRow(rows[y].element(), slice));
        }
        return newRows;
      };
      var subTable = function (table, startPos, endPos) {
        var sx = startPos.x(), sy = startPos.y();
        var ex = endPos.x(), ey = endPos.y();
        var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
        return tableModel(table.element(), getWidth(newRows), newRows);
      };
      var createDomTable = function (table, rows) {
        var tableElement = $_azl0s66njh8lyxj4.shallow(table.element());
        var tableBody = $_cgttw3zjh8lywdq.fromTag('tbody');
        $_9hl8mu2vjh8lywr4.append(tableBody, rows);
        $_4m7u2e2kjh8lywpi.append(tableElement, tableBody);
        return tableElement;
      };
      var modelRowsToDomRows = function (table) {
        return $_5wjzy24jh8lyw2t.map(table.rows(), function (row) {
          var cells = $_5wjzy24jh8lyw2t.map(row.cells(), function (cell) {
            var td = $_azl0s66njh8lyxj4.deep(cell);
            $_3da62i14jh8lyweo.remove(td, 'colspan');
            $_3da62i14jh8lyweo.remove(td, 'rowspan');
            return td;
          });
          var tr = $_azl0s66njh8lyxj4.shallow(row.element());
          $_9hl8mu2vjh8lywr4.append(tr, cells);
          return tr;
        });
      };
      var fromDom$2 = function (tableElm) {
        var table = tableModel($_azl0s66njh8lyxj4.shallow(tableElm), 0, []);
        $_5wjzy24jh8lyw2t.each($_eebxu2gjh8lywp3.descendants(tableElm, 'tr'), function (tr, y) {
          $_5wjzy24jh8lyw2t.each($_eebxu2gjh8lywp3.descendants(tr, 'td,th'), function (td, x) {
            fillout(table, skipCellsX(table, x, y), y, tr, td);
          });
        });
        return tableModel(table.element(), getWidth(table.rows()), table.rows());
      };
      var toDom = function (table) {
        return createDomTable(table, modelRowsToDomRows(table));
      };
      var subsection = function (table, startElement, endElement) {
        return findElementPos(table, startElement).bind(function (startPos) {
          return findElementPos(table, endElement).map(function (endPos) {
            return subTable(table, startPos, endPos);
          });
        });
      };
      var $_fb3vwb6pjh8lyxjk = {
        fromDom: fromDom$2,
        toDom: toDom,
        subsection: subsection
      };

      var findParentListContainer = function (parents) {
        return $_5wjzy24jh8lyw2t.find(parents, function (elm) {
          return $_7j1jt210jh8lywdx.name(elm) === 'ul' || $_7j1jt210jh8lywdx.name(elm) === 'ol';
        });
      };
      var getFullySelectedListWrappers = function (parents, rng) {
        return $_5wjzy24jh8lyw2t.find(parents, function (elm) {
          return $_7j1jt210jh8lywdx.name(elm) === 'li' && hasAllContentsSelected(elm, rng);
        }).fold($_eqpqvr6jh8lyw3s.constant([]), function (li) {
          return findParentListContainer(parents).map(function (listCont) {
            return [
              $_cgttw3zjh8lywdq.fromTag('li'),
              $_cgttw3zjh8lywdq.fromTag($_7j1jt210jh8lywdx.name(listCont))
            ];
          }).getOr([]);
        });
      };
      var wrap$3 = function (innerElm, elms) {
        var wrapped = $_5wjzy24jh8lyw2t.foldl(elms, function (acc, elm) {
          $_4m7u2e2kjh8lywpi.append(elm, acc);
          return elm;
        }, innerElm);
        return elms.length > 0 ? $_401op36ojh8lyxj6.fromElements([wrapped]) : wrapped;
      };
      var directListWrappers = function (commonAnchorContainer) {
        if (isListItem(commonAnchorContainer)) {
          return $_a43q0i17jh8lywfe.parent(commonAnchorContainer).filter(isList).fold($_eqpqvr6jh8lyw3s.constant([]), function (listElm) {
            return [
              commonAnchorContainer,
              listElm
            ];
          });
        } else {
          return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
        }
      };
      var getWrapElements = function (rootNode, rng) {
        var commonAnchorContainer = $_cgttw3zjh8lywdq.fromDom(rng.commonAncestorContainer);
        var parents = $_dyxtub3ejh8lywxq.parentsAndSelf(commonAnchorContainer, rootNode);
        var wrapElements = $_5wjzy24jh8lyw2t.filter(parents, function (elm) {
          return isInline(elm) || isHeading(elm);
        });
        var listWrappers = getFullySelectedListWrappers(parents, rng);
        var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
        return $_5wjzy24jh8lyw2t.map(allWrappers, $_azl0s66njh8lyxj4.shallow);
      };
      var emptyFragment = function () {
        return $_401op36ojh8lyxj6.fromElements([]);
      };
      var getFragmentFromRange = function (rootNode, rng) {
        return wrap$3($_cgttw3zjh8lywdq.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
      };
      var getParentTable = function (rootElm, cell) {
        return $_7sg18r3cjh8lywu1.ancestor(cell, 'table', $_eqpqvr6jh8lyw3s.curry($_5f6gpb1djh8lywg5.eq, rootElm));
      };
      var getTableFragment = function (rootNode, selectedTableCells) {
        return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
          var firstCell = selectedTableCells[0];
          var lastCell = selectedTableCells[selectedTableCells.length - 1];
          var fullTableModel = $_fb3vwb6pjh8lyxjk.fromDom(tableElm);
          return $_fb3vwb6pjh8lyxjk.subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
            return $_401op36ojh8lyxj6.fromElements([$_fb3vwb6pjh8lyxjk.toDom(sectionedTableModel)]);
          });
        }).getOrThunk(emptyFragment);
      };
      var getSelectionFragment = function (rootNode, ranges) {
        return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
      };
      var read$4 = function (rootNode, ranges) {
        var selectedCells = $_bwjtq63tjh8lyx1g.getCellsFromElementOrRanges(ranges, rootNode);
        return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
      };
      var $_7lffms6mjh8lyxip = { read: read$4 };

      var getContent = function (editor, args) {
        var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
        var sel = editor.selection.getSel();
        var fragment;
        var ranges = $_8o0eax6kjh8lyxii.processRanges(editor, $_d1o8uj3ujh8lyx1u.getRanges(sel));
        args = args || {};
        args.get = true;
        args.format = args.format || 'html';
        args.selection = true;
        args = editor.fire('BeforeGetContent', args);
        if (args.isDefaultPrevented()) {
          editor.fire('GetContent', args);
          return args.content;
        }
        if (args.format === 'text') {
          return editor.selection.isCollapsed() ? '' : $_d383mr21jh8lywlv.trim(rng.text || (sel.toString ? sel.toString() : ''));
        }
        if (rng.cloneContents) {
          fragment = args.contextual ? $_7lffms6mjh8lyxip.read($_cgttw3zjh8lywdq.fromDom(editor.getBody()), ranges).dom() : rng.cloneContents();
          if (fragment) {
            tmpElm.appendChild(fragment);
          }
        } else if (rng.item !== undefined || rng.htmlText !== undefined) {
          tmpElm.innerHTML = '<br>' + (rng.item ? rng.item(0).outerHTML : rng.htmlText);
          tmpElm.removeChild(tmpElm.firstChild);
        } else {
          tmpElm.innerHTML = rng.toString();
        }
        args.getInner = true;
        var content = editor.selection.serializer.serialize(tmpElm, args);
        if (args.format === 'tree') {
          return content;
        }
        args.content = editor.selection.isCollapsed() ? '' : content;
        editor.fire('GetContent', args);
        return args.content;
      };
      var $_dxvi8w6ljh8lyxik = { getContent: getContent };

      var setContent = function (editor, content, args) {
        var rng = editor.selection.getRng(), caretNode;
        var doc = editor.getDoc();
        var frag, temp;
        args = args || { format: 'html' };
        args.set = true;
        args.selection = true;
        args.content = content;
        if (!args.no_events) {
          args = editor.fire('BeforeSetContent', args);
          if (args.isDefaultPrevented()) {
            editor.fire('SetContent', args);
            return;
          }
        }
        content = args.content;
        if (rng.insertNode) {
          content += '<span id="__caret">_</span>';
          if (rng.startContainer === doc && rng.endContainer === doc) {
            doc.body.innerHTML = content;
          } else {
            rng.deleteContents();
            if (doc.body.childNodes.length === 0) {
              doc.body.innerHTML = content;
            } else {
              if (rng.createContextualFragment) {
                rng.insertNode(rng.createContextualFragment(content));
              } else {
                frag = doc.createDocumentFragment();
                temp = doc.createElement('div');
                frag.appendChild(temp);
                temp.outerHTML = content;
                rng.insertNode(frag);
              }
            }
          }
          caretNode = editor.dom.get('__caret');
          rng = doc.createRange();
          rng.setStartBefore(caretNode);
          rng.setEndBefore(caretNode);
          editor.selection.setRng(rng);
          editor.dom.remove('__caret');
          try {
            editor.selection.setRng(rng);
          } catch (ex) {
          }
        } else {
          if (rng.item) {
            doc.execCommand('Delete', false, null);
            rng = editor.getRng();
          }
          if (/^\s+/.test(content)) {
            rng.pasteHTML('<span id="__mce_tmp">_</span>' + content);
            editor.dom.remove('__mce_tmp');
          } else {
            rng.pasteHTML(content);
          }
        }
        if (!args.no_events) {
          editor.fire('SetContent', args);
        }
      };
      var $_8s2a5k6qjh8lyxk1 = { setContent: setContent };

      var getEndpointElement = function (root, rng, start, real, resolve) {
        var container = start ? rng.startContainer : rng.endContainer;
        var offset = start ? rng.startOffset : rng.endOffset;
        return Option.from(container).map($_cgttw3zjh8lywdq.fromDom).map(function (elm) {
          return !real || !rng.collapsed ? $_a43q0i17jh8lywfe.child(elm, resolve(elm, offset)).getOr(elm) : elm;
        }).bind(function (elm) {
          return $_7j1jt210jh8lywdx.isElement(elm) ? Option.some(elm) : $_a43q0i17jh8lywfe.parent(elm);
        }).map(function (elm) {
          return elm.dom();
        }).getOr(root);
      };
      var getStart$2 = function (root, rng, real) {
        return getEndpointElement(root, rng, true, real, function (elm, offset) {
          return Math.min($_a43q0i17jh8lywfe.childNodesCount(elm), offset);
        });
      };
      var getEnd = function (root, rng, real) {
        return getEndpointElement(root, rng, false, real, function (elm, offset) {
          return offset > 0 ? offset - 1 : offset;
        });
      };
      var skipEmptyTextNodes = function (node, forwards) {
        var orig = node;
        while (node && $_5oonaz1qjh8lywhz.isText(node) && node.length === 0) {
          node = forwards ? node.nextSibling : node.previousSibling;
        }
        return node || orig;
      };
      var getNode$1 = function (root, rng) {
        var elm, startContainer, endContainer, startOffset, endOffset;
        if (!rng) {
          return root;
        }
        startContainer = rng.startContainer;
        endContainer = rng.endContainer;
        startOffset = rng.startOffset;
        endOffset = rng.endOffset;
        elm = rng.commonAncestorContainer;
        if (!rng.collapsed) {
          if (startContainer === endContainer) {
            if (endOffset - startOffset < 2) {
              if (startContainer.hasChildNodes()) {
                elm = startContainer.childNodes[startOffset];
              }
            }
          }
          if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
            if (startContainer.length === startOffset) {
              startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
            } else {
              startContainer = startContainer.parentNode;
            }
            if (endOffset === 0) {
              endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
            } else {
              endContainer = endContainer.parentNode;
            }
            if (startContainer && startContainer === endContainer) {
              return startContainer;
            }
          }
        }
        if (elm && elm.nodeType === 3) {
          return elm.parentNode;
        }
        return elm;
      };
      var getSelectedBlocks = function (dom, rng, startElm, endElm) {
        var node, root;
        var selectedBlocks = [];
        root = dom.getRoot();
        startElm = dom.getParent(startElm || getStart$2(root, rng, false), dom.isBlock);
        endElm = dom.getParent(endElm || getEnd(root, rng, false), dom.isBlock);
        if (startElm && startElm !== root) {
          selectedBlocks.push(startElm);
        }
        if (startElm && endElm && startElm !== endElm) {
          node = startElm;
          var walker = new TreeWalker(startElm, root);
          while ((node = walker.next()) && node !== endElm) {
            if (dom.isBlock(node)) {
              selectedBlocks.push(node);
            }
          }
        }
        if (endElm && startElm !== endElm && endElm !== root) {
          selectedBlocks.push(endElm);
        }
        return selectedBlocks;
      };
      var select$1 = function (dom, node, content) {
        return Option.from(node).map(function (node) {
          var idx = dom.nodeIndex(node);
          var rng = dom.createRng();
          rng.setStart(node.parentNode, idx);
          rng.setEnd(node.parentNode, idx + 1);
          if (content) {
            moveEndPoint$1(dom, rng, node, true);
            moveEndPoint$1(dom, rng, node, false);
          }
          return rng;
        });
      };

      var each$19 = $_ahowuxkjh8lywbj.each;
      var isNativeIeSelection = function (rng) {
        return !!rng.select;
      };
      var isAttachedToDom = function (node) {
        return !!(node && node.ownerDocument) && $_5f6gpb1djh8lywg5.contains($_cgttw3zjh8lywdq.fromDom(node.ownerDocument), $_cgttw3zjh8lywdq.fromDom(node));
      };
      var isValidRange = function (rng) {
        if (!rng) {
          return false;
        } else if (isNativeIeSelection(rng)) {
          return true;
        } else {
          return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
        }
      };
      var Selection$1 = function (dom, win, serializer, editor) {
        var bookmarkManager, controlSelection;
        var selectedRange, explicitRange, selectorChangedData;
        var setCursorLocation = function (node, offset) {
          var rng = dom.createRng();
          if (!node) {
            moveEndPoint$1(dom, rng, editor.getBody(), true);
            setRng(rng);
          } else {
            rng.setStart(node, offset);
            rng.setEnd(node, offset);
            setRng(rng);
            collapse(false);
          }
        };
        var getContent = function (args) {
          return $_dxvi8w6ljh8lyxik.getContent(editor, args);
        };
        var setContent = function (content, args) {
          return $_8s2a5k6qjh8lyxk1.setContent(editor, content, args);
        };
        var getStart = function (real) {
          return getStart$2(editor.getBody(), getRng(), real);
        };
        var getEnd$$1 = function (real) {
          return getEnd(editor.getBody(), getRng(), real);
        };
        var getBookmark = function (type, normalized) {
          return bookmarkManager.getBookmark(type, normalized);
        };
        var moveToBookmark = function (bookmark) {
          return bookmarkManager.moveToBookmark(bookmark);
        };
        var select = function (node, content) {
          select$1(dom, node, content).each(setRng);
          return node;
        };
        var isCollapsed = function () {
          var rng = getRng(), sel = getSel();
          if (!rng || rng.item) {
            return false;
          }
          if (rng.compareEndPoints) {
            return rng.compareEndPoints('StartToEnd', rng) === 0;
          }
          return !sel || rng.collapsed;
        };
        var collapse = function (toStart) {
          var rng = getRng();
          rng.collapse(!!toStart);
          setRng(rng);
        };
        var getSel = function () {
          return win.getSelection ? win.getSelection() : win.document.selection;
        };
        var getRng = function () {
          var selection, rng, elm, doc;
          var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
            try {
              return sourceRange.compareBoundaryPoints(how, destinationRange);
            } catch (ex) {
              return -1;
            }
          };
          if (!win) {
            return null;
          }
          doc = win.document;
          if (typeof doc === 'undefined' || doc === null) {
            return null;
          }
          if (editor.bookmark !== undefined && $_cnu79r4ejh8lyx4x.hasFocus(editor) === false) {
            var bookmark = $_eqs11m40jh8lyx31.getRng(editor);
            if (bookmark.isSome()) {
              return bookmark.map(function (r) {
                return $_8o0eax6kjh8lyxii.processRanges(editor, [r])[0];
              }).getOr(doc.createRange());
            }
          }
          try {
            if (selection = getSel()) {
              if (selection.rangeCount > 0) {
                rng = selection.getRangeAt(0);
              } else {
                rng = selection.createRange ? selection.createRange() : doc.createRange();
              }
            }
          } catch (ex) {
          }
          rng = $_8o0eax6kjh8lyxii.processRanges(editor, [rng])[0];
          if (!rng) {
            rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
          }
          if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
            elm = dom.getRoot();
            rng.setStart(elm, 0);
            rng.setEnd(elm, 0);
          }
          if (selectedRange && explicitRange) {
            if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
              rng = explicitRange;
            } else {
              selectedRange = null;
              explicitRange = null;
            }
          }
          return rng;
        };
        var setRng = function (rng, forward) {
          var sel, node, evt;
          if (!isValidRange(rng)) {
            return;
          }
          var ieRange = isNativeIeSelection(rng) ? rng : null;
          if (ieRange) {
            explicitRange = null;
            try {
              ieRange.select();
            } catch (ex) {
            }
            return;
          }
          sel = getSel();
          evt = editor.fire('SetSelectionRange', {
            range: rng,
            forward: forward
          });
          rng = evt.range;
          if (sel) {
            explicitRange = rng;
            try {
              sel.removeAllRanges();
              sel.addRange(rng);
            } catch (ex) {
            }
            if (forward === false && sel.extend) {
              sel.collapse(rng.endContainer, rng.endOffset);
              sel.extend(rng.startContainer, rng.startOffset);
            }
            selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
          }
          if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !$_9bpim8ajh8lyw68.ie) {
            if (rng.endOffset - rng.startOffset < 2) {
              if (rng.startContainer.hasChildNodes()) {
                node = rng.startContainer.childNodes[rng.startOffset];
                if (node && node.tagName === 'IMG') {
                  sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
                  if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
                    sel.setBaseAndExtent(node, 0, node, 1);
                  }
                }
              }
            }
          }
          editor.fire('AfterSetSelectionRange', {
            range: rng,
            forward: forward
          });
        };
        var setNode = function (elm) {
          setContent(dom.getOuterHTML(elm));
          return elm;
        };
        var getNode = function () {
          return getNode$1(editor.getBody(), getRng());
        };
        var getSelectedBlocks$$1 = function (startElm, endElm) {
          return getSelectedBlocks(dom, getRng(), startElm, endElm);
        };
        var isForward = function () {
          var sel = getSel();
          var anchorRange, focusRange;
          if (!sel || !sel.anchorNode || !sel.focusNode) {
            return true;
          }
          anchorRange = dom.createRng();
          anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
          anchorRange.collapse(true);
          focusRange = dom.createRng();
          focusRange.setStart(sel.focusNode, sel.focusOffset);
          focusRange.collapse(true);
          return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
        };
        var normalize = function () {
          var rng = getRng();
          var sel = getSel();
          if (!$_d1o8uj3ujh8lyx1u.hasMultipleRanges(sel) && hasAnyRanges(editor)) {
            var normRng = $_4v2pn63yjh8lyx2s.normalize(dom, rng);
            normRng.each(function (normRng) {
              setRng(normRng, isForward());
            });
            return normRng.getOr(rng);
          }
          return rng;
        };
        var selectorChanged = function (selector, callback) {
          var currentSelectors;
          if (!selectorChangedData) {
            selectorChangedData = {};
            currentSelectors = {};
            editor.on('NodeChange', function (e) {
              var node = e.element, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
              each$19(selectorChangedData, function (callbacks, selector) {
                each$19(parents, function (node) {
                  if (dom.is(node, selector)) {
                    if (!currentSelectors[selector]) {
                      each$19(callbacks, function (callback) {
                        callback(true, {
                          node: node,
                          selector: selector,
                          parents: parents
                        });
                      });
                      currentSelectors[selector] = callbacks;
                    }
                    matchedSelectors[selector] = callbacks;
                    return false;
                  }
                });
              });
              each$19(currentSelectors, function (callbacks, selector) {
                if (!matchedSelectors[selector]) {
                  delete currentSelectors[selector];
                  each$19(callbacks, function (callback) {
                    callback(false, {
                      node: node,
                      selector: selector,
                      parents: parents
                    });
                  });
                }
              });
            });
          }
          if (!selectorChangedData[selector]) {
            selectorChangedData[selector] = [];
          }
          selectorChangedData[selector].push(callback);
          return exports;
        };
        var getScrollContainer = function () {
          var scrollContainer;
          var node = dom.getRoot();
          while (node && node.nodeName !== 'BODY') {
            if (node.scrollHeight > node.clientHeight) {
              scrollContainer = node;
              break;
            }
            node = node.parentNode;
          }
          return scrollContainer;
        };
        var scrollIntoView = function (elm, alignToTop) {
          return $_cosk3k2ijh8lywpa.scrollElementIntoView(editor, elm, alignToTop);
        };
        var placeCaretAt = function (clientX, clientY) {
          return setRng($_ct0ht56jjh8lyxif.fromPoint(clientX, clientY, editor.getDoc()));
        };
        var getBoundingClientRect = function () {
          var rng = getRng();
          return rng.collapsed ? CaretPosition$1.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
        };
        var destroy = function () {
          win = selectedRange = explicitRange = null;
          controlSelection.destroy();
        };
        var exports = {
          bookmarkManager: null,
          controlSelection: null,
          dom: dom,
          win: win,
          serializer: serializer,
          editor: editor,
          collapse: collapse,
          setCursorLocation: setCursorLocation,
          getContent: getContent,
          setContent: setContent,
          getBookmark: getBookmark,
          moveToBookmark: moveToBookmark,
          select: select,
          isCollapsed: isCollapsed,
          isForward: isForward,
          setNode: setNode,
          getNode: getNode,
          getSel: getSel,
          setRng: setRng,
          getRng: getRng,
          getStart: getStart,
          getEnd: getEnd$$1,
          getSelectedBlocks: getSelectedBlocks$$1,
          normalize: normalize,
          selectorChanged: selectorChanged,
          getScrollContainer: getScrollContainer,
          scrollIntoView: scrollIntoView,
          placeCaretAt: placeCaretAt,
          getBoundingClientRect: getBoundingClientRect,
          destroy: destroy
        };
        bookmarkManager = BookmarkManager$1(exports);
        controlSelection = ControlSelection(exports, editor);
        exports.bookmarkManager = bookmarkManager;
        exports.controlSelection = controlSelection;
        return exports;
      };

      var isContentEditableFalse$11 = $_5oonaz1qjh8lywhz.isContentEditableFalse;
      var getSelectedNode$1 = getSelectedNode;
      var isAfterContentEditableFalse$2 = isAfterContentEditableFalse;
      var isBeforeContentEditableFalse$2 = isBeforeContentEditableFalse;
      var getVisualCaretPosition = function (walkFn, caretPosition) {
        while (caretPosition = walkFn(caretPosition)) {
          if (caretPosition.isVisible()) {
            return caretPosition;
          }
        }
        return caretPosition;
      };
      var isMoveInsideSameBlock = function (from, to) {
        var inSameBlock = isInSameBlock(from, to);
        if (!inSameBlock && $_5oonaz1qjh8lywhz.isBr(from.getNode())) {
          return true;
        }
        return inSameBlock;
      };
      var moveToCeFalseHorizontally = function (direction, editor, getNextPosFn, range) {
        var node, caretPosition, peekCaretPosition, rangeIsInContainerBlock;
        var forwards = direction === HDirection.Forwards;
        var isBeforeContentEditableFalseFn = forwards ? isBeforeContentEditableFalse$2 : isAfterContentEditableFalse$2;
        if (!range.collapsed) {
          node = getSelectedNode$1(range);
          if (isContentEditableFalse$11(node)) {
            return showCaret(direction, editor, node, direction === HDirection.Backwards, true);
          }
        }
        rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
        caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
        if (isBeforeContentEditableFalseFn(caretPosition)) {
          return selectNode(editor, caretPosition.getNode(!forwards));
        }
        caretPosition = getNextPosFn(caretPosition);
        if (!caretPosition) {
          if (rangeIsInContainerBlock) {
            return range;
          }
          return null;
        }
        if (isBeforeContentEditableFalseFn(caretPosition)) {
          return showCaret(direction, editor, caretPosition.getNode(!forwards), forwards, true);
        }
        peekCaretPosition = getNextPosFn(caretPosition);
        if (isBeforeContentEditableFalseFn(peekCaretPosition)) {
          if (isMoveInsideSameBlock(caretPosition, peekCaretPosition)) {
            return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, true);
          }
        }
        if (rangeIsInContainerBlock) {
          return renderRangeCaret(editor, caretPosition.toRange(), true);
        }
        return null;
      };
      var moveToCeFalseVertically = function (direction, editor, walkerFn, range) {
        var caretPosition, linePositions, nextLinePositions;
        var closestNextLineRect, caretClientRect, clientX;
        var dist1, dist2, contentEditableFalseNode;
        contentEditableFalseNode = getSelectedNode$1(range);
        caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
        linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
        nextLinePositions = $_9tjm51ljh8lywbq.filter(linePositions, isLine(1));
        caretClientRect = $_9tjm51ljh8lywbq.last(caretPosition.getClientRects());
        if (isBeforeContentEditableFalse$2(caretPosition) || isBeforeTable(caretPosition)) {
          contentEditableFalseNode = caretPosition.getNode();
        }
        if (isAfterContentEditableFalse$2(caretPosition) || isAfterTable(caretPosition)) {
          contentEditableFalseNode = caretPosition.getNode(true);
        }
        if (!caretClientRect) {
          return null;
        }
        clientX = caretClientRect.left;
        closestNextLineRect = findClosestClientRect(nextLinePositions, clientX);
        if (closestNextLineRect) {
          if (isContentEditableFalse$11(closestNextLineRect.node)) {
            dist1 = Math.abs(clientX - closestNextLineRect.left);
            dist2 = Math.abs(clientX - closestNextLineRect.right);
            return showCaret(direction, editor, closestNextLineRect.node, dist1 < dist2, true);
          }
        }
        if (contentEditableFalseNode) {
          var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), contentEditableFalseNode);
          closestNextLineRect = findClosestClientRect($_9tjm51ljh8lywbq.filter(caretPositions, isLine(1)), clientX);
          if (closestNextLineRect) {
            return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
          }
          closestNextLineRect = $_9tjm51ljh8lywbq.last($_9tjm51ljh8lywbq.filter(caretPositions, isLine(0)));
          if (closestNextLineRect) {
            return renderRangeCaret(editor, closestNextLineRect.position.toRange(), true);
          }
        }
      };
      var createTextBlock = function (editor) {
        var textBlock = editor.dom.create(editor.settings.forced_root_block);
        if (!$_9bpim8ajh8lyw68.ie || $_9bpim8ajh8lyw68.ie >= 11) {
          textBlock.innerHTML = '<br data-mce-bogus="1">';
        }
        return textBlock;
      };
      var exitPreBlock = function (editor, direction, range) {
        var pre, caretPos, newBlock;
        var caretWalker = CaretWalker(editor.getBody());
        var getNextVisualCaretPosition = $_8aqzj925jh8lywmj.curry(getVisualCaretPosition, caretWalker.next);
        var getPrevVisualCaretPosition = $_8aqzj925jh8lywmj.curry(getVisualCaretPosition, caretWalker.prev);
        if (range.collapsed && editor.settings.forced_root_block) {
          pre = editor.dom.getParent(range.startContainer, 'PRE');
          if (!pre) {
            return;
          }
          if (direction === 1) {
            caretPos = getNextVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
          } else {
            caretPos = getPrevVisualCaretPosition(CaretPosition$1.fromRangeStart(range));
          }
          if (!caretPos) {
            newBlock = createTextBlock(editor);
            if (direction === 1) {
              editor.$(pre).after(newBlock);
            } else {
              editor.$(pre).before(newBlock);
            }
            editor.selection.select(newBlock, true);
            editor.selection.collapse();
          }
        }
      };
      var getHorizontalRange = function (editor, forward) {
        var caretWalker = CaretWalker(editor.getBody());
        var getNextVisualCaretPosition = $_8aqzj925jh8lywmj.curry(getVisualCaretPosition, caretWalker.next);
        var getPrevVisualCaretPosition = $_8aqzj925jh8lywmj.curry(getVisualCaretPosition, caretWalker.prev);
        var newRange;
        var direction = forward ? HDirection.Forwards : HDirection.Backwards;
        var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
        var range = editor.selection.getRng();
        newRange = moveToCeFalseHorizontally(direction, editor, getNextPosFn, range);
        if (newRange) {
          return newRange;
        }
        newRange = exitPreBlock(editor, direction, range);
        if (newRange) {
          return newRange;
        }
        return null;
      };
      var getVerticalRange = function (editor, down) {
        var newRange;
        var direction = down ? 1 : -1;
        var walkerFn = down ? downUntil : upUntil;
        var range = editor.selection.getRng();
        newRange = moveToCeFalseVertically(direction, editor, walkerFn, range);
        if (newRange) {
          return newRange;
        }
        newRange = exitPreBlock(editor, direction, range);
        if (newRange) {
          return newRange;
        }
        return null;
      };
      var moveH$1 = function (editor, forward) {
        return function () {
          var newRng = getHorizontalRange(editor, forward);
          if (newRng) {
            editor.selection.setRng(newRng);
            return true;
          } else {
            return false;
          }
        };
      };
      var moveV$1 = function (editor, down) {
        return function () {
          var newRng = getVerticalRange(editor, down);
          if (newRng) {
            editor.selection.setRng(newRng);
            return true;
          } else {
            return false;
          }
        };
      };

      var defaultPatterns = function (patterns) {
        return $_5wjzy24jh8lyw2t.map(patterns, function (pattern) {
          return $_7ffry568jh8lyxfy.merge({
            shiftKey: false,
            altKey: false,
            ctrlKey: false,
            metaKey: false,
            keyCode: 0,
            action: $_eqpqvr6jh8lyw3s.noop
          }, pattern);
        });
      };
      var matchesEvent = function (pattern, evt) {
        return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
      };
      var match$1 = function (patterns, evt) {
        return $_5wjzy24jh8lyw2t.bind(defaultPatterns(patterns), function (pattern) {
          return matchesEvent(pattern, evt) ? [pattern] : [];
        });
      };
      var action = function (f) {
        var x = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          x[_i - 1] = arguments[_i];
        }
        var args = Array.prototype.slice.call(arguments, 1);
        return function () {
          return f.apply(null, args);
        };
      };
      var execute = function (patterns, evt) {
        return $_5wjzy24jh8lyw2t.find(match$1(patterns, evt), function (pattern) {
          return pattern.action();
        });
      };
      var $_8um8ta6vjh8lyxko = {
        match: match$1,
        action: action,
        execute: execute
      };

      var executeKeydownOverride = function (editor, caret, evt) {
        var os = $_9hkktfnjh8lywc6.detect().os;
        $_8um8ta6vjh8lyxko.execute([
          {
            keyCode: $_6lsk4i5gjh8lyxau.RIGHT,
            action: moveH$1(editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.LEFT,
            action: moveH$1(editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.UP,
            action: moveV$1(editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DOWN,
            action: moveV$1(editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.RIGHT,
            action: moveH(editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.LEFT,
            action: moveH(editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.UP,
            action: moveV(editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DOWN,
            action: moveV(editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.RIGHT,
            action: $_65xx7w3pjh8lyx0d.move(editor, caret, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.LEFT,
            action: $_65xx7w3pjh8lyx0d.move(editor, caret, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.RIGHT,
            ctrlKey: !os.isOSX(),
            altKey: os.isOSX(),
            action: $_65xx7w3pjh8lyx0d.moveNextWord(editor, caret)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.LEFT,
            ctrlKey: !os.isOSX(),
            altKey: os.isOSX(),
            action: $_65xx7w3pjh8lyx0d.movePrevWord(editor, caret)
          }
        ], evt).each(function (_) {
          evt.preventDefault();
        });
      };
      var setup$5 = function (editor, caret) {
        editor.on('keydown', function (evt) {
          if (evt.isDefaultPrevented() === false) {
            executeKeydownOverride(editor, caret, evt);
          }
        });
      };
      var $_8m3to56tjh8lyxkd = { setup: setup$5 };

      var getParentInlines = function (rootElm, startElm) {
        var parents = $_dyxtub3ejh8lywxq.parentsAndSelf(startElm, rootElm);
        return $_5wjzy24jh8lyw2t.findIndex(parents, isBlock).fold($_eqpqvr6jh8lyw3s.constant(parents), function (index) {
          return parents.slice(0, index);
        });
      };
      var hasOnlyOneChild$1 = function (elm) {
        return $_a43q0i17jh8lywfe.children(elm).length === 1;
      };
      var deleteLastPosition = function (forward, editor, target, parentInlines) {
        var isFormatElement$$1 = $_eqpqvr6jh8lyw3s.curry(isFormatElement, editor);
        var formatNodes = $_5wjzy24jh8lyw2t.map($_5wjzy24jh8lyw2t.filter(parentInlines, isFormatElement$$1), function (elm) {
          return elm.dom();
        });
        if (formatNodes.length === 0) {
          $_1al0sh3jjh8lywyv.deleteElement(editor, forward, target);
        } else {
          var pos = replaceWithCaretFormat(target.dom(), formatNodes);
          editor.selection.setRng(pos.toRange());
        }
      };
      var deleteCaret$1 = function (editor, forward) {
        var rootElm = $_cgttw3zjh8lywdq.fromDom(editor.getBody());
        var startElm = $_cgttw3zjh8lywdq.fromDom(editor.selection.getStart());
        var parentInlines = $_5wjzy24jh8lyw2t.filter(getParentInlines(rootElm, startElm), hasOnlyOneChild$1);
        return $_5wjzy24jh8lyw2t.last(parentInlines).map(function (target) {
          var fromPos = CaretPosition$1.fromRangeStart(editor.selection.getRng());
          if ($_aj8isd34jh8lyws4.willDeleteLastPositionInElement(forward, fromPos, target.dom())) {
            deleteLastPosition(forward, editor, target, parentInlines);
            return true;
          } else {
            return false;
          }
        }).getOr(false);
      };
      var backspaceDelete$5 = function (editor, forward) {
        return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
      };
      var $_vald86xjh8lyxkw = { backspaceDelete: backspaceDelete$5 };

      var executeKeydownOverride$1 = function (editor, caret, evt) {
        $_8um8ta6vjh8lyxko.execute([
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_ar80r13gjh8lywy7.backspaceDelete, editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_ar80r13gjh8lywy7.backspaceDelete, editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_ej9d8d3kjh8lywzc.backspaceDelete, editor, caret, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_ej9d8d3kjh8lywzc.backspaceDelete, editor, caret, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_lcy1p3fjh8lywxx.backspaceDelete, editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_lcy1p3fjh8lywxx.backspaceDelete, editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_5jmwsv32jh8lywrr.backspaceDelete, editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_5jmwsv32jh8lywrr.backspaceDelete, editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_746feo3rjh8lyx0o.backspaceDelete, editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_746feo3rjh8lyx0o.backspaceDelete, editor, true)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_vald86xjh8lyxkw.backspaceDelete, editor, false)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_vald86xjh8lyxkw.backspaceDelete, editor, true)
          }
        ], evt).each(function (_) {
          evt.preventDefault();
        });
      };
      var executeKeyupOverride = function (editor, evt) {
        $_8um8ta6vjh8lyxko.execute([
          {
            keyCode: $_6lsk4i5gjh8lyxau.BACKSPACE,
            action: $_8um8ta6vjh8lyxko.action($_ar80r13gjh8lywy7.paddEmptyElement, editor)
          },
          {
            keyCode: $_6lsk4i5gjh8lyxau.DELETE,
            action: $_8um8ta6vjh8lyxko.action($_ar80r13gjh8lywy7.paddEmptyElement, editor)
          }
        ], evt);
      };
      var setup$6 = function (editor, caret) {
        editor.on('keydown', function (evt) {
          if (evt.isDefaultPrevented() === false) {
            executeKeydownOverride$1(editor, caret, evt);
          }
        });
        editor.on('keyup', function (evt) {
          if (evt.isDefaultPrevented() === false) {
            executeKeyupOverride(editor, evt);
          }
        });
      };
      var $_4ow4756wjh8lyxkt = { setup: setup$6 };

      var firstNonWhiteSpaceNodeSibling = function (node) {
        while (node) {
          if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
            return node;
          }
          node = node.nextSibling;
        }
      };
      var moveToCaretPosition = function (editor, root) {
        var walker, node, rng, lastNode = root, tempElm;
        var dom = editor.dom;
        var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
        if (!root) {
          return;
        }
        if (/^(LI|DT|DD)$/.test(root.nodeName)) {
          var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
          if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
            root.insertBefore(dom.doc.createTextNode('\xA0'), root.firstChild);
          }
        }
        rng = dom.createRng();
        root.normalize();
        if (root.hasChildNodes()) {
          walker = new TreeWalker(root, root);
          while (node = walker.current()) {
            if ($_5oonaz1qjh8lywhz.isText(node)) {
              rng.setStart(node, 0);
              rng.setEnd(node, 0);
              break;
            }
            if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
              rng.setStartBefore(node);
              rng.setEndBefore(node);
              break;
            }
            lastNode = node;
            node = walker.next();
          }
          if (!node) {
            rng.setStart(lastNode, 0);
            rng.setEnd(lastNode, 0);
          }
        } else {
          if ($_5oonaz1qjh8lywhz.isBr(root)) {
            if (root.nextSibling && dom.isBlock(root.nextSibling)) {
              rng.setStartBefore(root);
              rng.setEndBefore(root);
            } else {
              rng.setStartAfter(root);
              rng.setEndAfter(root);
            }
          } else {
            rng.setStart(root, 0);
            rng.setEnd(root, 0);
          }
        }
        editor.selection.setRng(rng);
        dom.remove(tempElm);
        editor.selection.scrollIntoView(root);
      };
      var getEditableRoot = function (dom, node) {
        var root = dom.getRoot();
        var parent, editableRoot;
        parent = node;
        while (parent !== root && dom.getContentEditable(parent) !== 'false') {
          if (dom.getContentEditable(parent) === 'true') {
            editableRoot = parent;
          }
          parent = parent.parentNode;
        }
        return parent !== root ? editableRoot : root;
      };
      var getParentBlock$2 = function (editor) {
        return Option.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
      };
      var getParentBlockName = function (editor) {
        return getParentBlock$2(editor).fold($_eqpqvr6jh8lyw3s.constant(''), function (parentBlock) {
          return parentBlock.nodeName.toUpperCase();
        });
      };
      var isListItemParentBlock = function (editor) {
        return getParentBlock$2(editor).filter(function (elm) {
          return isListItem($_cgttw3zjh8lywdq.fromDom(elm));
        }).isSome();
      };
      var $_83wjn572jh8lyxlu = {
        moveToCaretPosition: moveToCaretPosition,
        getEditableRoot: getEditableRoot,
        getParentBlock: getParentBlock$2,
        getParentBlockName: getParentBlockName,
        isListItemParentBlock: isListItemParentBlock
      };

      var hasFirstChild = function (elm, name) {
        return elm.firstChild && elm.firstChild.nodeName === name;
      };
      var hasParent$1 = function (elm, parentName) {
        return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
      };
      var isListBlock = function (elm) {
        return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
      };
      var isNestedList = function (elm) {
        return isListBlock(elm) && isListBlock(elm.parentNode);
      };
      var getContainerBlock = function (containerBlock) {
        var containerBlockParent = containerBlock.parentNode;
        if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
          return containerBlockParent;
        }
        return containerBlock;
      };
      var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
        var node = containerBlock[first ? 'firstChild' : 'lastChild'];
        while (node) {
          if ($_5oonaz1qjh8lywhz.isElement(node)) {
            break;
          }
          node = node[first ? 'nextSibling' : 'previousSibling'];
        }
        return node === parentBlock;
      };
      var insert$1 = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
        var dom = editor.dom;
        var rng = editor.selection.getRng();
        if (containerBlock === editor.getBody()) {
          return;
        }
        if (isNestedList(containerBlock)) {
          newBlockName = 'LI';
        }
        var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
        if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
          if (hasParent$1(containerBlock, 'LI')) {
            dom.insertAfter(newBlock, getContainerBlock(containerBlock));
          } else {
            dom.replace(newBlock, containerBlock);
          }
        } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
          if (hasParent$1(containerBlock, 'LI')) {
            dom.insertAfter(newBlock, getContainerBlock(containerBlock));
            newBlock.appendChild(dom.doc.createTextNode(' '));
            newBlock.appendChild(containerBlock);
          } else {
            containerBlock.parentNode.insertBefore(newBlock, containerBlock);
          }
        } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
        } else {
          containerBlock = getContainerBlock(containerBlock);
          var tmpRng = rng.cloneRange();
          tmpRng.setStartAfter(parentBlock);
          tmpRng.setEndAfter(containerBlock);
          var fragment = tmpRng.extractContents();
          if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
            newBlock = fragment.firstChild;
            dom.insertAfter(fragment, containerBlock);
          } else {
            dom.insertAfter(fragment, containerBlock);
            dom.insertAfter(newBlock, containerBlock);
          }
        }
        dom.remove(parentBlock);
        $_83wjn572jh8lyxlu.moveToCaretPosition(editor, newBlock);
      };
      var $_5pzeb371jh8lyxlr = { insert: insert$1 };

      var isEmptyAnchor = function (elm) {
        return elm && elm.nodeName === 'A' && $_ahowuxkjh8lywbj.trim($_d383mr21jh8lywlv.trim(elm.innerText || elm.textContent)).length === 0;
      };
      var isTableCell$5 = function (node) {
        return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
      };
      var emptyBlock = function (elm) {
        elm.innerHTML = '<br data-mce-bogus="1">';
      };
      var containerAndSiblingName = function (container, nodeName) {
        return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
      };
      var canSplitBlock = function (dom, node) {
        return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
      };
      var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
        var node = block;
        var firstChilds = [];
        var i;
        if (!node) {
          return;
        }
        while (node = node.firstChild) {
          if (dom.isBlock(node)) {
            return;
          }
          if ($_5oonaz1qjh8lywhz.isElement(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
            firstChilds.push(node);
          }
        }
        i = firstChilds.length;
        while (i--) {
          node = firstChilds[i];
          if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
            dom.remove(node);
          } else {
            if (isEmptyAnchor(node)) {
              dom.remove(node);
            }
          }
        }
      };
      var normalizeZwspOffset = function (start, container, offset) {
        if ($_5oonaz1qjh8lywhz.isText(container) === false) {
          return offset;
        } else if (start) {
          return offset === 1 && container.data.charAt(offset - 1) === $_d383mr21jh8lywlv.ZWSP ? 0 : offset;
        } else {
          return offset === container.data.length - 1 && container.data.charAt(offset) === $_d383mr21jh8lywlv.ZWSP ? container.data.length : offset;
        }
      };
      var includeZwspInRange = function (rng) {
        var newRng = rng.cloneRange();
        newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
        newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
        return newRng;
      };
      var trimLeadingLineBreaks = function (node) {
        do {
          if ($_5oonaz1qjh8lywhz.isText(node)) {
            node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
          }
          node = node.firstChild;
        } while (node);
      };
      var getEditableRoot$1 = function (dom, node) {
        var root = dom.getRoot();
        var parent, editableRoot;
        parent = node;
        while (parent !== root && dom.getContentEditable(parent) !== 'false') {
          if (dom.getContentEditable(parent) === 'true') {
            editableRoot = parent;
          }
          parent = parent.parentNode;
        }
        return parent !== root ? editableRoot : root;
      };
      var setForcedBlockAttrs = function (editor, node) {
        var forcedRootBlockName = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
        if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
          editor.dom.setAttribs(node, $_66vr6g2jjh8lywpf.getForcedRootBlockAttrs(editor));
        }
      };
      var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
        var newBlock, parentBlock, startNode, node, next, rootBlockName;
        var blockName = newBlockName || 'P';
        var dom = editor.dom, editableRoot = getEditableRoot$1(dom, container);
        parentBlock = dom.getParent(container, dom.isBlock);
        if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
          parentBlock = parentBlock || editableRoot;
          if (parentBlock === editor.getBody() || isTableCell$5(parentBlock)) {
            rootBlockName = parentBlock.nodeName.toLowerCase();
          } else {
            rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
          }
          if (!parentBlock.hasChildNodes()) {
            newBlock = dom.create(blockName);
            setForcedBlockAttrs(editor, newBlock);
            parentBlock.appendChild(newBlock);
            rng.setStart(newBlock, 0);
            rng.setEnd(newBlock, 0);
            return newBlock;
          }
          node = container;
          while (node.parentNode !== parentBlock) {
            node = node.parentNode;
          }
          while (node && !dom.isBlock(node)) {
            startNode = node;
            node = node.previousSibling;
          }
          if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
            newBlock = dom.create(blockName);
            setForcedBlockAttrs(editor, newBlock);
            startNode.parentNode.insertBefore(newBlock, startNode);
            node = startNode;
            while (node && !dom.isBlock(node)) {
              next = node.nextSibling;
              newBlock.appendChild(node);
              node = next;
            }
            rng.setStart(container, offset);
            rng.setEnd(container, offset);
          }
        }
        return container;
      };
      var addBrToBlockIfNeeded = function (dom, block) {
        var lastChild;
        block.normalize();
        lastChild = block.lastChild;
        if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
          dom.add(block, 'br');
        }
      };
      var insert$2 = function (editor, evt) {
        var tmpRng, editableRoot, container, offset, parentBlock, shiftKey;
        var newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;
        var dom = editor.dom;
        var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
        var rng = editor.selection.getRng();
        var createNewBlock = function (name) {
          var node = container, block, clonedNode, caretNode;
          var textInlineElements = schema.getTextInlineElements();
          if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
            block = dom.create(name || newBlockName);
            setForcedBlockAttrs(editor, block);
          } else {
            block = parentBlock.cloneNode(false);
          }
          caretNode = block;
          if ($_66vr6g2jjh8lywpf.shouldKeepStyles(editor) === false) {
            dom.setAttrib(block, 'style', null);
            dom.setAttrib(block, 'class', null);
          } else {
            do {
              if (textInlineElements[node.nodeName]) {
                if (isCaretNode(node)) {
                  continue;
                }
                clonedNode = node.cloneNode(false);
                dom.setAttrib(clonedNode, 'id', '');
                if (block.hasChildNodes()) {
                  clonedNode.appendChild(block.firstChild);
                  block.appendChild(clonedNode);
                } else {
                  caretNode = clonedNode;
                  block.appendChild(clonedNode);
                }
              }
            } while ((node = node.parentNode) && node !== editableRoot);
          }
          emptyBlock(caretNode);
          return block;
        };
        var isCaretAtStartOrEndOfBlock = function (start) {
          var walker, node, name, normalizedOffset;
          normalizedOffset = normalizeZwspOffset(start, container, offset);
          if ($_5oonaz1qjh8lywhz.isText(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
            return false;
          }
          if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
            return true;
          }
          if (start && $_5oonaz1qjh8lywhz.isElement(container) && container === parentBlock.firstChild) {
            return true;
          }
          if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
            return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
          }
          walker = new TreeWalker(container, parentBlock);
          if ($_5oonaz1qjh8lywhz.isText(container)) {
            if (start && normalizedOffset === 0) {
              walker.prev();
            } else if (!start && normalizedOffset === container.nodeValue.length) {
              walker.next();
            }
          }
          while (node = walker.current()) {
            if ($_5oonaz1qjh8lywhz.isElement(node)) {
              if (!node.getAttribute('data-mce-bogus')) {
                name = node.nodeName.toLowerCase();
                if (nonEmptyElementsMap[name] && name !== 'br') {
                  return false;
                }
              }
            } else if ($_5oonaz1qjh8lywhz.isText(node) && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
              return false;
            }
            if (start) {
              walker.prev();
            } else {
              walker.next();
            }
          }
          return true;
        };
        var insertNewBlockAfter = function () {
          if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
            newBlock = createNewBlock(newBlockName);
          } else {
            newBlock = createNewBlock();
          }
          if ($_66vr6g2jjh8lywpf.shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
            newBlock = dom.split(containerBlock, parentBlock);
          } else {
            dom.insertAfter(newBlock, parentBlock);
          }
          $_83wjn572jh8lyxlu.moveToCaretPosition(editor, newBlock);
        };
        $_4v2pn63yjh8lyx2s.normalize(dom, rng).each(function (normRng) {
          rng.setStart(normRng.startContainer, normRng.startOffset);
          rng.setEnd(normRng.endContainer, normRng.endOffset);
        });
        container = rng.startContainer;
        offset = rng.startOffset;
        newBlockName = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
        shiftKey = evt.shiftKey;
        if ($_5oonaz1qjh8lywhz.isElement(container) && container.hasChildNodes()) {
          isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
          container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
          if (isAfterLastNodeInContainer && $_5oonaz1qjh8lywhz.isText(container)) {
            offset = container.nodeValue.length;
          } else {
            offset = 0;
          }
        }
        editableRoot = getEditableRoot$1(dom, container);
        if (!editableRoot) {
          return;
        }
        if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
          container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
        }
        parentBlock = dom.getParent(container, dom.isBlock);
        containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
        parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
        containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
        if (containerBlockName === 'LI' && !evt.ctrlKey) {
          parentBlock = containerBlock;
          containerBlock = containerBlock.parentNode;
          parentBlockName = containerBlockName;
        }
        if (/^(LI|DT|DD)$/.test(parentBlockName)) {
          if (dom.isEmpty(parentBlock)) {
            $_5pzeb371jh8lyxlr.insert(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
            return;
          }
        }
        if (newBlockName && parentBlock === editor.getBody()) {
          return;
        }
        newBlockName = newBlockName || 'P';
        if (isCaretContainerBlock(parentBlock)) {
          newBlock = showCaretContainerBlock(parentBlock);
          if (dom.isEmpty(parentBlock)) {
            emptyBlock(parentBlock);
          }
          $_83wjn572jh8lyxlu.moveToCaretPosition(editor, newBlock);
        } else if (isCaretAtStartOrEndOfBlock()) {
          insertNewBlockAfter();
        } else if (isCaretAtStartOrEndOfBlock(true)) {
          newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
          $_83wjn572jh8lyxlu.moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
        } else {
          tmpRng = includeZwspInRange(rng).cloneRange();
          tmpRng.setEndAfter(parentBlock);
          fragment = tmpRng.extractContents();
          trimLeadingLineBreaks(fragment);
          newBlock = fragment.firstChild;
          dom.insertAfter(fragment, parentBlock);
          trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
          addBrToBlockIfNeeded(dom, parentBlock);
          if (dom.isEmpty(parentBlock)) {
            emptyBlock(parentBlock);
          }
          newBlock.normalize();
          if (dom.isEmpty(newBlock)) {
            dom.remove(newBlock);
            insertNewBlockAfter();
          } else {
            $_83wjn572jh8lyxlu.moveToCaretPosition(editor, newBlock);
          }
        }
        dom.setAttrib(newBlock, 'id', '');
        editor.fire('NewBlock', { newBlock: newBlock });
      };
      var $_apcs0t70jh8lyxlh = { insert: insert$2 };

      var matchesSelector = function (editor, selector) {
        return $_83wjn572jh8lyxlu.getParentBlock(editor).filter(function (parentBlock) {
          return selector.length > 0 && $_5h4ipt1fjh8lywgi.is($_cgttw3zjh8lywdq.fromDom(parentBlock), selector);
        }).isSome();
      };
      var shouldInsertBr = function (editor) {
        return matchesSelector(editor, $_66vr6g2jjh8lywpf.getBrNewLineSelector(editor));
      };
      var shouldBlockNewLine = function (editor) {
        return matchesSelector(editor, $_66vr6g2jjh8lywpf.getNoNewLineSelector(editor));
      };
      var $_5mj33174jh8lyxm9 = {
        shouldInsertBr: shouldInsertBr,
        shouldBlockNewLine: shouldBlockNewLine
      };

      var newLineAction = $_1ml90g3ijh8lywyp.generate([
        { br: [] },
        { block: [] },
        { none: [] }
      ]);
      var shouldBlockNewLine$1 = function (editor, shiftKey) {
        return $_5mj33174jh8lyxm9.shouldBlockNewLine(editor);
      };
      var isBrMode = function (requiredState) {
        return function (editor, shiftKey) {
          var brMode = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor) === '';
          return brMode === requiredState;
        };
      };
      var inListBlock = function (requiredState) {
        return function (editor, shiftKey) {
          return $_83wjn572jh8lyxlu.isListItemParentBlock(editor) === requiredState;
        };
      };
      var inBlock = function (blockName, requiredState) {
        return function (editor, shiftKey) {
          var state = $_83wjn572jh8lyxlu.getParentBlockName(editor) === blockName.toUpperCase();
          return state === requiredState;
        };
      };
      var inPreBlock = function (requiredState) {
        return inBlock('pre', requiredState);
      };
      var inSummaryBlock = function () {
        return inBlock('summary', true);
      };
      var shouldPutBrInPre$1 = function (requiredState) {
        return function (editor, shiftKey) {
          return $_66vr6g2jjh8lywpf.shouldPutBrInPre(editor) === requiredState;
        };
      };
      var inBrContext = function (editor, shiftKey) {
        return $_5mj33174jh8lyxm9.shouldInsertBr(editor);
      };
      var hasShiftKey = function (editor, shiftKey) {
        return shiftKey;
      };
      var canInsertIntoEditableRoot = function (editor) {
        var forcedRootBlock = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
        var rootEditable = $_83wjn572jh8lyxlu.getEditableRoot(editor.dom, editor.selection.getStart());
        return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
      };
      var match$2 = function (predicates, action) {
        return function (editor, shiftKey) {
          var isMatch = $_5wjzy24jh8lyw2t.foldl(predicates, function (res, p) {
            return res && p(editor, shiftKey);
          }, true);
          return isMatch ? Option.some(action) : Option.none();
        };
      };
      var getAction$1 = function (editor, evt) {
        return $_7r5om73ojh8lyx09.evaluateUntil([
          match$2([shouldBlockNewLine$1], newLineAction.none()),
          match$2([inSummaryBlock()], newLineAction.br()),
          match$2([
            inPreBlock(true),
            shouldPutBrInPre$1(false),
            hasShiftKey
          ], newLineAction.br()),
          match$2([
            inPreBlock(true),
            shouldPutBrInPre$1(false)
          ], newLineAction.block()),
          match$2([
            inPreBlock(true),
            shouldPutBrInPre$1(true),
            hasShiftKey
          ], newLineAction.block()),
          match$2([
            inPreBlock(true),
            shouldPutBrInPre$1(true)
          ], newLineAction.br()),
          match$2([
            inListBlock(true),
            hasShiftKey
          ], newLineAction.br()),
          match$2([inListBlock(true)], newLineAction.block()),
          match$2([
            isBrMode(true),
            hasShiftKey,
            canInsertIntoEditableRoot
          ], newLineAction.block()),
          match$2([isBrMode(true)], newLineAction.br()),
          match$2([inBrContext], newLineAction.br()),
          match$2([
            isBrMode(false),
            hasShiftKey
          ], newLineAction.br()),
          match$2([canInsertIntoEditableRoot], newLineAction.block())
        ], [
          editor,
          evt.shiftKey
        ]).getOr(newLineAction.none());
      };
      var $_efe7kj73jh8lyxm2 = { getAction: getAction$1 };

      var insert$3 = function (editor, evt) {
        $_efe7kj73jh8lyxm2.getAction(editor, evt).fold(function () {
          $_cg4dz53xjh8lyx2g.insert(editor, evt);
        }, function () {
          $_apcs0t70jh8lyxlh.insert(editor, evt);
        }, $_eqpqvr6jh8lyw3s.noop);
      };
      var $_5e167p6zjh8lyxlc = { insert: insert$3 };

      var endTypingLevel = function (undoManager) {
        if (undoManager.typing) {
          undoManager.typing = false;
          undoManager.add();
        }
      };
      var handleEnterKeyEvent = function (editor, event) {
        if (event.isDefaultPrevented()) {
          return;
        }
        event.preventDefault();
        endTypingLevel(editor.undoManager);
        editor.undoManager.transact(function () {
          if (editor.selection.isCollapsed() === false) {
            editor.execCommand('Delete');
          }
          $_5e167p6zjh8lyxlc.insert(editor, event);
        });
      };
      var setup$7 = function (editor) {
        editor.on('keydown', function (event) {
          if (event.keyCode === $_6lsk4i5gjh8lyxau.ENTER) {
            handleEnterKeyEvent(editor, event);
          }
        });
      };
      var $_5ff4w26yjh8lyxl3 = { setup: setup$7 };

      var isValidInsertPoint = function (location, caretPosition) {
        return isAtStartOrEnd(location) && $_5oonaz1qjh8lywhz.isText(caretPosition.container());
      };
      var insertNbspAtPosition = function (editor, caretPosition) {
        var container = caretPosition.container();
        var offset = caretPosition.offset();
        container.insertData(offset, '\xA0');
        editor.selection.setCursorLocation(container, offset + 1);
      };
      var insertAtLocation = function (editor, caretPosition, location) {
        if (isValidInsertPoint(location, caretPosition)) {
          insertNbspAtPosition(editor, caretPosition);
          return true;
        } else {
          return false;
        }
      };
      var insertAtCaret$2 = function (editor) {
        var isInlineTarget = $_eqpqvr6jh8lyw3s.curry($_231v7s37jh8lywt3.isInlineTarget, editor);
        var caretPosition = CaretPosition$1.fromRangeStart(editor.selection.getRng());
        var boundaryLocation = $_6kjy7r3njh8lywzz.readLocation(isInlineTarget, editor.getBody(), caretPosition);
        return boundaryLocation.map($_eqpqvr6jh8lyw3s.curry(insertAtLocation, editor, caretPosition)).getOr(false);
      };
      var isAtStartOrEnd = function (location) {
        return location.fold($_eqpqvr6jh8lyw3s.constant(false), $_eqpqvr6jh8lyw3s.constant(true), $_eqpqvr6jh8lyw3s.constant(true), $_eqpqvr6jh8lyw3s.constant(false));
      };
      var insertAtSelection = function (editor) {
        return editor.selection.isCollapsed() ? insertAtCaret$2(editor) : false;
      };
      var $_aptbve76jh8lyxme = { insertAtSelection: insertAtSelection };

      var executeKeydownOverride$2 = function (editor, evt) {
        $_8um8ta6vjh8lyxko.execute([{
            keyCode: $_6lsk4i5gjh8lyxau.SPACEBAR,
            action: $_8um8ta6vjh8lyxko.action($_aptbve76jh8lyxme.insertAtSelection, editor)
          }], evt).each(function (_) {
          evt.preventDefault();
        });
      };
      var setup$8 = function (editor) {
        editor.on('keydown', function (evt) {
          if (evt.isDefaultPrevented() === false) {
            executeKeydownOverride$2(editor, evt);
          }
        });
      };
      var $_50nb7z75jh8lyxmd = { setup: setup$8 };

      var findBlockCaretContainer = function (editor) {
        return $_7sg18r3cjh8lywu1.descendant($_cgttw3zjh8lywdq.fromDom(editor.getBody()), '*[data-mce-caret]').fold($_eqpqvr6jh8lyw3s.constant(null), function (elm) {
          return elm.dom();
        });
      };
      var removeIeControlRect = function (editor) {
        editor.selection.setRng(editor.selection.getRng());
      };
      var showBlockCaretContainer = function (editor, blockCaretContainer) {
        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
          showCaretContainerBlock(blockCaretContainer);
          removeIeControlRect(editor);
          editor.selection.scrollIntoView(blockCaretContainer);
        }
      };
      var handleBlockContainer = function (editor, e) {
        var blockCaretContainer = findBlockCaretContainer(editor);
        if (!blockCaretContainer) {
          return;
        }
        if (e.type === 'compositionstart') {
          e.preventDefault();
          e.stopPropagation();
          showBlockCaretContainer(editor, blockCaretContainer);
          return;
        }
        if (hasContent(blockCaretContainer)) {
          showBlockCaretContainer(editor, blockCaretContainer);
          editor.undoManager.add();
        }
      };
      var setup$9 = function (editor) {
        editor.on('keyup compositionstart', $_eqpqvr6jh8lyw3s.curry(handleBlockContainer, editor));
      };
      var $_98x1lt77jh8lyxmi = { setup: setup$9 };

      var setup$10 = function (editor) {
        var caret = $_65xx7w3pjh8lyx0d.setupSelectedState(editor);
        $_98x1lt77jh8lyxmi.setup(editor);
        $_8m3to56tjh8lyxkd.setup(editor, caret);
        $_4ow4756wjh8lyxkt.setup(editor, caret);
        $_5ff4w26yjh8lyxl3.setup(editor);
        $_50nb7z75jh8lyxmd.setup(editor);
      };
      var $_btkj596sjh8lyxkc = { setup: setup$10 };

      function Quirks (editor) {
        var each = $_ahowuxkjh8lywbj.each;
        var BACKSPACE = $_6lsk4i5gjh8lyxau.BACKSPACE, DELETE = $_6lsk4i5gjh8lyxau.DELETE, dom = editor.dom, selection = editor.selection, settings = editor.settings, parser = editor.parser;
        var isGecko = $_9bpim8ajh8lyw68.gecko, isIE = $_9bpim8ajh8lyw68.ie, isWebKit = $_9bpim8ajh8lyw68.webkit;
        var mceInternalUrlPrefix = 'data:text/mce-internal,';
        var mceInternalDataType = isIE ? 'Text' : 'URL';
        var setEditorCommandState = function (cmd, state) {
          try {
            editor.getDoc().execCommand(cmd, false, state);
          } catch (ex) {
          }
        };
        var isDefaultPrevented = function (e) {
          return e.isDefaultPrevented();
        };
        var setMceInternalContent = function (e) {
          var selectionHtml, internalContent;
          if (e.dataTransfer) {
            if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
              selection.select(e.target);
            }
            selectionHtml = editor.selection.getContent();
            if (selectionHtml.length > 0) {
              internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
              e.dataTransfer.setData(mceInternalDataType, internalContent);
            }
          }
        };
        var getMceInternalContent = function (e) {
          var internalContent;
          if (e.dataTransfer) {
            internalContent = e.dataTransfer.getData(mceInternalDataType);
            if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
              internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
              return {
                id: unescape(internalContent[0]),
                html: unescape(internalContent[1])
              };
            }
          }
          return null;
        };
        var insertClipboardContents = function (content, internal) {
          if (editor.queryCommandSupported('mceInsertClipboardContent')) {
            editor.execCommand('mceInsertClipboardContent', false, {
              content: content,
              internal: internal
            });
          } else {
            editor.execCommand('mceInsertContent', false, content);
          }
        };
        var emptyEditorWhenDeleting = function () {
          var serializeRng = function (rng) {
            var body = dom.create('body');
            var contents = rng.cloneContents();
            body.appendChild(contents);
            return selection.serializer.serialize(body, { format: 'html' });
          };
          var allContentsSelected = function (rng) {
            var selection = serializeRng(rng);
            var allRng = dom.createRng();
            allRng.selectNode(editor.getBody());
            var allSelection = serializeRng(allRng);
            return selection === allSelection;
          };
          editor.on('keydown', function (e) {
            var keyCode = e.keyCode;
            var isCollapsed, body;
            if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
              isCollapsed = editor.selection.isCollapsed();
              body = editor.getBody();
              if (isCollapsed && !dom.isEmpty(body)) {
                return;
              }
              if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
                return;
              }
              e.preventDefault();
              editor.setContent('');
              if (body.firstChild && dom.isBlock(body.firstChild)) {
                editor.selection.setCursorLocation(body.firstChild, 0);
              } else {
                editor.selection.setCursorLocation(body, 0);
              }
              editor.nodeChanged();
            }
          });
        };
        var selectAll = function () {
          editor.shortcuts.add('meta+a', null, 'SelectAll');
        };
        var inputMethodFocus = function () {
          if (!editor.settings.content_editable) {
            dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
              var rng;
              if (e.target === editor.getDoc().documentElement) {
                rng = selection.getRng();
                editor.getBody().focus();
                if (e.type === 'mousedown') {
                  if (isCaretContainer(rng.startContainer)) {
                    return;
                  }
                  selection.placeCaretAt(e.clientX, e.clientY);
                } else {
                  selection.setRng(rng);
                }
              }
            });
          }
        };
        var removeHrOnBackspace = function () {
          editor.on('keydown', function (e) {
            if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
              if (!editor.getBody().getElementsByTagName('hr').length) {
                return;
              }
              if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
                var node = selection.getNode();
                var previousSibling = node.previousSibling;
                if (node.nodeName === 'HR') {
                  dom.remove(node);
                  e.preventDefault();
                  return;
                }
                if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
                  dom.remove(previousSibling);
                  e.preventDefault();
                }
              }
            }
          });
        };
        var focusBody = function () {
          if (!Range.prototype.getClientRects) {
            editor.on('mousedown', function (e) {
              if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
                var body_1 = editor.getBody();
                body_1.blur();
                $_8sy3pfhjh8lyw95.setEditorTimeout(editor, function () {
                  body_1.focus();
                });
              }
            });
          }
        };
        var selectControlElements = function () {
          editor.on('click', function (e) {
            var target = e.target;
            if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
              e.preventDefault();
              editor.selection.select(target);
              editor.nodeChanged();
            }
            if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
              e.preventDefault();
              selection.select(target);
            }
          });
        };
        var removeStylesWhenDeletingAcrossBlockElements = function () {
          var getAttributeApplyFunction = function () {
            var template = dom.getAttribs(selection.getStart().cloneNode(false));
            return function () {
              var target = selection.getStart();
              if (target !== editor.getBody()) {
                dom.setAttrib(target, 'style', null);
                each(template, function (attr) {
                  target.setAttributeNode(attr.cloneNode(true));
                });
              }
            };
          };
          var isSelectionAcrossElements = function () {
            return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
          };
          editor.on('keypress', function (e) {
            var applyAttributes;
            if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
              applyAttributes = getAttributeApplyFunction();
              editor.getDoc().execCommand('delete', false, null);
              applyAttributes();
              e.preventDefault();
              return false;
            }
          });
          dom.bind(editor.getDoc(), 'cut', function (e) {
            var applyAttributes;
            if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
              applyAttributes = getAttributeApplyFunction();
              $_8sy3pfhjh8lyw95.setEditorTimeout(editor, function () {
                applyAttributes();
              });
            }
          });
        };
        var disableBackspaceIntoATable = function () {
          editor.on('keydown', function (e) {
            if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
              if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
                var previousSibling = selection.getNode().previousSibling;
                if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
                  e.preventDefault();
                  return false;
                }
              }
            }
          });
        };
        var removeBlockQuoteOnBackSpace = function () {
          editor.on('keydown', function (e) {
            var rng, container, offset, root, parent;
            if (isDefaultPrevented(e) || e.keyCode !== $_6lsk4i5gjh8lyxau.BACKSPACE) {
              return;
            }
            rng = selection.getRng();
            container = rng.startContainer;
            offset = rng.startOffset;
            root = dom.getRoot();
            parent = container;
            if (!rng.collapsed || offset !== 0) {
              return;
            }
            while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
              parent = parent.parentNode;
            }
            if (parent.tagName === 'BLOCKQUOTE') {
              editor.formatter.toggle('blockquote', null, parent);
              rng = dom.createRng();
              rng.setStart(container, 0);
              rng.setEnd(container, 0);
              selection.setRng(rng);
            }
          });
        };
        var setGeckoEditingOptions = function () {
          var setOpts = function () {
            setEditorCommandState('StyleWithCSS', false);
            setEditorCommandState('enableInlineTableEditing', false);
            if (!settings.object_resizing) {
              setEditorCommandState('enableObjectResizing', false);
            }
          };
          if (!settings.readonly) {
            editor.on('BeforeExecCommand MouseDown', setOpts);
          }
        };
        var addBrAfterLastLinks = function () {
          var fixLinks = function () {
            each(dom.select('a'), function (node) {
              var parentNode = node.parentNode;
              var root = dom.getRoot();
              if (parentNode.lastChild === node) {
                while (parentNode && !dom.isBlock(parentNode)) {
                  if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
                    return;
                  }
                  parentNode = parentNode.parentNode;
                }
                dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
              }
            });
          };
          editor.on('SetContent ExecCommand', function (e) {
            if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
              fixLinks();
            }
          });
        };
        var setDefaultBlockType = function () {
          if (settings.forced_root_block) {
            editor.on('init', function () {
              setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block);
            });
          }
        };
        var normalizeSelection = function () {
          editor.on('keyup focusin mouseup', function (e) {
            if (!$_6lsk4i5gjh8lyxau.modifierPressed(e)) {
              selection.normalize();
            }
          }, true);
        };
        var showBrokenImageIcon = function () {
          editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
        };
        var restoreFocusOnKeyDown = function () {
          if (!editor.inline) {
            editor.on('keydown', function () {
              if (document.activeElement === document.body) {
                editor.getWin().focus();
              }
            });
          }
        };
        var bodyHeight = function () {
          if (!editor.inline) {
            editor.contentStyles.push('body {min-height: 150px}');
            editor.on('click', function (e) {
              var rng;
              if (e.target.nodeName === 'HTML') {
                if ($_9bpim8ajh8lyw68.ie > 11) {
                  editor.getBody().focus();
                  return;
                }
                rng = editor.selection.getRng();
                editor.getBody().focus();
                editor.selection.setRng(rng);
                editor.selection.normalize();
                editor.nodeChanged();
              }
            });
          }
        };
        var blockCmdArrowNavigation = function () {
          if ($_9bpim8ajh8lyw68.mac) {
            editor.on('keydown', function (e) {
              if ($_6lsk4i5gjh8lyxau.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
                e.preventDefault();
                editor.selection.getSel().modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
              }
            });
          }
        };
        var disableAutoUrlDetect = function () {
          setEditorCommandState('AutoUrlDetect', false);
        };
        var tapLinksAndImages = function () {
          editor.on('click', function (e) {
            var elm = e.target;
            do {
              if (elm.tagName === 'A') {
                e.preventDefault();
                return;
              }
            } while (elm = elm.parentNode);
          });
          editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
        };
        var blockFormSubmitInsideEditor = function () {
          editor.on('init', function () {
            editor.dom.bind(editor.getBody(), 'submit', function (e) {
              e.preventDefault();
            });
          });
        };
        var removeAppleInterchangeBrs = function () {
          parser.addNodeFilter('br', function (nodes) {
            var i = nodes.length;
            while (i--) {
              if (nodes[i].attr('class') === 'Apple-interchange-newline') {
                nodes[i].remove();
              }
            }
          });
        };
        var ieInternalDragAndDrop = function () {
          editor.on('dragstart', function (e) {
            setMceInternalContent(e);
          });
          editor.on('drop', function (e) {
            if (!isDefaultPrevented(e)) {
              var internalContent = getMceInternalContent(e);
              if (internalContent && internalContent.id !== editor.id) {
                e.preventDefault();
                var rng = $_ct0ht56jjh8lyxif.fromPoint(e.x, e.y, editor.getDoc());
                selection.setRng(rng);
                insertClipboardContents(internalContent.html, true);
              }
            }
          });
        };
        var refreshContentEditable = function () {
        };
        var isHidden = function () {
          var sel;
          if (!isGecko || editor.removed) {
            return 0;
          }
          sel = editor.selection.getSel();
          return !sel || !sel.rangeCount || sel.rangeCount === 0;
        };
        removeBlockQuoteOnBackSpace();
        emptyEditorWhenDeleting();
        if (!$_9bpim8ajh8lyw68.windowsPhone) {
          normalizeSelection();
        }
        if (isWebKit) {
          inputMethodFocus();
          selectControlElements();
          setDefaultBlockType();
          blockFormSubmitInsideEditor();
          disableBackspaceIntoATable();
          removeAppleInterchangeBrs();
          if ($_9bpim8ajh8lyw68.iOS) {
            restoreFocusOnKeyDown();
            bodyHeight();
            tapLinksAndImages();
          } else {
            selectAll();
          }
        }
        if ($_9bpim8ajh8lyw68.ie >= 11) {
          bodyHeight();
          disableBackspaceIntoATable();
        }
        if ($_9bpim8ajh8lyw68.ie) {
          selectAll();
          disableAutoUrlDetect();
          ieInternalDragAndDrop();
        }
        if (isGecko) {
          removeHrOnBackspace();
          focusBody();
          removeStylesWhenDeletingAcrossBlockElements();
          setGeckoEditingOptions();
          addBrAfterLastLinks();
          showBrokenImageIcon();
          blockCmdArrowNavigation();
          disableBackspaceIntoATable();
        }
        return {
          refreshContentEditable: refreshContentEditable,
          isHidden: isHidden
        };
      }

      var isTextBlockNode = function (node) {
        return $_5oonaz1qjh8lywhz.isElement(node) && isTextBlock($_cgttw3zjh8lywdq.fromDom(node));
      };
      var normalizeSelection$1 = function (editor) {
        var rng = editor.selection.getRng();
        var startPos = CaretPosition.fromRangeStart(rng);
        var endPos = CaretPosition.fromRangeEnd(rng);
        if (CaretPosition.isElementPosition(startPos)) {
          var container = startPos.container();
          if (isTextBlockNode(container)) {
            $_9kvypj2cjh8lywnz.firstPositionIn(container).each(function (pos) {
              return rng.setStart(pos.container(), pos.offset());
            });
          }
        }
        if (CaretPosition.isElementPosition(endPos)) {
          var container = startPos.container();
          if (isTextBlockNode(container)) {
            $_9kvypj2cjh8lywnz.lastPositionIn(container).each(function (pos) {
              return rng.setEnd(pos.container(), pos.offset());
            });
          }
        }
        editor.selection.setRng($_cnbluh30jh8lywrn.normalize(rng));
      };
      var setup$11 = function (editor) {
        editor.on('click', function (e) {
          if (e.detail === 3) {
            normalizeSelection$1(editor);
          }
        });
      };
      var $_1nhbc479jh8lyxn0 = { setup: setup$11 };

      var preventSummaryToggle = function (editor) {
        editor.on('click', function (e) {
          if (editor.dom.getParent(e.target, 'details')) {
            e.preventDefault();
          }
        });
      };
      var filterDetails = function (editor) {
        editor.parser.addNodeFilter('details', function (elms) {
          $_5wjzy24jh8lyw2t.each(elms, function (details) {
            details.attr('data-mce-open', details.attr('open'));
            details.attr('open', 'open');
          });
        });
        editor.serializer.addNodeFilter('details', function (elms) {
          $_5wjzy24jh8lyw2t.each(elms, function (details) {
            var open = details.attr('data-mce-open');
            details.attr('open', $_dp4g6d7jh8lyw3y.isString(open) ? open : null);
            details.attr('data-mce-open', null);
          });
        });
      };
      var setup$12 = function (editor) {
        preventSummaryToggle(editor);
        filterDetails(editor);
      };

      var DOM$2 = DOMUtils$1.DOM;
      var appendStyle = function (editor, text) {
        var head = $_cgttw3zjh8lywdq.fromDom(editor.getDoc().head);
        var tag = $_cgttw3zjh8lywdq.fromTag('style');
        $_3da62i14jh8lyweo.set(tag, 'type', 'text/css');
        $_4m7u2e2kjh8lywpi.append(tag, $_cgttw3zjh8lywdq.fromText(text));
        $_4m7u2e2kjh8lywpi.append(head, tag);
      };
      var createParser = function (editor) {
        var parser = DomParser(editor.settings, editor.schema);
        parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
          var i = nodes.length, node;
          var dom = editor.dom;
          var value, internalName;
          while (i--) {
            node = nodes[i];
            value = node.attr(name);
            internalName = 'data-mce-' + name;
            if (!node.attributes.map[internalName]) {
              if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
                continue;
              }
              if (name === 'style') {
                value = dom.serializeStyle(dom.parseStyle(value), node.name);
                if (!value.length) {
                  value = null;
                }
                node.attr(internalName, value);
                node.attr(name, value);
              } else if (name === 'tabindex') {
                node.attr(internalName, value);
                node.attr(name, null);
              } else {
                node.attr(internalName, editor.convertURL(value, name, node.name));
              }
            }
          }
        });
        parser.addNodeFilter('script', function (nodes) {
          var i = nodes.length, node, type;
          while (i--) {
            node = nodes[i];
            type = node.attr('type') || 'no/type';
            if (type.indexOf('mce-') !== 0) {
              node.attr('type', 'mce-' + type);
            }
          }
        });
        parser.addNodeFilter('#cdata', function (nodes) {
          var i = nodes.length, node;
          while (i--) {
            node = nodes[i];
            node.type = 8;
            node.name = '#comment';
            node.value = '[CDATA[' + node.value + ']]';
          }
        });
        parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
          var i = nodes.length, node;
          var nonEmptyElements = editor.schema.getNonEmptyElements();
          while (i--) {
            node = nodes[i];
            if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
              node.append(new Node$2('br', 1)).shortEnded = true;
            }
          }
        });
        return parser;
      };
      var autoFocus = function (editor) {
        if (editor.settings.auto_focus) {
          $_8sy3pfhjh8lyw95.setEditorTimeout(editor, function () {
            var focusEditor;
            if (editor.settings.auto_focus === true) {
              focusEditor = editor;
            } else {
              focusEditor = editor.editorManager.get(editor.settings.auto_focus);
            }
            if (!focusEditor.destroyed) {
              focusEditor.focus();
            }
          }, 100);
        }
      };
      var initEditor = function (editor) {
        editor.bindPendingEventDelegates();
        editor.initialized = true;
        editor.fire('init');
        editor.focus(true);
        editor.nodeChanged({ initial: true });
        editor.execCallback('init_instance_callback', editor);
        autoFocus(editor);
      };
      var getStyleSheetLoader = function (editor) {
        return editor.inline ? DOM$2.styleSheetLoader : editor.dom.styleSheetLoader;
      };
      var initContentBody = function (editor, skipWrite) {
        var settings = editor.settings;
        var targetElm = editor.getElement();
        var doc = editor.getDoc(), body, contentCssText;
        if (!settings.inline) {
          editor.getElement().style.visibility = editor.orgVisibility;
        }
        if (!skipWrite && !settings.content_editable) {
          doc.open();
          doc.write(editor.iframeHTML);
          doc.close();
        }
        if (settings.content_editable) {
          editor.on('remove', function () {
            var bodyEl = this.getBody();
            DOM$2.removeClass(bodyEl, 'mce-content-body');
            DOM$2.removeClass(bodyEl, 'mce-edit-focus');
            DOM$2.setAttrib(bodyEl, 'contentEditable', null);
          });
          DOM$2.addClass(targetElm, 'mce-content-body');
          editor.contentDocument = doc = settings.content_document || document;
          editor.contentWindow = settings.content_window || window;
          editor.bodyElement = targetElm;
          settings.content_document = settings.content_window = null;
          settings.root_name = targetElm.nodeName.toLowerCase();
        }
        body = editor.getBody();
        body.disabled = true;
        editor.readonly = settings.readonly;
        if (!editor.readonly) {
          if (editor.inline && DOM$2.getStyle(body, 'position', true) === 'static') {
            body.style.position = 'relative';
          }
          body.contentEditable = editor.getParam('content_editable_state', true);
        }
        body.disabled = false;
        editor.editorUpload = EditorUpload(editor);
        editor.schema = Schema(settings);
        editor.dom = DOMUtils$1(doc, {
          keep_values: true,
          url_converter: editor.convertURL,
          url_converter_scope: editor,
          hex_colors: settings.force_hex_style_colors,
          class_filter: settings.class_filter,
          update_styles: true,
          root_element: editor.inline ? editor.getBody() : null,
          collect: settings.content_editable,
          schema: editor.schema,
          onSetAttrib: function (e) {
            editor.fire('SetAttrib', e);
          }
        });
        editor.parser = createParser(editor);
        editor.serializer = DomSerializer$1(settings, editor);
        editor.selection = Selection$1(editor.dom, editor.getWin(), editor.serializer, editor);
        editor.formatter = Formatter(editor);
        editor.undoManager = UndoManager(editor);
        editor._nodeChangeDispatcher = new NodeChange(editor);
        editor._selectionOverrides = SelectionOverrides(editor);
        setup$12(editor);
        $_1nhbc479jh8lyxn0.setup(editor);
        $_btkj596sjh8lyxkc.setup(editor);
        $_85z7kh54jh8lyx8j.setup(editor);
        editor.fire('PreInit');
        if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
          doc.body.spellcheck = false;
          DOM$2.setAttrib(body, 'spellcheck', 'false');
        }
        editor.quirks = Quirks(editor);
        editor.fire('PostRender');
        if (settings.directionality) {
          body.dir = settings.directionality;
        }
        if (settings.nowrap) {
          body.style.whiteSpace = 'nowrap';
        }
        if (settings.protect) {
          editor.on('BeforeSetContent', function (e) {
            $_ahowuxkjh8lywbj.each(settings.protect, function (pattern) {
              e.content = e.content.replace(pattern, function (str) {
                return '<!--mce:protected ' + escape(str) + '-->';
              });
            });
          });
        }
        editor.on('SetContent', function () {
          editor.addVisual(editor.getBody());
        });
        editor.load({
          initial: true,
          format: 'html'
        });
        editor.startContent = editor.getContent({ format: 'raw' });
        editor.on('compositionstart compositionend', function (e) {
          editor.composing = e.type === 'compositionstart';
        });
        if (editor.contentStyles.length > 0) {
          contentCssText = '';
          $_ahowuxkjh8lywbj.each(editor.contentStyles, function (style) {
            contentCssText += style + '\r\n';
          });
          editor.dom.addStyle(contentCssText);
        }
        getStyleSheetLoader(editor).loadAll(editor.contentCSS, function (_) {
          initEditor(editor);
        }, function (urls) {
          initEditor(editor);
        });
        if (settings.content_style) {
          appendStyle(editor, settings.content_style);
        }
      };
      var $_g84rjb4rjh8lyx6v = { initContentBody: initContentBody };

      var DOM$3 = DOMUtils$1.DOM;
      var relaxDomain = function (editor, ifr) {
        if (document.domain !== window.location.hostname && $_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 12) {
          var bodyUuid = $_co2y7g52jh8lyx8f.uuid('mce');
          editor[bodyUuid] = function () {
            $_g84rjb4rjh8lyx6v.initContentBody(editor);
          };
          var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
          DOM$3.setAttrib(ifr, 'src', domainRelaxUrl);
          return true;
        }
        return false;
      };
      var normalizeHeight = function (height) {
        var normalizedHeight = typeof height === 'number' ? height + 'px' : height;
        return normalizedHeight ? normalizedHeight : '';
      };
      var createIframeElement = function (id, title, height, customAttrs) {
        var iframe = $_cgttw3zjh8lywdq.fromTag('iframe');
        $_3da62i14jh8lyweo.setAll(iframe, customAttrs);
        $_3da62i14jh8lyweo.setAll(iframe, {
          id: id + '_ifr',
          frameBorder: '0',
          allowTransparency: 'true',
          title: title
        });
        $_36knnd12jh8lywe1.setAll(iframe, {
          width: '100%',
          height: normalizeHeight(height),
          display: 'block'
        });
        return iframe;
      };
      var getIframeHtml = function (editor) {
        var bodyId, bodyClass, iframeHTML;
        iframeHTML = $_66vr6g2jjh8lywpf.getDocType(editor) + '<html><head>';
        if ($_66vr6g2jjh8lywpf.getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
          iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
        }
        iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
        bodyId = $_66vr6g2jjh8lywpf.getBodyId(editor);
        bodyClass = $_66vr6g2jjh8lywpf.getBodyClass(editor);
        if ($_66vr6g2jjh8lywpf.getContentSecurityPolicy(editor)) {
          iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + $_66vr6g2jjh8lywpf.getContentSecurityPolicy(editor) + '" />';
        }
        iframeHTML += '</head><body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '"><br></body></html>';
        return iframeHTML;
      };
      var createIframe = function (editor, o) {
        var title = editor.editorManager.translate('Rich Text Area. Press ALT-F9 for menu. ' + 'Press ALT-F10 for toolbar. Press ALT-0 for help');
        var ifr = createIframeElement(editor.id, title, o.height, $_66vr6g2jjh8lywpf.getIframeAttrs(editor)).dom();
        ifr.onload = function () {
          ifr.onload = null;
          editor.fire('load');
        };
        var isDomainRelaxed = relaxDomain(editor, ifr);
        editor.contentAreaContainer = o.iframeContainer;
        editor.iframeElement = ifr;
        editor.iframeHTML = getIframeHtml(editor);
        DOM$3.add(o.iframeContainer, ifr);
        return isDomainRelaxed;
      };
      var init$1 = function (editor, boxInfo) {
        var isDomainRelaxed = createIframe(editor, boxInfo);
        if (boxInfo.editorContainer) {
          DOM$3.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
          editor.hidden = DOM$3.isHidden(boxInfo.editorContainer);
        }
        editor.getElement().style.display = 'none';
        DOM$3.setAttrib(editor.id, 'aria-hidden', 'true');
        if (!isDomainRelaxed) {
          $_g84rjb4rjh8lyx6v.initContentBody(editor);
        }
      };
      var $_9i7a4m7bjh8lyxnf = { init: init$1 };

      var DOM$4 = DOMUtils$1.DOM;
      var initPlugin = function (editor, initializedPlugins, plugin) {
        var Plugin = PluginManager$1.get(plugin);
        var pluginUrl, pluginInstance;
        pluginUrl = PluginManager$1.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
        plugin = $_ahowuxkjh8lywbj.trim(plugin);
        if (Plugin && $_ahowuxkjh8lywbj.inArray(initializedPlugins, plugin) === -1) {
          $_ahowuxkjh8lywbj.each(PluginManager$1.dependencies(plugin), function (dep) {
            initPlugin(editor, initializedPlugins, dep);
          });
          if (editor.plugins[plugin]) {
            return;
          }
          pluginInstance = new Plugin(editor, pluginUrl, editor.$);
          editor.plugins[plugin] = pluginInstance;
          if (pluginInstance.init) {
            pluginInstance.init(editor, pluginUrl);
            initializedPlugins.push(plugin);
          }
        }
      };
      var trimLegacyPrefix = function (name) {
        return name.replace(/^\-/, '');
      };
      var initPlugins = function (editor) {
        var initializedPlugins = [];
        $_ahowuxkjh8lywbj.each(editor.settings.plugins.split(/[ ,]/), function (name) {
          initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
        });
      };
      var initTheme = function (editor) {
        var Theme;
        var theme = editor.settings.theme;
        if ($_dp4g6d7jh8lyw3y.isString(theme)) {
          editor.settings.theme = trimLegacyPrefix(theme);
          Theme = ThemeManager.get(theme);
          editor.theme = new Theme(editor, ThemeManager.urls[theme]);
          if (editor.theme.init) {
            editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
          }
        } else {
          editor.theme = {};
        }
      };
      var renderFromLoadedTheme = function (editor) {
        var w, h, minHeight, re, info;
        var settings = editor.settings;
        var elm = editor.getElement();
        w = settings.width || DOM$4.getStyle(elm, 'width') || '100%';
        h = settings.height || DOM$4.getStyle(elm, 'height') || elm.offsetHeight;
        minHeight = settings.min_height || 100;
        re = /^[0-9\.]+(|px)$/i;
        if (re.test('' + w)) {
          w = Math.max(parseInt(w, 10), 100);
        }
        if (re.test('' + h)) {
          h = Math.max(parseInt(h, 10), minHeight);
        }
        info = editor.theme.renderUI({
          targetNode: elm,
          width: w,
          height: h,
          deltaWidth: settings.delta_width,
          deltaHeight: settings.delta_height
        });
        if (!settings.content_editable) {
          h = (info.iframeHeight || h) + (typeof h === 'number' ? info.deltaHeight || 0 : '');
          if (h < minHeight) {
            h = minHeight;
          }
        }
        info.height = h;
        return info;
      };
      var renderFromThemeFunc = function (editor) {
        var info;
        var elm = editor.getElement();
        info = editor.settings.theme(editor, elm);
        if (info.editorContainer.nodeType) {
          info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
        }
        if (info.iframeContainer && info.iframeContainer.nodeType) {
          info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
        }
        info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
        return info;
      };
      var createThemeFalseResult = function (element) {
        return {
          editorContainer: element,
          iframeContainer: element
        };
      };
      var renderThemeFalseIframe = function (targetElement) {
        var iframeContainer = DOM$4.create('div');
        DOM$4.insertAfter(iframeContainer, targetElement);
        return createThemeFalseResult(iframeContainer);
      };
      var renderThemeFalse = function (editor) {
        var targetElement = editor.getElement();
        return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
      };
      var renderThemeUi = function (editor) {
        var settings = editor.settings, elm = editor.getElement();
        editor.orgDisplay = elm.style.display;
        if ($_dp4g6d7jh8lyw3y.isString(settings.theme)) {
          return renderFromLoadedTheme(editor);
        } else if ($_dp4g6d7jh8lyw3y.isFunction(settings.theme)) {
          return renderFromThemeFunc(editor);
        } else {
          return renderThemeFalse(editor);
        }
      };
      var init$2 = function (editor) {
        var settings = editor.settings;
        var elm = editor.getElement();
        var boxInfo;
        editor.rtl = settings.rtl_ui || editor.editorManager.i18n.rtl;
        editor.editorManager.i18n.setCode(settings.language);
        settings.aria_label = settings.aria_label || DOM$4.getAttrib(elm, 'aria-label', editor.getLang('aria.rich_text_area'));
        editor.fire('ScriptsLoaded');
        initTheme(editor);
        initPlugins(editor);
        boxInfo = renderThemeUi(editor);
        editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
        if (settings.content_css) {
          $_ahowuxkjh8lywbj.each($_ahowuxkjh8lywbj.explode(settings.content_css), function (u) {
            editor.contentCSS.push(editor.documentBaseURI.toAbsolute(u));
          });
        }
        if (settings.content_editable) {
          return $_g84rjb4rjh8lyx6v.initContentBody(editor);
        } else {
          return $_9i7a4m7bjh8lyxnf.init(editor, boxInfo);
        }
      };
      var $_bynk2f4ojh8lyx6l = { init: init$2 };

      var DOM$5 = DOMUtils$1.DOM;
      var hasSkipLoadPrefix = function (name) {
        return name.charAt(0) === '-';
      };
      var loadLanguage = function (scriptLoader, editor) {
        var settings = editor.settings;
        if (settings.language && settings.language !== 'en' && !settings.language_url) {
          settings.language_url = editor.editorManager.baseURL + '/langs/' + settings.language + '.js';
        }
        if (settings.language_url && !editor.editorManager.i18n.data[settings.language]) {
          scriptLoader.add(settings.language_url);
        }
      };
      var loadTheme = function (scriptLoader, editor, suffix, callback) {
        var settings = editor.settings, theme = settings.theme;
        if ($_dp4g6d7jh8lyw3y.isString(theme)) {
          if (!hasSkipLoadPrefix(theme) && !ThemeManager.urls.hasOwnProperty(theme)) {
            var themeUrl = settings.theme_url;
            if (themeUrl) {
              ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
            } else {
              ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
            }
          }
          scriptLoader.loadQueue(function () {
            ThemeManager.waitFor(theme, callback);
          });
        } else {
          callback();
        }
      };
      var loadPlugins = function (settings, suffix) {
        if ($_ahowuxkjh8lywbj.isArray(settings.plugins)) {
          settings.plugins = settings.plugins.join(' ');
        }
        $_ahowuxkjh8lywbj.each(settings.external_plugins, function (url, name) {
          PluginManager$1.load(name, url);
          settings.plugins += ' ' + name;
        });
        $_ahowuxkjh8lywbj.each(settings.plugins.split(/[ ,]/), function (plugin) {
          plugin = $_ahowuxkjh8lywbj.trim(plugin);
          if (plugin && !PluginManager$1.urls[plugin]) {
            if (hasSkipLoadPrefix(plugin)) {
              plugin = plugin.substr(1, plugin.length);
              var dependencies = PluginManager$1.dependencies(plugin);
              $_ahowuxkjh8lywbj.each(dependencies, function (dep) {
                var defaultSettings = {
                  prefix: 'plugins/',
                  resource: dep,
                  suffix: '/plugin' + suffix + '.js'
                };
                dep = PluginManager$1.createUrl(defaultSettings, dep);
                PluginManager$1.load(dep.resource, dep);
              });
            } else {
              PluginManager$1.load(plugin, {
                prefix: 'plugins/',
                resource: plugin,
                suffix: '/plugin' + suffix + '.js'
              });
            }
          }
        });
      };
      var loadScripts = function (editor, suffix) {
        var scriptLoader = ScriptLoader.ScriptLoader;
        loadTheme(scriptLoader, editor, suffix, function () {
          loadLanguage(scriptLoader, editor);
          loadPlugins(editor.settings, suffix);
          scriptLoader.loadQueue(function () {
            if (!editor.removed) {
              $_bynk2f4ojh8lyx6l.init(editor);
            }
          }, editor, function (urls) {
            $_5vy074njh8lyx6h.pluginLoadError(editor, urls[0]);
            if (!editor.removed) {
              $_bynk2f4ojh8lyx6l.init(editor);
            }
          });
        });
      };
      var render = function (editor) {
        var settings = editor.settings, id = editor.id;
        var readyHandler = function () {
          DOM$5.unbind(window, 'ready', readyHandler);
          editor.render();
        };
        if (!EventUtils.Event.domLoaded) {
          DOM$5.bind(window, 'ready', readyHandler);
          return;
        }
        if (!editor.getElement()) {
          return;
        }
        if (!$_9bpim8ajh8lyw68.contentEditable) {
          return;
        }
        if (!settings.inline) {
          editor.orgVisibility = editor.getElement().style.visibility;
          editor.getElement().style.visibility = 'hidden';
        } else {
          editor.inline = true;
        }
        var form = editor.getElement().form || DOM$5.getParent(id, 'form');
        if (form) {
          editor.formElement = form;
          if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(editor.getElement().nodeName)) {
            DOM$5.insertAfter(DOM$5.create('input', {
              type: 'hidden',
              name: id
            }), id);
            editor.hasHiddenInput = true;
          }
          editor.formEventDelegate = function (e) {
            editor.fire(e.type, e);
          };
          DOM$5.bind(form, 'submit reset', editor.formEventDelegate);
          editor.on('reset', function () {
            editor.setContent(editor.startContent, { format: 'raw' });
          });
          if (settings.submit_patch && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
            form._mceOldSubmit = form.submit;
            form.submit = function () {
              editor.editorManager.triggerSave();
              editor.setDirty(false);
              return form._mceOldSubmit(form);
            };
          }
        }
        editor.windowManager = WindowManager(editor);
        editor.notificationManager = NotificationManager(editor);
        if (settings.encoding === 'xml') {
          editor.on('GetContent', function (e) {
            if (e.save) {
              e.content = DOM$5.encode(e.content);
            }
          });
        }
        if (settings.add_form_submit_trigger) {
          editor.on('submit', function () {
            if (editor.initialized) {
              editor.save();
            }
          });
        }
        if (settings.add_unload_trigger) {
          editor._beforeUnload = function () {
            if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
              editor.save({
                format: 'raw',
                no_events: true,
                set_dirty: false
              });
            }
          };
          editor.editorManager.on('BeforeUnload', editor._beforeUnload);
        }
        editor.editorManager.add(editor);
        loadScripts(editor, editor.suffix);
      };
      var $_64g0n44hjh8lyx5e = { render: render };

      var add$3 = function (editor, name, settings) {
        var sidebars = editor.sidebars ? editor.sidebars : [];
        sidebars.push({
          name: name,
          settings: settings
        });
        editor.sidebars = sidebars;
      };
      var $_67cz5d7cjh8lyxnm = { add: add$3 };

      var each$20 = $_ahowuxkjh8lywbj.each;
      var trim$4 = $_ahowuxkjh8lywbj.trim;
      var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
      var DEFAULT_PORTS = {
        ftp: 21,
        http: 80,
        https: 443,
        mailto: 25
      };
      var URI = function (url, settings) {
        var self = this;
        var baseUri, baseUrl;
        url = trim$4(url);
        settings = self.settings = settings || {};
        baseUri = settings.base_uri;
        if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
          self.source = url;
          return;
        }
        var isProtocolRelative = url.indexOf('//') === 0;
        if (url.indexOf('/') === 0 && !isProtocolRelative) {
          url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
        }
        if (!/^[\w\-]*:?\/\//.test(url)) {
          baseUrl = settings.base_uri ? settings.base_uri.path : new URI(document.location.href).directory;
          if (settings.base_uri.protocol == '') {
            url = '//mce_host' + self.toAbsPath(baseUrl, url);
          } else {
            url = /([^#?]*)([#?]?.*)/.exec(url);
            url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, url[1]) + url[2];
          }
        }
        url = url.replace(/@@/g, '(mce_at)');
        url = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
        each$20(queryParts, function (v, i) {
          var part = url[i];
          if (part) {
            part = part.replace(/\(mce_at\)/g, '@@');
          }
          self[v] = part;
        });
        if (baseUri) {
          if (!self.protocol) {
            self.protocol = baseUri.protocol;
          }
          if (!self.userInfo) {
            self.userInfo = baseUri.userInfo;
          }
          if (!self.port && self.host === 'mce_host') {
            self.port = baseUri.port;
          }
          if (!self.host || self.host === 'mce_host') {
            self.host = baseUri.host;
          }
          self.source = '';
        }
        if (isProtocolRelative) {
          self.protocol = '';
        }
      };
      URI.prototype = {
        setPath: function (path) {
          var self = this;
          path = /^(.*?)\/?(\w+)?$/.exec(path);
          self.path = path[0];
          self.directory = path[1];
          self.file = path[2];
          self.source = '';
          self.getURI();
        },
        toRelative: function (uri) {
          var self = this;
          var output;
          if (uri === './') {
            return uri;
          }
          uri = new URI(uri, { base_uri: self });
          if (uri.host !== 'mce_host' && self.host !== uri.host && uri.host || self.port !== uri.port || self.protocol !== uri.protocol && uri.protocol !== '') {
            return uri.getURI();
          }
          var tu = self.getURI(), uu = uri.getURI();
          if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
            return tu;
          }
          output = self.toRelPath(self.path, uri.path);
          if (uri.query) {
            output += '?' + uri.query;
          }
          if (uri.anchor) {
            output += '#' + uri.anchor;
          }
          return output;
        },
        toAbsolute: function (uri, noHost) {
          uri = new URI(uri, { base_uri: this });
          return uri.getURI(noHost && this.isSameOrigin(uri));
        },
        isSameOrigin: function (uri) {
          if (this.host == uri.host && this.protocol == uri.protocol) {
            if (this.port == uri.port) {
              return true;
            }
            var defaultPort = DEFAULT_PORTS[this.protocol];
            if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
              return true;
            }
          }
          return false;
        },
        toRelPath: function (base, path) {
          var items, breakPoint = 0, out = '', i, l;
          base = base.substring(0, base.lastIndexOf('/'));
          base = base.split('/');
          items = path.split('/');
          if (base.length >= items.length) {
            for (i = 0, l = base.length; i < l; i++) {
              if (i >= items.length || base[i] !== items[i]) {
                breakPoint = i + 1;
                break;
              }
            }
          }
          if (base.length < items.length) {
            for (i = 0, l = items.length; i < l; i++) {
              if (i >= base.length || base[i] !== items[i]) {
                breakPoint = i + 1;
                break;
              }
            }
          }
          if (breakPoint === 1) {
            return path;
          }
          for (i = 0, l = base.length - (breakPoint - 1); i < l; i++) {
            out += '../';
          }
          for (i = breakPoint - 1, l = items.length; i < l; i++) {
            if (i !== breakPoint - 1) {
              out += '/' + items[i];
            } else {
              out += items[i];
            }
          }
          return out;
        },
        toAbsPath: function (base, path) {
          var i, nb = 0, o = [], tr, outPath;
          tr = /\/$/.test(path) ? '/' : '';
          base = base.split('/');
          path = path.split('/');
          each$20(base, function (k) {
            if (k) {
              o.push(k);
            }
          });
          base = o;
          for (i = path.length - 1, o = []; i >= 0; i--) {
            if (path[i].length === 0 || path[i] === '.') {
              continue;
            }
            if (path[i] === '..') {
              nb++;
              continue;
            }
            if (nb > 0) {
              nb--;
              continue;
            }
            o.push(path[i]);
          }
          i = base.length - nb;
          if (i <= 0) {
            outPath = o.reverse().join('/');
          } else {
            outPath = base.slice(0, i).join('/') + '/' + o.reverse().join('/');
          }
          if (outPath.indexOf('/') !== 0) {
            outPath = '/' + outPath;
          }
          if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
            outPath += tr;
          }
          return outPath;
        },
        getURI: function (noProtoHost) {
          var s;
          var self = this;
          if (!self.source || noProtoHost) {
            s = '';
            if (!noProtoHost) {
              if (self.protocol) {
                s += self.protocol + '://';
              } else {
                s += '//';
              }
              if (self.userInfo) {
                s += self.userInfo + '@';
              }
              if (self.host) {
                s += self.host;
              }
              if (self.port) {
                s += ':' + self.port;
              }
            }
            if (self.path) {
              s += self.path;
            }
            if (self.query) {
              s += '?' + self.query;
            }
            if (self.anchor) {
              s += '#' + self.anchor;
            }
            self.source = s;
          }
          return self.source;
        }
      };
      URI.parseDataUri = function (uri) {
        var type, matches;
        uri = decodeURIComponent(uri).split(',');
        matches = /data:([^;]+)/.exec(uri[0]);
        if (matches) {
          type = matches[1];
        }
        return {
          type: type,
          data: uri[1]
        };
      };
      URI.getDocumentBaseUrl = function (loc) {
        var baseUrl;
        if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
          baseUrl = loc.href;
        } else {
          baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
        }
        if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
          baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
          if (!/[\/\\]$/.test(baseUrl)) {
            baseUrl += '/';
          }
        }
        return baseUrl;
      };

      var defaultFormat = 'html';
      var trimEmptyContents = function (editor, html) {
        var blockName = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
        var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
        return html.replace(emptyRegExp, '');
      };
      var getContentFromBody = function (editor, args, body) {
        var content;
        args.format = args.format ? args.format : defaultFormat;
        args.get = true;
        args.getInner = true;
        if (!args.no_events) {
          editor.fire('BeforeGetContent', args);
        }
        if (args.format === 'raw') {
          content = $_ahowuxkjh8lywbj.trim($_8lol015jjh8lyxbf.trimExternal(editor.serializer, body.innerHTML));
        } else if (args.format === 'text') {
          content = $_d383mr21jh8lywlv.trim(body.innerText || body.textContent);
        } else if (args.format === 'tree') {
          return editor.serializer.serialize(body, args);
        } else {
          content = trimEmptyContents(editor, editor.serializer.serialize(body, args));
        }
        if (args.format !== 'text' && !isWsPreserveElement($_cgttw3zjh8lywdq.fromDom(body))) {
          args.content = $_ahowuxkjh8lywbj.trim(content);
        } else {
          args.content = content;
        }
        if (!args.no_events) {
          editor.fire('GetContent', args);
        }
        return args.content;
      };
      var getContent$1 = function (editor, args) {
        if (args === void 0) {
          args = {};
        }
        return Option.from(editor.getBody()).fold($_eqpqvr6jh8lyw3s.constant(args.format === 'tree' ? new Node$2('body', 11) : ''), function (body) {
          return getContentFromBody(editor, args, body);
        });
      };

      var traverse = function (node, fn) {
        fn(node);
        if (node.firstChild) {
          traverse(node.firstChild, fn);
        }
        if (node.next) {
          traverse(node.next, fn);
        }
      };
      var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
        var nodeMatches = {};
        var attrMatches = {};
        var matches = [];
        if (node.firstChild) {
          traverse(node.firstChild, function (node) {
            $_5wjzy24jh8lyw2t.each(nodeFilters, function (filter) {
              if (filter.name === node.name) {
                if (nodeMatches[filter.name]) {
                  nodeMatches[filter.name].nodes.push(node);
                } else {
                  nodeMatches[filter.name] = {
                    filter: filter,
                    nodes: [node]
                  };
                }
              }
            });
            $_5wjzy24jh8lyw2t.each(attributeFilters, function (filter) {
              if (typeof node.attr(filter.name) === 'string') {
                if (attrMatches[filter.name]) {
                  attrMatches[filter.name].nodes.push(node);
                } else {
                  attrMatches[filter.name] = {
                    filter: filter,
                    nodes: [node]
                  };
                }
              }
            });
          });
        }
        for (var name_1 in nodeMatches) {
          if (nodeMatches.hasOwnProperty(name_1)) {
            matches.push(nodeMatches[name_1]);
          }
        }
        for (var name_2 in attrMatches) {
          if (attrMatches.hasOwnProperty(name_2)) {
            matches.push(attrMatches[name_2]);
          }
        }
        return matches;
      };
      var filter$3 = function (nodeFilters, attributeFilters, node) {
        var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
        $_5wjzy24jh8lyw2t.each(matches, function (match) {
          $_5wjzy24jh8lyw2t.each(match.filter.callbacks, function (callback) {
            callback(match.nodes, match.filter.name, {});
          });
        });
      };

      var defaultFormat$1 = 'html';
      var isTreeNode = function (content) {
        return content instanceof Node$2;
      };
      var moveSelection = function (editor) {
        if ($_cnu79r4ejh8lyx4x.hasFocus(editor)) {
          $_9kvypj2cjh8lywnz.firstPositionIn(editor.getBody()).each(function (pos) {
            var node = pos.getNode();
            var caretPos = $_5oonaz1qjh8lywhz.isTable(node) ? $_9kvypj2cjh8lywnz.firstPositionIn(node).getOr(pos) : pos;
            editor.selection.setRng(caretPos.toRange());
          });
        }
      };
      var setEditorHtml = function (editor, html) {
        editor.dom.setHTML(editor.getBody(), html);
        moveSelection(editor);
      };
      var setContentString = function (editor, body, content, args) {
        var forcedRootBlockName, padd;
        if (content.length === 0 || /^\s+$/.test(content)) {
          padd = '<br data-mce-bogus="1">';
          if (body.nodeName === 'TABLE') {
            content = '<tr><td>' + padd + '</td></tr>';
          } else if (/^(UL|OL)$/.test(body.nodeName)) {
            content = '<li>' + padd + '</li>';
          }
          forcedRootBlockName = $_66vr6g2jjh8lywpf.getForcedRootBlock(editor);
          if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
            content = padd;
            content = editor.dom.createHTML(forcedRootBlockName, editor.settings.forced_root_block_attrs, content);
          } else if (!content) {
            content = '<br data-mce-bogus="1">';
          }
          setEditorHtml(editor, content);
          editor.fire('SetContent', args);
        } else {
          if (args.format !== 'raw') {
            content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
              isRootContent: true,
              insert: true
            }));
          }
          args.content = isWsPreserveElement($_cgttw3zjh8lywdq.fromDom(body)) ? content : $_ahowuxkjh8lywbj.trim(content);
          setEditorHtml(editor, args.content);
          if (!args.no_events) {
            editor.fire('SetContent', args);
          }
        }
        return args.content;
      };
      var setContentTree = function (editor, body, content, args) {
        filter$3(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
        var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
        args.content = isWsPreserveElement($_cgttw3zjh8lywdq.fromDom(body)) ? html : $_ahowuxkjh8lywbj.trim(html);
        setEditorHtml(editor, args.content);
        if (!args.no_events) {
          editor.fire('SetContent', args);
        }
        return content;
      };
      var setContent$1 = function (editor, content, args) {
        if (args === void 0) {
          args = {};
        }
        args.format = args.format ? args.format : defaultFormat$1;
        args.set = true;
        args.content = isTreeNode(content) ? '' : content;
        if (!isTreeNode(content) && !args.no_events) {
          editor.fire('BeforeSetContent', args);
          content = args.content;
        }
        return Option.from(editor.getBody()).fold($_eqpqvr6jh8lyw3s.constant(content), function (body) {
          return isTreeNode(content) ? setContentTree(editor, body, content, args) : setContentString(editor, body, content, args);
        });
      };

      var DOM$6 = DOMUtils$1.DOM;
      var restoreOriginalStyles = function (editor) {
        DOM$6.setStyle(editor.id, 'display', editor.orgDisplay);
      };
      var safeDestroy = function (x) {
        return Option.from(x).each(function (x) {
          return x.destroy();
        });
      };
      var clearDomReferences = function (editor) {
        editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
        editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
        editor.iframeElement = editor.targetElm = null;
        if (editor.selection) {
          editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
        }
      };
      var restoreForm = function (editor) {
        var form = editor.formElement;
        if (form) {
          if (form._mceOldSubmit) {
            form.submit = form._mceOldSubmit;
            form._mceOldSubmit = null;
          }
          DOM$6.unbind(form, 'submit reset', editor.formEventDelegate);
        }
      };
      var remove$8 = function (editor) {
        if (!editor.removed) {
          var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
          var body = editor.getBody();
          var element = editor.getElement();
          if (body) {
            editor.save();
          }
          editor.removed = true;
          editor.unbindAllNativeEvents();
          if (editor.hasHiddenInput && element) {
            DOM$6.remove(element.nextSibling);
          }
          if (!editor.inline && body) {
            restoreOriginalStyles(editor);
          }
          $_a4fgrn4cjh8lyx4q.fireRemove(editor);
          editor.editorManager.remove(editor);
          DOM$6.remove(editor.getContainer());
          safeDestroy(_selectionOverrides);
          safeDestroy(editorUpload);
          editor.destroy();
        }
      };
      var destroy = function (editor, automatic) {
        var selection = editor.selection, dom = editor.dom;
        if (editor.destroyed) {
          return;
        }
        if (!automatic && !editor.removed) {
          editor.remove();
          return;
        }
        if (!automatic) {
          editor.editorManager.off('beforeunload', editor._beforeUnload);
          if (editor.theme && editor.theme.destroy) {
            editor.theme.destroy();
          }
          safeDestroy(selection);
          safeDestroy(dom);
        }
        restoreForm(editor);
        clearDomReferences(editor);
        editor.destroyed = true;
      };

      var DOM$7 = DOMUtils$1.DOM;
      var extend$4 = $_ahowuxkjh8lywbj.extend;
      var each$21 = $_ahowuxkjh8lywbj.each;
      var resolve$4 = $_ahowuxkjh8lywbj.resolve;
      var ie$2 = $_9bpim8ajh8lyw68.ie;
      var Editor = function (id, settings, editorManager) {
        var self = this;
        var documentBaseUrl = self.documentBaseUrl = editorManager.documentBaseURL;
        var baseUri = editorManager.baseURI;
        settings = getEditorSettings(self, id, documentBaseUrl, editorManager.defaultSettings, settings);
        self.settings = settings;
        AddOnManager.language = settings.language || 'en';
        AddOnManager.languageLoad = settings.language_load;
        AddOnManager.baseURL = editorManager.baseURL;
        self.id = id;
        self.setDirty(false);
        self.plugins = {};
        self.documentBaseURI = new URI(settings.document_base_url, { base_uri: baseUri });
        self.baseURI = baseUri;
        self.contentCSS = [];
        self.contentStyles = [];
        self.shortcuts = new Shortcuts(self);
        self.loadedCSS = {};
        self.editorCommands = new EditorCommands(self);
        self.suffix = editorManager.suffix;
        self.editorManager = editorManager;
        self.inline = settings.inline;
        self.buttons = {};
        self.menuItems = {};
        if (settings.cache_suffix) {
          $_9bpim8ajh8lyw68.cacheSuffix = settings.cache_suffix.replace(/^[\?\&]+/, '');
        }
        if (settings.override_viewport === false) {
          $_9bpim8ajh8lyw68.overrideViewPort = false;
        }
        editorManager.fire('SetupEditor', { editor: self });
        self.execCallback('setup', self);
        self.$ = DomQuery.overrideDefaults(function () {
          return {
            context: self.inline ? self.getBody() : self.getDoc(),
            element: self.getBody()
          };
        });
      };
      Editor.prototype = {
        render: function () {
          $_64g0n44hjh8lyx5e.render(this);
        },
        focus: function (skipFocus) {
          $_cnu79r4ejh8lyx4x.focus(this, skipFocus);
        },
        hasFocus: function () {
          return $_cnu79r4ejh8lyx4x.hasFocus(this);
        },
        execCallback: function (name) {
          var x = [];
          for (var _i = 1; _i < arguments.length; _i++) {
            x[_i - 1] = arguments[_i];
          }
          var self = this;
          var callback = self.settings[name], scope;
          if (!callback) {
            return;
          }
          if (self.callbackLookup && (scope = self.callbackLookup[name])) {
            callback = scope.func;
            scope = scope.scope;
          }
          if (typeof callback === 'string') {
            scope = callback.replace(/\.\w+$/, '');
            scope = scope ? resolve$4(scope) : 0;
            callback = resolve$4(callback);
            self.callbackLookup = self.callbackLookup || {};
            self.callbackLookup[name] = {
              func: callback,
              scope: scope
            };
          }
          return callback.apply(scope || self, Array.prototype.slice.call(arguments, 1));
        },
        translate: function (text) {
          if (text && $_ahowuxkjh8lywbj.is(text, 'string')) {
            var lang_1 = this.settings.language || 'en', i18n_1 = this.editorManager.i18n;
            text = i18n_1.data[lang_1 + '.' + text] || text.replace(/\{\#([^\}]+)\}/g, function (a, b) {
              return i18n_1.data[lang_1 + '.' + b] || '{#' + b + '}';
            });
          }
          return this.editorManager.translate(text);
        },
        getLang: function (name, defaultVal) {
          return this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + name] || (defaultVal !== undefined ? defaultVal : '{#' + name + '}');
        },
        getParam: function (name, defaultVal, type) {
          return getParam(this, name, defaultVal, type);
        },
        nodeChanged: function (args) {
          this._nodeChangeDispatcher.nodeChanged(args);
        },
        addButton: function (name, settings) {
          var self = this;
          if (settings.cmd) {
            settings.onclick = function () {
              self.execCommand(settings.cmd);
            };
          }
          if (settings.stateSelector && typeof settings.active === 'undefined') {
            settings.active = false;
          }
          if (!settings.text && !settings.icon) {
            settings.icon = name;
          }
          self.buttons = self.buttons;
          settings.tooltip = settings.tooltip || settings.title;
          self.buttons[name] = settings;
        },
        addSidebar: function (name, settings) {
          return $_67cz5d7cjh8lyxnm.add(this, name, settings);
        },
        addMenuItem: function (name, settings) {
          var self = this;
          if (settings.cmd) {
            settings.onclick = function () {
              self.execCommand(settings.cmd);
            };
          }
          self.menuItems = self.menuItems;
          self.menuItems[name] = settings;
        },
        addContextToolbar: function (predicate, items) {
          var self = this;
          var selector;
          self.contextToolbars = self.contextToolbars || [];
          if (typeof predicate === 'string') {
            selector = predicate;
            predicate = function (elm) {
              return self.dom.is(elm, selector);
            };
          }
          self.contextToolbars.push({
            id: $_co2y7g52jh8lyx8f.uuid('mcet'),
            predicate: predicate,
            items: items
          });
        },
        addCommand: function (name, callback, scope) {
          this.editorCommands.addCommand(name, callback, scope);
        },
        addQueryStateHandler: function (name, callback, scope) {
          this.editorCommands.addQueryStateHandler(name, callback, scope);
        },
        addQueryValueHandler: function (name, callback, scope) {
          this.editorCommands.addQueryValueHandler(name, callback, scope);
        },
        addShortcut: function (pattern, desc, cmdFunc, scope) {
          this.shortcuts.add(pattern, desc, cmdFunc, scope);
        },
        execCommand: function (cmd, ui, value, args) {
          return this.editorCommands.execCommand(cmd, ui, value, args);
        },
        queryCommandState: function (cmd) {
          return this.editorCommands.queryCommandState(cmd);
        },
        queryCommandValue: function (cmd) {
          return this.editorCommands.queryCommandValue(cmd);
        },
        queryCommandSupported: function (cmd) {
          return this.editorCommands.queryCommandSupported(cmd);
        },
        show: function () {
          var self = this;
          if (self.hidden) {
            self.hidden = false;
            if (self.inline) {
              self.getBody().contentEditable = true;
            } else {
              DOM$7.show(self.getContainer());
              DOM$7.hide(self.id);
            }
            self.load();
            self.fire('show');
          }
        },
        hide: function () {
          var self = this, doc = self.getDoc();
          if (!self.hidden) {
            if (ie$2 && doc && !self.inline) {
              doc.execCommand('SelectAll');
            }
            self.save();
            if (self.inline) {
              self.getBody().contentEditable = false;
              if (self === self.editorManager.focusedEditor) {
                self.editorManager.focusedEditor = null;
              }
            } else {
              DOM$7.hide(self.getContainer());
              DOM$7.setStyle(self.id, 'display', self.orgDisplay);
            }
            self.hidden = true;
            self.fire('hide');
          }
        },
        isHidden: function () {
          return !!this.hidden;
        },
        setProgressState: function (state, time) {
          this.fire('ProgressState', {
            state: state,
            time: time
          });
        },
        load: function (args) {
          var self = this;
          var elm = self.getElement(), html;
          if (self.removed) {
            return '';
          }
          if (elm) {
            args = args || {};
            args.load = true;
            html = self.setContent(elm.value !== undefined ? elm.value : elm.innerHTML, args);
            args.element = elm;
            if (!args.no_events) {
              self.fire('LoadContent', args);
            }
            args.element = elm = null;
            return html;
          }
        },
        save: function (args) {
          var self = this;
          var elm = self.getElement(), html, form;
          if (!elm || !self.initialized || self.removed) {
            return;
          }
          args = args || {};
          args.save = true;
          args.element = elm;
          html = args.content = self.getContent(args);
          if (!args.no_events) {
            self.fire('SaveContent', args);
          }
          if (args.format === 'raw') {
            self.fire('RawSaveContent', args);
          }
          html = args.content;
          if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
            if (!self.inline) {
              elm.innerHTML = html;
            }
            if (form = DOM$7.getParent(self.id, 'form')) {
              each$21(form.elements, function (elm) {
                if (elm.name === self.id) {
                  elm.value = html;
                  return false;
                }
              });
            }
          } else {
            elm.value = html;
          }
          args.element = elm = null;
          if (args.set_dirty !== false) {
            self.setDirty(false);
          }
          return html;
        },
        setContent: function (content, args) {
          return setContent$1(this, content, args);
        },
        getContent: function (args) {
          return getContent$1(this, args);
        },
        insertContent: function (content, args) {
          if (args) {
            content = extend$4({ content: content }, args);
          }
          this.execCommand('mceInsertContent', false, content);
        },
        isDirty: function () {
          return !this.isNotDirty;
        },
        setDirty: function (state) {
          var oldState = !this.isNotDirty;
          this.isNotDirty = !state;
          if (state && state !== oldState) {
            this.fire('dirty');
          }
        },
        setMode: function (mode) {
          setMode(this, mode);
        },
        getContainer: function () {
          var self = this;
          if (!self.container) {
            self.container = DOM$7.get(self.editorContainer || self.id + '_parent');
          }
          return self.container;
        },
        getContentAreaContainer: function () {
          return this.contentAreaContainer;
        },
        getElement: function () {
          if (!this.targetElm) {
            this.targetElm = DOM$7.get(this.id);
          }
          return this.targetElm;
        },
        getWin: function () {
          var self = this;
          var elm;
          if (!self.contentWindow) {
            elm = self.iframeElement;
            if (elm) {
              self.contentWindow = elm.contentWindow;
            }
          }
          return self.contentWindow;
        },
        getDoc: function () {
          var self = this;
          var win;
          if (!self.contentDocument) {
            win = self.getWin();
            if (win) {
              self.contentDocument = win.document;
            }
          }
          return self.contentDocument;
        },
        getBody: function () {
          var doc = this.getDoc();
          return this.bodyElement || (doc ? doc.body : null);
        },
        convertURL: function (url, name, elm) {
          var self = this, settings = self.settings;
          if (settings.urlconverter_callback) {
            return self.execCallback('urlconverter_callback', url, elm, true, name);
          }
          if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
            return url;
          }
          if (settings.relative_urls) {
            return self.documentBaseURI.toRelative(url);
          }
          url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
          return url;
        },
        addVisual: function (elm) {
          var self = this;
          var settings = self.settings;
          var dom = self.dom;
          var cls;
          elm = elm || self.getBody();
          if (self.hasVisual === undefined) {
            self.hasVisual = settings.visual;
          }
          each$21(dom.select('table,a', elm), function (elm) {
            var value;
            switch (elm.nodeName) {
            case 'TABLE':
              cls = settings.visual_table_class || 'mce-item-table';
              value = dom.getAttrib(elm, 'border');
              if ((!value || value === '0') && self.hasVisual) {
                dom.addClass(elm, cls);
              } else {
                dom.removeClass(elm, cls);
              }
              return;
            case 'A':
              if (!dom.getAttrib(elm, 'href')) {
                value = dom.getAttrib(elm, 'name') || elm.id;
                cls = settings.visual_anchor_class || 'mce-item-anchor';
                if (value && self.hasVisual) {
                  dom.addClass(elm, cls);
                } else {
                  dom.removeClass(elm, cls);
                }
              }
              return;
            }
          });
          self.fire('VisualAid', {
            element: elm,
            hasVisual: self.hasVisual
          });
        },
        remove: function () {
          remove$8(this);
        },
        destroy: function (automatic) {
          destroy(this, automatic);
        },
        uploadImages: function (callback) {
          return this.editorUpload.uploadImages(callback);
        },
        _scanForImages: function () {
          return this.editorUpload.scanForImages();
        }
      };
      extend$4(Editor.prototype, EditorObservable$1);

      var isEditorUIElement = function (elm) {
        return elm.className.toString().indexOf('mce-') !== -1;
      };
      var $_bmt26v7ljh8lyxp9 = { isEditorUIElement: isEditorUIElement };

      var isManualNodeChange = function (e) {
        return e.type === 'nodechange' && e.selectionChange;
      };
      var registerPageMouseUp = function (editor, throttledStore) {
        var mouseUpPage = function () {
          throttledStore.throttle();
        };
        DOMUtils$1.DOM.bind(document, 'mouseup', mouseUpPage);
        editor.on('remove', function () {
          DOMUtils$1.DOM.unbind(document, 'mouseup', mouseUpPage);
        });
      };
      var registerFocusOut = function (editor) {
        editor.on('focusout', function () {
          $_eqs11m40jh8lyx31.store(editor);
        });
      };
      var registerMouseUp = function (editor, throttledStore) {
        editor.on('mouseup touchend', function (e) {
          throttledStore.throttle();
        });
      };
      var registerEditorEvents = function (editor, throttledStore) {
        var browser = $_9hkktfnjh8lywc6.detect().browser;
        if (browser.isIE()) {
          registerFocusOut(editor);
        } else {
          registerMouseUp(editor, throttledStore);
        }
        editor.on('keyup nodechange', function (e) {
          if (!isManualNodeChange(e)) {
            $_eqs11m40jh8lyx31.store(editor);
          }
        });
      };
      var register$3 = function (editor) {
        var throttledStore = $_de600j5fjh8lyxas.first(function () {
          $_eqs11m40jh8lyx31.store(editor);
        }, 0);
        if (editor.inline) {
          registerPageMouseUp(editor, throttledStore);
        }
        editor.on('init', function () {
          registerEditorEvents(editor, throttledStore);
        });
        editor.on('remove', function () {
          throttledStore.cancel();
        });
      };
      var $_2mabdn7mjh8lyxpa = { register: register$3 };

      var documentFocusInHandler;
      var DOM$8 = DOMUtils$1.DOM;
      var isEditorUIElement$1 = function (elm) {
        return $_bmt26v7ljh8lyxp9.isEditorUIElement(elm);
      };
      var isUIElement = function (editor, elm) {
        var customSelector = editor ? editor.settings.custom_ui_selector : '';
        var parent = DOM$8.getParent(elm, function (elm) {
          return isEditorUIElement$1(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
        });
        return parent !== null;
      };
      var getActiveElement = function () {
        try {
          return document.activeElement;
        } catch (ex) {
          return document.body;
        }
      };
      var registerEvents = function (editorManager, e) {
        var editor = e.editor;
        $_2mabdn7mjh8lyxpa.register(editor);
        editor.on('focusin', function () {
          var self = this;
          var focusedEditor = editorManager.focusedEditor;
          if (focusedEditor !== self) {
            if (focusedEditor) {
              focusedEditor.fire('blur', { focusedEditor: self });
            }
            editorManager.setActive(self);
            editorManager.focusedEditor = self;
            self.fire('focus', { blurredEditor: focusedEditor });
            self.focus(true);
          }
        });
        editor.on('focusout', function () {
          var self = this;
          $_8sy3pfhjh8lyw95.setEditorTimeout(self, function () {
            var focusedEditor = editorManager.focusedEditor;
            if (!isUIElement(self, getActiveElement()) && focusedEditor === self) {
              self.fire('blur', { focusedEditor: null });
              editorManager.focusedEditor = null;
            }
          });
        });
        if (!documentFocusInHandler) {
          documentFocusInHandler = function (e) {
            var activeEditor = editorManager.activeEditor;
            var target;
            target = e.target;
            if (activeEditor && target.ownerDocument === document) {
              if (target !== document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
                activeEditor.fire('blur', { focusedEditor: null });
                editorManager.focusedEditor = null;
              }
            }
          };
          DOM$8.bind(document, 'focusin', documentFocusInHandler);
        }
      };
      var unregisterDocumentEvents = function (editorManager, e) {
        if (editorManager.focusedEditor === e.editor) {
          editorManager.focusedEditor = null;
        }
        if (!editorManager.activeEditor) {
          DOM$8.unbind(document, 'focusin', documentFocusInHandler);
          documentFocusInHandler = null;
        }
      };
      var setup$13 = function (editorManager) {
        editorManager.on('AddEditor', $_eqpqvr6jh8lyw3s.curry(registerEvents, editorManager));
        editorManager.on('RemoveEditor', $_eqpqvr6jh8lyw3s.curry(unregisterDocumentEvents, editorManager));
      };
      var $_k2ieq7kjh8lyxp5 = {
        setup: setup$13,
        isEditorUIElement: isEditorUIElement$1,
        isUIElement: isUIElement
      };

      var data = {};
      var code = 'en';
      var $_1tjgyr7njh8lyxpg = {
        setCode: function (newCode) {
          if (newCode) {
            code = newCode;
            this.rtl = this.data[newCode] ? this.data[newCode]._dir === 'rtl' : false;
          }
        },
        getCode: function () {
          return code;
        },
        rtl: false,
        add: function (code, items) {
          var langData = data[code];
          if (!langData) {
            data[code] = langData = {};
          }
          for (var name_1 in items) {
            langData[name_1] = items[name_1];
          }
          this.setCode(code);
        },
        translate: function (text) {
          var langData = data[code] || {};
          var toString = function (obj) {
            if ($_ahowuxkjh8lywbj.is(obj, 'function')) {
              return Object.prototype.toString.call(obj);
            }
            return !isEmpty(obj) ? '' + obj : '';
          };
          var isEmpty = function (text) {
            return text === '' || text === null || $_ahowuxkjh8lywbj.is(text, 'undefined');
          };
          var getLangData = function (text) {
            text = toString(text);
            return $_ahowuxkjh8lywbj.hasOwn(langData, text) ? toString(langData[text]) : text;
          };
          if (isEmpty(text)) {
            return '';
          }
          if ($_ahowuxkjh8lywbj.is(text, 'object') && $_ahowuxkjh8lywbj.hasOwn(text, 'raw')) {
            return toString(text.raw);
          }
          if ($_ahowuxkjh8lywbj.is(text, 'array')) {
            var values_1 = text.slice(1);
            text = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
              return $_ahowuxkjh8lywbj.hasOwn(values_1, $2) ? toString(values_1[$2]) : $1;
            });
          }
          return getLangData(text).replace(/{context:\w+}$/, '');
        },
        data: data
      };

      var DOM$9 = DOMUtils$1.DOM;
      var explode$4 = $_ahowuxkjh8lywbj.explode;
      var each$22 = $_ahowuxkjh8lywbj.each;
      var extend$5 = $_ahowuxkjh8lywbj.extend;
      var instanceCounter = 0;
      var beforeUnloadDelegate;
      var EditorManager;
      var boundGlobalEvents = false;
      var legacyEditors = [];
      var editors = [];
      var isValidLegacyKey = function (id) {
        return id !== 'length';
      };
      var globalEventDelegate = function (e) {
        each$22(EditorManager.get(), function (editor) {
          if (e.type === 'scroll') {
            editor.fire('ScrollWindow', e);
          } else {
            editor.fire('ResizeWindow', e);
          }
        });
      };
      var toggleGlobalEvents = function (state) {
        if (state !== boundGlobalEvents) {
          if (state) {
            DomQuery(window).on('resize scroll', globalEventDelegate);
          } else {
            DomQuery(window).off('resize scroll', globalEventDelegate);
          }
          boundGlobalEvents = state;
        }
      };
      var removeEditorFromList = function (targetEditor) {
        var oldEditors = editors;
        delete legacyEditors[targetEditor.id];
        for (var i = 0; i < legacyEditors.length; i++) {
          if (legacyEditors[i] === targetEditor) {
            legacyEditors.splice(i, 1);
            break;
          }
        }
        editors = $_5wjzy24jh8lyw2t.filter(editors, function (editor) {
          return targetEditor !== editor;
        });
        if (EditorManager.activeEditor === targetEditor) {
          EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
        }
        if (EditorManager.focusedEditor === targetEditor) {
          EditorManager.focusedEditor = null;
        }
        return oldEditors.length !== editors.length;
      };
      var purgeDestroyedEditor = function (editor) {
        if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
          removeEditorFromList(editor);
          editor.unbindAllNativeEvents();
          editor.destroy(true);
          editor.removed = true;
          editor = null;
        }
        return editor;
      };
      EditorManager = {
        defaultSettings: {},
        $: DomQuery,
        majorVersion: '4',
        minorVersion: '7.13',
        releaseDate: '2018-05-16',
        editors: legacyEditors,
        i18n: $_1tjgyr7njh8lyxpg,
        activeEditor: null,
        settings: {},
        setup: function () {
          var self = this;
          var baseURL, documentBaseURL, suffix = '', preInit, src;
          documentBaseURL = URI.getDocumentBaseUrl(document.location);
          if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
            documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
            if (!/[\/\\]$/.test(documentBaseURL)) {
              documentBaseURL += '/';
            }
          }
          preInit = window.tinymce || window.tinyMCEPreInit;
          if (preInit) {
            baseURL = preInit.base || preInit.baseURL;
            suffix = preInit.suffix;
          } else {
            var scripts = document.getElementsByTagName('script');
            for (var i = 0; i < scripts.length; i++) {
              src = scripts[i].src;
              var srcScript = src.substring(src.lastIndexOf('/'));
              if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
                if (srcScript.indexOf('.min') !== -1) {
                  suffix = '.min';
                }
                baseURL = src.substring(0, src.lastIndexOf('/'));
                break;
              }
            }
            if (!baseURL && document.currentScript) {
              src = document.currentScript.src;
              if (src.indexOf('.min') !== -1) {
                suffix = '.min';
              }
              baseURL = src.substring(0, src.lastIndexOf('/'));
            }
          }
          self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
          self.documentBaseURL = documentBaseURL;
          self.baseURI = new URI(self.baseURL);
          self.suffix = suffix;
          $_k2ieq7kjh8lyxp5.setup(self);
        },
        overrideDefaults: function (defaultSettings) {
          var baseUrl, suffix;
          baseUrl = defaultSettings.base_url;
          if (baseUrl) {
            this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
            this.baseURI = new URI(this.baseURL);
          }
          suffix = defaultSettings.suffix;
          if (defaultSettings.suffix) {
            this.suffix = suffix;
          }
          this.defaultSettings = defaultSettings;
          var pluginBaseUrls = defaultSettings.plugin_base_urls;
          for (var name_1 in pluginBaseUrls) {
            AddOnManager.PluginManager.urls[name_1] = pluginBaseUrls[name_1];
          }
        },
        init: function (settings) {
          var self = this;
          var result, invalidInlineTargets;
          invalidInlineTargets = $_ahowuxkjh8lywbj.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu', ' ');
          var isInvalidInlineTarget = function (settings, elm) {
            return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
          };
          var createId = function (elm) {
            var id = elm.id;
            if (!id) {
              id = elm.name;
              if (id && !DOM$9.get(id)) {
                id = elm.name;
              } else {
                id = DOM$9.uniqueId();
              }
              elm.setAttribute('id', id);
            }
            return id;
          };
          var execCallback = function (name) {
            var callback = settings[name];
            if (!callback) {
              return;
            }
            return callback.apply(self, Array.prototype.slice.call(arguments, 2));
          };
          var hasClass = function (elm, className) {
            return className.constructor === RegExp ? className.test(elm.className) : DOM$9.hasClass(elm, className);
          };
          var findTargets = function (settings) {
            var l, targets = [];
            if ($_9bpim8ajh8lyw68.ie && $_9bpim8ajh8lyw68.ie < 11) {
              $_5vy074njh8lyx6h.initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
              return [];
            }
            if (settings.types) {
              each$22(settings.types, function (type) {
                targets = targets.concat(DOM$9.select(type.selector));
              });
              return targets;
            } else if (settings.selector) {
              return DOM$9.select(settings.selector);
            } else if (settings.target) {
              return [settings.target];
            }
            switch (settings.mode) {
            case 'exact':
              l = settings.elements || '';
              if (l.length > 0) {
                each$22(explode$4(l), function (id) {
                  var elm;
                  if (elm = DOM$9.get(id)) {
                    targets.push(elm);
                  } else {
                    each$22(document.forms, function (f) {
                      each$22(f.elements, function (e) {
                        if (e.name === id) {
                          id = 'mce_editor_' + instanceCounter++;
                          DOM$9.setAttrib(e, 'id', id);
                          targets.push(e);
                        }
                      });
                    });
                  }
                });
              }
              break;
            case 'textareas':
            case 'specific_textareas':
              each$22(DOM$9.select('textarea'), function (elm) {
                if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
                  return;
                }
                if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
                  targets.push(elm);
                }
              });
              break;
            }
            return targets;
          };
          var provideResults = function (editors) {
            result = editors;
          };
          var initEditors = function () {
            var initCount = 0;
            var editors = [];
            var targets;
            var createEditor = function (id, settings, targetElm) {
              var editor = new Editor(id, settings, self);
              editors.push(editor);
              editor.on('init', function () {
                if (++initCount === targets.length) {
                  provideResults(editors);
                }
              });
              editor.targetElm = editor.targetElm || targetElm;
              editor.render();
            };
            DOM$9.unbind(window, 'ready', initEditors);
            execCallback('onpageload');
            targets = DomQuery.unique(findTargets(settings));
            if (settings.types) {
              each$22(settings.types, function (type) {
                $_ahowuxkjh8lywbj.each(targets, function (elm) {
                  if (DOM$9.is(elm, type.selector)) {
                    createEditor(createId(elm), extend$5({}, settings, type), elm);
                    return false;
                  }
                  return true;
                });
              });
              return;
            }
            $_ahowuxkjh8lywbj.each(targets, function (elm) {
              purgeDestroyedEditor(self.get(elm.id));
            });
            targets = $_ahowuxkjh8lywbj.grep(targets, function (elm) {
              return !self.get(elm.id);
            });
            if (targets.length === 0) {
              provideResults([]);
            } else {
              each$22(targets, function (elm) {
                if (isInvalidInlineTarget(settings, elm)) {
                  $_5vy074njh8lyx6h.initError('Could not initialize inline editor on invalid inline target element', elm);
                } else {
                  createEditor(createId(elm), settings, elm);
                }
              });
            }
          };
          self.settings = settings;
          DOM$9.bind(window, 'ready', initEditors);
          return new promiseObj(function (resolve) {
            if (result) {
              resolve(result);
            } else {
              provideResults = function (editors) {
                resolve(editors);
              };
            }
          });
        },
        get: function (id) {
          if (arguments.length === 0) {
            return editors.slice(0);
          } else if ($_dp4g6d7jh8lyw3y.isString(id)) {
            return $_5wjzy24jh8lyw2t.find(editors, function (editor) {
              return editor.id === id;
            }).getOr(null);
          } else if ($_dp4g6d7jh8lyw3y.isNumber(id)) {
            return editors[id] ? editors[id] : null;
          } else {
            return null;
          }
        },
        add: function (editor) {
          var self = this;
          var existingEditor;
          existingEditor = legacyEditors[editor.id];
          if (existingEditor === editor) {
            return editor;
          }
          if (self.get(editor.id) === null) {
            if (isValidLegacyKey(editor.id)) {
              legacyEditors[editor.id] = editor;
            }
            legacyEditors.push(editor);
            editors.push(editor);
          }
          toggleGlobalEvents(true);
          self.activeEditor = editor;
          self.fire('AddEditor', { editor: editor });
          if (!beforeUnloadDelegate) {
            beforeUnloadDelegate = function () {
              self.fire('BeforeUnload');
            };
            DOM$9.bind(window, 'beforeunload', beforeUnloadDelegate);
          }
          return editor;
        },
        createEditor: function (id, settings) {
          return this.add(new Editor(id, settings, this));
        },
        remove: function (selector) {
          var self = this;
          var i, editor;
          if (!selector) {
            for (i = editors.length - 1; i >= 0; i--) {
              self.remove(editors[i]);
            }
            return;
          }
          if ($_dp4g6d7jh8lyw3y.isString(selector)) {
            selector = selector.selector || selector;
            each$22(DOM$9.select(selector), function (elm) {
              editor = self.get(elm.id);
              if (editor) {
                self.remove(editor);
              }
            });
            return;
          }
          editor = selector;
          if ($_dp4g6d7jh8lyw3y.isNull(self.get(editor.id))) {
            return null;
          }
          if (removeEditorFromList(editor)) {
            self.fire('RemoveEditor', { editor: editor });
          }
          if (editors.length === 0) {
            DOM$9.unbind(window, 'beforeunload', beforeUnloadDelegate);
          }
          editor.remove();
          toggleGlobalEvents(editors.length > 0);
          return editor;
        },
        execCommand: function (cmd, ui, value) {
          var self = this, editor = self.get(value);
          switch (cmd) {
          case 'mceAddEditor':
            if (!self.get(value)) {
              new Editor(value, self.settings, self).render();
            }
            return true;
          case 'mceRemoveEditor':
            if (editor) {
              editor.remove();
            }
            return true;
          case 'mceToggleEditor':
            if (!editor) {
              self.execCommand('mceAddEditor', 0, value);
              return true;
            }
            if (editor.isHidden()) {
              editor.show();
            } else {
              editor.hide();
            }
            return true;
          }
          if (self.activeEditor) {
            return self.activeEditor.execCommand(cmd, ui, value);
          }
          return false;
        },
        triggerSave: function () {
          each$22(editors, function (editor) {
            editor.save();
          });
        },
        addI18n: function (code, items) {
          $_1tjgyr7njh8lyxpg.add(code, items);
        },
        translate: function (text) {
          return $_1tjgyr7njh8lyxpg.translate(text);
        },
        setActive: function (editor) {
          var activeEditor = this.activeEditor;
          if (this.activeEditor !== editor) {
            if (activeEditor) {
              activeEditor.fire('deactivate', { relatedTarget: editor });
            }
            editor.fire('activate', { relatedTarget: activeEditor });
          }
          this.activeEditor = editor;
        }
      };
      extend$5(EditorManager, $_fuzxjg45jh8lyx45);
      EditorManager.setup();
      var EditorManager$1 = EditorManager;

      function RangeUtils(dom) {
        var walk = function (rng, callback) {
          return $_90itx05zjh8lyxeq.walk(dom, rng, callback);
        };
        var split = $_5hrcpr5vjh8lyxe2.split;
        var normalize = function (rng) {
          return $_4v2pn63yjh8lyx2s.normalize(dom, rng).fold($_eqpqvr6jh8lyw3s.constant(false), function (normalizedRng) {
            rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
            rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
            return true;
          });
        };
        return {
          walk: walk,
          split: split,
          normalize: normalize
        };
      }
      (function (RangeUtils) {
        RangeUtils.compareRanges = $_aayq8q3zjh8lyx2z.isEq;
        RangeUtils.getCaretRangeFromPoint = $_ct0ht56jjh8lyxif.fromPoint;
        RangeUtils.getSelectedNode = getSelectedNode;
        RangeUtils.getNode = getNode;
      }(RangeUtils || (RangeUtils = {})));
      var RangeUtils$1 = RangeUtils;

      var min = Math.min;
      var max = Math.max;
      var round$2 = Math.round;
      var relativePosition = function (rect, targetRect, rel) {
        var x, y, w, h, targetW, targetH;
        x = targetRect.x;
        y = targetRect.y;
        w = rect.w;
        h = rect.h;
        targetW = targetRect.w;
        targetH = targetRect.h;
        rel = (rel || '').split('');
        if (rel[0] === 'b') {
          y += targetH;
        }
        if (rel[1] === 'r') {
          x += targetW;
        }
        if (rel[0] === 'c') {
          y += round$2(targetH / 2);
        }
        if (rel[1] === 'c') {
          x += round$2(targetW / 2);
        }
        if (rel[3] === 'b') {
          y -= h;
        }
        if (rel[4] === 'r') {
          x -= w;
        }
        if (rel[3] === 'c') {
          y -= round$2(h / 2);
        }
        if (rel[4] === 'c') {
          x -= round$2(w / 2);
        }
        return create$2(x, y, w, h);
      };
      var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
        var pos, i;
        for (i = 0; i < rels.length; i++) {
          pos = relativePosition(rect, targetRect, rels[i]);
          if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
            return rels[i];
          }
        }
        return null;
      };
      var inflate = function (rect, w, h) {
        return create$2(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
      };
      var intersect = function (rect, cropRect) {
        var x1, y1, x2, y2;
        x1 = max(rect.x, cropRect.x);
        y1 = max(rect.y, cropRect.y);
        x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
        y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
        if (x2 - x1 < 0 || y2 - y1 < 0) {
          return null;
        }
        return create$2(x1, y1, x2 - x1, y2 - y1);
      };
      var clamp$1 = function (rect, clampRect, fixedSize) {
        var underflowX1, underflowY1, overflowX2, overflowY2, x1, y1, x2, y2, cx2, cy2;
        x1 = rect.x;
        y1 = rect.y;
        x2 = rect.x + rect.w;
        y2 = rect.y + rect.h;
        cx2 = clampRect.x + clampRect.w;
        cy2 = clampRect.y + clampRect.h;
        underflowX1 = max(0, clampRect.x - x1);
        underflowY1 = max(0, clampRect.y - y1);
        overflowX2 = max(0, x2 - cx2);
        overflowY2 = max(0, y2 - cy2);
        x1 += underflowX1;
        y1 += underflowY1;
        if (fixedSize) {
          x2 += underflowX1;
          y2 += underflowY1;
          x1 -= overflowX2;
          y1 -= overflowY2;
        }
        x2 -= overflowX2;
        y2 -= overflowY2;
        return create$2(x1, y1, x2 - x1, y2 - y1);
      };
      var create$2 = function (x, y, w, h) {
        return {
          x: x,
          y: y,
          w: w,
          h: h
        };
      };
      var fromClientRect = function (clientRect) {
        return create$2(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
      };
      var $_fa0t9p7pjh8lyxpo = {
        inflate: inflate,
        relativePosition: relativePosition,
        findBestRelativePosition: findBestRelativePosition,
        intersect: intersect,
        clamp: clamp$1,
        create: create$2,
        fromClientRect: fromClientRect
      };

      var types = {};
      var $_fym6l27qjh8lyxpr = {
        add: function (type, typeClass) {
          types[type.toLowerCase()] = typeClass;
        },
        has: function (type) {
          return !!types[type.toLowerCase()];
        },
        get: function (type) {
          var lctype = type.toLowerCase();
          var controlType = types.hasOwnProperty(lctype) ? types[lctype] : null;
          if (controlType === null) {
            throw new Error('Could not find module for type: ' + type);
          }
          return controlType;
        },
        create: function (type, settings) {
          var ControlType;
          if (typeof type === 'string') {
            settings = settings || {};
            settings.type = type;
          } else {
            settings = type;
            type = settings.type;
          }
          type = type.toLowerCase();
          ControlType = types[type];
          if (!ControlType) {
            throw new Error('Could not find control by type: ' + type);
          }
          ControlType = new ControlType(settings);
          ControlType.type = type;
          return ControlType;
        }
      };

      var each$23 = $_ahowuxkjh8lywbj.each;
      var extend$6 = $_ahowuxkjh8lywbj.extend;
      var extendClass;
      var initializing;
      var Class$1 = function () {
      };
      Class$1.extend = extendClass = function (prop) {
        var self = this;
        var _super = self.prototype;
        var prototype, name, member;
        var Class = function () {
          var i, mixins, mixin;
          var self = this;
          if (!initializing) {
            if (self.init) {
              self.init.apply(self, arguments);
            }
            mixins = self.Mixins;
            if (mixins) {
              i = mixins.length;
              while (i--) {
                mixin = mixins[i];
                if (mixin.init) {
                  mixin.init.apply(self, arguments);
                }
              }
            }
          }
        };
        var dummy = function () {
          return this;
        };
        var createMethod = function (name, fn) {
          return function () {
            var self = this;
            var tmp = self._super;
            var ret;
            self._super = _super[name];
            ret = fn.apply(self, arguments);
            self._super = tmp;
            return ret;
          };
        };
        initializing = true;
        prototype = new self();
        initializing = false;
        if (prop.Mixins) {
          each$23(prop.Mixins, function (mixin) {
            for (var name_1 in mixin) {
              if (name_1 !== 'init') {
                prop[name_1] = mixin[name_1];
              }
            }
          });
          if (_super.Mixins) {
            prop.Mixins = _super.Mixins.concat(prop.Mixins);
          }
        }
        if (prop.Methods) {
          each$23(prop.Methods.split(','), function (name) {
            prop[name] = dummy;
          });
        }
        if (prop.Properties) {
          each$23(prop.Properties.split(','), function (name) {
            var fieldName = '_' + name;
            prop[name] = function (value) {
              var self = this;
              if (value !== undefined) {
                self[fieldName] = value;
                return self;
              }
              return self[fieldName];
            };
          });
        }
        if (prop.Statics) {
          each$23(prop.Statics, function (func, name) {
            Class[name] = func;
          });
        }
        if (prop.Defaults && _super.Defaults) {
          prop.Defaults = extend$6({}, _super.Defaults, prop.Defaults);
        }
        for (name in prop) {
          member = prop[name];
          if (typeof member === 'function' && _super[name]) {
            prototype[name] = createMethod(name, member);
          } else {
            prototype[name] = member;
          }
        }
        Class.prototype = prototype;
        Class.constructor = Class;
        Class.extend = extendClass;
        return Class;
      };

      var min$1 = Math.min;
      var max$1 = Math.max;
      var round$3 = Math.round;
      var Color = function (value) {
        var self = {};
        var r = 0, g = 0, b = 0;
        var rgb2hsv = function (r, g, b) {
          var h, s, v, d, minRGB, maxRGB;
          h = 0;
          s = 0;
          v = 0;
          r = r / 255;
          g = g / 255;
          b = b / 255;
          minRGB = min$1(r, min$1(g, b));
          maxRGB = max$1(r, max$1(g, b));
          if (minRGB === maxRGB) {
            v = minRGB;
            return {
              h: 0,
              s: 0,
              v: v * 100
            };
          }
          d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
          h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
          h = 60 * (h - d / (maxRGB - minRGB));
          s = (maxRGB - minRGB) / maxRGB;
          v = maxRGB;
          return {
            h: round$3(h),
            s: round$3(s * 100),
            v: round$3(v * 100)
          };
        };
        var hsvToRgb = function (hue, saturation, brightness) {
          var side, chroma, x, match;
          hue = (parseInt(hue, 10) || 0) % 360;
          saturation = parseInt(saturation, 10) / 100;
          brightness = parseInt(brightness, 10) / 100;
          saturation = max$1(0, min$1(saturation, 1));
          brightness = max$1(0, min$1(brightness, 1));
          if (saturation === 0) {
            r = g = b = round$3(255 * brightness);
            return;
          }
          side = hue / 60;
          chroma = brightness * saturation;
          x = chroma * (1 - Math.abs(side % 2 - 1));
          match = brightness - chroma;
          switch (Math.floor(side)) {
          case 0:
            r = chroma;
            g = x;
            b = 0;
            break;
          case 1:
            r = x;
            g = chroma;
            b = 0;
            break;
          case 2:
            r = 0;
            g = chroma;
            b = x;
            break;
          case 3:
            r = 0;
            g = x;
            b = chroma;
            break;
          case 4:
            r = x;
            g = 0;
            b = chroma;
            break;
          case 5:
            r = chroma;
            g = 0;
            b = x;
            break;
          default:
            r = g = b = 0;
          }
          r = round$3(255 * (r + match));
          g = round$3(255 * (g + match));
          b = round$3(255 * (b + match));
        };
        var toHex = function () {
          var hex = function (val) {
            val = parseInt(val, 10).toString(16);
            return val.length > 1 ? val : '0' + val;
          };
          return '#' + hex(r) + hex(g) + hex(b);
        };
        var toRgb = function () {
          return {
            r: r,
            g: g,
            b: b
          };
        };
        var toHsv = function () {
          return rgb2hsv(r, g, b);
        };
        var parse = function (value) {
          var matches;
          if (typeof value === 'object') {
            if ('r' in value) {
              r = value.r;
              g = value.g;
              b = value.b;
            } else if ('v' in value) {
              hsvToRgb(value.h, value.s, value.v);
            }
          } else {
            if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
              r = parseInt(matches[1], 10);
              g = parseInt(matches[2], 10);
              b = parseInt(matches[3], 10);
            } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
              r = parseInt(matches[1], 16);
              g = parseInt(matches[2], 16);
              b = parseInt(matches[3], 16);
            } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
              r = parseInt(matches[1] + matches[1], 16);
              g = parseInt(matches[2] + matches[2], 16);
              b = parseInt(matches[3] + matches[3], 16);
            }
          }
          r = r < 0 ? 0 : r > 255 ? 255 : r;
          g = g < 0 ? 0 : g > 255 ? 255 : g;
          b = b < 0 ? 0 : b > 255 ? 255 : b;
          return self;
        };
        if (value) {
          parse(value);
        }
        self.toRgb = toRgb;
        self.toHsv = toHsv;
        self.toHex = toHex;
        self.parse = parse;
        return self;
      };

      var serialize = function (o, quote) {
        var i, v, t, name;
        quote = quote || '"';
        if (o === null) {
          return 'null';
        }
        t = typeof o;
        if (t === 'string') {
          v = '\bb\tt\nn\ff\rr""\'\'\\\\';
          return quote + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function (a, b) {
            if (quote === '"' && a === '\'') {
              return a;
            }
            i = v.indexOf(b);
            if (i + 1) {
              return '\\' + v.charAt(i + 1);
            }
            a = b.charCodeAt().toString(16);
            return '\\u' + '0000'.substring(a.length) + a;
          }) + quote;
        }
        if (t === 'object') {
          if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
            for (i = 0, v = '['; i < o.length; i++) {
              v += (i > 0 ? ',' : '') + serialize(o[i], quote);
            }
            return v + ']';
          }
          v = '{';
          for (name in o) {
            if (o.hasOwnProperty(name)) {
              v += typeof o[name] !== 'function' ? (v.length > 1 ? ',' + quote : quote) + name + quote + ':' + serialize(o[name], quote) : '';
            }
          }
          return v + '}';
        }
        return '' + o;
      };
      var $_7z82167tjh8lyxq1 = {
        serialize: serialize,
        parse: function (text) {
          try {
            return JSON.parse(text);
          } catch (ex) {
          }
        }
      };

      var $_2v08kz7ujh8lyxq4 = {
        callbacks: {},
        count: 0,
        send: function (settings) {
          var self = this, dom = DOMUtils$1.DOM, count = settings.count !== undefined ? settings.count : self.count;
          var id = 'tinymce_jsonp_' + count;
          self.callbacks[count] = function (json) {
            dom.remove(id);
            delete self.callbacks[count];
            settings.callback(json);
          };
          dom.add(dom.doc.body, 'script', {
            id: id,
            src: settings.url,
            type: 'text/javascript'
          });
          self.count++;
        }
      };

      var XHR = {
        send: function (settings) {
          var xhr, count = 0;
          var ready = function () {
            if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
              if (settings.success && count < 10000 && xhr.status === 200) {
                settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
              } else if (settings.error) {
                settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
              }
              xhr = null;
            } else {
              setTimeout(ready, 10);
            }
          };
          settings.scope = settings.scope || this;
          settings.success_scope = settings.success_scope || settings.scope;
          settings.error_scope = settings.error_scope || settings.scope;
          settings.async = settings.async === false ? false : true;
          settings.data = settings.data || '';
          XHR.fire('beforeInitialize', { settings: settings });
          xhr = new XMLHttpRequest();
          if (xhr) {
            if (xhr.overrideMimeType) {
              xhr.overrideMimeType(settings.content_type);
            }
            xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
            if (settings.crossDomain) {
              xhr.withCredentials = true;
            }
            if (settings.content_type) {
              xhr.setRequestHeader('Content-Type', settings.content_type);
            }
            if (settings.requestheaders) {
              $_ahowuxkjh8lywbj.each(settings.requestheaders, function (header) {
                xhr.setRequestHeader(header.key, header.value);
              });
            }
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr = XHR.fire('beforeSend', {
              xhr: xhr,
              settings: settings
            }).xhr;
            xhr.send(settings.data);
            if (!settings.async) {
              return ready();
            }
            setTimeout(ready, 10);
          }
        }
      };
      $_ahowuxkjh8lywbj.extend(XHR, $_fuzxjg45jh8lyx45);

      var extend$7 = $_ahowuxkjh8lywbj.extend;
      var JSONRequest = function (settings) {
        this.settings = extend$7({}, settings);
        this.count = 0;
      };
      JSONRequest.sendRPC = function (o) {
        return new JSONRequest().send(o);
      };
      JSONRequest.prototype = {
        send: function (args) {
          var ecb = args.error, scb = args.success;
          args = extend$7(this.settings, args);
          args.success = function (c, x) {
            c = $_7z82167tjh8lyxq1.parse(c);
            if (typeof c === 'undefined') {
              c = { error: 'JSON Parse error.' };
            }
            if (c.error) {
              ecb.call(args.error_scope || args.scope, c.error, x);
            } else {
              scb.call(args.success_scope || args.scope, c.result);
            }
          };
          args.error = function (ty, x) {
            if (ecb) {
              ecb.call(args.error_scope || args.scope, ty, x);
            }
          };
          args.data = $_7z82167tjh8lyxq1.serialize({
            id: args.id || 'c' + this.count++,
            method: args.method,
            params: args.params
          });
          args.content_type = 'application/json';
          XHR.send(args);
        }
      };

      var localStorage = window.localStorage;

      var tinymce = EditorManager$1;
      var publicApi = {
        geom: { Rect: $_fa0t9p7pjh8lyxpo },
        util: {
          Promise: promiseObj,
          Delay: $_8sy3pfhjh8lyw95,
          Tools: $_ahowuxkjh8lywbj,
          VK: $_6lsk4i5gjh8lyxau,
          URI: URI,
          Class: Class$1,
          EventDispatcher: Dispatcher,
          Observable: $_fuzxjg45jh8lyx45,
          I18n: $_1tjgyr7njh8lyxpg,
          XHR: XHR,
          JSON: $_7z82167tjh8lyxq1,
          JSONRequest: JSONRequest,
          JSONP: $_2v08kz7ujh8lyxq4,
          LocalStorage: localStorage,
          Color: Color
        },
        dom: {
          EventUtils: EventUtils,
          Sizzle: Sizzle,
          DomQuery: DomQuery,
          TreeWalker: TreeWalker,
          DOMUtils: DOMUtils$1,
          ScriptLoader: ScriptLoader,
          RangeUtils: RangeUtils$1,
          Serializer: DomSerializer$1,
          ControlSelection: ControlSelection,
          BookmarkManager: BookmarkManager$1,
          Selection: Selection$1,
          Event: EventUtils.Event
        },
        html: {
          Styles: Styles,
          Entities: $_gex7a11rjh8lywi4,
          Node: Node$2,
          Schema: Schema,
          SaxParser: SaxParser$1,
          DomParser: DomParser,
          Writer: Writer,
          Serializer: HtmlSerializer
        },
        ui: { Factory: $_fym6l27qjh8lyxpr },
        Env: $_9bpim8ajh8lyw68,
        AddOnManager: AddOnManager,
        Formatter: Formatter,
        UndoManager: UndoManager,
        EditorCommands: EditorCommands,
        WindowManager: WindowManager,
        NotificationManager: NotificationManager,
        EditorObservable: EditorObservable$1,
        Shortcuts: Shortcuts,
        Editor: Editor,
        FocusManager: $_bmt26v7ljh8lyxp9,
        EditorManager: EditorManager$1,
        DOM: DOMUtils$1.DOM,
        ScriptLoader: ScriptLoader.ScriptLoader,
        PluginManager: AddOnManager.PluginManager,
        ThemeManager: AddOnManager.ThemeManager,
        trim: $_ahowuxkjh8lywbj.trim,
        isArray: $_ahowuxkjh8lywbj.isArray,
        is: $_ahowuxkjh8lywbj.is,
        toArray: $_ahowuxkjh8lywbj.toArray,
        makeMap: $_ahowuxkjh8lywbj.makeMap,
        each: $_ahowuxkjh8lywbj.each,
        map: $_ahowuxkjh8lywbj.map,
        grep: $_ahowuxkjh8lywbj.grep,
        inArray: $_ahowuxkjh8lywbj.inArray,
        extend: $_ahowuxkjh8lywbj.extend,
        create: $_ahowuxkjh8lywbj.create,
        walk: $_ahowuxkjh8lywbj.walk,
        createNS: $_ahowuxkjh8lywbj.createNS,
        resolve: $_ahowuxkjh8lywbj.resolve,
        explode: $_ahowuxkjh8lywbj.explode,
        _addCacheSuffix: $_ahowuxkjh8lywbj._addCacheSuffix,
        isOpera: $_9bpim8ajh8lyw68.opera,
        isWebKit: $_9bpim8ajh8lyw68.webkit,
        isIE: $_9bpim8ajh8lyw68.ie,
        isGecko: $_9bpim8ajh8lyw68.gecko,
        isMac: $_9bpim8ajh8lyw68.mac
      };
      tinymce = $_ahowuxkjh8lywbj.extend(tinymce, publicApi);
      var Tinymce = tinymce;

      var exportToModuleLoaders = function (tinymce) {
        if (typeof module === 'object') {
          try {
            module.exports = tinymce;
          } catch (_) {
          }
        }
      };
      var exportToWindowGlobal = function (tinymce) {
        window.tinymce = tinymce;
        window.tinyMCE = tinymce;
      };
      exportToWindowGlobal(Tinymce);
      exportToModuleLoaders(Tinymce);

    }());
    })();

    // Exports the "modern" theme for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/themes/modern')
    //   ES2015:
    //     import 'tinymce/themes/modern'
    require('./theme.js');

    // Exports the "table" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/table')
    //   ES2015:
    //     import 'tinymce/plugins/table'
    require('./plugin.js');

    // Exports the "link" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/link')
    //   ES2015:
    //     import 'tinymce/plugins/link'
    require('./plugin.js');

    // Exports the "paste" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/paste')
    //   ES2015:
    //     import 'tinymce/plugins/paste'
    require('./plugin.js');

    // Exports the "code" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/code')
    //   ES2015:
    //     import 'tinymce/plugins/code'
    require('./plugin.js');

    // Exports the "codesample" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/codesample')
    //   ES2015:
    //     import 'tinymce/plugins/codesample'
    require('./plugin.js');

    // Exports the "textcolor" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/textcolor')
    //   ES2015:
    //     import 'tinymce/plugins/textcolor'
    require('./plugin.js');

    // Exports the "colorpicker" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/colorpicker')
    //   ES2015:
    //     import 'tinymce/plugins/colorpicker'
    require('./plugin.js');

    // Exports the "image" plugin for usage with module loaders
    // Usage:
    //   CommonJS:
    //     require('tinymce/plugins/image')
    //   ES2015:
    //     import 'tinymce/plugins/image'
    require('./plugin.js');

    /**
     * @license angular-library-starter
     * MIT license
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostService = /** @class */ (function () {
        function VernostService(http, snackBar) {
            this.http = http;
            this.snackBar = snackBar;
            this.projectPath = "http://localhost:8086";
        }
        /**
         * @param {?} url
         * @return {?}
         */
        VernostService.prototype.getData = /**
         * @param {?} url
         * @return {?}
         */
        function (url) {
            console.log(url);
            return this.http.get(this.projectPath + url);
        };
        /**
         * @param {?} url
         * @param {?} query
         * @return {?}
         */
        VernostService.prototype.postData = /**
         * @param {?} url
         * @param {?} query
         * @return {?}
         */
        function (url, query) {
            var /** @type {?} */ params = query;
            var /** @type {?} */ headers = new HttpHeaders();
            console.log(query);
            console.log(url);
            headers.append("Content-Type", "text/plain");
            return this.http.post(this.projectPath + url, params, { headers: headers });
            // .pipe(map( res => res.json()));
        };
        /**
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.setClearComponents = /**
         * @param {?} Fields
         * @return {?}
         */
        function (Fields) {
            if (Fields != undefined) {
                if (Fields != null) {
                    Fields.forEach(function (element) {
                        element.value = undefined;
                    });
                }
            }
        };
        /**
         * @param {?} component
         * @return {?}
         */
        VernostService.prototype.setinit = /**
         * @param {?} component
         * @return {?}
         */
        function (component) {
            if (component.compname === 'combobox') {
                if (component.combo_search_query != undefined) {
                    if (component.combo_search_query != "") {
                        this.postData("/executequery", { data: btoa(component.combo_search_query) }).subscribe(function (data) {
                            data.forEach(function (element) {
                                component.datavalues.push({ pname: element[component.combo_disp_field], pvalue: data[component.combo_value_field] });
                            });
                        });
                    }
                }
            }
        };
        /**
         * @param {?} readonly
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.setReadonlyComponents = /**
         * @param {?} readonly
         * @param {?} Fields
         * @return {?}
         */
        function (readonly, Fields) {
            if (Fields != undefined) {
                if (Fields != null) {
                    Fields.forEach(function (element) {
                        element.readonly = readonly;
                        element.isvalid = true;
                    });
                }
            }
        };
        /**
         * @param {?} disable
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.setDisabledComponents = /**
         * @param {?} disable
         * @param {?} Fields
         * @return {?}
         */
        function (disable, Fields) {
            if (Fields != undefined) {
                if (Fields != null) {
                    Fields.forEach(function (element) {
                        element.disable = disable;
                    });
                }
            }
        };
        /**
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.addClick = /**
         * @param {?} Fields
         * @return {?}
         */
        function (Fields) {
            if (Fields != undefined) {
                if (Fields != null) {
                    Fields.forEach(function (element) {
                        element.isvalid = true;
                    });
                }
            }
        };
        /**
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.editClick = /**
         * @param {?} Fields
         * @return {?}
         */
        function (Fields) {
            if (Fields != undefined) {
                if (Fields != null) {
                    Fields.forEach(function (element) {
                        if (element.allowedit == false) {
                            element.disable = true;
                        }
                    });
                }
            }
        };
        /**
         * @param {?} Screen
         * @return {?}
         */
        VernostService.prototype.saveScreenData = /**
         * @param {?} Screen
         * @return {?}
         */
        function (Screen) {
            var _this = this;
            console.log(Screen);
            return new Promise(function (resolve, reject) {
                var /** @type {?} */ tableinfo = {
                    tablename: Screen.table,
                    keyid: Screen.key_id,
                    keyvalue: Screen.key_value,
                    fields: {}
                };
                Screen.fields.forEach(function (element) {
                    tableinfo.fields[element.dbfield] = element.value;
                });
                console.log("tableinfo:", tableinfo);
                _this.postData('/adddata', { "data": btoa(JSON.stringify(tableinfo)), "token": localStorage.getItem('userToken') }).subscribe(function (response) {
                    resolve(response);
                });
            });
        };
        /**
         * @param {?} Fields
         * @return {?}
         */
        VernostService.prototype.checkValidation = /**
         * @param {?} Fields
         * @return {?}
         */
        function (Fields) {
            var _this = this;
            var /** @type {?} */ counter = 0;
            Fields.forEach(function (element) {
                if (element.mandatory) {
                    if (_this.checkUndefined(element.value) == "") {
                        element.isvalid = false;
                        counter++;
                    }
                }
                if (element.isvalid == false) {
                    counter++;
                }
            });
            if (counter == 0) {
                return true;
            }
            else {
                return false;
            }
        };
        /**
         * @param {?} value
         * @return {?}
         */
        VernostService.prototype.checkUndefined = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == null) {
                value = "";
            }
            if (value == undefined) {
                value = "";
            }
            return value;
        };
        /**
         * @param {?} message
         * @return {?}
         */
        VernostService.prototype.showmessaage = /**
         * @param {?} message
         * @return {?}
         */
        function (message) {
            var /** @type {?} */ systemmessage = document.getElementById("systemmessage");
            if (systemmessage == null) {
                systemmessage = document.createElement("div");
                systemmessage.setAttribute("style", "position: fixed;bottom: 0;z-index: 9999;right: 0;border-bottom-color: #2fa7fb;border-bottom-style: solid;margin-right: -50%;padding-left: 30px;padding-right: 30px;padding-top: 10px;padding-bottom: 10px;background-color: black;color: white;text-align: center;");
                systemmessage.setAttribute("id", "systemmessage");
                systemmessage.innerHTML = message;
                document.body.appendChild(systemmessage);
            }
            else {
                systemmessage.innerHTML = message;
            }
            var /** @type {?} */ x = setInterval(function () {
                try {
                    systemmessage.parentNode.removeChild(systemmessage);
                }
                catch (/** @type {?} */ e) {
                    console.log(e);
                }
                clearInterval(x);
            }, 2000);
        };
        /**
         * @return {?}
         */
        VernostService.prototype.showprogressmodel = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ systemprogress = document.getElementById("systemprogress");
            if (systemprogress == null) {
                systemprogress = document.createElement("div");
                systemprogress.setAttribute("class", "processmodal");
                systemprogress.setAttribute("id", "systemprogress");
                var /** @type {?} */ tmpdiv = document.createElement("div");
                tmpdiv.setAttribute("class", "processmodal-content");
                tmpdiv.setAttribute("style", "text-align: center;");
                tmpdiv.innerHTML = "<h1>Loading...</h1><br><h6>Please wait</h6>";
                systemprogress.appendChild(tmpdiv);
                document.body.appendChild(systemprogress);
            }
        };
        /**
         * @return {?}
         */
        VernostService.prototype.hideprogressmodel = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ systemprogress = document.getElementById("systemprogress");
            if (systemprogress != null) {
                systemprogress.parentNode.removeChild(systemprogress);
            }
        };
        VernostService.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        VernostService.ctorParameters = function () { return [
            { type: HttpClient, },
            { type: MatSnackBar, },
        ]; };
        return VernostService;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var Datavalue = /** @class */ (function () {
        function Datavalue() {
        }
        return Datavalue;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var TableOptions = /** @class */ (function () {
        function TableOptions() {
        }
        return TableOptions;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var Condition = /** @class */ (function () {
        function Condition(name, value) {
            this.name = name;
            this.value = value;
        }
        return Condition;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var ModelInputComponent = /** @class */ (function () {
        function ModelInputComponent(fb, mainService) {
            this.mainService = mainService;
            this.pcombodata = [];
            this.afterchange = new core.EventEmitter();
            this.keyup = new core.EventEmitter();
            this.dropdownSettings = {
                singleSelection: false,
                text: 'Select',
                selectAllText: 'Select All',
                unSelectAllText: 'UnSelect All',
                enableSearchFilter: true,
                classes: 'myclass custom-class'
            };
            this.dropdownList = [];
            // search autocomplete data
            this.results = [];
            this.options = fb.group({
                hideRequired: false,
                floatLabel: 'auto',
            });
        }
        Object.defineProperty(ModelInputComponent.prototype, "combodata", {
            get: /**
             * @return {?}
             */
            function () {
                return this.pcombodata;
            },
            set: /**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                this.pcombodata = data;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
        };
        Object.defineProperty(ModelInputComponent.prototype, "field", {
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                console.log("fieldparam", this.fieldparam);
                this.fieldparam = val;
                this.fieldparam.isvalid = true;
                this.fieldparam.datavalues = [];
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            if (this.fieldparam.compname === 'multiselect') {
                this.dropdownSettings.text = this.fieldparam.title;
            }
            // console.log(this.fieldparam.style);
            // if (this.fieldparam.compname == "combobox" && this.fieldparam.combo_search_proce != "") {
            //   this.fillcombodata(this.fieldparam);
            // }
            // if (this.fieldparam.compname == "combobox" && this.fieldparam.list != "") {
            //   this.fillstaticcombodata();
            // }
            // if (this.fieldparam.compname == "checkbox" && this.fieldparam.value == null) {
            //   this.fieldparam.value = false;
            // }
            // if (this.fieldparam.compname == "autocomplete" && this.fieldparam.value != null) {
            //   this.setAutoCompleteData();
            // }
            // if (this.fieldparam.compname == "multipledropdown" && this.fieldparam.value != null) {
            //   this.setMultiSelectData();
            // }
        };
        // combobox with table data
        /**
         * @param {?} listparam
         * @return {?}
         */
        ModelInputComponent.prototype.fillcombodata = /**
         * @param {?} listparam
         * @return {?}
         */
        function (listparam) {
            var /** @type {?} */ tableoption = new TableOptions();
            var /** @type {?} */ conditions = [];
            if (listparam.combo_filter != null || listparam.combo_filter != "") {
                var /** @type {?} */ strfltr = listparam.combo_filter.replace(" ", "");
                strfltr = strfltr.toLowerCase();
                var /** @type {?} */ splitdata = strfltr.split("and");
                splitdata.forEach(function (element) {
                    var /** @type {?} */ tmpdata = element.split("=");
                    if (tmpdata.length == 2) {
                        conditions.push(new Condition(tmpdata[0], tmpdata[1]));
                    }
                });
            }
            tableoption.conditions = conditions;
            var /** @type {?} */ cols = [];
            cols.push(listparam.combo_disp_field);
            cols.push(listparam.combo_value_field);
            tableoption.tablecols = cols;
            // this.mainService.getTableData('hamse', listparam.combo_search_proce, tableoption).subscribe(
            //   response => {
            //     let datarow: datarows[] = response.datarows;
            //     listparam.datavalues = [];
            //     for (let data of datarow) {
            //       let d: datarows = new datarows();
            //       let datavalue: Datavalue = new Datavalue();
            //       for (let col of data.cols) {
            //         if (col.fieldName != listparam.combo_value_field) {
            //           datavalue.pvalue = col.value;
            //         }
            //         else {
            //           datavalue.pname = col.value;
            //         }
            //       }
            //       listparam.datavalues.push(datavalue);
            //     }
            //   });
        };
        // combobox with static data
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.fillstaticcombodata = /**
         * @return {?}
         */
        function () {
            var _this = this;
            var /** @type {?} */ combodata = this.fieldparam.list.split(",");
            this.fieldparam.datavalues = [];
            combodata.forEach(function (element) {
                var /** @type {?} */ id = element;
                var /** @type {?} */ value = element;
                if (element.indexOf(":") > 0) {
                    var /** @type {?} */ d = element.split(":");
                    id = d[0];
                    value = d[1];
                }
                var /** @type {?} */ datavalue = new Datavalue();
                datavalue.pname = id;
                datavalue.pvalue = value;
                _this.fieldparam.datavalues.push(datavalue);
            });
        };
        /**
         * @param {?} event
         * @return {?}
         */
        ModelInputComponent.prototype.searchData = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            var /** @type {?} */ autocompleteText = event.query;
            // if (this.fieldparam.combo_search_proce != "") {
            //   let tableoption: TableOptions = new TableOptions();
            //   let conditions: Condition[] = [];
            //   conditions.push(new Condition(this.fieldparam.combo_disp_field, "%" + autocompleteText + "%"));
            //   tableoption.conditions = conditions;
            //   tableoption.limit = 10;
            //   let cols: string[] = [];
            //   cols.push(this.fieldparam.combo_disp_field);
            //   cols.push(this.fieldparam.combo_value_field);
            //   tableoption.tablecols = cols;
            //   // this.mainService.getTableValues('hamse', this.fieldparam.combo_search_proce, tableoption).subscribe(
            //   //   response => {
            //   //     console.log("autocomplete search response === ", response);
            //   //     this.results = response;
            //   //   });
            // }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        ModelInputComponent.prototype.setData = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            console.log(event[this.fieldparam.combo_value_field]);
        };
        // set autocomplete data
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.setAutoCompleteData = /**
         * @return {?}
         */
        function () {
            this.fieldparam.value = (_a = {},
                _a[this.fieldparam.combo_value_field] = this.fieldparam.value,
                _a);
            var _a;
        };
        // set multiselect data
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.setMultiSelectData = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ tableoption = new TableOptions();
            var /** @type {?} */ cols = [];
            cols.push(this.fieldparam.combo_disp_field);
            cols.push(this.fieldparam.combo_value_field);
            tableoption.tablecols = cols;
            tableoption.limit = 10;
            var /** @type {?} */ customCondition = "";
            this.fieldparam.value.forEach(function (element) {
                customCondition = customCondition + element + ",";
            });
            customCondition = customCondition.substr(0, (customCondition.length - 1));
            tableoption.additionslfilter = this.fieldparam.combo_value_field + " IN (" + customCondition + ")";
            // this.mainService.getTableValues('hamse', this.fieldparam.combo_search_proce, tableoption).subscribe(
            //   response => {
            //     console.log("multiselect oninit response === ", response);
            //     this.fieldparam.value = response;
            //   });
        };
        // remove multiselect item
        /**
         * @param {?} item
         * @return {?}
         */
        ModelInputComponent.prototype.removeMultiselectItem = /**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            console.log(item[this.fieldparam.combo_value_field]);
            // if (this.fieldparam.editable != "1") {
            //   for (let i = 0; i < this.fieldparam.value.length; i++) {
            //     let element = this.fieldparam.value[i];
            //     if (element[this.fieldparam.combo_value_field] == item[this.fieldparam.combo_value_field]) {
            //       this.fieldparam.value.splice(i, 1);
            //     }
            //   }
            // }
        };
        // fileupload / imageupload
        /**
         * @return {?}
         */
        ModelInputComponent.prototype.uploadFile = /**
         * @return {?}
         */
        function () {
            // let uploadFile = (<HTMLInputElement>window.document.getElementById(this.fieldparam.dbfield)).files[0];
            // if (uploadFile != undefined) {
            //   this.mainService.uploadFile(uploadFile).subscribe(
            //     (response: any) => {
            //       console.log("uploadFile response === ", response.message);
            //       console.log("uploadFile response === ", response.path);
            //       // this.fieldparam.value = response.path;
            //       this.fieldparam.value = "http://10.10.10.51:8888" + response.path;
            //     });
            // }
        };
        // download file
        /**
         * @param {?} event
         * @param {?} filePath
         * @return {?}
         */
        ModelInputComponent.prototype.downloadFile = /**
         * @param {?} event
         * @param {?} filePath
         * @return {?}
         */
        function (event, filePath) {
            console.log("filePath === ", filePath);
            filePath = filePath.substring(23);
            var /** @type {?} */ target = event.target || event.srcElement || event.currentTarget;
            var /** @type {?} */ idAttr = target.attributes.id;
            var /** @type {?} */ value = idAttr.nodeValue;
            var /** @type {?} */ downloadfile = /** @type {?} */ (document.getElementById(value));
            downloadfile.href = filePath;
        };
        // html editor
        /**
         * @param {?} event
         * @return {?}
         */
        ModelInputComponent.prototype.onEditorChange = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            this.fieldparam.value = event;
        };
        // set dynamic styles
        // getStyles() {
        //   let styleJson = {};
        //   let mystyles = this.fieldparam.style.split(";");
        //   mystyles.forEach((element: any) => {
        //     let arr = [];
        //     arr = element.split(":");
        //     styleJson[arr[0]] = arr[1];
        //   });
        //   return styleJson;
        // }
        // get date value
        /**
         * @param {?} value
         * @return {?}
         */
        ModelInputComponent.prototype.writeDateValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value == '' || value == null) {
                return '';
            }
            else {
                var /** @type {?} */ vl = this.checkdate(value);
                this.fieldparam.value = vl;
                return vl;
            }
        };
        /**
         * @param {?} value
         * @return {?}
         */
        ModelInputComponent.prototype.checkdate = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ dt = new Date(value);
            var /** @type {?} */ fordate = dt.getFullYear() + "-" + this.getMonth(dt.getMonth()) + "-" + this.getDay(dt.getDate());
            return fordate;
        };
        /**
         * @param {?} day
         * @return {?}
         */
        ModelInputComponent.prototype.getDay = /**
         * @param {?} day
         * @return {?}
         */
        function (day) {
            var /** @type {?} */ d = day + "";
            if (d.length == 1) {
                return "0" + d;
            }
            else {
                return d;
            }
        };
        /**
         * @param {?} month
         * @return {?}
         */
        ModelInputComponent.prototype.getMonth = /**
         * @param {?} month
         * @return {?}
         */
        function (month) {
            var /** @type {?} */ mn = (month + 1) + "";
            if (mn.length == 1) {
                return "0" + mn;
            }
            else {
                return mn;
            }
        };
        // set date value
        /**
         * @param {?} element
         * @return {?}
         */
        ModelInputComponent.prototype.setDateValue = /**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            var /** @type {?} */ inputtext = (/** @type {?} */ (window.document.getElementById(this.fieldparam.dbfield)));
            this.fieldparam.value = inputtext.value;
        };
        /**
         * @param {?} data
         * @return {?}
         */
        ModelInputComponent.prototype.validatechangeevent = /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            var _this = this;
            this.fieldparam.isvalid = true;
            console.log(data.target.value, this.fieldparam.length);
            if (this.mainService.checkUndefined(this.fieldparam.length) != "") {
                if (data.target.value != "") {
                    if (data.target.value.length > this.fieldparam.length) {
                        this.mainService.showmessaage("Value too long, Max " + this.fieldparam.length + " characters required");
                        this.fieldparam.isvalid = false;
                    }
                }
            }
            if (this.fieldparam.unique) {
                if (this.mainService.checkUndefined(this.fieldparam.unique_query) != "") {
                    var /** @type {?} */ query = this.fieldparam.unique_query.replace("[code]", data.target.value);
                    this.mainService.postData("/executequery", { data: btoa(query) }).subscribe(function (result) {
                        if (result.status) {
                            if (result.data.length != 0) {
                                _this.mainService.showmessaage("Duplicate Entry!!!, \"" + data.target.value + "\" Already exist.");
                                _this.fieldparam.isvalid = false;
                            }
                        }
                        else {
                            _this.mainService.showmessaage("Please validate integrated query");
                        }
                    });
                }
            }
            // if(this.fieldparam.isu)
            this.afterchange.emit(data);
        };
        /**
         * @param {?} data
         * @return {?}
         */
        ModelInputComponent.prototype.validatekeyupevent = /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            this.keyup.emit(data);
        };
        /**
         * @param {?} data
         * @return {?}
         */
        ModelInputComponent.prototype.checkstatus = /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data.target.checked) {
                this.fieldparam.value = 1;
            }
            else {
                this.fieldparam.value = 0;
            }
        };
        ModelInputComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'app-model-input',
                        template: "<div class=\"input-wrapper\">\n\n  <!-- label -->\n\n  <!-- <label *ngIf=\"fieldparam.compname != 'hidden'\" [for]=\"fieldparam.dbfield\" class=\"input-label\">{{fieldparam.title}}</label> -->\n  <!-- <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label> -->\n\n  <!-- hidden -->\n\n  <!-- <input *ngIf=\"fieldparam.compname == 'hidden'\" type=\"hidden\"> -->\n\n  <!-- textbox -->\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'textbox'\">\n    <!-- <input type=\"text\" id=\"name\" class=\"form-control\" autocomplete=\"off\" required> -->\n    <input type=\"text\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [readonly]=\"fieldparam.readonly\"\n      [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\" [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\"\n      [ngStyle]=\"fieldparam.style\" [required]=\"fieldparam.mandatory\" autocomplete=\"off\" (change)=\"validatechangeevent($event)\"\n      (keyup)=\"validatekeyupevent($event)\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\"\n      [style.width]=\"fieldparam.width\" [style.background-color]=\"!fieldparam.isvalid?'#c5272726':'transparent'\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n\n  <!-- email -->\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'email'\">\n    <!-- <input type=\"text\" id=\"name\" class=\"form-control\" autocomplete=\"off\" required> -->\n    <input type=\"email\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [readonly]=\"fieldparam.readonly\"\n      [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\" [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\"\n      [ngStyle]=\"fieldparam.style\" [required]=\"fieldparam.mandatory\" autocomplete=\"off\" (change)=\"validatechangeevent($event)\"\n      (keyup)=\"validatekeyupevent($event)\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\"\n      [style.width]=\"fieldparam.width\" [style.background-color]=\"!fieldparam.isvalid?'#c5272726':'transparent'\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n\n  <!-- password -->\n\n  <input *ngIf=\"fieldparam.compname == 'password'\" type=\"password\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control input-common input-password\"\n    [readonly]=\"fieldparam.readonly\" [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\" [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\"\n    [ngStyle]=\"fieldparam.style\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\"\n    [style.width]=\"fieldparam.width\">\n\n  <!-- numberbox / decimalbox -->\n  <div class=\"form-group\" *ngIf=\"(fieldparam.compname == 'number' || fieldparam.compname == 'decimalbox')\">\n    <!-- <input type=\"text\" id=\"name\" class=\"form-control\" autocomplete=\"off\" required> -->\n    <input type=\"number\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [readonly]=\"fieldparam.readonly\"\n      [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\" [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\"\n      [ngStyle]=\"fieldparam.style\" [required]=\"fieldparam.mandatory\" autocomplete=\"off\" (change)=\"validatechangeevent($event)\"\n      (keyup)=\"validatekeyupevent($event)\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\"\n      [style.width]=\"fieldparam.width\" [style.background-color]=\"!fieldparam.isvalid?'#c5272726':'transparent'\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n\n  <!-- textarea -->\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'textarea'\">\n    <textarea [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\"\n      [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\" [ngStyle]=\"fieldparam.style\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\"\n      [style.height]=\"fieldparam.height\" [style.width]=\"fieldparam.width\" style=\"    border: 1px solid #9c9d9e !important;border-radius: 0.25rem !important;\"></textarea>\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n  <!-- checkbox -->\n\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'checkbox'\">\n    <input type=\"checkbox\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [readonly]=\"fieldparam.readonly\"\n      [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\" [ngStyle]=\"fieldparam.style\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\"\n      [style.height]=\"fieldparam.height\" [style.width]=\"fieldparam.width\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n  <!-- datebox -->\n\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'datebox'\">\n    <input type=\"date\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [readonly]=\"fieldparam.readonly\"\n      (change)=\"setDateValue() \" [ngModel]=\"writeDateValue(fieldparam.value)\" min=\"0000-00-00\" max=\"9999-12-31\" [ngStyle]=\"fieldparam.style\"\n      [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\" [style.width]=\"fieldparam.width\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n  <!-- combobox -->\n\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'combobox'\">\n    <select [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [value]=\"fieldparam.value\" [(ngModel)]=\"fieldparam.value\"\n      [ngStyle]=\"fieldparam.style\" [attr.disabled]=\"fieldparam.readonly ? true : null\" [style.height]=\"fieldparam.height\"\n      [style.width]=\"fieldparam.width\">\n      <option value=null attr.disabled hidden>Select {{fieldparam.title}}</option>\n      <option></option>\n      <option *ngFor=\"let datavalue of fieldparam.datavalues\" [value]=\"pvalue\">{{pname}}</option>\n    </select>\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n\n  <!-- url -->\n  <div class=\"form-group\" *ngIf=\"fieldparam.compname == 'url'\">\n    <input type=\"url\" [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control input-common input-url\" [value]=\"fieldparam.value\"\n      [(ngModel)]=\"fieldparam.value\" [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\" [ngStyle]=\"fieldparam.style\"\n      [attr.disabled]=\"fieldparam.editable == '1' ? true : null\" [style.height]=\"fieldparam.height\" [style.width]=\"fieldparam.width\">\n    <label class=\"form-control-placeholder\">{{fieldparam.title}}\n      <label *ngIf=\"fieldparam.compname != 'hidden' && fieldparam.mandatory=='1'\" class=\"input-label-mandatory\">*</label>\n    </label>\n  </div>\n\n  <!-- imageupload / fileupload -->\n\n  <div *ngIf=\"(fieldparam.compname == 'imageupload' || fieldparam.compname == 'fileupload')\" class=\"input-group\">\n    <input type=\"file\" imageUpload [name]=\"fieldparam.dbfield\" [id]=\"fieldparam.dbfield\" class=\"form-control\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\"\n      [ngStyle]=\"fieldparam.style\" [style.height]=\"fieldparam.height\" [style.width]=\"fieldparam.width\">\n    <span class=\"form-control\">\n      <button type=\"button\" class=\"btn btn-success imageupload-button\" (click)=\"uploadFile()\" [attr.disabled]=\"fieldparam.editable == '1' ? true : null\">Upload</button>\n    </span>\n  </div>\n\n  <div *ngIf=\"fieldparam.compname == 'imageupload'\" class=\"div-upload-content-wrapper\" [hidden]=\"((fieldparam.value=='') || (fieldparam.value=='null') || (fieldparam.value==null))\">\n    <img [attr.src]=\"fieldparam.value\" class=\"image-border\">\n  </div>\n\n  <div *ngIf=\"fieldparam.compname == 'fileupload'\" class=\"div-upload-content-wrapper\">\n    <div [hidden]=\"((fieldparam.value=='') || (fieldparam.value=='null') || (fieldparam.value==null))\" class=\"div-fileupload-message-wrapper\">\n      <span class=\"div.fileupload-message\">Uploaded file </span>\n      <a class=\"btn btn-success div-upload-content\" [href]=\"fieldparam.value\" download>\n        <!-- <a class=\"btn btn-success div-upload-content\" id=\"{{fieldparam.dbfield}}_download\" (click)=\"downloadFile($event, fieldparam.value)\" download> -->\n        Download\n      </a>\n    </div>\n    <div [hidden]=\"((!fieldparam.value=='') || (!fieldparam.value=='null') || (!fieldparam.value==null))\" class=\"div-fileupload-message-wrapper\">\n      <span class=\"div.fileupload-message\">No file uploaded</span>\n    </div>\n  </div>\n\n  <div *ngIf=\"fieldparam.compname == 'multiselect'\" class=\"input-group\">\n    <vernost-multiselect [settings]=\"dropdownSettings\" [data]=\"dropdownList\" [(ngModel)]=\"fieldparam.value\"></vernost-multiselect>\n  </div>\n\n  <!-- autocomplete -->\n\n  <!-- <p-autoComplete *ngIf=\"fieldparam.compname == 'autocomplete'\" [inputId]=\"fieldparam.dbfield\" minLength=3 [field]=\"fieldparam.combo_disp_field\"\n    [suggestions]=\"results\" emptyMessage=\"No results found\" [dataKey]=\"fieldparam.combo_value_field\" forceSelection=\"true\" (completeMethod)=\"searchData($event)\"\n    [(ngModel)]=\"fieldparam.value\" (onSelect)=\"setData($event)\" [style]=\"{'width':'100%','margin-top': '1.4rem','background-size': '0!important','font-size': '1rem','font-family': 'Lato!important','height': '2.5rem','border-radius': '.25rem','background':'#e9ecef'}\"\n    [inputStyle]=\"{'width':'100%','background-size': '0!important','font-size': '1rem','font-family': 'Lato!important','height': '2.5rem','border-radius': '.25rem','padding-left': '1rem'}\"\n    [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\" [disabled]=\"fieldparam.editable == '1' ? true : null\">\n\n    <ng-template let-value pTemplate=\"item\">\n      <div class=\"ui-helper-clearfix input-autocomplete-item-wrapper\">\n        <div class=\"input-autocomplete-item\">{{value[fieldparam.combo_disp_field]}}</div>\n      </div>\n    </ng-template>\n\n  </p-autoComplete> -->\n\n  <!-- multipledropdown -->\n\n  <!-- <div class=\"ui-fluid\">\n    <p-autoComplete *ngIf=\"fieldparam.compname == 'multipledropdown'\" [suggestions]=\"results\" (completeMethod)=\"searchData($event)\"\n      minLength=3 [multiple]=\"true\" (onSelect)=\"setData($event)\" [inputId]=\"fieldparam.dbfield\" [(ngModel)]=\"fieldparam.value\" [field]=\"fieldparam.combo_disp_field\"\n      [dataKey]=\"fieldparam.combo_value_field\" forceSelection=\"true\" emptyMessage=\"No results found\" [style]=\"{'margin-top': '1.4rem','background-size': '0!important','font-size': '1rem','font-family': 'Lato!important','border-radius': '.25rem','background':'#e9ecef'}\"\n      [inputStyle]=\"{'background-size': '0!important','font-size': '1rem','font-family': 'Lato!important','height': '1.8rem','padding-left': '0.7rem','width': '100%'}\"\n      [placeholder]=\"(fieldparam.hint != null) ? fieldparam.hint : ''\" [disabled]=\"fieldparam.editable == '1' ? true : null\">\n\n      <ng-template let-value pTemplate=\"item\">\n        <div class=\"ui-helper-clearfix input-autocomplete-item-wrapper\">\n          <div class=\"input-autocomplete-item\">{{value[fieldparam.combo_disp_field]}}</div>\n        </div>\n      </ng-template>\n\n      <ng-template let-value pTemplate=\"selectedItem\">\n        <span class=\"input-multidropdown\">{{value[fieldparam.combo_disp_field]}}</span>\n        <span class=\"input-multidropdown-remove-button\" (click)=\"removeMultiselectItem(value)\">\n          <i class=\"fa fa-times\"></i>\n        </span>\n      </ng-template>\n\n    </p-autoComplete>\n  </div> -->\n\n  <!-- htmleditor -->\n\n  <div *ngIf=\"fieldparam.compname == 'htmleditor'\" class=\"input-tinymce\">\n    <app-tiny-editor [id]=\"fieldparam.dbfield\" [elementId]=\"fieldparam.dbfield\" ngDefaultControl [(ngModel)]='fieldparam.value'\n      (onEditorContentChange)=\"onEditorChange($event)\"></app-tiny-editor>\n  </div>\n\n  <label *ngIf=\"fieldparam.compname == 'status'\" class=\"inputcontainer\"> {{fieldparam.title}} :\n    <label *ngIf=\"fieldparam.value==1\">Active</label>\n    <label *ngIf=\"fieldparam.value!=1\">In-Active</label>\n    <input type=\"checkbox\" [disabled]=\"fieldparam.readonly\" [checked]=\"fieldparam.value==1\" (click)=\"checkstatus($event)\">\n    <span class=\"inputcheckmark\"></span>\n  </label>\n</div>",
                        providers: [VernostService],
                        styles: [".input-wrapper {\n  min-width: 200px;\n  margin-bottom: 1.5rem;\n  font-size: 1rem; }\n\n.input-label {\n  margin-bottom: 0;\n  font-weight: 500; }\n\n.input-label-mandatory {\n  color: #ff0000; }\n\n.input-common {\n  margin-top: .9rem;\n  background-size: 0 !important;\n  border: 1px solid #e3e9f3;\n  border-radius: .25rem;\n  font-size: 1rem;\n  font-family: Lato !important; }\n\n.input-textbox, .input-datebox, .input-url, .input-password, .input-email, .input-combobox {\n  height: 2.5rem;\n  padding-left: 1rem; }\n\n.input-number::-webkit-inner-spin-button, .input-number::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0; }\n\n.input-textarea {\n  height: 8rem;\n  padding: .5rem 1rem .3rem;\n  line-height: 1.8rem; }\n\n.input-checkbox {\n  margin-top: 1.4rem;\n  height: 2.5rem;\n  width: 2.5rem;\n  box-shadow: none; }\n\n.input-imageupload {\n  height: 2.5rem;\n  padding: 5px 5px 0 1rem; }\n\n.imageupload-button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin-left: -2px; }\n\n.input-tinymce {\n  margin-top: .9rem;\n  background-size: 0 !important;\n  border: 1px solid #e3e9f3;\n  border-radius: .25rem; }\n\n.image-border {\n  border: black thin;\n  width: 100%; }\n\n.div-upload-content-wrapper {\n  margin: 10px; }\n\n.div-fileupload-message-wrapper {\n  display: flex;\n  align-items: center; }\n\n.div-fileupload-message {\n  font-weight: bold;\n  font-size: 20px; }\n\n.div-upload-content {\n  margin: 0 10px; }\n\n::ng-deep .ui-autocomplete-token {\n  margin: 5px !important; }\n\n.input-multidropdown {\n  font-size: 17px;\n  margin: 10px; }\n\n.input-autocomplete-item-wrapper {\n  border-bottom: 1px solid #D5D5D5; }\n\n.input-autocomplete-item {\n  font-size: 17px;\n  margin-bottom: 10px; }\n\n.input-multidropdown-remove-button {\n  color: #ffffff;\n  display: inline-flex;\n  vertical-align: text-top;\n  cursor: pointer; }\n\ninput:disabled, textarea:disabled, select:disabled {\n  background: #fff0ff !important; }\n\n.form-group {\n  position: relative;\n  margin-bottom: 1.5rem; }\n\n.form-control-placeholder {\n  position: absolute;\n  top: 0;\n  padding: 7px 0 0 13px;\n  transition: all 200ms;\n  opacity: 0.5;\n  transform: translate3d(0, -100%, 0);\n  color: black; }\n\n.inputcontainer {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n/* Hide the browser's default checkbox */\n.inputcontainer input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer; }\n\n/* Create a custom checkbox */\n.inputcheckmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: #eee; }\n\n/* On mouse-over, add a grey background color */\n.inputcontainer:hover input ~ .inputcheckmark {\n  background-color: #ccc; }\n\n/* When the checkbox is checked, add a blue background */\n.inputcontainer input:checked ~ .inputcheckmark {\n  background-color: #2196F3; }\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.inputcheckmark:after {\n  content: \"\";\n  position: absolute;\n  display: none; }\n\n/* Show the checkmark when checked */\n.inputcontainer input:checked ~ .inputcheckmark:after {\n  display: block; }\n\n/* Style the checkmark/indicator */\n.inputcontainer .inputcheckmark:after {\n  left: 9px;\n  top: 5px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg); }\n"]
                    }] }
        ];
        /** @nocollapse */
        ModelInputComponent.ctorParameters = function () { return [
            { type: FormBuilder, },
            { type: VernostService, },
        ]; };
        ModelInputComponent.propDecorators = {
            "combodata": [{ type: core.Input, args: ['combodata',] },],
            "field": [{ type: core.Input, args: ['field',] },],
            "afterchange": [{ type: core.Output, args: ['change',] },],
            "keyup": [{ type: core.Output, args: ['keyup',] },],
        };
        return ModelInputComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var TinyEditorComponent = /** @class */ (function () {
        function TinyEditorComponent() {
            this.onEditorContentChange = new core.EventEmitter();
        }
        /**
         * @return {?}
         */
        TinyEditorComponent.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            tinymce.init({
                selector: '#' + this.elementId,
                branding: false,
                plugins: ['link', 'table', 'paste', 'code', 'textcolor', 'colorpicker', 'image'],
                toolbar: 'code | bold italic strikethrough forecolor backcolor | link | image | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | fontsizeselect | fontselect | removeformat',
                skin_url: 'assets/skins/lightgray',
                setup: function (editor) {
                    _this.editor = editor;
                    editor.on('keyup change', function () {
                        var /** @type {?} */ content = editor.getContent();
                        _this.onEditorContentChange.emit(content);
                    });
                }
            });
        };
        /**
         * @return {?}
         */
        TinyEditorComponent.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            tinymce.remove(this.editor);
        };
        TinyEditorComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'app-tiny-editor',
                        template: "<textarea id=\"{{elementId}}\"></textarea>\n",
                        styles: [""]
                    }] }
        ];
        /** @nocollapse */
        TinyEditorComponent.propDecorators = {
            "elementId": [{ type: core.Input },],
            "onEditorContentChange": [{ type: core.Output },],
        };
        return TinyEditorComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostSearchComponent = /** @class */ (function () {
        function VernostSearchComponent(mainService) {
            this.mainService = mainService;
            this.inProgress = false;
            this.showScreen = new core.EventEmitter();
            this.searchdata = new core.EventEmitter();
        }
        /**
         * @return {?}
         */
        VernostSearchComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
        };
        /**
         * @return {?}
         */
        VernostSearchComponent.prototype.onAddClick = /**
         * @return {?}
         */
        function () {
            this.showScreen.emit();
        };
        /**
         * @return {?}
         */
        VernostSearchComponent.prototype.onSearchClick = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this.inProgress = true;
            this.mainService.postData('/searchfilter', this.searchModel).subscribe(function (response) {
                // console.log("onSearchClick response === ",response);
                // console.log("onSearchClick response === ",response);
                _this.inProgress = false;
                _this.searchdata.emit(response);
            });
        };
        VernostSearchComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-search',
                        template: "<div class=\"row content\">\n  <div class=\"col-md-12\">\n    <div class=\"card search-wrapper\">\n      <h5 class=\"card-header\">\n        <div class=\"row\">\n          <div class=\"col-md-6 search-title\">\n            <span>{{searchtitle}}</span>\n          </div>\n          <div class=\"col-md-6\">\n            <button style=\"float: right;\" class=\"btn btn-primary\" (click)=\"onAddClick()\">\n              <i class=\"fa fa-plus fa-add-margin\"></i>Add New\n            </button>\n          </div>\n        </div>\n      </h5>\n      <div class=\"card-body\">\n        <div class=\"row\">\n          <div class=\"col-md-12\">\n            <div class=\"form-div\">\n              <div class=\"row\">\n                <ng-content></ng-content>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-12 search-buttons-wrapper\">\n                  <vernost-spinner *ngIf=\"inProgress\" [tickness]=\"5\" [size]=\"40\"></vernost-spinner>\n                  <button *ngIf=\"!inProgress\" type=\"button\" class=\"btn search-button\" (click)=\"onSearchClick()\">\n                      <i class=\"fa fa-search fa-add-margin\"></i>Search\n                  </button>\n                  <button *ngIf=\"!inProgress\" type=\"button\" class=\"btn search-clear-button\">\n                      <i class=\"fa fa-eraser fa-add-margin\"></i>Clear\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                        providers: [VernostService],
                        styles: [".content {\n  padding-bottom: 36px; }\n\n.search-wrapper {\n  box-shadow: 0 2px 4px #e3e9f3; }\n\n.search-title {\n  display: flex;\n  align-items: center; }\n\n.fa-add-margin {\n  margin-right: 10px; }\n\n.form-div {\n  width: 100%;\n  padding: 0 15px; }\n\n.search-buttons-wrapper {\n  margin-top: 20px; }\n\n.search-button {\n  margin-right: 20px;\n  background-color: green;\n  color: white;\n  font-weight: bold; }\n\n.search-clear-button {\n  margin-right: 20px;\n  background-color: #CD6155;\n  color: white;\n  font-weight: bold; }\n\n.search-button-span {\n  padding: 20px; }\n"]
                    }] }
        ];
        /** @nocollapse */
        VernostSearchComponent.ctorParameters = function () { return [
            { type: VernostService, },
        ]; };
        VernostSearchComponent.propDecorators = {
            "searchtitle": [{ type: core.Input, args: ['searchtitle',] },],
            "searchModel": [{ type: core.Input, args: ['searchModel',] },],
            "showScreen": [{ type: core.Output },],
            "searchdata": [{ type: core.Output },],
        };
        return VernostSearchComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostScreenComponent = /** @class */ (function () {
        function VernostScreenComponent() {
            this.showSearch = new core.EventEmitter();
            this.saveData = new core.EventEmitter();
        }
        /**
         * @return {?}
         */
        VernostScreenComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
        };
        /**
         * @return {?}
         */
        VernostScreenComponent.prototype.onBackClick = /**
         * @return {?}
         */
        function () {
            this.showSearch.emit();
        };
        /**
         * @return {?}
         */
        VernostScreenComponent.prototype.SaveData = /**
         * @return {?}
         */
        function () {
            this.saveData.emit();
        };
        VernostScreenComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-screen',
                        template: "<div>\n\n  <div class=\"card screen-wrapper\">\n    <div class=\"header row\">\n      <div class=\"col-lg-7 header-title\">\n        <span class=\"screen-title\">{{screentitle}}</span>\n\n      </div>\n      <div class=\"col-lg-5 button-wrapper\">\n\n        <button *ngIf=\"actionmode=='Add' || actionmode=='Edit'\" class=\"btn back-button button-margin\" (click)=\"SaveData()\">\n          <i class=\"fa fa-telegram font-icon-button\"></i>\n          Save\n        </button>\n        <!-- <button *ngIf=\"actionmode=='Add' || actionmode=='Edit'\" class=\"btn clear-button button-margin\">\n          <i class=\"fa fa-eraser font-icon-button\"></i>\n          Reset\n        </button> -->\n        <button class=\"btn clear-button button-margin\" (click)=\"onBackClick()\">\n          <i class=\"fa fa-chevron-left font-icon-button\"></i>\n          Close\n        </button>\n      </div>\n    </div>\n\n    <div class=\"card-body\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"form-div\">\n            <div class=\"row\">\n\n              <ng-content></ng-content>\n\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</div>",
                        styles: [".header {\n  margin-bottom: 30px; }\n\n.header-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: .7rem;\n  margin-bottom: 1px;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center; }\n\n.screen-title {\n  margin-left: 20px; }\n\n.back-button {\n  margin-left: 20px;\n  background-color: green;\n  color: white;\n  font-weight: bold; }\n\n.clear-button {\n  background-color: #CD6155;\n  color: white;\n  font-weight: bold; }\n\n.font-icon-button {\n  margin-right: 10px; }\n\n.button-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end; }\n\n.button-margin {\n  margin: 20px;\n  padding-left: 50px;\n  padding-right: 50px; }\n\n.screen-wrapper {\n  box-shadow: 0 2px 4px #e3e9f3; }\n\n.form-div {\n  width: 100%;\n  padding: 0 15px; }\n"]
                    }] }
        ];
        /** @nocollapse */
        VernostScreenComponent.ctorParameters = function () { return []; };
        VernostScreenComponent.propDecorators = {
            "screentitle": [{ type: core.Input, args: ['screentitle',] },],
            "actionmode": [{ type: core.Input, args: ['actionmode',] },],
            "showSearch": [{ type: core.Output },],
            "saveData": [{ type: core.Output },],
        };
        return VernostScreenComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostListComponent = /** @class */ (function () {
        function VernostListComponent() {
        }
        /**
         * @return {?}
         */
        VernostListComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
        };
        VernostListComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-list',
                        template: "<div class=\"row content\">\n  <div class=\"col-md-12\">\n    <div class=\"card search-wrapper\">\n      <h5 class=\"card-header\">\n        <div class=\"row\">\n\n        </div>\n      </h5>\n      <div class=\"card-body\">\n        <div class=\"row\">\n          <div class=\"col-md-12\">\n            <div class=\"form-div\">\n              <div class=\"row\">\n                  <ng-content ></ng-content>\n                <!-- <mat-form-field>\n                  <input matInput (keyup)=\"applyFilter($event.target.value)\" placeholder=\"Filter\">\n                </mat-form-field> -->\n\n                <!-- <table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\"> -->\n\n                  <!-- Position Column -->\n                  <!-- <ng-container matColumnDef=\"position\">\n                    <th mat-header-cell *matHeaderCellDef> No. </th>\n                    <td mat-cell *matCellDef=\"let element\"> {{element.position}} </td>\n                  </ng-container> -->\n\n                  <!-- Name Column -->\n                  <!-- <ng-container matColumnDef=\"name\">\n                    <th mat-header-cell *matHeaderCellDef> Name </th>\n                    <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\n                  </ng-container> -->\n\n                  <!-- Weight Column -->\n                  <!-- <ng-container matColumnDef=\"weight\">\n                    <th mat-header-cell *matHeaderCellDef> Weight </th>\n                    <td mat-cell *matCellDef=\"let element\"> {{element.weight}} </td>\n                  </ng-container> -->\n\n                  <!-- Symbol Column -->\n                  <!-- <ng-container matColumnDef=\"symbol\">\n                    <th mat-header-cell *matHeaderCellDef> Symbol </th>\n                    <td mat-cell *matCellDef=\"let element\"> {{element.symbol}} </td>\n                  </ng-container> -->\n\n                  <!-- <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n                  <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n                </table> -->\n\n              </div>\n              <div class=\"row\">\n\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                        styles: ["table {\n  width: 100%; }\n\n.mat-form-field {\n  font-size: 14px;\n  width: 100%; }\n\n.list-table-container {\n  padding: 20px;\n  overflow-x: auto; }\n\n.list-table {\n  width: 100%; }\n\n.mat-form-field {\n  font-size: 14px;\n  width: 100%; }\n\nth.mat-sort-header-sorted {\n  color: black; }\n\n.paginetor {\n  float: right;\n  width: 100%;\n  margin-top: 10px; }\n\n.mat-row:hover {\n  background-color: lightgray;\n  cursor: pointer; }\n"]
                    }] }
        ];
        /** @nocollapse */
        VernostListComponent.ctorParameters = function () { return []; };
        VernostListComponent.propDecorators = {
            "listtitle": [{ type: core.Input, args: ['listtitle',] },],
            "listModel": [{ type: core.Input, args: ['listModel',] },],
        };
        return VernostListComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostTableComponent = /** @class */ (function () {
        function VernostTableComponent() {
            this.SelectedItem = new core.EventEmitter();
        }
        Object.defineProperty(VernostTableComponent.prototype, "displayedColumns", {
            get: /**
             * @return {?}
             */
            function () {
                return this.displayedCells;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this.actionbuttonsreq) {
                    if (value != null) {
                        if (value != undefined) {
                            var /** @type {?} */ pvalue_1 = [];
                            pvalue_1.push("Action");
                            value.forEach(function (el) {
                                pvalue_1.push(el);
                            });
                            this.displayedCells = pvalue_1;
                        }
                    }
                }
                else {
                    this.displayedCells = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VernostTableComponent.prototype, "displayedColumnTitles", {
            get: /**
             * @return {?}
             */
            function () {
                return this.displayedCellTitles;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (this.actionbuttonsreq) {
                    if (value != null) {
                        if (value != undefined) {
                            var /** @type {?} */ pvalue_2 = [];
                            pvalue_2.push("Action");
                            value.forEach(function (el) {
                                pvalue_2.push(el);
                            });
                            this.displayedCellTitles = pvalue_2;
                        }
                    }
                }
                else {
                    this.displayedCellTitles = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(VernostTableComponent.prototype, "dataSource", {
            get: /**
             * @return {?}
             */
            function () {
                return this.dataSourcevalue;
            },
            set: /**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                if (value != null) {
                    if (value != undefined) {
                        value.forEach(function (e) {
                            e.action = "";
                        });
                        this.dataSourcevalue = new MatTableDataSource(value);
                        this.dataSourcevalue.paginator = this.paginator;
                        this.dataSourcevalue.sort = this.sort;
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {?} filterValue
         * @return {?}
         */
        VernostTableComponent.prototype.applyFilter = /**
         * @param {?} filterValue
         * @return {?}
         */
        function (filterValue) {
            filterValue = filterValue.trim(); // Remove whitespace
            filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
            this.dataSourcevalue.filter = filterValue;
        };
        /**
         * @return {?}
         */
        VernostTableComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.dataSourcevalue.paginator = this.paginator;
            this.dataSourcevalue.sort = this.sort;
        };
        /**
         * @param {?} element
         * @param {?} type
         * @return {?}
         */
        VernostTableComponent.prototype.trclick = /**
         * @param {?} element
         * @param {?} type
         * @return {?}
         */
        function (element, type) {
            this.SelectedItem.emit({ type: type, data: element });
        };
        VernostTableComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-table',
                        template: "<style>\n    .cell0 {\n        width: 100px;\n    }\n\n    .actionbutton {\n        cursor: pointer;\n        margin-right: 6px;\n    }\n</style>\n<div class=\"row content\">\n    <div class=\"col-md-12\">\n        <div class=\"card search-wrapper\">\n            <h5 *ngIf=\"listtitle\" class=\"card-header\">\n                <div class=\"row\">\n                    {{listtitle}}\n                </div>\n            </h5>\n            <div class=\"card-body\">\n                <div class=\"row\" style=\"padding: 10px;\">\n                    <mat-form-field *ngIf=\"filterreq\">\n                        <input matInput (keyup)=\"applyFilter($event.target.value)\" placeholder=\"Filter\" autocomplete=\"off\">\n                    </mat-form-field>\n                    <table mat-table matSort [dataSource]=\"dataSourcevalue\" class=\"mat-elevation-z8\" style=\"width: 100%;\">\n                        <ng-container *ngFor=\"let col of displayedCells; let i = index \" matColumnDef=\"{{col}}\">\n                            <th [class]=\"col=='Action' && editactionbuttonreq?'cell0':''\" mat-sort-header mat-header-cell *matHeaderCellDef> {{displayedCellTitles[i]}} </th>\n                            <td mat-cell *matCellDef=\"let element\">\n                                <img *ngIf=\"col=='Action' && editactionbuttonreq\" class=\"actionbutton\" (click)=\"trclick(element,'View')\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADnSURBVDhPzdJRSgJRGIbhScGrbAdmF+FKiiAXUrQB6T7aUyqhFYQr0OtqDZVX9b7DfDKKoJd+8AzDOf9/5pyZKQ42R+jhsuL9XmngDgv8bZjjFtZszQnGSMM33ireZ3yENtbSwgtS9I5TJF3MkPkp7FnlEZn0aTb38VW5hov8IHUPKGPxEpl4hflExj4cIB4nY/aUu/Tyi0xYZHYtYE8HZe6RCbfpom7bRWy+whnqRxhglSYmyKQvzDMnNtdf4jPsWYufZogU+bR8xvqTn3CMrfEP9Gfxp0lDOHYDa/bKOS4q3h9kiuIf0hNZLlGzcQcAAAAASUVORK5CYII=\">\n                                <img *ngIf=\"col=='Action' && viewactionbuttonreq\" class=\"actionbutton\" (click)=\"trclick(element,'Edit')\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAESSURBVDhPldOxSwJhHMbxswxq03B0iCaHFB0ShTBsaGlJqNUlaG6RaoloqOj/KEIRQtpaa2iuP6AhcAv/ACO/z3uc3R3vHXcPfOD1p+9z6PvqkC5+8JfQL15RgEmazX5nMNGLOxyn8I4bmKhgy10mzj2sBWtYxirWLTRXIgsm0Fpvah7mbYosyCGLFeQtNFciC56wgSO8WGiu7KHmLoMFJyhiG6cWmisl7LjLYME+dEHKOAzZhbKAD0zR0cBf8IUGLqAL5vlGE3U8oIIxeggUxEXFOiV9fgQdeQbmbre0iIme7m2WAZZg8oZP9C2uoacM8Qxt1lxHPY9+NP0xbi0OUMUlzvGIRaRKG1fYhPnO/3GcGeuUZ7KgzIGfAAAAAElFTkSuQmCC\">\n                                <img *ngIf=\"col=='Action' && additionalactions\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEBSURBVDhPzdIxS0JRGMbxG0kaVIoEghBZDjk4KDa0CIISNDiIoy5CQwSSi7iE4CC4GoK4F5SfosFB0K/QB/BDiP6fk2e79y4N9sDv8nK5nPue9xznXySHOd5QxgJLD6+ooYEPxGAebVRwg46PEjK4hRY6hnOEAq5xgiL0oZs4bK5woOIea3zjCRsf77D5weVv+cek8YUu1P7UxzNshjhXkcAIj8hijImHKmxeoJmZQWggUQSgYXo5QxAhhGHyAA1ohtau9vKJHgZYQd2bXOAU6kYv3f4uOvdDqFN1YpKE9t3EHdz2btVho1sZUZGCrqVuWh46EbcTEA3apg+zwD7jOFumwUYVus4vPAAAAABJRU5ErkJggg==\">\n                                \n                                <div *ngIf=\"col!='Action'\" [innerHTML]=\"element[col]\"></div>\n                            </td>\n                        </ng-container>\n                        <tr mat-header-row *matHeaderRowDef=\"displayedCells\"></tr>\n                        <tr mat-row *matRowDef=\"let row; columns: displayedCells;\"></tr>\n                    </table>\n                    <hr>\n                    <mat-paginator class=\"paginetor\" [pageSizeOptions]=\"[10, 20, 50]\" showFirstLastButtons></mat-paginator>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>",
                        styles: ["table {\n  width: 100%; }\n\n.mat-form-field {\n  font-size: 14px;\n  width: 100%; }\n\n.list-table-container {\n  padding: 20px;\n  overflow-x: auto; }\n\n.list-table {\n  width: 100%; }\n\n.mat-form-field {\n  font-size: 14px;\n  width: 100%; }\n\nth.mat-sort-header-sorted {\n  color: black; }\n\n.paginetor {\n  float: right;\n  width: 100%;\n  margin-top: 10px; }\n\n.mat-row:hover {\n  background-color: lightgray;\n  cursor: pointer; }\n"]
                    }] }
        ];
        /** @nocollapse */
        VernostTableComponent.ctorParameters = function () { return []; };
        VernostTableComponent.propDecorators = {
            "paginator": [{ type: core.ViewChild, args: [MatPaginator,] },],
            "sort": [{ type: core.ViewChild, args: [MatSort,] },],
            "listtitle": [{ type: core.Input, args: ['listtitle',] },],
            "filterreq": [{ type: core.Input, args: ['filterreq',] },],
            "additionalactions": [{ type: core.Input, args: ['additionalactions',] },],
            "actionbuttonsreq": [{ type: core.Input, args: ['actionbuttonreq',] },],
            "editactionbuttonreq": [{ type: core.Input, args: ['editactionbuttonreq',] },],
            "viewactionbuttonreq": [{ type: core.Input, args: ['viewactionbuttonreq',] },],
            "displayedColumns": [{ type: core.Input, args: ['displayedColumns',] },],
            "displayedColumnTitles": [{ type: core.Input, args: ['displayedColumnTitles',] },],
            "dataSource": [{ type: core.Input, args: ['dataSource',] },],
            "SelectedItem": [{ type: core.Output },],
        };
        return VernostTableComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostTableRowComponent = /** @class */ (function () {
        //   displayedColumns = ['position', 'name', 'weight', 'symbol'];
        //   dataSource = new MatTableDataSource(ELEMENT_DATA);
        //   searcheddata: any;
        //   applyFilter(filterValue: string) {
        //     filterValue = filterValue.trim(); // Remove whitespace
        //     filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        //     this.dataSource.filter = filterValue;
        //   }
        function VernostTableRowComponent() {
        }
        /**
         * @return {?}
         */
        VernostTableRowComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
        };
        VernostTableRowComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-table-row',
                        template: "\n  <ng-container matColumnDef=\"{{name}}\">\n    <th mat-header-cell *matHeaderCellDef> {{title}} </th>\n    <td mat-cell *matCellDef=\"let element\"> {{element[value]}} </td>\n  </ng-container>\n  "
                    }] }
        ];
        /** @nocollapse */
        VernostTableRowComponent.ctorParameters = function () { return []; };
        VernostTableRowComponent.propDecorators = {
            "name": [{ type: core.Input, args: ['name',] },],
            "value": [{ type: core.Input, args: ['value',] },],
        };
        return VernostTableRowComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostProgressBarComponent = /** @class */ (function () {
        function VernostProgressBarComponent() {
            this.color = 'primary';
            this.mode = 'indeterminate';
            this.value = 50;
            this.bufferValue = 75;
        }
        /**
         * @return {?}
         */
        VernostProgressBarComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
        };
        VernostProgressBarComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-progress',
                        template: "\n        <mat-progress-bar\n        [color]=\"color\"\n        [mode]=\"mode\"\n        [value]=\"value\"\n        [bufferValue]=\"bufferValue\">\n        </mat-progress-bar>\n  "
                    }] }
        ];
        /** @nocollapse */
        VernostProgressBarComponent.ctorParameters = function () { return []; };
        return VernostProgressBarComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostSpinnerComponent = /** @class */ (function () {
        function VernostSpinnerComponent() {
            this.size = 25;
            this.tickness = 2;
            this.color = '#4f6aa7';
            this.opacity = '.1';
            this.secondColor = '';
        }
        /**
         * @return {?}
         */
        VernostSpinnerComponent.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ c = this.hexToRgb(this.color);
            this.secondColor = 'rgba(' + c.r + ',' + c.g + ',' + c.b + ', ' + this.opacity + ')';
        };
        /**
         * @param {?} hex
         * @return {?}
         */
        VernostSpinnerComponent.prototype.hexToRgb = /**
         * @param {?} hex
         * @return {?}
         */
        function (hex) {
            var /** @type {?} */ result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        };
        VernostSpinnerComponent.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-spinner',
                        template: '',
                        styles: ["\n    @keyframes spin {\n      from {transform: rotate(0deg);}\n      to {transform: rotate(360deg);}\n    }\n    :host {\n      position:relative;\n      box-sizing: border-box;\n      display:inline-block;\n      padding:0px;\n      border-radius:100%;\n      border-style:solid;\n      animation: spin 0.8s linear infinite;\n    }\n    :host .margins {\n        margin: 0px 10px;\n    }\n  "]
                    }] }
        ];
        /** @nocollapse */
        VernostSpinnerComponent.propDecorators = {
            "size": [{ type: core.Input }, { type: core.HostBinding, args: ['style.width.px',] }, { type: core.HostBinding, args: ['style.height.px',] },],
            "tickness": [{ type: core.Input }, { type: core.HostBinding, args: ['style.borderWidth.px',] },],
            "color": [{ type: core.Input }, { type: core.HostBinding, args: ['style.borderTopColor',] },],
            "opacity": [{ type: core.Input },],
            "secondColor": [{ type: core.HostBinding, args: ['style.borderBottomColor',] }, { type: core.HostBinding, args: ['style.borderLeftColor',] }, { type: core.HostBinding, args: ['style.borderRightColor',] },],
        };
        return VernostSpinnerComponent;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var DateRange = /** @class */ (function () {
        function DateRange() {
        }
        return DateRange;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var /** @type {?} */ DATEPICKER_CONTROL_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return DatePicker; }),
        multi: true
    };
    var DatePicker = /** @class */ (function () {
        function DatePicker() {
            this.onDateSelect = new core.EventEmitter();
            this.dateRange = new DateRange();
            this.popover = false;
            this.cal_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            this.timeViewDate = new Date(this.date);
            this.hourValue = 0;
            this.toHourValue = 0;
            this.minValue = 0;
            this.toMinValue = 0;
            this.timeViewMeridian = "";
            this.toTimeViewMeridian = "";
            this.timeView = false;
            this.yearView = false;
            this.yearsList = [];
            this.monthDays = [];
            this.toMonthDays = [];
            this.monthsView = false;
            this.today = new Date();
            this.leftDate = new Date();
            this.rightDate = new Date();
            this.defaultSettings = {
                defaultOpen: false,
                bigBanner: true,
                timePicker: false,
                format: 'dd-MMM-yyyy hh:mm a',
                cal_days_labels: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                cal_full_days_lables: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                cal_months_labels: ['January', 'February', 'March', 'April',
                    'May', 'June', 'July', 'August', 'September',
                    'October', 'November', 'December'],
                cal_months_labels_short: ['JAN', 'FEB', 'MAR', 'APR',
                    'MAY', 'JUN', 'JUL', 'AUG', 'SEP',
                    'OCT', 'NOV', 'DEC'],
                closeOnSelect: true,
                rangepicker: true
            };
            /**
             *
             * (ssd > endDay -> startDay = endDay -> step = 1 ) && (sed > startDay -> 2)
             * (ssd < endDay -> startDay = ssd - step =1) && (sed < startDay -> 2 )
             *
             */
            this.rangeSelected = 0;
        }
        /**
         * @return {?}
         */
        DatePicker.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.settings = Object.assign(this.defaultSettings, this.settings);
            if (this.settings.defaultOpen) {
                this.popover = true;
            }
        };
        /**
         * @param {?} value
         * @return {?}
         */
        DatePicker.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== undefined && value !== null) {
                if (!this.settings.rangepicker) {
                    this.initDate(value);
                    this.monthDays = this.generateDays(this.date);
                }
                else {
                    this.initDateRange(value);
                    if (this.dateRange.startDate.getMonth() === this.dateRange.endDate.getMonth() && this.dateRange.startDate.getFullYear() === this.dateRange.endDate.getFullYear()) {
                        this.leftDate = new Date(this.dateRange.startDate);
                        var /** @type {?} */ tempDate = new Date(this.dateRange.startDate);
                        tempDate.setMonth(tempDate.getMonth() + 1);
                        tempDate.setDate(1);
                        this.rightDate = new Date(tempDate);
                        this.monthDays = this.generateDays(this.leftDate);
                        this.toMonthDays = this.generateDays(this.rightDate);
                    }
                    else {
                        this.leftDate = new Date(this.dateRange.startDate);
                        this.rightDate = new Date(this.dateRange.endDate);
                        this.monthDays = this.generateDays(this.leftDate);
                        this.toMonthDays = this.generateDays(this.rightDate);
                    }
                    console.log(this.monthDays);
                }
            }
            else {
                this.date = new Date();
            }
        };
        /**
         * @param {?} fn
         * @return {?}
         */
        DatePicker.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onChangeCallback = fn;
        };
        /**
         * @param {?} fn
         * @return {?}
         */
        DatePicker.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onTouchedCallback = fn;
        };
        /**
         * @param {?} val
         * @return {?}
         */
        DatePicker.prototype.initDate = /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.date = new Date(val);
            if (this.date.getHours() <= 11) {
                this.hourValue = this.date.getHours();
                this.timeViewMeridian = "AM";
            }
            else {
                this.hourValue = this.date.getHours() - 12;
                this.timeViewMeridian = "PM";
            }
            if (this.date.getHours() == 0 || this.date.getHours() == 12) {
                this.hourValue = 12;
            }
            this.minValue = this.date.getMinutes();
        };
        /**
         * @param {?} val
         * @return {?}
         */
        DatePicker.prototype.initDateRange = /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.dateRange.startDate = new Date(val.startDate);
            this.dateRange.endDate = new Date(val.endDate);
            if (this.dateRange.startDate.getHours() <= 11) {
                this.hourValue = this.dateRange.startDate.getHours();
                this.timeViewMeridian = "AM";
            }
            else {
                this.hourValue = this.dateRange.startDate.getHours() - 12;
                this.timeViewMeridian = "PM";
            }
            if (this.dateRange.startDate.getHours() == 0 || this.dateRange.startDate.getHours() == 12) {
                this.hourValue = 12;
            }
            this.minValue = this.dateRange.startDate.getMinutes();
            if (this.dateRange.endDate.getHours() <= 11) {
                this.toHourValue = this.dateRange.endDate.getHours();
                this.toTimeViewMeridian = "AM";
            }
            else {
                this.toHourValue = this.dateRange.endDate.getHours() - 12;
                this.toTimeViewMeridian = "PM";
            }
            if (this.dateRange.endDate.getHours() == 0 || this.dateRange.endDate.getHours() == 12) {
                this.toHourValue = 12;
            }
            this.toMinValue = this.dateRange.endDate.getMinutes();
        };
        /**
         * @param {?} date
         * @return {?}
         */
        DatePicker.prototype.generateDays = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            var /** @type {?} */ year = date.getFullYear(), /** @type {?} */
            month = date.getMonth(), /** @type {?} */
            current_day = date.getDate(), /** @type {?} */
            today = new Date();
            var /** @type {?} */ firstDay = new Date(year, month, 1);
            var /** @type {?} */ startingDay = firstDay.getDay();
            var /** @type {?} */ monthLength = this.getMonthLength(month, year);
            var /** @type {?} */ day = 1;
            var /** @type {?} */ dateArr = [];
            var /** @type {?} */ dateRow = [];
            // this loop is for is weeks (rows)
            for (var /** @type {?} */ i = 0; i < 9; i++) {
                // this loop is for weekdays (cells)
                dateRow = [];
                for (var /** @type {?} */ j = 0; j <= 6; j++) {
                    var /** @type {?} */ dateCell = null;
                    if (day <= monthLength && (i > 0 || j >= startingDay)) {
                        dateCell = day;
                        if (day == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear()) ;
                        day++;
                    }
                    dateRow.push({ day: dateCell, date: new Date((month + 1) + '-' + dateCell + '-' + date.getFullYear()) });
                }
                // stop making rows if we've run out of days
                if (day > monthLength) {
                    dateArr.push(dateRow);
                    break;
                }
                else {
                    dateArr.push(dateRow);
                }
            }
            return dateArr;
        };
        /**
         * @param {?} param
         * @return {?}
         */
        DatePicker.prototype.generateYearList = /**
         * @param {?} param
         * @return {?}
         */
        function (param) {
            var /** @type {?} */ startYear = null;
            var /** @type {?} */ currentYear = null;
            if (param == "next") {
                startYear = this.yearsList[8] + 1;
                currentYear = this.date.getFullYear();
            }
            else if (param == "prev") {
                startYear = this.yearsList[0] - 9;
                currentYear = this.date.getFullYear();
            }
            else {
                currentYear = this.date.getFullYear();
                startYear = currentYear - 4;
                this.yearView = !this.yearView;
                this.monthsView = false;
            }
            for (var /** @type {?} */ k = 0; k < 9; k++) {
                this.yearsList[k] = startYear + k;
            }
        };
        /**
         * @param {?} month
         * @param {?} year
         * @return {?}
         */
        DatePicker.prototype.getMonthLength = /**
         * @param {?} month
         * @param {?} year
         * @return {?}
         */
        function (month, year) {
            var /** @type {?} */ monthLength = this.cal_days_in_month[month];
            // compensate for leap year
            if (month == 1) {
                // February only!
                if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
                    monthLength = 29;
                }
            }
            return monthLength;
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.toggleMonthView = /**
         * @return {?}
         */
        function () {
            this.yearView = false;
            this.monthsView = !this.monthsView;
        };
        /**
         * @param {?} val
         * @return {?}
         */
        DatePicker.prototype.toggleMeridian = /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.timeViewMeridian = val;
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.setTimeView = /**
         * @return {?}
         */
        function () {
            if (this.timeViewMeridian == "AM") {
                if (this.hourValue == 12) {
                    this.date.setHours(0);
                }
                else {
                    this.date.setHours(this.hourValue);
                }
                this.date.setMinutes(this.minValue);
            }
            else {
                if (this.hourValue == 12) {
                    this.date.setHours(this.hourValue);
                }
                else {
                    this.date.setHours(this.hourValue + 12);
                }
                this.date.setMinutes(this.minValue);
            }
            this.date = new Date(this.date);
            this.timeView = !this.timeView;
        };
        /**
         * @param {?} evt
         * @param {?} type
         * @return {?}
         */
        DatePicker.prototype.setDay = /**
         * @param {?} evt
         * @param {?} type
         * @return {?}
         */
        function (evt, type) {
            if (evt.target.innerHTML) {
                var /** @type {?} */ selectedDay = new Date(evt.target.getAttribute('data-label'));
                if (type == 'range') {
                    if (this.rangeSelected == 0) {
                        this.setStartDate(selectedDay);
                    }
                    else if (this.rangeSelected == 1) {
                        this.setEndDate(selectedDay);
                    }
                }
                else {
                    this.date = new Date(selectedDay);
                    this.onChangeCallback(this.date.toString());
                }
                if (this.settings.closeOnSelect) {
                    this.popover = false;
                    this.onDateSelect.emit(this.date);
                }
            }
        };
        /**
         * @param {?} selectedDate
         * @return {?}
         */
        DatePicker.prototype.setStartDate = /**
         * @param {?} selectedDate
         * @return {?}
         */
        function (selectedDate) {
            if (selectedDate < this.dateRange.endDate) {
                this.dateRange.startDate = new Date(selectedDate);
            }
            else if (selectedDate > this.dateRange.endDate) {
                this.dateRange.startDate = new Date(selectedDate);
                this.dateRange.endDate = new Date(selectedDate);
            }
            this.rangeSelected = 1;
        };
        /**
         * @param {?} selectedDate
         * @return {?}
         */
        DatePicker.prototype.setEndDate = /**
         * @param {?} selectedDate
         * @return {?}
         */
        function (selectedDate) {
            if (selectedDate > this.dateRange.startDate && (this.dateRange.startDate != this.dateRange.endDate)) {
                this.dateRange.endDate = new Date(selectedDate);
            }
            else if (selectedDate > this.dateRange.startDate && (this.dateRange.startDate == this.dateRange.endDate)) {
                this.dateRange.endDate = new Date(selectedDate);
            }
            else if (selectedDate < this.dateRange.startDate && (this.dateRange.startDate != this.dateRange.endDate)) {
                this.dateRange.startDate = new Date(selectedDate);
                this.dateRange.endDate = new Date(selectedDate);
            }
            else if (selectedDate < this.dateRange.startDate && (this.dateRange.startDate == this.dateRange.endDate)) {
                this.dateRange.startDate = new Date(selectedDate);
                this.dateRange.endDate = new Date(selectedDate);
            }
            else if (selectedDate.getTime() == this.dateRange.startDate.getTime()) {
                this.dateRange.startDate = new Date(selectedDate);
                this.dateRange.endDate = new Date(selectedDate);
            }
            this.rangeSelected = 0;
        };
        /**
         * @param {?} date
         * @return {?}
         */
        DatePicker.prototype.highlightRange = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return (date > this.dateRange.startDate && date < this.dateRange.endDate);
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        DatePicker.prototype.setYear = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            console.log(evt.target);
            var /** @type {?} */ selectedYear = parseInt(evt.target.getAttribute('id'));
            this.date = new Date(this.date.setFullYear(selectedYear));
            this.yearView = !this.yearView;
            this.monthDays = this.generateDays(this.date);
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        DatePicker.prototype.setMonth = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            if (evt.target.getAttribute('id')) {
                var /** @type {?} */ selectedMonth = this.settings.cal_months_labels_short.indexOf(evt.target.getAttribute('id'));
                this.date = new Date(this.date.setMonth(selectedMonth));
                this.monthsView = !this.monthsView;
                this.monthDays = this.generateDays(this.date);
            }
        };
        /**
         * @param {?} e
         * @return {?}
         */
        DatePicker.prototype.prevMonth = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            e.stopPropagation();
            if (this.date.getMonth() == 0) {
                this.date.setMonth(11);
                this.date.setFullYear(this.date.getFullYear() - 1);
            }
            else {
                var /** @type {?} */ prevmonthLength = this.getMonthLength(this.date.getMonth() - 1, this.date.getFullYear());
                var /** @type {?} */ currentDate = this.date.getDate();
                if (currentDate > prevmonthLength) {
                    this.date.setDate(prevmonthLength);
                }
                this.date.setMonth(this.date.getMonth() - 1);
            }
            this.date = new Date(this.date);
            this.monthDays = this.generateDays(this.date);
        };
        /**
         * @param {?} e
         * @return {?}
         */
        DatePicker.prototype.nextMonth = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            e.stopPropagation();
            if (this.date.getMonth() == 11) {
                this.date.setMonth(0);
                this.date.setFullYear(this.date.getFullYear() + 1);
            }
            else {
                var /** @type {?} */ nextmonthLength = this.getMonthLength(this.date.getMonth() + 1, this.date.getFullYear());
                var /** @type {?} */ currentDate = this.date.getDate();
                if (currentDate > nextmonthLength) {
                    this.date.setDate(nextmonthLength);
                }
                this.date.setMonth(this.date.getMonth() + 1);
            }
            this.date = new Date(this.date);
            this.monthDays = this.generateDays(this.date);
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        DatePicker.prototype.onChange = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            console.log(evt);
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.incHour = /**
         * @return {?}
         */
        function () {
            if (this.hourValue < 12) {
                this.hourValue += 1;
                console.log(this.hourValue);
            }
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.decHour = /**
         * @return {?}
         */
        function () {
            if (this.hourValue > 1) {
                this.hourValue -= 1;
                console.log(this.hourValue);
            }
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.incMinutes = /**
         * @return {?}
         */
        function () {
            if (this.minValue < 59) {
                this.minValue += 1;
                console.log(this.minValue);
            }
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.decMinutes = /**
         * @return {?}
         */
        function () {
            if (this.minValue > 0) {
                this.minValue -= 1;
                console.log(this.minValue);
            }
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.done = /**
         * @return {?}
         */
        function () {
            this.onChangeCallback(this.date.toString());
            this.popover = false;
            this.onDateSelect.emit(this.date);
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.togglePopover = /**
         * @return {?}
         */
        function () {
            if (this.popover) {
                this.closepopover();
            }
            else {
                this.popover = true;
            }
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.closepopover = /**
         * @return {?}
         */
        function () {
            this.rangeSelected = 0;
            this.popover = false;
        };
        /**
         * @param {?} date
         * @return {?}
         */
        DatePicker.prototype.composeDate = /**
         * @param {?} date
         * @return {?}
         */
        function (date) {
            return (date.getMonth() + 1) + '-' + date.getDate() + '-' + date.getFullYear();
        };
        /**
         * @return {?}
         */
        DatePicker.prototype.getCurrentWeek = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ curr_date = new Date();
            var /** @type {?} */ day = curr_date.getDay();
            var /** @type {?} */ diff = curr_date.getDate() - day + (day == 0 ? -6 : 1); // 0 for sunday
            var /** @type {?} */ week_start_tstmp = curr_date.setDate(diff);
            var /** @type {?} */ week_start = new Date(week_start_tstmp);
            var /** @type {?} */ week_end = new Date(week_start_tstmp); // first day of week
            week_end = new Date(week_end.setDate(week_end.getDate() + 6));
            var /** @type {?} */ date = week_start + ' to ' + week_end; // date range for current week
            console.log(date);
            if (week_start.getMonth() === week_end.getMonth()) {
                this.monthDays = this.generateDays(week_start);
                var /** @type {?} */ tempDate = new Date(week_end);
                tempDate.setMonth(tempDate.getMonth() + 1);
                tempDate.setDate(1);
                this.toMonthDays = this.generateDays(tempDate);
            }
            else {
                this.monthDays = this.generateDays(week_start);
                this.toMonthDays = this.generateDays(week_end);
            }
            this.setStartDate(week_start);
            this.setEndDate(week_end);
        };
        DatePicker.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-date-picker',
                        template: "<div class=\"winkel-calendar\" (clickOutside)=\"closepopover()\">\n        <span *ngIf=\"!settings.rangepicker\">\n        <input type=\"hidden\" class=\"wc-input\" value=\"{{date}}\">\n        <div class=\"wc-date-container\" (click)=\"popover = !popover\">\n            <span>{{date | date: settings.format}}</span>\n        <i class=\"fa fa-calendar\"></i>\n    </div>\n    </span>\n    <div *ngIf=\"!settings.rangepicker\" class=\"wc-date-popover\" [ngClass]=\"{'banner-true': settings.bigBanner == true}\" [hidden]=\"!popover\">\n        <div class=\"wc-banner\" *ngIf=\"settings.bigBanner\">\n            <div class=\"wc-day-row\">{{date | date: 'EEEE'}}</div>\n            <div class=\"wc-date-row\">{{date | date: 'dd'}}</div>\n            <div class=\"wc-my-sec\">\n                <div class=\"wc-month-row\">\n                    <div>{{date | date: 'MMMM'}}</div>\n                </div>\n                <div class=\"wc-year-row\">\n                    <div>{{date | date: 'yyyy'}}</div>\n                </div>\n            </div>\n            <div class=\"wc-time-sec ng-scope\">\n                <div *ngIf=\"settings.timePicker\" class=\"time\" (click)=\"timeView = !timeView\">\n                    {{date | date: 'hh'}} : {{date | date: 'mm'}} {{date | date: 'a'}} <span class=\"fa fa-clock-o\"></span>\n                </div>\n            </div>\n    \n        </div>\n        <div class=\"wc-details\">\n            <i class=\"wc-prev fa fa-angle-left\" (click)=\"prevMonth($event)\"></i>\n            <div class=\"month-year\" *ngIf=\"settings.bigBanner\" (click)=\"toggleMonthView()\">{{date | date: 'MMMM'}}\n                <!-- <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\"></i>\n                                     <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\"></i> -->\n            </div>\n            <div class=\"month-year\" *ngIf=\"!settings.bigBanner\" (click)=\"toggleMonthView()\">\n                {{date | date: 'MMMM'}}\n                <!--    <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\" (click)=\"toggleMonthView()\"></i>\n                                        <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\" (click)=\"toggleMonthView()\"></i>  -->\n    \n            </div>\n            <i class=\"wc-next fa fa-angle-right\" (click)=\"nextMonth($event)\"></i>\n        </div>\n        <div class=\"year-title\">\n            <div class=\"year-dropdown\" (click)=\"generateYearList('current')\">\n                {{date | date: 'yyyy'}}\n                <i *ngIf=\"!yearView\" class=\"fa fa-angle-down\"></i>\n                <i *ngIf=\"yearView\" class=\"fa fa-angle-up\"></i>\n            </div>\n        </div>\n        <table class=\"calendar-header\" [hidden]=\"yearView == true || monthsView == true\">\n            <tr>\n                <td class=\"calendar-header-day\">Su</td>\n                <td class=\"calendar-header-day\">Mo</td>\n                <td class=\"calendar-header-day\">Tu</td>\n                <td class=\"calendar-header-day\">We</td>\n                <td class=\"calendar-header-day\">Th</td>\n                <td class=\"calendar-header-day\">Fr</td>\n                <td class=\"calendar-header-day\">Sa</td>\n            </tr>\n        </table>\n        <div class=\"months-view\" [hidden]=\"!monthsView\" (click)=\"setMonth($event)\">\n            <span *ngFor=\"let month of settings.cal_months_labels_short\" [ngClass]=\"{'current-month': month == settings.cal_months_labels_short[date?.getMonth()]}\"\n                id=\"{{month}}\">{{month}}</span>\n        </div>\n        <div class=\"years-view\" *ngIf=\"yearView\">\n            <div class=\"fa fa-angle-left prev\" (click)=\"generateYearList('prev')\"></div>\n            <div class=\"fa fa-angle-right next\" (click)=\"generateYearList('next')\"></div>\n            <div class=\"years-list-view\" (click)=\"setYear($event)\">\n                <span *ngFor=\"let year of yearsList\" [ngClass]=\"{'current-year': year == date?.getFullYear()}\" id=\"{{year}}\">{{year}}</span>\n            </div>\n        </div>\n        <div class=\"time-view\" [hidden]=\"!timeView\">\n            <i class=\"fa fa-close time-close\" (click)=\"timeView = false\"></i>\n            <div class=\"time\">\n                <div class=\"hour\">\n                    <span class=\"fa fa-plus inc-btn\" (click)=\"incHour()\"></span>\n                    <input type=\"number\" value=\"{{hourValue}}\" [(ngModel)]=\"hourValue\" autofocus/>\n                    <span class=\"fa fa-minus dec-btn\" (click)=\"decHour()\"></span>\n                </div>\n                <div class=\"time-divider\">:</div>\n                <div class=\"minutes\">\n                    <span class=\"fa fa-plus inc-btn\" (click)=\"incMinutes()\"></span>\n                    <input type=\"number\" value=\"{{minValue}}\" [(ngModel)]=\"minValue\" />\n                    <span class=\"fa fa-minus dec-btn\" (click)=\"decMinutes()\"></span>\n                </div>\n            </div>\n            <div class=\"meridian\">\n                <div class=\"cuppa-btn-group\">\n                    <button [ngClass]=\"{'active': timeViewMeridian == 'AM'}\" class=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('AM')\">AM</button>\n                    <button [ngClass]=\"{'active': timeViewMeridian == 'PM'}\" class=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('PM')\">PM</button>\n                </div>\n            </div>\n            <div class=\"time-view-btn\">\n                <button class=\"button\" (click)=\"setTimeView()\">Set Time</button>\n            </div>\n        </div>\n        <table class=\"calendar-days\" (click)=\"setDay($event);\" [hidden]=\"monthsView || yearView\">\n            <tr *ngFor=\"let week of monthDays\">\n                <td [ngClass]=\"{'calendar-day': day.day != null,'today': day == today.getDate() && date?.getMonth() == today.getMonth() && date?.getFullYear() == today.getFullYear(),'selected-day': day.day == date?.getDate()}\"\n                    *ngFor=\"let day of week\">\n                    <span [attr.data-label]=\"composeDate(day.date)\">{{day.day}}</span>\n                </td>\n    \n            </tr>\n        </table>\n        <div class=\"cal-util\">\n            <div class=\"clock-icon\" *ngIf=\"!settings.bigBanner\">\n                <i class=\"fa fa-clock-o\" aria-hidden=\"true\" (click)=\"timeView = !timeView\"></i>\n            </div>\n            <div class=\"ok\" (click)=\"done()\"><i class=\"fa fa-check\"></i>Done\n            </div>\n        </div>\n    </div>\n    <span *ngIf=\"settings.rangepicker\">\n            <input type=\"hidden\" class=\"wc-input\" value=\"{{date}}\">\n    <div class=\"range-input\" (click)=\"togglePopover()\">\n            <div class=\"wc-date-container\" >\n                <span>{{dateRange?.startDate | date: settings.format}}</span>\n    <i class=\"fa fa-arrow-circle-o-right range-direc\"></i>\n    </div>\n    <div class=\"wc-date-container to-input\">\n        <span>{{dateRange?.endDate | date: settings.format}}</span>\n        <i class=\"fa fa-calendar\"></i>\n    </div>\n    </div>\n    </span>\n    <div *ngIf=\"settings.rangepicker\" class=\"range-date-popover\" [ngClass]=\"{'banner-true': settings.bigBanner == true}\" [hidden]=\"!popover\">\n        <div class=\"range-banner\">\n            <div class=\"wc-banner-col\" *ngIf=\"settings.bigBanner\">\n                <label>FROM</label>\n                <div class=\"wc-day\">\n                    {{dateRange.startDate | date: 'dd'}}\n                </div>\n                <div class=\"wc-my\">\n                    <div class=\"wc-month\">\n                        <div>\n                            {{dateRange.startDate | date: 'MMMM'}} {{dateRange.startDate | date: 'yyyy'}}\n                        </div>\n                    </div>\n                    <div class=\"wc-year\">\n                        <span>{{dateRange.startDate | date: 'EEEE'}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"wc-banner-col arrow-right\" *ngIf=\"settings.bigBanner\">\n                <i class=\"fa fa-angle-right\"></i>\n            </div>\n            <div class=\"wc-banner-col\" *ngIf=\"settings.bigBanner\">\n                <label>TO</label>\n                <div class=\"wc-day\">{{dateRange.endDate | date: 'dd'}}</div>\n                <div class=\"wc-my\">\n                    <div class=\"wc-month\">\n                        <div>\n                            {{dateRange.endDate | date: 'MMMM'}} {{dateRange.endDate | date: 'yyyy'}}\n                        </div>\n                    </div>\n                    <div class=\"wc-year\">\n                        <span>{{dateRange.endDate | date: 'EEEE'}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"dp-left-section\">\n            <div class=\"wc-details\">\n                <i class=\"wc-prev fa fa-angle-left\" (click)=\"prevMonth($event)\"></i>\n                <div class=\"month-year\" *ngIf=\"settings.bigBanner\" (click)=\"toggleMonthView()\">{{leftDate | date: 'MMMM'}}\n                    <!-- <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\"></i>\n                                     <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\"></i> -->\n                </div>\n                <div class=\"month-year\" *ngIf=\"!settings.bigBanner\" (click)=\"toggleMonthView()\">\n                    {{leftDate | date: 'MMMM'}}\n                    <!--    <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\" (click)=\"toggleMonthView()\"></i>\n                                        <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\" (click)=\"toggleMonthView()\"></i>  -->\n    \n                </div>\n                <i class=\"wc-next fa fa-angle-right\" (click)=\"nextMonth($event)\"></i>\n            </div>\n            <div class=\"year-title\">\n                <div class=\"year-dropdown\" (click)=\"generateYearList('current')\">\n                    {{leftDate | date: 'yyyy'}}\n                    <i *ngIf=\"!yearView\" class=\"fa fa-angle-down\"></i>\n                    <i *ngIf=\"yearView\" class=\"fa fa-angle-up\"></i>\n                </div>\n            </div>\n            <table class=\"calendar-header\" [hidden]=\"yearView == true || monthsView == true\">\n                <tr>\n                    <td class=\"calendar-header-day\">Su</td>\n                    <td class=\"calendar-header-day\">Mo</td>\n                    <td class=\"calendar-header-day\">Tu</td>\n                    <td class=\"calendar-header-day\">We</td>\n                    <td class=\"calendar-header-day\">Th</td>\n                    <td class=\"calendar-header-day\">Fr</td>\n                    <td class=\"calendar-header-day\">Sa</td>\n                </tr>\n            </table>\n            <div class=\"months-view\" [hidden]=\"!monthsView\" (click)=\"setMonth($event)\">\n                <span *ngFor=\"let month of settings.cal_months_labels_short\" [ngClass]=\"{'current-month': month == settings.cal_months_labels_short[dateRange.startDate?.getMonth()]}\"\n                    id=\"{{month}}\">{{month}}</span>\n            </div>\n            <div class=\"years-view\" *ngIf=\"yearView\">\n                <div class=\"fa fa-angle-left prev\" (click)=\"generateYearList('prev')\"></div>\n                <div class=\"fa fa-angle-right next\" (click)=\"generateYearList('next')\"></div>\n                <div class=\"years-list-view\" (click)=\"setYear($event)\">\n                    <span *ngFor=\"let year of yearsList\" [ngClass]=\"{'current-year': year == dateRange.startDate?.getFullYear()}\" id=\"{{year}}\">{{year}}</span>\n                </div>\n            </div>\n            <div class=\"time-view\" [hidden]=\"!timeView\">\n                <div class=\"time\">\n                    <div class=\"hour\">\n                        <span class=\"fa fa-plus inc-btn\" (click)=\"incHour()\"></span>\n                        <input type=\"number\" value=\"{{hourValue}}\" [(ngModel)]=\"hourValue\" autofocus/>\n                        <span class=\"fa fa-minus dec-btn\" (click)=\"decHour()\"></span>\n                    </div>\n                    <div class=\"time-divider\">:</div>\n                    <div class=\"minutes\">\n                        <span class=\"fa fa-plus inc-btn\" (click)=\"incMinutes()\"></span>\n                        <input type=\"number\" value=\"{{minValue}}\" [(ngModel)]=\"minValue\" />\n                        <span class=\"fa fa-minus dec-btn\" (click)=\"decMinutes()\"></span>\n                    </div>\n                </div>\n                <div class=\"meridian\">\n                    <div class=\"cuppa-btn-group\">\n                        <button [ngClass]=\"{'active': timeViewMeridian == 'AM'}\" class=\"button\" type=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('AM')\">AM</button>\n                        <button [ngClass]=\"{'active': timeViewMeridian == 'PM'}\" class=\"button\" type=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('PM')\">PM</button>\n                    </div>\n                </div>\n                <div class=\"time-view-btn\">\n                    <button class=\"button\" type=\"button\" (click)=\"setTimeView()\">Set Time</button>\n                </div>\n            </div>\n            <table class=\"calendar-days\" (click)=\"setDay($event,'range');\" [hidden]=\"monthsView || yearView\">\n                <tr *ngFor=\"let week of monthDays\">\n                    <td [ngClass]=\"{'range-highlight':highlightRange(day.date),'calendar-day': day.day != null,'today': day.day == today.getDate() && dateRange.startDate?.getMonth() == today.getMonth() && dateRange.startDate?.getFullYear() == today.getFullYear(),'selected-day': day.date.toString() == dateRange.startDate.toString() || day.date.toString() == dateRange.endDate.toString()}\"\n                        *ngFor=\"let day of week\">\n                        <span [attr.data-label]=\"composeDate(day.date)\">{{day.day}}</span>\n                    </td>\n    \n                </tr>\n            </table>\n        </div>\n    \n        <div class=\"dp-right-section\">\n            <div class=\"wc-details\">\n                <i class=\"wc-prev fa fa-angle-left\" (click)=\"prevMonth($event)\"></i>\n                <div class=\"month-year\" *ngIf=\"settings.bigBanner\" (click)=\"toggleMonthView()\">{{rightDate | date: 'MMMM'}}\n                    <!-- <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\"></i>\n                                     <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\"></i> -->\n                </div>\n                <div class=\"month-year\" *ngIf=\"!settings.bigBanner\" (click)=\"toggleMonthView()\">\n                    {{rightDate | date: 'MMMM'}}\n                    <!--    <i ng-show=\"!monthsView\" class=\"fa fa-arrow-down\" (click)=\"toggleMonthView()\"></i>\n                                        <i ng-show=\"monthsView\" class=\"fa fa-arrow-up\" (click)=\"toggleMonthView()\"></i>  -->\n    \n                </div>\n                <i class=\"wc-next fa fa-angle-right\" (click)=\"nextMonth($event)\"></i>\n            </div>\n            <div class=\"year-title\">\n                <div class=\"year-dropdown\" (click)=\"generateYearList('current')\">\n                    {{rightDate | date: 'yyyy'}}\n                    <i *ngIf=\"!yearView\" class=\"fa fa-angle-down\"></i>\n                    <i *ngIf=\"yearView\" class=\"fa fa-angle-up\"></i>\n                </div>\n            </div>\n            <table class=\"calendar-header\" [hidden]=\"yearView == true || monthsView == true\">\n                <tr>\n                    <td class=\"calendar-header-day\">Su</td>\n                    <td class=\"calendar-header-day\">Mo</td>\n                    <td class=\"calendar-header-day\">Tu</td>\n                    <td class=\"calendar-header-day\">We</td>\n                    <td class=\"calendar-header-day\">Th</td>\n                    <td class=\"calendar-header-day\">Fr</td>\n                    <td class=\"calendar-header-day\">Sa</td>\n                </tr>\n            </table>\n            <div class=\"months-view\" [hidden]=\"!monthsView\" (click)=\"setMonth($event)\">\n                <span *ngFor=\"let month of settings.cal_months_labels_short\" [ngClass]=\"{'current-month': month == settings.cal_months_labels_short[date?.getMonth()]}\"\n                    id=\"{{month}}\">{{month}}</span>\n            </div>\n            <div class=\"years-view\" *ngIf=\"yearView\">\n                <div class=\"fa fa-angle-left prev\" (click)=\"generateYearList('prev')\"></div>\n                <div class=\"fa fa-angle-right next\" (click)=\"generateYearList('next')\"></div>\n                <div class=\"years-list-view\" (click)=\"setYear($event)\">\n                    <span *ngFor=\"let year of yearsList\" [ngClass]=\"{'current-year': year == date?.getFullYear()}\" id=\"{{year}}\">{{year}}</span>\n                </div>\n            </div>\n            <div class=\"time-view\" [hidden]=\"!timeView\">\n                <div class=\"time\">\n                    <div class=\"hour\">\n                        <span class=\"fa fa-plus inc-btn\" (click)=\"incHour()\"></span>\n                        <input type=\"number\" value=\"{{hourValue}}\" [(ngModel)]=\"hourValue\" autofocus/>\n                        <span class=\"fa fa-minus dec-btn\" (click)=\"decHour()\"></span>\n                    </div>\n                    <div class=\"time-divider\">:</div>\n                    <div class=\"minutes\">\n                        <span class=\"fa fa-plus inc-btn\" (click)=\"incMinutes()\"></span>\n                        <input type=\"number\" value=\"{{minValue}}\" [(ngModel)]=\"minValue\" />\n                        <span class=\"fa fa-minus dec-btn\" (click)=\"decMinutes()\"></span>\n                    </div>\n                </div>\n                <div class=\"meridian\">\n                    <div class=\"cuppa-btn-group\">\n                        <button [ngClass]=\"{'active': timeViewMeridian == 'AM'}\" type=\"button\" class=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('AM')\">AM</button>\n                        <button [ngClass]=\"{'active': timeViewMeridian == 'PM'}\" type=\"button\" class=\"button\" ng-model=\"timeViewMeridian\" (click)=\"toggleMeridian('PM')\">PM</button>\n                    </div>\n                </div>\n                <div class=\"time-view-btn\">\n                    <button class=\"button\" (click)=\"setTimeView()\">Set Time</button>\n                </div>\n            </div>\n            <table class=\"calendar-days\" (click)=\"setDay($event,'range');\" [hidden]=\"monthsView || yearView\">\n                <tr *ngFor=\"let week of toMonthDays\">\n                    <td [ngClass]=\"{'range-highlight':highlightRange(day.date),'calendar-day': day != null,'today': day == today.getDate() && dateRange.endDate?.getMonth() == today.getMonth() && dateRange.endDate?.getFullYear() == today.getFullYear(),'selected-day': day.date.toString() == dateRange.startDate.toString() || day.date.toString() == dateRange.endDate.toString()}\"\n                        *ngFor=\"let day of week\">\n                        <span [attr.data-label]=\"composeDate(day.date)\">{{day.day}}</span>\n                    </td>\n    \n                </tr>\n            </table>\n        </div>\n        <div class=\"cal-util\">\n            <ul class=\"util-list\">\n                <li><a>Last week</a></li>\n                <li><a (click)=\"getCurrentWeek()\">Current week</a></li>\n                <li><a>Next week</a></li>\n            </ul>\n            <button class=\"button btn-xs\" type=\"button\" (click)=\"done()\"><i class=\"fa fa-check\"></i>Done</button>\n        </div>\n    </div>",
                        providers: [DATEPICKER_CONTROL_VALUE_ACCESSOR],
                        styles: ["@import url(\"https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700\");\n* {\n  box-sizing: border-box; }\n\n#cuppaDatePickerContainer, #cuppaDatePicker {\n  width: 250px;\n  text-align: center;\n  margin: 0px auto;\n  font-family: 'Roboto','Arial',sans-serif; }\n\n.year-dropdown {\n  text-align: center; }\n\n.calendar-header {\n  color: #333;\n  background: #fff; }\n\n.wc-date-container {\n  float: left;\n  width: 100%;\n  height: 30px;\n  border: 1px solid #1565c0;\n  margin-bottom: 1px;\n  font-size: 16px;\n  padding: 5px;\n  text-align: left;\n  cursor: pointer;\n  background: #fff;\n  line-height: 20px; }\n\n.wc-date-container > span {\n  color: #1565c0; }\n\n.wc-date-container > i {\n  float: right;\n  font-size: 20px;\n  color: #1565c0; }\n\n.winkel-calendar {\n  position: relative;\n  font-family: 'Roboto','Arial',sans-serif; }\n\n.wc-date-popover {\n  font-size: 14px;\n  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4);\n  margin: 0px auto;\n  perspective: 1000px;\n  float: left;\n  background: #fff;\n  background: #ffffff;\n  position: fixed;\n  width: 90%;\n  top: 5%;\n  left: 50%;\n  z-index: 9999999;\n  overflow: hidden;\n  height: 90%;\n  max-width: 320px;\n  transition: all .5s linear;\n  transform: translateX(-50%); }\n\n.wc-banner {\n  /* background: #3ce5ed; */\n  float: left;\n  width: 100%;\n  font-size: 54px;\n  background: #1565c0; }\n\n.wc-day-row {\n  padding: 5px 0px;\n  /*background: rgba(0, 0, 0, 0.09);*/\n  color: #ffffff;\n  width: 100%;\n  float: left;\n  font-size: 3vh;\n  text-align: center; }\n\n.wc-date-row {\n  display: inline-block;\n  font-size: 25vw;\n  color: #ffffff;\n  padding: 5px;\n  width: 50%;\n  float: left;\n  text-align: right;\n  font-weight: 200; }\n\n.wc-month-row {\n  padding: 25px 0px 0px 0px;\n  font-size: 8vw;\n  color: #ffffff;\n  width: 100%;\n  float: left; }\n\n.wc-month-row > i, .wc-year-row > i {\n  float: right;\n  font-size: 12px;\n  padding: 10px 6px;\n  cursor: pointer; }\n\n.wc-month-row > i:hover, .wc-year-row > i:hover {\n  color: rgba(255, 255, 255, 0.63); }\n\n.wc-year-row {\n  text-align: left;\n  color: #ffffff;\n  font-size: 7vw;\n  float: left;\n  width: 100%;\n  padding: 2px 0px 0px 0px; }\n\n.timepicker-true .wc-year-row {\n  font-size: 20px;\n  padding: 5px 0px 0px 12px; }\n\n.timestate > .active {\n  color: #fff; }\n\n.timestate span {\n  cursor: pointer; }\n\n.wc-my-sec {\n  display: inline-block;\n  padding: 5px 10px;\n  float: left;\n  width: 50%;\n  font-weight: 300; }\n\n.timepicker-true .wc-my-sec {\n  width: 20%; }\n\n.time i {\n  font-size: 21px;\n  display: block;\n  text-align: center;\n  cursor: pointer; }\n\n.time i:hover {\n  color: rgba(255, 255, 255, 0.65); }\n\n.time > .hour, .time > .minutes {\n  float: left;\n  width: 48%;\n  text-align: center; }\n\n.wc-month-row > div:nth-child(1), .wc-year-row > div:nth-child(1) {\n  float: left;\n  text-align: left; }\n\n.wc-time-sec {\n  color: #ffffff;\n  text-align: center;\n  padding: 0px 10px 10px;\n  float: left;\n  width: 100%; }\n\n.wc-time-sec > .time {\n  font-size: 38px;\n  font-weight: 300;\n  width: 100%;\n  text-align: center;\n  float: left; }\n\n.time-divider {\n  width: 4%;\n  float: left;\n  text-align: center;\n  padding: 0px 10px; }\n\n.time-view {\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  z-index: 1;\n  top: 40px;\n  padding: 35px;\n  border-top: 1px solid #1565c0; }\n\n.time-view-btn {\n  text-align: center; }\n\n.meridian {\n  text-align: center;\n  padding: 15px 0px; }\n\n.button {\n  width: 100%;\n  padding: 10px;\n  background: #1565c0;\n  color: #fff;\n  margin: 0px auto;\n  border: 1px solid #1565c0;\n  border-radius: 3px;\n  cursor: pointer; }\n\n.button-sm {\n  width: 50%; }\n\n.time-view .time {\n  font-size: 36px;\n  width: 100%;\n  margin: 0px auto;\n  display: inline-block;\n  padding: 5px 0px 0px 0px;\n  color: #1565c0;\n  font-weight: 300; }\n\n.time-view .time-divider {\n  padding: 16px 0; }\n\n.wc-time-sec .time input, .time-view .time input {\n  display: inline-block;\n  width: 100%;\n  background: none;\n  border: none;\n  text-align: center;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 32px;\n  font-weight: 300;\n  padding: 0px 10px;\n  text-align: center;\n  color: #1565c0; }\n\n.inc-btn, .dec-btn {\n  font-size: 14px;\n  display: block;\n  color: #8e8e8e; }\n\n.wc-time-sec > .time > .timestate {\n  float: left;\n  padding: 0px 10px; }\n\n.show-time-picker .wc-date-row {\n  width: 33% !important; }\n\n.show-time-picker .wc-my-sec {\n  width: 22% !important; }\n\n.wc-month-controls > .fa:hover, .wc-year-controls > .fa:hover {\n  color: #fff; }\n\n.wc-details > .fa:hover {\n  color: #ccc; }\n\n.wc-month-controls {\n  padding: 5px;\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.71);\n  float: right; }\n\n.wc-year-controls {\n  padding: 2px 5px 0px 5px;\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.71);\n  float: right; }\n\n.wc-year-controls > .fa, .wc-month-controls > .fa {\n  cursor: pointer;\n  padding: 0px 4px; }\n\n.wc-details {\n  float: left;\n  width: 65%;\n  padding: 10px 0px 10px;\n  color: #ffffff;\n  background: #1565c0; }\n\n.banner-true > .wc-details {\n  padding: 10px 0px 10px; }\n\n.wc-prev {\n  float: left;\n  width: 25%;\n  text-align: left;\n  padding: 0px 15px;\n  cursor: pointer;\n  font-size: 35px; }\n\n.month-year {\n  float: left;\n  width: 50%;\n  font-size: 18px;\n  line-height: 35px;\n  text-align: center; }\n\n.wc-next {\n  float: right;\n  width: 25%;\n  text-align: right;\n  padding: 0px 15px;\n  cursor: pointer;\n  font-size: 35px; }\n\n.calendar-days {\n  color: #07c;\n  background: #fff; }\n\n.cal-util {\n  width: 100%;\n  float: left;\n  position: absolute;\n  bottom: 0;\n  background: #fff;\n  border-top: 1px solid #f2f2f2; }\n\n.cal-util > .ok {\n  width: 100%;\n  padding: 5px;\n  float: left;\n  color: #1565c0;\n  font-size: 18px;\n  border-top: 1px solid #d1d1d1;\n  text-align: center;\n  cursor: pointer; }\n\n.ok > i {\n  margin-right: 5px; }\n\n.cal-util > .cancel {\n  width: 50%;\n  float: left;\n  padding: 10px;\n  color: #1565c0;\n  font-size: 20px; }\n\n.cal-util > .ok:hover, .cal-util > .cancel:hover {\n  box-shadow: inset 0px 0px 20px #ccc; }\n\n.range-date-popover .cal-util {\n  padding: 10px; }\n\n.range-date-popover .cal-util .btn-xs {\n  float: right; }\n\n.btn-xs {\n  padding: 5px 10px;\n  width: auto; }\n\n.today > span {\n  border: 1px solid #1565c0;\n  background: none; }\n\n.selected-day > span {\n  /*background: #3ce5ed;*/\n  background: #1565c0;\n  color: #fff; }\n\n.calendar-days td {\n  cursor: pointer; }\n\n.calendar-day:hover > span {\n  background: #1565c0;\n  color: #fff; }\n\n.winkel-calendar table {\n  width: 100%;\n  text-align: center;\n  font-size: 18px;\n  border-collapse: collapse; }\n\n.winkel-calendar table td {\n  padding: 0px 0px;\n  width: calc((100%)/7);\n  text-align: center;\n  transition: all .1s linear; }\n\n.winkel-calendar table td span {\n  display: block;\n  padding: 7px;\n  margin: 0px;\n  line-height: 32px; }\n\n.calendar-header td {\n  padding: 5px 0px !important; }\n\n.months-view, .years-view {\n  background: #fff;\n  width: 100%;\n  top: 210px;\n  width: 100%;\n  height: calc(100% - 210px);\n  bottom: 0;\n  text-align: center; }\n\n.years-list-view {\n  float: left;\n  width: calc(100% - 60px);\n  height: 100%; }\n\n.months-view > span, .years-list-view > span {\n  display: inline-block;\n  width: 25%;\n  padding: 25px 0px;\n  cursor: pointer;\n  font-size: 16px; }\n\n.years-list-view > span {\n  width: 33.3333%; }\n\n.years-view > .prev, .years-view > .next {\n  float: left;\n  width: 30px;\n  padding: 85px 0px;\n  cursor: pointer;\n  font-size: 52px; }\n\n.years-view > .prev:hover, .years-view > .next:hover {\n  color: #ccc; }\n\n.years-view > .next {\n  float: right; }\n\n.current-month, .current-year {\n  color: #1565c0; }\n\n.years-view > span {\n  width: 33.3333%; }\n\n.months-view > span:hover, .years-list-view > span:hover {\n  color: #1565c0; }\n\n.banner-true {\n  padding-top: 0px !important; }\n\n.banner-true > .wc-banner {\n  margin-bottom: 0px !important; }\n\n.banner-true > .time-view {\n  height: calc(100% - 124px);\n  top: 142px; }\n\n.methods {\n  clear: left;\n  padding: 50px 0px;\n  text-align: center; }\n\n.month-year i {\n  cursor: pointer;\n  font-size: 10px; }\n\n.timepicker-true .wc-month-row {\n  font-size: 28px;\n  padding: 5px 0px 5px 15px; }\n\n.timepicker-true .wc-month-row > i, .wc-year-row > i {\n  padding: 8px 6px; }\n\n.timepicker-true .wc-my-sec {\n  padding: 16px 2px; }\n\n.timepicker-true .wc-time-sec {\n  width: 48%;\n  padding: 25px 0px;\n  margin: 0px;\n  cursor: pointer; }\n\n.timepicker-true .wc-time-sec:hover {\n  color: rgba(255, 255, 255, 0.65); }\n\n.timepicker-true .wc-time-sec > .time {\n  width: 75%;\n  cursor: pointer; }\n\n.timepicker-true .time i {\n  display: none; }\n\n.timepicker-true .time-divider {\n  padding: 0px; }\n\n.timepicker-true .timestate {\n  padding: 0px;\n  width: auto;\n  padding-top: 7px;\n  font-size: 20px;\n  font-weight: 300; }\n\n.year-title {\n  width: 35%;\n  float: left;\n  line-height: 55px;\n  font-size: 18px;\n  color: #ffffff;\n  background: #1565c0; }\n\n.year-title i {\n  float: right;\n  padding: 13px 10px 7px 0px;\n  font-size: 28px; }\n\n@media (min-width: 365px) and (max-width: 767px) {\n  .timepicker-true .wc-date-row {\n    width: 54%;\n    padding: 20px 5px 10px; }\n  .timepicker-true .wc-my-sec {\n    padding: 33px 2px 10px;\n    width: 46%; }\n  .timepicker-true .wc-time-sec {\n    width: 100%;\n    padding: 0px 0px 15px 0px; }\n  .timepicker-true .wc-time-sec > .time {\n    width: 35%;\n    float: none;\n    margin: 0px auto;\n    font-size: 42px; }\n  .timepicker-true .wc-month-row {\n    font-size: 42px;\n    padding: 5px 0px 5px 5px; }\n  .timepicker-true .wc-year-row {\n    font-size: 24px;\n    padding: 15px 0px 0px 5px; }\n  .timepicker-true .timestate {\n    font-size: 22px;\n    font-weight: 100; }\n  .months-view, .years-view {\n    top: 297px; }\n  .banner-true > .time-view {\n    top: 240px; }\n  .time-view .time {\n    font-size: 62px; }\n  .cuppa-btn-group {\n    font-size: 22px;\n    font-weight: 300; }\n  .angular-range-slider {\n    height: 5px;\n    margin: 20px auto 25px auto; }\n  .angular-range-slider div.handle {\n    width: 45px;\n    height: 45px;\n    top: -20px;\n    font-size: 26px; }\n  .time-view-btn {\n    padding: 25px 0px; }\n  .button-sm {\n    width: 80%;\n    padding: 10px;\n    font-size: 16px; }\n  .cuppa-btn-group > .button {\n    padding: 5px 15px !important; } }\n\n@media (min-width: 768px) {\n  .wc-date-popover {\n    width: 250px;\n    position: absolute;\n    top: 31px;\n    height: auto;\n    left: 0;\n    transform: translateX(0); }\n  .wc-day-row {\n    padding: 5px 0px;\n    font-size: 0.25em; }\n  .wc-date-row {\n    font-size: 1em;\n    padding: 5px; }\n  .wc-my-sec {\n    padding: 5px 0px; }\n  .timepicker-true .wc-my-sec {\n    padding: 15px 3px; }\n  .wc-month-row {\n    padding: 10px 0px 0px 0px;\n    font-size: 0.4em; }\n  .wc-year-row {\n    font-size: 0.3em;\n    padding: 0px; }\n  .month-year {\n    font-size: 14px;\n    line-height: 20px;\n    cursor: pointer; }\n  .wc-prev, .wc-next {\n    font-size: 18px; }\n  .wc-details {\n    padding: 10px 0px 10px; }\n  .year-title {\n    line-height: 40px;\n    font-size: 16px; }\n  .year-title i {\n    padding: 11px 10px 10px 0px;\n    font-size: 18px; }\n  .calendar-header td {\n    padding: 5px 0px !important; }\n  .winkel-calendar table {\n    font-size: 14px; }\n  .winkel-calendar table td span {\n    line-height: 24px;\n    width: 35px;\n    height: 35px; }\n  .months-view, .years-view {\n    top: 40px;\n    width: 100%;\n    height: calc(100%); }\n  .banner-true .months-view, .banner-true .years-view {\n    top: 165px;\n    height: calc(100% - 128px); }\n  .winkel-calendar table td span {\n    padding: 6px; }\n  .cal-util > .ok {\n    font-size: 14px;\n    padding: 10px; }\n  .wc-time-sec > .time {\n    font-size: 0.35em;\n    cursor: pointer; }\n  .time i {\n    font-size: 10px; }\n  .wc-time-sec > .timestate {\n    font-size: 16px; }\n  .wc-month-row > div:nth-child(1), .wc-year-row > div:nth-child(1) {\n    min-width: 35px; }\n  .wc-month-row > i, .wc-year-row > i {\n    font-size: 8px; }\n  .cal-util {\n    position: relative; }\n  .banner-true > .time-view {\n    top: 159px; }\n  .timepicker-true .wc-month-row {\n    padding: 6px 0px 0px 0px;\n    font-size: 18px; }\n  .timepicker-true .wc-year-row {\n    padding: 0px 0px 0px 0px;\n    font-size: 16px; } }\n\n.time-view h5 {\n  text-align: left;\n  width: 80%;\n  margin: 0px auto;\n  padding: 5px 0px;\n  font-weight: 400; }\n\n.cuppa-btn-group {\n  display: inline-flex; }\n\n.cuppa-btn-group > .active {\n  background: #1565c0 !important;\n  color: #fff !important; }\n\n.cuppa-btn-group > .button {\n  border: 1px solid #1565c0;\n  background: #fff;\n  border-radius: 3px;\n  float: left;\n  margin: 0px;\n  align-items: initial;\n  color: #1565c0;\n  width: auto;\n  padding: 5px 10px; }\n\n.cuppa-btn-group > .button:first-child {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  border-right: 0px; }\n\n.cuppa-btn-group > .button:last-child {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px; }\n\n/* Slider CSS*/\n.slider {\n  width: 200px;\n  height: 5px;\n  background: #ccc;\n  border-radius: 5px;\n  margin: 12px auto;\n  position: relative; }\n\n.slider > .circle {\n  width: 20px;\n  height: 20px;\n  background: #fff;\n  position: absolute;\n  top: -8px;\n  border-radius: 20px;\n  left: 60px;\n  box-shadow: 0px 0px 5px #ccc;\n  cursor: pointer; }\n\ninput[type='number'] {\n  -moz-appearance: textfield; }\n\n/* Webkit browsers like Safari and Chrome */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n.range-highlight {\n  background: #f2f2f2; }\n\n.clock-icon {\n  text-align: center;\n  color: #1565c0; }\n\n.time-close {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  cursor: pointer; }\n\n.util-list {\n  list-style: none;\n  float: left;\n  padding: 0px;\n  margin: 0px; }\n\n.util-list li {\n  float: left;\n  padding: 5px; }\n\n.util-list li a {\n  color: #007bff;\n  cursor: pointer; }\n\n.util-list li a:hover {\n  color: #14569d;\n  text-decoration: underline; }\n", ".range-banner {\n  background: #ffffff;\n  width: 100%;\n  float: left;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding: 25px 15px 10px 15px; }\n\n.range-input {\n  display: flex;\n  flex-direction: row;\n  min-width: 275px; }\n\n.wc-date-container {\n  position: relative; }\n\n.range-direc {\n  position: absolute;\n  right: -8px;\n  background: #fff;\n  z-index: 1;\n  color: #ccc !important;\n  font-size: 16px !important;\n  top: 6px; }\n\n.to-input {\n  padding-left: 15px; }\n\n.arrow-right {\n  padding: 0px 20px; }\n\n.arrow-right .fa {\n  font-size: 2em;\n  color: #1565c0; }\n\n.wc-banner-col {\n  /*flex-grow: 1;*/\n  display: flex;\n  color: #1565c0;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  position: relative; }\n\n.wc-banner-col label {\n  width: 100%;\n  text-align: left;\n  margin: 0px;\n  position: absolute;\n  top: -18px;\n  color: #888888; }\n\n.wc-day {\n  font-size: 3em;\n  font-weight: 300;\n  padding-right: 5px; }\n\n.wc-my {\n  display: flex;\n  align-items: baseline;\n  flex-direction: column; }\n\n.wc-month {\n  font-size: 1.2em;\n  margin-top: -5px;\n  color: #888888; }\n\n.wc-year {\n  font-size: 0.9em;\n  font-weight: 300;\n  margin-top: -1px;\n  color: #6e6e6e; }\n\n.dp-left-section, .dp-right-section {\n  border-top: 1px solid #fff; }\n\n.dp-left-section {\n  border-right: 1px solid #ccc; }\n\n.range-date-popover {\n  border: 1px solid #1565c0;\n  background: #fff; }\n\n@media (min-width: 768px) {\n  .range-banner .wc-banner {\n    width: 30%; }\n  .range-date-popover {\n    width: 500px;\n    position: absolute;\n    top: 31px;\n    height: auto;\n    right: 0;\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n    z-index: 99999; }\n  .dp-left-section, .dp-right-section {\n    float: left;\n    width: 50%; } }\n"]
                    }] }
        ];
        /** @nocollapse */
        DatePicker.ctorParameters = function () { return []; };
        DatePicker.propDecorators = {
            "settings": [{ type: core.Input },],
            "onDateSelect": [{ type: core.Output },],
        };
        return DatePicker;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var ClickOutsideDirective = /** @class */ (function () {
        function ClickOutsideDirective(_elementRef) {
            this._elementRef = _elementRef;
            this.clickOutside = new core.EventEmitter();
        }
        /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        ClickOutsideDirective.prototype.onClick = /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        function (event, targetElement) {
            if (!targetElement) {
                return;
            }
            var /** @type {?} */ clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.clickOutside.emit(event);
            }
        };
        ClickOutsideDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[clickOutside]'
                    },] }
        ];
        /** @nocollapse */
        ClickOutsideDirective.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        ClickOutsideDirective.propDecorators = {
            "clickOutside": [{ type: core.Output },],
            "onClick": [{ type: core.HostListener, args: ['document:click', ['$event', '$event.target'],] },],
        };
        return ClickOutsideDirective;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var AngularDateTimePickerModule = /** @class */ (function () {
        function AngularDateTimePickerModule() {
        }
        AngularDateTimePickerModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, FormsModule],
                        declarations: [DatePicker, ClickOutsideDirective],
                        exports: [DatePicker, FormsModule, ClickOutsideDirective]
                    },] }
        ];
        return AngularDateTimePickerModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var MyException = /** @class */ (function () {
        function MyException(status, body) {
            this.status = status;
            this.body = body;
        }
        return MyException;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var ClickOutsideDirective$1 = /** @class */ (function () {
        function ClickOutsideDirective(_elementRef) {
            this._elementRef = _elementRef;
            this.clickOutside = new core.EventEmitter();
        }
        /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        ClickOutsideDirective.prototype.onClick = /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        function (event, targetElement) {
            if (!targetElement) {
                return;
            }
            var /** @type {?} */ clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.clickOutside.emit(event);
            }
        };
        ClickOutsideDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[clickOutside]'
                    },] }
        ];
        /** @nocollapse */
        ClickOutsideDirective.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        ClickOutsideDirective.propDecorators = {
            "clickOutside": [{ type: core.Output },],
            "onClick": [{ type: core.HostListener, args: ['document:click', ['$event', '$event.target'],] }, { type: core.HostListener, args: ['document:touchstart', ['$event', '$event.target'],] },],
        };
        return ClickOutsideDirective;
    }());
    var ScrollDirective = /** @class */ (function () {
        function ScrollDirective(_elementRef) {
            this._elementRef = _elementRef;
            this.scroll = new core.EventEmitter();
        }
        /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        ScrollDirective.prototype.onClick = /**
         * @param {?} event
         * @param {?} targetElement
         * @return {?}
         */
        function (event, targetElement) {
            this.scroll.emit(event);
        };
        ScrollDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[scroll]'
                    },] }
        ];
        /** @nocollapse */
        ScrollDirective.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        ScrollDirective.propDecorators = {
            "scroll": [{ type: core.Output },],
            "onClick": [{ type: core.HostListener, args: ['scroll', ['$event'],] },],
        };
        return ScrollDirective;
    }());
    var styleDirective = /** @class */ (function () {
        function styleDirective(el) {
            this.el = el;
        }
        /**
         * @return {?}
         */
        styleDirective.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.top = this.styleVal;
        };
        /**
         * @return {?}
         */
        styleDirective.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.top = this.styleVal;
        };
        styleDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[styleProp]'
                    },] }
        ];
        /** @nocollapse */
        styleDirective.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        styleDirective.propDecorators = {
            "styleVal": [{ type: core.Input, args: ['styleProp',] },],
        };
        return styleDirective;
    }());
    var setPosition = /** @class */ (function () {
        function setPosition(el) {
            this.el = el;
        }
        /**
         * @return {?}
         */
        setPosition.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            if (this.height) {
                this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
            }
        };
        /**
         * @return {?}
         */
        setPosition.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            if (this.height) {
                this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
            }
        };
        setPosition.decorators = [
            { type: core.Directive, args: [{
                        selector: '[setPosition]'
                    },] }
        ];
        /** @nocollapse */
        setPosition.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        setPosition.propDecorators = {
            "height": [{ type: core.Input, args: ['setPosition',] },],
        };
        return setPosition;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var ListFilterPipe = /** @class */ (function () {
        function ListFilterPipe() {
        }
        /**
         * @param {?} items
         * @param {?} filter
         * @param {?} searchBy
         * @return {?}
         */
        ListFilterPipe.prototype.transform = /**
         * @param {?} items
         * @param {?} filter
         * @param {?} searchBy
         * @return {?}
         */
        function (items, filter, searchBy) {
            var _this = this;
            if (!items || !filter) {
                return items;
            }
            return items.filter(function (item) { return _this.applyFilter(item, filter, searchBy); });
        };
        /**
         * @param {?} item
         * @param {?} filter
         * @param {?} searchBy
         * @return {?}
         */
        ListFilterPipe.prototype.applyFilter = /**
         * @param {?} item
         * @param {?} filter
         * @param {?} searchBy
         * @return {?}
         */
        function (item, filter, searchBy) {
            var /** @type {?} */ found = false;
            if (searchBy.length > 0) {
                for (var /** @type {?} */ t = 0; t < searchBy.length; t++) {
                    if (filter && item[searchBy[t]] && item[searchBy[t]] != "") {
                        if (item[searchBy[t]].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                            found = true;
                        }
                    }
                }
            }
            else {
                for (var /** @type {?} */ prop in item) {
                    if (filter && item[prop]) {
                        if (item[prop].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                            found = true;
                        }
                    }
                }
            }
            return found;
        };
        ListFilterPipe.decorators = [
            { type: core.Pipe, args: [{
                        name: 'listFilter',
                        pure: false
                    },] }
        ];
        return ListFilterPipe;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var Item = /** @class */ (function () {
        function Item() {
        }
        Item.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-item',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        Item.ctorParameters = function () { return []; };
        Item.propDecorators = {
            "template": [{ type: core.ContentChild, args: [core.TemplateRef,] },],
        };
        return Item;
    }());
    var Badge = /** @class */ (function () {
        function Badge() {
        }
        Badge.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-badge',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        Badge.ctorParameters = function () { return []; };
        Badge.propDecorators = {
            "template": [{ type: core.ContentChild, args: [core.TemplateRef,] },],
        };
        return Badge;
    }());
    var Search = /** @class */ (function () {
        function Search() {
        }
        Search.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-search',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        Search.ctorParameters = function () { return []; };
        Search.propDecorators = {
            "template": [{ type: core.ContentChild, args: [core.TemplateRef,] },],
        };
        return Search;
    }());
    var TemplateRenderer = /** @class */ (function () {
        function TemplateRenderer(viewContainer) {
            this.viewContainer = viewContainer;
        }
        /**
         * @return {?}
         */
        TemplateRenderer.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.view = this.viewContainer.createEmbeddedView(this.data.template, {
                '\$implicit': this.data,
                'item': this.item
            });
        };
        /**
         * @return {?}
         */
        TemplateRenderer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.view.destroy();
        };
        TemplateRenderer.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-templateRenderer',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        TemplateRenderer.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        TemplateRenderer.propDecorators = {
            "data": [{ type: core.Input },],
            "item": [{ type: core.Input },],
        };
        return TemplateRenderer;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    // import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
    var /** @type {?} */ DROPDOWN_CONTROL_VALUE_ACCESSOR = {
        provide: NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return AngularMultiSelect; }),
        multi: true
    };
    var /** @type {?} */ DROPDOWN_CONTROL_VALIDATION = {
        provide: NG_VALIDATORS,
        useExisting: core.forwardRef(function () { return AngularMultiSelect; }),
        multi: true,
    };
    var /** @type {?} */ noop = function () {
    };
    var AngularMultiSelect = /** @class */ (function () {
        function AngularMultiSelect(_elementRef, cdr) {
            this._elementRef = _elementRef;
            this.cdr = cdr;
            this.onSelect = new core.EventEmitter();
            this.onDeSelect = new core.EventEmitter();
            this.onSelectAll = new core.EventEmitter();
            this.onDeSelectAll = new core.EventEmitter();
            this.onOpen = new core.EventEmitter();
            this.onClose = new core.EventEmitter();
            this.isActive = false;
            this.isSelectAll = false;
            this.chunkIndex = [];
            this.cachedItems = [];
            this.itemHeight = 41.6;
            this.defaultSettings = {
                singleSelection: false,
                text: 'Select',
                enableCheckAll: true,
                selectAllText: 'Select All',
                unSelectAllText: 'UnSelect All',
                enableSearchFilter: false,
                searchBy: [],
                maxHeight: 300,
                badgeShowLimit: 999999999999,
                classes: '',
                disabled: false,
                searchPlaceholderText: 'Search',
                showCheckbox: true,
                noDataLabel: 'No Data Available',
                searchAutofocus: true,
                lazyLoading: false,
                labelKey: 'itemName',
                primaryKey: 'id',
                position: 'bottom'
            };
            this.onTouchedCallback = noop;
            this.onChangeCallback = noop;
        }
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            var _this = this;
            this.settings = Object.assign(this.defaultSettings, this.settings);
            if (this.settings.groupBy) {
                this.groupedData = this.transformData(this.data, this.settings.groupBy);
            }
            this.totalRows = (this.data && this.data.length);
            this.cachedItems = this.data;
            this.screenItemsLen = Math.ceil(this.settings.maxHeight / this.itemHeight);
            this.cachedItemsLen = this.screenItemsLen * 3;
            this.totalHeight = this.itemHeight * this.totalRows;
            this.maxBuffer = this.screenItemsLen * this.itemHeight;
            this.lastScrolled = 0;
            this.renderChunk(0, this.cachedItemsLen / 2);
            if (this.settings.position == 'top') {
                setTimeout(function () {
                    _this.selectedListHeight = { val: 0 };
                    _this.selectedListHeight.val = _this.selectedListElem.nativeElement.clientHeight;
                });
            }
        };
        /**
         * @param {?} changes
         * @return {?}
         */
        AngularMultiSelect.prototype.ngOnChanges = /**
         * @param {?} changes
         * @return {?}
         */
        function (changes) {
            if (changes["data"] && !changes["data"].firstChange) {
                if (this.settings.groupBy) {
                    this.groupedData = this.transformData(this.data, this.settings.groupBy);
                    if (this.data.length == 0) {
                        this.selectedItems = [];
                    }
                }
            }
            if (changes["settings"] && !changes["settings"].firstChange) {
                this.settings = Object.assign(this.defaultSettings, this.settings);
            }
        };
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.ngDoCheck = /**
         * @return {?}
         */
        function () {
            if (this.selectedItems) {
                if (this.selectedItems.length == 0 || this.data.length == 0 || this.selectedItems.length < this.data.length) {
                    this.isSelectAll = false;
                }
            }
        };
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            if (this.settings.lazyLoading) {
                this._elementRef.nativeElement.getElementsByClassName("lazyContainer")[0].addEventListener('scroll', this.onScroll.bind(this));
            }
        };
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.ngAfterViewChecked = /**
         * @return {?}
         */
        function () {
            if (this.selectedListElem.nativeElement.clientHeight && this.settings.position == 'top' && this.selectedListHeight) {
                this.selectedListHeight.val = this.selectedListElem.nativeElement.clientHeight;
                this.cdr.detectChanges();
            }
        };
        /**
         * @param {?} item
         * @param {?} index
         * @param {?} evt
         * @return {?}
         */
        AngularMultiSelect.prototype.onItemClick = /**
         * @param {?} item
         * @param {?} index
         * @param {?} evt
         * @return {?}
         */
        function (item, index, evt) {
            if (this.settings.disabled) {
                return false;
            }
            var /** @type {?} */ found = this.isSelected(item);
            var /** @type {?} */ limit = this.selectedItems.length < this.settings.limitSelection ? true : false;
            if (!found) {
                if (this.settings.limitSelection) {
                    if (limit) {
                        this.addSelected(item);
                        this.onSelect.emit(item);
                    }
                }
                else {
                    this.addSelected(item);
                    this.onSelect.emit(item);
                }
            }
            else {
                this.removeSelected(item);
                this.onDeSelect.emit(item);
            }
            if (this.isSelectAll || this.data.length > this.selectedItems.length) {
                this.isSelectAll = false;
            }
            if (this.data.length == this.selectedItems.length) {
                this.isSelectAll = true;
            }
        };
        /**
         * @param {?} c
         * @return {?}
         */
        AngularMultiSelect.prototype.validate = /**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            return null;
        };
        /**
         * @param {?} value
         * @return {?}
         */
        AngularMultiSelect.prototype.writeValue = /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== undefined && value !== null) {
                if (this.settings.singleSelection) {
                    try {
                        if (value.length > 1) {
                            this.selectedItems = [value[0]];
                            throw new MyException(404, { "msg": "Single Selection Mode, Selected Items cannot have more than one item." });
                        }
                        else {
                            this.selectedItems = value;
                        }
                    }
                    catch (/** @type {?} */ e) {
                        console.error(e.body.msg);
                    }
                }
                else {
                    if (this.settings.limitSelection) {
                        this.selectedItems = value.splice(0, this.settings.limitSelection);
                    }
                    else {
                        this.selectedItems = value;
                    }
                    if (this.selectedItems.length === this.data.length && this.data.length > 0) {
                        this.isSelectAll = true;
                    }
                }
            }
            else {
                this.selectedItems = [];
            }
        };
        //From ControlValueAccessor interface
        /**
         * @param {?} fn
         * @return {?}
         */
        AngularMultiSelect.prototype.registerOnChange = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onChangeCallback = fn;
        };
        //From ControlValueAccessor interface
        /**
         * @param {?} fn
         * @return {?}
         */
        AngularMultiSelect.prototype.registerOnTouched = /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            this.onTouchedCallback = fn;
        };
        /**
         * @param {?} index
         * @param {?} item
         * @return {?}
         */
        AngularMultiSelect.prototype.trackByFn = /**
         * @param {?} index
         * @param {?} item
         * @return {?}
         */
        function (index, item) {
            return item[this.settings.primaryKey];
        };
        /**
         * @param {?} clickedItem
         * @return {?}
         */
        AngularMultiSelect.prototype.isSelected = /**
         * @param {?} clickedItem
         * @return {?}
         */
        function (clickedItem) {
            var _this = this;
            var /** @type {?} */ found = false;
            this.selectedItems && this.selectedItems.forEach(function (item) {
                if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                    found = true;
                }
            });
            return found;
        };
        /**
         * @param {?} item
         * @return {?}
         */
        AngularMultiSelect.prototype.addSelected = /**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (this.settings.singleSelection) {
                this.selectedItems = [];
                this.selectedItems.push(item);
                this.closeDropdown();
            }
            else
                this.selectedItems.push(item);
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
        };
        /**
         * @param {?} clickedItem
         * @return {?}
         */
        AngularMultiSelect.prototype.removeSelected = /**
         * @param {?} clickedItem
         * @return {?}
         */
        function (clickedItem) {
            var _this = this;
            this.selectedItems && this.selectedItems.forEach(function (item) {
                if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                    _this.selectedItems.splice(_this.selectedItems.indexOf(item), 1);
                }
            });
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        AngularMultiSelect.prototype.toggleDropdown = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            var _this = this;
            if (this.settings.disabled) {
                return false;
            }
            this.isActive = !this.isActive;
            if (this.isActive) {
                if (this.settings.searchAutofocus && this.settings.enableSearchFilter && !this.searchTempl) {
                    setTimeout(function () {
                        _this.searchInput.nativeElement.focus();
                    }, 0);
                }
                this.onOpen.emit(true);
            }
            else {
                this.onClose.emit(false);
            }
            evt.preventDefault();
        };
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.closeDropdown = /**
         * @return {?}
         */
        function () {
            if (this.searchInput && this.settings.lazyLoading) {
                this.searchInput.nativeElement.value = "";
                this.data = [];
                this.data = this.cachedItems;
                this.totalHeight = this.itemHeight * this.data.length;
                this.totalRows = this.data.length;
                this.updateView(this.scrollTop);
            }
            if (this.searchInput) {
                this.searchInput.nativeElement.value = "";
            }
            this.filter = "";
            this.isActive = false;
            this.onClose.emit(false);
        };
        /**
         * @return {?}
         */
        AngularMultiSelect.prototype.toggleSelectAll = /**
         * @return {?}
         */
        function () {
            if (!this.isSelectAll) {
                this.selectedItems = [];
                this.selectedItems = this.data.slice();
                this.isSelectAll = true;
                this.onChangeCallback(this.selectedItems);
                this.onTouchedCallback(this.selectedItems);
                this.onSelectAll.emit(this.selectedItems);
            }
            else {
                this.selectedItems = [];
                this.isSelectAll = false;
                this.onChangeCallback(this.selectedItems);
                this.onTouchedCallback(this.selectedItems);
                this.onDeSelectAll.emit(this.selectedItems);
            }
        };
        /**
         * @param {?} arr
         * @param {?} field
         * @return {?}
         */
        AngularMultiSelect.prototype.transformData = /**
         * @param {?} arr
         * @param {?} field
         * @return {?}
         */
        function (arr, field) {
            var /** @type {?} */ groupedObj = arr.reduce(function (prev, cur) {
                if (!prev[cur[field]]) {
                    prev[cur[field]] = [cur];
                }
                else {
                    prev[cur[field]].push(cur);
                }
                return prev;
            }, {});
            var /** @type {?} */ tempArr = [];
            Object.keys(groupedObj).map(function (x) {
                tempArr.push({ key: x, value: groupedObj[x] });
            });
            return tempArr;
        };
        /**
         * @param {?} fromPos
         * @param {?} howMany
         * @return {?}
         */
        AngularMultiSelect.prototype.renderChunk = /**
         * @param {?} fromPos
         * @param {?} howMany
         * @return {?}
         */
        function (fromPos, howMany) {
            this.chunkArray = [];
            this.chunkIndex = [];
            var /** @type {?} */ finalItem = fromPos + howMany;
            if (finalItem > this.totalRows)
                finalItem = this.totalRows;
            for (var /** @type {?} */ i = fromPos; i < finalItem; i++) {
                this.chunkIndex.push((i * this.itemHeight) + 'px');
                this.chunkArray.push(this.data[i]);
            }
        };
        /**
         * @param {?} e
         * @return {?}
         */
        AngularMultiSelect.prototype.onScroll = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            this.scrollTop = e.target.scrollTop;
            this.updateView(this.scrollTop);
        };
        /**
         * @param {?} scrollTop
         * @return {?}
         */
        AngularMultiSelect.prototype.updateView = /**
         * @param {?} scrollTop
         * @return {?}
         */
        function (scrollTop) {
            var /** @type {?} */ scrollPos = scrollTop ? scrollTop : 0;
            var /** @type {?} */ first = (scrollPos / this.itemHeight) - this.screenItemsLen;
            var /** @type {?} */ firstTemp = "" + first;
            first = parseInt(firstTemp) < 0 ? 0 : parseInt(firstTemp);
            this.renderChunk(first, this.cachedItemsLen);
            this.lastRepaintY = scrollPos;
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        AngularMultiSelect.prototype.filterInfiniteList = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            var /** @type {?} */ filteredElems = [];
            this.data = this.cachedItems.slice();
            if (evt.target.value.toString() != '') {
                this.data.filter(function (el) {
                    for (var /** @type {?} */ prop in el) {
                        if (el[prop].toString().toLowerCase().indexOf(evt.target.value.toString().toLowerCase()) >= 0) {
                            filteredElems.push(el);
                            break;
                        }
                    }
                });
                //this.cachedItems = this.data;
                this.totalHeight = this.itemHeight * filteredElems.length;
                this.totalRows = filteredElems.length;
                this.data = [];
                this.data = filteredElems;
                this.updateView(this.scrollTop);
            }
            else if (evt.target.value.toString() == '' && this.cachedItems.length > 0) {
                this.data = [];
                this.data = this.cachedItems;
                this.totalHeight = this.itemHeight * this.data.length;
                this.totalRows = this.data.length;
                this.updateView(this.scrollTop);
            }
        };
        AngularMultiSelect.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-multiselect',
                        template: "<div class=\"cuppa-dropdown\" (clickOutside)=\"closeDropdown()\">\n    <div class=\"selected-list\" #selectedList>\n        <div class=\"c-btn\" (click)=\"toggleDropdown($event)\" [ngClass]=\"{'disabled': settings.disabled}\">\n            <span *ngIf=\"selectedItems?.length == 0\">{{settings.text}}</span>\n            <span *ngIf=\"settings.singleSelection\">\n                <span *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);\">\n                    {{item[settings.labelKey]}}\n                </span>\n            </span>\n            <div class=\"c-list\" *ngIf=\"selectedItems?.length > 0 && !settings.singleSelection\">\n                <div class=\"c-token\" *ngFor=\"let item of selectedItems;trackBy: trackByFn.bind(this);let k = index\" [hidden]=\"k > settings.badgeShowLimit-1\">\n                    <span *ngIf=\"!badgeTempl\" class=\"c-label\">{{item[settings.labelKey]}}</span>\n                    <span *ngIf=\"badgeTempl\" class=\"c-label\">\n                        <c-templateRenderer [data]=\"badgeTempl\" [item]=\"item\"></c-templateRenderer>\n                    </span>\n                    <span class=\"c-remove\" (click)=\"onItemClick(item,k,$event)\">\n                        <svg width=\"100%\" height=\"100%\" version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 47.971 47.971\" style=\"enable-background:new 0 0 47.971 47.971;\" xml:space=\"preserve\">\n<g>\n\t<path d=\"M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88\n\t\tc-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242\n\t\tC1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879\n\t\ts1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z\"/>\n</g>\n</svg>\n\n                    </span>\n                </div>\n            </div>\n            <span class=\"countplaceholder\" *ngIf=\"selectedItems?.length > settings.badgeShowLimit\">+{{selectedItems?.length - settings.badgeShowLimit }}</span>\n            <!--            <span class=\"fa\" [ngClass]=\"{'c-angle-down': !isActive,'fa-angle-up':isActive}\"></span>\n--><span *ngIf=\"!isActive\" class=\"c-angle-down\">\n                <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"100%\" height=\"100%\" viewBox=\"0 0 612 612\" style=\"enable-background:new 0 0 612 612;\" xml:space=\"preserve\">\n<g>\n\t<g id=\"_x31_0_34_\">\n\t\t<g>\n\t\t\t<path d=\"M604.501,134.782c-9.999-10.05-26.222-10.05-36.221,0L306.014,422.558L43.721,134.782\n\t\t\t\tc-9.999-10.05-26.223-10.05-36.222,0s-9.999,26.35,0,36.399l279.103,306.241c5.331,5.357,12.422,7.652,19.386,7.296\n\t\t\t\tc6.988,0.356,14.055-1.939,19.386-7.296l279.128-306.268C614.5,161.106,614.5,144.832,604.501,134.782z\"/>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n\n            </span>\n            <span *ngIf=\"isActive\" class=\"c-angle-up\">\n                <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"100%\" height=\"100%\" viewBox=\"0 0 612 612\" style=\"enable-background:new 0 0 612 612;\" xml:space=\"preserve\">\n<g>\n\t<g id=\"_x39__30_\">\n\t\t<g>\n\t\t\t<path d=\"M604.501,440.509L325.398,134.956c-5.331-5.357-12.423-7.627-19.386-7.27c-6.989-0.357-14.056,1.913-19.387,7.27\n\t\t\t\tL7.499,440.509c-9.999,10.024-9.999,26.298,0,36.323s26.223,10.024,36.222,0l262.293-287.164L568.28,476.832\n\t\t\t\tc9.999,10.024,26.222,10.024,36.221,0C614.5,466.809,614.5,450.534,604.501,440.509z\"/>\n\t\t</g>\n\t</g>\n</g>\n\n</svg>\n\n            </span>\n        </div>\n    </div>\n    <div [setPosition]=\"selectedListHeight?.val\" class=\"dropdown-list\" [ngClass]=\"{'dropdown-list-top': settings.position == 'top'}\"\n        [hidden]=\"!isActive\">\n        <div [ngClass]=\"{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}\" class=\"arrow-2\"></div>\n        <div [ngClass]=\"{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}\"></div>\n        <div class=\"list-area\">\n            <div class=\"pure-checkbox select-all\" *ngIf=\"settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection\"\n                (click)=\"toggleSelectAll()\">\n                <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelectAll\" [disabled]=\"settings.limitSelection == selectedItems?.length\"\n                />\n                <label>\n                <span [hidden]=\"isSelectAll\">{{settings.selectAllText}}</span>\n                <span [hidden]=\"!isSelectAll\">{{settings.unSelectAllText}}</span>\n            </label>\n            </div>\n            <div class=\"list-filter\" *ngIf=\"settings.enableSearchFilter\">\n                <span class=\"c-search\">\n                    <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t width=\"100%\" height=\"100%\" viewBox=\"0 0 615.52 615.52\" style=\"enable-background:new 0 0 615.52 615.52;\"\n\t xml:space=\"preserve\">\n<g>\n\t<g>\n\t\t<g id=\"Search__x28_and_thou_shall_find_x29_\">\n\t\t\t<g>\n\t\t\t\t<path d=\"M602.531,549.736l-184.31-185.368c26.679-37.72,42.528-83.729,42.528-133.548C460.75,103.35,357.997,0,231.258,0\n\t\t\t\t\tC104.518,0,1.765,103.35,1.765,230.82c0,127.47,102.753,230.82,229.493,230.82c49.53,0,95.271-15.944,132.78-42.777\n\t\t\t\t\tl184.31,185.366c7.482,7.521,17.292,11.291,27.102,11.291c9.812,0,19.62-3.77,27.083-11.291\n\t\t\t\t\tC617.496,589.188,617.496,564.777,602.531,549.736z M355.9,319.763l-15.042,21.273L319.7,356.174\n\t\t\t\t\tc-26.083,18.658-56.667,28.526-88.442,28.526c-84.365,0-152.995-69.035-152.995-153.88c0-84.846,68.63-153.88,152.995-153.88\n\t\t\t\t\ts152.996,69.034,152.996,153.88C384.271,262.769,374.462,293.526,355.9,319.763z\"/>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n\n</svg>\n\n                </span>\n                <input class=\"c-input\" *ngIf=\"!settings.lazyLoading && !searchTempl\" #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                    [(ngModel)]=\"filter\">\n                <input class=\"c-input\" *ngIf=\"settings.lazyLoading && !searchTempl\" #searchInput type=\"text\" [placeholder]=\"settings.searchPlaceholderText\"\n                    (keyup)=\"filterInfiniteList($event)\">\n                <c-templateRenderer *ngIf=\"searchTempl\" [data]=\"searchTempl\" [item]=\"item\"></c-templateRenderer>\n            </div>\n            <ul *ngIf=\"!settings.groupBy\" [style.maxHeight]=\"settings.maxHeight+'px'\" class=\"lazyContainer\">\n                <span *ngIf=\"itemTempl\">\n            <li *ngFor=\"let item of data | listFilter: filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n            <label></label>\n            <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n        </li>\n        </span>\n                <span *ngIf=\"!itemTempl && !settings.lazyLoading\">\n        <li *ngFor=\"let item of data | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n            <label>{{item[settings.labelKey]}}</label>\n        </li>\n        </span>\n                <span *ngIf=\"!itemTempl && settings.lazyLoading\">\n            <div [ngStyle]=\"{'height':totalHeight+'px'}\" style=\"position: relative;\">\n\n            \n        <li *ngFor=\"let item of chunkArray | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" style=\"position: absolute;width: 100%;\" class=\"pure-checkbox\" [styleProp]=\"chunkIndex[i]\">\n            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n            <label>{{item[settings.labelKey]}}</label>\n        </li>\n        </div>\n        </span>\n            </ul>\n            <div *ngIf=\"settings.groupBy\" [style.maxHeight]=\"settings.maxHeight+'px'\" style=\"overflow: auto;\">\n                <ul *ngFor=\"let obj of groupedData ; let i = index;\" class=\"list-grp\">\n                    <h4 *ngIf=\"(obj.value | listFilter:filter : settings.searchBy ).length > 0\">{{obj.key}}</h4>\n                    <span *ngIf=\"itemTempl\">\n        <li *ngFor=\"let item of obj.value | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n            <label></label>\n            <c-templateRenderer [data]=\"itemTempl\" [item]=\"item\"></c-templateRenderer>\n        </li>\n        </span>\n                    <span *ngIf=\"!itemTempl\">\n        <li *ngFor=\"let item of obj.value | listFilter:filter : settings.searchBy; let i = index;\" (click)=\"onItemClick(item,i,$event)\" class=\"pure-checkbox\">\n            <input *ngIf=\"settings.showCheckbox\" type=\"checkbox\" [checked]=\"isSelected(item)\" [disabled]=\"settings.limitSelection == selectedItems?.length && !isSelected(item)\"/>\n            <label>{{item[settings.labelKey]}}</label>\n        </li>\n        </span>\n                </ul>\n            </div>\n            <h5 class=\"list-message\" *ngIf=\"data?.length == 0\">{{settings.noDataLabel}}</h5>\n        </div>\n    </div>\n</div>",
                        host: { '[class]': 'defaultSettings.classes' },
                        providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR, DROPDOWN_CONTROL_VALIDATION],
                        styles: [".cuppa-dropdown {\n  position: relative;\n  width: 400px; }\n\n.c-btn {\n  display: inline-block;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 14px;\n  color: #333; }\n\n.c-btn.disabled {\n  background: #ccc; }\n\n.c-btn:focus {\n  outline: none; }\n\n.selected-list .c-list {\n  float: left;\n  padding: 0px;\n  margin: 0px;\n  width: calc(100% - 20px); }\n  .selected-list .c-list .c-token {\n    list-style: none;\n    padding: 2px 8px;\n    background: #0079FE;\n    color: #fff;\n    border-radius: 2px;\n    margin-right: 4px;\n    margin-top: 2px;\n    float: left;\n    position: relative;\n    padding-right: 25px; }\n    .selected-list .c-list .c-token .c-label {\n      display: block;\n      float: left; }\n    .selected-list .c-list .c-token .c-remove {\n      position: absolute;\n      right: 8px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 10px; }\n      .selected-list .c-list .c-token .c-remove svg {\n        fill: #fff; }\n\n.selected-list .fa-angle-down, .selected-list .fa-angle-up {\n  font-size: 15pt;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%); }\n\n.selected-list .c-angle-down, .selected-list .c-angle-up {\n  width: 15px;\n  height: 15px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none; }\n  .selected-list .c-angle-down svg, .selected-list .c-angle-up svg {\n    fill: #333; }\n\n.selected-list .countplaceholder {\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%); }\n\n.selected-list .c-btn {\n  width: 100%;\n  box-shadow: 0px 1px 5px #959595;\n  padding: 7px;\n  cursor: pointer;\n  display: flex;\n  position: relative; }\n  .selected-list .c-btn .c-icon {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%); }\n\n.dropdown-list {\n  position: absolute;\n  padding-top: 14px;\n  width: 100%;\n  z-index: 9999; }\n  .dropdown-list ul {\n    padding: 0px;\n    list-style: none;\n    overflow: auto;\n    margin: 0px; }\n    .dropdown-list ul li {\n      padding: 10px 10px;\n      cursor: pointer;\n      text-align: left; }\n    .dropdown-list ul li:first-child {\n      padding-top: 10px; }\n    .dropdown-list ul li:last-child {\n      padding-bottom: 10px; }\n    .dropdown-list ul li:hover {\n      background: #f5f5f5; }\n  .dropdown-list ::-webkit-scrollbar {\n    width: 8px; }\n  .dropdown-list ::-webkit-scrollbar-thumb {\n    background: #cccccc;\n    border-radius: 5px; }\n  .dropdown-list ::-webkit-scrollbar-track {\n    background: #f2f2f2; }\n\n.arrow-up, .arrow-down {\n  width: 0;\n  height: 0;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n  border-bottom: 15px solid #fff;\n  margin-left: 15px;\n  position: absolute;\n  top: 0; }\n\n.arrow-down {\n  bottom: -14px;\n  top: unset;\n  transform: rotate(180deg); }\n\n.arrow-2 {\n  border-bottom: 15px solid #ccc;\n  top: -1px; }\n\n.arrow-down.arrow-2 {\n  top: unset;\n  bottom: -16px; }\n\n.list-area {\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  background: #fff;\n  margin: 0px;\n  box-shadow: 0px 1px 5px #959595; }\n\n.select-all {\n  padding: 10px;\n  border-bottom: 1px solid #ccc;\n  text-align: left; }\n\n.list-filter {\n  border-bottom: 1px solid #ccc;\n  position: relative;\n  padding-left: 35px;\n  height: 35px; }\n  .list-filter input {\n    border: 0px;\n    width: 100%;\n    height: 100%;\n    padding: 0px; }\n  .list-filter input:focus {\n    outline: none; }\n  .list-filter .c-search {\n    position: absolute;\n    top: 9px;\n    left: 10px;\n    width: 15px;\n    height: 15px; }\n    .list-filter .c-search svg {\n      fill: #888; }\n\n.pure-checkbox input[type=\"checkbox\"] {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.pure-checkbox input[type=\"checkbox\"]:focus + label:before,\n.pure-checkbox input[type=\"checkbox\"]:hover + label:before {\n  border-color: #0079FE;\n  background-color: #f2f2f2; }\n\n.pure-checkbox input[type=\"checkbox\"]:active + label:before {\n  transition-duration: 0s; }\n\n.pure-checkbox input[type=\"checkbox\"] + label {\n  position: relative;\n  padding-left: 2em;\n  vertical-align: middle;\n  user-select: none;\n  cursor: pointer;\n  margin: 0px;\n  color: #000;\n  font-weight: 300; }\n\n.pure-checkbox input[type=\"checkbox\"] + label:before {\n  box-sizing: content-box;\n  content: '';\n  color: #0079FE;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 14px;\n  height: 14px;\n  margin-top: -9px;\n  border: 2px solid #0079FE;\n  text-align: center;\n  transition: all 0.4s ease; }\n\n.pure-checkbox input[type=\"checkbox\"] + label:after {\n  box-sizing: content-box;\n  content: '';\n  background-color: #0079FE;\n  position: absolute;\n  top: 50%;\n  left: 4px;\n  width: 10px;\n  height: 10px;\n  margin-top: -5px;\n  transform: scale(0);\n  transform-origin: 50%;\n  transition: transform 200ms ease-out; }\n\n.pure-checkbox input[type=\"checkbox\"]:disabled + label:before {\n  border-color: #cccccc; }\n\n.pure-checkbox input[type=\"checkbox\"]:disabled:focus + label:before\n.pure-checkbox input[type=\"checkbox\"]:disabled:hover + label:before {\n  background-color: inherit; }\n\n.pure-checkbox input[type=\"checkbox\"]:disabled:checked + label:before {\n  background-color: #cccccc; }\n\n.pure-checkbox input[type=\"checkbox\"] + label:after {\n  background-color: transparent;\n  top: 50%;\n  left: 4px;\n  width: 8px;\n  height: 3px;\n  margin-top: -4px;\n  border-style: solid;\n  border-color: #ffffff;\n  border-width: 0 0 3px 3px;\n  border-image: none;\n  transform: rotate(-45deg) scale(0); }\n\n.pure-checkbox input[type=\"checkbox\"]:checked + label:after {\n  content: '';\n  transform: rotate(-45deg) scale(1);\n  transition: transform 200ms ease-out; }\n\n.pure-checkbox input[type=\"radio\"]:checked + label:before {\n  background-color: white; }\n\n.pure-checkbox input[type=\"radio\"]:checked + label:after {\n  transform: scale(1); }\n\n.pure-checkbox input[type=\"radio\"] + label:before {\n  border-radius: 50%; }\n\n.pure-checkbox input[type=\"checkbox\"]:checked + label:before {\n  background: #0079FE; }\n\n.pure-checkbox input[type=\"checkbox\"]:checked + label:after {\n  transform: rotate(-45deg) scale(1); }\n\n.list-message {\n  text-align: center;\n  margin: 0px;\n  padding: 15px 0px;\n  font-size: initial; }\n\n.list-grp {\n  padding: 0 15px !important; }\n\n.list-grp h4 {\n  text-transform: capitalize;\n  margin: 15px 0px 0px 0px;\n  font-size: 14px;\n  font-weight: 700; }\n\n.list-grp > li {\n  padding-left: 15px !important; }\n"]
                    }] }
        ];
        /** @nocollapse */
        AngularMultiSelect.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: core.ChangeDetectorRef, },
        ]; };
        AngularMultiSelect.propDecorators = {
            "data": [{ type: core.Input },],
            "settings": [{ type: core.Input },],
            "onSelect": [{ type: core.Output, args: ['onSelect',] },],
            "onDeSelect": [{ type: core.Output, args: ['onDeSelect',] },],
            "onSelectAll": [{ type: core.Output, args: ['onSelectAll',] },],
            "onDeSelectAll": [{ type: core.Output, args: ['onDeSelectAll',] },],
            "onOpen": [{ type: core.Output, args: ['onOpen',] },],
            "onClose": [{ type: core.Output, args: ['onClose',] },],
            "itemTempl": [{ type: core.ContentChild, args: [Item,] },],
            "badgeTempl": [{ type: core.ContentChild, args: [Badge,] },],
            "searchTempl": [{ type: core.ContentChild, args: [Search,] },],
            "searchInput": [{ type: core.ViewChild, args: ['searchInput',] },],
            "selectedListElem": [{ type: core.ViewChild, args: ['selectedList',] },],
        };
        return AngularMultiSelect;
    }());
    var AngularMultiSelectModule = /** @class */ (function () {
        function AngularMultiSelectModule() {
        }
        AngularMultiSelectModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, FormsModule],
                        declarations: [AngularMultiSelect, ClickOutsideDirective$1, ScrollDirective, styleDirective, ListFilterPipe, Item, TemplateRenderer, Badge, Search, setPosition],
                        exports: [AngularMultiSelect, ClickOutsideDirective$1, ScrollDirective, styleDirective, ListFilterPipe, Item, TemplateRenderer, Badge, Search, setPosition]
                    },] }
        ];
        return AngularMultiSelectModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var KeysPipe = /** @class */ (function () {
        function KeysPipe() {
        }
        /**
         * @param {?} value
         * @param {?} args
         * @return {?}
         */
        KeysPipe.prototype.transform = /**
         * @param {?} value
         * @param {?} args
         * @return {?}
         */
        function (value, args) {
            var /** @type {?} */ keys = [];
            for (var /** @type {?} */ key in value) {
                keys.push({ key: key, value: value[key] });
            }
            return keys;
        };
        KeysPipe.decorators = [
            { type: core.Pipe, args: [{ name: 'keys' },] }
        ];
        return KeysPipe;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var styleDirective$1 = /** @class */ (function () {
        function styleDirective(el) {
            this.el = el;
        }
        /**
         * @return {?}
         */
        styleDirective.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.top = this.styleVal;
        };
        /**
         * @return {?}
         */
        styleDirective.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.top = this.styleVal;
        };
        styleDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[styleProp]'
                    },] }
        ];
        /** @nocollapse */
        styleDirective.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        styleDirective.propDecorators = {
            "styleVal": [{ type: core.Input, args: ['styleProp',] },],
        };
        return styleDirective;
    }());
    var columnWidth = /** @class */ (function () {
        function columnWidth(el) {
            this.el = el;
        }
        /**
         * @return {?}
         */
        columnWidth.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.width = (100 / this.columns.length) + "%";
        };
        columnWidth.decorators = [
            { type: core.Directive, args: [{
                        selector: '[columnWidth]'
                    },] }
        ];
        /** @nocollapse */
        columnWidth.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        columnWidth.propDecorators = {
            "columns": [{ type: core.Input, args: ['columnWidth',] },],
        };
        return columnWidth;
    }());
    var SetContainerHeight = /** @class */ (function () {
        function SetContainerHeight(el) {
            this.el = el;
        }
        /**
         * @return {?}
         */
        SetContainerHeight.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.height = this.containerHeight + "px";
        };
        /**
         * @return {?}
         */
        SetContainerHeight.prototype.ngOnChanges = /**
         * @return {?}
         */
        function () {
            this.el.nativeElement.style.height = this.containerHeight + "px";
        };
        SetContainerHeight.decorators = [
            { type: core.Directive, args: [{
                        selector: '[setContainerHeight]'
                    },] }
        ];
        /** @nocollapse */
        SetContainerHeight.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        SetContainerHeight.propDecorators = {
            "containerHeight": [{ type: core.Input, args: ['setContainerHeight',] },],
        };
        return SetContainerHeight;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var Column = /** @class */ (function () {
        function Column() {
        }
        Column.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-column',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        Column.ctorParameters = function () { return []; };
        Column.propDecorators = {
            "field": [{ type: core.Input },],
            "template": [{ type: core.ContentChild, args: [core.TemplateRef,] },],
        };
        return Column;
    }());
    var Heading = /** @class */ (function () {
        function Heading() {
        }
        /**
         * @return {?}
         */
        Heading.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
        };
        Heading.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-heading',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        Heading.ctorParameters = function () { return []; };
        Heading.propDecorators = {
            "template": [{ type: core.ContentChild, args: [core.TemplateRef,] },],
        };
        return Heading;
    }());
    var TemplateRenderer$1 = /** @class */ (function () {
        function TemplateRenderer(viewContainer) {
            this.viewContainer = viewContainer;
        }
        /**
         * @return {?}
         */
        TemplateRenderer.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.view = this.viewContainer.createEmbeddedView(this.data.template, {
                '\$implicit': this.data
            });
        };
        /**
         * @return {?}
         */
        TemplateRenderer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.view.destroy();
        };
        TemplateRenderer.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-templateRenderer',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        TemplateRenderer.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        TemplateRenderer.propDecorators = {
            "data": [{ type: core.Input },],
        };
        return TemplateRenderer;
    }());
    var ColumnTemplateRenderer = /** @class */ (function () {
        function ColumnTemplateRenderer(viewContainer) {
            this.viewContainer = viewContainer;
        }
        /**
         * @return {?}
         */
        ColumnTemplateRenderer.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.view = this.viewContainer.createEmbeddedView(this.data.template, {
                '\$implicit': this.data,
                'rowData': this.rowData
            });
        };
        /**
         * @return {?}
         */
        ColumnTemplateRenderer.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            this.view.destroy();
        };
        ColumnTemplateRenderer.decorators = [
            { type: core.Component, args: [{
                        selector: 'c-columnTemplateRenderer',
                        template: ""
                    }] }
        ];
        /** @nocollapse */
        ColumnTemplateRenderer.ctorParameters = function () { return [
            { type: core.ViewContainerRef, },
        ]; };
        ColumnTemplateRenderer.propDecorators = {
            "data": [{ type: core.Input },],
            "rowData": [{ type: core.Input },],
        };
        return ColumnTemplateRenderer;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var CuppaDataGrid = /** @class */ (function () {
        function CuppaDataGrid(_elementRef, sanitizer) {
            this._elementRef = _elementRef;
            this.sanitizer = sanitizer;
            this.rowClick = new core.EventEmitter();
            this.dataArray = ["111", "222", "333", "444"];
            this.chunkIndex = [];
            this.cachedItems = [];
        }
        /**
         * @return {?}
         */
        CuppaDataGrid.prototype.ngOnInit = /**
         * @return {?}
         */
        function () {
            this.width = (this.config && this.config.w + 'px') || '100%';
            this.height = (this.config && this.config.h + 'px') || '100%';
            this.itemHeight = this.config.itemHeight;
            this.items = this.config.items;
            this.totalRows = this.config.totalRows || (this.config.items && this.config.items.length);
            this.screenItemsLen = Math.ceil(this.config.h / this.itemHeight);
            this.cachedItemsLen = this.screenItemsLen * 3;
            this.totalHeight = this.itemHeight * this.totalRows;
            this.scroller = this.createScroller(this.totalHeight);
            this.maxBuffer = this.screenItemsLen * this.itemHeight;
            this.lastScrolled = 0;
            this.generateHeadArray(this.items[0]);
            this._renderChunk(0, this.cachedItemsLen / 2);
        };
        /**
         * @return {?}
         */
        CuppaDataGrid.prototype.ngAfterViewInit = /**
         * @return {?}
         */
        function () {
            this._elementRef.nativeElement.getElementsByClassName("container")[0].addEventListener('scroll', this.onScroll.bind(this));
        };
        /**
         * @return {?}
         */
        CuppaDataGrid.prototype.ngAfterContentInit = /**
         * @return {?}
         */
        function () {
        };
        /**
         * @param {?} row
         * @return {?}
         */
        CuppaDataGrid.prototype.generateHeadArray = /**
         * @param {?} row
         * @return {?}
         */
        function (row) {
            this.headSection = [];
            var /** @type {?} */ ind = 0;
            for (var /** @type {?} */ prop in row) {
                var /** @type {?} */ tempObj = { "title": prop, "sorting": "", 'prop': prop, 'index': ind };
                if (this.config.sort) {
                    for (var /** @type {?} */ sortprop in this.config.sort) {
                        if (this.config.sort.hasOwnProperty(prop)) {
                            tempObj.sorting = this.config.sort[prop];
                            this.sortColumn(tempObj);
                        }
                    }
                }
                this.headSection.push(tempObj);
                ind++;
            }
        };
        /**
         * @return {?}
         */
        CuppaDataGrid.prototype.changeData = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ temArr = ["1", "2", "3", "4"];
            this.dataArray = temArr;
        };
        /**
         * @param {?} i
         * @return {?}
         */
        CuppaDataGrid.prototype.getHeightVal = /**
         * @param {?} i
         * @return {?}
         */
        function (i) {
            var /** @type {?} */ c = i * 31;
            c = c + "px";
            return c;
        };
        /**
         * @param {?} e
         * @return {?}
         */
        CuppaDataGrid.prototype.onScroll = /**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            this.scrollTop = e.target.scrollTop;
            this.updateView(this.scrollTop);
        };
        /**
         * @param {?} scrollTop
         * @return {?}
         */
        CuppaDataGrid.prototype.updateView = /**
         * @param {?} scrollTop
         * @return {?}
         */
        function (scrollTop) {
            var /** @type {?} */ scrollPos = scrollTop ? scrollTop : 0;
            var /** @type {?} */ first = (scrollPos / this.itemHeight) - this.screenItemsLen;
            var /** @type {?} */ firstTemp = "" + first;
            first = parseInt(firstTemp) < 0 ? 0 : parseInt(firstTemp);
            this._renderChunk(first, this.cachedItemsLen);
            this.lastRepaintY = scrollPos;
        };
        /**
         * @param {?} fromPos
         * @param {?} howMany
         * @return {?}
         */
        CuppaDataGrid.prototype._renderChunk = /**
         * @param {?} fromPos
         * @param {?} howMany
         * @return {?}
         */
        function (fromPos, howMany) {
            this.chunkArray = [];
            this.chunkIndex = [];
            var /** @type {?} */ finalItem = fromPos + howMany;
            if (finalItem > this.totalRows)
                finalItem = this.totalRows;
            for (var /** @type {?} */ i = fromPos; i < finalItem; i++) {
                this.chunkIndex.push((i * this.itemHeight) + 'px');
                this.chunkArray.push(this.items[i]);
            }
        };
        /**
         * @param {?} h
         * @return {?}
         */
        CuppaDataGrid.prototype.createScroller = /**
         * @param {?} h
         * @return {?}
         */
        function (h) {
            var /** @type {?} */ scroller = document.createElement('div');
            scroller.style.opacity = "0";
            scroller.style.position = 'absolute';
            scroller.style.top = "0";
            scroller.style.left = "0";
            scroller.style.width = '1px';
            scroller.style.height = h + 'px';
            return scroller;
        };
        /**
         * @param {?} column
         * @return {?}
         */
        CuppaDataGrid.prototype.sortColumn = /**
         * @param {?} column
         * @return {?}
         */
        function (column) {
            if (this.config.sort) {
                for (var /** @type {?} */ t = 0; t < this.headSection.length; t++) {
                    if (t != column.index) {
                        this.headSection[t].sorting = "";
                    }
                }
                if (column.sorting == "") {
                    column.sorting = "asc";
                }
                this.items = this.mergeSort(this.items, column.prop, column.sorting);
                this.updateView(this.scrollTop);
                if (column.sorting == "asc") {
                    column.sorting = "desc";
                }
                else if (column.sorting == "desc") {
                    column.sorting = "asc";
                }
            }
        };
        /**
         * @param {?} arr
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        CuppaDataGrid.prototype.mergeSort = /**
         * @param {?} arr
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        function (arr, column, sortType) {
            var /** @type {?} */ len = arr.length;
            if (len < 2)
                return arr;
            var /** @type {?} */ mid = Math.floor(len / 2), /** @type {?} */
            left = arr.slice(0, mid), /** @type {?} */
            right = arr.slice(mid);
            var /** @type {?} */ temp = this.merge(this.mergeSort(left, column, sortType), this.mergeSort(right, column, sortType), column, sortType);
            return temp;
        };
        /**
         * @param {?} left
         * @param {?} right
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        CuppaDataGrid.prototype.merge = /**
         * @param {?} left
         * @param {?} right
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        function (left, right, column, sortType) {
            var /** @type {?} */ result = [], /** @type {?} */
            lLen = left.length, /** @type {?} */
            rLen = right.length, /** @type {?} */
            l = 0, /** @type {?} */
            r = 0;
            while (l < lLen && r < rLen) {
                if (this.compare(left[l], right[r], column, sortType) <= 0) {
                    result.push(left[l++]);
                }
                else {
                    result.push(right[r++]);
                }
            }
            //remaining part needs to be addred to the result
            return result.concat(left.slice(l)).concat(right.slice(r));
        };
        /**
         * @param {?} item1
         * @param {?} item2
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        CuppaDataGrid.prototype.compare = /**
         * @param {?} item1
         * @param {?} item2
         * @param {?} column
         * @param {?} sortType
         * @return {?}
         */
        function (item1, item2, column, sortType) {
            if (typeof item1[column] == 'string') {
                if (item1[column].toLowerCase() < item2[column].toLowerCase() && sortType == 'asc')
                    return -1;
                if (item1[column].toLowerCase() > item2[column].toLowerCase() && sortType == 'asc')
                    return 1;
                if (item1[column].toLowerCase() > item2[column].toLowerCase() && sortType == 'desc')
                    return -1;
                if (item1[column].toLowerCase() < item2[column].toLowerCase() && sortType == 'desc')
                    return 1;
                else
                    return 0;
            }
            else if (typeof item1[column] == 'number') {
                if (item1[column] < item2[column] && sortType == 'asc')
                    return -1;
                if (item1[column] > item2[column] && sortType == 'asc')
                    return 1;
                if (item1[column] > item2[column] && sortType == 'desc')
                    return -1;
                if (item1[column] < item2[column] && sortType == 'desc')
                    return 1;
                else
                    return 0;
            }
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        CuppaDataGrid.prototype.search = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            var /** @type {?} */ filteredElems = [];
            if (evt.target.value.toString() != '') {
                this.items.filter(function (el) {
                    for (var /** @type {?} */ prop in el) {
                        if (el[prop].toString().toLowerCase().indexOf(evt.target.value.toString().toLowerCase()) >= 0) {
                            filteredElems.push(el);
                        }
                    }
                });
                this.cachedItems = this.items;
                this.totalHeight = this.itemHeight * filteredElems.length;
                this.totalRows = filteredElems.length;
                this.items = [];
                this.items = filteredElems;
                this.updateView(this.scrollTop);
            }
            else if (evt.target.value.toString() == '' && this.cachedItems.length > 0) {
                this.items = [];
                this.items = this.cachedItems;
                this.totalHeight = this.itemHeight * this.items.length;
                this.totalRows = this.items.length;
                this.updateView(this.scrollTop);
            }
        };
        /**
         * @param {?} evt
         * @return {?}
         */
        CuppaDataGrid.prototype.filter = /**
         * @param {?} evt
         * @return {?}
         */
        function (evt) {
            if (evt.target.value.toString() == '' && this.cachedItems.length > 0) {
                this.items = [];
                this.items = this.cachedItems;
                this.cachedItems = [];
                this.totalHeight = this.itemHeight * this.items.length;
                this.totalRows = this.items.length;
                this.updateView(this.scrollTop);
            }
        };
        /**
         * @param {?} row
         * @return {?}
         */
        CuppaDataGrid.prototype.onRowClick = /**
         * @param {?} row
         * @return {?}
         */
        function (row) {
            this.rowClick.emit(row);
        };
        /**
         * @param {?} row
         * @param {?} field
         * @return {?}
         */
        CuppaDataGrid.prototype.getColumnData = /**
         * @param {?} row
         * @param {?} field
         * @return {?}
         */
        function (row, field) {
            return row[field];
        };
        CuppaDataGrid.decorators = [
            { type: core.Component, args: [{
                        selector: 'vernost-datagrid',
                        template: "<div class=\"cuppa-grid\">\n     <div class=\"vrow grid-main-header\">\n         <div class=\"grid-title\">\n             <c-templateRenderer *ngIf=\"heading\" [data]=\"heading\"></c-templateRenderer>\n             <span *ngIf=\"!heading\">{{config.title}}</span>\n         </div>\n         <div class=\"grid-search\">\n             <input (blur)=\"search($event)\" (keyup)=\"filter($event)\">\n            <button>Search</button>\n         </div>\n     </div>\n    <div class=\"header-row vrow\" >\n        <span *ngIf=\"columns.toArray().length == 0\">\n            <div *ngFor=\"let column of headSection;let k = index\" class=\"vcolumn\" [columnWidth]=\"headSection\" (click)=\"sortColumn(column)\" >\n                <span class=\"header-title\">{{column.title}} </span>\n                <div class=\"header-sort\" *ngIf=\"config.sort\">\n                    <i *ngIf=\"column.sorting=='desc'\" class=\"icon pe-7s-angle-up pe-lg\"></i>\n                    <i *ngIf=\"column.sorting=='asc'\" class=\"icon pe-7s-angle-down pe-lg\"></i>\n                </div>\n            </div>\n        </span>\n        <span *ngIf=\"columns\">\n            <div *ngFor=\"let column of headSection;let k = index\" class=\"vcolumn\" [columnWidth]=\"columns\" (click)=\"sortColumn(column)\" >\n                <span class=\"header-title\">{{column.title}} </span>\n                <div class=\"header-sort\" *ngIf=\"config.sort\">\n                    <i *ngIf=\"column.sorting=='desc'\" class=\"icon pe-7s-angle-up pe-lg\"></i>\n                    <i *ngIf=\"column.sorting=='asc'\" class=\"icon pe-7s-angle-down pe-lg\"></i>\n                </div>\n            </div>\n        </span>\n        </div>\n    <div class=\"container\">\n        <div style=\"position:absolute;top:0;left:0;opacity:0;width:1px;\" [setContainerHeight]=\"totalHeight\"></div>\n        <div *ngFor=\"let row of chunkArray;let i = index\" class=\"vrow\" style=\"position: absolute;\" [ngStyle]=\"{'height': config.itemHeight+'px'}\" [styleProp]=\"chunkIndex[i]\" (click)=\"onRowClick(row)\">\n            <span *ngIf=\"columns.toArray().length == 0\">\n            <div *ngFor=\"let obj of row | keys\" class=\"vcolumn\" [columnWidth]=\"headSection\">\n                {{obj.value}}\n\n            </div>\n            </span>\n            <span *ngIf=\"columns\">\n            <div *ngFor=\"let col of columns\" class=\"vcolumn\" [ngStyle]=\"{'height': config.itemHeight+'px'}\" [columnWidth]=\"columns\" [ngStyle]=\"{'width': (columns.length/3)+'px'}\">\n                <c-columnTemplateRenderer *ngIf=\"col.template\" [data]=\"col\" [rowData]=\"row\"></c-columnTemplateRenderer>\n                <span *ngIf=\"!col.template\">{{getColumnData(row, col.field)}}</span>\n            </div>\n            </span>\n        </div>\n    </div>\n    <div class=\"grid-footer\">\n        <label>Total Rows:</label> <span>{{totalRows}}</span>\n    </div>\n</div>\n\n",
                        styles: ["* {\n  box-sizing: border-box; }\n\n.cuppa-grid {\n  background: #f7f7f7;\n  border: 2px solid #d9dadf;\n  font-family: 'Arial',sans-serif;\n  font-size: 14px;\n  width: 100%;\n  margin: 0px auto; }\n\n.container {\n  width: calc(100% - 1px);\n  height: 310px;\n  overflow: auto;\n  position: relative;\n  padding: 0px;\n  background: #fff;\n  border-top: 1px solid #888; }\n\n.scroller {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 300px; }\n\n.vrow {\n  width: 100%;\n  border-bottom: 1px solid #e4e4e4;\n  height: 31px;\n  cursor: pointer;\n  transition: all .1s linear; }\n\n.cuppa-grid > .container > .vrow:hover {\n  background: rgba(25, 118, 210, 0.31); }\n\n.vcolumn {\n  display: inline-block;\n  padding: 8px;\n  border-right: 1px solid #e4e4e4; }\n\n.vrow > .vcolumn:last-child {\n  border-right: 0px; }\n\n.header-row > .vcolumn {\n  cursor: pointer; }\n\n.header-row > .vcolumn:hover {\n  box-shadow: inset 0px 0px 20px rgba(0, 0, 0, 0.21); }\n\n.cuppa-grid {\n  position: relative; }\n\n.header-row {\n  width: calc(100% - 10px);\n  background: #f7f7f7;\n  border-bottom: 0px;\n  color: #000;\n  text-transform: capitalize;\n  font-weight: bold; }\n\n::-webkit-scrollbar {\n  width: 10px; }\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);\n  border-radius: 0px;\n  background: #f5f5f5; }\n\n::-webkit-scrollbar-thumb {\n  border-radius: 0px;\n  background: #ccc; }\n\n.description {\n  text-align: center; }\n\n.header-title {\n  float: left; }\n\n.header-sort {\n  position: relative;\n  float: right;\n  width: 30px;\n  height: 15px; }\n\n.icon {\n  cursor: pointer;\n  position: absolute;\n  font-size: 23px;\n  top: -2px; }\n\n.grid-main-header {\n  background: #d9dadf;\n  height: 40px;\n  padding: 6px; }\n\n.grid-search {\n  display: inline-block;\n  float: right; }\n\n.grid-search > input {\n  border-color: transparent;\n  height: 25px;\n  border-radius: 3px;\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  float: left; }\n\n.grid-search > button {\n  display: inline-block;\n  padding: 0px 6px;\n  background: #144c98;\n  border: none;\n  height: 25px;\n  float: left;\n  color: #fff;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px; }\n\n.grid-title {\n  float: left;\n  line-height: 27px;\n  color: #969292;\n  font-weight: bold;\n  font-size: 16px; }\n\n.grid-footer {\n  padding: 5px 5px 0px 5px;\n  background: #f1f1f1;\n  border-top: 1px solid #ccc; }\n", "@font-face {\n  font-family: 'Pe-icon-7-stroke';\n  src: url(\"./fonts/Pe-icon-7-stroke.eot?d7yf1v\");\n  src: url(\"./fonts/Pe-icon-7-stroke.eot?#iefixd7yf1v\") format(\"embedded-opentype\"), url(\"./fonts/Pe-icon-7-stroke.woff?d7yf1v\") format(\"woff\"), url(\"./fonts/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^=\"pe-7s-\"], [class*=\" pe-7s-\"] {\n  display: inline-block;\n  font-family: 'Pe-icon-7-stroke';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.pe-7s-album:before {\n  content: \"\\e6aa\"; }\n\n.pe-7s-arc:before {\n  content: \"\\e6ab\"; }\n\n.pe-7s-back-2:before {\n  content: \"\\e6ac\"; }\n\n.pe-7s-bandaid:before {\n  content: \"\\e6ad\"; }\n\n.pe-7s-car:before {\n  content: \"\\e6ae\"; }\n\n.pe-7s-diamond:before {\n  content: \"\\e6af\"; }\n\n.pe-7s-door-lock:before {\n  content: \"\\e6b0\"; }\n\n.pe-7s-eyedropper:before {\n  content: \"\\e6b1\"; }\n\n.pe-7s-female:before {\n  content: \"\\e6b2\"; }\n\n.pe-7s-gym:before {\n  content: \"\\e6b3\"; }\n\n.pe-7s-hammer:before {\n  content: \"\\e6b4\"; }\n\n.pe-7s-headphones:before {\n  content: \"\\e6b5\"; }\n\n.pe-7s-helm:before {\n  content: \"\\e6b6\"; }\n\n.pe-7s-hourglass:before {\n  content: \"\\e6b7\"; }\n\n.pe-7s-leaf:before {\n  content: \"\\e6b8\"; }\n\n.pe-7s-magic-wand:before {\n  content: \"\\e6b9\"; }\n\n.pe-7s-male:before {\n  content: \"\\e6ba\"; }\n\n.pe-7s-map-2:before {\n  content: \"\\e6bb\"; }\n\n.pe-7s-next-2:before {\n  content: \"\\e6bc\"; }\n\n.pe-7s-paint-bucket:before {\n  content: \"\\e6bd\"; }\n\n.pe-7s-pendrive:before {\n  content: \"\\e6be\"; }\n\n.pe-7s-photo:before {\n  content: \"\\e6bf\"; }\n\n.pe-7s-piggy:before {\n  content: \"\\e6c0\"; }\n\n.pe-7s-plugin:before {\n  content: \"\\e6c1\"; }\n\n.pe-7s-refresh-2:before {\n  content: \"\\e6c2\"; }\n\n.pe-7s-rocket:before {\n  content: \"\\e6c3\"; }\n\n.pe-7s-settings:before {\n  content: \"\\e6c4\"; }\n\n.pe-7s-shield:before {\n  content: \"\\e6c5\"; }\n\n.pe-7s-smile:before {\n  content: \"\\e6c6\"; }\n\n.pe-7s-usb:before {\n  content: \"\\e6c7\"; }\n\n.pe-7s-vector:before {\n  content: \"\\e6c8\"; }\n\n.pe-7s-wine:before {\n  content: \"\\e6c9\"; }\n\n.pe-7s-cloud-upload:before {\n  content: \"\\e68a\"; }\n\n.pe-7s-cash:before {\n  content: \"\\e68c\"; }\n\n.pe-7s-close:before {\n  content: \"\\e680\"; }\n\n.pe-7s-bluetooth:before {\n  content: \"\\e68d\"; }\n\n.pe-7s-cloud-download:before {\n  content: \"\\e68b\"; }\n\n.pe-7s-way:before {\n  content: \"\\e68e\"; }\n\n.pe-7s-close-circle:before {\n  content: \"\\e681\"; }\n\n.pe-7s-id:before {\n  content: \"\\e68f\"; }\n\n.pe-7s-angle-up:before {\n  content: \"\\e682\"; }\n\n.pe-7s-wristwatch:before {\n  content: \"\\e690\"; }\n\n.pe-7s-angle-up-circle:before {\n  content: \"\\e683\"; }\n\n.pe-7s-world:before {\n  content: \"\\e691\"; }\n\n.pe-7s-angle-right:before {\n  content: \"\\e684\"; }\n\n.pe-7s-volume:before {\n  content: \"\\e692\"; }\n\n.pe-7s-angle-right-circle:before {\n  content: \"\\e685\"; }\n\n.pe-7s-users:before {\n  content: \"\\e693\"; }\n\n.pe-7s-angle-left:before {\n  content: \"\\e686\"; }\n\n.pe-7s-user-female:before {\n  content: \"\\e694\"; }\n\n.pe-7s-angle-left-circle:before {\n  content: \"\\e687\"; }\n\n.pe-7s-up-arrow:before {\n  content: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABDSURBVDhPYxgFtAd6UEwWkAHix1AMYpMEuID4EhD/h2IQGyRGFGAG4o1ADNMMwyAxkBxBMA2I0TXDMEhuFAwywMAAAMAZEpukrzSEAAAAAElFTkSuQmCC\"); }\n\n.pe-7s-angle-down:before {\n  content: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAvSURBVDhPYxgFgxTwA3EoDgySIwo0APF/NAwSIwkgG0KyZhgAaSRb8yigD2BgAAAmYQsXOqrpMAAAAABJRU5ErkJggg==\"); }\n\n.pe-7s-switch:before {\n  content: \"\\e696\"; }\n\n.pe-7s-angle-down-circle:before {\n  content: \"\\e689\"; }\n\n.pe-7s-scissors:before {\n  content: \"\\e697\"; }\n\n.pe-7s-wallet:before {\n  content: \"\\e600\"; }\n\n.pe-7s-safe:before {\n  content: \"\\e698\"; }\n\n.pe-7s-volume2:before {\n  content: \"\\e601\"; }\n\n.pe-7s-volume1:before {\n  content: \"\\e602\"; }\n\n.pe-7s-voicemail:before {\n  content: \"\\e603\"; }\n\n.pe-7s-video:before {\n  content: \"\\e604\"; }\n\n.pe-7s-user:before {\n  content: \"\\e605\"; }\n\n.pe-7s-upload:before {\n  content: \"\\e606\"; }\n\n.pe-7s-unlock:before {\n  content: \"\\e607\"; }\n\n.pe-7s-umbrella:before {\n  content: \"\\e608\"; }\n\n.pe-7s-trash:before {\n  content: \"\\e609\"; }\n\n.pe-7s-tools:before {\n  content: \"\\e60a\"; }\n\n.pe-7s-timer:before {\n  content: \"\\e60b\"; }\n\n.pe-7s-ticket:before {\n  content: \"\\e60c\"; }\n\n.pe-7s-target:before {\n  content: \"\\e60d\"; }\n\n.pe-7s-sun:before {\n  content: \"\\e60e\"; }\n\n.pe-7s-study:before {\n  content: \"\\e60f\"; }\n\n.pe-7s-stopwatch:before {\n  content: \"\\e610\"; }\n\n.pe-7s-star:before {\n  content: \"\\e611\"; }\n\n.pe-7s-speaker:before {\n  content: \"\\e612\"; }\n\n.pe-7s-signal:before {\n  content: \"\\e613\"; }\n\n.pe-7s-shuffle:before {\n  content: \"\\e614\"; }\n\n.pe-7s-shopbag:before {\n  content: \"\\e615\"; }\n\n.pe-7s-share:before {\n  content: \"\\e616\"; }\n\n.pe-7s-server:before {\n  content: \"\\e617\"; }\n\n.pe-7s-search:before {\n  content: \"\\e618\"; }\n\n.pe-7s-film:before {\n  content: \"\\e6a5\"; }\n\n.pe-7s-science:before {\n  content: \"\\e619\"; }\n\n.pe-7s-disk:before {\n  content: \"\\e6a6\"; }\n\n.pe-7s-ribbon:before {\n  content: \"\\e61a\"; }\n\n.pe-7s-repeat:before {\n  content: \"\\e61b\"; }\n\n.pe-7s-refresh:before {\n  content: \"\\e61c\"; }\n\n.pe-7s-add-user:before {\n  content: \"\\e6a9\"; }\n\n.pe-7s-refresh-cloud:before {\n  content: \"\\e61d\"; }\n\n.pe-7s-paperclip:before {\n  content: \"\\e69c\"; }\n\n.pe-7s-radio:before {\n  content: \"\\e61e\"; }\n\n.pe-7s-note2:before {\n  content: \"\\e69d\"; }\n\n.pe-7s-print:before {\n  content: \"\\e61f\"; }\n\n.pe-7s-network:before {\n  content: \"\\e69e\"; }\n\n.pe-7s-prev:before {\n  content: \"\\e620\"; }\n\n.pe-7s-mute:before {\n  content: \"\\e69f\"; }\n\n.pe-7s-power:before {\n  content: \"\\e621\"; }\n\n.pe-7s-medal:before {\n  content: \"\\e6a0\"; }\n\n.pe-7s-portfolio:before {\n  content: \"\\e622\"; }\n\n.pe-7s-like2:before {\n  content: \"\\e6a1\"; }\n\n.pe-7s-plus:before {\n  content: \"\\e623\"; }\n\n.pe-7s-left-arrow:before {\n  content: \"\\e6a2\"; }\n\n.pe-7s-play:before {\n  content: \"\\e624\"; }\n\n.pe-7s-key:before {\n  content: \"\\e6a3\"; }\n\n.pe-7s-plane:before {\n  content: \"\\e625\"; }\n\n.pe-7s-joy:before {\n  content: \"\\e6a4\"; }\n\n.pe-7s-photo-gallery:before {\n  content: \"\\e626\"; }\n\n.pe-7s-pin:before {\n  content: \"\\e69b\"; }\n\n.pe-7s-phone:before {\n  content: \"\\e627\"; }\n\n.pe-7s-plug:before {\n  content: \"\\e69a\"; }\n\n.pe-7s-pen:before {\n  content: \"\\e628\"; }\n\n.pe-7s-right-arrow:before {\n  content: \"\\e699\"; }\n\n.pe-7s-paper-plane:before {\n  content: \"\\e629\"; }\n\n.pe-7s-delete-user:before {\n  content: \"\\e6a7\"; }\n\n.pe-7s-paint:before {\n  content: \"\\e62a\"; }\n\n.pe-7s-bottom-arrow:before {\n  content: \"\\e6a8\"; }\n\n.pe-7s-notebook:before {\n  content: \"\\e62b\"; }\n\n.pe-7s-note:before {\n  content: \"\\e62c\"; }\n\n.pe-7s-next:before {\n  content: \"\\e62d\"; }\n\n.pe-7s-news-paper:before {\n  content: \"\\e62e\"; }\n\n.pe-7s-musiclist:before {\n  content: \"\\e62f\"; }\n\n.pe-7s-music:before {\n  content: \"\\e630\"; }\n\n.pe-7s-mouse:before {\n  content: \"\\e631\"; }\n\n.pe-7s-more:before {\n  content: \"\\e632\"; }\n\n.pe-7s-moon:before {\n  content: \"\\e633\"; }\n\n.pe-7s-monitor:before {\n  content: \"\\e634\"; }\n\n.pe-7s-micro:before {\n  content: \"\\e635\"; }\n\n.pe-7s-menu:before {\n  content: \"\\e636\"; }\n\n.pe-7s-map:before {\n  content: \"\\e637\"; }\n\n.pe-7s-map-marker:before {\n  content: \"\\e638\"; }\n\n.pe-7s-mail:before {\n  content: \"\\e639\"; }\n\n.pe-7s-mail-open:before {\n  content: \"\\e63a\"; }\n\n.pe-7s-mail-open-file:before {\n  content: \"\\e63b\"; }\n\n.pe-7s-magnet:before {\n  content: \"\\e63c\"; }\n\n.pe-7s-loop:before {\n  content: \"\\e63d\"; }\n\n.pe-7s-look:before {\n  content: \"\\e63e\"; }\n\n.pe-7s-lock:before {\n  content: \"\\e63f\"; }\n\n.pe-7s-lintern:before {\n  content: \"\\e640\"; }\n\n.pe-7s-link:before {\n  content: \"\\e641\"; }\n\n.pe-7s-like:before {\n  content: \"\\e642\"; }\n\n.pe-7s-light:before {\n  content: \"\\e643\"; }\n\n.pe-7s-less:before {\n  content: \"\\e644\"; }\n\n.pe-7s-keypad:before {\n  content: \"\\e645\"; }\n\n.pe-7s-junk:before {\n  content: \"\\e646\"; }\n\n.pe-7s-info:before {\n  content: \"\\e647\"; }\n\n.pe-7s-home:before {\n  content: \"\\e648\"; }\n\n.pe-7s-help2:before {\n  content: \"\\e649\"; }\n\n.pe-7s-help1:before {\n  content: \"\\e64a\"; }\n\n.pe-7s-graph3:before {\n  content: \"\\e64b\"; }\n\n.pe-7s-graph2:before {\n  content: \"\\e64c\"; }\n\n.pe-7s-graph1:before {\n  content: \"\\e64d\"; }\n\n.pe-7s-graph:before {\n  content: \"\\e64e\"; }\n\n.pe-7s-global:before {\n  content: \"\\e64f\"; }\n\n.pe-7s-gleam:before {\n  content: \"\\e650\"; }\n\n.pe-7s-glasses:before {\n  content: \"\\e651\"; }\n\n.pe-7s-gift:before {\n  content: \"\\e652\"; }\n\n.pe-7s-folder:before {\n  content: \"\\e653\"; }\n\n.pe-7s-flag:before {\n  content: \"\\e654\"; }\n\n.pe-7s-filter:before {\n  content: \"\\e655\"; }\n\n.pe-7s-file:before {\n  content: \"\\e656\"; }\n\n.pe-7s-expand1:before {\n  content: \"\\e657\"; }\n\n.pe-7s-exapnd2:before {\n  content: \"\\e658\"; }\n\n.pe-7s-edit:before {\n  content: \"\\e659\"; }\n\n.pe-7s-drop:before {\n  content: \"\\e65a\"; }\n\n.pe-7s-drawer:before {\n  content: \"\\e65b\"; }\n\n.pe-7s-download:before {\n  content: \"\\e65c\"; }\n\n.pe-7s-display2:before {\n  content: \"\\e65d\"; }\n\n.pe-7s-display1:before {\n  content: \"\\e65e\"; }\n\n.pe-7s-diskette:before {\n  content: \"\\e65f\"; }\n\n.pe-7s-date:before {\n  content: \"\\e660\"; }\n\n.pe-7s-cup:before {\n  content: \"\\e661\"; }\n\n.pe-7s-culture:before {\n  content: \"\\e662\"; }\n\n.pe-7s-crop:before {\n  content: \"\\e663\"; }\n\n.pe-7s-credit:before {\n  content: \"\\e664\"; }\n\n.pe-7s-copy-file:before {\n  content: \"\\e665\"; }\n\n.pe-7s-config:before {\n  content: \"\\e666\"; }\n\n.pe-7s-compass:before {\n  content: \"\\e667\"; }\n\n.pe-7s-comment:before {\n  content: \"\\e668\"; }\n\n.pe-7s-coffee:before {\n  content: \"\\e669\"; }\n\n.pe-7s-cloud:before {\n  content: \"\\e66a\"; }\n\n.pe-7s-clock:before {\n  content: \"\\e66b\"; }\n\n.pe-7s-check:before {\n  content: \"\\e66c\"; }\n\n.pe-7s-chat:before {\n  content: \"\\e66d\"; }\n\n.pe-7s-cart:before {\n  content: \"\\e66e\"; }\n\n.pe-7s-camera:before {\n  content: \"\\e66f\"; }\n\n.pe-7s-call:before {\n  content: \"\\e670\"; }\n\n.pe-7s-calculator:before {\n  content: \"\\e671\"; }\n\n.pe-7s-browser:before {\n  content: \"\\e672\"; }\n\n.pe-7s-box2:before {\n  content: \"\\e673\"; }\n\n.pe-7s-box1:before {\n  content: \"\\e674\"; }\n\n.pe-7s-bookmarks:before {\n  content: \"\\e675\"; }\n\n.pe-7s-bicycle:before {\n  content: \"\\e676\"; }\n\n.pe-7s-bell:before {\n  content: \"\\e677\"; }\n\n.pe-7s-battery:before {\n  content: \"\\e678\"; }\n\n.pe-7s-ball:before {\n  content: \"\\e679\"; }\n\n.pe-7s-back:before {\n  content: \"\\e67a\"; }\n\n.pe-7s-attention:before {\n  content: \"\\e67b\"; }\n\n.pe-7s-anchor:before {\n  content: \"\\e67c\"; }\n\n.pe-7s-albums:before {\n  content: \"\\e67d\"; }\n\n.pe-7s-alarm:before {\n  content: \"\\e67e\"; }\n\n.pe-7s-airplay:before {\n  content: \"\\e67f\"; }\n"]
                    }] }
        ];
        /** @nocollapse */
        CuppaDataGrid.ctorParameters = function () { return [
            { type: core.ElementRef, },
            { type: DomSanitizer, },
        ]; };
        CuppaDataGrid.propDecorators = {
            "datalist": [{ type: core.Input },],
            "config": [{ type: core.Input },],
            "rowClick": [{ type: core.Output, args: ['onRowSelect',] },],
            "heading": [{ type: core.ContentChild, args: [Heading,] },],
            "columns": [{ type: core.ContentChildren, args: [Column,] },],
        };
        return CuppaDataGrid;
    }());
    var CuppaDataGridModule = /** @class */ (function () {
        function CuppaDataGridModule() {
        }
        CuppaDataGridModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        declarations: [CuppaDataGrid, KeysPipe, styleDirective$1, columnWidth, SetContainerHeight, Column, Heading, TemplateRenderer$1, ColumnTemplateRenderer],
                        exports: [CuppaDataGrid, KeysPipe, styleDirective$1, columnWidth, SetContainerHeight, Column, Heading, TemplateRenderer$1, ColumnTemplateRenderer]
                    },] }
        ];
        return CuppaDataGridModule;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var DropdownNotClosableZone = /** @class */ (function () {
        function DropdownNotClosableZone(elementRef) {
            this.elementRef = elementRef;
        }
        /**
         * @param {?} element
         * @return {?}
         */
        DropdownNotClosableZone.prototype.contains = /**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (this.dropdownNotClosabledZone === false)
                return false;
            var /** @type {?} */ thisElement = this.elementRef.nativeElement;
            return thisElement.contains(element);
        };
        DropdownNotClosableZone.decorators = [
            { type: core.Directive, args: [{
                        selector: "[dropdown-not-closable-zone]"
                    },] }
        ];
        /** @nocollapse */
        DropdownNotClosableZone.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        DropdownNotClosableZone.propDecorators = {
            "dropdownNotClosabledZone": [{ type: core.Input, args: ["dropdown-not-closable-zone",] },],
        };
        return DropdownNotClosableZone;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var Dropdown = /** @class */ (function () {
        // -------------------------------------------------------------------------
        // Constructor
        // -------------------------------------------------------------------------
        function Dropdown(elementRef) {
            this.elementRef = elementRef;
            // -------------------------------------------------------------------------
            // Inputs / Outputs
            // -------------------------------------------------------------------------
            this.toggleClick = true;
            this.activateOnFocus = false;
            this.onOpen = new core.EventEmitter();
            this.onClose = new core.EventEmitter();
        }
        // -------------------------------------------------------------------------
        // Public Methods
        // -------------------------------------------------------------------------
        /**
         * @return {?}
         */
        Dropdown.prototype.open = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this.elementRef.nativeElement;
            element.classList.add("active");
            this.onOpen.emit(undefined);
        };
        /**
         * @return {?}
         */
        Dropdown.prototype.close = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this.elementRef.nativeElement;
            element.classList.remove("active");
            this.onClose.emit(undefined);
        };
        /**
         * @return {?}
         */
        Dropdown.prototype.isOpened = /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ element = this.elementRef.nativeElement;
            return element.classList.contains("active");
        };
        /**
         * @param {?} element
         * @return {?}
         */
        Dropdown.prototype.isInClosableZone = /**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (!this.notClosableZone)
                return false;
            return this.notClosableZone.contains(element);
        };
        Dropdown.decorators = [
            { type: core.Directive, args: [{
                        selector: "[dropdown]",
                        exportAs: "dropdown"
                    },] }
        ];
        /** @nocollapse */
        Dropdown.ctorParameters = function () { return [
            { type: core.ElementRef, },
        ]; };
        Dropdown.propDecorators = {
            "toggleClick": [{ type: core.Input, args: ["dropdownToggle",] },],
            "activateOnFocus": [{ type: core.Input, args: ["dropdownFocusActivate",] },],
            "onOpen": [{ type: core.Output },],
            "onClose": [{ type: core.Output },],
            "notClosableZone": [{ type: core.ContentChild, args: [DropdownNotClosableZone,] },],
        };
        return Dropdown;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var DropdownOpen = /** @class */ (function () {
        // -------------------------------------------------------------------------
        // Constructor
        // -------------------------------------------------------------------------
        function DropdownOpen(dropdown, elementRef) {
            this.dropdown = dropdown;
            this.elementRef = elementRef;
            /**
             * This hack is needed for dropdown not to open and instantly closed
             */
            this.openedByFocus = false;
            var /** @type {?} */ _this = this;
            this.closeDropdownOnOutsideClick = function closeDropdownOnOutsideClick(event) {
                _this.closeIfInClosableZone(event);
            };
        }
        // -------------------------------------------------------------------------
        // Public Methods
        // -------------------------------------------------------------------------
        /**
         * @return {?}
         */
        DropdownOpen.prototype.toggle = /**
         * @return {?}
         */
        function () {
            if (this.dropdown.isOpened()) {
                this.close();
            }
            else {
                this.open();
            }
        };
        /**
         * @return {?}
         */
        DropdownOpen.prototype.open = /**
         * @return {?}
         */
        function () {
            if (this.dropdown.isOpened())
                return;
            this.dropdown.open();
            document.addEventListener("click", this.closeDropdownOnOutsideClick, true);
        };
        /**
         * @return {?}
         */
        DropdownOpen.prototype.close = /**
         * @return {?}
         */
        function () {
            if (!this.dropdown.isOpened())
                return;
            this.dropdown.close();
            document.removeEventListener("click", this.closeDropdownOnOutsideClick, true);
        };
        /**
         * @return {?}
         */
        DropdownOpen.prototype.openDropdown = /**
         * @return {?}
         */
        function () {
            if (this.dropdown.activateOnFocus && this.openedByFocus) {
                this.openedByFocus = false;
                return;
            }
            if (this.dropdown.isOpened() && this.dropdown.toggleClick) {
                this.close();
            }
            else {
                this.open();
            }
        };
        /**
         * @param {?} event
         * @return {?}
         */
        DropdownOpen.prototype.dropdownKeydown = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.keyCode === 40) {
                // down
                //this.openDropdown();
                this.open();
            }
        };
        /**
         * @return {?}
         */
        DropdownOpen.prototype.onFocus = /**
         * @return {?}
         */
        function () {
            if (!this.dropdown.activateOnFocus)
                return;
            this.openedByFocus = true;
            this.dropdown.open();
            document.addEventListener("click", this.closeDropdownOnOutsideClick, true);
        };
        /**
         * @param {?} event
         * @return {?}
         */
        DropdownOpen.prototype.onBlur = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (!this.dropdown.activateOnFocus)
                return;
            if (event.relatedTarget &&
                !this.dropdown.isInClosableZone(/** @type {?} */ (event.relatedTarget)) &&
                event.relatedTarget !== this.elementRef.nativeElement) {
                this.dropdown.close();
                document.removeEventListener("click", this.closeDropdownOnOutsideClick, true);
            }
        };
        // -------------------------------------------------------------------------
        // Lifecycle Methods
        // -------------------------------------------------------------------------
        /**
         * @return {?}
         */
        DropdownOpen.prototype.ngOnDestroy = /**
         * @return {?}
         */
        function () {
            document.removeEventListener("click", this.closeDropdownOnOutsideClick, true);
        };
        /**
         * @param {?} event
         * @return {?}
         */
        DropdownOpen.prototype.closeIfInClosableZone = /**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (!this.dropdown.isInClosableZone(/** @type {?} */ (event.target))
                && event.target !== this.elementRef.nativeElement
                && !this.elementRef.nativeElement.contains(event.target)) {
                this.dropdown.close();
                document.removeEventListener("click", this.closeDropdownOnOutsideClick, true);
            }
        };
        DropdownOpen.decorators = [
            { type: core.Directive, args: [{
                        selector: "[dropdown-open]",
                        exportAs: "dropdownOpen"
                    },] }
        ];
        /** @nocollapse */
        DropdownOpen.ctorParameters = function () { return [
            { type: Dropdown, decorators: [{ type: core.Host },] },
            { type: core.ElementRef, },
        ]; };
        DropdownOpen.propDecorators = {
            "openDropdown": [{ type: core.HostListener, args: ["click",] },],
            "dropdownKeydown": [{ type: core.HostListener, args: ["keydown", ["$event"],] },],
            "onFocus": [{ type: core.HostListener, args: ["focus",] },],
            "onBlur": [{ type: core.HostListener, args: ["blur", ["$event"],] },],
        };
        return DropdownOpen;
    }());

    /**
     * @fileoverview added by tsickle
     * @suppress {checkTypes} checked by tsc
     */
    var VernostLibModule = /** @class */ (function () {
        function VernostLibModule() {
        }
        /**
         * Use in AppModule: new instance of SumService.
         * @return {?}
         */
        VernostLibModule.forRoot = /**
         * Use in AppModule: new instance of SumService.
         * @return {?}
         */
        function () {
            return {
                ngModule: VernostLibModule,
                providers: [VernostService]
            };
        };
        /**
         * Use in features modules with lazy loading: new instance of SumService.
         * @return {?}
         */
        VernostLibModule.forChild = /**
         * Use in features modules with lazy loading: new instance of SumService.
         * @return {?}
         */
        function () {
            return {
                ngModule: VernostLibModule,
                providers: [VernostService]
            };
        };
        VernostLibModule.decorators = [
            { type: core.NgModule, args: [{
                        declarations: [
                            DropdownNotClosableZone,
                            Dropdown,
                            DropdownOpen,
                            VernostTableComponent,
                            ModelInputComponent,
                            TinyEditorComponent,
                            VernostSearchComponent,
                            VernostScreenComponent,
                            VernostListComponent,
                            VernostTableRowComponent,
                            VernostProgressBarComponent,
                            VernostSpinnerComponent,
                        ],
                        exports: [
                            DropdownNotClosableZone,
                            Dropdown,
                            DropdownOpen,
                            AngularDateTimePickerModule,
                            AngularMultiSelectModule,
                            CuppaDataGridModule,
                            ModelInputComponent,
                            TinyEditorComponent,
                            VernostSearchComponent,
                            VernostScreenComponent,
                            VernostListComponent,
                            VernostTableComponent,
                            VernostTableRowComponent,
                            VernostProgressBarComponent,
                            VernostSpinnerComponent,
                        ],
                        imports: [
                            MatButtonModule,
                            MatMenuModule,
                            MatToolbarModule,
                            MatIconModule,
                            MatCardModule,
                            HttpClientModule,
                            MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule,
                            common.CommonModule,
                            FormsModule,
                            MatProgressBarModule,
                            MatSnackBarModule,
                            MatFormFieldModule,
                            ReactiveFormsModule,
                            AngularDateTimePickerModule,
                            AngularMultiSelectModule,
                            CuppaDataGridModule,
                        ],
                        providers: [VernostService]
                    },] }
        ];
        return VernostLibModule;
    }());

    exports.VernostService = VernostService;
    exports.VernostLibModule = VernostLibModule;
    exports.ɵp = ClickOutsideDirective;
    exports.ɵn = DATEPICKER_CONTROL_VALUE_ACCESSOR;
    exports.ɵo = DatePicker;
    exports.ɵm = AngularDateTimePickerModule;
    exports.ɵe = ModelInputComponent;
    exports.ɵy = ClickOutsideDirective$1;
    exports.ɵz = ScrollDirective;
    exports.ɵbb = setPosition;
    exports.ɵba = styleDirective;
    exports.ɵbc = ListFilterPipe;
    exports.ɵv = Badge;
    exports.ɵu = Item;
    exports.ɵw = Search;
    exports.ɵx = TemplateRenderer;
    exports.ɵs = AngularMultiSelect;
    exports.ɵt = AngularMultiSelectModule;
    exports.ɵr = DROPDOWN_CONTROL_VALIDATION;
    exports.ɵq = DROPDOWN_CONTROL_VALUE_ACCESSOR;
    exports.ɵf = TinyEditorComponent;
    exports.ɵbd = CuppaDataGrid;
    exports.ɵbe = CuppaDataGridModule;
    exports.ɵbf = Column;
    exports.ɵbi = ColumnTemplateRenderer;
    exports.ɵbg = Heading;
    exports.ɵbh = TemplateRenderer$1;
    exports.ɵbm = SetContainerHeight;
    exports.ɵbl = columnWidth;
    exports.ɵbk = styleDirective$1;
    exports.ɵbj = KeysPipe;
    exports.ɵi = VernostListComponent;
    exports.ɵd = VernostTableComponent;
    exports.ɵj = VernostTableRowComponent;
    exports.ɵk = VernostProgressBarComponent;
    exports.ɵh = VernostScreenComponent;
    exports.ɵg = VernostSearchComponent;
    exports.ɵl = VernostSpinnerComponent;
    exports.ɵa = DropdownNotClosableZone;
    exports.ɵc = DropdownOpen;
    exports.ɵb = Dropdown;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=angular-library-starter.umd.js.map
